/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 20:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var Buffer = (__webpack_require__(92861).Buffer);
var createHash = __webpack_require__(47108);
var stream = __webpack_require__(28399);
var inherits = __webpack_require__(56698);
var sign = __webpack_require__(35359);
var verify = __webpack_require__(74847);

var algorithms = __webpack_require__(62951);
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = Buffer.from(algorithms[key].id, 'hex');
  algorithms[key.toLowerCase()] = algorithms[key];
});

function Sign(algorithm) {
  stream.Writable.call(this);

  var data = algorithms[algorithm];
  if (!data) { throw new Error('Unknown message digest'); }

  this._hashType = data.hash;
  this._hash = createHash(data.hash);
  this._tag = data.id;
  this._signType = data.sign;
}
inherits(Sign, stream.Writable);

Sign.prototype._write = function _write(data, _, done) {
  this._hash.update(data);
  done();
};

Sign.prototype.update = function update(data, enc) {
  this._hash.update(typeof data === 'string' ? Buffer.from(data, enc) : data);

  return this;
};

Sign.prototype.sign = function signMethod(key, enc) {
  this.end();
  var hash = this._hash.digest();
  var sig = sign(hash, key, this._hashType, this._signType, this._tag);

  return enc ? sig.toString(enc) : sig;
};

function Verify(algorithm) {
  stream.Writable.call(this);

  var data = algorithms[algorithm];
  if (!data) { throw new Error('Unknown message digest'); }

  this._hash = createHash(data.hash);
  this._tag = data.id;
  this._signType = data.sign;
}
inherits(Verify, stream.Writable);

Verify.prototype._write = function _write(data, _, done) {
  this._hash.update(data);
  done();
};

Verify.prototype.update = function update(data, enc) {
  this._hash.update(typeof data === 'string' ? Buffer.from(data, enc) : data);

  return this;
};

Verify.prototype.verify = function verifyMethod(key, sig, enc) {
  var sigBuffer = typeof sig === 'string' ? Buffer.from(sig, enc) : sig;

  this.end();
  var hash = this._hash.digest();
  return verify(sigBuffer, hash, key, this._signType, this._tag);
};

function createSign(algorithm) {
  return new Sign(algorithm);
}

function createVerify(algorithm) {
  return new Verify(algorithm);
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
};


/***/ }),

/***/ 66:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26028);
/* provided dependency */ var process = __webpack_require__(65606);



function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

var _require = __webpack_require__(14256),
  call = _require.call;

var serverEndpoint = "https://api-nubbo.designer-trips.com";
var costControl = false;
var allowZeroHotel = process.env.ALLOW_HOTEL_ZERO;
var EXTRAS = ["admin","contacts","accounting","crm","arg","vamoos","ai","custom"];
var ua = navigator.userAgent;
var device = function () {
  if (/iPad/.test(ua)) return 'iPad';
  if (/iPhone/.test(ua)) return 'iPhone';
  if (/Android/.test(ua)) return 'Android';
  return 'Other';
}();
var languages = {
  'es': 'es',
  'en': 'en'
};
var Api = /*#__PURE__*/function () {
  function Api() {
    var _this = this;
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(this, Api);
    this.processEnv = Object.assign({}, process.env);
    this.tables = {};
    this.tablesFields = {};
    this.tableOptions = {};
    this.currentUser = null;
    this.processing = false;
    this.baseCurrency = null;
    this.receipts = [];
    this.payments = [];
    this.supplierCredits = [];
    this.serviceCost = {};
    this.hotelCost = {};
    this.serverEndpoint = serverEndpoint;
    this.checkCustom();
    this.costControl = costControl;
    this.allowZeroHotel = allowZeroHotel;
    //this.quoteByQuantity = quoteByQuantity;
    this.quoteByQuantity = true;
    this.CurrencyRates = {};
    this.selectYesNot = null;
    this.selectValue = null;
    this._gettingPayments = false;
    this._gettingReceipts = false;
    if (false) {}
    /*if (process.env.DOMAINS) {
        this.DOMAINS = Object.assign([], process.env.DOMAINS);
    }*/

    this._user = false;
    if (false) {}
    this.language = localStorage.getItem('user-language');
    if (!this.language) {
      var language = navigator.language || navigator.userLanguage;
      if (language) {
        this.language = language.substring(0, 2);
        if (!languages[this.language]) {
          this.language = 'en';
        }
      }
    }
    this.userAllowBlankHotel = false;
    this.getCurrencyBase();
    this.getGeneralSettings();
    this.getCurrentUser(function () {
      if (_this.language) {
        _this.get('/api/set_lang/', {
          lang: _this.language
        });
      }
      setTimeout(function () {
        _this.setCurrencyRates();
      }, 1000);
      _this.userAllowBlankHotel = tools.canAccess(_this.currentUser, 'api', 'POST', 'allow_blank_hotel', false);
    });
    this.EXTRAS = Object.assign([], EXTRAS);
    this.showAlert = null;
    this.myTemplates = null;
    this.hotelsList = [];
    this.closedRequest = {};
    this.requestTimeout = null;
    this.defaultExchange = true;
    this._tabId = (0,uuid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)();
  }
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(Api, [{
    key: "checkCustom",
    value: function () {
      var _checkCustom = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var location, custom, path, currentUrl, newUrl;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              location = window.location.hostname;
              if (!(location == 'testing.nubbo.io' || location == 'dev-test.nubbo.io' || location == 'support.nubbo.io')) {
                _context.next = 7;
                break;
              }
              _context.next = 4;
              return this.get('/api/get_custom/');
            case 4:
              custom = _context.sent;
              path = window.location.pathname;
              if (custom && !path.includes(custom)) {
                currentUrl = window.location.href;
                newUrl = currentUrl.replace(path, '/' + custom + '/');
                window.location.href = newUrl;
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function checkCustom() {
        return _checkCustom.apply(this, arguments);
      }
      return checkCustom;
    }()
  }, {
    key: "setProcessing",
    value: function setProcessing(value) {
      this.processing = value;
    }
  }, {
    key: "getTableFields",
    value: function () {
      var _getTableFields = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(table) {
        var res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.tablesFields[table]) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", this.tablesFields[table]);
            case 2:
              _context2.next = 4;
              return api.get('/api/get_table_fields/' + table);
            case 4:
              res = _context2.sent;
              if (!res) {
                _context2.next = 8;
                break;
              }
              this.tablesFields[table] = res;
              return _context2.abrupt("return", res);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getTableFields(_x) {
        return _getTableFields.apply(this, arguments);
      }
      return getTableFields;
    }()
  }, {
    key: "setTableOptions",
    value: function setTableOptions(table, options) {
      this.tableOptions[table] = options;
    }
  }, {
    key: "getGeneralSettings",
    value: function () {
      var _getGeneralSettings = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.get('/api/get_general_settings/');
            case 2:
              this.generalSettings = _context3.sent;
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getGeneralSettings() {
        return _getGeneralSettings.apply(this, arguments);
      }
      return getGeneralSettings;
    }()
  }, {
    key: "getCurrencyBase",
    value: function () {
      var _getCurrencyBase = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.get('/api/get_base_currency/');
            case 2:
              this.baseCurrency = _context4.sent;
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getCurrencyBase() {
        return _getCurrencyBase.apply(this, arguments);
      }
      return getCurrencyBase;
    }()
  }, {
    key: "updateUser",
    value: function () {
      var _updateUser = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(res) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (res) {
                _context5.next = 6;
                break;
              }
              _context5.next = 3;
              return this.get('/api/current_user/');
            case 3:
              this.currentUser = _context5.sent;
              _context5.next = 7;
              break;
            case 6:
              this.currentUser = res;
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function updateUser(_x2) {
        return _updateUser.apply(this, arguments);
      }
      return updateUser;
    }()
  }, {
    key: "getCurrentUser",
    value: function () {
      var _getCurrentUser = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(callback) {
        var res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              res = this.currentUser;
              if (res) {
                _context6.next = 8;
                break;
              }
              _context6.next = 4;
              return this.get('/api/current_user/');
            case 4:
              res = _context6.sent;
              this.currentUser = res;
              this._user = true;
              if (res && callback) {
                callback(res);
              }
            case 8:
              return _context6.abrupt("return", res);
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getCurrentUser(_x3) {
        return _getCurrentUser.apply(this, arguments);
      }
      return getCurrentUser;
    }()
  }, {
    key: "logout",
    value: function logout() {
      this.currentUser = null;
    }
  }, {
    key: "getTableParams",
    value: function getTableParams(table, params) {
      var self = this;
      return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7() {
        var module, options;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              module = self.importMixinModule(table, 'views'); //if (!params) params = {};
              _context7.next = 3;
              return module.getTableOptions(params);
            case 3:
              options = _context7.sent;
              self.tableOptions[table] = options;
              return _context7.abrupt("return", options);
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    }
  }, {
    key: "newAlert",
    value: function newAlert(newValue) {
      var _this2 = this;
      if (!this.showAlert) {
        this.showAlert = newValue;
        return;
      }
      if (newValue.text != this.showAlert.text) {
        this.showAlert = null;
        setTimeout(function () {
          _this2.showAlert = newValue;
        }, 200);
      }
    }
  }, {
    key: "getObjectFromStore",
    value: function () {
      var _getObjectFromStore = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8(table, id) {
        var res, _res, syncVersion, res2;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!this.tables[table]) {
                _context8.next = 17;
                break;
              }
              _res = _.find(this.tables[table], function (r) {
                return r.id == id;
              });
              if (!_res) {
                _context8.next = 17;
                break;
              }
              _context8.next = 5;
              return this.get('/api/get_sync_version/' + table + '/' + id);
            case 5:
              syncVersion = _context8.sent;
              if (!(syncVersion && syncVersion != _res.syncVersion)) {
                _context8.next = 16;
                break;
              }
              _context8.next = 9;
              return this.get('/api/' + table + '/' + id);
            case 9:
              res2 = _context8.sent;
              if (!res2) {
                _context8.next = 14;
                break;
              }
              res2.original_id = id;
              this.updateToStore(table, res2);
              return _context8.abrupt("return", res2);
            case 14:
              _context8.next = 17;
              break;
            case 16:
              return _context8.abrupt("return", _res);
            case 17:
              _context8.next = 19;
              return this.get('/api/' + table + '/' + id);
            case 19:
              res = _context8.sent;
              if (!res) {
                _context8.next = 22;
                break;
              }
              return _context8.abrupt("return", res);
            case 22:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getObjectFromStore(_x4, _x5) {
        return _getObjectFromStore.apply(this, arguments);
      }
      return getObjectFromStore;
    }()
  }, {
    key: "setCurrencyRates",
    value: function () {
      var _setCurrencyRates = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee9() {
        var currencyconversion, i, cc, rate;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return api.getTable('currencyconversion');
            case 2:
              currencyconversion = _context9.sent;
              _context9.t0 = _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().keys(currencyconversion);
            case 4:
              if ((_context9.t1 = _context9.t0()).done) {
                _context9.next = 13;
                break;
              }
              i = _context9.t1.value;
              cc = currencyconversion[i];
              _context9.next = 9;
              return travelTools.getCurrencyRate(cc);
            case 9:
              rate = _context9.sent;
              if (rate) {
                this.CurrencyRates[i] = {
                  FromCurrencyId: rate.FromCurrencyId,
                  ToCurrencyId: rate.ToCurrencyId,
                  Rate: rate.ConversionRate
                };
              }
              _context9.next = 4;
              break;
            case 13:
              return _context9.abrupt("return", true);
            case 14:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function setCurrencyRates() {
        return _setCurrencyRates.apply(this, arguments);
      }
      return setCurrencyRates;
    }()
  }, {
    key: "getFromStore",
    value: function getFromStore(table) {
      if (table == 'settings') return;
      if (this.tables[table] != null) {
        return this.tables[table];
      }
    }
  }, {
    key: "getTable",
    value: function () {
      var _getTable = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee10(table) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!(table == 'settings')) {
                _context10.next = 2;
                break;
              }
              return _context10.abrupt("return");
            case 2:
              if (!(!this.tables[table] || this.tables[table].length == 0)) {
                _context10.next = 5;
                break;
              }
              _context10.next = 5;
              return this.setTable({
                table: table
              });
            case 5:
              if (!(this.tables[table] != null)) {
                _context10.next = 7;
                break;
              }
              return _context10.abrupt("return", this.tables[table]);
            case 7:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getTable(_x6) {
        return _getTable.apply(this, arguments);
      }
      return getTable;
    }()
  }, {
    key: "setTableToStore",
    value: function setTableToStore(table, values) {
      if (!values) return;
      if (this.tables[table] && values.length < this.tables[table]) {
        return;
      }
      ;
      this.tables[table] = values;
    }
  }, {
    key: "setTable",
    value: function () {
      var _setTable = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee11(_ref2) {
        var table, closed, c, values;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              table = _ref2.table, closed = _ref2.closed;
              c = closed ? 'true' : 'false';
              _context11.next = 4;
              return api.get('/api/' + table + '/?IncludeClosed=' + c);
            case 4:
              values = _context11.sent;
              this.setTableToStore(table, values);
            case 6:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function setTable(_x7) {
        return _setTable.apply(this, arguments);
      }
      return setTable;
    }()
  }, {
    key: "setMyTemplates",
    value: function () {
      var _setMyTemplates = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee12() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (!api.currentUser) {
                _context12.next = 4;
                break;
              }
              _context12.next = 3;
              return api.get('/api/template/mytemplates/' + api.currentUser.id);
            case 3:
              this.myTemplates = _context12.sent;
            case 4:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function setMyTemplates() {
        return _setMyTemplates.apply(this, arguments);
      }
      return setMyTemplates;
    }()
  }, {
    key: "updateToStore",
    value: function updateToStore(table, record) {
      var records = this.tables[table];
      if (!records) return;
      var i = _.findIndex(records, function (c) {
        return c.id == record.id;
      });
      if (i > -1) {
        this.tables[table][i] = Object.assign({}, record);
      } else {
        this.tables[table].push(record);
      }
      //this.tables[table] = Object.assign([], this.tables[table]);
    }
  }, {
    key: "removeFromStore",
    value: function removeFromStore(table, id) {
      var records = this.tables[table];
      if (!records) return;
      var i = _.findIndex(records, function (c) {
        return c.id == id;
      });
      if (i >= 0) {
        this.tables[table].splice(i, 1);
        //this.tables[table] = Object.assign([], this.tables[table]);
      }
    }
  }, {
    key: "getUser",
    value: function () {
      var _getUser = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee13() {
        var user;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return this.get('/api/current_user/');
            case 2:
              user = _context13.sent;
              if (!user) {
                _context13.next = 6;
                break;
              }
              user.original_id = user.id;
              return _context13.abrupt("return", user);
            case 6:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function getUser() {
        return _getUser.apply(this, arguments);
      }
      return getUser;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee15(e, params, handleError, callback) {
        var self, endpoint;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              self = this;
              endpoint = new URL(this.serverEndpoint + e);
              if (params) {
                endpoint.search = new URLSearchParams(params).toString();
              }
              return _context15.abrupt("return", new Promise(function (resolve, reject) {
                fetch(endpoint, {
                  method: 'get',
                  mode: 'cors',
                  headers: {
                    'Accept': 'application/json',
                    'Content-type': 'application/json',
                    "Accept-Language": "*"
                    //"X-Browser-URL": window.location.hash
                  },
                  credentials: 'include'
                }).then(/*#__PURE__*/function () {
                  var _ref3 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee14(response) {
                    var r;
                    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee14$(_context14) {
                      while (1) switch (_context14.prev = _context14.next) {
                        case 0:
                          if (!(response.status === 200)) {
                            _context14.next = 4;
                            break;
                          }
                          if (callback) {
                            callback(response.json());
                          } else {
                            resolve(response.json());
                          }
                          _context14.next = 13;
                          break;
                        case 4:
                          _context14.t0 = tools;
                          _context14.t1 = response.status;
                          _context14.next = 8;
                          return response.json();
                        case 8:
                          _context14.t2 = _context14.sent;
                          r = _context14.t0.responseHelper.call(_context14.t0, _context14.t1, _context14.t2);
                          console.log('GET', e, 'status = ', response.status);
                          if (handleError && r) {
                            handleError(r);
                          } else if (r && r.detail) {
                            api.showAlert = {
                              text: r.detail,
                              level: 1
                            };
                          }
                          self.setProcessing(false);
                          //resolve(false)
                        case 13:
                        case "end":
                          return _context14.stop();
                      }
                    }, _callee14);
                  }));
                  return function (_x12) {
                    return _ref3.apply(this, arguments);
                  };
                }())["catch"](function (err) {
                  self.setProcessing(false);
                  api.showAlert = {
                    text: 'Internet connection error',
                    level: 0
                  };
                  var r = tools.responseHelper('Connection refused', null);
                  if (handleError && r) handleError(r);
                  resolve(false);
                  console.log('GET', err.message, err.stack, e, params);
                  //alert(err.message)
                  //reject(err);
                });
              }));
            case 4:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function get(_x8, _x9, _x10, _x11) {
        return _get.apply(this, arguments);
      }
      return get;
    }()
  }, {
    key: "post",
    value: function () {
      var _post = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee17(endpoint, data, headers, handleError) {
        var self, h;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              self = this;
              h = headers;
              if (!h) {
                h = {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                };
              }
              h["Accept-Language"] = "*";
              //h["X-Browser-URL"] = window.location.hash;
              return _context17.abrupt("return", new Promise(function (resolve, reject) {
                fetch(self.serverEndpoint + endpoint, {
                  method: 'POST',
                  mode: 'cors',
                  credentials: 'include',
                  headers: h,
                  body: data
                }).then(/*#__PURE__*/function () {
                  var _ref4 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee16(response) {
                    var r;
                    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee16$(_context16) {
                      while (1) switch (_context16.prev = _context16.next) {
                        case 0:
                          if (!(response.status === 200)) {
                            _context16.next = 4;
                            break;
                          }
                          //console.log('POST RESPONSE', response)
                          resolve(response.json());
                          _context16.next = 12;
                          break;
                        case 4:
                          _context16.t0 = tools;
                          _context16.t1 = response.status;
                          _context16.next = 8;
                          return response.json();
                        case 8:
                          _context16.t2 = _context16.sent;
                          r = _context16.t0.responseHelper.call(_context16.t0, _context16.t1, _context16.t2);
                          if (handleError && r) {
                            handleError(r);
                          } else if (r && r.detail) {
                            api.showAlert = {
                              text: r,
                              level: 1
                            };
                            self.setProcessing(false);
                          }
                          resolve(false);
                        case 12:
                        case "end":
                          return _context16.stop();
                      }
                    }, _callee16);
                  }));
                  return function (_x17) {
                    return _ref4.apply(this, arguments);
                  };
                }())["catch"](function (err) {
                  self.setProcessing(false);
                  api.showAlert = {
                    text: 'Internet connection error',
                    level: 0
                  };
                  var r = tools.responseHelper(err.message, null, handleError);
                  if (handleError && r) handleError(r);
                  resolve(false);
                  //console.log(3, 'POST', err.message, err.stack, endpoint);
                  //reject(err);
                });
              }));
            case 5:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function post(_x13, _x14, _x15, _x16) {
        return _post.apply(this, arguments);
      }
      return post;
    }()
  }, {
    key: "remove",
    value: function () {
      var _remove = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee19(endpoint, id, handleError) {
        var self;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              self = this;
              return _context19.abrupt("return", new Promise(function (resolve, reject) {
                fetch(self.serverEndpoint + endpoint + id, {
                  method: 'DELETE',
                  mode: 'cors',
                  credentials: 'include'
                  /*headers: {
                      "X-Browser-URL": window.location.hash
                  }*/
                }).then(/*#__PURE__*/function () {
                  var _ref5 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee18(response) {
                    var r;
                    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee18$(_context18) {
                      while (1) switch (_context18.prev = _context18.next) {
                        case 0:
                          if (!(response.status === 200)) {
                            _context18.next = 4;
                            break;
                          }
                          resolve(response.json());
                          _context18.next = 12;
                          break;
                        case 4:
                          _context18.t0 = tools;
                          _context18.t1 = response.status;
                          _context18.next = 8;
                          return response.json();
                        case 8:
                          _context18.t2 = _context18.sent;
                          r = _context18.t0.responseHelper.call(_context18.t0, _context18.t1, _context18.t2);
                          if (handleError && r) {
                            handleError(r, response);
                          } else if (r && r.detail) {
                            api.showAlert = {
                              text: r,
                              level: 1
                            };
                          }
                          self.setProcessing(false);
                        case 12:
                        case "end":
                          return _context18.stop();
                      }
                    }, _callee18);
                  }));
                  return function (_x21) {
                    return _ref5.apply(this, arguments);
                  };
                }())["catch"](function (err) {
                  self.setProcessing(false);
                  api.showAlert = {
                    text: 'Internet connection error',
                    level: 0
                  };
                  console.log('REMOVE', err.message, err.stack, endpoint, id);
                  resolve(false);
                  reject(err);
                });
              }));
            case 2:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function remove(_x18, _x19, _x20) {
        return _remove.apply(this, arguments);
      }
      return remove;
    }()
  }, {
    key: "save",
    value: function save(endpoint, record, attachFiles, tableName, handleError) {
      var self = this;
      return new Promise(function (resolve, reject) {
        self.post(endpoint, JSON.stringify(record), null, handleError).then(/*#__PURE__*/function () {
          var _ref6 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee20(response) {
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee20$(_context20) {
              while (1) switch (_context20.prev = _context20.next) {
                case 0:
                  if (!(response && attachFiles && attachFiles.length > 0)) {
                    _context20.next = 3;
                    break;
                  }
                  _context20.next = 3;
                  return self.saveAttachments(tableName, response.id, attachFiles, function (r) {
                    response.filesError = r;
                  });
                case 3:
                  resolve(response);
                case 4:
                case "end":
                  return _context20.stop();
              }
            }, _callee20);
          }));
          return function (_x22) {
            return _ref6.apply(this, arguments);
          };
        }())["catch"](function (err) {
          console.log('SAVE', err.message, err.stack, endpoint);
          reject(err);
        });
      });
    }
  }, {
    key: "saveAttachments",
    value: function () {
      var _saveAttachments = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee21(tableName, id, attachFiles, handleError) {
        var files, folders, i, f, res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              console.log('saveAttachments', attachFiles);
              files = new FormData();
              folders = {};
              for (i in attachFiles) {
                f = attachFiles[i];
                if (f.file) {
                  files.append('files[' + i + ']', f.file);
                  if (f.folder) folders[i] = f.folder;
                } else {
                  files.append('files[' + i + ']', f);
                }
                //files.append('files[' + i + ']', attachFiles[i]);
              }
              files.append('folders', JSON.stringify(folders));
              _context21.next = 7;
              return this.post('/api/' + tableName + '/files/' + id, files, {}, handleError);
            case 7:
              res = _context21.sent;
              console.log('response', res);
              return _context21.abrupt("return", res);
            case 10:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function saveAttachments(_x23, _x24, _x25, _x26) {
        return _saveAttachments.apply(this, arguments);
      }
      return saveAttachments;
    }()
  }, {
    key: "savePrintScreen",
    value: function () {
      var _savePrintScreen = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee22(img, fileName, handleError, noHash) {
        var data, res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              data = {
                img: img,
                fileName: fileName,
                noHash: noHash
              };
              _context22.next = 3;
              return this.post('/api/save_file/', JSON.stringify(data), null, handleError);
            case 3:
              res = _context22.sent;
              return _context22.abrupt("return", res);
            case 5:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function savePrintScreen(_x27, _x28, _x29, _x30) {
        return _savePrintScreen.apply(this, arguments);
      }
      return savePrintScreen;
    }()
  }, {
    key: "getServiceCost",
    value: function () {
      var _getServiceCost = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee23(id, date, categoryId, tourLeader, paxCountryType) {
        var data;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              if (id) {
                _context23.next = 2;
                break;
              }
              return _context23.abrupt("return");
            case 2:
              data = {
                id: id,
                date: date
              };
              if (categoryId) data.categoryId = categoryId;
              if (tourLeader) data.tourLeader = true;
              if (paxCountryType) data.paxCountryType = paxCountryType;
              _context23.next = 8;
              return this.get('/api/servicecost/get_by_date', data);
            case 8:
              return _context23.abrupt("return", _context23.sent);
            case 9:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function getServiceCost(_x31, _x32, _x33, _x34, _x35) {
        return _getServiceCost.apply(this, arguments);
      }
      return getServiceCost;
    }()
  }, {
    key: "getServicePrice",
    value: function () {
      var _getServicePrice = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee24(id, date, categoryId, bookingId, tourLeader, serviceMarkup, paxCountryType) {
        var data;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              if (id) {
                _context24.next = 2;
                break;
              }
              return _context24.abrupt("return");
            case 2:
              data = {
                id: id,
                date: date,
                bookingId: bookingId
              };
              if (categoryId) data.categoryId = categoryId;
              if (tourLeader) data.tourLeader = true;
              if (serviceMarkup) data.serviceMarkup = serviceMarkup;
              if (paxCountryType) data.paxCountryType = paxCountryType;
              _context24.next = 9;
              return this.get('/api/servicecost/get_price_by_date', data);
            case 9:
              return _context24.abrupt("return", _context24.sent);
            case 10:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function getServicePrice(_x36, _x37, _x38, _x39, _x40, _x41, _x42) {
        return _getServicePrice.apply(this, arguments);
      }
      return getServicePrice;
    }()
  }, {
    key: "getHotelCost",
    value: function () {
      var _getHotelCost = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee25(id, date, program, currencyId, update, days, paxCountryType) {
        var _this3 = this;
        var key, data, url, res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              if (id) {
                _context25.next = 2;
                break;
              }
              return _context25.abrupt("return");
            case 2:
              key = "".concat(id, "-").concat(date, "-").concat(program ? 'p' : '', "-").concat(currencyId ? currencyId : '', "-").concat(paxCountryType || '');
              if (!(!update && this.hotelCost[key])) {
                _context25.next = 5;
                break;
              }
              return _context25.abrupt("return", this.hotelCost[key]);
            case 5:
              data = {
                id: id,
                date: date
              };
              if (program) data.program = program;
              if (currencyId) data.currencyId = currencyId;
              if (days) data.days = days;
              if (paxCountryType) data.paxCountryType = paxCountryType;
              url = '/api/hotelcost/get_by_date';
              _context25.next = 13;
              return this.get(url, data);
            case 13:
              res = _context25.sent;
              if (!res) {
                _context25.next = 18;
                break;
              }
              this.hotelCost[key] = res;
              setTimeout(function () {
                _this3.hotelCost = {};
              }, 1000 * 30);
              return _context25.abrupt("return", res);
            case 18:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
      function getHotelCost(_x43, _x44, _x45, _x46, _x47, _x48, _x49) {
        return _getHotelCost.apply(this, arguments);
      }
      return getHotelCost;
    }()
  }, {
    key: "getHotelPrice",
    value: function () {
      var _getHotelPrice = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee26(id, date, program, currencyId, bookingId, days, paxCountryType) {
        var data, url;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              if (id) {
                _context26.next = 2;
                break;
              }
              return _context26.abrupt("return");
            case 2:
              data = {
                id: id,
                date: date,
                bookingId: bookingId
              };
              if (program) data.program = program;
              if (days) data.days = days;
              if (paxCountryType) data.paxCountryType = paxCountryType;
              //if (currencyId) data.currencyId = currencyId;
              url = '/api/hotelcost/get_price_by_date';
              _context26.next = 9;
              return this.get(url, data);
            case 9:
              return _context26.abrupt("return", _context26.sent);
            case 10:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
      function getHotelPrice(_x50, _x51, _x52, _x53, _x54, _x55, _x56) {
        return _getHotelPrice.apply(this, arguments);
      }
      return getHotelPrice;
    }()
  }, {
    key: "setReceipts",
    value: function () {
      var _setReceipts = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee27(bookingId) {
        var filters, data, res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              if (bookingId) {
                _context27.next = 3;
                break;
              }
              this.receipts = [];
              return _context27.abrupt("return");
            case 3:
              ;
              this._gettingReceipts = true;
              filters = {
                BookingId: bookingId
              };
              data = {
                filters: JSON.stringify(filters)
              };
              _context27.next = 9;
              return this.get('/api/bookingreceipt/', data);
            case 9:
              res = _context27.sent;
              if (res) {
                this.receipts = res;
                this._gettingReceipts = false;
              }
            case 11:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this);
      }));
      function setReceipts(_x57) {
        return _setReceipts.apply(this, arguments);
      }
      return setReceipts;
    }()
  }, {
    key: "setPayments",
    value: function () {
      var _setPayments = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee28(bookingId, supplierId, callback) {
        var filters, data, res, r, model, _iterator, _step, p, payment;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              if (bookingId) {
                _context28.next = 3;
                break;
              }
              this.payments = [];
              return _context28.abrupt("return");
            case 3:
              ;
              this._gettingPayments = true;
              filters = {
                BookingId: bookingId
              };
              if (supplierId) filters.SupplierId = supplierId;
              data = {
                filters: JSON.stringify(filters)
              };
              _context28.next = 10;
              return this.get('/api/bookingpayment/', data);
            case 10:
              res = _context28.sent;
              if (!res) {
                _context28.next = 36;
                break;
              }
              r = [];
              model = api.importMixinModule('bookingpayment', 'model');
              _iterator = _createForOfIteratorHelper(res);
              _context28.prev = 15;
              _iterator.s();
            case 17:
              if ((_step = _iterator.n()).done) {
                _context28.next = 25;
                break;
              }
              p = _step.value;
              _context28.next = 21;
              return new model({
                record: p,
                notFieldOptions: true
              });
            case 21:
              payment = _context28.sent;
              r.push(payment);
            case 23:
              _context28.next = 17;
              break;
            case 25:
              _context28.next = 30;
              break;
            case 27:
              _context28.prev = 27;
              _context28.t0 = _context28["catch"](15);
              _iterator.e(_context28.t0);
            case 30:
              _context28.prev = 30;
              _iterator.f();
              return _context28.finish(30);
            case 33:
              this.payments = r;
              this._gettingPayments = false;
              if (callback) callback();
            case 36:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this, [[15, 27, 30, 33]]);
      }));
      function setPayments(_x58, _x59, _x60) {
        return _setPayments.apply(this, arguments);
      }
      return setPayments;
    }()
  }, {
    key: "setSupplierCredits",
    value: function () {
      var _setSupplierCredits = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee29(bookingId, supplierId) {
        var filters, data, res, r, model, _iterator2, _step2, p, credit;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              if (bookingId) {
                _context29.next = 3;
                break;
              }
              this.supplierCredits = [];
              return _context29.abrupt("return");
            case 3:
              ;
              filters = {
                BookingId: bookingId
              };
              if (supplierId) filters.SupplierId = supplierId;
              data = {
                filters: JSON.stringify(filters)
              };
              _context29.next = 9;
              return this.get('/api/suppliercredit/', data);
            case 9:
              res = _context29.sent;
              if (!res) {
                _context29.next = 33;
                break;
              }
              r = [];
              model = api.importMixinModule('suppliercredit', 'model');
              _iterator2 = _createForOfIteratorHelper(res);
              _context29.prev = 14;
              _iterator2.s();
            case 16:
              if ((_step2 = _iterator2.n()).done) {
                _context29.next = 24;
                break;
              }
              p = _step2.value;
              _context29.next = 20;
              return new model({
                record: p,
                notFieldOptions: true
              });
            case 20:
              credit = _context29.sent;
              r.push(credit);
            case 22:
              _context29.next = 16;
              break;
            case 24:
              _context29.next = 29;
              break;
            case 26:
              _context29.prev = 26;
              _context29.t0 = _context29["catch"](14);
              _iterator2.e(_context29.t0);
            case 29:
              _context29.prev = 29;
              _iterator2.f();
              return _context29.finish(29);
            case 32:
              this.supplierCredits = r;
            case 33:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this, [[14, 26, 29, 32]]);
      }));
      function setSupplierCredits(_x61, _x62) {
        return _setSupplierCredits.apply(this, arguments);
      }
      return setSupplierCredits;
    }()
  }, {
    key: "addHotelsList",
    value: function () {
      var _addHotelsList = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee30() {
        var _this4 = this;
        var hotels, _iterator3, _step3, _loop;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee30$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              _context31.next = 2;
              return api.get('/api/hotel/get_list_by_date_city_id');
            case 2:
              hotels = _context31.sent;
              if (hotels) {
                _context31.next = 5;
                break;
              }
              return _context31.abrupt("return");
            case 5:
              _iterator3 = _createForOfIteratorHelper(hotels);
              _context31.prev = 6;
              _loop = /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _loop() {
                var hotel, h;
                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _loop$(_context30) {
                  while (1) switch (_context30.prev = _context30.next) {
                    case 0:
                      hotel = _step3.value;
                      h = _.find(_this4.hotelsList, function (r) {
                        return r.id == hotel.id;
                      });
                      if (!h) {
                        _this4.hotelsList.push(hotel);
                      }
                    case 3:
                    case "end":
                      return _context30.stop();
                  }
                }, _loop);
              });
              _iterator3.s();
            case 9:
              if ((_step3 = _iterator3.n()).done) {
                _context31.next = 13;
                break;
              }
              return _context31.delegateYield(_loop(), "t0", 11);
            case 11:
              _context31.next = 9;
              break;
            case 13:
              _context31.next = 18;
              break;
            case 15:
              _context31.prev = 15;
              _context31.t1 = _context31["catch"](6);
              _iterator3.e(_context31.t1);
            case 18:
              _context31.prev = 18;
              _iterator3.f();
              return _context31.finish(18);
            case 21:
            case "end":
              return _context31.stop();
          }
        }, _callee30, null, [[6, 15, 18, 21]]);
      }));
      function addHotelsList() {
        return _addHotelsList.apply(this, arguments);
      }
      return addHotelsList;
    }()
  }, {
    key: "setServiceCostId",
    value: function setServiceCostId(id, categoryId) {
      this.serviceCost[[id, categoryId]] = [];
    }
  }, {
    key: "pushServiceCostId",
    value: function pushServiceCostId(id, categoryId, value) {
      this.serviceCost[[id, categoryId]].push(value);
    }
  }, {
    key: "getModuleFieldsOptions",
    value: function () {
      var _getModuleFieldsOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee31(view, refresh, params) {
        var options, module;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee31$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              if (!(!this.tableOptions[view] || refresh)) {
                _context32.next = 10;
                break;
              }
              module = this.importMixinModule(view, 'views');
              if (!module) {
                module = this.importMixinModule('view', 'views');
              }
              module.table = view;
              //if (!params) params = {};
              _context32.next = 6;
              return module.getTableOptions(params);
            case 6:
              options = _context32.sent;
              this.setTableOptions(view, options);
              _context32.next = 13;
              break;
            case 10:
              _context32.next = 12;
              return this.tableOptions[view];
            case 12:
              options = _context32.sent;
            case 13:
              return _context32.abrupt("return", options);
            case 14:
            case "end":
              return _context32.stop();
          }
        }, _callee31, this);
      }));
      function getModuleFieldsOptions(_x63, _x64, _x65) {
        return _getModuleFieldsOptions.apply(this, arguments);
      }
      return getModuleFieldsOptions;
    }()
  }, {
    key: "importMixinModule",
    value: function importMixinModule(name, path, module) {
      //reverse of list to start with last extra
      var extras = Object.assign([], this.EXTRAS).reverse();
      //p = standard base module
      var p = "@/base/".concat(path, "/").concat(name, ".js");
      var m;
      if (!module && extras.length > 0) {
        m = extras[0];
        //p = last extra module
        p = "@/extra/".concat(m, "/").concat(path, "/").concat(name);
      } else if (extras.length > 0) {
        var i = extras.indexOf(module);
        m = extras[i + 1];
        //if module is indicated, p = next module in extra reversed list
        if (m) p = "@/extra/".concat(m, "/").concat(path, "/").concat(name);
      }
      var res;
      //console.log(extras, name, path, module, p)
      try {
        //try to import
        if (m) {
          //next extra module
          res = __webpack_require__(99837)("./".concat(m, "/").concat(path, "/").concat(name))["default"];
        } else {
          //standard module if not extra module is defined
          res = __webpack_require__(2674)("./".concat(path, "/").concat(name))["default"];
        }
      } catch (_unused) {
        //if cannot import module in extra list, got to next iteration on extra list and try to import
        if (m) {
          res = this.importMixinModule(name, path, m);
        } else {
          //console.log('***** import base view ******', path)
          res = (__webpack_require__(8818)["default"]);
        }
      }
      return res;
    }
  }, {
    key: "importMixinModule2",
    value: function importMixinModule2(name, path, module) {
      var extras = Object.assign([], this.EXTRAS).reverse();
      var p = "@/base/".concat(path, "/").concat(name, ".js");
      var m;
      if (!module && extras.length > 0) {
        m = extras[0];
        p = "@/extra/".concat(m, "/").concat(path, "/").concat(name);
      } else if (extras.length > 0) {
        var i = extras.indexOf(module);
        m = extras[i + 1];
        if (m) p = "@/extra/".concat(m, "/").concat(path, "/").concat(name);
      }
      var res;
      console.log('try', extras, name, path, module, p);
      try {
        if (m) {
          console.log('try', 1, "@/extra/".concat(m, "/").concat(path, "/").concat(name));
          res = __webpack_require__(99837)("./".concat(m, "/").concat(path, "/").concat(name))["default"];
        } else {
          console.log('try', 3, "@/base/".concat(path, "/").concat(name));
          res = __webpack_require__(2674)("./".concat(path, "/").concat(name))["default"];
        }
        //console.log(res)
      } catch (err) {
        console.log(err);
        console.log('try', 4, name, path, m);
        if (m) {
          res = this.importMixinModule2(name, path, m);
        } else {
          console.log('***** import base view ******', name);
          res = (__webpack_require__(8818)["default"]);
        }
      }
      return res;
    }
  }, {
    key: "getImage",
    value: function () {
      var _getImage = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee32(url) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee32$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              return _context33.abrupt("return", url);
            case 1:
            case "end":
              return _context33.stop();
          }
        }, _callee32);
      }));
      function getImage(_x66) {
        return _getImage.apply(this, arguments);
      }
      return getImage;
    }()
  }, {
    key: "getTableId",
    value: function () {
      var _getTableId = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee33(table, id) {
        var records;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee33$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              _context34.next = 2;
              return this.getTable(table);
            case 2:
              records = _context34.sent;
              if (!(records && records.length > 0)) {
                _context34.next = 5;
                break;
              }
              return _context34.abrupt("return", _.find(records, function (r) {
                return r.id == id;
              }));
            case 5:
            case "end":
              return _context34.stop();
          }
        }, _callee33, this);
      }));
      function getTableId(_x67, _x68) {
        return _getTableId.apply(this, arguments);
      }
      return getTableId;
    }()
  }, {
    key: "testDownloadSpeed",
    value: function () {
      var _testDownloadSpeed = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee34(fileName, callback, errorHandle) {
        var fileUrl, receivedLength, response, reader, startTimeReading, _yield$reader$read, done, value, endTimeReading, durationInSeconds, speedInMbps;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee34$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              fileUrl = "https://cairum-demo-app.s3.us-east-2.amazonaws.com/".concat(fileName, ".zip");
              receivedLength = 0;
              _context35.prev = 2;
              _context35.next = 5;
              return fetch(fileUrl, {
                cache: 'no-store'
              });
            case 5:
              response = _context35.sent;
              if (response.ok) {
                _context35.next = 12;
                break;
              }
              if (!errorHandle) {
                _context35.next = 10;
                break;
              }
              errorHandle(response);
              return _context35.abrupt("return");
            case 10:
              alert("Failed to download the file. Status: ".concat(response.status));
              return _context35.abrupt("return");
            case 12:
              reader = response.body.getReader();
              startTimeReading = new Date().getTime();
            case 14:
              if (false) {}
              _context35.next = 17;
              return reader.read();
            case 17:
              _yield$reader$read = _context35.sent;
              done = _yield$reader$read.done;
              value = _yield$reader$read.value;
              if (!done) {
                _context35.next = 22;
                break;
              }
              return _context35.abrupt("break", 25);
            case 22:
              receivedLength += value.length;
              _context35.next = 14;
              break;
            case 25:
              endTimeReading = new Date().getTime();
              durationInSeconds = (endTimeReading - startTimeReading) / 1000;
              speedInMbps = receivedLength * 8 / (durationInSeconds * 1000000);
              callback(speedInMbps);
              _context35.next = 36;
              break;
            case 31:
              _context35.prev = 31;
              _context35.t0 = _context35["catch"](2);
              if (!errorHandle) {
                _context35.next = 36;
                break;
              }
              errorHandle(_context35.t0);
              return _context35.abrupt("return");
            case 36:
            case "end":
              return _context35.stop();
          }
        }, _callee34, null, [[2, 31]]);
      }));
      function testDownloadSpeed(_x69, _x70, _x71) {
        return _testDownloadSpeed.apply(this, arguments);
      }
      return testDownloadSpeed;
    }()
  }]);
}();
window.api = new Api();
//api.getExtraFieldsPaths();

/***/ }),

/***/ 119:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort:
            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
                '_'
            ),
        weekdays:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysShort:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


/***/ }),

/***/ 134:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ParentBookingPayment = api.importMixinModule('bookingpayment', 'model', 'custom');
var CustomBookingPayment = /*#__PURE__*/function (_ParentBookingPayment) {
  function CustomBookingPayment() {
    _classCallCheck(this, CustomBookingPayment);
    return _callSuper(this, CustomBookingPayment, arguments);
  }
  _inherits(CustomBookingPayment, _ParentBookingPayment);
  return _createClass(CustomBookingPayment, [{
    key: "getCurrencyRate",
    get: function get() {
      if (this.MEPCurrencyRate) return this.MEPCurrencyRate;
      return this.CurrencyRate;
    }
  }, {
    key: "afterEdit",
    value: function afterEdit() {
      var res = _superPropGet(CustomBookingPayment, "afterEdit", this, 3)([]);
      res.CurrencyId = null;
      return res;
    }
  }]);
}(ParentBookingPayment);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomBookingPayment);

/***/ }),

/***/ 251:
/***/ ((__unused_webpack_module, exports) => {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 530:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var modeModules = {
  ECB: __webpack_require__(52632),
  CBC: __webpack_require__(92884),
  CFB: __webpack_require__(46383),
  CFB8: __webpack_require__(86975),
  CFB1: __webpack_require__(55264),
  OFB: __webpack_require__(46843),
  CTR: __webpack_require__(63053),
  GCM: __webpack_require__(63053)
}

var modes = __webpack_require__(3219)

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes


/***/ }),

/***/ 894:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var curve = exports;

curve.base = __webpack_require__(36677);
curve.short = __webpack_require__(39188);
curve.mont = __webpack_require__(30370);
curve.edwards = __webpack_require__(31298);


/***/ }),

/***/ 926:
/***/ ((module) => {

"use strict";


module.exports = {
  //NODE_ENV: "testing",
  SERVER_ENDPOINT: "https://api-test.nubbo.io",
  EXTRAS: ["admin", "contacts", "taxes", "accounting", "arg", "vamoos", "custom"],
  FRONT_URL: "https://testing.nubbo.io",
  API_GOOGLE_MAP: "AIzaSyAqSLEPJ7HAQYPi07V0XSJ1rS1fKYNkRLs",
  API_GOOGLE_MAP_ID: "a2c421d48f6df0c3efb962b6",
  APP_NAME: "Designer Trips",
  MAP_ICON: "logo.png",
  DOMAINS: ["localhost", "testing.nubbo.io"],
  DEV_TEST: true,
  COST_CONTROL: false,
  LANG_CODE: "es",
  DEF_EXCHANGE: true,
  SERVER_SIDE: {
    'hotel': true,
    'supplier': true,
    'hotelcost': true
  }
};

/***/ }),

/***/ 1076:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48287)["Buffer"];
/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/



const create = __webpack_require__(91092);

//#region wasm code: md4 (../../../assembly/hash/md4.asm.ts) --initialMemory 1
const md4 = new WebAssembly.Module(
  Buffer.from(
    // 2150 bytes
    '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',
    'base64'
  )
);
//#endregion

module.exports = create.bind(null, md4, [], 64, 32);


/***/ }),

/***/ 1221:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


/***/ }),

/***/ 1241:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var ciphers = __webpack_require__(25799)
var deciphers = __webpack_require__(36171)
var modes = __webpack_require__(3219)

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),

/***/ 1434:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const path = __webpack_require__(57975);
const emojisList = __webpack_require__(80825);
const getHashDigest = __webpack_require__(40286);

const emojiRegex = /[\uD800-\uDFFF]./;
const emojiList = emojisList.filter((emoji) => emojiRegex.test(emoji));
const emojiCache = {};

function encodeStringToEmoji(content, length) {
  if (emojiCache[content]) {
    return emojiCache[content];
  }

  length = length || 1;

  const emojis = [];

  do {
    if (!emojiList.length) {
      throw new Error('Ran out of emoji');
    }

    const index = Math.floor(Math.random() * emojiList.length);

    emojis.push(emojiList[index]);
    emojiList.splice(index, 1);
  } while (--length > 0);

  const emojiEncoding = emojis.join('');

  emojiCache[content] = emojiEncoding;

  return emojiEncoding;
}

function interpolateName(loaderContext, name, options) {
  let filename;

  const hasQuery =
    loaderContext.resourceQuery && loaderContext.resourceQuery.length > 1;

  if (typeof name === 'function') {
    filename = name(
      loaderContext.resourcePath,
      hasQuery ? loaderContext.resourceQuery : undefined
    );
  } else {
    filename = name || '[hash].[ext]';
  }

  const context = options.context;
  const content = options.content;
  const regExp = options.regExp;

  let ext = 'bin';
  let basename = 'file';
  let directory = '';
  let folder = '';
  let query = '';

  if (loaderContext.resourcePath) {
    const parsed = path.parse(loaderContext.resourcePath);
    let resourcePath = loaderContext.resourcePath;

    if (parsed.ext) {
      ext = parsed.ext.substr(1);
    }

    if (parsed.dir) {
      basename = parsed.name;
      resourcePath = parsed.dir + path.sep;
    }

    if (typeof context !== 'undefined') {
      directory = path
        .relative(context, resourcePath + '_')
        .replace(/\\/g, '/')
        .replace(/\.\.(\/)?/g, '_$1');
      directory = directory.substr(0, directory.length - 1);
    } else {
      directory = resourcePath.replace(/\\/g, '/').replace(/\.\.(\/)?/g, '_$1');
    }

    if (directory.length === 1) {
      directory = '';
    } else if (directory.length > 1) {
      folder = path.basename(directory);
    }
  }

  if (loaderContext.resourceQuery && loaderContext.resourceQuery.length > 1) {
    query = loaderContext.resourceQuery;

    const hashIdx = query.indexOf('#');

    if (hashIdx >= 0) {
      query = query.substr(0, hashIdx);
    }
  }

  let url = filename;

  if (content) {
    // Match hash template
    url = url
      // `hash` and `contenthash` are same in `loader-utils` context
      // let's keep `hash` for backward compatibility
      .replace(
        /\[(?:([^[:\]]+):)?(?:hash|contenthash)(?::([a-z]+\d*))?(?::(\d+))?\]/gi,
        (all, hashType, digestType, maxLength) =>
          getHashDigest(content, hashType, digestType, parseInt(maxLength, 10))
      )
      .replace(/\[emoji(?::(\d+))?\]/gi, (all, length) =>
        encodeStringToEmoji(content, parseInt(length, 10))
      );
  }

  url = url
    .replace(/\[ext\]/gi, () => ext)
    .replace(/\[name\]/gi, () => basename)
    .replace(/\[path\]/gi, () => directory)
    .replace(/\[folder\]/gi, () => folder)
    .replace(/\[query\]/gi, () => query);

  if (regExp && loaderContext.resourcePath) {
    const match = loaderContext.resourcePath.match(new RegExp(regExp));

    match &&
      match.forEach((matched, i) => {
        url = url.replace(new RegExp('\\[' + i + '\\]', 'ig'), matched);
      });
  }

  if (
    typeof loaderContext.options === 'object' &&
    typeof loaderContext.options.customInterpolateName === 'function'
  ) {
    url = loaderContext.options.customInterpolateName.call(
      loaderContext,
      url,
      name,
      options
    );
  }

  return url;
}

module.exports = interpolateName;


/***/ }),

/***/ 1506:
/***/ (() => {

window.modelTables.contact = true;

/***/ }),

/***/ 1632:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


/***/ }),

/***/ 1636:
/***/ ((module) => {

"use strict";
module.exports = {"rE":"6.6.1"};

/***/ }),

/***/ 2178:
/***/ ((module) => {

"use strict";

module.exports = function generate__formatLimit(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  out += 'var ' + ($valid) + ' = undefined;';
  if (it.opts.format === false) {
    out += ' ' + ($valid) + ' = true; ';
    return out;
  }
  var $schemaFormat = it.schema.format,
    $isDataFormat = it.opts.$data && $schemaFormat.$data,
    $closingBraces = '';
  if ($isDataFormat) {
    var $schemaValueFormat = it.util.getData($schemaFormat.$data, $dataLvl, it.dataPathArr),
      $format = 'format' + $lvl,
      $compare = 'compare' + $lvl;
    out += ' var ' + ($format) + ' = formats[' + ($schemaValueFormat) + '] , ' + ($compare) + ' = ' + ($format) + ' && ' + ($format) + '.compare;';
  } else {
    var $format = it.formats[$schemaFormat];
    if (!($format && $format.compare)) {
      out += '  ' + ($valid) + ' = true; ';
      return out;
    }
    var $compare = 'formats' + it.util.getProperty($schemaFormat) + '.compare';
  }
  var $isMax = $keyword == 'formatMaximum',
    $exclusiveKeyword = 'formatExclusive' + ($isMax ? 'Maximum' : 'Minimum'),
    $schemaExcl = it.schema[$exclusiveKeyword],
    $isDataExcl = it.opts.$data && $schemaExcl && $schemaExcl.$data,
    $op = $isMax ? '<' : '>',
    $result = 'result' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  if ($isDataExcl) {
    var $schemaValueExcl = it.util.getData($schemaExcl.$data, $dataLvl, it.dataPathArr),
      $exclusive = 'exclusive' + $lvl,
      $opExpr = 'op' + $lvl,
      $opStr = '\' + ' + $opExpr + ' + \'';
    out += ' var schemaExcl' + ($lvl) + ' = ' + ($schemaValueExcl) + '; ';
    $schemaValueExcl = 'schemaExcl' + $lvl;
    out += ' if (typeof ' + ($schemaValueExcl) + ' != \'boolean\' && ' + ($schemaValueExcl) + ' !== undefined) { ' + ($valid) + ' = false; ';
    var $errorKeyword = $exclusiveKeyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ($errorKeyword || '_formatExclusiveLimit') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
      if (it.opts.messages !== false) {
        out += ' , message: \'' + ($exclusiveKeyword) + ' should be boolean\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError([' + (__err) + ']); ';
      } else {
        out += ' validate.errors = [' + (__err) + ']; return false; ';
      }
    } else {
      out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    }
    out += ' }  ';
    if ($breakOnError) {
      $closingBraces += '}';
      out += ' else { ';
    }
    if ($isData) {
      out += ' if (' + ($schemaValue) + ' === undefined) ' + ($valid) + ' = true; else if (typeof ' + ($schemaValue) + ' != \'string\') ' + ($valid) + ' = false; else { ';
      $closingBraces += '}';
    }
    if ($isDataFormat) {
      out += ' if (!' + ($compare) + ') ' + ($valid) + ' = true; else { ';
      $closingBraces += '}';
    }
    out += ' var ' + ($result) + ' = ' + ($compare) + '(' + ($data) + ',  ';
    if ($isData) {
      out += '' + ($schemaValue);
    } else {
      out += '' + (it.util.toQuotedString($schema));
    }
    out += ' ); if (' + ($result) + ' === undefined) ' + ($valid) + ' = false; var ' + ($exclusive) + ' = ' + ($schemaValueExcl) + ' === true; if (' + ($valid) + ' === undefined) { ' + ($valid) + ' = ' + ($exclusive) + ' ? ' + ($result) + ' ' + ($op) + ' 0 : ' + ($result) + ' ' + ($op) + '= 0; } if (!' + ($valid) + ') var op' + ($lvl) + ' = ' + ($exclusive) + ' ? \'' + ($op) + '\' : \'' + ($op) + '=\';';
  } else {
    var $exclusive = $schemaExcl === true,
      $opStr = $op;
    if (!$exclusive) $opStr += '=';
    var $opExpr = '\'' + $opStr + '\'';
    if ($isData) {
      out += ' if (' + ($schemaValue) + ' === undefined) ' + ($valid) + ' = true; else if (typeof ' + ($schemaValue) + ' != \'string\') ' + ($valid) + ' = false; else { ';
      $closingBraces += '}';
    }
    if ($isDataFormat) {
      out += ' if (!' + ($compare) + ') ' + ($valid) + ' = true; else { ';
      $closingBraces += '}';
    }
    out += ' var ' + ($result) + ' = ' + ($compare) + '(' + ($data) + ',  ';
    if ($isData) {
      out += '' + ($schemaValue);
    } else {
      out += '' + (it.util.toQuotedString($schema));
    }
    out += ' ); if (' + ($result) + ' === undefined) ' + ($valid) + ' = false; if (' + ($valid) + ' === undefined) ' + ($valid) + ' = ' + ($result) + ' ' + ($op);
    if (!$exclusive) {
      out += '=';
    }
    out += ' 0;';
  }
  out += '' + ($closingBraces) + 'if (!' + ($valid) + ') { ';
  var $errorKeyword = $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ($errorKeyword || '_formatLimit') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { comparison: ' + ($opExpr) + ', limit:  ';
    if ($isData) {
      out += '' + ($schemaValue);
    } else {
      out += '' + (it.util.toQuotedString($schema));
    }
    out += ' , exclusive: ' + ($exclusive) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should be ' + ($opStr) + ' "';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + (it.util.escapeQuotes($schema));
      }
      out += '"\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + (it.util.toQuotedString($schema));
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '}';
  return out;
}


/***/ }),

/***/ 2287:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(67426);
var common = __webpack_require__(66166);
var shaCommon = __webpack_require__(66225);
var assert = __webpack_require__(43349);

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),

/***/ 2455:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* provided dependency */ var process = __webpack_require__(65606);
var defaultEncoding
/* istanbul ignore next */
if (__webpack_require__.g.process && __webpack_require__.g.process.browser) {
  defaultEncoding = 'utf-8'
} else if (__webpack_require__.g.process && __webpack_require__.g.process.version) {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
} else {
  defaultEncoding = 'utf-8'
}
module.exports = defaultEncoding


/***/ }),

/***/ 2543:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 2585:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var util = __webpack_require__(96740);

module.exports = SchemaObject;

function SchemaObject(obj) {
  util.copy(obj, this);
}


/***/ }),

/***/ 2674:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var map = {
	"./": 8626,
	"./abm": 51272,
	"./abm.js": 51272,
	"./abms/booking": 19783,
	"./abms/booking.js": 19783,
	"./api": 66,
	"./api.js": 66,
	"./image": 89431,
	"./image.js": 89431,
	"./index": 8626,
	"./index.js": 8626,
	"./model/base-model": 42675,
	"./model/base-model.js": 42675,
	"./model/basequote": 32299,
	"./model/basequote.js": 32299,
	"./model/basequotes": 8286,
	"./model/basequotes.js": 8286,
	"./model/booking": 13536,
	"./model/booking.js": 13536,
	"./model/bookingbasemodel": 51941,
	"./model/bookingbasemodel.js": 51941,
	"./model/bookingcurrencyrate": 80386,
	"./model/bookingcurrencyrate.js": 80386,
	"./model/bookingcurrencyrates": 5377,
	"./model/bookingcurrencyrates.js": 5377,
	"./model/bookingday": 88829,
	"./model/bookingday.js": 88829,
	"./model/bookingdayhotel": 44075,
	"./model/bookingdayhotel.js": 44075,
	"./model/bookingdayroom": 34298,
	"./model/bookingdayroom.js": 34298,
	"./model/bookingdayservice": 37162,
	"./model/bookingdayservice.js": 37162,
	"./model/bookingdayservicecar": 58382,
	"./model/bookingdayservicecar.js": 58382,
	"./model/bookingdayserviceimage": 48433,
	"./model/bookingdayserviceimage.js": 48433,
	"./model/bookingexpense": 73987,
	"./model/bookingexpense.js": 73987,
	"./model/bookingflight": 18129,
	"./model/bookingflight.js": 18129,
	"./model/bookingflightquote": 4853,
	"./model/bookingflightquote.js": 4853,
	"./model/bookingflightquotelist": 6169,
	"./model/bookingflightquotelist.js": 6169,
	"./model/bookingform": 58713,
	"./model/bookingform.js": 58713,
	"./model/bookingoptionalservice": 62948,
	"./model/bookingoptionalservice.js": 62948,
	"./model/bookingpayment": 98881,
	"./model/bookingpayment.js": 98881,
	"./model/bookingreceipt": 89067,
	"./model/bookingreceipt.js": 89067,
	"./model/bookingtotal": 55541,
	"./model/bookingtotal.js": 55541,
	"./model/bookingtotallist": 20505,
	"./model/bookingtotallist.js": 20505,
	"./model/bookingtotalperson": 56004,
	"./model/bookingtotalperson.js": 56004,
	"./model/bookingusershare": 34141,
	"./model/bookingusershare.js": 34141,
	"./model/cache": 42142,
	"./model/cache.js": 42142,
	"./model/cashout": 18953,
	"./model/cashout.js": 18953,
	"./model/city": 51477,
	"./model/city.js": 51477,
	"./model/hotel": 87214,
	"./model/hotel.js": 87214,
	"./model/hotelquote": 20660,
	"./model/hotelquote.js": 20660,
	"./model/hotelquotelist": 5820,
	"./model/hotelquotelist.js": 5820,
	"./model/mail": 61777,
	"./model/mail.js": 61777,
	"./model/record": 55539,
	"./model/record.js": 55539,
	"./model/roomconfiguration": 47471,
	"./model/roomconfiguration.js": 47471,
	"./model/service": 69203,
	"./model/service.js": 69203,
	"./model/servicepersonquote": 99352,
	"./model/servicepersonquote.js": 99352,
	"./model/servicequote": 84735,
	"./model/servicequote.js": 84735,
	"./model/servicequotelist": 29063,
	"./model/servicequotelist.js": 29063,
	"./model/servicequoteobject": 80924,
	"./model/servicequoteobject.js": 80924,
	"./model/supplier": 88098,
	"./model/supplier.js": 88098,
	"./model/suppliercredit": 14599,
	"./model/suppliercredit.js": 14599,
	"./model/user": 66797,
	"./model/user.js": 66797,
	"./pdf": 56112,
	"./pdf.js": 56112,
	"./tools": 80405,
	"./tools.js": 80405,
	"./travelTools": 29721,
	"./travelTools.js": 29721,
	"./views/accessgroup": 97326,
	"./views/accessgroup.js": 97326,
	"./views/agency": 39388,
	"./views/agency.js": 39388,
	"./views/basequote": 65556,
	"./views/basequote.js": 65556,
	"./views/basequotes": 9275,
	"./views/basequotes.js": 9275,
	"./views/booking": 77880,
	"./views/booking.js": 77880,
	"./views/bookingcurrencyrate": 19853,
	"./views/bookingcurrencyrate.js": 19853,
	"./views/bookingday": 79692,
	"./views/bookingday.js": 79692,
	"./views/bookingdayhotel": 58316,
	"./views/bookingdayhotel.js": 58316,
	"./views/bookingdayroom": 97439,
	"./views/bookingdayroom.js": 97439,
	"./views/bookingdayservice": 43525,
	"./views/bookingdayservice.js": 43525,
	"./views/bookingdayservicecar": 83211,
	"./views/bookingdayservicecar.js": 83211,
	"./views/bookingdayserviceimage": 73892,
	"./views/bookingdayserviceimage.js": 73892,
	"./views/bookingexpense": 31554,
	"./views/bookingexpense.js": 31554,
	"./views/bookingflight": 87938,
	"./views/bookingflight.js": 87938,
	"./views/bookingflightquote": 96496,
	"./views/bookingflightquote.js": 96496,
	"./views/bookingflightquotelist": 32856,
	"./views/bookingflightquotelist.js": 32856,
	"./views/bookingform": 20002,
	"./views/bookingform.js": 20002,
	"./views/bookingoptinalservice": 65730,
	"./views/bookingoptinalservice.js": 65730,
	"./views/bookingpayment": 90188,
	"./views/bookingpayment.js": 90188,
	"./views/bookingreceipt": 84070,
	"./views/bookingreceipt.js": 84070,
	"./views/bookingtotalperson": 78473,
	"./views/bookingtotalperson.js": 78473,
	"./views/bookingusershare": 3520,
	"./views/bookingusershare.js": 3520,
	"./views/cashout": 92702,
	"./views/cashout.js": 92702,
	"./views/city": 16740,
	"./views/city.js": 16740,
	"./views/currency": 60392,
	"./views/currency.js": 60392,
	"./views/currencyconversion": 71096,
	"./views/currencyconversion.js": 71096,
	"./views/currencyrate": 90514,
	"./views/currencyrate.js": 90514,
	"./views/hotel": 56117,
	"./views/hotel.js": 56117,
	"./views/hotelcost": 56456,
	"./views/hotelcost.js": 56456,
	"./views/hotelquote": 19249,
	"./views/hotelquote.js": 19249,
	"./views/hotelquotelist": 56853,
	"./views/hotelquotelist.js": 56853,
	"./views/image": 83646,
	"./views/image.js": 83646,
	"./views/includes": 56990,
	"./views/includes.js": 56990,
	"./views/language": 5853,
	"./views/language.js": 5853,
	"./views/mail": 70916,
	"./views/mail.js": 70916,
	"./views/reporttask": 4116,
	"./views/reporttask.js": 4116,
	"./views/roomconfiguration": 49856,
	"./views/roomconfiguration.js": 49856,
	"./views/service": 68152,
	"./views/service.js": 68152,
	"./views/serviceclass": 3766,
	"./views/serviceclass.js": 3766,
	"./views/servicepersonquote": 26021,
	"./views/servicepersonquote.js": 26021,
	"./views/servicequote": 23326,
	"./views/servicequote.js": 23326,
	"./views/servicequotelist": 12626,
	"./views/servicequotelist.js": 12626,
	"./views/servicequoteobject": 40237,
	"./views/servicequoteobject.js": 40237,
	"./views/supplier": 15575,
	"./views/supplier.js": 15575,
	"./views/suppliercredit": 60294,
	"./views/suppliercredit.js": 60294,
	"./views/supplierservice": 64000,
	"./views/supplierservice.js": 64000,
	"./views/termsandconditions": 95961,
	"./views/termsandconditions.js": 95961,
	"./views/user": 71368,
	"./views/user.js": 71368,
	"./views/userprofile": 76619,
	"./views/userprofile.js": 76619,
	"./views/view": 8818,
	"./views/view.js": 8818
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2674;

/***/ }),

/***/ 3035:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort:
            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays:
            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
                '_'
            ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


/***/ }),

/***/ 3044:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var View = api.importMixinModule('bookingdayservice', 'views', 'custom');
var CustomBookingDayServiceView = /*#__PURE__*/function (_View) {
  function CustomBookingDayServiceView() {
    _classCallCheck(this, CustomBookingDayServiceView);
    return _callSuper(this, CustomBookingDayServiceView, arguments);
  }
  _inherits(CustomBookingDayServiceView, _View);
  return _createClass(CustomBookingDayServiceView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(options) {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(CustomBookingDayServiceView, "getTableOptions", this, 2)([options]);
            case 2:
              res = _context.sent;
              res.fields.push({
                name: 'GroupByServiceId',
                label: 'Agrupar con',
                editor: 'vue-select',
                "class": 'w-100 mt-2',
                addBlank: true
              });
              return _context.abrupt("return", res);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions(_x) {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(View);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomBookingDayServiceView);

/***/ }),

/***/ 3219:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

/***/ }),

/***/ 3298:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Record = api.importMixinModule('booking', 'model', 'custom');
var CustomBooking = /*#__PURE__*/function (_Record) {
  function CustomBooking(obj) {
    var _this;
    _classCallCheck(this, CustomBooking);
    _this = _callSuper(this, CustomBooking, [obj]);
    var self = _this;
    return _possibleConstructorReturn(_this, _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var initPromise;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            initPromise = new Promise(function (resolve, reject) {
              resolve(self);
            });
            _context.next = 3;
            return initPromise;
          case 3:
            self = _context.sent;
            if (!(!obj.fromTemplate && !obj.isTemplate && !obj.record)) {
              _context.next = 7;
              break;
            }
            _context.next = 7;
            return self.setBookingDefaults();
          case 7:
            return _context.abrupt("return", self);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))());
  }
  _inherits(CustomBooking, _Record);
  return _createClass(CustomBooking, [{
    key: "create",
    value: function create() {
      _superPropGet(CustomBooking, "create", this, 3)([]);
      if (!this.isTemplate) {
        this.setDefValues();
      }
    }
  }, {
    key: "setDefValues",
    value: function setDefValues() {
      this.$QuoteBy.value = 'SERVICE';
      this.$ShowPriceBy.value = 'PERSON';
      this.$Status.value = 'QUOTE';
      this.CurrencyId = api.baseCurrency.BookingCurrency;
      this.PriceCurrencyId = api.baseCurrency.BookingCurrency;
    }
  }, {
    key: "setBookingDefaults",
    value: function () {
      var _setBookingDefaults = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this2 = this;
        var c, _iterator, _step, r, _iterator2, _step2, _loop, _iterator3, _step3, row;
        return _regeneratorRuntime().wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (api.tables.bookingsetting) {
                _context3.next = 5;
                break;
              }
              c = confirm("No se cargaron algunos seteos. Desea recargar la p\xE1gina?");
              if (!c) {
                _context3.next = 5;
                break;
              }
              window.location.reload();
              return _context3.abrupt("return");
            case 5:
              if (!api.tables.bookingsetting) {
                _context3.next = 54;
                break;
              }
              _iterator = _createForOfIteratorHelper(api.tables.bookingsetting);
              _context3.prev = 7;
              _iterator.s();
            case 9:
              if ((_step = _iterator.n()).done) {
                _context3.next = 46;
                break;
              }
              r = _step.value;
              _iterator2 = _createForOfIteratorHelper(r.DefaultServices);
              _context3.prev = 12;
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var row, found;
                return _regeneratorRuntime().wrap(function _loop$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      row = _step2.value;
                      found = _.find(_this2.BookingDays, function (d) {
                        if (_.find(d.BookingDayServices, function (s) {
                          return s.ServiceId == row.ServiceId;
                        })) return true;
                      });
                      if (found) {
                        _context2.next = 8;
                        break;
                      }
                      if (!(_this2.BookingDays.length == 0)) {
                        _context2.next = 6;
                        break;
                      }
                      _context2.next = 6;
                      return _this2.addNewDay();
                    case 6:
                      _context2.next = 8;
                      return _this2.addServices([row.Service], null, 0);
                    case 8:
                    case "end":
                      return _context2.stop();
                  }
                }, _loop);
              });
              _iterator2.s();
            case 15:
              if ((_step2 = _iterator2.n()).done) {
                _context3.next = 19;
                break;
              }
              return _context3.delegateYield(_loop(), "t0", 17);
            case 17:
              _context3.next = 15;
              break;
            case 19:
              _context3.next = 24;
              break;
            case 21:
              _context3.prev = 21;
              _context3.t1 = _context3["catch"](12);
              _iterator2.e(_context3.t1);
            case 24:
              _context3.prev = 24;
              _iterator2.f();
              return _context3.finish(24);
            case 27:
              _iterator3 = _createForOfIteratorHelper(r.DefaultExpenses);
              _context3.prev = 28;
              _iterator3.s();
            case 30:
              if ((_step3 = _iterator3.n()).done) {
                _context3.next = 36;
                break;
              }
              row = _step3.value;
              _context3.next = 34;
              return this.addRow({
                fieldName: 'BookingExpenses',
                values: {
                  ExpenseType: {
                    BookingExpense: true
                  },
                  Type: 'NOT_PAX',
                  Status: 'PENDING',
                  ExpenseTypeId: row.ExpenseTypeId
                }
              });
            case 34:
              _context3.next = 30;
              break;
            case 36:
              _context3.next = 41;
              break;
            case 38:
              _context3.prev = 38;
              _context3.t2 = _context3["catch"](28);
              _iterator3.e(_context3.t2);
            case 41:
              _context3.prev = 41;
              _iterator3.f();
              return _context3.finish(41);
            case 44:
              _context3.next = 9;
              break;
            case 46:
              _context3.next = 51;
              break;
            case 48:
              _context3.prev = 48;
              _context3.t3 = _context3["catch"](7);
              _iterator.e(_context3.t3);
            case 51:
              _context3.prev = 51;
              _iterator.f();
              return _context3.finish(51);
            case 54:
            case "end":
              return _context3.stop();
          }
        }, _callee2, this, [[7, 48, 51, 54], [12, 21, 24, 27], [28, 38, 41, 44]]);
      }));
      function setBookingDefaults() {
        return _setBookingDefaults.apply(this, arguments);
      }
      return setBookingDefaults;
    }()
  }, {
    key: "stdFinalTotalWithFlights",
    get: function get() {
      return this.stdFinalTotal + this.finalTotalFlightsNotIncluded.Price;
    }
  }, {
    key: "stdFinalTotal",
    get: function get() {
      var res = _superPropGet(CustomBooking, "finalTotal", this, 1);
      return res;
    }
  }, {
    key: "stdFinalTotalProfit",
    get: function get() {
      var res = _superPropGet(CustomBooking, "finalTotal", this, 1);
      return res;
    }
  }, {
    key: "agencyCommission",
    get: function get() {
      return this.finalTotal * (1 - this.PaxTax / 100) - this.stdFinalTotal;
    }
  }, {
    key: "totalProfitWithFlights",
    get: function get() {
      var totalWithFlights = this.totalByBasePaxTypeWithFlights;
      var totalProfit = 0;
      for (var quote in totalWithFlights) {
        var paxTypes = totalWithFlights[quote];
        for (var pType in paxTypes) {
          if (this.QuoteBy == 'SERVICE' && this.SplitTourLeaderQuote && pType == 'TL') continue;
          var profit = paxTypes[pType].Profit;
          totalProfit += profit;
        }
      }
      return totalProfit;
    }
  }, {
    key: "getTotalByBasePaxType",
    value: function getTotalByBasePaxType(baseId, pType) {
      var res = _superPropGet(CustomBooking, "getTotalByBasePaxType", this, 3)([baseId, pType]);
      res.Profit = res.Price - res.Cost;
      if (this.QuoteBy == 'SERVICE' && this.SplitTourLeaderQuote && this.BaseQuotes[baseId].TL) {
        var pax = this.BaseQuotes[baseId][pType];
        var quote = this.BaseQuotes[baseId];
        res.Profit += this.tourLeaderProfit(baseId) / quote.paxQuantityWithoutTL * pax;
      }
      return res;
    }
  }, {
    key: "totalByPaxGroup",
    get: function get() {
      var res = _superPropGet(CustomBooking, "totalByPaxGroup", this, 1);
      var tlProfit = {};
      for (var baseId in res) {
        tlProfit = 0;
        var pax = this.BaseQuotes[baseId].paxQuantity - this.BaseQuotes[baseId].TL;
        for (var groupId in this.QuoteGroups[baseId]) {
          var _res$baseId;
          if (res !== null && res !== void 0 && (_res$baseId = res[baseId]) !== null && _res$baseId !== void 0 && (_res$baseId = _res$baseId[groupId]) !== null && _res$baseId !== void 0 && _res$baseId.tlProfit) {
            tlProfit += res[baseId][groupId].tlProfit;
          }
        }
        var tlProfitPerPerson = tlProfit / pax;
        for (var _groupId in this.QuoteGroups[baseId]) {
          if (this.QuoteGroups[baseId][_groupId].ADT) {
            res[baseId][_groupId].ADT.tlProfitPerPerson = tlProfitPerPerson * this.QuoteGroups[baseId][_groupId].ADT;
            res[baseId][_groupId].ADT.ProfitWithTL = res[baseId][_groupId].ADT.Profit + res[baseId][_groupId].ADT.tlProfitPerPerson;
          }
          if (this.QuoteGroups[baseId][_groupId].CHD) {
            if (!res[baseId][_groupId].CHD) {
              res[baseId][_groupId].CHD = {
                Profit: 0,
                Cost: 0,
                Price: 0,
                tlProfitPerPerson: 0,
                tlProfit: 0,
                ProfitWithTL: 0
              };
            }
            res[baseId][_groupId].CHD.tlProfitPerPerson = tlProfitPerPerson * this.QuoteGroups[baseId][_groupId].CHD;
            res[baseId][_groupId].CHD.ProfitWithTL = res[baseId][_groupId].CHD.Profit + res[baseId][_groupId].CHD.tlProfitPerPerson;
          }
        }
      }
      return res;
    }
  }, {
    key: "tourLeaderProfit",
    value: function tourLeaderProfit(baseId) {
      var res = _superPropGet(CustomBooking, "getTotalByBasePaxType", this, 3)([baseId, 'TL']);
      return res.Price - res.Cost;
    }
  }, {
    key: "totalProfitCalc",
    value: function totalProfitCalc(res, baseId, groupId) {
      var _this3 = this;
      res.totalProfit = 0;
      res.tlProfit = 0;
      this.BaseQuotes[baseId].paxTypes.forEach(function (pType) {
        var _this3$QuoteGroups$ba;
        res[pType].Profit = (res[pType].Price - res[pType].Cost) * ((_this3$QuoteGroups$ba = _this3.QuoteGroups[baseId]) === null || _this3$QuoteGroups$ba === void 0 ? void 0 : _this3$QuoteGroups$ba[groupId][pType]);
        res.totalProfit += res[pType].Profit;
        if (pType == 'TL') {
          res.tlProfit += res[pType].Profit;
        }
      });
      return res;
    }
  }, {
    key: "getTotalByBasePaxTypeWithFlights",
    value: function getTotalByBasePaxTypeWithFlights(baseId, pType) {
      var res = _superPropGet(CustomBooking, "getTotalByBasePaxTypeWithFlights", this, 3)([baseId, pType]);
      res.Profit = res.Price - res.Cost;
      return res;
    }
  }, {
    key: "totalByBasePaxTypeWithFlights",
    get: function get() {
      var res = _superPropGet(CustomBooking, "totalByBasePaxTypeWithFlights", this, 1);
      if (this.QuoteBy == 'SERVICE' && this.SplitTourLeaderQuote) {
        for (var baseId in res) {
          if (!this.BaseQuotes[baseId].TL) continue;
          for (var pType in res[baseId]) {
            if (pType == 'TL') continue;
            var pax = this.BaseQuotes[baseId][pType];
            var quote = this.BaseQuotes[baseId];
            res[baseId][pType].Profit += res[baseId].TL.Profit / quote.paxQuantityWithoutTL * pax;
          }
        }
      }
      return res;
    }
  }, {
    key: "finalTotal",
    get: function get() {
      var res = _superPropGet(CustomBooking, "finalTotal", this, 1);
      if (this.AgencyCommission) {
        res = res / (1 - this.AgencyCommission / 100);
      }
      if (this.PaxTax) {
        res = res / (1 - this.PaxTax / 100);
      }
      return res;
    }
  }, {
    key: "getServiceCommission",
    value: function getServiceCommission(service, cost) {
      var res = _superPropGet(CustomBooking, "getServiceCommission", this, 3)([service, cost]);
      var factor;
      if (service.Service.Supplier) factor = service.Service.Supplier.IIBB;
      if (service.Supplier) factor = service.Supplier.IIBB;
      if (factor) {
        if (!res) res = 0;
        res = res - factor;
      }
      return res;
    }
  }, {
    key: "setAgency",
    value: function () {
      var _setAgency = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this$Agency;
        var _this$Agency2;
        return _regeneratorRuntime().wrap(function _callee3$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _superPropGet(CustomBooking, "setAgency", this, 3)([]);
              if (this.AgencyId == this.Agency.id && (_this$Agency = this.Agency) !== null && _this$Agency !== void 0 && _this$Agency.Note) {
                alert("".concat(tr('Agency'), ": ").concat((_this$Agency2 = this.Agency) === null || _this$Agency2 === void 0 ? void 0 : _this$Agency2.Note));
              }
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee3, this);
      }));
      function setAgency() {
        return _setAgency.apply(this, arguments);
      }
      return setAgency;
    }()
  }, {
    key: "getHotelCommission",
    value: function getHotelCommission(room, costByDate) {
      var res = _superPropGet(CustomBooking, "getHotelCommission", this, 3)([room, costByDate]);
      var factor;
      if (room.Hotel && room.Hotel.Supplier) factor = room.Hotel.Supplier.IIBB;
      if (room.HotelId && room.SupplierId && room.SupplierId != room.Hotel.SupplierId) factor = room.Supplier.IIBB;
      if (factor) {
        if (!res) res = 0;
        res = res - factor;
      }
      return res;
    }
  }, {
    key: "profitPercent",
    get: function get() {
      return this.profit / this.finalIncomes * 100;
    }
  }, {
    key: "finalIncomes",
    get: function get() {
      var res = _superPropGet(CustomBooking, "finalIncomes", this, 1);
      if (this.bookingConfirmed) {
        res += -this.totalExpenses;
      }
      return res;
    }
  }, {
    key: "finalCost",
    get: function get() {
      var res = _superPropGet(CustomBooking, "finalCost", this, 1);
      if (this.bookingConfirmed) {
        res += -this.totalExpenses;
      }
      return res;
    }
  }, {
    key: "bookingTotals",
    get: function get() {
      var res = _superPropGet(CustomBooking, "bookingTotals", this, 1);
      var _iterator4 = _createForOfIteratorHelper(res),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var row = _step4.value;
          if (row.Quote && row.Quote.Price) {
            if (this.AgencyCommission) {
              row.Quote.Price = row.Quote.Price / (1 - this.AgencyCommission / 100);
            }
            if (this.PaxTax) {
              row.Quote.Price = row.Quote.Price / (1 - this.PaxTax / 100);
            }
          }
          if (row.Quote && row.Quote.PersonPrice && this.QuoteBy == 'SERVICE') {
            if (this.AgencyCommission) {
              row.Quote.PersonPrice = row.Quote.PersonPrice / (1 - this.AgencyCommission / 100);
            }
            if (this.PaxTax) {
              row.Quote.PersonPrice = row.Quote.PersonPrice / (1 - this.PaxTax / 100);
            }
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return res;
    }
  }, {
    key: "addHotelComment",
    value: function addHotelComment(room, errorsList, dayNr, sId) {
      if (!room.HotelId) return;
      if (!room.Hotel) return;
      if (!room.Hotel.Comment) return;
      var errorCode = 'hotel_comment_' + room.HotelId;
      var text = "".concat(room.Hotel.Name, ":  ").concat(room.Hotel.Comment);
      var error = {
        text: text,
        dayNr: dayNr,
        sId: sId
      };
      errorsList[errorCode] = error;
    }
  }, {
    key: "checkFields",
    value: function () {
      var _checkFields = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res, ids, errors, _iterator5, _step5, day, _iterator7, _step7, service, _iterator6, _step6, _day, _iterator8, _step8, _service;
        return _regeneratorRuntime().wrap(function _callee4$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _superPropGet(CustomBooking, "checkFields", this, 3)([]);
            case 2:
              res = _context5.sent;
              if (!res) {
                _context5.next = 5;
                break;
              }
              return _context5.abrupt("return", res);
            case 5:
              ids = [];
              errors = [];
              _iterator5 = _createForOfIteratorHelper(this.BookingDays);
              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  day = _step5.value;
                  _iterator7 = _createForOfIteratorHelper(day.BookingDayServices);
                  try {
                    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                      service = _step7.value;
                      if (service.ServiceId && ids.indexOf(service.ServiceId) == -1) {
                        ids.push(service.ServiceId);
                      }
                    }
                  } catch (err) {
                    _iterator7.e(err);
                  } finally {
                    _iterator7.f();
                  }
                }
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
              _iterator6 = _createForOfIteratorHelper(this.BookingDays);
              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  _day = _step6.value;
                  _iterator8 = _createForOfIteratorHelper(_day.BookingDayServices);
                  try {
                    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                      _service = _step8.value;
                      if (_service.GroupByServiceId && ids.indexOf(_service.GroupByServiceId) == -1) {
                        errors.push("D\xEDa ".concat(_day.DayNr + 1, " ").concat(_service.Service.Name));
                      }
                    }
                  } catch (err) {
                    _iterator8.e(err);
                  } finally {
                    _iterator8.f();
                  }
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
              if (!(errors.length > 0)) {
                _context5.next = 13;
                break;
              }
              return _context5.abrupt("return", ['Error en Agrupar con: ' + errors.join('; ')]);
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee4, this);
      }));
      function checkFields() {
        return _checkFields.apply(this, arguments);
      }
      return checkFields;
    }()
  }, {
    key: "getMealsServices",
    value: function getMealsServices(dayService) {
      var _dayService$Service, _dayService$Service2, _dayService$Service3, _dayService$Service4, _dayService$Service5;
      var res = [];
      var lang = this.Language.Code || 'en';
      if ((_dayService$Service = dayService.Service) !== null && _dayService$Service !== void 0 && _dayService$Service.Breakfast || dayService.Breakfast) res.push(tr('Breakfast', lang));
      if ((_dayService$Service2 = dayService.Service) !== null && _dayService$Service2 !== void 0 && _dayService$Service2.Lunch || dayService.Lunch) res.push(tr('Lunch', lang));
      if ((_dayService$Service3 = dayService.Service) !== null && _dayService$Service3 !== void 0 && _dayService$Service3.Dinner || dayService.Dinner) res.push(tr('Dinner', lang));
      if ((_dayService$Service4 = dayService.Service) !== null && _dayService$Service4 !== void 0 && _dayService$Service4.Snack || dayService.Snack) res.push(tr('Snack', lang));
      if ((_dayService$Service5 = dayService.Service) !== null && _dayService$Service5 !== void 0 && _dayService$Service5.BoxLunch || dayService.BoxLunch) res.push(tr('Box Lunch', lang));
      return res.join(', ');
    }
  }, {
    key: "getMealsHotel",
    value: function getMealsHotel(dayRoom) {
      var _dayRoom$Hotel;
      var res = [];
      var lang = this.Language.Code || 'en';
      if ((_dayRoom$Hotel = dayRoom.Hotel) !== null && _dayRoom$Hotel !== void 0 && _dayRoom$Hotel.MealsByCategory) {
        var _dayRoom$Category, _dayRoom$Category2, _dayRoom$Category3, _dayRoom$Category4;
        if ((_dayRoom$Category = dayRoom.Category) !== null && _dayRoom$Category !== void 0 && _dayRoom$Category.Lunch) res.push(tr('Lunch', lang));
        if ((_dayRoom$Category2 = dayRoom.Category) !== null && _dayRoom$Category2 !== void 0 && _dayRoom$Category2.Dinner) res.push(tr('Dinner', lang));
        if ((_dayRoom$Category3 = dayRoom.Category) !== null && _dayRoom$Category3 !== void 0 && _dayRoom$Category3.Snack) res.push(tr('Snack', lang));
        if ((_dayRoom$Category4 = dayRoom.Category) !== null && _dayRoom$Category4 !== void 0 && _dayRoom$Category4.BoxLunch) res.push(tr('Box Lunch', lang));
      } else {
        var _dayRoom$Hotel2, _dayRoom$Hotel3, _dayRoom$Hotel4, _dayRoom$Hotel5;
        if ((_dayRoom$Hotel2 = dayRoom.Hotel) !== null && _dayRoom$Hotel2 !== void 0 && _dayRoom$Hotel2.Lunch || dayRoom.Lunch) res.push(tr('Lunch', lang));
        if ((_dayRoom$Hotel3 = dayRoom.Hotel) !== null && _dayRoom$Hotel3 !== void 0 && _dayRoom$Hotel3.Dinner || dayRoom.Dinner) res.push(tr('Dinner', lang));
        if ((_dayRoom$Hotel4 = dayRoom.Hotel) !== null && _dayRoom$Hotel4 !== void 0 && _dayRoom$Hotel4.Snack || dayRoom.Snack) res.push(tr('Snack', lang));
        if ((_dayRoom$Hotel5 = dayRoom.Hotel) !== null && _dayRoom$Hotel5 !== void 0 && _dayRoom$Hotel5.BoxLunch || dayRoom.BoxLunch) res.push(tr('Box Lunch', lang));
      }
      return res.join(', ');
    }
  }], [{
    key: "createBookingFromTemplate",
    value: function () {
      var _createBookingFromTemplate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(template) {
        var booking;
        return _regeneratorRuntime().wrap(function _callee5$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _superPropGet(CustomBooking, "createBookingFromTemplate", this, 2)([template]);
            case 2:
              booking = _context6.sent;
              _context6.next = 5;
              return booking.setBookingDefaults();
            case 5:
              return _context6.abrupt("return", booking);
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee5, this);
      }));
      function createBookingFromTemplate(_x) {
        return _createBookingFromTemplate.apply(this, arguments);
      }
      return createBookingFromTemplate;
    }()
  }]);
}(Record);
_defineProperty(CustomBooking, "swapQuoteBy", true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomBooking);

/***/ }),

/***/ 3322:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једног минута'],
            mm: ['минут', 'минута', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            d: ['један дан', 'једног дана'],
            dd: ['дан', 'дана', 'дана'],
            M: ['један месец', 'једног месеца'],
            MM: ['месец', 'месеца', 'месеци'],
            y: ['једну годину', 'једне године'],
            yy: ['годину', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'једна година';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'годину') {
                return number + ' година';
            }

            return number + ' ' + word;
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort:
            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return srCyrl;

})));


/***/ }),

/***/ 3389:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var assert = __webpack_require__(43349);
var inherits = __webpack_require__(56698);

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),

/***/ 3508:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort:
            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
                '_'
            ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


/***/ }),

/***/ 3520:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8818);





function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingUserShareView = /*#__PURE__*/function (_View) {
  function BookingUserShareView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, BookingUserShareView);
    return _callSuper(this, BookingUserShareView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(BookingUserShareView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingUserShareView, null, [{
    key: "getTableOptions",
    value: function getTableOptions() {
      return {
        fields: [{
          name: 'UserId',
          label: 'User',
          editor: 'select',
          optionLabels: 'UserName',
          relation: 'user',
          filters: function filters(row) {
            if (row.Department && row.Department.Sales && !row.Closed) return true;
          }
        }]
      };
    }
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_2__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingUserShareView);

/***/ }),

/***/ 3681:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;
var Transform = __webpack_require__(59083);
__webpack_require__(56698)(PassThrough, Transform);
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ 3766:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8818);









function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var ServiceClassView = /*#__PURE__*/function (_View) {
  function ServiceClassView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, ServiceClassView);
    return _callSuper(this, ServiceClassView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(ServiceClassView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(ServiceClassView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res, iconField;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(ServiceClassView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              res = _context.sent;
              iconField = _.find(res.fields, function (r) {
                return r.name == 'Icon';
              });
              iconField.editor = 'select';
              iconField.icons = true;
              iconField.addBlank = true;
              iconField.options = [{
                value: 'bus',
                label: 'bus'
              }, {
                value: 'utensils',
                label: 'utensils'
              }, {
                value: 'car',
                label: 'car'
              }, {
                value: 'landmark',
                label: 'museum'
              }, {
                value: 'theater-masks',
                label: 'theater'
              }, {
                value: 'hiking',
                label: 'hiking'
              }, {
                value: 'train',
                label: 'train'
              }, {
                value: 'ticket-alt',
                label: 'ticket'
              }];
              res.canAdd = true;
              return _context.abrupt("return", res);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_4__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(ServiceClassView, "table", 'serviceclass');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ServiceClassView);

/***/ }),

/***/ 4116:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64467);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8818);






function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ReportTaskView = /*#__PURE__*/function (_View) {
  function ReportTaskView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, ReportTaskView);
    return _callSuper(this, ReportTaskView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(ReportTaskView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(ReportTaskView, null, [{
    key: "getTableOptions",
    value: function getTableOptions() {
      return {
        fields: [{
          name: 'Endpoint',
          hidden: true
        }, {
          name: 'Name',
          label: 'Name',
          headerField: true,
          required: true
        }, {
          name: 'CronTaskId',
          relation: 'crontask',
          optionLabels: 'Name',
          required: true,
          setRelationTo: 'CronTask',
          editor: 'select',
          label: 'Process',
          headerField: true
        }, {
          name: 'Emails',
          headerField: true,
          required: true
        }, {
          name: 'Disabled',
          editor: 'checkbox',
          headerField: true
        }, {
          name: "Data",
          editor: "component",
          label: "Filters",
          component: 'report-labels',
          ref: 'reportLabels',
          componentName: 'ReportLabels',
          componentPath: 'components/tools'
        },
        /*{ name: 'DataTab', editor: 'tab', label: 'Data', hideFromList: true,
            fields: [
                { name: 'Data', editor: 'text-area', columns: 12},
            ]
        },*/
        {
          name: 'ByWeekDay',
          editor: 'component',
          component: 'record-week-days',
          label: 'Week Days'
        }, {
          name: 'WeekDays',
          editor: {},
          hideFromList: true,
          fields: [{
            name: '0'
          }, {
            name: '1'
          }, {
            name: '2'
          }, {
            name: '3'
          }, {
            name: '4'
          }, {
            name: '5'
          }, {
            name: '6'
          }]
        }],
        title: 'Report Task',
        canAdd: true
      };
    }
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(ReportTaskView, "table", 'reporttask');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ReportTaskView);

/***/ }),

/***/ 4131:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var View = api.importMixinModule('bookingpayment', 'views', 'custom');
var CustomBookingPaymentView = /*#__PURE__*/function (_View) {
  function CustomBookingPaymentView() {
    _classCallCheck(this, CustomBookingPaymentView);
    return _callSuper(this, CustomBookingPaymentView, arguments);
  }
  _inherits(CustomBookingPaymentView, _View);
  return _createClass(CustomBookingPaymentView, null, [{
    key: "options",
    value: function options() {
      var res = _superPropGet(CustomBookingPaymentView, "options", this, 2)([]);
      var ccTab = _.find(res.fields, function (r) {
        return r.name == 'currencyConvertTab';
      });
      var rate;
      if (ccTab) {
        rate = _.find(ccTab.fields, function (r) {
          return r.name == 'CurrencyRate';
        });
        ccTab.fields.push({
          name: 'MEPCurrencyRate',
          editor: 'number',
          columns: 2,
          decimal: 4,
          label: 'Cotización MEP'
        });
      }
      ;
      if (rate) rate.decimal = 4;
      return res;
    }
  }]);
}(View);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomBookingPaymentView);

/***/ }),

/***/ 4633:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(73738)["default"]);
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 4686:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var MissingRefError = (__webpack_require__(64551).MissingRef);

module.exports = compileAsync;


/**
 * Creates validating function for passed schema with asynchronous loading of missing schemas.
 * `loadSchema` option should be a function that accepts schema uri and returns promise that resolves with the schema.
 * @this  Ajv
 * @param {Object}   schema schema object
 * @param {Boolean}  meta optional true to compile meta-schema; this parameter can be skipped
 * @param {Function} callback an optional node-style callback, it is called with 2 parameters: error (or null) and validating function.
 * @return {Promise} promise that resolves with a validating function.
 */
function compileAsync(schema, meta, callback) {
  /* eslint no-shadow: 0 */
  /* global Promise */
  /* jshint validthis: true */
  var self = this;
  if (typeof this._opts.loadSchema != 'function')
    throw new Error('options.loadSchema should be a function');

  if (typeof meta == 'function') {
    callback = meta;
    meta = undefined;
  }

  var p = loadMetaSchemaOf(schema).then(function () {
    var schemaObj = self._addSchema(schema, undefined, meta);
    return schemaObj.validate || _compileAsync(schemaObj);
  });

  if (callback) {
    p.then(
      function(v) { callback(null, v); },
      callback
    );
  }

  return p;


  function loadMetaSchemaOf(sch) {
    var $schema = sch.$schema;
    return $schema && !self.getSchema($schema)
            ? compileAsync.call(self, { $ref: $schema }, true)
            : Promise.resolve();
  }


  function _compileAsync(schemaObj) {
    try { return self._compile(schemaObj); }
    catch(e) {
      if (e instanceof MissingRefError) return loadMissingSchema(e);
      throw e;
    }


    function loadMissingSchema(e) {
      var ref = e.missingSchema;
      if (added(ref)) throw new Error('Schema ' + ref + ' is loaded but ' + e.missingRef + ' cannot be resolved');

      var schemaPromise = self._loadingSchemas[ref];
      if (!schemaPromise) {
        schemaPromise = self._loadingSchemas[ref] = self._opts.loadSchema(ref);
        schemaPromise.then(removePromise, removePromise);
      }

      return schemaPromise.then(function (sch) {
        if (!added(ref)) {
          return loadMetaSchemaOf(sch).then(function () {
            if (!added(ref)) self.addSchema(sch, ref, undefined, meta);
          });
        }
      }).then(function() {
        return _compileAsync(schemaObj);
      });

      function removePromise() {
        delete self._loadingSchemas[ref];
      }

      function added(ref) {
        return self._refs[ref] || self._schemas[ref];
      }
    }
  }
}


/***/ }),

/***/ 4729:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var Buffer = (__webpack_require__(92861).Buffer)
var Transform = (__webpack_require__(88310).Transform)
var inherits = __webpack_require__(56698)

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

var useUint8Array = typeof Uint8Array !== 'undefined'
var useArrayBuffer = typeof ArrayBuffer !== 'undefined' &&
  typeof Uint8Array !== 'undefined' &&
  ArrayBuffer.isView &&
  (Buffer.prototype instanceof Uint8Array || Buffer.TYPED_ARRAY_SUPPORT)

function toBuffer (data, encoding) {
  // No need to do anything for exact instance
  // This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
  if (data instanceof Buffer) return data

  // Convert strings to Buffer
  if (typeof data === 'string') return Buffer.from(data, encoding)

  /*
   * Wrap any TypedArray instances and DataViews
   * Makes sense only on engines with full TypedArray support -- let Buffer detect that
   */
  if (useArrayBuffer && ArrayBuffer.isView(data)) {
    if (data.byteLength === 0) return Buffer.alloc(0) // Bug in Node.js <6.3.1, which treats this as out-of-bounds
    var res = Buffer.from(data.buffer, data.byteOffset, data.byteLength)
    // Recheck result size, as offset/length doesn't work on Node.js <5.10
    // We just go to Uint8Array case if this fails
    if (res.byteLength === data.byteLength) return res
  }

  /*
   * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
   * Doesn't make sense with other TypedArray instances
   */
  if (useUint8Array && data instanceof Uint8Array) return Buffer.from(data)

  /*
   * Old Buffer polyfill on an engine that doesn't have TypedArray support
   * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
   * Convert to our current Buffer implementation
   */
  if (
    Buffer.isBuffer(data) &&
    data.constructor &&
    typeof data.constructor.isBuffer === 'function' &&
    data.constructor.isBuffer(data)
  ) {
    return Buffer.from(data)
  }

  throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.')
}

HashBase.prototype.update = function (data, encoding) {
  if (this._finalized) throw new Error('Digest already called')

  data = toBuffer(data, encoding) // asserts correct input type

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase


/***/ }),

/***/ 4853:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64467);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51941);






function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingFlightQuote = /*#__PURE__*/function (_BookingBaseModel) {
  function BookingFlightQuote() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, BookingFlightQuote);
    return _callSuper(this, BookingFlightQuote, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(BookingFlightQuote, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingFlightQuote, [{
    key: "booking",
    get: function get() {
      return this.$parent.$parent.$parent;
    }
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingFlightQuote, "moduleName", 'bookingflightquote');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingFlightQuote);

/***/ }),

/***/ 4934:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var randomBytes = __webpack_require__(53209);
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__(66473);
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__(52244);
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),

/***/ 5267:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).



var eos;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}
var _require$codes = (__webpack_require__(12463)/* .codes */ .F),
  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = __webpack_require__(14257);
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true;

    // request.destroy just do .end - .abort is what we want
    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}
function call(fn) {
  fn();
}
function pipe(from, to) {
  return from.pipe(to);
}
function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}
function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }
  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];
  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }
  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}
module.exports = pipeline;

/***/ }),

/***/ 5359:
/***/ ((module) => {

"use strict";


function getRemainingRequest(loaderContext) {
  if (loaderContext.remainingRequest) {
    return loaderContext.remainingRequest;
  }

  const request = loaderContext.loaders
    .slice(loaderContext.loaderIndex + 1)
    .map((obj) => obj.request)
    .concat([loaderContext.resource]);

  return request.join('!');
}

module.exports = getRemainingRequest;


/***/ }),

/***/ 5377:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51941);







function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingCurrencyRates = /*#__PURE__*/function (_BookingBaseModel) {
  function BookingCurrencyRates(obj) {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingCurrencyRates);
    if (!obj.fields) obj.fields = [];
    if (obj.record) {
      tools.clean(obj.record);
      if (obj.record) {
        for (var key in obj.record) {
          if (isNaN(parseInt(key))) continue;
          obj.fields.push({
            name: key,
            editor: {},
            objectClass: 'bookingcurrencyrate',
            fields: []
          });
        }
      }
    }
    return _callSuper(this, BookingCurrencyRates, [obj]);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingCurrencyRates, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingCurrencyRates, [{
    key: "bases",
    get: function get() {
      return tools.getBases(_.cloneDeep(this));
    }
  }, {
    key: "newCurrencyRate",
    value: function () {
      var _newCurrencyRate = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(obj) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.newRow({
                rowClass: 'bookingcurrencyrate'
              }, obj);
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function newCurrencyRate(_x) {
        return _newCurrencyRate.apply(this, arguments);
      }
      return newCurrencyRate;
    }()
  }, {
    key: "booking",
    get: function get() {
      return this.$parent;
    }
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingCurrencyRates);

/***/ }),

/***/ 5689:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8818);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var AiResponseView = /*#__PURE__*/function (_View) {
  function AiResponseView() {
    _classCallCheck(this, AiResponseView);
    return _callSuper(this, AiResponseView, arguments);
  }
  _inherits(AiResponseView, _View);
  return _createClass(AiResponseView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var r;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(AiResponseView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              r = _context.sent;
              r.fields.push({
                name: 'id',
                editor: 'text',
                label: 'ID',
                readonly: true
              });
              r.fields.push({
                name: 'response',
                fieldName: 'Response',
                editor: 'component',
                component: 'json-editor',
                label: 'Responses'
              });
              r.title = 'Respuestas AI';
              r.canAdd = false;
              r.evalEdit = function (r) {
                return false;
              };
              r.evalDelete = function (r) {
                return false;
              };
              return _context.abrupt("return", r);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }, {
    key: "options",
    value: function options() {
      return {
        canAdd: false,
        canEdit: false
      };
    }
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_0__["default"]);
_defineProperty(AiResponseView, "table", 'airesponse');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AiResponseView);

/***/ }),

/***/ 5704:
/***/ ((module) => {

"use strict";


function parseString(str) {
  try {
    if (str[0] === '"') {
      return JSON.parse(str);
    }

    if (str[0] === "'" && str.substr(str.length - 1) === "'") {
      return parseString(
        str
          .replace(/\\.|"/g, (x) => (x === '"' ? '\\"' : x))
          .replace(/^'|'$/g, '"')
      );
    }

    return JSON.parse('"' + str + '"');
  } catch (e) {
    return str;
  }
}

module.exports = parseString;


/***/ }),

/***/ 5784:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months =
            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
                '_'
            ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


/***/ }),

/***/ 5820:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51941);









function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var HotelQuoteList = /*#__PURE__*/function (_BookingBaseModel) {
  function HotelQuoteList(obj) {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, HotelQuoteList);
    tools.clean(obj.record);
    if (!obj.fields) obj.fields = [];
    if (obj.record) {
      for (var key in obj.record) {
        if (isNaN(parseInt(key))) continue;
        obj.fields.push({
          name: key,
          editor: {},
          objectClass: 'hotelquote'
        });
      }
    }
    return _callSuper(this, HotelQuoteList, [obj]);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(HotelQuoteList, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(HotelQuoteList, [{
    key: "bases",
    get: function get() {
      return tools.getBases(_.cloneDeep(this));
    }
  }, {
    key: "setValue",
    value: function () {
      var _setValue = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_ref) {
        var fieldName, value;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              fieldName = _ref.fieldName, value = _ref.value;
              _context.next = 3;
              return _superPropGet(HotelQuoteList, "setValue", this, 3)([{
                fieldName: fieldName,
                value: value
              }]);
            case 3:
              if (this._loaded && this.bookingDayHotel && this.bookingDayHotel._cache) {
                this.bookingDayHotel._cache.roomsCapacity = false;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function setValue(_x) {
        return _setValue.apply(this, arguments);
      }
      return setValue;
    }()
  }, {
    key: "afterEditRow",
    value: function () {
      var _afterEditRow = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(field) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this._loaded && this.bookingDayHotel && this.bookingDayHotel._cache) {
                this.bookingDayHotel._cache.roomsCapacity = false;
              }
              _context2.next = 3;
              return _superPropGet(HotelQuoteList, "afterEditRow", this, 3)([field]);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function afterEditRow(_x2) {
        return _afterEditRow.apply(this, arguments);
      }
      return afterEditRow;
    }()
  }, {
    key: "getFields",
    value: function getFields() {
      var res = [];
      for (var key in this.bases) {
        res.push({
          name: key,
          editor: {},
          objectClass: 'hotelquote'
        });
      }
      this.fields = res;
    }
  }, {
    key: "newHotelQuote",
    value: function () {
      var _newHotelQuote = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(obj) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.newRow({
                rowClass: 'hotelquote'
              }, obj);
            case 2:
              return _context3.abrupt("return", _context3.sent);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function newHotelQuote(_x3) {
        return _newHotelQuote.apply(this, arguments);
      }
      return newHotelQuote;
    }()
  }, {
    key: "booking",
    get: function get() {
      return this.$parent.$parent.$parent.$parent;
    }
  }, {
    key: "bookingDay",
    get: function get() {
      return this.$parent.$parent.$parent;
    }
  }, {
    key: "bookingDayHotel",
    get: function get() {
      return this.$parent.$parent;
    }
  }, {
    key: "setVariants",
    value: function setVariants() {
      if (this.booking.QuoteVariants) {
        for (var baseId in this.bases) {
          if (!this.booking.isVariant(baseId)) continue;
          if (!this[baseId].Variants) this[baseId].Variants = {};
          for (var variantId in this.booking.QuoteVariants[baseId]) {
            if (tools.isNull(this[baseId].Variants[variantId])) this[baseId].Variants[variantId] = true;
          }
        }
      }
    }
  }, {
    key: "setGroups",
    value: function setGroups() {
      if (!this.booking.quoteService) return;
      if (this.booking.QuoteGroups) {
        for (var baseId in this.bases) {
          if (!this.booking.isGroup(baseId)) continue;
          if (!this[baseId].Groups) this[baseId].Groups = {};
          for (var groupId in this.booking.QuoteGroups[baseId]) {
            var g = this.booking.QuoteGroups[baseId][groupId];
            var pax = (g.ADT ? g.ADT : 0) + (g.CHD ? g.CHD : 0) + (g.TL ? g.TL : 0);
            if (tools.isNull(this[baseId].Groups[groupId])) {
              this[baseId].Groups[groupId] = {
                rooms: this[baseId].Rooms,
                pax: pax,
                selected: true
              };
            }
            this.booking.setPaxByGroups(baseId, this.bookingDay.dayId, 'hotels');
          }
        }
      }
    }
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_4__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(HotelQuoteList, "moduleName", 'hotelquotelist');
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(HotelQuoteList, "invalidated_cache", _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_4__["default"].invalidated_cache_hotels);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HotelQuoteList);

/***/ }),

/***/ 5853:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8818);









function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var LanguageView = /*#__PURE__*/function (_View) {
  function LanguageView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, LanguageView);
    return _callSuper(this, LanguageView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(LanguageView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(LanguageView, null, [{
    key: "options",
    value: function options() {
      return {
        fieldsOrder: ['Name', 'Code'],
        fieldsAbmList: ['Name', 'Code'],
        fieldsDataReplace: {
          Translations: {
            name: 'Translations',
            editor: 'component',
            component: 'json-editor',
            label: 'Translations',
            hideFromList: true
          }
        },
        canAdd: true
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(LanguageView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              res = _context.sent;
              return _context.abrupt("return", res);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_4__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(LanguageView, "table", 'language');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LanguageView);

/***/ }),

/***/ 6169:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51941);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingFlightQuoteList = /*#__PURE__*/function (_BookingBaseModel) {
  function BookingFlightQuoteList(obj) {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingFlightQuoteList);
    if (!obj.fields) obj.fields = [];
    if (obj.record) {
      for (var key in obj.record) {
        if (isNaN(parseInt(key))) continue;
        obj.fields.push({
          name: key,
          editor: {},
          objectClass: 'bookingflightquote'
        });
      }
    }
    return _callSuper(this, BookingFlightQuoteList, [obj]);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingFlightQuoteList, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingFlightQuoteList, [{
    key: "booking",
    get: function get() {
      return this.$parent.$parent;
    }
  }, {
    key: "setFields",
    value: function setFields() {
      this.fields = [];
      for (var baseId in this.booking.bases) {
        this.fields.push({
          name: baseId,
          editor: {},
          objectClass: 'bookingflightquote'
        });
      }
    }
  }, {
    key: "bases",
    get: function get() {
      return tools.getBases(_.cloneDeep(this));
    }
  }, {
    key: "getFields",
    value: function getFields() {
      var res = [];
      for (var key in this.bases) {
        res.push({
          name: key,
          editor: {},
          objectClass: 'bookingflightquote'
        });
      }
      this.fields = res;
    }
  }, {
    key: "newBookingFlightQuote",
    value: function () {
      var _newBookingFlightQuote = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(newBaseId, obj) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.fields.push({
                name: newBaseId,
                editor: {},
                objectClass: 'bookingflightquote'
              });
              _context.next = 3;
              return this.newObject({
                objectClass: 'bookingflightquote'
              }, obj, newBaseId);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function newBookingFlightQuote(_x, _x2) {
        return _newBookingFlightQuote.apply(this, arguments);
      }
      return newBookingFlightQuote;
    }()
  }, {
    key: "setVariants",
    value: function setVariants() {
      var booking = this.booking;
      if (booking.QuoteVariants) {
        for (var baseId in this.bases) {
          if (!booking.isVariant(baseId)) continue;
          if (!this[baseId].Variants) this[baseId].Variants = {};
          for (var variantId in booking.QuoteVariants[baseId]) {
            if (tools.isNull(this[baseId].Variants[variantId])) this[baseId].Variants[variantId] = true;
          }
        }
      }
    }
  }, {
    key: "setGroups",
    value: function setGroups() {
      var booking = this.booking;
      if (!booking.quoteService) return;
      if (booking.QuoteGroups) {
        for (var baseId in this.bases) {
          if (!booking.isGroup(baseId)) continue;
          if (!this[baseId].Groups) this[baseId].Groups = {};
          for (var groupId in booking.QuoteGroups[baseId]) {
            if (tools.isNull(this[baseId].Groups[groupId])) this[baseId].Groups[groupId] = true;
          }
        }
      }
    }
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingFlightQuoteList, "moduleName", 'bookingflightquotelist');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingFlightQuoteList);

/***/ }),

/***/ 6181:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Kurdish [ku-kmr]
//! authors : Mazlum Özdogan : https://github.com/mergehez

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(num, withoutSuffix, key, isFuture) {
        var format = {
            s: ['çend sanîye', 'çend sanîyeyan'],
            ss: [num + ' sanîye', num + ' sanîyeyan'],
            m: ['deqîqeyek', 'deqîqeyekê'],
            mm: [num + ' deqîqe', num + ' deqîqeyan'],
            h: ['saetek', 'saetekê'],
            hh: [num + ' saet', num + ' saetan'],
            d: ['rojek', 'rojekê'],
            dd: [num + ' roj', num + ' rojan'],
            w: ['hefteyek', 'hefteyekê'],
            ww: [num + ' hefte', num + ' hefteyan'],
            M: ['mehek', 'mehekê'],
            MM: [num + ' meh', num + ' mehan'],
            y: ['salek', 'salekê'],
            yy: [num + ' sal', num + ' salan'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    // function obliqueNumSuffix(num) {
    //     if(num.includes(':'))
    //         num = parseInt(num.split(':')[0]);
    //     else
    //         num = parseInt(num);
    //     return num == 0 || num % 10 == 1 ? 'ê'
    //                         : (num > 10 && num % 10 == 0 ? 'î' : 'an');
    // }
    function ezafeNumSuffix(num) {
        num = '' + num;
        var l = num.substring(num.length - 1),
            ll = num.length > 1 ? num.substring(num.length - 2) : '';
        if (
            !(ll == 12 || ll == 13) &&
            (l == '2' || l == '3' || ll == '50' || l == '70' || l == '80')
        )
            return 'yê';
        return 'ê';
    }

    var kuKmr = moment.defineLocale('ku-kmr', {
        // According to the spelling rules defined by the work group of Weqfa Mezopotamyayê (Mesopotamia Foundation)
        // this should be: 'Kanûna Paşîn_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Çirîya Pêşîn_Çirîya Paşîn_Kanûna Pêşîn'
        // But the names below are more well known and handy
        months: 'Rêbendan_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Cotmeh_Mijdar_Berfanbar'.split(
            '_'
        ),
        monthsShort: 'Rêb_Sib_Ada_Nîs_Gul_Hez_Tîr_Teb_Îlo_Cot_Mij_Ber'.split('_'),
        monthsParseExact: true,
        weekdays: 'Yekşem_Duşem_Sêşem_Çarşem_Pêncşem_În_Şemî'.split('_'),
        weekdaysShort: 'Yek_Du_Sê_Çar_Pên_În_Şem'.split('_'),
        weekdaysMin: 'Ye_Du_Sê_Ça_Pê_În_Şe'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'bn' : 'BN';
            } else {
                return isLower ? 'pn' : 'PN';
            }
        },
        meridiemParse: /bn|BN|pn|PN/,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[a] YYYY[an]',
            LLL: 'Do MMMM[a] YYYY[an] HH:mm',
            LLLL: 'dddd, Do MMMM[a] YYYY[an] HH:mm',
            ll: 'Do MMM[.] YYYY[an]',
            lll: 'Do MMM[.] YYYY[an] HH:mm',
            llll: 'ddd[.], Do MMM[.] YYYY[an] HH:mm',
        },
        calendar: {
            sameDay: '[Îro di saet] LT [de]',
            nextDay: '[Sibê di saet] LT [de]',
            nextWeek: 'dddd [di saet] LT [de]',
            lastDay: '[Duh di saet] LT [de]',
            lastWeek: 'dddd[a borî di saet] LT [de]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'di %s de',
            past: 'berî %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(?:yê|ê|\.)/,
        ordinal: function (num, period) {
            var p = period.toLowerCase();
            if (p.includes('w') || p.includes('m')) return num + '.';

            return num + ezafeNumSuffix(num);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return kuKmr;

})));


/***/ }),

/***/ 6947:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Palestine) [ar-ps]
//! author : Majd Al-Shihabi : https://github.com/majdal

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arPs = moment.defineLocale('ar-ps', {
        months: 'كانون الثاني_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_تشري الأوّل_تشرين الثاني_كانون الأوّل'.split(
            '_'
        ),
        monthsShort:
            'ك٢_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_ت١_ت٢_ك١'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .split('') // reversed since negative lookbehind not supported everywhere
                .reverse()
                .join('')
                .replace(/[١٢](?![\u062a\u0643])/g, function (match) {
                    return numberMap[match];
                })
                .split('')
                .reverse()
                .join('')
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arPs;

})));


/***/ }),

/***/ 6990:
/***/ ((module) => {

"use strict";

module.exports = function generate_ref(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $async, $refCode;
  if ($schema == '#' || $schema == '#/') {
    if (it.isRoot) {
      $async = it.async;
      $refCode = 'validate';
    } else {
      $async = it.root.schema.$async === true;
      $refCode = 'root.refVal[0]';
    }
  } else {
    var $refVal = it.resolveRef(it.baseId, $schema, it.isRoot);
    if ($refVal === undefined) {
      var $message = it.MissingRefError.message(it.baseId, $schema);
      if (it.opts.missingRefs == 'fail') {
        it.logger.error($message);
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ('$ref') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { ref: \'' + (it.util.escapeQuotes($schema)) + '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'can\\\'t resolve reference ' + (it.util.escapeQuotes($schema)) + '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: ' + (it.util.toQuotedString($schema)) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
        if ($breakOnError) {
          out += ' if (false) { ';
        }
      } else if (it.opts.missingRefs == 'ignore') {
        it.logger.warn($message);
        if ($breakOnError) {
          out += ' if (true) { ';
        }
      } else {
        throw new it.MissingRefError(it.baseId, $schema, $message);
      }
    } else if ($refVal.inline) {
      var $it = it.util.copy(it);
      $it.level++;
      var $nextValid = 'valid' + $it.level;
      $it.schema = $refVal.schema;
      $it.schemaPath = '';
      $it.errSchemaPath = $schema;
      var $code = it.validate($it).replace(/validate\.schema/g, $refVal.code);
      out += ' ' + ($code) + ' ';
      if ($breakOnError) {
        out += ' if (' + ($nextValid) + ') { ';
      }
    } else {
      $async = $refVal.$async === true || (it.async && $refVal.$async !== false);
      $refCode = $refVal.code;
    }
  }
  if ($refCode) {
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = '';
    if (it.opts.passContext) {
      out += ' ' + ($refCode) + '.call(this, ';
    } else {
      out += ' ' + ($refCode) + '( ';
    }
    out += ' ' + ($data) + ', (dataPath || \'\')';
    if (it.errorPath != '""') {
      out += ' + ' + (it.errorPath);
    }
    var $parentData = $dataLvl ? 'data' + (($dataLvl - 1) || '') : 'parentData',
      $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
    out += ' , ' + ($parentData) + ' , ' + ($parentDataProperty) + ', rootData)  ';
    var __callValidate = out;
    out = $$outStack.pop();
    if ($async) {
      if (!it.async) throw new Error('async schema referenced by sync schema');
      if ($breakOnError) {
        out += ' var ' + ($valid) + '; ';
      }
      out += ' try { await ' + (__callValidate) + '; ';
      if ($breakOnError) {
        out += ' ' + ($valid) + ' = true; ';
      }
      out += ' } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ';
      if ($breakOnError) {
        out += ' ' + ($valid) + ' = false; ';
      }
      out += ' } ';
      if ($breakOnError) {
        out += ' if (' + ($valid) + ') { ';
      }
    } else {
      out += ' if (!' + (__callValidate) + ') { if (vErrors === null) vErrors = ' + ($refCode) + '.errors; else vErrors = vErrors.concat(' + ($refCode) + '.errors); errors = vErrors.length; } ';
      if ($breakOnError) {
        out += ' else { ';
      }
    }
  }
  return out;
}


/***/ }),

/***/ 7106:
/***/ ((module) => {

"use strict";


var traverse = module.exports = function (schema, opts, cb) {
  // Legacy support for v0.3.1 and earlier.
  if (typeof opts == 'function') {
    cb = opts;
    opts = {};
  }

  cb = opts.cb || cb;
  var pre = (typeof cb == 'function') ? cb : cb.pre || function() {};
  var post = cb.post || function() {};

  _traverse(opts, pre, post, schema, '', schema);
};


traverse.keywords = {
  additionalItems: true,
  items: true,
  contains: true,
  additionalProperties: true,
  propertyNames: true,
  not: true
};

traverse.arrayKeywords = {
  items: true,
  allOf: true,
  anyOf: true,
  oneOf: true
};

traverse.propsKeywords = {
  definitions: true,
  properties: true,
  patternProperties: true,
  dependencies: true
};

traverse.skipKeywords = {
  default: true,
  enum: true,
  const: true,
  required: true,
  maximum: true,
  minimum: true,
  exclusiveMaximum: true,
  exclusiveMinimum: true,
  multipleOf: true,
  maxLength: true,
  minLength: true,
  pattern: true,
  format: true,
  maxItems: true,
  minItems: true,
  uniqueItems: true,
  maxProperties: true,
  minProperties: true
};


function _traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
  if (schema && typeof schema == 'object' && !Array.isArray(schema)) {
    pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    for (var key in schema) {
      var sch = schema[key];
      if (Array.isArray(sch)) {
        if (key in traverse.arrayKeywords) {
          for (var i=0; i<sch.length; i++)
            _traverse(opts, pre, post, sch[i], jsonPtr + '/' + key + '/' + i, rootSchema, jsonPtr, key, schema, i);
        }
      } else if (key in traverse.propsKeywords) {
        if (sch && typeof sch == 'object') {
          for (var prop in sch)
            _traverse(opts, pre, post, sch[prop], jsonPtr + '/' + key + '/' + escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
        }
      } else if (key in traverse.keywords || (opts.allKeys && !(key in traverse.skipKeywords))) {
        _traverse(opts, pre, post, sch, jsonPtr + '/' + key, rootSchema, jsonPtr, key, schema);
      }
    }
    post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
  }
}


function escapeJsonPtr(str) {
  return str.replace(/~/g, '~0').replace(/\//g, '~1');
}


/***/ }),

/***/ 7197:
/***/ ((module) => {

"use strict";


module.exports = function defFunc(ajv) {
  defFunc.definition = {
    type: 'number',
    macro: function (schema, parentSchema) {
      var min = schema[0]
        , max = schema[1]
        , exclusive = parentSchema.exclusiveRange;

      validateRangeSchema(min, max, exclusive);

      return exclusive === true
              ? {exclusiveMinimum: min, exclusiveMaximum: max}
              : {minimum: min, maximum: max};
    },
    metaSchema: {
      type: 'array',
      minItems: 2,
      maxItems: 2,
      items: { type: 'number' }
    }
  };

  ajv.addKeyword('range', defFunc.definition);
  ajv.addKeyword('exclusiveRange');
  return ajv;

  function validateRangeSchema(min, max, exclusive) {
    if (exclusive !== undefined && typeof exclusive != 'boolean')
      throw new Error('Invalid schema for exclusiveRange keyword, should be boolean');

    if (min > max || (exclusive && min == max))
      throw new Error('There are no numbers in range');
  }
};


/***/ }),

/***/ 7306:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone:
                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                    '_'
                ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
                '_'
            ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                      ? 'n'
                      : number === 3
                        ? 'r'
                        : number === 4
                          ? 't'
                          : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


/***/ }),

/***/ 7354:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var resolve = __webpack_require__(91030)
  , util = __webpack_require__(96740)
  , errorClasses = __webpack_require__(64551)
  , stableStringify = __webpack_require__(72492);

var validateGenerator = __webpack_require__(51873);

/**
 * Functions below are used inside compiled validations function
 */

var ucs2length = util.ucs2length;
var equal = __webpack_require__(32017);

// this error is thrown by async schemas to return validation errors via exception
var ValidationError = errorClasses.Validation;

module.exports = compile;


/**
 * Compiles schema to validation function
 * @this   Ajv
 * @param  {Object} schema schema object
 * @param  {Object} root object with information about the root schema for this schema
 * @param  {Object} localRefs the hash of local references inside the schema (created by resolve.id), used for inline resolution
 * @param  {String} baseId base ID for IDs in the schema
 * @return {Function} validation function
 */
function compile(schema, root, localRefs, baseId) {
  /* jshint validthis: true, evil: true */
  /* eslint no-shadow: 0 */
  var self = this
    , opts = this._opts
    , refVal = [ undefined ]
    , refs = {}
    , patterns = []
    , patternsHash = {}
    , defaults = []
    , defaultsHash = {}
    , customRules = [];

  root = root || { schema: schema, refVal: refVal, refs: refs };

  var c = checkCompiling.call(this, schema, root, baseId);
  var compilation = this._compilations[c.index];
  if (c.compiling) return (compilation.callValidate = callValidate);

  var formats = this._formats;
  var RULES = this.RULES;

  try {
    var v = localCompile(schema, root, localRefs, baseId);
    compilation.validate = v;
    var cv = compilation.callValidate;
    if (cv) {
      cv.schema = v.schema;
      cv.errors = null;
      cv.refs = v.refs;
      cv.refVal = v.refVal;
      cv.root = v.root;
      cv.$async = v.$async;
      if (opts.sourceCode) cv.source = v.source;
    }
    return v;
  } finally {
    endCompiling.call(this, schema, root, baseId);
  }

  /* @this   {*} - custom context, see passContext option */
  function callValidate() {
    /* jshint validthis: true */
    var validate = compilation.validate;
    var result = validate.apply(this, arguments);
    callValidate.errors = validate.errors;
    return result;
  }

  function localCompile(_schema, _root, localRefs, baseId) {
    var isRoot = !_root || (_root && _root.schema == _schema);
    if (_root.schema != root.schema)
      return compile.call(self, _schema, _root, localRefs, baseId);

    var $async = _schema.$async === true;

    var sourceCode = validateGenerator({
      isTop: true,
      schema: _schema,
      isRoot: isRoot,
      baseId: baseId,
      root: _root,
      schemaPath: '',
      errSchemaPath: '#',
      errorPath: '""',
      MissingRefError: errorClasses.MissingRef,
      RULES: RULES,
      validate: validateGenerator,
      util: util,
      resolve: resolve,
      resolveRef: resolveRef,
      usePattern: usePattern,
      useDefault: useDefault,
      useCustomRule: useCustomRule,
      opts: opts,
      formats: formats,
      logger: self.logger,
      self: self
    });

    sourceCode = vars(refVal, refValCode) + vars(patterns, patternCode)
                   + vars(defaults, defaultCode) + vars(customRules, customRuleCode)
                   + sourceCode;

    if (opts.processCode) sourceCode = opts.processCode(sourceCode, _schema);
    // console.log('\n\n\n *** \n', JSON.stringify(sourceCode));
    var validate;
    try {
      var makeValidate = new Function(
        'self',
        'RULES',
        'formats',
        'root',
        'refVal',
        'defaults',
        'customRules',
        'equal',
        'ucs2length',
        'ValidationError',
        sourceCode
      );

      validate = makeValidate(
        self,
        RULES,
        formats,
        root,
        refVal,
        defaults,
        customRules,
        equal,
        ucs2length,
        ValidationError
      );

      refVal[0] = validate;
    } catch(e) {
      self.logger.error('Error compiling schema, function code:', sourceCode);
      throw e;
    }

    validate.schema = _schema;
    validate.errors = null;
    validate.refs = refs;
    validate.refVal = refVal;
    validate.root = isRoot ? validate : _root;
    if ($async) validate.$async = true;
    if (opts.sourceCode === true) {
      validate.source = {
        code: sourceCode,
        patterns: patterns,
        defaults: defaults
      };
    }

    return validate;
  }

  function resolveRef(baseId, ref, isRoot) {
    ref = resolve.url(baseId, ref);
    var refIndex = refs[ref];
    var _refVal, refCode;
    if (refIndex !== undefined) {
      _refVal = refVal[refIndex];
      refCode = 'refVal[' + refIndex + ']';
      return resolvedRef(_refVal, refCode);
    }
    if (!isRoot && root.refs) {
      var rootRefId = root.refs[ref];
      if (rootRefId !== undefined) {
        _refVal = root.refVal[rootRefId];
        refCode = addLocalRef(ref, _refVal);
        return resolvedRef(_refVal, refCode);
      }
    }

    refCode = addLocalRef(ref);
    var v = resolve.call(self, localCompile, root, ref);
    if (v === undefined) {
      var localSchema = localRefs && localRefs[ref];
      if (localSchema) {
        v = resolve.inlineRef(localSchema, opts.inlineRefs)
            ? localSchema
            : compile.call(self, localSchema, root, localRefs, baseId);
      }
    }

    if (v === undefined) {
      removeLocalRef(ref);
    } else {
      replaceLocalRef(ref, v);
      return resolvedRef(v, refCode);
    }
  }

  function addLocalRef(ref, v) {
    var refId = refVal.length;
    refVal[refId] = v;
    refs[ref] = refId;
    return 'refVal' + refId;
  }

  function removeLocalRef(ref) {
    delete refs[ref];
  }

  function replaceLocalRef(ref, v) {
    var refId = refs[ref];
    refVal[refId] = v;
  }

  function resolvedRef(refVal, code) {
    return typeof refVal == 'object' || typeof refVal == 'boolean'
            ? { code: code, schema: refVal, inline: true }
            : { code: code, $async: refVal && !!refVal.$async };
  }

  function usePattern(regexStr) {
    var index = patternsHash[regexStr];
    if (index === undefined) {
      index = patternsHash[regexStr] = patterns.length;
      patterns[index] = regexStr;
    }
    return 'pattern' + index;
  }

  function useDefault(value) {
    switch (typeof value) {
      case 'boolean':
      case 'number':
        return '' + value;
      case 'string':
        return util.toQuotedString(value);
      case 'object':
        if (value === null) return 'null';
        var valueStr = stableStringify(value);
        var index = defaultsHash[valueStr];
        if (index === undefined) {
          index = defaultsHash[valueStr] = defaults.length;
          defaults[index] = value;
        }
        return 'default' + index;
    }
  }

  function useCustomRule(rule, schema, parentSchema, it) {
    if (self._opts.validateSchema !== false) {
      var deps = rule.definition.dependencies;
      if (deps && !deps.every(function(keyword) {
        return Object.prototype.hasOwnProperty.call(parentSchema, keyword);
      }))
        throw new Error('parent schema must have all required keywords: ' + deps.join(','));

      var validateSchema = rule.definition.validateSchema;
      if (validateSchema) {
        var valid = validateSchema(schema);
        if (!valid) {
          var message = 'keyword schema is invalid: ' + self.errorsText(validateSchema.errors);
          if (self._opts.validateSchema == 'log') self.logger.error(message);
          else throw new Error(message);
        }
      }
    }

    var compile = rule.definition.compile
      , inline = rule.definition.inline
      , macro = rule.definition.macro;

    var validate;
    if (compile) {
      validate = compile.call(self, schema, parentSchema, it);
    } else if (macro) {
      validate = macro.call(self, schema, parentSchema, it);
      if (opts.validateSchema !== false) self.validateSchema(validate, true);
    } else if (inline) {
      validate = inline.call(self, it, rule.keyword, schema, parentSchema);
    } else {
      validate = rule.definition.validate;
      if (!validate) return;
    }

    if (validate === undefined)
      throw new Error('custom keyword "' + rule.keyword + '"failed to compile');

    var index = customRules.length;
    customRules[index] = validate;

    return {
      code: 'customRule' + index,
      validate: validate
    };
  }
}


/**
 * Checks if the schema is currently compiled
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 * @return {Object} object with properties "index" (compilation index) and "compiling" (boolean)
 */
function checkCompiling(schema, root, baseId) {
  /* jshint validthis: true */
  var index = compIndex.call(this, schema, root, baseId);
  if (index >= 0) return { index: index, compiling: true };
  index = this._compilations.length;
  this._compilations[index] = {
    schema: schema,
    root: root,
    baseId: baseId
  };
  return { index: index, compiling: false };
}


/**
 * Removes the schema from the currently compiled list
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 */
function endCompiling(schema, root, baseId) {
  /* jshint validthis: true */
  var i = compIndex.call(this, schema, root, baseId);
  if (i >= 0) this._compilations.splice(i, 1);
}


/**
 * Index of schema compilation in the currently compiled list
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 * @return {Integer} compilation index
 */
function compIndex(schema, root, baseId) {
  /* jshint validthis: true */
  for (var i=0; i<this._compilations.length; i++) {
    var c = this._compilations[i];
    if (c.schema == schema && c.root == root && c.baseId == baseId) return i;
  }
  return -1;
}


function patternCode(i, patterns) {
  return 'var pattern' + i + ' = new RegExp(' + util.toQuotedString(patterns[i]) + ');';
}


function defaultCode(i) {
  return 'var default' + i + ' = defaults[' + i + '];';
}


function refValCode(i, refVal) {
  return refVal[i] === undefined ? '' : 'var refVal' + i + ' = refVal[' + i + '];';
}


function customRuleCode(i) {
  return 'var customRule' + i + ' = customRules[' + i + '];';
}


function vars(arr, statement) {
  if (!arr.length) return '';
  var code = '';
  for (var i=0; i<arr.length; i++)
    code += statement(i, arr);
  return code;
}


/***/ }),

/***/ 7543:
/***/ (() => {



/***/ }),

/***/ 7992:
/***/ ((module) => {

"use strict";

module.exports = function generate_custom(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $rule = this,
    $definition = 'definition' + $lvl,
    $rDef = $rule.definition,
    $closingBraces = '';
  var $compile, $inline, $macro, $ruleValidate, $validateCode;
  if ($isData && $rDef.$data) {
    $validateCode = 'keywordValidate' + $lvl;
    var $validateSchema = $rDef.validateSchema;
    out += ' var ' + ($definition) + ' = RULES.custom[\'' + ($keyword) + '\'].definition; var ' + ($validateCode) + ' = ' + ($definition) + '.validate;';
  } else {
    $ruleValidate = it.useCustomRule($rule, $schema, it.schema, it);
    if (!$ruleValidate) return;
    $schemaValue = 'validate.schema' + $schemaPath;
    $validateCode = $ruleValidate.code;
    $compile = $rDef.compile;
    $inline = $rDef.inline;
    $macro = $rDef.macro;
  }
  var $ruleErrs = $validateCode + '.errors',
    $i = 'i' + $lvl,
    $ruleErr = 'ruleErr' + $lvl,
    $asyncKeyword = $rDef.async;
  if ($asyncKeyword && !it.async) throw new Error('async keyword in sync schema');
  if (!($inline || $macro)) {
    out += '' + ($ruleErrs) + ' = null;';
  }
  out += 'var ' + ($errs) + ' = errors;var ' + ($valid) + ';';
  if ($isData && $rDef.$data) {
    $closingBraces += '}';
    out += ' if (' + ($schemaValue) + ' === undefined) { ' + ($valid) + ' = true; } else { ';
    if ($validateSchema) {
      $closingBraces += '}';
      out += ' ' + ($valid) + ' = ' + ($definition) + '.validateSchema(' + ($schemaValue) + '); if (' + ($valid) + ') { ';
    }
  }
  if ($inline) {
    if ($rDef.statements) {
      out += ' ' + ($ruleValidate.validate) + ' ';
    } else {
      out += ' ' + ($valid) + ' = ' + ($ruleValidate.validate) + '; ';
    }
  } else if ($macro) {
    var $it = it.util.copy(it);
    var $closingBraces = '';
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    $it.schema = $ruleValidate.validate;
    $it.schemaPath = '';
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    var $code = it.validate($it).replace(/validate\.schema/g, $validateCode);
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += ' ' + ($code);
  } else {
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = '';
    out += '  ' + ($validateCode) + '.call( ';
    if (it.opts.passContext) {
      out += 'this';
    } else {
      out += 'self';
    }
    if ($compile || $rDef.schema === false) {
      out += ' , ' + ($data) + ' ';
    } else {
      out += ' , ' + ($schemaValue) + ' , ' + ($data) + ' , validate.schema' + (it.schemaPath) + ' ';
    }
    out += ' , (dataPath || \'\')';
    if (it.errorPath != '""') {
      out += ' + ' + (it.errorPath);
    }
    var $parentData = $dataLvl ? 'data' + (($dataLvl - 1) || '') : 'parentData',
      $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
    out += ' , ' + ($parentData) + ' , ' + ($parentDataProperty) + ' , rootData )  ';
    var def_callRuleValidate = out;
    out = $$outStack.pop();
    if ($rDef.errors === false) {
      out += ' ' + ($valid) + ' = ';
      if ($asyncKeyword) {
        out += 'await ';
      }
      out += '' + (def_callRuleValidate) + '; ';
    } else {
      if ($asyncKeyword) {
        $ruleErrs = 'customErrors' + $lvl;
        out += ' var ' + ($ruleErrs) + ' = null; try { ' + ($valid) + ' = await ' + (def_callRuleValidate) + '; } catch (e) { ' + ($valid) + ' = false; if (e instanceof ValidationError) ' + ($ruleErrs) + ' = e.errors; else throw e; } ';
      } else {
        out += ' ' + ($ruleErrs) + ' = null; ' + ($valid) + ' = ' + (def_callRuleValidate) + '; ';
      }
    }
  }
  if ($rDef.modifying) {
    out += ' if (' + ($parentData) + ') ' + ($data) + ' = ' + ($parentData) + '[' + ($parentDataProperty) + '];';
  }
  out += '' + ($closingBraces);
  if ($rDef.valid) {
    if ($breakOnError) {
      out += ' if (true) { ';
    }
  } else {
    out += ' if ( ';
    if ($rDef.valid === undefined) {
      out += ' !';
      if ($macro) {
        out += '' + ($nextValid);
      } else {
        out += '' + ($valid);
      }
    } else {
      out += ' ' + (!$rDef.valid) + ' ';
    }
    out += ') { ';
    $errorKeyword = $rule.keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = '';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ($errorKeyword || 'custom') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { keyword: \'' + ($rule.keyword) + '\' } ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should pass "' + ($rule.keyword) + '" keyword validation\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError([' + (__err) + ']); ';
      } else {
        out += ' validate.errors = [' + (__err) + ']; return false; ';
      }
    } else {
      out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    }
    var def_customError = out;
    out = $$outStack.pop();
    if ($inline) {
      if ($rDef.errors) {
        if ($rDef.errors != 'full') {
          out += '  for (var ' + ($i) + '=' + ($errs) + '; ' + ($i) + '<errors; ' + ($i) + '++) { var ' + ($ruleErr) + ' = vErrors[' + ($i) + ']; if (' + ($ruleErr) + '.dataPath === undefined) ' + ($ruleErr) + '.dataPath = (dataPath || \'\') + ' + (it.errorPath) + '; if (' + ($ruleErr) + '.schemaPath === undefined) { ' + ($ruleErr) + '.schemaPath = "' + ($errSchemaPath) + '"; } ';
          if (it.opts.verbose) {
            out += ' ' + ($ruleErr) + '.schema = ' + ($schemaValue) + '; ' + ($ruleErr) + '.data = ' + ($data) + '; ';
          }
          out += ' } ';
        }
      } else {
        if ($rDef.errors === false) {
          out += ' ' + (def_customError) + ' ';
        } else {
          out += ' if (' + ($errs) + ' == errors) { ' + (def_customError) + ' } else {  for (var ' + ($i) + '=' + ($errs) + '; ' + ($i) + '<errors; ' + ($i) + '++) { var ' + ($ruleErr) + ' = vErrors[' + ($i) + ']; if (' + ($ruleErr) + '.dataPath === undefined) ' + ($ruleErr) + '.dataPath = (dataPath || \'\') + ' + (it.errorPath) + '; if (' + ($ruleErr) + '.schemaPath === undefined) { ' + ($ruleErr) + '.schemaPath = "' + ($errSchemaPath) + '"; } ';
          if (it.opts.verbose) {
            out += ' ' + ($ruleErr) + '.schema = ' + ($schemaValue) + '; ' + ($ruleErr) + '.data = ' + ($data) + '; ';
          }
          out += ' } } ';
        }
      }
    } else if ($macro) {
      out += '   var err =   '; /* istanbul ignore else */
      if (it.createErrors !== false) {
        out += ' { keyword: \'' + ($errorKeyword || 'custom') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { keyword: \'' + ($rule.keyword) + '\' } ';
        if (it.opts.messages !== false) {
          out += ' , message: \'should pass "' + ($rule.keyword) + '" keyword validation\' ';
        }
        if (it.opts.verbose) {
          out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
        }
        out += ' } ';
      } else {
        out += ' {} ';
      }
      out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
      if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */
        if (it.async) {
          out += ' throw new ValidationError(vErrors); ';
        } else {
          out += ' validate.errors = vErrors; return false; ';
        }
      }
    } else {
      if ($rDef.errors === false) {
        out += ' ' + (def_customError) + ' ';
      } else {
        out += ' if (Array.isArray(' + ($ruleErrs) + ')) { if (vErrors === null) vErrors = ' + ($ruleErrs) + '; else vErrors = vErrors.concat(' + ($ruleErrs) + '); errors = vErrors.length;  for (var ' + ($i) + '=' + ($errs) + '; ' + ($i) + '<errors; ' + ($i) + '++) { var ' + ($ruleErr) + ' = vErrors[' + ($i) + ']; if (' + ($ruleErr) + '.dataPath === undefined) ' + ($ruleErr) + '.dataPath = (dataPath || \'\') + ' + (it.errorPath) + ';  ' + ($ruleErr) + '.schemaPath = "' + ($errSchemaPath) + '";  ';
        if (it.opts.verbose) {
          out += ' ' + ($ruleErr) + '.schema = ' + ($schemaValue) + '; ' + ($ruleErr) + '.data = ' + ($data) + '; ';
        }
        out += ' } } else { ' + (def_customError) + ' } ';
      }
    }
    out += ' } ';
    if ($breakOnError) {
      out += ' else { ';
    }
  }
  return out;
}


/***/ }),

/***/ 8198:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"$schema":"http://json-schema.org/draft-07/schema#","$id":"http://json-schema.org/draft-07/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"$comment":{"type":"string"},"title":{"type":"string"},"description":{"type":"string"},"default":true,"readOnly":{"type":"boolean","default":false},"examples":{"type":"array","items":true},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":true},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"propertyNames":{"format":"regex"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":true,"enum":{"type":"array","items":true,"minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"contentMediaType":{"type":"string"},"contentEncoding":{"type":"string"},"if":{"$ref":"#"},"then":{"$ref":"#"},"else":{"$ref":"#"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":true}');

/***/ }),

/***/ 8235:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort:
            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


/***/ }),

/***/ 8286:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51941);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BaseQuotes = /*#__PURE__*/function (_BookingBaseModel) {
  function BaseQuotes(obj) {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BaseQuotes);
    if (!obj.fields) obj.fields = [];
    if (obj.record) {
      tools.clean(obj.record);
      if (obj.record) {
        for (var key in obj.record) {
          if (isNaN(parseInt(key))) continue;
          obj.fields.push({
            name: key,
            editor: {},
            objectClass: 'basequote',
            fields: []
          });
        }
      }
    }
    return _callSuper(this, BaseQuotes, [obj]);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BaseQuotes, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BaseQuotes, [{
    key: "bases",
    get: function get() {
      return tools.getBases(_.cloneDeep(this));
    }
  }, {
    key: "getFields",
    value: function getFields() {
      var res = [];
      for (var key in this.bases) {
        res.push({
          name: key,
          editor: {},
          objectClass: 'basequote'
        });
      }
      this.fields = res;
    }
  }, {
    key: "newBaseQuotes",
    value: function () {
      var _newBaseQuotes = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(base, obj) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.newObject({
                objectClass: 'basequote'
              }, obj, base);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function newBaseQuotes(_x, _x2) {
        return _newBaseQuotes.apply(this, arguments);
      }
      return newBaseQuotes;
    }()
  }, {
    key: "booking",
    get: function get() {
      return this.$parent;
    }
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BaseQuotes, "moduleName", 'basequotes');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BaseQuotes);

/***/ }),

/***/ 8317:
/***/ ((module) => {

"use strict";

module.exports = function generate_pattern(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $regexp = $isData ? '(new RegExp(' + $schemaValue + '))' : it.usePattern($schema);
  out += 'if ( ';
  if ($isData) {
    out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'string\') || ';
  }
  out += ' !' + ($regexp) + '.test(' + ($data) + ') ) {   ';
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('pattern') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { pattern:  ';
    if ($isData) {
      out += '' + ($schemaValue);
    } else {
      out += '' + (it.util.toQuotedString($schema));
    }
    out += '  } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should match pattern "';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + (it.util.escapeQuotes($schema));
      }
      out += '"\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + (it.util.toQuotedString($schema));
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '} ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),

/***/ 8624:
/***/ ((module) => {

"use strict";

module.exports = function generate_patternRequired(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $key = 'key' + $lvl,
    $idx = 'idx' + $lvl,
    $matched = 'patternMatched' + $lvl,
    $dataProperties = 'dataProperties' + $lvl,
    $closingBraces = '',
    $ownProperties = it.opts.ownProperties;
  out += 'var ' + ($valid) + ' = true;';
  if ($ownProperties) {
    out += ' var ' + ($dataProperties) + ' = undefined;';
  }
  var arr1 = $schema;
  if (arr1) {
    var $pProperty, i1 = -1,
      l1 = arr1.length - 1;
    while (i1 < l1) {
      $pProperty = arr1[i1 += 1];
      out += ' var ' + ($matched) + ' = false;  ';
      if ($ownProperties) {
        out += ' ' + ($dataProperties) + ' = ' + ($dataProperties) + ' || Object.keys(' + ($data) + '); for (var ' + ($idx) + '=0; ' + ($idx) + '<' + ($dataProperties) + '.length; ' + ($idx) + '++) { var ' + ($key) + ' = ' + ($dataProperties) + '[' + ($idx) + ']; ';
      } else {
        out += ' for (var ' + ($key) + ' in ' + ($data) + ') { ';
      }
      out += ' ' + ($matched) + ' = ' + (it.usePattern($pProperty)) + '.test(' + ($key) + '); if (' + ($matched) + ') break; } ';
      var $missingPattern = it.util.escapeQuotes($pProperty);
      out += ' if (!' + ($matched) + ') { ' + ($valid) + ' = false;  var err =   '; /* istanbul ignore else */
      if (it.createErrors !== false) {
        out += ' { keyword: \'' + ('patternRequired') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingPattern: \'' + ($missingPattern) + '\' } ';
        if (it.opts.messages !== false) {
          out += ' , message: \'should have property matching pattern \\\'' + ($missingPattern) + '\\\'\' ';
        }
        if (it.opts.verbose) {
          out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
        }
        out += ' } ';
      } else {
        out += ' {} ';
      }
      out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; }   ';
      if ($breakOnError) {
        $closingBraces += '}';
        out += ' else { ';
      }
    }
  }
  out += '' + ($closingBraces);
  return out;
}


/***/ }),

/***/ 8626:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2543);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _base_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66);
/* harmony import */ var _base_tools__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80405);
/* harmony import */ var _base_travelTools__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29721);
/* harmony import */ var _base_model_cache__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42142);
/* harmony import */ var _base_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89431);
/* harmony import */ var _base_abm__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51272);


window.$ = (jquery__WEBPACK_IMPORTED_MODULE_0___default());
window.jQuery = (jquery__WEBPACK_IMPORTED_MODULE_0___default());

window._ = lodash__WEBPACK_IMPORTED_MODULE_1__;
var moment = __webpack_require__(95093);
window.moment = moment;






window.modelTables = {
  hotel: true,
  booking: true,
  mail: true,
  bookingpayment: true,
  bookingreceipt: true,
  bookingform: true,
  supplier: true,
  suppliercredit: true,
  cashout: true
};
var extras = api.EXTRAS;
for (var i in extras) {
  var extra = extras[i];
  try {
    var r = __webpack_require__(86559)("./".concat(extra, "/index.js"))["default"];
  } catch (ex) {}
}
if (false) {}

/***/ }),

/***/ 8650:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var hash = __webpack_require__(77952);
var curves = __webpack_require__(60480);
var utils = __webpack_require__(47011);
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__(46661);
var Signature = __webpack_require__(90220);

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  curve = curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
    .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) {
    return false;
  }
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};


/***/ }),

/***/ 8818:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);




var View = /*#__PURE__*/function () {
  function View() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(this, View);
  }
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(View, null, [{
    key: "options",
    value: function options() {
      return {
        fieldsOrder: ['Name']
      };
    }
  }, {
    key: "serverSide",
    get: function get() {
      return {"hotel":true,"supplier":true,"hotelcost":true}[this.table];
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(options) {
        var res, opt, table, serverFields;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              res = options;
              if (!res) {
                res = {
                  title: this.table,
                  canAdd: true
                };
              }
              opt = this.options();
              res.fieldsOrder = opt.fieldsOrder;
              res.actions = opt.actions;
              if (res.fields) {
                _context.next = 14;
                break;
              }
              table = this.table;
              if (options && options.tableName) table = options.tableName;
              _context.next = 10;
              return api.getTableFields(table);
            case 10:
              _context.next = 12;
              return _context.sent;
            case 12:
              serverFields = _context.sent;
              res.fields = tools.serverTypes(serverFields, res);
            case 14:
              return _context.abrupt("return", res);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions(_x) {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}();
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (View);

/***/ }),

/***/ 9033:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),

/***/ 9053:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);


function mountModel(_x, _x2) {
  return _mountModel.apply(this, arguments);
}
function _mountModel() {
  _mountModel = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(table, id) {
    var options, endpoint, model, record;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return api.getModuleFieldsOptions(table, false, {});
        case 2:
          options = _context.sent;
          endpoint = "/api/".concat(table, "/");
          if (modelTables[table]) {
            model = api.importMixinModule(table, 'model');
          } else {
            model = api.importMixinModule('record', 'model');
          }
          _context.next = 7;
          return model.get({
            id: id,
            tableName: table,
            options: options,
            endpoint: endpoint
          });
        case 7:
          record = _context.sent;
          return _context.abrupt("return", record);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _mountModel.apply(this, arguments);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (mountModel);

/***/ }),

/***/ 9080:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8818);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var AIPromptView = /*#__PURE__*/function (_View) {
  function AIPromptView() {
    _classCallCheck(this, AIPromptView);
    return _callSuper(this, AIPromptView, arguments);
  }
  _inherits(AIPromptView, _View);
  return _createClass(AIPromptView, null, [{
    key: "options",
    value: function options() {
      return {
        canCopy: true,
        canAdd: true
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(AIPromptView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_0__["default"]);
_defineProperty(AIPromptView, "table", 'aiprompt');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AIPromptView);

/***/ }),

/***/ 9275:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8818);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BaseQuotesView = /*#__PURE__*/function (_View) {
  function BaseQuotesView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BaseQuotesView);
    return _callSuper(this, BaseQuotesView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BaseQuotesView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BaseQuotesView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", {
                fields: []
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BaseQuotesView, "table", 'basequotes');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BaseQuotesView);

/***/ }),

/***/ 9673:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var base = exports;

base.Reporter = (__webpack_require__(89220)/* .Reporter */ .a);
base.DecoderBuffer = (__webpack_require__(47227)/* .DecoderBuffer */ .t);
base.EncoderBuffer = (__webpack_require__(47227)/* .EncoderBuffer */ .d);
base.Node = __webpack_require__(90993);


/***/ }),

/***/ 9774:
/***/ ((module) => {

"use strict";


module.exports = function defFunc(ajv) {
  defFunc.definition = {
    type: 'object',
    macro: function (schema, parentSchema) {
      if (!schema) return true;
      var properties = Object.keys(parentSchema.properties);
      if (properties.length == 0) return true;
      return {required: properties};
    },
    metaSchema: {type: 'boolean'},
    dependencies: ['properties']
  };

  ajv.addKeyword('allRequired', defFunc.definition);
  return ajv;
};


/***/ }),

/***/ 10224:
/***/ ((module) => {

"use strict";

module.exports = function generate_const(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  if (!$isData) {
    out += ' var schema' + ($lvl) + ' = validate.schema' + ($schemaPath) + ';';
  }
  out += 'var ' + ($valid) + ' = equal(' + ($data) + ', schema' + ($lvl) + '); if (!' + ($valid) + ') {   ';
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('const') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { allowedValue: schema' + ($lvl) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should be equal to constant\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += ' }';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),

/***/ 10467:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ _asyncToGenerator)
/* harmony export */ });
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}


/***/ }),

/***/ 11025:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort:
            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
                '_'
            ),
        weekdays:
            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
                '_'
            ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


/***/ }),

/***/ 11470:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex =
            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


/***/ }),

/***/ 11713:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort:
            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse:
            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


/***/ }),

/***/ 11885:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort:
            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
                '_'
            ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


/***/ }),

/***/ 12000:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

const {
  stringHints,
  numberHints
} = __webpack_require__(19958);
/** @typedef {import("json-schema").JSONSchema6} JSONSchema6 */

/** @typedef {import("json-schema").JSONSchema7} JSONSchema7 */

/** @typedef {import("./validate").Schema} Schema */

/** @typedef {import("./validate").ValidationErrorConfiguration} ValidationErrorConfiguration */

/** @typedef {import("./validate").PostFormatter} PostFormatter */

/** @typedef {import("./validate").SchemaUtilErrorObject} SchemaUtilErrorObject */

/** @enum {number} */


const SPECIFICITY = {
  type: 1,
  not: 1,
  oneOf: 1,
  anyOf: 1,
  if: 1,
  enum: 1,
  const: 1,
  instanceof: 1,
  required: 2,
  pattern: 2,
  patternRequired: 2,
  format: 2,
  formatMinimum: 2,
  formatMaximum: 2,
  minimum: 2,
  exclusiveMinimum: 2,
  maximum: 2,
  exclusiveMaximum: 2,
  multipleOf: 2,
  uniqueItems: 2,
  contains: 2,
  minLength: 2,
  maxLength: 2,
  minItems: 2,
  maxItems: 2,
  minProperties: 2,
  maxProperties: 2,
  dependencies: 2,
  propertyNames: 2,
  additionalItems: 2,
  additionalProperties: 2,
  absolutePath: 2
};
/**
 *
 * @param {Array<SchemaUtilErrorObject>} array
 * @param {(item: SchemaUtilErrorObject) => number} fn
 * @returns {Array<SchemaUtilErrorObject>}
 */

function filterMax(array, fn) {
  const evaluatedMax = array.reduce((max, item) => Math.max(max, fn(item)), 0);
  return array.filter(item => fn(item) === evaluatedMax);
}
/**
 *
 * @param {Array<SchemaUtilErrorObject>} children
 * @returns {Array<SchemaUtilErrorObject>}
 */


function filterChildren(children) {
  let newChildren = children;
  newChildren = filterMax(newChildren,
  /**
   *
   * @param {SchemaUtilErrorObject} error
   * @returns {number}
   */
  error => error.dataPath ? error.dataPath.length : 0);
  newChildren = filterMax(newChildren,
  /**
   * @param {SchemaUtilErrorObject} error
   * @returns {number}
   */
  error => SPECIFICITY[
  /** @type {keyof typeof SPECIFICITY} */
  error.keyword] || 2);
  return newChildren;
}
/**
 * Find all children errors
 * @param {Array<SchemaUtilErrorObject>} children
 * @param {Array<string>} schemaPaths
 * @return {number} returns index of first child
 */


function findAllChildren(children, schemaPaths) {
  let i = children.length - 1;

  const predicate =
  /**
   * @param {string} schemaPath
   * @returns {boolean}
   */
  schemaPath => children[i].schemaPath.indexOf(schemaPath) !== 0;

  while (i > -1 && !schemaPaths.every(predicate)) {
    if (children[i].keyword === "anyOf" || children[i].keyword === "oneOf") {
      const refs = extractRefs(children[i]);
      const childrenStart = findAllChildren(children.slice(0, i), refs.concat(children[i].schemaPath));
      i = childrenStart - 1;
    } else {
      i -= 1;
    }
  }

  return i + 1;
}
/**
 * Extracts all refs from schema
 * @param {SchemaUtilErrorObject} error
 * @return {Array<string>}
 */


function extractRefs(error) {
  const {
    schema
  } = error;

  if (!Array.isArray(schema)) {
    return [];
  }

  return schema.map(({
    $ref
  }) => $ref).filter(s => s);
}
/**
 * Groups children by their first level parent (assuming that error is root)
 * @param {Array<SchemaUtilErrorObject>} children
 * @return {Array<SchemaUtilErrorObject>}
 */


function groupChildrenByFirstChild(children) {
  const result = [];
  let i = children.length - 1;

  while (i > 0) {
    const child = children[i];

    if (child.keyword === "anyOf" || child.keyword === "oneOf") {
      const refs = extractRefs(child);
      const childrenStart = findAllChildren(children.slice(0, i), refs.concat(child.schemaPath));

      if (childrenStart !== i) {
        result.push(Object.assign({}, child, {
          children: children.slice(childrenStart, i)
        }));
        i = childrenStart;
      } else {
        result.push(child);
      }
    } else {
      result.push(child);
    }

    i -= 1;
  }

  if (i === 0) {
    result.push(children[i]);
  }

  return result.reverse();
}
/**
 * @param {string} str
 * @param {string} prefix
 * @returns {string}
 */


function indent(str, prefix) {
  return str.replace(/\n(?!$)/g, `\n${prefix}`);
}
/**
 * @param {Schema} schema
 * @returns {schema is (Schema & {not: Schema})}
 */


function hasNotInSchema(schema) {
  return !!schema.not;
}
/**
 * @param {Schema} schema
 * @return {Schema}
 */


function findFirstTypedSchema(schema) {
  if (hasNotInSchema(schema)) {
    return findFirstTypedSchema(schema.not);
  }

  return schema;
}
/**
 * @param {Schema} schema
 * @return {boolean}
 */


function canApplyNot(schema) {
  const typedSchema = findFirstTypedSchema(schema);
  return likeNumber(typedSchema) || likeInteger(typedSchema) || likeString(typedSchema) || likeNull(typedSchema) || likeBoolean(typedSchema);
}
/**
 * @param {any} maybeObj
 * @returns {boolean}
 */


function isObject(maybeObj) {
  return typeof maybeObj === "object" && maybeObj !== null;
}
/**
 * @param {Schema} schema
 * @returns {boolean}
 */


function likeNumber(schema) {
  return schema.type === "number" || typeof schema.minimum !== "undefined" || typeof schema.exclusiveMinimum !== "undefined" || typeof schema.maximum !== "undefined" || typeof schema.exclusiveMaximum !== "undefined" || typeof schema.multipleOf !== "undefined";
}
/**
 * @param {Schema} schema
 * @returns {boolean}
 */


function likeInteger(schema) {
  return schema.type === "integer" || typeof schema.minimum !== "undefined" || typeof schema.exclusiveMinimum !== "undefined" || typeof schema.maximum !== "undefined" || typeof schema.exclusiveMaximum !== "undefined" || typeof schema.multipleOf !== "undefined";
}
/**
 * @param {Schema} schema
 * @returns {boolean}
 */


function likeString(schema) {
  return schema.type === "string" || typeof schema.minLength !== "undefined" || typeof schema.maxLength !== "undefined" || typeof schema.pattern !== "undefined" || typeof schema.format !== "undefined" || typeof schema.formatMinimum !== "undefined" || typeof schema.formatMaximum !== "undefined";
}
/**
 * @param {Schema} schema
 * @returns {boolean}
 */


function likeBoolean(schema) {
  return schema.type === "boolean";
}
/**
 * @param {Schema} schema
 * @returns {boolean}
 */


function likeArray(schema) {
  return schema.type === "array" || typeof schema.minItems === "number" || typeof schema.maxItems === "number" || typeof schema.uniqueItems !== "undefined" || typeof schema.items !== "undefined" || typeof schema.additionalItems !== "undefined" || typeof schema.contains !== "undefined";
}
/**
 * @param {Schema & {patternRequired?: Array<string>}} schema
 * @returns {boolean}
 */


function likeObject(schema) {
  return schema.type === "object" || typeof schema.minProperties !== "undefined" || typeof schema.maxProperties !== "undefined" || typeof schema.required !== "undefined" || typeof schema.properties !== "undefined" || typeof schema.patternProperties !== "undefined" || typeof schema.additionalProperties !== "undefined" || typeof schema.dependencies !== "undefined" || typeof schema.propertyNames !== "undefined" || typeof schema.patternRequired !== "undefined";
}
/**
 * @param {Schema} schema
 * @returns {boolean}
 */


function likeNull(schema) {
  return schema.type === "null";
}
/**
 * @param {string} type
 * @returns {string}
 */


function getArticle(type) {
  if (/^[aeiou]/i.test(type)) {
    return "an";
  }

  return "a";
}
/**
 * @param {Schema=} schema
 * @returns {string}
 */


function getSchemaNonTypes(schema) {
  if (!schema) {
    return "";
  }

  if (!schema.type) {
    if (likeNumber(schema) || likeInteger(schema)) {
      return " | should be any non-number";
    }

    if (likeString(schema)) {
      return " | should be any non-string";
    }

    if (likeArray(schema)) {
      return " | should be any non-array";
    }

    if (likeObject(schema)) {
      return " | should be any non-object";
    }
  }

  return "";
}
/**
 * @param {Array<string>} hints
 * @returns {string}
 */


function formatHints(hints) {
  return hints.length > 0 ? `(${hints.join(", ")})` : "";
}
/**
 * @param {Schema} schema
 * @param {boolean} logic
 * @returns {string[]}
 */


function getHints(schema, logic) {
  if (likeNumber(schema) || likeInteger(schema)) {
    return numberHints(schema, logic);
  } else if (likeString(schema)) {
    return stringHints(schema, logic);
  }

  return [];
}

class ValidationError extends Error {
  /**
   * @param {Array<SchemaUtilErrorObject>} errors
   * @param {Schema} schema
   * @param {ValidationErrorConfiguration} configuration
   */
  constructor(errors, schema, configuration = {}) {
    super();
    /** @type {string} */

    this.name = "ValidationError";
    /** @type {Array<SchemaUtilErrorObject>} */

    this.errors = errors;
    /** @type {Schema} */

    this.schema = schema;
    let headerNameFromSchema;
    let baseDataPathFromSchema;

    if (schema.title && (!configuration.name || !configuration.baseDataPath)) {
      const splittedTitleFromSchema = schema.title.match(/^(.+) (.+)$/);

      if (splittedTitleFromSchema) {
        if (!configuration.name) {
          [, headerNameFromSchema] = splittedTitleFromSchema;
        }

        if (!configuration.baseDataPath) {
          [,, baseDataPathFromSchema] = splittedTitleFromSchema;
        }
      }
    }
    /** @type {string} */


    this.headerName = configuration.name || headerNameFromSchema || "Object";
    /** @type {string} */

    this.baseDataPath = configuration.baseDataPath || baseDataPathFromSchema || "configuration";
    /** @type {PostFormatter | null} */

    this.postFormatter = configuration.postFormatter || null;
    const header = `Invalid ${this.baseDataPath} object. ${this.headerName} has been initialized using ${getArticle(this.baseDataPath)} ${this.baseDataPath} object that does not match the API schema.\n`;
    /** @type {string} */

    this.message = `${header}${this.formatValidationErrors(errors)}`;
    Error.captureStackTrace(this, this.constructor);
  }
  /**
   * @param {string} path
   * @returns {Schema}
   */


  getSchemaPart(path) {
    const newPath = path.split("/");
    let schemaPart = this.schema;

    for (let i = 1; i < newPath.length; i++) {
      const inner = schemaPart[
      /** @type {keyof Schema} */
      newPath[i]];

      if (!inner) {
        break;
      }

      schemaPart = inner;
    }

    return schemaPart;
  }
  /**
   * @param {Schema} schema
   * @param {boolean} logic
   * @param {Array<Object>} prevSchemas
   * @returns {string}
   */


  formatSchema(schema, logic = true, prevSchemas = []) {
    let newLogic = logic;

    const formatInnerSchema =
    /**
     *
     * @param {Object} innerSchema
     * @param {boolean=} addSelf
     * @returns {string}
     */
    (innerSchema, addSelf) => {
      if (!addSelf) {
        return this.formatSchema(innerSchema, newLogic, prevSchemas);
      }

      if (prevSchemas.includes(innerSchema)) {
        return "(recursive)";
      }

      return this.formatSchema(innerSchema, newLogic, prevSchemas.concat(schema));
    };

    if (hasNotInSchema(schema) && !likeObject(schema)) {
      if (canApplyNot(schema.not)) {
        newLogic = !logic;
        return formatInnerSchema(schema.not);
      }

      const needApplyLogicHere = !schema.not.not;
      const prefix = logic ? "" : "non ";
      newLogic = !logic;
      return needApplyLogicHere ? prefix + formatInnerSchema(schema.not) : formatInnerSchema(schema.not);
    }

    if (
    /** @type {Schema & {instanceof: string | Array<string>}} */
    schema.instanceof) {
      const {
        instanceof: value
      } =
      /** @type {Schema & {instanceof: string | Array<string>}} */
      schema;
      const values = !Array.isArray(value) ? [value] : value;
      return values.map(
      /**
       * @param {string} item
       * @returns {string}
       */
      item => item === "Function" ? "function" : item).join(" | ");
    }

    if (schema.enum) {
      const enumValues =
      /** @type {Array<any>} */
      schema.enum.map(item => {
        if (item === null && schema.undefinedAsNull) {
          return `${JSON.stringify(item)} | undefined`;
        }

        return JSON.stringify(item);
      }).join(" | ");
      return `${enumValues}`;
    }

    if (typeof schema.const !== "undefined") {
      return JSON.stringify(schema.const);
    }

    if (schema.oneOf) {
      return (
        /** @type {Array<Schema>} */
        schema.oneOf.map(item => formatInnerSchema(item, true)).join(" | ")
      );
    }

    if (schema.anyOf) {
      return (
        /** @type {Array<Schema>} */
        schema.anyOf.map(item => formatInnerSchema(item, true)).join(" | ")
      );
    }

    if (schema.allOf) {
      return (
        /** @type {Array<Schema>} */
        schema.allOf.map(item => formatInnerSchema(item, true)).join(" & ")
      );
    }

    if (
    /** @type {JSONSchema7} */
    schema.if) {
      const {
        if: ifValue,
        then: thenValue,
        else: elseValue
      } =
      /** @type {JSONSchema7} */
      schema;
      return `${ifValue ? `if ${formatInnerSchema(ifValue)}` : ""}${thenValue ? ` then ${formatInnerSchema(thenValue)}` : ""}${elseValue ? ` else ${formatInnerSchema(elseValue)}` : ""}`;
    }

    if (schema.$ref) {
      return formatInnerSchema(this.getSchemaPart(schema.$ref), true);
    }

    if (likeNumber(schema) || likeInteger(schema)) {
      const [type, ...hints] = getHints(schema, logic);
      const str = `${type}${hints.length > 0 ? ` ${formatHints(hints)}` : ""}`;
      return logic ? str : hints.length > 0 ? `non-${type} | ${str}` : `non-${type}`;
    }

    if (likeString(schema)) {
      const [type, ...hints] = getHints(schema, logic);
      const str = `${type}${hints.length > 0 ? ` ${formatHints(hints)}` : ""}`;
      return logic ? str : str === "string" ? "non-string" : `non-string | ${str}`;
    }

    if (likeBoolean(schema)) {
      return `${logic ? "" : "non-"}boolean`;
    }

    if (likeArray(schema)) {
      // not logic already applied in formatValidationError
      newLogic = true;
      const hints = [];

      if (typeof schema.minItems === "number") {
        hints.push(`should not have fewer than ${schema.minItems} item${schema.minItems > 1 ? "s" : ""}`);
      }

      if (typeof schema.maxItems === "number") {
        hints.push(`should not have more than ${schema.maxItems} item${schema.maxItems > 1 ? "s" : ""}`);
      }

      if (schema.uniqueItems) {
        hints.push("should not have duplicate items");
      }

      const hasAdditionalItems = typeof schema.additionalItems === "undefined" || Boolean(schema.additionalItems);
      let items = "";

      if (schema.items) {
        if (Array.isArray(schema.items) && schema.items.length > 0) {
          items = `${
          /** @type {Array<Schema>} */
          schema.items.map(item => formatInnerSchema(item)).join(", ")}`;

          if (hasAdditionalItems) {
            if (schema.additionalItems && isObject(schema.additionalItems) && Object.keys(schema.additionalItems).length > 0) {
              hints.push(`additional items should be ${formatInnerSchema(schema.additionalItems)}`);
            }
          }
        } else if (schema.items && Object.keys(schema.items).length > 0) {
          // "additionalItems" is ignored
          items = `${formatInnerSchema(schema.items)}`;
        } else {
          // Fallback for empty `items` value
          items = "any";
        }
      } else {
        // "additionalItems" is ignored
        items = "any";
      }

      if (schema.contains && Object.keys(schema.contains).length > 0) {
        hints.push(`should contains at least one ${this.formatSchema(schema.contains)} item`);
      }

      return `[${items}${hasAdditionalItems ? ", ..." : ""}]${hints.length > 0 ? ` (${hints.join(", ")})` : ""}`;
    }

    if (likeObject(schema)) {
      // not logic already applied in formatValidationError
      newLogic = true;
      const hints = [];

      if (typeof schema.minProperties === "number") {
        hints.push(`should not have fewer than ${schema.minProperties} ${schema.minProperties > 1 ? "properties" : "property"}`);
      }

      if (typeof schema.maxProperties === "number") {
        hints.push(`should not have more than ${schema.maxProperties} ${schema.minProperties && schema.minProperties > 1 ? "properties" : "property"}`);
      }

      if (schema.patternProperties && Object.keys(schema.patternProperties).length > 0) {
        const patternProperties = Object.keys(schema.patternProperties);
        hints.push(`additional property names should match pattern${patternProperties.length > 1 ? "s" : ""} ${patternProperties.map(pattern => JSON.stringify(pattern)).join(" | ")}`);
      }

      const properties = schema.properties ? Object.keys(schema.properties) : [];
      const required = schema.required ? schema.required : [];
      const allProperties = [...new Set(
      /** @type {Array<string>} */
      [].concat(required).concat(properties))];
      const objectStructure = allProperties.map(property => {
        const isRequired = required.includes(property); // Some properties need quotes, maybe we should add check
        // Maybe we should output type of property (`foo: string`), but it is looks very unreadable

        return `${property}${isRequired ? "" : "?"}`;
      }).concat(typeof schema.additionalProperties === "undefined" || Boolean(schema.additionalProperties) ? schema.additionalProperties && isObject(schema.additionalProperties) ? [`<key>: ${formatInnerSchema(schema.additionalProperties)}`] : ["…"] : []).join(", ");
      const {
        dependencies,
        propertyNames,
        patternRequired
      } =
      /** @type {Schema & {patternRequired?: Array<string>;}} */
      schema;

      if (dependencies) {
        Object.keys(dependencies).forEach(dependencyName => {
          const dependency = dependencies[dependencyName];

          if (Array.isArray(dependency)) {
            hints.push(`should have ${dependency.length > 1 ? "properties" : "property"} ${dependency.map(dep => `'${dep}'`).join(", ")} when property '${dependencyName}' is present`);
          } else {
            hints.push(`should be valid according to the schema ${formatInnerSchema(dependency)} when property '${dependencyName}' is present`);
          }
        });
      }

      if (propertyNames && Object.keys(propertyNames).length > 0) {
        hints.push(`each property name should match format ${JSON.stringify(schema.propertyNames.format)}`);
      }

      if (patternRequired && patternRequired.length > 0) {
        hints.push(`should have property matching pattern ${patternRequired.map(
        /**
         * @param {string} item
         * @returns {string}
         */
        item => JSON.stringify(item))}`);
      }

      return `object {${objectStructure ? ` ${objectStructure} ` : ""}}${hints.length > 0 ? ` (${hints.join(", ")})` : ""}`;
    }

    if (likeNull(schema)) {
      return `${logic ? "" : "non-"}null`;
    }

    if (Array.isArray(schema.type)) {
      // not logic already applied in formatValidationError
      return `${schema.type.join(" | ")}`;
    } // Fallback for unknown keywords
    // not logic already applied in formatValidationError

    /* istanbul ignore next */


    return JSON.stringify(schema, null, 2);
  }
  /**
   * @param {Schema=} schemaPart
   * @param {(boolean | Array<string>)=} additionalPath
   * @param {boolean=} needDot
   * @param {boolean=} logic
   * @returns {string}
   */


  getSchemaPartText(schemaPart, additionalPath, needDot = false, logic = true) {
    if (!schemaPart) {
      return "";
    }

    if (Array.isArray(additionalPath)) {
      for (let i = 0; i < additionalPath.length; i++) {
        /** @type {Schema | undefined} */
        const inner = schemaPart[
        /** @type {keyof Schema} */
        additionalPath[i]];

        if (inner) {
          // eslint-disable-next-line no-param-reassign
          schemaPart = inner;
        } else {
          break;
        }
      }
    }

    while (schemaPart.$ref) {
      // eslint-disable-next-line no-param-reassign
      schemaPart = this.getSchemaPart(schemaPart.$ref);
    }

    let schemaText = `${this.formatSchema(schemaPart, logic)}${needDot ? "." : ""}`;

    if (schemaPart.description) {
      schemaText += `\n-> ${schemaPart.description}`;
    }

    if (schemaPart.link) {
      schemaText += `\n-> Read more at ${schemaPart.link}`;
    }

    return schemaText;
  }
  /**
   * @param {Schema=} schemaPart
   * @returns {string}
   */


  getSchemaPartDescription(schemaPart) {
    if (!schemaPart) {
      return "";
    }

    while (schemaPart.$ref) {
      // eslint-disable-next-line no-param-reassign
      schemaPart = this.getSchemaPart(schemaPart.$ref);
    }

    let schemaText = "";

    if (schemaPart.description) {
      schemaText += `\n-> ${schemaPart.description}`;
    }

    if (schemaPart.link) {
      schemaText += `\n-> Read more at ${schemaPart.link}`;
    }

    return schemaText;
  }
  /**
   * @param {SchemaUtilErrorObject} error
   * @returns {string}
   */


  formatValidationError(error) {
    const {
      keyword,
      dataPath: errorDataPath
    } = error;
    const dataPath = `${this.baseDataPath}${errorDataPath}`;

    switch (keyword) {
      case "type":
        {
          const {
            parentSchema,
            params
          } = error; // eslint-disable-next-line default-case

          switch (
          /** @type {import("ajv").TypeParams} */
          params.type) {
            case "number":
              return `${dataPath} should be a ${this.getSchemaPartText(parentSchema, false, true)}`;

            case "integer":
              return `${dataPath} should be an ${this.getSchemaPartText(parentSchema, false, true)}`;

            case "string":
              return `${dataPath} should be a ${this.getSchemaPartText(parentSchema, false, true)}`;

            case "boolean":
              return `${dataPath} should be a ${this.getSchemaPartText(parentSchema, false, true)}`;

            case "array":
              return `${dataPath} should be an array:\n${this.getSchemaPartText(parentSchema)}`;

            case "object":
              return `${dataPath} should be an object:\n${this.getSchemaPartText(parentSchema)}`;

            case "null":
              return `${dataPath} should be a ${this.getSchemaPartText(parentSchema, false, true)}`;

            default:
              return `${dataPath} should be:\n${this.getSchemaPartText(parentSchema)}`;
          }
        }

      case "instanceof":
        {
          const {
            parentSchema
          } = error;
          return `${dataPath} should be an instance of ${this.getSchemaPartText(parentSchema, false, true)}`;
        }

      case "pattern":
        {
          const {
            params,
            parentSchema
          } = error;
          const {
            pattern
          } =
          /** @type {import("ajv").PatternParams} */
          params;
          return `${dataPath} should match pattern ${JSON.stringify(pattern)}${getSchemaNonTypes(parentSchema)}.${this.getSchemaPartDescription(parentSchema)}`;
        }

      case "format":
        {
          const {
            params,
            parentSchema
          } = error;
          const {
            format
          } =
          /** @type {import("ajv").FormatParams} */
          params;
          return `${dataPath} should match format ${JSON.stringify(format)}${getSchemaNonTypes(parentSchema)}.${this.getSchemaPartDescription(parentSchema)}`;
        }

      case "formatMinimum":
      case "formatMaximum":
        {
          const {
            params,
            parentSchema
          } = error;
          const {
            comparison,
            limit
          } =
          /** @type {import("ajv").ComparisonParams} */
          params;
          return `${dataPath} should be ${comparison} ${JSON.stringify(limit)}${getSchemaNonTypes(parentSchema)}.${this.getSchemaPartDescription(parentSchema)}`;
        }

      case "minimum":
      case "maximum":
      case "exclusiveMinimum":
      case "exclusiveMaximum":
        {
          const {
            parentSchema,
            params
          } = error;
          const {
            comparison,
            limit
          } =
          /** @type {import("ajv").ComparisonParams} */
          params;
          const [, ...hints] = getHints(
          /** @type {Schema} */
          parentSchema, true);

          if (hints.length === 0) {
            hints.push(`should be ${comparison} ${limit}`);
          }

          return `${dataPath} ${hints.join(" ")}${getSchemaNonTypes(parentSchema)}.${this.getSchemaPartDescription(parentSchema)}`;
        }

      case "multipleOf":
        {
          const {
            params,
            parentSchema
          } = error;
          const {
            multipleOf
          } =
          /** @type {import("ajv").MultipleOfParams} */
          params;
          return `${dataPath} should be multiple of ${multipleOf}${getSchemaNonTypes(parentSchema)}.${this.getSchemaPartDescription(parentSchema)}`;
        }

      case "patternRequired":
        {
          const {
            params,
            parentSchema
          } = error;
          const {
            missingPattern
          } =
          /** @type {import("ajv").PatternRequiredParams} */
          params;
          return `${dataPath} should have property matching pattern ${JSON.stringify(missingPattern)}${getSchemaNonTypes(parentSchema)}.${this.getSchemaPartDescription(parentSchema)}`;
        }

      case "minLength":
        {
          const {
            params,
            parentSchema
          } = error;
          const {
            limit
          } =
          /** @type {import("ajv").LimitParams} */
          params;

          if (limit === 1) {
            return `${dataPath} should be a non-empty string${getSchemaNonTypes(parentSchema)}.${this.getSchemaPartDescription(parentSchema)}`;
          }

          const length = limit - 1;
          return `${dataPath} should be longer than ${length} character${length > 1 ? "s" : ""}${getSchemaNonTypes(parentSchema)}.${this.getSchemaPartDescription(parentSchema)}`;
        }

      case "minItems":
        {
          const {
            params,
            parentSchema
          } = error;
          const {
            limit
          } =
          /** @type {import("ajv").LimitParams} */
          params;

          if (limit === 1) {
            return `${dataPath} should be a non-empty array${getSchemaNonTypes(parentSchema)}.${this.getSchemaPartDescription(parentSchema)}`;
          }

          return `${dataPath} should not have fewer than ${limit} items${getSchemaNonTypes(parentSchema)}.${this.getSchemaPartDescription(parentSchema)}`;
        }

      case "minProperties":
        {
          const {
            params,
            parentSchema
          } = error;
          const {
            limit
          } =
          /** @type {import("ajv").LimitParams} */
          params;

          if (limit === 1) {
            return `${dataPath} should be a non-empty object${getSchemaNonTypes(parentSchema)}.${this.getSchemaPartDescription(parentSchema)}`;
          }

          return `${dataPath} should not have fewer than ${limit} properties${getSchemaNonTypes(parentSchema)}.${this.getSchemaPartDescription(parentSchema)}`;
        }

      case "maxLength":
        {
          const {
            params,
            parentSchema
          } = error;
          const {
            limit
          } =
          /** @type {import("ajv").LimitParams} */
          params;
          const max = limit + 1;
          return `${dataPath} should be shorter than ${max} character${max > 1 ? "s" : ""}${getSchemaNonTypes(parentSchema)}.${this.getSchemaPartDescription(parentSchema)}`;
        }

      case "maxItems":
        {
          const {
            params,
            parentSchema
          } = error;
          const {
            limit
          } =
          /** @type {import("ajv").LimitParams} */
          params;
          return `${dataPath} should not have more than ${limit} items${getSchemaNonTypes(parentSchema)}.${this.getSchemaPartDescription(parentSchema)}`;
        }

      case "maxProperties":
        {
          const {
            params,
            parentSchema
          } = error;
          const {
            limit
          } =
          /** @type {import("ajv").LimitParams} */
          params;
          return `${dataPath} should not have more than ${limit} properties${getSchemaNonTypes(parentSchema)}.${this.getSchemaPartDescription(parentSchema)}`;
        }

      case "uniqueItems":
        {
          const {
            params,
            parentSchema
          } = error;
          const {
            i
          } =
          /** @type {import("ajv").UniqueItemsParams} */
          params;
          return `${dataPath} should not contain the item '${error.data[i]}' twice${getSchemaNonTypes(parentSchema)}.${this.getSchemaPartDescription(parentSchema)}`;
        }

      case "additionalItems":
        {
          const {
            params,
            parentSchema
          } = error;
          const {
            limit
          } =
          /** @type {import("ajv").LimitParams} */
          params;
          return `${dataPath} should not have more than ${limit} items${getSchemaNonTypes(parentSchema)}. These items are valid:\n${this.getSchemaPartText(parentSchema)}`;
        }

      case "contains":
        {
          const {
            parentSchema
          } = error;
          return `${dataPath} should contains at least one ${this.getSchemaPartText(parentSchema, ["contains"])} item${getSchemaNonTypes(parentSchema)}.`;
        }

      case "required":
        {
          const {
            parentSchema,
            params
          } = error;
          const missingProperty =
          /** @type {import("ajv").DependenciesParams} */
          params.missingProperty.replace(/^\./, "");
          const hasProperty = parentSchema && Boolean(
          /** @type {Schema} */
          parentSchema.properties &&
          /** @type {Schema} */
          parentSchema.properties[missingProperty]);
          return `${dataPath} misses the property '${missingProperty}'${getSchemaNonTypes(parentSchema)}.${hasProperty ? ` Should be:\n${this.getSchemaPartText(parentSchema, ["properties", missingProperty])}` : this.getSchemaPartDescription(parentSchema)}`;
        }

      case "additionalProperties":
        {
          const {
            params,
            parentSchema
          } = error;
          const {
            additionalProperty
          } =
          /** @type {import("ajv").AdditionalPropertiesParams} */
          params;
          return `${dataPath} has an unknown property '${additionalProperty}'${getSchemaNonTypes(parentSchema)}. These properties are valid:\n${this.getSchemaPartText(parentSchema)}`;
        }

      case "dependencies":
        {
          const {
            params,
            parentSchema
          } = error;
          const {
            property,
            deps
          } =
          /** @type {import("ajv").DependenciesParams} */
          params;
          const dependencies = deps.split(",").map(
          /**
           * @param {string} dep
           * @returns {string}
           */
          dep => `'${dep.trim()}'`).join(", ");
          return `${dataPath} should have properties ${dependencies} when property '${property}' is present${getSchemaNonTypes(parentSchema)}.${this.getSchemaPartDescription(parentSchema)}`;
        }

      case "propertyNames":
        {
          const {
            params,
            parentSchema,
            schema
          } = error;
          const {
            propertyName
          } =
          /** @type {import("ajv").PropertyNamesParams} */
          params;
          return `${dataPath} property name '${propertyName}' is invalid${getSchemaNonTypes(parentSchema)}. Property names should be match format ${JSON.stringify(schema.format)}.${this.getSchemaPartDescription(parentSchema)}`;
        }

      case "enum":
        {
          const {
            parentSchema
          } = error;

          if (parentSchema &&
          /** @type {Schema} */
          parentSchema.enum &&
          /** @type {Schema} */
          parentSchema.enum.length === 1) {
            return `${dataPath} should be ${this.getSchemaPartText(parentSchema, false, true)}`;
          }

          return `${dataPath} should be one of these:\n${this.getSchemaPartText(parentSchema)}`;
        }

      case "const":
        {
          const {
            parentSchema
          } = error;
          return `${dataPath} should be equal to constant ${this.getSchemaPartText(parentSchema, false, true)}`;
        }

      case "not":
        {
          const postfix = likeObject(
          /** @type {Schema} */
          error.parentSchema) ? `\n${this.getSchemaPartText(error.parentSchema)}` : "";
          const schemaOutput = this.getSchemaPartText(error.schema, false, false, false);

          if (canApplyNot(error.schema)) {
            return `${dataPath} should be any ${schemaOutput}${postfix}.`;
          }

          const {
            schema,
            parentSchema
          } = error;
          return `${dataPath} should not be ${this.getSchemaPartText(schema, false, true)}${parentSchema && likeObject(parentSchema) ? `\n${this.getSchemaPartText(parentSchema)}` : ""}`;
        }

      case "oneOf":
      case "anyOf":
        {
          const {
            parentSchema,
            children
          } = error;

          if (children && children.length > 0) {
            if (error.schema.length === 1) {
              const lastChild = children[children.length - 1];
              const remainingChildren = children.slice(0, children.length - 1);
              return this.formatValidationError(Object.assign({}, lastChild, {
                children: remainingChildren,
                parentSchema: Object.assign({}, parentSchema, lastChild.parentSchema)
              }));
            }

            let filteredChildren = filterChildren(children);

            if (filteredChildren.length === 1) {
              return this.formatValidationError(filteredChildren[0]);
            }

            filteredChildren = groupChildrenByFirstChild(filteredChildren);
            return `${dataPath} should be one of these:\n${this.getSchemaPartText(parentSchema)}\nDetails:\n${filteredChildren.map(
            /**
             * @param {SchemaUtilErrorObject} nestedError
             * @returns {string}
             */
            nestedError => ` * ${indent(this.formatValidationError(nestedError), "   ")}`).join("\n")}`;
          }

          return `${dataPath} should be one of these:\n${this.getSchemaPartText(parentSchema)}`;
        }

      case "if":
        {
          const {
            params,
            parentSchema
          } = error;
          const {
            failingKeyword
          } =
          /** @type {import("ajv").IfParams} */
          params;
          return `${dataPath} should match "${failingKeyword}" schema:\n${this.getSchemaPartText(parentSchema, [failingKeyword])}`;
        }

      case "absolutePath":
        {
          const {
            message,
            parentSchema
          } = error;
          return `${dataPath}: ${message}${this.getSchemaPartDescription(parentSchema)}`;
        }

      /* istanbul ignore next */

      default:
        {
          const {
            message,
            parentSchema
          } = error;
          const ErrorInJSON = JSON.stringify(error, null, 2); // For `custom`, `false schema`, `$ref` keywords
          // Fallback for unknown keywords

          return `${dataPath} ${message} (${ErrorInJSON}).\n${this.getSchemaPartText(parentSchema, false)}`;
        }
    }
  }
  /**
   * @param {Array<SchemaUtilErrorObject>} errors
   * @returns {string}
   */


  formatValidationErrors(errors) {
    return errors.map(error => {
      let formattedError = this.formatValidationError(error);

      if (this.postFormatter) {
        formattedError = this.postFormatter(formattedError, error);
      }

      return ` - ${indent(formattedError, "   ")}`;
    }).join("\n");
  }

}

var _default = ValidationError;
exports["default"] = _default;

/***/ }),

/***/ 12463:
/***/ ((module) => {

"use strict";


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.F = codes;


/***/ }),

/***/ 12626:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8818);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ServiceQuoteListView = /*#__PURE__*/function (_View) {
  function ServiceQuoteListView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, ServiceQuoteListView);
    return _callSuper(this, ServiceQuoteListView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(ServiceQuoteListView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(ServiceQuoteListView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", {
                fields: []
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(ServiceQuoteListView, "table", 'servicequotelist');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ServiceQuoteListView);

/***/ }),

/***/ 12913:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var util = __webpack_require__(23949);

module.exports = function defFunc(ajv) {
  defFunc.definition = {
    type: 'object',
    macro: function (schema) {
      var schemas = [];
      for (var pointer in schema)
        schemas.push(getSchema(pointer, schema[pointer]));
      return {'allOf': schemas};
    },
    metaSchema: {
      type: 'object',
      propertyNames: {
        type: 'string',
        format: 'json-pointer'
      },
      additionalProperties: util.metaSchemaRef(ajv)
    }
  };

  ajv.addKeyword('deepProperties', defFunc.definition);
  return ajv;
};


function getSchema(jsonPointer, schema) {
  var segments = jsonPointer.split('/');
  var rootSchema = {};
  var pointerSchema = rootSchema;
  for (var i=1; i<segments.length; i++) {
    var segment = segments[i];
    var isLast = i == segments.length - 1;
    segment = unescapeJsonPointer(segment);
    var properties = pointerSchema.properties = {};
    var items = undefined;
    if (/[0-9]+/.test(segment)) {
      var count = +segment;
      items = pointerSchema.items = [];
      while (count--) items.push({});
    }
    pointerSchema = isLast ? schema : {};
    properties[segment] = pointerSchema;
    if (items) items.push(pointerSchema);
  }
  return rootSchema;
}


function unescapeJsonPointer(str) {
  return str.replace(/~1/g, '/').replace(/~0/g, '~');
}


/***/ }),

/***/ 12995:
/***/ ((module) => {

"use strict";

module.exports = function generate_switch(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $ifPassed = 'ifPassed' + it.level,
    $currentBaseId = $it.baseId,
    $shouldContinue;
  out += 'var ' + ($ifPassed) + ';';
  var arr1 = $schema;
  if (arr1) {
    var $sch, $caseIndex = -1,
      l1 = arr1.length - 1;
    while ($caseIndex < l1) {
      $sch = arr1[$caseIndex += 1];
      if ($caseIndex && !$shouldContinue) {
        out += ' if (!' + ($ifPassed) + ') { ';
        $closingBraces += '}';
      }
      if ($sch.if && (it.opts.strictKeywords ? typeof $sch.if == 'object' && Object.keys($sch.if).length > 0 : it.util.schemaHasRules($sch.if, it.RULES.all))) {
        out += ' var ' + ($errs) + ' = errors;   ';
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        $it.createErrors = false;
        $it.schema = $sch.if;
        $it.schemaPath = $schemaPath + '[' + $caseIndex + '].if';
        $it.errSchemaPath = $errSchemaPath + '/' + $caseIndex + '/if';
        out += '  ' + (it.validate($it)) + ' ';
        $it.baseId = $currentBaseId;
        $it.createErrors = true;
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += ' ' + ($ifPassed) + ' = ' + ($nextValid) + '; if (' + ($ifPassed) + ') {  ';
        if (typeof $sch.then == 'boolean') {
          if ($sch.then === false) {
            var $$outStack = $$outStack || [];
            $$outStack.push(out);
            out = ''; /* istanbul ignore else */
            if (it.createErrors !== false) {
              out += ' { keyword: \'' + ('switch') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { caseIndex: ' + ($caseIndex) + ' } ';
              if (it.opts.messages !== false) {
                out += ' , message: \'should pass "switch" keyword validation\' ';
              }
              if (it.opts.verbose) {
                out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
              }
              out += ' } ';
            } else {
              out += ' {} ';
            }
            var __err = out;
            out = $$outStack.pop();
            if (!it.compositeRule && $breakOnError) {
              /* istanbul ignore if */
              if (it.async) {
                out += ' throw new ValidationError([' + (__err) + ']); ';
              } else {
                out += ' validate.errors = [' + (__err) + ']; return false; ';
              }
            } else {
              out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
            }
          }
          out += ' var ' + ($nextValid) + ' = ' + ($sch.then) + '; ';
        } else {
          $it.schema = $sch.then;
          $it.schemaPath = $schemaPath + '[' + $caseIndex + '].then';
          $it.errSchemaPath = $errSchemaPath + '/' + $caseIndex + '/then';
          out += '  ' + (it.validate($it)) + ' ';
          $it.baseId = $currentBaseId;
        }
        out += '  } else {  errors = ' + ($errs) + '; if (vErrors !== null) { if (' + ($errs) + ') vErrors.length = ' + ($errs) + '; else vErrors = null; } } ';
      } else {
        out += ' ' + ($ifPassed) + ' = true;  ';
        if (typeof $sch.then == 'boolean') {
          if ($sch.then === false) {
            var $$outStack = $$outStack || [];
            $$outStack.push(out);
            out = ''; /* istanbul ignore else */
            if (it.createErrors !== false) {
              out += ' { keyword: \'' + ('switch') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { caseIndex: ' + ($caseIndex) + ' } ';
              if (it.opts.messages !== false) {
                out += ' , message: \'should pass "switch" keyword validation\' ';
              }
              if (it.opts.verbose) {
                out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
              }
              out += ' } ';
            } else {
              out += ' {} ';
            }
            var __err = out;
            out = $$outStack.pop();
            if (!it.compositeRule && $breakOnError) {
              /* istanbul ignore if */
              if (it.async) {
                out += ' throw new ValidationError([' + (__err) + ']); ';
              } else {
                out += ' validate.errors = [' + (__err) + ']; return false; ';
              }
            } else {
              out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
            }
          }
          out += ' var ' + ($nextValid) + ' = ' + ($sch.then) + '; ';
        } else {
          $it.schema = $sch.then;
          $it.schemaPath = $schemaPath + '[' + $caseIndex + '].then';
          $it.errSchemaPath = $errSchemaPath + '/' + $caseIndex + '/then';
          out += '  ' + (it.validate($it)) + ' ';
          $it.baseId = $currentBaseId;
        }
      }
      $shouldContinue = $sch.continue
    }
  }
  out += '' + ($closingBraces) + 'var ' + ($valid) + ' = ' + ($nextValid) + ';';
  return out;
}


/***/ }),

/***/ 13393:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(65606);


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.validate = validate;
exports.enableValidation = enableValidation;
exports.disableValidation = disableValidation;
exports.needValidate = needValidate;
Object.defineProperty(exports, "ValidationError", ({
  enumerable: true,
  get: function () {
    return _ValidationError.default;
  }
}));

var _absolutePath = _interopRequireDefault(__webpack_require__(55600));

var _undefinedAsNull = _interopRequireDefault(__webpack_require__(86813));

var _ValidationError = _interopRequireDefault(__webpack_require__(12000));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @template T
 * @param fn {(function(): any) | undefined}
 * @returns {function(): T}
 */
const memoize = fn => {
  let cache = false;
  /** @type {T} */

  let result;
  return () => {
    if (cache) {
      return result;
    }

    result =
    /** @type {function(): any} */
    fn();
    cache = true; // Allow to clean up memory for fn
    // and all dependent resources
    // eslint-disable-next-line no-undefined, no-param-reassign

    fn = undefined;
    return result;
  };
};

const getAjv = memoize(() => {
  // Use CommonJS require for ajv libs so TypeScript consumers aren't locked into esModuleInterop (see #110).
  // eslint-disable-next-line global-require
  const Ajv = __webpack_require__(28019); // eslint-disable-next-line global-require


  const ajvKeywords = __webpack_require__(24563);

  const ajv = new Ajv({
    allErrors: true,
    verbose: true,
    $data: true
  });
  ajvKeywords(ajv, ["instanceof", "formatMinimum", "formatMaximum", "patternRequired"]); // Custom keywords

  (0, _absolutePath.default)(ajv);
  (0, _undefinedAsNull.default)(ajv);
  return ajv;
});
/** @typedef {import("json-schema").JSONSchema4} JSONSchema4 */

/** @typedef {import("json-schema").JSONSchema6} JSONSchema6 */

/** @typedef {import("json-schema").JSONSchema7} JSONSchema7 */

/** @typedef {import("ajv").ErrorObject} ErrorObject */

/** @typedef {import("ajv").ValidateFunction} ValidateFunction */

/**
 * @typedef {Object} Extend
 * @property {number=} formatMinimum
 * @property {number=} formatMaximum
 * @property {boolean=} formatExclusiveMinimum
 * @property {boolean=} formatExclusiveMaximum
 * @property {string=} link
 * @property {boolean=} undefinedAsNull
 */

/** @typedef {(JSONSchema4 | JSONSchema6 | JSONSchema7) & Extend} Schema */

/** @typedef {ErrorObject & { children?: Array<ErrorObject>}} SchemaUtilErrorObject */

/**
 * @callback PostFormatter
 * @param {string} formattedError
 * @param {SchemaUtilErrorObject} error
 * @returns {string}
 */

/**
 * @typedef {Object} ValidationErrorConfiguration
 * @property {string=} name
 * @property {string=} baseDataPath
 * @property {PostFormatter=} postFormatter
 */

/**
 * @param {SchemaUtilErrorObject} error
 * @param {number} idx
 * @returns {SchemaUtilErrorObject}
 */

function applyPrefix(error, idx) {
  // eslint-disable-next-line no-param-reassign
  error.dataPath = `[${idx}]${error.dataPath}`;

  if (error.children) {
    error.children.forEach(err => applyPrefix(err, idx));
  }

  return error;
}

let skipValidation = false; // We use `process.env.SKIP_VALIDATION` because you can have multiple `schema-utils` with different version,
// so we want to disable it globally, `process.env` doesn't supported by browsers, so we have the local `skipValidation` variables
// Enable validation

function enableValidation() {
  skipValidation = false; // Disable validation for any versions

  if (process && process.env) {
    process.env.SKIP_VALIDATION = "n";
  }
} // Disable validation


function disableValidation() {
  skipValidation = true;

  if (process && process.env) {
    process.env.SKIP_VALIDATION = "y";
  }
} // Check if we need to confirm


function needValidate() {
  if (skipValidation) {
    return false;
  }

  if (process && process.env && process.env.SKIP_VALIDATION) {
    const value = process.env.SKIP_VALIDATION.trim();

    if (/^(?:y|yes|true|1|on)$/i.test(value)) {
      return false;
    }

    if (/^(?:n|no|false|0|off)$/i.test(value)) {
      return true;
    }
  }

  return true;
}
/**
 * @param {Schema} schema
 * @param {Array<object> | object} options
 * @param {ValidationErrorConfiguration=} configuration
 * @returns {void}
 */


function validate(schema, options, configuration) {
  if (!needValidate()) {
    return;
  }

  let errors = [];

  if (Array.isArray(options)) {
    for (let i = 0; i <= options.length - 1; i++) {
      errors.push(...validateObject(schema, options[i]).map(err => applyPrefix(err, i)));
    }
  } else {
    errors = validateObject(schema, options);
  }

  if (errors.length > 0) {
    throw new _ValidationError.default(errors, schema, configuration);
  }
}
/** @typedef {WeakMap<Schema, ValidateFunction>} */


const schemaCache = new WeakMap();
/**
 * @param {Schema} schema
 * @param {Array<object> | object} options
 * @returns {Array<SchemaUtilErrorObject>}
 */

function validateObject(schema, options) {
  let compiledSchema = schemaCache.get(schema);

  if (!compiledSchema) {
    compiledSchema = getAjv().compile(schema);
    schemaCache.set(schema, compiledSchema);
  }

  const valid = compiledSchema(options);
  if (valid) return [];
  return compiledSchema.errors ? filterErrors(compiledSchema.errors) : [];
}
/**
 * @param {Array<ErrorObject>} errors
 * @returns {Array<SchemaUtilErrorObject>}
 */


function filterErrors(errors) {
  /** @type {Array<SchemaUtilErrorObject>} */
  let newErrors = [];

  for (const error of
  /** @type {Array<SchemaUtilErrorObject>} */
  errors) {
    const {
      dataPath
    } = error;
    /** @type {Array<SchemaUtilErrorObject>} */

    let children = [];
    newErrors = newErrors.filter(oldError => {
      if (oldError.dataPath.includes(dataPath)) {
        if (oldError.children) {
          children = children.concat(oldError.children.slice(0));
        } // eslint-disable-next-line no-undefined, no-param-reassign


        oldError.children = undefined;
        children.push(oldError);
        return false;
      }

      return true;
    });

    if (children.length) {
      error.children = children;
    }

    newErrors.push(error);
  }

  return newErrors;
}

/***/ }),

/***/ 13536:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ booking)
});

;// ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

;// ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(27800);
;// ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || (0,unsupportedIterableToArray/* default */.A)(r, e) || _nonIterableRest();
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(45458);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(10467);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(23029);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(92901);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js + 1 modules
var possibleConstructorReturn = __webpack_require__(50388);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(53954);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/get.js + 1 modules
var get = __webpack_require__(90991);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(15361);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(64467);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(54756);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/base/model/record.js
var record = __webpack_require__(55539);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v1.js + 2 modules
var v1 = __webpack_require__(26028);
;// ./src/base/model/booking.js










function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.A)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

function _callSuper(t, o, e) { return o = (0,getPrototypeOf/* default */.A)(o), (0,possibleConstructorReturn/* default */.A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,get/* default */.A)((0,getPrototypeOf/* default */.A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }


var bookingView = api.importMixinModule('booking', 'views');
var Booking = /*#__PURE__*/function (_Record) {
  function Booking(obj) {
    var _this;
    (0,classCallCheck/* default */.A)(this, Booking);
    var record = obj.record,
      isTemplate = obj.isTemplate,
      isOper = obj.isOper,
      versionDate = obj.versionDate,
      fromTemplate = obj.fromTemplate,
      clone = obj.clone;
    var options = bookingView.getTableOptions({
      isTemplate: isTemplate,
      isOper: isOper
    });
    obj.tableName = Booking.tableName;
    obj.endpoint = Booking.endpoint;
    obj.options = options;
    obj.backMethods = Booking.backMethods;
    _this = _callSuper(this, Booking, [obj]);
    var self = _this;
    return (0,possibleConstructorReturn/* default */.A)(_this, (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee() {
      var initPromise, id;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            initPromise = new Promise(function (resolve, reject) {
              resolve(self);
            });
            _context.next = 3;
            return initPromise;
          case 3:
            self = _context.sent;
            self.$ViewMode.value = -1;
            self.versionDate = versionDate;
            self._requestCount = 0;
            if (record) id = record.id;
            if (record && !record._public) {
              //api.setReceipts(id);
              self.setPayments(id);
              self.setReceipts(id);
              api.setSupplierCredits(id);
              api.hotelCost = {};
            }
            if (isTemplate || record && record.TemplateType != 'NONE' && record.TemplateType != 'CATALOGUE') {
              self.endpoint = '/api/template/';
              self.tableName = 'template';
            }
            if (isTemplate || record && record.TemplateType == 'CATALOGUE') {
              self.endpoint = '/api/catalogue/';
              self.tableName = 'catalogue';
            }
            if (!self.QuoteVariants) self.QuoteVariants = {};
            self._cachedTotals = null;
            self._cachedTotalsServices = null;
            self._cachedTotalsHotels = null;
            self._cachedQuoted = null;
            self._cachedBaseTotalsHotels = null;
            self._cachedTotalByPaxGroup = null;
            self._cache = {
              totals: false,
              totalsServices: false,
              totalsHotels: false,
              quoted: false,
              totalByPaxVariantId: false,
              baseTotalsHotels: false,
              totalByPaxGroup: false
            };
            return _context.abrupt("return", self);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))());
  }
  (0,inherits/* default */.A)(Booking, _Record);
  return (0,createClass/* default */.A)(Booking, [{
    key: "beforeSave",
    value: function beforeSave(r) {
      var res;
      //this.BrowserTabId = api._tabId;
      if (_superPropGet(Booking, "beforeSave", this, 1)) res = _superPropGet(Booking, "beforeSave", this, 3)([this]);
      if (res) return res;
      return res;
    }
  }, {
    key: "create",
    value: function () {
      var _create = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this._recordLoaded = true;
              this.TemplateType = 'NONE';
              this.QuoteBy = 'SERVICE';
              this.SalesUserId = api.currentUser.id;
              _context2.next = 6;
              return _superPropGet(Booking, "create", this, 3)([]);
            case 6:
              _context2.next = 8;
              return this.setCurrencyRates();
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function create() {
        return _create.apply(this, arguments);
      }
      return create;
    }()
  }, {
    key: "className",
    get: function get() {
      if (this.isCatalogue) return 'Catalogue';
      if (this.isTemplate) {
        if (this.TemplateType == 'PACKAGE') return 'Package';
        return 'Template';
      }
      if (this.isBooking) {
        if (this.bookingConfirmed) return 'File';
        return 'Quotation';
      }
      return 'Booking';
    }
  }, {
    key: "titleName",
    get: function get() {
      if (this.Status == 'CATALOGUE') {
        var _res = [];
        if (this.Title) _res.push(this.Title);
        return _res.join(' - ');
      }
      var res = [];
      if (this.id) res.push(this.id);
      if (this.Title) res.push(this.Title);
      return res.join(' - ');
    }
  }, {
    key: "bookingStatus",
    get: function get() {
      return {
        QUOTE: 'Quote',
        CONFIRMED: 'Confirmed',
        ENDED: 'Archived',
        CLOSED: 'Closed',
        CANCELED: 'Canceled',
        QUOTE_LOST: 'Lost'
      };
    }
  }, {
    key: "afterEdit",
    value: function afterEdit() {
      return {
        StartDate: function () {
          var _StartDate = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee3(r) {
            return regenerator_default().wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return r.changeDate(null, true);
                case 2:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }));
          function StartDate(_x) {
            return _StartDate.apply(this, arguments);
          }
          return StartDate;
        }(),
        QuoteDate: function () {
          var _QuoteDate = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee4(r, newVal, oldVal) {
            return regenerator_default().wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return r.changeQuoteDates(null, true, newVal, oldVal);
                case 2:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          }));
          function QuoteDate(_x2, _x3, _x4) {
            return _QuoteDate.apply(this, arguments);
          }
          return QuoteDate;
        }(),
        Markup: function Markup(r) {
          r.setMarkupToServices();
        },
        CurrencyId: function CurrencyId(r) {
          r.setCurrencyToServices();
        },
        SplitQuoteDate: function () {
          var _SplitQuoteDate = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee5(r) {
            return regenerator_default().wrap(function _callee5$(_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return r.setSplitQuoteDate();
                case 2:
                case "end":
                  return _context5.stop();
              }
            }, _callee5);
          }));
          function SplitQuoteDate(_x5) {
            return _SplitQuoteDate.apply(this, arguments);
          }
          return SplitQuoteDate;
        }(),
        AgencyId: function AgencyId(r) {
          r.setAgency();
        },
        CustomerTypeId: function CustomerTypeId(r) {
          r.setCustomerTypeId();
        },
        SalesOriginId: function () {
          var _SalesOriginId = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee6(r) {
            return regenerator_default().wrap(function _callee6$(_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return r.setSalesOrigin();
                case 2:
                case "end":
                  return _context6.stop();
              }
            }, _callee6);
          }));
          function SalesOriginId(_x6) {
            return _SalesOriginId.apply(this, arguments);
          }
          return SalesOriginId;
        }(),
        LanguageId: function () {
          var _LanguageId = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee7(r) {
            return regenerator_default().wrap(function _callee7$(_context7) {
              while (1) switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.next = 2;
                  return r.setLanguageId();
                case 2:
                case "end":
                  return _context7.stop();
              }
            }, _callee7);
          }));
          function LanguageId(_x7) {
            return _LanguageId.apply(this, arguments);
          }
          return LanguageId;
        }(),
        Status: function () {
          var _Status = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee8(r) {
            return regenerator_default().wrap(function _callee8$(_context8) {
              while (1) switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.next = 2;
                  return r.setStatus();
                case 2:
                case "end":
                  return _context8.stop();
              }
            }, _callee8);
          }));
          function Status(_x8) {
            return _Status.apply(this, arguments);
          }
          return Status;
        }(),
        SalesUserId: function () {
          var _SalesUserId = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee9(r) {
            return regenerator_default().wrap(function _callee9$(_context9) {
              while (1) switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.next = 2;
                  return r.setSalesUserId();
                case 2:
                case "end":
                  return _context9.stop();
              }
            }, _callee9);
          }));
          function SalesUserId(_x9) {
            return _SalesUserId.apply(this, arguments);
          }
          return SalesUserId;
        }(),
        PaxEmail: function () {
          var _PaxEmail = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee10(r) {
            return regenerator_default().wrap(function _callee10$(_context10) {
              while (1) switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.next = 2;
                  return r.setPaxEmail();
                case 2:
                case "end":
                  return _context10.stop();
              }
            }, _callee10);
          }));
          function PaxEmail(_x10) {
            return _PaxEmail.apply(this, arguments);
          }
          return PaxEmail;
        }(),
        PaxCountryType: function () {
          var _PaxCountryType = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee11(r) {
            return regenerator_default().wrap(function _callee11$(_context11) {
              while (1) switch (_context11.prev = _context11.next) {
                case 0:
                  _context11.next = 2;
                  return r.setPaxCountryType();
                case 2:
                case "end":
                  return _context11.stop();
              }
            }, _callee11);
          }));
          function PaxCountryType(_x11) {
            return _PaxCountryType.apply(this, arguments);
          }
          return PaxCountryType;
        }(),
        QuoteBy: function () {
          var _QuoteBy = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee12(r) {
            return regenerator_default().wrap(function _callee12$(_context12) {
              while (1) switch (_context12.prev = _context12.next) {
                case 0:
                  _context12.next = 2;
                  return r.setQuoteBy();
                case 2:
                case "end":
                  return _context12.stop();
              }
            }, _callee12);
          }));
          function QuoteBy(_x12) {
            return _QuoteBy.apply(this, arguments);
          }
          return QuoteBy;
        }()
      };
    }
  }, {
    key: "setQuoteBy",
    value: function () {
      var _setQuoteBy = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee13() {
        return regenerator_default().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (this.QuoteBy == 'SERVICE') {
                this.QuoteViewType = 'PERSON';
              }
            case 1:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function setQuoteBy() {
        return _setQuoteBy.apply(this, arguments);
      }
      return setQuoteBy;
    }()
  }, {
    key: "setPaxEmail",
    value: function () {
      var _setPaxEmail = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee14() {
        return regenerator_default().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }));
      function setPaxEmail() {
        return _setPaxEmail.apply(this, arguments);
      }
      return setPaxEmail;
    }()
  }, {
    key: "setCustomerTypeId",
    value: function () {
      var _setCustomerTypeId = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee15() {
        return regenerator_default().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              this.setMarkup();
            case 1:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function setCustomerTypeId() {
        return _setCustomerTypeId.apply(this, arguments);
      }
      return setCustomerTypeId;
    }()
  }, {
    key: "setStatus",
    value: function () {
      var _setStatus = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee16() {
        return regenerator_default().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }));
      function setStatus() {
        return _setStatus.apply(this, arguments);
      }
      return setStatus;
    }()
  }, {
    key: "setSalesUserId",
    value: function () {
      var _setSalesUserId = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee17() {
        return regenerator_default().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }));
      function setSalesUserId() {
        return _setSalesUserId.apply(this, arguments);
      }
      return setSalesUserId;
    }()
  }, {
    key: "setLanguageId",
    value: function () {
      var _setLanguageId = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee18() {
        return regenerator_default().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              this.setServiceLanguage();
              _context18.next = 3;
              return this.setIncludes();
            case 3:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function setLanguageId() {
        return _setLanguageId.apply(this, arguments);
      }
      return setLanguageId;
    }()
  }, {
    key: "canDelete",
    get: function get() {
      if (this._modified) return false;
      return _superPropGet(Booking, "canDelete", this, 1);
    }
  }, {
    key: "setMarkup",
    value: function setMarkup() {
      if (this.CustomerType && !tools.isNull(this.CustomerType.Markup)) {
        this.Markup = this.CustomerType.Markup;
      }
      if (this.SalesOrigin && !tools.isNull(this.SalesOrigin.Markup)) {
        this.Markup = this.SalesOrigin.Markup;
      }
      this.setMarkupToServices();
    }
  }, {
    key: "setMarkupToServices",
    value: function setMarkupToServices() {
      if (this.FixedPrices) return;
      var _iterator = _createForOfIteratorHelper(this.BookingDays),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var day = _step.value;
          var _iterator2 = _createForOfIteratorHelper(day.BookingDayServices),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var s = _step2.value;
              if (s.Quote && s.Quote.QuoteList) {
                for (var base in this.BaseQuotes.bases) {
                  var _iterator4 = _createForOfIteratorHelper(this.BaseQuotes[base].paxTypes),
                    _step4;
                  try {
                    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                      var pType = _step4.value;
                      if (!s.Quote.QuoteList[base]) continue;
                      if (!s.Quote.QuoteList[base][pType]) continue;
                      if (!tools.isNull(s.Quote.QuoteList[base][pType].Markup)) continue;
                      var priceModified = s.Quote.QuoteList[base][pType].PriceModified || s.Quote.QuoteList[base][pType].PersonPriceModified;
                      if (s.Quote.QuoteList[base][pType].Price && priceModified && !s.Quote.QuoteList[base][pType].Cost) continue;
                      s.Quote.QuoteList[base][pType].setPrice(this.Markup);
                      s.Quote.QuoteList[base][pType].setTotals(true);
                      if (this.QuoteBy == 'SERVICE') {
                        s.Quote.QuoteList[base][pType].calculatePersonPrice();
                      }
                    }
                  } catch (err) {
                    _iterator4.e(err);
                  } finally {
                    _iterator4.f();
                  }
                }
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          if (day.BookingDayHotels[0] && day.BookingDayHotels[0].BookingDayRooms) {
            var _iterator3 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var room = _step3.value;
                for (var baseId in this.BaseQuotes.bases) {
                  if (!room.QuoteList[baseId]) continue;
                  if (!tools.isNull(room.QuoteList[baseId].Markup)) continue;
                  if (room.QuoteList[baseId].Price && room.QuoteList[baseId].PriceModified && !room.QuoteList[baseId].Cost) continue;
                  room.QuoteList[baseId].$Price.value = tools.getPrice(room.QuoteList[baseId].Cost, this.Markup);
                  room.QuoteList[baseId].setTotals(true);
                  if (this.QuoteBy == 'SERVICE') {
                    room.QuoteList[baseId].setPersonValues();
                  }
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "getPaxTypesByBase",
    value: function getPaxTypesByBase(baseId) {
      var res = ['ADT'];
      if (this.BaseQuotes[baseId] && this.BaseQuotes[baseId].CHD > 0) res.push('CHD');
      if (this.BaseQuotes[baseId] && this.BaseQuotes[baseId].TL > 0) res.push('TL');
      return res;
    }
  }, {
    key: "paxTypesByBase",
    get: function get() {
      var res = {};
      for (var baseId in this.BaseQuotes.bases) {
        res[baseId] = this.getPaxTypesByBase(baseId);
      }
      return res;
    }
  }, {
    key: "isTemplate",
    get: function get() {
      return this.TemplateType != 'NONE' && this.TemplateType != 'CATALOGUE';
    }
  }, {
    key: "notTemplate",
    get: function get() {
      return this.TemplateType == 'NONE' || this.TemplateType == 'CATALOGUE';
    }
  }, {
    key: "isCatalogue",
    get: function get() {
      return this.TemplateType == 'CATALOGUE';
    }
  }, {
    key: "isBooking",
    get: function get() {
      return this.TemplateType == 'NONE';
    }
  }, {
    key: "setSalesOrigin",
    value: function () {
      var _setSalesOrigin = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee19() {
        return regenerator_default().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              if (!(this.SalesOrigin && this.SalesOrigin.CustomerTypeId)) {
                _context19.next = 4;
                break;
              }
              _context19.next = 3;
              return this.setValue({
                fieldName: 'CustomerTypeId',
                value: this.SalesOrigin.CustomerTypeId
              });
            case 3:
              this.setMarkup();
            case 4:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function setSalesOrigin() {
        return _setSalesOrigin.apply(this, arguments);
      }
      return setSalesOrigin;
    }()
  }, {
    key: "setAgency",
    value: function () {
      var _setAgency = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee20() {
        return regenerator_default().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              if (this.Agency && this.Agency.Email) {
                this.PaxEmail = this.Agency.Email;
              }
              if (this.Agency && this.Agency.Phone) {
                this.PaxPhone = this.Agency.Phone;
              }
              if (this.Agency && (this.Agency.Markup || !tools.isNull(this.Agency.Markup))) {
                this.Markup = this.Agency.Markup;
              }
            case 3:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function setAgency() {
        return _setAgency.apply(this, arguments);
      }
      return setAgency;
    }()
  }, {
    key: "setServiceLanguage",
    value: function setServiceLanguage() {
      var _this2 = this;
      var _iterator5 = _createForOfIteratorHelper(this.BookingDays),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var day = _step5.value;
          var _iterator6 = _createForOfIteratorHelper(day.BookingDayServices),
            _step6;
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var service = _step6.value;
              if (service.Service) {
                var d = _.find(service.Service.ServiceDescriptions, function (r) {
                  return r.LanguageId == _this2.LanguageId;
                });
                if (d) {
                  service.Description = d.Description;
                  service._Description = d.Description;
                }
              }
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "setIncludes",
    value: function () {
      var _setIncludes = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee21() {
        var res;
        return regenerator_default().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return api.get('/api/includes/', {
                LanguageId: this.LanguageId
              });
            case 2:
              res = _context21.sent;
              if (res !== null && res !== void 0 && res[0]) {
                this.Include = res[0].Data.Includes;
                this.NotInclude = res[0].Data.NotIncludes;
                if (res[0].Data.EmergencyContacts) {
                  this.EmergencyContacts = res[0].Data.EmergencyContacts;
                }
                this._Include = res[0].Data.Includes;
                this._NotInclude = res[0].Data.NotIncludes;
                if (tools.ifText(res[0].Data.Notes)) {
                  this.Comment = res[0].Data.Notes;
                  this._Comment = res[0].Data.Notes;
                }
              }
              return _context21.abrupt("return", res);
            case 5:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function setIncludes() {
        return _setIncludes.apply(this, arguments);
      }
      return setIncludes;
    }()
  }, {
    key: "removeBase",
    value: function () {
      var _removeBase = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee22(baseId) {
        var _iterator7, _step7, day, _iterator9, _step9, s, _iterator10, _step10, room, _iterator8, _step8, flight;
        return regenerator_default().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              delete this.BaseQuotes[baseId];
              delete this.Totals[baseId];
              delete this.QuoteGroups[baseId];
              delete this.QuoteVariants[baseId];
              tools.removeFieldByName(this.BaseQuotes.fields, baseId);
              tools.removeFieldByName(this.Totals.fields, baseId);
              this.BaseQuotes.getFields();
              this.Totals.getFields();
              _iterator7 = _createForOfIteratorHelper(this.BookingDays);
              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  day = _step7.value;
                  _iterator9 = _createForOfIteratorHelper(day.BookingDayServices);
                  try {
                    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                      s = _step9.value;
                      if (s.Quote && s.Quote.QuoteList) {
                        delete s.Quote.QuoteList[baseId];
                        tools.removeFieldByName(s.Quote.QuoteList.fields, baseId);
                        s.Quote.QuoteList.getFields();
                      }
                    }
                  } catch (err) {
                    _iterator9.e(err);
                  } finally {
                    _iterator9.f();
                  }
                  if (day.BookingDayHotels[0] && day.BookingDayHotels[0].BookingDayRooms) {
                    _iterator10 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms);
                    try {
                      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                        room = _step10.value;
                        if (room.QuoteList[baseId]) {
                          delete room.QuoteList[baseId];
                          tools.removeFieldByName(room.QuoteList.fields, baseId);
                          room.QuoteList.getFields();
                        }
                      }
                    } catch (err) {
                      _iterator10.e(err);
                    } finally {
                      _iterator10.f();
                    }
                  }
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
              _iterator8 = _createForOfIteratorHelper(this.BookingFlights);
              try {
                for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                  flight = _step8.value;
                  if (flight.QuoteList[baseId]) {
                    delete flight.QuoteList[baseId];
                    tools.removeFieldByName(flight.QuoteList.fields, baseId);
                    flight.QuoteList.getFields();
                  }
                }
              } catch (err) {
                _iterator8.e(err);
              } finally {
                _iterator8.f();
              }
              this.setBookingTotals();
            case 13:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function removeBase(_x13) {
        return _removeBase.apply(this, arguments);
      }
      return removeBase;
    }()
  }, {
    key: "getNextBaseId",
    value: function getNextBaseId() {
      var l = Object.keys(this.BaseQuotes.bases);
      if (l.length == 0) {
        return 0;
      }
      var lInts = [];
      for (var _i = 0, _l = l; _i < _l.length; _i++) {
        var k = _l[_i];
        lInts.push(parseInt(k));
      }
      var max = Math.max.apply(Math, lInts);
      return max + 1;
    }
  }, {
    key: "changeDate",
    value: function () {
      var _changeDate = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee23(dayNr, setCost) {
        var _iterator11, _step11, day, _iterator12, _step12, s;
        return regenerator_default().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _iterator11 = _createForOfIteratorHelper(this.BookingDays);
              _context23.prev = 1;
              _iterator11.s();
            case 3:
              if ((_step11 = _iterator11.n()).done) {
                _context23.next = 13;
                break;
              }
              day = _step11.value;
              if (!(dayNr != null && day.DayNr < dayNr)) {
                _context23.next = 7;
                break;
              }
              return _context23.abrupt("continue", 11);
            case 7:
              if (!this.StartDate) {
                day.TransDate = null;
              } else {
                day.TransDate = moment(this.StartDate, "YYYY-MM-DD").add(day.DayNr, 'days').format("YYYY-MM-DD");
              }
              _iterator12 = _createForOfIteratorHelper(day.BookingDayServices);
              try {
                for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                  s = _step12.value;
                  s.ServiceDate = day.TransDate;
                }
              } catch (err) {
                _iterator12.e(err);
              } finally {
                _iterator12.f();
              }
              if (day.BookingDayHotels[0]) {
                day.BookingDayHotels[0].setHotelDates();
              }
            case 11:
              _context23.next = 3;
              break;
            case 13:
              _context23.next = 18;
              break;
            case 15:
              _context23.prev = 15;
              _context23.t0 = _context23["catch"](1);
              _iterator11.e(_context23.t0);
            case 18:
              _context23.prev = 18;
              _iterator11.f();
              return _context23.finish(18);
            case 21:
              if (!(this.SplitQuoteDate && this.QuoteDate)) {
                _context23.next = 23;
                break;
              }
              return _context23.abrupt("return");
            case 23:
              if (!setCost) {
                _context23.next = 26;
                break;
              }
              _context23.next = 26;
              return this.setCostByDate({
                update: false
              });
            case 26:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this, [[1, 15, 18, 21]]);
      }));
      function changeDate(_x14, _x15) {
        return _changeDate.apply(this, arguments);
      }
      return changeDate;
    }()
  }, {
    key: "changeQuoteDates",
    value: function () {
      var _changeQuoteDates = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee24(dayNr, setCost, newVal, oldVal) {
        var _iterator13, _step13, day, _iterator14, _step14, s;
        return regenerator_default().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              if (!(this.SplitQuoteDate && this.QuoteDate)) {
                _context24.next = 21;
                break;
              }
              _iterator13 = _createForOfIteratorHelper(this.BookingDays);
              _context24.prev = 2;
              _iterator13.s();
            case 4:
              if ((_step13 = _iterator13.n()).done) {
                _context24.next = 13;
                break;
              }
              day = _step13.value;
              if (!(dayNr != null && day.DayNr < dayNr)) {
                _context24.next = 8;
                break;
              }
              return _context24.abrupt("continue", 11);
            case 8:
              day.QuoteDate = moment(this.QuoteDate, "YYYY-MM-DD").add(day.DayNr, 'days').format("YYYY-MM-DD");
              _iterator14 = _createForOfIteratorHelper(day.BookingDayServices);
              try {
                for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                  s = _step14.value;
                  s.QuoteDate = day.QuoteDate;
                }
              } catch (err) {
                _iterator14.e(err);
              } finally {
                _iterator14.f();
              }
            case 11:
              _context24.next = 4;
              break;
            case 13:
              _context24.next = 18;
              break;
            case 15:
              _context24.prev = 15;
              _context24.t0 = _context24["catch"](2);
              _iterator13.e(_context24.t0);
            case 18:
              _context24.prev = 18;
              _iterator13.f();
              return _context24.finish(18);
            case 21:
              if (!(this.QuoteDate == this.StartDate && !oldVal)) {
                _context24.next = 23;
                break;
              }
              return _context24.abrupt("return");
            case 23:
              if (!setCost) {
                _context24.next = 26;
                break;
              }
              _context24.next = 26;
              return this.setCostByDate({
                update: false
              });
            case 26:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this, [[2, 15, 18, 21]]);
      }));
      function changeQuoteDates(_x16, _x17, _x18, _x19) {
        return _changeQuoteDates.apply(this, arguments);
      }
      return changeQuoteDates;
    }()
  }, {
    key: "refactorDayNr",
    value: function refactorDayNr(dayNr) {
      if (!this.BookingDays) return;
      for (var i = 0; i < this.BookingDays.length; i++) {
        if (this.BookingDays[i].DayNr >= dayNr) {
          this.BookingDays[i].DayNr += -1;
          if (this.BookingDays[i].DayNr == 0) {
            this.BookingDays[i].Breakfast = false;
          }
        }
      }
    }
  }, {
    key: "hotelsByDay",
    get: function get() {
      var res = {};
      var daysList = [];
      var _iterator15 = _createForOfIteratorHelper(this.BookingDays),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var d = _step15.value;
          if (d.BookingDayHotels[0]) {
            res[d.DayNr] = d.BookingDayHotels[0];
            res[d.DayNr].firstDay = true;
            if (d.BookingDayHotels[0].Days) {
              for (var i = 1; i < parseInt(d.BookingDayHotels[0].Days); i++) {
                var nr = parseInt(d.DayNr) + i;
                res[nr] = Object.assign({}, d.BookingDayHotels[0]);
                res[nr].firstDay = false;
                res[nr].dayNr = i;
              }
            }
          }
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
      return res;
    }
  }, {
    key: "hotelListByDate",
    get: function get() {
      var res = {};
      var hotelsByDay = this.hotelsByDay;
      var _iterator16 = _createForOfIteratorHelper(this.BookingDays),
        _step16;
      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var day = _step16.value;
          if (hotelsByDay[day.DayNr] && hotelsByDay[day.DayNr].ifHotel) {
            res[day.DayNr] = hotelsByDay[day.DayNr];
          }
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }
      return res;
    }
  }, {
    key: "quotesSelected",
    get: function get() {
      var res = {};
      for (var baseId in this.BaseQuotes.bases) {
        if (this.isGroup(baseId)) {
          for (var groupId in this.QuoteGroups[baseId]) {
            var _iterator17 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
              _step17;
            try {
              for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                var _this$QuoteGroups, _this$QuoteGroups2;
                var pType = _step17.value;
                if (!((_this$QuoteGroups = this.QuoteGroups) !== null && _this$QuoteGroups !== void 0 && (_this$QuoteGroups = _this$QuoteGroups[baseId]) !== null && _this$QuoteGroups !== void 0 && (_this$QuoteGroups = _this$QuoteGroups[groupId]) !== null && _this$QuoteGroups !== void 0 && _this$QuoteGroups[pType])) continue;
                if ((_this$QuoteGroups2 = this.QuoteGroups) !== null && _this$QuoteGroups2 !== void 0 && (_this$QuoteGroups2 = _this$QuoteGroups2[baseId]) !== null && _this$QuoteGroups2 !== void 0 && (_this$QuoteGroups2 = _this$QuoteGroups2[groupId]) !== null && _this$QuoteGroups2 !== void 0 && (_this$QuoteGroups2 = _this$QuoteGroups2.Selected) !== null && _this$QuoteGroups2 !== void 0 && _this$QuoteGroups2[pType]) {
                  res[baseId] = true;
                }
              }
            } catch (err) {
              _iterator17.e(err);
            } finally {
              _iterator17.f();
            }
          }
        } else {
          var _iterator18 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
            _step18;
          try {
            for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
              var _pType2 = _step18.value;
              if (this.Totals[baseId] && this.Totals[baseId][_pType2] && this.Totals[baseId][_pType2].Selected) {
                res[baseId] = true;
              }
            }
          } catch (err) {
            _iterator18.e(err);
          } finally {
            _iterator18.f();
          }
        }
      }
      return res;
    }
  }, {
    key: "isQuoteSelected",
    value: function isQuoteSelected(baseId, pType) {
      var _this$BaseQuotes;
      if (this.QuoteBy != 'SERVICE') {
        var _this$Totals;
        return (_this$Totals = this.Totals) === null || _this$Totals === void 0 || (_this$Totals = _this$Totals[baseId]) === null || _this$Totals === void 0 || (_this$Totals = _this$Totals[pType]) === null || _this$Totals === void 0 ? void 0 : _this$Totals.Selected;
      }
      if (this.isGroup(baseId)) {
        var _iterator19 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
          _step19;
        try {
          for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
            var _pType = _step19.value;
            for (var groupId in (_this$QuoteGroups3 = this.QuoteGroups) === null || _this$QuoteGroups3 === void 0 ? void 0 : _this$QuoteGroups3[baseId]) {
              var _this$QuoteGroups3, _this$QuoteGroups4, _this$QuoteGroups5;
              if (!((_this$QuoteGroups4 = this.QuoteGroups) !== null && _this$QuoteGroups4 !== void 0 && (_this$QuoteGroups4 = _this$QuoteGroups4[baseId]) !== null && _this$QuoteGroups4 !== void 0 && (_this$QuoteGroups4 = _this$QuoteGroups4[groupId]) !== null && _this$QuoteGroups4 !== void 0 && _this$QuoteGroups4[_pType])) continue;
              if ((_this$QuoteGroups5 = this.QuoteGroups) !== null && _this$QuoteGroups5 !== void 0 && (_this$QuoteGroups5 = _this$QuoteGroups5[baseId]) !== null && _this$QuoteGroups5 !== void 0 && (_this$QuoteGroups5 = _this$QuoteGroups5[groupId]) !== null && _this$QuoteGroups5 !== void 0 && (_this$QuoteGroups5 = _this$QuoteGroups5.Selected) !== null && _this$QuoteGroups5 !== void 0 && _this$QuoteGroups5[_pType]) return true;
            }
          }
        } catch (err) {
          _iterator19.e(err);
        } finally {
          _iterator19.f();
        }
        return false;
      }
      if (!((_this$BaseQuotes = this.BaseQuotes) !== null && _this$BaseQuotes !== void 0 && (_this$BaseQuotes = _this$BaseQuotes[baseId]) !== null && _this$BaseQuotes !== void 0 && _this$BaseQuotes.paxTypes)) return false;
      var _iterator20 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
        _step20;
      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var _this$Totals2;
          var _pType3 = _step20.value;
          if ((_this$Totals2 = this.Totals) !== null && _this$Totals2 !== void 0 && (_this$Totals2 = _this$Totals2[baseId]) !== null && _this$Totals2 !== void 0 && (_this$Totals2 = _this$Totals2[_pType3]) !== null && _this$Totals2 !== void 0 && _this$Totals2.Selected) return true;
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }
      return false;
    }
  }, {
    key: "anyQuoteSelected",
    get: function get() {
      for (var baseId in this.BaseQuotes.bases) {
        for (var paxType in this.Totals[baseId]) {
          if (this.isQuoteSelected(baseId, paxType)) return true;
        }
      }
      return false;
    }
  }, {
    key: "setBase",
    value: function () {
      var _setBase = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee25(_ref2) {
        var adt, chd, tl, baseId, tourLeader, singleSup, obj;
        return regenerator_default().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              adt = _ref2.adt, chd = _ref2.chd, tl = _ref2.tl, baseId = _ref2.baseId, tourLeader = _ref2.tourLeader, singleSup = _ref2.singleSup;
              _context25.next = 3;
              return this.BaseQuotes.newBaseQuotes(baseId, {
                ADT: parseInt(adt),
                CHD: parseInt(chd),
                TL: parseInt(tl),
                TourLeader: tourLeader,
                SingleSupplement: singleSup
              });
            case 3:
              this.BaseQuotes.getFields();
              obj = {
                ADT: {
                  Selected: true,
                  Pax: null,
                  Comment: null
                }
              };
              if (parseInt(chd) > 0) {
                obj.CHD = {
                  Selected: true,
                  Pax: null,
                  Comment: null
                };
              }
              if (parseInt(tl) > 0) {
                obj.TL = {
                  Selected: true,
                  Pax: null,
                  Comment: null
                };
              }
              _context25.next = 9;
              return this.Totals.newBookingTotal(baseId, obj);
            case 9:
              this.Totals.getFields();
            case 10:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
      function setBase(_x20) {
        return _setBase.apply(this, arguments);
      }
      return setBase;
    }()
  }, {
    key: "newHotelQuote",
    value: function () {
      var _newHotelQuote = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee26(baseId, room, data, rooms) {
        var roomQuote, roomInfo, _room$$parent, paxQuantity, roomType, mod, paxRoms, _iterator21, _step21, _room$Room, _room;
        return regenerator_default().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              _context26.next = 2;
              return room.QuoteList.newHotelQuote(data);
            case 2:
              roomQuote = _context26.sent;
              if (!this.quoteService) {
                _context26.next = 40;
                break;
              }
              if (!((rooms === null || rooms === void 0 ? void 0 : rooms.length) > 0)) {
                _context26.next = 9;
                break;
              }
              roomInfo = rooms.find(function (r) {
                return r.id == room.Room.id;
              });
              if (roomInfo) {
                roomQuote.Rooms = roomInfo.rooms;
                roomQuote.Pax = roomInfo.pax;
              }
              _context26.next = 36;
              break;
            case 9:
              paxQuantity = this.BaseQuotes[baseId].paxQuantity;
              roomQuote.Pax = paxQuantity;
              if (!(((_room$$parent = room.$parent) === null || _room$$parent === void 0 || (_room$$parent = _room$$parent.BookingDayRooms) === null || _room$$parent === void 0 ? void 0 : _room$$parent.length) == 1)) {
                _context26.next = 16;
                break;
              }
              roomType = room.$parent.BookingDayRooms[0].Room;
              if (roomType !== null && roomType !== void 0 && roomType.Pax) {
                mod = roomQuote.Pax % roomType.Pax;
                if (mod == 0) {
                  roomQuote.Rooms = roomQuote.Pax / roomType.Pax;
                }
              }
              _context26.next = 36;
              break;
            case 16:
              paxRoms = 0;
              _iterator21 = _createForOfIteratorHelper(room.$parent.BookingDayRooms);
              _context26.prev = 18;
              _iterator21.s();
            case 20:
              if ((_step21 = _iterator21.n()).done) {
                _context26.next = 27;
                break;
              }
              _room = _step21.value;
              if (!_room.Room.Checkin) {
                _context26.next = 24;
                break;
              }
              return _context26.abrupt("continue", 25);
            case 24:
              if ((_room$Room = _room.Room) !== null && _room$Room !== void 0 && _room$Room.Pax) {
                paxRoms += _room.Room.Pax;
              }
            case 25:
              _context26.next = 20;
              break;
            case 27:
              _context26.next = 32;
              break;
            case 29:
              _context26.prev = 29;
              _context26.t0 = _context26["catch"](18);
              _iterator21.e(_context26.t0);
            case 32:
              _context26.prev = 32;
              _iterator21.f();
              return _context26.finish(32);
            case 35:
              if (paxQuantity == paxRoms) {
                roomQuote.Rooms = 1;
                roomQuote.Pax = room.Room.Pax;
              }
            case 36:
              room.QuoteList.getFields();
              room.QuoteList.setGroups();
              _context26.next = 41;
              break;
            case 40:
              room.QuoteList.getFields();
            case 41:
              room.QuoteList.setVariants();
              return _context26.abrupt("return", roomQuote);
            case 43:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this, [[18, 29, 32, 35]]);
      }));
      function newHotelQuote(_x21, _x22, _x23, _x24) {
        return _newHotelQuote.apply(this, arguments);
      }
      return newHotelQuote;
    }()
  }, {
    key: "setHotelCostSync",
    value: function () {
      var _setHotelCostSync = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee27(_ref3) {
        var idx, hotelId, hotelDate, days, roomNr, update, exchange, baseId, program, hasProgramRooms, currencyId, skipCurrency, sync, updateModified, daysChange;
        return regenerator_default().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              idx = _ref3.idx, hotelId = _ref3.hotelId, hotelDate = _ref3.hotelDate, days = _ref3.days, roomNr = _ref3.roomNr, update = _ref3.update, exchange = _ref3.exchange, baseId = _ref3.baseId, program = _ref3.program, hasProgramRooms = _ref3.hasProgramRooms, currencyId = _ref3.currencyId, skipCurrency = _ref3.skipCurrency, sync = _ref3.sync, updateModified = _ref3.updateModified, daysChange = _ref3.daysChange;
              if (!sync) {
                _context27.next = 6;
                break;
              }
              _context27.next = 4;
              return this.setHotelCost({
                idx: idx,
                hotelId: hotelId,
                hotelDate: hotelDate,
                days: days,
                roomNr: roomNr,
                update: update,
                exchange: exchange,
                baseId: baseId,
                program: program,
                hasProgramRooms: hasProgramRooms,
                currencyId: currencyId,
                skipCurrency: skipCurrency,
                updateModified: updateModified,
                daysChange: daysChange
              });
            case 4:
              _context27.next = 7;
              break;
            case 6:
              this.setHotelCost({
                idx: idx,
                hotelId: hotelId,
                hotelDate: hotelDate,
                days: days,
                roomNr: roomNr,
                update: update,
                exchange: exchange,
                baseId: baseId,
                program: program,
                hasProgramRooms: hasProgramRooms,
                currencyId: currencyId,
                skipCurrency: skipCurrency,
                updateModified: updateModified,
                daysChange: daysChange
              });
            case 7:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this);
      }));
      function setHotelCostSync(_x25) {
        return _setHotelCostSync.apply(this, arguments);
      }
      return setHotelCostSync;
    }()
  }, {
    key: "addBaseGroups",
    value: function () {
      var _addBaseGroups = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee28(groups, rooms) {
        var adt, chd, tl, _iterator22, _step22, group, baseId, groupsList;
        return regenerator_default().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              adt = 0;
              chd = 0;
              tl = 0;
              _iterator22 = _createForOfIteratorHelper(groups);
              try {
                for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
                  group = _step22.value;
                  adt += group.adt;
                  chd += group.chd;
                  tl += group.tl;
                }
              } catch (err) {
                _iterator22.e(err);
              } finally {
                _iterator22.f();
              }
              _context28.next = 7;
              return this.addBase({
                adt: adt,
                chd: chd,
                tl: tl,
                sync: false,
                rooms: rooms
              });
            case 7:
              baseId = _context28.sent;
              if (groups.length > 1) {
                groupsList = _.map(groups, function (g) {
                  return {
                    ADT: g.adt,
                    CHD: g.chd,
                    TL: g.tl
                  };
                });
                this.saveGroups(baseId, groupsList);
              }
            case 9:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this);
      }));
      function addBaseGroups(_x26, _x27) {
        return _addBaseGroups.apply(this, arguments);
      }
      return addBaseGroups;
    }() //refactor
  }, {
    key: "addBase",
    value: function () {
      var _addBase = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee29(_ref4) {
        var adt, chd, tl, sync, rooms, baseId, tourLeader, singleSup, idx, day, _iterator23, _step23, s, quoteDate, _iterator24, _step24, room, hotelDate, program;
        return regenerator_default().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              adt = _ref4.adt, chd = _ref4.chd, tl = _ref4.tl, sync = _ref4.sync, rooms = _ref4.rooms;
              if (!this.QuoteGroups) this.QuoteGroups = {};
              this._requestCount += 1;
              baseId = this.getNextBaseId();
              _context29.next = 6;
              return this.setBase({
                adt: adt,
                chd: chd,
                tl: tl,
                baseId: baseId
              });
            case 6:
              tourLeader = this.BaseQuotes[baseId].TourLeader;
              singleSup = this.BaseQuotes[baseId].SingleSupplement;
              _context29.t0 = regenerator_default().keys(this.BookingDays);
            case 9:
              if ((_context29.t1 = _context29.t0()).done) {
                _context29.next = 74;
                break;
              }
              idx = _context29.t1.value;
              day = this.BookingDays[idx];
              _iterator23 = _createForOfIteratorHelper(day.BookingDayServices);
              _context29.prev = 13;
              _iterator23.s();
            case 15:
              if ((_step23 = _iterator23.n()).done) {
                _context29.next = 28;
                break;
              }
              s = _step23.value;
              if (this.quoteService && !s.ServiceId && !s.costPer && !s.CostPer) {
                if (this.QuoteViewType == 'PERSON') {
                  s.$CostPer.value = 'PERSON';
                }
              }
              _context29.next = 20;
              return this.getServicePersonCostRow({
                baseQuoteId: baseId,
                service: s
              });
            case 20:
              quoteDate = day.TransDate;
              if (this.SplitQuoteDate && this.QuoteDate && day.QuoteDate) {
                quoteDate = day.QuoteDate;
              }
              if (s.ServiceId) {
                _context29.next = 24;
                break;
              }
              return _context29.abrupt("continue", 26);
            case 24:
              _context29.next = 26;
              return this.getServiceCost({
                service: s,
                quoteDate: quoteDate,
                baseQuoteId: baseId
              });
            case 26:
              _context29.next = 15;
              break;
            case 28:
              _context29.next = 33;
              break;
            case 30:
              _context29.prev = 30;
              _context29.t2 = _context29["catch"](13);
              _iterator23.e(_context29.t2);
            case 33:
              _context29.prev = 33;
              _iterator23.f();
              return _context29.finish(33);
            case 36:
              if (!(day.BookingDayHotels[0] && day.BookingDayHotels[0].BookingDayRooms)) {
                _context29.next = 72;
                break;
              }
              _iterator24 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms);
              _context29.prev = 38;
              _iterator24.s();
            case 40:
              if ((_step24 = _iterator24.n()).done) {
                _context29.next = 64;
                break;
              }
              room = _step24.value;
              if (room.QuoteList) {
                _context29.next = 46;
                break;
              }
              _context29.next = 45;
              return room.newRowByName('QuoteList');
            case 45:
              room.QuoteList = _context29.sent;
            case 46:
              if (room.QuoteList[baseId]) {
                _context29.next = 51;
                break;
              }
              _context29.next = 49;
              return this.newHotelQuote(baseId, room, null, rooms);
            case 49:
              room.QuoteList[baseId] = _context29.sent;
              room.QuoteList.getFields();
            case 51:
              if (room.TourLeader && !tourLeader) {
                room.QuoteList[baseId].Include = false;
              }
              if (room.SingleSupplement && !singleSup) {
                room.QuoteList[baseId].Include = false;
              }
              if (room.Hotel) {
                _context29.next = 55;
                break;
              }
              return _context29.abrupt("continue", 62);
            case 55:
              hotelDate = day.TransDate;
              if (this.SplitQuoteDate && this.QuoteDate) {
                hotelDate = day.QuoteDate;
              }
              program = void 0;
              if (room && room.Category && room.Category.Program) program = room.RoomCategory;
              if (!room.CurrencyId) {
                room.$CurrencyId.value = this.CurrencyId;
              }
              _context29.next = 62;
              return this.setHotelCostSync({
                idx: idx,
                hotelId: room.Hotel.id,
                hotelDate: hotelDate,
                days: day.BookingDayHotels[0].Days,
                baseId: baseId,
                program: program,
                hasProgramRooms: this.hasProgramRooms(room.Hotel),
                //currencyId: room.CurrencyId,
                sync: sync
              });
            case 62:
              _context29.next = 40;
              break;
            case 64:
              _context29.next = 69;
              break;
            case 66:
              _context29.prev = 66;
              _context29.t3 = _context29["catch"](38);
              _iterator24.e(_context29.t3);
            case 69:
              _context29.prev = 69;
              _iterator24.f();
              return _context29.finish(69);
            case 72:
              _context29.next = 9;
              break;
            case 74:
              _context29.next = 76;
              return this.addFlightsToBase(baseId);
            case 76:
              this.setBookingTotals();
              this._requestCount += -1;
              return _context29.abrupt("return", baseId);
            case 79:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this, [[13, 30, 33, 36], [38, 66, 69, 72]]);
      }));
      function addBase(_x28) {
        return _addBase.apply(this, arguments);
      }
      return addBase;
    }()
  }, {
    key: "addFlightsToBase",
    value: function () {
      var _addFlightsToBase = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee30(baseId) {
        var _iterator25, _step25, flight;
        return regenerator_default().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _iterator25 = _createForOfIteratorHelper(this.BookingFlights);
              _context30.prev = 1;
              _iterator25.s();
            case 3:
              if ((_step25 = _iterator25.n()).done) {
                _context30.next = 10;
                break;
              }
              flight = _step25.value;
              if (!flight.QuoteList) {
                _context30.next = 8;
                break;
              }
              _context30.next = 8;
              return flight.QuoteList.newBookingFlightQuote(baseId, {
                Include: true
              });
            case 8:
              _context30.next = 3;
              break;
            case 10:
              _context30.next = 15;
              break;
            case 12:
              _context30.prev = 12;
              _context30.t0 = _context30["catch"](1);
              _iterator25.e(_context30.t0);
            case 15:
              _context30.prev = 15;
              _iterator25.f();
              return _context30.finish(15);
            case 18:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this, [[1, 12, 15, 18]]);
      }));
      function addFlightsToBase(_x29) {
        return _addFlightsToBase.apply(this, arguments);
      }
      return addFlightsToBase;
    }()
  }, {
    key: "checkBase",
    value: function checkBase(baseId) {
      var paxTypes = this.BaseQuotes[baseId].paxTypes;
      var _iterator26 = _createForOfIteratorHelper(this.BookingDays),
        _step26;
      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var day = _step26.value;
          var _iterator27 = _createForOfIteratorHelper(day.BookingDayServices),
            _step27;
          try {
            for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
              var s = _step27.value;
              if (!s.Quote) return;
              if (!s.Quote.QuoteList) return;
              if (!s.Quote.QuoteList[baseId]) return;
              var _iterator28 = _createForOfIteratorHelper(paxTypes),
                _step28;
              try {
                for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
                  var paxType = _step28.value;
                  if (!s.Quote.QuoteList[baseId][paxType]) return;
                }
              } catch (err) {
                _iterator28.e(err);
              } finally {
                _iterator28.f();
              }
            }
          } catch (err) {
            _iterator27.e(err);
          } finally {
            _iterator27.f();
          }
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
      return true;
    }
  }, {
    key: "setBookingTotals",
    value: function setBookingTotals(bId) {
      var totals = this.totals;
      for (var baseId in this.BaseQuotes.bases) {
        if (parseInt(bId) > -1 && bId != baseId) continue;
        var _iterator29 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
          _step29;
        try {
          for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
            var pType = _step29.value;
            if (!this.Totals[baseId]) continue;
            if (!this.Totals[baseId][pType]) continue;
            if (!totals[baseId]) continue;
            if (!totals[baseId][pType]) continue;
            this.Totals[baseId][pType].$Cost.value = totals[baseId][pType].Cost;
            this.Totals[baseId][pType].$Price.value = totals[baseId][pType].Price;
            this.Totals[baseId][pType].Rooms = totals[baseId][pType].Rooms;
            if (this.quoteService) {
              if (!this.Totals[baseId][pType].$PersonCost) {
                this.Totals[baseId][pType].$PersonCost = {};
              }
              if (!this.Totals[baseId][pType].$PersonPrice) {
                this.Totals[baseId][pType].$PersonPrice = {};
              }
              this.Totals[baseId][pType].$PersonCost.value = totals[baseId][pType].PersonCost;
              this.Totals[baseId][pType].$PersonPrice.value = totals[baseId][pType].PersonPrice;
            }
          }
        } catch (err) {
          _iterator29.e(err);
        } finally {
          _iterator29.f();
        }
      }
    }
  }, {
    key: "copyBase",
    value: function () {
      var _copyBase = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee31(baseId) {
        var newBaseId, adt, chd, tl, tourLeader, singleSup, _iterator30, _step30, day, _iterator32, _step32, s, newValues, _iterator35, _step35, paxType, _iterator36, _step36, _field, _iterator33, _step33, room, _iterator34, _step34, field, _iterator31, _step31, flight;
        return regenerator_default().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              newBaseId = this.getNextBaseId();
              adt = this.BaseQuotes[baseId].ADT;
              chd = this.BaseQuotes[baseId].CHD;
              tl = this.BaseQuotes[baseId].TL;
              tourLeader = this.BaseQuotes[baseId].TourLeader;
              singleSup = this.BaseQuotes[baseId].SingleSupplement;
              _context31.next = 8;
              return this.setBase({
                adt: adt,
                chd: chd,
                tl: tl,
                baseId: newBaseId,
                tourLeader: tourLeader,
                singleSup: singleSup
              });
            case 8:
              if (this.quoteService) this.QuoteGroups[newBaseId] = Object.assign({}, _.cloneDeep(this.QuoteGroups[baseId]));
              if (this.QuoteVariants) this.QuoteVariants[newBaseId] = Object.assign({}, _.cloneDeep(this.QuoteVariants[baseId]));
              _iterator30 = _createForOfIteratorHelper(this.BookingDays);
              _context31.prev = 11;
              _iterator30.s();
            case 13:
              if ((_step30 = _iterator30.n()).done) {
                _context31.next = 81;
                break;
              }
              day = _step30.value;
              _iterator32 = _createForOfIteratorHelper(day.BookingDayServices);
              _context31.prev = 16;
              _iterator32.s();
            case 18:
              if ((_step32 = _iterator32.n()).done) {
                _context31.next = 49;
                break;
              }
              s = _step32.value;
              if (!(s.Quote && s.Quote.QuoteList)) {
                _context31.next = 47;
                break;
              }
              newValues = tools.plainObject(s.Quote.QuoteList[baseId]);
              _context31.next = 24;
              return s.Quote.QuoteList.newServiceQuote(newValues, true);
            case 24:
              s.Quote.QuoteList[newBaseId] = _context31.sent;
              s.Quote.QuoteList.getFields();
              _iterator35 = _createForOfIteratorHelper(s.Quote.QuoteList[newBaseId].paxTypes);
              _context31.prev = 27;
              _iterator35.s();
            case 29:
              if ((_step35 = _iterator35.n()).done) {
                _context31.next = 37;
                break;
              }
              paxType = _step35.value;
              if (s.Quote.QuoteList[newBaseId][paxType]) {
                _context31.next = 33;
                break;
              }
              return _context31.abrupt("continue", 35);
            case 33:
              _iterator36 = _createForOfIteratorHelper(s.Quote.QuoteList[newBaseId][paxType].fields);
              try {
                for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
                  _field = _step36.value;
                  s.Quote.QuoteList[newBaseId][paxType]['$' + _field.name].value = s.Quote.QuoteList[baseId][paxType][_field.name];
                }
              } catch (err) {
                _iterator36.e(err);
              } finally {
                _iterator36.f();
              }
            case 35:
              _context31.next = 29;
              break;
            case 37:
              _context31.next = 42;
              break;
            case 39:
              _context31.prev = 39;
              _context31.t0 = _context31["catch"](27);
              _iterator35.e(_context31.t0);
            case 42:
              _context31.prev = 42;
              _iterator35.f();
              return _context31.finish(42);
            case 45:
              if (this.quoteService) s.Quote.QuoteList[newBaseId].Groups = Object.assign({}, _.cloneDeep(s.Quote.QuoteList[baseId].Groups));
              s.Quote.QuoteList[newBaseId].Variants = Object.assign({}, _.cloneDeep(s.Quote.QuoteList[baseId].Variants));
            case 47:
              _context31.next = 18;
              break;
            case 49:
              _context31.next = 54;
              break;
            case 51:
              _context31.prev = 51;
              _context31.t1 = _context31["catch"](16);
              _iterator32.e(_context31.t1);
            case 54:
              _context31.prev = 54;
              _iterator32.f();
              return _context31.finish(54);
            case 57:
              if (!(day.BookingDayHotels[0] && day.BookingDayHotels[0].BookingDayRooms)) {
                _context31.next = 79;
                break;
              }
              _iterator33 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms);
              _context31.prev = 59;
              _iterator33.s();
            case 61:
              if ((_step33 = _iterator33.n()).done) {
                _context31.next = 71;
                break;
              }
              room = _step33.value;
              _context31.next = 65;
              return this.newHotelQuote(baseId, room, _.cloneDeep(room.QuoteList[baseId]));
            case 65:
              room.QuoteList[newBaseId] = _context31.sent;
              room.QuoteList.getFields();
              _iterator34 = _createForOfIteratorHelper(room.QuoteList[newBaseId].fields);
              try {
                for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
                  field = _step34.value;
                  room.QuoteList[newBaseId]['$' + field.name].value = room.QuoteList[baseId][field.name];
                }
              } catch (err) {
                _iterator34.e(err);
              } finally {
                _iterator34.f();
              }
            case 69:
              _context31.next = 61;
              break;
            case 71:
              _context31.next = 76;
              break;
            case 73:
              _context31.prev = 73;
              _context31.t2 = _context31["catch"](59);
              _iterator33.e(_context31.t2);
            case 76:
              _context31.prev = 76;
              _iterator33.f();
              return _context31.finish(76);
            case 79:
              _context31.next = 13;
              break;
            case 81:
              _context31.next = 86;
              break;
            case 83:
              _context31.prev = 83;
              _context31.t3 = _context31["catch"](11);
              _iterator30.e(_context31.t3);
            case 86:
              _context31.prev = 86;
              _iterator30.f();
              return _context31.finish(86);
            case 89:
              _iterator31 = _createForOfIteratorHelper(this.BookingFlights);
              _context31.prev = 90;
              _iterator31.s();
            case 92:
              if ((_step31 = _iterator31.n()).done) {
                _context31.next = 98;
                break;
              }
              flight = _step31.value;
              _context31.next = 96;
              return flight.QuoteList.newBookingFlightQuote(newBaseId, _.cloneDeep(flight.QuoteList[baseId]));
            case 96:
              _context31.next = 92;
              break;
            case 98:
              _context31.next = 103;
              break;
            case 100:
              _context31.prev = 100;
              _context31.t4 = _context31["catch"](90);
              _iterator31.e(_context31.t4);
            case 103:
              _context31.prev = 103;
              _iterator31.f();
              return _context31.finish(103);
            case 106:
            case "end":
              return _context31.stop();
          }
        }, _callee31, this, [[11, 83, 86, 89], [16, 51, 54, 57], [27, 39, 42, 45], [59, 73, 76, 79], [90, 100, 103, 106]]);
      }));
      function copyBase(_x30) {
        return _copyBase.apply(this, arguments);
      }
      return copyBase;
    }()
  }, {
    key: "hasProgramRooms",
    value: function hasProgramRooms(hotel) {
      var rooms = _.filter(hotel.RoomCategories, function (r) {
        return r.Program;
      });
      if (rooms.length > 0) return true;
    }
  }, {
    key: "getServiceCostFromState",
    value: function () {
      var _getServiceCostFromState = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee32(id, serviceDate, categoryId, update, tourLeader) {
        var cost, value;
        return regenerator_default().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              if (this.StartDate) {
                _context32.next = 2;
                break;
              }
              return _context32.abrupt("return");
            case 2:
              cost = null;
              if (!id) {
                _context32.next = 8;
                break;
              }
              _context32.next = 6;
              return api.getServiceCost(id, serviceDate, categoryId, tourLeader, this.PaxCountryType);
            case 6:
              value = _context32.sent;
              if (value) {
                cost = value;
              }
            case 8:
              return _context32.abrupt("return", cost);
            case 9:
            case "end":
              return _context32.stop();
          }
        }, _callee32, this);
      }));
      function getServiceCostFromState(_x31, _x32, _x33, _x34, _x35) {
        return _getServiceCostFromState.apply(this, arguments);
      }
      return getServiceCostFromState;
    }()
  }, {
    key: "getServicePriceFromState",
    value: function () {
      var _getServicePriceFromState = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee33(id, serviceDate, categoryId, bookingId, tourLeader, serviceMarkup) {
        var cost, value;
        return regenerator_default().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              if (this.StartDate) {
                _context33.next = 2;
                break;
              }
              return _context33.abrupt("return");
            case 2:
              cost = null;
              if (!id) {
                _context33.next = 8;
                break;
              }
              _context33.next = 6;
              return api.getServicePrice(id, serviceDate, categoryId, bookingId, tourLeader, serviceMarkup, this.PaxCountryType);
            case 6:
              value = _context33.sent;
              if (value) {
                cost = value;
              }
            case 8:
              return _context33.abrupt("return", cost);
            case 9:
            case "end":
              return _context33.stop();
          }
        }, _callee33, this);
      }));
      function getServicePriceFromState(_x36, _x37, _x38, _x39, _x40, _x41) {
        return _getServicePriceFromState.apply(this, arguments);
      }
      return getServicePriceFromState;
    }()
  }, {
    key: "hotelCostModified",
    value: function hotelCostModified(idx, roomNr, hotelId, baseId, updateModified) {
      //console.log(5555, idx, roomNr, hotelId, baseId, updateModified)
      if (updateModified) return;
      if (this.BookingDays[idx].BookingDayHotels[0] && this.BookingDays[idx].BookingDayHotels[0].BookingDayRooms) {
        for (var i in this.BookingDays[idx].BookingDayHotels[0].BookingDayRooms) {
          if (roomNr != undefined && roomNr != parseInt(i)) continue;
          var room = this.BookingDays[idx].BookingDayHotels[0].BookingDayRooms[i];
          if (room.HotelId != hotelId) continue;
          if (room.Room) {
            for (var base in this.BaseQuotes.bases) {
              if (baseId != null && baseId != undefined && base != baseId) continue;
              if (!room.QuoteList[base]) {
                return;
              }
              var quote = room.QuoteList[base];
              //if (!quote.Include) continue;
              if (quote.Modified) {
                return true;
              }
            }
          }
        }
      }
    }
  }, {
    key: "getHotelCostToApply",
    value: function () {
      var _getHotelCostToApply = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee34(days, hotelDate, hasProgramRooms, program, hotelId, currencyId, update) {
        var cost, i, date, _res2;
        return regenerator_default().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              cost = {};
              i = 0;
            case 2:
              if (!(i < days)) {
                _context34.next = 12;
                break;
              }
              date = moment(hotelDate).add(i, 'days').format("YYYY-MM-DD");
              _res2 = void 0;
              _context34.next = 7;
              return api.getHotelCost(hotelId, date, program, currencyId, update, days, this.PaxCountryType);
            case 7:
              _res2 = _context34.sent;
              if (_res2) {
                cost[i] = _res2;
              } else {
                cost[i] = null;
              }
            case 9:
              i++;
              _context34.next = 2;
              break;
            case 12:
              return _context34.abrupt("return", cost);
            case 13:
            case "end":
              return _context34.stop();
          }
        }, _callee34, this);
      }));
      function getHotelCostToApply(_x42, _x43, _x44, _x45, _x46, _x47, _x48) {
        return _getHotelCostToApply.apply(this, arguments);
      }
      return getHotelCostToApply;
    }()
  }, {
    key: "getHotelPriceToApply",
    value: function () {
      var _getHotelPriceToApply = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee35(days, hotelDate, hasProgramRooms, program, hotelId, currencyId, bookingId) {
        var cost, i, date, _res3;
        return regenerator_default().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              cost = {};
              i = 0;
            case 2:
              if (!(i < days)) {
                _context35.next = 11;
                break;
              }
              date = moment(hotelDate).add(i, 'days').format("YYYY-MM-DD");
              _context35.next = 6;
              return api.getHotelPrice(hotelId, date, program, currencyId, bookingId, days, this.PaxCountryType);
            case 6:
              _res3 = _context35.sent;
              if (_res3) {
                cost[i] = _res3;
              } else {
                cost[i] = null;
              }
            case 8:
              i++;
              _context35.next = 2;
              break;
            case 11:
              return _context35.abrupt("return", cost);
            case 12:
            case "end":
              return _context35.stop();
          }
        }, _callee35, this);
      }));
      function getHotelPriceToApply(_x49, _x50, _x51, _x52, _x53, _x54, _x55) {
        return _getHotelPriceToApply.apply(this, arguments);
      }
      return getHotelPriceToApply;
    }()
  }, {
    key: "setHotelCurrencyId",
    value: function setHotelCurrencyId(cost) {
      //if (!cost) return;
      var currencyId;
      if (Object.keys(cost).length > 0) {
        for (var i = 0; i < Object.keys(cost).length; i++) {
          if (cost[i]) {
            currencyId = cost[i].CurrencyId;
            break;
          }
        }
      } else {
        currencyId = this.CurrencyId;
      }
      return currencyId;
    }
  }, {
    key: "setCostValues",
    value: function setCostValues(quote, roomCost, room, days, quoteBy) {
      quote.$SourceCurrencyId.value = roomCost.SourceCurrencyId;
      //console.log(roomCost)
      if (roomCost.SourceCost) {
        quote.$SourceCost.value = roomCost.SourceCost;
        quote.$SourceRoomCost.value = roomCost.SourceCost;
      }
      ;
      if (roomCost.SourceRoomCost) {
        quote.$SourceRoomCost.value = roomCost.SourceRoomCost;
      }
      ;
      if (!tools.isNull(roomCost.roomCost) && this.QuoteBy != 'QUANTITY') {
        quote.$RoomCost.value = roomCost.roomCost;
      } else if (!tools.isNull(roomCost.Cost)) {
        if (quoteBy == 'SERVICE') {
          quote.$RoomCost.value = parseFloat(roomCost.Cost);
        } else {
          quote.$RoomCost.value = parseFloat(roomCost.Cost) * quote.factor / (parseInt(days) * quote.qFactor);
        }
      } else {
        quote.$RoomCost.value = null;
      }
      quote.$Cost.value = quote.getCost();
      quote.invalid.Cost = false;
      if (tools.isNull(quote.Cost)) quote.invalid.Cost = true;
      if (roomCost.OriginCost) quote.$OriginCost.value = roomCost.OriginCost;
      if (roomCost.ValidTo) quote.ValidTo = roomCost.ValidTo;
    }
  }, {
    key: "getHotelCommission",
    value: function getHotelCommission(room, costByDate) {
      var res = 0;
      if (room.Hotel && room.Hotel.CommisionPrice && room.Hotel.Commision) {
        res = room.Hotel.Commision;
      }
      if (costByDate && costByDate.Commission) res = costByDate.Commission;
      return res;
    }

    //refactor
  }, {
    key: "setHotelCost",
    value: function () {
      var _setHotelCost = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee36(_ref5) {
        var idx, hotelId, hotelDate, days, roomNr, update, exchange, baseId, program, hasProgramRooms, currencyId, skipCurrency, updateModified, daysChange, roomtypes, cost, totalNights, CurrencyId, i, hcm, room, roomCategoryId, roomCost, base, quote, _room$Room2, periodCostBy, unitCostBy, modified, markup, pax, _markup, _pax;
        return regenerator_default().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              idx = _ref5.idx, hotelId = _ref5.hotelId, hotelDate = _ref5.hotelDate, days = _ref5.days, roomNr = _ref5.roomNr, update = _ref5.update, exchange = _ref5.exchange, baseId = _ref5.baseId, program = _ref5.program, hasProgramRooms = _ref5.hasProgramRooms, currencyId = _ref5.currencyId, skipCurrency = _ref5.skipCurrency, updateModified = _ref5.updateModified, daysChange = _ref5.daysChange;
              if (!(Object.keys(this.BaseQuotes.bases).length == 0)) {
                _context36.next = 3;
                break;
              }
              return _context36.abrupt("return");
            case 3:
              if (!(roomNr == -1)) {
                _context36.next = 5;
                break;
              }
              return _context36.abrupt("return");
            case 5:
              if (!this._requestCount) this._requestCount = 0;
              this._requestCount += 1;
              _context36.next = 9;
              return api.getTable('roomtype');
            case 9:
              roomtypes = _context36.sent;
              _context36.next = 12;
              return this.getHotelCostToApply(days, hotelDate, hasProgramRooms, program, hotelId, currencyId, update);
            case 12:
              cost = _context36.sent;
              totalNights = this.getHotelTotalNights(hotelId);
              CurrencyId = this.setHotelCurrencyId(cost);
              if (!(this.BookingDays[idx] && this.BookingDays[idx].BookingDayHotels && this.BookingDays[idx].BookingDayHotels[0] && this.BookingDays[idx].BookingDayHotels[0].BookingDayRooms)) {
                _context36.next = 59;
                break;
              }
              _context36.t0 = regenerator_default().keys(this.BookingDays[idx].BookingDayHotels[0].BookingDayRooms);
            case 17:
              if ((_context36.t1 = _context36.t0()).done) {
                _context36.next = 59;
                break;
              }
              i = _context36.t1.value;
              if (!(roomNr != undefined && roomNr != i)) {
                _context36.next = 21;
                break;
              }
              return _context36.abrupt("continue", 17);
            case 21:
              hcm = this.hotelCostModified(idx, i, hotelId, baseId, updateModified);
              if (!(hcm && !daysChange)) {
                _context36.next = 24;
                break;
              }
              return _context36.abrupt("continue", 17);
            case 24:
              room = this.BookingDays[idx].BookingDayHotels[0].BookingDayRooms[i];
              room.exchange = exchange;
              if (!(room.HotelId != hotelId)) {
                _context36.next = 28;
                break;
              }
              return _context36.abrupt("continue", 17);
            case 28:
              roomCategoryId = room.RoomCategory;
              if (!room.Room) {
                _context36.next = 57;
                break;
              }
              //let commission = this.getHotelCommission(room);
              roomCost = this.getRoomCost(cost, room, roomCategoryId, days, this.CurrencyId, this.currencyRates, roomtypes, totalNights, this.QuoteBy);
              _context36.t2 = regenerator_default().keys(this.BaseQuotes.bases);
            case 32:
              if ((_context36.t3 = _context36.t2()).done) {
                _context36.next = 57;
                break;
              }
              base = _context36.t3.value;
              if (!(baseId != null && baseId != undefined && base != baseId)) {
                _context36.next = 36;
                break;
              }
              return _context36.abrupt("continue", 32);
            case 36:
              if (room.QuoteList[base]) {
                _context36.next = 43;
                break;
              }
              _context36.next = 39;
              return this.newHotelQuote(base, room);
            case 39:
              room.QuoteList[base] = _context36.sent;
              room.QuoteList.getFields();
              room.QuoteList.setGroups();
              room.QuoteList.setVariants();
            case 43:
              quote = room.QuoteList[base];
              if (this.QuoteBy != 'PERSON') {
                periodCostBy = void 0;
                if (cost[0]) {
                  periodCostBy = cost[0].PeriodCostBy;
                }
                if (!periodCostBy) {
                  if (program && room.Hotel && room.Hotel.ProgramPeriodCostBy) {
                    periodCostBy = room.Hotel.ProgramPeriodCostBy;
                  }
                  if (!program && room.Hotel && room.Hotel.PeriodCostBy) {
                    periodCostBy = room.Hotel.PeriodCostBy;
                  }
                }
                if (!periodCostBy) periodCostBy = 'NIGHT';
                if (room !== null && room !== void 0 && (_room$Room2 = room.Room) !== null && _room$Room2 !== void 0 && _room$Room2.Checkin) {
                  periodCostBy = 'PROGRAM';
                }
                unitCostBy = void 0;
                if (cost[0]) {
                  unitCostBy = cost[0].UnitCostBy;
                }
                if (!unitCostBy) {
                  if (program && room.Hotel && room.Hotel.ProgramUnitCostBy) {
                    unitCostBy = room.Hotel.ProgramUnitCostBy;
                  }
                  if (!program && room.Hotel && room.Hotel.UnitCostBy) {
                    unitCostBy = room.Hotel.UnitCostBy;
                  }
                }
                if (!unitCostBy) unitCostBy = 'ROOM';
                quote.$PeriodCostBy.value = periodCostBy;
                quote.$UnitCostBy.value = unitCostBy;
              }
              if (updateModified == 2) {
                quote.Modified = false;
                quote.PersonCostModified = false;
                quote.PriceModified = false;
                quote.PersonPriceModified = false;
              }
              if (updateModified == 1 && !tools.isNull(roomCost.Cost)) {
                quote.Modified = false;
                quote.PriceModified = false;
                quote.PersonCostModified = false;
                quote.PersonPriceModified = false;
              }
              modified = quote.Modified || quote.PersonCostModified;
              if (!modified) {
                //si el neto no esta modificado, lo tomo del calculo
                this.setCostValues(quote, roomCost, room, days, this.QuoteBy);
              } else {
                quote.$SourceCurrencyId.value = this.CurrencyId;
                if (this.QuoteBy == 'QUANTITY') {
                  quote.$SourceCost.value = roomCost.Cost;
                } else if (this.quoteService) {
                  quote.$SourceCost.value = roomCost.Cost;
                } else {
                  //COTIZACION POR PERSONA
                  if (!daysChange) {
                    //si el costo esta modificado, tomo como base de cálculo el precio de la habitación
                    if (!quote.RoomCost) {
                      //si la habitación no tiene precio la calculo en base al neto modificado
                      quote.$RoomCost.value = parseFloat(quote.Cost) * quote.factor / (parseInt(days) * quote.qFactor);
                    } else {}
                  } else if (quote.RoomCost) {
                    quote.$Cost.value = quote.getCost();
                  }
                  quote.$SourceCost.value = quote.Cost;
                  quote.$SourceRoomCost.value = quote.RoomCost;
                }
                quote.$OriginCost.value = roomCost.OriginCost;
              }
              markup = quote.Markup || this.Markup;
              if (exchange || quote.PriceModified) {
                if (quote.Cost) {
                  //si el precio esta modificado, calculo el marckup en base al neto
                  quote.$Markup.value = tools.getMarkup(quote.Price, quote.Cost);
                } else {
                  //si no tengo neto, calculo en neto en base al Markup
                  quote.$Cost.value = tools.getCost(quote.Price, markup);
                }
              } else if (quote.Cost) {
                //si el precio no esta modificado, lo calculo en base a neto y markup
                //quote.setPrice(markup)
                quote.$Price.value = tools.getPrice(quote.Cost, markup);
              } else {
                quote.$Price.value = null;
              }
              //quote.setValues();
              if (CurrencyId && !skipCurrency && room.CurrencyId != CurrencyId) {
                //await room.setValue({ fieldName: 'CurrencyId', value: CurrencyId});
                room.$CurrencyId.value = CurrencyId;
              }
              if (cost[0] && cost[0].EstimatedCost) {
                quote.$EstimatedCost.value = true;
              } else {
                quote.$EstimatedCost.value = false;
              }
              if (this.QuoteBy == 'QUANTITY') {
                //console.log(10, unitCostBy, periodCostBy)
                pax = parseInt(this.BaseQuotes[base].ADT) + parseInt(this.BaseQuotes[base].CHD);
                if (!quote.Rooms) {
                  quote.$Rooms.value = room.Rooms;
                  if (quote.UnitCostBy == 'PERSON') {
                    quote.$Rooms.value = pax;
                  }
                }
                _markup = quote.Markup || this.Markup;
                quote.OriginCost = roomCost.OriginCost;
                quote.setTotals();
                /// fin quantity
              }
              if (this.QuoteBy == 'SERVICE') {
                _pax = parseInt(this.BaseQuotes[base].ADT);
                if (this.BaseQuotes[base].TL) _pax += this.BaseQuotes[base].TL;
                if (this.BaseQuotes[base].CHD) _pax += this.BaseQuotes[base].CHD;
                if (!quote.Rooms) {
                  if (quote.UnitCostBy == 'PERSON') {
                    quote.$Rooms.value = _pax;
                  }
                }
                if (!quote.Groups && !quote.Pax) {
                  quote.$Pax.value = _pax;
                }
                ;
                quote.OriginCost = roomCost.OriginCost;
                quote.setTotals();
              }
              _context36.next = 32;
              break;
            case 57:
              _context36.next = 17;
              break;
            case 59:
              this.setBookingTotals();
              this._requestCount += -1;
            case 61:
            case "end":
              return _context36.stop();
          }
        }, _callee36, this);
      }));
      function setHotelCost(_x56) {
        return _setHotelCost.apply(this, arguments);
      }
      return setHotelCost;
    }()
  }, {
    key: "setRoomConfig",
    value: function () {
      var _setRoomConfig = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee37(idx, roomConfiguration) {
        var bookingDayHotels;
        return regenerator_default().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              if (this.BookingDays[idx].BookingDayHotels[0]) {
                _context37.next = 6;
                break;
              }
              _context37.next = 3;
              return this.BookingDays[idx].newRowByName('BookingDayHotels');
            case 3:
              bookingDayHotels = _context37.sent;
              this.BookingDays[idx].BookingDayHotels = [];
              this.BookingDays[idx].BookingDayHotels.push(bookingDayHotels);
            case 6:
            case "end":
              return _context37.stop();
          }
        }, _callee37, this);
      }));
      function setRoomConfig(_x57, _x58) {
        return _setRoomConfig.apply(this, arguments);
      }
      return setRoomConfig;
    }()
  }, {
    key: "getHotelTotalNights",
    value: function getHotelTotalNights(hotelId) {
      var res = 0;
      var _iterator37 = _createForOfIteratorHelper(this.BookingDays),
        _step37;
      try {
        for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
          var day = _step37.value;
          if (day.BookingDayHotels[0] && day.BookingDayHotels[0].Days) {
            var found = false;
            var _iterator38 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms),
              _step38;
            try {
              for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
                var room = _step38.value;
                if (room.Hotel && room.Hotel.id == hotelId) {
                  found = true;
                }
              }
            } catch (err) {
              _iterator38.e(err);
            } finally {
              _iterator38.f();
            }
            if (found) {
              res += parseInt(day.BookingDayHotels[0].Days);
            }
          }
        }
      } catch (err) {
        _iterator37.e(err);
      } finally {
        _iterator37.f();
      }
      return res;
    }
  }, {
    key: "setPaxCountryType",
    value: function () {
      var _setPaxCountryType = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee38() {
        return regenerator_default().wrap(function _callee38$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              if (!this.FixedPrices) {
                _context38.next = 2;
                break;
              }
              return _context38.abrupt("return");
            case 2:
              _context38.next = 4;
              return this.setCostByDate({
                update: false
              });
            case 4:
            case "end":
              return _context38.stop();
          }
        }, _callee38, this);
      }));
      function setPaxCountryType() {
        return _setPaxCountryType.apply(this, arguments);
      }
      return setPaxCountryType;
    }() //refactor
  }, {
    key: "setCostByDate",
    value: function () {
      var _setCostByDate = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee39(_ref6) {
        var update, fromDayNr, toDayNr, daysNrs, updateModified, baseId, sync, supplierId, hotelId, i, day, k, p, _p, _i2, _day2, quoteDate, _iterator39, _step39, s, _iterator40, _step40, room, hotelDate, program;
        return regenerator_default().wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              update = _ref6.update, fromDayNr = _ref6.fromDayNr, toDayNr = _ref6.toDayNr, daysNrs = _ref6.daysNrs, updateModified = _ref6.updateModified, baseId = _ref6.baseId, sync = _ref6.sync, supplierId = _ref6.supplierId, hotelId = _ref6.hotelId;
              if (!update) {
                _context39.next = 26;
                break;
              }
              i = 0;
            case 3:
              if (!(i < this.BookingDays.length)) {
                _context39.next = 26;
                break;
              }
              day = this.BookingDays[i];
              if (!(fromDayNr != null && fromDayNr != undefined && day.DayNr < fromDayNr)) {
                _context39.next = 7;
                break;
              }
              return _context39.abrupt("continue", 23);
            case 7:
              if (!(toDayNr != null && toDayNr != undefined && day.DayNr > toDayNr)) {
                _context39.next = 9;
                break;
              }
              return _context39.abrupt("continue", 23);
            case 9:
              if (!(daysNrs != null && daysNrs != undefined && daysNrs.indexOf(day.DayNr) == -1)) {
                _context39.next = 11;
                break;
              }
              return _context39.abrupt("continue", 23);
            case 11:
              k = 0;
            case 12:
              if (!(k < day.BookingDayServices.length)) {
                _context39.next = 19;
                break;
              }
              _context39.next = 15;
              return day.BookingDayServices[k].updateService();
            case 15:
              p = _context39.sent;
            case 16:
              k++;
              _context39.next = 12;
              break;
            case 19:
              if (!day.BookingDayHotels[0]) {
                _context39.next = 23;
                break;
              }
              _context39.next = 22;
              return day.updateHotel();
            case 22:
              _p = _context39.sent;
            case 23:
              i++;
              _context39.next = 3;
              break;
            case 26:
              _i2 = 0;
            case 27:
              if (!(_i2 < this.BookingDays.length)) {
                _context39.next = 88;
                break;
              }
              _day2 = this.BookingDays[_i2];
              if (!(fromDayNr != null && fromDayNr != undefined && _day2.DayNr < fromDayNr)) {
                _context39.next = 31;
                break;
              }
              return _context39.abrupt("continue", 85);
            case 31:
              if (!(toDayNr != null && toDayNr != undefined && _day2.DayNr > toDayNr)) {
                _context39.next = 33;
                break;
              }
              return _context39.abrupt("continue", 85);
            case 33:
              if (!(daysNrs != null && daysNrs != undefined && daysNrs.indexOf(_day2.DayNr) == -1)) {
                _context39.next = 35;
                break;
              }
              return _context39.abrupt("continue", 85);
            case 35:
              quoteDate = _day2.TransDate;
              if (this.SplitQuoteDate && this.QuoteDate) {
                quoteDate = _day2.QuoteDate;
              }
              _iterator39 = _createForOfIteratorHelper(_day2.BookingDayServices);
              _context39.prev = 38;
              _iterator39.s();
            case 40:
              if ((_step39 = _iterator39.n()).done) {
                _context39.next = 50;
                break;
              }
              s = _step39.value;
              if (!(supplierId && s.SupplierId != supplierId)) {
                _context39.next = 44;
                break;
              }
              return _context39.abrupt("continue", 48);
            case 44:
              if (s.ServiceId) {
                _context39.next = 46;
                break;
              }
              return _context39.abrupt("continue", 48);
            case 46:
              _context39.next = 48;
              return this.getServiceCostSync({
                baseQuoteId: baseId,
                update: update,
                service: s,
                quoteDate: quoteDate,
                updateModified: updateModified,
                sync: sync
              });
            case 48:
              _context39.next = 40;
              break;
            case 50:
              _context39.next = 55;
              break;
            case 52:
              _context39.prev = 52;
              _context39.t0 = _context39["catch"](38);
              _iterator39.e(_context39.t0);
            case 55:
              _context39.prev = 55;
              _iterator39.f();
              return _context39.finish(55);
            case 58:
              if (!_day2.BookingDayHotels[0]) {
                _context39.next = 85;
                break;
              }
              _iterator40 = _createForOfIteratorHelper(_day2.BookingDayHotels[0].BookingDayRooms);
              _context39.prev = 60;
              _iterator40.s();
            case 62:
              if ((_step40 = _iterator40.n()).done) {
                _context39.next = 77;
                break;
              }
              room = _step40.value;
              if (room.Hotel) {
                _context39.next = 66;
                break;
              }
              return _context39.abrupt("continue", 75);
            case 66:
              if (!(hotelId && hotelId != room.HotelId)) {
                _context39.next = 68;
                break;
              }
              return _context39.abrupt("continue", 75);
            case 68:
              hotelDate = _day2.TransDate;
              if (this.SplitQuoteDate && this.QuoteDate) {
                hotelDate = _day2.QuoteDate;
              }
              program = void 0;
              if (room && room.Category && room.Category.Program) program = room.RoomCategory;
              if (!room.CurrencyId) {
                room.$CurrencyId.value = this.CurrencyId;
              }
              _context39.next = 75;
              return this.setHotelCostSync({
                baseId: baseId,
                idx: _i2,
                hotelId: room.Hotel.id,
                hotelDate: hotelDate,
                days: _day2.BookingDayHotels[0].Days,
                update: update,
                program: program,
                hasProgramRooms: this.hasProgramRooms(room.Hotel),
                //currencyId: room.CurrencyId,
                skipCurrency: true,
                updateModified: updateModified,
                sync: sync
              });
            case 75:
              _context39.next = 62;
              break;
            case 77:
              _context39.next = 82;
              break;
            case 79:
              _context39.prev = 79;
              _context39.t1 = _context39["catch"](60);
              _iterator40.e(_context39.t1);
            case 82:
              _context39.prev = 82;
              _iterator40.f();
              return _context39.finish(82);
            case 85:
              _i2++;
              _context39.next = 27;
              break;
            case 88:
              if (sync) {
                this.setBookingTotals();
              }
            case 89:
            case "end":
              return _context39.stop();
          }
        }, _callee39, this, [[38, 52, 55, 58], [60, 79, 82, 85]]);
      }));
      function setCostByDate(_x59) {
        return _setCostByDate.apply(this, arguments);
      }
      return setCostByDate;
    }()
  }, {
    key: "getServicePersonCostRow",
    value: function () {
      var _getServicePersonCostRow = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee40(_ref7) {
        var baseQuoteId, service, cost, costBy, quoteData, base, _iterator41, _step41, pType, obj, personQuoteQuantity, paxBase, personQuote;
        return regenerator_default().wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              baseQuoteId = _ref7.baseQuoteId, service = _ref7.service;
              if (this.StartDate) {
                _context40.next = 3;
                break;
              }
              return _context40.abrupt("return");
            case 3:
              ;
              quoteData = service.Quote;
              if (service.Service) {
                if (quoteData.CostBy) costBy = quoteData.CostBy;
                if (!costBy && service.Service.CostBy) costBy = service.Service.CostBy;
                if (!costBy && service.Service.ServiceType == 'PERSON') costBy = service.Service.ServiceType.CostBy;
                if (!costBy && service.Service.Supplier && service.Service.Supplier.PrivateCostBy) costBy = service.Service.Supplier.PrivateCostBy;
              }
              if (!costBy && service.CostPer) costBy = service.CostPer;
              if (quoteData.CurrencyId) {
                _context40.next = 10;
                break;
              }
              _context40.next = 10;
              return quoteData.setValue({
                fieldName: 'CurrencyId',
                value: this.CurrencyId
              });
            case 10:
              _context40.t0 = regenerator_default().keys(this.BaseQuotes.bases);
            case 11:
              if ((_context40.t1 = _context40.t0()).done) {
                _context40.next = 53;
                break;
              }
              base = _context40.t1.value;
              if (!(baseQuoteId != null && base != baseQuoteId)) {
                _context40.next = 15;
                break;
              }
              return _context40.abrupt("continue", 11);
            case 15:
              if (quoteData.QuoteList[base]) {
                _context40.next = 24;
                break;
              }
              _context40.next = 18;
              return quoteData.QuoteList.newServiceQuote();
            case 18:
              quoteData.QuoteList[base] = _context40.sent;
              quoteData.QuoteList.getFields();
              quoteData.QuoteList.setGroups();
              quoteData.QuoteList.setVariants();
              _context40.next = 24;
              break;
            case 24:
              _iterator41 = _createForOfIteratorHelper(this.BaseQuotes[base].paxTypes);
              _context40.prev = 25;
              _iterator41.s();
            case 27:
              if ((_step41 = _iterator41.n()).done) {
                _context40.next = 43;
                break;
              }
              pType = _step41.value;
              if (quoteData.QuoteList[base][pType]) {
                _context40.next = 41;
                break;
              }
              obj = this.setPersonQuoteQuantity(base, pType, costBy);
              personQuoteQuantity = obj.personQuoteQuantity;
              paxBase = obj.pax;
              if (!service.ServiceId) personQuoteQuantity = null;
              personQuote = this.newPersonQuote(base, quoteData, paxBase, null, service, costBy);
              if (service.Optional) personQuote.Include = false;
              _context40.next = 38;
              return quoteData.QuoteList[base].newServicePersonQuote(pType, personQuote);
            case 38:
              quoteData.QuoteList[base][pType].$Quantity.value = personQuoteQuantity;
              _context40.next = 41;
              break;
            case 41:
              _context40.next = 27;
              break;
            case 43:
              _context40.next = 48;
              break;
            case 45:
              _context40.prev = 45;
              _context40.t2 = _context40["catch"](25);
              _iterator41.e(_context40.t2);
            case 48:
              _context40.prev = 48;
              _iterator41.f();
              return _context40.finish(48);
            case 51:
              _context40.next = 11;
              break;
            case 53:
            case "end":
              return _context40.stop();
          }
        }, _callee40, this, [[25, 45, 48, 51]]);
      }));
      function getServicePersonCostRow(_x60) {
        return _getServicePersonCostRow.apply(this, arguments);
      }
      return getServicePersonCostRow;
    }()
  }, {
    key: "setPersonQuoteQuantity",
    value: function setPersonQuoteQuantity(base, pType, costBy) {
      var pax = parseInt(this.BaseQuotes[base].ADT);
      if (this.BaseQuotes[base].CHD) pax += parseInt(this.BaseQuotes[base].CHD);
      if (this.BaseQuotes[base].TL) pax += parseInt(this.BaseQuotes[base].TL);
      var personQuoteQuantity;
      if (this.QuoteBy == 'QUANTITY') {
        personQuoteQuantity = 1;
        if (costBy == 'PERSON' || costBy == 'BASE_PERSON') {
          personQuoteQuantity = pax;
        }
      }
      if (this.QuoteBy == 'SERVICE') {
        personQuoteQuantity = 1;
        if (costBy == 'PERSON' || costBy == 'BASE_PERSON') {
          pax = parseInt(this.BaseQuotes[base][pType]);
          personQuoteQuantity = pax;
        }
      }
      return {
        personQuoteQuantity: personQuoteQuantity,
        pax: pax
      };
    }
  }, {
    key: "newPersonQuote",
    value: function newPersonQuote(base, quoteData, paxBase, personQuoteQuantity, service, costBy) {
      var personQuote = {
        SourceCurrencyId: this.CurrencyId,
        Include: quoteData.Include,
        Base: paxBase,
        Quantity: personQuoteQuantity,
        CostBy: costBy,
        baseQuoteId: base
      };
      return personQuote;
    }
  }, {
    key: "getServiceCommission",
    value: function getServiceCommission(service, cost) {
      var res;
      if (service.Service.Supplier && service.Service.Supplier.CommisionPrice && service.Service.Supplier.Commision) {
        res = service.Service.Supplier.Commision;
      }
      if (service.Service.CommisionPrice && service.Service.Commision) {
        res = service.Service.Commision;
      }
      if (cost && cost.Commission) res = cost.Commission;
      return res;
    }
  }, {
    key: "getServiceCostSync",
    value: function () {
      var _getServiceCostSync = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee41(_ref8) {
        var baseQuoteId, update, service, exchange, quoteDate, updateModified, sync;
        return regenerator_default().wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              baseQuoteId = _ref8.baseQuoteId, update = _ref8.update, service = _ref8.service, exchange = _ref8.exchange, quoteDate = _ref8.quoteDate, updateModified = _ref8.updateModified, sync = _ref8.sync;
              if (!sync) {
                _context41.next = 6;
                break;
              }
              _context41.next = 4;
              return this.getServiceCost({
                baseQuoteId: baseQuoteId,
                update: update,
                service: service,
                exchange: exchange,
                quoteDate: quoteDate,
                updateModified: updateModified
              });
            case 4:
              _context41.next = 7;
              break;
            case 6:
              this.getServiceCost({
                baseQuoteId: baseQuoteId,
                update: update,
                service: service,
                exchange: exchange,
                quoteDate: quoteDate,
                updateModified: updateModified
              });
            case 7:
            case "end":
              return _context41.stop();
          }
        }, _callee41, this);
      }));
      function getServiceCostSync(_x61) {
        return _getServiceCostSync.apply(this, arguments);
      }
      return getServiceCostSync;
    }()
  }, {
    key: "getServiceCost",
    value: function () {
      var _getServiceCost = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee42(_ref9) {
        var baseQuoteId, update, service, exchange, quoteDate, updateModified, cost, costBy, tourLeader, quoteData, base, _iterator42, _step42, pType, modified, paxBase, pax, personQuoteQuantity, obj, mod, costValue, costForBase, commission, price, m;
        return regenerator_default().wrap(function _callee42$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              baseQuoteId = _ref9.baseQuoteId, update = _ref9.update, service = _ref9.service, exchange = _ref9.exchange, quoteDate = _ref9.quoteDate, updateModified = _ref9.updateModified;
              if (service.ServiceId) {
                _context42.next = 3;
                break;
              }
              return _context42.abrupt("return");
            case 3:
              if (!(Object.keys(this.BaseQuotes.bases).length == 0)) {
                _context42.next = 5;
                break;
              }
              return _context42.abrupt("return");
            case 5:
              if (this.StartDate) {
                _context42.next = 7;
                break;
              }
              return _context42.abrupt("return");
            case 7:
              //  if (!this.quoteDate) return;
              if (!this._requestCount) this._requestCount = 0;
              this._requestCount += 1;
              if (!tools.isNull(baseQuoteId)) {
                tourLeader = this.BaseQuotes[baseQuoteId].TourLeader;
              }
              if (!(service.Service && service.Service.id)) {
                _context42.next = 18;
                break;
              }
              _context42.next = 13;
              return this.getServiceCostFromState(service.Service.id, quoteDate, service.ServiceCategoryId, update, tourLeader);
            case 13:
              cost = _context42.sent;
              if (cost && cost.CostBy) costBy = cost.CostBy;
              if (!costBy && service.Service.CostBy) costBy = service.Service.CostBy;
              if (!costBy && service.Service.ServiceType == 'PERSON') costBy = service.Service.ServiceType.CostBy;
              if (!costBy && service.Service.Supplier && service.Service.Supplier.PrivateCostBy) costBy = service.Service.Supplier.PrivateCostBy;
            case 18:
              quoteData = service.Quote;
              if (quoteData.CurrencyId) {
                _context42.next = 22;
                break;
              }
              _context42.next = 22;
              return quoteData.setValue({
                fieldName: 'CurrencyId',
                value: this.CurrencyId
              });
            case 22:
              _context42.t0 = regenerator_default().keys(this.BaseQuotes.bases);
            case 23:
              if ((_context42.t1 = _context42.t0()).done) {
                _context42.next = 99;
                break;
              }
              base = _context42.t1.value;
              if (!(baseQuoteId != null && base != baseQuoteId)) {
                _context42.next = 27;
                break;
              }
              return _context42.abrupt("continue", 23);
            case 27:
              if (!(service.Service && service.Service.id && tools.isNull(baseQuoteId))) {
                _context42.next = 33;
                break;
              }
              tourLeader = this.BaseQuotes[base].TourLeader;
              if (!tourLeader) {
                _context42.next = 33;
                break;
              }
              _context42.next = 32;
              return this.getServiceCostFromState(service.Service.id, quoteDate, service.ServiceCategoryId, update, tourLeader);
            case 32:
              cost = _context42.sent;
            case 33:
              _iterator42 = _createForOfIteratorHelper(this.BaseQuotes[base].paxTypes);
              _context42.prev = 34;
              _iterator42.s();
            case 36:
              if ((_step42 = _iterator42.n()).done) {
                _context42.next = 89;
                break;
              }
              pType = _step42.value;
              if (quoteData.QuoteList[base]) {
                _context42.next = 40;
                break;
              }
              return _context42.abrupt("continue", 87);
            case 40:
              if (quoteData.QuoteList[base][pType]) {
                _context42.next = 42;
                break;
              }
              return _context42.abrupt("continue", 87);
            case 42:
              if (updateModified == 2) {
                quoteData.QuoteList[base][pType].Modified = false;
                quoteData.QuoteList[base][pType].PriceModified = false;
                quoteData.QuoteList[base][pType].PersonCostModified = false;
                quoteData.QuoteList[base][pType].PersonPriceModified = false;
              }
              if (updateModified == 1 && cost) {
                quoteData.QuoteList[base][pType].Modified = false;
                quoteData.QuoteList[base][pType].PriceModified = false;
                quoteData.QuoteList[base][pType].PersonCostModified = false;
                quoteData.QuoteList[base][pType].PersonPriceModified = false;
              }
              modified = quoteData.QuoteList[base][pType].Modified || quoteData.QuoteList[base][pType].PersonCostModified;
              if (modified) {
                _context42.next = 84;
                break;
              }
              paxBase = void 0;
              paxBase = quoteData.QuoteList[base][pType].Base;
              pax = parseInt(this.BaseQuotes[base].ADT);
              if (this.BaseQuotes[base].CHD) pax += parseInt(this.BaseQuotes[base].CHD);
              if (this.BaseQuotes[base].TL) pax += parseInt(this.BaseQuotes[base].TL);
              if (paxBase) pax = parseInt(paxBase);
              if (this.QuoteBy == 'SERVICE') {
                pax = quoteData.QuoteList[base].ADT.Base;
                if ((costBy == 'PERSON' || costBy == 'BASE_PERSON') && quoteData.QuoteList[base].CHD && quoteData.QuoteList[base].CHD.Base) {
                  pax += quoteData.QuoteList[base].CHD.Base;
                }
                if ((costBy == 'PERSON' || costBy == 'BASE_PERSON') && quoteData.QuoteList[base].TL && quoteData.QuoteList[base].TL.Base) {
                  pax += quoteData.QuoteList[base].TL.Base;
                }
              }
              if (costBy != quoteData.QuoteList[base][pType].CostBy && !quoteData.QuoteList[base][pType].CostByModified) {
                quoteData.QuoteList[base][pType].$CostBy.value = costBy;
                personQuoteQuantity = this.setPersonQuoteQuantity(base, pType, costBy).personQuoteQuantity;
                quoteData.QuoteList[base][pType].$Quantity.value = personQuoteQuantity;
                obj = this.setPersonQuoteQuantity(base, pType, costBy);
                if (costBy == 'SERVICE' || costBy == 'BASE_SERVICE' && pType == 'ADT') {
                  quoteData.QuoteList[base][pType].$Base.value = obj.pax;
                  service.$CostPer.value = 'SERVICE';
                }
              }
              ;
              if (this.QuoteBy == 'SERVICE' && (costBy == 'SERVICE' || costBy == 'BASE_SERVICE')) {
                if (!tools.isNull(quoteData.QuoteList[base].ADT.Quantity) && quoteData.QuoteList[base].ADT.Quantity > 1) {
                  mod = quoteData.QuoteList[base].ADT.Base % quoteData.QuoteList[base].ADT.Quantity;
                  if (mod == 0) pax = quoteData.QuoteList[base].ADT.Base / quoteData.QuoteList[base].ADT.Quantity;
                }
              }
              costValue = void 0;
              costForBase = void 0;
              if (cost) {
                commission = this.getServiceCommission(service, cost);
                costForBase = travelTools.getCostForBase(cost, pax, pType, commission, this.QuoteBy, service.ExtraSeat, service.ADTCostCHD, tourLeader);
                costValue = costForBase.cost;
              }
              if (tools.isNull(costValue)) {
                _context42.next = 77;
                break;
              }
              price = void 0;
              m = this.Markup;
              if (!m) m = 0;
              if (!tools.isNull(quoteData.QuoteList[base][pType].Markup)) m = quoteData.QuoteList[base][pType].Markup;
              //if (quoteData.QuoteList[base][pType].Markup) m = quoteData.QuoteList[base][pType].Markup;
              if (costValue) {
                price = tools.getPrice(costValue, m);
                //console.log(service.$parent.DayNr, service.id, costValue, price)
              }
              if (quoteData.QuoteList[base][pType].PriceModified) {
                price = quoteData.QuoteList[base][pType].Price;
              }
              _context42.next = 68;
              return quoteData.setValue({
                fieldName: 'CurrencyId',
                value: cost.CurrencyId
              });
            case 68:
              quoteData.QuoteList[base][pType].$SourceCurrencyId.value = cost.CurrencyId;
              quoteData.QuoteList[base][pType].$SourceCost.value = costValue;
              quoteData.QuoteList[base][pType].$OriginCost.value = costForBase.originCost;
              quoteData.QuoteList[base][pType].$Cost.value = this.currencyConvert(cost.CurrencyId, this.CurrencyId, costValue);
              quoteData.QuoteList[base][pType].invalid.Cost = false;
              quoteData.QuoteList[base][pType].$EstimatedCost.value = cost.EstimatedCost ? true : false;
              if (!exchange && !quoteData.QuoteList[base][pType].PriceModified) {
                quoteData.QuoteList[base][pType].$Price.value = this.currencyConvert(cost.CurrencyId, this.CurrencyId, price);
              } else {
                quoteData.QuoteList[base][pType].$Markup.value = tools.getMarkup(quoteData.QuoteList[base][pType].Price, quoteData.QuoteList[base][pType].Cost);
              }
              _context42.next = 84;
              break;
            case 77:
              quoteData.QuoteList[base][pType].$EstimatedCost.value = false;
              quoteData.QuoteList[base][pType].$SourceCurrencyId.value = null;
              quoteData.QuoteList[base][pType].$SourceCost.value = null;
              quoteData.QuoteList[base][pType].$OriginCost.value = null;
              quoteData.QuoteList[base][pType].$Cost.value = null;
              quoteData.QuoteList[base][pType].invalid.Cost = true;
              if (!exchange && !quoteData.QuoteList[base][pType].PriceModified) {
                quoteData.QuoteList[base][pType].$Price.value = null;
              }
            case 84:
              quoteData.QuoteList[base][pType].setTotals();
              quoteData.QuoteList[base][pType].calculatePersonCost();
              quoteData.QuoteList[base][pType].calculatePersonPrice();
            case 87:
              _context42.next = 36;
              break;
            case 89:
              _context42.next = 94;
              break;
            case 91:
              _context42.prev = 91;
              _context42.t2 = _context42["catch"](34);
              _iterator42.e(_context42.t2);
            case 94:
              _context42.prev = 94;
              _iterator42.f();
              return _context42.finish(94);
            case 97:
              _context42.next = 23;
              break;
            case 99:
              this.setBookingTotals();
              this._requestCount += -1;
              //console.log('getServiceCost end')
            case 101:
            case "end":
              return _context42.stop();
          }
        }, _callee42, this, [[34, 91, 94, 97]]);
      }));
      function getServiceCost(_x62) {
        return _getServiceCost.apply(this, arguments);
      }
      return getServiceCost;
    }()
  }, {
    key: "addNewDay",
    value: function () {
      var _addNewDay = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee43() {
        var day, l;
        return regenerator_default().wrap(function _callee43$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              _context43.next = 2;
              return this.newRowByName('BookingDays');
            case 2:
              day = _context43.sent;
              //if (this.BookingDays.length > 0) day.Breakfast = true;
              if (!this.SkipDays) {
                day.DayNr = this.BookingDays.length;
              } else {
                l = this.BookingDays.length;
                if (l == 0) {
                  day.DayNr = 0;
                } else {
                  day.DayNr = this.BookingDays[this.BookingDays.length - 1].DayNr + 1;
                }
              }
              if (this.StartDate) {
                day.TransDate = moment(this.StartDate, "YYYY-MM-DD").add(this.BookingDays.length, 'days').format("YYYY-MM-DD");
              }
              if (this.SplitQuoteDate && this.QuoteDate) {
                day.QuoteDate = moment(this.QuoteDate, "YYYY-MM-DD").add(this.BookingDays.length, 'days').format("YYYY-MM-DD");
              }
              this.BookingDays.push(day);
              return _context43.abrupt("return", day);
            case 8:
            case "end":
              return _context43.stop();
          }
        }, _callee43, this);
      }));
      function addNewDay() {
        return _addNewDay.apply(this, arguments);
      }
      return addNewDay;
    }()
  }, {
    key: "insertDayAtBeginning",
    value: function () {
      var _insertDayAtBeginning = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee44() {
        var i;
        return regenerator_default().wrap(function _callee44$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              if (this.isBooking) {
                this.$StartDate.value = moment(this.StartDate, "YYYY-MM-DD").add(-1, 'days').format("YYYY-MM-DD");
                if (this.QuoteDate) {
                  this.$QuoteDate.value = moment(this.QuoteDate, "YYYY-MM-DD").add(-1, 'days').format("YYYY-MM-DD");
                }
              }
              _context44.next = 3;
              return this.insertNewDay(0);
            case 3:
              for (i = 1; i < this.BookingDays.length; i++) {
                this.BookingDays[i].DayNr += 1;
              }
            case 4:
            case "end":
              return _context44.stop();
          }
        }, _callee44, this);
      }));
      function insertDayAtBeginning() {
        return _insertDayAtBeginning.apply(this, arguments);
      }
      return insertDayAtBeginning;
    }()
  }, {
    key: "insertNewDay",
    value: function () {
      var _insertNewDay = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee45(dayNr) {
        var day;
        return regenerator_default().wrap(function _callee45$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              _context45.next = 2;
              return this.newRowByName('BookingDays');
            case 2:
              day = _context45.sent;
              // if (dayNr > 0) day.Breakfast = true;
              day.DayNr = dayNr;
              if (this.StartDate) {
                day.TransDate = moment(this.StartDate, "YYYY-MM-DD").add(dayNr, 'days').format("YYYY-MM-DD");
              }
              if (this.SplitQuoteDate && this.QuoteDate) {
                day.QuoteDate = moment(this.QuoteDate, "YYYY-MM-DD").add(dayNr, 'days').format("YYYY-MM-DD");
              }
              this.BookingDays.splice(dayNr, 0, day);
              return _context45.abrupt("return", day);
            case 8:
            case "end":
              return _context45.stop();
          }
        }, _callee45, this);
      }));
      function insertNewDay(_x63) {
        return _insertNewDay.apply(this, arguments);
      }
      return insertNewDay;
    }()
  }, {
    key: "removeDay",
    value: function () {
      var _removeDay = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee46(i) {
        var dayNr;
        return regenerator_default().wrap(function _callee46$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              dayNr = this.BookingDays[i].DayNr;
              this.removeRow({
                fieldName: 'BookingDays',
                rowNr: i
              });
              this.refactorDayNr(dayNr);
              _context46.next = 5;
              return this.changeDate(dayNr, false);
            case 5:
              _context46.next = 7;
              return this.changeQuoteDates(dayNr, false);
            case 7:
              this.setDaysByHotel();
              _context46.next = 10;
              return this.setCostByDate({
                update: false,
                fromDayNr: dayNr
              });
            case 10:
              this.clearCache();
              this.setBookingTotals();
            case 12:
            case "end":
              return _context46.stop();
          }
        }, _callee46, this);
      }));
      function removeDay(_x64) {
        return _removeDay.apply(this, arguments);
      }
      return removeDay;
    }()
  }, {
    key: "daysByHotel",
    value: function () {
      var _daysByHotel = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee47() {
        var hotelIds, promises, _iterator43, _step43, id, p;
        return regenerator_default().wrap(function _callee47$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              hotelIds = this.setDaysByHotel();
              promises = [];
              _iterator43 = _createForOfIteratorHelper(hotelIds);
              try {
                for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
                  id = _step43.value;
                  p = this.setHotelCostById({
                    hotelId: id
                  });
                  promises.push(p);
                }
              } catch (err) {
                _iterator43.e(err);
              } finally {
                _iterator43.f();
              }
              _context47.next = 6;
              return Promise.all(promises);
            case 6:
            case "end":
              return _context47.stop();
          }
        }, _callee47, this);
      }));
      function daysByHotel() {
        return _daysByHotel.apply(this, arguments);
      }
      return daysByHotel;
    }() //recalcDayByHotel
  }, {
    key: "setDaysByHotel",
    value: function setDaysByHotel() {
      var _this3 = this;
      var res = [];
      var _iterator44 = _createForOfIteratorHelper(this.BookingDays),
        _step44;
      try {
        var _loop = function _loop() {
          var day = _step44.value;
          if (day.PaxHotel) {
            var nextDay = _.find(_this3.BookingDays, function (r) {
              return parseInt(r.DayNr) == parseInt(day.DayNr + 1);
            });
            if (nextDay) {
              nextDay.Breakfast = false;
            }
          }
          if (day.BookingDayHotels[0]) {
            var originDays = day.BookingDayHotels[0].Days;
            var maxDays = _this3.countHotelDays(day.DayNr);
            if (day.BookingDayHotels[0].Days > maxDays) {
              day.BookingDayHotels[0].Days = maxDays;
            }
            day.BookingDayHotels[0].setHotelDates();
            if (day.BookingDayHotels[0].Days != originDays) {
              var _iterator46 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms),
                _step46;
              try {
                for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
                  var room = _step46.value;
                  if (!room.HotelId) continue;
                  if (res.indexOf(room.HotelId) == -1) {
                    res.push(room.HotelId);
                  }
                }
              } catch (err) {
                _iterator46.e(err);
              } finally {
                _iterator46.f();
              }
            }
          }
        };
        for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator44.e(err);
      } finally {
        _iterator44.f();
      }
      var maxDayNr = this.BookingDays.length - 1;
      if (this.SkipDays) {
        var lastDay = this.BookingDays[this.BookingDays.length - 1];
        maxDayNr = lastDay.DayNr;
      }
      var _iterator45 = _createForOfIteratorHelper(this.BookingDays),
        _step45;
      try {
        for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
          var day = _step45.value;
          if (day.DayNr >= maxDayNr) {
            day.BookingDayHotels = [];
          }
        }
      } catch (err) {
        _iterator45.e(err);
      } finally {
        _iterator45.f();
      }
      return res;
    }
  }, {
    key: "countHotelDays",
    value: function countHotelDays(dayNr) {
      var cnt = 1;
      var days = this.BookingDays;
      var maxDayNr = this.BookingDays[days.length - 1].DayNr;
      for (var i = dayNr + 1; i <= maxDayNr; i++) {
        var day = this.hotelsByDay[i];
        var _day = this.getDay(i);
        if (!_day) {
          return cnt;
        }
        if (day && day.firstDay) {
          return cnt;
        }
        if (i == maxDayNr) {
          return cnt;
        }
        cnt += 1;
      }
      return cnt;
    }
  }, {
    key: "setHotelCostById",
    value: function () {
      var _setHotelCostById = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee48(_ref10) {
        var hotelId, exchange, skipCurrency, daysChange, sync, newRoom, tempId, roomNr, dayNr, baseId, i, day, j, _day$BookingDayHotels, room, hotelDate, program;
        return regenerator_default().wrap(function _callee48$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              hotelId = _ref10.hotelId, exchange = _ref10.exchange, skipCurrency = _ref10.skipCurrency, daysChange = _ref10.daysChange, sync = _ref10.sync, newRoom = _ref10.newRoom, tempId = _ref10.tempId, roomNr = _ref10.roomNr, dayNr = _ref10.dayNr, baseId = _ref10.baseId;
              if (!(Object.keys(this.BaseQuotes.bases).length == 0)) {
                _context48.next = 3;
                break;
              }
              return _context48.abrupt("return");
            case 3:
              i = 0;
            case 4:
              if (!(i < this.BookingDays.length)) {
                _context48.next = 40;
                break;
              }
              day = this.BookingDays[i];
              if (!(dayNr !== undefined && dayNr != day.DayNr)) {
                _context48.next = 8;
                break;
              }
              return _context48.abrupt("continue", 37);
            case 8:
              if (!day.BookingDayHotels[0]) {
                _context48.next = 37;
                break;
              }
              _context48.t0 = regenerator_default().keys(day.BookingDayHotels[0].BookingDayRooms);
            case 10:
              if ((_context48.t1 = _context48.t0()).done) {
                _context48.next = 37;
                break;
              }
              j = _context48.t1.value;
              room = day === null || day === void 0 || (_day$BookingDayHotels = day.BookingDayHotels) === null || _day$BookingDayHotels === void 0 || (_day$BookingDayHotels = _day$BookingDayHotels[0]) === null || _day$BookingDayHotels === void 0 || (_day$BookingDayHotels = _day$BookingDayHotels.BookingDayRooms) === null || _day$BookingDayHotels === void 0 ? void 0 : _day$BookingDayHotels[j];
              if (room) {
                _context48.next = 15;
                break;
              }
              return _context48.abrupt("continue", 10);
            case 15:
              if (!(roomNr !== undefined && roomNr != j)) {
                _context48.next = 17;
                break;
              }
              return _context48.abrupt("continue", 10);
            case 17:
              if (!(this.bookingConfirmed && newRoom && room.id)) {
                _context48.next = 19;
                break;
              }
              return _context48.abrupt("continue", 10);
            case 19:
              if (!(this.bookingConfirmed && newRoom && room.tempId != tempId)) {
                _context48.next = 21;
                break;
              }
              return _context48.abrupt("continue", 10);
            case 21:
              if (room.Hotel) {
                _context48.next = 23;
                break;
              }
              return _context48.abrupt("continue", 10);
            case 23:
              if (room.RoomTypeId) {
                _context48.next = 25;
                break;
              }
              return _context48.abrupt("continue", 10);
            case 25:
              if (room.RoomCategory) {
                _context48.next = 27;
                break;
              }
              return _context48.abrupt("continue", 10);
            case 27:
              if (!(room.Hotel.id == hotelId)) {
                _context48.next = 35;
                break;
              }
              hotelDate = day.TransDate;
              if (this.SplitQuoteDate && this.QuoteDate) {
                hotelDate = day.QuoteDate;
              }
              program = void 0;
              if (room && room.Category && room.Category.Program) program = room.RoomCategory;
              if (!room.CurrencyId) {
                room.$CurrencyId.value = this.CurrencyId;
              }
              _context48.next = 35;
              return this.setHotelCostSync({
                idx: i,
                hotelId: room.Hotel.id,
                hotelDate: hotelDate,
                days: day.BookingDayHotels[0].Days,
                roomNr: roomNr,
                update: false,
                exchange: room.exchange,
                baseId: baseId,
                program: program,
                hasProgramRooms: this.hasProgramRooms(room.Hotel),
                //currencyId: room.CurrencyId,
                skipCurrency: skipCurrency,
                daysChange: daysChange,
                sync: sync
              });
            case 35:
              _context48.next = 10;
              break;
            case 37:
              i++;
              _context48.next = 4;
              break;
            case 40:
            case "end":
              return _context48.stop();
          }
        }, _callee48, this);
      }));
      function setHotelCostById(_x65) {
        return _setHotelCostById.apply(this, arguments);
      }
      return setHotelCostById;
    }()
  }, {
    key: "quoteService",
    get: function get() {
      return this.QuoteBy == 'SERVICE';
    }
  }, {
    key: "bases",
    get: function get() {
      return tools.getBases(_.cloneDeep(this.BaseQuotes));
    }
  }, {
    key: "currencyRates",
    get: function get() {
      return tools.getBases(_.cloneDeep(this.CurrencyRates));
    }
  }, {
    key: "getDay",
    value: function getDay(dayNr) {
      var day = _.find(this.BookingDays, function (c) {
        return c.DayNr == dayNr;
      });
      if (day) return day;
    }
  }, {
    key: "getDayIndex",
    value: function getDayIndex(dayNr) {
      return _.findIndex(this.BookingDays, function (c) {
        return c.DayNr == dayNr;
      });
    }
  }, {
    key: "addServices",
    value: function () {
      var _addServices = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee49(records, changeService, dayNr, currentService) {
        var services, day, _iterator47, _step47, s, dayId;
        return regenerator_default().wrap(function _callee49$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              services = records;
              if (changeService) {
                services = [records[0]];
              }
              day = this.getDay(dayNr);
              _iterator47 = _createForOfIteratorHelper(services);
              _context49.prev = 4;
              _iterator47.s();
            case 6:
              if ((_step47 = _iterator47.n()).done) {
                _context49.next = 12;
                break;
              }
              s = _step47.value;
              _context49.next = 10;
              return day.setServiceToDay({
                record: s,
                include: true,
                changeService: changeService,
                currentService: currentService
              });
            case 10:
              _context49.next = 6;
              break;
            case 12:
              _context49.next = 17;
              break;
            case 14:
              _context49.prev = 14;
              _context49.t0 = _context49["catch"](4);
              _iterator47.e(_context49.t0);
            case 17:
              _context49.prev = 17;
              _iterator47.f();
              return _context49.finish(17);
            case 20:
              day.setTitle();
              dayId = this.getDayIndex(dayNr);
            case 22:
            case "end":
              return _context49.stop();
          }
        }, _callee49, this, [[4, 14, 17, 20]]);
      }));
      function addServices(_x66, _x67, _x68, _x69) {
        return _addServices.apply(this, arguments);
      }
      return addServices;
    }()
  }, {
    key: "addTemplateServices",
    value: function () {
      var _addTemplateServices = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee50(template, n, insertDays) {
        var i, dayNr, _i3, _i4, _dayNr, day, templateDay;
        return regenerator_default().wrap(function _callee50$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              if (!insertDays) {
                _context50.next = 15;
                break;
              }
              _context50.t0 = regenerator_default().keys(template.BookingDays);
            case 2:
              if ((_context50.t1 = _context50.t0()).done) {
                _context50.next = 9;
                break;
              }
              i = _context50.t1.value;
              dayNr = parseInt(n) + parseInt(i);
              _context50.next = 7;
              return this.insertNewDay(dayNr);
            case 7:
              _context50.next = 2;
              break;
            case 9:
              for (_i3 = n; _i3 < this.BookingDays.length; _i3++) {
                if (!this.SkipDays) {
                  this.BookingDays[_i3].DayNr = _i3;
                } else {
                  /*let l = this.BookingDays.length;
                  if (l == 0) {
                      day.DayNr = 0;
                  } else {
                      day.DayNr = this.BookingDays[this.BookingDays.length-1].DayNr + 1;
                  }*/
                }
              }
              if (!this.StartDate) {
                _context50.next = 15;
                break;
              }
              _context50.next = 13;
              return this.changeDate();
            case 13:
              _context50.next = 15;
              return this.changeQuoteDates();
            case 15:
              _context50.t2 = regenerator_default().keys(template.BookingDays);
            case 16:
              if ((_context50.t3 = _context50.t2()).done) {
                _context50.next = 31;
                break;
              }
              _i4 = _context50.t3.value;
              _dayNr = parseInt(n) + parseInt(_i4);
              day = this.getDay(_dayNr);
              if (day) {
                _context50.next = 24;
                break;
              }
              _context50.next = 23;
              return this.addNewDay();
            case 23:
              day = this.getDay(_dayNr);
            case 24:
              templateDay = template.BookingDays[_i4];
              if (!day) {
                _context50.next = 29;
                break;
              }
              day.BookingDayServices.sort(function (a, b) {
                return a.OrderNr - b.OrderNr;
              });
              _context50.next = 29;
              return this.addTemplateDay(templateDay, day, template.TemplateKeepText);
            case 29:
              _context50.next = 16;
              break;
            case 31:
            case "end":
              return _context50.stop();
          }
        }, _callee50, this);
      }));
      function addTemplateServices(_x70, _x71, _x72) {
        return _addTemplateServices.apply(this, arguments);
      }
      return addTemplateServices;
    }()
  }, {
    key: "addServiceFromTemplate",
    value: function () {
      var _addServiceFromTemplate = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee51(s, newDay, templateKeepText, day) {
        var service, _iterator48, _step48, _loop2;
        return regenerator_default().wrap(function _callee51$(_context52) {
          while (1) switch (_context52.prev = _context52.next) {
            case 0:
              if (!(s.Service && s.Service.id)) {
                _context52.next = 8;
                break;
              }
              if (s.ServiceCategoryId) {
                s.Service.ServiceCategoryId = s.ServiceCategoryId;
              }
              _context52.next = 4;
              return newDay.setServiceToDay({
                record: s.Service,
                include: s.Quote.Include,
                isTemplate: true
              });
            case 4:
              service = _context52.sent;
              if (templateKeepText) {
                service.Description = s.Description;
                service.Name = s.Name;
                service.CityId = s.CityId;
              }
              _context52.next = 26;
              break;
            case 8:
              _context52.next = 10;
              return newDay.addBlankService();
            case 10:
              service = _context52.sent;
              if (!service) {
                _context52.next = 26;
                break;
              }
              service.Description = s.Description;
              service.Name = s.Name;
              service.Breakfast = s.Breakfast;
              service.Snack = s.Snack;
              service.BoxLunch = s.BoxLunch;
              service.Dinner = s.Dinner;
              service.Lunch = s.Lunch;
              service.EntranceIncluded = s.EntranceIncluded;
              if (!s.SupplierId) {
                _context52.next = 23;
                break;
              }
              _context52.next = 23;
              return service.setValue({
                fieldName: 'SupplierId',
                value: s.SupplierId
              });
            case 23:
              if (!s.CityId) {
                _context52.next = 26;
                break;
              }
              _context52.next = 26;
              return service.setValue({
                fieldName: 'CityId',
                value: s.CityId
              });
            case 26:
              if (service) {
                _context52.next = 28;
                break;
              }
              return _context52.abrupt("return");
            case 28:
              if (s.Optional) {
                service.Optional = true;
                newDay.ShowOptionals = true;
              }
              ;
              _iterator48 = _createForOfIteratorHelper(s.BookingDayServiceImages);
              _context52.prev = 31;
              _loop2 = /*#__PURE__*/regenerator_default().mark(function _loop2() {
                var image, found, img;
                return regenerator_default().wrap(function _loop2$(_context51) {
                  while (1) switch (_context51.prev = _context51.next) {
                    case 0:
                      image = _step48.value;
                      found = _.find(service.BookingDayServiceImages, function (r) {
                        return r.ImageId == image.ImageId;
                      });
                      if (image.ImageId == day.ImageId) found = true;
                      if (found) {
                        _context51.next = 10;
                        break;
                      }
                      _context51.next = 6;
                      return service.newRowByName('BookingDayServiceImages');
                    case 6:
                      img = _context51.sent;
                      _context51.next = 9;
                      return img.setValue({
                        fieldName: 'ImageId',
                        value: image.ImageId
                      });
                    case 9:
                      service.BookingDayServiceImages.push(img);
                    case 10:
                    case "end":
                      return _context51.stop();
                  }
                }, _loop2);
              });
              _iterator48.s();
            case 34:
              if ((_step48 = _iterator48.n()).done) {
                _context52.next = 38;
                break;
              }
              return _context52.delegateYield(_loop2(), "t0", 36);
            case 36:
              _context52.next = 34;
              break;
            case 38:
              _context52.next = 43;
              break;
            case 40:
              _context52.prev = 40;
              _context52.t1 = _context52["catch"](31);
              _iterator48.e(_context52.t1);
            case 43:
              _context52.prev = 43;
              _iterator48.f();
              return _context52.finish(43);
            case 46:
              return _context52.abrupt("return", service);
            case 47:
            case "end":
              return _context52.stop();
          }
        }, _callee51, null, [[31, 40, 43, 46]]);
      }));
      function addServiceFromTemplate(_x73, _x74, _x75, _x76) {
        return _addServiceFromTemplate.apply(this, arguments);
      }
      return addServiceFromTemplate;
    }()
  }, {
    key: "addTemplateDay",
    value: function () {
      var _addTemplateDay = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee52(day, newDay, templateKeepText) {
        var quoteDate, days, _iterator49, _step49, s, found, hotels, _iterator50, _step50, room;
        return regenerator_default().wrap(function _callee52$(_context53) {
          while (1) switch (_context53.prev = _context53.next) {
            case 0:
              quoteDate = newDay.TransDate;
              if (day.GroupDays) {
                newDay.GroupDays = day.GroupDays;
                days = day.GroupDayTo - day.DayNr;
                newDay.GroupDayTo = newDay.DayNr + days;
              }
              if (this.SplitQuoteDate && this.QuoteDate && day.QuoteDate) {
                quoteDate = day.QuoteDate;
              }
              day.BookingDayServices.sort(function (a, b) {
                return a.OrderNr - b.OrderNr;
              });
              _iterator49 = _createForOfIteratorHelper(day.BookingDayServices);
              _context53.prev = 5;
              _iterator49.s();
            case 7:
              if ((_step49 = _iterator49.n()).done) {
                _context53.next = 14;
                break;
              }
              s = _step49.value;
              if (!(s.Service && s.Service.Closed)) {
                _context53.next = 11;
                break;
              }
              return _context53.abrupt("continue", 12);
            case 11:
              this.addServiceFromTemplate(s, newDay, templateKeepText, day);
            case 12:
              _context53.next = 7;
              break;
            case 14:
              _context53.next = 19;
              break;
            case 16:
              _context53.prev = 16;
              _context53.t0 = _context53["catch"](5);
              _iterator49.e(_context53.t0);
            case 19:
              _context53.prev = 19;
              _iterator49.f();
              return _context53.finish(19);
            case 22:
              if (day.ImageId && !newDay.ImageId) {
                found = _.find(day.BookingDayServices, function (s) {
                  return _.find(s.BookingDayServiceImages, function (i) {
                    i.Image = day.ImageId;
                  });
                });
                if (!found) {
                  newDay.ImageId = day.ImageId;
                }
              }
              if (!day.BookingDayHotels[0]) {
                _context53.next = 30;
                break;
              }
              _context53.next = 26;
              return newDay.newRowByName('BookingDayHotels', day.BookingDayHotels[0]);
            case 26:
              hotels = _context53.sent;
              newDay.BookingDayHotels = [];
              newDay.BookingDayHotels.push(hotels);
              if (newDay.BookingDayHotels[0]) {
                _iterator50 = _createForOfIteratorHelper(newDay.BookingDayHotels[0].BookingDayRooms);
                try {
                  for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
                    room = _step50.value;
                    room.tempId = (0,v1/* default */.A)();
                    room.CreatedUTC = null;
                    room.CreatedUserId = null;
                    room.id = null;
                    room.tempId = (0,v1/* default */.A)();
                    room.BookingDayHotelId = null;
                    room.Status = 'PENDING';
                    room.ReservationNumber = null;
                    if (room.HotelId && room.Hotel && room.Hotel.Closed) {
                      room.HotelId = null;
                    } else if (room.HotelId && room.RoomTypeId && room.RoomCategory) {
                      room.updateCost({});
                    }
                  }
                } catch (err) {
                  _iterator50.e(err);
                } finally {
                  _iterator50.f();
                }
              }
            case 30:
              newDay.sortServices();
              if (templateKeepText) {
                newDay.Title = day.Title;
              } else {
                newDay.setTitle();
              }
            case 32:
            case "end":
              return _context53.stop();
          }
        }, _callee52, this, [[5, 16, 19, 22]]);
      }));
      function addTemplateDay(_x77, _x78, _x79) {
        return _addTemplateDay.apply(this, arguments);
      }
      return addTemplateDay;
    }()
  }, {
    key: "addTemplate",
    value: function () {
      var _addTemplate = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee53(records) {
        var _iterator51, _step51, record, _iterator52, _step52, day, newDay;
        return regenerator_default().wrap(function _callee53$(_context54) {
          while (1) switch (_context54.prev = _context54.next) {
            case 0:
              _iterator51 = _createForOfIteratorHelper(records);
              _context54.prev = 1;
              _iterator51.s();
            case 3:
              if ((_step51 = _iterator51.n()).done) {
                _context54.next = 27;
                break;
              }
              record = _step51.value;
              _iterator52 = _createForOfIteratorHelper(record.BookingDays);
              _context54.prev = 6;
              _iterator52.s();
            case 8:
              if ((_step52 = _iterator52.n()).done) {
                _context54.next = 17;
                break;
              }
              day = _step52.value;
              _context54.next = 12;
              return this.addNewDay();
            case 12:
              newDay = _context54.sent;
              _context54.next = 15;
              return this.addTemplateDay(day, newDay, record.TemplateKeepText);
            case 15:
              _context54.next = 8;
              break;
            case 17:
              _context54.next = 22;
              break;
            case 19:
              _context54.prev = 19;
              _context54.t0 = _context54["catch"](6);
              _iterator52.e(_context54.t0);
            case 22:
              _context54.prev = 22;
              _iterator52.f();
              return _context54.finish(22);
            case 25:
              _context54.next = 3;
              break;
            case 27:
              _context54.next = 32;
              break;
            case 29:
              _context54.prev = 29;
              _context54.t1 = _context54["catch"](1);
              _iterator51.e(_context54.t1);
            case 32:
              _context54.prev = 32;
              _iterator51.f();
              return _context54.finish(32);
            case 35:
            case "end":
              return _context54.stop();
          }
        }, _callee53, this, [[1, 29, 32, 35], [6, 19, 22, 25]]);
      }));
      function addTemplate(_x80) {
        return _addTemplate.apply(this, arguments);
      }
      return addTemplate;
    }()
  }, {
    key: "sortDays",
    value: function sortDays() {
      this.BookingDays.sort(function (a, b) {
        return a.DayNr - b.DayNr;
      });
    }
  }, {
    key: "insertService",
    value: function () {
      var _insertService = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee54(indexInsert, newDayIdx, service) {
        var s;
        return regenerator_default().wrap(function _callee54$(_context55) {
          while (1) switch (_context55.prev = _context55.next) {
            case 0:
              _context55.next = 2;
              return api.getObjectFromStore('service', service.id);
            case 2:
              s = _context55.sent;
              if (!(s && this.BookingDays[newDayIdx])) {
                _context55.next = 7;
                break;
              }
              if (service.ServiceCategoryId) s.ServiceCategoryId = service.ServiceCategoryId;
              _context55.next = 7;
              return this.BookingDays[newDayIdx].setServiceToDay({
                record: s,
                include: true,
                index: indexInsert
              });
            case 7:
            case "end":
              return _context55.stop();
          }
        }, _callee54, this);
      }));
      function insertService(_x81, _x82, _x83) {
        return _insertService.apply(this, arguments);
      }
      return insertService;
    }()
  }, {
    key: "switchServiceDay",
    value: function () {
      var _switchServiceDay = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee55(indexInsert, oldDayIdx, newDayIdx, serviceId, exchange) {
        var service, idx, _iterator53, _step53, image, quoteDate;
        return regenerator_default().wrap(function _callee55$(_context56) {
          while (1) switch (_context56.prev = _context56.next) {
            case 0:
              service = _.find(this.BookingDays[oldDayIdx].BookingDayServices, function (c) {
                return c.id == serviceId || c.tempId == serviceId;
              });
              if (service) {
                _context56.next = 3;
                break;
              }
              return _context56.abrupt("return");
            case 3:
              idx = _.findIndex(this.BookingDays[oldDayIdx].BookingDayServices, function (c) {
                return c.id == serviceId || c.tempId == serviceId;
              }); //console.log(service, indexInsert, oldDayIdx, newDayIdx, serviceId)
              service.setParent(this.BookingDays[oldDayIdx]);
              service.BookingDayId = null;
              service.id = null;
              service.setOrderNr(indexInsert);
              service.tempId = (0,v1/* default */.A)();
              service.ServiceDate = this.BookingDays[newDayIdx].TransDate;
              if (this.SplitQuoteDate && this.QuoteDate) {
                service.QuoteDate = this.BookingDays[newDayIdx].QuoteDate;
              }
              _iterator53 = _createForOfIteratorHelper(service.BookingDayServiceImages);
              try {
                for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
                  image = _step53.value;
                  image.id = null;
                  image.BookingDayServiceId = null;
                }
              } catch (err) {
                _iterator53.e(err);
              } finally {
                _iterator53.f();
              }
              if (!service.Service) {
                _context56.next = 34;
                break;
              }
              if (service.Service.EntranceIncluded) this.BookingDays[newDayIdx].EntranceIncluded = true;
              if (service.Service.Breakfast && !service.Breakfast) this.BookingDays[newDayIdx].Breakfast = true;
              if (service.Service.BoxLunch && !service.BoxLunch) this.BookingDays[newDayIdx].BoxLunch = true;
              if (service.Service.VoucherDisabled && !service.VoucherDisabled) this.BookingDays[newDayIdx].VoucherDisabled = true;
              if (service.Service.Lunch && !service.Lunch) this.BookingDays[newDayIdx].Lunch = true;
              if (service.Service.Dinner && !service.Dinner) this.BookingDays[newDayIdx].Dinner = true;
              if (service.Service.Snack && !service.Snack) this.BookingDays[newDayIdx].Snack = true;
              if (!(service.Service.ImageId && !this.BookingDays[newDayIdx].ImageId)) {
                _context56.next = 24;
                break;
              }
              _context56.next = 24;
              return this.BookingDays[newDayIdx].setDayImage(service.Service);
            case 24:
              if (service.Service.EntranceIncluded) this.BookingDays[oldDayIdx].EntranceIncluded = false;
              //cambiar mas adelante

              if (service.Service.Breakfast) this.BookingDays[oldDayIdx].Breakfast = false;
              if (service.Service.BoxLunch) this.BookingDays[oldDayIdx].BoxLunch = false;
              if (service.Service.VoucherDisabled) this.BookingDays[oldDayIdx].VoucherDisabled = false;
              if (service.Service.Lunch) this.BookingDays[oldDayIdx].Lunch = false;
              if (service.Service.Dinner) this.BookingDays[oldDayIdx].Dinner = false;
              if (service.Service.Snack) this.BookingDays[oldDayIdx].Snack = false;
              if (!(service.Service.ImageId && this.BookingDays[oldDayIdx].ImageId == service.Service.ImageId)) {
                _context56.next = 34;
                break;
              }
              _context56.next = 34;
              return this.BookingDays[oldDayIdx].setDayImage(null);
            case 34:
              this.BookingDays[newDayIdx].BookingDayServices.splice(indexInsert, 0, service);
              this.BookingDays[newDayIdx].setServicesOrderNr();
              if (idx > -1) this.BookingDays[oldDayIdx].removeService(idx, true);
              this.BookingDays[newDayIdx].sortServices();
              this.BookingDays[oldDayIdx].sortServices();
              this.BookingDays[newDayIdx].setTitle();
              this.BookingDays[oldDayIdx].setTitle();
              quoteDate = this.BookingDays[newDayIdx].TransDate;
              if (this.SplitQuoteDate && this.QuoteDate && this.BookingDays[newDayIdx].QuoteDate) {
                quoteDate = this.BookingDays[newDayIdx].QuoteDate;
              }
              _context56.next = 45;
              return this.getServiceCost({
                service: service,
                quoteDate: quoteDate,
                exchange: exchange
              });
            case 45:
            case "end":
              return _context56.stop();
          }
        }, _callee55, this);
      }));
      function switchServiceDay(_x84, _x85, _x86, _x87, _x88) {
        return _switchServiceDay.apply(this, arguments);
      }
      return switchServiceDay;
    }()
  }, {
    key: "cityList",
    get: function get() {
      var res = {};
      var lastCityId;
      var lastDayNr = {};
      var cnt;
      var _iterator54 = _createForOfIteratorHelper(this.BookingDays),
        _step54;
      try {
        for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
          var day = _step54.value;
          var _iterator55 = _createForOfIteratorHelper(day.BookingDayServices),
            _step55;
          try {
            for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
              var service = _step55.value;
              var _cityId = service.CityId;
              var _City = service.City;
              if (!_cityId && service.Service && service.Service.CityId) {
                _cityId = service.Service.CityId;
                _City = service.Service.City;
              }
              if (_cityId) {
                if (!lastCityId || _cityId != lastCityId || lastDayNr[_cityId] && day.DayNr > parseInt(lastDayNr[_cityId]) + 1) {
                  cnt = Object.keys(res).length;
                  res[cnt] = {
                    City: _City,
                    DayNrs: [day.DayNr]
                  };
                }
                lastCityId = _cityId;
                lastDayNr[_cityId] = day.DayNr;
              }
              if (!res[cnt]) res[cnt] = {
                City: _City,
                DayNrs: [day.DayNr]
              };
              if (res[cnt].DayNrs.indexOf(day.DayNr) == -1) {
                res[cnt].DayNrs.push(day.DayNr);
              }
            }
          } catch (err) {
            _iterator55.e(err);
          } finally {
            _iterator55.f();
          }
          if (this.hotelsByDay[day.DayNr] && this.hotelsByDay[day.DayNr].City) {
            var cityId = this.hotelsByDay[day.DayNr].City.id;
            var City = this.hotelsByDay[day.DayNr].City;
            if (cityId) {
              if (!lastCityId || cityId != lastCityId || lastDayNr[cityId] && day.DayNr > parseInt(lastDayNr[cityId]) + 1) {
                cnt = Object.keys(res).length;
                res[cnt] = {
                  City: City,
                  DayNrs: [day.DayNr]
                };
              }
              lastCityId = cityId;
              lastDayNr[cityId] = day.DayNr;
            }
            if (!res[cnt]) res[cnt] = {
              City: City,
              DayNrs: [day.DayNr]
            };
            if (res[cnt].DayNrs.indexOf(day.DayNr) == -1) {
              res[cnt].DayNrs.push(day.DayNr);
            }
          }
        }
      } catch (err) {
        _iterator54.e(err);
      } finally {
        _iterator54.f();
      }
      return res;
    }
  }, {
    key: "firstDayByView",
    get: function get() {
      var _iterator56 = _createForOfIteratorHelper(this.BookingDays),
        _step56;
      try {
        for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
          var day = _step56.value;
          var _iterator57 = _createForOfIteratorHelper(day.BookingDayServices),
            _step57;
          try {
            for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
              var s = _step57.value;
              if (s.Quote.QuoteList[this.ViewMode]) {
                var _iterator59 = _createForOfIteratorHelper(s.Quote.QuoteList[this.ViewMode].paxTypes),
                  _step59;
                try {
                  for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
                    var paxType = _step59.value;
                    if (s.Quote.QuoteList[this.ViewMode][paxType] && s.Quote.QuoteList[this.ViewMode][paxType].Include) {
                      return day;
                    }
                  }
                } catch (err) {
                  _iterator59.e(err);
                } finally {
                  _iterator59.f();
                }
              }
            }
          } catch (err) {
            _iterator57.e(err);
          } finally {
            _iterator57.f();
          }
          if (day.BookingDayHotels[0]) {
            var _iterator58 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms),
              _step58;
            try {
              for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
                var room = _step58.value;
                if (room.QuoteList[this.ViewMode] && room.QuoteList[this.ViewMode].Include) {
                  return day;
                }
              }
            } catch (err) {
              _iterator58.e(err);
            } finally {
              _iterator58.f();
            }
          }
        }
      } catch (err) {
        _iterator56.e(err);
      } finally {
        _iterator56.f();
      }
    }
  }, {
    key: "lastDayByView",
    get: function get() {
      var res;
      var _iterator60 = _createForOfIteratorHelper(this.BookingDays),
        _step60;
      try {
        for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
          var day = _step60.value;
          var _iterator61 = _createForOfIteratorHelper(day.BookingDayServices),
            _step61;
          try {
            for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
              var s = _step61.value;
              if (s.Quote.QuoteList[this.ViewMode]) {
                var _iterator63 = _createForOfIteratorHelper(s.Quote.QuoteList[this.ViewMode].paxTypes),
                  _step63;
                try {
                  for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
                    var paxType = _step63.value;
                    if (s.Quote.QuoteList[this.ViewMode][paxType] && s.Quote.QuoteList[this.ViewMode][paxType].Include) {
                      if (!day) res = day;
                      if (res && day.TransDate > res.TransDate) res = day;
                    }
                  }
                } catch (err) {
                  _iterator63.e(err);
                } finally {
                  _iterator63.f();
                }
              }
            }
          } catch (err) {
            _iterator61.e(err);
          } finally {
            _iterator61.f();
          }
          if (day.BookingDayHotels[0]) {
            var _iterator62 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms),
              _step62;
            try {
              for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
                var room = _step62.value;
                if (room.QuoteList[this.ViewMode] && room.QuoteList[this.ViewMode].Include) {
                  var dayNr = day.DayNr + day.BookingDayHotels[0].Days - 1;
                  res = this.BookingDays[dayNr];
                }
              }
            } catch (err) {
              _iterator62.e(err);
            } finally {
              _iterator62.f();
            }
          }
        }
      } catch (err) {
        _iterator60.e(err);
      } finally {
        _iterator60.f();
      }
      return res;
    }
  }, {
    key: "bookingDaysLength",
    get: function get() {
      if (this.ViewMode == -1) return this.daysLength;
      var firstDay = this.firstDayByView;
      var lastDay = this.lastDayByView;
      return lastDay.DayNr - firstDay.DayNr + 1;
    }
  }, {
    key: "objectList",
    get: function get() {
      var _this4 = this;
      var res = [];
      var _iterator64 = _createForOfIteratorHelper(this.BookingDays),
        _step64;
      try {
        for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
          var day = _step64.value;
          var _iterator65 = _createForOfIteratorHelper(day.BookingDayServices),
            _step65;
          try {
            for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
              var service = _step65.value;
              var cityId = service.CityId;
              var City = service.City;
              if (!cityId && service.Service && service.Service.CityId) {
                cityId = service.Service.CityId;
                City = service.Service.City;
              }
              res.push({
                dayNr: day.DayNr,
                name: service.serviceName,
                type: 'SERVICE',
                city: City,
                nr: res.length,
                id: service.id || service.tempId,
                service: service
              });
            }
          } catch (err) {
            _iterator65.e(err);
          } finally {
            _iterator65.f();
          }
          if (day.BookingDayHotels[0]) {
            var city = void 0;
            var hotels = {};
            var _iterator66 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms),
              _step66;
            try {
              for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
                var room = _step66.value;
                if (!hotels[room.HotelId]) {
                  hotels[room.HotelId] = room.Hotel.Name;
                  city = room.Hotel.City;
                }
              }
            } catch (err) {
              _iterator66.e(err);
            } finally {
              _iterator66.f();
            }
            var hotelNames = [];
            for (var h in hotels) {
              hotelNames.push(hotels[h]);
            }
            if (hotelNames.length > 0) {
              res.push({
                dayNr: day.DayNr,
                name: hotelNames.join('; '),
                type: 'HOTEL',
                city: city,
                nr: res.length,
                hotel: day.BookingDayHotels[0]
              });
            }
          }
        }
      } catch (err) {
        _iterator64.e(err);
      } finally {
        _iterator64.f();
      }
      var objects = [];
      var cnt = 0;
      var lastCityId;
      for (var _i5 = 0, _res4 = res; _i5 < _res4.length; _i5++) {
        var o = _res4[_i5];
        if (!o.city) continue;
        //console.log(lastCityId, o.city.id)
        if (lastCityId && o.city.id != lastCityId) {
          cnt += 1;
        }
        objects.push({
          nr: o.nr,
          dayNr: o.dayNr,
          cityName: o.city.Name,
          city: o.city,
          type: o.type,
          name: o.name,
          cityNr: cnt,
          service: o.service,
          hotel: o.hotel
        });
        lastCityId = o.city.id;
      }
      var _loop3 = function _loop3() {
        var o = _objects[_i6];
        if (o.type != 'SERVICE') return 1; // continue
        if (_this4.cityList[o.cityNr + 1]) {
          var found = _.find(_this4.cityList[o.cityNr + 1].DayNrs, function (d) {
            return d == o.dayNr;
          });
          if (found != undefined) {
            o.sharedDay = true;
          }
        }
      };
      for (var _i6 = 0, _objects = objects; _i6 < _objects.length; _i6++) {
        if (_loop3()) continue;
      }
      return objects;
    }
  }, {
    key: "imageServiceLinks",
    get: function get() {
      var res = {};
      var _iterator67 = _createForOfIteratorHelper(this.BookingDays),
        _step67;
      try {
        for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
          var day = _step67.value;
          if (!day.Image) continue;
          if (!day.Image.url) continue;
          var found = false;
          var serviceId = void 0;
          var serviceName = void 0;
          var sId = void 0;
          var _iterator68 = _createForOfIteratorHelper(day.BookingDayServices),
            _step68;
          try {
            for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
              var s = _step68.value;
              if (res[day.DayNr]) continue;
              if (s.Service && s.Service.id) {
                serviceId = s.Service.id;
              } else if (s.id) {
                sId = s.id;
              } else if (s.Name) {
                serviceName = s.Name;
              }
              if (s.Service && s.Service.Image && s.Service.Image.url == day.Image.url) {
                res[day.DayNr] = {
                  serviceId: serviceId,
                  serviceName: serviceName,
                  sId: sId,
                  Image: day.Image,
                  ImageId: day.ImageId
                };
                found = true;
                break;
              }
            }
          } catch (err) {
            _iterator68.e(err);
          } finally {
            _iterator68.f();
          }
        }
      } catch (err) {
        _iterator67.e(err);
      } finally {
        _iterator67.f();
      }
      return res;
    }
  }, {
    key: "switchCities",
    value: function () {
      var _switchCities = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee56(a, b) {
        var newCityOrder, cityList, i;
        return regenerator_default().wrap(function _callee56$(_context57) {
          while (1) switch (_context57.prev = _context57.next) {
            case 0:
              newCityOrder = {};
              cityList = this.cityList;
              for (i in cityList) {
                newCityOrder[i] = {
                  name: cityList[i].City.Name,
                  from: parseInt(i),
                  to: parseInt(i)
                };
              }
              newCityOrder[a].to = b;
              newCityOrder[b].to = a;
              _context57.next = 7;
              return this.moveDays(a, b, newCityOrder);
            case 7:
            case "end":
              return _context57.stop();
          }
        }, _callee56, this);
      }));
      function switchCities(_x89, _x90) {
        return _switchCities.apply(this, arguments);
      }
      return switchCities;
    }()
  }, {
    key: "moveDays",
    value: function () {
      var _moveDays = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee57(moveFrom, moveTo, newCityOrder) {
        var _this5 = this;
        var toDelete, toInsert, toInsertAfter, hotelsDelete, hotelsInsert, newCityOrderList, imageServiceLinks, i, objectList, newDayNr, lastDayNr, lastShared, objectCnt, toMove, _loop4, _i7, _newCityOrderList, daysMoved, _i8, _toMove, o, day, moveBefore, _iterator70, _step70, _loop6, _i9, _daysMoved, dayNr, _day3, _iterator71, _step71, _day4, _iterator72, _step72, hotel, _iterator73, _step73, service, dayFrom, dayTo;
        return regenerator_default().wrap(function _callee57$(_context61) {
          while (1) switch (_context61.prev = _context61.next) {
            case 0:
              toDelete = {};
              toInsert = {};
              toInsertAfter = {};
              hotelsDelete = {};
              hotelsInsert = {};
              newCityOrderList = [];
              imageServiceLinks = Object.assign({}, this.imageServiceLinks);
              for (i in newCityOrder) {
                newCityOrderList.push(newCityOrder[i]);
              }
              newCityOrderList.sort(function (a, b) {
                return a.to - b.to;
              });
              //console.log(newCityOrderList)
              //self.objectList;
              objectList = Object.assign([], this.objectList);
              newDayNr = 0;
              lastShared = false;
              objectCnt = 0;
              toMove = [];
              _loop4 = /*#__PURE__*/regenerator_default().mark(function _loop4() {
                var c, services, _iterator69, _step69, _loop5;
                return regenerator_default().wrap(function _loop4$(_context59) {
                  while (1) switch (_context59.prev = _context59.next) {
                    case 0:
                      c = _newCityOrderList[_i7];
                      services = _.filter(objectList, function (r) {
                        return c.from == r.cityNr;
                      });
                      _iterator69 = _createForOfIteratorHelper(services);
                      _context59.prev = 3;
                      _loop5 = /*#__PURE__*/regenerator_default().mark(function _loop5() {
                        var o, day, idx;
                        return regenerator_default().wrap(function _loop5$(_context58) {
                          while (1) switch (_context58.prev = _context58.next) {
                            case 0:
                              o = _step69.value;
                              if (lastDayNr != undefined && lastDayNr != o.dayNr && !lastShared && o.dayNr > 0) {
                                newDayNr += 1;
                              }
                              if (o.dayNr != newDayNr || objectCnt != o.nr) {
                                toMove.push({
                                  from: o.dayNr,
                                  to: newDayNr,
                                  orderFrom: o.nr,
                                  orderTo: objectCnt,
                                  type: o.type,
                                  service: o.service,
                                  hotel: o.hotel,
                                  name: o.name,
                                  sharedDay: o.sharedDay
                                });
                                day = _.find(_this5.BookingDays, function (c) {
                                  return c.DayNr == o.dayNr;
                                });
                                if (day) {
                                  if (o.type == 'SERVICE') {
                                    idx = _.findIndex(day.BookingDayServices, function (r) {
                                      if (o.service && o.service.id && r.id == o.service.id) return true;
                                      if (o.service && o.service.tempId && r.tempId == o.service.tempId) return true;
                                    });
                                    day.setOrderNr(-1, idx + 1);
                                    if (o.service.Service) {
                                      day.setBookingDayOptionsFalse(o.service.Service);
                                    }
                                    if (day.BookingDayServices[idx]) {
                                      day.BookingDayServices.splice(idx, 1);
                                    }
                                  } else {
                                    day.BookingDayHotels = [];
                                  }
                                }
                              }
                              objectCnt += 1;
                              lastDayNr = o.dayNr;
                              lastShared = o.sharedDay;
                            case 6:
                            case "end":
                              return _context58.stop();
                          }
                        }, _loop5);
                      });
                      _iterator69.s();
                    case 6:
                      if ((_step69 = _iterator69.n()).done) {
                        _context59.next = 10;
                        break;
                      }
                      return _context59.delegateYield(_loop5(), "t0", 8);
                    case 8:
                      _context59.next = 6;
                      break;
                    case 10:
                      _context59.next = 15;
                      break;
                    case 12:
                      _context59.prev = 12;
                      _context59.t1 = _context59["catch"](3);
                      _iterator69.e(_context59.t1);
                    case 15:
                      _context59.prev = 15;
                      _iterator69.f();
                      return _context59.finish(15);
                    case 18:
                    case "end":
                      return _context59.stop();
                  }
                }, _loop4, null, [[3, 12, 15, 18]]);
              });
              _i7 = 0, _newCityOrderList = newCityOrderList;
            case 16:
              if (!(_i7 < _newCityOrderList.length)) {
                _context61.next = 21;
                break;
              }
              return _context61.delegateYield(_loop4(), "t0", 18);
            case 18:
              _i7++;
              _context61.next = 16;
              break;
            case 21:
              daysMoved = [];
              _i8 = 0, _toMove = toMove;
            case 23:
              if (!(_i8 < _toMove.length)) {
                _context61.next = 59;
                break;
              }
              o = _toMove[_i8];
              //console.log('move from ', o.from, 'to', o.to, 'from', o.orderFrom, 'to', o.orderTo, o.type, o.name);
              if (o.from != o.to && daysMoved.indexOf(o.to) == -1) {
                daysMoved.push(o.to);
              }
              day = this.getDay(o.to); //console.log(443, o.to, day)
              if (!day) {
                _context61.next = 56;
                break;
              }
              if (!(o.type == 'SERVICE')) {
                _context61.next = 54;
                break;
              }
              moveBefore = false; //console.log('Moving', o.sharedDay)
              if (!o.sharedDay) {
                _context61.next = 49;
                break;
              }
              _iterator70 = _createForOfIteratorHelper(day.BookingDayServices);
              _context61.prev = 32;
              _loop6 = /*#__PURE__*/regenerator_default().mark(function _loop6() {
                var firstService, s;
                return regenerator_default().wrap(function _loop6$(_context60) {
                  while (1) switch (_context60.prev = _context60.next) {
                    case 0:
                      firstService = _step70.value;
                      s = _.find(objectList, function (r) {
                        if (r.service && r.service.id && firstService.id == r.service.id) return true;
                        if (r.name && firstService.Name == r.name) return true;
                      });
                      if (!s) {
                        _context60.next = 6;
                        break;
                      }
                      if (!(s.nr > o.orderTo && !moveBefore)) {
                        _context60.next = 6;
                        break;
                      }
                      moveBefore = s.service.id || s.service.tempId;
                      return _context60.abrupt("return", 1);
                    case 6:
                    case "end":
                      return _context60.stop();
                  }
                }, _loop6);
              });
              _iterator70.s();
            case 35:
              if ((_step70 = _iterator70.n()).done) {
                _context61.next = 41;
                break;
              }
              return _context61.delegateYield(_loop6(), "t1", 37);
            case 37:
              if (!_context61.t1) {
                _context61.next = 39;
                break;
              }
              return _context61.abrupt("break", 41);
            case 39:
              _context61.next = 35;
              break;
            case 41:
              _context61.next = 46;
              break;
            case 43:
              _context61.prev = 43;
              _context61.t2 = _context61["catch"](32);
              _iterator70.e(_context61.t2);
            case 46:
              _context61.prev = 46;
              _iterator70.f();
              return _context61.finish(46);
            case 49:
              _context61.next = 51;
              return day.moveServiceToDay(o.service, moveBefore);
            case 51:
              if (o.service.Service) {
                day.setBookingDayOptions(o.service);
              }
              //day.setTitle(false, true);
              _context61.next = 56;
              break;
            case 54:
              _context61.next = 56;
              return day.moveHotelToDay(o.hotel);
            case 56:
              _i8++;
              _context61.next = 23;
              break;
            case 59:
              for (_i9 = 0, _daysMoved = daysMoved; _i9 < _daysMoved.length; _i9++) {
                dayNr = _daysMoved[_i9];
                _day3 = this.getDay(dayNr);
                if (_day3) _day3.setTitle(false, true);
              }
              this.moveImages(imageServiceLinks, daysMoved);
              this.setDaysByHotel();
              _iterator71 = _createForOfIteratorHelper(this.BookingDays);
              try {
                for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
                  _day4 = _step71.value;
                  _iterator72 = _createForOfIteratorHelper(_day4.BookingDayHotels);
                  try {
                    for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
                      hotel = _step72.value;
                      hotel.setParent(_day4);
                    }
                  } catch (err) {
                    _iterator72.e(err);
                  } finally {
                    _iterator72.f();
                  }
                  _iterator73 = _createForOfIteratorHelper(_day4.BookingDayServices);
                  try {
                    for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
                      service = _step73.value;
                      service.setParent(_day4);
                    }
                  } catch (err) {
                    _iterator73.e(err);
                  } finally {
                    _iterator73.f();
                  }
                }
              } catch (err) {
                _iterator71.e(err);
              } finally {
                _iterator71.f();
              }
              if (daysMoved.length > 0) {
                dayFrom = Math.min.apply(Math, daysMoved);
                dayTo = Math.max.apply(Math, daysMoved);
              }
              _context61.next = 67;
              return this.setCostByDate({
                update: false,
                fromDayNr: dayFrom,
                toDayNr: dayTo
              });
            case 67:
            case "end":
              return _context61.stop();
          }
        }, _callee57, this, [[32, 43, 46, 49]]);
      }));
      function moveDays(_x91, _x92, _x93) {
        return _moveDays.apply(this, arguments);
      }
      return moveDays;
    }()
  }, {
    key: "removeImage",
    value: function removeImage(dayNr, data, daysMoved) {
      var _iterator74 = _createForOfIteratorHelper(this.BookingDays),
        _step74;
      try {
        for (_iterator74.s(); !(_step74 = _iterator74.n()).done;) {
          var day = _step74.value;
          if (daysMoved.indexOf(day.DayNr) == -1) continue;
          if (day.DayNr == dayNr) {
            if (day.Image && data.Image) {
              if (day.Image.url == data.Image.url) {
                day.ImageId = null;
                day.Image = null;
              }
            }
          }
        }
      } catch (err) {
        _iterator74.e(err);
      } finally {
        _iterator74.f();
      }
    }
  }, {
    key: "moveImage",
    value: function moveImage(data, daysMoved) {
      var _iterator75 = _createForOfIteratorHelper(this.BookingDays),
        _step75;
      try {
        for (_iterator75.s(); !(_step75 = _iterator75.n()).done;) {
          var day = _step75.value;
          if (daysMoved.indexOf(day.DayNr) == -1) continue;
          var _iterator76 = _createForOfIteratorHelper(day.BookingDayServices),
            _step76;
          try {
            for (_iterator76.s(); !(_step76 = _iterator76.n()).done;) {
              var s = _step76.value;
              var serviceId = void 0;
              var serviceName = void 0;
              var sId = void 0;
              if (s.Service && s.Service.id) {
                serviceId = s.Service.id;
              }
              if (s.id) {
                sId = s.id;
              }
              if (s.Name) {
                serviceName = s.Name;
              }
              if (data.serviceId && serviceId == data.serviceId) {
                day.ImageId = data.ImageId;
                day.Image = data.Image;
              }
              if (data.sId && sId == data.sId) {
                day.ImageId = data.ImageId;
                day.Image = data.Image;
              }
              if (data.serviceName && serviceName == data.serviceName) {
                day.ImageId = data.ImageId;
                day.Image = data.Image;
              }
            }
          } catch (err) {
            _iterator76.e(err);
          } finally {
            _iterator76.f();
          }
        }
      } catch (err) {
        _iterator75.e(err);
      } finally {
        _iterator75.f();
      }
    }
  }, {
    key: "moveImages",
    value: function moveImages(imageServiceLinks, daysMoved) {
      for (var imageDayNr in imageServiceLinks) {
        this.removeImage(imageDayNr, imageServiceLinks[imageDayNr], daysMoved);
      }
      for (var _imageDayNr in imageServiceLinks) {
        this.moveImage(imageServiceLinks[_imageDayNr], daysMoved);
      }
      this.setDaysByHotel();
    }
  }, {
    key: "getServicesByDayCity",
    value: function getServicesByDayCity(dayNr, cityId) {
      var res = [];
      var day = this.getDay(dayNr);
      if (!day) return res;
      var _iterator77 = _createForOfIteratorHelper(day.BookingDayServices),
        _step77;
      try {
        for (_iterator77.s(); !(_step77 = _iterator77.n()).done;) {
          var service = _step77.value;
          var id = service.CityId;
          if (!id && service.Service && service.Service.CityId) id = service.Service.CityId;
          if (id == cityId) {
            res.push(service);
          }
        }
      } catch (err) {
        _iterator77.e(err);
      } finally {
        _iterator77.f();
      }
      return res;
    }
  }, {
    key: "getServicesNamesByDayCity",
    value: function getServicesNamesByDayCity(dayNr, cityId) {
      var services = this.getServicesByDayCity(dayNr, cityId);
      var res = [];
      var _iterator78 = _createForOfIteratorHelper(services),
        _step78;
      try {
        for (_iterator78.s(); !(_step78 = _iterator78.n()).done;) {
          var service = _step78.value;
          var serviceName = service.Name;
          if (!serviceName && service.Service && service.Service.Name) {
            serviceName = service.Service.Name;
          }
          if (serviceName) {
            res.push(serviceName);
          }
        }
      } catch (err) {
        _iterator78.e(err);
      } finally {
        _iterator78.f();
      }
      var day = _.find(this.BookingDays, function (c) {
        return c.DayNr == dayNr;
      });
      if (day && day.BookingDayHotels[0] && day.BookingDayHotels[0].BookingDayRooms[0] && day.BookingDayHotels[0].BookingDayRooms[0].Hotel && day.BookingDayHotels[0].BookingDayRooms[0].Hotel.CityId == cityId) {
        res.push('HOTEL: ' + day.BookingDayHotels[0].BookingDayRooms[0].Hotel.Name + ' ' + day.BookingDayHotels[0].Days + ' noches');
      }
      return res.join(', ');
    }
  }, {
    key: "cityOrder",
    get: function get() {
      var res = [];
      var cityList = this.cityList;
      for (var i in cityList) {
        res.push({
          name: cityList[i].City.Name,
          id: cityList[i].City.id
        });
      }
      return res;
    }
  }, {
    key: "cityOrderNames",
    get: function get() {
      return _.map(this.cityOrder, function (c) {
        return c.name;
      });
    }
  }, {
    key: "hasChild",
    value: function hasChild(baseId) {
      if (this.BaseQuotes && this.BaseQuotes[baseId] && this.BaseQuotes[baseId].CHD > 0) return true;
      return false;
    }
  }, {
    key: "hasTL",
    value: function hasTL(baseId) {
      var _this$BaseQuotes2;
      if (((_this$BaseQuotes2 = this.BaseQuotes) === null || _this$BaseQuotes2 === void 0 || (_this$BaseQuotes2 = _this$BaseQuotes2[baseId]) === null || _this$BaseQuotes2 === void 0 ? void 0 : _this$BaseQuotes2.TL) > 0) return true;
      return false;
    }
  }, {
    key: "hasExtraBed",
    get: function get() {
      var _iterator79 = _createForOfIteratorHelper(this.BookingDays),
        _step79;
      try {
        for (_iterator79.s(); !(_step79 = _iterator79.n()).done;) {
          var day = _step79.value;
          if (day.BookingDayHotels[0] && day.BookingDayHotels[0].BookingDayRooms) {
            var _iterator80 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms),
              _step80;
            try {
              for (_iterator80.s(); !(_step80 = _iterator80.n()).done;) {
                var room = _step80.value;
                if (room.Room && room.Room.ExtraBed) return true;
              }
            } catch (err) {
              _iterator80.e(err);
            } finally {
              _iterator80.f();
            }
          }
        }
      } catch (err) {
        _iterator79.e(err);
      } finally {
        _iterator79.f();
      }
      return false;
    }
  }, {
    key: "roomTypesObjects",
    get: function get() {
      var roomTypes = api.tables.roomtype;
      var res = {};
      if (!roomTypes) return res;
      var _iterator81 = _createForOfIteratorHelper(this.BookingDays),
        _step81;
      try {
        for (_iterator81.s(); !(_step81 = _iterator81.n()).done;) {
          var day = _step81.value;
          if (day.BookingDayHotels[0] && day.BookingDayHotels[0].BookingDayRooms) {
            var _iterator82 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms),
              _step82;
            try {
              var _loop7 = function _loop7() {
                var room = _step82.value;
                var roomType = _.find(roomTypes, function (c) {
                  return c.id == room.RoomTypeId;
                });
                if (roomType && !res[roomType.id]) {
                  res[roomType.id] = {
                    id: roomType.id,
                    Pax: roomType.Pax,
                    Name: roomType.Name
                  };
                }
              };
              for (_iterator82.s(); !(_step82 = _iterator82.n()).done;) {
                _loop7();
              }
            } catch (err) {
              _iterator82.e(err);
            } finally {
              _iterator82.f();
            }
          }
        }
      } catch (err) {
        _iterator81.e(err);
      } finally {
        _iterator81.f();
      }
      return res;
    }
  }, {
    key: "totalsServices",
    get: function get() {
      if (this._cache && this._cache.totalsServices) {
        return this._cachedTotalsServices;
      }
      ;
      if (this._cache) this._cache.totalsServices = true;
      var res = {};
      var _iterator83 = _createForOfIteratorHelper(this.BookingDays),
        _step83;
      try {
        for (_iterator83.s(); !(_step83 = _iterator83.n()).done;) {
          var day = _step83.value;
          var _iterator84 = _createForOfIteratorHelper(day.BookingDayServices),
            _step84;
          try {
            for (_iterator84.s(); !(_step84 = _iterator84.n()).done;) {
              var s = _step84.value;
              //if (s.Status == 'CANCELED') continue;
              if (s.skipQuoteCanceled) continue;
              if (s.Quote && s.Quote.QuoteList) {
                for (var baseId in this.BaseQuotes.bases) {
                  if (!res[baseId]) res[baseId] = {};
                  var _iterator85 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
                    _step85;
                  try {
                    for (_iterator85.s(); !(_step85 = _iterator85.n()).done;) {
                      var pType = _step85.value;
                      if (!this.quoteService) {
                        if (!res[baseId][pType]) {
                          res[baseId][pType] = {
                            Cost: 0,
                            Price: 0
                          };
                        }
                        if (!s.Quote.QuoteList[baseId]) continue;
                        if (!s.Quote.QuoteList[baseId][pType]) continue;
                        if (!s.Quote.QuoteList[baseId][pType].Include) continue;
                        //if (!this.isQuoteSelected(baseId, pType)) continue;
                        if (!this.variantSelected(baseId, pType, s.Quote.QuoteList[baseId])) continue;
                        var q = 1;
                        s.Quote.QuoteList[baseId][pType].Markup; //to force recalculate
                        if (this.QuoteBy == 'QUANTITY') {
                          res[baseId][pType].Cost += parseFloat(s.Quote.QuoteList[baseId][pType]._TotalCost);
                          res[baseId][pType].Price += parseFloat(s.Quote.QuoteList[baseId][pType]._TotalPrice);
                        } else {
                          if (q && s.Quote.QuoteList[baseId] && s.Quote.QuoteList[baseId][pType] && s.Quote.QuoteList[baseId][pType].Cost) {
                            res[baseId][pType].Cost += parseFloat(s.Quote.QuoteList[baseId][pType].Cost || 0) * q;
                          }
                          if (q && s.Quote.QuoteList[baseId] && s.Quote.QuoteList[baseId][pType] && s.Quote.QuoteList[baseId][pType].Price) {
                            res[baseId][pType].Price += parseFloat(s.Quote.QuoteList[baseId][pType].Price || 0) * q;
                          }
                        }
                      } else {
                        var _s$Quote$QuoteList;
                        var pax = this.BaseQuotes[baseId][pType] || 0;
                        if (!res[baseId][pType]) {
                          res[baseId][pType] = {
                            Cost: 0,
                            //sum of total cost of services .TotalCost
                            Price: 0,
                            //sum of total price of services .TotalPrice
                            Rooms: null,
                            PersonCost: 0,
                            //sum of person cost .PersonCost
                            PersonPrice: 0,
                            //sum of person cost .PersonPrice
                            //TotalPersonCost: 0, //sum of total person cost .TotalPersonCost
                            //TotalPersonPrice: 0, //sum of total person cost .TotalPersonPrice
                            SumPersonCost: 0,
                            //sum of total cost of services / pax
                            SumPersonPrice: 0 //sum of total price of services / cost
                          };
                        }
                        var paxType = pType;
                        var isService = false;
                        //if (s.CostPer == 'SERVICE') isService = true;
                        //if (s.Service && s.Service.CostBy == 'SERVICE') isService = true;
                        //if (s.Service && s.Service.CostBy == 'BASE_SERVICE') isService = true;
                        if (s.costPer == 'SERVICE') isService = true;
                        if ((_s$Quote$QuoteList = s.Quote.QuoteList) !== null && _s$Quote$QuoteList !== void 0 && (_s$Quote$QuoteList = _s$Quote$QuoteList[baseId]) !== null && _s$Quote$QuoteList !== void 0 && (_s$Quote$QuoteList = _s$Quote$QuoteList[pType]) !== null && _s$Quote$QuoteList !== void 0 && _s$Quote$QuoteList.CostByModified) {
                          var _s$Quote$QuoteList2;
                          if (((_s$Quote$QuoteList2 = s.Quote.QuoteList) === null || _s$Quote$QuoteList2 === void 0 || (_s$Quote$QuoteList2 = _s$Quote$QuoteList2[baseId]) === null || _s$Quote$QuoteList2 === void 0 || (_s$Quote$QuoteList2 = _s$Quote$QuoteList2[pType]) === null || _s$Quote$QuoteList2 === void 0 ? void 0 : _s$Quote$QuoteList2.CostBy) == 'SERVICE') {
                            isService = true;
                          } else {
                            isService = false;
                          }
                        }
                        if (isService) paxType = 'ADT';
                        if (!s.Quote.QuoteList[baseId]) continue;
                        if (!s.Quote.QuoteList[baseId][paxType]) continue;
                        if (!s.Quote.QuoteList[baseId][paxType].Include) continue;
                        //if (!this.isQuoteSelected(baseId, pType)) continue;
                        if (!this.variantSelected(baseId, pType, s.Quote.QuoteList[baseId])) continue;
                        var _q = 1;
                        s.Quote.QuoteList[baseId][paxType].Markup; //to force recalculate
                        _q = parseFloat(s.Quote.QuoteList[baseId][paxType].Quantity || 1);
                        if (_q && s.Quote.QuoteList[baseId][paxType].Cost) {
                          if (!isService) {
                            var v = parseFloat(s.Quote.QuoteList[baseId][pType]._TotalCost || 0);
                            res[baseId][pType].Cost += v;
                            res[baseId][pType].PersonCost += parseFloat(s.Quote.QuoteList[baseId][pType]._TotalCost || 0) / this.BaseQuotes[baseId][pType];
                          } else {
                            if (s.Quote.QuoteList[baseId].ADT && s.Quote.QuoteList[baseId].ADT.Cost) {
                              var _v = parseFloat(s.Quote.QuoteList[baseId].ADT._TotalCost || 0) / this.BaseQuotes[baseId].paxQuantity * this.BaseQuotes[baseId][pType];
                              res[baseId][pType].Cost += _v;
                              res[baseId][pType].PersonCost += parseFloat(s.Quote.QuoteList[baseId].ADT._TotalCost || 0) / this.BaseQuotes[baseId].paxQuantity;
                            }
                          }
                        }
                        if (s.Quote.QuoteList[baseId][paxType].Price) {
                          if (!isService) {
                            res[baseId][pType].Price += parseFloat(s.Quote.QuoteList[baseId][pType]._TotalPrice || 0);
                            res[baseId][pType].PersonPrice += parseFloat(s.Quote.QuoteList[baseId][pType]._TotalPrice || 0) / this.BaseQuotes[baseId][pType];
                          } else {
                            if (s.Quote.QuoteList[baseId].ADT && s.Quote.QuoteList[baseId].ADT.Price) {
                              var _v2 = parseFloat(s.Quote.QuoteList[baseId].ADT._TotalPrice || 0) / this.BaseQuotes[baseId].paxQuantity * this.BaseQuotes[baseId][pType];
                              res[baseId][pType].Price += _v2;
                              res[baseId][pType].PersonPrice += parseFloat(s.Quote.QuoteList[baseId].ADT._TotalPrice || 0) / this.BaseQuotes[baseId].paxQuantity;
                            }
                          }
                        }
                      }
                    }
                  } catch (err) {
                    _iterator85.e(err);
                  } finally {
                    _iterator85.f();
                  }
                }
              }
            }
          } catch (err) {
            _iterator84.e(err);
          } finally {
            _iterator84.f();
          }
        }
      } catch (err) {
        _iterator83.e(err);
      } finally {
        _iterator83.f();
      }
      this._cachedTotalsServices = res;
      return res;
    }
  }, {
    key: "variantSelected",
    value: function variantSelected(baseId, pType, quote) {
      if (!this.isVariant(baseId)) return true;
      if (!this.QuoteVariants[baseId]) return true;
      for (var variantId in this.QuoteVariants[baseId]) {
        if (this.QuoteVariants[baseId][variantId].Selected[pType]) {
          if (!quote.Variants) continue;
          if (quote.Variants[variantId]) return true;
        }
      }
      return false;
    }
  }, {
    key: "sumVariant",
    value: function sumVariant(baseId) {
      this.forceVariantGetters = !this.forceVariantGetters;
    }
  }, {
    key: "priceByChild",
    value: function priceByChild(baseId, room, pType, day) {
      //if (this.hasChild(baseId) && room.Room && room.Room.ExtraBed && pType=='ADT') continue;
      //if (day.BookingDayHotels[0].extraBed && room.Room && !room.Room.ExtraBed && pType=='CHD') continue;
    }
  }, {
    key: "bookingRooms",
    get: function get() {
      var res = {};
      var _iterator86 = _createForOfIteratorHelper(this.BookingDays),
        _step86;
      try {
        for (_iterator86.s(); !(_step86 = _iterator86.n()).done;) {
          var day = _step86.value;
          if (day.BookingDayHotels[0]) {
            if (day.BookingDayHotels[0].BookingDayRooms) {
              var _iterator87 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms),
                _step87;
              try {
                for (_iterator87.s(); !(_step87 = _iterator87.n()).done;) {
                  var room = _step87.value;
                  if (room.QuoteList) {
                    for (var baseId in this.BaseQuotes.bases) {
                      if (!room.QuoteList[baseId]) continue;
                      if (!room.QuoteList[baseId].Include) continue;
                      var _iterator88 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
                        _step88;
                      try {
                        for (_iterator88.s(); !(_step88 = _iterator88.n()).done;) {
                          var pType = _step88.value;
                          if (this.priceByChild(baseId, room, pType, day)) continue;
                          //if (this.hasChild(baseId) && room.Room && room.Room.ExtraBed && pType=='ADT') continue;
                          //if (day.BookingDayHotels[0].extraBed && room.Room && !room.Room.ExtraBed && pType=='CHD') continue;
                          if (room.Room && room.Room.id && !res[room.Room.id]) {
                            res[room.Room.id] = room.Room;
                          }
                        }
                      } catch (err) {
                        _iterator88.e(err);
                      } finally {
                        _iterator88.f();
                      }
                    }
                  }
                }
              } catch (err) {
                _iterator87.e(err);
              } finally {
                _iterator87.f();
              }
            }
          }
        }
      } catch (err) {
        _iterator86.e(err);
      } finally {
        _iterator86.f();
      }
      return res;
    }
  }, {
    key: "totalsHotels",
    get: function get() {
      if (this._cache && this._cache.totalsHotels) {
        return this._cachedTotalsHotels;
      }
      ;
      if (this._cache) this._cache.totalsHotels = true;
      //console.log('$$_totalsHotels')
      var res = {};
      this.forceHotelGetters;
      var _iterator89 = _createForOfIteratorHelper(this.BookingDays),
        _step89;
      try {
        for (_iterator89.s(); !(_step89 = _iterator89.n()).done;) {
          var day = _step89.value;
          if (day.BookingDayHotels[0]) {
            if (day.BookingDayHotels[0].BookingDayRooms) {
              var _iterator90 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms),
                _step90;
              try {
                for (_iterator90.s(); !(_step90 = _iterator90.n()).done;) {
                  var room = _step90.value;
                  if (room.QuoteList) {
                    for (var baseId in this.BaseQuotes.bases) {
                      //if (room.Status == 'CANCELED') continue;
                      if (room.skipQuoteCanceled) continue;
                      if (!room.QuoteList[baseId]) continue;
                      if (!room.QuoteList[baseId].Include) continue;
                      if (!res[baseId]) res[baseId] = {};
                      var _iterator91 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
                        _step91;
                      try {
                        for (_iterator91.s(); !(_step91 = _iterator91.n()).done;) {
                          var pType = _step91.value;
                          if (!this.variantSelected(baseId, pType, room.QuoteList[baseId])) continue;
                          if (!this.quoteService) {
                            if (this.priceByChild(baseId, room, pType, day)) continue;
                            //if (this.hasChild(baseId) && room.Room && room.Room.ExtraBed && pType=='ADT') continue;
                            //if (day.BookingDayHotels[0].extraBed && room.Room && !room.Room.ExtraBed && pType=='CHD') continue;
                            if (!res[baseId][pType]) res[baseId][pType] = {
                              Cost: 0,
                              Price: 0,
                              Rooms: {}
                            };
                            if (room.Room && room.Room.id && !res[baseId][pType].Rooms[room.Room.id]) {
                              res[baseId][pType].Rooms[room.Room.id] = room.Room;
                            }
                            if (this.QuoteBy == 'QUANTITY') {
                              if (room.QuoteList[baseId].TotalCost) res[baseId][pType].Cost += parseFloat(room.QuoteList[baseId].TotalCost);
                              if (room.QuoteList[baseId].TotalPrice) res[baseId][pType].Price += parseFloat(room.QuoteList[baseId].TotalPrice);
                              if (!room.TourLeader && !room.SingleSupplement && res[baseId][pType].Rooms[room.Room.id]) {
                                res[baseId][pType].Rooms[room.Room.id].Rooms = room.QuoteList[baseId].Rooms;
                              }
                            } else {
                              if (room.QuoteList[baseId].Cost) res[baseId][pType].Cost += parseFloat(room.QuoteList[baseId].Cost);
                              if (room.QuoteList[baseId].Price) res[baseId][pType].Price += parseFloat(room.QuoteList[baseId].Price);
                            }
                          } else {
                            if (!res[baseId][pType]) res[baseId][pType] = {
                              Cost: 0,
                              Price: 0,
                              Rooms: {},
                              PersonPrice: 0,
                              PersonCost: 0
                            };
                            if (room.Room && room.Room.id && !res[baseId][pType].Rooms[room.Room.id]) {
                              res[baseId][pType].Rooms[room.Room.id] = room.Room;
                            }
                            if (!tools.isNull(room.QuoteList[baseId].PersonCost)) res[baseId][pType].Cost += parseFloat(room.QuoteList[baseId].TotalCost) / this.BaseQuotes[baseId].paxQuantity * this.BaseQuotes[baseId][pType];
                            if (!tools.isNull(room.QuoteList[baseId].PersonPrice)) res[baseId][pType].Price += parseFloat(room.QuoteList[baseId].TotalPrice) / this.BaseQuotes[baseId].paxQuantity * this.BaseQuotes[baseId][pType];
                            if (!tools.isNull(room.QuoteList[baseId].PersonCost)) res[baseId][pType].PersonCost += parseFloat(room.QuoteList[baseId].TotalCost) / this.BaseQuotes[baseId].paxQuantity;
                            if (!tools.isNull(room.QuoteList[baseId].PersonPrice)) res[baseId][pType].PersonPrice += parseFloat(room.QuoteList[baseId].TotalPrice) / this.BaseQuotes[baseId].paxQuantity;
                          }
                        }
                      } catch (err) {
                        _iterator91.e(err);
                      } finally {
                        _iterator91.f();
                      }
                    }
                  }
                }
              } catch (err) {
                _iterator90.e(err);
              } finally {
                _iterator90.f();
              }
            }
          }
        }
      } catch (err) {
        _iterator89.e(err);
      } finally {
        _iterator89.f();
      }
      this._cachedTotalsHotels = res;
      return res;
    }
  }, {
    key: "baseTotalsHotels",
    get: function get() {
      if (this._cache && this._cache.baseTotalsHotels) {
        return this._cachedBaseTotalsHotels;
      }
      ;
      if (this._cache) this._cache.baseTotalsHotels = true;
      var res = {};
      var _iterator92 = _createForOfIteratorHelper(this.BookingDays),
        _step92;
      try {
        for (_iterator92.s(); !(_step92 = _iterator92.n()).done;) {
          var day = _step92.value;
          if (day.BookingDayHotels[0]) {
            if (day.BookingDayHotels[0].BookingDayRooms) {
              var _iterator93 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms),
                _step93;
              try {
                for (_iterator93.s(); !(_step93 = _iterator93.n()).done;) {
                  var room = _step93.value;
                  if (room.QuoteList) {
                    for (var baseId in this.BaseQuotes.bases) {
                      if (room.Status == 'CANCELED') continue;
                      if (!room.QuoteList[baseId]) continue;
                      if (!room.QuoteList[baseId].Include) continue;
                      if (!res[baseId]) res[baseId] = {
                        Cost: 0,
                        Price: 0
                      };
                      if (room.QuoteList[baseId].TotalCost) res[baseId].Cost += parseFloat(room.QuoteList[baseId].TotalCost);
                      if (room.QuoteList[baseId].TotalPrice) res[baseId].Price += parseFloat(room.QuoteList[baseId].TotalPrice);
                    }
                  }
                }
              } catch (err) {
                _iterator93.e(err);
              } finally {
                _iterator93.f();
              }
            }
          }
        }
      } catch (err) {
        _iterator92.e(err);
      } finally {
        _iterator92.f();
      }
      this._cachedBaseTotalsHotels = res;
      return res;
    }
  }, {
    key: "totalsByHotelByRoom",
    get: function get() {
      var res = {};
      this.CurrencyId; //force getter
      this.Markup; //force getter
      var _iterator94 = _createForOfIteratorHelper(this.BookingDays),
        _step94;
      try {
        for (_iterator94.s(); !(_step94 = _iterator94.n()).done;) {
          var day = _step94.value;
          if (day.BookingDayHotels[0]) {
            if (day.BookingDayHotels[0].BookingDayRooms) {
              var _iterator95 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms),
                _step95;
              try {
                for (_iterator95.s(); !(_step95 = _iterator95.n()).done;) {
                  var room = _step95.value;
                  if (room.QuoteList) {
                    for (var baseId in this.BaseQuotes.bases) {
                      if (!this.quotesSelected[baseId]) continue;
                      if (!room.QuoteList[baseId]) continue;
                      if (!room.QuoteList[baseId].Include) continue;
                      if (!room.Hotel) continue;
                      if (!room.Hotel.id) continue;
                      if (!res[room.Hotel.id]) res[room.Hotel.id] = {};
                      var roomId = room.id;
                      if (!roomId) roomId = room.tempId;
                      if (!res[room.Hotel.id][roomId]) res[room.Hotel.id][roomId] = {
                        Cost: 0,
                        Price: 0,
                        Status: room.Status
                      };
                      /*if (this.isGroup(baseId)) {
                          for (let groupId in this.QuoteGroups[baseId]) {
                              for (let pType of this.BaseQuotes[baseId].paxTypes) {
                                  if (!this.QuoteGroups[baseId]?.[groupId]?.[pType]) continue;
                                  if (!this.QuoteGroups[baseId]?.[groupId]?.Selected?.[pType]) continue;
                                  if (!room.QuoteList[baseId]?.Groups?.[groupId]?.selected) continue;
                                  let pax = room.QuoteList[baseId]?.Groups?.[groupId]?.pax;
                                  if (!pax) continue;
                                  res[room.Hotel.id][roomId].Cost += parseFloat(room.QuoteList[baseId].PersonCost || 0) * pax;
                                  res[room.Hotel.id][roomId].Price += parseFloat(room.QuoteList[baseId].PersonPrice || 0) * pax;
                              }
                          }
                          continue;
                      }*/

                      if (this.QuoteBy == 'QUANTITY') {
                        res[room.Hotel.id][roomId].Cost = room.QuoteList[baseId].TotalCost;
                        res[room.Hotel.id][roomId].Price = room.QuoteList[baseId].TotalPrice;
                      } else if (this.QuoteBy == 'SERVICE') {
                        res[room.Hotel.id][roomId].Cost += room.QuoteList[baseId].TotalCost;
                        res[room.Hotel.id][roomId].Price += room.QuoteList[baseId].TotalPrice;
                      } else {
                        var _iterator96 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
                          _step96;
                        try {
                          for (_iterator96.s(); !(_step96 = _iterator96.n()).done;) {
                            var pType = _step96.value;
                            if (!this.variantSelected(baseId, pType, room.QuoteList[baseId])) continue;
                            if (this.Totals[baseId] && this.Totals[baseId][pType] && this.Totals[baseId][pType].Selected) {
                              if (this.priceByChild(baseId, room, pType, day)) continue;
                              //if (this.hasChild(baseId) && room.Room && room.Room.ExtraBed && pType=='ADT') continue;
                              //if (day.BookingDayHotels[0].extraBed && room.Room && !room.Room.ExtraBed && pType=='CHD') continue;
                              var pax = this.BaseQuotes[baseId][pType];
                              if (this.Totals[baseId][pType].Pax) pax = parseInt(this.Totals[baseId][pType].Pax);
                              if (room.QuoteList[baseId].Cost) res[room.Hotel.id][roomId].Cost += parseFloat(room.QuoteList[baseId].Cost) * pax;
                              if (room.QuoteList[baseId].Price) res[room.Hotel.id][roomId].Price += parseFloat(room.QuoteList[baseId].Price) * pax;
                            }
                          }
                        } catch (err) {
                          _iterator96.e(err);
                        } finally {
                          _iterator96.f();
                        }
                      }
                    }
                  }
                }
              } catch (err) {
                _iterator95.e(err);
              } finally {
                _iterator95.f();
              }
            }
          }
        }
      } catch (err) {
        _iterator94.e(err);
      } finally {
        _iterator94.f();
      }
      return res;
    }
  }, {
    key: "setValue",
    value: function () {
      var _setValue = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee58(_ref11) {
        var fieldName, value;
        return regenerator_default().wrap(function _callee58$(_context62) {
          while (1) switch (_context62.prev = _context62.next) {
            case 0:
              fieldName = _ref11.fieldName, value = _ref11.value;
              _context62.next = 3;
              return _superPropGet(Booking, "setValue", this, 3)([{
                fieldName: fieldName,
                value: value
              }]);
            case 3:
              if (this._loaded && this._cache) {
                this.clearCache();
              }
            case 4:
            case "end":
              return _context62.stop();
          }
        }, _callee58, this);
      }));
      function setValue(_x94) {
        return _setValue.apply(this, arguments);
      }
      return setValue;
    }()
  }, {
    key: "clearCache",
    value: function clearCache() {
      this._cache.totals = false;
      this._cache.totalsHotels = false;
      this._cache.totalsServices = false;
      this._cache.quoted = false;
      this._cache.totalByPaxVariantId = false;
      this._cache.baseTotalsHotels = false;
      this._cache.totalByPaxGroup = false;
    }
  }, {
    key: "summaryTotalsFlights",
    get: function get() {
      var res = {};
      var _iterator97 = _createForOfIteratorHelper(this.BookingFlights),
        _step97;
      try {
        for (_iterator97.s(); !(_step97 = _iterator97.n()).done;) {
          var flight = _step97.value;
          if (flight.QuoteType == 'INCLUDED') {
            for (var baseId in this.BaseQuotes.bases) {
              if (this.isVariant(baseId)) continue;
              if (!res[baseId]) res[baseId] = {};
              if (!flight.QuoteList[baseId] || !flight.QuoteList[baseId].Include) continue;
              var _iterator98 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
                _step98;
              try {
                for (_iterator98.s(); !(_step98 = _iterator98.n()).done;) {
                  var pType = _step98.value;
                  if (!res[baseId][pType]) {
                    res[baseId][pType] = {
                      Cost: 0,
                      Price: 0,
                      PersonCost: 0,
                      PersonPrice: 0
                    };
                  }
                  if (this.isGroup(baseId)) {
                    var totals = this.totalsFlightsGroups(baseId, flight, pType);
                    res[baseId][pType].Cost += this.currencyConvert(flight.CurrencyId, this.CurrencyId, totals.Cost);
                    res[baseId][pType].Price += this.currencyConvert(flight.CurrencyId, this.CurrencyId, totals.Price);
                    continue;
                  }
                  if (pType == 'CHD' && flight.PaxType == 'CHD' || pType != 'CHD' && flight.PaxType != 'CHD' || !this.hasChildFlight) {
                    var fPrice = flight.getFlightPrice(baseId);
                    var fCost = flight.getFlightCost(baseId);
                    if (this.QuoteBy == 'QUANTITY' && this.BaseQuotes[baseId] && this.BaseQuotes[baseId][pType] && this.Totals[baseId] && this.Totals[baseId][pType]) {
                      var pax = this.BaseQuotes[baseId][pType];
                      if (fPrice) fPrice = fPrice * pax;
                      if (fCost) fCost = fCost * pax;
                    }
                    if (this.QuoteBy == 'SERVICE') {
                      res[baseId][pType].PersonCost += this.currencyConvert(flight.CurrencyId, this.CurrencyId, fCost);
                      res[baseId][pType].PersonPrice += this.currencyConvert(flight.CurrencyId, this.CurrencyId, fPrice);
                      var _pax2 = this.BaseQuotes[baseId][pType];
                      if (this.Totals[baseId] && this.Totals[baseId][pType] && this.Totals[baseId][pType].Pax) _pax2 = parseInt(this.Totals[baseId][pType].Pax);
                      if (fPrice) fPrice = fPrice * _pax2;
                      if (fCost) fCost = fCost * _pax2;
                    }
                    res[baseId][pType].Cost += this.currencyConvert(flight.CurrencyId, this.CurrencyId, fCost);
                    res[baseId][pType].Price += this.currencyConvert(flight.CurrencyId, this.CurrencyId, fPrice);
                  }
                }
              } catch (err) {
                _iterator98.e(err);
              } finally {
                _iterator98.f();
              }
            }
          }
        }
      } catch (err) {
        _iterator97.e(err);
      } finally {
        _iterator97.f();
      }
      return res;
    }
  }, {
    key: "totals",
    get: function get() {
      if (this._cache && this._cache.totals) {
        return this._cachedTotals;
      }
      ;
      if (this._cache) this._cache.totals = true;
      var res = {};
      var totalsService = this.totalsServices;
      var totalsHotel = this.totalsHotels;
      for (var baseId in this.BaseQuotes.bases) {
        if (!res[baseId]) res[baseId] = {};
        var _iterator99 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
          _step99;
        try {
          for (_iterator99.s(); !(_step99 = _iterator99.n()).done;) {
            var paxType = _step99.value;
            if (!res[baseId][paxType]) {
              if (!this.quoteService) {
                res[baseId][paxType] = {
                  Cost: 0,
                  Price: 0,
                  Rooms: null
                };
              } else {
                res[baseId][paxType] = {
                  Cost: 0,
                  //sum of total cost of services .TotalCost
                  Price: 0,
                  //sum of total price of services .TotalPrice
                  Rooms: null,
                  PersonCost: 0,
                  //sum of person cost .PersonCost
                  PersonPrice: 0,
                  //sum of person cost .PersonPrice
                  //TotalPersonCost: 0, //sum of total person cost .TotalPersonCost
                  //TotalPersonPrice: 0, //sum of total person cost .TotalPersonPrice
                  SumPersonCost: 0,
                  //sum of total cost of services / pax
                  SumPersonPrice: 0 //sum of total price of services / cost
                };
              }
            }
          }
        } catch (err) {
          _iterator99.e(err);
        } finally {
          _iterator99.f();
        }
      }
      for (var _baseId in this.BaseQuotes.bases) {
        if (!res[_baseId]) res[_baseId] = {};
        //AAA if (this.quoteService && this.isGroup(baseId)) continue;
        if (this.isVariant(_baseId)) continue;
        for (var pType in totalsService[_baseId]) {
          res[_baseId][pType] = Object.assign({}, totalsService[_baseId][pType]);
        }
      }
      for (var _baseId2 in this.BaseQuotes.bases) {
        //if (!res[baseId]) res[baseId] = {Cost: 0, Price: 0, Rooms: null};
        //AAA if (this.quoteService && this.isGroup(baseId)) continue;
        if (this.isVariant(_baseId2)) continue;
        for (var _pType4 in totalsHotel[_baseId2]) {
          if (!res[_baseId2][_pType4]) {
            res[_baseId2][_pType4] = Object.assign({}, totalsHotel[_baseId2][_pType4]);
          } else {
            res[_baseId2][_pType4].Cost += totalsHotel[_baseId2][_pType4].Cost;
            res[_baseId2][_pType4].Price += totalsHotel[_baseId2][_pType4].Price;
            res[_baseId2][_pType4].Rooms = totalsHotel[_baseId2][_pType4].Rooms;
            if (this.QuoteBy == 'SERVICE') {
              if (totalsHotel[_baseId2][_pType4].PersonCost) res[_baseId2][_pType4].PersonCost += totalsHotel[_baseId2][_pType4].PersonCost;
              if (totalsHotel[_baseId2][_pType4].PersonPrice) res[_baseId2][_pType4].PersonPrice += totalsHotel[_baseId2][_pType4].PersonPrice;
            }
          }
        }
      }
      if (this.BookingFlights) {
        var summaryTotalsFlights = this.summaryTotalsFlights;
        for (var _baseId3 in summaryTotalsFlights) {
          for (var _pType5 in summaryTotalsFlights[_baseId3]) {
            if (!res[_baseId3][_pType5]) {
              res[_baseId3][_pType5] = {
                Cost: 0,
                Price: 0,
                PersonCost: 0,
                PersonPrice: 0
              };
            }
            res[_baseId3][_pType5].Cost += summaryTotalsFlights[_baseId3][_pType5].Cost;
            res[_baseId3][_pType5].Price += summaryTotalsFlights[_baseId3][_pType5].Price;
            if (this.QuoteBy == 'SERVICE') {
              res[_baseId3][_pType5].PersonCost += summaryTotalsFlights[_baseId3][_pType5].PersonCost;
              res[_baseId3][_pType5].PersonPrice += summaryTotalsFlights[_baseId3][_pType5].PersonPrice;
            }
          }
        }
      }
      for (var _baseId4 in res) {
        //AAA if (this.quoteService && this.isGroup(baseId)) continue;
        if (this.isVariant(_baseId4)) continue;
        for (var _pType6 in res[_baseId4]) {
          var _this$Totals3, _this$Totals4;
          res[_baseId4][_pType6].NoGroupPrice = res[_baseId4][_pType6].Price;
          if (this.quoteService && !this.BaseQuotes[_baseId4][_pType6]) continue;
          if (!tools.isNull((_this$Totals3 = this.Totals) === null || _this$Totals3 === void 0 || (_this$Totals3 = _this$Totals3[_baseId4]) === null || _this$Totals3 === void 0 || (_this$Totals3 = _this$Totals3[_pType6]) === null || _this$Totals3 === void 0 ? void 0 : _this$Totals3.OverPrice)) {
            res[_baseId4][_pType6].Price = this.Totals[_baseId4][_pType6].OverPrice;
          }
          if (this.quoteService && !tools.isNull((_this$Totals4 = this.Totals) === null || _this$Totals4 === void 0 || (_this$Totals4 = _this$Totals4[_baseId4]) === null || _this$Totals4 === void 0 || (_this$Totals4 = _this$Totals4[_pType6]) === null || _this$Totals4 === void 0 ? void 0 : _this$Totals4.OverPersonPrice)) {
            res[_baseId4][_pType6].PersonPrice = this.Totals[_baseId4][_pType6].OverPersonPrice;
          }
        }
        if (this.QuoteBy == 'SERVICE') {
          var pax = this.BaseQuotes[_baseId4].ADT;
          if (this.BaseQuotes[_baseId4].CHD || this.BaseQuotes[_baseId4].TL) {
            if (this.BaseQuotes[_baseId4].CHD) pax += this.BaseQuotes[_baseId4].CHD;
            if (this.BaseQuotes[_baseId4].TL) pax += this.BaseQuotes[_baseId4].TL;
            var cost = res[_baseId4].ADT.Cost;
            if (res[_baseId4].CHD) cost += res[_baseId4].CHD.Cost;
            if (res[_baseId4].TL) cost += res[_baseId4].TL.Cost;
            var price = res[_baseId4].ADT.Price;
            if (res[_baseId4].CHD) price += res[_baseId4].CHD.Price;
            if (res[_baseId4].TL) price += res[_baseId4].TL.Price;
            res[_baseId4].ADT.SumPersonCost = cost / pax;
            if (res[_baseId4].CHD) res[_baseId4].CHD.SumPersonCost = cost / pax;
            res[_baseId4].ADT.SumPersonPrice = price / pax;
            if (res[_baseId4].CHD) res[_baseId4].CHD.SumPersonPrice = price / pax;
            if (res[_baseId4].TL) res[_baseId4].TL.SumPersonPrice = price / pax;
            if (res[_baseId4].TL) res[_baseId4].TL.SumPersonCost = cost / pax;
          } else {
            res[_baseId4].ADT.SumPersonCost = res[_baseId4].ADT.Cost / pax;
            res[_baseId4].ADT.SumPersonPrice = res[_baseId4].ADT.Price / pax;
          }
          ;
        }
      }
      if (this.QuoteBy == 'SERVICE') {
        for (var _baseId5 in res) {
          if (!this.isGroup(_baseId5)) continue;
          var _iterator100 = _createForOfIteratorHelper(this.BaseQuotes[_baseId5].paxTypes),
            _step100;
          try {
            for (_iterator100.s(); !(_step100 = _iterator100.n()).done;) {
              var _pType7 = _step100.value;
              res[_baseId5][_pType7].Price = 0;
              for (var groupId in this.QuoteGroups[_baseId5]) {
                if (!this.QuoteGroups[_baseId5][groupId].Selected[_pType7]) continue;
                res[_baseId5][_pType7].Price += this.totalByGroup[_baseId5][groupId][_pType7].Price;
              }
            }
          } catch (err) {
            _iterator100.e(err);
          } finally {
            _iterator100.f();
          }
        }
      }
      var totalByPaxVariant = this.totalByPaxVariant;
      for (var _baseId6 in this.BaseQuotes.bases) {
        if (!this.isVariant(_baseId6)) continue;
        res[_baseId6] = {};
        var _iterator101 = _createForOfIteratorHelper(this.BaseQuotes[_baseId6].paxTypes),
          _step101;
        try {
          for (_iterator101.s(); !(_step101 = _iterator101.n()).done;) {
            var _pType8 = _step101.value;
            res[_baseId6][_pType8] = {
              Cost: 0,
              Price: 0
            };
            if (!this.QuoteVariants[_baseId6]) continue;
            for (var variantId in this.QuoteVariants[_baseId6]) {
              if (!totalByPaxVariant[_baseId6]) continue;
              if (!totalByPaxVariant[_baseId6][variantId]) continue;
              if (!totalByPaxVariant[_baseId6][variantId][_pType8]) continue;
              if (!this.QuoteVariants[_baseId6][variantId].Selected[_pType8]) continue;
              if (this.QuoteBy != 'SERVICE') {
                res[_baseId6][_pType8].Cost += totalByPaxVariant[_baseId6][variantId][_pType8].Cost;
                res[_baseId6][_pType8].Price += totalByPaxVariant[_baseId6][variantId][_pType8].Price;
              } else {
                res[_baseId6][_pType8].Cost += totalByPaxVariant[_baseId6][variantId][_pType8].Cost * this.BaseQuotes[_baseId6][_pType8];
                res[_baseId6][_pType8].Price += totalByPaxVariant[_baseId6][variantId][_pType8].Price * this.BaseQuotes[_baseId6][_pType8];
              }
            }
          }
        } catch (err) {
          _iterator101.e(err);
        } finally {
          _iterator101.f();
        }
      }
      this._cachedTotals = res;
      return res;
    }
  }, {
    key: "totalsPerPerson",
    get: function get() {
      var res = {};
      var totals = this.totals;
      var singleSupplementValue = this.singleSupplementValue;
      var paxBaseByPaxType = this.paxBaseByPaxType;
      if (this.QuoteBy != 'QUANTITY') return;
      for (var baseId in this.BaseQuotes.bases) {
        if (!this.BaseQuotes[baseId]) continue;
        if (!res[baseId]) res[baseId] = {};
        var _iterator102 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
          _step102;
        try {
          for (_iterator102.s(); !(_step102 = _iterator102.n()).done;) {
            var pType = _step102.value;
            if (!this.BaseQuotes[baseId][pType]) continue;
            if (!res[baseId][pType]) res[baseId][pType] = {
              Price: 0,
              Rooms: {}
            };
            var pax = paxBaseByPaxType[baseId][pType];
            res[baseId][pType].Price = totals[baseId][pType].Price / paxBaseByPaxType[baseId][pType];
            if (this.BaseQuotes[baseId].SingleSupplement && totals[baseId][pType].Rooms && Object.keys(totals[baseId][pType].Rooms).length == 2) {
              for (var roomId in totals[baseId][pType].Rooms) {
                var room = totals[baseId][pType].Rooms[roomId];
                var price = void 0;
                var total = totals[baseId][pType].Price;
                if (room.Pax == 2) {
                  price = (total - singleSupplementValue[baseId]) / pax;
                }
                if (room.Pax == 1) {
                  price = (total - singleSupplementValue[baseId]) / pax + singleSupplementValue[baseId];
                }
                res[baseId][pType].Rooms[roomId] = {
                  Room: room,
                  pax: room.Rooms * room.Pax,
                  Price: price
                };
              }
            }
          }
        } catch (err) {
          _iterator102.e(err);
        } finally {
          _iterator102.f();
        }
      }
      return res;
    }
  }, {
    key: "totalPaxExpenses",
    get: function get() {
      var res = 0;
      if (!this.BookingExpenses) return res;
      var _iterator103 = _createForOfIteratorHelper(this.BookingExpenses),
        _step103;
      try {
        for (_iterator103.s(); !(_step103 = _iterator103.n()).done;) {
          var row = _step103.value;
          if (row.Type != 'PAX') continue;
          if (!row.CurrencyId || !row.Amount) continue;
          res += this.currencyConvert(row.CurrencyId, this.CurrencyId, parseFloat(row.Amount));
        }
      } catch (err) {
        _iterator103.e(err);
      } finally {
        _iterator103.f();
      }
      return res;
    }
  }, {
    key: "finalTotal",
    get: function get() {
      var res = 0;
      var noGroupTotal = 0;
      var totals = this.totals;
      for (var baseId in this.BaseQuotes.bases) {
        var _iterator104 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
          _step104;
        try {
          for (_iterator104.s(); !(_step104 = _iterator104.n()).done;) {
            var pType = _step104.value;
            if (this.isQuoteSelected(baseId, pType) && totals[baseId] && totals[baseId][pType]) {
              if (this.QuoteBy == 'QUANTITY') {
                res += totals[baseId][pType].Price;
              } else if (this.QuoteBy == 'SERVICE') {
                res += totals[baseId][pType].Price;
                if (totals[baseId][pType].NoGroupPrice) noGroupTotal += totals[baseId][pType].NoGroupPrice;
              } else {
                var pax = this.BaseQuotes[baseId][pType];
                if (this.Totals[baseId][pType].Pax) pax = parseInt(this.Totals[baseId][pType].Pax);
                res += totals[baseId][pType].Price * pax;
              }
            }
          }
        } catch (err) {
          _iterator104.e(err);
        } finally {
          _iterator104.f();
        }
      }
      //if (this.QuoteBy == 'SERVICE' && Math.round(res, 0) != Math.round(noGroupTotal, 0)) console.log('check totals 1', res, noGroupTotal);
      //if (this.QuoteBy == 'SERVICE' && parseFloat((res / noGroupTotal).toFixed(5)) != 1) console.log('check totals 2', parseFloat((res / noGroupTotal).toFixed(5)), res , noGroupTotal);
      res += this.totalPaxExpenses;
      return res;
    }
  }, {
    key: "finalTotalFlightsNotIncluded",
    get: function get() {
      var totalFlightsNotIncluded = this.totalFlightsNotIncludedAll;
      var res = {
        Cost: 0,
        Price: 0
      };
      for (var baseId in this.BaseQuotes.bases) {
        if (this.isGroup(baseId)) {
          if (this.totalFlightsNotIncludedByGroup[baseId]) {
            res.Price += this.totalFlightsNotIncludedByGroup[baseId].Price;
            res.Cost += this.totalFlightsNotIncludedByGroup[baseId].Cost;
          }
        } else {
          var _iterator105 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
            _step105;
          try {
            for (_iterator105.s(); !(_step105 = _iterator105.n()).done;) {
              var pType = _step105.value;
              //if (this.Totals[baseId] && this.Totals[baseId][pType] && this.Totals[baseId][pType].Selected) {
              if (this.isQuoteSelected(baseId, pType)) {
                var pax = this.BaseQuotes[baseId][pType];
                if (this.QuoteBy == 'PERSON' && this.Totals[baseId][pType].Pax) pax = parseInt(this.Totals[baseId][pType].Pax);
                if (this.FlightsBy == 'PERSON') pax = 1;
                if (totalFlightsNotIncluded[baseId] && totalFlightsNotIncluded[baseId][pType]) {
                  res.Price += totalFlightsNotIncluded[baseId][pType].Price * pax;
                  res.Cost += totalFlightsNotIncluded[baseId][pType].Cost * pax;
                }
              }
            }
          } catch (err) {
            _iterator105.e(err);
          } finally {
            _iterator105.f();
          }
        }
      }
      return res;
    }
  }, {
    key: "finalTotalFlights",
    get: function get() {
      var totalFlightsNotIncluded = this.totalFlightsNotIncludedAll;
      var totalFlightsIncluded = this.totalFlightsIncluded;
      var res = {
        Cost: 0,
        Price: 0
      };
      for (var baseId in this.BaseQuotes.bases) {
        var _iterator106 = _createForOfIteratorHelper(this.getPaxTypesByBase(baseId)),
          _step106;
        try {
          for (_iterator106.s(); !(_step106 = _iterator106.n()).done;) {
            var pType = _step106.value;
            //if (this.Totals[baseId] && this.Totals[baseId][pType] && this.Totals[baseId][pType].Selected) {
            if (this.isQuoteSelected(baseId, pType)) {
              var pax = this.BaseQuotes[baseId][pType];
              if (this.QuoteBy == 'PERSON' && this.Totals[baseId][pType].Pax) pax = parseInt(this.Totals[baseId][pType].Pax);
              if (totalFlightsNotIncluded[baseId] && totalFlightsNotIncluded[baseId][pType]) {
                res.Cost += totalFlightsNotIncluded[baseId][pType].Cost * pax;
                res.Price += totalFlightsNotIncluded[baseId][pType].Price * pax;
              }
              if (totalFlightsIncluded[baseId] && totalFlightsIncluded[baseId][pType]) {
                res.Cost += totalFlightsIncluded[baseId][pType].Cost * pax;
                res.Price += totalFlightsIncluded[baseId][pType].Price * pax;
              }
            }
          }
        } catch (err) {
          _iterator106.e(err);
        } finally {
          _iterator106.f();
        }
      }
      return res;
    }
  }, {
    key: "hasChildFlight",
    get: function get() {
      if (!this.BookingFlights) return false;
      var _iterator107 = _createForOfIteratorHelper(this.BookingFlights),
        _step107;
      try {
        for (_iterator107.s(); !(_step107 = _iterator107.n()).done;) {
          var flight = _step107.value;
          if (flight.PaxType == 'CHD') return true;
        }
      } catch (err) {
        _iterator107.e(err);
      } finally {
        _iterator107.f();
      }
    }
  }, {
    key: "totalFlightsIncluded",
    get: function get() {
      var res = {};
      if (!this.BookingFlights) return res;
      var _iterator108 = _createForOfIteratorHelper(this.paxTypes),
        _step108;
      try {
        for (_iterator108.s(); !(_step108 = _iterator108.n()).done;) {
          var pType = _step108.value;
          var _iterator109 = _createForOfIteratorHelper(this.BookingFlights),
            _step109;
          try {
            for (_iterator109.s(); !(_step109 = _iterator109.n()).done;) {
              var flight = _step109.value;
              if (flight.QuoteType != 'INCLUDED') continue;
              for (var baseId in this.BaseQuotes.bases) {
                if (!res[baseId]) {
                  res[baseId] = {
                    ADT: {
                      Cost: 0,
                      Price: 0
                    },
                    CHD: {
                      Cost: 0,
                      Price: 0
                    },
                    TL: {
                      Cost: 0,
                      Price: 0
                    }
                  };
                }
                if (!flight.FlightPrice) continue;
                if (!flight.QuoteList[baseId] || !flight.QuoteList[baseId].Include) continue;
                if (pType == 'CHD' && flight.PaxType == 'CHD' || pType != 'CHD' && flight.PaxType != 'CHD' || !this.hasChildFlight) {
                  var fPrice = flight.getFlightPrice(baseId);
                  res[baseId][pType].Price += this.currencyConvert(flight.CurrencyId, this.CurrencyId, fPrice);
                  var fCost = flight.getFlightCost(baseId);
                  res[baseId][pType].Cost += this.currencyConvert(flight.CurrencyId, this.CurrencyId, fCost);
                }
              }
            }
          } catch (err) {
            _iterator109.e(err);
          } finally {
            _iterator109.f();
          }
        }
      } catch (err) {
        _iterator108.e(err);
      } finally {
        _iterator108.f();
      }
      return res;
    }
  }, {
    key: "finalTotalWithFlights",
    get: function get() {
      return this.finalTotal + this.finalTotalFlightsNotIncluded.Price;
    }
  }, {
    key: "paxTypes",
    get: function get() {
      return ['ADT', 'CHD', 'TL'];
    }
  }, {
    key: "totalFlightsNotIncludedAll",
    get: function get() {
      return this.totalFlightsNotIncluded();
    }
  }, {
    key: "totalFlightsNotIncludedInternal",
    get: function get() {
      return this.totalFlightsNotIncluded('LOCAL');
    }
  }, {
    key: "totalFlightsNotIncludedInternational",
    get: function get() {
      return this.totalFlightsNotIncluded('INTERNATIONAL');
    }
  }, {
    key: "totalFlightsNotIncluded",
    value: function totalFlightsNotIncluded(flightType) {
      var res = {};
      if (!this.BookingFlights) return res;
      var _iterator110 = _createForOfIteratorHelper(this.paxTypes),
        _step110;
      try {
        for (_iterator110.s(); !(_step110 = _iterator110.n()).done;) {
          var pType = _step110.value;
          var _iterator111 = _createForOfIteratorHelper(this.BookingFlights),
            _step111;
          try {
            for (_iterator111.s(); !(_step111 = _iterator111.n()).done;) {
              var flight = _step111.value;
              if (!flight.FlightPrice) continue;
              if (flight.QuoteType == 'NOT_INCLUDED' && (!flightType || flightType == flight.FlightType)) {
                for (var baseId in this.BaseQuotes.bases) {
                  if (!res[baseId]) {
                    res[baseId] = {
                      ADT: {
                        Cost: 0,
                        Price: 0
                      },
                      CHD: {
                        Cost: 0,
                        Price: 0
                      },
                      TL: {
                        Cost: 0,
                        Price: 0
                      }
                    };
                  }
                  if (!flight.QuoteList[baseId] || !flight.QuoteList[baseId].Include) continue;
                  if (pType == 'CHD' && flight.PaxType == 'CHD' || pType != 'CHD' && flight.PaxType != 'CHD' || !this.hasChildFlight) {
                    var fPrice = flight.getFlightPrice(baseId);
                    var fCost = flight.getFlightCost(baseId);
                    res[baseId][pType].Price += this.currencyConvert(flight.CurrencyId, this.CurrencyId, fPrice);
                    res[baseId][pType].Cost += this.currencyConvert(flight.CurrencyId, this.CurrencyId, fCost);
                  }
                }
              }
            }
          } catch (err) {
            _iterator111.e(err);
          } finally {
            _iterator111.f();
          }
        }
      } catch (err) {
        _iterator110.e(err);
      } finally {
        _iterator110.f();
      }
      return res;
    }
  }, {
    key: "totalByBasePaxTypeWithFlights",
    get: function get() {
      var totals = Object.assign({}, this.totals);
      var res = {};
      for (var baseId in this.BaseQuotes.bases) {
        var paxTypes = this.getPaxTypesByBase(baseId);
        var _iterator112 = _createForOfIteratorHelper(paxTypes),
          _step112;
        try {
          for (_iterator112.s(); !(_step112 = _iterator112.n()).done;) {
            var paxType = _step112.value;
            if (!res[baseId]) res[baseId] = {};
            res[baseId][paxType] = this.getTotalByBasePaxTypeWithFlights(baseId, paxType, totals);
          }
        } catch (err) {
          _iterator112.e(err);
        } finally {
          _iterator112.f();
        }
      }
      return res;
    }
  }, {
    key: "tourLeaderTotalFlightsNotIncludedAll",
    value: function tourLeaderTotalFlightsNotIncludedAll(baseId) {
      var _this$totalFlightsNot;
      return ((_this$totalFlightsNot = this.totalFlightsNotIncludedAll) === null || _this$totalFlightsNot === void 0 || (_this$totalFlightsNot = _this$totalFlightsNot[baseId]) === null || _this$totalFlightsNot === void 0 || (_this$totalFlightsNot = _this$totalFlightsNot.TL) === null || _this$totalFlightsNot === void 0 ? void 0 : _this$totalFlightsNot.Price) || 0;
    }
  }, {
    key: "getTotalByBasePaxTypeWithFlights",
    value: function getTotalByBasePaxTypeWithFlights(baseId, pType, totals) {
      var _totals, _this$totalFlightsNot2;
      if (!totals) totals = Object.assign({}, this.totals);
      var t = 0;
      var c = 0;
      if ((_totals = totals) !== null && _totals !== void 0 && (_totals = _totals[baseId]) !== null && _totals !== void 0 && _totals[pType]) {
        t = this.totals[baseId][pType].Price;
        c = this.totals[baseId][pType].Cost;
      }
      var f = 0;
      var fc = 0;
      if ((_this$totalFlightsNot2 = this.totalFlightsNotIncludedAll) !== null && _this$totalFlightsNot2 !== void 0 && (_this$totalFlightsNot2 = _this$totalFlightsNot2[baseId]) !== null && _this$totalFlightsNot2 !== void 0 && _this$totalFlightsNot2[pType]) {
        f = this.totalFlightsNotIncludedAll[baseId][pType].Price;
        fc = this.totalFlightsNotIncludedAll[baseId][pType].Cost;
        if (this.QuoteBy == 'QUANTITY') {
          var pax = this.getPaxBasePaxType(baseId, pType);
          f = f * pax;
          fc = fc * pax;
        }
        if (this.QuoteBy == 'SERVICE') {
          var _pax3 = this.getPaxBasePaxType(baseId, pType);
          f = f * _pax3;
          fc = fc * _pax3;
        }
      }
      if (this.QuoteBy == 'QUANTITY') {
        //let Price = this.getTotalInCurrency(t + f);
        //let Cost = this.getTotalInCurrency(c + fc);  
        var Price = t + f;
        var Cost = c + fc;
        return {
          Price: Price,
          Cost: Cost
        };
      } else if (this.QuoteBy == 'SERVICE') {
        //let Price = this.getTotalInCurrency(t + f);
        //let Cost = this.getTotalInCurrency(c + fc);
        var _Price = t + f;
        var _Cost = c + fc;
        return {
          Price: _Price,
          Cost: _Cost
        };
      } else {
        var _pax4 = this.getPaxBasePaxType(baseId, pType);
        //let Price = this.getTotalInCurrency(t + f) * pax;
        //let Cost = this.getTotalInCurrency(c + fc) * pax;
        var _Price2 = (t + f) * _pax4;
        var _Cost2 = (c + fc) * _pax4;
        return {
          Price: _Price2,
          Cost: _Cost2
        };
      }
    }
  }, {
    key: "getTotalInCurrency",
    value: function getTotalInCurrency(price) {
      var r = this.currencyConvert(this.CurrencyId, this.PriceCurrencyId, price);
      return r;
    }
  }, {
    key: "getTotalRoundedUp",
    value: function getTotalRoundedUp(r, f) {
      return Math.round(r / f + 0.5, 0) * f;
    }
  }, {
    key: "getPaxBasePaxType",
    value: function getPaxBasePaxType(baseId, pType) {
      if (!this.BaseQuotes[baseId]) return 0;
      if (!this.BaseQuotes[baseId][pType]) return 0;
      var pax = this.BaseQuotes[baseId][pType];
      if (!this.Totals[baseId]) return 0;
      if (this.QuoteBy == 'PERSON' && this.Totals[baseId][pType] && this.Totals[baseId][pType].Pax) pax = parseInt(this.Totals[baseId][pType].Pax);
      return pax;
    }
  }, {
    key: "paxBaseByPaxType",
    get: function get() {
      ///rev_quantity
      var res = {};
      for (var baseId in this.BaseQuotes.bases) {
        if (!res[baseId]) res[baseId] = {};
        var _iterator113 = _createForOfIteratorHelper(this.getPaxTypesByBase(baseId)),
          _step113;
        try {
          for (_iterator113.s(); !(_step113 = _iterator113.n()).done;) {
            var pType = _step113.value;
            res[baseId][pType] = this.BaseQuotes[baseId][pType];
            if (this.Totals[baseId] && this.Totals[baseId][pType] && this.Totals[baseId][pType].Pax) {
              res[baseId][pType] = this.Totals[baseId][pType].Pax;
            }
          }
        } catch (err) {
          _iterator113.e(err);
        } finally {
          _iterator113.f();
        }
      }
      return res;
    }
  }, {
    key: "paxQuaintityLabel",
    value: function paxQuaintityLabel(baseId, pType) {
      /*if (pType == 'ADT') {
          let adt = this.paxBaseByPaxType[baseId][pType];
          let tl = this.BaseQuotes[baseId].TL;
          if (this.BaseQuotes[baseId].TL) {
              return`${adt - tl} ADT, ${tl} TL`;
          } else {
              return adt + ' ADT';
           }
      }*/
      return this.paxBaseByPaxType[baseId][pType] + ' ' + pType;
    }
  }, {
    key: "totalByBasePaxType",
    get: function get() {
      var totals = Object.assign({}, this.totals);
      var res = {};
      for (var baseId in this.BaseQuotes.bases) {
        //let quote = this.BaseQuotes[baseId];
        var paxTypes = this.getPaxTypesByBase(baseId);
        var _iterator114 = _createForOfIteratorHelper(paxTypes),
          _step114;
        try {
          for (_iterator114.s(); !(_step114 = _iterator114.n()).done;) {
            var paxType = _step114.value;
            if (!res[baseId]) res[baseId] = {};
            //res[baseId][paxType] = quote.getTotalByBasePaxType[paxType];
            res[baseId][paxType] = this.getTotalByBasePaxType(baseId, paxType, totals);
          }
        } catch (err) {
          _iterator114.e(err);
        } finally {
          _iterator114.f();
        }
      }
      return res;
    }
  }, {
    key: "getTotalByBasePaxType",
    value: function getTotalByBasePaxType(baseId, pType, totals) {
      if (!totals) totals = Object.assign({}, this.totals);
      if (!totals[baseId]) return {};
      if (!totals[baseId][pType]) return {};
      if (this.QuoteBy == 'PERSON') {
        var pax = this.getPaxBasePaxType(baseId, pType);
        return {
          //Price: this.getTotalInCurrency(totals[baseId][pType].Price) * pax,
          //Cost: this.getTotalInCurrency(totals[baseId][pType].Cost) * pax,
          Price: totals[baseId][pType].Price * pax,
          Cost: totals[baseId][pType].Cost * pax
        };
      } else {
        return {
          //Price: this.getTotalInCurrency(totals[baseId][pType].Price),
          //Cost: this.getTotalInCurrency(totals[baseId][pType].Cost),
          Price: totals[baseId][pType].Price,
          Cost: totals[baseId][pType].Cost
        };
      }
    }
  }, {
    key: "languageName",
    get: function get() {
      if (this.Language) return this.Language.Name;
    }
  }, {
    key: "bookingConfirmed",
    get: function get() {
      if (this.isBooking && this.Status && this.Status != 'QUOTE' && this.Status != 'QUOTE_LOST') {
        return true;
      }
    }
  }, {
    key: "operationStatus",
    get: function get() {
      return this.bookingConfirmed;
    }
  }, {
    key: "quoteStatus",
    get: function get() {
      if (this.Status == 'QUOTE') {
        return true;
      }
    }
  }, {
    key: "cityServicePending",
    get: function get() {
      var _iterator115 = _createForOfIteratorHelper(this.BookingDays),
        _step115;
      try {
        for (_iterator115.s(); !(_step115 = _iterator115.n()).done;) {
          var day = _step115.value;
          var _iterator116 = _createForOfIteratorHelper(day.BookingDayServices),
            _step116;
          try {
            for (_iterator116.s(); !(_step116 = _iterator116.n()).done;) {
              var service = _step116.value;
              var cityId = service.CityId;
              var City = service.City;
              if (service.Service && service.Service.CityId) {
                cityId = service.Service.CityId;
                City = service.Service.City;
              }
              if (!cityId) {
                return true;
              }
            }
          } catch (err) {
            _iterator116.e(err);
          } finally {
            _iterator116.f();
          }
        }
      } catch (err) {
        _iterator115.e(err);
      } finally {
        _iterator115.f();
      }
      return false;
    }
  }, {
    key: "setCurrencyToServices",
    value: function () {
      var _setCurrencyToServices = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee59() {
        return regenerator_default().wrap(function _callee59$(_context63) {
          while (1) switch (_context63.prev = _context63.next) {
            case 0:
              _context63.next = 2;
              return this.setCurrencyRateToServices({});
            case 2:
              this.setBookingTotals();
            case 3:
            case "end":
              return _context63.stop();
          }
        }, _callee59, this);
      }));
      function setCurrencyToServices() {
        return _setCurrencyToServices.apply(this, arguments);
      }
      return setCurrencyToServices;
    }()
  }, {
    key: "setCurrencyRateToServices",
    value: function () {
      var _setCurrencyRateToServices = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee60(_ref12) {
        var rate, currencyId, currency, _iterator117, _step117, day, _iterator118, _step118, s, base, _iterator120, _step120, pType, _quote, _currencyRate, _markup2, _iterator119, _step119, room, baseId, quote, currencyRate, value, markup;
        return regenerator_default().wrap(function _callee60$(_context64) {
          while (1) switch (_context64.prev = _context64.next) {
            case 0:
              rate = _ref12.rate, currencyId = _ref12.currencyId;
              currency = currencyId;
              if (!currency) currency = this.CurrencyId;
              _iterator117 = _createForOfIteratorHelper(this.BookingDays);
              _context64.prev = 4;
              _iterator117.s();
            case 6:
              if ((_step117 = _iterator117.n()).done) {
                _context64.next = 99;
                break;
              }
              day = _step117.value;
              _iterator118 = _createForOfIteratorHelper(day.BookingDayServices);
              _context64.prev = 9;
              _iterator118.s();
            case 11:
              if ((_step118 = _iterator118.n()).done) {
                _context64.next = 55;
                break;
              }
              s = _step118.value;
              if (!(s.Quote && s.Quote.QuoteList)) {
                _context64.next = 53;
                break;
              }
              _context64.t0 = regenerator_default().keys(s.Quote.QuoteList);
            case 15:
              if ((_context64.t1 = _context64.t0()).done) {
                _context64.next = 53;
                break;
              }
              base = _context64.t1.value;
              _iterator120 = _createForOfIteratorHelper(this.getPaxTypesByBase(base));
              _context64.prev = 18;
              _iterator120.s();
            case 20:
              if ((_step120 = _iterator120.n()).done) {
                _context64.next = 43;
                break;
              }
              pType = _step120.value;
              if (!s.Quote.QuoteList[base]) {
                _context64.next = 41;
                break;
              }
              _quote = s.Quote.QuoteList[base][pType];
              if (!(_quote && _quote.SourceCost)) {
                _context64.next = 41;
                break;
              }
              if (!_quote.Modified) {
                _context64.next = 27;
                break;
              }
              return _context64.abrupt("continue", 41);
            case 27:
              if (!_quote.PersonCostModified) {
                _context64.next = 29;
                break;
              }
              return _context64.abrupt("continue", 41);
            case 29:
              if (!_quote.PriceModified) {
                _context64.next = 31;
                break;
              }
              return _context64.abrupt("continue", 41);
            case 31:
              if (!_quote.PersonPriceModified) {
                _context64.next = 33;
                break;
              }
              return _context64.abrupt("continue", 41);
            case 33:
              if (!(rate && _quote.SourceCurrencyId == currency)) {
                _context64.next = 35;
                break;
              }
              return _context64.abrupt("continue", 41);
            case 35:
              if (!(rate && _quote.SourceCurrencyId != rate.FromCurrencyId && _quote.SourceCurrencyId != rate.ToCurrencyId)) {
                _context64.next = 37;
                break;
              }
              return _context64.abrupt("continue", 41);
            case 37:
              _currencyRate = {
                0: rate
              };
              if (!rate) _currencyRate = this.currencyRates;
              _markup2 = _quote.Markup || this.Markup;
              if (this.QuoteBy == 'SERVICE') {
                _quote.setTotals();
                _quote.calculatePersonCost();
                _quote.calculatePersonPrice();
              } else {
                _quote.$Cost.value = travelTools.currencyConvert(_quote.SourceCurrencyId, currency, _quote.SourceCost, _currencyRate);
                _quote.setPriceByCost();
                if (_quote.Cost) _quote.setPrice(_markup2);
                //quote.setTotals();
              }
            case 41:
              _context64.next = 20;
              break;
            case 43:
              _context64.next = 48;
              break;
            case 45:
              _context64.prev = 45;
              _context64.t2 = _context64["catch"](18);
              _iterator120.e(_context64.t2);
            case 48:
              _context64.prev = 48;
              _iterator120.f();
              return _context64.finish(48);
            case 51:
              _context64.next = 15;
              break;
            case 53:
              _context64.next = 11;
              break;
            case 55:
              _context64.next = 60;
              break;
            case 57:
              _context64.prev = 57;
              _context64.t3 = _context64["catch"](9);
              _iterator118.e(_context64.t3);
            case 60:
              _context64.prev = 60;
              _iterator118.f();
              return _context64.finish(60);
            case 63:
              if (!(day.BookingDayHotels[0] && day.BookingDayHotels[0].BookingDayRooms)) {
                _context64.next = 97;
                break;
              }
              _iterator119 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms);
              _context64.prev = 65;
              _iterator119.s();
            case 67:
              if ((_step119 = _iterator119.n()).done) {
                _context64.next = 89;
                break;
              }
              room = _step119.value;
              if (!(rate && room.CurrencyId == currency)) {
                _context64.next = 71;
                break;
              }
              return _context64.abrupt("continue", 87);
            case 71:
              if (!(rate && room.CurrencyId != rate.FromCurrencyId && room.CurrencyId != rate.ToCurrencyId)) {
                _context64.next = 73;
                break;
              }
              return _context64.abrupt("continue", 87);
            case 73:
              _context64.t4 = regenerator_default().keys(room.QuoteList.bases);
            case 74:
              if ((_context64.t5 = _context64.t4()).done) {
                _context64.next = 87;
                break;
              }
              baseId = _context64.t5.value;
              quote = room.QuoteList[baseId];
              if (!quote.Modified) {
                _context64.next = 79;
                break;
              }
              return _context64.abrupt("continue", 74);
            case 79:
              if (!quote.PriceModified) {
                _context64.next = 81;
                break;
              }
              return _context64.abrupt("continue", 74);
            case 81:
              currencyRate = {
                0: rate
              };
              if (!rate) currencyRate = this.currencyRates;
              if (quote.SourceRoomCost) {
                value = travelTools.currencyConvert(quote.SourceCurrencyId, currency, quote.SourceRoomCost, currencyRate);
                quote.$RoomCost.value = parseFloat(value) * quote.factor / (parseInt(day.BookingDayHotels[0].Days) * quote.qFactor);
                quote.$Cost.value = quote.getCost();
              } else if (quote.SourceCost) {
                quote.$Cost.value = travelTools.currencyConvert(quote.SourceCurrencyId, currency, quote.SourceCost, currencyRate);
                quote.$RoomCost.value = parseFloat(quote.Cost) * quote.factor / (parseInt(day.BookingDayHotels[0].Days) * quote.qFactor);
              }
              if (quote.Cost) {
                markup = quote.Markup || this.Markup;
                quote.$Price.value = tools.getPrice(quote.Cost, markup);
                quote.setTotals();
              }
              _context64.next = 74;
              break;
            case 87:
              _context64.next = 67;
              break;
            case 89:
              _context64.next = 94;
              break;
            case 91:
              _context64.prev = 91;
              _context64.t6 = _context64["catch"](65);
              _iterator119.e(_context64.t6);
            case 94:
              _context64.prev = 94;
              _iterator119.f();
              return _context64.finish(94);
            case 97:
              _context64.next = 6;
              break;
            case 99:
              _context64.next = 104;
              break;
            case 101:
              _context64.prev = 101;
              _context64.t7 = _context64["catch"](4);
              _iterator117.e(_context64.t7);
            case 104:
              _context64.prev = 104;
              _iterator117.f();
              return _context64.finish(104);
            case 107:
            case "end":
              return _context64.stop();
          }
        }, _callee60, this, [[4, 101, 104, 107], [9, 57, 60, 63], [18, 45, 48, 51], [65, 91, 94, 97]]);
      }));
      function setCurrencyRateToServices(_x95) {
        return _setCurrencyRateToServices.apply(this, arguments);
      }
      return setCurrencyRateToServices;
    }()
  }, {
    key: "setSplitQuoteDate",
    value: function () {
      var _setSplitQuoteDate = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee61() {
        var _iterator121, _step121, day, _iterator122, _step122, s;
        return regenerator_default().wrap(function _callee61$(_context65) {
          while (1) switch (_context65.prev = _context65.next) {
            case 0:
              if (this.SplitQuoteDate) {
                _context65.next = 8;
                break;
              }
              this.$QuoteDate.value = null;
              _iterator121 = _createForOfIteratorHelper(this.BookingDays);
              try {
                for (_iterator121.s(); !(_step121 = _iterator121.n()).done;) {
                  day = _step121.value;
                  day.QuoteDate = null;
                  _iterator122 = _createForOfIteratorHelper(day.BookingDayServices);
                  try {
                    for (_iterator122.s(); !(_step122 = _iterator122.n()).done;) {
                      s = _step122.value;
                      s.QuoteDate = null;
                    }
                  } catch (err) {
                    _iterator122.e(err);
                  } finally {
                    _iterator122.f();
                  }
                }
                //if (this.QuoteDate && this.QuoteDate != this.StartDate) {
              } catch (err) {
                _iterator121.e(err);
              } finally {
                _iterator121.f();
              }
              _context65.next = 6;
              return this.setCostByDate({
                update: false
              });
            case 6:
              _context65.next = 9;
              break;
            case 8:
              this.QuoteDate = this.StartDate;
            case 9:
            case "end":
              return _context65.stop();
          }
        }, _callee61, this);
      }));
      function setSplitQuoteDate() {
        return _setSplitQuoteDate.apply(this, arguments);
      }
      return setSplitQuoteDate;
    }()
  }, {
    key: "bookingCities",
    get: function get() {
      var res = [];
      var _iterator123 = _createForOfIteratorHelper(this.BookingDays),
        _step123;
      try {
        for (_iterator123.s(); !(_step123 = _iterator123.n()).done;) {
          var day = _step123.value;
          var _iterator124 = _createForOfIteratorHelper(day.BookingDayServices),
            _step124;
          try {
            for (_iterator124.s(); !(_step124 = _iterator124.n()).done;) {
              var s = _step124.value;
              if (s && s.serviceSelected && !s.serviceSelected(this.ViewMode)) continue;
              if (s.CityId) {
                if (res.indexOf(s.CityId) == -1) {
                  res.push(s.CityId);
                  continue;
                }
              } else if (s.Service && s.Service.CityId) {
                if (res.indexOf(s.Service.CityId) == -1) {
                  res.push(s.Service.CityId);
                }
              }
            }
          } catch (err) {
            _iterator124.e(err);
          } finally {
            _iterator124.f();
          }
          if (day.BookingDayHotels[0] && day.BookingDayHotels[0].CityId) {
            var found = day.showByViewMode(this.ViewMode);
            if (found && res.indexOf(day.BookingDayHotels[0].CityId) == -1) {
              res.push(day.BookingDayHotels[0].CityId);
            }
          }
        }
      } catch (err) {
        _iterator123.e(err);
      } finally {
        _iterator123.f();
      }
      return res;
    }
  }, {
    key: "bookingCitiesObject",
    get: function get() {
      var res = {};
      var _iterator125 = _createForOfIteratorHelper(this.BookingDays),
        _step125;
      try {
        for (_iterator125.s(); !(_step125 = _iterator125.n()).done;) {
          var day = _step125.value;
          var _iterator126 = _createForOfIteratorHelper(day.BookingDayServices),
            _step126;
          try {
            for (_iterator126.s(); !(_step126 = _iterator126.n()).done;) {
              var s = _step126.value;
              if (s && s.serviceSelected && !s.serviceSelected(this.ViewMode)) continue;
              if (s.CityId) {
                if (!res[s.CityId]) {
                  res[s.CityId] = s.City;
                  res[s.CityId].DayNr = day.DayNr + 1;
                }
              } else if (s.Service && s.Service.CityId) {
                if (!res[s.Service.CityId]) {
                  res[s.Service.CityId] = s.Service.City;
                  res[s.Service.CityId].DayNr = day.DayNr + 1;
                }
              }
            }
          } catch (err) {
            _iterator126.e(err);
          } finally {
            _iterator126.f();
          }
          if (day.BookingDayHotels[0] && day.BookingDayHotels[0].CityId) {
            if (day.showByViewMode(this.ViewMode)) {
              res[day.BookingDayHotels[0].CityId] = day.BookingDayHotels[0].City;
              res[day.BookingDayHotels[0].CityId].DayNr = day.DayNr + 1;
            }
          }
        }
      } catch (err) {
        _iterator125.e(err);
      } finally {
        _iterator125.f();
      }
      return res;
    }
  }, {
    key: "flightsList",
    get: function get() {
      var res = [];
      var _iterator127 = _createForOfIteratorHelper(this.BookingFlights),
        _step127;
      try {
        for (_iterator127.s(); !(_step127 = _iterator127.n()).done;) {
          var f = _step127.value;
          if (!f.serviceFlight(this.ViewMode)) continue;
          if (f.Output) {
            var rows = f.Output.split('\n');
            var _iterator128 = _createForOfIteratorHelper(rows),
              _step128;
            try {
              for (_iterator128.s(); !(_step128 = _iterator128.n()).done;) {
                var r = _step128.value;
                res.push(r);
              }
            } catch (err) {
              _iterator128.e(err);
            } finally {
              _iterator128.f();
            }
          }
        }
      } catch (err) {
        _iterator127.e(err);
      } finally {
        _iterator127.f();
      }
      return res;
    }
  }, {
    key: "flightsListInternal",
    get: function get() {
      var res = [];
      var _iterator129 = _createForOfIteratorHelper(this.BookingFlights),
        _step129;
      try {
        for (_iterator129.s(); !(_step129 = _iterator129.n()).done;) {
          var f = _step129.value;
          if (!f.serviceFlight(this.ViewMode)) continue;
          if (f.Output && f.FlightType == 'LOCAL') {
            var rows = f.Output.split('\n');
            var _iterator130 = _createForOfIteratorHelper(rows),
              _step130;
            try {
              for (_iterator130.s(); !(_step130 = _iterator130.n()).done;) {
                var r = _step130.value;
                res.push(r);
              }
            } catch (err) {
              _iterator130.e(err);
            } finally {
              _iterator130.f();
            }
          }
        }
      } catch (err) {
        _iterator129.e(err);
      } finally {
        _iterator129.f();
      }
      return res;
    }
  }, {
    key: "flightsListInternational",
    get: function get() {
      var res = [];
      var _iterator131 = _createForOfIteratorHelper(this.BookingFlights),
        _step131;
      try {
        for (_iterator131.s(); !(_step131 = _iterator131.n()).done;) {
          var f = _step131.value;
          if (!f.serviceFlight(this.ViewMode)) continue;
          if (f.Output && f.FlightType == 'INTERNATIONAL') {
            var rows = f.Output.split('\n');
            var _iterator132 = _createForOfIteratorHelper(rows),
              _step132;
            try {
              for (_iterator132.s(); !(_step132 = _iterator132.n()).done;) {
                var r = _step132.value;
                res.push(r);
              }
            } catch (err) {
              _iterator132.e(err);
            } finally {
              _iterator132.f();
            }
          }
        }
      } catch (err) {
        _iterator131.e(err);
      } finally {
        _iterator131.f();
      }
      return res;
    }
  }, {
    key: "includes",
    get: function get() {
      if (!this.Include) return [];
      return this.Include.split('\n');
    }
  }, {
    key: "notIncludes",
    get: function get() {
      if (!this.NotInclude) return [];
      return this.NotInclude.split('\n');
    }
  }, {
    key: "skipDays",
    get: function get() {
      var res = {};
      var _iterator133 = _createForOfIteratorHelper(this.BookingDays),
        _step133;
      try {
        for (_iterator133.s(); !(_step133 = _iterator133.n()).done;) {
          var day = _step133.value;
          if (day.GroupDays) {
            var from = parseInt(day.DayNr) + 1;
            var to = parseInt(day.GroupDayTo) - 1;
            for (var i = from; i <= to; i++) {
              res[i] = true;
            }
          }
          if (this.ViewMode != -1) {
            var found = false;
            var _iterator134 = _createForOfIteratorHelper(day.BookingDayServices),
              _step134;
            try {
              for (_iterator134.s(); !(_step134 = _iterator134.n()).done;) {
                var s = _step134.value;
                if (s.Quote.QuoteList[this.ViewMode]) {
                  var _iterator136 = _createForOfIteratorHelper(s.Quote.QuoteList[this.ViewMode].paxTypes),
                    _step136;
                  try {
                    for (_iterator136.s(); !(_step136 = _iterator136.n()).done;) {
                      var paxType = _step136.value;
                      if (s.Quote.QuoteList[this.ViewMode][paxType] && s.Quote.QuoteList[this.ViewMode][paxType].Include) {
                        found = true;
                      }
                    }
                  } catch (err) {
                    _iterator136.e(err);
                  } finally {
                    _iterator136.f();
                  }
                }
              }
            } catch (err) {
              _iterator134.e(err);
            } finally {
              _iterator134.f();
            }
            var hotel = this.hotelsByDay[day.DayNr];
            if (hotel) {
              var _iterator135 = _createForOfIteratorHelper(hotel.BookingDayRooms),
                _step135;
              try {
                for (_iterator135.s(); !(_step135 = _iterator135.n()).done;) {
                  var room = _step135.value;
                  if (room.QuoteList[this.ViewMode] && room.QuoteList[this.ViewMode].Include) {
                    found = true;
                  }
                }
              } catch (err) {
                _iterator135.e(err);
              } finally {
                _iterator135.f();
              }
            }
            if (!found) res[day.DayNr] = true;
          }
        }
      } catch (err) {
        _iterator133.e(err);
      } finally {
        _iterator133.f();
      }
      return res;
    }
  }, {
    key: "bookingServices",
    get: function get() {
      var res = [];
      var _iterator137 = _createForOfIteratorHelper(this.BookingDays),
        _step137;
      try {
        for (_iterator137.s(); !(_step137 = _iterator137.n()).done;) {
          var day = _step137.value;
          var _iterator138 = _createForOfIteratorHelper(day.BookingDayServices),
            _step138;
          try {
            for (_iterator138.s(); !(_step138 = _iterator138.n()).done;) {
              var service = _step138.value;
              res.push(service.ServiceId);
            }
          } catch (err) {
            _iterator138.e(err);
          } finally {
            _iterator138.f();
          }
        }
      } catch (err) {
        _iterator137.e(err);
      } finally {
        _iterator137.f();
      }
      return res;
    }
  }, {
    key: "optionalServices",
    value: function optionalServices(services) {
      var res = {};
      var self = this;
      var _loop8 = function _loop8(cityId) {
        var r = _.filter(services, function (s) {
          return s.Optional && s.CityId == cityId && self.bookingServices.indexOf(s.id) < 0;
        });
        res[cityId] = r;
      };
      for (var cityId in this.bookingCitiesObject) {
        _loop8(cityId);
      }
      return res;
    }
  }, {
    key: "flightsNotIncluded",
    get: function get() {
      var res = {};
      var _iterator139 = _createForOfIteratorHelper(this.BookingFlights),
        _step139;
      try {
        for (_iterator139.s(); !(_step139 = _iterator139.n()).done;) {
          var flight = _step139.value;
          if (flight.QuoteType != 'NOT_INCLUDED') continue;
          var key = [flight.FlightType, flight.PaxType];
          var bases = [];
          var found = false;
          for (var baseId in this.BaseQuotes.bases) {
            if (!flight.QuoteList[baseId]) continue;
            if (flight.QuoteList[baseId].Include) {
              found = true;
              key.push(baseId);
              bases.push(baseId);
            }
          }
          if (found) {
            if (!res[key]) {
              res[key] = {
                pType: flight.PaxType,
                Price: 0,
                FlightType: flight.FlightType
              };
              if (flight.Comment) {
                res[key].Comment = flight.Comment;
              }
            }
            var _baseId7 = key[2];
            var fPrice = flight.getFlightPrice(_baseId7);
            res[key].Price += this.currencyConvert(flight.CurrencyId, this.CurrencyId, fPrice);
            res[key].Bases = bases;
          }
        }
      } catch (err) {
        _iterator139.e(err);
      } finally {
        _iterator139.f();
      }
      return res;
    }
  }, {
    key: "bookingTotals",
    get: function get() {
      var res = [];
      for (var base in this.Totals) {
        if (!this.BaseQuotes[base]) continue;
        var paxQuantity = this.BaseQuotes[base].ADT;
        if (this.BaseQuotes[base].CHD) paxQuantity += this.BaseQuotes[base].CHD;
        if (this.BaseQuotes[base].TL) paxQuantity += this.BaseQuotes[base].TL;
        var expenseByPax = this.totalPaxExpenses / paxQuantity;
        for (var pType in this.Totals[base]) {
          if (!this.Totals[base][pType]) continue;
          if (!this.totals[base]) continue;
          if (!this.totals[base][pType]) continue;
          if (this.Totals[base][pType].Selected) {
            var q = _.cloneDeep(this.totals[base][pType]);
            if (this.QuoteBy == 'SERVICE') {
              q.Price += this.totalPaxExpenses;
              q.PersonPrice += this.totalPaxExpenses / paxQuantity;
            } else {
              q.Price += expenseByPax;
            }
            q.Comment = this.Totals[base][pType].Comment;
            res.push({
              Quote: q,
              pax: paxQuantity,
              pType: pType,
              Room: this.Totals[base][pType].Rooms,
              Base: base
            });
          }
        }
      }
      return res;
    }
  }, {
    key: "categoriesByQuotation",
    get: function get() {
      var res = {};
      var _iterator140 = _createForOfIteratorHelper(this.BookingDays),
        _step140;
      try {
        for (_iterator140.s(); !(_step140 = _iterator140.n()).done;) {
          var day = _step140.value;
          if (day.BookingDayHotels[0]) {
            if (!day.BookingDayHotels[0].BookingDayRooms) continue;
            var _iterator141 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms),
              _step141;
            try {
              for (_iterator141.s(); !(_step141 = _iterator141.n()).done;) {
                var room = _step141.value;
                if (!room.roomQuoteSelected && this.anyQuoteSelected) continue;
                if (!room.HotelCategoryId) continue;
                if (!room.QuoteList) continue;
                for (var _baseId8 in this.BaseQuotes.bases) {
                  if (!room.QuoteList[_baseId8]) continue;
                  if (!room.QuoteList[_baseId8].Include) continue;
                  if (!res[_baseId8]) res[_baseId8] = [];
                  if (res[_baseId8].indexOf(room.HotelCategoryId) == -1) {
                    res[_baseId8].push(room.HotelCategoryId);
                  }
                }
              }
            } catch (err) {
              _iterator141.e(err);
            } finally {
              _iterator141.f();
            }
          }
        }
      } catch (err) {
        _iterator140.e(err);
      } finally {
        _iterator140.f();
      }
      for (var baseId in res) {
        if (res[baseId].length != 1) return;
      }
      return true;
    }
  }, {
    key: "isBaseHotelCategory",
    value: function isBaseHotelCategory(baseId, hotelCategoryId) {
      if (Object.keys(this.hotelCategories).length <= 1) return true;
      var _iterator142 = _createForOfIteratorHelper(this.BookingDays),
        _step142;
      try {
        for (_iterator142.s(); !(_step142 = _iterator142.n()).done;) {
          var day = _step142.value;
          if (day.BookingDayHotels[0]) {
            var _iterator143 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms),
              _step143;
            try {
              for (_iterator143.s(); !(_step143 = _iterator143.n()).done;) {
                var room = _step143.value;
                if (room.HotelCategoryId == hotelCategoryId) {
                  if (room.QuoteList[baseId].Include) {
                    return true;
                  }
                }
              }
            } catch (err) {
              _iterator143.e(err);
            } finally {
              _iterator143.f();
            }
          }
        }
      } catch (err) {
        _iterator142.e(err);
      } finally {
        _iterator142.f();
      }
    }
  }, {
    key: "_categoriesToSelect",
    value: function _categoriesToSelect(onlySelected) {
      var res = {};
      var categoriesQuantityByDay = {};
      var _iterator144 = _createForOfIteratorHelper(this.BookingDays),
        _step144;
      try {
        for (_iterator144.s(); !(_step144 = _iterator144.n()).done;) {
          var day = _step144.value;
          if (day.BookingDayHotels[0]) {
            var categoriesByDay = {};
            var _iterator145 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms),
              _step145;
            try {
              for (_iterator145.s(); !(_step145 = _iterator145.n()).done;) {
                var room = _step145.value;
                if (onlySelected && !room.roomQuoteSelected && this.anyQuoteSelected) continue;
                if (room.HotelCategoryId && room.HotelCategory) {
                  res[room.HotelCategoryId] = room.HotelCategory.Name;
                  categoriesByDay[room.HotelCategoryId] = room.HotelCategory.Name;
                } else {
                  res['_no_hotel_category_'] = null;
                  categoriesByDay['_no_hotel_category_'] = null;
                }
              }
            } catch (err) {
              _iterator145.e(err);
            } finally {
              _iterator145.f();
            }
            categoriesQuantityByDay[day.DayNr] = Object.keys(categoriesByDay).length;
          }
        }
      } catch (err) {
        _iterator144.e(err);
      } finally {
        _iterator144.f();
      }
      if (Object.keys(res).length == 0) {
        res['_no_hotel_category_'] = null;
        return res;
      }
      var moreThanOne = false;
      for (var dayNr in categoriesQuantityByDay) {
        if (categoriesQuantityByDay[dayNr] != 1) {
          moreThanOne = true;
        }
      }
      if (!moreThanOne) {
        var names = [];
        for (var id in res) {
          if (!res[id]) continue;
          names.push(res[id]);
        }
        if (names.length == 0) {
          return {
            '_no_hotel_category_': null
          };
        }
        return {
          '__unique_category__': names
        };
      }
      return res;
    }
  }, {
    key: "_hotelCategories",
    get: function get() {
      return this._categoriesToSelect();
    }
  }, {
    key: "hotelCategories",
    get: function get() {
      if (!this.categoriesByQuotation) {
        return {
          '_no_hotel_category_': null
        };
      }
      var res = {};
      if (this.ShowPriceBy == 'TOTAL_TRIP' && this.SumByType != 'HOTEL_CATEGORY') {
        res['_no_hotel_category_'] = null;
        return res;
      }
      return this._categoriesToSelect(true);
    }
  }, {
    key: "hotelCategoriesNames",
    get: function get() {
      var res = this.hotelCategories;
      var keys = Object.keys(res);
      if (keys.length == 1 && keys[0] == '__unique_category__') {
        var names = res['__unique_category__'];
        var categoriesNames = names.join(' & ');
        if (names.length > 2) {
          categoriesNames = tools.joinText(names, ', ', ' & ');
        }
        return {
          '__unique_category__': categoriesNames
        };
      }
      return res;
    }
  }, {
    key: "isHotelCategory",
    value: function isHotelCategory(t, hotelCategoryId) {
      if (Object.keys(this.hotelCategories).length <= 1) {
        return true;
      }
      var _iterator146 = _createForOfIteratorHelper(this.BookingDays),
        _step146;
      try {
        for (_iterator146.s(); !(_step146 = _iterator146.n()).done;) {
          var day = _step146.value;
          if (day.BookingDayHotels[0]) {
            var _iterator147 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms),
              _step147;
            try {
              for (_iterator147.s(); !(_step147 = _iterator147.n()).done;) {
                var room = _step147.value;
                if (room.HotelCategoryId == hotelCategoryId) {
                  for (var baseId in room.QuoteList.bases) {
                    if (baseId == t.Base && room.QuoteList[baseId].Include) {
                      return true;
                    }
                  }
                }
              }
            } catch (err) {
              _iterator147.e(err);
            } finally {
              _iterator147.f();
            }
          }
        }
      } catch (err) {
        _iterator146.e(err);
      } finally {
        _iterator146.f();
      }
    }
  }, {
    key: "tripEnded",
    get: function get() {
      return this.Status == 'TRAVELED' || this.Status == 'CLOSED';
    }
  }, {
    key: "showDocumentation",
    get: function get() {
      return this.bookingConfirmed;
    }
  }, {
    key: "setPayments",
    value: function () {
      var _setPayments = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee62(id, supplierId, callback) {
        return regenerator_default().wrap(function _callee62$(_context66) {
          while (1) switch (_context66.prev = _context66.next) {
            case 0:
              _context66.next = 2;
              return api.setPayments(id, supplierId, callback);
            case 2:
            case "end":
              return _context66.stop();
          }
        }, _callee62);
      }));
      function setPayments(_x96, _x97, _x98) {
        return _setPayments.apply(this, arguments);
      }
      return setPayments;
    }()
  }, {
    key: "setReceipts",
    value: function () {
      var _setReceipts = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee63(id) {
        return regenerator_default().wrap(function _callee63$(_context67) {
          while (1) switch (_context67.prev = _context67.next) {
            case 0:
              _context67.next = 2;
              return api.setReceipts(id);
            case 2:
            case "end":
              return _context67.stop();
          }
        }, _callee63);
      }));
      function setReceipts(_x99) {
        return _setReceipts.apply(this, arguments);
      }
      return setReceipts;
    }()
  }, {
    key: "bookingTotalsTrip",
    get: function get() {
      var res = [];
      if (this.SumByType == 'ONE_TOTAL') {
        res.push({
          Price: this.currencyConvert(this.CurrencyId, this.PriceCurrencyId, this.finalTotal)
        });
        return res;
      } else if (this.SumByType == 'HOTEL_CATEGORY') {
        for (var hotelCategoryId in this.hotelCategories) {
          var price = 0;
          var paxQuant = 0;
          for (var base in this.BaseQuotes.bases) {
            if (!this.Totals[base]) continue;
            if (!this.isBaseHotelCategory(base, hotelCategoryId)) continue;
            paxQuant += this.BaseQuotes[base].ADT;
            if (this.BaseQuotes[base].CHD) paxQuant += this.BaseQuotes[base].CHD;
            if (this.BaseQuotes[base].TL) paxQuant += this.BaseQuotes[base].TL;
            var expenseByPax = this.totalPaxExpenses / paxQuant;
            if (this.QuoteBy == 'QUANTITY') expenseByPax = this.totalPaxExpenses;
            if (this.QuoteBy == 'SERVICE') expenseByPax = this.totalPaxExpenses;
            for (var pType in this.Totals[base]) {
              if (!this.Totals[base][pType]) continue;
              if (this.Totals[base][pType].Selected) {
                var q = this.BaseQuotes[base][pType];
                if (this.Totals[base][pType].Pax) {
                  q = this.Totals[base][pType].Pax;
                }
                if (this.QuoteBy == 'QUANTITY') q = 1;
                if (this.QuoteBy == 'SERVICE') q = 1;
                price += this.totals[base][pType].Price * q + expenseByPax;
              }
            }
          }
          res.push({
            Price: price,
            base: paxQuant,
            hotelCategoryId: hotelCategoryId
          });
        }
      } else {
        for (var _base in this.BaseQuotes.bases) {
          if (!this.Totals[_base]) continue;
          var paxQuantity = this.BaseQuotes[_base].ADT;
          if (this.BaseQuotes[_base].CHD) paxQuantity += this.BaseQuotes[_base].CHD;
          var text = 'based on' + ' ' + this.BaseQuotes[_base].ADT + ' ' + 'Adult';
          if (this.BaseQuotes[_base].CHD) {
            text += ' & ' + this.BaseQuotes[_base].CHD + ' ' + 'Child';
          }
          var _expenseByPax = this.totalPaxExpenses / paxQuantity;
          if (this.QuoteBy == 'QUANTITY') _expenseByPax = this.totalPaxExpenses;
          if (this.QuoteBy == 'SERVICE') _expenseByPax = this.totalPaxExpenses;
          var comments = [];
          var _price = 0;
          for (var _pType9 in this.Totals[_base]) {
            if (!this.Totals[_base][_pType9]) continue;
            if (this.Totals[_base][_pType9].Selected) {
              var _q2 = 1;
              if (this.QuoteBy == 'PERSON') {
                _q2 = this.BaseQuotes[_base][_pType9];
                if (this.Totals[_base][_pType9].Pax) {
                  _q2 = this.Totals[_base][_pType9].Pax;
                }
              }
              if (this.Totals[_base][_pType9].Comment) {
                comments.push(this.Totals[_base][_pType9].Comment);
              }
              _price += this.totals[_base][_pType9].Price * _q2 + _expenseByPax;
            }
          }
          var rooms = [];
          var _iterator148 = _createForOfIteratorHelper(this.BookingDays),
            _step148;
          try {
            for (_iterator148.s(); !(_step148 = _iterator148.n()).done;) {
              var day = _step148.value;
              if (this.hotelsByDay[day.DayNr] && this.hotelsByDay[day.DayNr].ifHotel) {
                var _iterator149 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms),
                  _step149;
                try {
                  for (_iterator149.s(); !(_step149 = _iterator149.n()).done;) {
                    var room = _step149.value;
                    var roomQuote = room.QuoteList[_base];
                    var qty = roomQuote.Rooms;
                    if (!qty) qty = room.roomsQuantity;
                    rooms.push("".concat(qty, " ").concat(room.Room.Name));
                  }
                } catch (err) {
                  _iterator149.e(err);
                } finally {
                  _iterator149.f();
                }
                break;
              }
            }
          } catch (err) {
            _iterator148.e(err);
          } finally {
            _iterator148.f();
          }
          var comment = comments.join(' / ');
          res.push({
            Price: this.currencyConvert(this.CurrencyId, this.PriceCurrencyId, _price),
            pax: paxQuantity,
            Comment: comment,
            Base: _base,
            PaxText: text,
            rooms: rooms
          });
        }
      }
      return res;
    }
  }, {
    key: "typeOfServices",
    get: function get() {
      var r = {};
      var _iterator150 = _createForOfIteratorHelper(this.BookingDays),
        _step150;
      try {
        for (_iterator150.s(); !(_step150 = _iterator150.n()).done;) {
          var day = _step150.value;
          var _res5 = [];
          var _iterator151 = _createForOfIteratorHelper(day.BookingDayServices),
            _step151;
          try {
            for (_iterator151.s(); !(_step151 = _iterator151.n()).done;) {
              var _s$ServiceType;
              var s = _step151.value;
              if (s && s.Service && s.Service.ServiceType) {
                if (_res5.indexOf(s.Service.ServiceType.Name) == -1) {
                  _res5.push(s.Service.ServiceType.Name);
                }
              }
              if (!s.ServiceId && (_s$ServiceType = s.ServiceType) !== null && _s$ServiceType !== void 0 && _s$ServiceType.Name) {
                if (_res5.indexOf(s.ServiceType.Name) == -1) {
                  _res5.push(s.ServiceType.Name);
                }
              }
            }
          } catch (err) {
            _iterator151.e(err);
          } finally {
            _iterator151.f();
          }
          if (_res5.length == 1) {
            r[day.DayNr] = _res5.join(', ');
          } else if (_res5.length > 1) {}
        }
      } catch (err) {
        _iterator150.e(err);
      } finally {
        _iterator150.f();
      }
      return r;
    }
  }, {
    key: "typeOfServicesList",
    get: function get() {
      var r = {};
      var _iterator152 = _createForOfIteratorHelper(this.BookingDays),
        _step152;
      try {
        for (_iterator152.s(); !(_step152 = _iterator152.n()).done;) {
          var day = _step152.value;
          var _res6 = [];
          var _iterator153 = _createForOfIteratorHelper(day.BookingDayServices),
            _step153;
          try {
            for (_iterator153.s(); !(_step153 = _iterator153.n()).done;) {
              var _s$ServiceType2;
              var s = _step153.value;
              if (s && s.Service && s.Service.ServiceType) {
                if (_res6.indexOf(s.Service.ServiceType.Name) == -1) {
                  _res6.push(s.Service.ServiceType.Name);
                }
              }
              if (!s.ServiceId && (_s$ServiceType2 = s.ServiceType) !== null && _s$ServiceType2 !== void 0 && _s$ServiceType2.Name) {
                if (_res6.indexOf(s.ServiceType.Name) == -1) {
                  _res6.push(s.ServiceType.Name);
                }
              }
            }
          } catch (err) {
            _iterator153.e(err);
          } finally {
            _iterator153.f();
          }
          if (_res6.length == 1) {
            r[day.DayNr] = _res6;
          } else if (_res6.length > 1) {}
        }
      } catch (err) {
        _iterator152.e(err);
      } finally {
        _iterator152.f();
      }
      return r;
    }
  }, {
    key: "isVariant",
    value: function isVariant(baseId) {
      if (!this.QuoteVariants[baseId]) return;
      if (!Object.keys(this.QuoteVariants[baseId])) return;
      if (Object.keys(this.QuoteVariants[baseId]).length == 0) return;
      return true;
    }
  }, {
    key: "hasVariants",
    get: function get() {
      for (var baseId in this.BaseQuotes.bases) {
        if (this.isVariant(baseId)) return true;
      }
      return false;
    }
  }, {
    key: "isGroup",
    value: function isGroup(baseId) {
      if (!this.QuoteGroups[baseId]) return false;
      if (!Object.keys(this.QuoteGroups[baseId])) return false;
      if (Object.keys(this.QuoteGroups[baseId]).length == 0) return false;
      return true;
    }
  }, {
    key: "hasAnyGroup",
    get: function get() {
      if (!this.QuoteGroups) return false;
      for (var baseId in this.QuoteGroups) {
        if (this.isGroup(baseId)) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "setCurrencyRates",
    value: function () {
      var _setCurrencyRates = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee64() {
        var currencyconversion, i, cc, rate, _cc;
        return regenerator_default().wrap(function _callee64$(_context68) {
          while (1) switch (_context68.prev = _context68.next) {
            case 0:
              _context68.next = 2;
              return api.getTable('currencyconversion');
            case 2:
              currencyconversion = _context68.sent;
              _context68.t0 = regenerator_default().keys(currencyconversion);
            case 4:
              if ((_context68.t1 = _context68.t0()).done) {
                _context68.next = 17;
                break;
              }
              i = _context68.t1.value;
              cc = currencyconversion[i]; //if (this.CurrencyRates[i]) continue;
              _context68.next = 9;
              return travelTools.getCurrencyRate(cc, 'sales');
            case 9:
              rate = _context68.sent;
              if (!rate) {
                _context68.next = 15;
                break;
              }
              _context68.next = 13;
              return this.CurrencyRates.newCurrencyRate({
                FromCurrencyId: rate.FromCurrencyId,
                ToCurrencyId: rate.ToCurrencyId,
                Rate: rate.ConversionRate
              });
            case 13:
              _cc = _context68.sent;
              this.CurrencyRates[i] = _cc;
            case 15:
              _context68.next = 4;
              break;
            case 17:
              return _context68.abrupt("return", true);
            case 18:
            case "end":
              return _context68.stop();
          }
        }, _callee64, this);
      }));
      function setCurrencyRates() {
        return _setCurrencyRates.apply(this, arguments);
      }
      return setCurrencyRates;
    }()
  }, {
    key: "checkServicePrice",
    value: function checkServicePrice(paxQuote, service) {
      var priceNull = paxQuote.Price === null || paxQuote.Price === undefined || paxQuote.Price === '';
      if (paxQuote.Cost && parseFloat(paxQuote.Cost) > 0 && (priceNull || parseFloat(paxQuote.Price) < parseFloat(paxQuote.Cost))) {
        return false;
      }
      return true;
    }
  }, {
    key: "checkRoomPrice",
    value: function checkRoomPrice(quote, room) {
      var priceNull = quote.Price === null || quote.Price === undefined || quote.Price === '';
      if (quote.Cost && parseFloat(quote.Cost) > 0 && (priceNull || parseFloat(quote.Price) < parseFloat(quote.Cost))) {
        return false;
      }
      return true;
    }
  }, {
    key: "bookingErrors",
    get: function get() {
      var errorsList = {};
      var hotelsByDay = this.hotelsByDay;
      if (this.isTemplate) return;
      if (this.BaseQuotes) {
        if (this.bookingConfirmed) {
          var f = this.finalTotalWithFlights;
          var quoted = this.getTotalInCurrency(this.finalTotalWithFlights);
          var receipts = this.totalToReceiptInSalesCurrency;
          var diff = Math.abs(receipts - quoted);
          var controlLimit = api.generalSettings.ControlLimit;
          if (!controlLimit) {
            controlLimit = {
              currency: 'USD',
              value: 2
            };
          }
          var value = this.currencyConvert(this.PriceCurrencyId, controlLimit.currency, diff);
          if (value > controlLimit.value) {
            var errorCode = 'receipt_pending';
            errorsList[errorCode] = {
              text: [{
                errorCode: 'QUOTED_NOT_AMOUNT_RECEIVED'
              }],
              color: 'red'
            };
          }
        }
        for (var baseId in this.BaseQuotes.bases) {
          var _iterator154 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
            _step154;
          try {
            for (_iterator154.s(); !(_step154 = _iterator154.n()).done;) {
              var _this$Totals5;
              var pType = _step154.value;
              if (!tools.isNull((_this$Totals5 = this.Totals) === null || _this$Totals5 === void 0 || (_this$Totals5 = _this$Totals5[baseId]) === null || _this$Totals5 === void 0 || (_this$Totals5 = _this$Totals5[pType]) === null || _this$Totals5 === void 0 ? void 0 : _this$Totals5.OverPrice)) {
                var _errorCode = 'over_price';
                errorsList[_errorCode] = {
                  text: [{
                    errorCode: 'OVERWRITE_PRICE'
                  }],
                  color: 'red'
                };
              }
            }
          } catch (err) {
            _iterator154.e(err);
          } finally {
            _iterator154.f();
          }
        }
      }
      for (var dayNr in this.BookingDays) {
        var day = this.BookingDays[dayNr];
        for (var sId in day.BookingDayServices) {
          var s = day.BookingDayServices[sId];
          if (!s.ServiceId && !s.CityId) {
            var cities = day.getCities(hotelsByDay[day.DayNr]);
            if (cities.length == 1) {
              s.CityId = cities[0].id;
              s.City = cities[0];
            }
          }
          if (s.Service.PaxMinQty) {
            for (var quoteId in this.BaseQuotes.bases) {
              var pax = s.paxQuantityByBase(quoteId);
              if (s.Service.PaxMinQty > pax) {
                var _errorCode2 = 'min_pax' + quoteId;
                var text = [{
                  errorCode: 'Service'
                }, "\"".concat(s.Service.Name, "\""), {
                  errorCode: 'MIN_REQUIRED'
                }, s.Service.PaxMinQty, {
                  errorCode: 'Pax'
                }];
                var error = {
                  text: text,
                  color: 'red'
                };
                errorsList[_errorCode2] = error;
              }
            }
          }
          if (s.Service && s.Service.ByWeekDay) {
            var wd = moment(day.TransDate).day() - 1;
            if (wd < 0) wd += 7;
            if (!s.Service.WeekDays[wd]) {
              var _errorCode3 = 'weekday' + day.TransDate + s.Service.id;
              var _text = [{
                errorCode: 'Service'
              }, "\"".concat(s.Service.Name, "\""), {
                errorCode: 'NOT_AVAILABLE_ON_DAYS'
              }, moment(day.TransDate).locale(api.language).format('dddd')];
              var _error = {
                text: _text,
                color: 'red'
              };
              errorsList[_errorCode3] = _error;
            }
          }
          if (s.Quote && s.Quote.QuoteList) {
            if (s.Service && s.Service.NotPrice) continue;
            for (var base in s.Quote.QuoteList) {
              var baseQuote = s.Quote.QuoteList[base];
              for (var paxType in baseQuote) {
                if (paxType != 'ADT' && paxType != 'CHD' && paxType != 'TL') continue;
                var paxQuote = baseQuote[paxType];
                //let priceNull = paxQuote.Price===null || paxQuote.Price===undefined || paxQuote.Price==='';
                //if ((paxQuote.Cost && parseFloat(paxQuote.Cost)>0) && (priceNull || (parseFloat(paxQuote.Price) < parseFloat(paxQuote.Cost)))) {
                if (!this.checkServicePrice(paxQuote, s)) {
                  var _sId = s.id || s.tempId;
                  var _errorCode4 = 'low_price' + day.TransDate + _sId + paxType;
                  var serviceName = s.Service.Name;
                  if (!serviceName) serviceName = s.Name;
                  if (!serviceName) serviceName = {
                    errorCode: '(Free)'
                  };
                  var _text2 = [{
                    errorCode: 'GROSS_SERVICE'
                  }, "\"".concat(serviceName, "\""), {
                    errorCode: 'LOWER_THAN_NET'
                  }, moment(day.TransDate).locale(api.language).format('DD MMM YY')];
                  var _error2 = {
                    text: _text2,
                    color: 'red'
                  };
                  errorsList[_errorCode4] = _error2;
                }
              }
            }
          }
          if (s.Service && s.Service.Comment) {
            var _errorCode5 = 'comment_' + s.Service.id;
            var _error3 = {
              service: "\"".concat(s.Service.Name, "\""),
              text: s.Service.Comment,
              dayNr: dayNr,
              sId: sId
            };
            errorsList[_errorCode5] = _error3;
          }
        }
        if (day.BookingDayHotels[0] && day.BookingDayHotels[0].BookingDayRooms) {
          var roomsCapacity = day.BookingDayHotels[0].roomsCapacity;
          for (var rId in day.BookingDayHotels[0].BookingDayRooms) {
            var _day$BookingDayHotels2;
            var room = day === null || day === void 0 || (_day$BookingDayHotels2 = day.BookingDayHotels) === null || _day$BookingDayHotels2 === void 0 || (_day$BookingDayHotels2 = _day$BookingDayHotels2[0]) === null || _day$BookingDayHotels2 === void 0 || (_day$BookingDayHotels2 = _day$BookingDayHotels2.BookingDayRooms) === null || _day$BookingDayHotels2 === void 0 ? void 0 : _day$BookingDayHotels2[rId];
            this.addHotelComment(room, errorsList, dayNr, rId);
            if (room.RoomTypeId && room.RoomCategory && room.Rooms) {
              if (!room.QuoteList) {
                /*let errorCode = 'not_cost_hotel' + day.TransDate + room.Hotel.id;
                errorsList[errorCode] = {text: [{errorCode: 'Hotel'}, room.Hotel.Name,
                    {errorCode: 'NOT_COST_ON_DATE'},
                    moment(day.TransDate).locale(api.language).format('DD MMM YY'),
                    {errorCode: 'ON_ROOM'}, room.Room.Name]};*/
              } else {
                for (var _baseId9 in this.BaseQuotes.bases) {
                  var quote = room.QuoteList[_baseId9];
                  /*if (!quote.Cost) {
                      let errorCode = 'not_cost_hotel' + day.TransDate + room.Hotel.id;
                      errorsList[errorCode] = {text: [{errorCode: 'Hotel'}, room.Hotel.Name,
                          {errorCode: 'NOT_COST_ON_DATE'},
                          moment(day.TransDate).locale(api.language).format('DD MMM YY'),
                          {errorCode: 'ON_ROOM'}, room.Room.Name]};
                  }*/
                  if (!quote) continue;
                  if (!quote.Include) continue;
                  //let priceNull = quote.Price===null || quote.Price===undefined || quote.Price==='';
                  //if ((quote.Cost && parseFloat(quote.Cost)>0) && (priceNull || (parseFloat(quote.Price) < parseFloat(quote.Cost)))) {
                  if (!this.checkRoomPrice(quote, room)) {
                    var _errorCode6 = 'low_price' + day.TransDate + room.HotelId + room.RoomTypeId;
                    var hotelName = room.Hotel.Name;
                    var _text3 = [{
                      errorCode: 'HOTEL_GROSS'
                    }, "\"".concat(hotelName, "\""), {
                      errorCode: 'LOWER_THAN_NET'
                    }, moment(day.TransDate).locale(api.language).format('DD MMM YY')];
                    var _error4 = {
                      text: _text3,
                      color: 'red'
                    };
                    errorsList[_errorCode6] = _error4;
                  }
                  if (this.QuoteBy == 'SERVICE') {
                    if (!roomsCapacity[_baseId9]) continue;
                    if (roomsCapacity[_baseId9].error) {
                      var _errorCode7 = 'room_pax_quantity_' + day.DayNr;
                      errorsList[_errorCode7] = {
                        text: [{
                          errorCode: 'Day'
                        }, day.DayNr + 1, {
                          errorCode: 'ROOM_PAX_QUANTITY'
                        }],
                        color: 'red'
                      };
                    }
                    if (!roomsCapacity[_baseId9].capacity) {
                      for (var groupId in roomsCapacity[_baseId9]) {
                        if (roomsCapacity[_baseId9][groupId].error) {
                          if (roomsCapacity[_baseId9][groupId].roomIds.indexOf(room._id) > -1) {
                            var _errorCode8 = 'room_pax_quantity_' + day.DayNr;
                            errorsList[_errorCode8] = {
                              text: [{
                                errorCode: 'Day'
                              }, day.DayNr + 1, {
                                errorCode: 'ROOM_PAX_QUANTITY'
                              }],
                              color: 'red'
                            };
                          }
                          ;
                        }
                      }
                    }
                  }
                }
              }
            }
            if (room.Hotel && room.Hotel.Name && !room.RoomTypeId) {
              var _errorCode9 = 'not_hotel_room' + day.DayNr;
              errorsList[_errorCode9] = {
                text: [{
                  errorCode: 'Hotel'
                }, "\"".concat(room.Hotel.Name, "\""), {
                  errorCode: 'NOT_ROOM_ASSIGNED'
                }],
                color: 'red'
              };
            }
            if (room.Hotel && room.Hotel.Name && !room.RoomCategory) {
              var _errorCode10 = 'not_hotel_room_cat' + day.DayNr;
              errorsList[_errorCode10] = {
                text: [{
                  errorCode: 'Hotel'
                }, "\"".concat(room.Hotel.Name, "\""), {
                  errorCode: 'NOT_ROOM_CAT_ASSIGNED'
                }],
                color: 'red'
              };
            }
          }
        }
        var n = parseInt(day.DayNr) + 1;
        if (hotelsByDay && !hotelsByDay[day.DayNr] && !day.PaxHotel) {
          if (n < this.daysLength) {
            var _errorCode11 = 'not_hotel_dat' + day.TransDate;
            errorsList[_errorCode11] = {
              text: [{
                errorCode: 'NO_HOTEL'
              }, n],
              color: 'red'
            };
          }
        } else if (hotelsByDay && hotelsByDay[day.DayNr]) {
          var found = false;
          var notHotel = false;
          var _iterator155 = _createForOfIteratorHelper(hotelsByDay[day.DayNr].BookingDayRooms),
            _step155;
          try {
            for (_iterator155.s(); !(_step155 = _iterator155.n()).done;) {
              var _room2 = _step155.value;
              if (!_room2.HotelId) {
                notHotel = true;
              } else {
                found = true;
              }
            }
          } catch (err) {
            _iterator155.e(err);
          } finally {
            _iterator155.f();
          }
          if (!found) {
            if (n < this.daysLength) {
              var _errorCode12 = 'not_hotel_dat' + day.TransDate;
              errorsList[_errorCode12] = {
                text: [{
                  errorCode: 'ROOM_NO_HOTEL'
                }, n],
                color: 'red'
              };
            }
          } else if (notHotel) {
            if (n < this.daysLength) {
              var _errorCode13 = 'not_hotel_room' + day.TransDate;
              errorsList[_errorCode13] = {
                text: [{
                  errorCode: 'ROOM_NO_HOTEL'
                }, n],
                color: 'red'
              };
            }
          }
        }
      }
      if (this.Status == 'QUOTE' && !this.isNew) {
        var today = new Date();
        var start = new Date(this.StartDate);
        if (start <= today) {
          var _errorCode14 = 'NOT_AVAILABLE_DATE';
          var _text4 = [{
            errorCode: 'NOT_AVAILABLE_DATE'
          }, "".concat(this.formatDate(this.StartDate))];
          var _error5 = {
            text: _text4,
            color: 'red'
          };
          errorsList[_errorCode14] = _error5;
        }
      }
      var supHotels = Object.keys(this.hotels || {});
      var supServices = Object.keys(this.suppliers || {});
      var supFlights = Object.keys(this.flights || {});
      var sups = [].concat(supHotels, supServices, supFlights);
      var _iterator156 = _createForOfIteratorHelper(api.payments),
        _step156;
      try {
        for (_iterator156.s(); !(_step156 = _iterator156.n()).done;) {
          var payment = _step156.value;
          if (payment.PaymentStatus == 'CANCELED') continue;
          var notService = false;
          if (payment.Supplier.SupplierType == 'SERVICE' && supServices[payment.SupplierId] && supServices[payment.SupplierId].Services) {
            if (supServices[payment.SupplierId].Services.length == 0) notService = true;
          }
          if (payment.Supplier.SupplierType == 'HOTEL' && supHotels[payment.SupplierId] && supHotels[payment.SupplierId].Rooms) {
            if (supHotels[payment.SupplierId].Rooms.length == 0) notService = true;
          }
          if (payment.Supplier.SupplierType == 'MIXED' && supHotels[payment.SupplierId] && supHotels[payment.SupplierId].Rooms) {
            if (supHotels[payment.SupplierId].Rooms.length == 0) notService = true;
          }
          if (payment.Supplier.SupplierType == 'FLIGHTS' && supFlights[payment.SupplierId] && supFlights[payment.SupplierId].Flights) {
            if (supFlights[payment.SupplierId].Flights.length == 0) notService = true;
          }
          /*if (payment.Supplier.SupplierType == 'ALL') {
              if (supHotels[payment.SupplierId] && supHotels[payment.SupplierId].Rooms && supHotels[payment.SupplierId].Rooms.length == 0 
                  && supFlights[payment.SupplierId] && supFlights[payment.SupplierId].Flights && supFlights[payment.SupplierId].Flights.length == 0 
                  && supServices[payment.SupplierId] && supServices[payment.SupplierId].Services && supServices[payment.SupplierId].Services.length == 0) notService = true;
          }*/

          if (notService) {
            var _errorCode15 = 'not_service ' + payment.SupplierId;
            errorsList[_errorCode15] = {
              text: [{
                errorCode: 'Supplier'
              }, payment.Supplier.Name, {
                errorCode: 'UNLINKED_SERVICE_PAYMENT'
              }],
              color: 'red'
            };
          }
        }
      } catch (err) {
        _iterator156.e(err);
      } finally {
        _iterator156.f();
      }
      return errorsList;
    }
  }, {
    key: "addHotelComment",
    value: function addHotelComment(room, errorsList, dayNr, sId) {}
  }, {
    key: "hasErrors",
    get: function get() {
      var self = this;
      var errors = _.filter(this.bookingErrors, function (r) {
        if (!r.dayNr) return true;
        var day = self.getDay(r.dayNr);
        if (!day) return;
        if (r.sId && day.BookingDayServices[r.sId]) {
          if (!day.BookingDayServices[r.sId].ServiceCommentReaded && !day.BookingDayServices[r.sId].ServiceCommentDeleted) {
            return true;
          }
        }
      });
      return errors.length > 0;
    }
  }, {
    key: "totalReceipts",
    value: function totalReceipts(receipts) {
      var res = 0;
      var _iterator157 = _createForOfIteratorHelper(receipts),
        _step157;
      try {
        for (_iterator157.s(); !(_step157 = _iterator157.n()).done;) {
          var receipt = _step157.value;
          if (receipt.Amount) {
            res += this.currencyConvert(receipt.CurrencyId, this.CurrencyId, parseFloat(receipt.Amount));
          }
        }
      } catch (err) {
        _iterator157.e(err);
      } finally {
        _iterator157.f();
      }
      return res;
    }
  }, {
    key: "totalReceiptsInSalesCurrency",
    get: function get() {
      var res = 0;
      var _iterator158 = _createForOfIteratorHelper(api.receipts),
        _step158;
      try {
        for (_iterator158.s(); !(_step158 = _iterator158.n()).done;) {
          var receipt = _step158.value;
          if (receipt.PaymentStatus == 'CANCELED') continue;
          var amount = void 0;
          if (receipt.ReceivedAmount) {
            res += this.currencyConvert(receipt.ReceivedCurrencyId, this.PriceCurrencyId, parseFloat(receipt.ReceivedAmount));
          } else if (receipt.Amount) {
            res += this.currencyConvert(receipt.CurrencyId, this.PriceCurrencyId, parseFloat(receipt.Amount));
          }
        }
      } catch (err) {
        _iterator158.e(err);
      } finally {
        _iterator158.f();
      }
      return res;
    }
  }, {
    key: "totalToReceiptInSalesCurrency",
    get: function get() {
      var res = 0;
      var _iterator159 = _createForOfIteratorHelper(api.receipts),
        _step159;
      try {
        for (_iterator159.s(); !(_step159 = _iterator159.n()).done;) {
          var receipt = _step159.value;
          if (receipt.PaymentStatus == 'CANCELED') continue;
          if (receipt.Amount) {
            res += this.currencyConvert(receipt.CurrencyId, this.PriceCurrencyId, parseFloat(receipt.Amount));
          }
        }
      } catch (err) {
        _iterator159.e(err);
      } finally {
        _iterator159.f();
      }
      return res;
    }
  }, {
    key: "addNewFlight",
    value: function () {
      var _addNewFlight = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee65(salesActions) {
        var flight, baseId, row;
        return regenerator_default().wrap(function _callee65$(_context69) {
          while (1) switch (_context69.prev = _context69.next) {
            case 0:
              flight = {
                Input: null,
                Output: null,
                Supplier: {}
              };
              if (!salesActions) {
                flight.QuoteType = 'NOT_INCLUDED';
              }
              flight.QuoteList = {};
              for (baseId in this.BaseQuotes.bases) {
                flight.QuoteList[baseId] = {
                  Include: true
                };
              }
              _context69.next = 6;
              return this.addRow({
                fieldName: 'BookingFlights',
                values: flight
              });
            case 6:
              row = _context69.sent;
              row.QuoteList.setGroups();
              row.QuoteList.setVariants();
            case 9:
            case "end":
              return _context69.stop();
          }
        }, _callee65, this);
      }));
      function addNewFlight(_x100) {
        return _addNewFlight.apply(this, arguments);
      }
      return addNewFlight;
    }()
  }, {
    key: "suppliers",
    get: function get() {
      var res = {};
      if (!this.BookingDays) return res;
      var _iterator160 = _createForOfIteratorHelper(this.BookingDays),
        _step160;
      try {
        for (_iterator160.s(); !(_step160 = _iterator160.n()).done;) {
          var day = _step160.value;
          var _iterator163 = _createForOfIteratorHelper(day.BookingDayServices),
            _step163;
          try {
            for (_iterator163.s(); !(_step163 = _iterator163.n()).done;) {
              var service = _step163.value;
              if (service.Optional) continue;
              if (service.Service && service.Service.NotPrice) continue;
              var supplierId = service.SupplierId;
              var supplier = service.Supplier;
              if (!supplierId) {
                supplierId = -1;
                supplier = {
                  Name: tr('None Supplier')
                };
              }
              if (supplierId) {
                if (!res[supplierId]) {
                  res[supplierId] = {
                    Supplier: supplier,
                    Services: []
                  };
                  var r = this.supplierTotal(supplierId);
                  res[supplierId].Totals = r;
                }
                res[supplierId].Services.push(service);
              }
            }
          } catch (err) {
            _iterator163.e(err);
          } finally {
            _iterator163.f();
          }
        }
      } catch (err) {
        _iterator160.e(err);
      } finally {
        _iterator160.f();
      }
      if (this.bookingConfirmed) {
        var _iterator161 = _createForOfIteratorHelper(api.payments),
          _step161;
        try {
          for (_iterator161.s(); !(_step161 = _iterator161.n()).done;) {
            var payment = _step161.value;
            if (this.versionDate && payment.CreatedUTC > this.versionDate) continue;
            if (payment.Supplier && payment.Supplier.SupplierType == 'SERVICE' && !res[payment.SupplierId]) {
              res[payment.SupplierId] = {
                Supplier: payment.Supplier,
                Services: [],
                Totals: {
                  Price: 0,
                  Cost: 0
                }
              };
            }
          }
        } catch (err) {
          _iterator161.e(err);
        } finally {
          _iterator161.f();
        }
        var _iterator162 = _createForOfIteratorHelper(api.supplierCredits),
          _step162;
        try {
          for (_iterator162.s(); !(_step162 = _iterator162.n()).done;) {
            var credit = _step162.value;
            if (this.versionDate && credit.CreatedUTC > this.versionDate) continue;
            if (credit.Supplier && credit.Supplier.SupplierType == 'SERVICE' && !res[credit.SupplierId]) {
              res[credit.SupplierId] = {
                Supplier: credit.Supplier,
                Services: [],
                Totals: {
                  Price: 0,
                  Cost: 0
                }
              };
            }
          }
        } catch (err) {
          _iterator162.e(err);
        } finally {
          _iterator162.f();
        }
      }
      if (res[-1] && !res[-1].Totals.Cost && !res[-1].Totals.Price) delete res[-1];
      return res;
    }
  }, {
    key: "supplierTotal",
    value: function supplierTotal(supplierId) {
      var res = {
        Cost: 0,
        Price: 0
      };
      if (!this.BookingDays) {
        return res;
      }
      var _iterator164 = _createForOfIteratorHelper(this.BookingDays),
        _step164;
      try {
        for (_iterator164.s(); !(_step164 = _iterator164.n()).done;) {
          var day = _step164.value;
          var _iterator165 = _createForOfIteratorHelper(day.BookingDayServices),
            _step165;
          try {
            for (_iterator165.s(); !(_step165 = _iterator165.n()).done;) {
              var s = _step165.value;
              if (s.Optional) continue;
              var sId = s.SupplierId;
              if (!sId) sId = -1;
              if (sId != supplierId) continue;
              if (s.Status == 'CANCELED') continue;
              if (sId == -1 && this.Status == 'CANCELED') continue;
              var sCost = s.serviceTotal;
              if (!sCost) continue;
              if (!tools.isNull(sCost.Cost)) res.Cost += sCost.Cost;
              if (!tools.isNull(sCost.Price)) res.Price += sCost.Price;
            }
          } catch (err) {
            _iterator165.e(err);
          } finally {
            _iterator165.f();
          }
        }
      } catch (err) {
        _iterator164.e(err);
      } finally {
        _iterator164.f();
      }
      return res;
    }
  }, {
    key: "hotels",
    get: function get() {
      var res = {};
      var _iterator166 = _createForOfIteratorHelper(this.BookingDays),
        _step166;
      try {
        for (_iterator166.s(); !(_step166 = _iterator166.n()).done;) {
          var day = _step166.value;
          if (day.BookingDayHotels[0]) {
            var _iterator169 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms),
              _step169;
            try {
              for (_iterator169.s(); !(_step169 = _iterator169.n()).done;) {
                var room = _step169.value;
                if (!room.HotelId) continue;
                if (!room.Hotel) continue;
                if (!room.Hotel.id) continue;
                if (!room.QuoteList) continue;
                var found = void 0;
                for (var baseId in room.QuoteList.bases) {
                  var quote = room.QuoteList[baseId];
                  if (quote.Include) found = true;
                }
                if (!found) continue;
                var supplier = room.Hotel.Supplier;
                if (room.SupplierId && room.Supplier && room.SupplierId != room.Hotel.Supplier.id) {
                  supplier = room.Supplier;
                }
                if (!supplier) continue;
                if (!res[supplier.id]) {
                  res[supplier.id] = {
                    Rooms: [],
                    Supplier: supplier
                  };
                }
                var roomData = tools.deepCloneWithParent(room);
                roomData.DayNr = day.DayNr;
                roomData.TransDate = day.TransDate;
                roomData.nights = day.BookingDayHotels[0].Days;
                res[supplier.id].Rooms.push(roomData);
              }
            } catch (err) {
              _iterator169.e(err);
            } finally {
              _iterator169.f();
            }
          }
        }
      } catch (err) {
        _iterator166.e(err);
      } finally {
        _iterator166.f();
      }
      if (this.bookingConfirmed) {
        var _iterator167 = _createForOfIteratorHelper(api.payments),
          _step167;
        try {
          for (_iterator167.s(); !(_step167 = _iterator167.n()).done;) {
            var payment = _step167.value;
            if (this.versionDate && payment.CreatedUTC > this.versionDate) continue;
            if (payment.Supplier && (payment.Supplier.SupplierType == 'HOTEL' || payment.Supplier.SupplierType == 'MIXED') && !res[payment.SupplierId]) {
              var _sup$Services;
              var flight = this.flights[payment.SupplierId];
              if (flight) continue;
              var sup = this.suppliers[payment.SupplierId];
              if (!sup || (sup === null || sup === void 0 || (_sup$Services = sup.Services) === null || _sup$Services === void 0 ? void 0 : _sup$Services.length) == 0) {
                res[payment.SupplierId] = {
                  Supplier: payment.Supplier,
                  Rooms: [],
                  Totals: {
                    Price: 0,
                    Cost: 0
                  }
                };
              }
            }
          }
        } catch (err) {
          _iterator167.e(err);
        } finally {
          _iterator167.f();
        }
        var _iterator168 = _createForOfIteratorHelper(api.supplierCredits),
          _step168;
        try {
          for (_iterator168.s(); !(_step168 = _iterator168.n()).done;) {
            var credit = _step168.value;
            if (this.versionDate && credit.CreatedUTC > this.versionDate) continue;
            if (credit.Supplier && (credit.Supplier.SupplierType == 'HOTEL' || credit.Supplier.SupplierType == 'MIXED') && !res[credit.SupplierId]) {
              var _sup$Services2;
              var _flight = this.flights[credit.SupplierId];
              if (_flight) continue;
              var _sup = this.suppliers[credit.SupplierId];
              if (!_sup || (_sup === null || _sup === void 0 || (_sup$Services2 = _sup.Services) === null || _sup$Services2 === void 0 ? void 0 : _sup$Services2.length) == 0) {
                res[credit.SupplierId] = {
                  Supplier: credit.Supplier,
                  Rooms: [],
                  Totals: {
                    Price: 0,
                    Cost: 0
                  }
                };
              }
            }
          }
        } catch (err) {
          _iterator168.e(err);
        } finally {
          _iterator168.f();
        }
      }
      return res;
    }
  }, {
    key: "flights",
    get: function get() {
      var res = {};
      var _iterator170 = _createForOfIteratorHelper(this.BookingFlights),
        _step170;
      try {
        for (_iterator170.s(); !(_step170 = _iterator170.n()).done;) {
          var flight = _step170.value;
          if (!flight.SupplierId && !flight.FlightCost && !flight.FlightPrice) continue;
          var sId = flight.SupplierId;
          var supplier = flight.Supplier;
          if (!sId) {
            sId = -1;
            supplier = {
              Name: tr('None Supplier')
            };
          }
          ;
          if (sId) {
            if (!res[sId]) {
              res[sId] = {
                Supplier: supplier,
                Flights: [],
                Totals: {
                  Cost: 0
                }
              };
            }
            res[sId].Flights.push(flight);
          }
        }
      } catch (err) {
        _iterator170.e(err);
      } finally {
        _iterator170.f();
      }
      var _iterator171 = _createForOfIteratorHelper(api.payments),
        _step171;
      try {
        for (_iterator171.s(); !(_step171 = _iterator171.n()).done;) {
          var payment = _step171.value;
          if (payment.Supplier && payment.Supplier.SupplierType == 'FLIGHTS' && !res[payment.SupplierId]) {
            if (!this.suppliers[payment.SupplierId]) {
              res[payment.SupplierId] = {
                Supplier: payment.Supplier,
                Flights: [],
                Totals: {
                  Price: 0,
                  Cost: 0
                }
              };
            }
          }
        }
      } catch (err) {
        _iterator171.e(err);
      } finally {
        _iterator171.f();
      }
      var _iterator172 = _createForOfIteratorHelper(api.supplierCredits),
        _step172;
      try {
        for (_iterator172.s(); !(_step172 = _iterator172.n()).done;) {
          var credit = _step172.value;
          if (credit.Supplier && credit.Supplier.SupplierType == 'FLIGHTS' && !res[credit.SupplierId]) {
            if (!this.suppliers[credit.SupplierId]) {
              res[credit.SupplierId] = {
                Supplier: credit.Supplier,
                Flights: [],
                Totals: {
                  Price: 0,
                  Cost: 0
                }
              };
            }
          }
        }
      } catch (err) {
        _iterator172.e(err);
      } finally {
        _iterator172.f();
      }
      return res;
    }
  }, {
    key: "totalFlights",
    get: function get() {
      var res = {
        Cost: 0,
        Price: 0
      };
      var flights = this.totalFlightBySuppliers;
      for (var id in flights) {
        if (!this.supplierSummary[id]) continue;
        res.Cost += this.supplierSummary[id].amount;
        res.Price += flights[id].Price;
      }
      return res;
    }
  }, {
    key: "totalFlightBySuppliers",
    get: function get() {
      var res = {};
      if (!this.BookingFlights) return res;
      var _iterator173 = _createForOfIteratorHelper(this.paxTypes),
        _step173;
      try {
        for (_iterator173.s(); !(_step173 = _iterator173.n()).done;) {
          var pType = _step173.value;
          var _iterator174 = _createForOfIteratorHelper(this.BookingFlights),
            _step174;
          try {
            for (_iterator174.s(); !(_step174 = _iterator174.n()).done;) {
              var flight = _step174.value;
              if (!flight.FlightCost && !flight.FlightPrice) continue;
              var sId = flight.SupplierId;
              if (!sId) sId = -1;
              if (this.hasChildFlight && pType != flight.PaxType) continue;
              //if (!flight.SupplierId) continue
              if (!res[sId]) res[sId] = {
                Cost: 0,
                Price: 0,
                CurrencyId: flight.CurrencyId
              };
              for (var baseId in this.BaseQuotes.bases) {
                if (!flight.QuoteList[baseId] || !flight.QuoteList[baseId].Include) continue;
                if (this.isGroup(baseId)) {
                  var totals = this.totalsFlightsGroups(baseId, flight, pType);
                  res[sId].Cost += this.currencyConvert(flight.CurrencyId, this.CurrencyId, totals.Cost);
                  res[sId].Price += this.currencyConvert(flight.CurrencyId, this.CurrencyId, totals.Price);
                } else {
                  //if (this.Totals[baseId] && this.Totals[baseId][pType] && this.Totals[baseId][pType].Selected) {
                  if (this.isQuoteSelected(baseId, pType)) {
                    var pax = this.BaseQuotes[baseId][pType];
                    if (this.QuoteBy == 'PERSON' && this.Totals[baseId][pType].Pax) pax = parseInt(this.Totals[baseId][pType].Pax);
                    //if (this.QuoteBy == 'QUANTITY') pax = 1;
                    //if (flight.PricePer == 'GROUP') pax = 1;
                    if (!pax) continue;
                    if (flight.FlightPrice) {
                      var fPrice = flight.getFlightPrice(baseId);
                      res[sId].Price += this.currencyConvert(flight.CurrencyId, this.CurrencyId, fPrice) * pax;
                    }
                    if (flight.FlightCost && this.variantSelected(baseId, pType, flight.QuoteList[baseId])) {
                      var fCost = flight.getFlightCost(baseId);
                      res[sId].Cost += this.currencyConvert(flight.CurrencyId, this.CurrencyId, fCost) * pax;
                    }
                  }
                }
              }
            }
          } catch (err) {
            _iterator174.e(err);
          } finally {
            _iterator174.f();
          }
        }
      } catch (err) {
        _iterator173.e(err);
      } finally {
        _iterator173.f();
      }
      for (var supplierId in this.flights) {
        //if (!this.flights[supplierId].Totals) continue;
        //if (!this.flights[supplierId].Totals.Cost && !this.flights[supplierId].Totals.Price) continue;
        if (!res[supplierId]) res[supplierId] = {
          Cost: 0,
          Price: 0
        };
      }
      return res;
    }
  }, {
    key: "totalPaxFlightBySuppliers",
    get: function get() {
      var res = {};
      if (!this.BookingFlights) return res;
      var _iterator175 = _createForOfIteratorHelper(this.paxTypes),
        _step175;
      try {
        for (_iterator175.s(); !(_step175 = _iterator175.n()).done;) {
          var pType = _step175.value;
          var _iterator176 = _createForOfIteratorHelper(this.BookingFlights),
            _step176;
          try {
            for (_iterator176.s(); !(_step176 = _iterator176.n()).done;) {
              var flight = _step176.value;
              if (!flight.FlightCost && !flight.FlightPrice) continue;
              var sId = flight.SupplierId;
              if (!sId) sId = -1;
              if (this.hasChildFlight && pType != flight.PaxType) continue;
              if (!res[sId]) res[sId] = 0;
              for (var baseId in this.BaseQuotes.bases) {
                if (!flight.QuoteList[baseId] || !flight.QuoteList[baseId].Include) continue;
                if (this.isGroup(baseId)) {
                  var pax = this.totalsPaxFlightsGroups(baseId, flight, pType);
                  res[sId] += pax;
                } else {
                  if (this.isQuoteSelected(baseId, pType)) {
                    var _pax5 = this.BaseQuotes[baseId][pType];
                    if (this.QuoteBy == 'PERSON' && this.Totals[baseId][pType].Pax) _pax5 = parseInt(this.Totals[baseId][pType].Pax);
                    if (!_pax5) continue;
                    res[sId] += _pax5;
                  }
                }
              }
            }
          } catch (err) {
            _iterator176.e(err);
          } finally {
            _iterator176.f();
          }
        }
      } catch (err) {
        _iterator175.e(err);
      } finally {
        _iterator175.f();
      }
      for (var supplierId in this.flights) {
        if (!res[supplierId]) res[supplierId] = 0;
      }
      return res;
    }
  }, {
    key: "extraSupplier",
    get: function get() {
      if (!this.bookingConfirmed) return {};
      var supplierIds = _.union(Object.keys(this.suppliers), Object.keys(this.hotels), Object.keys(this.flights));
      var res = {};
      var _iterator177 = _createForOfIteratorHelper(api.payments),
        _step177;
      try {
        for (_iterator177.s(); !(_step177 = _iterator177.n()).done;) {
          var p = _step177.value;
          if (this.versionDate && p.CreatedUTC > this.versionDate) continue;
          if (!p.Supplier || !p.Supplier.id) continue;
          if (supplierIds.indexOf(p.Supplier.id.toString()) == -1) {
            res[p.Supplier.id] = {
              Supplier: p.Supplier
            };
          }
        }
      } catch (err) {
        _iterator177.e(err);
      } finally {
        _iterator177.f();
      }
      return res;
    }
  }, {
    key: "quoted",
    get: function get() {
      if (this._cache && this._cache.quoted) {
        return this._cachedQuoted;
      }
      if (this._cache) this._cache.quoted = true;
      //console.log('$$_quoted')
      //let t1 = moment(new Date()).valueOf();
      var res = {};
      for (var id in this.suppliers) {
        var supplier = this.suppliers[id];
        if (!res[id]) {
          res[id] = {
            Cost: 0,
            Price: 0
          };
        }
        if (this.CurrencyId == this.SummaryCurrencyId) {
          res[id].Cost += parseFloat(supplier.Totals.Cost);
          res[id].Price += parseFloat(supplier.Totals.Price);
        } else {
          res[id].Cost += this.currencyConvert(this.CurrencyId, this.SummaryCurrencyId, supplier.Totals.Cost);
          res[id].Price += this.currencyConvert(this.CurrencyId, this.SummaryCurrencyId, supplier.Totals.Price);
        }
      }
      for (var _id in this.hotels) {
        var hotel = this.hotels[_id];
        if (!res[_id]) {
          res[_id] = {
            Cost: 0,
            Price: 0
          };
        }
        var _iterator178 = _createForOfIteratorHelper(hotel.Rooms),
          _step178;
        try {
          for (_iterator178.s(); !(_step178 = _iterator178.n()).done;) {
            var room = _step178.value;
            var roomId = room.id;
            if (!roomId) roomId = room.tempId;
            if (!roomId) continue;
            if (!this.totalsByHotelByRoom[room.HotelId]) continue;
            var r = this.totalsByHotelByRoom[room.HotelId][roomId];
            if (!this.totalsByHotelByRoom[room.HotelId]) continue;
            if (!this.totalsByHotelByRoom[room.HotelId][roomId]) continue;
            if (this.totalsByHotelByRoom[room.HotelId][roomId].Status == 'CANCELED') continue;
            if (this.CurrencyId == this.SummaryCurrencyId) {
              res[_id].Cost += r.Cost;
              res[_id].Price += r.Price;
            } else {
              res[_id].Cost += this.currencyConvert(this.CurrencyId, this.SummaryCurrencyId, r.Cost);
              res[_id].Price += this.currencyConvert(this.CurrencyId, this.SummaryCurrencyId, r.Price);
            }
          }
        } catch (err) {
          _iterator178.e(err);
        } finally {
          _iterator178.f();
        }
      }
      for (var _id2 in this.totalFlightBySuppliers) {
        if (!res[_id2]) {
          res[_id2] = {
            Cost: 0,
            Price: 0
          };
        }
        var flight = this.totalFlightBySuppliers[_id2];
        res[_id2].Cost += this.currencyConvert(this.CurrencyId, this.SummaryCurrencyId, flight.Cost);
        res[_id2].Price += this.currencyConvert(this.CurrencyId, this.SummaryCurrencyId, flight.Price);
      }
      for (var _id3 in this.extraSupplier) {
        res[_id3] = {
          Cost: 0,
          Price: 0
        };
      }
      if (res[-1] && !res[-1].Cost && !res[-1].Price) delete res[-1];
      this._cachedQuoted = res;
      return res;
    }
  }, {
    key: "totalExpenses",
    get: function get() {
      var _this6 = this;
      var res = 0;
      var _iterator179 = _createForOfIteratorHelper(this.BookingExpenses),
        _step179;
      try {
        var _loop9 = function _loop9() {
            var r = _step179.value;
            if (r.Type != 'NOT_PAX') return 0; // continue
            if (!r.Amount) return 0; // continue
            if (r.ExpenseType && r.ExpenseType.NotCloseApply) return 0; // continue
            if (r.CurrencyId == _this6.SummaryCurrencyId) {
              res += parseFloat(r.Amount);
            } else {
              var rate = r.CurrencyRate;
              if (!rate) {
                res += _this6.currencyConvert(r.CurrencyId, _this6.SummaryCurrencyId, r.Amount);
              } else {
                var currency = _.find(api.tables.currency, function (c) {
                  return c.id == r.CurrencyId;
                });
                //let currency = await api.getTableId('currency', r.CurrencyId);
                if (currency) {
                  var cc;
                  if (currency.Operation != 'DIVIDE') {
                    cc = {
                      FromCurrencyId: r.CurrencyId,
                      ToCurrencyId: _this6.SummaryCurrencyId,
                      Rate: rate
                    };
                  } else {
                    cc = {
                      FromCurrencyId: _this6.SummaryCurrencyId,
                      ToCurrencyId: r.CurrencyId,
                      Rate: rate
                    };
                  }
                  res += travelTools.currencyConvert(r.CurrencyId, _this6.SummaryCurrencyId, r.Amount, {
                    0: cc
                  });
                } else {
                  if (rate && r.CurrencyId == api.baseCurrency.BookingCurrency) {
                    res += parseFloat(r.Amount) * parseFloat(rate);
                  } else if (rate && r.CurrencyId == api.baseCurrency.BaseCurrency) {
                    res += parseFloat(r.Amount) / parseFloat(rate);
                  }
                }
              }
            }
          },
          _ret;
        for (_iterator179.s(); !(_step179 = _iterator179.n()).done;) {
          _ret = _loop9();
          if (_ret === 0) continue;
        }
      } catch (err) {
        _iterator179.e(err);
      } finally {
        _iterator179.f();
      }
      return res;
    }
  }, {
    key: "allSuppliers",
    get: function get() {
      var res = {};
      for (var id in this.suppliers) {
        res[id] = this.suppliers[id].Supplier;
      }
      for (var _id4 in this.hotels) {
        var hotel = this.hotels[_id4];
        if (!res[hotel.Supplier.id]) {
          res[hotel.Supplier.id] = hotel.Supplier;
        }
      }
      for (var _id5 in this.flights) {
        //if (!this.flights[id].Totals) continue;
        //if (!this.flights[id].Totals.Cost && !this.flights[id].Totals.Price) continue;
        if (!res[_id5]) {
          res[_id5] = this.flights[_id5].Supplier;
        }
      }
      for (var _id6 in this.extraSupplier) {
        if (!res[_id6]) {
          res[_id6] = this.extraSupplier[_id6].Supplier;
        }
      }
      if (res[-1] && !this.supplierSummary[-1]) delete res[-1];
      return res;
    }
  }, {
    key: "paidErrors",
    get: function get() {
      var res = {};
      for (var id in this.quoted) {
        res[id] = this.toPay(id, false, true).options.errors;
      }
      return res;
    }
  }, {
    key: "totalToPay",
    get: function get() {
      var res = {};
      for (var id in this.quoted) {
        res[id] = this.toPay(id).amount;
      }
      return res;
    }
  }, {
    key: "totalPaid",
    get: function get() {
      var res = {};
      for (var id in this.quoted) {
        res[id] = this.toPay(id, true).amount;
      }
      return res;
    }
  }, {
    key: "supplierSummary",
    get: function get() {
      var res = {};
      for (var id in this.quoted) {
        res[id] = this.toPay(id, false, true, this.quoted[id].Cost);
      }
      return res;
    }
  }, {
    key: "profitPercent",
    get: function get() {
      return this.profit / this.finalCost * 100;
    }
  }, {
    key: "finalCost",
    get: function get() {
      var res = 0;
      for (var id in this.quoted) {
        res += this.supplierSummary[id].amount;
      }
      res += this.totalExpenses;
      return res;
    }
  }, {
    key: "bookingReceipts",
    get: function get() {
      var res = {};
      var _iterator180 = _createForOfIteratorHelper(api.receipts),
        _step180;
      try {
        for (_iterator180.s(); !(_step180 = _iterator180.n()).done;) {
          var r = _step180.value;
          if (r.PaymentStatus == 'CANCELED') continue;
          if (this.versionDate && r.CreatedUTC > this.versionDate) continue;
          var rate = void 0;
          if (api.baseCurrency.BookingCurrency == r.ReceivedCurrencyId) {
            rate = r.CurrencyRate;
          } else {
            rate = 1 / r.CurrencyRate;
          }
          var cc = {
            FromCurrencyId: r.ReceivedCurrencyId,
            ToCurrencyId: this.SummaryCurrencyId,
            Rate: rate
          };
          var p = {
            id: r.id,
            amount: 0,
            CurrencyId: r.CurrencyId,
            ReceivedCurrencyId: r.ReceivedCurrencyId,
            Amount: this.currencyConvert(r.CurrencyId, this.SummaryCurrencyId, parseFloat(r.Amount)),
            ReceivedAmount: travelTools.currencyConvert(r.ReceivedCurrencyId, this.SummaryCurrencyId, parseFloat(r.ReceivedAmount), [cc])
          };
          if (r.Amount) {
            p.amount = p.Amount;
          }
          if (r.ReceivedAmount) {
            p.amount = p.ReceivedAmount;
          }
          if (!p.Amount) p.Amount = 0;
          if (!p.ReceivedAmount) p.ReceivedAmount = 0;
          res[r.id] = p;
        }
      } catch (err) {
        _iterator180.e(err);
      } finally {
        _iterator180.f();
      }
      return res;
    }
  }, {
    key: "finalIncomes",
    get: function get() {
      var res = 0;
      if (this.bookingConfirmed) {
        for (var id in this.bookingReceipts) {
          res += this.bookingReceipts[id].amount;
        }
      }
      if (res == 0) {
        return this.currencyConvert(this.CurrencyId, this.SummaryCurrencyId, this.finalTotalWithFlights);
      }
      return res;
    }
  }, {
    key: "profit",
    get: function get() {
      return this.finalIncomes - this.finalCost;
    }
  }, {
    key: "getPayments",
    value: function getPayments(supplierId) {
      return _.filter(api.payments, function (p) {
        return p.SupplierId == supplierId;
      });
    }
  }, {
    key: "getSupplierCredits",
    value: function getSupplierCredits(supplierId) {
      return _.filter(api.supplierCredits, function (p) {
        return p.SupplierId == supplierId;
      });
    }
  }, {
    key: "toPay",
    value: function toPay(supplierId, paid, getTotal, cost) {
      var options = {
        cost: false,
        toPay: false,
        paid: false,
        errors: []
      };
      var res = 0;
      var payments = this.getPayments(supplierId);
      var supplierCredits = this.getSupplierCredits(supplierId);
      payments = [].concat((0,toConsumableArray/* default */.A)(payments), (0,toConsumableArray/* default */.A)(supplierCredits));
      if ((!payments || payments.length == 0 || !this.bookingConfirmed) && getTotal) {
        options.cost = true;
        res = cost;
      }
      var _iterator181 = _createForOfIteratorHelper(payments),
        _step181;
      try {
        for (_iterator181.s(); !(_step181 = _iterator181.n()).done;) {
          var payment = _step181.value;
          if (!this.bookingConfirmed) continue;
          if (this.versionDate && payment.CreatedUTC > this.versionDate) continue;
          if (getTotal && payment.PaymentStatus == 'USED' && (!payment.PaymentAmount || payment.PaymentAmount == 0)) continue;
          if (payment.PaymentStatus == 'CANCELED') continue;
          //let paidNull = toos.isNull(payment.PaymentAmount);
          if ((getTotal || paid) && payment.PaymentAmount) {
            if (payment.PaymentCurrencyId == this.SummaryCurrencyId) {
              options.paid = true;
              res += parseFloat(payment.PaymentAmount);
            } else if (payment.getCurrencyRate) {
              options.paid = true;
              var value = payment.PaymentAmount;
              var v = void 0;
              if (payment.FromCurrencyId && payment.ToCurrencyId) {
                if (payment.FromCurrencyId == this.SummaryCurrencyId) {
                  v = parseFloat(value) / parseFloat(payment.getCurrencyRate);
                } else if (payment.ToCurrencyId == this.SummaryCurrencyId) {
                  v = parseFloat(value) * parseFloat(payment.getCurrencyRate);
                }
              } else if (payment.PaymentCurrency && payment.PaymentCurrency.CurrencyConvertId) {
                if (payment.PaymentCurrency.Operation == 'DIVIDE') {
                  v = parseFloat(value) / parseFloat(payment.getCurrencyRate);
                } else if (payment.PaymentCurrency.Operation == 'MULTIPLY') {
                  v = parseFloat(value) * parseFloat(payment.getCurrencyRate);
                }
              }
              if (v) {
                res += v;
              }
            } else if (!payment.getCurrencyRate) {
              options.errors.push(['Payment', payment.id, 'has not Currency Rate']);
              options.paid = true;
              var _value = payment.PaymentAmount;
              var _v3 = this.currencyConvert(payment.CurrencyId, this.SummaryCurrencyId, parseFloat(_value));
              if (_v3) {
                res += _v3;
              }
            }
          } else if ((!paid || getTotal) && payment.Amount) {
            if (!getTotal && payment.PaymentStatus == 'ON_ACCOUNT') continue;
            options.toPay = true;
            if (payment.CurrencyId == this.SummaryCurrencyId) {
              res += parseFloat(payment.getAmount);
            } else if (payment.getCurrencyRate) {
              var _value2 = payment.getAmount;
              var _v4 = void 0;
              if (payment.FromCurrencyId && payment.ToCurrencyId) {
                if (payment.FromCurrencyId == this.SummaryCurrencyId && payment.ToCurrencyId == payment.CurrencyId) {
                  _v4 = parseFloat(_value2) / parseFloat(payment.getCurrencyRate);
                } else if (payment.ToCurrencyId == this.SummaryCurrencyId && payment.FromCurrencyId == payment.CurrencyId) {
                  _v4 = parseFloat(_value2) * parseFloat(payment.getCurrencyRate);
                } else {
                  _v4 = this.currencyConvert(payment.CurrencyId, this.SummaryCurrencyId, parseFloat(_value2));
                }
              } else if (payment.PaymentCurrency && payment.PaymentCurrency.CurrencyConvertId) {
                if (payment.PaymentCurrency.Operation == 'DIVIDE') {
                  _v4 = parseFloat(_value2) / parseFloat(payment.getCurrencyRate);
                } else if (payment.PaymentCurrency.Operation == 'MULTIPLY') {
                  _v4 = parseFloat(_value2) * parseFloat(payment.getCurrencyRate);
                }
              }
              if (_v4) {
                res += _v4;
              }
            } else if (!payment.getCurrencyRate) {
              options.errors.push(['Payment', payment.id, 'has not Currency Rate']);
              var _value3 = payment.getAmount;
              var _v5 = this.currencyConvert(payment.CurrencyId, this.SummaryCurrencyId, parseFloat(_value3));
              if (_v5) {
                res += _v5;
              }
            } else {
              var _value4 = payment.getAmount;
              var _v6 = this.currencyConvert(payment.CurrencyId, this.SummaryCurrencyId, _value4);
              if (_v6) {
                res += _v6;
              }
            }
          }
        }
      } catch (err) {
        _iterator181.e(err);
      } finally {
        _iterator181.f();
      }
      if ((res === undefined || res === null) && cost) {
        res = cost;
      }
      return {
        amount: res,
        options: options
      };
    }
  }, {
    key: "getName",
    get: function get() {
      var r = this.PaxName;
      if (this.isTemplate) {
        return this.Title;
      }
      if (this.Title) r = "".concat(r, " - ").concat(this.Title);
      return r;
    }
  }, {
    key: "currencyConvert",
    value: function currencyConvert(fromCurrencyId, toCurrencyId, value) {
      var r = travelTools.currencyConvert(fromCurrencyId, toCurrencyId, value, this.currencyRates);
      return r;
    }
  }, {
    key: "citiesToPrint",
    get: function get() {
      var res = {
        's': {},
        'h': {}
      };
      var printedCities = [];
      var _iterator182 = _createForOfIteratorHelper(this.BookingDays),
        _step182;
      try {
        for (_iterator182.s(); !(_step182 = _iterator182.n()).done;) {
          var day = _step182.value;
          if (!res['s'][day.DayNr]) res['s'][day.DayNr] = {};
          var services = day.BookingDayServices;
          for (var i in services) {
            var s = services[i];
            if (s.City && s.City.id) {
              if (printedCities.indexOf(s.City.id) == -1) {
                res['s'][day.DayNr][i] = s.City;
                printedCities.push(s.City.id);
              }
            }
          }
          if (this.hotelListByDate && this.hotelListByDate[day.DayNr]) {
            //for (let hotelId in this.hotelListByDate[day.DayNr]) {
            var hotel = this.hotelListByDate[day.DayNr];
            if (hotel && hotel.City && hotel.City.id) {
              if (printedCities.indexOf(hotel.City.id) == -1) {
                res['h'][day.DayNr] = hotel.City;
                printedCities.push(hotel.City.id);
              }
            }
            //}
          }
        }
      } catch (err) {
        _iterator182.e(err);
      } finally {
        _iterator182.f();
      }
      return res;
    }
  }, {
    key: "getDiscountForRoom",
    value: function getDiscountForRoom(cost, roomType, roomCategory) {
      var r = cost.Data[roomType.id + ',' + roomCategory];
      var res = {
        Discount: cost.Discount,
        DiscountType: cost.DiscountType,
        DiscountDays: cost.DiscountDays
      };
      if (r) {
        if (r.Discount !== undefined) res.Discount = r.Discount;
        if (r.DiscountType !== undefined) res.DiscountType = r.DiscountType;
        if (r.DiscountDays !== undefined) res.DiscountDays = r.DiscountDays;
      }
      return res;
    }
  }, {
    key: "getHotelCostData",
    value: function getHotelCostData(costByDate, roomType, roomCategory) {
      if (!costByDate) return;
      var r = costByDate.Data[roomType.id + ',' + roomCategory];
      var promotion;
      if (r) promotion = r.Promotion;
      if (promotion === undefined && costByDate) promotion = costByDate.Promotion;
      if (promotion && r) {
        r.ValidTo = costByDate.PromoEndDate;
      }
      return r;
    }
  }, {
    key: "getRoomCost",
    value: function getRoomCost(cost, room, roomCategory, nights, toCurrency, rates, roomTypes, totalNights, quoteBy) {
      var roomType = room.Room;
      var hotel = room.Hotel;
      var f = roomType.Pax;
      var f2 = 1;
      var f3 = 1;
      var costBy;
      if (cost[0]) {
        costBy = cost[0].RoomCostBy;
      } else {
        costBy = hotel.RoomCostBy;
      }
      if (hotel.hotelType == 'ALL_INCLUSIVE') {
        f = 1;
      }
      var defaultCost = {
        SourceCost: null,
        Cost: null,
        SourceCurrencyId: null
      };
      if (!cost || Object.keys(cost).length == 0) {
        return defaultCost;
      }
      if (costBy == 'ROOM_TYPE_CATEGORY') {
        var costValue = 0;
        var sourceCostValue = 0;
        var originCost;
        var sourceCurrencyId;
        var days = 0;
        var roomCost;
        if (this.QuoteBy == 'SERVICE') roomCost = 0;
        var validTo;
        for (var day in cost) {
          var costByDate = cost[day];
          if (!costByDate) return defaultCost;
          if (costByDate !== null && costByDate !== void 0 && costByDate.BlackOut) continue;
          var _r = this.getHotelCostData(costByDate, roomType, roomCategory);
          sourceCurrencyId = costByDate.CurrencyId;
          var rValue = void 0;
          if (_r) {
            rValue = parseFloat(_r.value);
            if (_r.ValidTo) validTo = _r.ValidTo;
          }
          if (!rValue && roomType.Pax == 3) {
            //si no encuentra habitación y estoy buscando una TPL, tengo que tomar DBL + Cama Extra
            var roomDBL = _.find(roomTypes, function (c) {
              return c.Pax == 2;
            });
            var roomBED = _.find(roomTypes, function (c) {
              return c.ExtraBed;
            });
            if (roomDBL && roomBED) {
              var rDBL = this.getHotelCostData(costByDate, roomDBL, roomCategory);
              var rBED = this.getHotelCostData(costByDate, roomBED, roomCategory);
              if (rDBL && rBED) {
                rValue = parseFloat(rDBL.value) + parseFloat(rBED.value);
                if (rDBL.ValidTo) validTo = rDBL.ValidTo;
              }
            }
          }
          originCost = rValue;
          if (costByDate.UnitCostBy == 'PERSON') f = 1;
          if (costByDate.UnitCostBy == 'ROOM') f = roomType.Pax;
          if (quoteBy == 'QUANTITY') {
            f = 1;
            f2 = 1;
            f3 = nights;
          }
          if (quoteBy == 'SERVICE') {
            f = 1;
            f2 = 1;
            f3 = nights;
          }
          var rValue2 = rValue;
          if (rValue || rValue == 0) {
            rValue = parseFloat(rValue) / (f * f3);
            var dsc = this.getDiscountForRoom(cost[day], roomType, roomCategory);
            var newValue = travelTools.applyDiscount(dsc.DiscountType, dsc.DiscountDays, dsc.Discount, rValue, nights, totalNights);
            rValue = newValue;
            var com = this.getHotelCommission(room, costByDate);
            if (com) {
              rValue = rValue * (1 - com / 100.0);
            }
            sourceCostValue += rValue;
            var valueToRate = this.currencyConvert(costByDate.CurrencyId, toCurrency, rValue);
            costValue += valueToRate;
            days += 1;
          }
          if ((rValue2 || rValue2 == 0) && this.QuoteBy != 'QUANTiTY') {
            var _dsc = this.getDiscountForRoom(cost[day], roomType, roomCategory);
            rValue2 = travelTools.applyDiscount(_dsc.DiscountType, _dsc.DiscountDays, _dsc.Discount, rValue2, nights, totalNights);
            var _com = this.getHotelCommission(room, costByDate);
            if (_com) {
              rValue2 = rValue2 * (1 - _com / 100.0);
            }
            //sourceCostValue += rValue2;
            var _valueToRate = this.currencyConvert(costByDate.CurrencyId, toCurrency, rValue2);
            roomCost += _valueToRate;
          }
        }
        if (days < nights) {
          //corrijo si no hay neto costo para toda las noches
          costValue = costValue / days * nights;
          roomCost = roomCost / days * nights;
        }
        return {
          SourceCost: sourceCostValue,
          Cost: costValue,
          OriginCost: originCost,
          SourceCurrencyId: sourceCurrencyId,
          ValidTo: validTo,
          roomCost: roomCost / nights
        };
      }
      if (costBy == 'NIGHT_ROOM_TYPE') {
        var _costByDate = cost[0];
        if (!_costByDate) return defaultCost;
        if (_costByDate.UnitCostBy == 'PERSON') f = 1;
        if (_costByDate.UnitCostBy == 'ROOM') f = roomType.Pax;
        if (_costByDate.PeriodCostBy == 'PROGRAM') f2 = 1;
        if (_costByDate.PeriodCostBy == 'NIGHT') f2 = nights;
        if (quoteBy == 'QUANTITY') {
          f = 1;
          f2 = 1;
        }
        if (quoteBy == 'SERVICE') {
          f = 1;
          f2 = 1;
        }
        var _r2 = _costByDate.Data[nights + ',' + roomType.id];
        var _rValue;
        if (_costByDate) {
          var _r3 = _costByDate.Data[nights + ',' + roomType.id];
          var _originCost;
          if (_r3) _rValue = parseFloat(_r3.value);
          if (!_rValue && roomType.Pax == 3) {
            //si no encuentra habitación y estoy buscando una TPL, tengo que tomar DBL + Cama Extra
            var _roomDBL = _.find(roomTypes, function (c) {
              return c.Pax == 2;
            });
            var _roomBED = _.find(roomTypes, function (c) {
              return c.ExtraBed;
            });
            if (_roomDBL && _roomBED) {
              var _rDBL = _costByDate.Data[nights + ',' + _roomDBL.id];
              var _rBED = _costByDate.Data[nights + ',' + _roomBED.id];
              if (_rDBL && _rBED) {
                _rValue = parseFloat(_rDBL.value) + parseFloat(_rBED.value);
              }
            }
          }
          if (_rValue) {
            _originCost = _rValue;
            var _costValue = _rValue * f2 / f;
            //let com = commission;
            //if (costByDate.Commission) com = costByDate.Commission;
            var _com2 = this.getHotelCommission(room, _costByDate);
            if (_com2) _costValue = _costValue * (1 - _com2 / 100.0);
            return {
              SourceCost: _costValue,
              Cost: this.currencyConvert(_costByDate.CurrencyId, toCurrency, _costValue),
              OriginCost: _originCost,
              SourceCurrencyId: _costByDate.CurrencyId
            };
          }
          var costRoom = travelTools.getRowValue(_costByDate.Data, roomType, nights);
          var _costValue2 = costRoom.costValue;
          var _maxNightId = costRoom.maxNightId;
          if (!_costValue2 && roomType.Pax == 3) {
            //si no encuentra habitación y estoy buscando una TPL, tengo que tomar DBL + Cama Extra
            var _roomDBL2 = _.find(roomTypes, function (c) {
              return c.Pax == 2;
            });
            var costDBL = travelTools.getRowValue(_costByDate.Data, _roomDBL2, nights);
            var _roomBED2 = _.find(roomTypes, function (c) {
              return c.ExtraBed;
            });
            var costBED = travelTools.getRowValue(_costByDate.Data, _roomBED2, nights);
            if (costDBL.costValue && costBED.costValue) _rValue = parseFloat(costDBL.costValue) + parseFloat(costBED.costValue);
            if (costBED.maxNightId) _maxNightId = costBED.maxNightId;
          }
          if (_costValue2 && _maxNightId > 0) {
            _originCost = _costValue2;
            _costValue2 = _costValue2 / f;
            //let com = commission;
            //if (costByDate.Commission) com = costByDate.Commission;
            var _com3 = this.getHotelCommission(room, _costByDate);
            if (_com3) _costValue2 = _costValue2 * (1 - _com3 / 100.0);
            return {
              SourceCost: _costValue2,
              Cost: this.currencyConvert(_costByDate.CurrencyId, toCurrency, _costValue2),
              OriginCost: _originCost,
              SourceCurrencyId: _costByDate.CurrencyId
            };
          }
        }
      }
      if (costBy == 'NIGHT_ROOM_CATEGORY') {
        var _costByDate2 = cost[0];
        if (!_costByDate2) return defaultCost;
        if (_costByDate2) {
          if (_costByDate2.UnitCostBy == 'PERSON') f = 1;
          if (_costByDate2.UnitCostBy == 'ROOM') f = roomType.Pax;
          if (_costByDate2.PeriodCostBy == 'PROGRAM') f2 = 1;
          if (_costByDate2.PeriodCostBy == 'NIGHT') f2 = nights;
          if (quoteBy == 'QUANTITY') {
            f = 1;
            f2 = 1;
          }
          if (quoteBy == 'SERVICE') {
            f = 1;
            f2 = 1;
          }
          var _originCost2;
          for (var row in _costByDate2.Data) {
            if (row.split(',')[0] != 'extra') {
              var nightsId = parseInt(row.split(',')[0]);
              var category = parseInt(row.split(',')[1]);
              if (category == roomCategory && nightsId == nights) {
                var _r4 = _costByDate2.Data[row];
                _originCost2 = parseFloat(_r4.value);
                var _costValue3 = parseFloat(_r4.value) * f2 / f;
                //let com = commission;
                //if (costByDate.Commission) com = costByDate.Commission;
                var _com4 = this.getHotelCommission(room, _costByDate2);
                if (_com4) _costValue3 = _costValue3 * (1 - _com4 / 100.0);
                return {
                  SourceCost: _costValue3,
                  Cost: this.currencyConvert(_costByDate2.CurrencyId, toCurrency, _costValue3),
                  OriginCost: _originCost2,
                  SourceCurrencyId: _costByDate2.CurrencyId
                };
              }
            }
          }
          var maxNightId = 0;
          var r = null;
          var rExtra = null;
          for (var _row in _costByDate2.Data) {
            var _category = parseInt(_row.split(',')[1]);
            if (_row.split(',')[0] != 'extra') {
              var _nightsId = parseInt(_row.split(',')[0]);
              if (_category == roomCategory && _nightsId > maxNightId) {
                maxNightId = _nightsId;
                r = _costByDate2.Data[_row];
              }
            } else {
              if (_category == roomCategory) {
                rExtra = _costByDate2.Data[_row];
              }
            }
          }
          if (r && rExtra && maxNightId > 0) {
            _originCost2 = parseFloat(r.value) + parseFloat(rExtra.value * (nights - maxNightId));
            var _costValue4 = parseFloat(r.value) * f2 / f + parseFloat(rExtra.value * (nights - maxNightId)) / f;
            //let com = commission;
            //if (costByDate.Commission) com = costByDate.Commission;
            var _com5 = this.getHotelCommission(room, _costByDate2);
            if (_com5) _costValue4 = _costValue4 * (1 - _com5 / 100.0);
            return {
              SourceCost: _costValue4,
              Cost: this.currencyConvert(_costByDate2.CurrencyId, toCurrency, _costValue4),
              OriginCost: _originCost2,
              SourceCurrencyId: _costByDate2.CurrencyId
            };
          }
        }
      }
      if (costBy == 'ROOM_TYPE_CATEGORY_NIGHT') {
        var _costByDate3 = cost[0];
        if (!_costByDate3) return defaultCost;
        if (_costByDate3.UnitCostBy == 'PERSON') f = 1;
        if (_costByDate3.UnitCostBy == 'ROOM') f = roomType.Pax;
        if (_costByDate3.PeriodCostBy == 'PROGRAM') f2 = 1;
        if (_costByDate3.PeriodCostBy == 'NIGHT') f2 = nights;
        if (quoteBy == 'QUANTITY') {
          f = 1;
          f2 = 1;
        }
        if (quoteBy == 'SERVICE') {
          f = 1;
          f2 = 1;
        }
        var _r5 = _costByDate3.Data[nights + ',' + roomCategory + ',' + roomType.id];
        var _rValue2;
        if (_costByDate3) {
          //if (costByDate.UnitCostBy == 'PERSON') f = 1;
          //if (costByDate.UnitCostBy == 'ROOM') f = roomType.Pax;
          //if (costByDate.PeriodCostBy == 'PROGRAM') f2 = 1;
          //if (costByDate.PeriodCostBy == 'NIGHT') f2 = nights;
          if (!_costByDate3) return defaultCost;
          var _r6 = _costByDate3.Data[nights + ',' + roomCategory + ',' + roomType.id];
          var _originCost3;
          if (_r6) _rValue2 = parseFloat(_r6.value);
          if (!_rValue2 && roomType.Pax == 3) {
            //si no encuentra habitación y estoy buscando una TPL, tengo que tomar DBL + Cama Extra
            var _roomDBL3 = _.find(roomTypes, function (c) {
              return c.Pax == 2;
            });
            var _roomBED3 = _.find(roomTypes, function (c) {
              return c.ExtraBed;
            });
            if (_roomDBL3 && _roomBED3) {
              var _rDBL2 = _costByDate3.Data[nights + ',' + roomCategory + ',' + _roomDBL3.id];
              var _rBED2 = _costByDate3.Data[nights + ',' + roomCategory + ',' + _roomBED3.id];
              if (_rDBL2 && _rBED2) {
                _rValue2 = parseFloat(_rDBL2.value) + parseFloat(_rBED2.value);
              }
            }
          }
          if (_rValue2) {
            _originCost3 = _rValue2;
            var _costValue5 = _rValue2 * f2 / f;
            //let com = commission;
            //if (costByDate.Commission) com = costByDate.Commission;
            var _com6 = this.getHotelCommission(room, _costByDate3);
            if (_com6) _costValue5 = _costValue5 * (1 - _com6 / 100.0);
            return {
              SourceCost: _costValue5,
              Cost: this.currencyConvert(_costByDate3.CurrencyId, toCurrency, _costValue5),
              OriginCost: _originCost3,
              SourceCurrencyId: _costByDate3.CurrencyId
            };
          }
          var _costRoom = travelTools.getRowValue(_costByDate3.Data, roomType, nights, roomCategory);
          var _costValue6 = _costRoom.costValue;
          var _maxNightId2 = _costRoom.maxNightId;
          if (!_costValue6 && roomType.Pax == 3) {
            //si no encuentra habitación y estoy buscando una TPL, tengo que tomar DBL + Cama Extra
            var _roomDBL4 = _.find(roomTypes, function (c) {
              return c.Pax == 2;
            });
            var _costDBL = travelTools.getRowValue(_costByDate3.Data, _roomDBL4, nights, roomCategory);
            var _roomBED4 = _.find(roomTypes, function (c) {
              return c.ExtraBed;
            });
            var _costBED = travelTools.getRowValue(_costByDate3.Data, _roomBED4, nights, roomCategory);
            if (_costDBL.costValue && _costBED.costValue) _rValue2 = parseFloat(_costDBL.costValue) + parseFloat(_costBED.costValue);
            if (_costBED.maxNightId) _maxNightId2 = _costBED.maxNightId;
          }
          if (_costValue6 && _maxNightId2 > 0) {
            _originCost3 = _costValue6;
            _costValue6 = _costValue6 * f2 / f;
            //let com = commission;
            //if (costByDate.Commission) com = costByDate.Commission;
            var _com7 = this.getHotelCommission(room, _costByDate3);
            if (_com7) _costValue6 = _costValue6 * (1 - _com7 / 100.0);
            return {
              SourceCost: _costValue6,
              Cost: this.currencyConvert(_costByDate3.CurrencyId, toCurrency, _costValue6),
              OriginCost: _originCost3,
              SourceCurrencyId: _costByDate3.CurrencyId
            };
          }
        }
      }
      return defaultCost;
    }
  }, {
    key: "getMailSubject",
    value: function getMailSubject(dateIn, supplier) {
      return "".concat(tr('Booking request'), " x ").concat(this.PaxName, " ").concat(this.getPaxForQuote());
    }
  }, {
    key: "getMailRecord",
    value: function getMailRecord(emailAddress, user, dateIn, supplier) {
      var body = '';
      if (user.EmailIntro) body += '<p>' + user.EmailIntro + '</p>';
      body += '<p><br></p>';
      var mailRecord = {
        id: null,
        BookingId: this.id,
        MailFrom: user.Email,
        MailTo: emailAddress,
        MailCc: null,
        MailBcc: null,
        Subject: this.getMailSubject(dateIn, supplier),
        UserId: user.id,
        Status: 'CREATED',
        Datetime: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'),
        MailBookingServices: [],
        MailBookingHotels: []
      };
      if (false) {}
      return {
        mailRecord: mailRecord,
        body: body
      };
    }
  }, {
    key: "setPaxToMail",
    value: function setPaxToMail(body, bookingForm, addRoom, flight) {
      var _this7 = this;
      if (!bookingForm.BookingFormPaxs) return body;
      if (bookingForm.BookingFormPaxs.length == 0) return body;
      var BookingFormPaxs = bookingForm.BookingFormPaxs;
      body += "<p><br></p><p><strong>".concat(tr('Passengers'), "</strong></p><p><br></p>");
      var countriesJSON = __webpack_require__(48456)("./".concat(api.language, "/world.json"));
      var _iterator183 = _createForOfIteratorHelper(BookingFormPaxs),
        _step183;
      try {
        var _loop10 = function _loop10() {
          var pax = _step183.value;
          body += "<p><strong>".concat(tr('Name'), ": </strong> ").concat(_this7.value(pax.FirstName), " ").concat(_this7.value(pax.MiddleName), " ").concat(_this7.value(pax.LastName), " </p>");
          if (pax.BirthDate) body += "<p><strong>".concat(tr('Date of Birth'), ": </strong>") + _this7.value(_this7.formatDate(pax.BirthDate)) + '</p>';
          if (pax.Passport) body += "<p><strong>".concat(tr('Passport'), ": </strong>") + _this7.value(pax.Passport) + '</p>';
          if (pax.PassportValidTo) body += "<p><strong>".concat(tr('Valid until'), ": </strong>") + _this7.value(_this7.formatDate(pax.PassportValidTo)) + '</p>';
          var country = _.find(countriesJSON, function (r) {
            return r.alpha3 == pax.PassportCountry;
          });
          var countryName = pax.PassportCountry;
          if (country) countryName = country.name;
          if (pax.PassportCountry) body += "<p><strong>".concat(tr('Country'), ": </strong>") + _this7.value(countryName) + '</p>';
          if (pax.Medication) body += "<p><strong>".concat(tr('Medication'), ": </strong>") + _this7.value(pax.Medication) + '</p>';
          if (pax.Dietary) body += "<p><strong>".concat(tr('Dietary'), ": </strong>") + _this7.value(pax.Dietary) + '</p>';
          if (pax.Allergies) body += "<p><strong>".concat(tr('Allergies'), ": </strong>") + _this7.value(pax.Allergies) + '</p>';
          if (addRoom && pax.RoomType) body += "<p><strong>".concat(tr('Room Type'), ": </strong>") + _this7.value(pax.RoomType) + '</p>';
          body += '<p><br></p>';
        };
        for (_iterator183.s(); !(_step183 = _iterator183.n()).done;) {
          _loop10();
        }
      } catch (err) {
        _iterator183.e(err);
      } finally {
        _iterator183.f();
      }
      body += '</p>';
      body += '<p><br></p>';
      return body;
    }
  }, {
    key: "value",
    value: function value(v) {
      if (!v) return '';
      if (v == 'none') return '';
      return v;
    }
  }, {
    key: "getFirstInServices",
    value: function getFirstInServices(supplier) {
      var _iterator184 = _createForOfIteratorHelper(supplier.Services),
        _step184;
      try {
        for (_iterator184.s(); !(_step184 = _iterator184.n()).done;) {
          var service = _step184.value;
          if (service.Status != 'PENDING') continue;
          if (service.Service) {
            return service.ServiceDate;
          }
        }
      } catch (err) {
        _iterator184.e(err);
      } finally {
        _iterator184.f();
      }
    }
  }, {
    key: "formatDate",
    value: function formatDate(d) {
      return moment(d).format('DD/MM/YYYY');
    }
  }, {
    key: "addServicesToMail",
    value: function addServicesToMail(supplier, body, cities, mailRecord, dateIn, includePickup, paxDetailsInServices) {
      var _this8 = this;
      var _iterator185 = _createForOfIteratorHelper(supplier.Services),
        _step185;
      try {
        var _loop11 = function _loop11() {
          var service = _step185.value;
          if (service.Status != 'PENDING') return 1; // continue
          if (service.Service) {
            var serviceName = service.Service.Name;
            if (service.Name) serviceName = service.Name;
            var serviceLanguage = '';
            if (service.LanguageId) {
              serviceLanguage = ' (' + service.Language.Name + ') ';
            }
            if (includePickup && service.PickupInfo) {
              serviceName += "<b><i>Pickup:  ".concat(service.PickupInfo, "</i></b>");
            }
            if (service.Service && service.Service.CarRental && service.BookingDayServiceCar) {
              body += "<p><b>".concat(serviceName, "</b></p>");
              if (service.BookingDayServiceCar.PickupAddress) {
                body += "<p>Pick up: ".concat(_this8.formatDate(service.ServiceDate), " ").concat(service.BookingDayServiceCar.PickupTime, " hs ");
                body += "".concat(service.BookingDayServiceCar.PickupAddress.Name, " (").concat(service.BookingDayServiceCar.PickupAddress.Address, ", ");
                if (service.BookingDayServiceCar.PickupAddress.City) {
                  body += "".concat(service.BookingDayServiceCar.PickupAddress.City.Name, ")</p>");
                }
              }
              if (service.BookingDayServiceCar.DropOffAddress) {
                var dropOffDate = moment(service.ServiceDate).add(service.BookingDayServiceCar.Days - 1, 'days').format('YYYY-MM-DD');
                body += "<p>Drop off: ".concat(_this8.formatDate(dropOffDate), " ").concat(service.BookingDayServiceCar.DropOffTime, " hs ");
                body += "".concat(service.BookingDayServiceCar.DropOffAddress.Name, " (").concat(service.BookingDayServiceCar.DropOffAddress.Address, ", ");
                if (service.BookingDayServiceCar.DropOffAddress.City) {
                  body += "".concat(service.BookingDayServiceCar.DropOffAddress.City.Name, ")</p>");
                }
              }
              var fields = _.filter(service.BookingDayServiceCar.fields, function (r) {
                if (r.editor != 'checkbox') return false;
                if (service.BookingDayServiceCar[r.name]) return true;
              });
              var labels = _.map(fields, function (r) {
                return r.label;
              });
              if (labels.length > 0) {
                body += "<p>".concat(tr('Included'), ": ").concat(labels.join(', '), "</p>");
              }
            } else {
              var serviceType = '';
              if (service.Service && service.Service.ServiceType) {
                serviceType = service.Service.ServiceType.Name;
                if (serviceName.includes(serviceType)) serviceType = '';
              }
              ;
              var paxString = '';
              if (paxDetailsInServices) {
                var pax = service.paxForService;
                paxString = _.map(pax, function (v, k) {
                  return "".concat(v, " ").concat(k);
                }).join(' + ');
              }
              body += "<p> ".concat(_this8.formatDate(service.ServiceDate), ": ").concat(serviceName, " ").concat(serviceLanguage, " ").concat(serviceType, " ").concat(paxString ? "// ".concat(tr('Pax'), ": ").concat(paxString) : '', " </p>");
              if (service.City && cities.indexOf(service.City.id)) {
                cities.push(service.City.id);
              }
            }
          }
        };
        for (_iterator185.s(); !(_step185 = _iterator185.n()).done;) {
          if (_loop11()) continue;
        }
      } catch (err) {
        _iterator185.e(err);
      } finally {
        _iterator185.f();
      }
      return body;
    }
  }, {
    key: "setHotelsInfo",
    value: function setHotelsInfo(body, supplier, cities) {
      var servicesId = _.map(supplier.Services, function (r) {
        return r.id;
      });
      var found;
      var hotels = {};
      var _iterator186 = _createForOfIteratorHelper(this.BookingDays),
        _step186;
      try {
        for (_iterator186.s(); !(_step186 = _iterator186.n()).done;) {
          var day = _step186.value;
          var hasServices = _.find(day.BookingDayServices, function (s) {
            if (servicesId.indexOf(s.id) > -1) return true;
          });
          if (!hasServices) continue;
          var _hotel = this.hotelsByDay[day.DayNr];
          if (_hotel && _hotel.BookingDayRooms && _hotel.BookingDayRooms[0]) {
            var _iterator187 = _createForOfIteratorHelper(_hotel.BookingDayRooms),
              _step187;
            try {
              for (_iterator187.s(); !(_step187 = _iterator187.n()).done;) {
                var room = _step187.value;
                if (!hotels[_hotel.id]) {
                  hotels[_hotel.id] = {
                    hotel: room.Hotel,
                    dateIn: _hotel.Checkin,
                    days: _hotel.Days
                  };
                }
                ;
              }
            } catch (err) {
              _iterator187.e(err);
            } finally {
              _iterator187.f();
            }
          }
          _hotel = this.hotelsByDay[day.DayNr - 1];
          if (_hotel && _hotel.BookingDayRooms && _hotel.BookingDayRooms[0]) {
            var _iterator188 = _createForOfIteratorHelper(_hotel.BookingDayRooms),
              _step188;
            try {
              for (_iterator188.s(); !(_step188 = _iterator188.n()).done;) {
                var _room3 = _step188.value;
                if (!hotels[_hotel.id]) {
                  hotels[_hotel.id] = {
                    hotel: _room3.Hotel,
                    dateIn: _hotel.Checkin,
                    days: _hotel.Days
                  };
                }
                ;
              }
            } catch (err) {
              _iterator188.e(err);
            } finally {
              _iterator188.f();
            }
          }
        }
      } catch (err) {
        _iterator186.e(err);
      } finally {
        _iterator186.f();
      }
      var sortable = [];
      for (var hotelId in hotels) {
        sortable.push(hotels[hotelId]);
      }
      sortable.sort(function (a, b) {
        if (a.dateIn > b.dateIn) return 1;
        if (a.dateIn < b.dateIn) return -1;
        return 0;
      });
      for (var _i10 = 0, _sortable = sortable; _i10 < _sortable.length; _i10++) {
        var hotel = _sortable[_i10];
        if (!found) {
          found = true;
          body += "<p><br></p><p>".concat(tr('Accommodation'), ":</p>");
        }
        var date = moment(hotel.dateIn).local().locale(api.language).format('DD MMM YYYY');
        var dateTo = moment(hotel.dateIn, "YYYY-MM-DD").add(hotel.days, 'days').format("YYYY-MM-DD");
        dateTo = moment(dateTo).local().locale(api.language).format('DD MMM YYYY');
        body += "<p>".concat(hotel.hotel.Name, ": ").concat(date, " ").concat(tr('to'), " ").concat(dateTo, "</p>");
      }
      body += '<p><br></p>';
      return body;
    }
  }, {
    key: "createSupplierServiceMail",
    value: function () {
      var _createSupplierServiceMail = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee66(bookingForm, user, supplier, includeHotels, includeFlights, includePickup, paxDetailsInServices) {
        var body, cities, dateIn, r, mailRecord;
        return regenerator_default().wrap(function _callee66$(_context70) {
          while (1) switch (_context70.prev = _context70.next) {
            case 0:
              body = '';
              cities = [];
              dateIn = this.getFirstInServices(supplier);
              r = this.getMailRecord(supplier.Supplier.Email, user, dateIn, supplier.Supplier);
              body += r.body;
              mailRecord = r.mailRecord;
              body = this.addServicesToMail(supplier, body, cities, mailRecord, dateIn, includePickup, paxDetailsInServices);
              if (includeHotels) {
                body = this.setHotelsInfo(body, supplier, cities);
              }
              if (includeFlights) {
                body = this.getFlightsMail(body, bookingForm);
              }
              _context70.next = 11;
              return this.setPaxToMail(body, bookingForm);
            case 11:
              body = _context70.sent;
              body += '<p><br></p>';
              if (user.Signature) body += user.Signature;
              body += '</this.body>';
              body += '</html>';
              mailRecord.MessageBody = body;
              return _context70.abrupt("return", mailRecord);
            case 18:
            case "end":
              return _context70.stop();
          }
        }, _callee66, this);
      }));
      function createSupplierServiceMail(_x101, _x102, _x103, _x104, _x105, _x106, _x107) {
        return _createSupplierServiceMail.apply(this, arguments);
      }
      return createSupplierServiceMail;
    }()
  }, {
    key: "getFlightsMail",
    value: function getFlightsMail(body, bookingForm) {
      body += '<p><br></p>';
      body += "<p>".concat(tr('Flights'), "</p>");
      var _iterator189 = _createForOfIteratorHelper(this.BookingFlights),
        _step189;
      try {
        for (_iterator189.s(); !(_step189 = _iterator189.n()).done;) {
          var flight = _step189.value;
          if (!flight.Output) continue;
          var segments = flight.Output.split('\n');
          var _iterator190 = _createForOfIteratorHelper(segments),
            _step190;
          try {
            for (_iterator190.s(); !(_step190 = _iterator190.n()).done;) {
              var segment = _step190.value;
              body += '<p>' + segment + '</p>';
            }
          } catch (err) {
            _iterator190.e(err);
          } finally {
            _iterator190.f();
          }
        }
      } catch (err) {
        _iterator189.e(err);
      } finally {
        _iterator189.f();
      }
      body += '<p><br></p>';
      return body;
    }
  }, {
    key: "getPaxForQuote",
    value: function getPaxForQuote() {
      var r = 0;
      for (var baseId in this.BaseQuotes.bases) {
        if (!this.Totals[baseId]) continue;
        var _iterator191 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
          _step191;
        try {
          for (_iterator191.s(); !(_step191 = _iterator191.n()).done;) {
            var pType = _step191.value;
            //if (!this.Totals[baseId][pType]) continue;
            //if (this.Totals[baseId][pType].Selected) {
            if (this.isQuoteSelected(baseId, pType)) {
              if (this.QuoteBy == 'PERSON' && this.Totals[baseId][pType].Pax) {
                r += this.Totals[baseId][pType].Pax;
              } else {
                r += this.getPaxQuantity(baseId, pType);
              }
            }
          }
        } catch (err) {
          _iterator191.e(err);
        } finally {
          _iterator191.f();
        }
      }
      return r;
    }
  }, {
    key: "getPaxForSupplier",
    value: function getPaxForSupplier(supplier) {
      var supplierId = supplier.id;
      if (supplier.Hotel && supplier.Hotel.SupplierId) supplierId = supplier.Hotel.SupplierId;
      var paxList = [];
      for (var baseId in this.BaseQuotes.bases) {
        var baseQuote = this.BaseQuotes[baseId];
        var p = baseQuote.paxQuantity;
        if (Object.keys(this.BaseQuotes.bases) == 1) return p;
        var p2 = void 0;
        var p1 = 0;
        var _iterator192 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
          _step192;
        try {
          for (_iterator192.s(); !(_step192 = _iterator192.n()).done;) {
            var pType = _step192.value;
            var _p2 = void 0;
            if (this.QuoteBy == 'PERSON' && this.Totals[baseId][pType].Pax) {
              _p2 += this.Totals[baseId][pType].Pax;
            }
            if (!_p2) p2 = p;
            var _iterator193 = _createForOfIteratorHelper(this.BookingDays),
              _step193;
            try {
              for (_iterator193.s(); !(_step193 = _iterator193.n()).done;) {
                var day = _step193.value;
                var _iterator195 = _createForOfIteratorHelper(day.BookingDayServices),
                  _step195;
                try {
                  for (_iterator195.s(); !(_step195 = _iterator195.n()).done;) {
                    var s = _step195.value;
                    if (!s.Quote) continue;
                    if (!s.Quote.QuoteList) continue;
                    if (!s.Quote.QuoteList[baseId]) continue;
                    if (!s.Quote.QuoteList[baseId][pType]) continue;
                    if (!s.Quote.QuoteList[baseId][pType]) continue;
                    if (!s.Quote.QuoteList[baseId][pType].Include) continue;
                    if (s.SupplierId == supplierId || s.Supplier && s.Supplier.id == supplierId) {
                      var q = s.paxQuantity;
                      //console.log('serv 2 ', q)
                      if (q) paxList.push(q);
                    }
                  }
                } catch (err) {
                  _iterator195.e(err);
                } finally {
                  _iterator195.f();
                }
                var _iterator196 = _createForOfIteratorHelper(day.BookingDayHotels),
                  _step196;
                try {
                  for (_iterator196.s(); !(_step196 = _iterator196.n()).done;) {
                    var hotel = _step196.value;
                    var found = void 0;
                    var _iterator197 = _createForOfIteratorHelper(hotel.BookingDayRooms),
                      _step197;
                    try {
                      for (_iterator197.s(); !(_step197 = _iterator197.n()).done;) {
                        var room = _step197.value;
                        if (!room.HotelId) continue;
                        if (!room.QuoteList) continue;
                        if (!room.QuoteList[baseId]) continue;
                        if (!room.QuoteList[baseId].Include) continue;
                        if (room.HotelId == supplier.id) {
                          found = true;
                        }
                      }
                    } catch (err) {
                      _iterator197.e(err);
                    } finally {
                      _iterator197.f();
                    }
                    if (found) {
                      var _q3 = hotel.paxQuantity;
                      if (_q3) paxList.push(_q3);
                    }
                  }
                } catch (err) {
                  _iterator196.e(err);
                } finally {
                  _iterator196.f();
                }
              }
            } catch (err) {
              _iterator193.e(err);
            } finally {
              _iterator193.f();
            }
            var _iterator194 = _createForOfIteratorHelper(this.BookingFlights),
              _step194;
            try {
              for (_iterator194.s(); !(_step194 = _iterator194.n()).done;) {
                var flight = _step194.value;
                if (flight.SupplierId != supplierId) continue;
                var _q4 = flight.paxQuantity;
                //console.log('flight ', q)
                if (_q4) paxList.push(_q4);
              }
            } catch (err) {
              _iterator194.e(err);
            } finally {
              _iterator194.f();
            }
          }
        } catch (err) {
          _iterator192.e(err);
        } finally {
          _iterator192.f();
        }
      }
      //console.log(paxList)
      return _.max(paxList);
    }
  }, {
    key: "getPerQuote",
    get: function get() {
      var r = {};
      var bases_pax = [];
      for (var baseId in this.BaseQuotes.bases) {
        if (!this.Totals[baseId] && this.QuoteBy != 'SERVICE') continue;
        r[baseId] = 0;
        var base_pax = this.BaseQuotes[baseId].paxQuantity;
        if (bases_pax.indexOf(base_pax) == -1) {
          bases_pax.push(base_pax);
        }
        var _iterator198 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
          _step198;
        try {
          for (_iterator198.s(); !(_step198 = _iterator198.n()).done;) {
            var pType = _step198.value;
            if (pType == 'TL' && this.QuoteBy == 'SERVICE') continue;
            /*if (this.isGroup(baseId)) {
                for (let groupId in this.QuoteGroups[baseId]) {
                    if (!this.QuoteGroups[baseId]?.[groupId]?.[pType]) continue;
                    if (!this.QuoteGroups[baseId]?.[groupId]?.Selected?.[pType]) continue;
                    r[baseId] += this.QuoteGroups[baseId]?.[groupId]?.[pType];
                }
                continue;
            }*/
            if (this.isQuoteSelected(baseId, pType)) {
              if (this.Totals[baseId][pType].Pax) {
                r[baseId] += this.Totals[baseId][pType].Pax;
              } else {
                r[baseId] += this.getPaxQuantity(baseId, pType);
              }
            }
          }
        } catch (err) {
          _iterator198.e(err);
        } finally {
          _iterator198.f();
        }
      }
      bases_pax = (0,toConsumableArray/* default */.A)(new Set(bases_pax));
      if (bases_pax.length == 1) {
        var max_pax = bases_pax[0];
        var sum = 0;
        for (var id in r) {
          if (sum >= max_pax) {
            r[id] = 0;
          }
          sum += r[id];
        }
      }
      return r;
    }
  }, {
    key: "getPaxQuantity",
    value: function getPaxQuantity(baseId, pType) {
      var res = 0;
      if (!this.BaseQuotes || !this.BaseQuotes[baseId]) return res;
      if (this.BaseQuotes[baseId].ADT && pType == 'ADT') res += this.BaseQuotes[baseId].ADT;
      if (this.BaseQuotes[baseId].CHD && pType == 'CHD') res += this.BaseQuotes[baseId].CHD;
      if (this.BaseQuotes[baseId].TL && pType == 'TL') res += this.BaseQuotes[baseId].TL;
      return res;
    }
  }, {
    key: "getFirstInHotel",
    value: function getFirstInHotel(roomsByDateIn) {
      for (var transDate in roomsByDateIn) {
        var rooms = roomsByDateIn[transDate];
        return transDate;
      }
    }
  }, {
    key: "createSupplierFlightMail",
    value: function () {
      var _createSupplierFlightMail = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee67(bookingForm, user, email, flights) {
        var r, body, mailRecord, _iterator199, _step199, flight;
        return regenerator_default().wrap(function _callee67$(_context71) {
          while (1) switch (_context71.prev = _context71.next) {
            case 0:
              r = this.getMailRecord(email, user, null, flights.Supplier);
              body = '';
              body += r.body;
              mailRecord = r.mailRecord;
              _iterator199 = _createForOfIteratorHelper(flights.Flights);
              try {
                for (_iterator199.s(); !(_step199 = _iterator199.n()).done;) {
                  flight = _step199.value;
                  if (flight.Output) {
                    body += "<p>".concat(flight.Output, "</p>");
                  } else if (flight.Input) {
                    body += "<p>".concat(flight.Input, "</p>");
                  }
                  body += '<p><br></p>';
                }
              } catch (err) {
                _iterator199.e(err);
              } finally {
                _iterator199.f();
              }
              _context71.next = 8;
              return this.setPaxToMail(body, bookingForm, true, true);
            case 8:
              body = _context71.sent;
              if (user.Signature) body += user.Signature;
              mailRecord.MessageBody = body;
              return _context71.abrupt("return", mailRecord);
            case 12:
            case "end":
              return _context71.stop();
          }
        }, _callee67, this);
      }));
      function createSupplierFlightMail(_x108, _x109, _x110, _x111) {
        return _createSupplierFlightMail.apply(this, arguments);
      }
      return createSupplierFlightMail;
    }()
  }, {
    key: "getRoomsMailRows",
    value: function getRoomsMailRows(body, transDate, rooms, i, quant) {
      var dates = this.formatDate(transDate) + " ".concat(tr('to'), " ") + this.formatDate(moment(rooms[0].TransDate).add(rooms[0].nights, 'days'));
      if (quant > 1) {
        body += "<p><u>".concat(tr('Check-in'), " ") + i + ': ' + dates + '</u></p>';
      } else {
        body += "<p><u>".concat(tr('Check-in'), ": ") + dates + ' </u></p>';
      }
      var _iterator200 = _createForOfIteratorHelper(rooms),
        _step200;
      try {
        var _loop12 = function _loop12() {
          var room = _step200.value;
          if (!room.quoteIncluded) return 1; // continue
          var roomCategoryName = '';
          var roomCategory = _.find(room.Hotel.RoomCategories, function (c) {
            if (room.RoomCategory) {
              return c.id == room.RoomCategory;
            } else {
              return c.id == room.RoomCategory;
            }
          });
          if (roomCategory) roomCategoryName = roomCategory.Name;
          if (!room.Room.Checkin) {
            body += '<p>' + room.Hotel.Name + ': ' + room.roomsQuantity + " ".concat(tr('Room'), " ") + roomCategoryName + ' ' + room.Room.Name + '</p>';
          } else {
            body += '<p>' + room.Room.Name + '</p>';
          }
        };
        for (_iterator200.s(); !(_step200 = _iterator200.n()).done;) {
          if (_loop12()) continue;
        }
      } catch (err) {
        _iterator200.e(err);
      } finally {
        _iterator200.f();
      }
      return body;
    }
  }, {
    key: "createSupplierHotelMail",
    value: function () {
      var _createSupplierHotelMail = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee68(bookingForm, user, email, hotel, includeFlights, roomsByDateIn) {
        var dateIn, r, body, mailRecord, quant, i, transDate, rooms;
        return regenerator_default().wrap(function _callee68$(_context72) {
          while (1) switch (_context72.prev = _context72.next) {
            case 0:
              dateIn = this.getFirstInHotel(roomsByDateIn);
              r = this.getMailRecord(email, user, dateIn, hotel.Rooms[0].Hotel);
              body = '';
              body += r.body;
              mailRecord = r.mailRecord;
              quant = Object.keys(roomsByDateIn).length;
              i = 1;
              for (transDate in roomsByDateIn) {
                rooms = roomsByDateIn[transDate];
                body = this.getRoomsMailRows(body, transDate, rooms, i, quant);
                i += 1;
              }
              if (includeFlights) {
                body = this.getFlightsMail(body, bookingForm);
              }
              _context72.next = 11;
              return this.setPaxToMail(body, bookingForm, true);
            case 11:
              body = _context72.sent;
              if (user.Signature) body += user.Signature;
              mailRecord.MessageBody = body;
              return _context72.abrupt("return", mailRecord);
            case 15:
            case "end":
              return _context72.stop();
          }
        }, _callee68, this);
      }));
      function createSupplierHotelMail(_x112, _x113, _x114, _x115, _x116, _x117) {
        return _createSupplierHotelMail.apply(this, arguments);
      }
      return createSupplierHotelMail;
    }()
  }, {
    key: "createSupplierMixedMail",
    value: function () {
      var _createSupplierMixedMail = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee69(bookingForm, user, email, hotel, supplier, includeFlights, roomsByDateIn, includePickup, paxDetailsInServices) {
        var dateIn, r, body, mailRecord, cities, quant, i, transDate, rooms;
        return regenerator_default().wrap(function _callee69$(_context73) {
          while (1) switch (_context73.prev = _context73.next) {
            case 0:
              dateIn = this.getFirstInHotel(roomsByDateIn);
              r = this.getMailRecord(email, user, dateIn, hotel.Rooms[0].Hotel);
              body = '';
              body += r.body;
              mailRecord = r.mailRecord;
              cities = [];
              body = this.addServicesToMail(supplier, body, cities, mailRecord, dateIn, includePickup, paxDetailsInServices);
              body += '<br/>';
              body += 'Rooms:';
              quant = Object.keys(roomsByDateIn).length;
              i = 1;
              for (transDate in roomsByDateIn) {
                rooms = roomsByDateIn[transDate];
                body = this.getRoomsMailRows(body, transDate, rooms, i, quant);
                i += 1;
              }
              if (includeFlights) {
                body = this.getFlightsMail(body, bookingForm);
              }
              _context73.next = 15;
              return this.setPaxToMail(body, bookingForm, true);
            case 15:
              body = _context73.sent;
              if (user.Signature) body += user.Signature;
              mailRecord.MessageBody = body;
              return _context73.abrupt("return", mailRecord);
            case 19:
            case "end":
              return _context73.stop();
          }
        }, _callee69, this);
      }));
      function createSupplierMixedMail(_x118, _x119, _x120, _x121, _x122, _x123, _x124, _x125, _x126) {
        return _createSupplierMixedMail.apply(this, arguments);
      }
      return createSupplierMixedMail;
    }()
  }, {
    key: "getBasePaxTypes",
    value: function getBasePaxTypes(quote, baseId) {
      var ADT = quote.ADT;
      var pax = quote.ADT + (quote.CHD ? quote.CHD : 0) + (quote.TL ? quote.TL : 0);
      var res = ADT + ' ADT';
      if (quote.CHD) {
        res += ', ' + quote.CHD + ' CHD';
      }
      if (quote.TL) {
        res += ', ' + quote.TL + ' TL';
      }
      res = "".concat(pax, " ").concat(tr('Passengers'), " (").concat(res, ")");
      var r = [];
      if (!this.Totals[baseId]) return res;
      if (this.Totals[baseId].ADT && this.Totals[baseId].ADT.Comment) {
        r.push(this.Totals[baseId].ADT.Comment);
      }
      if (this.Totals[baseId].CHD && this.Totals[baseId].CHD.Comment) {
        r.push(this.Totals[baseId].CHD.Comment);
      }
      if (this.Totals[baseId].TL && this.Totals[baseId].TL.Comment) {
        r.push(this.Totals[baseId].TL.Comment);
      }
      if (r.length > 0) {
        res += '; ' + r.join(' / ');
      }
      return res;
    }
  }, {
    key: "getPaxByBase",
    value: function getPaxByBase(baseId) {
      var res = this.BaseQuotes[baseId].ADT + ' ADT';
      if (this.BaseQuotes[baseId].CHD) {
        res += ', ' + this.BaseQuotes[baseId].CHD + ' CHD';
      }
      if (this.BaseQuotes[baseId].TL) {
        res += ', ' + this.BaseQuotes[baseId].TL + ' TL';
      }
      return res;
    }
  }, {
    key: "getFlightsList",
    get: function get() {
      var res = [];
      if (!this.BookingFlights) return res;
      var _iterator201 = _createForOfIteratorHelper(this.BookingFlights),
        _step201;
      try {
        for (_iterator201.s(); !(_step201 = _iterator201.n()).done;) {
          var f = _step201.value;
          if (f.Output) {
            var rows = f.Output.split('\n');
            var _iterator202 = _createForOfIteratorHelper(rows),
              _step202;
            try {
              for (_iterator202.s(); !(_step202 = _iterator202.n()).done;) {
                var r = _step202.value;
                res.push(r);
              }
            } catch (err) {
              _iterator202.e(err);
            } finally {
              _iterator202.f();
            }
          }
        }
      } catch (err) {
        _iterator201.e(err);
      } finally {
        _iterator201.f();
      }
      return res;
    }
  }, {
    key: "getFlightsListInternal",
    get: function get() {
      var res = [];
      if (!this.BookingFlights) return res;
      var _iterator203 = _createForOfIteratorHelper(this.BookingFlights),
        _step203;
      try {
        for (_iterator203.s(); !(_step203 = _iterator203.n()).done;) {
          var f = _step203.value;
          if (f.Output && f.FlightType == 'LOCAL') {
            var rows = f.Output.split('\n');
            var _iterator204 = _createForOfIteratorHelper(rows),
              _step204;
            try {
              for (_iterator204.s(); !(_step204 = _iterator204.n()).done;) {
                var r = _step204.value;
                res.push(r);
              }
            } catch (err) {
              _iterator204.e(err);
            } finally {
              _iterator204.f();
            }
          }
        }
      } catch (err) {
        _iterator203.e(err);
      } finally {
        _iterator203.f();
      }
      return res;
    }
  }, {
    key: "getFlightsListInternational",
    get: function get() {
      var res = [];
      if (!this.BookingFlights) return res;
      var _iterator205 = _createForOfIteratorHelper(this.BookingFlights),
        _step205;
      try {
        for (_iterator205.s(); !(_step205 = _iterator205.n()).done;) {
          var f = _step205.value;
          if (f.Output && f.FlightType == 'INTERNATIONAL') {
            var rows = f.Output.split('\n');
            var _iterator206 = _createForOfIteratorHelper(rows),
              _step206;
            try {
              for (_iterator206.s(); !(_step206 = _iterator206.n()).done;) {
                var r = _step206.value;
                res.push(r);
              }
            } catch (err) {
              _iterator206.e(err);
            } finally {
              _iterator206.f();
            }
          }
        }
      } catch (err) {
        _iterator205.e(err);
      } finally {
        _iterator205.f();
      }
      return res;
    }
  }, {
    key: "completeDays",
    value: function () {
      var _completeDays = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee70() {
        var a, b, days, startDay, i;
        return regenerator_default().wrap(function _callee70$(_context74) {
          while (1) switch (_context74.prev = _context74.next) {
            case 0:
              a = moment(this.StartDate);
              b = moment(this.EndDate);
              days = b.diff(a, 'days');
              startDay = this.BookingDays.length;
              i = startDay;
            case 5:
              if (!(i <= days)) {
                _context74.next = 11;
                break;
              }
              _context74.next = 8;
              return this.addNewDay();
            case 8:
              i++;
              _context74.next = 5;
              break;
            case 11:
            case "end":
              return _context74.stop();
          }
        }, _callee70, this);
      }));
      function completeDays() {
        return _completeDays.apply(this, arguments);
      }
      return completeDays;
    }()
  }, {
    key: "closeFile",
    value: function closeFile(baseCurrency) {
      if (this.Status != 'CLOSED') {
        this.Status = 'CLOSED';
      }
      var currentSummaryCurrencyId = this.SummaryCurrencyId;
      this.ProfitSummary = {};
      this.ProfitSummary[currentSummaryCurrencyId] = {
        Incomes: this.finalIncomes,
        CurrencyId: this.SummaryCurrencyId,
        Cost: this.finalCost,
        Profit: this.profit
      };
      if (this.SummaryCurrencyId == baseCurrency.BookingCurrency) {
        this.SummaryCurrencyId = baseCurrency.BaseCurrency;
      } else if (this.SummaryCurrencyId == baseCurrency.BaseCurrency) {
        this.SummaryCurrencyId = baseCurrency.BookingCurrency;
      }
      this.ProfitSummary[this.SummaryCurrencyId] = {
        Incomes: this.finalIncomes,
        CurrencyId: this.SummaryCurrencyId,
        Cost: this.finalCost,
        Profit: this.profit
      };
      this.SummaryCurrencyId = currentSummaryCurrencyId;
    }
  }, {
    key: "setOptionalServicesToBooking",
    value: function () {
      var _setOptionalServicesToBooking = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee71(services, suppliers) {
        var _this9 = this;
        var t1, update, addServices, optionalServices, cityId, _iterator207, _step207, _loop13, _iterator208, _step208, _loop14, _i11, _addServices2, row, t2;
        return regenerator_default().wrap(function _callee71$(_context77) {
          while (1) switch (_context77.prev = _context77.next) {
            case 0:
              t1 = moment(new Date()).valueOf();
              update = false;
              this._counter = 0;
              addServices = [];
              optionalServices = this.optionalServices(services);
              _context77.t0 = regenerator_default().keys(optionalServices);
            case 6:
              if ((_context77.t1 = _context77.t0()).done) {
                _context77.next = 28;
                break;
              }
              cityId = _context77.t1.value;
              _iterator207 = _createForOfIteratorHelper(optionalServices[cityId]);
              _context77.prev = 9;
              _loop13 = /*#__PURE__*/regenerator_default().mark(function _loop13() {
                var service, supplier, found, r, row;
                return regenerator_default().wrap(function _loop13$(_context75) {
                  while (1) switch (_context75.prev = _context75.next) {
                    case 0:
                      service = _step207.value;
                      supplier = _.find(suppliers, function (s) {
                        return service.SupplierId == s.id;
                      });
                      if (supplier) {
                        _context75.next = 4;
                        break;
                      }
                      return _context75.abrupt("return", 1);
                    case 4:
                      found = _.find(_this9.BookingOptionalServices, function (s) {
                        return s.ServiceId == service.id;
                      });
                      if (found) {
                        _context75.next = 11;
                        break;
                      }
                      r = {
                        ServiceId: service.id,
                        ServiceName: service.Name,
                        SupplierName: supplier.Name,
                        Include: false
                      };
                      _context75.next = 9;
                      return _this9.newRowByName('BookingOptionalServices', r);
                    case 9:
                      row = _context75.sent;
                      addServices.push(row);
                    case 11:
                    case "end":
                      return _context75.stop();
                  }
                }, _loop13);
              });
              _iterator207.s();
            case 12:
              if ((_step207 = _iterator207.n()).done) {
                _context77.next = 18;
                break;
              }
              return _context77.delegateYield(_loop13(), "t2", 14);
            case 14:
              if (!_context77.t2) {
                _context77.next = 16;
                break;
              }
              return _context77.abrupt("continue", 16);
            case 16:
              _context77.next = 12;
              break;
            case 18:
              _context77.next = 23;
              break;
            case 20:
              _context77.prev = 20;
              _context77.t3 = _context77["catch"](9);
              _iterator207.e(_context77.t3);
            case 23:
              _context77.prev = 23;
              _iterator207.f();
              return _context77.finish(23);
            case 26:
              _context77.next = 6;
              break;
            case 28:
              _iterator208 = _createForOfIteratorHelper(this.bookingServices);
              _context77.prev = 29;
              _loop14 = /*#__PURE__*/regenerator_default().mark(function _loop14() {
                var serviceId, i;
                return regenerator_default().wrap(function _loop14$(_context76) {
                  while (1) switch (_context76.prev = _context76.next) {
                    case 0:
                      serviceId = _step208.value;
                      i = _.findIndex(_this9.BookingOptionalServices, function (s) {
                        return s.ServiceId == serviceId;
                      });
                      if (i >= 0) {
                        _this9.BookingOptionalServices.splice(i, 1);
                      }
                    case 3:
                    case "end":
                      return _context76.stop();
                  }
                }, _loop14);
              });
              _iterator208.s();
            case 32:
              if ((_step208 = _iterator208.n()).done) {
                _context77.next = 36;
                break;
              }
              return _context77.delegateYield(_loop14(), "t4", 34);
            case 34:
              _context77.next = 32;
              break;
            case 36:
              _context77.next = 41;
              break;
            case 38:
              _context77.prev = 38;
              _context77.t5 = _context77["catch"](29);
              _iterator208.e(_context77.t5);
            case 41:
              _context77.prev = 41;
              _iterator208.f();
              return _context77.finish(41);
            case 44:
              //let interval = setInterval(() => {
              //if (this._counter==0) {
              //clearInterval(interval);
              for (_i11 = 0, _addServices2 = addServices; _i11 < _addServices2.length; _i11++) {
                row = _addServices2[_i11];
                this.BookingOptionalServices.push(row);
              }
              t2 = moment(new Date()).valueOf();
              console.log('setOptionalServicesToBooking', t2 - t1);
              //}
              //}, 100);
            case 47:
            case "end":
              return _context77.stop();
          }
        }, _callee71, this, [[9, 20, 23, 26], [29, 38, 41, 44]]);
      }));
      function setOptionalServicesToBooking(_x127, _x128) {
        return _setOptionalServicesToBooking.apply(this, arguments);
      }
      return setOptionalServicesToBooking;
    }()
  }, {
    key: "addToList",
    value: function () {
      var _addToList = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee72(list, r) {
        var row;
        return regenerator_default().wrap(function _callee72$(_context78) {
          while (1) switch (_context78.prev = _context78.next) {
            case 0:
              _context78.next = 2;
              return this.newRowByName('BookingOptionalServices', r);
            case 2:
              row = _context78.sent;
              list.push(row);
              this._counter += -1;
            case 5:
            case "end":
              return _context78.stop();
          }
        }, _callee72, this);
      }));
      function addToList(_x129, _x130) {
        return _addToList.apply(this, arguments);
      }
      return addToList;
    }()
  }, {
    key: "checkFields",
    value: function () {
      var _checkFields = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee73() {
        var res, hasPaxErrors, _iterator209, _step209, row, requiredErrors, errors, e, _e, required, roomsError, paxRoomError, hotelNull, hotelZero, roomsByHotelDay, _iterator210, _step210, day, j, _service$Service, service, baseId, data, _iterator211, _step211, paxType, quote, _j, hotel, k, room, hasHotelId, _e3, _e4, _e5, _e6, _baseId10, _quote2, key, today, start, _e2, c, mixedErrors;
        return regenerator_default().wrap(function _callee73$(_context79) {
          while (1) switch (_context79.prev = _context79.next) {
            case 0:
              _context79.next = 2;
              return _superPropGet(Booking, "checkFields", this, 3)([]);
            case 2:
              res = _context79.sent;
              if (res && this.invalid['BookingExpenses']) {
                hasPaxErrors = false;
                _iterator209 = _createForOfIteratorHelper(this.BookingExpenses);
                try {
                  for (_iterator209.s(); !(_step209 = _iterator209.n()).done;) {
                    row = _step209.value;
                    if (row.invalid) {
                      if (row.Type === 'PAX') hasPaxErrors = true;
                    }
                  }
                } catch (err) {
                  _iterator209.e(err);
                } finally {
                  _iterator209.f();
                }
                if (hasPaxErrors) {
                  this.invalid['quote'] = true;
                  delete this.invalid['BookingExpenses'];
                }
                this.invalid = Object.assign({}, this.invalid);
              }
              if (!res) {
                _context79.next = 6;
                break;
              }
              return _context79.abrupt("return", res);
            case 6:
              this.invalid = {};
              requiredErrors = [];
              errors = [];
              if (!this.isTemplate && !this.CurrencyId) {
                e = tr('Fill required fields');
                if (requiredErrors.indexOf(e) == -1) requiredErrors.push(e);
                this.invalid.CurrencyId = true;
                this.invalid.BookingQuote = true;
              }
              if (!this.isTemplate && !this.PriceCurrencyId) {
                _e = tr('Fill required fields');
                if (requiredErrors.indexOf(_e) == -1) requiredErrors.push(_e);
                this.invalid.PriceCurrencyId = true;
                this.invalid.BookingQuote = true;
              }
              required = tr('Complete cost, disable service or enter zero value');
              roomsError = tr('More than one hotel per quotation');
              paxRoomError = tr('Wrong room for number of pax quoted');
              hotelNull = tr('Hotel cost cannot be empty');
              hotelZero = tr('Hotel cost cannot be zero');
              if (this.PriceBreakdown) {
                if (!this.PaxFrom || !this.PaxTo) {
                  requiredErrors.push(tr('Fill passengers range for  breakdown'));
                  this.invalid.BookingQuote = true;
                }
              }
              roomsByHotelDay = {};
              _iterator210 = _createForOfIteratorHelper(this.BookingDays);
              _context79.prev = 19;
              _iterator210.s();
            case 21:
              if ((_step210 = _iterator210.n()).done) {
                _context79.next = 102;
                break;
              }
              day = _step210.value;
              _context79.t0 = regenerator_default().keys(day.BookingDayServices);
            case 24:
              if ((_context79.t1 = _context79.t0()).done) {
                _context79.next = 70;
                break;
              }
              j = _context79.t1.value;
              service = day.BookingDayServices[j];
              if (!(service.ServiceId && !((_service$Service = service.Service) !== null && _service$Service !== void 0 && _service$Service.id))) {
                _context79.next = 30;
                break;
              }
              _context79.next = 30;
              return service.setRelationTo(service.fieldsObject.ServiceId);
            case 30:
              if (!(service.Service && service.Service.NotPrice)) {
                _context79.next = 32;
                break;
              }
              return _context79.abrupt("continue", 24);
            case 32:
              if (!(service.Quote && service.Quote.QuoteList)) {
                _context79.next = 68;
                break;
              }
              _context79.t2 = regenerator_default().keys(this.BaseQuotes.bases);
            case 34:
              if ((_context79.t3 = _context79.t2()).done) {
                _context79.next = 68;
                break;
              }
              baseId = _context79.t3.value;
              if (service.Quote.QuoteList[baseId]) {
                _context79.next = 44;
                break;
              }
              console.log('baseId', baseId);
              console.log('QuoteList', service.Quote.QuoteList);
              data = [{
                baseId: baseId,
                QuoteList: service.Quote.QuoteList
              }];
              api.post('/api/send_logs/', JSON.stringify(data));
              return _context79.abrupt("continue", 34);
            case 44:
              _iterator211 = _createForOfIteratorHelper(service.Quote.QuoteList[baseId].paxTypes);
              _context79.prev = 45;
              _iterator211.s();
            case 47:
              if ((_step211 = _iterator211.n()).done) {
                _context79.next = 58;
                break;
              }
              paxType = _step211.value;
              if (!(this.quoteService && service.costPer == 'SERVICE' && this.getPaxTypesByBase(baseId).length > 1 && (paxType == 'CHD' || paxType == 'TL'))) {
                _context79.next = 51;
                break;
              }
              return _context79.abrupt("continue", 56);
            case 51:
              quote = service.Quote.QuoteList[baseId][paxType];
              if (quote) {
                _context79.next = 54;
                break;
              }
              return _context79.abrupt("continue", 56);
            case 54:
              quote.invalid = {};
              this.checkQuoteValues(quote, errors, required, day.DayNr, service.Name);
            case 56:
              _context79.next = 47;
              break;
            case 58:
              _context79.next = 63;
              break;
            case 60:
              _context79.prev = 60;
              _context79.t4 = _context79["catch"](45);
              _iterator211.e(_context79.t4);
            case 63:
              _context79.prev = 63;
              _iterator211.f();
              return _context79.finish(63);
            case 66:
              _context79.next = 34;
              break;
            case 68:
              _context79.next = 24;
              break;
            case 70:
              _context79.t5 = regenerator_default().keys(day.BookingDayHotels);
            case 71:
              if ((_context79.t6 = _context79.t5()).done) {
                _context79.next = 100;
                break;
              }
              _j = _context79.t6.value;
              hotel = day.BookingDayHotels[_j];
              _context79.t7 = regenerator_default().keys(hotel.BookingDayRooms);
            case 75:
              if ((_context79.t8 = _context79.t7()).done) {
                _context79.next = 98;
                break;
              }
              k = _context79.t8.value;
              room = hotel.BookingDayRooms[k];
              hasHotelId = room.Hotel && room.HotelId;
              if (!hasHotelId) {
                _e3 = "".concat(tr('Day'), " ").concat(day.DayNr + 1, " ").concat(tr('Hotel assignment pending'));
                if (requiredErrors.indexOf(_e3) == -1) requiredErrors.push(_e3);
              }
              if (room.Hotel && room.Hotel.Name && !room.RoomTypeId) {
                _e4 = "Hotel ".concat(room.Hotel.Name, " ").concat(tr('has no room type'));
                if (requiredErrors.indexOf(_e4) == -1) requiredErrors.push(_e4);
              }
              if (room.Hotel && room.Hotel.Name && !room.RoomCategory) {
                _e5 = "Hotel ".concat(room.Hotel.Name, " ").concat(tr('has no room category'));
                if (requiredErrors.indexOf(_e5) == -1) requiredErrors.push(_e5);
              }
              if (this.QuoteBy == 'PERSON' && !room.Rooms && this.bookingConfirmed) {
                _e6 = "Hotel ".concat(room.Hotel.Name, " ").concat(tr('has no quantity of rooms'));
                if (requiredErrors.indexOf(_e6) == -1) requiredErrors.push(_e6);
              }
              if (!room.QuoteList) {
                _context79.next = 96;
                break;
              }
              _context79.t9 = regenerator_default().keys(this.BaseQuotes.bases);
            case 85:
              if ((_context79.t10 = _context79.t9()).done) {
                _context79.next = 96;
                break;
              }
              _baseId10 = _context79.t10.value;
              _quote2 = room.QuoteList[_baseId10];
              if (_quote2) {
                _context79.next = 90;
                break;
              }
              return _context79.abrupt("continue", 85);
            case 90:
              if (_quote2.Include) {
                _context79.next = 92;
                break;
              }
              return _context79.abrupt("continue", 85);
            case 92:
              _quote2.invalid = {};
              this.checkHotelRoom(_quote2, errors, room, roomsByHotelDay, day, _baseId10, hotelNull, hotelZero, paxRoomError);
              _context79.next = 85;
              break;
            case 96:
              _context79.next = 75;
              break;
            case 98:
              _context79.next = 71;
              break;
            case 100:
              _context79.next = 21;
              break;
            case 102:
              _context79.next = 107;
              break;
            case 104:
              _context79.prev = 104;
              _context79.t11 = _context79["catch"](19);
              _iterator210.e(_context79.t11);
            case 107:
              _context79.prev = 107;
              _iterator210.f();
              return _context79.finish(107);
            case 110:
              for (key in roomsByHotelDay) {
                if (roomsByHotelDay[key] > 1 && this.QuoteBy == 'PERSON') {
                  if (errors.indexOf(roomsError) == -1) errors.push(roomsError);
                  this.invalid.BookingQuote = true;
                }
              }
              if (this.Status == 'QUOTE' && this.isNew) {
                today = new Date();
                start = new Date(this.StartDate);
                if (start <= today) {
                  _e2 = tr('NOT_AVAILABLE_DATE');
                  alert(_e2);
                }
              }
              if (!(requiredErrors.length > 0)) {
                _context79.next = 114;
                break;
              }
              return _context79.abrupt("return", requiredErrors);
            case 114:
              if (!(!this.quoteStatus && errors.length > 0)) {
                _context79.next = 121;
                break;
              }
              c = confirm("".concat(errors.join('; '), ". ").concat(tr('Continue?')));
              if (!c) {
                _context79.next = 120;
                break;
              }
              return _context79.abrupt("return", false);
            case 120:
              return _context79.abrupt("return", errors);
            case 121:
              ;
              mixedErrors = [].concat(errors, requiredErrors);
              if (!(mixedErrors.length > 0)) {
                _context79.next = 125;
                break;
              }
              return _context79.abrupt("return", mixedErrors);
            case 125:
            case "end":
              return _context79.stop();
          }
        }, _callee73, this, [[19, 104, 107, 110], [45, 60, 63, 66]]);
      }));
      function checkFields() {
        return _checkFields.apply(this, arguments);
      }
      return checkFields;
    }()
  }, {
    key: "checkQuoteValues",
    value: function checkQuoteValues(quote, errors, required, dayNr, serviceName) {
      var fields = ['Cost', 'Price'];
      if (this.QuoteBy == 'QUANTITY' && (quote.Cost || quote.Price)) fields.push('Quantity');
      for (var _i12 = 0, _fields = fields; _i12 < _fields.length; _i12++) {
        var fieldId = _fields[_i12];
        var valueNull = quote[fieldId] === null || quote[fieldId] === undefined || quote[fieldId] === '' || isNaN(quote[fieldId]);
        if (quote.Include && valueNull) {
          if (errors.indexOf(required) == -1) errors.push(required);
          quote.invalid[fieldId] = true;
          this.invalid.BookingQuote = true;
        }
      }
      this.checkQuoteValuesQuoteService(quote, errors, required, dayNr, serviceName);
    }
  }, {
    key: "checkQuoteValuesQuoteService",
    value: function checkQuoteValuesQuoteService(quote, errors, required, dayNr, serviceName) {
      if (this.QuoteBy == 'SERVICE') {
        if (!quote.costPer) {
          var t = "".concat(tr('Set Column Cost Per in service'), " ").concat(serviceName, ", ").concat(tr('day'), " ").concat(dayNr + 1);
          if (errors.indexOf(t) == -1) errors.push(t);
          quote.invalid.CostBy = true;
          this.invalid.BookingQuote = true;
        }
        var baseNull = tools.isNull(quote.Base);
        if (quote.Include && baseNull && quote.costPer == 'PERSON') {
          var _t = 'Set pax quantity';
          if (errors.indexOf(_t) == -1) errors.push(_t);
          quote.invalid.Base = true;
          this.invalid.BookingQuote = true;
        }
        var quantNull = tools.isNull(quote.Quantity);
        if (quote.Include && quantNull && quote.costPer == 'SERVICE') {
          var _t2 = 'Set quantity of services';
          if (errors.indexOf(_t2) == -1) errors.push(_t2);
          quote.invalid.Quantity = true;
          this.invalid.BookingQuote = true;
        }
      }
    }
  }, {
    key: "checkHotelRoom",
    value: function checkHotelRoom(quote, errors, room, roomsByHotelDay, day, baseId, hotelNull, hotelZero) {
      if (!api.userAllowBlankHotel) {
        var fields = ['Cost', 'Price'];
        if (this.QuoteBy == 'QUANTITY') fields.push('Rooms');
        if (this.QuoteBy == 'SERVICE' && !quote.Rooms) {
          quote.invalid.Rooms = true;
          this.invalid.BookingQuote = true;
          var t = 'Rooms quantity required in hotels';
          if (errors.indexOf(t) == -1) {
            errors.push(t);
          }
        }
        if (this.QuoteBy == 'SERVICE' && !quote.Pax) {
          quote.invalid.Pax = true;
          this.invalid.BookingQuote = true;
          var _t3 = 'Pax quantity required in hotels';
          if (errors.indexOf(_t3) == -1) {
            errors.push(_t3);
          }
        }
        for (var _i13 = 0, _fields2 = fields; _i13 < _fields2.length; _i13++) {
          var fieldId = _fields2[_i13];
          var valueNull = quote[fieldId] === null || quote[fieldId] === undefined || quote[fieldId] === '' || isNaN(quote[fieldId]);
          if (quote.Include && valueNull) {
            if (errors.indexOf(hotelNull) == -1) {
              errors.push(hotelNull);
            }
          }
          if (quote.Cost == 0 && quote.Include && !api.allowZeroHotel) {
            if (errors.indexOf(hotelZero) == -1) {
              errors.push(hotelZero);
            }
            quote.invalid.Cost = true;
          }
        }
      }
      if (quote.Include && room.Room && !room.Room.Checkin && !room.Room.ExtraBed && !this.isVariant(baseId)) {
        if (!roomsByHotelDay[[day.DayNr, baseId]]) {
          roomsByHotelDay[[day.DayNr, baseId]] = 0;
        }
        if (!room.TourLeader) {
          roomsByHotelDay[[day.DayNr, baseId]] += 1;
        }
        ;
      }
      this.checkRoomPaxQuantity(quote, errors, room, baseId);
    }
  }, {
    key: "checkRoomPaxQuantity",
    value: function checkRoomPaxQuantity(quote, errors, room, baseId) {
      if (this.QuoteBy == 'QUANTITY') return;
      if (this.QuoteBy == 'SERVICE') return;
      if (quote.Include && room.Room && room.Room.Pax > 1) {
        var q = 0;
        var _iterator212 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
          _step212;
        try {
          for (_iterator212.s(); !(_step212 = _iterator212.n()).done;) {
            var pax = _step212.value;
            if (!this.BaseQuotes[baseId][pax]) continue;
            q += this.BaseQuotes[baseId][pax];
          }
        } catch (err) {
          _iterator212.e(err);
        } finally {
          _iterator212.f();
        }
        if (q < room.Room.Pax) {
          var t;
          if (q == 1) t = "".concat(room.Hotel.Name, ": ").concat(q, " ").concat(tr('traveller must be in a single room'));
          if (t) {
            if (errors.indexOf(t) == -1) errors.push(t);
            quote.invalid.Cost = true;
            quote.invalid.Price = true;
            this.invalid.BookingQuote = true;
          }
        }
      }
    }
  }, {
    key: "copyFile",
    value: function () {
      var _copyFile = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee74() {
        var model, booking, baseId, _baseId11, _iterator213, _step213, _booking$Totals, pType, _iterator214, _step214, day, _iterator215, _step215, s, base, _iterator217, _step217, _pType10, _iterator216, _step216, hotel, _iterator218, _step218, room, _baseId12;
        return regenerator_default().wrap(function _callee74$(_context80) {
          while (1) switch (_context80.prev = _context80.next) {
            case 0:
              _context80.next = 2;
              return api.importMixinModule('booking', 'model');
            case 2:
              model = _context80.sent;
              _context80.next = 5;
              return model.clone({
                isTemplate: this.isTemplate,
                record: _.cloneDeep(this)
              });
            case 5:
              booking = _context80.sent;
              booking.removeArchived();
              if (!(this.constructor.swapQuoteBy && booking.QuoteBy === 'PERSON' && this.isForcePaxQty)) {
                _context80.next = 18;
                break;
              }
              _context80.t0 = regenerator_default().keys(booking.BaseQuotes.bases);
            case 9:
              if ((_context80.t1 = _context80.t0()).done) {
                _context80.next = 15;
                break;
              }
              baseId = _context80.t1.value;
              _context80.next = 13;
              return booking.removeBase(baseId);
            case 13:
              _context80.next = 9;
              break;
            case 15:
              booking.QuoteBy = 'SERVICE';
              _context80.next = 118;
              break;
            case 18:
              if (!(this.constructor.swapQuoteBy && booking.QuoteBy === 'PERSON')) {
                _context80.next = 23;
                break;
              }
              _context80.next = 21;
              return booking.setPersonToService();
            case 21:
              _context80.next = 118;
              break;
            case 23:
              for (_baseId11 in booking.BaseQuotes.bases) {
                _iterator213 = _createForOfIteratorHelper(booking.BaseQuotes[_baseId11].paxTypes);
                try {
                  for (_iterator213.s(); !(_step213 = _iterator213.n()).done;) {
                    pType = _step213.value;
                    if (!tools.isNull((_booking$Totals = booking.Totals) === null || _booking$Totals === void 0 || (_booking$Totals = _booking$Totals[_baseId11]) === null || _booking$Totals === void 0 || (_booking$Totals = _booking$Totals[pType]) === null || _booking$Totals === void 0 ? void 0 : _booking$Totals.OverPrice)) {
                      booking.Totals[_baseId11][pType].OverPrice = false;
                      if (this.quoteService) booking.Totals[_baseId11][pType].OverPersonPrice = false;
                    }
                  }
                } catch (err) {
                  _iterator213.e(err);
                } finally {
                  _iterator213.f();
                }
              }
              _iterator214 = _createForOfIteratorHelper(booking.BookingDays);
              _context80.prev = 25;
              _iterator214.s();
            case 27:
              if ((_step214 = _iterator214.n()).done) {
                _context80.next = 110;
                break;
              }
              day = _step214.value;
              _iterator215 = _createForOfIteratorHelper(day.BookingDayServices);
              _context80.prev = 30;
              _iterator215.s();
            case 32:
              if ((_step215 = _iterator215.n()).done) {
                _context80.next = 62;
                break;
              }
              s = _step215.value;
              if (!(s.Quote && s.Quote.QuoteList)) {
                _context80.next = 60;
                break;
              }
              _context80.t2 = regenerator_default().keys(booking.BaseQuotes.bases);
            case 36:
              if ((_context80.t3 = _context80.t2()).done) {
                _context80.next = 60;
                break;
              }
              base = _context80.t3.value;
              _iterator217 = _createForOfIteratorHelper(booking.BaseQuotes[base].paxTypes);
              _context80.prev = 39;
              _iterator217.s();
            case 41:
              if ((_step217 = _iterator217.n()).done) {
                _context80.next = 50;
                break;
              }
              _pType10 = _step217.value;
              if (s.Quote.QuoteList[base]) {
                _context80.next = 45;
                break;
              }
              return _context80.abrupt("continue", 48);
            case 45:
              if (s.Quote.QuoteList[base][_pType10]) {
                _context80.next = 47;
                break;
              }
              return _context80.abrupt("continue", 48);
            case 47:
              s.Quote.QuoteList[base][_pType10].setTotals();
            case 48:
              _context80.next = 41;
              break;
            case 50:
              _context80.next = 55;
              break;
            case 52:
              _context80.prev = 52;
              _context80.t4 = _context80["catch"](39);
              _iterator217.e(_context80.t4);
            case 55:
              _context80.prev = 55;
              _iterator217.f();
              return _context80.finish(55);
            case 58:
              _context80.next = 36;
              break;
            case 60:
              _context80.next = 32;
              break;
            case 62:
              _context80.next = 67;
              break;
            case 64:
              _context80.prev = 64;
              _context80.t5 = _context80["catch"](30);
              _iterator215.e(_context80.t5);
            case 67:
              _context80.prev = 67;
              _iterator215.f();
              return _context80.finish(67);
            case 70:
              _iterator216 = _createForOfIteratorHelper(day.BookingDayHotels);
              _context80.prev = 71;
              _iterator216.s();
            case 73:
              if ((_step216 = _iterator216.n()).done) {
                _context80.next = 100;
                break;
              }
              hotel = _step216.value;
              _iterator218 = _createForOfIteratorHelper(hotel.BookingDayRooms);
              _context80.prev = 76;
              _iterator218.s();
            case 78:
              if ((_step218 = _iterator218.n()).done) {
                _context80.next = 90;
                break;
              }
              room = _step218.value;
              _context80.t6 = regenerator_default().keys(booking.BaseQuotes.bases);
            case 81:
              if ((_context80.t7 = _context80.t6()).done) {
                _context80.next = 88;
                break;
              }
              _baseId12 = _context80.t7.value;
              if (room.QuoteList[_baseId12]) {
                _context80.next = 85;
                break;
              }
              return _context80.abrupt("continue", 81);
            case 85:
              room.QuoteList[_baseId12].setTotals();
              _context80.next = 81;
              break;
            case 88:
              _context80.next = 78;
              break;
            case 90:
              _context80.next = 95;
              break;
            case 92:
              _context80.prev = 92;
              _context80.t8 = _context80["catch"](76);
              _iterator218.e(_context80.t8);
            case 95:
              _context80.prev = 95;
              _iterator218.f();
              return _context80.finish(95);
            case 98:
              _context80.next = 73;
              break;
            case 100:
              _context80.next = 105;
              break;
            case 102:
              _context80.prev = 102;
              _context80.t9 = _context80["catch"](71);
              _iterator216.e(_context80.t9);
            case 105:
              _context80.prev = 105;
              _iterator216.f();
              return _context80.finish(105);
            case 108:
              _context80.next = 27;
              break;
            case 110:
              _context80.next = 115;
              break;
            case 112:
              _context80.prev = 112;
              _context80.t10 = _context80["catch"](25);
              _iterator214.e(_context80.t10);
            case 115:
              _context80.prev = 115;
              _iterator214.f();
              return _context80.finish(115);
            case 118:
              booking.setBookingTotals();
              return _context80.abrupt("return", booking);
            case 120:
            case "end":
              return _context80.stop();
          }
        }, _callee74, this, [[25, 112, 115, 118], [30, 64, 67, 70], [39, 52, 55, 58], [71, 102, 105, 108], [76, 92, 95, 98]]);
      }));
      function copyFile() {
        return _copyFile.apply(this, arguments);
      }
      return copyFile;
    }()
  }, {
    key: "createBookingFromCatalogue",
    value: function () {
      var _createBookingFromCatalogue = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee75() {
        var booking;
        return regenerator_default().wrap(function _callee75$(_context81) {
          while (1) switch (_context81.prev = _context81.next) {
            case 0:
              _context81.next = 2;
              return this.copyFile();
            case 2:
              booking = _context81.sent;
              if (booking) {
                booking.TemplateType = 'NONE';
                booking.Status = 'QUOTE';
                booking.SalesUserId = api.currentUser.id;
              }
              return _context81.abrupt("return", booking);
            case 5:
            case "end":
              return _context81.stop();
          }
        }, _callee75, this);
      }));
      function createBookingFromCatalogue() {
        return _createBookingFromCatalogue.apply(this, arguments);
      }
      return createBookingFromCatalogue;
    }()
  }, {
    key: "removeArchived",
    value: function removeArchived() {
      var _iterator219 = _createForOfIteratorHelper(this.BookingDays),
        _step219;
      try {
        for (_iterator219.s(); !(_step219 = _iterator219.n()).done;) {
          var day = _step219.value;
          var toRemove = [];
          for (var i in day.BookingDayServices) {
            var s = day.BookingDayServices[i];
            if (s && s.Service && s.Service.Closed) {
              toRemove.push(i);
            }
          }
          for (var _i14 = 0, _toRemove = toRemove; _i14 < _toRemove.length; _i14++) {
            var _i15 = _toRemove[_i14];
            day.removeService(_i15);
          }
          if (day.BookingDayHotels[0]) {
            var _iterator220 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms),
              _step220;
            try {
              for (_iterator220.s(); !(_step220 = _iterator220.n()).done;) {
                var room = _step220.value;
                if (room.HotelId && room.Hotel && room.Hotel.Closed) {
                  room.HotelId = null;
                }
              }
            } catch (err) {
              _iterator220.e(err);
            } finally {
              _iterator220.f();
            }
          }
        }
      } catch (err) {
        _iterator219.e(err);
      } finally {
        _iterator219.f();
      }
    }
  }, {
    key: "setHotelStatus",
    value: function setHotelStatus(value, hotel) {
      var _iterator221 = _createForOfIteratorHelper(this.BookingDays),
        _step221;
      try {
        for (_iterator221.s(); !(_step221 = _iterator221.n()).done;) {
          var day = _step221.value;
          var _iterator222 = _createForOfIteratorHelper(day.BookingDayHotels),
            _step222;
          try {
            for (_iterator222.s(); !(_step222 = _iterator222.n()).done;) {
              var h = _step222.value;
              var _iterator223 = _createForOfIteratorHelper(h.BookingDayRooms),
                _step223;
              try {
                for (_iterator223.s(); !(_step223 = _iterator223.n()).done;) {
                  var room = _step223.value;
                  if (!room.Hotel) continue;
                  if (!room.Hotel.Supplier) continue;
                  if (!room.Hotel.Supplier.id || room.Hotel.Supplier.id != hotel.Supplier.id) continue;
                  room.Status = value;
                }
              } catch (err) {
                _iterator223.e(err);
              } finally {
                _iterator223.f();
              }
            }
          } catch (err) {
            _iterator222.e(err);
          } finally {
            _iterator222.f();
          }
        }
      } catch (err) {
        _iterator221.e(err);
      } finally {
        _iterator221.f();
      }
    }
  }, {
    key: "setServiceStatus",
    value: function setServiceStatus(value, services) {
      var _iterator224 = _createForOfIteratorHelper(services),
        _step224;
      try {
        for (_iterator224.s(); !(_step224 = _iterator224.n()).done;) {
          var service = _step224.value;
          service.Status = value;
        }
      } catch (err) {
        _iterator224.e(err);
      } finally {
        _iterator224.f();
      }
    }
  }, {
    key: "viewOptions",
    get: function get() {
      var res = [{
        value: -1,
        label: 'Full Trip'
      }];
      for (var baseId in this.BaseQuotes.bases) {
        var _iterator225 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
          _step225;
        try {
          for (_iterator225.s(); !(_step225 = _iterator225.n()).done;) {
            var pType = _step225.value;
            if (!this.Totals[baseId]) continue;
            if (!this.Totals[baseId][pType]) continue;
            if (!this.Totals[baseId][pType].Selected) continue;
            if (!this.Totals[baseId][pType].Comment) continue;
            res.push({
              value: baseId,
              label: this.Totals[baseId][pType].Comment
            });
          }
        } catch (err) {
          _iterator225.e(err);
        } finally {
          _iterator225.f();
        }
      }
      return res;
    }
  }, {
    key: "hotelViewMode",
    value: function hotelViewMode(hotel) {
      if (this.ViewMode == -1) return true;
      var _iterator226 = _createForOfIteratorHelper(hotel.BookingDayRooms),
        _step226;
      try {
        for (_iterator226.s(); !(_step226 = _iterator226.n()).done;) {
          var room = _step226.value;
          if (room.QuoteList[this.ViewMode] && room.QuoteList[this.ViewMode].Include) {
            return true;
          }
        }
      } catch (err) {
        _iterator226.e(err);
      } finally {
        _iterator226.f();
      }
    }
  }, {
    key: "statusChangeOptions",
    get: function get() {
      var view = api.importMixinModule('booking', 'views');
      var options = view.bookingStatus;
      var optionsList = Object.keys(options);
      optionsList = _.filter(optionsList, function (r) {
        return r != 'ENDED';
      });
      var r = {
        QUOTE: optionsList,
        QUOTE_LOST: optionsList
      };
      return r;
    }
  }, {
    key: "setStatusOptions",
    value: function setStatusOptions(res) {
      var enabledStatus = this.statusChangeOptions[this.Status];
      var view = api.importMixinModule('booking', 'views');
      var dStatus = view.disabledStatus();
      var _iterator227 = _createForOfIteratorHelper(res.Status.options),
        _step227;
      try {
        for (_iterator227.s(); !(_step227 = _iterator227.n()).done;) {
          var r = _step227.value;
          if (r.value == this.Status) {
            r.disabled = false;
          } else if (enabledStatus && enabledStatus.indexOf(r.value) == -1 || dStatus[r.value]) {
            r.disabled = true;
          } else {
            r.disabled = false;
          }
          ;
          if (!this.id && r.value != 'QUOTE') r.disabled = true;
        }
      } catch (err) {
        _iterator227.e(err);
      } finally {
        _iterator227.f();
      }
    }
  }, {
    key: "getFieldsObject",
    value: function getFieldsObject(fields) {
      var res = _superPropGet(Booking, "getFieldsObject", this, 3)([fields]);
      if (res.Status) {
        this.setStatusOptions(res);
      }
      return res;
    }
  }, {
    key: "rooming",
    get: function get() {
      var res = {};
      var _iterator228 = _createForOfIteratorHelper(this.BookingDays),
        _step228;
      try {
        for (_iterator228.s(); !(_step228 = _iterator228.n()).done;) {
          var day = _step228.value;
          var _iterator229 = _createForOfIteratorHelper(day.BookingDayHotels),
            _step229;
          try {
            for (_iterator229.s(); !(_step229 = _iterator229.n()).done;) {
              var hotel = _step229.value;
              var _iterator230 = _createForOfIteratorHelper(hotel.BookingDayRooms),
                _step230;
              try {
                for (_iterator230.s(); !(_step230 = _iterator230.n()).done;) {
                  var room = _step230.value;
                  var _id7 = room.id || room.tempId;
                  res[_id7] = {
                    room: room,
                    days: hotel.Days,
                    roomCost: null
                  };
                  var pax = 0;
                  for (var baseId in this.BaseQuotes.bases) {
                    if (!room.QuoteList) continue;
                    if (!room.QuoteList[baseId]) continue;
                    if (!room.QuoteList[baseId].Include) continue;
                    if (room.QuoteList[baseId].RoomCost) res[_id7].roomCost = room.QuoteList[baseId].RoomCost;
                    var baseQuote = this.BaseQuotes[baseId];
                    var basePax = baseQuote.paxQuantity;
                    var tPax = 0;
                    var _iterator231 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
                      _step231;
                    try {
                      for (_iterator231.s(); !(_step231 = _iterator231.n()).done;) {
                        var pType = _step231.value;
                        if (!this.Totals[baseId]) continue;
                        if (!this.Totals[baseId][pType]) continue;
                        //if (!this.Totals[baseId][pType].Selected) continue;
                        if (!this.isQuoteSelected(baseId, pType)) continue;
                        if (this.Totals[baseId][pType].Pax) tPax += this.Totals[baseId][pType].Pax;
                      }
                    } catch (err) {
                      _iterator231.e(err);
                    } finally {
                      _iterator231.f();
                    }
                    if (tPax) basePax = tPax;
                    pax += basePax;
                  }
                  res[_id7].Pax = pax;
                }
              } catch (err) {
                _iterator230.e(err);
              } finally {
                _iterator230.f();
              }
            }
          } catch (err) {
            _iterator229.e(err);
          } finally {
            _iterator229.f();
          }
        }
      } catch (err) {
        _iterator228.e(err);
      } finally {
        _iterator228.f();
      }
      for (var id in res) {
        var row = res[id];
        var c = parseFloat(row.roomCost) * row.room.roomsQuantity * row.days / row.Pax;
      }
      return res;
    }
  }, {
    key: "afterSave",
    value: function afterSave() {
      this.getFieldsObject(this.fields);
      this.setReceipts(this.id);
      this.setPayments(this.id);
      api.setSupplierCredits(this.id);
      api.hotelCost = {};
    }
  }, {
    key: "daysLength",
    get: function get() {
      if (this.SkipDays) {
        var l = this.BookingDays.length;
        if (this.BookingDays[l - 1]) return this.BookingDays[l - 1].DayNr + 1;
      }
      return this.BookingDays.length;
    }

    ////// variants start
  }, {
    key: "newVariant",
    value: function newVariant(g) {
      return {
        Name: g ? g.Name : '',
        OverPrice: {},
        Selected: {
          ADT: true
        },
        HotelCategoryId: null,
        Comments: {}
      };
    }
  }, {
    key: "saveVariants",
    value: function saveVariants(baseId, variants) {
      if (!this.QuoteVariants) this.QuoteVariants = {};
      if (!this.QuoteVariants[baseId]) this.QuoteVariants[baseId] = {};
      for (var variantId in variants) {
        var g = variants[variantId];
        if (!this.QuoteVariants[baseId][variantId]) {
          this.QuoteVariants[baseId][variantId] = this.newVariant(g);
        } else {
          this.QuoteVariants[baseId][variantId].Name = g.Name;
        }
        if (!this.QuoteVariants[baseId][variantId].Comments) {
          this.QuoteVariants[baseId][variantId].Comments = {};
        }
      }
      var _iterator232 = _createForOfIteratorHelper(this.BookingDays),
        _step232;
      try {
        for (_iterator232.s(); !(_step232 = _iterator232.n()).done;) {
          var day = _step232.value;
          var _iterator234 = _createForOfIteratorHelper(day.BookingDayServices),
            _step234;
          try {
            for (_iterator234.s(); !(_step234 = _iterator234.n()).done;) {
              var s = _step234.value;
              if (s.Quote.QuoteList && s.Quote.QuoteList[baseId]) {
                if (!s.Quote.QuoteList[baseId].Variants) {
                  s.Quote.QuoteList[baseId].Variants = {};
                }
                for (var _variantId in this.QuoteVariants[baseId]) {
                  var ids = Object.keys(s.Quote.QuoteList[baseId].Variants);
                  if (ids.indexOf(_variantId) == -1) {
                    s.Quote.QuoteList[baseId].Variants[_variantId] = true;
                  }
                }
                for (var _variantId2 in s.Quote.QuoteList[baseId].Variants) {
                  if (!this.QuoteVariants[baseId][_variantId2]) {
                    delete s.Quote.QuoteList[baseId].Variants[_variantId2];
                  }
                }
              }
            }
          } catch (err) {
            _iterator234.e(err);
          } finally {
            _iterator234.f();
          }
          var _iterator235 = _createForOfIteratorHelper(day.BookingDayHotels),
            _step235;
          try {
            for (_iterator235.s(); !(_step235 = _iterator235.n()).done;) {
              var hotel = _step235.value;
              var _iterator236 = _createForOfIteratorHelper(hotel.BookingDayRooms),
                _step236;
              try {
                for (_iterator236.s(); !(_step236 = _iterator236.n()).done;) {
                  var room = _step236.value;
                  for (var p in room.QuoteList[baseId]) {
                    if (!room.QuoteList[baseId].Variants) {
                      room.QuoteList[baseId].Variants = {};
                    }
                    for (var _variantId3 in this.QuoteVariants[baseId]) {
                      var _ids = Object.keys(room.QuoteList[baseId].Variants);
                      if (_ids.indexOf(_variantId3) == -1) {
                        room.QuoteList[baseId].Variants[_variantId3] = true;
                      }
                    }
                    for (var _variantId4 in room.QuoteList[baseId].Variants) {
                      if (!this.QuoteVariants[baseId][_variantId4]) {
                        delete room.QuoteList[baseId].Variants[_variantId4];
                      }
                    }
                  }
                }
              } catch (err) {
                _iterator236.e(err);
              } finally {
                _iterator236.f();
              }
            }
          } catch (err) {
            _iterator235.e(err);
          } finally {
            _iterator235.f();
          }
        }
      } catch (err) {
        _iterator232.e(err);
      } finally {
        _iterator232.f();
      }
      var _iterator233 = _createForOfIteratorHelper(this.BookingFlights),
        _step233;
      try {
        for (_iterator233.s(); !(_step233 = _iterator233.n()).done;) {
          var flight = _step233.value;
          for (var _baseId13 in this.BaseQuotes.bases) {
            if (!flight.QuoteList) continue;
            if (!flight.QuoteList[_baseId13]) continue;
            if (!flight.QuoteList[_baseId13].Variants) {
              flight.QuoteList[_baseId13].Variants = {};
            }
            for (var _variantId5 in this.QuoteVariants[_baseId13]) {
              var _ids2 = Object.keys(flight.QuoteList[_baseId13].Variants);
              if (_ids2.indexOf(_variantId5) == -1) {
                flight.QuoteList[_baseId13].Variants[_variantId5] = true;
              }
            }
            for (var _variantId6 in flight.QuoteList[_baseId13].Variants) {
              if (!this.QuoteVariants[_baseId13][_variantId6]) {
                delete flight.QuoteList[_baseId13].Variants[_variantId6];
              }
            }
          }
        }
      } catch (err) {
        _iterator233.e(err);
      } finally {
        _iterator233.f();
      }
      this.forceVariantGetters = !this.forceVariantGetters;
    }
  }, {
    key: "addVariant",
    value: function addVariant(baseId) {
      var base = this.BaseQuotes[baseId];
      if (!this.QuoteVariants) this.QuoteVariants = {};
      var variants = this.QuoteVariants[baseId];
      var variant = this.newVariant();
      if (base.CHD) {
        variant.Selected.CHD = true;
      }
      ;
      if (base.TL) {
        variant.Selected.TL = true;
      }
      ;
      if (!variants || Object.keys(variants).length == 0) {
        variants = {
          0: Object.assign({}, variant),
          1: Object.assign({}, variant)
        };
      } else {
        var k = this.getNextVariantId(variants);
        variants[k] = Object.assign({}, variant);
      }
      this.QuoteVariants[baseId] = variants;
    }
  }, {
    key: "getNextVariantId",
    value: function getNextVariantId(variants) {
      var l = Object.keys(variants);
      if (l.length == 0) {
        return 0;
      }
      var lInts = [];
      for (var _i16 = 0, _l2 = l; _i16 < _l2.length; _i16++) {
        var k = _l2[_i16];
        lInts.push(parseInt(k));
      }
      var max = Math.max.apply(Math, lInts);
      return max + 1;
    }
  }, {
    key: "setPaxByVariants",
    value: function () {
      var _setPaxByVariants = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee76(baseId) {
        var variants, isVariant, _iterator237, _step237, day, _iterator239, _step239, s, adt, chd, tl, variantId, _iterator238, _step238, flight, field;
        return regenerator_default().wrap(function _callee76$(_context82) {
          while (1) switch (_context82.prev = _context82.next) {
            case 0:
              variants = this.QuoteVariants[baseId];
              isVariant = this.isVariant(baseId);
              _iterator237 = _createForOfIteratorHelper(this.BookingDays);
              _context82.prev = 3;
              _iterator237.s();
            case 5:
              if ((_step237 = _iterator237.n()).done) {
                _context82.next = 55;
                break;
              }
              day = _step237.value;
              _iterator239 = _createForOfIteratorHelper(day.BookingDayServices);
              _context82.prev = 8;
              _iterator239.s();
            case 10:
              if ((_step239 = _iterator239.n()).done) {
                _context82.next = 45;
                break;
              }
              s = _step239.value;
              if (!(s.Quote.QuoteList && s.Quote.QuoteList[baseId])) {
                _context82.next = 43;
                break;
              }
              adt = 0;
              chd = 0;
              tl = 0;
              if (!isVariant) {
                _context82.next = 31;
                break;
              }
              _context82.t0 = regenerator_default().keys(variants);
            case 18:
              if ((_context82.t1 = _context82.t0()).done) {
                _context82.next = 29;
                break;
              }
              variantId = _context82.t1.value;
              if (s.Quote.QuoteList[baseId].Variants) {
                _context82.next = 22;
                break;
              }
              return _context82.abrupt("continue", 18);
            case 22:
              if (s.Quote.QuoteList[baseId].Variants[variantId]) {
                _context82.next = 24;
                break;
              }
              return _context82.abrupt("continue", 18);
            case 24:
              if (variants[variantId].ADT) adt += variants[variantId].ADT;
              if (variants[variantId].CHD) chd += variants[variantId].CHD;
              if (variants[variantId].TL) tl += variants[variantId].TL;
              _context82.next = 18;
              break;
            case 29:
              _context82.next = 34;
              break;
            case 31:
              adt = parseInt(this.BaseQuotes[baseId].ADT);
              chd = parseInt(this.BaseQuotes[baseId].CHD);
              tl = parseInt(this.BaseQuotes[baseId].TL);
            case 34:
              if (!s.Quote.QuoteList[baseId].ADT) {
                _context82.next = 37;
                break;
              }
              _context82.next = 37;
              return s.Quote.QuoteList[baseId].ADT.setValue({
                fieldName: 'Base',
                value: adt
              });
            case 37:
              if (!s.Quote.QuoteList[baseId].CHD) {
                _context82.next = 40;
                break;
              }
              _context82.next = 40;
              return s.Quote.QuoteList[baseId].CHD.setValue({
                fieldName: 'Base',
                value: chd
              });
            case 40:
              if (!s.Quote.QuoteList[baseId].TL) {
                _context82.next = 43;
                break;
              }
              _context82.next = 43;
              return s.Quote.QuoteList[baseId].TL.setValue({
                fieldName: 'Base',
                value: tl
              });
            case 43:
              _context82.next = 10;
              break;
            case 45:
              _context82.next = 50;
              break;
            case 47:
              _context82.prev = 47;
              _context82.t2 = _context82["catch"](8);
              _iterator239.e(_context82.t2);
            case 50:
              _context82.prev = 50;
              _iterator239.f();
              return _context82.finish(50);
            case 53:
              _context82.next = 5;
              break;
            case 55:
              _context82.next = 60;
              break;
            case 57:
              _context82.prev = 57;
              _context82.t3 = _context82["catch"](3);
              _iterator237.e(_context82.t3);
            case 60:
              _context82.prev = 60;
              _iterator237.f();
              return _context82.finish(60);
            case 63:
              _iterator238 = _createForOfIteratorHelper(this.BookingFlights);
              try {
                for (_iterator238.s(); !(_step238 = _iterator238.n()).done;) {
                  flight = _step238.value;
                  field = _.find(flight.fieldsList, function (c) {
                    return c.name == 'FlightCost';
                  });
                  flight.afterEditField(field, flight.FlightCost, flight.FlightCost);
                  //flight.setValue({fieldName: 'FlightCost', value: flight.FlightCost + 0.000001});
                }
              } catch (err) {
                _iterator238.e(err);
              } finally {
                _iterator238.f();
              }
            case 65:
            case "end":
              return _context82.stop();
          }
        }, _callee76, this, [[3, 57, 60, 63], [8, 47, 50, 53]]);
      }));
      function setPaxByVariants(_x131) {
        return _setPaxByVariants.apply(this, arguments);
      }
      return setPaxByVariants;
    }()
  }, {
    key: "removeVariant",
    value: function removeVariant(baseId, variantId) {
      delete this.QuoteVariants[baseId][variantId];
      var _iterator240 = _createForOfIteratorHelper(this.BookingDays),
        _step240;
      try {
        for (_iterator240.s(); !(_step240 = _iterator240.n()).done;) {
          var day = _step240.value;
          var _iterator242 = _createForOfIteratorHelper(day.BookingDayServices),
            _step242;
          try {
            for (_iterator242.s(); !(_step242 = _iterator242.n()).done;) {
              var s = _step242.value;
              if (s.Quote.QuoteList && s.Quote.QuoteList[baseId]) {
                if (!s.Quote.QuoteList[baseId].Variants) {
                  delete s.Quote.QuoteList[baseId].Variants[variantId];
                }
              }
            }
          } catch (err) {
            _iterator242.e(err);
          } finally {
            _iterator242.f();
          }
          var _iterator243 = _createForOfIteratorHelper(day.BookingDayHotels),
            _step243;
          try {
            for (_iterator243.s(); !(_step243 = _iterator243.n()).done;) {
              var hotel = _step243.value;
              var _iterator244 = _createForOfIteratorHelper(hotel.BookingDayRooms),
                _step244;
              try {
                for (_iterator244.s(); !(_step244 = _iterator244.n()).done;) {
                  var room = _step244.value;
                  for (var p in room.QuoteList[baseId]) {
                    if (!room.QuoteList[baseId].Variants) {
                      delete room.QuoteList[baseId].Variants[variantId];
                    }
                  }
                }
              } catch (err) {
                _iterator244.e(err);
              } finally {
                _iterator244.f();
              }
            }
          } catch (err) {
            _iterator243.e(err);
          } finally {
            _iterator243.f();
          }
        }
      } catch (err) {
        _iterator240.e(err);
      } finally {
        _iterator240.f();
      }
      var _iterator241 = _createForOfIteratorHelper(this.BookingFlights),
        _step241;
      try {
        for (_iterator241.s(); !(_step241 = _iterator241.n()).done;) {
          var flight = _step241.value;
          for (var _baseId14 in this.BaseQuotes.bases) {
            if (!flight.QuoteList) continue;
            if (!flight.QuoteList[_baseId14]) continue;
            if (flight.QuoteList[_baseId14].Variants) {
              delete flight.QuoteList[_baseId14].Variants[variantId];
            }
          }
        }
      } catch (err) {
        _iterator241.e(err);
      } finally {
        _iterator241.f();
      }
      this.forceVariantGetters = !this.forceVariantGetters;
    }
  }, {
    key: "removeVariants",
    value: function removeVariants(baseId) {
      delete this.QuoteVariants[baseId];
      var _iterator245 = _createForOfIteratorHelper(this.BookingDays),
        _step245;
      try {
        for (_iterator245.s(); !(_step245 = _iterator245.n()).done;) {
          var day = _step245.value;
          var _iterator247 = _createForOfIteratorHelper(day.BookingDayServices),
            _step247;
          try {
            for (_iterator247.s(); !(_step247 = _iterator247.n()).done;) {
              var s = _step247.value;
              if (s.Quote.QuoteList && s.Quote.QuoteList[baseId]) {
                s.Quote.QuoteList[baseId].Variants = null;
              }
            }
          } catch (err) {
            _iterator247.e(err);
          } finally {
            _iterator247.f();
          }
          var _iterator248 = _createForOfIteratorHelper(day.BookingDayHotels),
            _step248;
          try {
            for (_iterator248.s(); !(_step248 = _iterator248.n()).done;) {
              var hotel = _step248.value;
              var _iterator249 = _createForOfIteratorHelper(hotel.BookingDayRooms),
                _step249;
              try {
                for (_iterator249.s(); !(_step249 = _iterator249.n()).done;) {
                  var room = _step249.value;
                  if (room.QuoteList[baseId]) {
                    room.QuoteList[baseId].Variants = null;
                  }
                }
              } catch (err) {
                _iterator249.e(err);
              } finally {
                _iterator249.f();
              }
            }
          } catch (err) {
            _iterator248.e(err);
          } finally {
            _iterator248.f();
          }
        }
      } catch (err) {
        _iterator245.e(err);
      } finally {
        _iterator245.f();
      }
      var _iterator246 = _createForOfIteratorHelper(this.BookingFlights),
        _step246;
      try {
        for (_iterator246.s(); !(_step246 = _iterator246.n()).done;) {
          var flight = _step246.value;
          if (!flight.QuoteList) continue;
          if (!flight.QuoteList[baseId]) continue;
          flight.QuoteList[baseId].Variants = null;
        }
      } catch (err) {
        _iterator246.e(err);
      } finally {
        _iterator246.f();
      }
    }
  }, {
    key: "sumUpVariants",
    get: function get() {
      var res = {};
      if (this.QuoteVariants) {
        for (var baseId in this.BaseQuotes.bases) {
          if (!this.isVariant(baseId)) continue;
          var totalVariants = this.totalByPaxVariant[baseId];
          if (!this.QuoteVariants[baseId]) continue;
          for (var variantId in this.QuoteVariants[baseId]) {
            if (!this.totalByPaxVariant[baseId][variantId]) continue;
            var _iterator250 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
              _step250;
            try {
              for (_iterator250.s(); !(_step250 = _iterator250.n()).done;) {
                var pType = _step250.value;
                if (!this.totalByPaxVariant[baseId][variantId][pType]) continue;
                if (!this.QuoteVariants[baseId][variantId]) continue;
                if (!this.QuoteVariants[baseId][variantId][pType]) continue;
                if (!res[baseId]) res[baseId] = {
                  Price: 0,
                  Cost: 0
                };
                var v = this.totalByPaxVariant[baseId][variantId][pType].Price * this.QuoteVariants[baseId][variantId][pType];
                res[baseId].Price += v;
                var c = this.totalByPaxVariant[baseId][variantId][pType].Cost * this.QuoteVariants[baseId][variantId][pType];
                res[baseId].Cost += c;
              }
            } catch (err) {
              _iterator250.e(err);
            } finally {
              _iterator250.f();
            }
          }
        }
      }
      if (this.CurrencyId != this.PriceCurrencyId) {
        for (var _baseId15 in res) {
          var _v7 = res[_baseId15].Price;
          res[_baseId15].Price = this.currencyConvert(this.CurrencyId, this.PriceCurrencyId, _v7);
          var _c = res[_baseId15].Cost;
          res[_baseId15].Cost = this.currencyConvert(this.CurrencyId, this.PriceCurrencyId, _c);
        }
      }
      return res;
    }
  }, {
    key: "totalByVariants",
    get: function get() {
      var res = {};
      if (this.QuoteVariants) {
        for (var baseId in this.BaseQuotes.bases) {
          if (!this.isVariant(baseId)) continue;
          if (!res[baseId]) res[baseId] = {};
          if (!this.QuoteVariants[baseId]) continue;
          for (var variantId in this.QuoteVariants[baseId]) {
            if (!res[baseId][variantId]) res[baseId][variantId] = {};
            var _iterator251 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
              _step251;
            try {
              for (_iterator251.s(); !(_step251 = _iterator251.n()).done;) {
                var pType = _step251.value;
                if (!res[baseId][variantId][pType]) {
                  res[baseId][variantId][pType] = {
                    Price: 0,
                    Cost: 0
                  };
                  var pax = this.BaseQuotes[baseId][pType];
                  if (!this.totalByPaxVariant[baseId][variantId][pType]) continue;
                  res[baseId][variantId][pType].Price = this.totalByPaxVariant[baseId][variantId][pType].Price * pax;
                  res[baseId][variantId][pType].Cost = this.totalByPaxVariant[baseId][variantId][pType].Cost * pax;
                }
              }
            } catch (err) {
              _iterator251.e(err);
            } finally {
              _iterator251.f();
            }
          }
        }
      }
      return res;
    }
  }, {
    key: "totalByVariantWithFlights",
    get: function get() {
      var res = {};
      if (this.QuoteVariants) {
        var totalByVariants = this.totalByVariants;
        var totalFlightsNotIncludedAll = this.totalFlightsNotIncludedAll;
        for (var baseId in this.BaseQuotes.bases) {
          if (!this.isVariant(baseId)) continue;
          if (!res[baseId]) res[baseId] = {};
          if (!this.QuoteVariants[baseId]) continue;
          for (var variantId in this.QuoteVariants[baseId]) {
            if (!res[baseId][variantId]) res[baseId][variantId] = {};
            var _iterator252 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
              _step252;
            try {
              for (_iterator252.s(); !(_step252 = _iterator252.n()).done;) {
                var pType = _step252.value;
                if (!res[baseId][variantId][pType]) {
                  var pax = this.BaseQuotes[baseId][pType];
                  res[baseId][variantId][pType] = totalByVariants[baseId][variantId][pType].Price;
                  if (totalFlightsNotIncludedAll[baseId] && totalFlightsNotIncludedAll[baseId][pType]) {
                    res[baseId][variantId][pType] += totalFlightsNotIncludedAll[baseId][pType].Price * pax;
                  }
                }
              }
            } catch (err) {
              _iterator252.e(err);
            } finally {
              _iterator252.f();
            }
          }
        }
      }
      return res;
    }
  }, {
    key: "totalPriceByPaxVariant",
    get: function get() {
      var res = {};
      var totalByPaxVariant = this.totalByPaxVariant;
      for (var baseId in totalByPaxVariant) {
        res[baseId] = {};
        for (var variantId in totalByPaxVariant[baseId]) {
          res[baseId][variantId] = {};
          for (var pType in totalByPaxVariant[baseId][variantId]) {
            res[baseId][variantId][pType] = totalByPaxVariant[baseId][variantId][pType].Price;
          }
        }
      }
      return res;
    }
  }, {
    key: "totalByPaxVariant",
    get: function get() {
      //console.log('$$_totalByPaxVariant')
      //this.forceVariantGetters; //force getters

      var res = {};
      if (this.QuoteVariants) {
        for (var baseId in this.BaseQuotes.bases) {
          if (!this.isVariant(baseId)) continue;
          if (!res[baseId]) res[baseId] = {};
          if (!this.QuoteVariants[baseId]) continue;
          for (var variantId in this.QuoteVariants[baseId]) {
            if (!res[baseId][variantId]) {
              res[baseId][variantId] = this.totalByPaxVariantId(baseId, variantId);
            }
          }
        }
      }
      //window._booking = this
      return res;
    }
  }, {
    key: "totalByPaxVariantId",
    value: function totalByPaxVariantId(baseId, variantId) {
      //console.log('totalByPaxVariantId', baseId, variantId)
      var res = {};
      var _iterator253 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
        _step253;
      try {
        for (_iterator253.s(); !(_step253 = _iterator253.n()).done;) {
          var pType = _step253.value;
          res[pType] = {
            Price: 0,
            Cost: 0
          };
        }
      } catch (err) {
        _iterator253.e(err);
      } finally {
        _iterator253.f();
      }
      var _iterator254 = _createForOfIteratorHelper(this.BookingDays),
        _step254;
      try {
        for (_iterator254.s(); !(_step254 = _iterator254.n()).done;) {
          var day = _step254.value;
          var _iterator257 = _createForOfIteratorHelper(day.BookingDayServices),
            _step257;
          try {
            for (_iterator257.s(); !(_step257 = _iterator257.n()).done;) {
              var s = _step257.value;
              if (!s.Quote) continue;
              if (!s.Quote.QuoteList) continue;
              if (!s.Quote.QuoteList[baseId]) continue;
              if (!s.Quote.QuoteList[baseId].Variants) continue;
              if (!s.Quote.QuoteList[baseId].Variants[variantId]) continue;
              var _iterator259 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
                _step259;
              try {
                for (_iterator259.s(); !(_step259 = _iterator259.n()).done;) {
                  var _pType11 = _step259.value;
                  if (!s.Quote.QuoteList[baseId][_pType11]) continue;
                  if (!s.Quote.QuoteList[baseId][_pType11].Include) continue;
                  var v = void 0;
                  if (this.QuoteBy == 'SERVICE') v = s.Quote.QuoteList[baseId][_pType11].PersonPrice;else v = s.Quote.QuoteList[baseId][_pType11].Price;
                  res[_pType11].Price += v;
                  res[_pType11].Cost += s.Quote.QuoteList[baseId][_pType11].Cost;
                }
              } catch (err) {
                _iterator259.e(err);
              } finally {
                _iterator259.f();
              }
            }
          } catch (err) {
            _iterator257.e(err);
          } finally {
            _iterator257.f();
          }
          var _iterator258 = _createForOfIteratorHelper(day.BookingDayHotels),
            _step258;
          try {
            for (_iterator258.s(); !(_step258 = _iterator258.n()).done;) {
              var hotel = _step258.value;
              var _iterator260 = _createForOfIteratorHelper(hotel.BookingDayRooms),
                _step260;
              try {
                for (_iterator260.s(); !(_step260 = _iterator260.n()).done;) {
                  var room = _step260.value;
                  if (!room.QuoteList) continue;
                  if (!room.QuoteList[baseId]) continue;
                  if (!room.QuoteList[baseId].Include) continue;
                  if (!room.QuoteList[baseId].Variants) continue;
                  if (!room.QuoteList[baseId].Variants[variantId]) continue;
                  var _iterator261 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
                    _step261;
                  try {
                    for (_iterator261.s(); !(_step261 = _iterator261.n()).done;) {
                      var _pType12 = _step261.value;
                      var _v8 = void 0;
                      if (this.QuoteBy == 'SERVICE') _v8 = room.QuoteList[baseId].PersonPrice;else _v8 = room.QuoteList[baseId].Price;
                      res[_pType12].Price += _v8;
                      if (room.QuoteList[baseId].Cost) {
                        res[_pType12].Cost += room.QuoteList[baseId].Cost;
                      }
                    }
                  } catch (err) {
                    _iterator261.e(err);
                  } finally {
                    _iterator261.f();
                  }
                }
              } catch (err) {
                _iterator260.e(err);
              } finally {
                _iterator260.f();
              }
            }
          } catch (err) {
            _iterator258.e(err);
          } finally {
            _iterator258.f();
          }
        }
      } catch (err) {
        _iterator254.e(err);
      } finally {
        _iterator254.f();
      }
      var _iterator255 = _createForOfIteratorHelper(this.BookingFlights),
        _step255;
      try {
        for (_iterator255.s(); !(_step255 = _iterator255.n()).done;) {
          var flight = _step255.value;
          if (flight.QuoteType == 'NOT_INCLUDED') continue;
          if (!flight.QuoteList) continue;
          if (!flight.QuoteList[baseId]) continue;
          if (!flight.QuoteList[baseId].Include) continue;
          if (!flight.QuoteList[baseId].Variants) continue;
          if (!flight.QuoteList[baseId].Variants[variantId]) continue;
          var _iterator262 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
            _step262;
          try {
            for (_iterator262.s(); !(_step262 = _iterator262.n()).done;) {
              var _pType13 = _step262.value;
              if (_pType13 == 'CHD' && flight.PaxType == 'CHD' || _pType13 != 'CHD' && flight.PaxType != 'CHD' || !this.hasChildFlight) {
                var fPrice = flight.getFlightPrice(baseId);
                fPrice = this.currencyConvert(flight.CurrencyId, this.CurrencyId, fPrice);
                var _v9 = fPrice;
                res[_pType13].Price += _v9;
                var fCost = flight.getFlightCost(baseId);
                fCost = this.currencyConvert(flight.CurrencyId, this.CurrencyId, fCost);
                res[_pType13].Cost += fCost;
              }
            }
          } catch (err) {
            _iterator262.e(err);
          } finally {
            _iterator262.f();
          }
        }
      } catch (err) {
        _iterator255.e(err);
      } finally {
        _iterator255.f();
      }
      var _iterator256 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
        _step256;
      try {
        for (_iterator256.s(); !(_step256 = _iterator256.n()).done;) {
          var _this$QuoteVariants;
          var _pType14 = _step256.value;
          if (!tools.isNull((_this$QuoteVariants = this.QuoteVariants) === null || _this$QuoteVariants === void 0 || (_this$QuoteVariants = _this$QuoteVariants[baseId]) === null || _this$QuoteVariants === void 0 || (_this$QuoteVariants = _this$QuoteVariants[variantId]) === null || _this$QuoteVariants === void 0 || (_this$QuoteVariants = _this$QuoteVariants.OverPrice) === null || _this$QuoteVariants === void 0 ? void 0 : _this$QuoteVariants[_pType14])) {
            res[_pType14].Price = this.QuoteVariants[baseId][variantId].OverPrice[_pType14];
          }
        }
      } catch (err) {
        _iterator256.e(err);
      } finally {
        _iterator256.f();
      }
      return res;
    }
  }, {
    key: "roomsByVariant",
    get: function get() {
      var res = {};
      if (this.QuoteVariants) {
        var _iterator263 = _createForOfIteratorHelper(this.BookingDays),
          _step263;
        try {
          for (_iterator263.s(); !(_step263 = _iterator263.n()).done;) {
            var day = _step263.value;
            var _iterator264 = _createForOfIteratorHelper(day.BookingDayHotels),
              _step264;
            try {
              for (_iterator264.s(); !(_step264 = _iterator264.n()).done;) {
                var hotel = _step264.value;
                var _iterator265 = _createForOfIteratorHelper(hotel.BookingDayRooms),
                  _step265;
                try {
                  for (_iterator265.s(); !(_step265 = _iterator265.n()).done;) {
                    var room = _step265.value;
                    if (!room.QuoteList) continue;
                    if (!room.RoomTypeId) continue;
                    for (var baseId in this.BaseQuotes.bases) {
                      if (!this.isVariant(baseId)) continue;
                      if (!room.QuoteList[baseId]) continue;
                      if (!room.QuoteList[baseId].Include) continue;
                      if (!room.QuoteList[baseId].Variants) continue;
                      if (!this.QuoteVariants[baseId]) continue;
                      if (!res[baseId]) res[baseId] = {};
                      for (var variantId in this.QuoteVariants[baseId]) {
                        if (!room.QuoteList[baseId].Variants[variantId]) continue;
                        if (!res[baseId][variantId]) res[baseId][variantId] = {};
                        var _iterator266 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
                          _step266;
                        try {
                          for (_iterator266.s(); !(_step266 = _iterator266.n()).done;) {
                            var pType = _step266.value;
                            if (!res[baseId][variantId][pType]) res[baseId][variantId][pType] = {};
                            if (!res[baseId][variantId][pType][room.RoomTypeId]) {
                              res[baseId][variantId][pType][room.RoomTypeId] = room.Room;
                            }
                          }
                        } catch (err) {
                          _iterator266.e(err);
                        } finally {
                          _iterator266.f();
                        }
                      }
                    }
                  }
                } catch (err) {
                  _iterator265.e(err);
                } finally {
                  _iterator265.f();
                }
              }
            } catch (err) {
              _iterator264.e(err);
            } finally {
              _iterator264.f();
            }
          }
        } catch (err) {
          _iterator263.e(err);
        } finally {
          _iterator263.f();
        }
      }
      return res;
    }
  }, {
    key: "roomsTypeNamesByVariant",
    get: function get() {
      var res = {};
      for (var baseId in this.BaseQuotes.bases) {
        if (!this.QuoteVariants[baseId]) continue;
        if (!res[baseId]) res[baseId] = {};
        for (var variantId in this.QuoteVariants[baseId]) {
          if (!res[baseId][variantId]) res[baseId][variantId] = {};
          var _iterator267 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
            _step267;
          try {
            for (_iterator267.s(); !(_step267 = _iterator267.n()).done;) {
              var pType = _step267.value;
              if (!res[baseId][variantId][pType]) res[baseId][variantId][pType] = '';
            }
          } catch (err) {
            _iterator267.e(err);
          } finally {
            _iterator267.f();
          }
        }
      }
      var roomsByVariant = this.roomsByVariant;
      for (var _baseId16 in roomsByVariant) {
        for (var _variantId7 in roomsByVariant[_baseId16]) {
          if (!res[_baseId16][_variantId7]) res[_baseId16][_variantId7] = {};
          for (var _pType15 in roomsByVariant[_baseId16][_variantId7]) {
            var rooms = [];
            for (var roomId in roomsByVariant[_baseId16][_variantId7][_pType15]) {
              var room = roomsByVariant[_baseId16][_variantId7][_pType15][roomId];
              rooms.push(room.Name);
            }
            res[_baseId16][_variantId7][_pType15] = rooms.join(', ');
          }
        }
      }
      return res;
    }

    ////// variants end

    ////// groups start
  }, {
    key: "refresGroup",
    value: function refresGroup(baseId) {
      var groups = Object.assign({}, this.QuoteGroups[baseId]);
      /*for (let id in groups) {
          groups[id].$ADT = groups[id].ADT
          if (groups[id].TL) groups[id].$ADT += groups[id].TL; 
      }*/
      return groups;
    }
  }, {
    key: "saveGroups",
    value: function saveGroups(baseId, groups) {
      if (!this.QuoteGroups) this.QuoteGroups = {};
      var isNew = false;
      if (!this.QuoteGroups[baseId]) {
        this.QuoteGroups[baseId] = {};
        isNew = true;
      }
      for (var groupId in groups) {
        var g = groups[groupId];
        if (!this.QuoteGroups[baseId][groupId]) {
          this.QuoteGroups[baseId][groupId] = this.newGroup(g);
          //await this.QuoteGroups.newQuoteGroups(groupId, {ADT: g.ADT, CHD: g.CHD});
          //this.QuoteGroups.getFields();
        } else {
          this.QuoteGroups[baseId][groupId].ADT = g.ADT;
          this.QuoteGroups[baseId][groupId].CHD = g.CHD;
          this.QuoteGroups[baseId][groupId].TL = g.TL;
          this.QuoteGroups[baseId][groupId].Name = g.Name;
          this.QuoteGroups[baseId][groupId].ADT = g.ADT;
          this.QuoteGroups[baseId][groupId].Rooms = g.Rooms;
        }
        if (!this.QuoteGroups[baseId][groupId].Comments) {
          this.QuoteGroups[baseId][groupId].Comments = {};
        }
        //console.log(g.Rooms[2], this.QuoteGroups[baseId][groupId].Rooms[2])
      }
      var toDelete = [];
      for (var _groupId in this.QuoteGroups[baseId]) {
        if (!groups[_groupId]) toDelete.push(_groupId);
      }
      for (var _i17 = 0, _toDelete = toDelete; _i17 < _toDelete.length; _i17++) {
        var _groupId2 = _toDelete[_i17];
        delete this.QuoteGroups[baseId][_groupId2];
      }
      var _iterator268 = _createForOfIteratorHelper(this.BookingDays),
        _step268;
      try {
        for (_iterator268.s(); !(_step268 = _iterator268.n()).done;) {
          var day = _step268.value;
          var _iterator270 = _createForOfIteratorHelper(day.BookingDayServices),
            _step270;
          try {
            for (_iterator270.s(); !(_step270 = _iterator270.n()).done;) {
              var s = _step270.value;
              if (s.Quote.QuoteList && s.Quote.QuoteList[baseId]) {
                if (!s.Quote.QuoteList[baseId].Groups) {
                  s.Quote.QuoteList[baseId].Groups = {};
                }
                for (var _groupId3 in this.QuoteGroups[baseId]) {
                  var ids = Object.keys(s.Quote.QuoteList[baseId].Groups);
                  if (ids.indexOf(_groupId3) == -1) {
                    s.Quote.QuoteList[baseId].Groups[_groupId3] = true;
                  }
                }
                for (var _groupId4 in s.Quote.QuoteList[baseId].Groups) {
                  if (!this.QuoteGroups[baseId][_groupId4]) {
                    delete s.Quote.QuoteList[baseId].Groups[_groupId4];
                  }
                }
              }
            }
          } catch (err) {
            _iterator270.e(err);
          } finally {
            _iterator270.f();
          }
          var _iterator271 = _createForOfIteratorHelper(day.BookingDayHotels),
            _step271;
          try {
            for (_iterator271.s(); !(_step271 = _iterator271.n()).done;) {
              var hotel = _step271.value;
              var _iterator272 = _createForOfIteratorHelper(hotel.BookingDayRooms),
                _step272;
              try {
                for (_iterator272.s(); !(_step272 = _iterator272.n()).done;) {
                  var room = _step272.value;
                  if (!room.QuoteList[baseId].Groups) {
                    room.QuoteList[baseId].Groups = {};
                  }
                  for (var _groupId5 in this.QuoteGroups[baseId]) {
                    var _g = groups[_groupId5];
                    var _ids3 = Object.keys(room.QuoteList[baseId].Groups);
                    var pax = (_g.ADT ? _g.ADT : 0) + (_g.CHD ? _g.CHD : 0) + (_g.TL ? _g.TL : 0);
                    if (_ids3.indexOf(_groupId5) == -1) {
                      //room.QuoteList[baseId].Groups[groupId] = true;
                      room.QuoteList[baseId].Groups[_groupId5] = {
                        rooms: room.QuoteList[baseId].Rooms,
                        pax: pax,
                        selected: true
                      };
                    } else {
                      room.QuoteList[baseId].Groups[_groupId5].pax = pax;
                      room.QuoteList[baseId].Groups[_groupId5].rooms = room.QuoteList[baseId].Rooms;
                    }
                  }
                  for (var _groupId6 in room.QuoteList[baseId].Groups) {
                    if (!this.QuoteGroups[baseId][_groupId6]) {
                      delete room.QuoteList[baseId].Groups[_groupId6];
                    }
                  }
                }
              } catch (err) {
                _iterator272.e(err);
              } finally {
                _iterator272.f();
              }
            }
          } catch (err) {
            _iterator271.e(err);
          } finally {
            _iterator271.f();
          }
        }
      } catch (err) {
        _iterator268.e(err);
      } finally {
        _iterator268.f();
      }
      var _iterator269 = _createForOfIteratorHelper(this.BookingFlights),
        _step269;
      try {
        for (_iterator269.s(); !(_step269 = _iterator269.n()).done;) {
          var flight = _step269.value;
          for (var _baseId17 in this.BaseQuotes.bases) {
            if (!flight.QuoteList) continue;
            if (!flight.QuoteList[_baseId17]) continue;
            if (!flight.QuoteList[_baseId17].Groups) {
              flight.QuoteList[_baseId17].Groups = {};
            }
            for (var _groupId7 in this.QuoteGroups[_baseId17]) {
              var _ids4 = Object.keys(flight.QuoteList[_baseId17].Groups);
              if (_ids4.indexOf(_groupId7) == -1) {
                flight.QuoteList[_baseId17].Groups[_groupId7] = true;
              }
            }
            for (var _groupId8 in flight.QuoteList[_baseId17].Groups) {
              if (!this.QuoteGroups[_baseId17][_groupId8]) {
                delete flight.QuoteList[_baseId17].Groups[_groupId8];
              }
            }
          }
        }
        //if (isNew) {
        //this.assignRoomTypes(baseId)
        //}
      } catch (err) {
        _iterator269.e(err);
      } finally {
        _iterator269.f();
      }
    }
  }, {
    key: "someRoomAssigned",
    value: function someRoomAssigned(baseId) {
      var someAssigned = false;
      var someNotAssigned = false;
      var _iterator273 = _createForOfIteratorHelper(this.BookingDays),
        _step273;
      try {
        for (_iterator273.s(); !(_step273 = _iterator273.n()).done;) {
          var day = _step273.value;
          var _iterator274 = _createForOfIteratorHelper(day.BookingDayHotels),
            _step274;
          try {
            for (_iterator274.s(); !(_step274 = _iterator274.n()).done;) {
              var hotel = _step274.value;
              var _iterator275 = _createForOfIteratorHelper(hotel.BookingDayRooms),
                _step275;
              try {
                for (_iterator275.s(); !(_step275 = _iterator275.n()).done;) {
                  var room = _step275.value;
                  if (room.QuoteList[baseId].Groups) {
                    for (var groupId in room.QuoteList[baseId].Groups) {
                      if (room.QuoteList[baseId].Groups[groupId].selected) {
                        someAssigned = true;
                      } else {
                        someNotAssigned = true;
                      }
                    }
                  }
                }
              } catch (err) {
                _iterator275.e(err);
              } finally {
                _iterator275.f();
              }
            }
          } catch (err) {
            _iterator274.e(err);
          } finally {
            _iterator274.f();
          }
        }
      } catch (err) {
        _iterator273.e(err);
      } finally {
        _iterator273.f();
      }
      return someAssigned && someNotAssigned;
    }
  }, {
    key: "assignRoomTypes",
    value: function assignRoomTypes(baseId) {
      if (this.someRoomAssigned(baseId)) {
        return;
      }
      var roomTypesObjects = Object.assign({}, this.roomTypesObjects);
      var groups = this.QuoteGroups[baseId];
      var _iterator276 = _createForOfIteratorHelper(this.BookingDays),
        _step276;
      try {
        for (_iterator276.s(); !(_step276 = _iterator276.n()).done;) {
          var day = _step276.value;
          var _iterator277 = _createForOfIteratorHelper(day.BookingDayHotels),
            _step277;
          try {
            for (_iterator277.s(); !(_step277 = _iterator277.n()).done;) {
              var hotel = _step277.value;
              var groupsQty = {};
              for (var roomId in hotel.BookingDayRooms) {
                var room = hotel.BookingDayRooms[roomId];
                var assigned = 0;
                for (var groupId in groups) {
                  var qtyToAssing = 0;
                  for (var _rId in this.QuoteGroups[baseId][groupId].Rooms) {
                    if (this.QuoteGroups[baseId][groupId].Rooms[_rId] > 0) {
                      qtyToAssing += this.QuoteGroups[baseId][groupId].Rooms[_rId];
                    }
                  }
                  if (!qtyToAssing) continue;
                  var group = this.QuoteGroups[baseId][groupId];
                  var paxGroup = (group.ADT ? group.ADT : 0) + (group.CHD ? group.CHD : 0) + (group.TL ? group.TL : 0);
                  var rId = room.RoomTypeId;
                  if (!groupsQty[[groupId, rId]]) groupsQty[[groupId, rId]] = 0;
                  var roomsQty = groups[groupId].Rooms[rId];
                  if (roomsQty && assigned < room.QuoteList[baseId].Rooms && groupsQty[[groupId, rId]] < roomsQty) {
                    if (room.QuoteList[baseId].Groups) {
                      room.QuoteList[baseId].Groups[groupId].rooms = roomsQty;
                      var toAssign = roomTypesObjects[rId].Pax * roomsQty;
                      if (toAssign > paxGroup) toAssign = paxGroup;
                      room.QuoteList[baseId].Groups[groupId].pax = toAssign;
                      assigned += roomsQty;
                      groupsQty[[groupId, rId]] += roomsQty;
                    }
                  } else if (!roomsQty) {
                    room.QuoteList[baseId].Groups[groupId].selected = false;
                  }
                }
              }
            }
          } catch (err) {
            _iterator277.e(err);
          } finally {
            _iterator277.f();
          }
        }
      } catch (err) {
        _iterator276.e(err);
      } finally {
        _iterator276.f();
      }
    }
  }, {
    key: "newGroup",
    value: function newGroup(g) {
      var res = {
        ADT: g ? g.ADT : null,
        CHD: g ? g.CHD : null,
        TL: g ? g.TL : null,
        Name: g ? g.Name : null,
        OverPrice: {},
        Selected: {
          ADT: true
        },
        Comments: {
          ADT: null
        },
        Rooms: {}
      };
      if (g && g.Rooms) res.Rooms = Object.assign({}, g.Rooms);
      if (g && g.CHD) res.Selected.CHD = true;
      if (g && g.TL) res.Selected.TL = true;
      return res;
    }
  }, {
    key: "addGroup",
    value: function addGroup(baseId) {
      var base = this.BaseQuotes[baseId];
      var groups = Object.assign({}, this.QuoteGroups[baseId]);
      var group = this.newGroup();
      if (!base.CHD) {
        group.CHD = null;
        group.Selected.CHD = true;
        group.Comments.CHD = null;
      }
      ;
      if (!base.TL) {
        group.TL = null;
        group.Selected.TL = true;
        group.Comments.TL = null;
      }
      ;
      if (!groups || Object.keys(groups).length == 0) {
        groups = {
          0: Object.assign({}, group),
          1: Object.assign({}, group)
        };
      } else {
        var k = this.getNextGroupId(groups);
        groups[k] = Object.assign({}, group);
      }
      //this.QuoteGroups[baseId] = groups;
      return groups;
    }
  }, {
    key: "getNextGroupId",
    value: function getNextGroupId(groups) {
      var l = Object.keys(groups);
      if (l.length == 0) {
        return 0;
      }
      var lInts = [];
      for (var _i18 = 0, _l3 = l; _i18 < _l3.length; _i18++) {
        var k = _l3[_i18];
        lInts.push(parseInt(k));
      }
      var max = Math.max.apply(Math, lInts);
      return max + 1;
    }
  }, {
    key: "setPaxByGroups",
    value: function () {
      var _setPaxByGroups = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee77(baseId, dayId, type) {
        var groups, isGroup, i, day, _iterator278, _step278, s, adt, chd, tl, quoteADT, groupId, _this$BaseQuotes3, _this$BaseQuotes4, _this$BaseQuotes5, costPer, _iterator279, _step279, hotel, _iterator280, _step280, room, pax, rooms, _groupId9, _iterator281, _step281, flight, field;
        return regenerator_default().wrap(function _callee77$(_context83) {
          while (1) switch (_context83.prev = _context83.next) {
            case 0:
              groups = this.QuoteGroups[baseId];
              isGroup = this.isGroup(baseId);
              _context83.t0 = regenerator_default().keys(this.BookingDays);
            case 3:
              if ((_context83.t1 = _context83.t0()).done) {
                _context83.next = 122;
                break;
              }
              i = _context83.t1.value;
              if (!(dayId !== undefined && dayId != i)) {
                _context83.next = 7;
                break;
              }
              return _context83.abrupt("continue", 3);
            case 7:
              day = this.BookingDays[i];
              if (!(!type || type == 'services')) {
                _context83.next = 64;
                break;
              }
              _iterator278 = _createForOfIteratorHelper(day.BookingDayServices);
              _context83.prev = 10;
              _iterator278.s();
            case 12:
              if ((_step278 = _iterator278.n()).done) {
                _context83.next = 56;
                break;
              }
              s = _step278.value;
              if (!(s.Quote.QuoteList && s.Quote.QuoteList[baseId] && s.Quote.QuoteList[baseId].ADT)) {
                _context83.next = 54;
                break;
              }
              adt = 0;
              chd = 0;
              tl = 0;
              quoteADT = s.Quote.QuoteList[baseId].ADT;
              if (!isGroup) {
                _context83.next = 34;
                break;
              }
              _context83.t2 = regenerator_default().keys(groups);
            case 21:
              if ((_context83.t3 = _context83.t2()).done) {
                _context83.next = 32;
                break;
              }
              groupId = _context83.t3.value;
              if (s.Quote.QuoteList[baseId].Groups) {
                _context83.next = 25;
                break;
              }
              return _context83.abrupt("continue", 21);
            case 25:
              if (s.Quote.QuoteList[baseId].Groups[groupId]) {
                _context83.next = 27;
                break;
              }
              return _context83.abrupt("continue", 21);
            case 27:
              if (groups[groupId].ADT) adt += groups[groupId].ADT;
              if (groups[groupId].CHD) chd += groups[groupId].CHD;
              if (groups[groupId].TL) tl += groups[groupId].TL;
              _context83.next = 21;
              break;
            case 32:
              _context83.next = 37;
              break;
            case 34:
              adt = parseInt(((_this$BaseQuotes3 = this.BaseQuotes) === null || _this$BaseQuotes3 === void 0 || (_this$BaseQuotes3 = _this$BaseQuotes3[baseId]) === null || _this$BaseQuotes3 === void 0 ? void 0 : _this$BaseQuotes3.ADT) || 0);
              chd = parseInt(((_this$BaseQuotes4 = this.BaseQuotes) === null || _this$BaseQuotes4 === void 0 || (_this$BaseQuotes4 = _this$BaseQuotes4[baseId]) === null || _this$BaseQuotes4 === void 0 ? void 0 : _this$BaseQuotes4.CHD) || 0);
              tl = parseInt(((_this$BaseQuotes5 = this.BaseQuotes) === null || _this$BaseQuotes5 === void 0 || (_this$BaseQuotes5 = _this$BaseQuotes5[baseId]) === null || _this$BaseQuotes5 === void 0 ? void 0 : _this$BaseQuotes5.TL) || 0);
            case 37:
              costPer = quoteADT.costPer;
              if (!costPer) costPer = s.costPer;
              if (!(costPer == 'PERSON')) {
                _context83.next = 51;
                break;
              }
              if (!s.Quote.QuoteList[baseId].ADT) {
                _context83.next = 43;
                break;
              }
              _context83.next = 43;
              return s.Quote.QuoteList[baseId].ADT.setValue({
                fieldName: 'Base',
                value: adt
              });
            case 43:
              if (!s.Quote.QuoteList[baseId].CHD) {
                _context83.next = 46;
                break;
              }
              _context83.next = 46;
              return s.Quote.QuoteList[baseId].CHD.setValue({
                fieldName: 'Base',
                value: chd
              });
            case 46:
              if (!s.Quote.QuoteList[baseId].TL) {
                _context83.next = 49;
                break;
              }
              _context83.next = 49;
              return s.Quote.QuoteList[baseId].TL.setValue({
                fieldName: 'Base',
                value: tl
              });
            case 49:
              _context83.next = 54;
              break;
            case 51:
              if (!s.Quote.QuoteList[baseId].ADT) {
                _context83.next = 54;
                break;
              }
              _context83.next = 54;
              return s.Quote.QuoteList[baseId].ADT.setValue({
                fieldName: 'Base',
                value: adt + chd + tl
              });
            case 54:
              _context83.next = 12;
              break;
            case 56:
              _context83.next = 61;
              break;
            case 58:
              _context83.prev = 58;
              _context83.t4 = _context83["catch"](10);
              _iterator278.e(_context83.t4);
            case 61:
              _context83.prev = 61;
              _iterator278.f();
              return _context83.finish(61);
            case 64:
              if (!(!type || type == 'hotels')) {
                _context83.next = 120;
                break;
              }
              _iterator279 = _createForOfIteratorHelper(day.BookingDayHotels);
              _context83.prev = 66;
              _iterator279.s();
            case 68:
              if ((_step279 = _iterator279.n()).done) {
                _context83.next = 112;
                break;
              }
              hotel = _step279.value;
              _iterator280 = _createForOfIteratorHelper(hotel.BookingDayRooms);
              _context83.prev = 71;
              _iterator280.s();
            case 73:
              if ((_step280 = _iterator280.n()).done) {
                _context83.next = 102;
                break;
              }
              room = _step280.value;
              pax = void 0;
              if (!isGroup) {
                _context83.next = 96;
                break;
              }
              pax = 0;
              rooms = 0;
              _context83.t5 = regenerator_default().keys(groups);
            case 80:
              if ((_context83.t6 = _context83.t5()).done) {
                _context83.next = 94;
                break;
              }
              _groupId9 = _context83.t6.value;
              if (room.QuoteList[baseId]) {
                _context83.next = 84;
                break;
              }
              return _context83.abrupt("continue", 80);
            case 84:
              if (room.QuoteList[baseId].Groups) {
                _context83.next = 86;
                break;
              }
              return _context83.abrupt("continue", 80);
            case 86:
              if (room.QuoteList[baseId].Groups[_groupId9]) {
                _context83.next = 88;
                break;
              }
              return _context83.abrupt("continue", 80);
            case 88:
              if (room.QuoteList[baseId].Groups[_groupId9].selected) {
                _context83.next = 90;
                break;
              }
              return _context83.abrupt("continue", 80);
            case 90:
              pax += parseInt(room.QuoteList[baseId].Groups[_groupId9].pax);
              rooms += parseInt(room.QuoteList[baseId].Groups[_groupId9].rooms);
              _context83.next = 80;
              break;
            case 94:
              _context83.next = 97;
              break;
            case 96:
              pax = this.BaseQuotes[baseId].paxQuantity;
            case 97:
              _context83.next = 99;
              return room.QuoteList[baseId].setValue({
                fieldName: 'Pax',
                value: pax
              });
            case 99:
              room.QuoteList[baseId].Groups = Object.assign({}, room.QuoteList[baseId].Groups);
            case 100:
              _context83.next = 73;
              break;
            case 102:
              _context83.next = 107;
              break;
            case 104:
              _context83.prev = 104;
              _context83.t7 = _context83["catch"](71);
              _iterator280.e(_context83.t7);
            case 107:
              _context83.prev = 107;
              _iterator280.f();
              return _context83.finish(107);
            case 110:
              _context83.next = 68;
              break;
            case 112:
              _context83.next = 117;
              break;
            case 114:
              _context83.prev = 114;
              _context83.t8 = _context83["catch"](66);
              _iterator279.e(_context83.t8);
            case 117:
              _context83.prev = 117;
              _iterator279.f();
              return _context83.finish(117);
            case 120:
              _context83.next = 3;
              break;
            case 122:
              if (!type || type == 'flights') {
                _iterator281 = _createForOfIteratorHelper(this.BookingFlights);
                try {
                  for (_iterator281.s(); !(_step281 = _iterator281.n()).done;) {
                    flight = _step281.value;
                    field = _.find(flight.fieldsList, function (c) {
                      return c.name == 'FlightCost';
                    });
                    flight.afterEditField(field, flight.FlightCost, flight.FlightCost);
                    //flight.setValue({fieldName: 'FlightCost', value: flight.FlightCost + 0.000001});
                  }
                } catch (err) {
                  _iterator281.e(err);
                } finally {
                  _iterator281.f();
                }
              }
            case 123:
            case "end":
              return _context83.stop();
          }
        }, _callee77, this, [[10, 58, 61, 64], [66, 114, 117, 120], [71, 104, 107, 110]]);
      }));
      function setPaxByGroups(_x132, _x133, _x134) {
        return _setPaxByGroups.apply(this, arguments);
      }
      return setPaxByGroups;
    }()
  }, {
    key: "removeGroup",
    value: function removeGroup(baseId) {
      delete this.QuoteGroups[baseId];
      var _iterator282 = _createForOfIteratorHelper(this.BookingDays),
        _step282;
      try {
        for (_iterator282.s(); !(_step282 = _iterator282.n()).done;) {
          var day = _step282.value;
          var _iterator284 = _createForOfIteratorHelper(day.BookingDayServices),
            _step284;
          try {
            for (_iterator284.s(); !(_step284 = _iterator284.n()).done;) {
              var s = _step284.value;
              if (s.Quote.QuoteList && s.Quote.QuoteList[baseId]) {
                s.Quote.QuoteList[baseId].Groups = null;
              }
            }
          } catch (err) {
            _iterator284.e(err);
          } finally {
            _iterator284.f();
          }
          var _iterator285 = _createForOfIteratorHelper(day.BookingDayHotels),
            _step285;
          try {
            for (_iterator285.s(); !(_step285 = _iterator285.n()).done;) {
              var hotel = _step285.value;
              var _iterator286 = _createForOfIteratorHelper(hotel.BookingDayRooms),
                _step286;
              try {
                for (_iterator286.s(); !(_step286 = _iterator286.n()).done;) {
                  var room = _step286.value;
                  if (room.QuoteList[baseId]) {
                    room.QuoteList[baseId].Groups = null;
                  }
                }
              } catch (err) {
                _iterator286.e(err);
              } finally {
                _iterator286.f();
              }
            }
          } catch (err) {
            _iterator285.e(err);
          } finally {
            _iterator285.f();
          }
        }
      } catch (err) {
        _iterator282.e(err);
      } finally {
        _iterator282.f();
      }
      var _iterator283 = _createForOfIteratorHelper(this.BookingFlights),
        _step283;
      try {
        for (_iterator283.s(); !(_step283 = _iterator283.n()).done;) {
          var flight = _step283.value;
          if (!flight.QuoteList) continue;
          if (!flight.QuoteList[baseId]) continue;
          flight.QuoteList[baseId].Groups = null;
        }
      } catch (err) {
        _iterator283.e(err);
      } finally {
        _iterator283.f();
      }
    }
  }, {
    key: "sumUpGroups",
    get: function get() {
      var res = {};
      if (this.QuoteGroups) {
        for (var baseId in this.BaseQuotes.bases) {
          if (!this.isGroup(baseId)) continue;
          var totalGroups = this.totalByPaxGroup[baseId];
          for (var groupId in this.QuoteGroups[baseId]) {
            var _this$totalByPaxGroup;
            if (!((_this$totalByPaxGroup = this.totalByPaxGroup) !== null && _this$totalByPaxGroup !== void 0 && (_this$totalByPaxGroup = _this$totalByPaxGroup[baseId]) !== null && _this$totalByPaxGroup !== void 0 && _this$totalByPaxGroup[groupId])) continue;
            var _iterator287 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
              _step287;
            try {
              for (_iterator287.s(); !(_step287 = _iterator287.n()).done;) {
                var _this$totalByPaxGroup2, _this$QuoteGroups6, _this$QuoteGroups7;
                var pType = _step287.value;
                if (!((_this$totalByPaxGroup2 = this.totalByPaxGroup) !== null && _this$totalByPaxGroup2 !== void 0 && (_this$totalByPaxGroup2 = _this$totalByPaxGroup2[baseId]) !== null && _this$totalByPaxGroup2 !== void 0 && (_this$totalByPaxGroup2 = _this$totalByPaxGroup2[groupId]) !== null && _this$totalByPaxGroup2 !== void 0 && _this$totalByPaxGroup2[pType])) continue;
                if (!((_this$QuoteGroups6 = this.QuoteGroups) !== null && _this$QuoteGroups6 !== void 0 && (_this$QuoteGroups6 = _this$QuoteGroups6[baseId]) !== null && _this$QuoteGroups6 !== void 0 && _this$QuoteGroups6[groupId])) continue;
                if (!((_this$QuoteGroups7 = this.QuoteGroups) !== null && _this$QuoteGroups7 !== void 0 && (_this$QuoteGroups7 = _this$QuoteGroups7[baseId]) !== null && _this$QuoteGroups7 !== void 0 && (_this$QuoteGroups7 = _this$QuoteGroups7[groupId]) !== null && _this$QuoteGroups7 !== void 0 && _this$QuoteGroups7[pType])) continue;
                if (!res[baseId]) res[baseId] = {
                  Price: 0,
                  Cost: 0
                };
                var v = this.totalByPaxGroup[baseId][groupId][pType].Price * this.QuoteGroups[baseId][groupId][pType];
                res[baseId].Price += v;
                var c = this.totalByPaxGroup[baseId][groupId][pType].Cost * this.QuoteGroups[baseId][groupId][pType];
                res[baseId].Cost += c;
              }
            } catch (err) {
              _iterator287.e(err);
            } finally {
              _iterator287.f();
            }
          }
        }
      }
      if (this.CurrencyId != this.PriceCurrencyId) {
        for (var _baseId18 in res) {
          var _v10 = res[_baseId18].Price;
          res[_baseId18].Price = this.currencyConvert(this.CurrencyId, this.PriceCurrencyId, _v10);
          var _c2 = res[_baseId18].Cost;
          res[_baseId18].Cost = this.currencyConvert(this.CurrencyId, this.PriceCurrencyId, _c2);
        }
      }
      return res;
    }
  }, {
    key: "totalByGroup",
    get: function get() {
      var res = {};
      if (this.QuoteGroups) {
        //let totalByPaxGroup = this.totalByPaxGroup;
        for (var baseId in this.BaseQuotes.bases) {
          if (!this.isGroup(baseId)) continue;
          if (!res[baseId]) res[baseId] = {};
          for (var groupId in this.QuoteGroups[baseId]) {
            if (!res[baseId][groupId]) res[baseId][groupId] = {};
            var _iterator288 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
              _step288;
            try {
              for (_iterator288.s(); !(_step288 = _iterator288.n()).done;) {
                var pType = _step288.value;
                if (!res[baseId][groupId][pType]) {
                  var _this$totalByPaxGroup3, _this$totalByPaxGroup4, _this$totalByPaxGroup5;
                  res[baseId][groupId][pType] = {
                    Price: 0,
                    Cost: 0
                  };
                  var pax = this.QuoteGroups[baseId][groupId][pType];
                  if (!((_this$totalByPaxGroup3 = this.totalByPaxGroup) !== null && _this$totalByPaxGroup3 !== void 0 && (_this$totalByPaxGroup3 = _this$totalByPaxGroup3[baseId]) !== null && _this$totalByPaxGroup3 !== void 0 && (_this$totalByPaxGroup3 = _this$totalByPaxGroup3[groupId]) !== null && _this$totalByPaxGroup3 !== void 0 && _this$totalByPaxGroup3[pType])) continue;
                  res[baseId][groupId][pType].Price = ((_this$totalByPaxGroup4 = this.totalByPaxGroup) === null || _this$totalByPaxGroup4 === void 0 || (_this$totalByPaxGroup4 = _this$totalByPaxGroup4[baseId]) === null || _this$totalByPaxGroup4 === void 0 || (_this$totalByPaxGroup4 = _this$totalByPaxGroup4[groupId]) === null || _this$totalByPaxGroup4 === void 0 || (_this$totalByPaxGroup4 = _this$totalByPaxGroup4[pType]) === null || _this$totalByPaxGroup4 === void 0 ? void 0 : _this$totalByPaxGroup4.Price) * pax;
                  res[baseId][groupId][pType].Cost = ((_this$totalByPaxGroup5 = this.totalByPaxGroup) === null || _this$totalByPaxGroup5 === void 0 || (_this$totalByPaxGroup5 = _this$totalByPaxGroup5[baseId]) === null || _this$totalByPaxGroup5 === void 0 || (_this$totalByPaxGroup5 = _this$totalByPaxGroup5[groupId]) === null || _this$totalByPaxGroup5 === void 0 || (_this$totalByPaxGroup5 = _this$totalByPaxGroup5[pType]) === null || _this$totalByPaxGroup5 === void 0 ? void 0 : _this$totalByPaxGroup5.Cost) * pax;
                }
              }
            } catch (err) {
              _iterator288.e(err);
            } finally {
              _iterator288.f();
            }
          }
        }
      }
      return res;
    }
  }, {
    key: "totalByGroupWithFlights",
    get: function get() {
      var res = {};
      if (this.QuoteGroups) {
        var totalByGroup = this.totalByGroup;
        //let totalFlightsNotIncludedAll = this.totalFlightsNotIncludedAll;
        var flightsNotIncludedByGroup = this.flightsNotIncludedByGroup;
        for (var baseId in this.BaseQuotes.bases) {
          if (!this.isGroup(baseId)) continue;
          if (!res[baseId]) res[baseId] = {};
          for (var groupId in this.QuoteGroups[baseId]) {
            if (!res[baseId][groupId]) res[baseId][groupId] = {};
            var _iterator289 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
              _step289;
            try {
              for (_iterator289.s(); !(_step289 = _iterator289.n()).done;) {
                var pType = _step289.value;
                if (!res[baseId][groupId][pType]) {
                  var _flightsNotIncludedBy;
                  var pax = this.QuoteGroups[baseId][groupId][pType];
                  res[baseId][groupId][pType] = totalByGroup[baseId][groupId][pType].Price;
                  if (flightsNotIncludedByGroup !== null && flightsNotIncludedByGroup !== void 0 && (_flightsNotIncludedBy = flightsNotIncludedByGroup[baseId]) !== null && _flightsNotIncludedBy !== void 0 && (_flightsNotIncludedBy = _flightsNotIncludedBy[groupId]) !== null && _flightsNotIncludedBy !== void 0 && _flightsNotIncludedBy[pType]) {
                    res[baseId][groupId][pType] += flightsNotIncludedByGroup[baseId][groupId][pType].Price * pax;
                  }
                }
              }
            } catch (err) {
              _iterator289.e(err);
            } finally {
              _iterator289.f();
            }
          }
        }
      }
      return res;
    }
  }, {
    key: "totalFlightsNotIncludedByGroup",
    get: function get() {
      var res = {};
      if (this.QuoteGroups) {
        var flightsNotIncludedByGroup = this.flightsNotIncludedByGroup;
        for (var baseId in this.BaseQuotes.bases) {
          if (!this.isGroup(baseId)) continue;
          if (!res[baseId]) res[baseId] = {
            Cost: 0,
            Price: 0
          };
          for (var groupId in this.QuoteGroups[baseId]) {
            var _iterator290 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
              _step290;
            try {
              for (_iterator290.s(); !(_step290 = _iterator290.n()).done;) {
                var _flightsNotIncludedBy2;
                var pType = _step290.value;
                var pax = this.QuoteGroups[baseId][groupId][pType];
                if (flightsNotIncludedByGroup !== null && flightsNotIncludedByGroup !== void 0 && (_flightsNotIncludedBy2 = flightsNotIncludedByGroup[baseId]) !== null && _flightsNotIncludedBy2 !== void 0 && (_flightsNotIncludedBy2 = _flightsNotIncludedBy2[groupId]) !== null && _flightsNotIncludedBy2 !== void 0 && _flightsNotIncludedBy2[pType]) {
                  res[baseId].Price += flightsNotIncludedByGroup[baseId][groupId][pType].Price * pax;
                  res[baseId].Cost += flightsNotIncludedByGroup[baseId][groupId][pType].Cost * pax;
                }
              }
            } catch (err) {
              _iterator290.e(err);
            } finally {
              _iterator290.f();
            }
          }
        }
      }
      return res;
    }
  }, {
    key: "totalByPaxGroup",
    get: function get() {
      if (this._cache && this._cache.totalByPaxGroup) return this._cachedTotalByPaxGroup;
      if (this._cache) this._cache.totalByPaxGroup = true;
      var res = {};
      if (this.QuoteGroups) {
        for (var baseId in this.BaseQuotes.bases) {
          if (!this.isGroup(baseId)) continue;
          if (!res[baseId]) res[baseId] = {};
          for (var groupId in this.QuoteGroups[baseId]) {
            if (!res[baseId][groupId]) {
              res[baseId][groupId] = this.totalByPaxGroupId(baseId, groupId);
            }
          }
        }
      }
      this._cachedTotalByPaxGroup = res;
      //window._booking = this
      return res;
    }
  }, {
    key: "totalPriceByPaxGroup",
    get: function get() {
      var res = {};
      var totalByPaxGroup = this.totalByPaxGroup;
      for (var baseId in totalByPaxGroup) {
        res[baseId] = {};
        for (var groupId in totalByPaxGroup[baseId]) {
          res[baseId][groupId] = {};
          for (var pType in totalByPaxGroup[baseId][groupId]) {
            res[baseId][groupId][pType] = totalByPaxGroup[baseId][groupId][pType].Price;
          }
        }
      }
      return res;
    }
  }, {
    key: "totalHotelsByPaxGroupId",
    value: function totalHotelsByPaxGroupId(baseId) {
      var res = {};
      var _iterator291 = _createForOfIteratorHelper(this.BookingDays),
        _step291;
      try {
        for (_iterator291.s(); !(_step291 = _iterator291.n()).done;) {
          var day = _step291.value;
          var _iterator292 = _createForOfIteratorHelper(day.BookingDayHotels),
            _step292;
          try {
            for (_iterator292.s(); !(_step292 = _iterator292.n()).done;) {
              var hotel = _step292.value;
              var _iterator293 = _createForOfIteratorHelper(hotel.BookingDayRooms),
                _step293;
              try {
                for (_iterator293.s(); !(_step293 = _iterator293.n()).done;) {
                  var room = _step293.value;
                  if (!room.QuoteList) continue;
                  if (!room.QuoteList[baseId]) continue;
                  if (!room.QuoteList[baseId].Include) continue;
                  if (!room.QuoteList[baseId].Groups) continue;
                  if (!this.QuoteGroups[baseId]) continue;
                  for (var groupId in this.QuoteGroups[baseId]) {
                    if (!res[groupId]) res[groupId] = {};
                    if (!room.QuoteList[baseId].Groups[groupId]) continue;
                    if (!room.QuoteList[baseId].Groups[groupId].selected) continue;
                    var group = this.QuoteGroups[baseId][groupId];
                    var quoteGroup = room.QuoteList[baseId].Groups[groupId];
                    var _iterator294 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
                      _step294;
                    try {
                      for (_iterator294.s(); !(_step294 = _iterator294.n()).done;) {
                        var pType = _step294.value;
                        if (!res[groupId][pType]) res[groupId][pType] = {
                          Price: 0,
                          Cost: 0
                        };
                        if (!room.QuoteList[baseId].PersonPrice) continue;
                        if (!room.QuoteList[baseId].PersonCost) continue;
                        var paxGroup = (group.ADT ? group.ADT : 0) + (group.CHD ? group.CHD : 0) + (group.TL ? group.TL : 0);
                        var personPrice = room.QuoteList[baseId].PersonPrice;
                        var personCost = room.QuoteList[baseId].PersonCost;
                        res[groupId][pType].Price += quoteGroup.pax * personPrice / paxGroup;
                        res[groupId][pType].Cost += quoteGroup.pax * personCost / paxGroup;
                      }
                    } catch (err) {
                      _iterator294.e(err);
                    } finally {
                      _iterator294.f();
                    }
                  }
                }
              } catch (err) {
                _iterator293.e(err);
              } finally {
                _iterator293.f();
              }
            }
          } catch (err) {
            _iterator292.e(err);
          } finally {
            _iterator292.f();
          }
        }
      } catch (err) {
        _iterator291.e(err);
      } finally {
        _iterator291.f();
      }
      return res;
    }
  }, {
    key: "totalByPaxGroupId",
    value: function totalByPaxGroupId(baseId, groupId) {
      //console.log(baseId, groupId)
      var group = this.QuoteGroups[baseId][groupId];
      var res = {};
      var _iterator295 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
        _step295;
      try {
        for (_iterator295.s(); !(_step295 = _iterator295.n()).done;) {
          var pType = _step295.value;
          res[pType] = {
            Price: 0,
            Cost: 0,
            ServicesPrice: 0,
            ServicesCost: 0,
            HotelsPrice: 0,
            HotelsCost: 0,
            FlightsPrice: 0,
            FlightsCost: 0,
            Rooms: [],
            HotelCategories: []
          };
        }
      } catch (err) {
        _iterator295.e(err);
      } finally {
        _iterator295.f();
      }
      var _iterator296 = _createForOfIteratorHelper(this.BookingDays),
        _step296;
      try {
        for (_iterator296.s(); !(_step296 = _iterator296.n()).done;) {
          var day = _step296.value;
          var _iterator299 = _createForOfIteratorHelper(day.BookingDayServices),
            _step299;
          try {
            for (_iterator299.s(); !(_step299 = _iterator299.n()).done;) {
              var s = _step299.value;
              if (!s.Quote) continue;
              if (!s.Quote.QuoteList) continue;
              if (!s.Quote.QuoteList[baseId]) continue;
              if (!s.Quote.QuoteList[baseId].Groups) continue;
              if (!s.Quote.QuoteList[baseId].Groups[groupId]) continue;
              var _iterator301 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
                _step301;
              try {
                for (_iterator301.s(); !(_step301 = _iterator301.n()).done;) {
                  var _s$Quote;
                  var _pType16 = _step301.value;
                  var _pType = _pType16;
                  if (((_s$Quote = s.Quote) === null || _s$Quote === void 0 || (_s$Quote = _s$Quote.QuoteList) === null || _s$Quote === void 0 || (_s$Quote = _s$Quote[baseId]) === null || _s$Quote === void 0 || (_s$Quote = _s$Quote[_pType16]) === null || _s$Quote === void 0 ? void 0 : _s$Quote.costPer) == 'SERVICE' && (_pType16 == 'CHD' || _pType16 == 'TL')) {
                    _pType = 'ADT';
                  }
                  if (!s.Quote.QuoteList[baseId][_pType]) continue;
                  if (!s.Quote.QuoteList[baseId][_pType].Include) continue;
                  if (s.Quote.QuoteList[baseId][_pType].PersonPrice) {
                    res[_pType16].Price += s.Quote.QuoteList[baseId][_pType].PersonPrice;
                    res[_pType16].ServicesPrice += s.Quote.QuoteList[baseId][_pType].PersonPrice;
                    res[_pType16].Cost += s.Quote.QuoteList[baseId][_pType].PersonCost;
                    res[_pType16].ServicesCost += s.Quote.QuoteList[baseId][_pType].PersonCost;
                  }
                }
              } catch (err) {
                _iterator301.e(err);
              } finally {
                _iterator301.f();
              }
            }
          } catch (err) {
            _iterator299.e(err);
          } finally {
            _iterator299.f();
          }
          var _iterator300 = _createForOfIteratorHelper(day.BookingDayHotels),
            _step300;
          try {
            for (_iterator300.s(); !(_step300 = _iterator300.n()).done;) {
              var hotel = _step300.value;
              var _iterator302 = _createForOfIteratorHelper(hotel.BookingDayRooms),
                _step302;
              try {
                for (_iterator302.s(); !(_step302 = _iterator302.n()).done;) {
                  var room = _step302.value;
                  if (!room.QuoteList) continue;
                  if (!room.QuoteList[baseId]) continue;
                  if (!room.QuoteList[baseId].Include) continue;
                  if (!room.QuoteList[baseId].Groups) continue;
                  if (!room.QuoteList[baseId].Groups[groupId]) continue;
                  if (!room.QuoteList[baseId].Groups[groupId].selected) continue;
                  var quoteGroup = room.QuoteList[baseId].Groups[groupId];
                  var _iterator303 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
                    _step303;
                  try {
                    for (_iterator303.s(); !(_step303 = _iterator303.n()).done;) {
                      var _pType17 = _step303.value;
                      var paxGroup = (group.ADT ? group.ADT : 0) + (group.CHD ? group.CHD : 0) + (group.TL ? group.TL : 0);
                      if (room.QuoteList[baseId].PersonPrice) {
                        var personPrice = room.QuoteList[baseId].PersonPrice;
                        res[_pType17].Price += quoteGroup.pax * personPrice / paxGroup;
                        res[_pType17].HotelsPrice += quoteGroup.pax * personPrice / paxGroup;
                      }
                      if (room.QuoteList[baseId].PersonCost) {
                        var personCost = room.QuoteList[baseId].PersonCost;
                        res[_pType17].Cost += quoteGroup.pax * personCost / paxGroup;
                        res[_pType17].HotelsCost += quoteGroup.pax * personCost / paxGroup;
                      }
                      res[_pType17].Rooms.push(room.Room.Name);
                      if (room.HotelCategory && res[_pType17].HotelCategories.indexOf(room.HotelCategory.Name) == -1) {
                        res[_pType17].HotelCategories.push(room.HotelCategory.Name);
                      }
                    }
                  } catch (err) {
                    _iterator303.e(err);
                  } finally {
                    _iterator303.f();
                  }
                }
              } catch (err) {
                _iterator302.e(err);
              } finally {
                _iterator302.f();
              }
            }
          } catch (err) {
            _iterator300.e(err);
          } finally {
            _iterator300.f();
          }
        }
      } catch (err) {
        _iterator296.e(err);
      } finally {
        _iterator296.f();
      }
      var _iterator297 = _createForOfIteratorHelper(this.BookingFlights),
        _step297;
      try {
        for (_iterator297.s(); !(_step297 = _iterator297.n()).done;) {
          var _flight$QuoteList, _flight$QuoteList2;
          var flight = _step297.value;
          if (flight.QuoteType == 'NOT_INCLUDED') continue;
          if (!(flight !== null && flight !== void 0 && (_flight$QuoteList = flight.QuoteList) !== null && _flight$QuoteList !== void 0 && (_flight$QuoteList = _flight$QuoteList[baseId]) !== null && _flight$QuoteList !== void 0 && _flight$QuoteList.Include)) continue;
          if (!(flight !== null && flight !== void 0 && (_flight$QuoteList2 = flight.QuoteList) !== null && _flight$QuoteList2 !== void 0 && (_flight$QuoteList2 = _flight$QuoteList2[baseId]) !== null && _flight$QuoteList2 !== void 0 && (_flight$QuoteList2 = _flight$QuoteList2.Groups) !== null && _flight$QuoteList2 !== void 0 && _flight$QuoteList2[groupId])) continue;
          var _iterator304 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
            _step304;
          try {
            for (_iterator304.s(); !(_step304 = _iterator304.n()).done;) {
              var _pType18 = _step304.value;
              if (_pType18 == 'CHD' && flight.PaxType == 'CHD' || _pType18 != 'CHD' && flight.PaxType != 'CHD' || !this.hasChildFlight) {
                var fPrice = flight.getFlightPrice(baseId);
                if (fPrice) {
                  fPrice = this.currencyConvert(flight.CurrencyId, this.CurrencyId, fPrice);
                  res[_pType18].Price += fPrice;
                  res[_pType18].FlightsPrice += fPrice;
                }
                var fCost = flight.getFlightCost(baseId);
                if (fCost) {
                  fCost = this.currencyConvert(flight.CurrencyId, this.CurrencyId, fCost);
                  res[_pType18].Cost += fCost;
                  res[_pType18].FlightsCost += fCost;
                }
              }
            }
          } catch (err) {
            _iterator304.e(err);
          } finally {
            _iterator304.f();
          }
        }
      } catch (err) {
        _iterator297.e(err);
      } finally {
        _iterator297.f();
      }
      var _iterator298 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
        _step298;
      try {
        for (_iterator298.s(); !(_step298 = _iterator298.n()).done;) {
          var _this$QuoteGroups8;
          var _pType19 = _step298.value;
          if (!tools.isNull((_this$QuoteGroups8 = this.QuoteGroups) === null || _this$QuoteGroups8 === void 0 || (_this$QuoteGroups8 = _this$QuoteGroups8[baseId]) === null || _this$QuoteGroups8 === void 0 || (_this$QuoteGroups8 = _this$QuoteGroups8[groupId]) === null || _this$QuoteGroups8 === void 0 || (_this$QuoteGroups8 = _this$QuoteGroups8.OverPrice) === null || _this$QuoteGroups8 === void 0 ? void 0 : _this$QuoteGroups8[_pType19])) {
            res[_pType19].Price = this.QuoteGroups[baseId][groupId].OverPrice[_pType19];
          }
        }
      } catch (err) {
        _iterator298.e(err);
      } finally {
        _iterator298.f();
      }
      res = this.totalProfitCalc(res, baseId, groupId);
      return res;
    }
  }, {
    key: "totalsFlightsGroups",
    value: function totalsFlightsGroups(baseId, flight, pType) {
      var res = {
        Cost: 0,
        Price: 0
      };
      for (var groupId in this.QuoteGroups[baseId]) {
        var _this$QuoteGroups9, _this$QuoteGroups10;
        if (!flight.QuoteList) continue;
        if (!flight.QuoteList[baseId]) continue;
        if (!flight.QuoteList[baseId].Include) continue;
        if (!flight.QuoteList[baseId].Groups) continue;
        if (!flight.QuoteList[baseId].Groups[groupId]) continue;
        if (!((_this$QuoteGroups9 = this.QuoteGroups) !== null && _this$QuoteGroups9 !== void 0 && (_this$QuoteGroups9 = _this$QuoteGroups9[baseId]) !== null && _this$QuoteGroups9 !== void 0 && (_this$QuoteGroups9 = _this$QuoteGroups9[groupId]) !== null && _this$QuoteGroups9 !== void 0 && (_this$QuoteGroups9 = _this$QuoteGroups9.Selected) !== null && _this$QuoteGroups9 !== void 0 && _this$QuoteGroups9[pType])) continue;
        var pax = ((_this$QuoteGroups10 = this.QuoteGroups) === null || _this$QuoteGroups10 === void 0 || (_this$QuoteGroups10 = _this$QuoteGroups10[baseId]) === null || _this$QuoteGroups10 === void 0 || (_this$QuoteGroups10 = _this$QuoteGroups10[groupId]) === null || _this$QuoteGroups10 === void 0 ? void 0 : _this$QuoteGroups10[pType]) || 0;
        if (pax == 0) continue;
        if (pType == 'CHD' && flight.PaxType == 'CHD' || pType != 'CHD' && flight.PaxType != 'CHD' || !this.hasChildFlight) {
          var fPrice = flight.getFlightPrice(baseId);
          if (fPrice) {
            res.Price += fPrice * pax;
          }
          var fCost = flight.getFlightCost(baseId);
          if (fCost) {
            res.Cost += fCost * pax;
          }
        }
      }
      return res;
    }
  }, {
    key: "totalsPaxFlightsGroups",
    value: function totalsPaxFlightsGroups(baseId, flight, pType) {
      var res = 0;
      for (var groupId in this.QuoteGroups[baseId]) {
        var _flight$QuoteList3, _flight$QuoteList4, _flight$QuoteList5, _this$QuoteGroups11, _this$QuoteGroups12;
        if (!((_flight$QuoteList3 = flight.QuoteList) !== null && _flight$QuoteList3 !== void 0 && (_flight$QuoteList3 = _flight$QuoteList3[baseId]) !== null && _flight$QuoteList3 !== void 0 && _flight$QuoteList3.Include)) continue;
        if (!((_flight$QuoteList4 = flight.QuoteList) !== null && _flight$QuoteList4 !== void 0 && (_flight$QuoteList4 = _flight$QuoteList4[baseId]) !== null && _flight$QuoteList4 !== void 0 && _flight$QuoteList4.Groups)) continue;
        if (!((_flight$QuoteList5 = flight.QuoteList) !== null && _flight$QuoteList5 !== void 0 && (_flight$QuoteList5 = _flight$QuoteList5[baseId]) !== null && _flight$QuoteList5 !== void 0 && (_flight$QuoteList5 = _flight$QuoteList5.Groups) !== null && _flight$QuoteList5 !== void 0 && _flight$QuoteList5[groupId])) continue;
        if (!((_this$QuoteGroups11 = this.QuoteGroups) !== null && _this$QuoteGroups11 !== void 0 && (_this$QuoteGroups11 = _this$QuoteGroups11[baseId]) !== null && _this$QuoteGroups11 !== void 0 && (_this$QuoteGroups11 = _this$QuoteGroups11[groupId]) !== null && _this$QuoteGroups11 !== void 0 && (_this$QuoteGroups11 = _this$QuoteGroups11.Selected) !== null && _this$QuoteGroups11 !== void 0 && _this$QuoteGroups11[pType])) continue;
        var pax = ((_this$QuoteGroups12 = this.QuoteGroups) === null || _this$QuoteGroups12 === void 0 || (_this$QuoteGroups12 = _this$QuoteGroups12[baseId]) === null || _this$QuoteGroups12 === void 0 || (_this$QuoteGroups12 = _this$QuoteGroups12[groupId]) === null || _this$QuoteGroups12 === void 0 ? void 0 : _this$QuoteGroups12[pType]) || 0;
        if (pax == 0) continue;
        if (pType == 'CHD' && flight.PaxType == 'CHD' || pType != 'CHD' && flight.PaxType != 'CHD' || !this.hasChildFlight) {
          res += pax;
        }
      }
      return res;
    }
  }, {
    key: "flightsNotIncludedByGroup",
    get: function get() {
      var splitTourLeader = this.SplitTourLeaderQuote;
      var res = {};
      for (var baseId in this.BaseQuotes.bases) {
        if (!this.isGroup(baseId)) continue;
        if (!res[baseId]) res[baseId] = {};
        for (var groupId in this.QuoteGroups[baseId]) {
          if (!res[baseId][groupId]) res[baseId][groupId] = {};
          var _iterator305 = _createForOfIteratorHelper(this.BookingFlights),
            _step305;
          try {
            for (_iterator305.s(); !(_step305 = _iterator305.n()).done;) {
              var flight = _step305.value;
              if (flight.QuoteType != 'NOT_INCLUDED') continue;
              if (!flight.QuoteList) continue;
              if (!flight.QuoteList[baseId]) continue;
              if (!flight.QuoteList[baseId].Include) continue;
              if (!flight.QuoteList[baseId].Groups) continue;
              if (!flight.QuoteList[baseId].Groups[groupId]) continue;
              var _iterator306 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
                _step306;
              try {
                for (_iterator306.s(); !(_step306 = _iterator306.n()).done;) {
                  var pType = _step306.value;
                  if (splitTourLeader && pType == 'TL') continue;
                  if (!res[baseId][groupId][pType]) res[baseId][groupId][pType] = {
                    Price: 0,
                    Cost: 0,
                    Comments: []
                  };
                  if (pType == 'CHD' && flight.PaxType == 'CHD' || pType != 'CHD' && flight.PaxType != 'CHD' || !this.hasChildFlight) {
                    if (flight.Comment) {
                      if (!res[baseId][groupId][pType].Comments.includes(flight.Comment)) {
                        res[baseId][groupId][pType].Comments.push(flight.Comment);
                      }
                    }
                    var fPrice = flight.getFlightPrice(baseId);
                    if (fPrice) {
                      fPrice = this.currencyConvert(flight.CurrencyId, this.CurrencyId, fPrice);
                      res[baseId][groupId][pType].Price += fPrice;
                      res[baseId][groupId][pType].FlightType = flight.FlightType;
                    }
                    var fCost = flight.getFlightCost(baseId);
                    if (fCost) {
                      fCost = this.currencyConvert(flight.CurrencyId, this.CurrencyId, fCost);
                      res[baseId][groupId][pType].Cost += fCost;
                    }
                  }
                }
              } catch (err) {
                _iterator306.e(err);
              } finally {
                _iterator306.f();
              }
            }
          } catch (err) {
            _iterator305.e(err);
          } finally {
            _iterator305.f();
          }
        }
        if (this.SplitTourLeaderQuote) {
          var paxQuantitySplitTourLeader = this.BaseQuotes[baseId].paxQuantity - (this.BaseQuotes[baseId].TL || 0);
          var tlFlightsPrice = this.tourLeaderTotalFlightsNotIncludedAll(baseId);
          var tlFlightsPricePerPax = tlFlightsPrice / paxQuantitySplitTourLeader;
          for (var _groupId10 in res[baseId]) {
            for (var _pType20 in res[baseId][_groupId10]) {
              res[baseId][_groupId10][_pType20].Price += tlFlightsPricePerPax;
            }
          }
        }
      }
      return res;
    }
  }, {
    key: "totalProfitCalc",
    value: function totalProfitCalc(res, baseId, groupId) {
      return res;
    }
  }, {
    key: "roomsByGroup",
    get: function get() {
      var res = {};
      if (this.QuoteGroups) {
        var _iterator307 = _createForOfIteratorHelper(this.BookingDays),
          _step307;
        try {
          for (_iterator307.s(); !(_step307 = _iterator307.n()).done;) {
            var day = _step307.value;
            var _iterator308 = _createForOfIteratorHelper(day.BookingDayHotels),
              _step308;
            try {
              for (_iterator308.s(); !(_step308 = _iterator308.n()).done;) {
                var hotel = _step308.value;
                var _iterator309 = _createForOfIteratorHelper(hotel.BookingDayRooms),
                  _step309;
                try {
                  for (_iterator309.s(); !(_step309 = _iterator309.n()).done;) {
                    var room = _step309.value;
                    if (!room.QuoteList) continue;
                    if (!room.RoomTypeId) continue;
                    for (var baseId in this.BaseQuotes.bases) {
                      if (!this.isGroup(baseId)) continue;
                      if (!room.QuoteList[baseId]) continue;
                      if (!room.QuoteList[baseId].Include) continue;
                      if (!room.QuoteList[baseId].Groups) continue;
                      if (!res[baseId]) res[baseId] = {};
                      for (var groupId in this.QuoteGroups[baseId]) {
                        if (!room.QuoteList[baseId].Groups[groupId]) continue;
                        if (!res[baseId][groupId]) res[baseId][groupId] = {};
                        var _iterator310 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
                          _step310;
                        try {
                          for (_iterator310.s(); !(_step310 = _iterator310.n()).done;) {
                            var pType = _step310.value;
                            if (!res[baseId][groupId][pType]) res[baseId][groupId][pType] = {};
                            if (!res[baseId][groupId][pType][room.RoomTypeId]) {
                              res[baseId][groupId][pType][room.RoomTypeId] = room.Room;
                            }
                          }
                        } catch (err) {
                          _iterator310.e(err);
                        } finally {
                          _iterator310.f();
                        }
                      }
                    }
                  }
                } catch (err) {
                  _iterator309.e(err);
                } finally {
                  _iterator309.f();
                }
              }
            } catch (err) {
              _iterator308.e(err);
            } finally {
              _iterator308.f();
            }
          }
        } catch (err) {
          _iterator307.e(err);
        } finally {
          _iterator307.f();
        }
      }
      return res;
    }
  }, {
    key: "roomsTypeNamesByGroup",
    get: function get() {
      var res = {};
      for (var baseId in this.BaseQuotes.bases) {
        if (!res[baseId]) res[baseId] = {};
        for (var groupId in this.QuoteGroups[baseId]) {
          if (!res[baseId][groupId]) res[baseId][groupId] = {};
          var _iterator311 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
            _step311;
          try {
            for (_iterator311.s(); !(_step311 = _iterator311.n()).done;) {
              var pType = _step311.value;
              if (!res[baseId][groupId][pType]) res[baseId][groupId][pType] = '';
            }
          } catch (err) {
            _iterator311.e(err);
          } finally {
            _iterator311.f();
          }
        }
      }
      var roomsByGroup = this.roomsByGroup;
      var quoteGroups = this.QuoteGroups;
      for (var _baseId19 in roomsByGroup) {
        for (var _groupId11 in roomsByGroup[_baseId19]) {
          if (!res[_baseId19][_groupId11]) res[_baseId19][_groupId11] = {};
          for (var _pType21 in roomsByGroup[_baseId19][_groupId11]) {
            var rooms = [];
            for (var roomId in roomsByGroup[_baseId19][_groupId11][_pType21]) {
              if (quoteGroups[_baseId19][_groupId11].Rooms[roomId]) {
                var room = roomsByGroup[_baseId19][_groupId11][_pType21][roomId];
                rooms.push(room.Name);
              }
            }
            res[_baseId19][_groupId11][_pType21] = rooms.join(', ');
          }
        }
      }
      return res;
    }

    ////// groups end
  }, {
    key: "paxQuantity",
    get: function get() {
      var res = 0;
      for (var baseId in this.BaseQuotes.bases) {
        if (!this.BaseQuotes[baseId]) continue;
        var _iterator312 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
          _step312;
        try {
          for (_iterator312.s(); !(_step312 = _iterator312.n()).done;) {
            var pType = _step312.value;
            if (!this.BaseQuotes[baseId][pType]) continue;
            //if (!this.Totals[baseId]) continue;
            //if (!this.Totals[baseId][pType]) continue;
            //if (!this.Totals[baseId][pType].Selected) continue;
            if (!this.isQuoteSelected(baseId, pType)) continue;
            var pax = this.BaseQuotes[baseId][pType];
            if (this.QuoteBy == 'PERSON') {
              if (this.Totals[baseId][pType].Pax) {
                pax = this.Totals[baseId][pType].Pax;
              }
            }
            res += pax;
          }
        } catch (err) {
          _iterator312.e(err);
        } finally {
          _iterator312.f();
        }
      }
      return res;
    }
  }, {
    key: "paxQuantityList",
    get: function get() {
      var res = [];
      for (var baseId in this.BaseQuotes.bases) {
        if (!this.BaseQuotes[baseId]) continue;
        var selected = false;
        var _iterator313 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
          _step313;
        try {
          for (_iterator313.s(); !(_step313 = _iterator313.n()).done;) {
            var pType = _step313.value;
            //if (!this.Totals[baseId]) continue;
            //if (!this.Totals[baseId][pType]) continue;
            //if (!this.Totals[baseId][pType].Selected) continue;
            if (!this.isQuoteSelected(baseId, pType)) continue;
            selected = true;
          }
        } catch (err) {
          _iterator313.e(err);
        } finally {
          _iterator313.f();
        }
        if (!selected) continue;
        var pax = this.BaseQuotes[baseId].paxQuantity;
        res.push(pax);
      }
      return res;
    }
  }, {
    key: "firstQuoteQty",
    get: function get() {
      for (var baseId in this.BaseQuotes.bases) {
        if (!this.BaseQuotes[baseId]) continue;
        if (!this.BaseQuotes[baseId].ADT) continue;
        if (!this.Totals[baseId]) continue;
        if (!this.Totals[baseId].ADT) continue;
        if (!this.Totals[baseId].ADT.Selected) continue;
        var pax = this.BaseQuotes[baseId].ADT;
        if (this.BaseQuotes[baseId].CHD) pax += this.BaseQuotes[baseId].CHD;
        if (this.BaseQuotes[baseId].TL) pax += this.BaseQuotes[baseId].TL;
        return pax;
      }
    }
  }, {
    key: "paxQuantityPrices",
    get: function get() {
      var res = [];
      for (var baseId in this.BaseQuotes.bases) {
        if (!this.BaseQuotes[baseId]) continue;
        var _iterator314 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
          _step314;
        try {
          for (_iterator314.s(); !(_step314 = _iterator314.n()).done;) {
            var pType = _step314.value;
            if (!this.BaseQuotes[baseId][pType]) continue;
            //if (!this.Totals[baseId]) continue;
            //if (!this.Totals[baseId][pType]) continue;
            //if (!this.Totals[baseId][pType].Selected) continue;
            if (!this.isQuoteSelected(baseId, pType)) continue;
            var pax = this.BaseQuotes[baseId][pType];
            if (this.QuoteBy == 'PERSON') {
              if (this.Totals[baseId][pType].Pax) {
                pax = this.Totals[baseId][pType].Pax;
              }
            }
            res.push({
              pax: pax,
              price: this.totals[baseId][pType].Price
            });
          }
        } catch (err) {
          _iterator314.e(err);
        } finally {
          _iterator314.f();
        }
      }
      return res;
    }
  }, {
    key: "regions",
    get: function get() {
      var res = {};
      for (var id in this.cityList) {
        var city = this.cityList[id].City;
        if (!city.RegionId) continue;
        if (!res[city.RegionId]) res[city.RegionId] = city.Region;
      }
      return res;
    }

    ////// tour leader start
  }, {
    key: "addTourLeaderRoom",
    value: function () {
      var _addTourLeaderRoom = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee78(currentBaseId, tourLeaderValue, roomPax) {
        var _iterator315, _step315, day, _iterator316, _step316, hotel, firstRoom, roomTL, room, tlRoom, baseId, _baseId20, _baseId21, _tlRoom;
        return regenerator_default().wrap(function _callee78$(_context84) {
          while (1) switch (_context84.prev = _context84.next) {
            case 0:
              _iterator315 = _createForOfIteratorHelper(this.BookingDays);
              _context84.prev = 1;
              _iterator315.s();
            case 3:
              if ((_step315 = _iterator315.n()).done) {
                _context84.next = 36;
                break;
              }
              day = _step315.value;
              _iterator316 = _createForOfIteratorHelper(day.BookingDayHotels);
              _context84.prev = 6;
              _iterator316.s();
            case 8:
              if ((_step316 = _iterator316.n()).done) {
                _context84.next = 26;
                break;
              }
              hotel = _step316.value;
              if (!(hotel.BookingDayRooms.length == 0)) {
                _context84.next = 12;
                break;
              }
              return _context84.abrupt("continue", 24);
            case 12:
              firstRoom = hotel.BookingDayRooms[0];
              if (firstRoom) {
                _context84.next = 15;
                break;
              }
              return _context84.abrupt("continue", 24);
            case 15:
              roomTL = _.find(hotel.BookingDayRooms, function (r) {
                return r.TourLeader;
              });
              if (!(!roomTL && tourLeaderValue)) {
                _context84.next = 23;
                break;
              }
              _context84.next = 19;
              return hotel.addRoom();
            case 19:
              room = _context84.sent;
              if (room && room.Hotel) {
                room.RoomCategory = firstRoom.RoomCategory;
                room.TourLeader = true;
                tlRoom = _.find(room.Hotel.HotelRoomTypes, function (r) {
                  if (r.RoomType && r.RoomType.Pax == roomPax && !r.RoomType.ExtraBed && !r.RoomType.Checkin) return true;
                });
                if (tlRoom) {
                  room.RoomTypeId = tlRoom.RoomTypeId;
                }
                for (baseId in room.QuoteList.bases) {
                  if (baseId != currentBaseId) {
                    room.QuoteList[baseId].Include = false;
                  }
                }
              }
              _context84.next = 24;
              break;
            case 23:
              if (roomTL && !tourLeaderValue) {
                for (_baseId20 in roomTL.QuoteList.bases) {
                  if (_baseId20 == currentBaseId) {
                    roomTL.QuoteList[_baseId20].Include = false;
                  }
                }
              } else if (roomTL && tourLeaderValue) {
                for (_baseId21 in roomTL.QuoteList.bases) {
                  if (_baseId21 == currentBaseId) {
                    roomTL.QuoteList[_baseId21].Include = true;
                  }
                }
                if (roomTL.Room && roomTL.Room.Pax != roomPax) {
                  _tlRoom = _.find(roomTL.Hotel.HotelRoomTypes, function (r) {
                    if (r.RoomType && r.RoomType.Pax == roomPax && !r.RoomType.ExtraBed && !r.RoomType.Checkin) return true;
                  });
                  if (_tlRoom) {
                    roomTL.RoomTypeId = _tlRoom.RoomTypeId;
                  }
                  if (roomPax == 1) {
                    roomTL.Rooms = 1;
                  } else {
                    roomTL.Rooms = 0;
                  }
                }
              }
            case 24:
              _context84.next = 8;
              break;
            case 26:
              _context84.next = 31;
              break;
            case 28:
              _context84.prev = 28;
              _context84.t0 = _context84["catch"](6);
              _iterator316.e(_context84.t0);
            case 31:
              _context84.prev = 31;
              _iterator316.f();
              return _context84.finish(31);
            case 34:
              _context84.next = 3;
              break;
            case 36:
              _context84.next = 41;
              break;
            case 38:
              _context84.prev = 38;
              _context84.t1 = _context84["catch"](1);
              _iterator315.e(_context84.t1);
            case 41:
              _context84.prev = 41;
              _iterator315.f();
              return _context84.finish(41);
            case 44:
            case "end":
              return _context84.stop();
          }
        }, _callee78, this, [[1, 38, 41, 44], [6, 28, 31, 34]]);
      }));
      function addTourLeaderRoom(_x135, _x136, _x137) {
        return _addTourLeaderRoom.apply(this, arguments);
      }
      return addTourLeaderRoom;
    }()
  }, {
    key: "singleSupplementValue",
    get: function get() {
      var res = {};
      for (var baseId in this.BaseQuotes.bases) {
        if (!this.BaseQuotes[baseId]) continue;
        if (!res[baseId]) res[baseId] = 0;
        var _iterator317 = _createForOfIteratorHelper(this.BookingDays),
          _step317;
        try {
          for (_iterator317.s(); !(_step317 = _iterator317.n()).done;) {
            var day = _step317.value;
            var _iterator318 = _createForOfIteratorHelper(day.BookingDayHotels),
              _step318;
            try {
              for (_iterator318.s(); !(_step318 = _iterator318.n()).done;) {
                var hotel = _step318.value;
                if (hotel.BookingDayRooms.length == 0) continue;
                var _iterator319 = _createForOfIteratorHelper(hotel.BookingDayRooms),
                  _step319;
                try {
                  for (_iterator319.s(); !(_step319 = _iterator319.n()).done;) {
                    var room = _step319.value;
                    if (!room.Room) continue;
                    if (room.Room.Pax != 2) continue;
                    if (!room.QuoteList) continue;
                    if (!room.QuoteList[baseId]) continue;
                    if (!room.QuoteList[baseId].Include) continue;
                    if (!room.QuoteList[baseId].Cost) continue;
                    res[baseId] += room.QuoteList[baseId].Price / 2 * hotel.Days;
                  }
                } catch (err) {
                  _iterator319.e(err);
                } finally {
                  _iterator319.f();
                }
              }
            } catch (err) {
              _iterator318.e(err);
            } finally {
              _iterator318.f();
            }
          }
        } catch (err) {
          _iterator317.e(err);
        } finally {
          _iterator317.f();
        }
      }
      return res;
    }
  }, {
    key: "totalServicePrice",
    get: function get() {
      var res = {};
      for (var baseId in this.BaseQuotes.bases) {
        if (!this.totalsServices[baseId]) return;
        if (!this.totalsServices[baseId].ADT) return;
        res[baseId] = this.totalsServices[baseId].ADT.Price;
        if (this.totalsServices[baseId].CHD && this.totalsServices[baseId].CHD.Price) {
          res[baseId] += this.totalsServices[baseId].CHD.Price;
        }
        ;
        if (this.totalsServices[baseId].TL && this.totalsServices[baseId].TL.Price) {
          res[baseId] += this.totalsServices[baseId].TL.Price;
        }
        ;
      }
      return res;
    }
  }, {
    key: "totalServiceCost",
    get: function get() {
      var res = {};
      for (var baseId in this.BaseQuotes.bases) {
        if (!this.totalsServices[baseId]) return;
        if (!this.totalsServices[baseId].ADT) return;
        res[baseId] = this.totalsServices[baseId].ADT.Cost;
        if (this.totalsServices[baseId].CHD && this.totalsServices[baseId].CHD.Cost) {
          res[baseId] += this.totalsServices[baseId].CHD.Cost;
        }
        ;
        if (this.totalsServices[baseId].TL && this.totalsServices[baseId].TL.Cost) {
          res[baseId] += this.totalsServices[baseId].TL.Cost;
        }
        ;
      }
      return res;
    }
  }, {
    key: "anySingleSup",
    get: function get() {
      for (var baseId in this.BaseQuotes.bases) {
        if (this.BaseQuotes[baseId] && this.BaseQuotes[baseId].SingleSupplement) return true;
      }
    }
  }, {
    key: "addSingleSupplementRoom",
    value: function () {
      var _addSingleSupplementRoom = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee79(currentBaseId, singleSupValue) {
        var _iterator320, _step320, day, _iterator321, _step321, hotel, firstDouble, roomSup, room, typeRoom, baseId, _baseId22, _baseId23, _typeRoom;
        return regenerator_default().wrap(function _callee79$(_context85) {
          while (1) switch (_context85.prev = _context85.next) {
            case 0:
              _iterator320 = _createForOfIteratorHelper(this.BookingDays);
              _context85.prev = 1;
              _iterator320.s();
            case 3:
              if ((_step320 = _iterator320.n()).done) {
                _context85.next = 49;
                break;
              }
              day = _step320.value;
              _iterator321 = _createForOfIteratorHelper(day.BookingDayHotels);
              _context85.prev = 6;
              _iterator321.s();
            case 8:
              if ((_step321 = _iterator321.n()).done) {
                _context85.next = 39;
                break;
              }
              hotel = _step321.value;
              if (!(hotel.BookingDayRooms.length == 0)) {
                _context85.next = 12;
                break;
              }
              return _context85.abrupt("continue", 37);
            case 12:
              firstDouble = _.find(hotel.BookingDayRooms, function (r) {
                if (r.Room && r.Room.Pax == 2 && !r.Room.ExtraBed && !r.Room.Checkin) return true;
              });
              if (firstDouble) {
                _context85.next = 15;
                break;
              }
              return _context85.abrupt("continue", 37);
            case 15:
              roomSup = _.find(hotel.BookingDayRooms, function (r) {
                return r.SingleSupplement;
              });
              if (!(!roomSup && singleSupValue)) {
                _context85.next = 23;
                break;
              }
              _context85.next = 19;
              return hotel.addRoom();
            case 19:
              room = _context85.sent;
              if (room && room.Hotel) {
                room.$CurrencyId.value = this.CurrencyId;
                room.$RoomCategory.value = firstDouble.RoomCategory;
                room.SingleSupplement = true;
                typeRoom = _.find(room.Hotel.HotelRoomTypes, function (r) {
                  if (r.RoomType && r.RoomType.Pax == 1 && !r.RoomType.ExtraBed && !r.RoomType.Checkin) return true;
                });
                if (typeRoom) {
                  room.$RoomTypeId.value = typeRoom.RoomTypeId;
                  room.Room = typeRoom.RoomType;
                }
                room.updateCost({
                  skipCurrency: true,
                  baseId: currentBaseId
                });
                for (baseId in room.QuoteList.bases) {
                  room.QuoteList[baseId].Include = false;
                  room.QuoteList[baseId].$Markup.value = firstDouble.QuoteList[baseId].Markup;
                  if (baseId == currentBaseId) {
                    room.QuoteList[baseId].setRoomCost();
                  }
                }
                room.updateCost({
                  skipCurrency: true
                });
              }
              _context85.next = 37;
              break;
            case 23:
              if (!(roomSup && singleSupValue)) {
                _context85.next = 36;
                break;
              }
              _context85.next = 26;
              return roomSup.updateCost({
                skipCurrency: true,
                baseId: currentBaseId
              });
            case 26:
              _context85.t0 = regenerator_default().keys(roomSup.QuoteList.bases);
            case 27:
              if ((_context85.t1 = _context85.t0()).done) {
                _context85.next = 34;
                break;
              }
              _baseId22 = _context85.t1.value;
              if (!(_baseId22 != currentBaseId)) {
                _context85.next = 31;
                break;
              }
              return _context85.abrupt("continue", 27);
            case 31:
              if (!roomSup.QuoteList[_baseId22].Cost) roomSup.QuoteList[_baseId22].setRoomCost();
              _context85.next = 27;
              break;
            case 34:
              _context85.next = 37;
              break;
            case 36:
              if (roomSup) {
                for (_baseId23 in roomSup.QuoteList.bases) {
                  roomSup.QuoteList[_baseId23].Include = false;
                  roomSup.QuoteList[_baseId23].$Markup.value = firstDouble.QuoteList[_baseId23].Markup;
                }
                if (roomSup.Room && roomSup.Room.Pax != 1) {
                  _typeRoom = _.find(roomSup.Hotel.HotelRoomTypes, function (r) {
                    if (r.RoomType && r.RoomType.Pax == 1 && !r.RoomType.ExtraBed && !r.RoomType.Checkin) return true;
                  });
                  if (_typeRoom) {
                    roomSup.RoomTypeId = _typeRoom.RoomTypeId;
                  }
                  roomSup.Rooms = 1;
                }
              }
            case 37:
              _context85.next = 8;
              break;
            case 39:
              _context85.next = 44;
              break;
            case 41:
              _context85.prev = 41;
              _context85.t2 = _context85["catch"](6);
              _iterator321.e(_context85.t2);
            case 44:
              _context85.prev = 44;
              _iterator321.f();
              return _context85.finish(44);
            case 47:
              _context85.next = 3;
              break;
            case 49:
              _context85.next = 54;
              break;
            case 51:
              _context85.prev = 51;
              _context85.t3 = _context85["catch"](1);
              _iterator320.e(_context85.t3);
            case 54:
              _context85.prev = 54;
              _iterator320.f();
              return _context85.finish(54);
            case 57:
              return _context85.abrupt("return", res);
            case 58:
            case "end":
              return _context85.stop();
          }
        }, _callee79, this, [[1, 51, 54, 57], [6, 41, 44, 47]]);
      }));
      function addSingleSupplementRoom(_x138, _x139) {
        return _addSingleSupplementRoom.apply(this, arguments);
      }
      return addSingleSupplementRoom;
    }()
  }, {
    key: "changeBase",
    value: function changeBase(baseId, adt, chd, tl) {
      if (adt) this.BaseQuotes[baseId].ADT = adt;
      if (chd) this.BaseQuotes[baseId].CHD = chd;
      if (tl) this.BaseQuotes[baseId].TL = tl;
      var pax = adt ? adt : 0 + chd ? chd : 0 + tl ? tl : 0;
      if (this.QuoteBy == 'QUANTITY') {
        var _iterator322 = _createForOfIteratorHelper(this.BookingDays),
          _step322;
        try {
          for (_iterator322.s(); !(_step322 = _iterator322.n()).done;) {
            var day = _step322.value;
            var _iterator323 = _createForOfIteratorHelper(day.BookingDayServices),
              _step323;
            try {
              for (_iterator323.s(); !(_step323 = _iterator323.n()).done;) {
                var s = _step323.value;
                var _iterator324 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
                  _step324;
                try {
                  for (_iterator324.s(); !(_step324 = _iterator324.n()).done;) {
                    var pType = _step324.value;
                    if (!s.Quote.QuoteList[baseId]) continue;
                    if (!s.Quote.QuoteList[baseId][pType]) continue;
                    var q = 1;
                    if (s.costBy == 'PERSON' || s.costBy == 'BASE_PERSON') {
                      q = pax;
                    }
                    s.Quote.QuoteList[baseId][pType].Quantity = q;
                  }
                } catch (err) {
                  _iterator324.e(err);
                } finally {
                  _iterator324.f();
                }
              }
            } catch (err) {
              _iterator323.e(err);
            } finally {
              _iterator323.f();
            }
          }
        } catch (err) {
          _iterator322.e(err);
        } finally {
          _iterator322.f();
        }
      }
      if (this.QuoteBy == 'SERVICE') {
        var _iterator325 = _createForOfIteratorHelper(this.BookingDays),
          _step325;
        try {
          for (_iterator325.s(); !(_step325 = _iterator325.n()).done;) {
            var _day5 = _step325.value;
            var _iterator326 = _createForOfIteratorHelper(_day5.BookingDayServices),
              _step326;
            try {
              for (_iterator326.s(); !(_step326 = _iterator326.n()).done;) {
                var _s = _step326.value;
                if (!_s.Quote) continue;
                if (!_s.Quote.QuoteList) continue;
                if (!_s.Quote.QuoteList[baseId]) continue;
                var _iterator328 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes),
                  _step328;
                try {
                  for (_iterator328.s(); !(_step328 = _iterator328.n()).done;) {
                    var _pType22 = _step328.value;
                    if (!_s.Quote.QuoteList[baseId][_pType22]) continue;
                    _s.Quote.QuoteList[baseId][_pType22].Base = pax;
                  }
                } catch (err) {
                  _iterator328.e(err);
                } finally {
                  _iterator328.f();
                }
              }
            } catch (err) {
              _iterator326.e(err);
            } finally {
              _iterator326.f();
            }
            var _iterator327 = _createForOfIteratorHelper(_day5.BookingDayHotels),
              _step327;
            try {
              for (_iterator327.s(); !(_step327 = _iterator327.n()).done;) {
                var r = _step327.value;
                var _iterator329 = _createForOfIteratorHelper(r.BookingDayRooms),
                  _step329;
                try {
                  for (_iterator329.s(); !(_step329 = _iterator329.n()).done;) {
                    var room = _step329.value;
                    if (!room.QuoteList) continue;
                    if (!room.QuoteList[baseId]) continue;
                    room.QuoteList[baseId].Pax = pax;
                  }
                } catch (err) {
                  _iterator329.e(err);
                } finally {
                  _iterator329.f();
                }
              }
            } catch (err) {
              _iterator327.e(err);
            } finally {
              _iterator327.f();
            }
          }
        } catch (err) {
          _iterator325.e(err);
        } finally {
          _iterator325.f();
        }
      }
    }
  }, {
    key: "newPayment",
    value: function () {
      var _newPayment = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee80(supplierId) {
        var model, payment;
        return regenerator_default().wrap(function _callee80$(_context86) {
          while (1) switch (_context86.prev = _context86.next) {
            case 0:
              _context86.next = 2;
              return api.importMixinModule('bookingpayment', 'model');
            case 2:
              model = _context86.sent;
              _context86.next = 5;
              return new model({
                tableName: 'bookingpayment'
              });
            case 5:
              payment = _context86.sent;
              payment.SupplierId = supplierId;
              payment.BookingId = this.id;
              return _context86.abrupt("return", payment);
            case 9:
            case "end":
              return _context86.stop();
          }
        }, _callee80, this);
      }));
      function newPayment(_x140) {
        return _newPayment.apply(this, arguments);
      }
      return newPayment;
    }()
  }, {
    key: "newSupplierCredit",
    value: function () {
      var _newSupplierCredit = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee81(supplierId) {
        var model, credit;
        return regenerator_default().wrap(function _callee81$(_context87) {
          while (1) switch (_context87.prev = _context87.next) {
            case 0:
              _context87.next = 2;
              return api.importMixinModule('suppliercredit', 'model');
            case 2:
              model = _context87.sent;
              _context87.next = 5;
              return new model({
                tableName: 'suppliercredit'
              });
            case 5:
              credit = _context87.sent;
              credit.SupplierId = supplierId;
              credit.BookingId = this.id;
              return _context87.abrupt("return", credit);
            case 9:
            case "end":
              return _context87.stop();
          }
        }, _callee81, this);
      }));
      function newSupplierCredit(_x141) {
        return _newSupplierCredit.apply(this, arguments);
      }
      return newSupplierCredit;
    }() /// TL split 
  }, {
    key: "totalsSplitTourLeader",
    get: function get() {
      if (this.SplitTourLeaderQuote) {
        var _res7 = {};
        for (var baseId in this.bases) {
          if (!this.hasTL(baseId)) continue;
          var tlFlightsPrice = this.tourLeaderTotalFlightsNotIncludedAll(baseId);
          _res7[baseId] = {};
          var quote = this.BaseQuotes[baseId];
          var _iterator330 = _createForOfIteratorHelper(this.paxTypesByBase[baseId]),
            _step330;
          try {
            for (_iterator330.s(); !(_step330 = _iterator330.n()).done;) {
              var pType = _step330.value;
              if (pType == 'TL') continue;
              _res7[baseId][pType] = this.totals[baseId][pType].PersonPrice + (this.tourLeaderPrice(baseId) - tlFlightsPrice) / quote.paxQuantityWithoutTL;
            }
          } catch (err) {
            _iterator330.e(err);
          } finally {
            _iterator330.f();
          }
        }
        return _res7;
      }
      return {};
    }
  }, {
    key: "totalByBasePaxTypeSplitTourLeader",
    get: function get() {
      if (this.SplitTourLeaderQuote) {
        var _res8 = {};
        for (var baseId in this.bases) {
          if (!this.hasTL(baseId)) continue;
          _res8[baseId] = {};
          var _iterator331 = _createForOfIteratorHelper(this.paxTypesByBase[baseId]),
            _step331;
          try {
            for (_iterator331.s(); !(_step331 = _iterator331.n()).done;) {
              var _this$BaseQuotes6;
              var pType = _step331.value;
              if (pType == 'TL') continue;
              if (!((_this$BaseQuotes6 = this.BaseQuotes) !== null && _this$BaseQuotes6 !== void 0 && (_this$BaseQuotes6 = _this$BaseQuotes6[baseId]) !== null && _this$BaseQuotes6 !== void 0 && _this$BaseQuotes6[pType])) continue;
              var pax = this.BaseQuotes[baseId][pType];
              _res8[baseId][pType] = this.totalsSplitTourLeader[baseId][pType] * pax;
            }
          } catch (err) {
            _iterator331.e(err);
          } finally {
            _iterator331.f();
          }
        }
        return _res8;
      }
      return {};
    }
  }, {
    key: "totalByBasePaxTypeSplitTourLeaderWithFlights",
    get: function get() {
      if (this.SplitTourLeaderQuote) {
        var _res9 = {};
        for (var baseId in this.bases) {
          if (!this.hasTL(baseId)) continue;
          _res9[baseId] = {};
          var _iterator332 = _createForOfIteratorHelper(this.paxTypesByBase[baseId]),
            _step332;
          try {
            for (_iterator332.s(); !(_step332 = _iterator332.n()).done;) {
              var _this$BaseQuotes7, _this$totalByBasePaxT, _this$splitTourLeader;
              var pType = _step332.value;
              if (pType == 'TL') continue;
              if (!((_this$BaseQuotes7 = this.BaseQuotes) !== null && _this$BaseQuotes7 !== void 0 && (_this$BaseQuotes7 = _this$BaseQuotes7[baseId]) !== null && _this$BaseQuotes7 !== void 0 && _this$BaseQuotes7[pType])) continue;
              var pax = this.BaseQuotes[baseId][pType];
              if (!((_this$totalByBasePaxT = this.totalByBasePaxTypeSplitTourLeader) !== null && _this$totalByBasePaxT !== void 0 && (_this$totalByBasePaxT = _this$totalByBasePaxT[baseId]) !== null && _this$totalByBasePaxT !== void 0 && _this$totalByBasePaxT[pType])) continue;
              _res9[baseId][pType] = this.totalByBasePaxTypeSplitTourLeader[baseId][pType];
              if ((_this$splitTourLeader = this.splitTourLeaderTotalFlightsNotIncludedAll) !== null && _this$splitTourLeader !== void 0 && (_this$splitTourLeader = _this$splitTourLeader[baseId]) !== null && _this$splitTourLeader !== void 0 && (_this$splitTourLeader = _this$splitTourLeader[pType]) !== null && _this$splitTourLeader !== void 0 && _this$splitTourLeader.Price) {
                _res9[baseId][pType] += this.splitTourLeaderTotalFlightsNotIncludedAll[baseId][pType].Price * pax;
              }
            }
          } catch (err) {
            _iterator332.e(err);
          } finally {
            _iterator332.f();
          }
        }
        return _res9;
      }
      return {};
    }
  }, {
    key: "SplitTourLeaderFlightsNotIncluded",
    get: function get() {
      var res = {};
      if (this.SplitTourLeaderQuote && this.flightsNotIncluded) {
        res = _objectSpread({}, this.flightsNotIncluded);
        for (var key in res) {
          var _this$BaseQuotes8, _this$BaseQuotes$base, _this$BaseQuotes$base2, _this$BaseQuotes$base3, _this$BaseQuotes$base4, _this$BaseQuotes$base5, _this$BaseQuotes$base6;
          var parts = key.split(',');
          var baseId = parts[2];
          if (!this.hasTL(baseId)) continue;
          if (!baseId || !((_this$BaseQuotes8 = this.BaseQuotes) !== null && _this$BaseQuotes8 !== void 0 && _this$BaseQuotes8[baseId]) || !((_this$BaseQuotes$base = this.BaseQuotes[baseId]) !== null && _this$BaseQuotes$base !== void 0 && _this$BaseQuotes$base.TL)) continue;
          var tlPrice = ((_this$BaseQuotes$base2 = this.BaseQuotes[baseId]) === null || _this$BaseQuotes$base2 === void 0 ? void 0 : _this$BaseQuotes$base2.TL) * res[key].Price;
          var paxWithoutTL = 0;
          if ((_this$BaseQuotes$base3 = this.BaseQuotes[baseId]) !== null && _this$BaseQuotes$base3 !== void 0 && _this$BaseQuotes$base3.ADT) paxWithoutTL += (_this$BaseQuotes$base4 = this.BaseQuotes[baseId]) === null || _this$BaseQuotes$base4 === void 0 ? void 0 : _this$BaseQuotes$base4.ADT;
          if ((_this$BaseQuotes$base5 = this.BaseQuotes[baseId]) !== null && _this$BaseQuotes$base5 !== void 0 && _this$BaseQuotes$base5.CHD) paxWithoutTL += (_this$BaseQuotes$base6 = this.BaseQuotes[baseId]) === null || _this$BaseQuotes$base6 === void 0 ? void 0 : _this$BaseQuotes$base6.CHD;
          if (paxWithoutTL > 0) {
            res[key].Price += tlPrice / paxWithoutTL;
          }
        }
      }
      return res;
    }
  }, {
    key: "splitTourLeaderTotalFlightsNotIncludedAll",
    get: function get() {
      var res = {};
      if (this.SplitTourLeaderQuote && this.totalFlightsNotIncludedAll) {
        res = _objectSpread({}, this.totalFlightsNotIncludedAll);
        for (var baseId in res) {
          var _this$BaseQuotes9, _this$BaseQuotes$base7, _this$BaseQuotes$base8, _this$BaseQuotes10;
          if (!this.hasTL(baseId)) continue;
          if (!((_this$BaseQuotes9 = this.BaseQuotes) !== null && _this$BaseQuotes9 !== void 0 && _this$BaseQuotes9[baseId]) || !((_this$BaseQuotes$base7 = this.BaseQuotes[baseId]) !== null && _this$BaseQuotes$base7 !== void 0 && _this$BaseQuotes$base7.TL)) continue;
          var tlPrice = ((_this$BaseQuotes$base8 = this.BaseQuotes[baseId]) === null || _this$BaseQuotes$base8 === void 0 ? void 0 : _this$BaseQuotes$base8.TL) * res[baseId].ADT.Price;
          var paxWithoutTL = ((_this$BaseQuotes10 = this.BaseQuotes) === null || _this$BaseQuotes10 === void 0 ? void 0 : _this$BaseQuotes10[baseId].paxQuantityWithoutTL) || 0;
          if (paxWithoutTL > 0) {
            for (var pType in res[baseId]) {
              if (pType == 'TL') continue;
              res[baseId][pType].Price += tlPrice / paxWithoutTL;
            }
          }
        }
      }
      return res;
    }
  }, {
    key: "totalByPaxGroupSplitTourLeader",
    get: function get() {
      if (this.SplitTourLeaderQuote) {
        var _res10 = {};
        for (var baseId in this.bases) {
          if (!this.hasTL(baseId)) continue;
          if (!this.isGroup(baseId)) continue;
          var quote = this.BaseQuotes[baseId];
          _res10[baseId] = {};
          for (var groupId in this.QuoteGroups[baseId]) {
            _res10[baseId][groupId] = {};
            for (var pType in this.totalByPaxGroup[baseId][groupId]) {
              if (pType == 'TL') continue;
              _res10[baseId][groupId][pType] = this.totalByPaxGroup[baseId][groupId][pType].Price + this.tourLeaderPrice(baseId) / quote.paxQuantityWithoutTL;
            }
          }
        }
        return _res10;
      }
      return {};
    }
  }, {
    key: "totalGroupSplitTourLeader",
    get: function get() {
      if (this.SplitTourLeaderQuote) {
        var _res11 = {};
        for (var baseId in this.bases) {
          if (!this.isGroup(baseId)) continue;
          var quote = this.BaseQuotes[baseId];
          _res11[baseId] = {};
          for (var groupId in this.QuoteGroups[baseId]) {
            _res11[baseId][groupId] = {};
            for (var pType in this.totalByGroupWithFlights[baseId][groupId]) {
              if (pType == 'TL') continue;
              if (!this.QuoteGroups[baseId][groupId][pType]) continue;
              var pax = this.QuoteGroups[baseId][groupId][pType];
              _res11[baseId][groupId][pType] = this.totalByGroup[baseId][groupId][pType].Price + this.tourLeaderPrice(baseId) / quote.paxQuantityWithoutTL * pax;
            }
          }
        }
        return _res11;
      }
      return {};
    }
  }, {
    key: "totalGroupSplitTourLeaderWithFlights",
    get: function get() {
      var res = {};
      if (this.SplitTourLeaderQuote) {
        for (var baseId in this.bases) {
          if (!this.hasTL(baseId)) continue;
          var tlFlightsPrice = this.tourLeaderTotalFlightsNotIncludedAll(baseId);
          var paxQuantitySplitTourLeader = this.BaseQuotes[baseId].paxQuantity - (this.BaseQuotes[baseId].TL || 0);
          var tlFlightsPricePerPax = tlFlightsPrice / paxQuantitySplitTourLeader;
          if (!this.isGroup(baseId)) continue;
          var quote = this.BaseQuotes[baseId];
          res[baseId] = {};
          for (var groupId in this.QuoteGroups[baseId]) {
            res[baseId][groupId] = {};
            for (var pType in this.totalByGroupWithFlights[baseId][groupId]) {
              var _this$totalFlightsNot3;
              if (pType == 'TL') continue;
              if (!this.QuoteGroups[baseId][groupId][pType]) continue;
              var pax = this.QuoteGroups[baseId][groupId][pType];
              res[baseId][groupId][pType] = this.totalByGroup[baseId][groupId][pType].Price + this.tourLeaderPrice(baseId) / quote.paxQuantityWithoutTL * pax;
              if ((_this$totalFlightsNot3 = this.totalFlightsNotIncludedAll) !== null && _this$totalFlightsNot3 !== void 0 && (_this$totalFlightsNot3 = _this$totalFlightsNot3[baseId]) !== null && _this$totalFlightsNot3 !== void 0 && _this$totalFlightsNot3[pType]) {
                res[baseId][groupId][pType] += (this.totalFlightsNotIncludedAll[baseId][pType].Price + tlFlightsPricePerPax) * pax;
              }
            }
          }
        }
      }
      return res;
    }
  }, {
    key: "tourLeaderPrice",
    value: function tourLeaderPrice(baseId) {
      var includeTL = false;
      var tlPrice = 0;
      if (this.isGroup(baseId)) {
        for (var groupId in this.QuoteGroups[baseId]) {
          if (this.QuoteGroups[baseId][groupId].Selected.TL) {
            var _this$totalByGroup;
            includeTL = true;
            if ((_this$totalByGroup = this.totalByGroup) !== null && _this$totalByGroup !== void 0 && (_this$totalByGroup = _this$totalByGroup[baseId]) !== null && _this$totalByGroup !== void 0 && (_this$totalByGroup = _this$totalByGroup[groupId]) !== null && _this$totalByGroup !== void 0 && (_this$totalByGroup = _this$totalByGroup.TL) !== null && _this$totalByGroup !== void 0 && _this$totalByGroup.Price) {
              tlPrice += this.totalByGroup[baseId][groupId].TL.Price;
            }
          }
        }
      } else {
        var _this$Totals$baseId;
        if ((_this$Totals$baseId = this.Totals[baseId]) !== null && _this$Totals$baseId !== void 0 && (_this$Totals$baseId = _this$Totals$baseId.TL) !== null && _this$Totals$baseId !== void 0 && _this$Totals$baseId.Selected) {
          var _this$totalByBasePaxT2;
          includeTL = true;
          tlPrice = ((_this$totalByBasePaxT2 = this.totalByBasePaxTypeWithFlights) === null || _this$totalByBasePaxT2 === void 0 || (_this$totalByBasePaxT2 = _this$totalByBasePaxT2[baseId]) === null || _this$totalByBasePaxT2 === void 0 || (_this$totalByBasePaxT2 = _this$totalByBasePaxT2.TL) === null || _this$totalByBasePaxT2 === void 0 ? void 0 : _this$totalByBasePaxT2.Price) || 0;
        }
      }
      if (this.SplitTourLeaderQuote && includeTL) {
        //let c = 1 / this.getTotalInCurrency(1);
        var c = 1;
        return tlPrice * c;
      }
      return 0;
    }
  }, {
    key: "setPersonToService",
    value: function () {
      var _setPersonToService = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee82() {
        var baseId, _iterator333, _step333, _this$Totals$baseId$p, pType, quantityPax, _iterator334, _step334, day, _iterator335, _step335, _s$Quote$QuoteList$ba, s, quote, costModified, priceModified, markupModified, rCost, costBy, quantity, _iterator336, _step336, r, _iterator337, _step337, room, roomQuote, cost, markUpModified, _costModified, _priceModified, _rCost, pCost, pPrice, markup, price;
        return regenerator_default().wrap(function _callee82$(_context88) {
          while (1) switch (_context88.prev = _context88.next) {
            case 0:
              this.QuoteBy = 'SERVICE';
              this.QuoteViewType = 'PERSON';
              _context88.t0 = regenerator_default().keys(this.BaseQuotes.bases);
            case 3:
              if ((_context88.t1 = _context88.t0()).done) {
                _context88.next = 142;
                break;
              }
              baseId = _context88.t1.value;
              if (this.BaseQuotes[baseId]) {
                _context88.next = 7;
                break;
              }
              return _context88.abrupt("continue", 3);
            case 7:
              _iterator333 = _createForOfIteratorHelper(this.BaseQuotes[baseId].paxTypes);
              _context88.prev = 8;
              _iterator333.s();
            case 10:
              if ((_step333 = _iterator333.n()).done) {
                _context88.next = 132;
                break;
              }
              pType = _step333.value;
              quantityPax = ((_this$Totals$baseId$p = this.Totals[baseId][pType]) === null || _this$Totals$baseId$p === void 0 ? void 0 : _this$Totals$baseId$p.Pax) || this.BaseQuotes[baseId][pType];
              if (this.BaseQuotes[baseId][pType]) {
                _context88.next = 15;
                break;
              }
              return _context88.abrupt("continue", 130);
            case 15:
              _iterator334 = _createForOfIteratorHelper(this.BookingDays);
              _context88.prev = 16;
              _iterator334.s();
            case 18:
              if ((_step334 = _iterator334.n()).done) {
                _context88.next = 122;
                break;
              }
              day = _step334.value;
              _iterator335 = _createForOfIteratorHelper(day.BookingDayServices);
              _context88.prev = 21;
              _iterator335.s();
            case 23:
              if ((_step335 = _iterator335.n()).done) {
                _context88.next = 49;
                break;
              }
              s = _step335.value;
              quote = (_s$Quote$QuoteList$ba = s.Quote.QuoteList[baseId]) === null || _s$Quote$QuoteList$ba === void 0 ? void 0 : _s$Quote$QuoteList$ba[pType];
              if (quote) {
                _context88.next = 28;
                break;
              }
              return _context88.abrupt("continue", 47);
            case 28:
              costModified = quote.Modified;
              priceModified = quote.PriceModified;
              markupModified = quote.MarkupModified;
              rCost = quote.SourceCost / quote.Cost ? quote.Cost : 1;
              costBy = quote.CostBy || (s.Service.CostBy === 'PERSON' || s.Service.CostBy === 'BASE_PERSON' ? 'PERSON' : 'SERVICE');
              quantity = quote.CostBy == 'PERSON' || quote.CostBy == 'BASE_PERSON' ? quantityPax : 1;
              if (!costBy) quote.setValue({
                fieldName: 'CostPer',
                value: 'PERSON'
              });
              quote.$Quantity.value = quantity;
              quote.$Base.value = quantityPax;
              _context88.next = 39;
              return quote.setValue({
                fieldName: 'PersonCost',
                value: quote.Cost
              });
            case 39:
              quote.$SourceCost.value = quote.SourceCost * rCost;
              quote.$PersonCostModified.value = costModified;
              quote.$PersonPriceModified.value = priceModified;
              quote.$MarkupModified.value = markupModified;
              quote.$TotalCost.value = quote.PersonCost * quantityPax;
              quote.$TotalPrice.value = quote.PersonPrice * quantityPax;
              quote.$Modified.value = false;
              quote.$PriceModified.value = false;
            case 47:
              _context88.next = 23;
              break;
            case 49:
              _context88.next = 54;
              break;
            case 51:
              _context88.prev = 51;
              _context88.t2 = _context88["catch"](21);
              _iterator335.e(_context88.t2);
            case 54:
              _context88.prev = 54;
              _iterator335.f();
              return _context88.finish(54);
            case 57:
              _iterator336 = _createForOfIteratorHelper(day.BookingDayHotels);
              _context88.prev = 58;
              _iterator336.s();
            case 60:
              if ((_step336 = _iterator336.n()).done) {
                _context88.next = 112;
                break;
              }
              r = _step336.value;
              _iterator337 = _createForOfIteratorHelper(r.BookingDayRooms);
              _context88.prev = 63;
              _iterator337.s();
            case 65:
              if ((_step337 = _iterator337.n()).done) {
                _context88.next = 102;
                break;
              }
              room = _step337.value;
              roomQuote = room.QuoteList[baseId];
              if (roomQuote) {
                _context88.next = 70;
                break;
              }
              return _context88.abrupt("continue", 100);
            case 70:
              cost = roomQuote.RoomCost;
              markUpModified = roomQuote.MarkupModified;
              _costModified = roomQuote.Modified;
              _priceModified = roomQuote.PriceModified;
              _rCost = roomQuote.SourceRoomCost / cost ? cost : 1;
              pCost = roomQuote.Cost;
              pPrice = roomQuote.Price;
              markup = roomQuote.Markup || this.Markup;
              _context88.next = 80;
              return roomQuote.setValue({
                fieldName: 'Rooms',
                value: room.Rooms
              });
            case 80:
              _context88.next = 82;
              return roomQuote.setValue({
                fieldName: 'Pax',
                value: quantityPax
              });
            case 82:
              _context88.next = 84;
              return roomQuote.setValue({
                fieldName: 'UnitCostBy',
                value: room.Hotel.UnitCostBy
              });
            case 84:
              _context88.next = 86;
              return roomQuote.setValue({
                fieldName: 'PeriodCostBy',
                value: room.Hotel.PeriodCostBy
              });
            case 86:
              _context88.next = 88;
              return roomQuote.setValue({
                fieldName: 'Cost',
                value: cost
              });
            case 88:
              price = tools.getPrice(cost, markup);
              _context88.next = 91;
              return roomQuote.setValue({
                fieldName: 'Price',
                value: price
              });
            case 91:
              if (markUpModified) {
                roomQuote.$Markup.value = markup;
              }
              roomQuote.$SourceRoomCost.value = roomQuote.SourceRoomCost * _rCost;
              roomQuote.$MarkupModified.value = markUpModified;
              roomQuote.$Modified.value = _costModified;
              roomQuote.$PriceModified.value = _priceModified;
              roomQuote.$PersonCost.value = pCost;
              roomQuote.$PersonPrice.value = pPrice;
              roomQuote.$TotalCost.value = pCost * quantityPax;
              roomQuote.$TotalPrice.value = pPrice * quantityPax;
            case 100:
              _context88.next = 65;
              break;
            case 102:
              _context88.next = 107;
              break;
            case 104:
              _context88.prev = 104;
              _context88.t3 = _context88["catch"](63);
              _iterator337.e(_context88.t3);
            case 107:
              _context88.prev = 107;
              _iterator337.f();
              return _context88.finish(107);
            case 110:
              _context88.next = 60;
              break;
            case 112:
              _context88.next = 117;
              break;
            case 114:
              _context88.prev = 114;
              _context88.t4 = _context88["catch"](58);
              _iterator336.e(_context88.t4);
            case 117:
              _context88.prev = 117;
              _iterator336.f();
              return _context88.finish(117);
            case 120:
              _context88.next = 18;
              break;
            case 122:
              _context88.next = 127;
              break;
            case 124:
              _context88.prev = 124;
              _context88.t5 = _context88["catch"](16);
              _iterator334.e(_context88.t5);
            case 127:
              _context88.prev = 127;
              _iterator334.f();
              return _context88.finish(127);
            case 130:
              _context88.next = 10;
              break;
            case 132:
              _context88.next = 137;
              break;
            case 134:
              _context88.prev = 134;
              _context88.t6 = _context88["catch"](8);
              _iterator333.e(_context88.t6);
            case 137:
              _context88.prev = 137;
              _iterator333.f();
              return _context88.finish(137);
            case 140:
              _context88.next = 3;
              break;
            case 142:
            case "end":
              return _context88.stop();
          }
        }, _callee82, this, [[8, 134, 137, 140], [16, 124, 127, 130], [21, 51, 54, 57], [58, 114, 117, 120], [63, 104, 107, 110]]);
      }));
      function setPersonToService() {
        return _setPersonToService.apply(this, arguments);
      }
      return setPersonToService;
    }()
  }, {
    key: "isForcePaxQty",
    get: function get() {
      for (var baseId in this.Totals) {
        for (var pType in this.Totals[baseId]) {
          var _this$Totals$baseId$p2;
          if ((_this$Totals$baseId$p2 = this.Totals[baseId][pType]) !== null && _this$Totals$baseId$p2 !== void 0 && _this$Totals$baseId$p2.Pax && this.Totals[baseId][pType].Pax != this.BaseQuotes[baseId][pType]) {
            return true;
          }
        }
      }
      for (var _baseId24 in this.BaseQuotes.bases) {
        if (this.hasChild(_baseId24)) return true;
      }
      return false;
    }
  }, {
    key: "uniqueFlights",
    get: function get() {
      var _this10 = this;
      var uniqueFlightsMap = {};
      var result = {};
      var flightsData = this.flightsNotIncludedByGroup;
      if (!flightsData) {
        return {};
      }
      for (var baseId in flightsData) {
        result[baseId] = {};
        for (var groupId in flightsData[baseId]) {
          result[baseId][groupId] = {};
          var _loop15 = function _loop15() {
            if (!_this10.QuoteGroups[baseId][groupId][pType]) return 1; // continue
            var Price = flightsData[baseId][groupId][pType].Price;
            // const translatePtype = tr(pType, this.Language.Code);

            if (uniqueFlightsMap[Price]) {
              var _flightsData$baseId$g;
              uniqueFlightsMap[Price].count++;
              if (!uniqueFlightsMap[Price].pTypes.includes(pType) && _this10.showRow(pType)) {
                // uniqueFlightsMap[Price].pTypes.push(translatePtype);
                uniqueFlightsMap[Price].pTypes.push(pType);
              }
              if (!uniqueFlightsMap[Price].groups.includes(groupId)) {
                uniqueFlightsMap[Price].groups.push(groupId);
              }
              if ((_flightsData$baseId$g = flightsData[baseId][groupId][pType].Comments) !== null && _flightsData$baseId$g !== void 0 && _flightsData$baseId$g.length) {
                var _flightsData$baseId$g2;
                (_flightsData$baseId$g2 = flightsData[baseId][groupId][pType].Comments) === null || _flightsData$baseId$g2 === void 0 || _flightsData$baseId$g2.forEach(function (element) {
                  if (!uniqueFlightsMap[Price].comments.includes(element)) {
                    uniqueFlightsMap[Price].comments.push(element);
                  }
                });
              }
            }
            if (Price && !uniqueFlightsMap[Price]) {
              var comments = flightsData[baseId][groupId][pType].Comments || [];
              uniqueFlightsMap[Price] = {
                price: Price,
                count: 1,
                pTypes: [pType],
                groups: [groupId],
                comments: comments,
                FlightType: flightsData[baseId][groupId][pType].FlightType
              };
              result[baseId][groupId][pType] = Price;
            }
          };
          for (var pType in flightsData[baseId][groupId]) {
            if (_loop15()) continue;
          }
        }
      }
      result.Length = Object.keys(uniqueFlightsMap).length;
      result.uniqueFlightsMap = uniqueFlightsMap;
      return result;
    }
  }, {
    key: "showRow",
    value: function showRow(pType) {
      if (this.QuoteBy != 'SERVICE') return true;
      if (this.SplitTourLeaderQuote && pType == 'TL') return false;
      return true;
    }
  }, {
    key: "updatePickupInfo",
    value: function updatePickupInfo() {
      var _this11 = this;
      var _iterator338 = _createForOfIteratorHelper(this.BookingDays),
        _step338;
      try {
        for (_iterator338.s(); !(_step338 = _iterator338.n()).done;) {
          var day = _step338.value;
          var _iterator339 = _createForOfIteratorHelper(day.BookingDayServices),
            _step339;
          try {
            for (_iterator339.s(); !(_step339 = _iterator339.n()).done;) {
              var _s$Service;
              var s = _step339.value;
              if ((_s$Service = s.Service) !== null && _s$Service !== void 0 && (_s$Service = _s$Service.ServiceDescriptions) !== null && _s$Service !== void 0 && _s$Service.length) {
                var description = s.Service.ServiceDescriptions.find(function (d) {
                  return d.LanguageId == _this11.LanguageId;
                });
                if (description !== null && description !== void 0 && description.PickupInfo) {
                  s.PickupInfo = description.PickupInfo;
                }
              }
            }
          } catch (err) {
            _iterator339.e(err);
          } finally {
            _iterator339.f();
          }
        }
      } catch (err) {
        _iterator338.e(err);
      } finally {
        _iterator338.f();
      }
    }
  }, {
    key: "FlightList",
    get: function get() {
      if (this.ShowPriceBy == 'TOTAL_TRIP') return null;
      var flightList = [];
      var mappedNoGroupMaps = [];
      var allNonGroupFlights = [];
      var allGroupFlights = [];
      for (var baseId in this.BaseQuotes.bases) {
        if (this.isGroup(baseId)) {
          var _this$uniqueFlights, _Object$values, _this$uniqueFlights2;
          var uniqueFlights = ((_this$uniqueFlights = this.uniqueFlights) === null || _this$uniqueFlights === void 0 ? void 0 : _this$uniqueFlights[baseId]) || {};
          var firstFlightMaped = (_Object$values = Object.values((_this$uniqueFlights2 = this.uniqueFlights) === null || _this$uniqueFlights2 === void 0 ? void 0 : _this$uniqueFlights2.uniqueFlightsMap)) === null || _Object$values === void 0 ? void 0 : _Object$values[0];
          if (this.uniqueFlights.Length == 1 && (firstFlightMaped === null || firstFlightMaped === void 0 ? void 0 : firstFlightMaped.count) != 1) {
            var Label = this.getUniqueFlightLabel(firstFlightMaped, baseId);
            var flight = {
              BaseId: baseId,
              Label: Label,
              Price: firstFlightMaped === null || firstFlightMaped === void 0 ? void 0 : firstFlightMaped.price
            };
            allGroupFlights.push(flight);
            continue;
          }
          for (var _i19 = 0, _Object$keys = Object.keys(uniqueFlights); _i19 < _Object$keys.length; _i19++) {
            var groupId = _Object$keys[_i19];
            for (var _i20 = 0, _Object$keys2 = Object.keys(uniqueFlights[groupId]); _i20 < _Object$keys2.length; _i20++) {
              var pType = _Object$keys2[_i20];
              if (!uniqueFlights[groupId][pType]) continue;
              var _flight2 = {
                BaseId: baseId,
                GroupId: groupId,
                PType: pType,
                Label: "",
                Price: 0
              };
              _flight2.Label = this.getGroupFlightLabel(baseId, groupId, pType);
              _flight2.Price = uniqueFlights[groupId][pType];
              allGroupFlights.push(_flight2);
            }
          }
        } else {
          for (var _i21 = 0, _Object$entries = Object.entries(this.flightsNotIncluded); _i21 < _Object$entries.length; _i21++) {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i21], 2),
              id = _Object$entries$_i[0],
              eFlight = _Object$entries$_i[1];
            if (this.isFlightForBase(id, baseId) && !mappedNoGroupMaps.includes(id)) {
              var label = this.getNotIncludedFlightLabel(baseId, eFlight.pType, eFlight);
              var price = 0;
              if (!this.SplitTourLeaderQuote) {
                price = eFlight.Price;
              } else {
                price = this.SplitTourLeaderFlightsNotIncluded[id].Price;
              }
              var flightData = {
                id: id,
                BaseId: baseId,
                PType: eFlight.pType,
                Label: label,
                Price: price
              };
              allNonGroupFlights.push(flightData);
              mappedNoGroupMaps.push(id);
            }
          }
        }
      }
      var allFlights = [].concat(allGroupFlights, allNonGroupFlights);
      if (allFlights.length === 0) {
        return flightList;
      }
      var flightsByPrice = {};
      allFlights.forEach(function (flight) {
        if (!flightsByPrice[flight.Price]) {
          flightsByPrice[flight.Price] = [];
        }
        flightsByPrice[flight.Price].push(flight);
      });
      var prices = Object.keys(flightsByPrice);
      if (prices.length === 1 && allFlights.length > 1) {
        var singlePrice = prices[0];
        var flights = flightsByPrice[singlePrice];
        var simpleFlight = flights.find(function (f) {
          return !f.Label.includes('Room') && !f.Label.includes('based on');
        }) || flights.find(function (f) {
          return !f.Label.includes('Room');
        }) || flights.reduce(function (a, b) {
          return a.Label.length < b.Label.length ? a : b;
        });
        flightList.push(simpleFlight);
      } else {
        flightList.push.apply(flightList, (0,toConsumableArray/* default */.A)(allFlights));
      }
      return flightList;
    }
  }, {
    key: "getGroupName",
    value: function getGroupName(baseId, groupId, pType) {
      var _this12 = this;
      var paxQuantity = 0;
      if (Array.isArray(groupId)) {
        groupId.forEach(function (id) {
          if (Array.isArray(pType)) {
            pType.forEach(function (type) {
              var _this12$QuoteGroups;
              paxQuantity += ((_this12$QuoteGroups = _this12.QuoteGroups) === null || _this12$QuoteGroups === void 0 || (_this12$QuoteGroups = _this12$QuoteGroups[baseId]) === null || _this12$QuoteGroups === void 0 || (_this12$QuoteGroups = _this12$QuoteGroups[id]) === null || _this12$QuoteGroups === void 0 ? void 0 : _this12$QuoteGroups[type]) || 0;
            });
          } else {
            var _this12$QuoteGroups2;
            paxQuantity += ((_this12$QuoteGroups2 = _this12.QuoteGroups) === null || _this12$QuoteGroups2 === void 0 || (_this12$QuoteGroups2 = _this12$QuoteGroups2[baseId]) === null || _this12$QuoteGroups2 === void 0 || (_this12$QuoteGroups2 = _this12$QuoteGroups2[id]) === null || _this12$QuoteGroups2 === void 0 ? void 0 : _this12$QuoteGroups2[pType]) || 0;
          }
        });
      } else {
        if (Array.isArray(pType)) {
          pType.forEach(function (type) {
            var _this12$QuoteGroups3;
            paxQuantity += ((_this12$QuoteGroups3 = _this12.QuoteGroups) === null || _this12$QuoteGroups3 === void 0 || (_this12$QuoteGroups3 = _this12$QuoteGroups3[baseId]) === null || _this12$QuoteGroups3 === void 0 || (_this12$QuoteGroups3 = _this12$QuoteGroups3[groupId]) === null || _this12$QuoteGroups3 === void 0 ? void 0 : _this12$QuoteGroups3[type]) || 0;
          });
        } else {
          var _this$QuoteGroups13;
          paxQuantity = ((_this$QuoteGroups13 = this.QuoteGroups) === null || _this$QuoteGroups13 === void 0 || (_this$QuoteGroups13 = _this$QuoteGroups13[baseId]) === null || _this$QuoteGroups13 === void 0 || (_this$QuoteGroups13 = _this$QuoteGroups13[groupId]) === null || _this$QuoteGroups13 === void 0 ? void 0 : _this$QuoteGroups13[pType]) || 0;
        }
      }
      var roomTypeNamesGroups = this.roomTypeNamesGroups(baseId, groupId, pType, paxQuantity);
      return roomTypeNamesGroups;
    }
  }, {
    key: "getUniqueFlightLabel",
    value: function getUniqueFlightLabel(flightMaped, baseId) {
      var _flightMaped$comments, _flightMaped$comments2;
      var flightType = (flightMaped === null || flightMaped === void 0 ? void 0 : flightMaped.FlightType) || '';
      if (flightType == 'LOCAL') flightType = tr('Internal Flights', this.Language.Code);else flightType = tr('International Flights', this.Language.Code);
      var comment = flightMaped !== null && flightMaped !== void 0 && (_flightMaped$comments = flightMaped.comments) !== null && _flightMaped$comments !== void 0 && _flightMaped$comments.join(', ') ? " - ".concat(flightMaped === null || flightMaped === void 0 || (_flightMaped$comments2 = flightMaped.comments) === null || _flightMaped$comments2 === void 0 ? void 0 : _flightMaped$comments2.join(', ')) : '';
      return "".concat(flightType, " ").concat(tr(flightMaped.pTypes[0], this.Language.Code)).concat(comment);
    }
  }, {
    key: "getGroupFlightLabel",
    value: function getGroupFlightLabel(baseId, groupId, pType) {
      var _FlightMaped$comments;
      var FlightMaped = this.getFlightMaped(baseId, groupId, pType);
      var groupName = this.getGroupName(baseId, FlightMaped.groups, FlightMaped.pTypes);
      var commentsForLabel = (FlightMaped === null || FlightMaped === void 0 || (_FlightMaped$comments = FlightMaped.comments) === null || _FlightMaped$comments === void 0 ? void 0 : _FlightMaped$comments.join(', ')) || '';
      var flightType = (FlightMaped === null || FlightMaped === void 0 ? void 0 : FlightMaped.FlightType) || '';
      if (flightType == 'LOCAL') flightType = tr('Internal Flights', this.Language.Code);else flightType = tr('International Flights', this.Language.Code);
      return "".concat(flightType, " ").concat(tr(pType, this.Language.Code), " - ").concat(groupName, " -  ").concat(commentsForLabel);
    }
  }, {
    key: "getNotIncludedFlightLabel",
    value: function getNotIncludedFlightLabel(baseId, pType, eFlight) {
      var label = "";
      var comment = eFlight.Comment ? " - ".concat(eFlight.Comment) : '';
      if (eFlight.FlightType == 'LOCAL') {
        label = "".concat(tr('Internal Flights', this.Language.Code), " ").concat(tr(pType, this.Language.Code), " ").concat(comment);
      }
      if (eFlight.FlightType == 'INTERNATIONAL') {
        label = "".concat(tr('International Flights', this.Language.Code), " ").concat(tr(pType, this.Language.Code), " ").concat(comment);
      }
      return label;
    }
  }, {
    key: "getFlightMaped",
    value: function getFlightMaped(baseId, groupId, pType) {
      return this.uniqueFlights.uniqueFlightsMap[this.uniqueFlights[baseId][groupId][pType]];
    }
  }, {
    key: "isFlightForBase",
    value: function isFlightForBase(flightId, baseId) {
      var _this$flightsNotInclu;
      if (!((_this$flightsNotInclu = this.flightsNotIncluded) !== null && _this$flightsNotInclu !== void 0 && _this$flightsNotInclu[flightId])) {
        return false;
      }
      var flight = this.flightsNotIncluded[flightId];
      if (flight.Bases) {
        return flight.Bases.includes(baseId);
      }
      return flightId.includes(baseId);
    }
  }, {
    key: "roomTypeNamesGroups",
    value: function roomTypeNamesGroups(baseId, groupId, pType, paxQuantity) {
      var _this13 = this;
      var groupRooms;
      if (Array.isArray(groupId)) {
        groupRooms = new Set();
        groupId.forEach(function (id) {
          pType.forEach(function (type) {
            var _groupRooms, _this13$totalByPaxGro;
            (_groupRooms = groupRooms).add.apply(_groupRooms, (0,toConsumableArray/* default */.A)(((_this13$totalByPaxGro = _this13.totalByPaxGroup[baseId][id][type]) === null || _this13$totalByPaxGro === void 0 ? void 0 : _this13$totalByPaxGro.Rooms) || []));
          });
        });
      } else {
        var _this$totalByPaxGroup6;
        groupRooms = new Set((_this$totalByPaxGroup6 = this.totalByPaxGroup[baseId][groupId][pType]) === null || _this$totalByPaxGroup6 === void 0 ? void 0 : _this$totalByPaxGroup6.Rooms);
      }
      var roomNames = (0,toConsumableArray/* default */.A)(groupRooms).map(function (room) {
        return tr(room, _this13.Language.Code);
      });
      if (this.Language.Code == 'en') {
        return "".concat(roomNames.join(' / '), " ").concat(tr('Room', this.Language.Code), " (").concat(tr('based on', this.Language.Code), " ").concat(paxQuantity, " ").concat(tr('pax', this.Language.Code), ")");
      }
      return "".concat(tr('Room', this.Language.Code), " ").concat(roomNames.join(' / '), " (").concat(tr('based on', this.Language.Code), " ").concat(paxQuantity, " ").concat(tr('pax', this.Language.Code), ")");
    }
  }, {
    key: "groupsComments",
    value: function groupsComments(baseId, pType, groupId) {
      var _this$QuoteGroups$bas;
      if ((_this$QuoteGroups$bas = this.QuoteGroups[baseId]) !== null && _this$QuoteGroups$bas !== void 0 && (_this$QuoteGroups$bas = _this$QuoteGroups$bas[groupId]) !== null && _this$QuoteGroups$bas !== void 0 && (_this$QuoteGroups$bas = _this$QuoteGroups$bas.Comments) !== null && _this$QuoteGroups$bas !== void 0 && _this$QuoteGroups$bas[pType]) return this.QuoteGroups[baseId][groupId].Comments[pType];
      var t = this.bookingTotals.find(function (t) {
        return t.Base === baseId && t.pType === pType;
      });
      if (t.Quote.Comment) return t.Quote.Comment;
    }
  }, {
    key: "roomTypeNames",
    value: function roomTypeNames(t) {
      if (!t.Room) return "(".concat(tr('based on', this.Language.Code), " ").concat(t.pax, " ").concat(tr('pax', this.Language.Code), ")");
      var roomsNames = this.getRoomsNames(t.Room);
      var rooms = roomsNames.split(' / ');
      var res = [];
      var _iterator340 = _createForOfIteratorHelper(rooms),
        _step340;
      try {
        for (_iterator340.s(); !(_step340 = _iterator340.n()).done;) {
          var r = _step340.value;
          res.push(tr(r, this.Language.Code));
        }
      } catch (err) {
        _iterator340.e(err);
      } finally {
        _iterator340.f();
      }
      if (this.Language.Code != 'en') {
        return "".concat(tr('Room', this.Language.Code), " ").concat(res.join(' / '), " (").concat(tr('based on', this.Language.Code), " ").concat(t.pax, " ").concat(tr('pax', this.Language.Code), ")");
      }
      return "".concat(res.join(' / '), " ").concat(tr('Room', this.Language.Code), " (").concat(tr('based on', this.Language.Code), " ").concat(t.pax, " ").concat(tr('pax', this.Language.Code), ")");
    }
  }, {
    key: "getRoomsNames",
    value: function getRoomsNames(rooms) {
      var r = [];
      for (var roomId in rooms) {
        if (rooms[roomId].Checkin) continue;
        if (r.indexOf(rooms[roomId].Name) == -1) {
          r.push(rooms[roomId].Name);
        }
      }
      return r.join(' / ');
    }
  }, {
    key: "getMonthName",
    value: function getMonthName(day) {
      return tools.toTitleCase(moment(day.TransDate).locale(this.Language.Code).format("MMM"));
    }
  }, {
    key: "getDayNr",
    value: function getDayNr(day) {
      return moment(day.TransDate).format("DD");
    }
  }, {
    key: "getDayMonthNrText",
    value: function getDayMonthNrText(day) {
      return "".concat(this.getMonthName(day), " ").concat(this.getDayNr(day));
    }
  }, {
    key: "getDatesText",
    value: function getDatesText(day, langCode) {
      if (day.GroupDays && day.GroupDayTo) {
        var r1 = this.getDayMonthNrText(day);
        var r2 = '';
        var dayTo = _.find(this.BookingDays, function (p) {
          return p.DayNr == day.GroupDayTo - 1;
        });
        if (dayTo) {
          r2 = this.getDayMonthNrText(dayTo);
        }
        return "".concat(tr('From', langCode), " ").concat(r1, " ").concat(tr('TO_', langCode), " ").concat(r2);
      }
      return this.getDayMonthNrText(day);
    }
  }], [{
    key: "get",
    value: function () {
      var _get2 = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee83(_ref13) {
        var id, isTemplate, payments, receipts, record, r;
        return regenerator_default().wrap(function _callee83$(_context89) {
          while (1) switch (_context89.prev = _context89.next) {
            case 0:
              id = _ref13.id, isTemplate = _ref13.isTemplate, payments = _ref13.payments, receipts = _ref13.receipts;
              _context89.next = 3;
              return api.getObjectFromStore('booking', id);
            case 3:
              record = _context89.sent;
              if (!record) {
                _context89.next = 22;
                break;
              }
              _context89.next = 7;
              return new this({
                record: record,
                isTemplate: record.isTemplate
              });
            case 7:
              r = _context89.sent;
              if (!r.id) {
                _context89.next = 21;
                break;
              }
              r.getAttached();
              if (!r.SummaryCurrencyId) r.SummaryCurrencyId = api.baseCurrency.SummaryCurrency;
              //if (receipts) await api.setReceipts(r.id);
              if (!receipts) {
                _context89.next = 14;
                break;
              }
              _context89.next = 14;
              return r.setReceipts(r.id);
            case 14:
              if (!payments) {
                _context89.next = 19;
                break;
              }
              _context89.next = 17;
              return api.setPayments(r.id);
            case 17:
              _context89.next = 19;
              return api.setSupplierCredits(id);
            case 19:
              ;
              api.hotelCost = {};
            case 21:
              return _context89.abrupt("return", r);
            case 22:
            case "end":
              return _context89.stop();
          }
        }, _callee83, this);
      }));
      function get(_x142) {
        return _get2.apply(this, arguments);
      }
      return get;
    }()
  }, {
    key: "createBookingFromTemplate",
    value: function () {
      var _createBookingFromTemplate = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee84(template) {
        var booking, baseId, _iterator341, _step341, day, _iterator342, _step342, s, _baseId26, _iterator343, _step343, room, _baseId25;
        return regenerator_default().wrap(function _callee84$(_context90) {
          while (1) switch (_context90.prev = _context90.next) {
            case 0:
              _context90.next = 2;
              return new this({
                isTemplate: false,
                fromTemplate: true
              });
            case 2:
              booking = _context90.sent;
              booking._fromTemlate = true;
              booking._recordLoaded = true;
              booking.TemplateType = "NONE";
              booking.LanguageId = template.LanguageId;
              booking.Title = template.Title;
              booking.ImageId = template.ImageId;
              booking.Image = template.Image;
              booking.Summary = template.Summary;
              booking.NotInclude = template.NotInclude;
              booking.Include = template.Include;
              _context90.t0 = regenerator_default().keys(template.BaseQuotes.bases);
            case 14:
              if ((_context90.t1 = _context90.t0()).done) {
                _context90.next = 20;
                break;
              }
              baseId = _context90.t1.value;
              _context90.next = 18;
              return template.removeBase(baseId);
            case 18:
              _context90.next = 14;
              break;
            case 20:
              _context90.next = 22;
              return booking.addTemplate([template]);
            case 22:
              _iterator341 = _createForOfIteratorHelper(booking.BookingDays);
              try {
                for (_iterator341.s(); !(_step341 = _iterator341.n()).done;) {
                  day = _step341.value;
                  _iterator342 = _createForOfIteratorHelper(day.BookingDayServices);
                  try {
                    for (_iterator342.s(); !(_step342 = _iterator342.n()).done;) {
                      s = _step342.value;
                      for (_baseId26 in s.Quote.QuoteList.bases) {
                        if (s.Quote && s.Quote.QuoteList) {
                          delete s.Quote.QuoteList[_baseId26];
                          tools.removeFieldByName(s.Quote.QuoteList.fields, _baseId26);
                          s.Quote.QuoteList.getFields();
                        }
                      }
                    }
                  } catch (err) {
                    _iterator342.e(err);
                  } finally {
                    _iterator342.f();
                  }
                  if (day.BookingDayHotels[0] && day.BookingDayHotels[0].BookingDayRooms) {
                    _iterator343 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms);
                    try {
                      for (_iterator343.s(); !(_step343 = _iterator343.n()).done;) {
                        room = _step343.value;
                        for (_baseId25 in room.QuoteList) {
                          if (room.QuoteList[_baseId25]) {
                            delete room.QuoteList[_baseId25];
                            tools.removeFieldByName(room.QuoteList.fields, _baseId25);
                            room.QuoteList.getFields();
                          }
                        }
                      }
                    } catch (err) {
                      _iterator343.e(err);
                    } finally {
                      _iterator343.f();
                    }
                  }
                }
              } catch (err) {
                _iterator341.e(err);
              } finally {
                _iterator341.f();
              }
              return _context90.abrupt("return", booking);
            case 25:
            case "end":
              return _context90.stop();
          }
        }, _callee84, this);
      }));
      function createBookingFromTemplate(_x143) {
        return _createBookingFromTemplate.apply(this, arguments);
      }
      return createBookingFromTemplate;
    }()
  }, {
    key: "createCatalogueFromTemplate",
    value: function () {
      var _createCatalogueFromTemplate = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee85(template) {
        var booking;
        return regenerator_default().wrap(function _callee85$(_context91) {
          while (1) switch (_context91.prev = _context91.next) {
            case 0:
              _context91.next = 2;
              return this.createBookingFromTemplate(template);
            case 2:
              booking = _context91.sent;
              booking.TemplateType = 'CATALOGUE';
              booking.Status = 'CATALOGUE';
              booking.endpoint = '/api/catalogue/';
              booking.tableName = 'catalogue';
              booking.SalesUserId = null;
              booking.SalesOriginId = null;
              booking.PaxLeadId = null;
              booking.CatalogueCode = null;
              booking.BlockedDate = null;
              return _context91.abrupt("return", booking);
            case 13:
            case "end":
              return _context91.stop();
          }
        }, _callee85, this);
      }));
      function createCatalogueFromTemplate(_x144) {
        return _createCatalogueFromTemplate.apply(this, arguments);
      }
      return createCatalogueFromTemplate;
    }()
  }, {
    key: "createTemplateFromBooking",
    value: function () {
      var _createTemplateFromBooking = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee86(record) {
        var model, booking, baseId, _iterator344, _step344, day, _iterator345, _step345, s, _baseId28, _iterator346, _step346, room, _baseId27;
        return regenerator_default().wrap(function _callee86$(_context92) {
          while (1) switch (_context92.prev = _context92.next) {
            case 0:
              _context92.next = 2;
              return api.importMixinModule('booking', 'model');
            case 2:
              model = _context92.sent;
              _context92.next = 5;
              return new model({
                isTemplate: true
              });
            case 5:
              booking = _context92.sent;
              booking._recordLoaded = true;
              booking.TemplateType = "PRIVATE";
              booking.LanguageId = record.LanguageId;
              booking.Title = record.Title;
              booking.ImageId = record.ImageId;
              booking.Summary = record.Summary;
              booking.NotInclude = record.NotInclude;
              booking.Include = record.Include;
              booking.Notes = record.Notes;
              _context92.t0 = regenerator_default().keys(record.BaseQuotes.bases);
            case 16:
              if ((_context92.t1 = _context92.t0()).done) {
                _context92.next = 22;
                break;
              }
              baseId = _context92.t1.value;
              _context92.next = 20;
              return record.removeBase(baseId);
            case 20:
              _context92.next = 16;
              break;
            case 22:
              _context92.next = 24;
              return booking.addTemplate([record]);
            case 24:
              _iterator344 = _createForOfIteratorHelper(booking.BookingDays);
              try {
                for (_iterator344.s(); !(_step344 = _iterator344.n()).done;) {
                  day = _step344.value;
                  _iterator345 = _createForOfIteratorHelper(day.BookingDayServices);
                  try {
                    for (_iterator345.s(); !(_step345 = _iterator345.n()).done;) {
                      s = _step345.value;
                      s.CreatedUTC = null;
                      s.CreatedUserId = null;
                      s.id = null;
                      s.BookingDayId = null;
                      s.Status = 'PENDING';
                      s.VoucherDisabled = null;
                      s.VoucherText = null;
                      s.ReservationNumber = null;
                      s.tempId = (0,v1/* default */.A)();
                      for (_baseId28 in s.Quote.QuoteList.bases) {
                        if (s.Quote && s.Quote.QuoteList) {
                          delete s.Quote.QuoteList[_baseId28];
                          tools.removeFieldByName(s.Quote.QuoteList.fields, _baseId28);
                          s.Quote.QuoteList.getFields();
                        }
                      }
                    }
                  } catch (err) {
                    _iterator345.e(err);
                  } finally {
                    _iterator345.f();
                  }
                  if (day.BookingDayHotels[0] && day.BookingDayHotels[0].BookingDayRooms) {
                    _iterator346 = _createForOfIteratorHelper(day.BookingDayHotels[0].BookingDayRooms);
                    try {
                      for (_iterator346.s(); !(_step346 = _iterator346.n()).done;) {
                        room = _step346.value;
                        room.tempId = (0,v1/* default */.A)();
                        room.CreatedUTC = null;
                        room.CreatedUserId = null;
                        room.id = null;
                        room.tempId = (0,v1/* default */.A)();
                        room.BookingDayHotelId = null;
                        room.ReservationNumber = null;
                        room.Status = 'PENDING';
                        for (_baseId27 in room.QuoteList) {
                          if (room.QuoteList[_baseId27]) {
                            delete room.QuoteList[_baseId27];
                            tools.removeFieldByName(room.QuoteList.fields, _baseId27);
                            room.QuoteList.getFields();
                          }
                        }
                      }
                    } catch (err) {
                      _iterator346.e(err);
                    } finally {
                      _iterator346.f();
                    }
                  }
                }
              } catch (err) {
                _iterator344.e(err);
              } finally {
                _iterator344.f();
              }
              return _context92.abrupt("return", booking);
            case 27:
            case "end":
              return _context92.stop();
          }
        }, _callee86);
      }));
      function createTemplateFromBooking(_x145) {
        return _createTemplateFromBooking.apply(this, arguments);
      }
      return createTemplateFromBooking;
    }()
  }, {
    key: "clone",
    value: function () {
      var _clone = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee87(_ref14) {
        var isTemplate, isOper, record, cloneFlights, b, _iterator347, _step347, day, _iterator350, _step350, service, _iterator351, _step351, hotel, _iterator352, _step352, room, _iterator348, _step348, flight, _iterator349, _step349, opt;
        return regenerator_default().wrap(function _callee87$(_context93) {
          while (1) switch (_context93.prev = _context93.next) {
            case 0:
              isTemplate = _ref14.isTemplate, isOper = _ref14.isOper, record = _ref14.record, cloneFlights = _ref14.cloneFlights;
              _context93.next = 3;
              return _superPropGet(Booking, "clone", this, 2)([{
                record: record
              }]);
            case 3:
              b = _context93.sent;
              b.id = null;
              _iterator347 = _createForOfIteratorHelper(b.BookingDays);
              try {
                for (_iterator347.s(); !(_step347 = _iterator347.n()).done;) {
                  day = _step347.value;
                  day.id = null;
                  day.BookingId = null;
                  _iterator350 = _createForOfIteratorHelper(day.BookingDayServices);
                  try {
                    for (_iterator350.s(); !(_step350 = _iterator350.n()).done;) {
                      service = _step350.value;
                      service.CreatedUTC = null;
                      service.CreatedUserId = null;
                      service.id = null;
                      service.BookingDayId = null;
                      service.Status = 'PENDING';
                      service.VoucherDisabled = null;
                      service.VoucherText = null;
                      service.ReservationNumber = null;
                      service.PickupInfo = null;
                      service.tempId = (0,v1/* default */.A)();
                      service.PickupInfo = null;
                    }
                  } catch (err) {
                    _iterator350.e(err);
                  } finally {
                    _iterator350.f();
                  }
                  _iterator351 = _createForOfIteratorHelper(day.BookingDayHotels);
                  try {
                    for (_iterator351.s(); !(_step351 = _iterator351.n()).done;) {
                      hotel = _step351.value;
                      hotel.CreatedUTC = null;
                      hotel.CreatedUserId = null;
                      hotel.id = null;
                      hotel.BookingDayId = null;
                      _iterator352 = _createForOfIteratorHelper(hotel.BookingDayRooms);
                      try {
                        for (_iterator352.s(); !(_step352 = _iterator352.n()).done;) {
                          room = _step352.value;
                          room.CreatedUTC = null;
                          room.CreatedUserId = null;
                          room.id = null;
                          room.tempId = (0,v1/* default */.A)();
                          room.BookingDayHotelId = null;
                          room.ReservationNumber = null;
                          room.Status = 'PENDING';
                        }
                      } catch (err) {
                        _iterator352.e(err);
                      } finally {
                        _iterator352.f();
                      }
                    }
                  } catch (err) {
                    _iterator351.e(err);
                  } finally {
                    _iterator351.f();
                  }
                }
              } catch (err) {
                _iterator347.e(err);
              } finally {
                _iterator347.f();
              }
              if (!cloneFlights) {
                b.BookingFlights = [];
              } else {
                _iterator348 = _createForOfIteratorHelper(b.BookingFlights);
                try {
                  for (_iterator348.s(); !(_step348 = _iterator348.n()).done;) {
                    flight = _step348.value;
                    flight.CreatedUTC = null;
                    flight.CreatedUserId = null;
                    flight.id = null;
                    flight.BookingId = null;
                    flight.tempId = (0,v1/* default */.A)();
                    flight.Status = 'PENDING';
                  }
                } catch (err) {
                  _iterator348.e(err);
                } finally {
                  _iterator348.f();
                }
              }
              _iterator349 = _createForOfIteratorHelper(b.BookingOptionalServices);
              try {
                for (_iterator349.s(); !(_step349 = _iterator349.n()).done;) {
                  opt = _step349.value;
                  opt.CreatedUTC = null;
                  opt.CreatedUserId = null;
                  opt.id = null;
                  opt.BookingId = null;
                }
              } catch (err) {
                _iterator349.e(err);
              } finally {
                _iterator349.f();
              }
              b.BookingExpenses = [];
              b.PaxName = null;
              b.EmergencyContacts = null;
              if (!isTemplate) b.Status = 'QUOTE';
              //b.CurrencyRates = {};
              b.Hash = null;
              b.BookingFormId = null;
              b.PaxEmail = null;
              b.Documentation = {};
              b.ProfitSummary = {};
              b.BookingNotes = [];
              b.BookingUserShares = [];
              b.ConfirmedDate = null;
              b.VoucherComments = {};
              b.ServiceStatus = null;
              b.HotelStatus = null;
              b.setCurrencyRates();
              /*for (let r in this.CurrencyRates) {
                  await this.setCurrencyRateToServices({rate: r.Rate, currencyId: null});
              }*/
              //api.setPayments();
              b.setPayments();
              //api.setReceipts();
              b.setReceipts();
              api.setSupplierCredits();
              api.hotelCost = {};
              return _context93.abrupt("return", b);
            case 31:
            case "end":
              return _context93.stop();
          }
        }, _callee87, this);
      }));
      function clone(_x146) {
        return _clone.apply(this, arguments);
      }
      return clone;
    }()
  }, {
    key: "cloneAll",
    value: function () {
      var _cloneAll = (0,asyncToGenerator/* default */.A)(/*#__PURE__*/regenerator_default().mark(function _callee88(_ref15) {
        var record, fields;
        return regenerator_default().wrap(function _callee88$(_context94) {
          while (1) switch (_context94.prev = _context94.next) {
            case 0:
              record = _ref15.record, fields = _ref15.fields;
              _context94.next = 3;
              return _superPropGet(Booking, "clone", this, 2)([{
                record: _.cloneDeep(record)
              }]);
            case 3:
              return _context94.abrupt("return", _context94.sent);
            case 4:
            case "end":
              return _context94.stop();
          }
        }, _callee88, this);
      }));
      function cloneAll(_x147) {
        return _cloneAll.apply(this, arguments);
      }
      return cloneAll;
    }()
  }]);
}(record["default"]);
(0,defineProperty/* default */.A)(Booking, "moduleName", 'booking');
(0,defineProperty/* default */.A)(Booking, "tableName", 'booking');
(0,defineProperty/* default */.A)(Booking, "endpoint", '/api/booking/');
(0,defineProperty/* default */.A)(Booking, "swapQuoteBy", true);
(0,defineProperty/* default */.A)(Booking, "backMethods", {
  "getPaxTypesByBase": {
    name: "getPaxTypesByBase",
    params: [{
      name: 'baseId',
      getter: 'bases',
      type: 'object'
    }]
  }
});
(0,defineProperty/* default */.A)(Booking, "backGetters", {
  "finalTotal": "finalTotal",
  "finalTotalWithFlights": "final_total_with_flights",
  "finalTotalFlights": "finalTotalFlight",
  "totals": "totals",
  "finalTotalFlightsNotIncluded": "finalTotalFlightsNotIncluded",
  "totalsServices": "totalsServices",
  "totalsHotels": "totalsHotels",
  "totalsByHotelByRoom": "totalsByHotelByRoom",
  "totalFlightsIncluded": "totalFlightsIncluded",
  "totalFlightsNotIncludedByGroup": "totalFlightsNotIncludedByGroup",
  "totalPaxExpenses": "totalPaxExpenses",
  "totalReceiptsInSalesCurrency": "totalReceiptsInSalesCurrency",
  "finalIncomes": "final_incomes",
  "paxQuantity": "pax_quantity",
  "hotelsByDay": "hotels_by_day",
  //"QuoteGroups": "quote_groups",
  "totalExpenses": "totalExpenses",
  "finalCost": "finalCost",
  "flightsNotIncludedByGroup": "flightsNotIncludedByGroup",
  "totalFlightBySuppliers": "totalFlightBySuppliers",
  //'get_by_date': 'get_by_date_std',
  'summaryTotalsFlights': 'summaryTotalsFlights',
  'totalByGroup': 'total_by_group',
  'totalByPaxGroup': 'total_by_pax_group',
  'supplierSummary': 'supplierSummary',
  'quoted': 'quoted',
  'totalByPaxVariant': 'total_by_pax_variant'
  //'suppliers': 'suppliers',
  //'hotels': 'hotels',
});
/* harmony default export */ const booking = (Booking);

/***/ }),

/***/ 14256:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const loader = __webpack_require__(88974);

module.exports = loader.default;
module.exports.raw = loader.raw;

/***/ }),

/***/ 14257:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).



var ERR_STREAM_PREMATURE_CLOSE = (__webpack_require__(12463)/* .codes */ .F).ERR_STREAM_PREMATURE_CLOSE;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    callback.apply(this, args);
  };
}
function noop() {}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;
  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };
  var writableEnded = stream._writableState && stream._writableState.finished;
  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };
  var readableEnded = stream._readableState && stream._readableState.endEmitted;
  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };
  var onerror = function onerror(err) {
    callback.call(stream, err);
  };
  var onclose = function onclose() {
    var err;
    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };
  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };
  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }
  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}
module.exports = eos;

/***/ }),

/***/ 14278:
/***/ ((module) => {

"use strict";

module.exports = function generate_comment(it, $keyword, $ruleType) {
  var out = ' ';
  var $schema = it.schema[$keyword];
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $comment = it.util.toQuotedString($schema);
  if (it.opts.$comment === true) {
    out += ' console.log(' + ($comment) + ');';
  } else if (typeof it.opts.$comment == 'function') {
    out += ' self._opts.$comment(' + ($comment) + ', ' + (it.util.toQuotedString($errSchemaPath)) + ', validate.root.schema);';
  }
  return out;
}


/***/ }),

/***/ 14599:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_record__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55539);









function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var SupplierCredit = /*#__PURE__*/function (_Record) {
  function SupplierCredit() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, SupplierCredit);
    return _callSuper(this, SupplierCredit, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(SupplierCredit, _Record);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(SupplierCredit, [{
    key: "setCurrencyRate",
    value: function () {
      var _setCurrencyRate = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var _this = this;
        var currencyconversion, cc, rate, _cc;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return api.getTable('currencyconversion');
            case 2:
              currencyconversion = _context.sent;
              cc = _.find(currencyconversion, function (r) {
                if (r.FromCurrencyId == _this.FromCurrencyId && r.ToCurrencyId == _this.ToCurrencyId) return true;
                if (r.FromCurrencyId == _this.ToCurrencyId && r.ToCurrencyId == _this.FromCurrencyId) return true;
              });
              if (cc) {
                _context.next = 9;
                break;
              }
              cc = _.find(currencyconversion, function (r) {
                if (r.FromCurrencyId == _this.FromCurrencyId) return true;
              });
              if (cc) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return");
            case 8:
              this.ToCurrencyId = cc.ToCurrencyId;
            case 9:
              if (cc) {
                _context.next = 11;
                break;
              }
              return _context.abrupt("return");
            case 11:
              _context.next = 13;
              return travelTools.getCurrencyRate(cc, 'purchase');
            case 13:
              rate = _context.sent;
              if (rate) {
                this.FromCurrencyId = rate.FromCurrencyId;
                this.ToCurrencyId = rate.ToCurrencyId;
                this.CurrencyRate = rate.ConversionRate;
              }
              if (!this.CurrencyRate) {
                _cc = _.find(api.CurrencyRates, function (r) {
                  return r.FromCurrencyId == _this.FromCurrencyId && r.ToCurrencyId == _this.ToCurrencyId;
                });
                if (_cc) {
                  this.CurrencyRate = _cc.Rate;
                }
              }
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function setCurrencyRate() {
        return _setCurrencyRate.apply(this, arguments);
      }
      return setCurrencyRate;
    }()
  }, {
    key: "afterEdit",
    value: function afterEdit() {
      return {
        CurrencyId: function () {
          var _CurrencyId = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(record) {
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(record.CurrencyId && record.Currency)) {
                    _context2.next = 5;
                    break;
                  }
                  if (record.Currency.Operation == 'DIVIDE') {
                    record.ToCurrencyId = record.CurrencyId;
                    record.FromCurrencyId = record.Currency.CurrencyConvertId;
                  }
                  if (record.Currency.Operation == 'MULTIPLY') {
                    record.FromCurrencyId = record.CurrencyId;
                    record.ToCurrencyId = record.Currency.CurrencyConvertId;
                  }
                  _context2.next = 5;
                  return record.setCurrencyRate();
                case 5:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          function CurrencyId(_x) {
            return _CurrencyId.apply(this, arguments);
          }
          return CurrencyId;
        }()
      };
    }
  }, {
    key: "titleName",
    get: function get() {
      if (this.id) return "".concat(tr('Credit'), " ").concat(this.id);
      return tr('Credit');
    }
  }, {
    key: "getAmount",
    get: function get() {
      return -this.Amount;
    }
  }, {
    key: "getCurrencyRate",
    get: function get() {
      return this.CurrencyRate;
    }
  }, {
    key: "checkFields",
    value: function () {
      var _checkFields = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _superPropGet(SupplierCredit, "checkFields", this, 3)([]);
            case 2:
              return _context3.abrupt("return", _context3.sent);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function checkFields() {
        return _checkFields.apply(this, arguments);
      }
      return checkFields;
    }()
  }, {
    key: "PaymentStatus",
    get: function get() {
      return 'ON_ACCOUNT';
    }
  }, {
    key: "PaymentAmount",
    get: function get() {
      return -this.Amount;
    }
  }, {
    key: "PaymentCurrencyId",
    get: function get() {
      return this.CurrencyId;
    }
  }]);
}(_base_model_record__WEBPACK_IMPORTED_MODULE_4__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(SupplierCredit, "moduleName", 'suppliercredit');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SupplierCredit);

/***/ }),

/***/ 14910:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__(48287)["Buffer"];
var BN = __webpack_require__(66473);
var MillerRabin = __webpack_require__(52244);
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__(4934);
var randomBytes = __webpack_require__(53209);
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}


/***/ }),

/***/ 15003:
/***/ ((module, exports, __webpack_require__) => {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(48287)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 15037:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = __webpack_require__(73776);
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}


/***/ }),

/***/ 15340:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 15361:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ _inherits)
});

;// ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

;// ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}


/***/ }),

/***/ 15380:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__(48287)["Buffer"];
var generatePrime = __webpack_require__(4934)
var primes = __webpack_require__(23241)

var DH = __webpack_require__(14910)

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman


/***/ }),

/***/ 15575:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8818);









function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var SupplierView = /*#__PURE__*/function (_View) {
  function SupplierView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, SupplierView);
    return _callSuper(this, SupplierView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(SupplierView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(SupplierView, null, [{
    key: "options",
    value: function options() {
      return {
        fieldsOrder: ['Name', 'Address', 'Phone', 'Email', 'CompanyName'],
        fieldsAbmList: ['Name', 'Address', 'Phone', 'Email', 'CompanyName'],
        extraFields: [{
          name: 'AttachTab',
          editor: 'tab',
          label: 'Attachments',
          hideFromList: true,
          icon: 'paperclip',
          fields: [{
            name: 'Attach',
            label: 'Attachments',
            editor: 'attach',
            columns: 12
          }]
        }],
        fieldsDataReplace: {
          SupplierDescriptions: {
            component: 'languages-comp',
            editor: 'component',
            textStyle: true,
            icon: 'font',
            tableName: 'supplierdescription',
            rowFields: [{
              name: 'LanguageId',
              relation: 'language',
              optionLabels: 'Name',
              editor: 'select',
              setRelationTo: 'Language'
            }, {
              name: 'Description'
            }]
          },
          Comment: {
            name: 'CommentTab',
            editor: 'tab',
            label: 'Notes',
            icon: 'comment-dots',
            hideFromList: true,
            fields: [{
              name: 'Comment',
              editor: 'text-area',
              rows: 10,
              columns: 12
            }]
          },
          Commision: {
            name: 'Commision',
            label: '% Commission',
            editor: 'number',
            hideFromList: true,
            readonlyIf: function readonlyIf(record) {
              return !record.CommisionPrice;
            }
          }
        },
        title: 'Suppliers',
        serverSide: true,
        canAdd: true
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res, addresses;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(SupplierView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              res = _context.sent;
              addresses = _.find(res.fields, function (r) {
                return r.name == 'SupplierAddresses';
              });
              if (addresses) addresses.icon = 'map-marked-alt';
              return _context.abrupt("return", res);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_4__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(SupplierView, "table", 'supplier');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SupplierView);

/***/ }),

/***/ 15579:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

/***/ }),

/***/ 15622:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(48287).Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


/***/ }),

/***/ 15867:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort:
            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
                '_'
            ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


/***/ }),

/***/ 16618:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative:
                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                        '_'
                    ),
                accusative:
                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                        '_'
                    ),
                genitive:
                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                        '_'
                    ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
              ? 'genitive'
              : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone:
                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                    '_'
                ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uk;

})));


/***/ }),

/***/ 16708:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(65606);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(33225);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(__webpack_require__(15622));
util.inherits = __webpack_require__(56698);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(94643)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(40345);
/*</replacement>*/

/*<replacement>*/

var Buffer = (__webpack_require__(34106).Buffer);
var OurUint8Array = (typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(75896);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(25382);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(25382);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};

/***/ }),

/***/ 16740:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8818);









function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var CityView = /*#__PURE__*/function (_View) {
  function CityView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, CityView);
    return _callSuper(this, CityView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(CityView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(CityView, null, [{
    key: "options",
    value:
    /*static getTableOptions () {
        return {
            canAdd: true,
            fields: [
                { name: 'Name', label: 'Name', required: true, columns: 2,},
                { name: 'Latitude', label: 'Latitude', required: true, editor: 'number', decimal: 2, columns: 2,},
                { name: 'Longitude', label: 'Longitude', required: true, editor: 'number', decimal: 2, columns: 2,},
                //{ name: 'ImageId', editor: 'photo-div', columns: 2, hideFromList: true, relation: 'image', setRelationTo: 'Image'},
                { name: 'MapHidden', editor: 'checkbox', label: 'Hide from Map', columns: 2},
                { name: 'CountryId', relation: 'country', optionLabels: 'Name', editor: 'select', setRelationTo: 'Country', label: 'Country'},
                { name: 'Closed', editor: 'checkbox', label: 'Archive', columns: 2, hideFromList: true, footerRow: true},
            ],
            title: 'Cities',
        }
    }*/

    function options() {
      return {
        fieldsOrder: ['Name', 'Latitude', 'Longitude', 'CountryId', 'MapHidden'],
        fieldsAbmList: ['Name', 'Latitude', 'Longitude', 'CountryId', 'MapHidden'],
        fieldsDataReplace: {},
        title: 'City',
        serverSide: false,
        canAdd: true
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(CityView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              res = _context.sent;
              return _context.abrupt("return", res);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_4__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(CityView, "table", 'city');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CityView);

/***/ }),

/***/ 17160:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone:
                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                    '_'
                ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays:
            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
                '_'
            ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


/***/ }),

/***/ 17357:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bnBd;

})));


/***/ }),

/***/ 17538:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays:
            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
                '_'
            ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),

/***/ 17730:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return esMx;

})));


/***/ }),

/***/ 18129:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51941);








function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingFlight = /*#__PURE__*/function (_BookingBaseModel) {
  function BookingFlight() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingFlight);
    return _callSuper(this, BookingFlight, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingFlight, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingFlight, [{
    key: "setOutput",
    value: function setOutput() {
      if (!this.Input) return;
      var lines = this.Input.split("\n");
      var text = "";
      var _iterator = _createForOfIteratorHelper(lines),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var line = _step.value;
          var flight = {};
          var info = line.replace("*", " ");
          info = info.replace("TK ", "TK").split(" ");
          var words = [];
          var _iterator2 = _createForOfIteratorHelper(info),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var w = _step2.value;
              if (w) {
                words.push(w);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          if (words[1] && words[2] && words[1].length == '2' && words[2].length == 3) {
            words[1] = words[1] + words[2];
            words.splice(2, 1);
          }
          if (words.length < 11) continue;
          flight.Flight = words[1];
          flight.Class = words[2];
          flight.DepartureDate = words[3];
          flight.DepartureStation = words[5].substring(0, 3);
          flight.ArrivalStation = words[5].substring(3, 6);
          flight.DepartureSTD = words[7].substring(0, 2) + ":" + words[7].substring(2, 4);
          flight.ArrivalSTD = words[8].substring(0, 2) + ":" + words[8].substring(2, 4);
          flight.ArrivalDate = words[9];
          flight.Cabin = words[10];
          text += this.flightNameLine(flight, words) + "\n";
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.Output = text;
    }
  }, {
    key: "flightNameLine",
    value: function flightNameLine(flight, words) {
      var stations = api.tables.station;
      flight.Flight = words[1];
      flight.Class = words[2];
      flight.DepartureDate = words[3];
      flight.DepartureStation = words[5].substring(0, 3);
      flight.ArrivalStation = words[5].substring(3, 6);
      flight.DepartureSTD = words[7].substring(0, 2) + ":" + words[7].substring(2, 4);
      flight.ArrivalSTD = words[8].substring(0, 2) + ":" + words[8].substring(2, 4);
      flight.ArrivalDate = words[9];
      flight.Cabin = words[10];
      var text = flight.Flight + " " + flight.DepartureDate + " " + this.getAirportName(flight.DepartureStation, stations) + " - " + this.getAirportName(flight.ArrivalStation, stations) + " " + flight.DepartureSTD + " " + flight.ArrivalSTD;
      return text;
    }
  }, {
    key: "getAirportName",
    value: function getAirportName(code, stations) {
      var c = _.find(stations, function (c) {
        return c.Code == code;
      });
      if (c) return c.Name;
      return code;
    }
  }, {
    key: "setCost",
    value: function setCost() {
      if (this.FlightCost && this.FlightPrice && !this.Markup) {
        this.$Markup.value = tools.getMarkup(this.FlightPrice, this.FlightCost);
      } else if (this.FlightCost && this.Markup) {
        this.$FlightPrice.value = tools.getPrice(this.FlightCost, this.Markup);
      }
      this.setBookingTotals();
    }
  }, {
    key: "setPrice",
    value: function setPrice() {
      this.$Markup.value = tools.getMarkup(this.FlightPrice, this.FlightCost);
      this.$MarkupModified.value = true;
      this.setBookingTotals();
    }
  }, {
    key: "setMarkup",
    value: function setMarkup() {
      this.$MarkupModified.value = true;
      var markup = 0;
      if (this.Markup) markup = this.Markup;
      this.$FlightPrice.value = tools.getPrice(this.FlightCost, markup);
      this.setBookingTotals();
    }
  }, {
    key: "afterEdit",
    value: function afterEdit() {
      return {
        Input: function () {
          var _Input = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(r) {
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return r.setOutput();
                case 2:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function Input(_x) {
            return _Input.apply(this, arguments);
          }
          return Input;
        }(),
        FlightCost: function FlightCost(r) {
          r.setCost();
        },
        FlightPrice: function FlightPrice(r) {
          r.setPrice();
        },
        Markup: function Markup(r) {
          r.setMarkup();
        },
        CurrencyId: function CurrencyId(r) {
          r.setCurrencyId();
        },
        Status: function Status(r) {
          r.setStatus();
        },
        QuoteType: function QuoteType(r) {
          r.setBookingTotals();
        },
        PricePer: function PricePer(r) {
          r.setBookingTotals();
        }
      };
    }
  }, {
    key: "setCurrencyId",
    value: function setCurrencyId() {
      this.setBookingTotals();
    }
  }, {
    key: "setStatus",
    value: function setStatus() {}
  }, {
    key: "booking",
    get: function get() {
      return this.$parent;
    }
  }, {
    key: "paxFlight",
    value: function paxFlight(baseId) {
      var pax;
      var groups = this.booking.QuoteGroups[baseId];
      if (this.booking.isGroup(baseId)) {
        pax = 0;
        for (var groupId in groups) {
          if (!this.QuoteList[baseId]) continue;
          if (!this.QuoteList[baseId].Groups[groupId]) continue;
          if (groups[groupId].ADT) pax += groups[groupId].ADT;
          if (groups[groupId].CHD) pax += groups[groupId].CHD;
          if (groups[groupId].TL) pax += groups[groupId].TL;
        }
      } else {
        pax = this.booking.BaseQuotes[baseId].paxQuantity;
      }
      return pax;
    }
  }, {
    key: "getFlightPrice",
    value: function getFlightPrice(baseId) {
      if (!this.FlightPrice) return this.FlightPrice;
      if (this.PricePer && this.PricePer == 'GROUP') {
        return parseFloat(this.FlightPrice) / this.paxQuantity(baseId);
      }
      return this.FlightPrice;
    }
  }, {
    key: "getFlightCost",
    value: function getFlightCost(baseId) {
      if (!this.FlightCost) return this.FlightCost;
      if (this.PricePer && this.PricePer == 'GROUP') {
        return parseFloat(this.FlightCost) / this.paxQuantity(baseId);
      }
      return this.FlightCost;
    }
  }, {
    key: "serviceFlight",
    value: function serviceFlight(viewMode) {
      if (viewMode == -1) return true;
      if (!this.QuoteList[viewMode]) return;
      if (this.QuoteList[viewMode] && this.QuoteList[viewMode].Include) {
        return true;
      }
    }
  }, {
    key: "flightRoute",
    get: function get() {
      if (this.Comment) return this.Comment;
      if (!this.Output) return '';
      var cities = [];
      try {
        var lines = this.Output.split('\n');
        var _iterator3 = _createForOfIteratorHelper(lines),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var line = _step3.value;
            var segments = line.split(' - ');
            if (segments.length == 0) continue;
            var words = segments[0].split(' ');
            if (words.length == 0) continue;
            words.splice(0, 1);
            words.splice(0, 1);
            var city1 = words.join(' ');
            if (city1 && cities.indexOf(city1) == -1) cities.push(city1);
            words = segments[1].split(' ');
            if (words.length == 0) continue;
            words.splice(words.length - 1, 1);
            words.splice(words.length - 1, 1);
            var city2 = words.join(' ');
            if (city2 && cities.indexOf(city2) == -1) cities.push(city2);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      } catch (err) {}
      if (cities.length == 0 && this.Output) return this.Output;
      return cities.join(' - ');
    }
  }, {
    key: "setBookingTotals",
    value: function setBookingTotals() {
      this.booking.setBookingTotals();
    }
  }, {
    key: "paxQuantity",
    value: function paxQuantity(id) {
      var res = 0;
      var _iterator4 = _createForOfIteratorHelper(this.booking.paxTypes),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var pType = _step4.value;
          for (var baseId in this.booking.BaseQuotes.bases) {
            var _this$booking, _this$booking$Totals$;
            if (id && id != baseId && this.booking.QuoteBy == 'QUANTITY') continue;
            if (!this.QuoteList) continue;
            if (!this.QuoteList[baseId] || !this.QuoteList[baseId].Include) continue;
            if (this.booking.QuoteBy != 'SERVICE' && !((_this$booking = this.booking) !== null && _this$booking !== void 0 && (_this$booking = _this$booking.Totals) !== null && _this$booking !== void 0 && (_this$booking = _this$booking[baseId]) !== null && _this$booking !== void 0 && (_this$booking = _this$booking[pType]) !== null && _this$booking !== void 0 && _this$booking.Selected)) continue;
            //if (this.booking.Totals[baseId] && this.booking.Totals[baseId][pType] && this.booking.Totals[baseId][pType].Selected) {
            var pax = this.booking.BaseQuotes[baseId][pType];
            if (this.booking.QuoteBy == 'PERSON' && (_this$booking$Totals$ = this.booking.Totals[baseId]) !== null && _this$booking$Totals$ !== void 0 && (_this$booking$Totals$ = _this$booking$Totals$[pType]) !== null && _this$booking$Totals$ !== void 0 && _this$booking$Totals$.Pax) pax = parseInt(this.booking.Totals[baseId][pType].Pax);
            res += pax;
            //}
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return res;
    }
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingFlight, "moduleName", 'bookingflight');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingFlight);

/***/ }),

/***/ 18377:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = __webpack_require__(52587)('Minimum');


/***/ }),

/***/ 18953:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_record__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55539);









function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var CashOut = /*#__PURE__*/function (_Record) {
  function CashOut() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, CashOut);
    return _callSuper(this, CashOut, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(CashOut, _Record);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(CashOut, [{
    key: "checkFields",
    value: function () {
      var _checkFields = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res, errors;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(CashOut, "checkFields", this, 3)([]);
            case 2:
              res = _context.sent;
              if (!res) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", res);
            case 5:
              this.invalid = {};
              errors = [];
              if (this.FromCurrencyId && this.FromCurrencyId != this.CurrencyId && this.ToCurrencyId != this.CurrencyId) {
                errors.push('Invalid Currency');
                this.invalid.CurrencyId = true;
              }
              if (!(errors.length > 0)) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return", errors);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function checkFields() {
        return _checkFields.apply(this, arguments);
      }
      return checkFields;
    }()
  }]);
}(_base_model_record__WEBPACK_IMPORTED_MODULE_4__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(CashOut, "moduleName", 'cashout');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CashOut);

/***/ }),

/***/ 19249:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8818);





function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var HotelQuoteView = /*#__PURE__*/function (_View) {
  function HotelQuoteView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, HotelQuoteView);
    return _callSuper(this, HotelQuoteView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(HotelQuoteView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(HotelQuoteView, null, [{
    key: "getTableOptions",
    value: function getTableOptions() {
      return {
        fields: [{
          name: 'Cost'
        },
        //costo de la habitación por noche
        {
          name: 'OriginCost'
        }, {
          name: 'SourceCost'
        }, {
          name: 'SourceRoomCost'
        }, {
          name: 'SourceCurrencyId'
        }, {
          name: 'Price'
        },
        //precio de la habitación por noche
        {
          name: 'RoomPax'
        },
        //cant. de pax por habitación
        {
          name: 'Pax'
        },
        //cant. de pax que toman el grupo de habitaciones
        {
          name: 'PersonCost'
        },
        //costo por persona = TotalCost / pax
        {
          name: 'PersonPrice'
        },
        //precio por persona = TotalPrice / pax
        {
          name: 'RoomPersonCost'
        },
        //costo estadía por pax = Cost * noches / RoomPax
        {
          name: 'RoomPersonPrice'
        },
        //precio estdía por persona = RoomPersonCost * (1 + mkp)
        {
          name: 'RoomCost'
        },
        //costo de la habitación
        {
          name: 'TotalCost'
        },
        //costo total, Cost * noches * cantidad de rooms
        {
          name: 'TotalPrice'
        },
        //precio total, Price * noches * cantidad de rooms
        {
          name: 'Rooms'
        },
        //cantidad de habitaciones
        {
          name: 'UnitCostBy'
        }, {
          name: 'PeriodCostBy'
        }, {
          name: 'Markup'
        }, {
          name: 'Groups'
        }, {
          name: 'Variants'
        }, {
          name: 'Include',
          defValue: true
        }, {
          name: 'Modified',
          defValue: false
        }, {
          name: 'MarkupModified',
          defValue: false
        }, {
          name: 'PriceModified',
          defValue: false
        }, {
          name: 'EstimatedCost',
          defValue: false
        }, {
          name: 'ValidTo'
        }]
      };
    }
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_2__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HotelQuoteView);

/***/ }),

/***/ 19318:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8818);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var SurveyView = /*#__PURE__*/function (_View) {
  function SurveyView() {
    _classCallCheck(this, SurveyView);
    return _callSuper(this, SurveyView, arguments);
  }
  _inherits(SurveyView, _View);
  return _createClass(SurveyView, null, [{
    key: "getTableOptions",
    value: function getTableOptions() {
      return {
        canAdd: true,
        allowContextMenu: true,
        fields: [{
          name: 'Name',
          required: true
        }, {
          name: 'SurveyType',
          label: 'Type',
          editor: 'select',
          options: [{
            value: 'PAX',
            label: 'Passenger'
          }, {
            value: 'AGENCY',
            label: 'Agency'
          }]
        }, {
          name: 'Intro',
          editor: 'text-area-style',
          columns: 12
        }, {
          name: 'Footer',
          editor: 'text-area-style',
          columns: 12
        }, {
          name: 'SurveyQuestions',
          editor: [],
          label: 'Questions',
          rowClass: 'surveyquestion',
          rowFields: [{
            name: 'Label',
            required: true,
            label: 'Question',
            columns: 6
          }, {
            name: 'QuestionType',
            label: 'Question Type',
            editor: 'select',
            columns: 2,
            options: [{
              value: 'TEXT',
              label: 'Text'
            }, {
              value: 'LIST',
              label: 'List'
            }, {
              value: 'OPTIONS',
              label: 'Options'
            }, {
              value: 'TABLE',
              label: 'Table'
            }]
          }, {
            name: 'OrderNr',
            editor: 'number',
            hidden: true,
            label: 'Order'
          }, {
            name: 'rowUp',
            editor: 'button',
            icon: 'arrow-up',
            action: 'rowUp',
            columns: 1,
            divRowClass: 'd-flex align-items-center justify-content-center'
          }, {
            name: 'rowDown',
            editor: 'button',
            action: 'rowDown',
            icon: 'arrow-down',
            columns: 1,
            divRowClass: 'd-flex align-items-center justify-content-center'
          }]
        }],
        title: 'Survey'
      };
    }
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_0__["default"]);
_defineProperty(SurveyView, "table", 'survey');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SurveyView);

/***/ }),

/***/ 19783:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_abm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51272);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var AbmBooking = /*#__PURE__*/function (_Abm) {
  function AbmBooking(_ref) {
    var _this;
    var options = _ref.options,
      endpoint = _ref.endpoint,
      template = _ref.template,
      sales = _ref.sales,
      table = _ref.table;
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, AbmBooking);
    _this = _callSuper(this, AbmBooking, [{
      table: table ? table : 'booking',
      options: options,
      endpoint: endpoint
    }]);
    var self = _this;
    return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(_this, (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var initPromise;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            initPromise = new Promise(function (resolve, reject) {
              resolve(self);
            });
            _context.next = 3;
            return initPromise;
          case 3:
            self = _context.sent;
            self.template = template;
            self.sales = sales;
            self.showDue = false;
            return _context.abrupt("return", self);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))());
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(AbmBooking, _Abm);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(AbmBooking, [{
    key: "getColumnsNames",
    value: function getColumnsNames() {
      var res = _superPropGet(AbmBooking, "getColumnsNames", this, 3)([]);
      if (this.template) {
        res.push('Quote');
        res.push('Edit');
      }
      return res;
    }
  }, {
    key: "getHeadings",
    value: function getHeadings() {
      var res = _superPropGet(AbmBooking, "getHeadings", this, 3)([]);
      if (this.template) {
        res['Quote'] = 'Create Quote';
        res['Edit'] = '';
      }
      return res;
    }
  }]);
}(_base_abm__WEBPACK_IMPORTED_MODULE_4__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AbmBooking);

/***/ }),

/***/ 19853:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8818);







function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingCurrencyRateView = /*#__PURE__*/function (_View) {
  function BookingCurrencyRateView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingCurrencyRateView);
    return _callSuper(this, BookingCurrencyRateView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingCurrencyRateView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingCurrencyRateView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", {
                fields: [{
                  name: 'Rate'
                }, {
                  name: 'FromCurrencyId',
                  relation: 'currency',
                  optionLabels: 'id',
                  editor: 'select'
                }, {
                  name: 'ToCurrencyId',
                  relation: 'currency',
                  optionLabels: 'id',
                  editor: 'select'
                }]
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_3__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingCurrencyRateView);

/***/ }),

/***/ 19958:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const Range = __webpack_require__(36097);
/** @typedef {import("../validate").Schema} Schema */

/**
 * @param {Schema} schema
 * @param {boolean} logic
 * @return {string[]}
 */


module.exports.stringHints = function stringHints(schema, logic) {
  const hints = [];
  let type = "string";
  const currentSchema = { ...schema
  };

  if (!logic) {
    const tmpLength = currentSchema.minLength;
    const tmpFormat = currentSchema.formatMinimum;
    const tmpExclusive = currentSchema.formatExclusiveMaximum;
    currentSchema.minLength = currentSchema.maxLength;
    currentSchema.maxLength = tmpLength;
    currentSchema.formatMinimum = currentSchema.formatMaximum;
    currentSchema.formatMaximum = tmpFormat;
    currentSchema.formatExclusiveMaximum = !currentSchema.formatExclusiveMinimum;
    currentSchema.formatExclusiveMinimum = !tmpExclusive;
  }

  if (typeof currentSchema.minLength === "number") {
    if (currentSchema.minLength === 1) {
      type = "non-empty string";
    } else {
      const length = Math.max(currentSchema.minLength - 1, 0);
      hints.push(`should be longer than ${length} character${length > 1 ? "s" : ""}`);
    }
  }

  if (typeof currentSchema.maxLength === "number") {
    if (currentSchema.maxLength === 0) {
      type = "empty string";
    } else {
      const length = currentSchema.maxLength + 1;
      hints.push(`should be shorter than ${length} character${length > 1 ? "s" : ""}`);
    }
  }

  if (currentSchema.pattern) {
    hints.push(`should${logic ? "" : " not"} match pattern ${JSON.stringify(currentSchema.pattern)}`);
  }

  if (currentSchema.format) {
    hints.push(`should${logic ? "" : " not"} match format ${JSON.stringify(currentSchema.format)}`);
  }

  if (currentSchema.formatMinimum) {
    hints.push(`should be ${currentSchema.formatExclusiveMinimum ? ">" : ">="} ${JSON.stringify(currentSchema.formatMinimum)}`);
  }

  if (currentSchema.formatMaximum) {
    hints.push(`should be ${currentSchema.formatExclusiveMaximum ? "<" : "<="} ${JSON.stringify(currentSchema.formatMaximum)}`);
  }

  return [type].concat(hints);
};
/**
 * @param {Schema} schema
 * @param {boolean} logic
 * @return {string[]}
 */


module.exports.numberHints = function numberHints(schema, logic) {
  const hints = [schema.type === "integer" ? "integer" : "number"];
  const range = new Range();

  if (typeof schema.minimum === "number") {
    range.left(schema.minimum);
  }

  if (typeof schema.exclusiveMinimum === "number") {
    range.left(schema.exclusiveMinimum, true);
  }

  if (typeof schema.maximum === "number") {
    range.right(schema.maximum);
  }

  if (typeof schema.exclusiveMaximum === "number") {
    range.right(schema.exclusiveMaximum, true);
  }

  const rangeFormat = range.format(logic);

  if (rangeFormat) {
    hints.push(rangeFormat);
  }

  if (typeof schema.multipleOf === "number") {
    hints.push(`should${logic ? "" : " not"} be multiple of ${schema.multipleOf}`);
  }

  return hints;
};

/***/ }),

/***/ 20002:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8818);








function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function roomTypesBookingForm() {
  var model = api.importMixinModule('bookingform', 'model');
  return model.roomTypesBookingForm();
}
var countriesJSON = __webpack_require__(48456)("./".concat(api.language, "/world.json"));

var BookingFormView = /*#__PURE__*/function (_View) {
  function BookingFormView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, BookingFormView);
    return _callSuper(this, BookingFormView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingFormView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(BookingFormView, null, [{
    key: "options",
    value: function options() {
      return {
        fieldsOrder: ['id', 'BookingId', 'PaxName', 'Phone', 'Mobile', 'Country', 'Address'],
        serverSide: true
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var res, id, pax, paxFieldsSort, _iterator, _step, field, bookingFormPaxFields, countryField, values, countriesList, _iterator2, _step2, row;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(BookingFormView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              res = _context.sent;
              id = _.find(res.fields, function (r) {
                return r.name == 'id';
              });
              if (id) {
                id.hidden = false;
              }
              ;
              pax = _.find(res.fields, function (r) {
                return r.name == 'BookingFormPaxs';
              });
              if (pax) pax.labelAlways = true;
              paxFieldsSort = ['FirstName', 'MiddleName', 'LastName', 'Email', 'BirthDate', 'Passport', 'PassportValidTo', 'PassportCountry', 'RoomType', 'Allergies', 'Medication', 'Dietary'];
              if (pax && pax.rowFields) {
                pax.rowFields.sort(function (a, b) {
                  var v1 = paxFieldsSort.indexOf(a.name);
                  if (v1 == -1) v1 = 100;
                  var v2 = paxFieldsSort.indexOf(b.name);
                  if (v2 == -1) v2 = 100;
                  return v1 - v2;
                });
                _iterator = _createForOfIteratorHelper(pax.rowFields);
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    field = _step.value;
                    field.columns = 2;
                    if (field.name == 'BirthDate') field.editor = 'date';
                    if (field.name == 'PassportValidTo') field.editor = 'date';
                    if (field.name == 'RoomType') field.options = roomTypesBookingForm();
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }
              res.fields.push({
                name: 'Attach',
                label: 'Attachments',
                editor: 'attach',
                columns: 12,
                hideFromList: true
              });
              bookingFormPaxFields = _.find(res.fields, function (r) {
                return r.name == 'BookingFormPaxs';
              });
              if (bookingFormPaxFields && bookingFormPaxFields.rowFields) {
                countryField = _.find(bookingFormPaxFields.rowFields, function (r) {
                  return r.name == 'PassportCountry';
                });
                values = {};
                countriesList = [];
                _iterator2 = _createForOfIteratorHelper(countriesJSON);
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    row = _step2.value;
                    values[row.alpha3] = row.name;
                    countriesList.push({
                      label: row.name,
                      value: row.alpha3
                    });
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
                countryField.editor = 'vue-select';
                countryField.options = countriesList;
              }
              /*res.fields.push({
                  name: 'ImportExcel',
                  label: 'Import Excel',
                  editor: 'component',
                  component: 'import-excel',
                  componentName: 'ImportExcel',
                  componentPath: 'components/tools',
                  columns: 12,
              })*/
              return _context.abrupt("return", res);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions(_x) {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_4__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingFormView);

/***/ }),

/***/ 20320:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var MD5 = __webpack_require__(88276)

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}


/***/ }),

/***/ 20407:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_model_base_model__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42675);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var SurveyQuestion = /*#__PURE__*/function (_BaseModel) {
  function SurveyQuestion() {
    _classCallCheck(this, SurveyQuestion);
    return _callSuper(this, SurveyQuestion, arguments);
  }
  _inherits(SurveyQuestion, _BaseModel);
  return _createClass(SurveyQuestion, [{
    key: "canEdit",
    get: function get() {
      if (!this.id) {
        return false;
      }
      return true;
    }
  }, {
    key: "afterEdit",
    value: function afterEdit() {
      var _this = this;
      return {
        OrderNr: function OrderNr(r, value) {
          _this.$parent.SurveyQuestions.sort(function (a, b) {
            return a.OrderNr - b.OrderNr;
          });
        }
      };
    }
  }, {
    key: "rowUp",
    value: function rowUp() {
      var _this2 = this;
      var v1 = this.OrderNr;
      var index = _.findIndex(this.$parent.SurveyQuestions, function (r) {
        return r.OrderNr == _this2.OrderNr;
      });
      var row = this.$parent.SurveyQuestions[index - 1];
      if (!row) return;
      var v2 = row.OrderNr;
      this.$OrderNr.value = v2;
      row.$OrderNr.value = v1;
      this.$parent.SurveyQuestions.sort(function (a, b) {
        return a.OrderNr - b.OrderNr;
      });
    }
  }, {
    key: "rowDown",
    value: function rowDown() {
      var _this3 = this;
      var v1 = this.OrderNr;
      var index = _.findIndex(this.$parent.SurveyQuestions, function (r) {
        return r.OrderNr == _this3.OrderNr;
      });
      var row = this.$parent.SurveyQuestions[index + 1];
      if (!row) return;
      var v2 = row.OrderNr;
      this.$OrderNr.value = v2;
      row.$OrderNr.value = v1;
      this.$parent.SurveyQuestions.sort(function (a, b) {
        return a.OrderNr - b.OrderNr;
      });
    }
  }]);
}(_base_model_base_model__WEBPACK_IMPORTED_MODULE_0__["default"]);
_defineProperty(SurveyQuestion, "moduleName", 'surveyquestion');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SurveyQuestion);

/***/ }),

/***/ 20505:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51941);







function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingTotalList = /*#__PURE__*/function (_BookingBaseModel) {
  function BookingTotalList(obj) {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingTotalList);
    if (!obj.fields) obj.fields = [];
    if (obj.record) {
      tools.clean(obj.record);
      if (obj.record) {
        for (var key in obj.record) {
          if (isNaN(parseInt(key))) continue;
          obj.fields.push({
            name: key,
            editor: {},
            objectClass: 'bookingtotal',
            fields: []
          });
        }
      }
    }
    return _callSuper(this, BookingTotalList, [obj]);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingTotalList, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingTotalList, [{
    key: "bases",
    get: function get() {
      return tools.getBases(_.cloneDeep(this));
    }
  }, {
    key: "getFields",
    value: function getFields() {
      var res = [];
      for (var key in this.bases) {
        res.push({
          name: key,
          editor: {},
          objectClass: 'servicequote'
        });
      }
      this.fields = res;
    }
  }, {
    key: "newBookingTotal",
    value: function () {
      var _newBookingTotal = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(base, obj) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.newRow({
                rowClass: 'bookingtotal'
              }, obj, base);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function newBookingTotal(_x, _x2) {
        return _newBookingTotal.apply(this, arguments);
      }
      return newBookingTotal;
    }()
  }, {
    key: "booking",
    get: function get() {
      return this.$parent;
    }
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingTotalList);

/***/ }),

/***/ 20660:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51941);








function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var HotelQuote = /*#__PURE__*/function (_BookingBaseModel) {
  function HotelQuote(obj) {
    var _this;
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, HotelQuote);
    _this = _callSuper(this, HotelQuote, [obj]);
    var self = _this;
    return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(_this, (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var hotelQuote, costNull;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return new Promise(function (resolve, reject) {
              resolve(self);
            });
          case 2:
            hotelQuote = _context.sent;
            costNull = tools.isNull(hotelQuote.Cost);
            if (!api.allowZeroHotel && hotelQuote.Cost == 0) hotelQuote.invalid.Cost = true;
            if (costNull) hotelQuote.invalid.Cost = true;
            return _context.abrupt("return", hotelQuote);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))());
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(HotelQuote, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(HotelQuote, [{
    key: "bookingDayHotel",
    get: function get() {
      return this.$parent.$parent.$parent;
    }
  }, {
    key: "setValue",
    value: function () {
      var _setValue = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(_ref2) {
        var fieldName, value;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              fieldName = _ref2.fieldName, value = _ref2.value;
              _context2.next = 3;
              return _superPropGet(HotelQuote, "setValue", this, 3)([{
                fieldName: fieldName,
                value: value
              }]);
            case 3:
              if (this._loaded && this.bookingDayHotel && this.bookingDayHotel._cache) {
                this.bookingDayHotel._cache.roomsCapacity = false;
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function setValue(_x) {
        return _setValue.apply(this, arguments);
      }
      return setValue;
    }()
  }, {
    key: "afterEditRow",
    value: function () {
      var _afterEditRow = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(field) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this._loaded && this.bookingDayHotel && this.bookingDayHotel._cache) {
                this.bookingDayHotel._cache.roomsCapacity = false;
              }
              _context3.next = 3;
              return _superPropGet(HotelQuote, "afterEditRow", this, 3)([field]);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function afterEditRow(_x2) {
        return _afterEditRow.apply(this, arguments);
      }
      return afterEditRow;
    }()
  }, {
    key: "booking",
    get: function get() {
      return this.$parent.$parent.$parent.$parent.$parent;
    }
  }, {
    key: "setPriceByCost",
    value: function setPriceByCost(modified) {
      /*if (!this.PriceModified) {
          this.$Price.value = tools.getPrice(this.Cost, markup)
      } else {
          this.$Markup.value  = tools.getMarkup(this.Price, this.Cost);
      }*/
      if (modified) this.EstimatedCost = null;
      var costNull = tools.isNull(this.Cost);
      if (!costNull) {
        if (!this.PriceModified) {
          this.$Price.value = tools.getPrice(this.Cost, this.markup);
          if (this.UnitCostBy == 'PERSON') {
            this.$PersonPrice.value = tools.getPrice(this.PersonCost, this.markup);
          }
        } else {
          this.$Markup.value = tools.getMarkup(this.Price, this.Cost);
        }
      } else {
        this.$Price.value = null;
        this.Modified = false;
        this.PriceModified = false;
      }
      if (!this.SourceCost) this.$SourceCost.value = null;
      this.invalid.Cost = false;
      if (costNull) this.invalid.Cost = true;
      if (!api.allowZeroHotel && this.Cost == 0) this.invalid.Cost = true;
      if (modified && !costNull) this.setValues();
      this.setTotals();
      this.setBookingTotals();
    }
  }, {
    key: "setValues",
    value: function setValues() {
      this.$Modified.value = true;
      var costNull = tools.isNull(this.Cost);
      if (!costNull) {
        if (this.booking.QuoteBy == 'SERVICE') {
          this.$RoomCost.value = this.Cost;
        } else {
          this.$RoomCost.value = parseFloat(this.Cost) * this.factor / (parseInt(this.bookingDayHotel.Days) * this.qFactor);
        }
      } else {
        this.$RoomCost.value = null;
      }
      this.$SourceRoomCost.value = this.RoomCost;
      this.$SourceCost.value = this.Cost;
      this.$SourceCurrencyId.value = this.booking.CurrencyId;
      //if (!api.allowZeroHotel && this.Cost==0) costNull = true;
      if (costNull) {
        this.$Modified.value = false;
        this.invalid.Cost = true;
      } else {
        this.invalid.Cost = false;
      }
      if (!api.allowZeroHotel && this.Cost == 0) {
        this.$Modified.value = false;
        this.invalid.Cost = true;
      } else {
        this.invalid.Cost = false;
      }
    }
  }, {
    key: "setBookingTotals",
    value: function setBookingTotals() {
      this.clearBookingCache();
      this.booking.setBookingTotals(this.baseId);
    }
  }, {
    key: "setTotals",
    value: function setTotals(tt) {
      if (this.booking.QuoteBy == 'QUANTITY') {
        var rooms = this.Rooms;
        if (!rooms) rooms = this.$parent.$parent.Rooms;
        var n = this.bookingDayHotel.Days;
        if (this.PeriodCostBy == 'PROGRAM') n = 1;
        this.TotalCost = this.Cost * rooms * n;
        this.TotalPrice = this.Price * rooms * n;
      }
      if (this.booking.QuoteBy == 'SERVICE') {
        var _rooms = this.Rooms;
        if (!_rooms) _rooms = this.$parent.$parent.Rooms;
        var cost = this.Cost;
        var price = this.Price;
        if (this.UnitCostBy == 'ROOM') {
          cost = cost * _rooms;
          price = price * _rooms;
        }
        ;
        if (this.UnitCostBy == 'PERSON') {
          cost = cost * this.Pax;
          price = price * this.Pax;
        }
        ;
        if (this.PeriodCostBy == 'NIGHT') {
          cost = cost * this.days;
          price = price * this.days;
        }
        ;
        this.$TotalCost.value = cost;
        this.$TotalPrice.value = price;
        if (this.UnitCostBy != 'PERSON') {
          this.setPersonValues();
        }
        if (this.UnitCostBy == 'PERSON') {
          this.$PersonPrice.value = this.TotalPrice / this.Pax;
          this.$PersonCost.value = this.TotalCost / this.Pax;
          this.setRoomPersonValues();
        }
      }
      this.setBookingTotals();
    }
  }, {
    key: "setPersonValues",
    value: function setPersonValues() {
      if (this.UnitCostBy == 'PERSON') {
        this.$PersonPrice.value = tools.getPrice(this.PersonCost, this.markup);
        this.setTotals();
      } else {
        this.$PersonPrice.value = this.TotalPrice / this.Pax;
        this.$PersonCost.value = this.TotalCost / this.Pax;
        this.setRoomPersonValues();
      }
    }
  }, {
    key: "markup",
    get: function get() {
      if (this.markupNull) return this.booking.Markup;
      return this.Markup;
    }
  }, {
    key: "setRoomPersonValues",
    value: function setRoomPersonValues() {
      if (!this.RoomPax) {
        this.$RoomPax.value = this.room.Pax;
      }
      this.$RoomPersonCost.value = this.Cost * this.days / this.RoomPax;
      this.$RoomPersonPrice.value = this.Price * this.days / this.RoomPax;
    }
  }, {
    key: "quoteBy",
    get: function get() {
      return this.booking.QuoteBy;
    }
  }, {
    key: "markupNull",
    get: function get() {
      return tools.isNull(this.Markup);
    }
  }, {
    key: "setMarkup",
    value: function setMarkup() {
      this.$MarkupModified.value = false;
      if (!this.markupNull) this.$MarkupModified.value = true;
      if (this.Modified && this.MarkupModified) this.PriceModified = false;
      this.setPriceByCost();
      this.setBookingTotals();
    }
  }, {
    key: "setMarkupByPrice",
    value: function setMarkupByPrice() {
      var costNull = tools.isNull(this.Cost);
      if (!costNull) {
        this.$Markup.value = tools.getMarkup(this.Price, this.Cost);
      }
      this.$PriceModified.value = false;
      if (this.Price) {
        this.$PriceModified.value = true;
      }
      this.setTotals();
    }
  }, {
    key: "isErrorPrice",
    get: function get() {
      if (!this.Include) return false;
      var priceNull = this.Price === null || this.Price === undefined || this.Price === '';
      if (priceNull) return true;
      if (parseFloat(this.Price) < parseFloat(this.Cost)) {
        return true;
      }
    }
  }, {
    key: "roomCategoryName",
    get: function get() {
      return this.$parent.$parent.roomCategoryName;
    }
  }, {
    key: "hotelName",
    get: function get() {
      if (!this.$parent.$parent.Hotel) return '';
      return this.$parent.$parent.Hotel.Name;
    }
  }, {
    key: "hotelType",
    get: function get() {
      if (!this.$parent.$parent.Hotel) return null;
      return this.$parent.$parent.Hotel.Type;
    }
  }, {
    key: "dayNr",
    get: function get() {
      return this.$parent.$parent.$parent.$parent.DayNr;
    }
  }, {
    key: "days",
    get: function get() {
      return this.bookingDayHotel.Days;
    }
  }, {
    key: "room",
    get: function get() {
      return this.$parent.$parent.Room;
    }
  }, {
    key: "roomPax",
    get: function get() {
      if (!this.$parent.$parent.Room) return 1;
      var f = parseInt(this.$parent.$parent.Room.Pax);
      if (this.getHotelType == 'ALL_INCLUSIVE') {
        f = 1;
      }
      return f;
    }
  }, {
    key: "hotelId",
    get: function get() {
      if (!this.$parent.$parent) return;
      if (this.$parent.$parent.HotelId) return this.$parent.$parent.HotelId;
    }
  }, {
    key: "hasExtraBed",
    get: function get() {
      var extraBed;
      if (!this.hotelId) return;
      var rooms = this.bookingDayHotel.BookingDayRooms;
      if (rooms) {
        var _iterator = _createForOfIteratorHelper(rooms),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var room = _step.value;
            if (!room.QuoteList) continue;
            if (!room.QuoteList[this.baseId]) continue;
            if (!room.QuoteList[this.baseId].Include) continue;
            if (!room.HotelId) continue;
            if (room.HotelId != this.hotelId) continue;
            if (room.Room && room.Room.ExtraBed) extraBed = true;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return extraBed;
    }
  }, {
    key: "factor",
    get: function get() {
      if (!this.$parent.$parent.Room) return 1;
      var rooms = this.$parent.$parent.Rooms;
      if (!rooms) rooms = 1;
      var quoteByQuantity = this.booking.QuoteBy == 'QUANTITY';
      //if (this.booking.QuoteBy == 'QUANTITY') return 1;
      var f = parseInt(this.$parent.$parent.Room.Pax) * rooms;
      var roomsCapacity = parseInt(this.$parent.$parent.Room.Pax);
      if (this.getHotelType == 'ALL_INCLUSIVE') {
        f = 1;
      }
      var paxBase;
      var base = this.baseQuote;
      if (base) {
        paxBase = base.ADT;
        if (base.CHD) paxBase += base.CHD;
      }
      var extraBed;
      if (paxBase && paxBase != f) {
        extraBed = this.hasExtraBed;
      }
      var paxQuant;
      var Totals = this.booking.Totals;
      if (Totals && this.baseId && Totals[this.baseId]) {
        var t = Totals[this.baseId];
        if (t) {
          if (t.ADT && t.ADT.Pax || t.CHD && t.CHD.Pax) {
            paxQuant = 0;
          }
          if (t.ADT && t.ADT.Pax) {
            paxQuant += t.ADT.Pax;
          }
          ;
          if (t.CHD && t.CHD.Pax) {
            paxQuant += t.CHD.Pax;
          }
          ;
        }
        if (t.PaxRooms) {
          paxQuant = t.PaxRooms;
        }
      }
      if (!paxQuant) paxQuant = paxBase;
      if (quoteByQuantity && paxQuant < paxBase) {
        paxQuant = paxBase;
      }
      if (tools.isNull(f)) f = paxQuant;
      //if (f > 4) {
      if (roomsCapacity >= 4 && paxQuant < f && !extraBed) {
        f = paxQuant / rooms;
        return f;
      }
      ;
      if (extraBed && paxQuant && !quoteByQuantity) {
        return paxQuant;
      }
      return roomsCapacity;
    }
  }, {
    key: "baseQuote",
    get: function get() {
      return this.booking.BaseQuotes[this.baseId];
    }
  }, {
    key: "baseId",
    get: function get() {
      for (var baseId in this.$parent.bases) {
        var quote = this.$parent[baseId];
        if (quote._id == this._id) {
          return baseId;
        }
      }
    }
  }, {
    key: "setRoomCost",
    value: function setRoomCost() {
      this.$Cost.value = this.getCost();
      this.setPriceByCost();
    }
  }, {
    key: "qFactor",
    get: function get() {
      var q = 1;
      ///let quoteByQuantity = this.booking.QuoteBy == 'QUANTITY';
      if (this.booking.QuoteBy == 'QUANTITY') return 1;
      if (this.$parent.$parent.Rooms && this.hasExtraBed) return this.$parent.$parent.Rooms;
      if (this.$parent.$parent.Room.ExtraBed) {
        q = this.$parent.$parent.Rooms;
      }
      return q;
    }
  }, {
    key: "getSglSupCost",
    value: function getSglSupCost() {
      var _this2 = this;
      var supRoomCost = this.RoomCost * parseInt(this.days) / this.factor * this.qFactor;
      var doubleRoom = _.find(this.bookingDayHotel.BookingDayRooms, function (r) {
        if (r.RoomCategory == _this2.$parent.$parent.RoomCategory) {
          if (r.Room && r.Room.Pax == 2 && !r.Room.ExtraBed && !r.Room.Checkin) {
            if (r.HotelId == _this2.$parent.$parent.HotelId) return true;
          }
        }
      });
      if (!supRoomCost && doubleRoom && doubleRoom.QuoteList[this.baseId].Cost) {
        supRoomCost = doubleRoom.QuoteList[this.baseId].Cost;
      }
      if (supRoomCost && doubleRoom && doubleRoom.QuoteList[this.baseId].Cost) {
        if (this.booking.QuoteBy != 'QUANTITY') {
          return supRoomCost - doubleRoom.QuoteList[this.baseId].Cost;
        } else {
          return supRoomCost - doubleRoom.QuoteList[this.baseId].Cost / 2;
        }
      }
    }
  }, {
    key: "getCost",
    value: function getCost() {
      if (this.quoteBy == 'SERVICE') {
        if (this.Modified) return this.Cost;
        return this.RoomCost;
      }
      if (this.baseQuote && this.baseQuote.SingleSupplement && this.$parent.$parent.SingleSupplement) {
        return this.getSglSupCost();
      }
      if (!this.RoomCost) return;
      if (this.baseQuote && this.baseQuote.TourLeader && this.$parent.$parent.TourLeader && this.booking.QuoteBy != 'QUANTITY') {
        return this.RoomCost * parseInt(this.days) / this.baseQuote.paxQuantity;
      }
      var r = this.RoomCost * parseInt(this.days) / this.factor * this.qFactor;
      return r;
    }
  }, {
    key: "setPersonCost",
    value: function setPersonCost() {
      /*let rooms = this.Rooms;
      if (!rooms) rooms = this.$parent.$parent.Rooms;
      let totalCost = this.PersonCost * this.Pax;
      let days = this.days;
      if (this.UnitCostBy == 'PERSON') {
          rooms = 1;
      }
      if (this.PeriodCostBy == 'PROGRAM') {
          days = 1;
      }
      this.Cost = totalCost / (rooms * days);*/
      this.Cost = this.PersonCost;
      this.$PersonPrice.value = tools.getPrice(this.PersonCost, this.markup);
      this.setTotals();
    }
  }, {
    key: "setPersonPrice",
    value: function setPersonPrice() {
      /*let rooms = this.Rooms;
      if (!rooms) rooms = this.$parent.$parent.Rooms;
      let totalPrice = this.PersonPrice * this.Pax;
      let days = this.days;
      if (this.UnitCostBy == 'PERSON') {
          rooms = 1;
      }
      if (this.PeriodCostBy == 'PROGRAM') {
          days = 1;
      }
      this.Price = totalPrice / (rooms * days);
      if (this.PersonCost) {
          this.$Markup.value  = tools.getMarkup(this.PersonPrice, this.PersonPrice);
      }*/
      this.Price = this.PersonPrice;
      if (this.PersonCost) {
        this.$Markup.value = tools.getMarkup(this.PersonPrice, this.PersonCost);
      }
      this.setTotals();
    }
  }, {
    key: "setRooms",
    value: function setRooms() {
      if (Object.keys(this.booking.BaseQuotes.bases).length == 1) {
        this.$parent.$parent.$Rooms.value = this.Rooms;
      }
      this.setTotals();
    }
  }, {
    key: "setInclude",
    value: function setInclude() {
      this.setBookingTotals();
    }
  }, {
    key: "afterEdit",
    value: function afterEdit() {
      return {
        Cost: function Cost(r) {
          r.setPriceByCost(true);
        },
        Price: function Price(r) {
          r.setMarkupByPrice();
        },
        Markup: function Markup(r) {
          r.setMarkup();
        },
        Pax: function Pax(r) {
          r.setPersonValues();
        },
        RoomPax: function RoomPax(r) {
          r.setRoomPersonValues();
        },
        Rooms: function Rooms(r) {
          r.setRooms();
        },
        PersonCost: function PersonCost(r) {
          r.setPersonCost();
        },
        PersonPrice: function PersonPrice(r) {
          r.setPersonPrice();
        },
        Include: function Include(r) {
          r.setInclude();
        },
        RoomCost: function RoomCost(r) {
          r.setRoomCost();
          r.$Modified.value = true;
        },
        PeriodCostBy: function PeriodCostBy(r) {
          r.setTotals();
        },
        UnitCostBy: function UnitCostBy(r) {
          r.setTotals();
        }
      };
    }

    /*setGroups () {
        let booking = this.booking;
        if (booking.QuoteGroups && booking.QuoteGroups[this.baseId]) {
            if (!this.Groups) this.Groups = {};
            for (let groupId in booking.QuoteGroups[this.baseId]) {
                if (tools.isNull(this.Groups[groupId])) this.Groups[groupId] = true;
            }
        }
    }*/
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_4__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(HotelQuote, "moduleName", 'hotelquote');
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(HotelQuote, "invalidated_cache", _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_4__["default"].invalidated_cache_hotels);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HotelQuote);

/***/ }),

/***/ 20816:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ toPropertyKey)
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(82284);
;// ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != (0,esm_typeof/* default */.A)(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != (0,esm_typeof/* default */.A)(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == (0,esm_typeof/* default */.A)(i) ? i : i + "";
}


/***/ }),

/***/ 20838:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


/***/ }),

/***/ 21135:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort:
            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),

/***/ 21137:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.



var asn1 = __webpack_require__(87568);

exports.certificate = __webpack_require__(36413);

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
	this.seq().obj(
		this.key('version')['int'](),
		this.key('modulus')['int'](),
		this.key('publicExponent')['int'](),
		this.key('privateExponent')['int'](),
		this.key('prime1')['int'](),
		this.key('prime2')['int'](),
		this.key('exponent1')['int'](),
		this.key('exponent2')['int'](),
		this.key('coefficient')['int']()
	);
});
exports.RSAPrivateKey = RSAPrivateKey;

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
	this.seq().obj(
		this.key('modulus')['int'](),
		this.key('publicExponent')['int']()
	);
});
exports.RSAPublicKey = RSAPublicKey;

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
	this.seq().obj(
		this.key('algorithm').objid(),
		this.key('none').null_().optional(),
		this.key('curve').objid().optional(),
		this.key('params').seq().obj(
			this.key('p')['int'](),
			this.key('q')['int'](),
			this.key('g')['int']()
		).optional()
	);
});

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
	this.seq().obj(
		this.key('algorithm').use(AlgorithmIdentifier),
		this.key('subjectPublicKey').bitstr()
	);
});
exports.PublicKey = PublicKey;

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
	this.seq().obj(
		this.key('version')['int'](),
		this.key('algorithm').use(AlgorithmIdentifier),
		this.key('subjectPrivateKey').octstr()
	);
});
exports.PrivateKey = PrivateKeyInfo;
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
	this.seq().obj(
		this.key('algorithm').seq().obj(
			this.key('id').objid(),
			this.key('decrypt').seq().obj(
				this.key('kde').seq().obj(
					this.key('id').objid(),
					this.key('kdeparams').seq().obj(
						this.key('salt').octstr(),
						this.key('iters')['int']()
					)
				),
				this.key('cipher').seq().obj(
					this.key('algo').objid(),
					this.key('iv').octstr()
				)
			)
		),
		this.key('subjectPrivateKey').octstr()
	);
});

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo;

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
	this.seq().obj(
		this.key('version')['int'](),
		this.key('p')['int'](),
		this.key('q')['int'](),
		this.key('g')['int'](),
		this.key('pub_key')['int'](),
		this.key('priv_key')['int']()
	);
});
exports.DSAPrivateKey = DSAPrivateKey;

exports.DSAparam = asn1.define('DSAparam', function () {
	this['int']();
});

var ECParameters = asn1.define('ECParameters', function () {
	this.choice({
		namedCurve: this.objid()
	});
});

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
	this.seq().obj(
		this.key('version')['int'](),
		this.key('privateKey').octstr(),
		this.key('parameters').optional().explicit(0).use(ECParameters),
		this.key('publicKey').optional().explicit(1).bitstr()
	);
});
exports.ECPrivateKey = ECPrivateKey;

exports.signature = asn1.define('signature', function () {
	this.seq().obj(
		this.key('r')['int'](),
		this.key('s')['int']()
	);
});


/***/ }),

/***/ 21352:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var md5 = __webpack_require__(20320)
var RIPEMD160 = __webpack_require__(66011)
var sha = __webpack_require__(62802)
var Buffer = (__webpack_require__(92861).Buffer)

var checkParameters = __webpack_require__(64196)
var defaultEncoding = __webpack_require__(2455)
var toBuffer = __webpack_require__(93382)

var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }
  function rmd160Func (data) {
    return new RIPEMD160().update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(iterations, keylen)
  password = toBuffer(password, defaultEncoding, 'Password')
  salt = toBuffer(salt, defaultEncoding, 'Salt')

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2


/***/ }),

/***/ 21827:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


/***/ }),

/***/ 21911:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(67426);

var SHA512 = __webpack_require__(57766);

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};


/***/ }),

/***/ 22153:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__(74598);


/***/ }),

/***/ 22274:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'én time',
            hh: '%d timer',
            d: 'én dag',
            dd: '%d dager',
            w: 'én uke',
            ww: '%d uker',
            M: 'én måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


/***/ }),

/***/ 22283:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);


function mountModelNew(_x) {
  return _mountModelNew.apply(this, arguments);
}
function _mountModelNew() {
  _mountModelNew = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(table) {
    var options, endpoint, model, record;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return api.getModuleFieldsOptions(table, null, {});
        case 2:
          options = _context.sent;
          endpoint = "/api/".concat(table, "/");
          if (modelTables[table]) {
            model = api.importMixinModule(table, 'model');
          } else {
            model = api.importMixinModule('record', 'model');
          }
          _context.next = 7;
          return new model({
            tableName: table,
            options: options,
            endpoint: endpoint
          });
        case 7:
          record = _context.sent;
          return _context.abrupt("return", record);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _mountModelNew.apply(this, arguments);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (mountModelNew);

/***/ }),

/***/ 22296:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var PurchaseInvoiceMixinView = api.importMixinModule('purchaseinvoice', 'views', 'custom');
var CustomPurchaseInvoiceView = /*#__PURE__*/function (_PurchaseInvoiceMixin) {
  function CustomPurchaseInvoiceView() {
    _classCallCheck(this, CustomPurchaseInvoiceView);
    return _callSuper(this, CustomPurchaseInvoiceView, arguments);
  }
  _inherits(CustomPurchaseInvoiceView, _PurchaseInvoiceMixin);
  return _createClass(CustomPurchaseInvoiceView, null, [{
    key: "options",
    value: function options() {
      var res = _superPropGet(CustomPurchaseInvoiceView, "options", this, 2)([]);
      var invoiceNumber = _.find(res.fields, function (r) {
        return r.name == 'InvoiceNumber';
      });
      if (invoiceNumber) {
        invoiceNumber.afterEdit = function (record) {
          var r = record.InvoiceNumber.replace(/[^\d\s-]/g, '').toUpperCase().trim();
          var parts = r.split(/[ -]/);
          if (parts.length < 2) {
            return;
          }
          var part1 = parts[0].padStart(5, '0');
          var part2 = parts[1].padStart(8, '0');
          record.InvoiceNumber = "".concat(part1, "-").concat(part2);
        };
      }
      var supplier = _.find(res.fields, function (r) {
        return r.name == 'SupplierId';
      });
      if (supplier) supplier.optionLabels = 'CompanyName';
      var type = _.find(res.fields, function (r) {
        return r.name == 'Type';
      });
      if (type) {
        type.options.push({
          value: "LIQUIDATION",
          label: 'Liquidación'
        });
      }
      return res;
    }
  }]);
}(PurchaseInvoiceMixinView);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomPurchaseInvoiceView);

/***/ }),

/***/ 22853:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var decoders = exports;

decoders.der = __webpack_require__(62010);
decoders.pem = __webpack_require__(58903);


/***/ }),

/***/ 22859:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8818);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var ContactView = /*#__PURE__*/function (_View) {
  function ContactView() {
    _classCallCheck(this, ContactView);
    return _callSuper(this, ContactView, arguments);
  }
  _inherits(ContactView, _View);
  return _createClass(ContactView, null, [{
    key: "options",
    value: function options() {
      return {
        fieldsOrder: ['ContactName', 'FirstName', 'LastName', 'Title', 'JobDescription', 'Address', 'CountryName', 'Phone', 'Mobile', 'Email', 'Gender', 'SupplierId', 'AgencyId'],
        canAdd: true
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(ContactView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              res = _context.sent;
              return _context.abrupt("return", res);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_0__["default"]);
_defineProperty(ContactView, "table", 'contact');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ContactView);

/***/ }),

/***/ 22897:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var metaSchema = __webpack_require__(8198);

module.exports = {
  $id: 'https://github.com/ajv-validator/ajv/blob/master/lib/definition_schema.js',
  definitions: {
    simpleTypes: metaSchema.definitions.simpleTypes
  },
  type: 'object',
  dependencies: {
    schema: ['validate'],
    $data: ['validate'],
    statements: ['inline'],
    valid: {not: {required: ['macro']}}
  },
  properties: {
    type: metaSchema.properties.type,
    schema: {type: 'boolean'},
    statements: {type: 'boolean'},
    dependencies: {
      type: 'array',
      items: {type: 'string'}
    },
    metaSchema: {type: 'object'},
    modifying: {type: 'boolean'},
    valid: {type: 'boolean'},
    $data: {type: 'boolean'},
    async: {type: 'boolean'},
    errors: {
      anyOf: [
        {type: 'boolean'},
        {const: 'full'}
      ]
    }
  }
};


/***/ }),

/***/ 23029:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ _classCallCheck)
/* harmony export */ });
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


/***/ }),

/***/ 23032:
/***/ ((module) => {

"use strict";

module.exports = function generate_propertyNames(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  out += 'var ' + ($errs) + ' = errors;';
  if ((it.opts.strictKeywords ? (typeof $schema == 'object' && Object.keys($schema).length > 0) || $schema === false : it.util.schemaHasRules($schema, it.RULES.all))) {
    $it.schema = $schema;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    var $key = 'key' + $lvl,
      $idx = 'idx' + $lvl,
      $i = 'i' + $lvl,
      $invalidName = '\' + ' + $key + ' + \'',
      $dataNxt = $it.dataLevel = it.dataLevel + 1,
      $nextData = 'data' + $dataNxt,
      $dataProperties = 'dataProperties' + $lvl,
      $ownProperties = it.opts.ownProperties,
      $currentBaseId = it.baseId;
    if ($ownProperties) {
      out += ' var ' + ($dataProperties) + ' = undefined; ';
    }
    if ($ownProperties) {
      out += ' ' + ($dataProperties) + ' = ' + ($dataProperties) + ' || Object.keys(' + ($data) + '); for (var ' + ($idx) + '=0; ' + ($idx) + '<' + ($dataProperties) + '.length; ' + ($idx) + '++) { var ' + ($key) + ' = ' + ($dataProperties) + '[' + ($idx) + ']; ';
    } else {
      out += ' for (var ' + ($key) + ' in ' + ($data) + ') { ';
    }
    out += ' var startErrs' + ($lvl) + ' = errors; ';
    var $passData = $key;
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    var $code = it.validate($it);
    $it.baseId = $currentBaseId;
    if (it.util.varOccurences($code, $nextData) < 2) {
      out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
    } else {
      out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
    }
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += ' if (!' + ($nextValid) + ') { for (var ' + ($i) + '=startErrs' + ($lvl) + '; ' + ($i) + '<errors; ' + ($i) + '++) { vErrors[' + ($i) + '].propertyName = ' + ($key) + '; }   var err =   '; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('propertyNames') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { propertyName: \'' + ($invalidName) + '\' } ';
      if (it.opts.messages !== false) {
        out += ' , message: \'property name \\\'' + ($invalidName) + '\\\' is invalid\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError(vErrors); ';
      } else {
        out += ' validate.errors = vErrors; return false; ';
      }
    }
    if ($breakOnError) {
      out += ' break; ';
    }
    out += ' } }';
  }
  if ($breakOnError) {
    out += ' ' + ($closingBraces) + ' if (' + ($errs) + ' == errors) {';
  }
  return out;
}


/***/ }),

/***/ 23241:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');

/***/ }),

/***/ 23326:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8818);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ServiceQuoteView = /*#__PURE__*/function (_View) {
  function ServiceQuoteView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, ServiceQuoteView);
    return _callSuper(this, ServiceQuoteView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(ServiceQuoteView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(ServiceQuoteView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", {
                fields: []
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(ServiceQuoteView, "table", 'servicequote');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ServiceQuoteView);

/***/ }),

/***/ 23827:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


/***/ }),

/***/ 23949:
/***/ ((module) => {

"use strict";


module.exports = {
  metaSchemaRef: metaSchemaRef
};

var META_SCHEMA_ID = 'http://json-schema.org/draft-07/schema';

function metaSchemaRef(ajv) {
  var defaultMeta = ajv._opts.defaultMeta;
  if (typeof defaultMeta == 'string') return { $ref: defaultMeta };
  if (ajv.getSchema(META_SCHEMA_ID)) return { $ref: META_SCHEMA_ID };
  console.warn('meta schema not defined');
  return {};
}


/***/ }),

/***/ 24101:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;
var evp = __webpack_require__(68078);
var ciphers = __webpack_require__(1241);
var Buffer = (__webpack_require__(92861).Buffer);
module.exports = function (okey, password) {
	var key = okey.toString();
	var match = key.match(findProc);
	var decrypted;
	if (!match) {
		var match2 = key.match(fullRegex);
		decrypted = Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
	} else {
		var suite = 'aes' + match[1];
		var iv = Buffer.from(match[2], 'hex');
		var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
		var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
		var out = [];
		var cipher = ciphers.createDecipheriv(suite, cipherKey, iv);
		out.push(cipher.update(cipherText));
		out.push(cipher['final']());
		decrypted = Buffer.concat(out);
	}
	var tag = key.match(startRegex)[1];
	return {
		tag: tag,
		data: decrypted
	};
};


/***/ }),

/***/ 24107:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(56698)
var Hash = __webpack_require__(90392)
var Buffer = (__webpack_require__(92861).Buffer)

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),

/***/ 24278:
/***/ ((module) => {

"use strict";


var KEYWORDS = [
  'multipleOf',
  'maximum',
  'exclusiveMaximum',
  'minimum',
  'exclusiveMinimum',
  'maxLength',
  'minLength',
  'pattern',
  'additionalItems',
  'maxItems',
  'minItems',
  'uniqueItems',
  'maxProperties',
  'minProperties',
  'required',
  'additionalProperties',
  'enum',
  'format',
  'const'
];

module.exports = function (metaSchema, keywordsJsonPointers) {
  for (var i=0; i<keywordsJsonPointers.length; i++) {
    metaSchema = JSON.parse(JSON.stringify(metaSchema));
    var segments = keywordsJsonPointers[i].split('/');
    var keywords = metaSchema;
    var j;
    for (j=1; j<segments.length; j++)
      keywords = keywords[segments[j]];

    for (j=0; j<KEYWORDS.length; j++) {
      var key = KEYWORDS[j];
      var schema = keywords[key];
      if (schema) {
        keywords[key] = {
          anyOf: [
            schema,
            { $ref: 'https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#' }
          ]
        };
      }
    }
  }

  return metaSchema;
};


/***/ }),

/***/ 24457:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort:
            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


/***/ }),

/***/ 24496:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arMa;

})));


/***/ }),

/***/ 24563:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var KEYWORDS = __webpack_require__(72312);

module.exports = defineKeywords;


/**
 * Defines one or several keywords in ajv instance
 * @param  {Ajv} ajv validator instance
 * @param  {String|Array<String>|undefined} keyword keyword(s) to define
 * @return {Ajv} ajv instance (for chaining)
 */
function defineKeywords(ajv, keyword) {
  if (Array.isArray(keyword)) {
    for (var i=0; i<keyword.length; i++)
      get(keyword[i])(ajv);
    return ajv;
  }
  if (keyword) {
    get(keyword)(ajv);
    return ajv;
  }
  for (keyword in KEYWORDS) get(keyword)(ajv);
  return ajv;
}


defineKeywords.get = get;

function get(keyword) {
  var defFunc = KEYWORDS[keyword];
  if (!defFunc) throw new Error('Unknown keyword ' + keyword);
  return defFunc;
}


/***/ }),

/***/ 24669:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var encoders = exports;

encoders.der = __webpack_require__(70082);
encoders.pem = __webpack_require__(90735);


/***/ }),

/***/ 24802:
/***/ (() => {

window.modelTables.purchaseinvoice = true;
window.modelTables.invoice = true;

/***/ }),

/***/ 25177:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


/***/ }),

/***/ 25382:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(33225);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(__webpack_require__(15622));
util.inherits = __webpack_require__(56698);
/*</replacement>*/

var Readable = __webpack_require__(45412);
var Writable = __webpack_require__(16708);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),

/***/ 25538:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var map = {
	"./base": 8626,
	"./base/": 8626,
	"./base/abm": 51272,
	"./base/abm.js": 51272,
	"./base/abms/booking": 19783,
	"./base/abms/booking.js": 19783,
	"./base/api": 66,
	"./base/api.js": 66,
	"./base/image": 89431,
	"./base/image.js": 89431,
	"./base/index": 8626,
	"./base/index.js": 8626,
	"./base/model/base-model": 42675,
	"./base/model/base-model.js": 42675,
	"./base/model/basequote": 32299,
	"./base/model/basequote.js": 32299,
	"./base/model/basequotes": 8286,
	"./base/model/basequotes.js": 8286,
	"./base/model/booking": 13536,
	"./base/model/booking.js": 13536,
	"./base/model/bookingbasemodel": 51941,
	"./base/model/bookingbasemodel.js": 51941,
	"./base/model/bookingcurrencyrate": 80386,
	"./base/model/bookingcurrencyrate.js": 80386,
	"./base/model/bookingcurrencyrates": 5377,
	"./base/model/bookingcurrencyrates.js": 5377,
	"./base/model/bookingday": 88829,
	"./base/model/bookingday.js": 88829,
	"./base/model/bookingdayhotel": 44075,
	"./base/model/bookingdayhotel.js": 44075,
	"./base/model/bookingdayroom": 34298,
	"./base/model/bookingdayroom.js": 34298,
	"./base/model/bookingdayservice": 37162,
	"./base/model/bookingdayservice.js": 37162,
	"./base/model/bookingdayservicecar": 58382,
	"./base/model/bookingdayservicecar.js": 58382,
	"./base/model/bookingdayserviceimage": 48433,
	"./base/model/bookingdayserviceimage.js": 48433,
	"./base/model/bookingexpense": 73987,
	"./base/model/bookingexpense.js": 73987,
	"./base/model/bookingflight": 18129,
	"./base/model/bookingflight.js": 18129,
	"./base/model/bookingflightquote": 4853,
	"./base/model/bookingflightquote.js": 4853,
	"./base/model/bookingflightquotelist": 6169,
	"./base/model/bookingflightquotelist.js": 6169,
	"./base/model/bookingform": 58713,
	"./base/model/bookingform.js": 58713,
	"./base/model/bookingoptionalservice": 62948,
	"./base/model/bookingoptionalservice.js": 62948,
	"./base/model/bookingpayment": 98881,
	"./base/model/bookingpayment.js": 98881,
	"./base/model/bookingreceipt": 89067,
	"./base/model/bookingreceipt.js": 89067,
	"./base/model/bookingtotal": 55541,
	"./base/model/bookingtotal.js": 55541,
	"./base/model/bookingtotallist": 20505,
	"./base/model/bookingtotallist.js": 20505,
	"./base/model/bookingtotalperson": 56004,
	"./base/model/bookingtotalperson.js": 56004,
	"./base/model/bookingusershare": 34141,
	"./base/model/bookingusershare.js": 34141,
	"./base/model/cache": 42142,
	"./base/model/cache.js": 42142,
	"./base/model/cashout": 18953,
	"./base/model/cashout.js": 18953,
	"./base/model/city": 51477,
	"./base/model/city.js": 51477,
	"./base/model/hotel": 87214,
	"./base/model/hotel.js": 87214,
	"./base/model/hotelquote": 20660,
	"./base/model/hotelquote.js": 20660,
	"./base/model/hotelquotelist": 5820,
	"./base/model/hotelquotelist.js": 5820,
	"./base/model/mail": 61777,
	"./base/model/mail.js": 61777,
	"./base/model/record": 55539,
	"./base/model/record.js": 55539,
	"./base/model/roomconfiguration": 47471,
	"./base/model/roomconfiguration.js": 47471,
	"./base/model/service": 69203,
	"./base/model/service.js": 69203,
	"./base/model/servicepersonquote": 99352,
	"./base/model/servicepersonquote.js": 99352,
	"./base/model/servicequote": 84735,
	"./base/model/servicequote.js": 84735,
	"./base/model/servicequotelist": 29063,
	"./base/model/servicequotelist.js": 29063,
	"./base/model/servicequoteobject": 80924,
	"./base/model/servicequoteobject.js": 80924,
	"./base/model/supplier": 88098,
	"./base/model/supplier.js": 88098,
	"./base/model/suppliercredit": 14599,
	"./base/model/suppliercredit.js": 14599,
	"./base/model/user": 66797,
	"./base/model/user.js": 66797,
	"./base/pdf": 56112,
	"./base/pdf.js": 56112,
	"./base/tools": 80405,
	"./base/tools.js": 80405,
	"./base/travelTools": 29721,
	"./base/travelTools.js": 29721,
	"./base/views/accessgroup": 97326,
	"./base/views/accessgroup.js": 97326,
	"./base/views/agency": 39388,
	"./base/views/agency.js": 39388,
	"./base/views/basequote": 65556,
	"./base/views/basequote.js": 65556,
	"./base/views/basequotes": 9275,
	"./base/views/basequotes.js": 9275,
	"./base/views/booking": 77880,
	"./base/views/booking.js": 77880,
	"./base/views/bookingcurrencyrate": 19853,
	"./base/views/bookingcurrencyrate.js": 19853,
	"./base/views/bookingday": 79692,
	"./base/views/bookingday.js": 79692,
	"./base/views/bookingdayhotel": 58316,
	"./base/views/bookingdayhotel.js": 58316,
	"./base/views/bookingdayroom": 97439,
	"./base/views/bookingdayroom.js": 97439,
	"./base/views/bookingdayservice": 43525,
	"./base/views/bookingdayservice.js": 43525,
	"./base/views/bookingdayservicecar": 83211,
	"./base/views/bookingdayservicecar.js": 83211,
	"./base/views/bookingdayserviceimage": 73892,
	"./base/views/bookingdayserviceimage.js": 73892,
	"./base/views/bookingexpense": 31554,
	"./base/views/bookingexpense.js": 31554,
	"./base/views/bookingflight": 87938,
	"./base/views/bookingflight.js": 87938,
	"./base/views/bookingflightquote": 96496,
	"./base/views/bookingflightquote.js": 96496,
	"./base/views/bookingflightquotelist": 32856,
	"./base/views/bookingflightquotelist.js": 32856,
	"./base/views/bookingform": 20002,
	"./base/views/bookingform.js": 20002,
	"./base/views/bookingoptinalservice": 65730,
	"./base/views/bookingoptinalservice.js": 65730,
	"./base/views/bookingpayment": 90188,
	"./base/views/bookingpayment.js": 90188,
	"./base/views/bookingreceipt": 84070,
	"./base/views/bookingreceipt.js": 84070,
	"./base/views/bookingtotalperson": 78473,
	"./base/views/bookingtotalperson.js": 78473,
	"./base/views/bookingusershare": 3520,
	"./base/views/bookingusershare.js": 3520,
	"./base/views/cashout": 92702,
	"./base/views/cashout.js": 92702,
	"./base/views/city": 16740,
	"./base/views/city.js": 16740,
	"./base/views/currency": 60392,
	"./base/views/currency.js": 60392,
	"./base/views/currencyconversion": 71096,
	"./base/views/currencyconversion.js": 71096,
	"./base/views/currencyrate": 90514,
	"./base/views/currencyrate.js": 90514,
	"./base/views/hotel": 56117,
	"./base/views/hotel.js": 56117,
	"./base/views/hotelcost": 56456,
	"./base/views/hotelcost.js": 56456,
	"./base/views/hotelquote": 19249,
	"./base/views/hotelquote.js": 19249,
	"./base/views/hotelquotelist": 56853,
	"./base/views/hotelquotelist.js": 56853,
	"./base/views/image": 83646,
	"./base/views/image.js": 83646,
	"./base/views/includes": 56990,
	"./base/views/includes.js": 56990,
	"./base/views/language": 5853,
	"./base/views/language.js": 5853,
	"./base/views/mail": 70916,
	"./base/views/mail.js": 70916,
	"./base/views/reporttask": 4116,
	"./base/views/reporttask.js": 4116,
	"./base/views/roomconfiguration": 49856,
	"./base/views/roomconfiguration.js": 49856,
	"./base/views/service": 68152,
	"./base/views/service.js": 68152,
	"./base/views/serviceclass": 3766,
	"./base/views/serviceclass.js": 3766,
	"./base/views/servicepersonquote": 26021,
	"./base/views/servicepersonquote.js": 26021,
	"./base/views/servicequote": 23326,
	"./base/views/servicequote.js": 23326,
	"./base/views/servicequotelist": 12626,
	"./base/views/servicequotelist.js": 12626,
	"./base/views/servicequoteobject": 40237,
	"./base/views/servicequoteobject.js": 40237,
	"./base/views/supplier": 15575,
	"./base/views/supplier.js": 15575,
	"./base/views/suppliercredit": 60294,
	"./base/views/suppliercredit.js": 60294,
	"./base/views/supplierservice": 64000,
	"./base/views/supplierservice.js": 64000,
	"./base/views/termsandconditions": 95961,
	"./base/views/termsandconditions.js": 95961,
	"./base/views/user": 71368,
	"./base/views/user.js": 71368,
	"./base/views/userprofile": 76619,
	"./base/views/userprofile.js": 76619,
	"./base/views/view": 8818,
	"./base/views/view.js": 8818,
	"./extra/accounting/views/account": 90028,
	"./extra/accounting/views/account.js": 90028,
	"./extra/admin": 24802,
	"./extra/admin/": 24802,
	"./extra/admin/index": 24802,
	"./extra/admin/index.js": 24802,
	"./extra/admin/model/bookingpayment": 99249,
	"./extra/admin/model/bookingpayment.js": 99249,
	"./extra/admin/model/invoice": 25967,
	"./extra/admin/model/invoice.js": 25967,
	"./extra/admin/model/purchaseinvoice": 66506,
	"./extra/admin/model/purchaseinvoice.js": 66506,
	"./extra/admin/views/accountmovement": 80713,
	"./extra/admin/views/accountmovement.js": 80713,
	"./extra/admin/views/bookingpayment": 26780,
	"./extra/admin/views/bookingpayment.js": 26780,
	"./extra/admin/views/hotel": 35557,
	"./extra/admin/views/hotel.js": 35557,
	"./extra/admin/views/invoice": 94576,
	"./extra/admin/views/invoice.js": 94576,
	"./extra/admin/views/purchaseinvoice": 85725,
	"./extra/admin/views/purchaseinvoice.js": 85725,
	"./extra/ai": 57859,
	"./extra/ai/": 57859,
	"./extra/ai/index": 57859,
	"./extra/ai/index.js": 57859,
	"./extra/ai/model/googledrivefile": 70114,
	"./extra/ai/model/googledrivefile.js": 70114,
	"./extra/ai/model/purchaseinvoice": 48095,
	"./extra/ai/model/purchaseinvoice.js": 48095,
	"./extra/ai/views/aiprompt": 9080,
	"./extra/ai/views/aiprompt.js": 9080,
	"./extra/ai/views/airesponse": 5689,
	"./extra/ai/views/airesponse.js": 5689,
	"./extra/ai/views/aisettings": 55231,
	"./extra/ai/views/aisettings.js": 55231,
	"./extra/ai/views/googledrivefile": 68813,
	"./extra/ai/views/googledrivefile.js": 68813,
	"./extra/ai/views/purchaseinvoice": 72812,
	"./extra/ai/views/purchaseinvoice.js": 72812,
	"./extra/ai/views/service": 47289,
	"./extra/ai/views/service.js": 47289,
	"./extra/arg/views/purchaseinvoice": 91256,
	"./extra/arg/views/purchaseinvoice.js": 91256,
	"./extra/argafip/model/invoice": 71788,
	"./extra/argafip/model/invoice.js": 71788,
	"./extra/argafip/views/currency": 77941,
	"./extra/argafip/views/currency.js": 77941,
	"./extra/argafip/views/invoice": 49955,
	"./extra/argafip/views/invoice.js": 49955,
	"./extra/contacts": 1506,
	"./extra/contacts/": 1506,
	"./extra/contacts/index": 1506,
	"./extra/contacts/index.js": 1506,
	"./extra/contacts/model/contact": 43928,
	"./extra/contacts/model/contact.js": 43928,
	"./extra/contacts/views/agency": 47500,
	"./extra/contacts/views/agency.js": 47500,
	"./extra/contacts/views/booking": 86824,
	"./extra/contacts/views/booking.js": 86824,
	"./extra/contacts/views/contact": 22859,
	"./extra/contacts/views/contact.js": 22859,
	"./extra/contacts/views/hotel": 75301,
	"./extra/contacts/views/hotel.js": 75301,
	"./extra/contacts/views/supplier": 29895,
	"./extra/contacts/views/supplier.js": 29895,
	"./extra/contacts/views/supplierservice": 61776,
	"./extra/contacts/views/supplierservice.js": 61776,
	"./extra/crm": 71799,
	"./extra/crm/": 71799,
	"./extra/crm/index": 71799,
	"./extra/crm/index.js": 71799,
	"./extra/crm/model/booking": 98658,
	"./extra/crm/model/booking.js": 98658,
	"./extra/crm/model/paxlead": 69042,
	"./extra/crm/model/paxlead.js": 69042,
	"./extra/crm/model/survey": 99091,
	"./extra/crm/model/survey.js": 99091,
	"./extra/crm/model/surveypax": 86078,
	"./extra/crm/model/surveypax.js": 86078,
	"./extra/crm/model/surveyquestion": 20407,
	"./extra/crm/model/surveyquestion.js": 20407,
	"./extra/crm/views/booking": 53233,
	"./extra/crm/views/booking.js": 53233,
	"./extra/crm/views/leadstatus": 66432,
	"./extra/crm/views/leadstatus.js": 66432,
	"./extra/crm/views/paxlead": 97341,
	"./extra/crm/views/paxlead.js": 97341,
	"./extra/crm/views/survey": 19318,
	"./extra/crm/views/survey.js": 19318,
	"./extra/crm/views/surveypax": 83417,
	"./extra/crm/views/surveypax.js": 83417,
	"./extra/crm/views/surveyquestion": 36158,
	"./extra/crm/views/surveyquestion.js": 36158,
	"./extra/custom": 7543,
	"./extra/custom/": 7543,
	"./extra/custom/env/dev-test.env": 70984,
	"./extra/custom/env/dev-test.env.js": 70984,
	"./extra/custom/env/prod.env": 67883,
	"./extra/custom/env/prod.env.js": 67883,
	"./extra/custom/env/support.env": 92493,
	"./extra/custom/env/support.env.js": 92493,
	"./extra/custom/env/test.env": 926,
	"./extra/custom/env/test.env.js": 926,
	"./extra/custom/index": 7543,
	"./extra/custom/index.js": 7543,
	"./extra/custom/model/booking": 3298,
	"./extra/custom/model/booking.js": 3298,
	"./extra/custom/model/bookingday": 39258,
	"./extra/custom/model/bookingday.js": 39258,
	"./extra/custom/model/bookingdayservice": 45567,
	"./extra/custom/model/bookingdayservice.js": 45567,
	"./extra/custom/model/bookingpayment": 134,
	"./extra/custom/model/bookingpayment.js": 134,
	"./extra/custom/model/servicepersonquote": 39975,
	"./extra/custom/model/servicepersonquote.js": 39975,
	"./extra/custom/test/data/booking-679.txt": 68674,
	"./extra/custom/test/data/city-3.txt": 71059,
	"./extra/custom/test/tests": 87581,
	"./extra/custom/test/tests.js": 87581,
	"./extra/custom/views/aisettings": 30475,
	"./extra/custom/views/aisettings.js": 30475,
	"./extra/custom/views/booking": 61649,
	"./extra/custom/views/booking.js": 61649,
	"./extra/custom/views/bookingdayservice": 3044,
	"./extra/custom/views/bookingdayservice.js": 3044,
	"./extra/custom/views/bookingpayment": 4131,
	"./extra/custom/views/bookingpayment.js": 4131,
	"./extra/custom/views/bookingsetting": 74021,
	"./extra/custom/views/bookingsetting.js": 74021,
	"./extra/custom/views/claim": 39994,
	"./extra/custom/views/claim.js": 39994,
	"./extra/custom/views/hotel": 85332,
	"./extra/custom/views/hotel.js": 85332,
	"./extra/custom/views/paxlead": 39517,
	"./extra/custom/views/paxlead.js": 39517,
	"./extra/custom/views/purchaseinvoice": 22296,
	"./extra/custom/views/purchaseinvoice.js": 22296,
	"./extra/custom/views/service": 99725,
	"./extra/custom/views/service.js": 99725,
	"./languages/countries/de/world": 63966,
	"./languages/countries/de/world.json": 63966,
	"./languages/countries/en/world": 62730,
	"./languages/countries/en/world.json": 62730,
	"./languages/countries/es/world": 67537,
	"./languages/countries/es/world.json": 67537,
	"./languages/countries/fr/world": 56057,
	"./languages/countries/fr/world.json": 56057,
	"./languages/countries/it/world": 99708,
	"./languages/countries/it/world.json": 99708,
	"./languages/countries/nl/world": 61163,
	"./languages/countries/nl/world.json": 61163,
	"./languages/countries/pt/world": 52309,
	"./languages/countries/pt/world.json": 52309,
	"./languages/de": 72842,
	"./languages/de.json": 72842,
	"./languages/en": 70786,
	"./languages/en.json": 70786,
	"./languages/es": 39777,
	"./languages/es.json": 39777,
	"./languages/fr": 53577,
	"./languages/fr.json": 53577,
	"./languages/it": 65028,
	"./languages/it.json": 65028,
	"./languages/nl": 53011,
	"./languages/nl.json": 53011,
	"./languages/pt": 48857,
	"./languages/pt.json": 48857,
	"./languages/system_languages": 71040,
	"./languages/system_languages.json": 71040,
	"./test/bookingTest": 87444,
	"./test/bookingTest.js": 87444,
	"./test/mountModel": 9053,
	"./test/mountModel.js": 9053,
	"./test/mountModelFromJSON": 40687,
	"./test/mountModelFromJSON.js": 40687,
	"./test/mountModelNew": 22283,
	"./test/mountModelNew.js": 22283,
	"./tests": 65243,
	"./tests.js": 65243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;

/***/ }),

/***/ 25799:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var MODES = __webpack_require__(530)
var AuthCipher = __webpack_require__(92356)
var Buffer = (__webpack_require__(92861).Buffer)
var StreamCipher = __webpack_require__(50650)
var Transform = __webpack_require__(56168)
var aes = __webpack_require__(50462)
var ebtk = __webpack_require__(68078)
var inherits = __webpack_require__(56698)

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher


/***/ }),

/***/ 25892:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Buffer = (__webpack_require__(92861).Buffer)
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH


/***/ }),

/***/ 25967:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_model_record__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55539);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var Invoice = /*#__PURE__*/function (_Record) {
  function Invoice() {
    _classCallCheck(this, Invoice);
    return _callSuper(this, Invoice, arguments);
  }
  _inherits(Invoice, _Record);
  return _createClass(Invoice, [{
    key: "rowTotalAmount",
    get: function get() {
      if (!this.Amount || !this.Pax) return 0;
      return this.Amount * this.Pax;
    }
  }, {
    key: "totalAmount",
    get: function get() {
      return this.InvoiceDetails.reduce(function (acc, detail) {
        return acc + detail.rowTotalAmount;
      }, 0);
    }
  }]);
}(_base_model_record__WEBPACK_IMPORTED_MODULE_0__["default"]);
_defineProperty(Invoice, "table", 'invoice');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Invoice);

/***/ }),

/***/ 26021:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8818);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ServicePersonQuoteView = /*#__PURE__*/function (_View) {
  function ServicePersonQuoteView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, ServicePersonQuoteView);
    return _callSuper(this, ServicePersonQuoteView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(ServicePersonQuoteView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(ServicePersonQuoteView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", {
                fields: [{
                  name: 'Base'
                }, {
                  name: 'Cost'
                },
                //cost of service
                {
                  name: 'PersonCost'
                },
                //cost per person
                {
                  name: 'PersonCostModified'
                },
                //cost per person
                {
                  name: 'PersonPrice'
                },
                //price per person
                {
                  name: 'PersonPriceModified'
                },
                //price per person
                {
                  name: 'Include',
                  defValue: true
                }, {
                  name: 'Markup'
                }, {
                  name: 'OriginCost'
                }, {
                  name: 'Price'
                },
                //price of service
                {
                  name: 'TotalCost'
                },
                //total cost of service
                //{ name: 'TotalPersonCost'}, //PersonCost * quantity of persons (base)
                {
                  name: 'Quantity'
                }, {
                  name: 'TotalPrice'
                },
                //total price of service
                {
                  name: 'TotalPersonPrice'
                },
                //PersonPrice * quantity of persons (base)
                {
                  name: 'CostBy'
                }, {
                  name: 'SourceCost'
                },
                //{ name: 'Groups' },
                {
                  name: 'SourceCurrencyId'
                }, {
                  name: 'Modified',
                  defValue: false
                }, {
                  name: 'MarkupModified',
                  defValue: false
                }, {
                  name: 'PriceModified',
                  defValue: false
                }, {
                  name: 'Comment'
                }, {
                  name: 'EstimatedCost',
                  defValue: false
                }, {
                  name: 'CostByModified',
                  defValue: false
                }]
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(ServicePersonQuoteView, "table", 'servicepersonquote');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ServicePersonQuoteView);

/***/ }),

/***/ 26028:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ esm_browser_v1)
});

// UNUSED EXPORTS: updateV1State

;// ./node_modules/uuid/dist/esm-browser/rng.js
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
    if (!getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) {
            throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        }
        getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return getRandomValues(rnds8);
}

;// ./node_modules/uuid/dist/esm-browser/stringify.js

const byteToHex = [];
for (let i = 0; i < 256; ++i) {
    byteToHex.push((i + 0x100).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
    return (byteToHex[arr[offset + 0]] +
        byteToHex[arr[offset + 1]] +
        byteToHex[arr[offset + 2]] +
        byteToHex[arr[offset + 3]] +
        '-' +
        byteToHex[arr[offset + 4]] +
        byteToHex[arr[offset + 5]] +
        '-' +
        byteToHex[arr[offset + 6]] +
        byteToHex[arr[offset + 7]] +
        '-' +
        byteToHex[arr[offset + 8]] +
        byteToHex[arr[offset + 9]] +
        '-' +
        byteToHex[arr[offset + 10]] +
        byteToHex[arr[offset + 11]] +
        byteToHex[arr[offset + 12]] +
        byteToHex[arr[offset + 13]] +
        byteToHex[arr[offset + 14]] +
        byteToHex[arr[offset + 15]]).toLowerCase();
}
function stringify(arr, offset = 0) {
    const uuid = unsafeStringify(arr, offset);
    if (!validate(uuid)) {
        throw TypeError('Stringified UUID is invalid');
    }
    return uuid;
}
/* harmony default export */ const esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));

;// ./node_modules/uuid/dist/esm-browser/v1.js


const _state = {};
function v1(options, buf, offset) {
    let bytes;
    const isV6 = options?._v6 ?? false;
    if (options) {
        const optionsKeys = Object.keys(options);
        if (optionsKeys.length === 1 && optionsKeys[0] === '_v6') {
            options = undefined;
        }
    }
    if (options) {
        bytes = v1Bytes(options.random ?? options.rng?.() ?? rng(), options.msecs, options.nsecs, options.clockseq, options.node, buf, offset);
    }
    else {
        const now = Date.now();
        const rnds = rng();
        updateV1State(_state, now, rnds);
        bytes = v1Bytes(rnds, _state.msecs, _state.nsecs, isV6 ? undefined : _state.clockseq, isV6 ? undefined : _state.node, buf, offset);
    }
    return buf ?? unsafeStringify(bytes);
}
function updateV1State(state, now, rnds) {
    state.msecs ??= -Infinity;
    state.nsecs ??= 0;
    if (now === state.msecs) {
        state.nsecs++;
        if (state.nsecs >= 10000) {
            state.node = undefined;
            state.nsecs = 0;
        }
    }
    else if (now > state.msecs) {
        state.nsecs = 0;
    }
    else if (now < state.msecs) {
        state.node = undefined;
    }
    if (!state.node) {
        state.node = rnds.slice(10, 16);
        state.node[0] |= 0x01;
        state.clockseq = ((rnds[8] << 8) | rnds[9]) & 0x3fff;
    }
    state.msecs = now;
    return state;
}
function v1Bytes(rnds, msecs, nsecs, clockseq, node, buf, offset = 0) {
    if (rnds.length < 16) {
        throw new Error('Random bytes length must be >= 16');
    }
    if (!buf) {
        buf = new Uint8Array(16);
        offset = 0;
    }
    else {
        if (offset < 0 || offset + 16 > buf.length) {
            throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        }
    }
    msecs ??= Date.now();
    nsecs ??= 0;
    clockseq ??= ((rnds[8] << 8) | rnds[9]) & 0x3fff;
    node ??= rnds.slice(10, 16);
    msecs += 12219292800000;
    const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    buf[offset++] = (tl >>> 24) & 0xff;
    buf[offset++] = (tl >>> 16) & 0xff;
    buf[offset++] = (tl >>> 8) & 0xff;
    buf[offset++] = tl & 0xff;
    const tmh = ((msecs / 0x100000000) * 10000) & 0xfffffff;
    buf[offset++] = (tmh >>> 8) & 0xff;
    buf[offset++] = tmh & 0xff;
    buf[offset++] = ((tmh >>> 24) & 0xf) | 0x10;
    buf[offset++] = (tmh >>> 16) & 0xff;
    buf[offset++] = (clockseq >>> 8) | 0x80;
    buf[offset++] = clockseq & 0xff;
    for (let n = 0; n < 6; ++n) {
        buf[offset++] = node[n];
    }
    return buf;
}
/* harmony default export */ const esm_browser_v1 = (v1);


/***/ }),

/***/ 26111:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


/***/ }),

/***/ 26308:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone:
                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                    '_'
                ),
        },
        monthsShort:
            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


/***/ }),

/***/ 26435:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),

/***/ 26710:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(56698)
var Sha256 = __webpack_require__(24107)
var Hash = __webpack_require__(90392)
var Buffer = (__webpack_require__(92861).Buffer)

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),

/***/ 26780:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var View = api.importMixinModule('bookingpayment', 'views', 'admin');
var AdminBookingPaymentView = /*#__PURE__*/function (_View) {
  function AdminBookingPaymentView() {
    _classCallCheck(this, AdminBookingPaymentView);
    return _callSuper(this, AdminBookingPaymentView, arguments);
  }
  _inherits(AdminBookingPaymentView, _View);
  return _createClass(AdminBookingPaymentView, null, [{
    key: "paymentStatusOptions",
    value: function paymentStatusOptions() {
      var adminActions = AdminBookingPaymentView.adminActions || AdminBookingPaymentView.paymentActions;
      return [{
        value: 'PENDING',
        label: 'Pending'
      }, {
        value: 'PAID',
        label: 'Paid',
        disabled: !adminActions
      },
      //{value: 'ON_ACCOUNT', label: 'Credit', disabled: !adminActions},
      {
        value: 'USED',
        label: 'Credit Used',
        disabled: !adminActions
      }, {
        value: 'CANCELED',
        label: 'Canceled',
        disabled: !adminActions
      }];
    }
  }, {
    key: "options",
    value: function options() {
      var adminActions = AdminBookingPaymentView.adminActions || AdminBookingPaymentView.paymentActions;
      var r = _superPropGet(AdminBookingPaymentView, "options", this, 2)([]);
      var p1 = {
        name: 'InvoiceTotal',
        label: 'Invoices Total',
        headerField: true,
        readonly: true,
        editor: 'number',
        hideFromList: true,
        decimal: 2,
        columns: 2,
        computed: function computed(record) {
          var v = 0;
          var _iterator = _createForOfIteratorHelper(record.PaymentPurchaseInvoices),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var row = _step.value;
              if (row.Amount) v += row.Amount;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return v;
        },
        hidden: !adminActions
      };
      var p2 = {
        name: 'Balance',
        label: 'Balance',
        headerField: true,
        readonly: true,
        editor: 'number',
        hideFromList: true,
        decimal: 2,
        columns: 2,
        computed: function computed(record) {
          var r = parseFloat(record.PaymentAmount) - parseFloat(record.InvoiceTotal);
          return r || 0;
        },
        hidden: !adminActions
      };
      var p3 = {
        name: 'PaymentPurchaseInvoices',
        editor: [],
        label: 'Detail',
        hidden: !adminActions,
        rowFields: [{
          name: 'id',
          hidden: true
        }, {
          name: 'PurchaseInvoiceId',
          relation: 'purchaseinvoice',
          optionLabels: function optionLabels(row) {
            return row.InvoiceNumber;
          },
          columns: 2,
          label: 'Invoice',
          editor: 'vue-select',
          endpoint: '/api/purchaseinvoice/get_pending/',
          endpointFilters: function endpointFilters(record) {
            if (record && record.SupplierId) {
              var res = {};
              res.SupplierId = record.SupplierId;
              return res;
            }
            return {};
          },
          setRelationTo: 'PurchaseInvoice'
        }, {
          name: 'Amount',
          label: 'Amount',
          editor: 'number',
          columns: 2,
          decimal: 2
        }, {
          name: 'PurchaseInvoiceTotal',
          label: 'Invoice Total',
          editor: 'number',
          columns: 2,
          decimal: 2,
          readonly: true,
          computed: function computed(row) {
            if (row.PurchaseInvoice) return row.PurchaseInvoice.Total;
          }
        }, {
          name: 'PurchaseInvoiceCurrencyId',
          relation: 'currency',
          optionLabels: 'id',
          disabled: true,
          editor: 'select',
          label: 'Currency',
          columns: 1,
          computed: function computed(row) {
            if (row.PurchaseInvoice) return row.PurchaseInvoice.CurrencyId;
          }
        }, {
          name: 'PurchaseInvoiceBalance',
          label: 'Invoice Balance',
          editor: 'number',
          columns: 2,
          decimal: 2,
          readonly: true,
          computed: function computed(row) {
            if (row.PurchaseInvoice) return row.PurchaseInvoice.Balance;
          }
        }, {
          name: 'InvoiceAmount',
          label: 'Applied Amount',
          editor: 'number',
          columns: 2,
          decimal: 2,
          computed: function computed(row) {
            if (row.PurchaseInvoice) {
              if (row.$parent.PaymentCurrencyId == row.PurchaseInvoice.CurrencyId) {
                return row.Amount;
              }
              return row.InvoiceAmount;
            }
            return row.InvoiceAmount;
          }
        }]
      };
      r.fields.push(p1);
      r.fields.push(p2);
      r.fields.push(p3);
      var supplierField = _.find(r.fields, function (f) {
        return f.name == 'SupplierId';
      });
      supplierField.afterEdit = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(self, newVal, oldVal) {
          var fo, field, rowField, rowId, row;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                fo = {};
                field = _.find(self.fields, function (r) {
                  return r.name == 'PaymentPurchaseInvoices';
                });
                if (field) {
                  _context.next = 4;
                  break;
                }
                return _context.abrupt("return");
              case 4:
                rowField = _.find(field.rowFields, function (r) {
                  return r.name == 'PurchaseInvoiceId';
                });
                if (!rowField) {
                  _context.next = 14;
                  break;
                }
                _context.t0 = _regeneratorRuntime().keys(self.PaymentPurchaseInvoices);
              case 7:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 14;
                  break;
                }
                rowId = _context.t1.value;
                row = self.PaymentPurchaseInvoices[rowId];
                _context.next = 12;
                return tools.calculateFieldOptionsByField(rowField, fo, false, row);
              case 12:
                _context.next = 7;
                break;
              case 14:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x, _x2, _x3) {
          return _ref.apply(this, arguments);
        };
      }();
      supplierField.disabledIf = function (record) {
        return record.PaymentPurchaseInvoices && record.PaymentPurchaseInvoices.length > 0;
      };
      return r;
    }
  }]);
}(View);
_defineProperty(AdminBookingPaymentView, "adminMenu", tools.canAccess(api.currentUser, "view", "GET", 'admin_menu', false));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AdminBookingPaymentView);

/***/ }),

/***/ 27088:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


/***/ }),

/***/ 27403:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


//all requires must be explicit because browserify won't work with dynamic requires
module.exports = {
  '$ref': __webpack_require__(6990),
  allOf: __webpack_require__(80353),
  anyOf: __webpack_require__(29480),
  '$comment': __webpack_require__(14278),
  const: __webpack_require__(10224),
  contains: __webpack_require__(35674),
  dependencies: __webpack_require__(41926),
  'enum': __webpack_require__(80598),
  format: __webpack_require__(80400),
  'if': __webpack_require__(88532),
  items: __webpack_require__(54371),
  maximum: __webpack_require__(74667),
  minimum: __webpack_require__(74667),
  maxItems: __webpack_require__(52119),
  minItems: __webpack_require__(52119),
  maxLength: __webpack_require__(47935),
  minLength: __webpack_require__(47935),
  maxProperties: __webpack_require__(51298),
  minProperties: __webpack_require__(51298),
  multipleOf: __webpack_require__(99294),
  not: __webpack_require__(48914),
  oneOf: __webpack_require__(95326),
  pattern: __webpack_require__(8317),
  properties: __webpack_require__(41374),
  propertyNames: __webpack_require__(23032),
  required: __webpack_require__(47850),
  uniqueItems: __webpack_require__(85898),
  validate: __webpack_require__(51873)
};


/***/ }),

/***/ 27800:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ _unsupportedIterableToArray)
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43145);

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(r, a) : void 0;
  }
}


/***/ }),

/***/ 27816:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__(56698)
var Hash = __webpack_require__(90392)
var Buffer = (__webpack_require__(92861).Buffer)

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),

/***/ 28019:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var compileSchema = __webpack_require__(7354)
  , resolve = __webpack_require__(91030)
  , Cache = __webpack_require__(94006)
  , SchemaObject = __webpack_require__(2585)
  , stableStringify = __webpack_require__(72492)
  , formats = __webpack_require__(45950)
  , rules = __webpack_require__(73845)
  , $dataMetaSchema = __webpack_require__(24278)
  , util = __webpack_require__(96740);

module.exports = Ajv;

Ajv.prototype.validate = validate;
Ajv.prototype.compile = compile;
Ajv.prototype.addSchema = addSchema;
Ajv.prototype.addMetaSchema = addMetaSchema;
Ajv.prototype.validateSchema = validateSchema;
Ajv.prototype.getSchema = getSchema;
Ajv.prototype.removeSchema = removeSchema;
Ajv.prototype.addFormat = addFormat;
Ajv.prototype.errorsText = errorsText;

Ajv.prototype._addSchema = _addSchema;
Ajv.prototype._compile = _compile;

Ajv.prototype.compileAsync = __webpack_require__(4686);
var customKeyword = __webpack_require__(96016);
Ajv.prototype.addKeyword = customKeyword.add;
Ajv.prototype.getKeyword = customKeyword.get;
Ajv.prototype.removeKeyword = customKeyword.remove;
Ajv.prototype.validateKeyword = customKeyword.validate;

var errorClasses = __webpack_require__(64551);
Ajv.ValidationError = errorClasses.Validation;
Ajv.MissingRefError = errorClasses.MissingRef;
Ajv.$dataMetaSchema = $dataMetaSchema;

var META_SCHEMA_ID = 'http://json-schema.org/draft-07/schema';

var META_IGNORE_OPTIONS = [ 'removeAdditional', 'useDefaults', 'coerceTypes', 'strictDefaults' ];
var META_SUPPORT_DATA = ['/properties'];

/**
 * Creates validator instance.
 * Usage: `Ajv(opts)`
 * @param {Object} opts optional options
 * @return {Object} ajv instance
 */
function Ajv(opts) {
  if (!(this instanceof Ajv)) return new Ajv(opts);
  opts = this._opts = util.copy(opts) || {};
  setLogger(this);
  this._schemas = {};
  this._refs = {};
  this._fragments = {};
  this._formats = formats(opts.format);

  this._cache = opts.cache || new Cache;
  this._loadingSchemas = {};
  this._compilations = [];
  this.RULES = rules();
  this._getId = chooseGetId(opts);

  opts.loopRequired = opts.loopRequired || Infinity;
  if (opts.errorDataPath == 'property') opts._errorDataPathProperty = true;
  if (opts.serialize === undefined) opts.serialize = stableStringify;
  this._metaOpts = getMetaSchemaOptions(this);

  if (opts.formats) addInitialFormats(this);
  if (opts.keywords) addInitialKeywords(this);
  addDefaultMetaSchema(this);
  if (typeof opts.meta == 'object') this.addMetaSchema(opts.meta);
  if (opts.nullable) this.addKeyword('nullable', {metaSchema: {type: 'boolean'}});
  addInitialSchemas(this);
}



/**
 * Validate data using schema
 * Schema will be compiled and cached (using serialized JSON as key. [fast-json-stable-stringify](https://github.com/epoberezkin/fast-json-stable-stringify) is used to serialize.
 * @this   Ajv
 * @param  {String|Object} schemaKeyRef key, ref or schema object
 * @param  {Any} data to be validated
 * @return {Boolean} validation result. Errors from the last validation will be available in `ajv.errors` (and also in compiled schema: `schema.errors`).
 */
function validate(schemaKeyRef, data) {
  var v;
  if (typeof schemaKeyRef == 'string') {
    v = this.getSchema(schemaKeyRef);
    if (!v) throw new Error('no schema with key or ref "' + schemaKeyRef + '"');
  } else {
    var schemaObj = this._addSchema(schemaKeyRef);
    v = schemaObj.validate || this._compile(schemaObj);
  }

  var valid = v(data);
  if (v.$async !== true) this.errors = v.errors;
  return valid;
}


/**
 * Create validating function for passed schema.
 * @this   Ajv
 * @param  {Object} schema schema object
 * @param  {Boolean} _meta true if schema is a meta-schema. Used internally to compile meta schemas of custom keywords.
 * @return {Function} validating function
 */
function compile(schema, _meta) {
  var schemaObj = this._addSchema(schema, undefined, _meta);
  return schemaObj.validate || this._compile(schemaObj);
}


/**
 * Adds schema to the instance.
 * @this   Ajv
 * @param {Object|Array} schema schema or array of schemas. If array is passed, `key` and other parameters will be ignored.
 * @param {String} key Optional schema key. Can be passed to `validate` method instead of schema object or id/ref. One schema per instance can have empty `id` and `key`.
 * @param {Boolean} _skipValidation true to skip schema validation. Used internally, option validateSchema should be used instead.
 * @param {Boolean} _meta true if schema is a meta-schema. Used internally, addMetaSchema should be used instead.
 * @return {Ajv} this for method chaining
 */
function addSchema(schema, key, _skipValidation, _meta) {
  if (Array.isArray(schema)){
    for (var i=0; i<schema.length; i++) this.addSchema(schema[i], undefined, _skipValidation, _meta);
    return this;
  }
  var id = this._getId(schema);
  if (id !== undefined && typeof id != 'string')
    throw new Error('schema id must be string');
  key = resolve.normalizeId(key || id);
  checkUnique(this, key);
  this._schemas[key] = this._addSchema(schema, _skipValidation, _meta, true);
  return this;
}


/**
 * Add schema that will be used to validate other schemas
 * options in META_IGNORE_OPTIONS are alway set to false
 * @this   Ajv
 * @param {Object} schema schema object
 * @param {String} key optional schema key
 * @param {Boolean} skipValidation true to skip schema validation, can be used to override validateSchema option for meta-schema
 * @return {Ajv} this for method chaining
 */
function addMetaSchema(schema, key, skipValidation) {
  this.addSchema(schema, key, skipValidation, true);
  return this;
}


/**
 * Validate schema
 * @this   Ajv
 * @param {Object} schema schema to validate
 * @param {Boolean} throwOrLogError pass true to throw (or log) an error if invalid
 * @return {Boolean} true if schema is valid
 */
function validateSchema(schema, throwOrLogError) {
  var $schema = schema.$schema;
  if ($schema !== undefined && typeof $schema != 'string')
    throw new Error('$schema must be a string');
  $schema = $schema || this._opts.defaultMeta || defaultMeta(this);
  if (!$schema) {
    this.logger.warn('meta-schema not available');
    this.errors = null;
    return true;
  }
  var valid = this.validate($schema, schema);
  if (!valid && throwOrLogError) {
    var message = 'schema is invalid: ' + this.errorsText();
    if (this._opts.validateSchema == 'log') this.logger.error(message);
    else throw new Error(message);
  }
  return valid;
}


function defaultMeta(self) {
  var meta = self._opts.meta;
  self._opts.defaultMeta = typeof meta == 'object'
                            ? self._getId(meta) || meta
                            : self.getSchema(META_SCHEMA_ID)
                              ? META_SCHEMA_ID
                              : undefined;
  return self._opts.defaultMeta;
}


/**
 * Get compiled schema from the instance by `key` or `ref`.
 * @this   Ajv
 * @param  {String} keyRef `key` that was passed to `addSchema` or full schema reference (`schema.id` or resolved id).
 * @return {Function} schema validating function (with property `schema`).
 */
function getSchema(keyRef) {
  var schemaObj = _getSchemaObj(this, keyRef);
  switch (typeof schemaObj) {
    case 'object': return schemaObj.validate || this._compile(schemaObj);
    case 'string': return this.getSchema(schemaObj);
    case 'undefined': return _getSchemaFragment(this, keyRef);
  }
}


function _getSchemaFragment(self, ref) {
  var res = resolve.schema.call(self, { schema: {} }, ref);
  if (res) {
    var schema = res.schema
      , root = res.root
      , baseId = res.baseId;
    var v = compileSchema.call(self, schema, root, undefined, baseId);
    self._fragments[ref] = new SchemaObject({
      ref: ref,
      fragment: true,
      schema: schema,
      root: root,
      baseId: baseId,
      validate: v
    });
    return v;
  }
}


function _getSchemaObj(self, keyRef) {
  keyRef = resolve.normalizeId(keyRef);
  return self._schemas[keyRef] || self._refs[keyRef] || self._fragments[keyRef];
}


/**
 * Remove cached schema(s).
 * If no parameter is passed all schemas but meta-schemas are removed.
 * If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
 * Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
 * @this   Ajv
 * @param  {String|Object|RegExp} schemaKeyRef key, ref, pattern to match key/ref or schema object
 * @return {Ajv} this for method chaining
 */
function removeSchema(schemaKeyRef) {
  if (schemaKeyRef instanceof RegExp) {
    _removeAllSchemas(this, this._schemas, schemaKeyRef);
    _removeAllSchemas(this, this._refs, schemaKeyRef);
    return this;
  }
  switch (typeof schemaKeyRef) {
    case 'undefined':
      _removeAllSchemas(this, this._schemas);
      _removeAllSchemas(this, this._refs);
      this._cache.clear();
      return this;
    case 'string':
      var schemaObj = _getSchemaObj(this, schemaKeyRef);
      if (schemaObj) this._cache.del(schemaObj.cacheKey);
      delete this._schemas[schemaKeyRef];
      delete this._refs[schemaKeyRef];
      return this;
    case 'object':
      var serialize = this._opts.serialize;
      var cacheKey = serialize ? serialize(schemaKeyRef) : schemaKeyRef;
      this._cache.del(cacheKey);
      var id = this._getId(schemaKeyRef);
      if (id) {
        id = resolve.normalizeId(id);
        delete this._schemas[id];
        delete this._refs[id];
      }
  }
  return this;
}


function _removeAllSchemas(self, schemas, regex) {
  for (var keyRef in schemas) {
    var schemaObj = schemas[keyRef];
    if (!schemaObj.meta && (!regex || regex.test(keyRef))) {
      self._cache.del(schemaObj.cacheKey);
      delete schemas[keyRef];
    }
  }
}


/* @this   Ajv */
function _addSchema(schema, skipValidation, meta, shouldAddSchema) {
  if (typeof schema != 'object' && typeof schema != 'boolean')
    throw new Error('schema should be object or boolean');
  var serialize = this._opts.serialize;
  var cacheKey = serialize ? serialize(schema) : schema;
  var cached = this._cache.get(cacheKey);
  if (cached) return cached;

  shouldAddSchema = shouldAddSchema || this._opts.addUsedSchema !== false;

  var id = resolve.normalizeId(this._getId(schema));
  if (id && shouldAddSchema) checkUnique(this, id);

  var willValidate = this._opts.validateSchema !== false && !skipValidation;
  var recursiveMeta;
  if (willValidate && !(recursiveMeta = id && id == resolve.normalizeId(schema.$schema)))
    this.validateSchema(schema, true);

  var localRefs = resolve.ids.call(this, schema);

  var schemaObj = new SchemaObject({
    id: id,
    schema: schema,
    localRefs: localRefs,
    cacheKey: cacheKey,
    meta: meta
  });

  if (id[0] != '#' && shouldAddSchema) this._refs[id] = schemaObj;
  this._cache.put(cacheKey, schemaObj);

  if (willValidate && recursiveMeta) this.validateSchema(schema, true);

  return schemaObj;
}


/* @this   Ajv */
function _compile(schemaObj, root) {
  if (schemaObj.compiling) {
    schemaObj.validate = callValidate;
    callValidate.schema = schemaObj.schema;
    callValidate.errors = null;
    callValidate.root = root ? root : callValidate;
    if (schemaObj.schema.$async === true)
      callValidate.$async = true;
    return callValidate;
  }
  schemaObj.compiling = true;

  var currentOpts;
  if (schemaObj.meta) {
    currentOpts = this._opts;
    this._opts = this._metaOpts;
  }

  var v;
  try { v = compileSchema.call(this, schemaObj.schema, root, schemaObj.localRefs); }
  catch(e) {
    delete schemaObj.validate;
    throw e;
  }
  finally {
    schemaObj.compiling = false;
    if (schemaObj.meta) this._opts = currentOpts;
  }

  schemaObj.validate = v;
  schemaObj.refs = v.refs;
  schemaObj.refVal = v.refVal;
  schemaObj.root = v.root;
  return v;


  /* @this   {*} - custom context, see passContext option */
  function callValidate() {
    /* jshint validthis: true */
    var _validate = schemaObj.validate;
    var result = _validate.apply(this, arguments);
    callValidate.errors = _validate.errors;
    return result;
  }
}


function chooseGetId(opts) {
  switch (opts.schemaId) {
    case 'auto': return _get$IdOrId;
    case 'id': return _getId;
    default: return _get$Id;
  }
}

/* @this   Ajv */
function _getId(schema) {
  if (schema.$id) this.logger.warn('schema $id ignored', schema.$id);
  return schema.id;
}

/* @this   Ajv */
function _get$Id(schema) {
  if (schema.id) this.logger.warn('schema id ignored', schema.id);
  return schema.$id;
}


function _get$IdOrId(schema) {
  if (schema.$id && schema.id && schema.$id != schema.id)
    throw new Error('schema $id is different from id');
  return schema.$id || schema.id;
}


/**
 * Convert array of error message objects to string
 * @this   Ajv
 * @param  {Array<Object>} errors optional array of validation errors, if not passed errors from the instance are used.
 * @param  {Object} options optional options with properties `separator` and `dataVar`.
 * @return {String} human readable string with all errors descriptions
 */
function errorsText(errors, options) {
  errors = errors || this.errors;
  if (!errors) return 'No errors';
  options = options || {};
  var separator = options.separator === undefined ? ', ' : options.separator;
  var dataVar = options.dataVar === undefined ? 'data' : options.dataVar;

  var text = '';
  for (var i=0; i<errors.length; i++) {
    var e = errors[i];
    if (e) text += dataVar + e.dataPath + ' ' + e.message + separator;
  }
  return text.slice(0, -separator.length);
}


/**
 * Add custom format
 * @this   Ajv
 * @param {String} name format name
 * @param {String|RegExp|Function} format string is converted to RegExp; function should return boolean (true when valid)
 * @return {Ajv} this for method chaining
 */
function addFormat(name, format) {
  if (typeof format == 'string') format = new RegExp(format);
  this._formats[name] = format;
  return this;
}


function addDefaultMetaSchema(self) {
  var $dataSchema;
  if (self._opts.$data) {
    $dataSchema = __webpack_require__(53420);
    self.addMetaSchema($dataSchema, $dataSchema.$id, true);
  }
  if (self._opts.meta === false) return;
  var metaSchema = __webpack_require__(8198);
  if (self._opts.$data) metaSchema = $dataMetaSchema(metaSchema, META_SUPPORT_DATA);
  self.addMetaSchema(metaSchema, META_SCHEMA_ID, true);
  self._refs['http://json-schema.org/schema'] = META_SCHEMA_ID;
}


function addInitialSchemas(self) {
  var optsSchemas = self._opts.schemas;
  if (!optsSchemas) return;
  if (Array.isArray(optsSchemas)) self.addSchema(optsSchemas);
  else for (var key in optsSchemas) self.addSchema(optsSchemas[key], key);
}


function addInitialFormats(self) {
  for (var name in self._opts.formats) {
    var format = self._opts.formats[name];
    self.addFormat(name, format);
  }
}


function addInitialKeywords(self) {
  for (var name in self._opts.keywords) {
    var keyword = self._opts.keywords[name];
    self.addKeyword(name, keyword);
  }
}


function checkUnique(self, id) {
  if (self._schemas[id] || self._refs[id])
    throw new Error('schema with key or id "' + id + '" already exists');
}


function getMetaSchemaOptions(self) {
  var metaOpts = util.copy(self._opts);
  for (var i=0; i<META_IGNORE_OPTIONS.length; i++)
    delete metaOpts[META_IGNORE_OPTIONS[i]];
  return metaOpts;
}


function setLogger(self) {
  var logger = self._opts.logger;
  if (logger === false) {
    self.logger = {log: noop, warn: noop, error: noop};
  } else {
    if (logger === undefined) logger = console;
    if (!(typeof logger == 'object' && logger.log && logger.warn && logger.error))
      throw new Error('logger must implement log, warn and error methods');
    self.logger = logger;
  }
}


function noop() {}


/***/ }),

/***/ 28298:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),

/***/ 28399:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(45412);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(16708);
exports.Duplex = __webpack_require__(25382);
exports.Transform = __webpack_require__(74610);
exports.PassThrough = __webpack_require__(63600);


/***/ }),

/***/ 28490:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = (__webpack_require__(79368).Buffer);
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);


/***/ }),

/***/ 28545:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var BN = __webpack_require__(28490);

var utils = __webpack_require__(47011);
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;

  // Indefinite length or overflow
  if (octetLen === 0 || octetLen > 4) {
    return false;
  }

  if(buf[p.place] === 0x00) {
    return false;
  }

  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
    val >>>= 0;
  }

  // Leading zeroes
  if (val <= 0x7f) {
    return false;
  }

  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if (len === false) {
    return false;
  }
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  if (rlen === false) {
    return false;
  }
  if ((data[p.place] & 128) !== 0) {
    return false;
  }
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (slen === false) {
    return false;
  }
  if (data.length !== slen + p.place) {
    return false;
  }
  if ((data[p.place] & 128) !== 0) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0) {
    if (r[1] & 0x80) {
      r = r.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }
  if (s[0] === 0) {
    if (s[1] & 0x80) {
      s = s.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};


/***/ }),

/***/ 28861:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


/***/ }),

/***/ 28902:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var parseKeys = __webpack_require__(78170)
var randomBytes = __webpack_require__(53209)
var createHash = __webpack_require__(47108)
var mgf = __webpack_require__(48206)
var xor = __webpack_require__(52061)
var BN = __webpack_require__(82509)
var withPublic = __webpack_require__(99247)
var crt = __webpack_require__(67332)
var Buffer = (__webpack_require__(92861).Buffer)

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}


/***/ }),

/***/ 28948:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(67426);
var assert = __webpack_require__(43349);

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),

/***/ 28959:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone:
                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                    '_'
                ),
        },
        monthsShort:
            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone:
                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                    '_'
                ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


/***/ }),

/***/ 29063:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51941);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ServiceQuoteList = /*#__PURE__*/function (_BookingBaseModel) {
  function ServiceQuoteList(obj) {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, ServiceQuoteList);
    tools.clean(obj.record);
    if (!obj.fields) obj.fields = [];
    if (obj.record) {
      for (var key in obj.record) {
        if (isNaN(parseInt(key))) continue;
        obj.fields.push({
          name: key,
          editor: {},
          objectClass: 'servicequote'
        });
      }
    }
    return _callSuper(this, ServiceQuoteList, [obj]);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(ServiceQuoteList, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(ServiceQuoteList, [{
    key: "booking",
    get: function get() {
      return this.$parent.$parent.$parent.$parent;
    }
  }, {
    key: "bases",
    get: function get() {
      return tools.getBases(_.cloneDeep(this));
    }
  }, {
    key: "getFields",
    value: function getFields() {
      var res = [];
      for (var key in this.bases) {
        res.push({
          name: key,
          editor: {},
          objectClass: 'servicequote'
        });
      }
      this.fields = res;
    }
  }, {
    key: "newServiceQuote",
    value: function () {
      var _newServiceQuote = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(obj, copy) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.newObject({
                objectClass: 'servicequote'
              }, obj, null, copy);
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function newServiceQuote(_x, _x2) {
        return _newServiceQuote.apply(this, arguments);
      }
      return newServiceQuote;
    }()
  }, {
    key: "setVariants",
    value: function setVariants() {
      if (this.booking.QuoteVariants) {
        for (var baseId in this.bases) {
          if (!this.booking.isVariant(baseId)) continue;
          if (!this[baseId].Variants) this[baseId].Variants = {};
          for (var variantId in this.booking.QuoteVariants[baseId]) {
            if (tools.isNull(this[baseId].Variants[variantId])) this[baseId].Variants[variantId] = true;
          }
        }
      }
    }
  }, {
    key: "setGroups",
    value: function setGroups() {
      var booking = this.$parent.$parent.$parent.$parent;
      if (!booking.quoteService) return;
      if (booking.QuoteGroups) {
        for (var baseId in this.bases) {
          if (!booking.isGroup(baseId)) continue;
          if (!this[baseId].Groups) this[baseId].Groups = {};
          for (var groupId in booking.QuoteGroups[baseId]) {
            if (tools.isNull(this[baseId].Groups[groupId])) this[baseId].Groups[groupId] = true;
          }
        }
      }
    }
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(ServiceQuoteList, "invalidated_cache", _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__["default"].invalidated_cache_services);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(ServiceQuoteList, "moduleName", 'servicequotelist');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ServiceQuoteList);

/***/ }),

/***/ 29231:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


/***/ }),

/***/ 29480:
/***/ ((module) => {

"use strict";

module.exports = function generate_anyOf(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $noEmptySchema = $schema.every(function($sch) {
    return (it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all));
  });
  if ($noEmptySchema) {
    var $currentBaseId = $it.baseId;
    out += ' var ' + ($errs) + ' = errors; var ' + ($valid) + ' = false;  ';
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    var arr1 = $schema;
    if (arr1) {
      var $sch, $i = -1,
        l1 = arr1.length - 1;
      while ($i < l1) {
        $sch = arr1[$i += 1];
        $it.schema = $sch;
        $it.schemaPath = $schemaPath + '[' + $i + ']';
        $it.errSchemaPath = $errSchemaPath + '/' + $i;
        out += '  ' + (it.validate($it)) + ' ';
        $it.baseId = $currentBaseId;
        out += ' ' + ($valid) + ' = ' + ($valid) + ' || ' + ($nextValid) + '; if (!' + ($valid) + ') { ';
        $closingBraces += '}';
      }
    }
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += ' ' + ($closingBraces) + ' if (!' + ($valid) + ') {   var err =   '; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('anyOf') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should match some schema in anyOf\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError(vErrors); ';
      } else {
        out += ' validate.errors = vErrors; return false; ';
      }
    }
    out += ' } else {  errors = ' + ($errs) + '; if (vErrors !== null) { if (' + ($errs) + ') vErrors.length = ' + ($errs) + '; else vErrors = null; } ';
    if (it.opts.allErrors) {
      out += ' } ';
    }
  } else {
    if ($breakOnError) {
      out += ' if (true) { ';
    }
  }
  return out;
}


/***/ }),

/***/ 29560:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


exports.utils = __webpack_require__(87626);
exports.Cipher = __webpack_require__(82808);
exports.DES = __webpack_require__(82211);
exports.CBC = __webpack_require__(3389);
exports.EDE = __webpack_require__(65279);


/***/ }),

/***/ 29721:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);




function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var TravelTools = /*#__PURE__*/function () {
  function TravelTools() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(this, TravelTools);
  }
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(TravelTools, [{
    key: "currencyConvert",
    value: function currencyConvert(fromCurrency, toCurrency, value, rates) {
      if (!value) return 0;
      if (fromCurrency == toCurrency) return value;
      for (var key in rates) {
        if (!tools.isNormalInteger(key)) continue;
        var cc = rates[key];
        if (fromCurrency == cc.FromCurrencyId && toCurrency == cc.ToCurrencyId) return value * cc.Rate;
        if (fromCurrency == cc.ToCurrencyId && toCurrency == cc.FromCurrencyId) return value / cc.Rate;
      }
      var r = this.convertWithPivot(fromCurrency, toCurrency, value, rates);
      if (r) return r;
      r = this.convertWithPivot(fromCurrency, toCurrency, value, api.CurrencyRates);
      if (r) return r;
      return value;
    }
  }, {
    key: "convertWithPivot",
    value: function convertWithPivot(fromCurrency, toCurrency, value, rates) {
      var pivot;
      for (var key in rates) {
        if (!tools.isNormalInteger(key)) continue;
        var cc = rates[key];
        if (fromCurrency == cc.FromCurrencyId) {
          pivot = cc.ToCurrencyId;
          for (var key2 in rates.bases) {
            var cc2 = rates[key2];
            if (toCurrency == cc2.ToCurrencyId && pivot == cc2.FromCurrencyId) {
              return this.currencyConvertPivot(fromCurrency, toCurrency, value, rates, pivot);
            }
          }
        }
        if (fromCurrency == cc.ToCurrencyId) {
          pivot = cc.FromCurrencyId;
          for (var _key in rates) {
            if (!tools.isNormalInteger(_key)) continue;
            var _cc = rates[_key];
            if (toCurrency == _cc.FromCurrencyId && pivot == _cc.ToCurrencyId) {
              return this.currencyConvertPivot(fromCurrency, toCurrency, value, rates, pivot);
            }
            if (toCurrency == _cc.ToCurrencyId && pivot == _cc.FromCurrencyId) {
              return this.currencyConvertPivot(fromCurrency, toCurrency, value, rates, pivot);
            }
          }
        }
      }
    }
  }, {
    key: "currencyConvertPivot",
    value: function currencyConvertPivot(fromCurrency, toCurrency, value, rates, pivot) {
      var r = this.currencyConvert(fromCurrency, pivot, value, rates);
      return this.currencyConvert(pivot, toCurrency, r, rates);
    }
  }, {
    key: "parseNumberString",
    value: function parseNumberString(str) {
      if (typeof str !== 'string') {
        str = String(str);
      }
      // Si contiene coma, asumimos formato europeo (punto = miles, coma = decimal)
      if (str.includes(',')) {
        // Removemos los puntos (separadores de miles) y reemplazamos la coma por punto
        return parseFloat(str.replace(/\./g, '').replace(',', '.'));
      }
      // Si no contiene coma, asumimos formato inglés (punto = decimal)
      return parseFloat(str);
    }
  }, {
    key: "getAPIRates",
    value: function getAPIRates(data, cc) {
      var rate;
      try {
        var fields = cc.JSONFields.split(';');
        var getValue = function getValue(obj, path) {
          if (!path) return undefined;
          path = path.trim();
          var keys = path.split('.');
          var value = obj;
          var _iterator = _createForOfIteratorHelper(keys),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var key = _step.value;
              if (value === null || value === undefined) return undefined;
              value = value[key];
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return value;
        };
        var value1 = getValue(data, fields[0]);
        var value2 = getValue(data, fields[1]);
        if (value1 === undefined || value2 === undefined) {
          return;
        }
        var rate1 = this.parseNumberString(value1);
        var rate2 = this.parseNumberString(value2);
        if (isNaN(rate1) || isNaN(rate2)) {
          return;
        }
        if (rate1 == rate2) {
          return rate1;
        }
        rate = (rate1 + rate2) / 2;
      } catch (err) {
        return;
      }
      return rate;
    }
  }, {
    key: "getCurrencyRate",
    value: function () {
      var _getCurrencyRate = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(cc, type) {
        var res, _res, e, data, _res2, rate;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(cc.ConversionType == 'TABLE')) {
                _context.next = 16;
                break;
              }
              if (!type) {
                _context.next = 9;
                break;
              }
              _context.next = 4;
              return api.get('/api/currencyrate/get_pair/' + type + '/' + cc.FromCurrencyId + '/' + cc.ToCurrencyId);
            case 4:
              res = _context.sent;
              if (!res) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return", res);
            case 7:
              _context.next = 14;
              break;
            case 9:
              _context.next = 11;
              return api.get('/api/currencyrate/get_pairs/' + cc.FromCurrencyId + '/' + cc.ToCurrencyId);
            case 11:
              _res = _context.sent;
              if (!_res) {
                _context.next = 14;
                break;
              }
              return _context.abrupt("return", _res);
            case 14:
              _context.next = 29;
              break;
            case 16:
              if (!(cc.ConversionType == 'API')) {
                _context.next = 29;
                break;
              }
              e = 'Currency rate not found for ' + cc.FromCurrencyId + ' / ' + cc.ToCurrencyId;
              _context.next = 20;
              return api.get('/api/currencyrate/get_from_url/' + cc.id);
            case 20:
              _res2 = _context.sent;
              if (_res2) {
                data = _res2;
              }
              if (data) {
                rate = this.getAPIRates(data, cc);
              }
              if (!rate) {
                _context.next = 27;
                break;
              }
              return _context.abrupt("return", {
                FromCurrencyId: cc.FromCurrencyId,
                ToCurrencyId: cc.ToCurrencyId,
                ConversionRate: rate
              });
            case 27:
              alert(e);
              return _context.abrupt("return", {
                FromCurrencyId: cc.FromCurrencyId,
                ToCurrencyId: cc.ToCurrencyId,
                ConversionRate: null
              });
            case 29:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getCurrencyRate(_x, _x2) {
        return _getCurrencyRate.apply(this, arguments);
      }
      return getCurrencyRate;
    }()
  }, {
    key: "getCostForBase",
    value: function getCostForBase(costData, base, pType, commission, quoteBy, extraSeat, tourLeader) {
      var _base = base;
      if (base && extraSeat) _base += -1;
      if (base && tourLeader && !costData.TourLeader) _base += 1;
      var res = {
        cost: null,
        originCost: null
      };
      var tourLeaderFactor = _base / base;
      if (quoteBy == 'QUANTITY') tourLeaderFactor = 1;
      var costBy;
      if (costData.CostBy) costBy = costData.CostBy;
      if (!costBy && costData.Service.CostBy) costBy = costData.Service.CostBy;
      if (!costBy && costData.Service.ServiceType) costBy = costData.Service.ServiceType.CostBy;
      if (!costBy && costData.Service.ServiceType) costBy = 'PERSON';
      if (costBy == 'PERSON') {
        res.cost = costData.Data[pType] ? parseFloat(costData.Data[pType]) : 0;
        res.originCost = res.cost;
        if (pType == 'CHD' && !costData.Data[pType]) res.cost = costData.Data['ADT'];
        if (pType == 'TL' && !costData.Data[pType]) res.cost = costData.Data['ADT'];
        if (tourLeader && !costData.TourLeader && pType == 'ADT') {
          res.cost = res.cost * tourLeaderFactor;
          res.originCost = res.originCost * tourLeaderFactor;
        } else if (tourLeader && !costData.TourLeader && pType == 'CHD') {
          var adtCost = costData.Data.ADT;
          if (adtCost) {
            res.cost = res.cost + adtCost / base;
            res.originCost = res.originCost + adtCost / base;
          } else {
            res.cost = res.cost * tourLeaderFactor;
            res.originCost = res.originCost * tourLeaderFactor;
          }
        }
      } else {
        var data = {};
        var extra;
        for (var b in costData.Data) {
          if (b == 'Extra') {
            extra = costData.Data[b] ? parseFloat(costData.Data[b]) : 0;
          }
        }
        var max;
        var maxCost;
        for (var _b in costData.Data) {
          if (costBy == 'SERVICE' && _b == '1') {
            data[_base] = costData.Data[_b] ? parseFloat(costData.Data[_b]) : 0;
          } else {
            if (_b.includes(':')) {
              var range = _b.split(':');
              var fromValue = parseInt(range[0]);
              var toValue = parseInt(range[1]);
              if (extra && costData.Data[_b]) {
                if (!max || toValue > max) {
                  max = toValue;
                  maxCost = costData.Data[_b] ? parseFloat(costData.Data[_b]) : 0;
                }
              }
              if (!toValue || isNaN(toValue)) toValue = fromValue;
              for (var i = fromValue; i <= toValue; i++) {
                var _dataNull = tools.isNull(costData.Data[_b]);
                if (!_dataNull) {
                  data[i] = costData.Data[_b] ? parseFloat(costData.Data[_b]) : 0;
                }
              }
            } else if (costData.Data[_b]) {
              data[_b] = costData.Data[_b] ? parseFloat(costData.Data[_b]) : 0;
              if (costData.Data[_b] && extra) {
                if (!max || parseInt(_b) > max) {
                  max = parseInt(_b);
                  maxCost = costData.Data[_b] ? parseFloat(costData.Data[_b]) : 0;
                }
              }
            }
          }
        }
        if (max && extra && _base > max && costBy == 'BASE_SERVICE') {
          var extras = _base - max;
          var value = parseFloat(maxCost) + extras * parseFloat(extra);
          data[_base] = value;
        }
        if (max && extra && _base > max && costBy == 'BASE_PERSON') {
          var _extras = _base - max;
          var _value = parseFloat(maxCost) * max + _extras * parseFloat(extra);
          data[_base] = _value / _base;
        }
        var dataNull = tools.isNull(data[_base]);
        if (!dataNull) {
          if (costBy == 'BASE_PERSON') {
            if (tourLeader && !costData.TourLeader) {
              if (quoteBy != 'QUANTITY') {
                res.cost = data[_base] * tourLeaderFactor;
              } else {
                res.cost = data[_base];
              }
            } else {
              res.cost = data[_base];
            }
          } else {
            if (!quoteBy || quoteBy == 'PERSON') {
              res.cost = data[_base] / base;
            } else {
              res.cost = data[_base];
            }
          }
          res.originCost = data[_base];
        }
      }
      if (costBy == 'BASE_PERSON' && pType == 'CHD' && costData.ChildDiscount) {
        if (res.cost) res.cost = res.cost * (1 - costData.ChildDiscount / 100);
        if (res.originCost) res.originCost = res.originCost * (1 - costData.ChildDiscount / 100);
      }
      if (res.cost) res.cost = parseFloat(res.cost);
      if (res.originCost) res.originCost = parseFloat(res.originCost);
      if (commission && res.cost) res.cost = res.cost * (1 - commission / 100.0);
      return res;
    }
  }, {
    key: "getRowValue",
    value: function getRowValue(costData, roomType, nights, roomCategory) {
      var maxNightId = 0;
      var r;
      var rValue;
      var rExtra;
      var rExtraValue;
      for (var row in costData) {
        var category = void 0;
        var typeId = void 0;
        if (roomCategory) {
          category = parseInt(row.split(',')[1]);
          typeId = parseInt(row.split(',')[2]);
        } else {
          typeId = parseInt(row.split(',')[1]);
        }
        if (row.split(',')[0] != 'extra') {
          var nightsId = parseInt(row.split(',')[0]);
          if (!roomCategory && typeId == roomType.id && nightsId > maxNightId || roomCategory && typeId == roomType.id && nightsId > maxNightId && roomCategory == category) {
            maxNightId = nightsId;
            r = costData[row];
          }
        } else {
          if (typeId == roomType.id) {
            rExtra = costData[row];
          }
        }
      }
      if (rExtra) rExtraValue = rExtra.value;
      if (r) rValue = r.value;
      var costValue;
      if (rValue && rExtraValue) {
        costValue = parseFloat(rValue) + parseFloat(rExtraValue * (nights - maxNightId));
      }
      return {
        costValue: costValue,
        maxNightId: maxNightId
      };
    }
  }, {
    key: "applyDiscount",
    value: function applyDiscount(discountType, discountDays, discount, costValue, nights, totalNights) {
      if (discountType == 'CONSECUTIVE' && parseInt(nights) >= parseInt(discountDays)) {
        return costValue * (1 - parseFloat(discount) / 100.0);
      }
      if (discountType == 'TOTAL' && parseInt(totalNights) >= parseInt(discountDays)) {
        return costValue * (1 - parseFloat(discount) / 100.0);
      }
      return costValue;
    }
  }, {
    key: "getBases",
    value: function getBases(self) {
      var res = {};
      for (var id in self) {
        if (tools.isNormalInteger(id)) {
          res[id] = self[id];
        }
      }
      return res;
    }
  }, {
    key: "serviceList",
    value: function serviceList(services, suppliers, serviceCategories, serviceClasses) {
      if (!services) return [];
      var res = [];
      var _iterator2 = _createForOfIteratorHelper(services),
        _step2;
      try {
        var _loop = function _loop() {
            var s = _step2.value;
            if (s.Closed) return 0; // continue
            if (s.TemplateOnly) return 0; // continue
            s.sId = s.id;
            var supplier = _.find(suppliers, function (r) {
              return r.id == s.SupplierId;
            });
            var serviceClass = _.find(serviceClasses, function (r) {
              return r.id == s.ServiceClassId;
            });
            s.Icon = null;
            if (serviceClass && serviceClass.Icon) s.Icon = serviceClass.Icon;
            if (!supplier) return 0; // continue
            if (supplier.Closed) return 0; // continue
            if (!supplier.ServiceCategoriesByService) return 0; // continue
            if (supplier.ServiceCategoriesByService[s.id]) {
              var _iterator3 = _createForOfIteratorHelper(supplier.ServiceCategoriesByService[s.id]),
                _step3;
              try {
                var _loop2 = function _loop2() {
                  var c = _step3.value;
                  if (c) {
                    var service = _.cloneDeep(s);
                    service.ServiceCategoryId = c;
                    service.ServiceCategory = _.find(serviceCategories, function (r) {
                      return r.id == c;
                    });
                    service.id = s.sId + '-' + c;
                    res.push(service);
                  } else {
                    res.push(s);
                  }
                };
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  _loop2();
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            } else {
              res.push(s);
            }
          },
          _ret;
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _ret = _loop();
          if (_ret === 0) continue;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return res;
    }
  }, {
    key: "checkOverlap",
    value: function checkOverlap(periods, objectId) {
      if (!periods) return false;
      var _iterator4 = _createForOfIteratorHelper(periods),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var period1 = _step4.value;
          if (period1.Closed) continue;
          if (period1.Delete) continue;
          if (period1.remove) continue;
          if (period1.EndDate < period1.StartDate) {
            return {
              overlap: [period1, null],
              'msj': 'End Date can not be lower than Start Date'
            };
          }
          var _iterator5 = _createForOfIteratorHelper(periods),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var period2 = _step5.value;
              if (period1.rowNr == period2.rowNr) continue;
              if (period2.Closed) continue;
              if (period2.Delete) continue;
              if (period2.remove) continue;
              var sameRoomCostBy = period1.RoomCostBy == "ROOM_TYPE_CATEGORY" && period2.RoomCostBy == "ROOM_TYPE_CATEGORY" || period1.RoomCostBy != "ROOM_TYPE_CATEGORY" && period2.RoomCostBy != "ROOM_TYPE_CATEGORY";
              if (!sameRoomCostBy) continue;
              if (period1.Promotion && !period2.Promotion) continue;
              if (!period1.Promotion && period2.Promotion) continue;
              if (period1.CurrencyId != period2.CurrencyId) continue;
              if (period1.TourLeader && !period2.TourLeader) continue;
              if (!period1.TourLeader && period2.TourLeader) continue;
              if (period1.PaxCountryType != period2.PaxCountryType) continue;
              if (period1.StartDate == period2.StartDate && period1.EndDate == period2.EndDate) {
                if (travelTools.checkOverlapWeekDays(period1, period2)) {
                  if (!objectId) {
                    return {
                      overlap: [period1, period2],
                      'msj': 'Periods dates overlap'
                    };
                  }
                  var obj = this.shareObjects(period1, period2, objectId);
                  if (obj) {
                    var v = obj.values.find(function (v) {
                      return v.fieldName == 'Name';
                    });
                    if (!v) v = obj.ServiceId;
                    return {
                      overlap: [period1, period2],
                      'msj': "Periods dates overlap ".concat(v.value || '')
                    };
                  }
                }
              }
              var ok = false;
              if (period1.EndDate < period2.StartDate) {
                ok = true;
              }
              if (period2.EndDate < period1.StartDate) {
                ok = true;
              }
              if (period1.StartDate >= period2.StartDate && period1.EndDate <= period2.EndDate) {
                ok = true;
              }
              if (period2.StartDate >= period1.StartDate && period2.EndDate <= period1.EndDate) {
                ok = true;
              }
              if (!ok) {
                if (travelTools.checkOverlapWeekDays(period1, period2)) {
                  if (!objectId) {
                    return {
                      overlap: [period1, period2],
                      'msj': 'Periods dates overlap'
                    };
                  }
                  var _obj = this.shareObjects(period1, period2, objectId);
                  if (_obj) {
                    var _v = _obj.values.find(function (v) {
                      return v.fieldName == 'Name';
                    });
                    if (!_v) _v = _obj.ServiceId;
                    return {
                      overlap: [period1, period2],
                      'msj': "Periods dates overlap ".concat(_v.value || '')
                    };
                  }
                }
              }
              /*if (period1.StartDate>period2.StartDate && period1.StartDate<period2.EndDate
                  && period1.EndDate>period2.EndDate) {
                  if (travelTools.checkOverlapWeekDays(period1, period2)) {
                      if (!objectId || this.shareObjects(period1, period2, objectId)) {
                          return {overlap: [period1, period2], 'msj': 'Periods dates overlap'};
                      }
                  }
              }
              if (period2.StartDate>=period1.StartDate && period2.StartDate<=period1.EndDate
                  && period2.EndDate>period1.EndDate) {
                  if (travelTools.checkOverlapWeekDays(period1, period2)) {
                      if (!objectId || this.shareObjects(period1, period2, objectId)) {
                          return {overlap: [period1, period2], 'msj': 'Periods dates overlap'};
                      }
                  }
              }*/
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return false;
    }
  }, {
    key: "shareObjects",
    value: function shareObjects(period1, period2, objectId) {
      var _loop3 = function _loop3() {
          var row = period1.table.rows[i];
          if (row.Closed.value) return 0; // continue
          if (row.Delete) return 0; // continue
          var obj = _.find(period2.table.rows, function (c) {
            return c[objectId].value == row[objectId].value && !c.Closed.value && !c.Delete;
          });
          if (obj) {
            return {
              v: obj
            };
          }
        },
        _ret2;
      for (var i in period1.table.rows) {
        _ret2 = _loop3();
        if (_ret2 === 0) continue;
        if (_ret2) return _ret2.v;
      }
    }
  }, {
    key: "checkOverlapWeekDays",
    value: function checkOverlapWeekDays(period1, period2) {
      if (period1.ByWeekDay && !period2.ByWeekDay) return false;
      if (!period1.ByWeekDay && period2.ByWeekDay) return false;
      if (!period1.ByWeekDay && !period2.ByWeekDay) return true;
      for (var _i = 0, _arr = [0, 1, 2, 3, 4, 5, 6]; _i < _arr.length; _i++) {
        var i = _arr[_i];
        if (period1.WeekDays[i] && period2.WeekDays[i]) {
          return true;
        }
      }
    }
  }]);
}();
window.travelTools = new TravelTools();

/***/ }),

/***/ 29849:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort:
            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
                '_'
            ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


/***/ }),

/***/ 29853:
/***/ ((module) => {

"use strict";


// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
module.exports = function ucs2length(str) {
  var length = 0
    , len = str.length
    , pos = 0
    , value;
  while (pos < len) {
    length++;
    value = str.charCodeAt(pos++);
    if (value >= 0xD800 && value <= 0xDBFF && pos < len) {
      // high surrogate, and there is a next character
      value = str.charCodeAt(pos);
      if ((value & 0xFC00) == 0xDC00) pos++; // low surrogate
    }
  }
  return length;
};


/***/ }),

/***/ 29895:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SupplierMixinView = api.importMixinModule('supplier', 'views', 'contacts');
var ContactsSupplierView = /*#__PURE__*/function (_SupplierMixinView) {
  function ContactsSupplierView() {
    _classCallCheck(this, ContactsSupplierView);
    return _callSuper(this, ContactsSupplierView, arguments);
  }
  _inherits(ContactsSupplierView, _SupplierMixinView);
  return _createClass(ContactsSupplierView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(ContactsSupplierView, "getTableOptions", this, 2)([]);
            case 2:
              res = _context.sent;
              res.fields.push({
                name: "SupplierContactList",
                editor: "component",
                hideFromList: true,
                label: "Contacts",
                icon: 'user',
                component: 'supplier-contact-list',
                componentName: 'supplier-contact-list',
                componentPath: 'components'
              });
              return _context.abrupt("return", res);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(SupplierMixinView);
_defineProperty(ContactsSupplierView, "table", 'supplier');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ContactsSupplierView);

//window.SupplierView = SupplierView

/***/ }),

/***/ 30125:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var DES = __webpack_require__(84050)
var aes = __webpack_require__(1241)
var aesModes = __webpack_require__(530)
var desModes = __webpack_require__(32438)
var ebtk = __webpack_require__(68078)

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),

/***/ 30295:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__(48287)["Buffer"];
module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}


/***/ }),

/***/ 30306:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


/***/ }),

/***/ 30370:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var BN = __webpack_require__(28490);
var inherits = __webpack_require__(56698);
var Base = __webpack_require__(36677);

var utils = __webpack_require__(47011);

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};


/***/ }),

/***/ 30475:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var AiSettingsMixinView = api.importMixinModule('aisettings', 'views', 'custom');
var AiSettingsView = /*#__PURE__*/function (_AiSettingsMixinView) {
  function AiSettingsView() {
    _classCallCheck(this, AiSettingsView);
    return _callSuper(this, AiSettingsView, arguments);
  }
  _inherits(AiSettingsView, _AiSettingsMixinView);
  return _createClass(AiSettingsView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var r, cityTransferField, transferServiceIds;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(AiSettingsView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              r = _context.sent;
              cityTransferField = _.find(r.fields, function (r) {
                return r.name == 'AISettingsCityTransfers';
              });
              if (cityTransferField) {
                transferServiceIds = cityTransferField.rowFields.find(function (r) {
                  return r.name == 'TransferServiceIds';
                });
                if (transferServiceIds) {
                  transferServiceIds.filters = function (row, record) {
                    if (row.ServiceClassId == 1) return true;
                    if (row.ServiceClassId == 13) return true;
                    return false;
                  };
                }
              }
              return _context.abrupt("return", r);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(AiSettingsMixinView);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AiSettingsView);

/***/ }),

/***/ 31052:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                  ? time.slice(0, -3) + 'waQ'
                  : output.indexOf('DIS') !== -1
                    ? time.slice(0, -3) + 'nem'
                    : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                  ? time.slice(0, -3) + 'wen'
                  : output.indexOf('DIS') !== -1
                    ? time.slice(0, -3) + 'ben'
                    : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort:
            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


/***/ }),

/***/ 31298:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(47011);
var BN = __webpack_require__(28490);
var inherits = __webpack_require__(56698);
var Base = __webpack_require__(36677);

var assert = utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  var e;
  var h;
  var j;
  if (this.curve.twisted) {
    // E = a * C
    e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      h = this.z.redSqr();
      // J = F - 2 * H
      j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    e = c.redAdd(d);
    // H = (c * Z1)^2
    h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
    this.y,
    this.z,
    this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;


/***/ }),

/***/ 31541:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


/***/ }),

/***/ 31545:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort:
            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
                '_'
            ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays:
            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
                '_'
            ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


/***/ }),

/***/ 31554:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8818);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingExpenseView = /*#__PURE__*/function (_View) {
  function BookingExpenseView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingExpenseView);
    return _callSuper(this, BookingExpenseView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingExpenseView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingExpenseView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", {
                fields: [{
                  name: 'Type',
                  label: 'Type',
                  editor: 'select',
                  options: [{
                    value: 'PAX',
                    label: 'Passenger',
                    tr: true
                  }, {
                    value: 'NOT_PAX',
                    label: 'Internal Expense',
                    tr: true
                  }]
                }, {
                  name: 'Status',
                  label: 'Status',
                  editor: 'select',
                  options: [{
                    value: 'PENDING',
                    label: 'Pending',
                    tr: true
                  }, {
                    value: 'PAID',
                    label: 'Paid',
                    tr: true
                  }]
                }, {
                  name: 'PaymentDate',
                  label: 'Payment Date',
                  dateFormat: "DD/MM/YYYY",
                  editor: 'date'
                }, {
                  name: 'Amount',
                  label: 'Amount',
                  editor: 'number'
                }, {
                  name: 'Comment',
                  label: 'Comment'
                }, {
                  name: 'ExpenseTypeId',
                  relation: 'expensetype',
                  optionLabels: 'Name',
                  editor: 'select',
                  label: 'Concept',
                  setRelationTo: 'ExpenseType',
                  filters: function filters(row, record) {
                    if (row.BookingExpense == true && record.Type == 'NOT_PAX') return true;
                    if (row.BookingPax == true && record.Type == 'PAX') return true;
                  }
                }, {
                  name: 'CurrencyId',
                  relation: 'currency',
                  optionLabels: 'id',
                  setRelationTo: 'Currency',
                  editor: 'select',
                  label: 'Currency'
                }, {
                  name: 'CurrencyRate',
                  label: 'Rate',
                  editor: 'number'
                }, {
                  name: 'PaymentTypeId',
                  relation: 'paymenttype',
                  optionLabels: 'Name',
                  editor: 'select',
                  label: 'Payment Type',
                  filters: function filters(row) {
                    if (row.Payments == true) return true;
                  }
                }]
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingExpenseView, "table", 'bookingexpense');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingExpenseView);

/***/ }),

/***/ 32017:
/***/ ((module) => {

"use strict";


// do not edit .js files directly - edit src/index.jst



module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 32124:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone:
                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                    '_'
                ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


/***/ }),

/***/ 32299:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64467);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51941);






function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BaseQuote = /*#__PURE__*/function (_BookingBaseModel) {
  function BaseQuote(obj) {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, BaseQuote);
    if (!obj.fields) obj.fields = [];
    if (obj.record) {
      for (var key in obj.record) {
        if (['ADT', 'CHD', 'TL'].indexOf(key) == -1) continue;
        obj.fields.push({
          name: key,
          editor: 'number'
        });
      }
      obj.fields.push({
        name: 'TourLeader',
        editor: 'checkbox'
      });
      obj.fields.push({
        name: 'SingleSupplement',
        editor: 'checkbox'
      });
    }
    return _callSuper(this, BaseQuote, [obj]);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(BaseQuote, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BaseQuote, [{
    key: "paxTypes",
    get: function get() {
      var r = ['ADT'];
      if (this.CHD) r.push('CHD');
      if (this.TL) r.push('TL');
      return r;
    }
  }, {
    key: "paxQuantity",
    get: function get() {
      var res = 0;
      if (this.ADT) res += this.ADT;
      if (this.CHD) res += this.CHD;
      if (this.TL) res += this.TL;
      return res;
    }
  }, {
    key: "paxQuantityWithoutTL",
    get: function get() {
      var res = 0;
      if (this.ADT) res += this.ADT;
      if (this.CHD) res += this.CHD;
      return res;
    }
  }, {
    key: "baseId",
    get: function get() {
      for (var id in this.$parent.bases) {
        if (!this.$parent[id]) continue;
        if (this.$parent[id]._id == this._id) {
          return id;
        }
      }
    }
  }, {
    key: "booking",
    get: function get() {
      return this.$parent.$parent;
    }
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BaseQuote, "moduleName", 'basequote');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BaseQuote);

/***/ }),

/***/ 32438:
/***/ ((__unused_webpack_module, exports) => {

exports["des-ecb"] = {
  key: 8,
  iv: 0
}
exports["des-cbc"] = exports.des = {
  key: 8,
  iv: 8
}
exports["des-ede3-cbc"] = exports.des3 = {
  key: 24,
  iv: 8
}
exports["des-ede3"] = {
  key: 24,
  iv: 0
}
exports["des-ede-cbc"] = {
  key: 16,
  iv: 8
}
exports["des-ede"] = {
  key: 16,
  iv: 0
}


/***/ }),

/***/ 32723:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var hash = __webpack_require__(77952);
var utils = __webpack_require__(64367);
var assert = __webpack_require__(43349);

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};


/***/ }),

/***/ 32827:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var inherits = __webpack_require__(56698)
var SHA512 = __webpack_require__(82890)
var Hash = __webpack_require__(90392)
var Buffer = (__webpack_require__(92861).Buffer)

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),

/***/ 32856:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8818);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingFlightQuoteListView = /*#__PURE__*/function (_View) {
  function BookingFlightQuoteListView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingFlightQuoteListView);
    return _callSuper(this, BookingFlightQuoteListView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingFlightQuoteListView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingFlightQuoteListView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", {
                fields: []
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingFlightQuoteListView, "table", 'bookingflightquote');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingFlightQuoteListView);

/***/ }),

/***/ 32934:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


/***/ }),

/***/ 33225:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(65606);


if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}



/***/ }),

/***/ 33478:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort:
            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays:
            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
                '_'
            ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


/***/ }),

/***/ 33963:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = __webpack_require__(52587)('Maximum');


/***/ }),

/***/ 34106:
/***/ ((module, exports, __webpack_require__) => {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(48287)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 34112:
/***/ ((module) => {

"use strict";


function getCurrentRequest(loaderContext) {
  if (loaderContext.currentRequest) {
    return loaderContext.currentRequest;
  }

  const request = loaderContext.loaders
    .slice(loaderContext.loaderIndex)
    .map((obj) => obj.request)
    .concat([loaderContext.resource]);

  return request.join('!');
}

module.exports = getCurrentRequest;


/***/ }),

/***/ 34141:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64467);
/* harmony import */ var _base_model_base_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42675);
/* harmony import */ var _base_views_bookingusershare__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3520);






function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }


var BookingUserShare = /*#__PURE__*/function (_BaseModel) {
  function BookingUserShare() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingUserShare);
    return _callSuper(this, BookingUserShare, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingUserShare, _BaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingUserShare);
}(_base_model_base_model__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(BookingUserShare, "moduleName", 'bookingusershare');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingUserShare);

/***/ }),

/***/ 34298:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51941);







function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingDayRoom = /*#__PURE__*/function (_BookingBaseModel) {
  function BookingDayRoom() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingDayRoom);
    return _callSuper(this, BookingDayRoom, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingDayRoom, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingDayRoom, [{
    key: "newHotelQuoteList",
    value: function () {
      var _newHotelQuoteList = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(obj) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.newObject({
                objectClass: 'hotelquotelist'
              }, obj, 'QuoteList');
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function newHotelQuoteList(_x) {
        return _newHotelQuoteList.apply(this, arguments);
      }
      return newHotelQuoteList;
    }()
  }, {
    key: "booking",
    get: function get() {
      return this.$parent.$parent.$parent;
    }
  }, {
    key: "roomsQuantity",
    get: function get() {
      if (this.booking.QuoteBy != 'SERVICE') return this.Rooms;
      var res = 0;
      for (var baseId in this.booking.BaseQuotes.bases) {
        var _this$QuoteList, _this$QuoteList2;
        if (!((_this$QuoteList = this.QuoteList) !== null && _this$QuoteList !== void 0 && (_this$QuoteList = _this$QuoteList[baseId]) !== null && _this$QuoteList !== void 0 && _this$QuoteList.Include)) continue;
        if (!((_this$QuoteList2 = this.QuoteList) !== null && _this$QuoteList2 !== void 0 && (_this$QuoteList2 = _this$QuoteList2[baseId]) !== null && _this$QuoteList2 !== void 0 && _this$QuoteList2.Rooms)) continue;
        res += this.QuoteList[baseId].Rooms;
      }
      return res;
    }
  }, {
    key: "roomCategories",
    get: function get() {
      var res = [];
      if (this.Hotel && this.Hotel.RoomCategories) {
        var categories = _.filter(this.Hotel.RoomCategories, function (r) {
          return !r.Closed;
        });
        res = _.map(categories, function (r) {
          var name = r.Name;
          if (r.Comment) name += ', ' + r.Comment;
          if (r.Program) return {
            value: r.id,
            label: 'Prog: ' + name
          };
          return {
            value: r.id,
            label: name
          };
        });
      }
      return res;
    }
  }, {
    key: "roomsOptions",
    get: function get() {
      var res = [];
      if (this.Hotel && this.Hotel.HotelRoomTypes) {
        res = _.map(this.Hotel.HotelRoomTypes, function (r) {
          return {
            value: r.RoomType.id,
            label: r.RoomType.Name
          };
        });
        var hasExtra = _.find(this.Hotel.HotelRoomTypes, function (r) {
          return r.RoomType.ExtraBed;
        });
        var hasDBLExtraBed = _.find(this.Hotel.HotelRoomTypes, function (r) {
          return r.RoomType.DBLExtraBed;
        });
        if (hasExtra && !hasDBLExtraBed) {
          var tplRooms = _.filter(api.tables.roomtype, function (r) {
            return r.DBLExtraBed;
          });
          var _iterator = _createForOfIteratorHelper(tplRooms),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var r = _step.value;
              res.push({
                value: r.id,
                label: r.Name
              });
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }
      return res;
    }
  }, {
    key: "supplierId",
    get: function get() {
      if (this.SupplierId) return this.SupplierId;
      if (this.Hotel && this.Hotel.SupplierId) return this.Hotel.SupplierId;
    }
  }, {
    key: "bookingDayHotel",
    get: function get() {
      return this.$parent;
    }
  }, {
    key: "bookingDay",
    get: function get() {
      return this.bookingDayHotel.$parent;
    }
  }, {
    key: "setHotel",
    value: function () {
      var _setHotel = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(oldValue) {
        var _this = this;
        var oldHotelId, oldRoomCategory, roomType, includes, baseId, _iterator2, _step2, field;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              oldHotelId = oldValue;
              if (!oldValue) {
                _context2.next = 6;
                break;
              }
              oldRoomCategory = this.RoomCategory;
              this.RoomCategory = null;
              _context2.next = 6;
              return this.setProgramServices(oldRoomCategory, oldHotelId);
            case 6:
              if (!this.HotelId) {
                _context2.next = 20;
                break;
              }
              if (!(this.Hotel && this.Hotel.SupplierId && this.SupplierId)) {
                _context2.next = 10;
                break;
              }
              _context2.next = 10;
              return this.setValue({
                fieldName: 'SupplierId',
                value: null
              });
            case 10:
              if (!(this.Hotel && this.Hotel.HotelCategoryId)) {
                _context2.next = 13;
                break;
              }
              _context2.next = 13;
              return this.setValue({
                fieldName: 'HotelCategoryId',
                value: this.Hotel.HotelCategoryId
              });
            case 13:
              if (!(this.Hotel && this.RoomTypeId)) {
                _context2.next = 18;
                break;
              }
              roomType = _.find(this.Hotel.HotelRoomTypes, function (r) {
                return r.RoomTypeId == _this.RoomTypeId;
              });
              if (roomType) {
                _context2.next = 18;
                break;
              }
              _context2.next = 18;
              return this.setValue({
                fieldName: 'RoomTypeId',
                value: null
              });
            case 18:
              _context2.next = 26;
              break;
            case 20:
              _context2.next = 22;
              return this.setValue({
                fieldName: 'RoomCategory',
                value: null
              });
            case 22:
              _context2.next = 24;
              return this.setValue({
                fieldName: 'RoomTypeId',
                value: null
              });
            case 24:
              _context2.next = 26;
              return this.setValue({
                fieldName: 'HotelCategoryId',
                value: null
              });
            case 26:
              this.setPending();
              includes = {};
              if (!(oldHotelId && !this.exchange)) {
                _context2.next = 59;
                break;
              }
              _context2.t0 = _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().keys(this.booking.BaseQuotes);
            case 30:
              if ((_context2.t1 = _context2.t0()).done) {
                _context2.next = 57;
                break;
              }
              baseId = _context2.t1.value;
              includes[baseId] = true;
              if (!(this.QuoteList[baseId] && this.QuoteList[baseId].fields)) {
                _context2.next = 55;
                break;
              }
              _iterator2 = _createForOfIteratorHelper(this.QuoteList[baseId].fields);
              _context2.prev = 35;
              _iterator2.s();
            case 37:
              if ((_step2 = _iterator2.n()).done) {
                _context2.next = 46;
                break;
              }
              field = _step2.value;
              if (!(field.name == 'Groups')) {
                _context2.next = 41;
                break;
              }
              return _context2.abrupt("continue", 44);
            case 41:
              if (!(field.name == 'Variants')) {
                _context2.next = 43;
                break;
              }
              return _context2.abrupt("continue", 44);
            case 43:
              this.QuoteList[baseId]['$' + field.name].value = null;
            case 44:
              _context2.next = 37;
              break;
            case 46:
              _context2.next = 51;
              break;
            case 48:
              _context2.prev = 48;
              _context2.t2 = _context2["catch"](35);
              _iterator2.e(_context2.t2);
            case 51:
              _context2.prev = 51;
              _iterator2.f();
              return _context2.finish(51);
            case 54:
              this.QuoteList[baseId].$Include.value = includes[baseId];
            case 55:
              _context2.next = 30;
              break;
            case 57:
              this.QuoteList.setGroups();
              this.QuoteList.setVariants();
            case 59:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[35, 48, 51, 54]]);
      }));
      function setHotel(_x2) {
        return _setHotel.apply(this, arguments);
      }
      return setHotel;
    }()
  }, {
    key: "updateCost",
    value: function () {
      var _updateCost = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(_ref) {
        var skipCurrency, _ref$sync, sync, baseId;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              skipCurrency = _ref.skipCurrency, _ref$sync = _ref.sync, sync = _ref$sync === void 0 ? true : _ref$sync, baseId = _ref.baseId;
              if (!this.HotelId) {
                _context3.next = 4;
                break;
              }
              _context3.next = 4;
              return this.booking.setHotelCostById({
                hotelId: this.HotelId,
                exchange: this.exchange,
                skipCurrency: skipCurrency,
                daysChange: false,
                sync: sync,
                dayNr: this.$parent.$parent.DayNr,
                baseId: baseId,
                roomNr: this.roomNr
              });
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function updateCost(_x3) {
        return _updateCost.apply(this, arguments);
      }
      return updateCost;
    }()
  }, {
    key: "roomNr",
    get: function get() {
      var _this2 = this;
      return _.findIndex(this.$parent.BookingDayRooms, function (r) {
        if (_this2.id && r.id == _this2.id) return true;
        if (_this2.id && r.id != _this2.id) return false;
        if (_this2.tempId && r.tempId == _this2.tempId) return true;
        if (_this2.tempId && r.tempId != _this2.tempId) return false;
      });
    }

    /*static async clone ({fields, record, parent}) {
        return await super.clone({fields, record, parent})
    }*/
  }, {
    key: "updateInfo",
    value: function () {
      var _updateInfo = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(id, setQuoteList) {
        var baseId, i;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              //cc this.baseId undefined
              //cc setQuoteList undefined
              if (setQuoteList) {
                for (baseId in this.booking.BaseQuotes.bases) {
                  if (this.baseId && baseId != this.baseId) {
                    this.QuoteList[baseId].Include = false;
                  } else {
                    this.QuoteList[baseId].Include = true;
                  }
                }
              }
              if (this.exchange) {
                for (i in this.$parent.BookingDayRooms) {
                  if (parseInt(i) == id || id === undefined || id === null) {
                    this.$parent.BookingDayRooms[i].setPending();
                  }
                }
              }
              if (!(this.HotelId && this.RoomCategory && this.RoomTypeId)) {
                _context4.next = 5;
                break;
              }
              _context4.next = 5;
              return this.updateCost({});
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function updateInfo(_x4, _x5) {
        return _updateInfo.apply(this, arguments);
      }
      return updateInfo;
    }()
  }, {
    key: "setRooms",
    value: function setRooms() {
      this.updateInfo();
    }
  }, {
    key: "roomCategoryName",
    get: function get() {
      var _this3 = this;
      if (!this.Hotel || !this.Hotel.RoomCategories) return;
      var room = _.find(this.Hotel.RoomCategories, function (c) {
        return c.id == _this3.RoomCategory;
      });
      if (room) return room.Name;
      return '';
    }
  }, {
    key: "roomQuoteSelected",
    get: function get() {
      var quoteInclude = false;
      for (var baseId in this.booking.BaseQuotes.bases) {
        if (!this.booking.quotesSelected[baseId]) continue;
        if (this.QuoteList[baseId].Include) {
          quoteInclude = true;
        }
      }
      return quoteInclude;
    }
  }, {
    key: "bases",
    get: function get() {
      return tools.getBases(_.cloneDeep(this.QuoteList));
    }
  }, {
    key: "setStatus",
    value: function setStatus() {}
  }, {
    key: "setRoomTypeId",
    value: function setRoomTypeId() {
      this.updateInfo();
      if (this.booking.quoteService && this.Room && this.Room.Pax) {
        for (var baseId in this.booking.BaseQuotes.bases) {
          if (!this.QuoteList[baseId]) continue;
          this.QuoteList[baseId].RoomPax = this.Room.Pax;
        }
      }
    }
  }, {
    key: "setServiceToDay",
    value: function () {
      var _setServiceToDay = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(day, service) {
        var addedServices;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              addedServices = _.filter(day.BookingDayServices, function (s) {
                return s.ServiceId == service.id;
              });
              if (!(addedServices.length == 0)) {
                _context5.next = 4;
                break;
              }
              _context5.next = 4;
              return day.setServiceToDay({
                record: service,
                include: true,
                changeService: false,
                currentService: null,
                isTemplate: false
              });
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function setServiceToDay(_x6, _x7) {
        return _setServiceToDay.apply(this, arguments);
      }
      return setServiceToDay;
    }()
  }, {
    key: "removeServiceFromDay",
    value: function removeServiceFromDay(day, service) {
      var serviceIndex = _.findIndex(day.BookingDayServices, function (s) {
        return s.ServiceId == service.id;
      });
      if (serviceIndex > -1) {
        day.removeService(serviceIndex);
      }
      var _iterator3 = _createForOfIteratorHelper(service === null || service === void 0 ? void 0 : service.RequiredServices),
        _step3;
      try {
        var _loop = function _loop() {
          var _s = _step3.value;
          var serviceIndex = _.findIndex(day.BookingDayServices, function (s) {
            return s.ServiceId == _s.RequiredServiceId;
          });
          if (serviceIndex > -1) {
            day.removeService(serviceIndex);
          }
        };
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "removeService",
    value: function () {
      var _removeService = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(oldCategory, serviceId) {
        var service, days, i, day, _days, _i, _day;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return api.getObjectFromStore('service', serviceId);
            case 2:
              service = _context6.sent;
              if (service) {
                _context6.next = 5;
                break;
              }
              return _context6.abrupt("return");
            case 5:
              if (oldCategory.AddingMode == 'FIRST_DAY') {
                this.removeServiceFromDay(this.bookingDay, service);
              }
              if (!(oldCategory.AddingMode == 'EVERY_DAY')) {
                _context6.next = 17;
                break;
              }
              days = this.bookingDayHotel.Days;
              i = 0;
            case 9:
              if (!(i < days)) {
                _context6.next = 17;
                break;
              }
              day = this.booking.BookingDays[this.bookingDay.DayNr + i];
              if (day) {
                _context6.next = 13;
                break;
              }
              return _context6.abrupt("continue", 14);
            case 13:
              this.removeServiceFromDay(day, service);
            case 14:
              i++;
              _context6.next = 9;
              break;
            case 17:
              if (!(oldCategory.AddingMode == 'SET_DAYS_QTY')) {
                _context6.next = 28;
                break;
              }
              _days = oldCategory.ServiceDaysQty;
              _i = 0;
            case 20:
              if (!(_i < _days)) {
                _context6.next = 28;
                break;
              }
              _day = this.booking.BookingDays[this.bookingDay.DayNr + _i];
              if (_day) {
                _context6.next = 24;
                break;
              }
              return _context6.abrupt("continue", 25);
            case 24:
              this.removeServiceFromDay(_day, service);
            case 25:
              _i++;
              _context6.next = 20;
              break;
            case 28:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function removeService(_x8, _x9) {
        return _removeService.apply(this, arguments);
      }
      return removeService;
    }()
  }, {
    key: "removeProgramServices",
    value: function () {
      var _removeProgramServices = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7(oldValue, oldHotelId, oldDaysQty) {
        var _this$Category, _this$Category2, _this$Category3, _this$Category4;
        var oldHotel, _oldHotel, oldCategory, service, i, day, _service, _i2, _day2;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              oldHotel = this.Hotel;
              if (!(oldHotelId && this.HotelId != oldHotelId)) {
                _context7.next = 5;
                break;
              }
              _context7.next = 4;
              return api.getObjectFromStore('hotel', oldHotelId);
            case 4:
              oldHotel = _context7.sent;
            case 5:
              if (!oldValue) {
                _context7.next = 10;
                break;
              }
              oldCategory = (_oldHotel = oldHotel) === null || _oldHotel === void 0 ? void 0 : _oldHotel.RoomCategories.find(function (c) {
                return c.id == oldValue;
              });
              if (!(oldCategory !== null && oldCategory !== void 0 && oldCategory.ServiceId)) {
                _context7.next = 10;
                break;
              }
              _context7.next = 10;
              return this.removeService(oldCategory, oldCategory.ServiceId);
            case 10:
              if (!(oldDaysQty > this.bookingDayHotel.Days && (_this$Category = this.Category) !== null && _this$Category !== void 0 && _this$Category.ServiceId && ((_this$Category2 = this.Category) === null || _this$Category2 === void 0 ? void 0 : _this$Category2.AddingMode) == 'EVERY_DAY')) {
                _context7.next = 23;
                break;
              }
              _context7.next = 13;
              return api.getObjectFromStore('service', this.Category.ServiceId);
            case 13:
              service = _context7.sent;
              i = this.bookingDayHotel.Days;
            case 15:
              if (!(i < oldDaysQty)) {
                _context7.next = 23;
                break;
              }
              day = this.booking.BookingDays[this.bookingDay.DayNr + parseInt(i)];
              if (day) {
                _context7.next = 19;
                break;
              }
              return _context7.abrupt("continue", 20);
            case 19:
              this.removeServiceFromDay(day, service);
            case 20:
              i++;
              _context7.next = 15;
              break;
            case 23:
              if (!(oldDaysQty < this.bookingDayHotel.Days && (_this$Category3 = this.Category) !== null && _this$Category3 !== void 0 && _this$Category3.ServiceId && ((_this$Category4 = this.Category) === null || _this$Category4 === void 0 ? void 0 : _this$Category4.AddingMode) == 'EVERY_DAY')) {
                _context7.next = 37;
                break;
              }
              _context7.next = 26;
              return api.getObjectFromStore('service', this.Category.ServiceId);
            case 26:
              _service = _context7.sent;
              _i2 = oldDaysQty;
            case 28:
              if (!(_i2 < this.bookingDayHotel.Days)) {
                _context7.next = 37;
                break;
              }
              _day2 = this.booking.BookingDays[this.bookingDay.DayNr + parseInt(_i2)];
              if (_day2) {
                _context7.next = 32;
                break;
              }
              return _context7.abrupt("continue", 34);
            case 32:
              _context7.next = 34;
              return this.setServiceToDay(_day2, _service);
            case 34:
              _i2++;
              _context7.next = 28;
              break;
            case 37:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function removeProgramServices(_x10, _x11, _x12) {
        return _removeProgramServices.apply(this, arguments);
      }
      return removeProgramServices;
    }()
  }, {
    key: "setProgramServices",
    value: function () {
      var _setProgramServices = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8(oldValue, oldHotelId, oldDaysQty) {
        var _this$Hotel, _this$Category5;
        var _this$Category6, _this$Category7, _this$Category8, service, days, i, day, _this$Category9, _days2, _i3, _day3;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.removeProgramServices(oldValue, oldHotelId, oldDaysQty);
            case 2:
              if (!(this.RoomCategory && (_this$Hotel = this.Hotel) !== null && _this$Hotel !== void 0 && _this$Hotel.ProgramAddServices && (_this$Category5 = this.Category) !== null && _this$Category5 !== void 0 && _this$Category5.ServiceId)) {
                _context8.next = 35;
                break;
              }
              _context8.next = 5;
              return api.getObjectFromStore('service', this.Category.ServiceId);
            case 5:
              service = _context8.sent;
              if (service) {
                _context8.next = 8;
                break;
              }
              return _context8.abrupt("return");
            case 8:
              if (!(((_this$Category6 = this.Category) === null || _this$Category6 === void 0 ? void 0 : _this$Category6.AddingMode) == 'FIRST_DAY')) {
                _context8.next = 11;
                break;
              }
              _context8.next = 11;
              return this.setServiceToDay(this.bookingDay, service);
            case 11:
              if (!(((_this$Category7 = this.Category) === null || _this$Category7 === void 0 ? void 0 : _this$Category7.AddingMode) == 'EVERY_DAY')) {
                _context8.next = 23;
                break;
              }
              days = this.bookingDayHotel.Days;
              i = 0;
            case 14:
              if (!(i < days)) {
                _context8.next = 23;
                break;
              }
              day = this.booking.BookingDays[this.bookingDay.DayNr + i];
              if (day) {
                _context8.next = 18;
                break;
              }
              return _context8.abrupt("continue", 20);
            case 18:
              _context8.next = 20;
              return this.setServiceToDay(day, service);
            case 20:
              i++;
              _context8.next = 14;
              break;
            case 23:
              if (!(((_this$Category8 = this.Category) === null || _this$Category8 === void 0 ? void 0 : _this$Category8.AddingMode) == 'SET_DAYS_QTY')) {
                _context8.next = 35;
                break;
              }
              _days2 = (_this$Category9 = this.Category) === null || _this$Category9 === void 0 ? void 0 : _this$Category9.ServiceDaysQty;
              _i3 = 0;
            case 26:
              if (!(_i3 < _days2)) {
                _context8.next = 35;
                break;
              }
              _day3 = this.booking.BookingDays[this.bookingDay.DayNr + _i3];
              if (_day3) {
                _context8.next = 30;
                break;
              }
              return _context8.abrupt("continue", 32);
            case 30:
              _context8.next = 32;
              return this.setServiceToDay(_day3, service);
            case 32:
              _i3++;
              _context8.next = 26;
              break;
            case 35:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function setProgramServices(_x13, _x14, _x15) {
        return _setProgramServices.apply(this, arguments);
      }
      return setProgramServices;
    }()
  }, {
    key: "setRoomCategory",
    value: function () {
      var _setRoomCategory = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee9(oldValue) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              this.updateInfo();
              _context9.next = 3;
              return this.setProgramServices(oldValue);
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function setRoomCategory(_x16) {
        return _setRoomCategory.apply(this, arguments);
      }
      return setRoomCategory;
    }()
  }, {
    key: "setPending",
    value: function setPending() {
      if (this.Status == 'CANCELED') return;
      this.Status = 'PENDING';
    }
  }, {
    key: "afterEdit",
    value: function afterEdit() {
      return {
        HotelId: function HotelId(r, newVal, oldVal) {
          r.setHotel(oldVal);
        },
        RoomTypeId: function RoomTypeId(r) {
          r.setRoomTypeId();
        },
        RoomCategory: function () {
          var _RoomCategory = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee10(r, newVal, oldVal) {
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee10$(_context10) {
              while (1) switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.next = 2;
                  return r.setRoomCategory(oldVal);
                case 2:
                case "end":
                  return _context10.stop();
              }
            }, _callee10);
          }));
          function RoomCategory(_x17, _x18, _x19) {
            return _RoomCategory.apply(this, arguments);
          }
          return RoomCategory;
        }(),
        CurrencyId: function () {
          var _CurrencyId = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee11(record) {
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee11$(_context11) {
              while (1) switch (_context11.prev = _context11.next) {
                case 0:
                  _context11.next = 2;
                  return record.updateCost({
                    skipCurrency: true
                  });
                case 2:
                case "end":
                  return _context11.stop();
              }
            }, _callee11);
          }));
          function CurrencyId(_x20) {
            return _CurrencyId.apply(this, arguments);
          }
          return CurrencyId;
        }(),
        Rooms: function Rooms(r) {
          r.updateInfo();
          r.setRooms();
        },
        Status: function Status(r) {
          r.setStatus();
        },
        ExcludeQuotation: function ExcludeQuotation(r) {
          r.setExcludeQuotation();
        }
      };
    }
  }, {
    key: "setExcludeQuotation",
    value: function setExcludeQuotation() {
      if (this.ExcludeQuotation) {
        for (var baseId in this.bases) {
          this.QuoteList[baseId].Include = false;
        }
      }
    }
  }, {
    key: "quoteIncluded",
    get: function get() {
      if (!this.Room) return false;
      for (var baseId in this.booking.BaseQuotes.bases) {
        if (this.QuoteList[baseId].Include) {
          return true;
        }
      }
    }
  }, {
    key: "skipQuoteCanceled",
    get: function get() {
      if (this.Status == 'CANCELED') return true;
    }

    /*
    get roomsCapacity () {
        if (this._cache && this._cache.roomsCapacity) {
            return this._cachedRoomsCapacity;
        }
        if (this._cache) this._cache.roomsCapacity = true;
        if (this.booking.QuoteBy == 'PERSON') return {};
        let res = {};
        if (this.TourLeader) return res;
        if (this.SingleSupplement) return res;
        if (!this.Room) return res;
        if (!this.Room.Pax) return res;
        if (!this.QuoteList) return res;
        for (let baseId in this.QuoteList.bases) {
            if (!this.QuoteList[baseId]) continue;
            if (!this.QuoteList[baseId].Include) continue;
            if (!this.QuoteList[baseId].Rooms) continue;
            if (!this.booking.isGroup(baseId)) continue;
            let groups = this.booking.QuoteGroups[baseId];
            let pax = 0;
            let rooms = 0;
            for (let groupId in groups) {
                let group = this.QuoteList[baseId].Groups[groupId];
                if (!group) continue;
                if (!group.selected) continue;
                pax += parseInt(group.pax);
                rooms +=  parseInt(group.rooms);
            }
            if (!res[baseId]) {
                res[baseId] = {
                    pax,
                    capacity: this.QuoteList[baseId].Rooms * this.Room.Pax,
                    capacityGroups: this.Room.Pax * rooms,
                    error: false,
                }
            }
        }
        for (let baseId in res) {
            if (res[baseId].capacity < res[baseId].pax) res[baseId].error = true;
            if (res[baseId].capacityGroups < res[baseId].pax) res[baseId].error = true;
        }
        this._cachedRoomsCapacity = res;
        return res;
    }
    */
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__["default"]);
/*constructor({fields, record, parent}) {
    super({fields, record, parent});
    let self = this;
    return (async () => {
        let r = await new Promise((resolve, reject) => {
            resolve(self);
        })
        r._cache = {
            roomsCapacity: false,
        }
        r._cachedRoomsCapacity = null;
        return r;
    })();
}*/
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingDayRoom, "moduleName", 'bookingdayroom');
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingDayRoom, "invalidated_cache", _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__["default"].invalidated_cache_hotels);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingDayRoom);

/***/ }),

/***/ 35031:
/***/ ((module) => {

"use strict";


module.exports = function defFunc(ajv) {
  defFunc.definition = {
    type: 'string',
    inline: function (it, keyword, schema) {
      return getRegExp() + '.test(data' + (it.dataLevel || '') + ')';

      function getRegExp() {
        try {
          if (typeof schema == 'object')
            return new RegExp(schema.pattern, schema.flags);

          var rx = schema.match(/^\/(.*)\/([gimuy]*)$/);
          if (rx) return new RegExp(rx[1], rx[2]);
          throw new Error('cannot parse string into RegExp');
        } catch(e) {
          console.error('regular expression', schema, 'is invalid');
          throw e;
        }
      }
    },
    metaSchema: {
      type: ['string', 'object'],
      properties: {
        pattern: { type: 'string' },
        flags: { type: 'string' }
      },
      required: ['pattern'],
      additionalProperties: false
    }
  };

  ajv.addKeyword('regexp', defFunc.definition);
  return ajv;
};


/***/ }),

/***/ 35358:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var map = {
	"./af": 25177,
	"./af.js": 25177,
	"./ar": 61509,
	"./ar-dz": 41488,
	"./ar-dz.js": 41488,
	"./ar-kw": 58676,
	"./ar-kw.js": 58676,
	"./ar-ly": 42353,
	"./ar-ly.js": 42353,
	"./ar-ma": 24496,
	"./ar-ma.js": 24496,
	"./ar-ps": 6947,
	"./ar-ps.js": 6947,
	"./ar-sa": 82682,
	"./ar-sa.js": 82682,
	"./ar-tn": 89756,
	"./ar-tn.js": 89756,
	"./ar.js": 61509,
	"./az": 95533,
	"./az.js": 95533,
	"./be": 28959,
	"./be.js": 28959,
	"./bg": 47777,
	"./bg.js": 47777,
	"./bm": 54903,
	"./bm.js": 54903,
	"./bn": 61290,
	"./bn-bd": 17357,
	"./bn-bd.js": 17357,
	"./bn.js": 61290,
	"./bo": 31545,
	"./bo.js": 31545,
	"./br": 11470,
	"./br.js": 11470,
	"./bs": 44429,
	"./bs.js": 44429,
	"./ca": 7306,
	"./ca.js": 7306,
	"./cs": 56464,
	"./cs.js": 56464,
	"./cv": 73635,
	"./cv.js": 73635,
	"./cy": 64226,
	"./cy.js": 64226,
	"./da": 93601,
	"./da.js": 93601,
	"./de": 77853,
	"./de-at": 26111,
	"./de-at.js": 26111,
	"./de-ch": 54697,
	"./de-ch.js": 54697,
	"./de.js": 77853,
	"./dv": 60708,
	"./dv.js": 60708,
	"./el": 54691,
	"./el.js": 54691,
	"./en-au": 53872,
	"./en-au.js": 53872,
	"./en-ca": 28298,
	"./en-ca.js": 28298,
	"./en-gb": 56195,
	"./en-gb.js": 56195,
	"./en-ie": 66584,
	"./en-ie.js": 66584,
	"./en-il": 65543,
	"./en-il.js": 65543,
	"./en-in": 9033,
	"./en-in.js": 9033,
	"./en-nz": 79402,
	"./en-nz.js": 79402,
	"./en-sg": 43004,
	"./en-sg.js": 43004,
	"./eo": 32934,
	"./eo.js": 32934,
	"./es": 97650,
	"./es-do": 20838,
	"./es-do.js": 20838,
	"./es-mx": 17730,
	"./es-mx.js": 17730,
	"./es-us": 56575,
	"./es-us.js": 56575,
	"./es.js": 97650,
	"./et": 3035,
	"./et.js": 3035,
	"./eu": 3508,
	"./eu.js": 3508,
	"./fa": 119,
	"./fa.js": 119,
	"./fi": 90527,
	"./fi.js": 90527,
	"./fil": 95995,
	"./fil.js": 95995,
	"./fo": 52477,
	"./fo.js": 52477,
	"./fr": 85498,
	"./fr-ca": 26435,
	"./fr-ca.js": 26435,
	"./fr-ch": 37892,
	"./fr-ch.js": 37892,
	"./fr.js": 85498,
	"./fy": 37071,
	"./fy.js": 37071,
	"./ga": 41734,
	"./ga.js": 41734,
	"./gd": 70217,
	"./gd.js": 70217,
	"./gl": 77329,
	"./gl.js": 77329,
	"./gom-deva": 32124,
	"./gom-deva.js": 32124,
	"./gom-latn": 93383,
	"./gom-latn.js": 93383,
	"./gu": 95050,
	"./gu.js": 95050,
	"./he": 11713,
	"./he.js": 11713,
	"./hi": 43861,
	"./hi.js": 43861,
	"./hr": 26308,
	"./hr.js": 26308,
	"./hu": 90609,
	"./hu.js": 90609,
	"./hy-am": 17160,
	"./hy-am.js": 17160,
	"./id": 74063,
	"./id.js": 74063,
	"./is": 89374,
	"./is.js": 89374,
	"./it": 88383,
	"./it-ch": 21827,
	"./it-ch.js": 21827,
	"./it.js": 88383,
	"./ja": 23827,
	"./ja.js": 23827,
	"./jv": 89722,
	"./jv.js": 89722,
	"./ka": 41794,
	"./ka.js": 41794,
	"./kk": 27088,
	"./kk.js": 27088,
	"./km": 96870,
	"./km.js": 96870,
	"./kn": 84451,
	"./kn.js": 84451,
	"./ko": 63164,
	"./ko.js": 63164,
	"./ku": 98174,
	"./ku-kmr": 6181,
	"./ku-kmr.js": 6181,
	"./ku.js": 98174,
	"./ky": 78474,
	"./ky.js": 78474,
	"./lb": 79680,
	"./lb.js": 79680,
	"./lo": 15867,
	"./lo.js": 15867,
	"./lt": 45766,
	"./lt.js": 45766,
	"./lv": 69532,
	"./lv.js": 69532,
	"./me": 58076,
	"./me.js": 58076,
	"./mi": 41848,
	"./mi.js": 41848,
	"./mk": 30306,
	"./mk.js": 30306,
	"./ml": 73739,
	"./ml.js": 73739,
	"./mn": 99053,
	"./mn.js": 99053,
	"./mr": 86169,
	"./mr.js": 86169,
	"./ms": 73386,
	"./ms-my": 92297,
	"./ms-my.js": 92297,
	"./ms.js": 73386,
	"./mt": 77075,
	"./mt.js": 77075,
	"./my": 72264,
	"./my.js": 72264,
	"./nb": 22274,
	"./nb.js": 22274,
	"./ne": 8235,
	"./ne.js": 8235,
	"./nl": 92572,
	"./nl-be": 43784,
	"./nl-be.js": 43784,
	"./nl.js": 92572,
	"./nn": 54566,
	"./nn.js": 54566,
	"./oc-lnc": 69330,
	"./oc-lnc.js": 69330,
	"./pa-in": 29849,
	"./pa-in.js": 29849,
	"./pl": 94418,
	"./pl.js": 94418,
	"./pt": 79834,
	"./pt-br": 48303,
	"./pt-br.js": 48303,
	"./pt.js": 79834,
	"./ro": 24457,
	"./ro.js": 24457,
	"./ru": 82271,
	"./ru.js": 82271,
	"./sd": 1221,
	"./sd.js": 1221,
	"./se": 33478,
	"./se.js": 33478,
	"./si": 17538,
	"./si.js": 17538,
	"./sk": 5784,
	"./sk.js": 5784,
	"./sl": 46637,
	"./sl.js": 46637,
	"./sq": 86794,
	"./sq.js": 86794,
	"./sr": 45719,
	"./sr-cyrl": 3322,
	"./sr-cyrl.js": 3322,
	"./sr.js": 45719,
	"./ss": 56000,
	"./ss.js": 56000,
	"./sv": 41011,
	"./sv.js": 41011,
	"./sw": 40748,
	"./sw.js": 40748,
	"./ta": 11025,
	"./ta.js": 11025,
	"./te": 11885,
	"./te.js": 11885,
	"./tet": 28861,
	"./tet.js": 28861,
	"./tg": 86571,
	"./tg.js": 86571,
	"./th": 55802,
	"./th.js": 55802,
	"./tk": 59527,
	"./tk.js": 59527,
	"./tl-ph": 29231,
	"./tl-ph.js": 29231,
	"./tlh": 31052,
	"./tlh.js": 31052,
	"./tr": 85096,
	"./tr.js": 85096,
	"./tzl": 79846,
	"./tzl.js": 79846,
	"./tzm": 81765,
	"./tzm-latn": 97711,
	"./tzm-latn.js": 97711,
	"./tzm.js": 81765,
	"./ug-cn": 48414,
	"./ug-cn.js": 48414,
	"./uk": 16618,
	"./uk.js": 16618,
	"./ur": 57777,
	"./ur.js": 57777,
	"./uz": 57609,
	"./uz-latn": 72475,
	"./uz-latn.js": 72475,
	"./uz.js": 57609,
	"./vi": 21135,
	"./vi.js": 21135,
	"./x-pseudo": 64051,
	"./x-pseudo.js": 64051,
	"./yo": 82218,
	"./yo.js": 82218,
	"./zh-cn": 52648,
	"./zh-cn.js": 52648,
	"./zh-hk": 1632,
	"./zh-hk.js": 1632,
	"./zh-mo": 31541,
	"./zh-mo.js": 31541,
	"./zh-tw": 50304,
	"./zh-tw.js": 50304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35358;

/***/ }),

/***/ 35359:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = (__webpack_require__(92861).Buffer);
var createHmac = __webpack_require__(83507);
var crt = __webpack_require__(67332);
var EC = (__webpack_require__(86729).ec);
var BN = __webpack_require__(39404);
var parseKeys = __webpack_require__(78170);
var curves = __webpack_require__(64589);

var RSA_PKCS1_PADDING = 1;

function sign(hash, key, hashType, signType, tag) {
  var priv = parseKeys(key);
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') { throw new Error('wrong private key type'); }
    return ecSign(hash, priv);
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') { throw new Error('wrong private key type'); }
    return dsaSign(hash, priv, hashType);
  }
  if (signType !== 'rsa' && signType !== 'ecdsa/rsa') { throw new Error('wrong private key type'); }
  if (key.padding !== undefined && key.padding !== RSA_PKCS1_PADDING) { throw new Error('illegal or unsupported padding mode'); }

  hash = Buffer.concat([tag, hash]);
  var len = priv.modulus.byteLength();
  var pad = [0, 1];
  while (hash.length + pad.length + 1 < len) { pad.push(0xff); }
  pad.push(0x00);
  var i = -1;
  while (++i < hash.length) { pad.push(hash[i]); }

  var out = crt(pad, priv);
  return out;
}

function ecSign(hash, priv) {
  var curveId = curves[priv.curve.join('.')];
  if (!curveId) { throw new Error('unknown curve ' + priv.curve.join('.')); }

  var curve = new EC(curveId);
  var key = curve.keyFromPrivate(priv.privateKey);
  var out = key.sign(hash);

  return Buffer.from(out.toDER());
}

function dsaSign(hash, priv, algo) {
  var x = priv.params.priv_key;
  var p = priv.params.p;
  var q = priv.params.q;
  var g = priv.params.g;
  var r = new BN(0);
  var k;
  var H = bits2int(hash, q).mod(q);
  var s = false;
  var kv = getKey(x, q, hash, algo);
  while (s === false) {
    k = makeKey(q, kv, algo);
    r = makeR(g, k, p, q);
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
    if (s.cmpn(0) === 0) {
      s = false;
      r = new BN(0);
    }
  }
  return toDER(r, s);
}

function toDER(r, s) {
  r = r.toArray();
  s = s.toArray();

  // Pad values
  if (r[0] & 0x80) { r = [0].concat(r); }
  if (s[0] & 0x80) { s = [0].concat(s); }

  var total = r.length + s.length + 4;
  var res = [
    0x30, total, 0x02, r.length
  ];
  res = res.concat(r, [0x02, s.length], s);
  return Buffer.from(res);
}

function getKey(x, q, hash, algo) {
  x = Buffer.from(x.toArray());
  if (x.length < q.byteLength()) {
    var zeros = Buffer.alloc(q.byteLength() - x.length);
    x = Buffer.concat([zeros, x]);
  }
  var hlen = hash.length;
  var hbits = bits2octets(hash, q);
  var v = Buffer.alloc(hlen);
  v.fill(1);
  var k = Buffer.alloc(hlen);
  k = createHmac(algo, k).update(v).update(Buffer.from([0])).update(x).update(hbits).digest();
  v = createHmac(algo, k).update(v).digest();
  k = createHmac(algo, k).update(v).update(Buffer.from([1])).update(x).update(hbits).digest();
  v = createHmac(algo, k).update(v).digest();
  return { k: k, v: v };
}

function bits2int(obits, q) {
  var bits = new BN(obits);
  var shift = (obits.length << 3) - q.bitLength();
  if (shift > 0) { bits.ishrn(shift); }
  return bits;
}

function bits2octets(bits, q) {
  bits = bits2int(bits, q);
  bits = bits.mod(q);
  var out = Buffer.from(bits.toArray());
  if (out.length < q.byteLength()) {
    var zeros = Buffer.alloc(q.byteLength() - out.length);
    out = Buffer.concat([zeros, out]);
  }
  return out;
}

function makeKey(q, kv, algo) {
  var t;
  var k;

  do {
    t = Buffer.alloc(0);

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest();
      t = Buffer.concat([t, kv.v]);
    }

    k = bits2int(t, q);
    kv.k = createHmac(algo, kv.k).update(kv.v).update(Buffer.from([0])).digest();
    kv.v = createHmac(algo, kv.k).update(kv.v).digest();
  } while (k.cmp(q) !== -1);

  return k;
}

function makeR(g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q);
}

module.exports = sign;
module.exports.getKey = getKey;
module.exports.makeKey = makeKey;


/***/ }),

/***/ 35557:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var View = api.importMixinModule('hotel', 'views', 'taxes');
var HotelView = /*#__PURE__*/function (_View) {
  function HotelView() {
    _classCallCheck(this, HotelView);
    return _callSuper(this, HotelView, arguments);
  }
  _inherits(HotelView, _View);
  return _createClass(HotelView, null, [{
    key: "options",
    value: function options() {
      var options = _superPropGet(HotelView, "options", this, 2)([]);
      options.fieldsDataReplace.HotelTaxCodes = {
        name: 'HotelTaxCodes',
        editor: [],
        label: 'Taxes',
        icon: 'money-check-alt',
        rowFields: [{
          name: 'TaxCodeId',
          relation: 'taxcode',
          optionLabels: 'Name',
          editor: 'select',
          label: 'Tax'
        }, {
          name: 'PaxCountryType',
          label: 'Pax Type',
          editor: 'select',
          options: [{
            value: 'RESIDENT',
            label: 'Resident'
          }, {
            value: 'NOT_RESIDENT',
            label: 'Not Resident'
          }]
        }]
      };
      return options;
    }
  }]);
}(View);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HotelView);

/***/ }),

/***/ 35674:
/***/ ((module) => {

"use strict";

module.exports = function generate_contains(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $idx = 'i' + $lvl,
    $dataNxt = $it.dataLevel = it.dataLevel + 1,
    $nextData = 'data' + $dataNxt,
    $currentBaseId = it.baseId,
    $nonEmptySchema = (it.opts.strictKeywords ? (typeof $schema == 'object' && Object.keys($schema).length > 0) || $schema === false : it.util.schemaHasRules($schema, it.RULES.all));
  out += 'var ' + ($errs) + ' = errors;var ' + ($valid) + ';';
  if ($nonEmptySchema) {
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    $it.schema = $schema;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    out += ' var ' + ($nextValid) + ' = false; for (var ' + ($idx) + ' = 0; ' + ($idx) + ' < ' + ($data) + '.length; ' + ($idx) + '++) { ';
    $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
    var $passData = $data + '[' + $idx + ']';
    $it.dataPathArr[$dataNxt] = $idx;
    var $code = it.validate($it);
    $it.baseId = $currentBaseId;
    if (it.util.varOccurences($code, $nextData) < 2) {
      out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
    } else {
      out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
    }
    out += ' if (' + ($nextValid) + ') break; }  ';
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += ' ' + ($closingBraces) + ' if (!' + ($nextValid) + ') {';
  } else {
    out += ' if (' + ($data) + '.length == 0) {';
  }
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('contains') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should contain a valid item\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += ' } else { ';
  if ($nonEmptySchema) {
    out += '  errors = ' + ($errs) + '; if (vErrors !== null) { if (' + ($errs) + ') vErrors.length = ' + ($errs) + '; else vErrors = null; } ';
  }
  if (it.opts.allErrors) {
    out += ' } ';
  }
  return out;
}


/***/ }),

/***/ 35699:
/***/ ((module) => {

"use strict";


var SCALAR_TYPES = ['number', 'integer', 'string', 'boolean', 'null'];

module.exports = function defFunc(ajv) {
  defFunc.definition = {
    type: 'array',
    compile: function(keys, parentSchema, it) {
      var equal = it.util.equal;
      var scalar = getScalarKeys(keys, parentSchema);

      return function(data) {
        if (data.length > 1) {
          for (var k=0; k < keys.length; k++) {
            var i, key = keys[k];
            if (scalar[k]) {
              var hash = {};
              for (i = data.length; i--;) {
                if (!data[i] || typeof data[i] != 'object') continue;
                var prop = data[i][key];
                if (prop && typeof prop == 'object') continue;
                if (typeof prop == 'string') prop = '"' + prop;
                if (hash[prop]) return false;
                hash[prop] = true;
              }
            } else {
              for (i = data.length; i--;) {
                if (!data[i] || typeof data[i] != 'object') continue;
                for (var j = i; j--;) {
                  if (data[j] && typeof data[j] == 'object' && equal(data[i][key], data[j][key]))
                    return false;
                }
              }
            }
          }
        }
        return true;
      };
    },
    metaSchema: {
      type: 'array',
      items: {type: 'string'}
    }
  };

  ajv.addKeyword('uniqueItemProperties', defFunc.definition);
  return ajv;
};


function getScalarKeys(keys, schema) {
  return keys.map(function(key) {
    var properties = schema.items && schema.items.properties;
    var propType = properties && properties[key] && properties[key].type;
    return Array.isArray(propType)
            ? propType.indexOf('object') < 0 && propType.indexOf('array') < 0
            : SCALAR_TYPES.indexOf(propType) >= 0;
  });
}


/***/ }),

/***/ 36097:
/***/ ((module) => {

"use strict";


/**
 * @typedef {[number, boolean]} RangeValue
 */

/**
 * @callback RangeValueCallback
 * @param {RangeValue} rangeValue
 * @returns {boolean}
 */
class Range {
  /**
   * @param {"left" | "right"} side
   * @param {boolean} exclusive
   * @returns {">" | ">=" | "<" | "<="}
   */
  static getOperator(side, exclusive) {
    if (side === "left") {
      return exclusive ? ">" : ">=";
    }

    return exclusive ? "<" : "<=";
  }
  /**
   * @param {number} value
   * @param {boolean} logic is not logic applied
   * @param {boolean} exclusive is range exclusive
   * @returns {string}
   */


  static formatRight(value, logic, exclusive) {
    if (logic === false) {
      return Range.formatLeft(value, !logic, !exclusive);
    }

    return `should be ${Range.getOperator("right", exclusive)} ${value}`;
  }
  /**
   * @param {number} value
   * @param {boolean} logic is not logic applied
   * @param {boolean} exclusive is range exclusive
   * @returns {string}
   */


  static formatLeft(value, logic, exclusive) {
    if (logic === false) {
      return Range.formatRight(value, !logic, !exclusive);
    }

    return `should be ${Range.getOperator("left", exclusive)} ${value}`;
  }
  /**
   * @param {number} start left side value
   * @param {number} end right side value
   * @param {boolean} startExclusive is range exclusive from left side
   * @param {boolean} endExclusive is range exclusive from right side
   * @param {boolean} logic is not logic applied
   * @returns {string}
   */


  static formatRange(start, end, startExclusive, endExclusive, logic) {
    let result = "should be";
    result += ` ${Range.getOperator(logic ? "left" : "right", logic ? startExclusive : !startExclusive)} ${start} `;
    result += logic ? "and" : "or";
    result += ` ${Range.getOperator(logic ? "right" : "left", logic ? endExclusive : !endExclusive)} ${end}`;
    return result;
  }
  /**
   * @param {Array<RangeValue>} values
   * @param {boolean} logic is not logic applied
   * @return {RangeValue} computed value and it's exclusive flag
   */


  static getRangeValue(values, logic) {
    let minMax = logic ? Infinity : -Infinity;
    let j = -1;
    const predicate = logic ?
    /** @type {RangeValueCallback} */
    ([value]) => value <= minMax :
    /** @type {RangeValueCallback} */
    ([value]) => value >= minMax;

    for (let i = 0; i < values.length; i++) {
      if (predicate(values[i])) {
        [minMax] = values[i];
        j = i;
      }
    }

    if (j > -1) {
      return values[j];
    }

    return [Infinity, true];
  }

  constructor() {
    /** @type {Array<RangeValue>} */
    this._left = [];
    /** @type {Array<RangeValue>} */

    this._right = [];
  }
  /**
   * @param {number} value
   * @param {boolean=} exclusive
   */


  left(value, exclusive = false) {
    this._left.push([value, exclusive]);
  }
  /**
   * @param {number} value
   * @param {boolean=} exclusive
   */


  right(value, exclusive = false) {
    this._right.push([value, exclusive]);
  }
  /**
   * @param {boolean} logic is not logic applied
   * @return {string} "smart" range string representation
   */


  format(logic = true) {
    const [start, leftExclusive] = Range.getRangeValue(this._left, logic);
    const [end, rightExclusive] = Range.getRangeValue(this._right, !logic);

    if (!Number.isFinite(start) && !Number.isFinite(end)) {
      return "";
    }

    const realStart = leftExclusive ? start + 1 : start;
    const realEnd = rightExclusive ? end - 1 : end; // e.g. 5 < x < 7, 5 < x <= 6, 6 <= x <= 6

    if (realStart === realEnd) {
      return `should be ${logic ? "" : "!"}= ${realStart}`;
    } // e.g. 4 < x < ∞


    if (Number.isFinite(start) && !Number.isFinite(end)) {
      return Range.formatLeft(start, logic, leftExclusive);
    } // e.g. ∞ < x < 4


    if (!Number.isFinite(start) && Number.isFinite(end)) {
      return Range.formatRight(end, logic, rightExclusive);
    }

    return Range.formatRange(start, end, leftExclusive, rightExclusive, logic);
  }

}

module.exports = Range;

/***/ }),

/***/ 36158:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8818);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var SurveyQuestionView = /*#__PURE__*/function (_View) {
  function SurveyQuestionView() {
    _classCallCheck(this, SurveyQuestionView);
    return _callSuper(this, SurveyQuestionView, arguments);
  }
  _inherits(SurveyQuestionView, _View);
  return _createClass(SurveyQuestionView, null, [{
    key: "getTableOptions",
    value: function getTableOptions() {
      return {
        canAdd: false,
        evalEdit: function evalEdit(record) {
          return !!record.id;
        },
        allowContextMenu: true,
        fields: [{
          name: 'SurveyId',
          relation: 'survey',
          optionLabels: 'Name',
          editor: 'select',
          label: 'Survey',
          setRelationTo: 'Survey',
          readonly: true
        }, {
          name: 'OrderNr',
          hidden: true,
          defValue: function defValue(r) {
            var _r$$parent;
            return ((_r$$parent = r.$parent) === null || _r$$parent === void 0 ? void 0 : _r$$parent.SurveyQuestions.length) + 1;
          }
        }, {
          name: 'Label',
          required: true,
          columns: 6
        }, {
          name: 'QuestionType',
          label: 'Question Type',
          editor: 'select',
          options: [{
            value: 'TEXT',
            label: 'Text'
          }, {
            value: 'LIST',
            label: 'List'
          }, {
            value: 'OPTIONS',
            label: 'Options'
          }, {
            value: 'TABLE',
            label: 'Table'
          }]
        }, {
          name: 'TableType',
          label: 'Table',
          editor: 'select',
          showIf: function showIf(record) {
            return record.QuestionType == 'TABLE';
          },
          options: [{
            value: 'SERVICE',
            label: 'Service'
          }, {
            value: 'HOTEL',
            label: 'Hotel'
          }, {
            value: 'CITY',
            label: 'City'
          }, {
            value: 'SUPPLIER',
            label: 'Supplier'
          }]
        }, {
          name: 'Closed',
          editor: 'checkbox',
          label: 'Archived'
        }, {
          name: 'SurveyQuestionOptions',
          editor: [],
          label: 'Question Options',
          rowFields: [{
            name: 'Label',
            required: true,
            label: 'Name'
          }],
          showIf: function showIf(record) {
            return record.QuestionType == 'LIST' || record.QuestionType == 'OPTIONS';
          }
        }],
        title: 'Survey Question'
      };
    }
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_0__["default"]);
_defineProperty(SurveyQuestionView, "table", 'surveyquestion');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SurveyQuestionView);

/***/ }),

/***/ 36171:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var AuthCipher = __webpack_require__(92356)
var Buffer = (__webpack_require__(92861).Buffer)
var MODES = __webpack_require__(530)
var StreamCipher = __webpack_require__(50650)
var Transform = __webpack_require__(56168)
var aes = __webpack_require__(50462)
var ebtk = __webpack_require__(68078)
var inherits = __webpack_require__(56698)

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv


/***/ }),

/***/ 36413:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__(87568);

var Time = asn.define('Time', function () {
	this.choice({
		utcTime: this.utctime(),
		generalTime: this.gentime()
	});
});

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
	this.seq().obj(
		this.key('type').objid(),
		this.key('value').any()
	);
});

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
	this.seq().obj(
		this.key('algorithm').objid(),
		this.key('parameters').optional(),
		this.key('curve').objid().optional()
	);
});

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
	this.seq().obj(
		this.key('algorithm').use(AlgorithmIdentifier),
		this.key('subjectPublicKey').bitstr()
	);
});

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
	this.setof(AttributeTypeValue);
});

var RDNSequence = asn.define('RDNSequence', function () {
	this.seqof(RelativeDistinguishedName);
});

var Name = asn.define('Name', function () {
	this.choice({
		rdnSequence: this.use(RDNSequence)
	});
});

var Validity = asn.define('Validity', function () {
	this.seq().obj(
		this.key('notBefore').use(Time),
		this.key('notAfter').use(Time)
	);
});

var Extension = asn.define('Extension', function () {
	this.seq().obj(
		this.key('extnID').objid(),
		this.key('critical').bool().def(false),
		this.key('extnValue').octstr()
	);
});

var TBSCertificate = asn.define('TBSCertificate', function () {
	this.seq().obj(
		this.key('version').explicit(0)['int']().optional(),
		this.key('serialNumber')['int'](),
		this.key('signature').use(AlgorithmIdentifier),
		this.key('issuer').use(Name),
		this.key('validity').use(Validity),
		this.key('subject').use(Name),
		this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
		this.key('issuerUniqueID').implicit(1).bitstr().optional(),
		this.key('subjectUniqueID').implicit(2).bitstr().optional(),
		this.key('extensions').explicit(3).seqof(Extension).optional()
	);
});

var X509Certificate = asn.define('X509Certificate', function () {
	this.seq().obj(
		this.key('tbsCertificate').use(TBSCertificate),
		this.key('signatureAlgorithm').use(AlgorithmIdentifier),
		this.key('signatureValue').bitstr()
	);
});

module.exports = X509Certificate;


/***/ }),

/***/ 36677:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var BN = __webpack_require__(28490);
var utils = __webpack_require__(47011);
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  this._bitLength = this.n ? this.n.bitLength() : 0;

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1, this._bitLength);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  var j;
  var nafW;
  for (j = 0; j < naf.length; j += doubles.step) {
    nafW = 0;
    for (var l = j + doubles.step - 1; l >= j; l--)
      nafW = (nafW << 1) + naf[l];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (j = 0; j < repr.length; j++) {
      nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w, this._bitLength);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var l = 0; i >= 0 && naf[i] === 0; i--)
      l++;
    if (i >= 0)
      l++;
    acc = acc.dblp(l);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
  points,
  coeffs,
  len,
  jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  var i;
  var j;
  var p;
  for (i = 0; i < len; i++) {
    p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b], /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3,  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (j = 0; j < len; j++) {
      var z = tmp[j];
      p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
      bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len));
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null,
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles,
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res,
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};


/***/ }),

/***/ 37007:
/***/ ((module) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),

/***/ 37071:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


/***/ }),

/***/ 37162:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51941);







function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingDayService = /*#__PURE__*/function (_BookingBaseModel) {
  function BookingDayService(obj) {
    var _this;
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingDayService);
    _this = _callSuper(this, BookingDayService, [obj]);
    var self = _this;
    return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(_this, (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var r;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return new Promise(function (resolve, reject) {
              resolve(self);
            });
          case 2:
            r = _context.sent;
            r._images = false;
            if (!r.Service || !r.Service.CarRental) {
              r.BookingDayServiceCar = null;
            }
            return _context.abrupt("return", r);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))());
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingDayService, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(BookingDayService, [{
    key: "booking",
    get: function get() {
      return this.$parent.$parent;
    }
  }, {
    key: "updateService",
    value: function () {
      var _updateService = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
        var res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.Service && this.Service.id)) {
                _context2.next = 5;
                break;
              }
              _context2.next = 3;
              return api.get('/api/service/' + this.Service.id);
            case 3:
              res = _context2.sent;
              if (res) {
                this.Service = res;
                if (res.Supplier) this.Supplier = res.Supplier;
                if (res.City) this.City = res.City;
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function updateService() {
        return _updateService.apply(this, arguments);
      }
      return updateService;
    }()
  }, {
    key: "setImagesToService",
    value: function () {
      var _setImagesToService = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.setImages();
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function setImagesToService() {
        return _setImagesToService.apply(this, arguments);
      }
      return setImagesToService;
    }()
  }, {
    key: "setImages",
    value: function () {
      var _setImages = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4() {
        var hasImagesToAdd, _iterator, _step, sImage, image, _iterator2, _step2, _sImage, _image;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (this.Service && this.Service.ImageId) hasImagesToAdd = true;
              if (this.Service.ServicePhotos) {
                _iterator = _createForOfIteratorHelper(this.Service.ServicePhotos);
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    sImage = _step.value;
                    if (sImage.ImageId) hasImagesToAdd = true;
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }
              if (!(this._images || this.BookingDayServiceImages && this.BookingDayServiceImages.length > 0)) {
                _context4.next = 6;
                break;
              }
              this._images = false;
              this.BookingDayServiceImages = [];
              return _context4.abrupt("return");
            case 6:
              this._images = true;
              if (!this.BookingDayServiceImages) this.BookingDayServiceImages = [];
              if (!(this.BookingDayServiceImages.length == 0 && hasImagesToAdd)) {
                _context4.next = 39;
                break;
              }
              if (!(this.Service && this.Service.ImageId)) {
                _context4.next = 16;
                break;
              }
              _context4.next = 12;
              return this.newRowByName('BookingDayServiceImages');
            case 12:
              image = _context4.sent;
              _context4.next = 15;
              return image.setValue({
                fieldName: 'ImageId',
                value: this.Service.ImageId
              });
            case 15:
              this.BookingDayServiceImages.push(image);
            case 16:
              if (!this.Service.ServicePhotos) {
                _context4.next = 39;
                break;
              }
              _iterator2 = _createForOfIteratorHelper(this.Service.ServicePhotos);
              _context4.prev = 18;
              _iterator2.s();
            case 20:
              if ((_step2 = _iterator2.n()).done) {
                _context4.next = 31;
                break;
              }
              _sImage = _step2.value;
              if (!_sImage.ImageId) {
                _context4.next = 29;
                break;
              }
              _context4.next = 25;
              return this.newRowByName('BookingDayServiceImages');
            case 25:
              _image = _context4.sent;
              _context4.next = 28;
              return _image.setValue({
                fieldName: 'ImageId',
                value: _sImage.ImageId
              });
            case 28:
              this.BookingDayServiceImages.push(_image);
            case 29:
              _context4.next = 20;
              break;
            case 31:
              _context4.next = 36;
              break;
            case 33:
              _context4.prev = 33;
              _context4.t0 = _context4["catch"](18);
              _iterator2.e(_context4.t0);
            case 36:
              _context4.prev = 36;
              _iterator2.f();
              return _context4.finish(36);
            case 39:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[18, 33, 36, 39]]);
      }));
      function setImages() {
        return _setImages.apply(this, arguments);
      }
      return setImages;
    }()
  }, {
    key: "addNewServiceImage",
    value: function () {
      var _addNewServiceImage = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5() {
        var image;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!this.BookingDayServiceImages) this.BookingDayServiceImages = [];
              _context5.next = 3;
              return this.newRowByName('BookingDayServiceImages');
            case 3:
              image = _context5.sent;
              this.BookingDayServiceImages.push(image);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function addNewServiceImage() {
        return _addNewServiceImage.apply(this, arguments);
      }
      return addNewServiceImage;
    }()
  }, {
    key: "setServiceVoucher",
    value: function setServiceVoucher() {
      this.VoucherDisabled = !this.VoucherDisabled;
    }
  }, {
    key: "title",
    get: function get() {
      var _this2 = this;
      if (this.Title) return this.Title;
      if (!this.Service) return;
      if (!this.Service.ServiceDescriptions) return;
      var t = _.find(this.Service.ServiceDescriptions, function (c) {
        return c.LanguageId == _this2.booking.LanguageId;
      });
      if (t) return t.Title;
    }
  }, {
    key: "serviceClassName",
    get: function get() {
      return '';
    }
  }, {
    key: "serviceRowName",
    get: function get() {
      var name;
      var category;
      var serviceType;
      if (this.Name) return this.Name;
      if (!this.Name && this.Service && this.Service.Name) name = this.Service.Name;
      if (this.ServiceCategory && this.ServiceCategory.Name) {
        category = this.ServiceCategory.Name;
      }
      if (this.Service && this.Service.ServiceType) {
        serviceType = this.Service.ServiceType.Name;
      }

      //if (!name) name = 'Add Service Name';
      var r = name;
      if (category && serviceType) r += ' (' + serviceType + ' ' + category + ')';
      if (!category && serviceType) r += ' (' + serviceType + ')';
      return r;
    }
  }, {
    key: "supplierName",
    get: function get() {
      var supplier;
      if (this.Supplier && this.Supplier.Name) supplier = this.Supplier.Name;
      if (!supplier && this.Service.Supplier && this.Service.Supplier.Name) supplier = this.Service.Supplier.Name;
      //if (!supplier) supplier = 'Add Supplier';
      return supplier;
    }
  }, {
    key: "supplierId",
    get: function get() {
      var _this$Service;
      if (this.SupplierId) return this.SupplierId;
      if ((_this$Service = this.Service) !== null && _this$Service !== void 0 && _this$Service.SupplierId) return this.Service.SupplierId;
    }
  }, {
    key: "cityName",
    get: function get() {
      if (this.City && this.City.Name) return this.City.Name;
      if (this.Service && this.Service.City && this.Service.City.Name) return this.Service.City.Name;
    }
  }, {
    key: "addSupplierToService",
    value: function () {
      var _addSupplierToService = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(records) {
        var record;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!(records === null)) {
                _context6.next = 3;
                break;
              }
              _context6.next = 3;
              return this.setValue({
                fieldName: 'SupplierId',
                value: null
              });
            case 3:
              if (!(records && records.length > 0)) {
                _context6.next = 7;
                break;
              }
              record = records[0];
              _context6.next = 7;
              return this.setValue({
                fieldName: 'SupplierId',
                value: record.id
              });
            case 7:
              ;
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function addSupplierToService(_x) {
        return _addSupplierToService.apply(this, arguments);
      }
      return addSupplierToService;
    }()
  }, {
    key: "setOrderNr",
    value: function setOrderNr(i) {
      this.OrderNr = i;
      if (i < 0) {
        throw 'Error en setOrderNr';
      }
    }
  }, {
    key: "serviceTypeCategory",
    get: function get() {
      var res = [];
      if (this.Service && this.Service.ServiceType && this.Service.ServiceType.Name) {
        res.push(this.Service.ServiceType.Name);
      }
      if (this.ServiceCategory && this.ServiceCategory.Name) {
        res.push(this.ServiceCategory.Name);
      }
      if (res.length > 0) return '(' + res.join(' ') + ')';
      return '';
    }
  }, {
    key: "supplierNameQuote",
    get: function get() {
      if (this.SupplierId && this.Supplier && this.Supplier.Name) {
        return this.Supplier.Name;
      }
      if (this.Service && this.Service.Supplier) {
        return this.Service.Supplier.Name;
      }
      return '';
    }
  }, {
    key: "dayNr",
    get: function get() {
      return this.$parent.DayNr;
    }
  }, {
    key: "serviceTotal",
    get: function get() {
      var res = {
        Cost: 0,
        Price: 0
      };
      var s = this;
      if (s.Quote && s.Quote.QuoteList) {
        for (var baseId in s.Quote.QuoteList.bases) {
          if (!s.Quote.QuoteList[baseId]) continue;
          for (var pType in s.Quote.QuoteList[baseId]) {
            var _s$Quote$QuoteList$ba;
            if (!((_s$Quote$QuoteList$ba = s.Quote.QuoteList[baseId]) !== null && _s$Quote$QuoteList$ba !== void 0 && (_s$Quote$QuoteList$ba = _s$Quote$QuoteList$ba[pType]) !== null && _s$Quote$QuoteList$ba !== void 0 && _s$Quote$QuoteList$ba.Include)) continue;
            var booking = s.$parent.$parent;
            if (!booking.isQuoteSelected(baseId, pType)) continue;
            if (!booking.variantSelected(baseId, pType, s.Quote.QuoteList[baseId])) continue;
            if (booking.QuoteBy == 'SERVICE' && s.costPer == 'SERVICE' && (pType == 'CHD' || pType == 'TL')) continue;
            /*if (booking.isGroup(baseId)) {
                for (let groupId in booking.QuoteGroups[baseId]) {
                    if (!booking.QuoteGroups[baseId][groupId][pType]) continue;
                    if (!booking.QuoteGroups[baseId]?.[groupId]?.Selected?.[pType]) continue;
                    let _pType = pType;
                    if (s.costPer == 'SERVICE' && (pType == 'CHD' || pType == 'TL')) {
                        _pType = 'ADT';
                    }
                    let personCost = s.Quote.QuoteList[baseId]?.[_pType]?.PersonCost || 0;
                    let personPrice = s.Quote.QuoteList[baseId]?.[_pType]?.PersonPrice || 0;
                    res.Cost += parseFloat(personCost) * booking.QuoteGroups[baseId][groupId][pType];
                    res.Price += parseFloat(personPrice) * booking.QuoteGroups[baseId][groupId][pType];
                }
                continue;
            }*/
            if (booking.QuoteBy == 'QUANTITY') {
              res.Cost += parseFloat(s.Quote.QuoteList[baseId][pType]._TotalCost);
              res.Price += parseFloat(s.Quote.QuoteList[baseId][pType]._TotalPrice);
            } else if (booking.QuoteBy == 'SERVICE') {
              res.Cost += parseFloat(s.Quote.QuoteList[baseId][pType]._TotalCost);
              res.Price += parseFloat(s.Quote.QuoteList[baseId][pType]._TotalPrice);
            } else {
              var pax = booking.BaseQuotes[baseId][pType];
              if (booking.Totals[baseId][pType].Pax) pax = parseInt(booking.Totals[baseId][pType].Pax);
              var q = pax;
              if (s.Quote.QuoteList[baseId][pType].Cost) {
                res.Cost += parseFloat(s.Quote.QuoteList[baseId][pType].Cost) * q;
              }
              if (s.Quote.QuoteList[baseId][pType].Price) {
                res.Price += parseFloat(s.Quote.QuoteList[baseId][pType].Price) * q;
              }
            }
          }
        }
      }
      return res;
    }
  }, {
    key: "paxQuantity",
    get: function get() {
      var res = 0;
      var s = this;
      var booking = s.$parent.$parent;
      if (s.Quote && s.Quote.QuoteList) {
        for (var baseId in booking.BaseQuotes.bases) {
          if (!s.Quote.QuoteList[baseId]) continue;
          var _iterator3 = _createForOfIteratorHelper(booking.BaseQuotes[baseId].paxTypes),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var pType = _step3.value;
              if (!s.Quote.QuoteList[baseId][pType]) continue;
              //if (!s.Quote.QuoteList[baseId][pType].Include) continue;
              //if (!booking.variantSelected(baseId, pType, s.Quote.QuoteList[baseId])) continue;
              if (booking.Totals[baseId] && booking.Totals[baseId][pType] && booking.Totals[baseId][pType].Selected) {
                var pax = booking.BaseQuotes[baseId].paxQuantity;
                if (booking.QuoteBy == 'QUANTITY') {
                  return pax;
                } else {
                  if (booking.Totals[baseId][pType].Pax) {
                    res += parseInt(booking.Totals[baseId][pType].Pax);
                  } else {
                    return pax;
                  }
                  ;
                }
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      }
      return res;
    }
  }, {
    key: "paxQuantityByBase",
    value: function paxQuantityByBase(baseId) {
      var res = 0;
      var s = this;
      var booking = s.$parent.$parent;
      if (s.Quote && s.Quote.QuoteList) {
        var _iterator4 = _createForOfIteratorHelper(booking.BaseQuotes[baseId].paxTypes),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var pType = _step4.value;
            if (!s.Quote.QuoteList[baseId][pType]) continue;
            //if (!s.Quote.QuoteList[baseId][pType].Include) continue;
            if (booking.Totals[baseId] && booking.Totals[baseId][pType] && booking.Totals[baseId][pType].Selected) {
              var pax = booking.BaseQuotes[baseId].paxQuantity;
              if (booking.QuoteBy == 'QUANTITY') {
                return pax;
              } else {
                if (booking.QuoteBy == 'PERSON' && booking.Totals[baseId][pType].Pax) {
                  res += parseInt(booking.Totals[baseId][pType].Pax);
                } else {
                  return pax;
                }
                ;
              }
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
      return res;
    }
  }, {
    key: "paxForService",
    get: function get() {
      var res = {};
      if (this.Quote && this.Quote.QuoteList) {
        for (var baseId in this.booking.BaseQuotes.bases) {
          if (!this.Quote.QuoteList[baseId]) continue;
          var quotePaxDetails = this.Quote.QuoteList[baseId].getPaxDetails;
          for (var pType in quotePaxDetails) {
            if (!quotePaxDetails[pType]) continue;
            res[pType] = quotePaxDetails[pType];
          }
        }
      }
      return res;
    }
  }, {
    key: "deleteComment",
    value: function deleteComment() {
      this.ServiceCommentDeleted = true;
    }
  }, {
    key: "setOptional",
    value: function setOptional() {
      for (var baseId in this.Quote.QuoteList.bases) {
        var quote = this.Quote.QuoteList[baseId];
        var _iterator5 = _createForOfIteratorHelper(quote.paxTypes),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var paxId = _step5.value;
            if (!quote[paxId]) continue;
            quote[paxId].Include = !this.Optional;
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }
  }, {
    key: "setCostPer",
    value: function setCostPer() {
      this.CostPerModified = true;
      for (var baseId in this.Quote.QuoteList.bases) {
        var quote = this.Quote.QuoteList[baseId];
        var _iterator6 = _createForOfIteratorHelper(quote.paxTypes),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var pType = _step6.value;
            if (!quote[pType]) continue;
            if (this.CostPer == 'PERSON') {
              quote[pType].$Quantity.value = quote[pType].Base;
            } else {
              quote[pType].$Quantity.value = 1;
            }
            ;
            quote[pType].setPriceByCost(false, true);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    }
  }, {
    key: "setADTCostCHD",
    value: function () {
      var _setADTCostCHD = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7() {
        var baseId, quote;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.t0 = _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().keys(this.Quote.QuoteList.bases);
            case 1:
              if ((_context7.t1 = _context7.t0()).done) {
                _context7.next = 9;
                break;
              }
              baseId = _context7.t1.value;
              quote = this.Quote.QuoteList[baseId];
              if (!(quote && quote.CHD)) {
                _context7.next = 7;
                break;
              }
              _context7.next = 7;
              return quote.CHD.setCost();
            case 7:
              _context7.next = 1;
              break;
            case 9:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function setADTCostCHD() {
        return _setADTCostCHD.apply(this, arguments);
      }
      return setADTCostCHD;
    }()
  }, {
    key: "setStatus",
    value: function setStatus() {}
  }, {
    key: "setSupplierId",
    value: function setSupplierId() {
      if (!this.Status) {
        this.Status = 'PENDING';
      }
    }
  }, {
    key: "setPending",
    value: function setPending() {
      if (this.Status == 'CANCELED') return;
      this.Status = 'PENDING';
    }
  }, {
    key: "setServiceDate",
    value: function setServiceDate() {
      this.setPending();
    }
  }, {
    key: "afterEdit",
    value: function afterEdit() {
      return {
        Optional: function Optional(r) {
          return r.setOptional();
        },
        ServiceDate: function ServiceDate(r) {
          r.setServiceDate();
        },
        Status: function Status(r) {
          r.setStatus();
        },
        SupplierId: function SupplierId(r) {
          r.setSupplierId();
        },
        ServiceId: function () {
          var _ServiceId = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8(r) {
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context8) {
              while (1) switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.next = 2;
                  return r.setService();
                case 2:
                case "end":
                  return _context8.stop();
              }
            }, _callee8);
          }));
          function ServiceId(_x2) {
            return _ServiceId.apply(this, arguments);
          }
          return ServiceId;
        }(),
        CostPer: function CostPer(r) {
          r.setCostPer();
        },
        ADTCostCHD: function () {
          var _ADTCostCHD = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee9(r) {
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee9$(_context9) {
              while (1) switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.next = 2;
                  return r.setADTCostCHD();
                case 2:
                case "end":
                  return _context9.stop();
              }
            }, _callee9);
          }));
          function ADTCostCHD(_x3) {
            return _ADTCostCHD.apply(this, arguments);
          }
          return ADTCostCHD;
        }(),
        Title: function Title(r) {
          r.$parent.setTitle();
        }
      };
    }
  }, {
    key: "setService",
    value: function () {
      var _setService = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee10() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!(this.Service && this.Service.CarRental)) {
                _context10.next = 3;
                break;
              }
              _context10.next = 3;
              return this.newBookingDayServiceCar({});
            case 3:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function setService() {
        return _setService.apply(this, arguments);
      }
      return setService;
    }()
  }, {
    key: "newBookingDayServiceCar",
    value: function () {
      var _newBookingDayServiceCar = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee11() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.newObject({
                objectClass: 'bookingdayservicecar'
              }, {}, 'BookingDayServiceCar');
            case 2:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function newBookingDayServiceCar() {
        return _newBookingDayServiceCar.apply(this, arguments);
      }
      return newBookingDayServiceCar;
    }()
  }, {
    key: "serviceSelected",
    value: function serviceSelected(viewMode) {
      if (viewMode == -1) return true;
      if (!this.Quote.QuoteList[viewMode]) return;
      var _iterator7 = _createForOfIteratorHelper(this.Quote.QuoteList[viewMode].paxTypes),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var paxType = _step7.value;
          if (this.Quote.QuoteList[viewMode][paxType] && this.Quote.QuoteList[viewMode][paxType].Include) {
            return true;
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  }, {
    key: "anyQuoteSelected",
    get: function get() {
      var quoteInclude = false;
      for (var baseId in this.booking.BaseQuotes.bases) {
        if (!this.booking.quotesSelected[baseId]) continue;
        if (!this.Quote) continue;
        if (!this.Quote.QuoteList[baseId]) continue;
        var _iterator8 = _createForOfIteratorHelper(this.Quote.QuoteList[baseId].paxTypes),
          _step8;
        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var paxType = _step8.value;
            if (this.Quote.QuoteList[baseId][paxType] && this.Quote.QuoteList[baseId][paxType].Include) {
              quoteInclude = true;
              break;
            }
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }
      return quoteInclude;
    }
  }, {
    key: "showItinerary",
    get: function get() {
      return true;
    }
  }, {
    key: "costPer",
    get: function get() {
      var res;
      if (this.CostPer) return this.CostPer;
      if (this.Service) {
        if (this.Service.CostBy == 'BASE_PERSON') res = 'PERSON';
        if (this.Service.CostBy == 'PERSON') res = 'PERSON';
        if (this.Service.CostBy == 'SERVICE') res = 'SERVICE';
        if (this.Service.CostBy == 'BASE_SERVICE') res = 'SERVICE';
      }
      if (!res && this.Service.Supplier && this.Service.Supplier.PrivateCostBy) {
        if (this.Service.Supplier.PrivateCostBy == 'SERVICE') res = 'SERVICE';
        if (this.Service.Supplier.PrivateCostBy == 'BASE_PERSON') res = 'PERSON';
        if (this.Service.Supplier.PrivateCostBy == 'BASE_SERVICE') res = 'SERVICE';
      }
      if (!res && this.CostPer) res = this.CostPer;
      return res;
    }
  }, {
    key: "skipQuoteCanceled",
    get: function get() {
      if (this.Status == 'CANCELED') return true;
    }
  }, {
    key: "serviceName",
    get: function get() {
      return this.Name || this.Service.Name;
    }
  }, {
    key: "costBy",
    get: function get() {
      var costBy;
      var quoteData = this.Quote;
      if (this.Service) {
        if (quoteData.CostBy) costBy = quoteData.CostBy;
        if (!costBy && this.Service.CostBy) costBy = this.Service.CostBy;
        if (!costBy && this.Service.ServiceType == 'PERSON') costBy = this.Service.ServiceType.CostBy;
        if (!costBy && this.Service.Supplier && this.Service.Supplier.PrivateCostBy) costBy = this.Service.Supplier.PrivateCostBy;
      }
      return costBy;
    }
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingDayService, "moduleName", 'bookingdayservice');
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingDayService, "serviceStatus", {
  PENDING: 'Pending',
  REQUESTED: 'Requested',
  CONFIRMED: 'Confirmed',
  CANCELED: 'Canceled'
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingDayService);

/***/ }),

/***/ 37892:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),

/***/ 39188:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(47011);
var BN = __webpack_require__(28490);
var inherits = __webpack_require__(56698);
var Base = __webpack_require__(36677);

var assert = utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16),
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis,
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 },
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
      var npoints = this._endoWnafT1;
      var ncoeffs = this._endoWnafT2;
      for (var i = 0; i < points.length; i++) {
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();

        if (split.k1.negative) {
          split.k1.ineg();
          p = p.neg(true);
        }
        if (split.k2.negative) {
          split.k2.ineg();
          beta = beta.neg(true);
        }

        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
      }
      var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

      // Clean-up references to points and coefficients
      for (var j = 0; j < i * 2; j++) {
        npoints[j] = null;
        ncoeffs[j] = null;
      }
      return res;
    };

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul),
      },
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1),
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1),
    },
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point)),
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point)),
    },
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);
  if (this.isInfinity())
    return this;
  else if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate),
      },
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  var i;
  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};


/***/ }),

/***/ 39258:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var BookingDay = api.importMixinModule('bookingday', 'model', 'custom');
var CustomBookingDay = /*#__PURE__*/function (_BookingDay) {
  function CustomBookingDay() {
    _classCallCheck(this, CustomBookingDay);
    return _callSuper(this, CustomBookingDay, arguments);
  }
  _inherits(CustomBookingDay, _BookingDay);
  return _createClass(CustomBookingDay, [{
    key: "setTitle",
    value: function setTitle(setBlank, force, removed) {}
  }, {
    key: "setServiceToDay",
    value: function () {
      var _setServiceToDay = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
        var record, include, description, cityId, isTemplate, templateLanguageId, changeService, currentService, index, row;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              record = _ref.record, include = _ref.include, description = _ref.description, cityId = _ref.cityId, isTemplate = _ref.isTemplate, templateLanguageId = _ref.templateLanguageId, changeService = _ref.changeService, currentService = _ref.currentService, index = _ref.index;
              _context.next = 3;
              return _superPropGet(CustomBookingDay, "setServiceToDay", this, 3)([{
                record: record,
                include: include,
                description: description,
                cityId: cityId,
                isTemplate: isTemplate,
                templateLanguageId: templateLanguageId,
                changeService: changeService,
                currentService: currentService,
                index: index
              }]);
            case 3:
              row = _context.sent;
              row.GroupByServiceId = record.GroupByServiceId;
              return _context.abrupt("return", row);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function setServiceToDay(_x) {
        return _setServiceToDay.apply(this, arguments);
      }
      return setServiceToDay;
    }()
  }]);
}(BookingDay);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomBookingDay);

/***/ }),

/***/ 39388:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8818);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var AgencyView = /*#__PURE__*/function (_View) {
  function AgencyView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, AgencyView);
    return _callSuper(this, AgencyView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(AgencyView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(AgencyView, null, [{
    key: "options",
    value: function options() {
      return {
        fieldsDataReplace: {
          ImageId: {
            name: 'ImageId',
            editor: 'photo-div',
            hideFromList: true,
            relation: 'image',
            setRelationTo: 'Image',
            label: 'Logo'
          },
          IconId: {
            name: 'IconId',
            editor: 'photo-div',
            hideFromList: true,
            relation: 'image',
            setRelationTo: 'Icon',
            label: 'Icon'
          }
        },
        fieldsOrder: ['Name', 'CompanyName', 'Email', 'Phone', 'Address', 'WebSite', 'Code', 'Markup', 'ImageId', 'IconId', 'ImagesPath'],
        canAdd: true
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(AgencyView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              res = _context.sent;
              res.fields.push({
                name: 'Attach',
                label: 'Attachments',
                editor: 'attach',
                columns: 12,
                hideFromList: true
              });
              if (!api.currentUser || api.currentUser.id != 1) {
                res.fields.splice(res.fields.findIndex(function (f) {
                  return f.name == 'ImagesPath';
                }), 1);
              }
              return _context.abrupt("return", res);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_4__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AgencyView);

/***/ }),

/***/ 39404:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = (__webpack_require__(47790).Buffer);
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [number & 0x3ffffff];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [0];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this._strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // '0' - '9'
    if (c >= 48 && c <= 57) {
      return c - 48;
    // 'A' - 'F'
    } else if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    } else {
      assert(false, 'Invalid character in ' + string);
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this._strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var b = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        b = c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        b = c - 17 + 0xa;

      // '0' - '9'
      } else {
        b = c;
      }
      assert(c >= 0 && b < mul, 'Invalid character');
      r += b;
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [0];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this._strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  function move (dest, src) {
    dest.words = src.words;
    dest.length = src.length;
    dest.negative = src.negative;
    dest.red = src.red;
  }

  BN.prototype._move = function _move (dest) {
    move(dest, this);
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype._strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  // Check Symbol.for because not everywhere where Symbol defined
  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
  if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') {
    try {
      BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
      BN.prototype.inspect = inspect;
    }
  } else {
    BN.prototype.inspect = inspect;
  }

  function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  }

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modrn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16, 2);
  };

  if (Buffer) {
    BN.prototype.toBuffer = function toBuffer (endian, length) {
      return this.toArrayLike(Buffer, endian, length);
    };
  }

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  var allocate = function allocate (ArrayType, size) {
    if (ArrayType.allocUnsafe) {
      return ArrayType.allocUnsafe(size);
    }
    return new ArrayType(size);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    this._strip();

    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    var res = allocate(ArrayType, reqLength);
    var postfix = endian === 'le' ? 'LE' : 'BE';
    this['_toArrayLike' + postfix](res, byteLength);
    return res;
  };

  BN.prototype._toArrayLikeLE = function _toArrayLikeLE (res, byteLength) {
    var position = 0;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position++] = word & 0xff;
      if (position < res.length) {
        res[position++] = (word >> 8) & 0xff;
      }
      if (position < res.length) {
        res[position++] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position < res.length) {
          res[position++] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position < res.length) {
      res[position++] = carry;

      while (position < res.length) {
        res[position++] = 0;
      }
    }
  };

  BN.prototype._toArrayLikeBE = function _toArrayLikeBE (res, byteLength) {
    var position = res.length - 1;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position--] = word & 0xff;
      if (position >= 0) {
        res[position--] = (word >> 8) & 0xff;
      }
      if (position >= 0) {
        res[position--] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position >= 0) {
          res[position--] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position >= 0) {
      res[position--] = carry;

      while (position >= 0) {
        res[position--] = 0;
      }
    }
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] >>> wbit) & 0x01;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this._strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this._strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this._strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this._strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this._strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this._strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out._strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out._strip();
  }

  function jumboMulTo (self, num, out) {
    // Temporary disable, see https://github.com/indutny/bn.js/issues/211
    // var fftm = new FFTM();
    // return fftm.mulp(self, num, out);
    return bigMulTo(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out._strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this._strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this._strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this._strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) <= num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this._strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this._strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this._strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q._strip();
    }
    a._strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modrn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modrn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || (r2 === 1 && cmp === 0)) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modrn = function modrn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return isNegNum ? -acc : acc;
  };

  // WARNING: DEPRECATED
  BN.prototype.modn = function modn (num) {
    return this.modrn(num);
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    this._strip();
    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this._strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is a BN v4 instance
        r.strip();
      } else {
        // r is a BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);

    move(a, a.umod(this.m)._forceRed(this));
    return a;
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);


/***/ }),

/***/ 39517:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var PaxLeadMixinView = api.importMixinModule('paxlead', 'views', 'custom');
var CustomPaxLeadView = /*#__PURE__*/function (_PaxLeadMixinView) {
  function CustomPaxLeadView() {
    _classCallCheck(this, CustomPaxLeadView);
    return _callSuper(this, CustomPaxLeadView, arguments);
  }
  _inherits(CustomPaxLeadView, _PaxLeadMixinView);
  return _createClass(CustomPaxLeadView, null, [{
    key: "options",
    value: function options() {
      var res = _superPropGet(CustomPaxLeadView, "options", this, 2)([]);
      if (res.fieldsOrder) {
        var i = _.findIndex(res.fieldsOrder, function (r) {
          return r == 'PaxEmail';
        });
        if (i > -1) {
          res.fieldsOrder.splice(i, 0, 'EventFairId');
        }
      }
      if (res.fieldsAbmList) {
        res.fieldsAbmList.splice(0, 0, 'id');
      }
      if (res.fieldsOrder) {
        res.fieldsOrder.splice(0, 0, 'id');
      }
      return res;
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, reviewDate;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(CustomPaxLeadView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              res = _context.sent;
              res.fields.splice(0, 0, {
                name: 'id',
                readonly: true,
                label: 'ID'
              });
              reviewDate = _.find(res.fields, function (r) {
                return r.name == 'ReviewDate';
              });
              if (reviewDate) {
                reviewDate.hideIf = function (record) {
                  return !record.LeadStatus || record.LeadStatus.StatusType != 'POSTPONE';
                };
              }
              return _context.abrupt("return", res);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(PaxLeadMixinView);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomPaxLeadView);

/***/ }),

/***/ 39777:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"ADT":"Adulto","TL":"Coordinador","AVERAGE":"PROMEDIO","About":"Acerca de","Accepted on":"Aceptado el","Accept All":"Aceptar todo","Access":"Acceso","Access Groups":"Permisos","Access Group":"Permisos","Accommodation Options":"Opciones de Alojamiento","Accommodation during your trip":"Alojamiento durante tu viaje","Accommodation":"Alojamiento","Account":"Cuenta","Action not allowed":"Sin permiso para esta acción","Action":"Acción","Activities View":"Vista Actividades","Activities":"Actividades","Actives":"Activos","Activity":"Actividad","Add Range":"Agregar Base","Add credit":"Agregar saldo a favor","Add Category":"Agregar Categoría","Add Comment":"Agregar Comentario","Add Destination":"Agregar Destino","Add Free Service":"Agregar Servicio Libre","Add group":"Agregar grupo","Add New Note":"Agregar Nueva Nota","Add Passengers":"Agregar Pasajeros","Add Passport":"Adjuntar pasaporte","Add payment":"Agregar pago","Add Quote Currency":"Ingresar Monedas de Cotización","Add Rooms Configuration":"Agregar Configuración de Habitaciones","Add Service Name":"Ingresar Nombre de Servicio","Add Service":"Agregar Servicio","Add Service on day":"Agregar Servicio el día","Add Services to Program":"Agregar Servicios a Programas","Add Template from day":"Agregar Template desde el día","Add Start Date":"Ingresar Fecha de Inicio","Add Supplier":"Ingresar Proveedor","Add Ticket":"Adjuntar ticket","Add Template":"Agregar Template","Add Package":"Agregar Paquete","Add Totals":"Agregar Totales","Adding Mode":"Modo de Agregado","Add":"Agregar","Address":"Dirección","Address, City & Country":"Dirección, Ciudad y País","Aditional Information":"Información Adicional","Administrate Payments":"Administrar Pagos","Administration":"Administración","Adults":"Adultos","Adventure":"Aventura","Age From":"Edad Desde","Age To":"Edad Hasta","Age":"Edad","Age Range":"Rango de Edad","Agency":"Agencia","Agency List":"Listado de Agencias","Agent AI":"Agente AI","Airline and flight number":"Linea aérea y número de vuelo","Airports":"Aeropuertos","All Confirmed":"Todos los Confirmados","All Days":"Todos los días","All":"Todo","Allergies":"Alergias","_Allergies":"¿Alergias? ¿Cuáles?","Already registered for this date":"Ya registrado para esta fecha","Amount to Pay":"Monto a Pagar","Amount":"Monto","Amount greater than Credit balance":"Monto mayor al Saldo a favor pendiente","An email was sent to your inbox":"Hemos enviado un correo a tu casilla","Any ideas or suggestions about this app?":"¿Alguna idea o sugerencia sobre esta app?","Apr":"Abr","April":"Abril","Applied Amount":"Monto Aplicado","Apply Invoice":"Aplicar Factura","Apply Increase":"Aplicar Aumento","Archive":"Archivar","Archived":"Archivado","Archiveds":"Archivados","Argentina Suggested Restaurants":"Argentina - Restaurants recomendados","Arrival City":"Ciudad de Llegada","Arrival city":"Ciudad de arribo","Attachments":"Adjuntos","Attachments errors":"Error al adjuntar","Attachments sent":"Adjuntos enviados","Attention! This provider has payments in the file. Before make changes, edit or remove payments. Do you want to continue?":"Atención! Este proveedor tiene pagos ingresados en el file. Antes de realizar los cambios, editar o eliminar los pagos. ¿Desea continuar?","Average Days":"Promedio de Días","Average Age":"Promedio de Edad","Average Price":"Precio Promedio","Audit":"Auditar","Aug":"Ago","August":"Agosto","Authorization Pending":"Autorización Pendiente","Authorize":"Autorizar","BOOK WITH CONFIDENCE":"RESERVA CON CONFIANZA ","Back":"Volver","Balance Pending":"Saldo Pendiente","Balance":"Saldo","Bank Account":"Cuenta Bancaria","Bank Details":"Datos Bancarios","Bars":"Barras","Base Amount":"Monto Base","Base Value":"Base Imponible","Base from":"Base desde","Base to":"Base hasta","Base_person":"Por Persona Variable","Base_service":"Por Servicio Variable","Basic Data":"Datos Básicos","Birth Date":"Fecha de Nacimiento","Book Now":"Reserve ahora","Booked by yourself":"Reservado por tu cuenta","Booked Services":"Servicios contratados","BookingId":"File","Booking Confirmation number":"Número de Confirmación","Booking Id":"File","Booking From":"Reserva de","Booking Form Flights":"Vuelos","Booking Form Paxs":"Pasajeros","Booking Information Form":"Formulario de reservas","Booking Internal":"Internos del File","Booking Status":"Estado File","Booking Views":"Visualizaciones","Booking request":"Pedido de Reserva","Reservation made":"Reserva realizada","Bookings by Sales Origin":"Cotizaciones por Origen de Venta","Bookings by Customer":"Cotizaciones por Cliente","Bookings by Seller":"Cotizaciones por Vendedor","Bookmarks":"Marcadores","Box Lunch":"Box Lunch","Budget":"Presupuesto","Business Hours":"Horario","Breakfast":"Desayuno","By":"Por","Per Pax":"Por Pax","Per Person, fixed":"Por Persona, Fijo","Per Person":"Por Persona","Per Person variable":"Por Persona Variable","Per Service":"Por Servicio","Per Service, fixed":"Por Servicio, Fijo","Per Service variable":"Por Servicio Variable","CANCELED":"Cancelado","CHD":"Menor","CLIENT":"PASAJERO","COMMENTS":"COMENTARIOS","CONFIRMED":"Confirmado","Confirmed Program":"Programa Confirmado","CONTACT US":"Contáctenos","CPL Room":"Habitación Cuádruple","CPL":"Cuádruple","CREATED":"Inicial","Updated Values":"Valores Actualizados","Update":"Actualizar","Update cost edited manually?":"¿Actualizar costos editados manualmente?","Bases Quotations By":"Cotización Por","Cancel":"Cancelar","Cancel_":"Quitar","Canceled":"Cancelado","Cannot create Blackout because there are confirmed bookings in the period":"No se puede crear Blackout porque hay reservas confirmadas en el período","Car Rental":"Alquiler de Auto","Carbon Footprint":"Huella de Carbono","Carbon Footprint Per":"Huella de Carbono Por","Cash Flow":"Flujo de Caja","Cash Out":"Salidas de Fondo","Cash List":"Listado de Caja","Categories":"Categorías","ROOM_TYPE_CATEGORY":"Categoría y Tipo de Habitación","Catalogue":"Catálogo","Catalogues":"Catálogos","Role Type":"Tipo de Contacto","Category and Room Type":"Categoría y Tipo de Habitación","Category":"Categoría","Multi Quote":"Múltiples Cotizaciones","Change":"Cambio","Change Hotel":"Cambiar de Hotel","Changes History":"Historial de Cambios","Current changes could not be saved":"Los cambios actuales podrían no grabarse","Custom":"Personalizado","Change Password":"Cambiar Contraseña","Change Supplier":"Cambiar Proveedor","Change View":"Cambiar Vista","Chart Set":"Serie","Chart Type":"Tipo de Grafico","Check our Pricing":"Consulta nuestros Precios","Children":"Menores","Child discount":"Descuento Menor","Chile Suggested Restaurants":"Chile - Restaurants recomendados","Cities":"Destinos","City":"Destino","City or Supplier filter is required":"Completar filtro de Destino o Proveedor","Classic":"Clásico","Classification":"Clasificación","Clear":"Limpiar","Click here":"Click aquí","Close File":"Cerrar File","Close List":"Listado de Cierres","Close":"Cerrar","Closed":"Cerrado","Code":"Código","Coding":"Codificación","Collapse All":"Contraer Todos","Columns":"Columnas","Comments or suggestions about this app?":"¿Comentarios o sugerencias acerca de esta app?","Comment":"Comentario","Commision Price":"Precio Comisionable","Commision":"Comisión","Commission Price":"Precio Comisionable","Commission":"Comisión","% Commission":"% Comisión","Company Name":"Razón Social","Company":"Empresa","Compare":"Comparar","Complete Days":"Completar Días","Complete cost, disable service or enter zero value":"Completar netos, deshabilitar el servicio o ingresar valor cero","Compress":"Comprimida","Concept":"Concepto","Configuration":"Configuración","Confirm":"Confirmar","Confirmed Date":"Fecha Confirmación","Confirmed Sales":"Ventas Confirmadas","Confirmed Time":"Tiempo de Confirmación","Confirmed":"Confirmado","Connection refused":"Error de Conexión","Consecutive Nights":"Noches Consecutivas","Contact Name":"Nombre de Contacto","Contact":"Contacto","Contact Relation":"Relación del contacto","Contacts":"Contactos","Continent":"Continente","Continue?":"¿Desea continuar?","Conversion Type":"Tipo de Conversión","Conversion":"Conversión","Convert to":"Convertir a","Copy":"Copiar","CostBy":"Costo por","Cost By":"Costo por","Cost Per":"Costo por","Cost per Base":"Costo por Base","Cost":"Costo","Costs":"Costos","Country Issued":"País de Emisión","Country Name":"País","Country of Origin of Passport":"País de origen del pasaporte","Country":"País","Country/Age Range":"País/Rango de Edad","Country/Sales Origin":"País/Origen de Venta","Age Range/Sales Origin":"Rango de Edad/Origen de Venta","Claims":"Reclamos","Claim Time":"Hora de Reclamo","Cover Picture":"Imagen de Portada","Create":"Crear","Create Quote":"Crear Cotización","Create Supplier":"Crear Proveedor","Create Template":"Crear Template","Create Catalogue":"Crear Catálogo","Created by":"Creado por","Created From":"Creado Desde","Created To":"Creado Hasta","Created":"Creado","Created User":"Usuario","Credit Note":"Nota de Crédito","Credit Number":"Nro. de Saldo","Credit witn balance negative":"Saldo con balance negativo","Cruise":"Crucero","Currencies":"Monedas","Currency Id":"Moneda","Currency Rate":"Cotización de Monedas","Currency Rate not found":"Cotización de Moneda no encontrada","Currency Rates":"Cotización de Monedas","Currency View":"Ver en Moneda","Currency":"Moneda","Currencies required":"Completar monedas","Current cost":"Costo actual","Current":"Actual","Customer Information":"Información del Cliente","Customer Price":"Precios al Cliente","Customer Receipts":"Cobranzas de Clientes","Customer Type":"Tipo de Cliente","Customer":"Cliente","Cut":"Cortar","DATE IN":"FECHA IN","DATE OUT":"FECHA OUT","DATE":"FECHA","DBL MAT":"Doble Matrimonial","DBL Room":"Habitación Doble","DBL TWIN":"Doble Twin","DBL":"Doble","DEPARTURE FLIGHT":"Vuelo de salida","DIFFICULTY":"GRADO DE DIFICULTAD","DOMESTIC FLIGHTS (COMPLETE ONLY IF YOU HAVE ALREADY PURCHASED INTERNAL FLIGHTS)":"Vuelos domésticos (Completar solo si lo has comprado por tu cuenta)","DURATION":"DURACIÓN","Data":"Datos","Data too long for field":"Data demasiado larga para la columna","Date Inn":"Fecha Ingreso","Date Inn From":"Ingreso Desde","Date Inn To":"Ingreso Hasta","Date Out":"Fecha Salida","Date and time of flight":"Día de salida y horario","Date of Birth":"Fecha de Nacimiento","Date":"Fecha","Dates Range":"Rango de Fechas","Day":"Día","Day Change":"Cambio de Dia","Day Nr.":"Día Nr.","Days From":"Días Desde","Days To":"Días Hasta","Days Quantity":"Cantidad de Días","Days":"Días","Destination":"Destino","Destination Country":"País Destino","Destination name indicated in the service":"Nombre del destino indicado en el servicio","Dec":"Dic","December":"Diciembre","Delete Base":"Borrar base","Delete Groups":"Borrar grupos","Delete row":"Borrar línea","Delete all rows":"Borrar todas las líneas","Delete empty rows":"Borrar líneas vacías","Delete Attach?":"¿Eliminar adjunto?","Delete Record?":"¿Eliminar registro?","Delete picture":"Borrar imagen","Delete":"Eliminar","Deleted":"Eliminado","Department":"Área","Departure City":"Ciudad de Salida","Departure Flight":"Vuelo de Salida","Departure_flight":"Vuelo de Salida","Departure city":"Ciudad de salida","Dependencies":"Dependencias","Deposit":"Depósito","Descriptions":"Descriptivos","Deselect all":"Deseleccionar todos","Deselect day":"Deseleccionar día","Deselect All":"Deseleccionar Todos","Deselect Day":"Deseleccionar Día","Detail":"Detalle","Dietary Restrictions (Celiac, Vegan, Diabetic. etc)":"Restricciones alimenticias (Celiacos, Veganos, Diabeticos. etc)","Dietary":"Dieta","Diff %":"Dif.%","Difference":"Diferencia","Difficulty":"Dificultad","Dinner":"Cena","Disable":"Deshabilitar","Disable Links":"Deshabilitar Links","Disabled":"Deshabilitado","Disabled while pending changes":"Deshabilitado mientras hay cambios pendientes","Discount Percentage":"Porcentaje de Descuento","Discount":"Descuento","Discount per person":"Descuento por persona","Discounted price":"Precio con descuento","Divide":"Dividir","Documents":"Documentación","Documentation for your trip":"DOCUMENTACIÓN PARA TU VIAJE","Documentation":"Documentación","DOCUMENTS ALREADY SENT":"DOCUMENTOS YA ENVIADOS","_DOCS":"Documentación","Domestic":"Local","Domain":"Dominio","Done":"Aceptar","Download":"Descargar","Double":"Doble","Drag services here":"Arrastre los servicios aquí","Drop Off Address":"Dirección Devolución","Drop Off City":"Destino Devolución","Drop Off Date":"Fecha Devolución","Drop Off Time":"Hora Devolución","Duplicated contact for email":"Contacto duplicado para el correo","Due Cost":"Tarifarios Vencidos","Due Date":"Vencimiento","Due Date From":"Vencimiento Desde","Due Date To":"Vencimiento Hasta","_Due":"Vto.","Duration":"Duración","EASY":"FÁCIL","Entry_flight":"Vuelo de entrada","ENTRY FLIGHT":"Vuelo de entrada","Easy":"Fácil","Edit Range":"Editar Base","Edit Hotel":"Editar Hotel","Edit Images":"Editar Imágenes","Edit Note":"Editar Nota","Edit Quote Configuration":"Editar Configuración de Cotizaciones","Edit Service":"Editar Servicio","Edit":"Editar","Edited by":"Editado por","Edited":"Editado","Emergency Phone":"Teléfono de Emergencia","Emergency Contact":"Contacto de Emergencia","Emergency Contact Phone":"Teléfon del Contacto de Emergencia","Emergency Contacts":"Contactos de Emergencia","Emergency contacts":"Contactos de Emergencia","Enable":"Habilitar","End Date can not be lower than Start Date":"Fecha Fin no puede ser menor a Fecha Inicio","End Date":"Fecha Fin","End of our services":"Final de nuestros servicios","Entrance Included":"Entradas Incluídas","Entrances Includes":"Entradas Incluidas","Entry Flight":"Vuelo de Llegada","Estimated Profits":"Ganancia Estimada","Every Day":"Cada Día","Exclude Canceled":"Excluir Cancelados","Exclude Status":"Excluir Estado","Expand All":"Expandir Todos","Expanded":"Expandida","Expense":"Gasto","Expense Budget":"Presupuesto de Gasto","Expense File":"Gastos del Internos del File","Expense Pax":"Gasto de Pasajero","Expense Type":"Tipo de Gasto","Expenses":"Gastos","Expenses List":"Listado de Gastos","Expiration":"Vencimiento","Extra Bed":"Cama Extra","Extension":"Extensión","FIELDS_ERRORS":"Uno o más campos tienen un error. Por favor revisa e inténtalo de nuevo.","Failed to fetch":"Error de conexión a internet","Family Trip":"Familiar","Fares":"Tarifario","Feb":"Feb","February":"Febrero","Fill passengers range for  breakdown":"Complentar rango de pasajeros para el breakdown","File Profit":"Ganancia File","File - Tax":"File - Impuesto","File Status":"Estado de File","Fill City in all Free Services":"Completar Destino en todos los Servicios Libres","Fill required fields":"Completar campos requeridos","Filters":"Filtros","Filter Date by":"Filtro Fecha","Filter by":"Filtrar por","Filter by {column}":"Filtrar por {column}","Filter":"Filtro","Final Confirmation":"Confirmación Final","Finance":"Finanzas","Find Files":"Buscar Files","Find Passenger":"Buscar Pasajero","Finish":"Finalizar","First Name":"Primer Nombre","First":"Primero","First Day":"Primer Día","Fields required":"Campos requeridos","Fixed per person":"Fijo por persona","Flight":"Vuelo","Flight Date":"Fecha de Vuelo","Flight Number":"Número de Vuelo","Flight Type":"Tipo de Vuelo","Flight Schedule":"Vuelos","Flights per Person":"Vuelos por Persona","Flights Included":"Vuelos Incluidos","Flights Information":"Información de Vuelos","Flights NOT Included":"Vuelos NO Incluidos","Flights Tickets":"Vuelos","Flights per":"Vuelos por","Flights":"Vuelos","Foot Summary":"Sumar al final","Folder must be empty":"La carpeta debe estar vacía","For":"Para","Format":"Formato","Forgot password?":"¿Has olvidado tu contraseña?","Fr":"Vi","Fri":"Vie","Friday":"Viernes","From Date":"Fecha Desde","From":"Desde","_From":"Del","FromDate":"Fecha Desde","From_1":"De","Full Trip":"Viaje Completo","Full view":"Vista completa","GROSS_SERVICE":"El precio del servicio","the general terms and conditions of sale":"los términos y condiciones generales de venta","Gender":"Género","Green":"Verde","Price/ Pax Stay":"Precio/ Pax Estadía","Price Total":"Bruto Total","Price/Pax":"Precio/Pax","Group":"Grupo","Group Days":"Agrupar Dias","Group by":"Agrupar por","Group by City":"Agrupar por Destino","Group by Day":"Agrupar por Día","Group by month":"Agrupar por mes","Group Name":"Nombre del Grupo","Group Trip":"Viaje Grupal","Guide":"Guía","Guide Included":"Guía Incluído","HARD":"DIFÍCIL","HOTEL":"Hotel","HOTEL_GROSS":"El precio de la habitación en el hotel","HOW TO BOOK":"COMO RESERVAR","Hard":"Difícil","Help us to improve":"Ayúdanos a mejorar","Hide":"Ocultar","Hide Room Type":"Ocultar Tipo de Habitación","Hide Hotel Text":"Ocultar texto de Hoteles","Hide Images":"Ocultar Imágenes","Hide from Map":"Ocultar en el Mapa","Hide Breakdown Prices":"Ocultar Precios en Breakedown","Hide Total Price":"Ocultar Precio Total","Home":"Inicio","Hotel/Room removed":"Hotel/Habitación eliminada","Hotel Category":"Categoría de Hotel","Hotel Rates":"Tarifario de Hoteles","Hotel booked by Passenger":"Hotel por cuenta del Pasajero","Hotel cost cannot be empty":"Costo de hotel no puede estar vacío","Hotel cost cannot be zero":"Costo de hotel no puede ser cero","Hotels":"Hoteles","Who booked your trip?":"¿Quién reservó tu viaje?","I accept":"Acepto","I accept the":"Acepto los","INTERNATIONAL FLIGHTS":"Vuelos internacionales","IP Address":"Dirección IP","Image Profile":"Foto de Perfil","Images":"Imágenes","Importance":"Importancia","IN CASE OF EMERGENCY":"EN CASO DE EMERGENCIA","Include Canceled":"Incluir Cancelados","Include Destination":"Incluir Destinos","Include Flights":"Incluir Vuelos","Included":"Incluido","Includes":"Incluye","Incomes":"Ingresos","Income":"Ingreso","Include":"Incluir","Incorrect User or Password":"Credenciales incorrectas","Incorrect Due Date":"Fecha de Vencimiento Incorrecta","Incorrect field":"Campo incorrecto","Incorrect currency. Record not updated":"Moneda incorrecta. Registro no actualizado","Information":"Información","Initial":"Creado","Input Image Name":"Ingresar Nombre de Imagen","Input Text":"Ingresar texto","Input Values":"Ingresar Valores","Insert Days":"Insertar Dias","Integrity Error":"Error de Integridad","Internal Expense":"Gasto Interno","Internal Flights":"Vuelos Internos","Internal operational flights":"Vuelos internos operacionales","International Flights":"Vuelos Internacionales","International flights":"Vuelos internacionales","International":"Internacional","Internet connection error":"Error de conexión a internet","Invalid Payment Type for Credit":"Forma de pago incorrecta para Saldo a Favor","Invoice":"Factura","Invoice Applied":"Factura Aplicada","Invoice Balance":"Saldo Factura","Invoice Date":"Fecha Factura","Invoice Purchases":"Facturar Compras","Invoice Sales":"Facturar Ventas","Invoice Status":"Estdo de Factura","Invoices":"Facturas","Invoices Total":"Total Facturas","Invoiced":"Facturado","Issue Date":"Fecha de Emisión","It is not possible to view vouchers. Authorization changes pending":"No es posible Visualizar los Vouchers. Cambios Pendietes de Autorizar.","Itinerary":"Itinerario","ITINERARY":"ITINERARIO","Jan":"Ene","January":"Enero","Job Title":"Puesto de Trabajo","Job Description":"Puesto de Trabajo","Jul":"Jul","July":"Julio","Jun":"Jun","June":"Junio","Keep Edited Text":"Mantener Texto Editado","LOWER_THAN_NET":"es menor al cost el día ","Language":"Idioma","Language/Sales Origin":"Idioma/Origen de Venta","Languages":"Idiomas","Last Name":"Apellido","Last Date":"Última Fecha","Last":"Último","Latitude":"Latitud","Legal Name":"Razón Social","Less Crowded":"Menos Masificado","Load more":"Mostrar mas","Loading":"Cargando","Loading, wait please":"Cargando, espere por favor","Longitude":"Longitud","Local Service":"Servicio de Cercanía","Local Supplier":"Operador Local","Local Operator":"Operador Local","Locality":"Localidad","Lost":"Perdida","Low Pollution":"Menos Contaminante","Lunch":"Almuerzo","MIN_REQUIRED":"require un mímino de","MODERATE":"MEDIA","Mails":"Correos","Manage Images":"Gestionar Imágenes","Management Summary":"Resumen Gerencial","Map":"Mapa","Mar":"Mar","March":"Marzo","Margin":"Margen","Maximum allowed file size":"Tamaño de archivo máximo permitido","Max. allowed size":"Tamaño máximo","May":"Mayo","Meals Included":"Comidas Incluidas","Medication":"Medicación","Message sent":"Correo enviado","Message":"Mensaje","Middle Name":"Segundo Nombre","Min Value":"Valor Mínimo","Minimum Pax":"Mínimo de Pax","Minimum Stay":"Estadía Mínima","Mixed":"Mixto","Mo":"Lu","Mobile Phone Number":"Numero de celular","Mobile":"Celular","Modified":"Modificado","Modify":"Modificar","Mon":"Lun","Monday":"Lunes","Month":"Mes","More Flights":"Mas Vuelos","More Passengers":"Mas Viajeros","More than one hotel per quotation":"Mas de un hotel por cotización","Multiply":"Multiplicar","Must change password":"Debe cambiar contraseña","My Files":"Mis Files","My Quotations":"Mis Cotizaciones","My Sales":"Mis Ventas","My Templates":"Mis Templates","Names":"Nombres","Name and Surname":"Nombre y apellido","NIGHTS ACCOMMODATION IN":"NOCHES DE ALOJAMIENTO EN","NO":"NO","NO_PAY":"No Pagado","NOT FOUND":"NO ENCONTRADO","NOT_AVAILABLE_ON_DATE":"no disponible en fecha","NOT_AVAILABLE_ON_DAYS":"no esta disponible los días","NOT_BLANK":"Debe Completar","NOT_COST_ON_DATE":"no tiene neto para la fecha","NOT_ROOM_ASSIGNED":"no tiene Tipo de Habitación","NOT_ROOM_CAT_ASSIGNED":"no tiene Categoría de Habitación","NO DOCUMENTS ATTACHED":"SIN DOCUMENTOS ADJUNTOS","NO_HOTEL":"No hay Hotel la noche","Name":"Nombre","National Park Entrances Included":"Entradas a los Parques Nacionales Incluidas","Cost/ Pax Stay":"Neto / Pax Estadía","Cost / Room Night":"Neto / Hab Noche","Cost/Room Night":"Neto/Hab Noche","Cost Total":"Neto Total","Cost per":"Neto por","Cost/Pax":"Netos/Pax","New button in the right side of the text toolbar to reload updated service description":"Nuevo botón en el lado derecho de la barra de edición de texto para recargar la descripción actualizada del servicio","New Folder":"Crear Carpeta","New field to add or edit service title":"Nuevo campo para agregar o editar el título de un servicio","New Trip":"Nuevo Viaje","New option to select which filters display in each report":"Nueva opción para elegir que filtros mostrar en cada reporte","Hide or show report filters":"Ocultar o mostrar los filters de reportes","Report filters configuration":"Configuración de filters en reportes","Only avaible in reports with more than 4 filters":"Solo disponible en reportes con mas de 4 filtros","New":"Nuevo","New hotel/room":"Nuevo hotel/habitación","New service":"Nuevo servicio","New option to include pickup information in services request":"Nueva opción para incluir la información de pickup en el pedido de servicios","New Record":"Nuevo Registro","Next":"Siguiente","Night":"Noche","Nights Quantity":"Cantidad de Noches","Nights from":"Noches desde","Nights":"Noches","No Breakfast":"Sin Desayuno","No new Notifications":"Sin notificaiones","No Resident":"No Residente","None":"No Aplica","None Supplier":"Sin Proveedor","Not Apply":"No Corresponde","Not_apply":"No Corresponde","Not Close Apply":"No Aplica al Cierre","Not to pay":"No pagar","What can we do better?":"¿Qué podemos hacer mejor?","Without Description":"Sin Texto Descriptivo","Without Price":"Sin Precio","Not Included":"No Incluido","Not Includes":"No Incluye","Note":"Nota","No Informed":"No Informado","Not apply":"No aplica","Not results":"Sin resultados","Notes":"Notas","Notifications":"Notificaciones","Nov":"Nov","November":"Noviembre","There is a new update, please save changes and reload the site":"Hay una nueva actualización, por favor guarde los cambios y recargue el sitio","Number":"Número","N° OF ADULTS":"N° ADULTOS","N° OF CHILDREN":"N° MENORES","ON_ACCOUNT":"Saldo","On Account":"Saldo","ON_ROOM":"en habitación","OVERWRITE_PRICE":"Overwrite de Precio Final","Observations":"Observaciones","Oct":"Oct","October":"Octubre","Credits":"Saldos","Credit Used":"Saldo Utilizado","Credit":"Saldo a Favor","Credit only allows negative amounts":"Saldo a Favor solo permite montos negativos","One Total":"Un solo total","Only Differences":"Solo Diferencias","Only not added":"Solo no agregados","Open link":"Abrir Link","Operator":"Operador","Oper User Files":"Files por Usuario Operaciones","Oper User":"Usuario Operaciones","Operation":"Operación","Operation User":"Usuario Operaciones","Operation Status":"Estado Operaciones","Operations":"Operaciones","Option":"Opción","Optional Service":"Servicio Opcional","Optional Services":"Excursiones Opcionales","Optional":"Opcional","Optionals":"Opcionales","Optionals always visible in quotations":"Opcionales siempre visibles en cotizaciones","Origin":"Origen","Other Documents":"Otros Documentos","Other Expenses":"Otros Gastos","Other user":"Otro usuario","Others":"Otros","Our representatives in":"Nuestros representantes en","Outcomes":"Egresos","PAID":"Pagado","PACKAGE":"Paquete","PARK ENTRANCES INCLUDED":"Entradas a los parques incluidas","PARK ENTRANCES NOT INCLUDED":"Entradas a los parques no incluidas","PASSENGERS":"VIAJEROS","PENDING":"Pendiente","PREPAID TRAVEL VOUCHER":"VOUCHER PRE-PAGO","PROPOSE OF TRAVEL FOR":"PROPUESTA DE VIAJE PARA","Proyected Payments":"Pagos Proyectados","Package":"Paquete","Packages":"Paquetes","Page":"Página","Paid":"Pagado","Paid Amount":"Monto Pagado","Passenger Expense":"Gastos de Pasajeros","Passenger Expenses":"Gastos por cuenta del Pasajero","Passenger Groups":"Grupo de Pasajeros","Passenger Phone":"Teléfono del Pasajero","Passenger Mobile":"Celular del Pasajero","Passenger Name":"Pasajero","Passenger Type":"Tipo de Pasajero","Passenger prices unlocked":"Los precios al pasajero se modificarán!!","Passenger prices locked":"Los precios al pasajero NO se modificarán!!","Passenger":"Pasajero","Passengers List":"Listado de Pasajeros","Passengers":"Pasajeros","Passport Expiration Date":"Vencimiento del Pasaporte","Passport Valid To":"Vencimiento del Pasaporte","Passport Country":"País de Emisión","Passport":"Pasaporte","Password":"Contraseña","Paste":"Pegar","Pax Details In Services":"Detalles de Pax en Servicios","Pax Cost":"Neto Pax","Pax Price":"Precio Pax","Pax Comment":"Comentario Pax","Pax From":"Pasajeros Desde","Pax To":"Pasajeros Hasta","Pax Name":"Nombre de Pasajero","Pax Type":"Tipo Pax","Pax. Quant.":"Cant. de Pax","Pay":"Pagar","Pay Off":"Saldar","Payment Condition":"Condición de Pago","Payment Currency":"Moneda de Pago","Payment currency does not match with Credit currency":"La moneda de pogo no coincide con la moneda del Saldo","Payment Date":"Fecha de Pago","Payment Mode":"Forma de Pago","Payment Number":"Número de Pago","Payment Status":"Estado de Pago","Payment Type":"Forma de Pago","Payment":"Pago","Paymentcondition":"Condición de Pago","Payments List":"Listado de Pagos","Payments Applied":"Pagos aplicados","Payments":"Pagos","Paymenttype":"Forma de Pago","Pending Authorization Changes":"Cambios pendientes de Autorizar","Pending":"Pendiente","Percent":"Porcentaje","Percentage":"Porcentaje","Period":"Período","Periods dates overlap":"Superposición de fechas entre períodos","Permissions":"Permisos","Person Fixed Price":"Precio Fijo por Persona","Person":"Persona","Personal Data":"Datos Personales","Persons":"Personas","Phone Number":"Número de teléfono","Phone":"Teléfono","Pick-up & Details":"Pickup & Detalles","Pickup Address":"Dirección Pickup","Pickup information in services request":"Información de Pickup en pedido de servicios","Pickup Time":"Hora Pickup","Picture":"Imagen","Pie":"Torta","Plain Text":"Texto Plano","Preview":"Vista Previa","Price From":"Precio Desde","Price To":"Precio Hasta","Price per Service":"Prercio por Servicio","Price per Person":"Precio por Persona","Price Per Person":"Precio por Persona","Price Per Day":"Precio por Día","Price Per":"Precio por","Price":"Precio","Prices":"Precios","Prices DON\'T include":"Precios NO Incluyen","Prices include":"Precios Incluyen","Prices Breakdown":"Breakdown de Precios","Pricing":"Precios","Print":"Imprimir","Privado":"Privado","Private Cost Per":"Cost por","Private Cost By":"Cost por","Private Templates":"Templates Privados","Private":"Privado","Process":"Proceso","Processing":"Procesando","Profile":"Perfil","Profit":"Ganancia","Profits":"Ganancia","Program - Night and Room Category":"Programa - Noche y Categoría de Habitación","Program - Night and Room Type":"Programa - Noche y Tipo de Habitación","Program - Night, Category and Room Type":"Programa - Noche, Categoría y Tipo de Habitación","NIGHT_ROOM_CATEGORY":"Programa - Noche y Categoría de Habitación","NIGHT_ROOM_TYPE":"Programa - Noche y Tipo de Habitación","ROOM_TYPE_CATEGORY_NIGHT":"Programa - Noche, Categoría y Tipo de Habitación","Program":"Programa","Programs":"Programas","Provided by":"Proveedor","Public":"Público","Purchase":"Compra","Purchase Invoice List":"Listado Facturas de Compra","Purchase Invoice":"Facturas de Compra","Purchases":"Compras","QUOTED_NOT_AMOUNT_RECEIVED":"El monto a cobrar no coincide con el total cotizado","Quant":"Cant.","Quant.":"Cant.","Quantities":"Cantidades","Quantity":"Cantidad","Quotations by Seller":"Cotizaciones por Vendedor","Quotation":"Cotización","Quotation Method":"Método de Cotización","Quotations":"Cotizaciones","Quote Date":"Fecha de Cotización","Quote per":"Cotizar por","Quote in other date":"Cotizar con otra fecha","Quote in":"Cotizar en","Quote":"Cotización","Quotes List":"Listado de Cotizaciones","Quotes by Seller":"Cotizaciones por Vendedor","Quoted":"Cotizado","Quotations of this file will be deleted, do you want to continue?":"Las cotizaciones de este File se eliminaran, ¿desea continuar?","RESERVE WITH CONFIDENCE":"Reserve con confianza","Read":"Leer","Reset Password":"Resetear Contraseña","ROOM":"HABITACIÓN","ROOM_NO_HOTEL":"Falta hotel en una habitación la noche","ROOM_PAX_QUANTITY":"Cantidad de pax mayor a la capacidad de habitaciones","Rate":"Cotización","Reject all":"Rechazar todo","Receipt Amount":"Monto Recibido","Receipt":"Recibo","Receipts List":"Listado de Recibos","Receipts Pending":"Recibos Pendientes","Receipts":"Recibos","Received":"Recibido","Received Currency":"Moneda Recibida","Received Date":"Fecha Recibido","Recent Entries":"Registros Recientes","Registration already entered":"Registro ya ingresado","Record recently modified by other session":"Registro modificado por otra sesión de usuario","Record not updated":"Registro no actualizado","Record not found":"Registro no encontrado","Record Saved":"Registro Grabado","Records":"Registros","Records per page":"Registros por página","Red":"Rojo","Refresh button to reload updated service description":"Botón para recargar la descripción actualizada del servicio","Reference":"Referencia","Refresh price for service":"Actualizar precios del servicio","Refresh prices for supplier":"Actualizar precios del proveedor","Regular":"Regular","Remove Folder":"Eliminar Carpeta","Remove Categories":"Eliminar Categorías","Remove Hotel":"Eliminar Hotel","Remove Period":"Eliminar Período","Remove Service":"Eliminar Servicio","Remove day":"Eliminar día","Remove":"Borrar","Rename":"Renombrar","Replace":"Reemplazar","Replace Service":"Reemplazar Servicio","Reports":"Reportes","Report":"Reporte","Required Services":"Servicios Requeridos","Request Flights":"Pedir Vuelos","Request Rooms":"Pedir Habitaciones","Request Rooms/Services":"Pedir Habitaciones/Servicios","Request Services":"Pedir Servicios","Required Service":"Servicio Requerido","Requested":"Pedido","Reservation Form":"Formulario de Reserva","Reservation Number":"Número de Reserva","Reservation under which name":"Reserva a nombre de","Reservation":"Reserva","Resident":"Residente","Restore":"Restablecer","Reservation Form updated for File":"Actualización de Formulario de Reserva File","Room Cost By":"Cost por","Room Categories":"Categorías de Habitación","Room Category":"Categoría de Habitación","Room Capacity":"Capacidad Hab.","Room Type":"Tipo de Habitación","Room Type?":"¿Tipo de habitación?","Room Types":"Tipos de Habitaciones","Room":"Habitación","Rooms Fares":"Tarifario Habitaciones","Rooms Quantity":"Cant. Habitaciones","Pax Quantity":"Cant. Pax","Rooms quantity required in hotels":"Cantidad de habitaciones requerida en hoteles","Rooms":"Habitaciones","Run":"Ejecutar","Schedule":"Horario","Schedule Delivery":"Programar envío","SERVICES INCLUDED":"SERVICIOS INCLUIDOS","SGL Room":"Habitación Simple","SGL":"Simple","SIGN UP FOR OUR NEWSLETTER":"Subscríbase a nuestro newsletter","Signature":"Firma","_SIGNATURE":"AGENTE RESPONSABLE","Sa":"Sa","Sale Date":"Fecha de Venta","Sales Currency":"Moneda de Venta","Sales Invoices List":"Listado Facturas de Venta","Sales Date":"Fecha de Venta","Sales Origin":"Origen de Venta","Sales Price":"Precio de Venta","Sales Summary":"Resumen de Ventas","Sales by Seller":"Ventas por Vendedor","Sales":"Ventas","Salesman":"Vendedor","Seller":"Vendedor","Seller/Sales Origin":"Vendedor/Origen de Venta","Sat":"Sab","Saturday":"Sábado","Save Changes":"Guardar Cambios","Save Changes?":"¿Guardar Modificaciones?","Save Version":"Grabar Versión","Save settings":"Guardar opciones","Save":"Guardar","Search":"Buscar","Search services":"Buscar servicios","Search periods":"Buscar períodos","Season":"Temporada","Seasons":"Temporadas","Second Name":"Segundo Nombre","See Less":"Ver menos","See More":"Ver más","Select Activities View":"Elegir Vista Actividades","Select All":"Seleccionar Todo","Select Day":"Seleccionar Día","Select Category":"Elegir Categoría","Select Language":"Elegir Idioma","Select Picture":"Elegir Imagen","Select Purchase Invoice":"Elegir Factura de Compra","Select all":"Marcar todos","Select {column}":"Seleccionar {column}","Select":"Seleccionar","Self Drive":"Alquiler de Auto","Semi Privado":"Semi Privado","Semi-Privado":"Semi-Privado","Sending attachments":"Enviando adjuntos","Send Logs by Email":"Enviar Logs de Consola por Correo","Send":"Enviar","Sent":"Enviado","Sep":"Sep","September":"Septiembre","Service title editable in activities tab in itinteraries":"Título de servicio editable en pestaña Actividades en Itinerarios","Server Error":"Error de Servidor","Service Class":"Clase de Servicio","Service Rates":"Tarifario de Servicios","Service Date":"Fecha Servicio","Service Language":"Idioma de Servicio","Service List Quote":"Comparativo Cotizado / Tarifario","Service Offered Language":"Servicio Ofrecido en este Idioma","Service Status":"Estado de Servicio","Service Suppliers":"Operadores de Servicios","Service Type":"Tipo de Servicio","Service by Supplier List":"Servicios por Proveedor","Service removed":"Servicio eliminado","Service":"Servicio","SERVICE":"Servicio","Service/Hotel List":"Listado de Servicios/Hoteles","Services Fares":"Tarifario Servicios","Services":"Servicios","Services/Hotels List":"Listado de Servicios/Hoteles","Services/Hotels":"Servicios/Hoteles","Services/Person":"Servicios/Personas","Settings":"Opciones","Set Column Cost Per in service":"Completar Columna Costo por en servicio","Set Days Qty":"Cantidad de Días","Share File":"Compartir File","Show Archived":"Mostrar Archivados","Show Due":"Vencidos","Show Images":"Mostrar Imágenes","Show Itinerary Dates":"Mostrar Fechas en Itineraio","Show Prices per":"Mostrar Precios Por","Show Service Language":"Mostrar Idioma de Servicios","Show Service Type in Itinerary":"Mostrar Tipo de Servicio en Itinerario","Show URL":"Mostrar URL","Showing {from} to {to} of {count} records|{count} records|One record":"Mostrando {from} hasta {to} de {count} registros|{count} registros|Un registro","Sign in":"Ingresar","Sign out":"Salir","Simplified view":"Vista simplificada","Skipped Days":"Días Salteados","Snack":"Snack","Special characters are not allowed":"No se permiten caracteres especiales","Split Tour Leader Price":"Dividir precio del TL","Start Date":"Fecha de Inicio","Status":"Estado","Status not allowed for Credit payment type":"Estado no permitodo para forma de pago Saldo a Favor","Stay":"Estadía","Styles":"Estilos","Su":"Do","Sub Title":"Sub Título","Subject":"Asunto","Sum By":"Sumar por","Summary":"Resumen","Sun":"Dom","Sunday":"Domingo","Supplier Addresses":"Direcciones","Supplier Class":"Clase de Proveedor","Supplier Descriptions":"Descripciones","Supplier Invoice":"Factura Proveedor","Supplier List":"Listado de Proveedores","Supplier Packages":"Paquetes Proveedores","Supplier Payment":"Pagos a Proveedores","Supplier Payment Type":"Forma de Pago Prov.","Supplier Type":"Tipo","Supplier":"Proveedor","SupplierDescriptions":"Descriptivos","Supplierclass":"Clase","Suppliers":"Proveedores","Support":"Soporte","Surname":"Apellido","System":"Sistema","TERMS AND CONDITIONS":"TÉRMINOS Y CONDICIONES","TESTING ENVIROMENT":"ENTORNO DE PRUEBAS","TO":"PARA","TO_":"a","_TO":"al","TPL Room":"Habitación Triple","TPL":"Triple","TRIP MODE":"TIPO DE VIAJE","Table":"Tabla","Table Type":"Tipo de Tabla","Taking medication? If so, what?":"¿Tomando medicación? ¿Cuál?","Tax Amount":"Monto Impuesto","Tax Base Percent":"Base %","Tax Code":"Código de Impuesto","Tax Code for Invoicing":"Nro. de Registro para Facturación","Tax Excempt":"Excento","Tax Number":"Reg.ID","Tax":"Impuesto","Taxcode":"Impuesto","Taxes":"Impuestos","Template":"Template","Terms & Conditions":"Términos & Condiciones","Terms and Conditions":"Términos y Condiciones","Text Summary":"Texto Intro","Text":"Texto","Th":"Ju","The operation could not be completed":"No se pudo completar la operación","There is not reservation form":"No hay Reservation Form","This will remove groups configuration for all services and hotels in this quotation":"Esto eliminará la configuración de grupos para todos los servicios y hoteles en esta cotización","Thu":"Jue","Thursday":"Jueves","Time":"Tiempo","Title":"Título","To Date":"Fecha Hasta","To Day Nr.":"Hasta Dia Nr.","To much rows to retrieve. Please limit search":"Demasiadas líneas a devolver. Por favor acotar la búsqueda","To Pay":"A Pagar","To Receive":"A Recibir","To":"Hasta","To_1":"A","Today":"Hoy","Total balance":"Balance total","Total Cost":"Costo Total","Total Expenses":"Total Egresos","Total Hotels":"Total Hoteles","Total Incomes":"Ingreso Total","Total Invoices":"Total Facturas","Total Nights":"Noches Totales","Total Services":"Total Servicios","Total Trip Price":"Precio Total del Viaje","Total Price":"Precio Total","Total per Pax":"Total por Pasajero","Totals by User":"Total por Usuario","Totals by User/Day":"Total por Usuario/Día","Totals":"Totales","Transfer":"Traslado","Transfer Included":"Traslado Incluído","Translate to":"Traducir al","Translations":"Traducciones","Translate":"Traducir","Travel Conditions":"Condiciones de Viaje","travel contract":"Contrato de viaje","The quote for a single traveler must be in a single room.":"La cotización para un solo pasajero debe ser habitación SGL","Travel Details":"Detalles del Viaje","Travel for":"Viaje para","TRAVEL FOR":"VIAJE PARA","Traveled":"Viajado","Trip Date":"Fecha de Viaje","Trip Mode":"Tipo de Viaje","Trip Number":"Número de Viaje","Trip Summary":"Resumen de Viaje","Trip Title":"Título del Viaje","Trip Type":"Tipo de Viaje","Trip not found":"Viaje no encontrado","Trip":"Viaje","Tu":"Ma","Tue":"Mar","Tuesday":"Martes","Type of Service":"Tipo de Servicio","Type of service":"Tipo de Servicio","Type":"Tipo","Types":"Tipos","UNLINKED_SERVICE_PAYMENT":"tiene pagos sin servicios asociados","USED":"Saldo Utilizado","Unable to send mail":"No es posible enviar el correo","Under Quoted":"Sub-cotizado","Unique Date":"Fecha Única","Unit values for":"Valores para","Upload":"Cargar","Used Payment Type":"Forma de Pago Utilizada","Useful Information":"Información Útil","User Activity":"Actividad de Usuarios","User Name":"Nombre de Usuario","User":"Usuario","Uses":"Utilizaciones","Users":"Usuarios","User not found":"Usuario no encontrado","User has not email address":"El usuario no tiene dirección de correo","Valid Passport Number":"Número de pasaporte válido","Valid to":"Vencimiento","Valid until":"Válido hasta","Value":"Valor","Values":"Valores","Value already registered":"Valor ya resgistrado","Variable per Base":"Variable por Base","Variable per Person":"Variable por Persona","Variable by base":"Variable por base","Version News":"Novedades de Versión","Version":"Versión","Versions":"Versiones","View Dependencies":"Ver Dependencias","View Detail":"Ver Detalle","View like":"Ver Como","View":"Visualizar","View Cost per":"Ver Costo por","We":"Mi","Web Itinerary":"Itinerario Web","Web Site":"Sitio Web","Wed":"Mie","Wednesday":"Miércoles","Week Days":"Días de la Semana","With Category Only":"Solo con categorías","With Children":"Con Menores","With Flights":"Con Vuelos","Without Discount":"Sin Descuento","Without Flights":"Sin Vuelos","Without Hotel":"Sin Hotel","Without Rooms":"Sin Habitaciones","Without Services":"Sin Servicios","Wrong room for number of pax quoted":"Habitación incorrecta para cantidad de pax cotizados","Yellow":"Amarillo","YES":"SI","You can not set groups with variants, please remove variants first":"No se pueden establecer grupos con variantes, por favor elimine las variantes primero","You can not set variants with groups, please remove groups first":"No se pueden establecer variantes con grupos, por favor elimine los grupos primero","_Add":"Sumar","_City":"Ciudad","_Close":"Cierre","_May":"May","_TOTAL":"TOTAL","_from":"a partir de","already applied to payment":"ya aplica al pago","and":"y","based on":"base de","between dates":"entre fechas","has no room assigned":"no tiene asignada la habitación","has no room type":"no tiene tipo de habitación","has no room category":"no tiene categoría de habitación","has no quantity of rooms":"no tiene cantidad de habitaciones","has not Currency Rate":"no tiene Cotización de Moneda","is working on this record":"está trabajando en este registro","in":"en","in other tab":"en otra pestaña","not found":"no encontrado","per":"por","per Room per Night":"por Habitación por Noche","per Room per Program":"por Habitación por Estadía","per Person per Night":"por Persona por Noche","per Person per Program":"por Persona por Estadía","the privacy policy":"la política de privacidad","the itinerary":"el itinerario","terms and conditions":"Términos y condiciones","to":"a","with value":"con valor","_contact_person":"Persona a quien avisar en caso de necesidad durante su viaje","Insurance Company":"Empresa de seguros","Insurance Type":"Tipo de seguro","Member Number":"Número de socio","_entrance_includes":"Entradas a los Parques Nacionales Incluidas","SalesOriginMonth":"Origen de Venta por Mes","Sales Origin/Month":"Origen de Venta/Mes","Market/Month":"Mercado/Mes","MonthMarket":"Mercado por Mes","CampaignMonth":"Campaña por Mes","Campaign/Month":"Campaña/Mes","SubCampaignMonth":"Subcampaña por Mes","Sub Campaign/Month":"Subcampaña/Mes","Sure?":"Eliminar","LeadValueMonth":"Califica por Mes","Lead Value/Month":"Califica/Mes","AgencyMonth":"Agencia por Mes","Agency/Month":"Agencia/Mes","SalesOriginMarket":"Origen de Venta por Mercado","Sales Origin/Market":"Origen de Venta/Mercado","File By Destination":"File por Destino","There are emojis or special characters that you must remove before saving your data":"Hay emojis o caracteres especiales que debes eliminar antes de guardar tus datos","Quotes by Destination":"Cotizaciones por Destino","There is already a lead for this passenger":"Ya existe una consulta para este pasajero","There is already a user for the code":"Ya existe un usuario para el código","Data too long for column":"Texto demasiado largo para la columna","When a country is selected, the date range cannot exceed 1 month":"Cuando se selecciona un país, el rango de fechas no puede exceder 1 mes","The quotes for this copy will be deleted, do you want to continue?":"Se eliminarán las cotizaciones de esta copia, ¿desea continuar?","NOT_AVAILABLE_DATE":"La fecha de inicio es menor a la fecha actual","Hotel assignment pending":"Falta asignar hotel","Meals By Category":"Comidas por Categoría","Quotation method not permitted":"Método de cotización no permitido","Show Multi Quote By":"Mostrar Multi Cotización Por","Quantity / Pax Quantity":"Cantidad / Cantidad de Pax","Base / Rooms":"Base / Habitaciones","Markup":"Margen de Ganancia","Cost Per Person":"Costo por Persona","Add Required Items":"Sumar Items Requeridos","Currency is required in service cost":"La moneda es requerida en el costo del servicio"}');

/***/ }),

/***/ 39975:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Record = api.importMixinModule('servicepersonquote', 'model', 'custom');
var CustomServicePersonQuote = /*#__PURE__*/function (_Record) {
  function CustomServicePersonQuote() {
    _classCallCheck(this, CustomServicePersonQuote);
    return _callSuper(this, CustomServicePersonQuote, arguments);
  }
  _inherits(CustomServicePersonQuote, _Record);
  return _createClass(CustomServicePersonQuote, [{
    key: "_TotalCost",
    get: function get() {
      return this._totalCost;
    }
  }, {
    key: "_TotalPrice",
    get: function get() {
      return this._totalPrice;
    }
  }]);
}(Record);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomServicePersonQuote);

/***/ }),

/***/ 39994:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8818);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var ClaimView = /*#__PURE__*/function (_View) {
  function ClaimView() {
    _classCallCheck(this, ClaimView);
    return _callSuper(this, ClaimView, arguments);
  }
  _inherits(ClaimView, _View);
  return _createClass(ClaimView, null, [{
    key: "options",
    value: function options() {
      return {
        fieldsOrder: ['BookingId', 'TransDate', 'TableType', 'BookingDayRoomId', 'BookingDayServiceId', 'BookingFlightId', 'Problem', 'Comment'],
        fieldsAbmList: ['BookingId', 'TransDate', 'Problem'],
        canAdd: true
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, bookingIdField, transDate, tableType, hotelField, serviceField, flightField;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(ClaimView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              res = _context.sent;
              bookingIdField = _.find(res.fields, function (r) {
                return r.name == 'BookingId';
              });
              transDate = _.find(res.fields, function (r) {
                return r.name == 'TransDate';
              });
              if (transDate) {
                transDate.label = "Fecha de reclamo";
                transDate.required = true;
              }
              tableType = _.find(res.fields, function (r) {
                return r.name == 'TableType';
              });
              if (tableType) {
                tableType.label = "Tipo de Reclamo";
              }
              if (bookingIdField) {
                bookingIdField.columns = 6;
                bookingIdField.editor = "vue-select";
                bookingIdField.relation = "booking";
                bookingIdField.endpoint = "/api/booking/claim_list";
                bookingIdField.required = true;
                bookingIdField.optionLabels = function (row) {
                  return row.id + " - " + row.PaxName;
                };
              }
              hotelField = _.find(res.fields, function (r) {
                return r.name == 'BookingDayRoomId';
              });
              if (hotelField) {
                hotelField.hideIf = function (record) {
                  return record.TableType != 'HOTEL';
                };
                hotelField.endpoint = '/api/bookingdayroom/bybookingid/';
                hotelField.editor = 'vue-select';
                hotelField.relation = 'bookingdayroom';
                hotelField.label = 'Alojamiento';
                hotelField.columns = 6;
                hotelField.setRelationTo = 'BookingDayRoom';
                hotelField.optionLabels = function (row) {
                  var h = '';
                  if (row.Hotel) h = row.Hotel.Name;
                  var i = '';
                  if (row.Category) i = row.Category.Name;
                  var c = '';
                  if (row.Room) c = row.Room.Name;
                  return "".concat(h, " ").concat(i, " ").concat(c, " ").concat(moment(row.TransDate, "YYYY-MM-DD").format("DD/MM/YYYY"), " ");
                };
                hotelField.endpointFilters = function (record) {
                  if (record && record.BookingId) {
                    return {
                      BookingId: record.BookingId
                    };
                  }
                  return {};
                };
              }
              serviceField = _.find(res.fields, function (r) {
                return r.name == 'BookingDayServiceId';
              });
              if (serviceField) {
                serviceField.hideIf = function (record) {
                  return record.TableType != 'SERVICE';
                };
                serviceField.editor = 'vue-select';
                serviceField.relation = 'bookingdayservice';
                serviceField.label = 'Service';
                serviceField.setRelationTo = 'BookingDayService';
                serviceField.optionLabels = 'Name';
                serviceField.endpoint = '/api/custom/bookingdayservice/bybookingid/';
                serviceField.endpointFilters = function (record) {
                  if (record && record.BookingId) {
                    return {
                      BookingId: record.BookingId
                    };
                  }
                  return {};
                };
              }
              flightField = _.find(res.fields, function (r) {
                return r.name == 'BookingFlightId';
              });
              if (flightField) {
                flightField.hideIf = function (record) {
                  return record.TableType != 'FLIGHT';
                };
                flightField.editor = 'vue-select';
                flightField.relation = 'bookingflight';
                flightField.setRelationTo = 'BookingFlight';
                flightField.endpoint = '/api/bookingflight/bybookingid/';
                flightField.optionLabels = 'Output';
                flightField.label = 'Flight';
                flightField.optionLabels = function (row) {
                  if (!row.Output) return '';
                  return row.Output.substring(0, 40);
                };
                flightField.endpointFilters = function (record) {
                  if (record && record.BookingId) {
                    return {
                      BookingId: record.BookingId
                    };
                  }
                  return {};
                };
              }
              return _context.abrupt("return", res);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_0__["default"]);
_defineProperty(ClaimView, "table", 'claim');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ClaimView);

/***/ }),

/***/ 40237:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8818);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ServiceQuoteObjectView = /*#__PURE__*/function (_View) {
  function ServiceQuoteObjectView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, ServiceQuoteObjectView);
    return _callSuper(this, ServiceQuoteObjectView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(ServiceQuoteObjectView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(ServiceQuoteObjectView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", {
                fields: [{
                  name: 'Include',
                  defValue: true
                }, {
                  name: 'CurrencyId',
                  relation: 'currency',
                  optionLabels: 'id',
                  editor: 'select',
                  label: 'Currency'
                }, {
                  name: 'QuoteList',
                  editor: {},
                  objectClass: 'servicequotelist'
                }]
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(ServiceQuoteObjectView, "table", 'servicequoteobject');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ServiceQuoteObjectView);

/***/ }),

/***/ 40286:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const baseEncodeTables = {
  26: 'abcdefghijklmnopqrstuvwxyz',
  32: '123456789abcdefghjkmnpqrstuvwxyz', // no 0lio
  36: '0123456789abcdefghijklmnopqrstuvwxyz',
  49: 'abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ', // no lIO
  52: 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
  58: '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ', // no 0lIO
  62: '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
  64: '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-_',
};

function encodeBufferToBase(buffer, base) {
  const encodeTable = baseEncodeTables[base];
  if (!encodeTable) {
    throw new Error('Unknown encoding base' + base);
  }

  const readLength = buffer.length;
  const Big = __webpack_require__(69900);

  Big.RM = Big.DP = 0;
  let b = new Big(0);

  for (let i = readLength - 1; i >= 0; i--) {
    b = b.times(256).plus(buffer[i]);
  }

  let output = '';
  while (b.gt(0)) {
    output = encodeTable[b.mod(base)] + output;
    b = b.div(base);
  }

  Big.DP = 20;
  Big.RM = 1;

  return output;
}

let createMd4 = undefined;
let BatchedHash = undefined;

function getHashDigest(buffer, hashType, digestType, maxLength) {
  hashType = hashType || 'md4';
  maxLength = maxLength || 9999;

  let hash;

  try {
    hash = (__webpack_require__(91565).createHash)(hashType);
  } catch (error) {
    if (error.code === 'ERR_OSSL_EVP_UNSUPPORTED' && hashType === 'md4') {
      if (createMd4 === undefined) {
        createMd4 = __webpack_require__(1076);

        if (BatchedHash === undefined) {
          BatchedHash = __webpack_require__(61206);
        }
      }

      hash = new BatchedHash(createMd4());
    }

    if (!hash) {
      throw error;
    }
  }

  hash.update(buffer);

  if (
    digestType === 'base26' ||
    digestType === 'base32' ||
    digestType === 'base36' ||
    digestType === 'base49' ||
    digestType === 'base52' ||
    digestType === 'base58' ||
    digestType === 'base62'
  ) {
    return encodeBufferToBase(hash.digest(), digestType.substr(4)).substr(
      0,
      maxLength
    );
  } else {
    return hash.digest(digestType || 'hex').substr(0, maxLength);
  }
}

module.exports = getHashDigest;


/***/ }),

/***/ 40345:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(37007).EventEmitter;


/***/ }),

/***/ 40687:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);


function mountModelFromJSON(_x, _x2) {
  return _mountModelFromJSON.apply(this, arguments);
}
function _mountModelFromJSON() {
  _mountModelFromJSON = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(table, id) {
    var r, options, endpoint, model, record;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          r = __webpack_require__(87489)("./".concat(table, "-").concat(id, ".txt"))["default"];
          r = JSON.parse(r);
          _context.next = 4;
          return api.getModuleFieldsOptions(table, null, {});
        case 4:
          options = _context.sent;
          endpoint = "/api/".concat(table, "/");
          model = api.importMixinModule(table, 'model');
          _context.next = 9;
          return new model({
            id: id,
            tableName: table,
            options: options,
            endpoint: endpoint,
            record: r
          });
        case 9:
          record = _context.sent;
          return _context.abrupt("return", record);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _mountModelFromJSON.apply(this, arguments);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (mountModelFromJSON);

/***/ }),

/***/ 40748:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays:
            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
                '_'
            ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


/***/ }),

/***/ 41011:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                          ? ':a'
                          : b === 2
                            ? ':a'
                            : b === 3
                              ? ':e'
                              : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


/***/ }),

/***/ 41374:
/***/ ((module) => {

"use strict";

module.exports = function generate_properties(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $key = 'key' + $lvl,
    $idx = 'idx' + $lvl,
    $dataNxt = $it.dataLevel = it.dataLevel + 1,
    $nextData = 'data' + $dataNxt,
    $dataProperties = 'dataProperties' + $lvl;
  var $schemaKeys = Object.keys($schema || {}).filter(notProto),
    $pProperties = it.schema.patternProperties || {},
    $pPropertyKeys = Object.keys($pProperties).filter(notProto),
    $aProperties = it.schema.additionalProperties,
    $someProperties = $schemaKeys.length || $pPropertyKeys.length,
    $noAdditional = $aProperties === false,
    $additionalIsSchema = typeof $aProperties == 'object' && Object.keys($aProperties).length,
    $removeAdditional = it.opts.removeAdditional,
    $checkAdditional = $noAdditional || $additionalIsSchema || $removeAdditional,
    $ownProperties = it.opts.ownProperties,
    $currentBaseId = it.baseId;
  var $required = it.schema.required;
  if ($required && !(it.opts.$data && $required.$data) && $required.length < it.opts.loopRequired) {
    var $requiredHash = it.util.toHash($required);
  }

  function notProto(p) {
    return p !== '__proto__';
  }
  out += 'var ' + ($errs) + ' = errors;var ' + ($nextValid) + ' = true;';
  if ($ownProperties) {
    out += ' var ' + ($dataProperties) + ' = undefined;';
  }
  if ($checkAdditional) {
    if ($ownProperties) {
      out += ' ' + ($dataProperties) + ' = ' + ($dataProperties) + ' || Object.keys(' + ($data) + '); for (var ' + ($idx) + '=0; ' + ($idx) + '<' + ($dataProperties) + '.length; ' + ($idx) + '++) { var ' + ($key) + ' = ' + ($dataProperties) + '[' + ($idx) + ']; ';
    } else {
      out += ' for (var ' + ($key) + ' in ' + ($data) + ') { ';
    }
    if ($someProperties) {
      out += ' var isAdditional' + ($lvl) + ' = !(false ';
      if ($schemaKeys.length) {
        if ($schemaKeys.length > 8) {
          out += ' || validate.schema' + ($schemaPath) + '.hasOwnProperty(' + ($key) + ') ';
        } else {
          var arr1 = $schemaKeys;
          if (arr1) {
            var $propertyKey, i1 = -1,
              l1 = arr1.length - 1;
            while (i1 < l1) {
              $propertyKey = arr1[i1 += 1];
              out += ' || ' + ($key) + ' == ' + (it.util.toQuotedString($propertyKey)) + ' ';
            }
          }
        }
      }
      if ($pPropertyKeys.length) {
        var arr2 = $pPropertyKeys;
        if (arr2) {
          var $pProperty, $i = -1,
            l2 = arr2.length - 1;
          while ($i < l2) {
            $pProperty = arr2[$i += 1];
            out += ' || ' + (it.usePattern($pProperty)) + '.test(' + ($key) + ') ';
          }
        }
      }
      out += ' ); if (isAdditional' + ($lvl) + ') { ';
    }
    if ($removeAdditional == 'all') {
      out += ' delete ' + ($data) + '[' + ($key) + ']; ';
    } else {
      var $currentErrorPath = it.errorPath;
      var $additionalProperty = '\' + ' + $key + ' + \'';
      if (it.opts._errorDataPathProperty) {
        it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
      }
      if ($noAdditional) {
        if ($removeAdditional) {
          out += ' delete ' + ($data) + '[' + ($key) + ']; ';
        } else {
          out += ' ' + ($nextValid) + ' = false; ';
          var $currErrSchemaPath = $errSchemaPath;
          $errSchemaPath = it.errSchemaPath + '/additionalProperties';
          var $$outStack = $$outStack || [];
          $$outStack.push(out);
          out = ''; /* istanbul ignore else */
          if (it.createErrors !== false) {
            out += ' { keyword: \'' + ('additionalProperties') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { additionalProperty: \'' + ($additionalProperty) + '\' } ';
            if (it.opts.messages !== false) {
              out += ' , message: \'';
              if (it.opts._errorDataPathProperty) {
                out += 'is an invalid additional property';
              } else {
                out += 'should NOT have additional properties';
              }
              out += '\' ';
            }
            if (it.opts.verbose) {
              out += ' , schema: false , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
            }
            out += ' } ';
          } else {
            out += ' {} ';
          }
          var __err = out;
          out = $$outStack.pop();
          if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */
            if (it.async) {
              out += ' throw new ValidationError([' + (__err) + ']); ';
            } else {
              out += ' validate.errors = [' + (__err) + ']; return false; ';
            }
          } else {
            out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
          }
          $errSchemaPath = $currErrSchemaPath;
          if ($breakOnError) {
            out += ' break; ';
          }
        }
      } else if ($additionalIsSchema) {
        if ($removeAdditional == 'failing') {
          out += ' var ' + ($errs) + ' = errors;  ';
          var $wasComposite = it.compositeRule;
          it.compositeRule = $it.compositeRule = true;
          $it.schema = $aProperties;
          $it.schemaPath = it.schemaPath + '.additionalProperties';
          $it.errSchemaPath = it.errSchemaPath + '/additionalProperties';
          $it.errorPath = it.opts._errorDataPathProperty ? it.errorPath : it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
          var $passData = $data + '[' + $key + ']';
          $it.dataPathArr[$dataNxt] = $key;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
          } else {
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
          }
          out += ' if (!' + ($nextValid) + ') { errors = ' + ($errs) + '; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete ' + ($data) + '[' + ($key) + ']; }  ';
          it.compositeRule = $it.compositeRule = $wasComposite;
        } else {
          $it.schema = $aProperties;
          $it.schemaPath = it.schemaPath + '.additionalProperties';
          $it.errSchemaPath = it.errSchemaPath + '/additionalProperties';
          $it.errorPath = it.opts._errorDataPathProperty ? it.errorPath : it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
          var $passData = $data + '[' + $key + ']';
          $it.dataPathArr[$dataNxt] = $key;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
          } else {
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
          }
          if ($breakOnError) {
            out += ' if (!' + ($nextValid) + ') break; ';
          }
        }
      }
      it.errorPath = $currentErrorPath;
    }
    if ($someProperties) {
      out += ' } ';
    }
    out += ' }  ';
    if ($breakOnError) {
      out += ' if (' + ($nextValid) + ') { ';
      $closingBraces += '}';
    }
  }
  var $useDefaults = it.opts.useDefaults && !it.compositeRule;
  if ($schemaKeys.length) {
    var arr3 = $schemaKeys;
    if (arr3) {
      var $propertyKey, i3 = -1,
        l3 = arr3.length - 1;
      while (i3 < l3) {
        $propertyKey = arr3[i3 += 1];
        var $sch = $schema[$propertyKey];
        if ((it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all))) {
          var $prop = it.util.getProperty($propertyKey),
            $passData = $data + $prop,
            $hasDefault = $useDefaults && $sch.default !== undefined;
          $it.schema = $sch;
          $it.schemaPath = $schemaPath + $prop;
          $it.errSchemaPath = $errSchemaPath + '/' + it.util.escapeFragment($propertyKey);
          $it.errorPath = it.util.getPath(it.errorPath, $propertyKey, it.opts.jsonPointers);
          $it.dataPathArr[$dataNxt] = it.util.toQuotedString($propertyKey);
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            $code = it.util.varReplace($code, $nextData, $passData);
            var $useData = $passData;
          } else {
            var $useData = $nextData;
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ';
          }
          if ($hasDefault) {
            out += ' ' + ($code) + ' ';
          } else {
            if ($requiredHash && $requiredHash[$propertyKey]) {
              out += ' if ( ' + ($useData) + ' === undefined ';
              if ($ownProperties) {
                out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
              }
              out += ') { ' + ($nextValid) + ' = false; ';
              var $currentErrorPath = it.errorPath,
                $currErrSchemaPath = $errSchemaPath,
                $missingProperty = it.util.escapeQuotes($propertyKey);
              if (it.opts._errorDataPathProperty) {
                it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
              }
              $errSchemaPath = it.errSchemaPath + '/required';
              var $$outStack = $$outStack || [];
              $$outStack.push(out);
              out = ''; /* istanbul ignore else */
              if (it.createErrors !== false) {
                out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
                if (it.opts.messages !== false) {
                  out += ' , message: \'';
                  if (it.opts._errorDataPathProperty) {
                    out += 'is a required property';
                  } else {
                    out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
                  }
                  out += '\' ';
                }
                if (it.opts.verbose) {
                  out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
                }
                out += ' } ';
              } else {
                out += ' {} ';
              }
              var __err = out;
              out = $$outStack.pop();
              if (!it.compositeRule && $breakOnError) {
                /* istanbul ignore if */
                if (it.async) {
                  out += ' throw new ValidationError([' + (__err) + ']); ';
                } else {
                  out += ' validate.errors = [' + (__err) + ']; return false; ';
                }
              } else {
                out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
              }
              $errSchemaPath = $currErrSchemaPath;
              it.errorPath = $currentErrorPath;
              out += ' } else { ';
            } else {
              if ($breakOnError) {
                out += ' if ( ' + ($useData) + ' === undefined ';
                if ($ownProperties) {
                  out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
                }
                out += ') { ' + ($nextValid) + ' = true; } else { ';
              } else {
                out += ' if (' + ($useData) + ' !== undefined ';
                if ($ownProperties) {
                  out += ' &&   Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
                }
                out += ' ) { ';
              }
            }
            out += ' ' + ($code) + ' } ';
          }
        }
        if ($breakOnError) {
          out += ' if (' + ($nextValid) + ') { ';
          $closingBraces += '}';
        }
      }
    }
  }
  if ($pPropertyKeys.length) {
    var arr4 = $pPropertyKeys;
    if (arr4) {
      var $pProperty, i4 = -1,
        l4 = arr4.length - 1;
      while (i4 < l4) {
        $pProperty = arr4[i4 += 1];
        var $sch = $pProperties[$pProperty];
        if ((it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all))) {
          $it.schema = $sch;
          $it.schemaPath = it.schemaPath + '.patternProperties' + it.util.getProperty($pProperty);
          $it.errSchemaPath = it.errSchemaPath + '/patternProperties/' + it.util.escapeFragment($pProperty);
          if ($ownProperties) {
            out += ' ' + ($dataProperties) + ' = ' + ($dataProperties) + ' || Object.keys(' + ($data) + '); for (var ' + ($idx) + '=0; ' + ($idx) + '<' + ($dataProperties) + '.length; ' + ($idx) + '++) { var ' + ($key) + ' = ' + ($dataProperties) + '[' + ($idx) + ']; ';
          } else {
            out += ' for (var ' + ($key) + ' in ' + ($data) + ') { ';
          }
          out += ' if (' + (it.usePattern($pProperty)) + '.test(' + ($key) + ')) { ';
          $it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
          var $passData = $data + '[' + $key + ']';
          $it.dataPathArr[$dataNxt] = $key;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
          } else {
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
          }
          if ($breakOnError) {
            out += ' if (!' + ($nextValid) + ') break; ';
          }
          out += ' } ';
          if ($breakOnError) {
            out += ' else ' + ($nextValid) + ' = true; ';
          }
          out += ' }  ';
          if ($breakOnError) {
            out += ' if (' + ($nextValid) + ') { ';
            $closingBraces += '}';
          }
        }
      }
    }
  }
  if ($breakOnError) {
    out += ' ' + ($closingBraces) + ' if (' + ($errs) + ' == errors) {';
  }
  return out;
}


/***/ }),

/***/ 41396:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(37007).EventEmitter;


/***/ }),

/***/ 41488:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


/***/ }),

/***/ 41734:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


/***/ }),

/***/ 41794:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone:
                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                    '_'
                ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(
                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
                    function ($0, $1, $2) {
                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                    }
                );
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


/***/ }),

/***/ 41800:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var inherits = __webpack_require__(56698)
var Buffer = (__webpack_require__(92861).Buffer)

var Base = __webpack_require__(56168)

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac


/***/ }),

/***/ 41848:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort:
            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
                '_'
            ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


/***/ }),

/***/ 41926:
/***/ ((module) => {

"use strict";

module.exports = function generate_dependencies(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $schemaDeps = {},
    $propertyDeps = {},
    $ownProperties = it.opts.ownProperties;
  for ($property in $schema) {
    if ($property == '__proto__') continue;
    var $sch = $schema[$property];
    var $deps = Array.isArray($sch) ? $propertyDeps : $schemaDeps;
    $deps[$property] = $sch;
  }
  out += 'var ' + ($errs) + ' = errors;';
  var $currentErrorPath = it.errorPath;
  out += 'var missing' + ($lvl) + ';';
  for (var $property in $propertyDeps) {
    $deps = $propertyDeps[$property];
    if ($deps.length) {
      out += ' if ( ' + ($data) + (it.util.getProperty($property)) + ' !== undefined ';
      if ($ownProperties) {
        out += ' && Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($property)) + '\') ';
      }
      if ($breakOnError) {
        out += ' && ( ';
        var arr1 = $deps;
        if (arr1) {
          var $propertyKey, $i = -1,
            l1 = arr1.length - 1;
          while ($i < l1) {
            $propertyKey = arr1[$i += 1];
            if ($i) {
              out += ' || ';
            }
            var $prop = it.util.getProperty($propertyKey),
              $useData = $data + $prop;
            out += ' ( ( ' + ($useData) + ' === undefined ';
            if ($ownProperties) {
              out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
            }
            out += ') && (missing' + ($lvl) + ' = ' + (it.util.toQuotedString(it.opts.jsonPointers ? $propertyKey : $prop)) + ') ) ';
          }
        }
        out += ')) {  ';
        var $propertyPath = 'missing' + $lvl,
          $missingProperty = '\' + ' + $propertyPath + ' + \'';
        if (it.opts._errorDataPathProperty) {
          it.errorPath = it.opts.jsonPointers ? it.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + ' + ' + $propertyPath;
        }
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ('dependencies') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { property: \'' + (it.util.escapeQuotes($property)) + '\', missingProperty: \'' + ($missingProperty) + '\', depsCount: ' + ($deps.length) + ', deps: \'' + (it.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", "))) + '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'should have ';
            if ($deps.length == 1) {
              out += 'property ' + (it.util.escapeQuotes($deps[0]));
            } else {
              out += 'properties ' + (it.util.escapeQuotes($deps.join(", ")));
            }
            out += ' when property ' + (it.util.escapeQuotes($property)) + ' is present\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
      } else {
        out += ' ) { ';
        var arr2 = $deps;
        if (arr2) {
          var $propertyKey, i2 = -1,
            l2 = arr2.length - 1;
          while (i2 < l2) {
            $propertyKey = arr2[i2 += 1];
            var $prop = it.util.getProperty($propertyKey),
              $missingProperty = it.util.escapeQuotes($propertyKey),
              $useData = $data + $prop;
            if (it.opts._errorDataPathProperty) {
              it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
            }
            out += ' if ( ' + ($useData) + ' === undefined ';
            if ($ownProperties) {
              out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
            }
            out += ') {  var err =   '; /* istanbul ignore else */
            if (it.createErrors !== false) {
              out += ' { keyword: \'' + ('dependencies') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { property: \'' + (it.util.escapeQuotes($property)) + '\', missingProperty: \'' + ($missingProperty) + '\', depsCount: ' + ($deps.length) + ', deps: \'' + (it.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", "))) + '\' } ';
              if (it.opts.messages !== false) {
                out += ' , message: \'should have ';
                if ($deps.length == 1) {
                  out += 'property ' + (it.util.escapeQuotes($deps[0]));
                } else {
                  out += 'properties ' + (it.util.escapeQuotes($deps.join(", ")));
                }
                out += ' when property ' + (it.util.escapeQuotes($property)) + ' is present\' ';
              }
              if (it.opts.verbose) {
                out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
              }
              out += ' } ';
            } else {
              out += ' {} ';
            }
            out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ';
          }
        }
      }
      out += ' }   ';
      if ($breakOnError) {
        $closingBraces += '}';
        out += ' else { ';
      }
    }
  }
  it.errorPath = $currentErrorPath;
  var $currentBaseId = $it.baseId;
  for (var $property in $schemaDeps) {
    var $sch = $schemaDeps[$property];
    if ((it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all))) {
      out += ' ' + ($nextValid) + ' = true; if ( ' + ($data) + (it.util.getProperty($property)) + ' !== undefined ';
      if ($ownProperties) {
        out += ' && Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($property)) + '\') ';
      }
      out += ') { ';
      $it.schema = $sch;
      $it.schemaPath = $schemaPath + it.util.getProperty($property);
      $it.errSchemaPath = $errSchemaPath + '/' + it.util.escapeFragment($property);
      out += '  ' + (it.validate($it)) + ' ';
      $it.baseId = $currentBaseId;
      out += ' }  ';
      if ($breakOnError) {
        out += ' if (' + ($nextValid) + ') { ';
        $closingBraces += '}';
      }
    }
  }
  if ($breakOnError) {
    out += '   ' + ($closingBraces) + ' if (' + ($errs) + ' == errors) {';
  }
  return out;
}


/***/ }),

/***/ 42142:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23029);


var Cache = /*#__PURE__*/(0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(function Cache() {
  (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(this, Cache);
  this.objects = {};
});
window._cache = new Cache();

/***/ }),

/***/ 42353:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Libya) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


/***/ }),

/***/ 42675:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45458);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82284);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26028);





function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

//const uuidv1 = require('uuid');

var BaseModel = /*#__PURE__*/function () {
  function BaseModel(_ref) {
    var _this = this;
    var fields = _ref.fields,
      record = _ref.record,
      parent = _ref.parent,
      tableName = _ref.tableName,
      parentField = _ref.parentField,
      rowNr = _ref.rowNr,
      clone = _ref.clone;
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(this, BaseModel);
    var self = this;
    return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (parent) self.setParent(parent);
            if (parentField) self.$parentField = parentField;
            if (!parent && clone) self._isClone = true;
            if (rowNr) self._rowNr = rowNr;
            self._id = (0,uuid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)();
            //self._cache = {};
            self.fields = fields;
            if (!(!self.fields && self.constructor.moduleName)) {
              _context.next = 10;
              break;
            }
            _context.next = 9;
            return _this.constructor.getFields();
          case 9:
            self.fields = _context.sent;
          case 10:
            if (self.fields) {
              _context.next = 15;
              break;
            }
            _context.next = 13;
            return api.getTableFields(tableName);
          case 13:
            self.serverFields = _context.sent;
            self.fields = tools.serverTypes(self.serverFields);
          case 15:
            self.invalid = {};
            _context.next = 18;
            return self.initFieldProperties();
          case 18:
            self.tableSpec = {};
            if (clone) {
              _context.next = 27;
              break;
            }
            if (!record) {
              _context.next = 25;
              break;
            }
            _context.next = 23;
            return self.init(record);
          case 23:
            _context.next = 27;
            break;
          case 25:
            _context.next = 27;
            return self.create();
          case 27:
            self.getters = {};
            self.fieldsObject = self.getFieldsObject(self.fields);
            self._requestCount = 0;
            self._changeNr = 0;
            return _context.abrupt("return", self);
          case 32:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(BaseModel, [{
    key: "getFieldsObject",
    value: function getFieldsObject(fields) {
      var res = {};
      var _iterator = _createForOfIteratorHelper(fields),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var field = _step.value;
          res[field.name] = field;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return res;
    }
  }, {
    key: "tabFields",
    get: function get() {
      var res = [];
      var tabs = _.filter(this.fields, function (r) {
        return r && r.editor == 'tab';
      });
      var _iterator2 = _createForOfIteratorHelper(tabs),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var tab = _step2.value;
          if (!tab.fields) continue;
          var _iterator3 = _createForOfIteratorHelper(tab.fields),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var field = _step3.value;
              res.push(field);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return res;
    }
  }, {
    key: "abmFields",
    get: function get() {
      var _this2 = this;
      var fields = _.filter(this.fields, function (f) {
        if (f.hideCondition) {
          if (f.hideCondition(_this2)) {
            return false;
          }
        }
        return true;
      });
      return tools.getAbmFields(fields);
    }
  }, {
    key: "headerFields",
    get: function get() {
      var res = [];
      var _iterator4 = _createForOfIteratorHelper(this.fields),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var f = _step4.value;
          if (f.editor == 'tab') continue;
          if (f.editor == 'button') continue;
          if (f.editor == 'component') continue;
          if ((0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(f.editor) === 'object') continue;
          if (Array.isArray(f.editor)) continue;
          res.push(f.name);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return res;
    }
  }, {
    key: "fieldsList",
    get: function get() {
      return Object.assign([], this.fields).concat(this.tabFields);
    }
  }, {
    key: "initFieldProperties",
    value: function () {
      var _initFieldProperties = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
        var _this3 = this;
        var self, _iterator5, _step5, _loop;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              self = this;
              _iterator5 = _createForOfIteratorHelper(this.fieldsList);
              _context3.prev = 2;
              _loop = /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _loop() {
                var field;
                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _loop$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      field = _step5.value;
                      if (field.name) {
                        _context2.next = 3;
                        break;
                      }
                      return _context2.abrupt("return", 1);
                    case 3:
                      if (!(Array.isArray(field.editor) || field.rowFields)) {
                        _context2.next = 8;
                        break;
                      }
                      _this3['$' + field.name] = {
                        getters: {},
                        value: []
                      };
                      Object.defineProperty(_this3, field.name, {
                        enumerable: true,
                        configurable: true,
                        set: function set(value) {
                          _this3['$' + field.name].value = [];
                        },
                        get: function get() {
                          return _this3['$' + field.name].value;
                        }
                      });
                      _context2.next = 18;
                      break;
                    case 8:
                      if (!((0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(field.editor) == 'object')) {
                        _context2.next = 14;
                        break;
                      }
                      _context2.next = 11;
                      return _this3.newClassObject(field);
                    case 11:
                      _this3[field.name] = _context2.sent;
                      _context2.next = 18;
                      break;
                    case 14:
                      _this3['$' + field.name] = {
                        value: null,
                        getters: {}
                      };
                      _this3.invalid[field.name] = false;
                      //this.setGetter(field);
                      Object.defineProperty(_this3, field.name, {
                        enumerable: true,
                        configurable: true,
                        set: function set(value) {
                          _this3.setValue({
                            fieldName: field.name,
                            value: value
                          });
                        },
                        get: function get() {
                          return _this3['$' + field.name].value;
                        }
                      });
                      if (field.setRelationTo) {
                        _this3[field.setRelationTo] = {};
                      }
                    case 18:
                    case "end":
                      return _context2.stop();
                  }
                }, _loop);
              });
              _iterator5.s();
            case 5:
              if ((_step5 = _iterator5.n()).done) {
                _context3.next = 11;
                break;
              }
              return _context3.delegateYield(_loop(), "t0", 7);
            case 7:
              if (!_context3.t0) {
                _context3.next = 9;
                break;
              }
              return _context3.abrupt("continue", 9);
            case 9:
              _context3.next = 5;
              break;
            case 11:
              _context3.next = 16;
              break;
            case 13:
              _context3.prev = 13;
              _context3.t1 = _context3["catch"](2);
              _iterator5.e(_context3.t1);
            case 16:
              _context3.prev = 16;
              _iterator5.f();
              return _context3.finish(16);
            case 19:
            case "end":
              return _context3.stop();
          }
        }, _callee2, this, [[2, 13, 16, 19]]);
      }));
      function initFieldProperties() {
        return _initFieldProperties.apply(this, arguments);
      }
      return initFieldProperties;
    }()
  }, {
    key: "setValue",
    value: function () {
      var _setValue = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(_ref3) {
        var fieldName, value, oldVal, field;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              fieldName = _ref3.fieldName, value = _ref3.value;
              if (!this._clone && this._loaded) {
                //console.log(this.constructor.name, fieldName, value)
              }
              oldVal = this['$' + fieldName].value;
              this['$' + fieldName].value = value;
              field = _.find(this.fieldsList, function (c) {
                return c.name == fieldName;
              });
              if (!(value !== oldVal && !this._clone)) {
                _context4.next = 8;
                break;
              }
              _context4.next = 8;
              return this.afterEditField(field, value, oldVal);
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee3, this);
      }));
      function setValue(_x) {
        return _setValue.apply(this, arguments);
      }
      return setValue;
    }()
  }, {
    key: "_loaded",
    get: function get() {
      if (this.$parent) {
        return this.$parent._loaded;
      } else {
        if (this._recordLoaded != undefined) return this._recordLoaded;
      }
    }
  }, {
    key: "_clone",
    get: function get() {
      if (this.$parent) {
        return this.$parent._clone;
      } else {
        return this._isClone;
      }
    }
  }, {
    key: "afterEdit",
    value: function afterEdit() {
      return {};
    }
  }, {
    key: "afterEditField",
    value: function () {
      var _afterEditField = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(field, newVal, oldVal) {
        var newValNull, oldValNull, f;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!this._loaded) {
                _context5.next = 15;
                break;
              }
              newValNull = newVal === null || newVal === undefined || newVal === '';
              oldValNull = oldVal === null || oldVal === undefined || oldVal === '';
              if (!(!newValNull || !oldValNull)) {
                _context5.next = 13;
                break;
              }
              _context5.next = 6;
              return this.edit(field);
            case 6:
              if (!field.afterEdit) {
                _context5.next = 9;
                break;
              }
              _context5.next = 9;
              return field.afterEdit(this, newVal, oldVal);
            case 9:
              if (!(this.afterEdit && this.afterEdit()[field.name])) {
                _context5.next = 13;
                break;
              }
              f = this.afterEdit()[field.name];
              _context5.next = 13;
              return f(this, newVal, oldVal);
            case 13:
              this.setComputedFields();
              this.propagateChanges();
            case 15:
            case "end":
              return _context5.stop();
          }
        }, _callee4, this);
      }));
      function afterEditField(_x2, _x3, _x4) {
        return _afterEditField.apply(this, arguments);
      }
      return afterEditField;
    }()
  }, {
    key: "propagateChanges",
    value: function propagateChanges() {
      if (this.hasOwnProperty('$parent')) {
        this.$parent.propagateChanges();
      } else {
        this._changeNr += 1;
      }
    }
  }, {
    key: "afterEditRow",
    value: function () {
      var _afterEditRow = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(field) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!this._loaded) {
                _context6.next = 7;
                break;
              }
              _context6.next = 3;
              return this.edit(field);
            case 3:
              if (!field.afterEdit) {
                _context6.next = 6;
                break;
              }
              _context6.next = 6;
              return field.afterEdit(this);
            case 6:
              this.setComputedFields();
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee5, this);
      }));
      function afterEditRow(_x5) {
        return _afterEditRow.apply(this, arguments);
      }
      return afterEditRow;
    }()
  }, {
    key: "addRow",
    value: function () {
      var _addRow = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(_ref4) {
        var fieldName, values, field, childRow, _iterator6, _step6, f, objChild, _iterator7, _step7, objField, objectClass, name;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              fieldName = _ref4.fieldName, values = _ref4.values;
              field = _.find(this.fieldsList, function (c) {
                return c.name == fieldName;
              });
              _context7.next = 4;
              return this.newRow(field);
            case 4:
              childRow = _context7.sent;
              _context7.next = 7;
              return childRow.create();
            case 7:
              if (!values) {
                _context7.next = 55;
                break;
              }
              _iterator6 = _createForOfIteratorHelper(childRow.fieldsList);
              _context7.prev = 9;
              _iterator6.s();
            case 11:
              if ((_step6 = _iterator6.n()).done) {
                _context7.next = 47;
                break;
              }
              f = _step6.value;
              if (!values[f.name]) {
                _context7.next = 45;
                break;
              }
              if (!((0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(f.editor) == 'object')) {
                _context7.next = 44;
                break;
              }
              objChild = childRow[f.name];
              if (!objChild) {
                _context7.next = 42;
                break;
              }
              if (objChild.setFields) objChild.setFields();
              _iterator7 = _createForOfIteratorHelper(objChild.fields);
              _context7.prev = 19;
              _iterator7.s();
            case 21:
              if ((_step7 = _iterator7.n()).done) {
                _context7.next = 34;
                break;
              }
              objField = _step7.value;
              if (!values[f.name][objField.name]) {
                _context7.next = 32;
                break;
              }
              if (!((0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(objField.editor) == 'object')) {
                _context7.next = 31;
                break;
              }
              objectClass = api.importMixinModule(objField.objectClass, 'model');
              _context7.next = 28;
              return new objectClass({
                record: values[f.name][objField.name],
                parent: objChild
              });
            case 28:
              objChild[objField.name] = _context7.sent;
              _context7.next = 32;
              break;
            case 31:
              objChild[objField.name] = values[f.name][objField.name];
            case 32:
              _context7.next = 21;
              break;
            case 34:
              _context7.next = 39;
              break;
            case 36:
              _context7.prev = 36;
              _context7.t0 = _context7["catch"](19);
              _iterator7.e(_context7.t0);
            case 39:
              _context7.prev = 39;
              _iterator7.f();
              return _context7.finish(39);
            case 42:
              _context7.next = 45;
              break;
            case 44:
              childRow[f.name] = values[f.name];
            case 45:
              _context7.next = 11;
              break;
            case 47:
              _context7.next = 52;
              break;
            case 49:
              _context7.prev = 49;
              _context7.t1 = _context7["catch"](9);
              _iterator6.e(_context7.t1);
            case 52:
              _context7.prev = 52;
              _iterator6.f();
              return _context7.finish(52);
            case 55:
              name = field.fieldName ? field.fieldName : field.name;
              this[name].push(childRow);
              childRow._rowNr = this[name].length - 1;
              _context7.next = 60;
              return this.afterEditRow(field);
            case 60:
              return _context7.abrupt("return", childRow);
            case 61:
            case "end":
              return _context7.stop();
          }
        }, _callee6, this, [[9, 49, 52, 55], [19, 36, 39, 42]]);
      }));
      function addRow(_x6) {
        return _addRow.apply(this, arguments);
      }
      return addRow;
    }()
  }, {
    key: "removeRow",
    value: function () {
      var _removeRow = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7(_ref5) {
        var fieldName, rowNr, field;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              fieldName = _ref5.fieldName, rowNr = _ref5.rowNr;
              this['$' + fieldName].value.splice(rowNr, 1);
              field = _.find(this.fieldsList, function (c) {
                return c.name == fieldName;
              });
              _context8.next = 5;
              return this.afterEditRow(field);
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee7, this);
      }));
      function removeRow(_x7) {
        return _removeRow.apply(this, arguments);
      }
      return removeRow;
    }()
  }, {
    key: "closeRow",
    value: function () {
      var _closeRow = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8(_ref6) {
        var fieldName, rowNr, field;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              fieldName = _ref6.fieldName, rowNr = _ref6.rowNr;
              _context9.next = 3;
              return this[fieldName][rowNr].setValue({
                fieldName: 'Closed',
                value: true
              });
            case 3:
              field = _.find(this.fieldsList, function (c) {
                return c.name == fieldName;
              });
              _context9.next = 6;
              return this.afterEditField(field, false, true);
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee8, this);
      }));
      function closeRow(_x8) {
        return _closeRow.apply(this, arguments);
      }
      return closeRow;
    }()
  }, {
    key: "setParent",
    value: function setParent(obj) {
      Object.defineProperty(this, '$parent', {
        enumerable: false,
        value: obj,
        configurable: true
      });
    }
  }, {
    key: "newObjectByName",
    value: function () {
      var _newObjectByName = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee9(fieldName, obj) {
        var field, r;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee9$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              field = _.find(this.fieldsList, function (c) {
                return c.name == fieldName;
              });
              if (!field) {
                _context10.next = 6;
                break;
              }
              _context10.next = 4;
              return this.newClassObject(field, obj);
            case 4:
              r = _context10.sent;
              return _context10.abrupt("return", r);
            case 6:
            case "end":
              return _context10.stop();
          }
        }, _callee9, this);
      }));
      function newObjectByName(_x9, _x10) {
        return _newObjectByName.apply(this, arguments);
      }
      return newObjectByName;
    }()
  }, {
    key: "newObject",
    value: function () {
      var _newObject = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee10(field, obj, fieldName, copy) {
        var r;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee10$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.newClassObject(field, obj, copy);
            case 2:
              r = _context11.sent;
              if (fieldName || fieldName == 0) this[fieldName] = r;
              this.setComputedFields();
              return _context11.abrupt("return", r);
            case 6:
            case "end":
              return _context11.stop();
          }
        }, _callee10, this);
      }));
      function newObject(_x11, _x12, _x13, _x14) {
        return _newObject.apply(this, arguments);
      }
      return newObject;
    }()
  }, {
    key: "newClassObject",
    value: function () {
      var _newClassObject = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee11(field, obj, copy) {
        var objectClass, _r, r;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee11$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (!field.objectClass) {
                _context12.next = 12;
                break;
              }
              objectClass = api.importMixinModule(field.objectClass, 'model');
              if (!copy) {
                _context12.next = 8;
                break;
              }
              _context12.next = 5;
              return objectClass.clone({
                fields: obj ? obj.fields : null,
                record: obj,
                parent: this
              });
            case 5:
              _r = _context12.sent;
              _context12.next = 11;
              break;
            case 8:
              _context12.next = 10;
              return new objectClass({
                record: obj,
                parent: this
              });
            case 10:
              _r = _context12.sent;
            case 11:
              return _context12.abrupt("return", _r);
            case 12:
              if (!copy) {
                _context12.next = 18;
                break;
              }
              _context12.next = 15;
              return BaseModel.clone({
                fields: field.fields,
                record: obj,
                parent: this
              });
            case 15:
              r = _context12.sent;
              _context12.next = 21;
              break;
            case 18:
              _context12.next = 20;
              return new BaseModel({
                fields: field.fields,
                record: obj,
                parent: this
              });
            case 20:
              r = _context12.sent;
            case 21:
              return _context12.abrupt("return", r);
            case 22:
            case "end":
              return _context12.stop();
          }
        }, _callee11, this);
      }));
      function newClassObject(_x15, _x16, _x17) {
        return _newClassObject.apply(this, arguments);
      }
      return newClassObject;
    }()
  }, {
    key: "newRowByName",
    value: function () {
      var _newRowByName = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee12(fieldName, obj) {
        var field, r;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee12$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              field = _.find(this.fieldsList, function (c) {
                return c.name == fieldName;
              });
              if (!field) {
                _context13.next = 7;
                break;
              }
              _context13.next = 4;
              return this.newRow(field, obj);
            case 4:
              r = _context13.sent;
              r.id = null;
              return _context13.abrupt("return", r);
            case 7:
            case "end":
              return _context13.stop();
          }
        }, _callee12, this);
      }));
      function newRowByName(_x18, _x19) {
        return _newRowByName.apply(this, arguments);
      }
      return newRowByName;
    }()
  }, {
    key: "newRow",
    value: function () {
      var _newRow = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee13(field, record, fieldName) {
        var r;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee13$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return this.newClassRow(field, record);
            case 2:
              r = _context14.sent;
              if (fieldName || fieldName == 0) {
                this[fieldName] = r;
              }
              _context14.next = 6;
              return this.afterEditRow(field);
            case 6:
              return _context14.abrupt("return", r);
            case 7:
            case "end":
              return _context14.stop();
          }
        }, _callee13, this);
      }));
      function newRow(_x20, _x21, _x22) {
        return _newRow.apply(this, arguments);
      }
      return newRow;
    }()
  }, {
    key: "newClassRow",
    value: function () {
      var _newClassRow = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee14(field, record, copy) {
        var rowClass, _r2, r;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee14$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!field.rowClass) {
                _context15.next = 12;
                break;
              }
              rowClass = api.importMixinModule(field.rowClass, 'model');
              if (!copy) {
                _context15.next = 8;
                break;
              }
              _context15.next = 5;
              return rowClass.clone({
                fields: record.fields,
                record: record,
                parent: this,
                parentField: field.name
              });
            case 5:
              _r2 = _context15.sent;
              _context15.next = 11;
              break;
            case 8:
              _context15.next = 10;
              return new rowClass({
                record: record,
                parent: this,
                parentField: field.name
              });
            case 10:
              _r2 = _context15.sent;
            case 11:
              return _context15.abrupt("return", _r2);
            case 12:
              if (!copy) {
                _context15.next = 18;
                break;
              }
              _context15.next = 15;
              return BaseModel.clone({
                fields: field.rowFields,
                record: record,
                parent: this,
                parentField: field.name
              });
            case 15:
              r = _context15.sent;
              _context15.next = 21;
              break;
            case 18:
              _context15.next = 20;
              return new BaseModel({
                fields: field.rowFields,
                record: record,
                parent: this,
                parentField: field.name,
                tableName: field.tableName
              });
            case 20:
              r = _context15.sent;
            case 21:
              return _context15.abrupt("return", r);
            case 22:
            case "end":
              return _context15.stop();
          }
        }, _callee14, this);
      }));
      function newClassRow(_x23, _x24, _x25) {
        return _newClassRow.apply(this, arguments);
      }
      return newClassRow;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee15(record) {
        var _this4 = this;
        var arrayFields, _loop2, i;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee15$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              arrayFields = record.fieldsList ? record.fieldsList : record.fields;
              if (!arrayFields) arrayFields = record;
              _loop2 = /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _loop2() {
                var fieldName, field, _iterator8, _step8, row, childRow, o, empty;
                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _loop2$(_context16) {
                  while (1) switch (_context16.prev = _context16.next) {
                    case 0:
                      fieldName = i;
                      if (record.fields) fieldName = arrayFields[i].name;
                      field = _.find(_this4.fieldsList, function (f) {
                        return f.name == fieldName;
                      });
                      if (!(field && (Array.isArray(field.editor) || field.rowFields))) {
                        _context16.next = 27;
                        break;
                      }
                      _this4[field.name] = [];
                      _iterator8 = _createForOfIteratorHelper(record[field.name]);
                      _context16.prev = 6;
                      _iterator8.s();
                    case 8:
                      if ((_step8 = _iterator8.n()).done) {
                        _context16.next = 17;
                        break;
                      }
                      row = _step8.value;
                      _context16.next = 12;
                      return _this4.newClassRow(field, row);
                    case 12:
                      childRow = _context16.sent;
                      _this4[field.name].push(childRow);
                      childRow._rowNr = _this4[field.name].length - 1;
                    case 15:
                      _context16.next = 8;
                      break;
                    case 17:
                      _context16.next = 22;
                      break;
                    case 19:
                      _context16.prev = 19;
                      _context16.t0 = _context16["catch"](6);
                      _iterator8.e(_context16.t0);
                    case 22:
                      _context16.prev = 22;
                      _iterator8.f();
                      return _context16.finish(22);
                    case 25:
                      _context16.next = 45;
                      break;
                    case 27:
                      if (!(field && field.editor && (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(field.editor) == 'object')) {
                        _context16.next = 34;
                        break;
                      }
                      _context16.next = 30;
                      return _this4.newClassObject(field, record[fieldName]);
                    case 30:
                      o = _context16.sent;
                      _this4[fieldName] = o;
                      _context16.next = 45;
                      break;
                    case 34:
                      if (!(field && _this4._loaded && field.setRelationTo)) {
                        _context16.next = 39;
                        break;
                      }
                      _context16.next = 37;
                      return _this4.setValue({
                        fieldName: fieldName,
                        value: record[fieldName]
                      });
                    case 37:
                      _context16.next = 40;
                      break;
                    case 39:
                      try {
                        _this4[fieldName] = record[fieldName];
                      } catch (ex) {
                        console.log('err fieldName', fieldName);
                      }
                    case 40:
                      if (!(field && field.setRelationTo && record[field.setRelationTo])) {
                        _context16.next = 45;
                        break;
                      }
                      empty = Object.keys(record[field.setRelationTo]).length == 0;
                      if (!(empty && record[fieldName])) {
                        _context16.next = 45;
                        break;
                      }
                      _context16.next = 45;
                      return _this4.setRelationTo(field);
                    case 45:
                    case "end":
                      return _context16.stop();
                  }
                }, _loop2, null, [[6, 19, 22, 25]]);
              });
              _context17.t0 = _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().keys(arrayFields);
            case 4:
              if ((_context17.t1 = _context17.t0()).done) {
                _context17.next = 9;
                break;
              }
              i = _context17.t1.value;
              return _context17.delegateYield(_loop2(), "t2", 7);
            case 7:
              _context17.next = 4;
              break;
            case 9:
              this.setComputedFields();
            case 10:
            case "end":
              return _context17.stop();
          }
        }, _callee15, this);
      }));
      function init(_x26) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee16() {
        var _iterator9, _step9, f, value;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee16$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              this._recordLoaded = true;
              _iterator9 = _createForOfIteratorHelper(this.fieldsList);
              _context18.prev = 2;
              _iterator9.s();
            case 4:
              if ((_step9 = _iterator9.n()).done) {
                _context18.next = 13;
                break;
              }
              f = _step9.value;
              if (!f.defValue) {
                _context18.next = 11;
                break;
              }
              value = f.defValue;
              if (typeof f.defValue === 'function') {
                value = f.defValue(this);
              }
              _context18.next = 11;
              return this.setValue({
                fieldName: f.name,
                value: value
              });
            case 11:
              _context18.next = 4;
              break;
            case 13:
              _context18.next = 18;
              break;
            case 15:
              _context18.prev = 15;
              _context18.t0 = _context18["catch"](2);
              _iterator9.e(_context18.t0);
            case 18:
              _context18.prev = 18;
              _iterator9.f();
              return _context18.finish(18);
            case 21:
              this.setComputedFields();
            case 22:
            case "end":
              return _context18.stop();
          }
        }, _callee16, this, [[2, 15, 18, 21]]);
      }));
      function create() {
        return _create.apply(this, arguments);
      }
      return create;
    }()
  }, {
    key: "checkFields",
    value: function () {
      var _checkFields = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee17() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee17$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return tools.checkFields(this, this);
            case 2:
              return _context19.abrupt("return", _context19.sent);
            case 3:
            case "end":
              return _context19.stop();
          }
        }, _callee17, this);
      }));
      function checkFields() {
        return _checkFields.apply(this, arguments);
      }
      return checkFields;
    }()
  }, {
    key: "arrayFields",
    get: function get() {
      var res = [];
      var _iterator10 = _createForOfIteratorHelper(this.fieldsList),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var f = _step10.value;
          if (f.hidden) continue;
          if (Array.isArray(f.editor)) {
            var show = true;
            if (f.showIf && !f.showIf(this)) {
              show = false;
            }
            if (f.hideIf && f.hideIf(this)) {
              show = false;
            }
            if (show) res.push(f);
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      return res;
    }
  }, {
    key: "tabList",
    get: function get() {
      var res = [];
      var _iterator11 = _createForOfIteratorHelper(this.fields),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var f = _step11.value;
          if (f.editor == 'tab') {
            res.push(f);
          }
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      return res;
    }
  }, {
    key: "setRelationTo",
    value: function () {
      var _setRelationTo = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee18(field) {
        var res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee18$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              if (field.relation) {
                _context20.next = 2;
                break;
              }
              return _context20.abrupt("return");
            case 2:
              if (field.setRelationTo) {
                _context20.next = 4;
                break;
              }
              return _context20.abrupt("return");
            case 4:
              if (this[field.name]) {
                _context20.next = 7;
                break;
              }
              this[field.setRelationTo] = {};
              return _context20.abrupt("return");
            case 7:
              _context20.next = 9;
              return api.getObjectFromStore(field.relation, this[field.name]);
            case 9:
              res = _context20.sent;
              if (res) {
                this[field.setRelationTo] = res;
              }
            case 11:
            case "end":
              return _context20.stop();
          }
        }, _callee18, this);
      }));
      function setRelationTo(_x27) {
        return _setRelationTo.apply(this, arguments);
      }
      return setRelationTo;
    }()
  }, {
    key: "getMaxLength",
    value: function getMaxLength(fieldName) {
      if (this.fields[fieldName] && this.fields[fieldName].length) {
        return this.fields[fieldName].length;
      }
    }
  }, {
    key: "setComputedFields",
    value: function setComputedFields(list) {
      var res = list;
      if (!list) res = [];
      var _iterator12 = _createForOfIteratorHelper(this.fieldsList),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var field = _step12.value;
          if (!field) {
            var data = [{
              constructor: this.constructor.name,
              field: field,
              fieldsList: this.fieldsList
            }];
            api.post('/api/send_logs/', JSON.stringify(data));
          }
          if (field.computed) {
            var value = field.computed(this, this.$parent);
            if (value != null && value != undefined) {
              if (!this['$' + field.name]) continue;
              this['$' + field.name].value = value;
              var params = [];
              if (this.$parentField) params.push(this.$parentField);
              if (this._rowNr != undefined) params.push(this._rowNr);
              params.push(field.name);
              res.push({
                params: params,
                value: value,
                action: 'set'
              });
            }
          }
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      if (this.hasOwnProperty('$parent')) {
        this.$parent.setComputedFields(res);
      }
      return res;
    }
  }, {
    key: "getPropertiesNames",
    value: function getPropertiesNames(proto, values) {
      if (proto.constructor.name == 'Object') {
        return values;
      } else {
        var _v;
        var v = values;
        if (!values) v = [];
        var names = Object.getOwnPropertyNames(proto);
        (_v = v).push.apply(_v, (0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(names));
        return this.getPropertiesNames(Object.getPrototypeOf(proto), v);
      }
      return [];
    }
  }, {
    key: "setModified",
    value: function setModified(value) {
      if (this.hasOwnProperty('_modified')) {
        if (this._modified != value) {
          this._modified = value;
          //api.setModified(value);
        }
      } else if (this.hasOwnProperty('$parent')) {
        this.$parent.setModified(value);
      }
    }
  }, {
    key: "isNew",
    get: function get() {
      if (this.hasOwnProperty('_new')) {
        return this._new;
      } else if (this.hasOwnProperty('$parent')) {
        return this.$parent.isNew;
      }
    }
  }, {
    key: "edit",
    value: function () {
      var _edit = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee19(field) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee19$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              this.setModified(true);
              if (!(field && field.relation && field.setRelationTo)) {
                _context21.next = 4;
                break;
              }
              _context21.next = 4;
              return this.setRelationTo(field);
            case 4:
            case "end":
              return _context21.stop();
          }
        }, _callee19, this);
      }));
      function edit(_x28) {
        return _edit.apply(this, arguments);
      }
      return edit;
    }()
  }, {
    key: "getName",
    get: function get() {
      if (this.Name) return this.Name;
    }
  }, {
    key: "getFieldLabel",
    value: function getFieldLabel(fieldName) {
      var field = _.find(this.fields, function (f) {
        return f.name == fieldName;
      });
      if (field && field.label) return field.label;
      if (field) return field.name;
      var tabs = _.filter(this.fields, function (f) {
        return f.editor == 'tab';
      });
      if (tabs) {
        var _iterator13 = _createForOfIteratorHelper(tabs),
          _step13;
        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var tab = _step13.value;
            var _field = _.find(tab.fields, function (f) {
              return f.name == fieldName;
            });
            if (_field && _field.label) return _field.label;
            if (_field) return _field.name;
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }
      }
      return fieldName;
    }
  }], [{
    key: "getFields",
    value: function () {
      var _getFields = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee20() {
        var options;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee20$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return api.getModuleFieldsOptions(this.moduleName);
            case 2:
              options = _context22.sent;
              return _context22.abrupt("return", options.fields);
            case 4:
            case "end":
              return _context22.stop();
          }
        }, _callee20, this);
      }));
      function getFields() {
        return _getFields.apply(this, arguments);
      }
      return getFields;
    }()
  }, {
    key: "clone",
    value: function () {
      var _clone = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee21(_ref7) {
        var fields, record, parent, r, _iterator14, _step14, field, fieldName, _iterator15, _step15, row, childRow, o;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee21$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              fields = _ref7.fields, record = _ref7.record, parent = _ref7.parent;
              if (record) {
                _context23.next = 3;
                break;
              }
              return _context23.abrupt("return");
            case 3:
              _context23.next = 5;
              return new this({
                fields: record.fields,
                parent: parent,
                record: record,
                clone: true
              });
            case 5:
              r = _context23.sent;
              r.id = null;
              _iterator14 = _createForOfIteratorHelper(r.fields);
              _context23.prev = 8;
              _iterator14.s();
            case 10:
              if ((_step14 = _iterator14.n()).done) {
                _context23.next = 50;
                break;
              }
              field = _step14.value;
              if (!(field.name == 'id')) {
                _context23.next = 14;
                break;
              }
              return _context23.abrupt("continue", 48);
            case 14:
              fieldName = field.name;
              if (!(field && (Array.isArray(field.editor) || field.rowFields))) {
                _context23.next = 39;
                break;
              }
              r[field.name] = [];
              _iterator15 = _createForOfIteratorHelper(record[field.name]);
              _context23.prev = 18;
              _iterator15.s();
            case 20:
              if ((_step15 = _iterator15.n()).done) {
                _context23.next = 29;
                break;
              }
              row = _step15.value;
              _context23.next = 24;
              return r.newClassRow(field, row, true);
            case 24:
              childRow = _context23.sent;
              r[field.name].push(childRow);
              childRow._rowNr = r[field.name].length - 1;
            case 27:
              _context23.next = 20;
              break;
            case 29:
              _context23.next = 34;
              break;
            case 31:
              _context23.prev = 31;
              _context23.t0 = _context23["catch"](18);
              _iterator15.e(_context23.t0);
            case 34:
              _context23.prev = 34;
              _iterator15.f();
              return _context23.finish(34);
            case 37:
              _context23.next = 48;
              break;
            case 39:
              if (!(field && (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(field.editor) == 'object')) {
                _context23.next = 46;
                break;
              }
              _context23.next = 42;
              return r.newClassObject(field, record[fieldName], true);
            case 42:
              o = _context23.sent;
              r[fieldName] = o;
              _context23.next = 48;
              break;
            case 46:
              r['$' + fieldName].value = record[fieldName];
              if (field.setRelationTo) {
                r[field.setRelationTo] = Object.assign({}, record[field.setRelationTo]);
              }
            case 48:
              _context23.next = 10;
              break;
            case 50:
              _context23.next = 55;
              break;
            case 52:
              _context23.prev = 52;
              _context23.t1 = _context23["catch"](8);
              _iterator14.e(_context23.t1);
            case 55:
              _context23.prev = 55;
              _iterator14.f();
              return _context23.finish(55);
            case 58:
              if (r.CreatedUTC) r.CreatedUTC = null;
              if (r.ModifiedUTC) r.ModifiedUTC = null;
              if (r.CreatedUserId) r.CreatedUserId = null;
              if (r.ModifiedUserId) r.ModifiedUserId = null;
              r.setComputedFields();
              return _context23.abrupt("return", r);
            case 64:
            case "end":
              return _context23.stop();
          }
        }, _callee21, this, [[8, 52, 55, 58], [18, 31, 34, 37]]);
      }));
      function clone(_x29) {
        return _clone.apply(this, arguments);
      }
      return clone;
    }()
  }]);
}();
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BaseModel);

/***/ }),

/***/ 43004:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),

/***/ 43145:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ _arrayLikeToArray)
/* harmony export */ });
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}


/***/ }),

/***/ 43349:
/***/ ((module) => {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),

/***/ 43525:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8818);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingDayServiceView = /*#__PURE__*/function (_View) {
  function BookingDayServiceView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingDayServiceView);
    return _callSuper(this, BookingDayServiceView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingDayServiceView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingDayServiceView, null, [{
    key: "serviceStatusOptions",
    get: function get() {
      var res = [];
      for (var s in this.serviceStatus) {
        res.push({
          value: s,
          label: this.serviceStatus[s]
        });
      }
      return res;
    }
  }, {
    key: "costPerOptions",
    get: function get() {
      var res = [{
        'PERSON': 'P/P'
      }, {
        'SERVICE': 'P/S'
      }];
      return res;
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", {
                fields: [{
                  name: 'ServiceId',
                  relation: 'service',
                  optionLabels: 'Name',
                  editor: 'select',
                  label: 'Service',
                  setRelationTo: 'Service'
                }, {
                  name: 'ServiceCategoryId',
                  relation: 'servicecategory',
                  optionLabels: 'Name',
                  editor: 'select',
                  label: 'ServiceCategory',
                  setRelationTo: 'ServiceCategory'
                }, {
                  name: 'SupplierId',
                  relation: 'supplier',
                  optionLabels: 'Name',
                  editor: 'select',
                  label: 'Supplier',
                  setRelationTo: 'Supplier'
                }, {
                  name: 'ServiceClassId',
                  relation: 'serviceclass',
                  optionLabels: 'Name',
                  editor: 'select',
                  label: 'Service Class',
                  setRelationTo: 'ServiceClass'
                }, {
                  name: 'CityId',
                  relation: 'city',
                  optionLabels: 'Name',
                  editor: 'vue-select',
                  label: 'Service',
                  setRelationTo: 'City'
                }, {
                  name: 'ServiceTypeId',
                  relation: 'servicetype',
                  optionLabels: 'Name',
                  editor: 'select',
                  label: 'Service Type',
                  setRelationTo: 'ServiceType'
                }, {
                  name: 'Description'
                }, {
                  name: 'OrderNr'
                }, {
                  name: 'SortNr'
                }, {
                  name: 'ServiceDate'
                }, {
                  name: 'Name',
                  label: 'Name',
                  classes: 'input-bold'
                }, {
                  name: 'Status',
                  editor: 'select',
                  options: this.serviceStatusOptions
                }, {
                  name: 'CostPer',
                  editor: 'select',
                  options: this.costPerOptions
                }, {
                  name: 'ADTCostCHD',
                  editor: 'checkbox'
                }, {
                  name: 'ReservationNumber'
                }, {
                  name: 'PaymentDate'
                }, {
                  name: 'ServiceCommentReaded'
                }, {
                  name: 'ServiceCommentDeleted'
                }, {
                  name: 'VoucherDisabled'
                }, {
                  name: 'VoucherText'
                }, {
                  name: 'PickupInfo'
                }, {
                  name: 'QuoteDate'
                }, {
                  name: 'Optional'
                }, {
                  name: 'EntranceIncluded'
                }, {
                  name: 'Dinner'
                }, {
                  name: 'Lunch'
                }, {
                  name: 'Title',
                  label: 'Title'
                }, {
                  name: 'BoxLunch'
                }, {
                  name: 'Snack'
                }, {
                  name: 'Breakfast'
                }, {
                  name: 'Quote',
                  editor: {},
                  objectClass: 'servicequoteobject'
                }, {
                  name: 'BookingDayServiceImages',
                  editor: [],
                  rowClass: 'bookingdayserviceimage'
                }, {
                  name: 'BookingDayServiceCar',
                  editor: {},
                  objectClass: 'bookingdayservicecar'
                }]
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingDayServiceView, "table", 'bookingdayservice');
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingDayServiceView, "serviceStatus", {
  PENDING: 'Pending',
  REQUESTED: 'Requested',
  CONFIRMED: 'Confirmed',
  CANCELED: 'Canceled'
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingDayServiceView);

/***/ }),

/***/ 43784:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^(maart|mrt\.?)$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),

/***/ 43832:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Buffer = (__webpack_require__(92861).Buffer)

var checkParameters = __webpack_require__(64196)
var defaultEncoding = __webpack_require__(2455)
var sync = __webpack_require__(21352)
var toBuffer = __webpack_require__(93382)

var ZERO_BUF
var subtle = __webpack_require__.g.crypto && __webpack_require__.g.crypto.subtle
var toBrowser = {
  sha: 'SHA-1',
  'sha-1': 'SHA-1',
  sha1: 'SHA-1',
  sha256: 'SHA-256',
  'sha-256': 'SHA-256',
  sha384: 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  sha512: 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (__webpack_require__.g.process && !__webpack_require__.g.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}
var nextTick
function getNextTick () {
  if (nextTick) {
    return nextTick
  }
  if (__webpack_require__.g.process && __webpack_require__.g.process.nextTick) {
    nextTick = __webpack_require__.g.process.nextTick
  } else if (__webpack_require__.g.queueMicrotask) {
    nextTick = __webpack_require__.g.queueMicrotask
  } else if (__webpack_require__.g.setImmediate) {
    nextTick = __webpack_require__.g.setImmediate
  } else {
    nextTick = __webpack_require__.g.setTimeout
  }
  return nextTick
}
function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, { name: 'PBKDF2' }, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    getNextTick()(function () {
      callback(null, out)
    })
  }, function (e) {
    getNextTick()(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof __webpack_require__.g.Promise !== 'function') {
    getNextTick()(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
    return
  }

  checkParameters(iterations, keylen)
  password = toBuffer(password, defaultEncoding, 'Password')
  salt = toBuffer(salt, defaultEncoding, 'Salt')
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}


/***/ }),

/***/ 43861:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone:
                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                    '_'
                ),
        },
        monthsShort:
            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex:
            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex:
            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


/***/ }),

/***/ 43917:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(67426);
var common = __webpack_require__(66166);
var shaCommon = __webpack_require__(66225);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),

/***/ 43928:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_model_record__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55539);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var Contact = /*#__PURE__*/function (_Record) {
  function Contact() {
    _classCallCheck(this, Contact);
    return _callSuper(this, Contact, arguments);
  }
  _inherits(Contact, _Record);
  return _createClass(Contact, [{
    key: "titleName",
    get: function get() {
      return this.ContactName;
    }
  }]);
}(_base_model_record__WEBPACK_IMPORTED_MODULE_0__["default"]);
_defineProperty(Contact, "table", 'contact');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Contact);

/***/ }),

/***/ 44075:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51941);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26028);








function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }


var BookingDayHotel = /*#__PURE__*/function (_BookingBaseModel) {
  function BookingDayHotel(_ref) {
    var _this;
    var fields = _ref.fields,
      record = _ref.record,
      parent = _ref.parent;
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, BookingDayHotel);
    _this = _callSuper(this, BookingDayHotel, [{
      fields: fields,
      record: record,
      parent: parent
    }]);
    var self = _this;
    return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(_this, (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var r;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return new Promise(function (resolve, reject) {
              resolve(self);
            });
          case 2:
            r = _context.sent;
            r._cache = {
              roomsCapacity: false
            };
            r._cachedRoomsCapacity = null;
            return _context.abrupt("return", r);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))());
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(BookingDayHotel, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingDayHotel, [{
    key: "booking",
    get: function get() {
      return this.$parent.$parent;
    }
  }, {
    key: "setHotelDates",
    value: function setHotelDates() {
      var transDate = this.$parent.TransDate;
      if (this.booking.notTemplate) {
        this.Checkin = transDate;
        this.Checkout = moment(transDate, 'YYYY-MM-DD').add(this.days, 'days').format('YYYY-MM-DD');
      }
    }
  }, {
    key: "findHotelFromRows",
    value: function findHotelFromRows(hotelId) {
      var _iterator = _createForOfIteratorHelper(this.BookingDayRooms),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var room = _step.value;
          if (room.Hotel && room.Hotel.id == hotelId) return room.Hotel;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "addRoom",
    value: function () {
      var _addRoom = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(defaultHotel) {
        var newHotelId, lastRowNr, row, baseId;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.BookingDayRooms.length > 0) {
                lastRowNr = this.BookingDayRooms.length - 1;
                newHotelId = this.BookingDayRooms[lastRowNr].HotelId;
              } else if (defaultHotel) {
                newHotelId = defaultHotel.id;
              }
              _context2.next = 3;
              return this.addRow({
                fieldName: 'BookingDayRooms'
              });
            case 3:
              row = this.BookingDayRooms[this.BookingDayRooms.length - 1];
              row.$Rooms.value = 1;
              row.$CurrencyId.value = this.booking.CurrencyId;
              row.tempId = (0,uuid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)();
              row.$Status.value = 'PENDING';
              _context2.t0 = _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().keys(this.booking.BaseQuotes.bases);
            case 9:
              if ((_context2.t1 = _context2.t0()).done) {
                _context2.next = 20;
                break;
              }
              baseId = _context2.t1.value;
              _context2.next = 13;
              return row.QuoteList.newHotelQuote();
            case 13:
              row.QuoteList[baseId] = _context2.sent;
              row.QuoteList[baseId].Pax = this.booking.BaseQuotes[baseId].paxQuantity;
              row.QuoteList.getFields();
              row.QuoteList.setGroups();
              row.QuoteList.setVariants();
              _context2.next = 9;
              break;
            case 20:
              if (!newHotelId) {
                _context2.next = 23;
                break;
              }
              _context2.next = 23;
              return row.setValue({
                fieldName: 'HotelId',
                value: newHotelId
              });
            case 23:
              if (!(row.Hotel && row.Hotel.HotelCategoryId)) {
                _context2.next = 26;
                break;
              }
              _context2.next = 26;
              return row.setValue({
                fieldName: 'HotelCategoryId',
                value: row.Hotel.HotelCategoryId
              });
            case 26:
              _context2.next = 28;
              return row.updateInfo(this.BookingDayRooms.length - 1, true);
            case 28:
              return _context2.abrupt("return", row);
            case 29:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function addRoom(_x) {
        return _addRoom.apply(this, arguments);
      }
      return addRoom;
    }()
  }, {
    key: "removeRoom",
    value: function () {
      var _removeRoom = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(rowNr) {
        var _this$BookingDayRooms, _this$BookingDayRooms2, _this$BookingDayRooms3;
        var hotelId, categoryId;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              hotelId = (_this$BookingDayRooms = this.BookingDayRooms) === null || _this$BookingDayRooms === void 0 || (_this$BookingDayRooms = _this$BookingDayRooms[rowNr]) === null || _this$BookingDayRooms === void 0 ? void 0 : _this$BookingDayRooms.HotelId;
              categoryId = (_this$BookingDayRooms2 = this.BookingDayRooms) === null || _this$BookingDayRooms2 === void 0 || (_this$BookingDayRooms2 = _this$BookingDayRooms2[rowNr]) === null || _this$BookingDayRooms2 === void 0 ? void 0 : _this$BookingDayRooms2.RoomCategory;
              _context3.next = 4;
              return (_this$BookingDayRooms3 = this.BookingDayRooms) === null || _this$BookingDayRooms3 === void 0 || (_this$BookingDayRooms3 = _this$BookingDayRooms3[rowNr]) === null || _this$BookingDayRooms3 === void 0 ? void 0 : _this$BookingDayRooms3.removeProgramServices(categoryId, hotelId);
            case 4:
              _context3.next = 6;
              return this.removeRow({
                fieldName: 'BookingDayRooms',
                rowNr: rowNr
              });
            case 6:
              if (!hotelId) {
                _context3.next = 10;
                break;
              }
              _context3.next = 9;
              return this.booking.setHotelCostById({
                hotelId: hotelId,
                exchange: this.exchange,
                skipCurrency: false,
                daysChange: false,
                sync: false
              });
            case 9:
              this.setRoomCost(hotelId);
            case 10:
              return _context3.abrupt("return", true);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function removeRoom(_x2) {
        return _removeRoom.apply(this, arguments);
      }
      return removeRoom;
    }()
  }, {
    key: "setRoomCost",
    value: function setRoomCost(hotelId) {
      var _iterator2 = _createForOfIteratorHelper(this.BookingDayRooms),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var room = _step2.value;
          if (hotelId && !room.HotelId == hotelId) continue;
          for (var baseId in room.QuoteList.bases) {
            room.QuoteList[baseId].setRoomCost();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "updateCost",
    value: function () {
      var _updateCost = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(_ref3) {
        var skipCurrency, daysChange, _ref3$sync, sync, hotelIds, _iterator3, _step3, room, _i, _hotelIds, hotelId;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              skipCurrency = _ref3.skipCurrency, daysChange = _ref3.daysChange, _ref3$sync = _ref3.sync, sync = _ref3$sync === void 0 ? true : _ref3$sync;
              hotelIds = [];
              _iterator3 = _createForOfIteratorHelper(this.BookingDayRooms);
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  room = _step3.value;
                  room.setPending();
                  if (room.HotelId) {
                    if (hotelIds.indexOf(room.HotelId)) {
                      hotelIds.push(room.HotelId);
                    }
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              _i = 0, _hotelIds = hotelIds;
            case 5:
              if (!(_i < _hotelIds.length)) {
                _context4.next = 12;
                break;
              }
              hotelId = _hotelIds[_i];
              _context4.next = 9;
              return this.booking.setHotelCostById({
                hotelId: hotelId,
                exchange: this.exchange,
                skipCurrency: skipCurrency,
                daysChange: daysChange,
                sync: sync,
                dayNr: this.$parent.DayNr
              });
            case 9:
              _i++;
              _context4.next = 5;
              break;
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function updateCost(_x3) {
        return _updateCost.apply(this, arguments);
      }
      return updateCost;
    }()
  }, {
    key: "setDays",
    value: function () {
      var _setDays = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(v) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.setValue({
                fieldName: 'Days',
                value: v
              });
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function setDays(_x4) {
        return _setDays.apply(this, arguments);
      }
      return setDays;
    }()
  }, {
    key: "setValue",
    value: function () {
      var _setValue = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(_ref4) {
        var fieldName, value;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              fieldName = _ref4.fieldName, value = _ref4.value;
              _context6.next = 3;
              return _superPropGet(BookingDayHotel, "setValue", this, 3)([{
                fieldName: fieldName,
                value: value
              }]);
            case 3:
              if (this._loaded && this._cache) {
                this._cache.roomsCapacity = false;
              }
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function setValue(_x5) {
        return _setValue.apply(this, arguments);
      }
      return setValue;
    }()
  }, {
    key: "afterEditRow",
    value: function () {
      var _afterEditRow = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7(field) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (this._loaded) {
                this._cache.roomsCapacity = false;
              }
              _context7.next = 3;
              return _superPropGet(BookingDayHotel, "afterEditRow", this, 3)([field]);
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function afterEditRow(_x6) {
        return _afterEditRow.apply(this, arguments);
      }
      return afterEditRow;
    }()
  }, {
    key: "roomTypesNames",
    get: function get() {
      var rooms = [];
      if (this.BookingDayRooms) {
        for (var i in this.BookingDayRooms) {
          var room = this.BookingDayRooms[i];
          var roomField = _.find(room.fields, function (r) {
            return r.name == 'RoomTypeId';
          });
          if (!roomField) continue;
          var r = room.roomsQuantity + ' ' + tools.getDisplayValue(room, roomField, null, false);
          if (room.RoomCategory && room.Hotel) {
            r += ' ';
            var roomId = room.RoomCategory;
            r += room.roomCategoryName;
          }
          rooms.push(r);
        }
        return rooms.join(', ');
      }
    }
  }, {
    key: "extraBed",
    get: function get() {
      var _iterator4 = _createForOfIteratorHelper(this.BookingDayRooms),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var room = _step4.value;
          if (room.Room && room.Room.ExtraBed) return true;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "ifHotel",
    get: function get() {
      if (this.BookingDayRooms && this.BookingDayRooms[0] && this.BookingDayRooms[0].Hotel && this.BookingDayRooms[0].Hotel.id) {
        return true;
      }
    }
  }, {
    key: "roomCategoryName",
    get: function get() {
      var hotelList = [];
      var hotels = {};
      var _iterator5 = _createForOfIteratorHelper(this.BookingDayRooms),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var room = _step5.value;
          if (!room.Hotel) continue;
          if (!room.Hotel.id) continue;
          if (!room.Hotel.RoomCategories) continue;
          if (!room.roomQuoteSelected && this.booking.anyQuoteSelected) continue;
          if (!hotels[room.Hotel.id]) {
            hotelList.push(room.Hotel.id);
            hotels[room.Hotel.id] = {
              rooms: [],
              hotelName: room.Hotel.Name
            };
            if (room.HotelCategory && room.HotelCategory.Name) {
              hotels[room.Hotel.id].HotelCategory = room.HotelCategory.Name;
            }
          }
          var _iterator6 = _createForOfIteratorHelper(room.Hotel.RoomCategories),
            _step6;
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var category = _step6.value;
              if (category.id == room.RoomCategory && hotels[room.Hotel.id].rooms.indexOf(category.Name) == -1) {
                hotels[room.Hotel.id].rooms.push(category.Name);
              }
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      var res = [];
      for (var _i2 = 0, _hotelList = hotelList; _i2 < _hotelList.length; _i2++) {
        var id = _hotelList[_i2];
        var hotel = hotels[id];
        var r = '';
        if (hotel.HotelCategory) {
          r += hotel.HotelCategory + ' - ';
        }
        r += hotel.hotelName + ' (' + hotel.rooms.join(', ') + ')';
        res.push(r);
      }
      return res.join(' / ');
    }
  }, {
    key: "setHotelDays",
    value: function () {
      var _setHotelDays = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8(oldValue) {
        var _this2 = this;
        var _loop, i, _iterator7, _step7, room;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.updateCost({
                skipCurrency: false,
                daysChange: true
              });
            case 2:
              this.$parent.PaxHotel = 0;
              _loop = /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _loop(i) {
                var nextDay;
                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _loop$(_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      nextDay = _.find(_this2.booking.BookingDays, function (r) {
                        return parseInt(r.DayNr) == parseInt(_this2.$parent.DayNr + i + 1);
                      });
                      if (nextDay) {
                        nextDay.PaxHotel = 0;
                      }
                    case 2:
                    case "end":
                      return _context8.stop();
                  }
                }, _loop);
              });
              i = 0;
            case 5:
              if (!(i < this.Days - 1)) {
                _context9.next = 10;
                break;
              }
              return _context9.delegateYield(_loop(i), "t0", 7);
            case 7:
              i++;
              _context9.next = 5;
              break;
            case 10:
              _iterator7 = _createForOfIteratorHelper(this.BookingDayRooms);
              _context9.prev = 11;
              _iterator7.s();
            case 13:
              if ((_step7 = _iterator7.n()).done) {
                _context9.next = 19;
                break;
              }
              room = _step7.value;
              _context9.next = 17;
              return room.setProgramServices(null, null, oldValue);
            case 17:
              _context9.next = 13;
              break;
            case 19:
              _context9.next = 24;
              break;
            case 21:
              _context9.prev = 21;
              _context9.t1 = _context9["catch"](11);
              _iterator7.e(_context9.t1);
            case 24:
              _context9.prev = 24;
              _iterator7.f();
              return _context9.finish(24);
            case 27:
            case "end":
              return _context9.stop();
          }
        }, _callee8, this, [[11, 21, 24, 27]]);
      }));
      function setHotelDays(_x7) {
        return _setHotelDays.apply(this, arguments);
      }
      return setHotelDays;
    }()
  }, {
    key: "afterEdit",
    value: function afterEdit() {
      return {
        Days: function () {
          var _Days = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee9(r, newVal, oldVal) {
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee9$(_context10) {
              while (1) switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.next = 2;
                  return r.setHotelDays(oldVal);
                case 2:
                case "end":
                  return _context10.stop();
              }
            }, _callee9);
          }));
          function Days(_x8, _x9, _x10) {
            return _Days.apply(this, arguments);
          }
          return Days;
        }()
      };
    }
  }, {
    key: "hotelNames",
    get: function get() {
      var res = [];
      var viewMode = this.booking.ViewMode;
      var _iterator8 = _createForOfIteratorHelper(this.BookingDayRooms),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var room = _step8.value;
          var found = false;
          if (viewMode == -1) {
            found = true;
          } else {
            if (room.QuoteList[viewMode] && room.QuoteList[viewMode].Include) {
              found = true;
            }
          }
          if (!found) continue;
          if (room.Hotel && res.Hotel.Name) res.push(res.Hotel.Name);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      return res.join('; ');
    }
  }, {
    key: "roomsCapacity",
    get: function get() {
      if (this._cache && this._cache.roomsCapacity) {
        return this._cachedRoomsCapacity;
      }
      this._cache.roomsCapacity = true;
      var res = {};
      if (this.booking.QuoteBy == 'PERSON') return res;
      var _iterator9 = _createForOfIteratorHelper(this.BookingDayRooms),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var room = _step9.value;
          if (room.TourLeader) continue;
          if (room.SingleSupplement) continue;
          if (!room.Room) continue;
          if (!room.Room.Pax) continue;
          if (!room.QuoteList) continue;
          var baseIds = Object.keys(room.QuoteList.bases || {});
          for (var _i3 = 0, _baseIds = baseIds; _i3 < _baseIds.length; _i3++) {
            var _baseId2 = _baseIds[_i3];
            if (!room.QuoteList[_baseId2]) continue;
            if (!room.QuoteList[_baseId2].Include) continue;
            if (!room.QuoteList[_baseId2].Rooms) continue;
            var pax = 0;
            if (this.booking.isGroup(_baseId2)) {
              var groups = this.booking.QuoteGroups[_baseId2];
              for (var groupId in groups) {
                var group = room.QuoteList[_baseId2].Groups[groupId];
                if (!group) continue;
                if (!group.selected) continue;
                pax += parseInt(group.pax);
              }
            } else {
              pax = this.booking.BaseQuotes[_baseId2].paxQuantity;
            }
            if (!res[_baseId2]) res[_baseId2] = {
              pax: pax,
              capacity: 0,
              error: false
            };
            res[_baseId2].capacity += room.QuoteList[_baseId2].Rooms * room.Room.Pax;
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      for (var baseId in res) {
        if (res[baseId].capacity < res[baseId].pax) res[baseId].error = true;
      }
      this._cachedRoomsCapacity = res;
      return res;
    }
  }, {
    key: "paxQuantity",
    get: function get() {
      var res = 0;
      var booking = this.booking;
      for (var baseId in booking.BaseQuotes.bases) {
        var found = false;
        var _iterator10 = _createForOfIteratorHelper(this.BookingDayRooms),
          _step10;
        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var room = _step10.value;
            if (!found) {
              if (room.QuoteList) {
                if (!room.QuoteList[baseId]) continue;
                if (!room.QuoteList[baseId].Include) continue;
                var _iterator11 = _createForOfIteratorHelper(booking.BaseQuotes[baseId].paxTypes),
                  _step11;
                try {
                  for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                    var pType = _step11.value;
                    //if (!booking.variantSelected(baseId, pType, this.QuoteList[baseId])) continue;
                    if (booking.Totals[baseId] && booking.Totals[baseId][pType] && booking.Totals[baseId][pType].Selected) {
                      var pax = booking.BaseQuotes[baseId].paxQuantity;
                      if (booking.QuoteBy == 'QUANTITY') {
                        return pax;
                      } else {
                        if (booking.Totals[baseId][pType].Pax) {
                          res += parseInt(booking.Totals[baseId][pType].Pax);
                          found = true;
                        } else {
                          return pax;
                        }
                        ;
                      }
                    }
                  }
                } catch (err) {
                  _iterator11.e(err);
                } finally {
                  _iterator11.f();
                }
              }
            }
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      }
      return res;
    }
  }, {
    key: "copyRoomRow",
    value: function () {
      var _copyRoomRow = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee10(_baseId, roomIdx) {
        var room, hotel, newRoom, baseId;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee10$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              room = this.BookingDayRooms[roomIdx];
              hotel = room.Hotel;
              _context11.next = 4;
              return this.addRoom(hotel);
            case 4:
              newRoom = this.BookingDayRooms[this.BookingDayRooms.length - 1];
              _context11.next = 7;
              return newRoom.setValue({
                fieldName: 'RoomTypeId',
                value: room.RoomTypeId
              });
            case 7:
              _context11.next = 9;
              return newRoom.setValue({
                fieldName: 'RoomCategory',
                value: room.RoomCategory
              });
            case 9:
              _context11.next = 11;
              return newRoom.setValue({
                fieldName: 'HotelCategoryId',
                value: room.HotelCategoryId
              });
            case 11:
              _context11.t0 = _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().keys(this.booking.BaseQuotes.bases);
            case 12:
              if ((_context11.t1 = _context11.t0()).done) {
                _context11.next = 23;
                break;
              }
              baseId = _context11.t1.value;
              if (!(baseId == _baseId)) {
                _context11.next = 20;
                break;
              }
              newRoom.QuoteList[baseId].Include = true;
              _context11.next = 18;
              return newRoom.QuoteList[baseId].setValue({
                fieldName: 'Rooms',
                value: 1
              });
            case 18:
              _context11.next = 21;
              break;
            case 20:
              newRoom.QuoteList[baseId].Include = false;
            case 21:
              _context11.next = 12;
              break;
            case 23:
            case "end":
              return _context11.stop();
          }
        }, _callee10, this);
      }));
      function copyRoomRow(_x11, _x12) {
        return _copyRoomRow.apply(this, arguments);
      }
      return copyRoomRow;
    }()
  }], [{
    key: "clone",
    value: function () {
      var _clone = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee11(_ref5) {
        var fields, record, parent, r, _iterator12, _step12, room;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee11$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              fields = _ref5.fields, record = _ref5.record, parent = _ref5.parent;
              _context12.next = 3;
              return _superPropGet(BookingDayHotel, "clone", this, 2)([{
                fields: fields,
                record: record,
                parent: parent
              }]);
            case 3:
              r = _context12.sent;
              _iterator12 = _createForOfIteratorHelper(r.BookingDayRooms);
              try {
                for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                  room = _step12.value;
                  room.tempId = (0,uuid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)();
                }
              } catch (err) {
                _iterator12.e(err);
              } finally {
                _iterator12.f();
              }
              return _context12.abrupt("return", r);
            case 7:
            case "end":
              return _context12.stop();
          }
        }, _callee11, this);
      }));
      function clone(_x13) {
        return _clone.apply(this, arguments);
      }
      return clone;
    }()
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_4__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .A)(BookingDayHotel, "moduleName", 'bookingdayhotel');
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .A)(BookingDayHotel, "invalidated_cache", _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_4__["default"].invalidated_cache_hotels);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingDayHotel);

/***/ }),

/***/ 44287:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.normalizePath = normalizePath;

function normalizePath(path, stripTrailing) {
  if (path === '\\' || path === '/') {
    return '/';
  }

  const len = path.length;

  if (len <= 1) {
    return path;
  } // ensure that win32 namespaces has two leading slashes, so that the path is
  // handled properly by the win32 version of path.parse() after being normalized
  // https://msdn.microsoft.com/library/windows/desktop/aa365247(v=vs.85).aspx#namespaces


  let prefix = '';

  if (len > 4 && path[3] === '\\') {
    // eslint-disable-next-line prefer-destructuring
    const ch = path[2];

    if ((ch === '?' || ch === '.') && path.slice(0, 2) === '\\\\') {
      // eslint-disable-next-line no-param-reassign
      path = path.slice(2);
      prefix = '//';
    }
  }

  const segs = path.split(/[/\\]+/);

  if (stripTrailing !== false && segs[segs.length - 1] === '') {
    segs.pop();
  }

  return prefix + segs.join('/');
} // eslint-disable-next-line import/prefer-default-export

/***/ }),

/***/ 44429:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! author : Rasid Redzic : https://github.com/rasidre
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 'm':
                return withoutSuffix
                    ? 'jedna minuta'
                    : isFuture
                      ? 'jednu minutu'
                      : 'jedne minute';
        }
    }

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jedan sat';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: processRelativeTime,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


/***/ }),

/***/ 45122:
/***/ ((module) => {

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32


/***/ }),

/***/ 45412:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(65606);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(33225);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(64634);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = (__webpack_require__(37007).EventEmitter);

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(40345);
/*</replacement>*/

/*<replacement>*/

var Buffer = (__webpack_require__(34106).Buffer);
var OurUint8Array = (typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(__webpack_require__(15622));
util.inherits = __webpack_require__(56698);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(79838);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(83222);
var destroyImpl = __webpack_require__(75896);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(25382);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = (__webpack_require__(83141)/* .StringDecoder */ .I);
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(25382);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = (__webpack_require__(83141)/* .StringDecoder */ .I);
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, { hasUnpiped: false });
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}

/***/ }),

/***/ 45458:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ _toConsumableArray)
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(43145);
;// ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return (0,arrayLikeToArray/* default */.A)(r);
}

;// ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(27800);
;// ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || (0,unsupportedIterableToArray/* default */.A)(r) || _nonIterableSpread();
}


/***/ }),

/***/ 45567:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Record = api.importMixinModule('bookingdayservice', 'model', 'custom');
var CustomBookingDayService = /*#__PURE__*/function (_Record) {
  function CustomBookingDayService() {
    _classCallCheck(this, CustomBookingDayService);
    return _callSuper(this, CustomBookingDayService, arguments);
  }
  _inherits(CustomBookingDayService, _Record);
  return _createClass(CustomBookingDayService, [{
    key: "orphan",
    get: function get() {
      var _this$$parent;
      if (!this.GroupByServiceId) return false;
      if ((_this$$parent = this.$parent) !== null && _this$$parent !== void 0 && (_this$$parent = _this$$parent.$parent) !== null && _this$$parent !== void 0 && _this$$parent.BookingDays) {
        var _iterator = _createForOfIteratorHelper(this.$parent.$parent.BookingDays),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var day = _step.value;
            var _iterator2 = _createForOfIteratorHelper(day.BookingDayServices),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var service = _step2.value;
                if (service.ServiceId == this.GroupByServiceId) return false;
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return true;
    }
  }]);
}(Record);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomBookingDayService);

/***/ }),

/***/ 45719:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            d: ['jedan dan', 'jednog dana'],
            dd: ['dan', 'dana', 'dana'],
            M: ['jedan mesec', 'jednog meseca'],
            MM: ['mesec', 'meseca', 'meseci'],
            y: ['jednu godinu', 'jedne godine'],
            yy: ['godinu', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'jedna godina';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'godinu') {
                return number + ' godina';
            }

            return number + ' ' + word;
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


/***/ }),

/***/ 45766:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
              ? forms(key)[1]
              : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone:
                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                    '_'
                ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone:
                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                    '_'
                ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


/***/ }),

/***/ 45950:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var util = __webpack_require__(96740);

var DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
var DAYS = [0,31,28,31,30,31,30,31,31,30,31,30,31];
var TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
var HOSTNAME = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i;
var URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
var URIREF = /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
// uri-template: https://tools.ietf.org/html/rfc6570
var URITEMPLATE = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i;
// For the source: https://gist.github.com/dperini/729294
// For test cases: https://mathiasbynens.be/demo/url-regex
// @todo Delete current URL in favour of the commented out URL rule when this issue is fixed https://github.com/eslint/eslint/issues/7983.
// var URL = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u{00a1}-\u{ffff}0-9]+-)*[a-z\u{00a1}-\u{ffff}0-9]+)(?:\.(?:[a-z\u{00a1}-\u{ffff}0-9]+-)*[a-z\u{00a1}-\u{ffff}0-9]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu;
var URL = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i;
var UUID = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
var JSON_POINTER = /^(?:\/(?:[^~/]|~0|~1)*)*$/;
var JSON_POINTER_URI_FRAGMENT = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i;
var RELATIVE_JSON_POINTER = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;


module.exports = formats;

function formats(mode) {
  mode = mode == 'full' ? 'full' : 'fast';
  return util.copy(formats[mode]);
}


formats.fast = {
  // date: http://tools.ietf.org/html/rfc3339#section-5.6
  date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/,
  // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
  time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i,
  'date-time': /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i,
  // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
  uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
  'uri-reference': /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
  'uri-template': URITEMPLATE,
  url: URL,
  // email (sources from jsen validator):
  // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
  // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'willful violation')
  email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
  hostname: HOSTNAME,
  // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
  ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
  // optimized http://stackoverflow.com/questions/53497/regular-expression-that-matches-valid-ipv6-addresses
  ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
  regex: regex,
  // uuid: http://tools.ietf.org/html/rfc4122
  uuid: UUID,
  // JSON-pointer: https://tools.ietf.org/html/rfc6901
  // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
  'json-pointer': JSON_POINTER,
  'json-pointer-uri-fragment': JSON_POINTER_URI_FRAGMENT,
  // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
  'relative-json-pointer': RELATIVE_JSON_POINTER
};


formats.full = {
  date: date,
  time: time,
  'date-time': date_time,
  uri: uri,
  'uri-reference': URIREF,
  'uri-template': URITEMPLATE,
  url: URL,
  email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
  hostname: HOSTNAME,
  ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
  ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
  regex: regex,
  uuid: UUID,
  'json-pointer': JSON_POINTER,
  'json-pointer-uri-fragment': JSON_POINTER_URI_FRAGMENT,
  'relative-json-pointer': RELATIVE_JSON_POINTER
};


function isLeapYear(year) {
  // https://tools.ietf.org/html/rfc3339#appendix-C
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}


function date(str) {
  // full-date from http://tools.ietf.org/html/rfc3339#section-5.6
  var matches = str.match(DATE);
  if (!matches) return false;

  var year = +matches[1];
  var month = +matches[2];
  var day = +matches[3];

  return month >= 1 && month <= 12 && day >= 1 &&
          day <= (month == 2 && isLeapYear(year) ? 29 : DAYS[month]);
}


function time(str, full) {
  var matches = str.match(TIME);
  if (!matches) return false;

  var hour = matches[1];
  var minute = matches[2];
  var second = matches[3];
  var timeZone = matches[5];
  return ((hour <= 23 && minute <= 59 && second <= 59) ||
          (hour == 23 && minute == 59 && second == 60)) &&
         (!full || timeZone);
}


var DATE_TIME_SEPARATOR = /t|\s/i;
function date_time(str) {
  // http://tools.ietf.org/html/rfc3339#section-5.6
  var dateTime = str.split(DATE_TIME_SEPARATOR);
  return dateTime.length == 2 && date(dateTime[0]) && time(dateTime[1], true);
}


var NOT_URI_FRAGMENT = /\/|:/;
function uri(str) {
  // http://jmrware.com/articles/2009/uri_regexp/URI_regex.html + optional protocol + required "."
  return NOT_URI_FRAGMENT.test(str) && URI.test(str);
}


var Z_ANCHOR = /[^\\]\\Z/;
function regex(str) {
  if (Z_ANCHOR.test(str)) return false;
  try {
    new RegExp(str);
    return true;
  } catch(e) {
    return false;
  }
}


/***/ }),

/***/ 46229:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


exports.sha1 = __webpack_require__(43917);
exports.sha224 = __webpack_require__(47714);
exports.sha256 = __webpack_require__(2287);
exports.sha384 = __webpack_require__(21911);
exports.sha512 = __webpack_require__(57766);


/***/ }),

/***/ 46383:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var Buffer = (__webpack_require__(92861).Buffer)
var xor = __webpack_require__(30295)

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}


/***/ }),

/***/ 46579:
/***/ (function(__unused_webpack_module, exports) {

/** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */
(function (global, factory) {
	 true ? factory(exports) :
	0;
}(this, (function (exports) { 'use strict';

function merge() {
    for (var _len = arguments.length, sets = Array(_len), _key = 0; _key < _len; _key++) {
        sets[_key] = arguments[_key];
    }

    if (sets.length > 1) {
        sets[0] = sets[0].slice(0, -1);
        var xl = sets.length - 1;
        for (var x = 1; x < xl; ++x) {
            sets[x] = sets[x].slice(1, -1);
        }
        sets[xl] = sets[xl].slice(1);
        return sets.join('');
    } else {
        return sets[0];
    }
}
function subexp(str) {
    return "(?:" + str + ")";
}
function typeOf(o) {
    return o === undefined ? "undefined" : o === null ? "null" : Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase();
}
function toUpperCase(str) {
    return str.toUpperCase();
}
function toArray(obj) {
    return obj !== undefined && obj !== null ? obj instanceof Array ? obj : typeof obj.length !== "number" || obj.split || obj.setInterval || obj.call ? [obj] : Array.prototype.slice.call(obj) : [];
}
function assign(target, source) {
    var obj = target;
    if (source) {
        for (var key in source) {
            obj[key] = source[key];
        }
    }
    return obj;
}

function buildExps(isIRI) {
    var ALPHA$$ = "[A-Za-z]",
        CR$ = "[\\x0D]",
        DIGIT$$ = "[0-9]",
        DQUOTE$$ = "[\\x22]",
        HEXDIG$$ = merge(DIGIT$$, "[A-Fa-f]"),
        //case-insensitive
    LF$$ = "[\\x0A]",
        SP$$ = "[\\x20]",
        PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)),
        //expanded
    GEN_DELIMS$$ = "[\\:\\/\\?\\#\\[\\]\\@]",
        SUB_DELIMS$$ = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]",
        RESERVED$$ = merge(GEN_DELIMS$$, SUB_DELIMS$$),
        UCSCHAR$$ = isIRI ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]",
        //subset, excludes bidi control characters
    IPRIVATE$$ = isIRI ? "[\\uE000-\\uF8FF]" : "[]",
        //subset
    UNRESERVED$$ = merge(ALPHA$$, DIGIT$$, "[\\-\\.\\_\\~]", UCSCHAR$$),
        SCHEME$ = subexp(ALPHA$$ + merge(ALPHA$$, DIGIT$$, "[\\+\\-\\.]") + "*"),
        USERINFO$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]")) + "*"),
        DEC_OCTET$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("[1-9]" + DIGIT$$) + "|" + DIGIT$$),
        DEC_OCTET_RELAXED$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("0?[1-9]" + DIGIT$$) + "|0?0?" + DIGIT$$),
        //relaxed parsing rules
    IPV4ADDRESS$ = subexp(DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$),
        H16$ = subexp(HEXDIG$$ + "{1,4}"),
        LS32$ = subexp(subexp(H16$ + "\\:" + H16$) + "|" + IPV4ADDRESS$),
        IPV6ADDRESS1$ = subexp(subexp(H16$ + "\\:") + "{6}" + LS32$),
        //                           6( h16 ":" ) ls32
    IPV6ADDRESS2$ = subexp("\\:\\:" + subexp(H16$ + "\\:") + "{5}" + LS32$),
        //                      "::" 5( h16 ":" ) ls32
    IPV6ADDRESS3$ = subexp(subexp(H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{4}" + LS32$),
        //[               h16 ] "::" 4( h16 ":" ) ls32
    IPV6ADDRESS4$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,1}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{3}" + LS32$),
        //[ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
    IPV6ADDRESS5$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,2}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{2}" + LS32$),
        //[ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
    IPV6ADDRESS6$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,3}" + H16$) + "?\\:\\:" + H16$ + "\\:" + LS32$),
        //[ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
    IPV6ADDRESS7$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,4}" + H16$) + "?\\:\\:" + LS32$),
        //[ *4( h16 ":" ) h16 ] "::"              ls32
    IPV6ADDRESS8$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,5}" + H16$) + "?\\:\\:" + H16$),
        //[ *5( h16 ":" ) h16 ] "::"              h16
    IPV6ADDRESS9$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,6}" + H16$) + "?\\:\\:"),
        //[ *6( h16 ":" ) h16 ] "::"
    IPV6ADDRESS$ = subexp([IPV6ADDRESS1$, IPV6ADDRESS2$, IPV6ADDRESS3$, IPV6ADDRESS4$, IPV6ADDRESS5$, IPV6ADDRESS6$, IPV6ADDRESS7$, IPV6ADDRESS8$, IPV6ADDRESS9$].join("|")),
        ZONEID$ = subexp(subexp(UNRESERVED$$ + "|" + PCT_ENCODED$) + "+"),
        //RFC 6874
    IPV6ADDRZ$ = subexp(IPV6ADDRESS$ + "\\%25" + ZONEID$),
        //RFC 6874
    IPV6ADDRZ_RELAXED$ = subexp(IPV6ADDRESS$ + subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + ZONEID$),
        //RFC 6874, with relaxed parsing rules
    IPVFUTURE$ = subexp("[vV]" + HEXDIG$$ + "+\\." + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]") + "+"),
        IP_LITERAL$ = subexp("\\[" + subexp(IPV6ADDRZ_RELAXED$ + "|" + IPV6ADDRESS$ + "|" + IPVFUTURE$) + "\\]"),
        //RFC 6874
    REG_NAME$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$)) + "*"),
        HOST$ = subexp(IP_LITERAL$ + "|" + IPV4ADDRESS$ + "(?!" + REG_NAME$ + ")" + "|" + REG_NAME$),
        PORT$ = subexp(DIGIT$$ + "*"),
        AUTHORITY$ = subexp(subexp(USERINFO$ + "@") + "?" + HOST$ + subexp("\\:" + PORT$) + "?"),
        PCHAR$ = subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@]")),
        SEGMENT$ = subexp(PCHAR$ + "*"),
        SEGMENT_NZ$ = subexp(PCHAR$ + "+"),
        SEGMENT_NZ_NC$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\@]")) + "+"),
        PATH_ABEMPTY$ = subexp(subexp("\\/" + SEGMENT$) + "*"),
        PATH_ABSOLUTE$ = subexp("\\/" + subexp(SEGMENT_NZ$ + PATH_ABEMPTY$) + "?"),
        //simplified
    PATH_NOSCHEME$ = subexp(SEGMENT_NZ_NC$ + PATH_ABEMPTY$),
        //simplified
    PATH_ROOTLESS$ = subexp(SEGMENT_NZ$ + PATH_ABEMPTY$),
        //simplified
    PATH_EMPTY$ = "(?!" + PCHAR$ + ")",
        PATH$ = subexp(PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$),
        QUERY$ = subexp(subexp(PCHAR$ + "|" + merge("[\\/\\?]", IPRIVATE$$)) + "*"),
        FRAGMENT$ = subexp(subexp(PCHAR$ + "|[\\/\\?]") + "*"),
        HIER_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$),
        URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"),
        RELATIVE_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$),
        RELATIVE$ = subexp(RELATIVE_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"),
        URI_REFERENCE$ = subexp(URI$ + "|" + RELATIVE$),
        ABSOLUTE_URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?"),
        GENERIC_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$",
        RELATIVE_REF$ = "^(){0}" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$",
        ABSOLUTE_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?$",
        SAMEDOC_REF$ = "^" + subexp("\\#(" + FRAGMENT$ + ")") + "?$",
        AUTHORITY_REF$ = "^" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?$";
    return {
        NOT_SCHEME: new RegExp(merge("[^]", ALPHA$$, DIGIT$$, "[\\+\\-\\.]"), "g"),
        NOT_USERINFO: new RegExp(merge("[^\\%\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
        NOT_HOST: new RegExp(merge("[^\\%\\[\\]\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
        NOT_PATH: new RegExp(merge("[^\\%\\/\\:\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
        NOT_PATH_NOSCHEME: new RegExp(merge("[^\\%\\/\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
        NOT_QUERY: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]", IPRIVATE$$), "g"),
        NOT_FRAGMENT: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]"), "g"),
        ESCAPE: new RegExp(merge("[^]", UNRESERVED$$, SUB_DELIMS$$), "g"),
        UNRESERVED: new RegExp(UNRESERVED$$, "g"),
        OTHER_CHARS: new RegExp(merge("[^\\%]", UNRESERVED$$, RESERVED$$), "g"),
        PCT_ENCODED: new RegExp(PCT_ENCODED$, "g"),
        IPV4ADDRESS: new RegExp("^(" + IPV4ADDRESS$ + ")$"),
        IPV6ADDRESS: new RegExp("^\\[?(" + IPV6ADDRESS$ + ")" + subexp(subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + "(" + ZONEID$ + ")") + "?\\]?$") //RFC 6874, with relaxed parsing rules
    };
}
var URI_PROTOCOL = buildExps(false);

var IRI_PROTOCOL = buildExps(true);

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();













var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/** Highest positive signed 32-bit float value */

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1

/** Bootstring parameters */
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'

/** Regular expressions */
var regexPunycode = /^xn--/;
var regexNonASCII = /[^\0-\x7E]/; // non-ASCII chars
var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators

/** Error messages */
var errors = {
	'overflow': 'Overflow: input needs wider integers to process',
	'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
	'invalid-input': 'Invalid input'
};

/** Convenience shortcuts */
var baseMinusTMin = base - tMin;
var floor = Math.floor;
var stringFromCharCode = String.fromCharCode;

/*--------------------------------------------------------------------------*/

/**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */
function error$1(type) {
	throw new RangeError(errors[type]);
}

/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */
function map(array, fn) {
	var result = [];
	var length = array.length;
	while (length--) {
		result[length] = fn(array[length]);
	}
	return result;
}

/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */
function mapDomain(string, fn) {
	var parts = string.split('@');
	var result = '';
	if (parts.length > 1) {
		// In email addresses, only the domain name should be punycoded. Leave
		// the local part (i.e. everything up to `@`) intact.
		result = parts[0] + '@';
		string = parts[1];
	}
	// Avoid `split(regex)` for IE8 compatibility. See #17.
	string = string.replace(regexSeparators, '\x2E');
	var labels = string.split('.');
	var encoded = map(labels, fn).join('.');
	return result + encoded;
}

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */
function ucs2decode(string) {
	var output = [];
	var counter = 0;
	var length = string.length;
	while (counter < length) {
		var value = string.charCodeAt(counter++);
		if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
			// It's a high surrogate, and there is a next character.
			var extra = string.charCodeAt(counter++);
			if ((extra & 0xFC00) == 0xDC00) {
				// Low surrogate.
				output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
			} else {
				// It's an unmatched surrogate; only append this code unit, in case the
				// next code unit is the high surrogate of a surrogate pair.
				output.push(value);
				counter--;
			}
		} else {
			output.push(value);
		}
	}
	return output;
}

/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */
var ucs2encode = function ucs2encode(array) {
	return String.fromCodePoint.apply(String, toConsumableArray(array));
};

/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */
var basicToDigit = function basicToDigit(codePoint) {
	if (codePoint - 0x30 < 0x0A) {
		return codePoint - 0x16;
	}
	if (codePoint - 0x41 < 0x1A) {
		return codePoint - 0x41;
	}
	if (codePoint - 0x61 < 0x1A) {
		return codePoint - 0x61;
	}
	return base;
};

/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */
var digitToBasic = function digitToBasic(digit, flag) {
	//  0..25 map to ASCII a..z or A..Z
	// 26..35 map to ASCII 0..9
	return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */
var adapt = function adapt(delta, numPoints, firstTime) {
	var k = 0;
	delta = firstTime ? floor(delta / damp) : delta >> 1;
	delta += floor(delta / numPoints);
	for (; /* no initialization */delta > baseMinusTMin * tMax >> 1; k += base) {
		delta = floor(delta / baseMinusTMin);
	}
	return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */
var decode = function decode(input) {
	// Don't use UCS-2.
	var output = [];
	var inputLength = input.length;
	var i = 0;
	var n = initialN;
	var bias = initialBias;

	// Handle the basic code points: let `basic` be the number of input code
	// points before the last delimiter, or `0` if there is none, then copy
	// the first basic code points to the output.

	var basic = input.lastIndexOf(delimiter);
	if (basic < 0) {
		basic = 0;
	}

	for (var j = 0; j < basic; ++j) {
		// if it's not a basic code point
		if (input.charCodeAt(j) >= 0x80) {
			error$1('not-basic');
		}
		output.push(input.charCodeAt(j));
	}

	// Main decoding loop: start just after the last delimiter if any basic code
	// points were copied; start at the beginning otherwise.

	for (var index = basic > 0 ? basic + 1 : 0; index < inputLength;) /* no final expression */{

		// `index` is the index of the next character to be consumed.
		// Decode a generalized variable-length integer into `delta`,
		// which gets added to `i`. The overflow checking is easier
		// if we increase `i` as we go, then subtract off its starting
		// value at the end to obtain `delta`.
		var oldi = i;
		for (var w = 1, k = base;; /* no condition */k += base) {

			if (index >= inputLength) {
				error$1('invalid-input');
			}

			var digit = basicToDigit(input.charCodeAt(index++));

			if (digit >= base || digit > floor((maxInt - i) / w)) {
				error$1('overflow');
			}

			i += digit * w;
			var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;

			if (digit < t) {
				break;
			}

			var baseMinusT = base - t;
			if (w > floor(maxInt / baseMinusT)) {
				error$1('overflow');
			}

			w *= baseMinusT;
		}

		var out = output.length + 1;
		bias = adapt(i - oldi, out, oldi == 0);

		// `i` was supposed to wrap around from `out` to `0`,
		// incrementing `n` each time, so we'll fix that now:
		if (floor(i / out) > maxInt - n) {
			error$1('overflow');
		}

		n += floor(i / out);
		i %= out;

		// Insert `n` at position `i` of the output.
		output.splice(i++, 0, n);
	}

	return String.fromCodePoint.apply(String, output);
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */
var encode = function encode(input) {
	var output = [];

	// Convert the input in UCS-2 to an array of Unicode code points.
	input = ucs2decode(input);

	// Cache the length.
	var inputLength = input.length;

	// Initialize the state.
	var n = initialN;
	var delta = 0;
	var bias = initialBias;

	// Handle the basic code points.
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _currentValue2 = _step.value;

			if (_currentValue2 < 0x80) {
				output.push(stringFromCharCode(_currentValue2));
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	var basicLength = output.length;
	var handledCPCount = basicLength;

	// `handledCPCount` is the number of code points that have been handled;
	// `basicLength` is the number of basic code points.

	// Finish the basic string with a delimiter unless it's empty.
	if (basicLength) {
		output.push(delimiter);
	}

	// Main encoding loop:
	while (handledCPCount < inputLength) {

		// All non-basic code points < n have been handled already. Find the next
		// larger one:
		var m = maxInt;
		var _iteratorNormalCompletion2 = true;
		var _didIteratorError2 = false;
		var _iteratorError2 = undefined;

		try {
			for (var _iterator2 = input[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
				var currentValue = _step2.value;

				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow.
		} catch (err) {
			_didIteratorError2 = true;
			_iteratorError2 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion2 && _iterator2.return) {
					_iterator2.return();
				}
			} finally {
				if (_didIteratorError2) {
					throw _iteratorError2;
				}
			}
		}

		var handledCPCountPlusOne = handledCPCount + 1;
		if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
			error$1('overflow');
		}

		delta += (m - n) * handledCPCountPlusOne;
		n = m;

		var _iteratorNormalCompletion3 = true;
		var _didIteratorError3 = false;
		var _iteratorError3 = undefined;

		try {
			for (var _iterator3 = input[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
				var _currentValue = _step3.value;

				if (_currentValue < n && ++delta > maxInt) {
					error$1('overflow');
				}
				if (_currentValue == n) {
					// Represent delta as a generalized variable-length integer.
					var q = delta;
					for (var k = base;; /* no condition */k += base) {
						var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
						if (q < t) {
							break;
						}
						var qMinusT = q - t;
						var baseMinusT = base - t;
						output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}
		} catch (err) {
			_didIteratorError3 = true;
			_iteratorError3 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion3 && _iterator3.return) {
					_iterator3.return();
				}
			} finally {
				if (_didIteratorError3) {
					throw _iteratorError3;
				}
			}
		}

		++delta;
		++n;
	}
	return output.join('');
};

/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */
var toUnicode = function toUnicode(input) {
	return mapDomain(input, function (string) {
		return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
	});
};

/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */
var toASCII = function toASCII(input) {
	return mapDomain(input, function (string) {
		return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
	});
};

/*--------------------------------------------------------------------------*/

/** Define the public API */
var punycode = {
	/**
  * A string representing the current Punycode.js version number.
  * @memberOf punycode
  * @type String
  */
	'version': '2.1.0',
	/**
  * An object of methods to convert from JavaScript's internal character
  * representation (UCS-2) to Unicode code points, and back.
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode
  * @type Object
  */
	'ucs2': {
		'decode': ucs2decode,
		'encode': ucs2encode
	},
	'decode': decode,
	'encode': encode,
	'toASCII': toASCII,
	'toUnicode': toUnicode
};

/**
 * URI.js
 *
 * @fileoverview An RFC 3986 compliant, scheme extendable URI parsing/validating/resolving library for JavaScript.
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/uri-js
 */
/**
 * Copyright 2011 Gary Court. All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 *
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 *
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY GARY COURT ``AS IS'' AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL GARY COURT OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * The views and conclusions contained in the software and documentation are those of the
 * authors and should not be interpreted as representing official policies, either expressed
 * or implied, of Gary Court.
 */
var SCHEMES = {};
function pctEncChar(chr) {
    var c = chr.charCodeAt(0);
    var e = void 0;
    if (c < 16) e = "%0" + c.toString(16).toUpperCase();else if (c < 128) e = "%" + c.toString(16).toUpperCase();else if (c < 2048) e = "%" + (c >> 6 | 192).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();else e = "%" + (c >> 12 | 224).toString(16).toUpperCase() + "%" + (c >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
    return e;
}
function pctDecChars(str) {
    var newStr = "";
    var i = 0;
    var il = str.length;
    while (i < il) {
        var c = parseInt(str.substr(i + 1, 2), 16);
        if (c < 128) {
            newStr += String.fromCharCode(c);
            i += 3;
        } else if (c >= 194 && c < 224) {
            if (il - i >= 6) {
                var c2 = parseInt(str.substr(i + 4, 2), 16);
                newStr += String.fromCharCode((c & 31) << 6 | c2 & 63);
            } else {
                newStr += str.substr(i, 6);
            }
            i += 6;
        } else if (c >= 224) {
            if (il - i >= 9) {
                var _c = parseInt(str.substr(i + 4, 2), 16);
                var c3 = parseInt(str.substr(i + 7, 2), 16);
                newStr += String.fromCharCode((c & 15) << 12 | (_c & 63) << 6 | c3 & 63);
            } else {
                newStr += str.substr(i, 9);
            }
            i += 9;
        } else {
            newStr += str.substr(i, 3);
            i += 3;
        }
    }
    return newStr;
}
function _normalizeComponentEncoding(components, protocol) {
    function decodeUnreserved(str) {
        var decStr = pctDecChars(str);
        return !decStr.match(protocol.UNRESERVED) ? str : decStr;
    }
    if (components.scheme) components.scheme = String(components.scheme).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_SCHEME, "");
    if (components.userinfo !== undefined) components.userinfo = String(components.userinfo).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_USERINFO, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
    if (components.host !== undefined) components.host = String(components.host).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_HOST, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
    if (components.path !== undefined) components.path = String(components.path).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(components.scheme ? protocol.NOT_PATH : protocol.NOT_PATH_NOSCHEME, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
    if (components.query !== undefined) components.query = String(components.query).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_QUERY, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
    if (components.fragment !== undefined) components.fragment = String(components.fragment).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_FRAGMENT, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
    return components;
}

function _stripLeadingZeros(str) {
    return str.replace(/^0*(.*)/, "$1") || "0";
}
function _normalizeIPv4(host, protocol) {
    var matches = host.match(protocol.IPV4ADDRESS) || [];

    var _matches = slicedToArray(matches, 2),
        address = _matches[1];

    if (address) {
        return address.split(".").map(_stripLeadingZeros).join(".");
    } else {
        return host;
    }
}
function _normalizeIPv6(host, protocol) {
    var matches = host.match(protocol.IPV6ADDRESS) || [];

    var _matches2 = slicedToArray(matches, 3),
        address = _matches2[1],
        zone = _matches2[2];

    if (address) {
        var _address$toLowerCase$ = address.toLowerCase().split('::').reverse(),
            _address$toLowerCase$2 = slicedToArray(_address$toLowerCase$, 2),
            last = _address$toLowerCase$2[0],
            first = _address$toLowerCase$2[1];

        var firstFields = first ? first.split(":").map(_stripLeadingZeros) : [];
        var lastFields = last.split(":").map(_stripLeadingZeros);
        var isLastFieldIPv4Address = protocol.IPV4ADDRESS.test(lastFields[lastFields.length - 1]);
        var fieldCount = isLastFieldIPv4Address ? 7 : 8;
        var lastFieldsStart = lastFields.length - fieldCount;
        var fields = Array(fieldCount);
        for (var x = 0; x < fieldCount; ++x) {
            fields[x] = firstFields[x] || lastFields[lastFieldsStart + x] || '';
        }
        if (isLastFieldIPv4Address) {
            fields[fieldCount - 1] = _normalizeIPv4(fields[fieldCount - 1], protocol);
        }
        var allZeroFields = fields.reduce(function (acc, field, index) {
            if (!field || field === "0") {
                var lastLongest = acc[acc.length - 1];
                if (lastLongest && lastLongest.index + lastLongest.length === index) {
                    lastLongest.length++;
                } else {
                    acc.push({ index: index, length: 1 });
                }
            }
            return acc;
        }, []);
        var longestZeroFields = allZeroFields.sort(function (a, b) {
            return b.length - a.length;
        })[0];
        var newHost = void 0;
        if (longestZeroFields && longestZeroFields.length > 1) {
            var newFirst = fields.slice(0, longestZeroFields.index);
            var newLast = fields.slice(longestZeroFields.index + longestZeroFields.length);
            newHost = newFirst.join(":") + "::" + newLast.join(":");
        } else {
            newHost = fields.join(":");
        }
        if (zone) {
            newHost += "%" + zone;
        }
        return newHost;
    } else {
        return host;
    }
}
var URI_PARSE = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i;
var NO_MATCH_IS_UNDEFINED = "".match(/(){0}/)[1] === undefined;
function parse(uriString) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var components = {};
    var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
    if (options.reference === "suffix") uriString = (options.scheme ? options.scheme + ":" : "") + "//" + uriString;
    var matches = uriString.match(URI_PARSE);
    if (matches) {
        if (NO_MATCH_IS_UNDEFINED) {
            //store each component
            components.scheme = matches[1];
            components.userinfo = matches[3];
            components.host = matches[4];
            components.port = parseInt(matches[5], 10);
            components.path = matches[6] || "";
            components.query = matches[7];
            components.fragment = matches[8];
            //fix port number
            if (isNaN(components.port)) {
                components.port = matches[5];
            }
        } else {
            //IE FIX for improper RegExp matching
            //store each component
            components.scheme = matches[1] || undefined;
            components.userinfo = uriString.indexOf("@") !== -1 ? matches[3] : undefined;
            components.host = uriString.indexOf("//") !== -1 ? matches[4] : undefined;
            components.port = parseInt(matches[5], 10);
            components.path = matches[6] || "";
            components.query = uriString.indexOf("?") !== -1 ? matches[7] : undefined;
            components.fragment = uriString.indexOf("#") !== -1 ? matches[8] : undefined;
            //fix port number
            if (isNaN(components.port)) {
                components.port = uriString.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? matches[4] : undefined;
            }
        }
        if (components.host) {
            //normalize IP hosts
            components.host = _normalizeIPv6(_normalizeIPv4(components.host, protocol), protocol);
        }
        //determine reference type
        if (components.scheme === undefined && components.userinfo === undefined && components.host === undefined && components.port === undefined && !components.path && components.query === undefined) {
            components.reference = "same-document";
        } else if (components.scheme === undefined) {
            components.reference = "relative";
        } else if (components.fragment === undefined) {
            components.reference = "absolute";
        } else {
            components.reference = "uri";
        }
        //check for reference errors
        if (options.reference && options.reference !== "suffix" && options.reference !== components.reference) {
            components.error = components.error || "URI is not a " + options.reference + " reference.";
        }
        //find scheme handler
        var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
        //check if scheme can't handle IRIs
        if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
            //if host component is a domain name
            if (components.host && (options.domainHost || schemeHandler && schemeHandler.domainHost)) {
                //convert Unicode IDN -> ASCII IDN
                try {
                    components.host = punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase());
                } catch (e) {
                    components.error = components.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
                }
            }
            //convert IRI -> URI
            _normalizeComponentEncoding(components, URI_PROTOCOL);
        } else {
            //normalize encodings
            _normalizeComponentEncoding(components, protocol);
        }
        //perform scheme specific parsing
        if (schemeHandler && schemeHandler.parse) {
            schemeHandler.parse(components, options);
        }
    } else {
        components.error = components.error || "URI can not be parsed.";
    }
    return components;
}

function _recomposeAuthority(components, options) {
    var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
    var uriTokens = [];
    if (components.userinfo !== undefined) {
        uriTokens.push(components.userinfo);
        uriTokens.push("@");
    }
    if (components.host !== undefined) {
        //normalize IP hosts, add brackets and escape zone separator for IPv6
        uriTokens.push(_normalizeIPv6(_normalizeIPv4(String(components.host), protocol), protocol).replace(protocol.IPV6ADDRESS, function (_, $1, $2) {
            return "[" + $1 + ($2 ? "%25" + $2 : "") + "]";
        }));
    }
    if (typeof components.port === "number" || typeof components.port === "string") {
        uriTokens.push(":");
        uriTokens.push(String(components.port));
    }
    return uriTokens.length ? uriTokens.join("") : undefined;
}

var RDS1 = /^\.\.?\//;
var RDS2 = /^\/\.(\/|$)/;
var RDS3 = /^\/\.\.(\/|$)/;
var RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/;
function removeDotSegments(input) {
    var output = [];
    while (input.length) {
        if (input.match(RDS1)) {
            input = input.replace(RDS1, "");
        } else if (input.match(RDS2)) {
            input = input.replace(RDS2, "/");
        } else if (input.match(RDS3)) {
            input = input.replace(RDS3, "/");
            output.pop();
        } else if (input === "." || input === "..") {
            input = "";
        } else {
            var im = input.match(RDS5);
            if (im) {
                var s = im[0];
                input = input.slice(s.length);
                output.push(s);
            } else {
                throw new Error("Unexpected dot segment condition");
            }
        }
    }
    return output.join("");
}

function serialize(components) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var protocol = options.iri ? IRI_PROTOCOL : URI_PROTOCOL;
    var uriTokens = [];
    //find scheme handler
    var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
    //perform scheme specific serialization
    if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options);
    if (components.host) {
        //if host component is an IPv6 address
        if (protocol.IPV6ADDRESS.test(components.host)) {}
        //TODO: normalize IPv6 address as per RFC 5952

        //if host component is a domain name
        else if (options.domainHost || schemeHandler && schemeHandler.domainHost) {
                //convert IDN via punycode
                try {
                    components.host = !options.iri ? punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase()) : punycode.toUnicode(components.host);
                } catch (e) {
                    components.error = components.error || "Host's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                }
            }
    }
    //normalize encoding
    _normalizeComponentEncoding(components, protocol);
    if (options.reference !== "suffix" && components.scheme) {
        uriTokens.push(components.scheme);
        uriTokens.push(":");
    }
    var authority = _recomposeAuthority(components, options);
    if (authority !== undefined) {
        if (options.reference !== "suffix") {
            uriTokens.push("//");
        }
        uriTokens.push(authority);
        if (components.path && components.path.charAt(0) !== "/") {
            uriTokens.push("/");
        }
    }
    if (components.path !== undefined) {
        var s = components.path;
        if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) {
            s = removeDotSegments(s);
        }
        if (authority === undefined) {
            s = s.replace(/^\/\//, "/%2F"); //don't allow the path to start with "//"
        }
        uriTokens.push(s);
    }
    if (components.query !== undefined) {
        uriTokens.push("?");
        uriTokens.push(components.query);
    }
    if (components.fragment !== undefined) {
        uriTokens.push("#");
        uriTokens.push(components.fragment);
    }
    return uriTokens.join(""); //merge tokens into a string
}

function resolveComponents(base, relative) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var skipNormalization = arguments[3];

    var target = {};
    if (!skipNormalization) {
        base = parse(serialize(base, options), options); //normalize base components
        relative = parse(serialize(relative, options), options); //normalize relative components
    }
    options = options || {};
    if (!options.tolerant && relative.scheme) {
        target.scheme = relative.scheme;
        //target.authority = relative.authority;
        target.userinfo = relative.userinfo;
        target.host = relative.host;
        target.port = relative.port;
        target.path = removeDotSegments(relative.path || "");
        target.query = relative.query;
    } else {
        if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
            //target.authority = relative.authority;
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = removeDotSegments(relative.path || "");
            target.query = relative.query;
        } else {
            if (!relative.path) {
                target.path = base.path;
                if (relative.query !== undefined) {
                    target.query = relative.query;
                } else {
                    target.query = base.query;
                }
            } else {
                if (relative.path.charAt(0) === "/") {
                    target.path = removeDotSegments(relative.path);
                } else {
                    if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) {
                        target.path = "/" + relative.path;
                    } else if (!base.path) {
                        target.path = relative.path;
                    } else {
                        target.path = base.path.slice(0, base.path.lastIndexOf("/") + 1) + relative.path;
                    }
                    target.path = removeDotSegments(target.path);
                }
                target.query = relative.query;
            }
            //target.authority = base.authority;
            target.userinfo = base.userinfo;
            target.host = base.host;
            target.port = base.port;
        }
        target.scheme = base.scheme;
    }
    target.fragment = relative.fragment;
    return target;
}

function resolve(baseURI, relativeURI, options) {
    var schemelessOptions = assign({ scheme: 'null' }, options);
    return serialize(resolveComponents(parse(baseURI, schemelessOptions), parse(relativeURI, schemelessOptions), schemelessOptions, true), schemelessOptions);
}

function normalize(uri, options) {
    if (typeof uri === "string") {
        uri = serialize(parse(uri, options), options);
    } else if (typeOf(uri) === "object") {
        uri = parse(serialize(uri, options), options);
    }
    return uri;
}

function equal(uriA, uriB, options) {
    if (typeof uriA === "string") {
        uriA = serialize(parse(uriA, options), options);
    } else if (typeOf(uriA) === "object") {
        uriA = serialize(uriA, options);
    }
    if (typeof uriB === "string") {
        uriB = serialize(parse(uriB, options), options);
    } else if (typeOf(uriB) === "object") {
        uriB = serialize(uriB, options);
    }
    return uriA === uriB;
}

function escapeComponent(str, options) {
    return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.ESCAPE : IRI_PROTOCOL.ESCAPE, pctEncChar);
}

function unescapeComponent(str, options) {
    return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.PCT_ENCODED : IRI_PROTOCOL.PCT_ENCODED, pctDecChars);
}

var handler = {
    scheme: "http",
    domainHost: true,
    parse: function parse(components, options) {
        //report missing host
        if (!components.host) {
            components.error = components.error || "HTTP URIs must have a host.";
        }
        return components;
    },
    serialize: function serialize(components, options) {
        var secure = String(components.scheme).toLowerCase() === "https";
        //normalize the default port
        if (components.port === (secure ? 443 : 80) || components.port === "") {
            components.port = undefined;
        }
        //normalize the empty path
        if (!components.path) {
            components.path = "/";
        }
        //NOTE: We do not parse query strings for HTTP URIs
        //as WWW Form Url Encoded query strings are part of the HTML4+ spec,
        //and not the HTTP spec.
        return components;
    }
};

var handler$1 = {
    scheme: "https",
    domainHost: handler.domainHost,
    parse: handler.parse,
    serialize: handler.serialize
};

function isSecure(wsComponents) {
    return typeof wsComponents.secure === 'boolean' ? wsComponents.secure : String(wsComponents.scheme).toLowerCase() === "wss";
}
//RFC 6455
var handler$2 = {
    scheme: "ws",
    domainHost: true,
    parse: function parse(components, options) {
        var wsComponents = components;
        //indicate if the secure flag is set
        wsComponents.secure = isSecure(wsComponents);
        //construct resouce name
        wsComponents.resourceName = (wsComponents.path || '/') + (wsComponents.query ? '?' + wsComponents.query : '');
        wsComponents.path = undefined;
        wsComponents.query = undefined;
        return wsComponents;
    },
    serialize: function serialize(wsComponents, options) {
        //normalize the default port
        if (wsComponents.port === (isSecure(wsComponents) ? 443 : 80) || wsComponents.port === "") {
            wsComponents.port = undefined;
        }
        //ensure scheme matches secure flag
        if (typeof wsComponents.secure === 'boolean') {
            wsComponents.scheme = wsComponents.secure ? 'wss' : 'ws';
            wsComponents.secure = undefined;
        }
        //reconstruct path from resource name
        if (wsComponents.resourceName) {
            var _wsComponents$resourc = wsComponents.resourceName.split('?'),
                _wsComponents$resourc2 = slicedToArray(_wsComponents$resourc, 2),
                path = _wsComponents$resourc2[0],
                query = _wsComponents$resourc2[1];

            wsComponents.path = path && path !== '/' ? path : undefined;
            wsComponents.query = query;
            wsComponents.resourceName = undefined;
        }
        //forbid fragment component
        wsComponents.fragment = undefined;
        return wsComponents;
    }
};

var handler$3 = {
    scheme: "wss",
    domainHost: handler$2.domainHost,
    parse: handler$2.parse,
    serialize: handler$2.serialize
};

var O = {};
var isIRI = true;
//RFC 3986
var UNRESERVED$$ = "[A-Za-z0-9\\-\\.\\_\\~" + (isIRI ? "\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF" : "") + "]";
var HEXDIG$$ = "[0-9A-Fa-f]"; //case-insensitive
var PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)); //expanded
//RFC 5322, except these symbols as per RFC 6068: @ : / ? # [ ] & ; =
//const ATEXT$$ = "[A-Za-z0-9\\!\\#\\$\\%\\&\\'\\*\\+\\-\\/\\=\\?\\^\\_\\`\\{\\|\\}\\~]";
//const WSP$$ = "[\\x20\\x09]";
//const OBS_QTEXT$$ = "[\\x01-\\x08\\x0B\\x0C\\x0E-\\x1F\\x7F]";  //(%d1-8 / %d11-12 / %d14-31 / %d127)
//const QTEXT$$ = merge("[\\x21\\x23-\\x5B\\x5D-\\x7E]", OBS_QTEXT$$);  //%d33 / %d35-91 / %d93-126 / obs-qtext
//const VCHAR$$ = "[\\x21-\\x7E]";
//const WSP$$ = "[\\x20\\x09]";
//const OBS_QP$ = subexp("\\\\" + merge("[\\x00\\x0D\\x0A]", OBS_QTEXT$$));  //%d0 / CR / LF / obs-qtext
//const FWS$ = subexp(subexp(WSP$$ + "*" + "\\x0D\\x0A") + "?" + WSP$$ + "+");
//const QUOTED_PAIR$ = subexp(subexp("\\\\" + subexp(VCHAR$$ + "|" + WSP$$)) + "|" + OBS_QP$);
//const QUOTED_STRING$ = subexp('\\"' + subexp(FWS$ + "?" + QCONTENT$) + "*" + FWS$ + "?" + '\\"');
var ATEXT$$ = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]";
var QTEXT$$ = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]";
var VCHAR$$ = merge(QTEXT$$, "[\\\"\\\\]");
var SOME_DELIMS$$ = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]";
var UNRESERVED = new RegExp(UNRESERVED$$, "g");
var PCT_ENCODED = new RegExp(PCT_ENCODED$, "g");
var NOT_LOCAL_PART = new RegExp(merge("[^]", ATEXT$$, "[\\.]", '[\\"]', VCHAR$$), "g");
var NOT_HFNAME = new RegExp(merge("[^]", UNRESERVED$$, SOME_DELIMS$$), "g");
var NOT_HFVALUE = NOT_HFNAME;
function decodeUnreserved(str) {
    var decStr = pctDecChars(str);
    return !decStr.match(UNRESERVED) ? str : decStr;
}
var handler$4 = {
    scheme: "mailto",
    parse: function parse$$1(components, options) {
        var mailtoComponents = components;
        var to = mailtoComponents.to = mailtoComponents.path ? mailtoComponents.path.split(",") : [];
        mailtoComponents.path = undefined;
        if (mailtoComponents.query) {
            var unknownHeaders = false;
            var headers = {};
            var hfields = mailtoComponents.query.split("&");
            for (var x = 0, xl = hfields.length; x < xl; ++x) {
                var hfield = hfields[x].split("=");
                switch (hfield[0]) {
                    case "to":
                        var toAddrs = hfield[1].split(",");
                        for (var _x = 0, _xl = toAddrs.length; _x < _xl; ++_x) {
                            to.push(toAddrs[_x]);
                        }
                        break;
                    case "subject":
                        mailtoComponents.subject = unescapeComponent(hfield[1], options);
                        break;
                    case "body":
                        mailtoComponents.body = unescapeComponent(hfield[1], options);
                        break;
                    default:
                        unknownHeaders = true;
                        headers[unescapeComponent(hfield[0], options)] = unescapeComponent(hfield[1], options);
                        break;
                }
            }
            if (unknownHeaders) mailtoComponents.headers = headers;
        }
        mailtoComponents.query = undefined;
        for (var _x2 = 0, _xl2 = to.length; _x2 < _xl2; ++_x2) {
            var addr = to[_x2].split("@");
            addr[0] = unescapeComponent(addr[0]);
            if (!options.unicodeSupport) {
                //convert Unicode IDN -> ASCII IDN
                try {
                    addr[1] = punycode.toASCII(unescapeComponent(addr[1], options).toLowerCase());
                } catch (e) {
                    mailtoComponents.error = mailtoComponents.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
                }
            } else {
                addr[1] = unescapeComponent(addr[1], options).toLowerCase();
            }
            to[_x2] = addr.join("@");
        }
        return mailtoComponents;
    },
    serialize: function serialize$$1(mailtoComponents, options) {
        var components = mailtoComponents;
        var to = toArray(mailtoComponents.to);
        if (to) {
            for (var x = 0, xl = to.length; x < xl; ++x) {
                var toAddr = String(to[x]);
                var atIdx = toAddr.lastIndexOf("@");
                var localPart = toAddr.slice(0, atIdx).replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_LOCAL_PART, pctEncChar);
                var domain = toAddr.slice(atIdx + 1);
                //convert IDN via punycode
                try {
                    domain = !options.iri ? punycode.toASCII(unescapeComponent(domain, options).toLowerCase()) : punycode.toUnicode(domain);
                } catch (e) {
                    components.error = components.error || "Email address's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                }
                to[x] = localPart + "@" + domain;
            }
            components.path = to.join(",");
        }
        var headers = mailtoComponents.headers = mailtoComponents.headers || {};
        if (mailtoComponents.subject) headers["subject"] = mailtoComponents.subject;
        if (mailtoComponents.body) headers["body"] = mailtoComponents.body;
        var fields = [];
        for (var name in headers) {
            if (headers[name] !== O[name]) {
                fields.push(name.replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFNAME, pctEncChar) + "=" + headers[name].replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFVALUE, pctEncChar));
            }
        }
        if (fields.length) {
            components.query = fields.join("&");
        }
        return components;
    }
};

var URN_PARSE = /^([^\:]+)\:(.*)/;
//RFC 2141
var handler$5 = {
    scheme: "urn",
    parse: function parse$$1(components, options) {
        var matches = components.path && components.path.match(URN_PARSE);
        var urnComponents = components;
        if (matches) {
            var scheme = options.scheme || urnComponents.scheme || "urn";
            var nid = matches[1].toLowerCase();
            var nss = matches[2];
            var urnScheme = scheme + ":" + (options.nid || nid);
            var schemeHandler = SCHEMES[urnScheme];
            urnComponents.nid = nid;
            urnComponents.nss = nss;
            urnComponents.path = undefined;
            if (schemeHandler) {
                urnComponents = schemeHandler.parse(urnComponents, options);
            }
        } else {
            urnComponents.error = urnComponents.error || "URN can not be parsed.";
        }
        return urnComponents;
    },
    serialize: function serialize$$1(urnComponents, options) {
        var scheme = options.scheme || urnComponents.scheme || "urn";
        var nid = urnComponents.nid;
        var urnScheme = scheme + ":" + (options.nid || nid);
        var schemeHandler = SCHEMES[urnScheme];
        if (schemeHandler) {
            urnComponents = schemeHandler.serialize(urnComponents, options);
        }
        var uriComponents = urnComponents;
        var nss = urnComponents.nss;
        uriComponents.path = (nid || options.nid) + ":" + nss;
        return uriComponents;
    }
};

var UUID = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/;
//RFC 4122
var handler$6 = {
    scheme: "urn:uuid",
    parse: function parse(urnComponents, options) {
        var uuidComponents = urnComponents;
        uuidComponents.uuid = uuidComponents.nss;
        uuidComponents.nss = undefined;
        if (!options.tolerant && (!uuidComponents.uuid || !uuidComponents.uuid.match(UUID))) {
            uuidComponents.error = uuidComponents.error || "UUID is not valid.";
        }
        return uuidComponents;
    },
    serialize: function serialize(uuidComponents, options) {
        var urnComponents = uuidComponents;
        //normalize UUID
        urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
        return urnComponents;
    }
};

SCHEMES[handler.scheme] = handler;
SCHEMES[handler$1.scheme] = handler$1;
SCHEMES[handler$2.scheme] = handler$2;
SCHEMES[handler$3.scheme] = handler$3;
SCHEMES[handler$4.scheme] = handler$4;
SCHEMES[handler$5.scheme] = handler$5;
SCHEMES[handler$6.scheme] = handler$6;

exports.SCHEMES = SCHEMES;
exports.pctEncChar = pctEncChar;
exports.pctDecChars = pctDecChars;
exports.parse = parse;
exports.removeDotSegments = removeDotSegments;
exports.serialize = serialize;
exports.resolveComponents = resolveComponents;
exports.resolve = resolve;
exports.normalize = normalize;
exports.equal = equal;
exports.escapeComponent = escapeComponent;
exports.unescapeComponent = unescapeComponent;

Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=uri.all.js.map


/***/ }),

/***/ 46637:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


/***/ }),

/***/ 46661:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(47011);
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;


/***/ }),

/***/ 46662:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


const getOptions = __webpack_require__(55250);
const parseQuery = __webpack_require__(90497);
const stringifyRequest = __webpack_require__(87942);
const getRemainingRequest = __webpack_require__(5359);
const getCurrentRequest = __webpack_require__(34112);
const isUrlRequest = __webpack_require__(93662);
const urlToRequest = __webpack_require__(55729);
const parseString = __webpack_require__(5704);
const getHashDigest = __webpack_require__(40286);
const interpolateName = __webpack_require__(1434);

exports.getOptions = getOptions;
exports.parseQuery = parseQuery;
exports.stringifyRequest = stringifyRequest;
exports.getRemainingRequest = getRemainingRequest;
exports.getCurrentRequest = getCurrentRequest;
exports.isUrlRequest = isUrlRequest;
exports.urlToRequest = urlToRequest;
exports.parseString = parseString;
exports.getHashDigest = getHashDigest;
exports.interpolateName = interpolateName;


/***/ }),

/***/ 46784:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(67426);
var common = __webpack_require__(66166);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),

/***/ 46843:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__(48287)["Buffer"];
var xor = __webpack_require__(30295)

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),

/***/ 46891:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(65606);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



module.exports = Readable;

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = (__webpack_require__(37007).EventEmitter);
var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(41396);
/*</replacement>*/

var Buffer = (__webpack_require__(48287).Buffer);
var OurUint8Array = (typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*<replacement>*/
var debugUtil = __webpack_require__(77199);
var debug;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/

var BufferList = __webpack_require__(81766);
var destroyImpl = __webpack_require__(54347);
var _require = __webpack_require__(66644),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = (__webpack_require__(12463)/* .codes */ .F),
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
__webpack_require__(56698)(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}
function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__(88101);
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'end' (and potentially 'finish')
  this.autoDestroy = !!options.autoDestroy;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = (__webpack_require__(83141)/* .StringDecoder */ .I);
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}
function Readable(options) {
  Duplex = Duplex || __webpack_require__(88101);
  if (!(this instanceof Readable)) return new Readable(options);

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex);

  // legacy
  this.readable = true;
  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }
  Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;
  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }
  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }
      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  }

  // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.
  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }
  return er;
}
Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = (__webpack_require__(83141)/* .StringDecoder */ .I);
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder;
  // If setEncoding(null), decoder.encoding equals utf8
  this._readableState.encoding = this._readableState.decoder.encoding;

  // Iterate over current buffer to convert already stored Buffers:
  var p = this._readableState.buffer.head;
  var content = '';
  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }
  this._readableState.buffer.clear();
  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
};

// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }
  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }
  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;
  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }
  if (ret !== null) this.emit('data', ret);
  return ret;
};
function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;
  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;
    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}
function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);
  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  }

  // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.
  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}
function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;
  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }
  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);
    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);
  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }
  return dest;
};
function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}
Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    for (var i = 0; i < len; i++) dests[i].emit('unpipe', this, {
      hasUnpiped: false
    });
    return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;
  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0;

    // Try start flowing on next tick if stream isn't explicitly paused
    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);
      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }
  return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);
  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);
  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;
  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;

    // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}
function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()
    state.flowing = !state.readableListening;
    resume(this, state);
  }
  state.paused = false;
  return this;
};
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}
function resume_(stream, state) {
  debug('resume', state.reading);
  if (!state.reading) {
    stream.read(0);
  }
  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  this._readableState.paused = true;
  return this;
};
function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null);
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;
  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }
    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };
  return this;
};
if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = __webpack_require__(65034);
    }
    return createReadableStreamAsyncIterator(this);
  };
}
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
});

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}
function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);
  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}
function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length);

  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;
      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}
if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = __webpack_require__(90968);
    }
    return from(Readable, iterable, opts);
  };
}
function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}

/***/ }),

/***/ 47011:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var utils = exports;
var BN = __webpack_require__(28490);
var minAssert = __webpack_require__(43349);
var minUtils = __webpack_require__(64367);

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w, bits) {
  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
  var i;
  for (i = 0; i < naf.length; i += 1) {
    naf[i] = 0;
  }

  var ws = 1 << (w + 1);
  var k = num.clone();

  for (i = 0; i < naf.length; i++) {
    var z;
    var mod = k.andln(ws - 1);
    if (k.isOdd()) {
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }

    naf[i] = z;
    k.iushrn(1);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    [],
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  var m8;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
      this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
    bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;



/***/ }),

/***/ 47108:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var inherits = __webpack_require__(56698)
var MD5 = __webpack_require__(88276)
var RIPEMD160 = __webpack_require__(66011)
var sha = __webpack_require__(62802)
var Base = __webpack_require__(56168)

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}


/***/ }),

/***/ 47227:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var inherits = __webpack_require__(56698);
var Reporter = (__webpack_require__(9673).Reporter);
var Buffer = (__webpack_require__(48287).Buffer);

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.t = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.d = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};


/***/ }),

/***/ 47289:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var View = api.importMixinModule('service', 'views', 'ai');
var AiServiceView = /*#__PURE__*/function (_View) {
  function AiServiceView() {
    _classCallCheck(this, AiServiceView);
    return _callSuper(this, AiServiceView, arguments);
  }
  _inherits(AiServiceView, _View);
  return _createClass(AiServiceView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var options;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(AiServiceView, "getTableOptions", this, 2)([]);
            case 2:
              options = _context.sent;
              options.fields.push({
                name: 'Optimized',
                editor: 'checkbox',
                label: 'Optimized'
              });
              return _context.abrupt("return", options);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(View);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AiServiceView);

/***/ }),

/***/ 47363:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var asn1 = __webpack_require__(87568);
var inherits = __webpack_require__(56698);

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = (__webpack_require__(68961).runInThisContext)(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};


/***/ }),

/***/ 47419:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = function defFunc(ajv) {
  defFunc.definition = {
    type: 'object',
    inline: __webpack_require__(8624),
    statements: true,
    errors: 'full',
    metaSchema: {
      type: 'array',
      items: {
        type: 'string',
        format: 'regex'
      },
      uniqueItems: true
    }
  };

  ajv.addKeyword('patternRequired', defFunc.definition);
  return ajv;
};


/***/ }),

/***/ 47471:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64467);
/* harmony import */ var _base_model_base_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42675);






function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var RoomConfiguration = /*#__PURE__*/function (_BaseModel) {
  function RoomConfiguration() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, RoomConfiguration);
    return _callSuper(this, RoomConfiguration, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(RoomConfiguration, _BaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(RoomConfiguration);
}(_base_model_base_model__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(RoomConfiguration, "moduleName", 'roomconfiguration');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (RoomConfiguration);

/***/ }),

/***/ 47500:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AgencyMixinView = api.importMixinModule('agency', 'views', 'contacts');
var ContactsAgencyView = /*#__PURE__*/function (_AgencyMixinView) {
  function ContactsAgencyView() {
    _classCallCheck(this, ContactsAgencyView);
    return _callSuper(this, ContactsAgencyView, arguments);
  }
  _inherits(ContactsAgencyView, _AgencyMixinView);
  return _createClass(ContactsAgencyView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(ContactsAgencyView, "getTableOptions", this, 2)([]);
            case 2:
              res = _context.sent;
              res.fields.push({
                name: "AgencyContactList",
                editor: "component",
                hideFromList: true,
                label: "Contacts",
                icon: 'user',
                component: 'agency-contact-list',
                componentName: 'agency-contact-list',
                componentPath: 'components'
              });
              return _context.abrupt("return", res);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(AgencyMixinView);
_defineProperty(ContactsAgencyView, "table", 'agency');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ContactsAgencyView);

/***/ }),

/***/ 47714:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(67426);
var SHA256 = __webpack_require__(2287);

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};



/***/ }),

/***/ 47777:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


/***/ }),

/***/ 47790:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 47850:
/***/ ((module) => {

"use strict";

module.exports = function generate_required(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $vSchema = 'schema' + $lvl;
  if (!$isData) {
    if ($schema.length < it.opts.loopRequired && it.schema.properties && Object.keys(it.schema.properties).length) {
      var $required = [];
      var arr1 = $schema;
      if (arr1) {
        var $property, i1 = -1,
          l1 = arr1.length - 1;
        while (i1 < l1) {
          $property = arr1[i1 += 1];
          var $propertySch = it.schema.properties[$property];
          if (!($propertySch && (it.opts.strictKeywords ? (typeof $propertySch == 'object' && Object.keys($propertySch).length > 0) || $propertySch === false : it.util.schemaHasRules($propertySch, it.RULES.all)))) {
            $required[$required.length] = $property;
          }
        }
      }
    } else {
      var $required = $schema;
    }
  }
  if ($isData || $required.length) {
    var $currentErrorPath = it.errorPath,
      $loopRequired = $isData || $required.length >= it.opts.loopRequired,
      $ownProperties = it.opts.ownProperties;
    if ($breakOnError) {
      out += ' var missing' + ($lvl) + '; ';
      if ($loopRequired) {
        if (!$isData) {
          out += ' var ' + ($vSchema) + ' = validate.schema' + ($schemaPath) + '; ';
        }
        var $i = 'i' + $lvl,
          $propertyPath = 'schema' + $lvl + '[' + $i + ']',
          $missingProperty = '\' + ' + $propertyPath + ' + \'';
        if (it.opts._errorDataPathProperty) {
          it.errorPath = it.util.getPathExpr($currentErrorPath, $propertyPath, it.opts.jsonPointers);
        }
        out += ' var ' + ($valid) + ' = true; ';
        if ($isData) {
          out += ' if (schema' + ($lvl) + ' === undefined) ' + ($valid) + ' = true; else if (!Array.isArray(schema' + ($lvl) + ')) ' + ($valid) + ' = false; else {';
        }
        out += ' for (var ' + ($i) + ' = 0; ' + ($i) + ' < ' + ($vSchema) + '.length; ' + ($i) + '++) { ' + ($valid) + ' = ' + ($data) + '[' + ($vSchema) + '[' + ($i) + ']] !== undefined ';
        if ($ownProperties) {
          out += ' &&   Object.prototype.hasOwnProperty.call(' + ($data) + ', ' + ($vSchema) + '[' + ($i) + ']) ';
        }
        out += '; if (!' + ($valid) + ') break; } ';
        if ($isData) {
          out += '  }  ';
        }
        out += '  if (!' + ($valid) + ') {   ';
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'';
            if (it.opts._errorDataPathProperty) {
              out += 'is a required property';
            } else {
              out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
            }
            out += '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
        out += ' } else { ';
      } else {
        out += ' if ( ';
        var arr2 = $required;
        if (arr2) {
          var $propertyKey, $i = -1,
            l2 = arr2.length - 1;
          while ($i < l2) {
            $propertyKey = arr2[$i += 1];
            if ($i) {
              out += ' || ';
            }
            var $prop = it.util.getProperty($propertyKey),
              $useData = $data + $prop;
            out += ' ( ( ' + ($useData) + ' === undefined ';
            if ($ownProperties) {
              out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
            }
            out += ') && (missing' + ($lvl) + ' = ' + (it.util.toQuotedString(it.opts.jsonPointers ? $propertyKey : $prop)) + ') ) ';
          }
        }
        out += ') {  ';
        var $propertyPath = 'missing' + $lvl,
          $missingProperty = '\' + ' + $propertyPath + ' + \'';
        if (it.opts._errorDataPathProperty) {
          it.errorPath = it.opts.jsonPointers ? it.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + ' + ' + $propertyPath;
        }
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'';
            if (it.opts._errorDataPathProperty) {
              out += 'is a required property';
            } else {
              out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
            }
            out += '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
        out += ' } else { ';
      }
    } else {
      if ($loopRequired) {
        if (!$isData) {
          out += ' var ' + ($vSchema) + ' = validate.schema' + ($schemaPath) + '; ';
        }
        var $i = 'i' + $lvl,
          $propertyPath = 'schema' + $lvl + '[' + $i + ']',
          $missingProperty = '\' + ' + $propertyPath + ' + \'';
        if (it.opts._errorDataPathProperty) {
          it.errorPath = it.util.getPathExpr($currentErrorPath, $propertyPath, it.opts.jsonPointers);
        }
        if ($isData) {
          out += ' if (' + ($vSchema) + ' && !Array.isArray(' + ($vSchema) + ')) {  var err =   '; /* istanbul ignore else */
          if (it.createErrors !== false) {
            out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
            if (it.opts.messages !== false) {
              out += ' , message: \'';
              if (it.opts._errorDataPathProperty) {
                out += 'is a required property';
              } else {
                out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
              }
              out += '\' ';
            }
            if (it.opts.verbose) {
              out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
            }
            out += ' } ';
          } else {
            out += ' {} ';
          }
          out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (' + ($vSchema) + ' !== undefined) { ';
        }
        out += ' for (var ' + ($i) + ' = 0; ' + ($i) + ' < ' + ($vSchema) + '.length; ' + ($i) + '++) { if (' + ($data) + '[' + ($vSchema) + '[' + ($i) + ']] === undefined ';
        if ($ownProperties) {
          out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', ' + ($vSchema) + '[' + ($i) + ']) ';
        }
        out += ') {  var err =   '; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'';
            if (it.opts._errorDataPathProperty) {
              out += 'is a required property';
            } else {
              out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
            }
            out += '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ';
        if ($isData) {
          out += '  }  ';
        }
      } else {
        var arr3 = $required;
        if (arr3) {
          var $propertyKey, i3 = -1,
            l3 = arr3.length - 1;
          while (i3 < l3) {
            $propertyKey = arr3[i3 += 1];
            var $prop = it.util.getProperty($propertyKey),
              $missingProperty = it.util.escapeQuotes($propertyKey),
              $useData = $data + $prop;
            if (it.opts._errorDataPathProperty) {
              it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
            }
            out += ' if ( ' + ($useData) + ' === undefined ';
            if ($ownProperties) {
              out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
            }
            out += ') {  var err =   '; /* istanbul ignore else */
            if (it.createErrors !== false) {
              out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
              if (it.opts.messages !== false) {
                out += ' , message: \'';
                if (it.opts._errorDataPathProperty) {
                  out += 'is a required property';
                } else {
                  out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
                }
                out += '\' ';
              }
              if (it.opts.verbose) {
                out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
              }
              out += ' } ';
            } else {
              out += ' {} ';
            }
            out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ';
          }
        }
      }
    }
    it.errorPath = $currentErrorPath;
  } else if ($breakOnError) {
    out += ' if (true) {';
  }
  return out;
}


/***/ }),

/***/ 47935:
/***/ ((module) => {

"use strict";

module.exports = function generate__limitLength(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  if (!($isData || typeof $schema == 'number')) {
    throw new Error($keyword + ' must be number');
  }
  var $op = $keyword == 'maxLength' ? '>' : '<';
  out += 'if ( ';
  if ($isData) {
    out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
  }
  if (it.opts.unicode === false) {
    out += ' ' + ($data) + '.length ';
  } else {
    out += ' ucs2length(' + ($data) + ') ';
  }
  out += ' ' + ($op) + ' ' + ($schemaValue) + ') { ';
  var $errorKeyword = $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ($errorKeyword || '_limitLength') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { limit: ' + ($schemaValue) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should NOT be ';
      if ($keyword == 'maxLength') {
        out += 'longer';
      } else {
        out += 'shorter';
      }
      out += ' than ';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + ($schema);
      }
      out += ' characters\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + ($schema);
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '} ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),

/***/ 48095:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Record = api.importMixinModule('purchaseinvoice', 'model', 'ai');
var PurchaseInvoice = /*#__PURE__*/function (_Record) {
  function PurchaseInvoice() {
    _classCallCheck(this, PurchaseInvoice);
    return _callSuper(this, PurchaseInvoice, arguments);
  }
  _inherits(PurchaseInvoice, _Record);
  return _createClass(PurchaseInvoice, [{
    key: "processAI",
    value: function () {
      var _processAI = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(fileList) {
        var formData, file, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              formData = new FormData();
              file = fileList[0].file || fileList[0];
              formData.append("file", file);
              api.setProcessing(true);
              _context.next = 6;
              return api.post("/api/ai_invoice/pdf", formData, {}, function (err) {
                api.showAlert = {
                  text: err.detail,
                  level: 1
                };
              });
            case 6:
              response = _context.sent;
              this._recordLoaded = false;
              if (response.PurchaseInvoiceTaxes && Array.isArray(response.PurchaseInvoiceTaxes)) {
                response.PurchaseInvoiceTaxes = _toConsumableArray(response.PurchaseInvoiceTaxes);
              }
              if (response.PurchaseInvoiceDetails && Array.isArray(response.PurchaseInvoiceDetails)) {
                response.PurchaseInvoiceDetails = _toConsumableArray(response.PurchaseInvoiceDetails);
              }
              _context.next = 12;
              return this.init(response);
            case 12:
              _context.next = 14;
              return this.getAttached();
            case 14:
              api.updateToStore(this.tableName, response);
              this.addNotification("Factura cargada correctamente");
              this._recordLoaded = true;
              api.setProcessing(false);
              return _context.abrupt("return", response);
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function processAI(_x) {
        return _processAI.apply(this, arguments);
      }
      return processAI;
    }()
  }]);
}(Record);
_defineProperty(PurchaseInvoice, "table", 'purchaseinvoice');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PurchaseInvoice);

/***/ }),

/***/ 48206:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var createHash = __webpack_require__(47108)
var Buffer = (__webpack_require__(92861).Buffer)

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}


/***/ }),

/***/ 48287:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



const base64 = __webpack_require__(67526)
const ieee754 = __webpack_require__(251)
const customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

const K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    const arr = new Uint8Array(1)
    const proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  const buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  const valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  const b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length)
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  const length = byteLength(string, encoding) | 0
  let buf = createBuffer(length)

  const actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  const length = array.length < 0 ? 0 : checked(array.length) | 0
  const buf = createBuffer(length)
  for (let i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    const copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  let buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    const len = checked(obj.length) | 0
    const buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  let x = a.length
  let y = b.length

  for (let i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  let i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  const buffer = Buffer.allocUnsafe(length)
  let pos = 0
  for (i = 0; i < list.length; ++i) {
    let buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)
        buf.copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  const len = string.length
  const mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  let loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  const i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  const len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (let i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  const len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (let i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  const len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (let i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  const length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  let str = ''
  const max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  let x = thisEnd - thisStart
  let y = end - start
  const len = Math.min(x, y)

  const thisCopy = this.slice(thisStart, thisEnd)
  const targetCopy = target.slice(start, end)

  for (let i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  let indexSize = 1
  let arrLength = arr.length
  let valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  let i
  if (dir) {
    let foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      let found = true
      for (let j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  const remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  const strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  let i
  for (i = 0; i < length; ++i) {
    const parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  const remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  const res = []

  let i = start
  while (i < end) {
    const firstByte = buf[i]
    let codePoint = null
    let bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      let secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  const len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  let res = ''
  let i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  const len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  let out = ''
  for (let i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  const bytes = buf.slice(start, end)
  let res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (let i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  const len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  const newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  let val = this[offset + --byteLength]
  let mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const lo = first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24

  const hi = this[++offset] +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    last * 2 ** 24

  return BigInt(lo) + (BigInt(hi) << BigInt(32))
})

Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const hi = first * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  const lo = this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last

  return (BigInt(hi) << BigInt(32)) + BigInt(lo)
})

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let i = byteLength
  let mul = 1
  let val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = this[offset + 4] +
    this[offset + 5] * 2 ** 8 +
    this[offset + 6] * 2 ** 16 +
    (last << 24) // Overflow

  return (BigInt(val) << BigInt(32)) +
    BigInt(first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24)
})

Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  return (BigInt(val) << BigInt(32)) +
    BigInt(this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last)
})

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let mul = 1
  let i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let i = byteLength - 1
  let mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function wrtBigUInt64LE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  return offset
}

function wrtBigUInt64BE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset + 7] = lo
  lo = lo >> 8
  buf[offset + 6] = lo
  lo = lo >> 8
  buf[offset + 5] = lo
  lo = lo >> 8
  buf[offset + 4] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset + 3] = hi
  hi = hi >> 8
  buf[offset + 2] = hi
  hi = hi >> 8
  buf[offset + 1] = hi
  hi = hi >> 8
  buf[offset] = hi
  return offset + 8
}

Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = 0
  let mul = 1
  let sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = byteLength - 1
  let mul = 1
  let sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  const len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      const code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  let i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    const bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    const len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// CUSTOM ERRORS
// =============

// Simplified versions from Node, changed for Buffer-only usage
const errors = {}
function E (sym, getMessage, Base) {
  errors[sym] = class NodeError extends Base {
    constructor () {
      super()

      Object.defineProperty(this, 'message', {
        value: getMessage.apply(this, arguments),
        writable: true,
        configurable: true
      })

      // Add the error code to the name to include it in the stack trace.
      this.name = `${this.name} [${sym}]`
      // Access the stack to generate the error message including the error code
      // from the name.
      this.stack // eslint-disable-line no-unused-expressions
      // Reset the name to the actual name.
      delete this.name
    }

    get code () {
      return sym
    }

    set code (value) {
      Object.defineProperty(this, 'code', {
        configurable: true,
        enumerable: true,
        value,
        writable: true
      })
    }

    toString () {
      return `${this.name} [${sym}]: ${this.message}`
    }
  }
}

E('ERR_BUFFER_OUT_OF_BOUNDS',
  function (name) {
    if (name) {
      return `${name} is outside of buffer bounds`
    }

    return 'Attempt to access memory outside buffer bounds'
  }, RangeError)
E('ERR_INVALID_ARG_TYPE',
  function (name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`
  }, TypeError)
E('ERR_OUT_OF_RANGE',
  function (str, range, input) {
    let msg = `The value of "${str}" is out of range.`
    let received = input
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input))
    } else if (typeof input === 'bigint') {
      received = String(input)
      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
        received = addNumericalSeparator(received)
      }
      received += 'n'
    }
    msg += ` It must be ${range}. Received ${received}`
    return msg
  }, RangeError)

function addNumericalSeparator (val) {
  let res = ''
  let i = val.length
  const start = val[0] === '-' ? 1 : 0
  for (; i >= start + 4; i -= 3) {
    res = `_${val.slice(i - 3, i)}${res}`
  }
  return `${val.slice(0, i)}${res}`
}

// CHECK FUNCTIONS
// ===============

function checkBounds (buf, offset, byteLength) {
  validateNumber(offset, 'offset')
  if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
    boundsError(offset, buf.length - (byteLength + 1))
  }
}

function checkIntBI (value, min, max, buf, offset, byteLength) {
  if (value > max || value < min) {
    const n = typeof min === 'bigint' ? 'n' : ''
    let range
    if (byteLength > 3) {
      if (min === 0 || min === BigInt(0)) {
        range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`
      } else {
        range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` +
                `${(byteLength + 1) * 8 - 1}${n}`
      }
    } else {
      range = `>= ${min}${n} and <= ${max}${n}`
    }
    throw new errors.ERR_OUT_OF_RANGE('value', range, value)
  }
  checkBounds(buf, offset, byteLength)
}

function validateNumber (value, name) {
  if (typeof value !== 'number') {
    throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value)
  }
}

function boundsError (value, length, type) {
  if (Math.floor(value) !== value) {
    validateNumber(value, type)
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value)
  }

  if (length < 0) {
    throw new errors.ERR_BUFFER_OUT_OF_BOUNDS()
  }

  throw new errors.ERR_OUT_OF_RANGE(type || 'offset',
                                    `>= ${type ? 1 : 0} and <= ${length}`,
                                    value)
}

// HELPER FUNCTIONS
// ================

const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  let codePoint
  const length = string.length
  let leadSurrogate = null
  const bytes = []

  for (let i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  let c, hi, lo
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  let i
  for (i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = (function () {
  const alphabet = '0123456789abcdef'
  const table = new Array(256)
  for (let i = 0; i < 16; ++i) {
    const i16 = i * 16
    for (let j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()

// Return not function with Error if BigInt not supported
function defineBigIntMethod (fn) {
  return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn
}

function BufferBigIntNotDefined () {
  throw new Error('BigInt not supported')
}


/***/ }),

/***/ 48303:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
                '_'
            ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


/***/ }),

/***/ 48414:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort:
            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
                '_'
            ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


/***/ }),

/***/ 48433:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64467);
/* harmony import */ var _base_model_base_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42675);






function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingDayServiceImage = /*#__PURE__*/function (_BaseModel) {
  function BookingDayServiceImage() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, BookingDayServiceImage);
    return _callSuper(this, BookingDayServiceImage, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(BookingDayServiceImage, _BaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingDayServiceImage);
}(_base_model_base_model__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingDayServiceImage, "moduleName", 'bookingdayserviceimage');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingDayServiceImage);

/***/ }),

/***/ 48456:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var map = {
	"./de/world.json": 63966,
	"./en/world.json": 62730,
	"./es/world.json": 67537,
	"./fr/world.json": 56057,
	"./it/world.json": 99708,
	"./nl/world.json": 61163,
	"./pt/world.json": 52309
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48456;

/***/ }),

/***/ 48479:
/***/ ((module) => {

"use strict";


module.exports = function defFunc(ajv) {
  defFunc.definition = {
    type: 'object',
    macro: function (schema) {
      if (schema.length == 0) return true;
      if (schema.length == 1) return {required: schema};
      var schemas = schema.map(function (prop) {
        return {required: [prop]};
      });
      return {anyOf: schemas};
    },
    metaSchema: {
      type: 'array',
      items: {
        type: 'string'
      }
    }
  };

  ajv.addKeyword('anyRequired', defFunc.definition);
  return ajv;
};


/***/ }),

/***/ 48857:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"Date":"Data","Location":"Localização","Itinerary":"Itinerário","Confirmation":"Confirmação","Day":"Dia","Accommodation":"Acomodação","Meals":"Refeições","Meals Included":"Refeições Incluído","Included":"Incluído","Breakfast":"Café da manhã","Lunch":"Almoço","Box lunch":"Lanche embalada","Dinner":"Jantar","End of our services":"Fim de nossos serviços","Not included":"Não incluído","Flights":"Voos","Emergency contacts":"Contatos de emergência","Emergency":"Emergência","Contacts":"Contatos","Useful information":"Informações úteis","Useful":"Útil","Information":"Informação","Our Representatives":"Nossos Representantes","Address":"Endereço","During Your Trip":"Durante Sua Viagem","Phone Number":"Número de telefone","PROPOSE OF TRAVEL FOR":"Propósito da viagem para","Duration":"Duração","Trip Mode":"Modo de viagem","Conventional":"Convencional","Challenging":"Desafiador","Luxury":"Luxo","Expedition cruising":"Cruzeiro de expedição","Cycling":"Ciclismo","Difficulty":"Dificuldade","Easy":"Fácil","Difficult":"Difícil","Medium":"Médio","Stars":"Estrelas","Price per Person":"Preço por pessoa","Type of service":"Tipo de serviço","Prices include":"Preços incluem","Prices DON\'T include":"Preços não incluem","Based on":"Baseado em","Tel":"Número de telefone","Travel For":"Viagem para","Travel Advisor":"Consultor de Viagens","map":"mapa","Days":"Dias","Nights":"Noites","5 stars":"5 estrelas","4 stars":"4 estrelas","3 stars":"3 estrelas","deluxe":"luxo","lake":"lago","Price":"Preço","per":"por","person":"pessoa","based on":"baseado em","Executive Room":"Quarto Executivo","prices":"preços","not":"não","include":"incluem","terms and conditions":"termos e condições","passengers":"passageiros","not included":"não incluído","our representatives":"nossos representantes","optional service":"serviço opcional","Travel Details":"Detalhes da Viagem","Print":"Imprimir","Terms and Conditions":"Termos e Condições","Services":"Serviços","Description":"Descrição","Hotels":"Hotéis","Date in":"Data de entrada","Date out":"Data de saída","Price per person, per stay":"Preço por pessoa, por estadia","Select Base":"Selecionar Base","Select Room Type":"Selecionar Tipo de Quarto","Total per Person":"Total por Pessoa","Request Reservation":"Solicitar Reserva","Bases (price per person)":"Bases (preço por pessoa)","_Word":"Word","ADT":"Adulto","CHD":"Menor"}');

/***/ }),

/***/ 48914:
/***/ ((module) => {

"use strict";

module.exports = function generate_not(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  if ((it.opts.strictKeywords ? (typeof $schema == 'object' && Object.keys($schema).length > 0) || $schema === false : it.util.schemaHasRules($schema, it.RULES.all))) {
    $it.schema = $schema;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    out += ' var ' + ($errs) + ' = errors;  ';
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    $it.createErrors = false;
    var $allErrorsOption;
    if ($it.opts.allErrors) {
      $allErrorsOption = $it.opts.allErrors;
      $it.opts.allErrors = false;
    }
    out += ' ' + (it.validate($it)) + ' ';
    $it.createErrors = true;
    if ($allErrorsOption) $it.opts.allErrors = $allErrorsOption;
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += ' if (' + ($nextValid) + ') {   ';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('not') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should NOT be valid\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError([' + (__err) + ']); ';
      } else {
        out += ' validate.errors = [' + (__err) + ']; return false; ';
      }
    } else {
      out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    }
    out += ' } else {  errors = ' + ($errs) + '; if (vErrors !== null) { if (' + ($errs) + ') vErrors.length = ' + ($errs) + '; else vErrors = null; } ';
    if (it.opts.allErrors) {
      out += ' } ';
    }
  } else {
    out += '  var err =   '; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('not') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should NOT be valid\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    if ($breakOnError) {
      out += ' if (false) { ';
    }
  }
  return out;
}


/***/ }),

/***/ 49856:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8818);





function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var RoomConfigurationView = /*#__PURE__*/function (_View) {
  function RoomConfigurationView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, RoomConfigurationView);
    return _callSuper(this, RoomConfigurationView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(RoomConfigurationView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(RoomConfigurationView, null, [{
    key: "getTableOptions",
    value: function getTableOptions() {
      return {
        fields: [{
          name: 'RoomTypeId',
          label: 'Type',
          optionLabels: 'Name',
          relation: 'roomtype',
          editor: 'select',
          setRelationTo: 'Room'
        }, {
          name: 'Rooms',
          editor: 'number'
        }]
      };
    }
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_2__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (RoomConfigurationView);

/***/ }),

/***/ 49955:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var View = api.importMixinModule('invoice', 'views', 'argafip');
var InvoiceView = /*#__PURE__*/function (_View) {
  function InvoiceView() {
    _classCallCheck(this, InvoiceView);
    return _callSuper(this, InvoiceView, arguments);
  }
  _inherits(InvoiceView, _View);
  return _createClass(InvoiceView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, invoiceNumber, _iterator, _step, field;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _superPropGet(InvoiceView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              res = _context2.sent;
              invoiceNumber = _.find(res.fields, function (f) {
                return f.name == 'InvoiceNumber';
              });
              invoiceNumber.required = false;
              invoiceNumber.readonly = true;
              res.fields.splice(_.findIndex(res.fields, function (r) {
                return r.name == 'CAE';
              }), 1);
              res.fields.splice(_.findIndex(res.fields, function (r) {
                return r.name == 'Link';
              }), 1);
              res.fields.splice(_.findIndex(res.fields, function (r) {
                return r.name == 'AfipData';
              }), 1);
              res.fields.push({
                name: 'tab1',
                label: 'AFIP',
                editor: 'tab',
                hideFromList: true,
                fields: [{
                  name: 'CAE',
                  label: 'CAE',
                  readonly: true,
                  columns: 4
                },
                //{name: 'Link', label: 'Descargar PDF', editor: 'link', columns: 2},
                {
                  name: 'GetAttach',
                  editor: 'button',
                  label: 'Documento',
                  classes: 'text-center',
                  buttonClick: function () {
                    var _buttonClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(record) {
                      var res;
                      return _regeneratorRuntime().wrap(function _callee$(_context) {
                        while (1) switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return api.get('/arg/api/get_attach/' + record.id, {}, function (err) {
                              //record.addError(err);
                            });
                          case 2:
                            res = _context.sent;
                            if (res) {
                              record.attached.push(res);
                              record.attached = Object.assign([], record.attached);
                            }
                          case 4:
                          case "end":
                            return _context.stop();
                        }
                      }, _callee);
                    }));
                    function buttonClick(_x) {
                      return _buttonClick.apply(this, arguments);
                    }
                    return buttonClick;
                  }()
                }
                //{name: 'AfipData', label: 'Afip Data', readonly: true, columns: 12, editor: 'text-area', rows: 10},
                ]
              });
              res.actions = [{
                label: 'Facturar AFIP',
                method: 'sendAFIP',
                id: 'sendAFIP',
                disabledIf: function disabledIf(r) {
                  return !res.canEdit || r.CAE;
                }
              }];
              _iterator = _createForOfIteratorHelper(res.fields);
              _context2.prev = 12;
              _iterator.s();
            case 14:
              if ((_step = _iterator.n()).done) {
                _context2.next = 23;
                break;
              }
              field = _step.value;
              if (!(field.name == 'tab1')) {
                _context2.next = 18;
                break;
              }
              return _context2.abrupt("continue", 21);
            case 18:
              if (!(field.name == 'InvoiceDetails')) {
                _context2.next = 20;
                break;
              }
              return _context2.abrupt("continue", 21);
            case 20:
              field.headerField = true;
            case 21:
              _context2.next = 14;
              break;
            case 23:
              _context2.next = 28;
              break;
            case 25:
              _context2.prev = 25;
              _context2.t0 = _context2["catch"](12);
              _iterator.e(_context2.t0);
            case 28:
              _context2.prev = 28;
              _iterator.f();
              return _context2.finish(28);
            case 31:
              return _context2.abrupt("return", res);
            case 32:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[12, 25, 28, 31]]);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(View);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InvoiceView);

/***/ }),

/***/ 50304:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),

/***/ 50388:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ _possibleConstructorReturn)
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(82284);
;// ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

;// ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == (0,esm_typeof/* default */.A)(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}


/***/ }),

/***/ 50462:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = (__webpack_require__(92861).Buffer)

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES


/***/ }),

/***/ 50650:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aes = __webpack_require__(50462)
var Buffer = (__webpack_require__(92861).Buffer)
var Transform = __webpack_require__(56168)
var inherits = __webpack_require__(56698)

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher


/***/ }),

/***/ 51069:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 51272:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82284);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);




function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

var Abm = /*#__PURE__*/function () {
  function Abm(_ref) {
    var table = _ref.table,
      endpoint = _ref.endpoint,
      options = _ref.options;
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(this, Abm);
    var self = this;
    return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var o;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            self.table = table;
            self.showClosed = false;
            self.hideActive = false;
            self.serverSide = options.serverSide;
            self.originEndpoint = endpoint;
            self.endpoint = self.getEndpoint();
            self.search = null;
            self.fields = options.fields;
            if (options.fields) {
              _context.next = 13;
              break;
            }
            _context.next = 11;
            return api.getModuleFieldsOptions(table);
          case 11:
            o = _context.sent;
            self.fields = o.fields;
          case 13:
            self.fieldsAbmList = options.fieldsAbmList;
            self.dataList = [];
            self.dataFilter = options.dataFilter;
            self.listValues = {};
            self.hasClosed = self.getHasClosed();
            self.notifications = {
              errors: [],
              message: null,
              warning: null
            };
            self.tableSpec = {};
            self.serverFields = null;
            _context.next = 23;
            return tools.calculateFieldOptions(self.abmFields, self.serverSide, null, true);
          case 23:
            self.fieldOptions = _context.sent;
            self.columnsNames = self.getColumnsNames();
            self.headings = self.getHeadings();
            self.templates = self.getTemplates();
            return _context.abrupt("return", self);
          case 28:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(Abm, [{
    key: "getEndpoint",
    value: function getEndpoint() {
      var endpoint = this.originEndpoint;
      var _char = '?';
      if (endpoint.includes('?')) _char = '&';
      return endpoint + _char + 'IncludeClosed=' + this.showClosed + '&hideActive=' + this.hideActive;
    }
  }, {
    key: "abmFields",
    get: function get() {
      return tools.getAbmFields(this.fields, true);
    }
  }, {
    key: "getHasClosed",
    value: function getHasClosed() {
      var _iterator = _createForOfIteratorHelper(this.fields),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var f = _step.value;
          if (f === 'Closed' || f.name === 'Closed') return true;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return false;
    }
  }, {
    key: "fetchList",
    value: function () {
      var _fetchList = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(tableName, endpoint, filters, refresh) {
        var _this = this;
        var e, list;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              e = endpoint ? endpoint : this.getEndpoint();
              _context2.next = 3;
              return tools.fetchTable(tableName, e, filters, refresh, null, this.showClosed, this.hideActive);
            case 3:
              list = _context2.sent;
              if (list) {
                this.dataList = _.each(_.filter(list, function (r) {
                  if (r.Closed && r.Closed !== undefined && !_this.showClosed) return false;
                  if (!r.Closed && r.Closed !== undefined && _this.hideActive) return false;
                  if (_this.dataFilter) {
                    if (!_this.dataFilter(r)) return false;
                  }
                  return true;
                }), function (c) {
                  c.original_id = c.id;
                });
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchList(_x, _x2, _x3, _x4) {
        return _fetchList.apply(this, arguments);
      }
      return fetchList;
    }()
  }, {
    key: "getValues",
    value: function getValues() {
      this.listValues = {};
      var _iterator2 = _createForOfIteratorHelper(this.abmFields),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var field = _step2.value;
          var _iterator3 = _createForOfIteratorHelper(this.dataList),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var row = _step3.value;
              var r = tools.getDisplayValue(row, field, this.serverSide, this.fieldOptions, true);
              if (!this.listValues[[field.name, row[field.name]]]) {
                this.listValues[[field.name, row[field.name]]] = r;
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "abmList",
    value: function abmList() {
      return tools.abmList(this);
    }
  }, {
    key: "getColumnsNames",
    value: function getColumnsNames() {
      var res = [];
      var _iterator4 = _createForOfIteratorHelper(this.abmFields),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var f = _step4.value;
          if (f.type == 'password') continue;
          if (f.hideFromList) continue;
          if (f.hidden) continue;
          if (f.editor == 'tab') continue;
          //if (f.editor=='button') continue;
          if (f.editor == 'component') continue;
          if ((0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(f.editor) === 'object') continue;
          if (Array.isArray(f.editor)) continue;
          res.push(f.name);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return res;
    }
  }, {
    key: "getHeadings",
    value: function getHeadings() {
      var res = {};
      var _iterator5 = _createForOfIteratorHelper(this.abmFields),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var f = _step5.value;
          if (f.type == 'password') continue;
          if (f.hidden) continue;
          if (f.label) {
            res[f.name] = f.label;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return res;
    }
  }, {
    key: "getTemplates",
    value: function getTemplates() {
      var res = {};
      var self = this;
      var _iterator6 = _createForOfIteratorHelper(this.abmFields),
        _step6;
      try {
        var _loop = function _loop() {
          var field = _step6.value;
          if (field.editor == 'text-area-style') return 1; // continue
          res[field.name] = function (t, row) {
            return tools.getDisplayValue(row, field, self.serverSide, self.fieldOptions, true);
          };
        };
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          if (_loop()) continue;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return res;
    }
  }, {
    key: "requestFunction",
    value: function () {
      var _requestFunction = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(data, callback) {
        var _this2 = this;
        var f, res, dataList;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              f = Object.assign({}, data);
              f.fields = _.filter(this.abmFields, function (r) {
                if (_this2.fieldsAbmList) {
                  return _this2.fieldsAbmList.indexOf(r.name) > -1;
                }
                return _this2.columnsNames.indexOf(r.name) > -1;
              });
              /*return await api.get(this.endpoint, {getCount: true, toJSON: true, IncludeClosed: this.showClosed,
                  data: JSON.stringify(f)}).then((d) => {
                    let dataList = _.each(d.query, (c) => {
                        c.original_id = c.id;
                    })
                    return {data: dataList, count: d.count};
                  }).catch(function(e) {
                    //this.dispatch('error', e);
                  }.bind(this));*/
              callback(true);
              _context3.next = 5;
              return api.get(this.endpoint, {
                getCount: true,
                toJSON: true,
                IncludeClosed: this.showClosed,
                hideActive: this.hideActive,
                data: JSON.stringify(f)
              });
            case 5:
              res = _context3.sent;
              if (!res) {
                _context3.next = 10;
                break;
              }
              dataList = _.each(res.query, function (c) {
                c.original_id = c.id;
              });
              callback(false);
              return _context3.abrupt("return", {
                data: dataList,
                count: res.count
              });
            case 10:
              callback(false);
              return _context3.abrupt("return", {
                data: [],
                count: 0
              });
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function requestFunction(_x5, _x6) {
        return _requestFunction.apply(this, arguments);
      }
      return requestFunction;
    }()
  }]);
}();
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Abm);
window.abm = Abm;

/***/ }),

/***/ 51298:
/***/ ((module) => {

"use strict";

module.exports = function generate__limitProperties(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  if (!($isData || typeof $schema == 'number')) {
    throw new Error($keyword + ' must be number');
  }
  var $op = $keyword == 'maxProperties' ? '>' : '<';
  out += 'if ( ';
  if ($isData) {
    out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
  }
  out += ' Object.keys(' + ($data) + ').length ' + ($op) + ' ' + ($schemaValue) + ') { ';
  var $errorKeyword = $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ($errorKeyword || '_limitProperties') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { limit: ' + ($schemaValue) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should NOT have ';
      if ($keyword == 'maxProperties') {
        out += 'more';
      } else {
        out += 'fewer';
      }
      out += ' than ';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + ($schema);
      }
      out += ' properties\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + ($schema);
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '} ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),

/***/ 51477:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64467);
/* harmony import */ var _base_model_record__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55539);






function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var City = /*#__PURE__*/function (_Record) {
  function City() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, City);
    return _callSuper(this, City, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(City, _Record);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(City, [{
    key: "cityName",
    get: function get() {
      return 'City Name is' + this.Name;
    }
  }, {
    key: "setName",
    value: function setName() {
      this.Latitude = 11;
    }
  }]);
}(_base_model_record__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(City, "moduleName", 'city');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (City);

/***/ }),

/***/ 51873:
/***/ ((module) => {

"use strict";

module.exports = function generate_validate(it, $keyword, $ruleType) {
  var out = '';
  var $async = it.schema.$async === true,
    $refKeywords = it.util.schemaHasRulesExcept(it.schema, it.RULES.all, '$ref'),
    $id = it.self._getId(it.schema);
  if (it.opts.strictKeywords) {
    var $unknownKwd = it.util.schemaUnknownRules(it.schema, it.RULES.keywords);
    if ($unknownKwd) {
      var $keywordsMsg = 'unknown keyword: ' + $unknownKwd;
      if (it.opts.strictKeywords === 'log') it.logger.warn($keywordsMsg);
      else throw new Error($keywordsMsg);
    }
  }
  if (it.isTop) {
    out += ' var validate = ';
    if ($async) {
      it.async = true;
      out += 'async ';
    }
    out += 'function(data, dataPath, parentData, parentDataProperty, rootData) { \'use strict\'; ';
    if ($id && (it.opts.sourceCode || it.opts.processCode)) {
      out += ' ' + ('/\*# sourceURL=' + $id + ' */') + ' ';
    }
  }
  if (typeof it.schema == 'boolean' || !($refKeywords || it.schema.$ref)) {
    var $keyword = 'false schema';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    if (it.schema === false) {
      if (it.isTop) {
        $breakOnError = true;
      } else {
        out += ' var ' + ($valid) + ' = false; ';
      }
      var $$outStack = $$outStack || [];
      $$outStack.push(out);
      out = ''; /* istanbul ignore else */
      if (it.createErrors !== false) {
        out += ' { keyword: \'' + ($errorKeyword || 'false schema') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
        if (it.opts.messages !== false) {
          out += ' , message: \'boolean schema is false\' ';
        }
        if (it.opts.verbose) {
          out += ' , schema: false , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
        }
        out += ' } ';
      } else {
        out += ' {} ';
      }
      var __err = out;
      out = $$outStack.pop();
      if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */
        if (it.async) {
          out += ' throw new ValidationError([' + (__err) + ']); ';
        } else {
          out += ' validate.errors = [' + (__err) + ']; return false; ';
        }
      } else {
        out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
      }
    } else {
      if (it.isTop) {
        if ($async) {
          out += ' return data; ';
        } else {
          out += ' validate.errors = null; return true; ';
        }
      } else {
        out += ' var ' + ($valid) + ' = true; ';
      }
    }
    if (it.isTop) {
      out += ' }; return validate; ';
    }
    return out;
  }
  if (it.isTop) {
    var $top = it.isTop,
      $lvl = it.level = 0,
      $dataLvl = it.dataLevel = 0,
      $data = 'data';
    it.rootId = it.resolve.fullPath(it.self._getId(it.root.schema));
    it.baseId = it.baseId || it.rootId;
    delete it.isTop;
    it.dataPathArr = [""];
    if (it.schema.default !== undefined && it.opts.useDefaults && it.opts.strictDefaults) {
      var $defaultMsg = 'default is ignored in the schema root';
      if (it.opts.strictDefaults === 'log') it.logger.warn($defaultMsg);
      else throw new Error($defaultMsg);
    }
    out += ' var vErrors = null; ';
    out += ' var errors = 0;     ';
    out += ' if (rootData === undefined) rootData = data; ';
  } else {
    var $lvl = it.level,
      $dataLvl = it.dataLevel,
      $data = 'data' + ($dataLvl || '');
    if ($id) it.baseId = it.resolve.url(it.baseId, $id);
    if ($async && !it.async) throw new Error('async schema in sync schema');
    out += ' var errs_' + ($lvl) + ' = errors;';
  }
  var $valid = 'valid' + $lvl,
    $breakOnError = !it.opts.allErrors,
    $closingBraces1 = '',
    $closingBraces2 = '';
  var $errorKeyword;
  var $typeSchema = it.schema.type,
    $typeIsArray = Array.isArray($typeSchema);
  if ($typeSchema && it.opts.nullable && it.schema.nullable === true) {
    if ($typeIsArray) {
      if ($typeSchema.indexOf('null') == -1) $typeSchema = $typeSchema.concat('null');
    } else if ($typeSchema != 'null') {
      $typeSchema = [$typeSchema, 'null'];
      $typeIsArray = true;
    }
  }
  if ($typeIsArray && $typeSchema.length == 1) {
    $typeSchema = $typeSchema[0];
    $typeIsArray = false;
  }
  if (it.schema.$ref && $refKeywords) {
    if (it.opts.extendRefs == 'fail') {
      throw new Error('$ref: validation keywords used in schema at path "' + it.errSchemaPath + '" (see option extendRefs)');
    } else if (it.opts.extendRefs !== true) {
      $refKeywords = false;
      it.logger.warn('$ref: keywords ignored in schema at path "' + it.errSchemaPath + '"');
    }
  }
  if (it.schema.$comment && it.opts.$comment) {
    out += ' ' + (it.RULES.all.$comment.code(it, '$comment'));
  }
  if ($typeSchema) {
    if (it.opts.coerceTypes) {
      var $coerceToTypes = it.util.coerceToTypes(it.opts.coerceTypes, $typeSchema);
    }
    var $rulesGroup = it.RULES.types[$typeSchema];
    if ($coerceToTypes || $typeIsArray || $rulesGroup === true || ($rulesGroup && !$shouldUseGroup($rulesGroup))) {
      var $schemaPath = it.schemaPath + '.type',
        $errSchemaPath = it.errSchemaPath + '/type';
      var $schemaPath = it.schemaPath + '.type',
        $errSchemaPath = it.errSchemaPath + '/type',
        $method = $typeIsArray ? 'checkDataTypes' : 'checkDataType';
      out += ' if (' + (it.util[$method]($typeSchema, $data, it.opts.strictNumbers, true)) + ') { ';
      if ($coerceToTypes) {
        var $dataType = 'dataType' + $lvl,
          $coerced = 'coerced' + $lvl;
        out += ' var ' + ($dataType) + ' = typeof ' + ($data) + '; var ' + ($coerced) + ' = undefined; ';
        if (it.opts.coerceTypes == 'array') {
          out += ' if (' + ($dataType) + ' == \'object\' && Array.isArray(' + ($data) + ') && ' + ($data) + '.length == 1) { ' + ($data) + ' = ' + ($data) + '[0]; ' + ($dataType) + ' = typeof ' + ($data) + '; if (' + (it.util.checkDataType(it.schema.type, $data, it.opts.strictNumbers)) + ') ' + ($coerced) + ' = ' + ($data) + '; } ';
        }
        out += ' if (' + ($coerced) + ' !== undefined) ; ';
        var arr1 = $coerceToTypes;
        if (arr1) {
          var $type, $i = -1,
            l1 = arr1.length - 1;
          while ($i < l1) {
            $type = arr1[$i += 1];
            if ($type == 'string') {
              out += ' else if (' + ($dataType) + ' == \'number\' || ' + ($dataType) + ' == \'boolean\') ' + ($coerced) + ' = \'\' + ' + ($data) + '; else if (' + ($data) + ' === null) ' + ($coerced) + ' = \'\'; ';
            } else if ($type == 'number' || $type == 'integer') {
              out += ' else if (' + ($dataType) + ' == \'boolean\' || ' + ($data) + ' === null || (' + ($dataType) + ' == \'string\' && ' + ($data) + ' && ' + ($data) + ' == +' + ($data) + ' ';
              if ($type == 'integer') {
                out += ' && !(' + ($data) + ' % 1)';
              }
              out += ')) ' + ($coerced) + ' = +' + ($data) + '; ';
            } else if ($type == 'boolean') {
              out += ' else if (' + ($data) + ' === \'false\' || ' + ($data) + ' === 0 || ' + ($data) + ' === null) ' + ($coerced) + ' = false; else if (' + ($data) + ' === \'true\' || ' + ($data) + ' === 1) ' + ($coerced) + ' = true; ';
            } else if ($type == 'null') {
              out += ' else if (' + ($data) + ' === \'\' || ' + ($data) + ' === 0 || ' + ($data) + ' === false) ' + ($coerced) + ' = null; ';
            } else if (it.opts.coerceTypes == 'array' && $type == 'array') {
              out += ' else if (' + ($dataType) + ' == \'string\' || ' + ($dataType) + ' == \'number\' || ' + ($dataType) + ' == \'boolean\' || ' + ($data) + ' == null) ' + ($coerced) + ' = [' + ($data) + ']; ';
            }
          }
        }
        out += ' else {   ';
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { type: \'';
          if ($typeIsArray) {
            out += '' + ($typeSchema.join(","));
          } else {
            out += '' + ($typeSchema);
          }
          out += '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'should be ';
            if ($typeIsArray) {
              out += '' + ($typeSchema.join(","));
            } else {
              out += '' + ($typeSchema);
            }
            out += '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
        out += ' } if (' + ($coerced) + ' !== undefined) {  ';
        var $parentData = $dataLvl ? 'data' + (($dataLvl - 1) || '') : 'parentData',
          $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
        out += ' ' + ($data) + ' = ' + ($coerced) + '; ';
        if (!$dataLvl) {
          out += 'if (' + ($parentData) + ' !== undefined)';
        }
        out += ' ' + ($parentData) + '[' + ($parentDataProperty) + '] = ' + ($coerced) + '; } ';
      } else {
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { type: \'';
          if ($typeIsArray) {
            out += '' + ($typeSchema.join(","));
          } else {
            out += '' + ($typeSchema);
          }
          out += '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'should be ';
            if ($typeIsArray) {
              out += '' + ($typeSchema.join(","));
            } else {
              out += '' + ($typeSchema);
            }
            out += '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
      }
      out += ' } ';
    }
  }
  if (it.schema.$ref && !$refKeywords) {
    out += ' ' + (it.RULES.all.$ref.code(it, '$ref')) + ' ';
    if ($breakOnError) {
      out += ' } if (errors === ';
      if ($top) {
        out += '0';
      } else {
        out += 'errs_' + ($lvl);
      }
      out += ') { ';
      $closingBraces2 += '}';
    }
  } else {
    var arr2 = it.RULES;
    if (arr2) {
      var $rulesGroup, i2 = -1,
        l2 = arr2.length - 1;
      while (i2 < l2) {
        $rulesGroup = arr2[i2 += 1];
        if ($shouldUseGroup($rulesGroup)) {
          if ($rulesGroup.type) {
            out += ' if (' + (it.util.checkDataType($rulesGroup.type, $data, it.opts.strictNumbers)) + ') { ';
          }
          if (it.opts.useDefaults) {
            if ($rulesGroup.type == 'object' && it.schema.properties) {
              var $schema = it.schema.properties,
                $schemaKeys = Object.keys($schema);
              var arr3 = $schemaKeys;
              if (arr3) {
                var $propertyKey, i3 = -1,
                  l3 = arr3.length - 1;
                while (i3 < l3) {
                  $propertyKey = arr3[i3 += 1];
                  var $sch = $schema[$propertyKey];
                  if ($sch.default !== undefined) {
                    var $passData = $data + it.util.getProperty($propertyKey);
                    if (it.compositeRule) {
                      if (it.opts.strictDefaults) {
                        var $defaultMsg = 'default is ignored for: ' + $passData;
                        if (it.opts.strictDefaults === 'log') it.logger.warn($defaultMsg);
                        else throw new Error($defaultMsg);
                      }
                    } else {
                      out += ' if (' + ($passData) + ' === undefined ';
                      if (it.opts.useDefaults == 'empty') {
                        out += ' || ' + ($passData) + ' === null || ' + ($passData) + ' === \'\' ';
                      }
                      out += ' ) ' + ($passData) + ' = ';
                      if (it.opts.useDefaults == 'shared') {
                        out += ' ' + (it.useDefault($sch.default)) + ' ';
                      } else {
                        out += ' ' + (JSON.stringify($sch.default)) + ' ';
                      }
                      out += '; ';
                    }
                  }
                }
              }
            } else if ($rulesGroup.type == 'array' && Array.isArray(it.schema.items)) {
              var arr4 = it.schema.items;
              if (arr4) {
                var $sch, $i = -1,
                  l4 = arr4.length - 1;
                while ($i < l4) {
                  $sch = arr4[$i += 1];
                  if ($sch.default !== undefined) {
                    var $passData = $data + '[' + $i + ']';
                    if (it.compositeRule) {
                      if (it.opts.strictDefaults) {
                        var $defaultMsg = 'default is ignored for: ' + $passData;
                        if (it.opts.strictDefaults === 'log') it.logger.warn($defaultMsg);
                        else throw new Error($defaultMsg);
                      }
                    } else {
                      out += ' if (' + ($passData) + ' === undefined ';
                      if (it.opts.useDefaults == 'empty') {
                        out += ' || ' + ($passData) + ' === null || ' + ($passData) + ' === \'\' ';
                      }
                      out += ' ) ' + ($passData) + ' = ';
                      if (it.opts.useDefaults == 'shared') {
                        out += ' ' + (it.useDefault($sch.default)) + ' ';
                      } else {
                        out += ' ' + (JSON.stringify($sch.default)) + ' ';
                      }
                      out += '; ';
                    }
                  }
                }
              }
            }
          }
          var arr5 = $rulesGroup.rules;
          if (arr5) {
            var $rule, i5 = -1,
              l5 = arr5.length - 1;
            while (i5 < l5) {
              $rule = arr5[i5 += 1];
              if ($shouldUseRule($rule)) {
                var $code = $rule.code(it, $rule.keyword, $rulesGroup.type);
                if ($code) {
                  out += ' ' + ($code) + ' ';
                  if ($breakOnError) {
                    $closingBraces1 += '}';
                  }
                }
              }
            }
          }
          if ($breakOnError) {
            out += ' ' + ($closingBraces1) + ' ';
            $closingBraces1 = '';
          }
          if ($rulesGroup.type) {
            out += ' } ';
            if ($typeSchema && $typeSchema === $rulesGroup.type && !$coerceToTypes) {
              out += ' else { ';
              var $schemaPath = it.schemaPath + '.type',
                $errSchemaPath = it.errSchemaPath + '/type';
              var $$outStack = $$outStack || [];
              $$outStack.push(out);
              out = ''; /* istanbul ignore else */
              if (it.createErrors !== false) {
                out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { type: \'';
                if ($typeIsArray) {
                  out += '' + ($typeSchema.join(","));
                } else {
                  out += '' + ($typeSchema);
                }
                out += '\' } ';
                if (it.opts.messages !== false) {
                  out += ' , message: \'should be ';
                  if ($typeIsArray) {
                    out += '' + ($typeSchema.join(","));
                  } else {
                    out += '' + ($typeSchema);
                  }
                  out += '\' ';
                }
                if (it.opts.verbose) {
                  out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
                }
                out += ' } ';
              } else {
                out += ' {} ';
              }
              var __err = out;
              out = $$outStack.pop();
              if (!it.compositeRule && $breakOnError) {
                /* istanbul ignore if */
                if (it.async) {
                  out += ' throw new ValidationError([' + (__err) + ']); ';
                } else {
                  out += ' validate.errors = [' + (__err) + ']; return false; ';
                }
              } else {
                out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
              }
              out += ' } ';
            }
          }
          if ($breakOnError) {
            out += ' if (errors === ';
            if ($top) {
              out += '0';
            } else {
              out += 'errs_' + ($lvl);
            }
            out += ') { ';
            $closingBraces2 += '}';
          }
        }
      }
    }
  }
  if ($breakOnError) {
    out += ' ' + ($closingBraces2) + ' ';
  }
  if ($top) {
    if ($async) {
      out += ' if (errors === 0) return data;           ';
      out += ' else throw new ValidationError(vErrors); ';
    } else {
      out += ' validate.errors = vErrors; ';
      out += ' return errors === 0;       ';
    }
    out += ' }; return validate;';
  } else {
    out += ' var ' + ($valid) + ' = errors === errs_' + ($lvl) + ';';
  }

  function $shouldUseGroup($rulesGroup) {
    var rules = $rulesGroup.rules;
    for (var i = 0; i < rules.length; i++)
      if ($shouldUseRule(rules[i])) return true;
  }

  function $shouldUseRule($rule) {
    return it.schema[$rule.keyword] !== undefined || ($rule.implements && $ruleImplementsSomeKeyword($rule));
  }

  function $ruleImplementsSomeKeyword($rule) {
    var impl = $rule.implements;
    for (var i = 0; i < impl.length; i++)
      if (it.schema[impl[i]] !== undefined) return true;
  }
  return out;
}


/***/ }),

/***/ 51941:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_base_model__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42675);









function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var BookingBaseModel = /*#__PURE__*/function (_BaseModel) {
  function BookingBaseModel() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, BookingBaseModel);
    return _callSuper(this, BookingBaseModel, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingBaseModel, _BaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(BookingBaseModel, [{
    key: "clearBookingCache",
    value: function clearBookingCache() {
      if (this.booking && this.booking._cache) {
        var _iterator = _createForOfIteratorHelper(this.constructor.invalidated_cache),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var cache = _step.value;
            this.booking._cache[cache] = false;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "setValue",
    value: function () {
      var _setValue = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_ref) {
        var fieldName, value;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              fieldName = _ref.fieldName, value = _ref.value;
              _context.next = 3;
              return _superPropGet(BookingBaseModel, "setValue", this, 3)([{
                fieldName: fieldName,
                value: value
              }]);
            case 3:
              if (this._loaded) {
                this.clearBookingCache();
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function setValue(_x) {
        return _setValue.apply(this, arguments);
      }
      return setValue;
    }()
  }, {
    key: "afterEditRow",
    value: function () {
      var _afterEditRow = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(field) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _superPropGet(BookingBaseModel, "afterEditRow", this, 3)([field]);
            case 2:
              if (this._loaded) {
                this.clearBookingCache();
              }
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function afterEditRow(_x2) {
        return _afterEditRow.apply(this, arguments);
      }
      return afterEditRow;
    }()
  }, {
    key: "booking",
    get: function get() {
      return this.$parent;
    }
  }]);
}(_base_model_base_model__WEBPACK_IMPORTED_MODULE_4__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(BookingBaseModel, "invalidated_cache", ['totals', 'totalsServices', 'totalsHotels', 'quoted', 'totalByPaxVariantId', 'baseTotalsHotels', 'totalByPaxGroup']);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(BookingBaseModel, "invalidated_cache_hotels", ['totals', 'totalsHotels', 'quoted', 'totalByPaxVariantId', 'baseTotalsHotels', 'totalByPaxGroup']);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(BookingBaseModel, "invalidated_cache_services", ['totals', 'totalsServices', 'quoted', 'totalByPaxVariantId', 'baseTotalsHotels', 'totalByPaxGroup']);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingBaseModel);

/***/ }),

/***/ 52061:
/***/ ((module) => {

module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}


/***/ }),

/***/ 52119:
/***/ ((module) => {

"use strict";

module.exports = function generate__limitItems(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  if (!($isData || typeof $schema == 'number')) {
    throw new Error($keyword + ' must be number');
  }
  var $op = $keyword == 'maxItems' ? '>' : '<';
  out += 'if ( ';
  if ($isData) {
    out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
  }
  out += ' ' + ($data) + '.length ' + ($op) + ' ' + ($schemaValue) + ') { ';
  var $errorKeyword = $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ($errorKeyword || '_limitItems') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { limit: ' + ($schemaValue) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should NOT have ';
      if ($keyword == 'maxItems') {
        out += 'more';
      } else {
        out += 'fewer';
      }
      out += ' than ';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + ($schema);
      }
      out += ' items\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + ($schema);
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '} ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),

/***/ 52244:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var bn = __webpack_require__(61158);
var brorand = __webpack_require__(15037);

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),

/***/ 52309:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('[{"id":4,"alpha2":"af","alpha3":"afg","name":"Afeganistão"},{"id":710,"alpha2":"za","alpha3":"zaf","name":"África do Sul"},{"id":248,"alpha2":"ax","alpha3":"ala","name":"Ilhas Åland"},{"id":8,"alpha2":"al","alpha3":"alb","name":"Albânia"},{"id":276,"alpha2":"de","alpha3":"deu","name":"Alemanha"},{"id":20,"alpha2":"ad","alpha3":"and","name":"Andorra"},{"id":24,"alpha2":"ao","alpha3":"ago","name":"Angola"},{"id":660,"alpha2":"ai","alpha3":"aia","name":"Anguila"},{"id":10,"alpha2":"aq","alpha3":"ata","name":"Antártida"},{"id":28,"alpha2":"ag","alpha3":"atg","name":"Antígua e Barbuda"},{"id":682,"alpha2":"sa","alpha3":"sau","name":"Arábia Saudita"},{"id":12,"alpha2":"dz","alpha3":"dza","name":"Argélia"},{"id":32,"alpha2":"ar","alpha3":"arg","name":"Argentina"},{"id":51,"alpha2":"am","alpha3":"arm","name":"Armênia"},{"id":533,"alpha2":"aw","alpha3":"abw","name":"Aruba"},{"id":36,"alpha2":"au","alpha3":"aus","name":"Austrália"},{"id":40,"alpha2":"at","alpha3":"aut","name":"Áustria"},{"id":31,"alpha2":"az","alpha3":"aze","name":"Azerbaijão"},{"id":44,"alpha2":"bs","alpha3":"bhs","name":"Bahamas"},{"id":50,"alpha2":"bd","alpha3":"bgd","name":"Bangladexe"},{"id":52,"alpha2":"bb","alpha3":"brb","name":"Barbados"},{"id":48,"alpha2":"bh","alpha3":"bhr","name":"Barém"},{"id":56,"alpha2":"be","alpha3":"bel","name":"Bélgica"},{"id":84,"alpha2":"bz","alpha3":"blz","name":"Belize"},{"id":204,"alpha2":"bj","alpha3":"ben","name":"Benim"},{"id":60,"alpha2":"bm","alpha3":"bmu","name":"Bermudas"},{"id":112,"alpha2":"by","alpha3":"blr","name":"Bielorrússia"},{"id":68,"alpha2":"bo","alpha3":"bol","name":"Bolívia"},{"id":535,"alpha2":"bq","alpha3":"bes","name":"Países Baixos Caribenhos"},{"id":70,"alpha2":"ba","alpha3":"bih","name":"Bósnia e Herzegovina"},{"id":72,"alpha2":"bw","alpha3":"bwa","name":"Botsuana"},{"id":74,"alpha2":"bv","alpha3":"bvt","name":"Ilha Bouvet"},{"id":76,"alpha2":"br","alpha3":"bra","name":"Brasil"},{"id":96,"alpha2":"bn","alpha3":"brn","name":"Brunei"},{"id":100,"alpha2":"bg","alpha3":"bgr","name":"Bulgária"},{"id":854,"alpha2":"bf","alpha3":"bfa","name":"Burquina Fasso"},{"id":108,"alpha2":"bi","alpha3":"bdi","name":"Burundi"},{"id":64,"alpha2":"bt","alpha3":"btn","name":"Butão"},{"id":132,"alpha2":"cv","alpha3":"cpv","name":"Cabo Verde"},{"id":136,"alpha2":"ky","alpha3":"cym","name":"Ilhas Caimã"},{"id":116,"alpha2":"kh","alpha3":"khm","name":"Camboja"},{"id":120,"alpha2":"cm","alpha3":"cmr","name":"Camarões"},{"id":124,"alpha2":"ca","alpha3":"can","name":"Canadá"},{"id":634,"alpha2":"qa","alpha3":"qat","name":"Catar"},{"id":398,"alpha2":"kz","alpha3":"kaz","name":"Cazaquistão"},{"id":140,"alpha2":"cf","alpha3":"caf","name":"República Centro-Africana"},{"id":148,"alpha2":"td","alpha3":"tcd","name":"Chade"},{"id":203,"alpha2":"cz","alpha3":"cze","name":"Chéquia"},{"id":152,"alpha2":"cl","alpha3":"chl","name":"Chile"},{"id":156,"alpha2":"cn","alpha3":"chn","name":"China"},{"id":196,"alpha2":"cy","alpha3":"cyp","name":"Chipre"},{"id":166,"alpha2":"cc","alpha3":"cck","name":"Ilhas Cocos (Keeling)"},{"id":170,"alpha2":"co","alpha3":"col","name":"Colômbia"},{"id":174,"alpha2":"km","alpha3":"com","name":"Comores"},{"id":178,"alpha2":"cg","alpha3":"cog","name":"República do Congo"},{"id":180,"alpha2":"cd","alpha3":"cod","name":"República Democrática do Congo"},{"id":184,"alpha2":"ck","alpha3":"cok","name":"Ilhas Cook"},{"id":410,"alpha2":"kr","alpha3":"kor","name":"Coreia do Sul"},{"id":408,"alpha2":"kp","alpha3":"prk","name":"Coreia do Norte"},{"id":384,"alpha2":"ci","alpha3":"civ","name":"Costa do Marfim"},{"id":188,"alpha2":"cr","alpha3":"cri","name":"Costa Rica"},{"id":191,"alpha2":"hr","alpha3":"hrv","name":"Croácia"},{"id":192,"alpha2":"cu","alpha3":"cub","name":"Cuba"},{"id":531,"alpha2":"cw","alpha3":"cuw","name":"Curaçau"},{"id":208,"alpha2":"dk","alpha3":"dnk","name":"Dinamarca"},{"id":262,"alpha2":"dj","alpha3":"dji","name":"Djibuti"},{"id":212,"alpha2":"dm","alpha3":"dma","name":"Dominica"},{"id":214,"alpha2":"do","alpha3":"dom","name":"República Dominicana"},{"id":818,"alpha2":"eg","alpha3":"egy","name":"Egito"},{"id":222,"alpha2":"sv","alpha3":"slv","name":"El Salvador"},{"id":784,"alpha2":"ae","alpha3":"are","name":"Emirados Árabes Unidos"},{"id":218,"alpha2":"ec","alpha3":"ecu","name":"Equador"},{"id":232,"alpha2":"er","alpha3":"eri","name":"Eritreia"},{"id":703,"alpha2":"sk","alpha3":"svk","name":"Eslováquia"},{"id":705,"alpha2":"si","alpha3":"svn","name":"Eslovênia"},{"id":724,"alpha2":"es","alpha3":"esp","name":"Espanha"},{"id":840,"alpha2":"us","alpha3":"usa","name":"Estados Unidos"},{"id":233,"alpha2":"ee","alpha3":"est","name":"Estónia"},{"id":748,"alpha2":"sz","alpha3":"swz","name":"Essuatíni"},{"id":744,"alpha2":"sj","alpha3":"sjm","name":"Esvalbarde e Jan Mayen"},{"id":231,"alpha2":"et","alpha3":"eth","name":"Etiópia"},{"id":234,"alpha2":"fo","alpha3":"fro","name":"Ilhas Feroé"},{"id":242,"alpha2":"fj","alpha3":"fji","name":"Fiji"},{"id":608,"alpha2":"ph","alpha3":"phl","name":"Filipinas"},{"id":246,"alpha2":"fi","alpha3":"fin","name":"Finlândia"},{"id":250,"alpha2":"fr","alpha3":"fra","name":"França"},{"id":266,"alpha2":"ga","alpha3":"gab","name":"Gabão"},{"id":270,"alpha2":"gm","alpha3":"gmb","name":"Gâmbia"},{"id":288,"alpha2":"gh","alpha3":"gha","name":"Gana"},{"id":268,"alpha2":"ge","alpha3":"geo","name":"Geórgia"},{"id":239,"alpha2":"gs","alpha3":"sgs","name":"Ilhas Geórgia do Sul e Sandwich do Sul"},{"id":292,"alpha2":"gi","alpha3":"gib","name":"Gibraltar"},{"id":308,"alpha2":"gd","alpha3":"grd","name":"Granada"},{"id":300,"alpha2":"gr","alpha3":"grc","name":"Grécia"},{"id":304,"alpha2":"gl","alpha3":"grl","name":"Gronelândia"},{"id":312,"alpha2":"gp","alpha3":"glp","name":"Guadalupe"},{"id":316,"alpha2":"gu","alpha3":"gum","name":"Guam"},{"id":320,"alpha2":"gt","alpha3":"gtm","name":"Guatemala"},{"id":831,"alpha2":"gg","alpha3":"ggy","name":"Guernsey"},{"id":328,"alpha2":"gy","alpha3":"guy","name":"Guiana"},{"id":254,"alpha2":"gf","alpha3":"guf","name":"Guiana Francesa"},{"id":624,"alpha2":"gw","alpha3":"gnb","name":"Guiné-Bissau"},{"id":324,"alpha2":"gn","alpha3":"gin","name":"Guiné"},{"id":226,"alpha2":"gq","alpha3":"gnq","name":"Guiné Equatorial"},{"id":332,"alpha2":"ht","alpha3":"hti","name":"Haiti"},{"id":334,"alpha2":"hm","alpha3":"hmd","name":"Ilha Heard e Ilhas McDonald"},{"id":340,"alpha2":"hn","alpha3":"hnd","name":"Honduras"},{"id":344,"alpha2":"hk","alpha3":"hkg","name":"Hong Kong"},{"id":348,"alpha2":"hu","alpha3":"hun","name":"Hungria"},{"id":887,"alpha2":"ye","alpha3":"yem","name":"Iêmen"},{"id":356,"alpha2":"in","alpha3":"ind","name":"Índia"},{"id":360,"alpha2":"id","alpha3":"idn","name":"Indonésia"},{"id":368,"alpha2":"iq","alpha3":"irq","name":"Iraque"},{"id":364,"alpha2":"ir","alpha3":"irn","name":"Irã"},{"id":372,"alpha2":"ie","alpha3":"irl","name":"Irlanda"},{"id":352,"alpha2":"is","alpha3":"isl","name":"Islândia"},{"id":376,"alpha2":"il","alpha3":"isr","name":"Israel"},{"id":380,"alpha2":"it","alpha3":"ita","name":"Itália"},{"id":388,"alpha2":"jm","alpha3":"jam","name":"Jamaica"},{"id":392,"alpha2":"jp","alpha3":"jpn","name":"Japão"},{"id":832,"alpha2":"je","alpha3":"jey","name":"Jersey"},{"id":400,"alpha2":"jo","alpha3":"jor","name":"Jordânia"},{"id":414,"alpha2":"kw","alpha3":"kwt","name":"Kuwait"},{"id":418,"alpha2":"la","alpha3":"lao","name":"Laos"},{"id":426,"alpha2":"ls","alpha3":"lso","name":"Lesoto"},{"id":428,"alpha2":"lv","alpha3":"lva","name":"Letônia"},{"id":422,"alpha2":"lb","alpha3":"lbn","name":"Líbano"},{"id":430,"alpha2":"lr","alpha3":"lbr","name":"Libéria"},{"id":434,"alpha2":"ly","alpha3":"lby","name":"Líbia"},{"id":438,"alpha2":"li","alpha3":"lie","name":"Listenstaine"},{"id":440,"alpha2":"lt","alpha3":"ltu","name":"Lituânia"},{"id":442,"alpha2":"lu","alpha3":"lux","name":"Luxemburgo"},{"id":446,"alpha2":"mo","alpha3":"mac","name":"Macau"},{"id":807,"alpha2":"mk","alpha3":"mkd","name":"Macedônia do Norte"},{"id":450,"alpha2":"mg","alpha3":"mdg","name":"Madagáscar"},{"id":175,"alpha2":"yt","alpha3":"myt","name":"Maiote"},{"id":458,"alpha2":"my","alpha3":"mys","name":"Malásia"},{"id":454,"alpha2":"mw","alpha3":"mwi","name":"Maláui"},{"id":462,"alpha2":"mv","alpha3":"mdv","name":"Maldivas"},{"id":466,"alpha2":"ml","alpha3":"mli","name":"Mali"},{"id":470,"alpha2":"mt","alpha3":"mlt","name":"Malta"},{"id":238,"alpha2":"fk","alpha3":"flk","name":"Ilhas Malvinas"},{"id":833,"alpha2":"im","alpha3":"imn","name":"Ilha de Man"},{"id":580,"alpha2":"mp","alpha3":"mnp","name":"Marianas Setentrionais"},{"id":504,"alpha2":"ma","alpha3":"mar","name":"Marrocos"},{"id":584,"alpha2":"mh","alpha3":"mhl","name":"Ilhas Marshall"},{"id":474,"alpha2":"mq","alpha3":"mtq","name":"Martinica"},{"id":480,"alpha2":"mu","alpha3":"mus","name":"Ilhas Maurícias"},{"id":478,"alpha2":"mr","alpha3":"mrt","name":"Mauritânia"},{"id":581,"alpha2":"um","alpha3":"umi","name":"Ilhas Menores Distantes dos Estados Unidos"},{"id":484,"alpha2":"mx","alpha3":"mex","name":"México"},{"id":104,"alpha2":"mm","alpha3":"mmr","name":"Mianmar"},{"id":583,"alpha2":"fm","alpha3":"fsm","name":"Estados Federados da Micronésia"},{"id":508,"alpha2":"mz","alpha3":"moz","name":"Moçambique"},{"id":498,"alpha2":"md","alpha3":"mda","name":"Moldávia"},{"id":492,"alpha2":"mc","alpha3":"mco","name":"Mónaco"},{"id":496,"alpha2":"mn","alpha3":"mng","name":"Mongólia"},{"id":500,"alpha2":"ms","alpha3":"msr","name":"Monserrate"},{"id":499,"alpha2":"me","alpha3":"mne","name":"Montenegro"},{"id":516,"alpha2":"na","alpha3":"nam","name":"Namíbia"},{"id":162,"alpha2":"cx","alpha3":"cxr","name":"Ilha do Natal"},{"id":520,"alpha2":"nr","alpha3":"nru","name":"Nauru"},{"id":524,"alpha2":"np","alpha3":"npl","name":"Nepal"},{"id":558,"alpha2":"ni","alpha3":"nic","name":"Nicarágua"},{"id":562,"alpha2":"ne","alpha3":"ner","name":"Níger"},{"id":566,"alpha2":"ng","alpha3":"nga","name":"Nigéria"},{"id":570,"alpha2":"nu","alpha3":"niu","name":"Niue"},{"id":574,"alpha2":"nf","alpha3":"nfk","name":"Ilha Norfolk"},{"id":578,"alpha2":"no","alpha3":"nor","name":"Noruega"},{"id":540,"alpha2":"nc","alpha3":"ncl","name":"Nova Caledónia"},{"id":554,"alpha2":"nz","alpha3":"nzl","name":"Nova Zelândia"},{"id":512,"alpha2":"om","alpha3":"omn","name":"Omã"},{"id":528,"alpha2":"nl","alpha3":"nld","name":"Países Baixos"},{"id":585,"alpha2":"pw","alpha3":"plw","name":"Palau"},{"id":275,"alpha2":"ps","alpha3":"pse","name":"Palestina"},{"id":591,"alpha2":"pa","alpha3":"pan","name":"Panamá"},{"id":598,"alpha2":"pg","alpha3":"png","name":"Papua-Nova Guiné"},{"id":586,"alpha2":"pk","alpha3":"pak","name":"Paquistão"},{"id":600,"alpha2":"py","alpha3":"pry","name":"Paraguai"},{"id":604,"alpha2":"pe","alpha3":"per","name":"Peru"},{"id":612,"alpha2":"pn","alpha3":"pcn","name":"Pitcairn"},{"id":258,"alpha2":"pf","alpha3":"pyf","name":"Polinésia Francesa"},{"id":616,"alpha2":"pl","alpha3":"pol","name":"Polónia"},{"id":630,"alpha2":"pr","alpha3":"pri","name":"Porto Rico"},{"id":620,"alpha2":"pt","alpha3":"prt","name":"Portugal"},{"id":404,"alpha2":"ke","alpha3":"ken","name":"Quênia"},{"id":417,"alpha2":"kg","alpha3":"kgz","name":"Quirguistão"},{"id":296,"alpha2":"ki","alpha3":"kir","name":"Quiribáti"},{"id":826,"alpha2":"gb","alpha3":"gbr","name":"Reino Unido"},{"id":638,"alpha2":"re","alpha3":"reu","name":"Reunião"},{"id":642,"alpha2":"ro","alpha3":"rou","name":"Roménia"},{"id":646,"alpha2":"rw","alpha3":"rwa","name":"Ruanda"},{"id":643,"alpha2":"ru","alpha3":"rus","name":"Rússia"},{"id":732,"alpha2":"eh","alpha3":"esh","name":"Saara Ocidental"},{"id":16,"alpha2":"as","alpha3":"asm","name":"Samoa Americana"},{"id":882,"alpha2":"ws","alpha3":"wsm","name":"Samoa"},{"id":90,"alpha2":"sb","alpha3":"slb","name":"Ilhas Salomão"},{"id":674,"alpha2":"sm","alpha3":"smr","name":"San Marino"},{"id":654,"alpha2":"sh","alpha3":"shn","name":"Santa Helena, Ascensão e Tristão da Cunha"},{"id":662,"alpha2":"lc","alpha3":"lca","name":"Santa Lúcia"},{"id":652,"alpha2":"bl","alpha3":"blm","name":"São Bartolomeu"},{"id":659,"alpha2":"kn","alpha3":"kna","name":"São Cristóvão e Neves"},{"id":663,"alpha2":"mf","alpha3":"maf","name":"São Martinho"},{"id":534,"alpha2":"sx","alpha3":"sxm","name":"São Martinho"},{"id":666,"alpha2":"pm","alpha3":"spm","name":"São Pedro e Miquelão"},{"id":678,"alpha2":"st","alpha3":"stp","name":"São Tomé e Príncipe"},{"id":670,"alpha2":"vc","alpha3":"vct","name":"São Vicente e Granadinas"},{"id":690,"alpha2":"sc","alpha3":"syc","name":"Seicheles"},{"id":686,"alpha2":"sn","alpha3":"sen","name":"Senegal"},{"id":144,"alpha2":"lk","alpha3":"lka","name":"Seri Lanca"},{"id":694,"alpha2":"sl","alpha3":"sle","name":"Serra Leoa"},{"id":688,"alpha2":"rs","alpha3":"srb","name":"Sérvia"},{"id":702,"alpha2":"sg","alpha3":"sgp","name":"Singapura"},{"id":760,"alpha2":"sy","alpha3":"syr","name":"Síria"},{"id":706,"alpha2":"so","alpha3":"som","name":"Somália"},{"id":729,"alpha2":"sd","alpha3":"sdn","name":"Sudão"},{"id":728,"alpha2":"ss","alpha3":"ssd","name":"Sudão do Sul"},{"id":752,"alpha2":"se","alpha3":"swe","name":"Suécia"},{"id":756,"alpha2":"ch","alpha3":"che","name":"Suíça"},{"id":740,"alpha2":"sr","alpha3":"sur","name":"Suriname"},{"id":764,"alpha2":"th","alpha3":"tha","name":"Tailândia"},{"id":158,"alpha2":"tw","alpha3":"twn","name":"Taiwan"},{"id":762,"alpha2":"tj","alpha3":"tjk","name":"Tajiquistão"},{"id":834,"alpha2":"tz","alpha3":"tza","name":"Tanzânia"},{"id":260,"alpha2":"tf","alpha3":"atf","name":"Terras Austrais e Antárticas Francesas"},{"id":86,"alpha2":"io","alpha3":"iot","name":"Território Britânico do Oceano Índico"},{"id":626,"alpha2":"tl","alpha3":"tls","name":"Timor-Leste"},{"id":768,"alpha2":"tg","alpha3":"tgo","name":"Togo"},{"id":776,"alpha2":"to","alpha3":"ton","name":"Tonga"},{"id":772,"alpha2":"tk","alpha3":"tkl","name":"Toquelau"},{"id":780,"alpha2":"tt","alpha3":"tto","name":"Trinidad e Tobago"},{"id":788,"alpha2":"tn","alpha3":"tun","name":"Tunísia"},{"id":796,"alpha2":"tc","alpha3":"tca","name":"Turcas e Caicos"},{"id":795,"alpha2":"tm","alpha3":"tkm","name":"Turcomenistão"},{"id":792,"alpha2":"tr","alpha3":"tur","name":"Turquia"},{"id":798,"alpha2":"tv","alpha3":"tuv","name":"Tuvalu"},{"id":804,"alpha2":"ua","alpha3":"ukr","name":"Ucrânia"},{"id":800,"alpha2":"ug","alpha3":"uga","name":"Uganda"},{"id":858,"alpha2":"uy","alpha3":"ury","name":"Uruguai"},{"id":860,"alpha2":"uz","alpha3":"uzb","name":"Uzbequistão"},{"id":548,"alpha2":"vu","alpha3":"vut","name":"Vanuatu"},{"id":336,"alpha2":"va","alpha3":"vat","name":"Vaticano"},{"id":862,"alpha2":"ve","alpha3":"ven","name":"Venezuela"},{"id":704,"alpha2":"vn","alpha3":"vnm","name":"Vietname"},{"id":850,"alpha2":"vi","alpha3":"vir","name":"Ilhas Virgens Americanas"},{"id":92,"alpha2":"vg","alpha3":"vgb","name":"Ilhas Virgens Britânicas"},{"id":876,"alpha2":"wf","alpha3":"wlf","name":"Wallis e Futuna"},{"id":894,"alpha2":"zm","alpha3":"zmb","name":"Zâmbia"},{"id":716,"alpha2":"zw","alpha3":"zwe","name":"Zimbábue"}]');

/***/ }),

/***/ 52477:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays:
            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


/***/ }),

/***/ 52587:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d:\d\d)?$/i;
var DATE_TIME_SEPARATOR = /t|\s/i;

var COMPARE_FORMATS = {
  date: compareDate,
  time: compareTime,
  'date-time': compareDateTime
};

var $dataMetaSchema = {
  type: 'object',
  required: [ '$data' ],
  properties: {
    $data: {
      type: 'string',
      anyOf: [
        { format: 'relative-json-pointer' },
        { format: 'json-pointer' }
      ]
    }
  },
  additionalProperties: false
};

module.exports = function (minMax) {
  var keyword = 'format' + minMax;
  return function defFunc(ajv) {
    defFunc.definition = {
      type: 'string',
      inline: __webpack_require__(2178),
      statements: true,
      errors: 'full',
      dependencies: ['format'],
      metaSchema: {
        anyOf: [
          {type: 'string'},
          $dataMetaSchema
        ]
      }
    };

    ajv.addKeyword(keyword, defFunc.definition);
    ajv.addKeyword('formatExclusive' + minMax, {
      dependencies: ['format' + minMax],
      metaSchema: {
        anyOf: [
          {type: 'boolean'},
          $dataMetaSchema
        ]
      }
    });
    extendFormats(ajv);
    return ajv;
  };
};


function extendFormats(ajv) {
  var formats = ajv._formats;
  for (var name in COMPARE_FORMATS) {
    var format = formats[name];
    // the last condition is needed if it's RegExp from another window
    if (typeof format != 'object' || format instanceof RegExp || !format.validate)
      format = formats[name] = { validate: format };
    if (!format.compare)
      format.compare = COMPARE_FORMATS[name];
  }
}


function compareDate(d1, d2) {
  if (!(d1 && d2)) return;
  if (d1 > d2) return 1;
  if (d1 < d2) return -1;
  if (d1 === d2) return 0;
}


function compareTime(t1, t2) {
  if (!(t1 && t2)) return;
  t1 = t1.match(TIME);
  t2 = t2.match(TIME);
  if (!(t1 && t2)) return;
  t1 = t1[1] + t1[2] + t1[3] + (t1[4]||'');
  t2 = t2[1] + t2[2] + t2[3] + (t2[4]||'');
  if (t1 > t2) return 1;
  if (t1 < t2) return -1;
  if (t1 === t2) return 0;
}


function compareDateTime(dt1, dt2) {
  if (!(dt1 && dt2)) return;
  dt1 = dt1.split(DATE_TIME_SEPARATOR);
  dt2 = dt2.split(DATE_TIME_SEPARATOR);
  var res = compareDate(dt1[0], dt2[0]);
  if (res === undefined) return;
  return res || compareTime(dt1[1], dt2[1]);
}


/***/ }),

/***/ 52632:
/***/ ((__unused_webpack_module, exports) => {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),

/***/ 52648:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


/***/ }),

/***/ 53011:
/***/ ((module) => {

"use strict";
module.exports = {};

/***/ }),

/***/ 53209:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(65606);


// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536

// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = (__webpack_require__(92861).Buffer)
var crypto = __webpack_require__.g.crypto || __webpack_require__.g.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

  var bytes = Buffer.allocUnsafe(size)

  if (size > 0) {  // getRandomValues fails on IE if size == 0
    if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
      // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
      for (var generated = 0; generated < size; generated += MAX_BYTES) {
        // buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES))
      }
    } else {
      crypto.getRandomValues(bytes)
    }
  }

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}


/***/ }),

/***/ 53233:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var View = api.importMixinModule('booking', 'views', 'crm');
var CRMBookingView = /*#__PURE__*/function (_View) {
  function CRMBookingView() {
    _classCallCheck(this, CRMBookingView);
    return _callSuper(this, CRMBookingView, arguments);
  }
  _inherits(CRMBookingView, _View);
  return _createClass(CRMBookingView, null, [{
    key: "showOnlyStatus",
    value: function showOnlyStatus(paxlead) {
      return true;
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
        var _this = this;
        var isTemplate, isOper, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isTemplate = _ref.isTemplate, isOper = _ref.isOper;
              _context.next = 3;
              return _superPropGet(CRMBookingView, "getTableOptions", this, 2)([{
                isTemplate: isTemplate,
                isOper: isOper
              }]);
            case 3:
              res = _context.sent;
              res.fields.push({
                name: "PaxLeadId",
                label: "Lead",
                editor: 'select',
                setRelationTo: 'PaxLead',
                linkTo: true,
                relation: 'paxlead',
                optionLabels: function optionLabels(row) {
                  return "".concat(row.id, " - ").concat(row.PaxName);
                },
                addBlank: true,
                hideFromList: true,
                endpointFilters: function endpointFilters(record) {
                  var res = {};
                  res.SalesUserId = record.SalesUserId;
                  return res;
                },
                filters: function filters(row, record) {
                  if (!_this.showOnlyStatus(row)) return false;
                  if (!record) return true;
                  if (record.PaxLeadId == row.id) return true;
                  if (!row.BookingId && row.SalesUserId == record.SalesUserId) return true;
                }
              });
              return _context.abrupt("return", res);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions(_x) {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(View);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CRMBookingView);

/***/ }),

/***/ 53420:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"$schema":"http://json-schema.org/draft-07/schema#","$id":"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#","description":"Meta-schema for $data reference (JSON Schema extension proposal)","type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}');

/***/ }),

/***/ 53577:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"_Word":"Word","DOCUMENTS ALREADY SENT":"DOCUMENTS DÉJÀ ENVOYÉS","NO DOCUMENTS ATTACHED":"AUCUN DOCUMENT JOINT"}');

/***/ }),

/***/ 53872:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),

/***/ 53954:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ _getPrototypeOf)
/* harmony export */ });
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}


/***/ }),

/***/ 54347:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(65606);


// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;
  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;
  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }
  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });
  return this;
}
function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}
function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}
function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }
  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}
function emitErrorNT(self, err) {
  self.emit('error', err);
}
function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.

  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}
module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};

/***/ }),

/***/ 54371:
/***/ ((module) => {

"use strict";

module.exports = function generate_items(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $idx = 'i' + $lvl,
    $dataNxt = $it.dataLevel = it.dataLevel + 1,
    $nextData = 'data' + $dataNxt,
    $currentBaseId = it.baseId;
  out += 'var ' + ($errs) + ' = errors;var ' + ($valid) + ';';
  if (Array.isArray($schema)) {
    var $additionalItems = it.schema.additionalItems;
    if ($additionalItems === false) {
      out += ' ' + ($valid) + ' = ' + ($data) + '.length <= ' + ($schema.length) + '; ';
      var $currErrSchemaPath = $errSchemaPath;
      $errSchemaPath = it.errSchemaPath + '/additionalItems';
      out += '  if (!' + ($valid) + ') {   ';
      var $$outStack = $$outStack || [];
      $$outStack.push(out);
      out = ''; /* istanbul ignore else */
      if (it.createErrors !== false) {
        out += ' { keyword: \'' + ('additionalItems') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { limit: ' + ($schema.length) + ' } ';
        if (it.opts.messages !== false) {
          out += ' , message: \'should NOT have more than ' + ($schema.length) + ' items\' ';
        }
        if (it.opts.verbose) {
          out += ' , schema: false , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
        }
        out += ' } ';
      } else {
        out += ' {} ';
      }
      var __err = out;
      out = $$outStack.pop();
      if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */
        if (it.async) {
          out += ' throw new ValidationError([' + (__err) + ']); ';
        } else {
          out += ' validate.errors = [' + (__err) + ']; return false; ';
        }
      } else {
        out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
      }
      out += ' } ';
      $errSchemaPath = $currErrSchemaPath;
      if ($breakOnError) {
        $closingBraces += '}';
        out += ' else { ';
      }
    }
    var arr1 = $schema;
    if (arr1) {
      var $sch, $i = -1,
        l1 = arr1.length - 1;
      while ($i < l1) {
        $sch = arr1[$i += 1];
        if ((it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all))) {
          out += ' ' + ($nextValid) + ' = true; if (' + ($data) + '.length > ' + ($i) + ') { ';
          var $passData = $data + '[' + $i + ']';
          $it.schema = $sch;
          $it.schemaPath = $schemaPath + '[' + $i + ']';
          $it.errSchemaPath = $errSchemaPath + '/' + $i;
          $it.errorPath = it.util.getPathExpr(it.errorPath, $i, it.opts.jsonPointers, true);
          $it.dataPathArr[$dataNxt] = $i;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
          } else {
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
          }
          out += ' }  ';
          if ($breakOnError) {
            out += ' if (' + ($nextValid) + ') { ';
            $closingBraces += '}';
          }
        }
      }
    }
    if (typeof $additionalItems == 'object' && (it.opts.strictKeywords ? (typeof $additionalItems == 'object' && Object.keys($additionalItems).length > 0) || $additionalItems === false : it.util.schemaHasRules($additionalItems, it.RULES.all))) {
      $it.schema = $additionalItems;
      $it.schemaPath = it.schemaPath + '.additionalItems';
      $it.errSchemaPath = it.errSchemaPath + '/additionalItems';
      out += ' ' + ($nextValid) + ' = true; if (' + ($data) + '.length > ' + ($schema.length) + ') {  for (var ' + ($idx) + ' = ' + ($schema.length) + '; ' + ($idx) + ' < ' + ($data) + '.length; ' + ($idx) + '++) { ';
      $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
      var $passData = $data + '[' + $idx + ']';
      $it.dataPathArr[$dataNxt] = $idx;
      var $code = it.validate($it);
      $it.baseId = $currentBaseId;
      if (it.util.varOccurences($code, $nextData) < 2) {
        out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
      } else {
        out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
      }
      if ($breakOnError) {
        out += ' if (!' + ($nextValid) + ') break; ';
      }
      out += ' } }  ';
      if ($breakOnError) {
        out += ' if (' + ($nextValid) + ') { ';
        $closingBraces += '}';
      }
    }
  } else if ((it.opts.strictKeywords ? (typeof $schema == 'object' && Object.keys($schema).length > 0) || $schema === false : it.util.schemaHasRules($schema, it.RULES.all))) {
    $it.schema = $schema;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    out += '  for (var ' + ($idx) + ' = ' + (0) + '; ' + ($idx) + ' < ' + ($data) + '.length; ' + ($idx) + '++) { ';
    $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
    var $passData = $data + '[' + $idx + ']';
    $it.dataPathArr[$dataNxt] = $idx;
    var $code = it.validate($it);
    $it.baseId = $currentBaseId;
    if (it.util.varOccurences($code, $nextData) < 2) {
      out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
    } else {
      out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
    }
    if ($breakOnError) {
      out += ' if (!' + ($nextValid) + ') break; ';
    }
    out += ' }';
  }
  if ($breakOnError) {
    out += ' ' + ($closingBraces) + ' if (' + ($errs) + ' == errors) {';
  }
  return out;
}


/***/ }),

/***/ 54566:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


/***/ }),

/***/ 54691:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl:
            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
                '_'
            ),
        monthsGenitiveEl:
            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
                '_'
            ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


/***/ }),

/***/ 54697:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


/***/ }),

/***/ 54756:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(4633)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ 54903:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


/***/ }),

/***/ 55231:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8818);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var AiSettingsView = /*#__PURE__*/function (_View) {
  function AiSettingsView() {
    _classCallCheck(this, AiSettingsView);
    return _callSuper(this, AiSettingsView, arguments);
  }
  _inherits(AiSettingsView, _View);
  return _createClass(AiSettingsView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var r, cityTransferField, transferServiceIds;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(AiSettingsView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              r = _context.sent;
              cityTransferField = _.find(r.fields, function (r) {
                return r.name == 'AISettingsCityTransfers';
              });
              if (cityTransferField) {
                transferServiceIds = cityTransferField.rowFields.find(function (r) {
                  return r.name == 'TransferServiceIds';
                });
                if (transferServiceIds) {
                  transferServiceIds.optionLabels = function (row) {
                    var _row$Supplier, _row$Supplier2;
                    if (!row) return '';
                    if ((_row$Supplier = row.Supplier) !== null && _row$Supplier !== void 0 && _row$Supplier.Name) return ((_row$Supplier2 = row.Supplier) === null || _row$Supplier2 === void 0 ? void 0 : _row$Supplier2.Name) + ' - ' + row.Name;
                    if (!api.tables.supplier) return row.Name;
                    var supplier = api.tables.supplier.find(function (r) {
                      return r.id === row.SupplierId;
                    });
                    if (!supplier) return row.Name;
                    var serviceType = api.tables.servicetype.find(function (r) {
                      return r.id === row.ServiceTypeId;
                    });
                    if (serviceType) return supplier.Name + ' - ' + row.Name + ' - ' + serviceType.Name;
                    return supplier.Name + ' - ' + row.Name;
                  };
                }
              }
              return _context.abrupt("return", r);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_0__["default"]);
_defineProperty(AiSettingsView, "table", 'aisettings');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AiSettingsView);

/***/ }),

/***/ 55250:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const parseQuery = __webpack_require__(90497);

function getOptions(loaderContext) {
  const query = loaderContext.query;

  if (typeof query === 'string' && query !== '') {
    return parseQuery(loaderContext.query);
  }

  if (!query || typeof query !== 'object') {
    // Not object-like queries are not supported.
    return {};
  }

  return query;
}

module.exports = getOptions;


/***/ }),

/***/ 55264:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var Buffer = (__webpack_require__(92861).Buffer)

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),

/***/ 55539:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_base_model__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42675);







function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var Record = /*#__PURE__*/function (_BaseModel) {
  function Record(_ref) {
    var _this;
    var fields = _ref.fields,
      tableName = _ref.tableName,
      options = _ref.options,
      endpoint = _ref.endpoint,
      record = _ref.record;
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, Record);
    var f = options ? options.fields : null;
    if (fields) f = fields;
    _this = _callSuper(this, Record, [{
      fields: f,
      record: record,
      tableName: tableName
    }]);
    var self = _this;
    return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(_this, (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var initPromise, user;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            initPromise = new Promise(function (resolve, reject) {
              resolve(self);
            });
            _context.next = 3;
            return api.getCurrentUser();
          case 3:
            user = _context.sent;
            _context.next = 6;
            return initPromise;
          case 6:
            self = _context.sent;
            self.tableName = tableName;
            self.showClosed = false;
            self.endpoint = endpoint ? endpoint : '/api/' + tableName + '/';
            self.search = null;
            self.initNotifications();
            self.attached = [];
            self.attachList = [];
            self.canAdd = tools.canAccess(user, 'api', 'POST', self.endpoint);
            self.userCanEdit = tools.canAccess(user, 'api', 'POST', self.endpoint);
            self.userCanDelete = tools.canAccess(user, 'api', 'DELETE', self.endpoint);
            if (options) {
              if (options.afterSave) self.afterSave = options.afterSave;
              if (options.beforeSave) self.beforeSave = options.beforeSave;
              if (options.serverSide) self.serverSide = options.serverSide;
              if (options.evalDelete) self.evalDelete = options.evalDelete;
              if (options.evalEdit) self.evalEdit = options.evalEdit;
              if (options.setTitleName) self.setTitleName = options.setTitleName;
            }
            //self.me = user;
            self.processingAttach = false;
            if (self.id) self._modified = false;
            if (!self.id) self._new = true;
            self._recordLoaded = true;
            self._isClone = false;
            self.dependencies = false;
            return _context.abrupt("return", self);
          case 25:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))());
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(Record, _BaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(Record, [{
    key: "getHasClosed",
    value: function getHasClosed() {
      var _iterator = _createForOfIteratorHelper(this.fields),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var f = _step.value;
          if (f === 'Closed' || f.name === 'Closed') return true;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return false;
    }
  }, {
    key: "save",
    value: function () {
      var _save = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
        var _res, res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.beforeSave) {
                _context2.next = 6;
                break;
              }
              _res = this.beforeSave(this);
              if (!_res) {
                _context2.next = 6;
                break;
              }
              _context2.next = 5;
              return this.init(_res);
            case 5:
              return _context2.abrupt("return");
            case 6:
              _context2.next = 8;
              return this.saveRecord();
            case 8:
              res = _context2.sent;
              if (this.afterSave) {
                this.afterSave(this);
              }
              return _context2.abrupt("return", res);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function save() {
        return _save.apply(this, arguments);
      }
      return save;
    }()
  }, {
    key: "remove",
    value: function () {
      var _remove = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3() {
        var _this2 = this;
        var self, res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.initNotifications();
              self = this;
              self.dependencies = false;
              _context3.next = 5;
              return api.remove(this.endpoint, this.id, function (r, response) {
                if (response && response.status == 420) self.dependencies = true;
                _this2.addError(r.err, r.detail);
              });
            case 5:
              res = _context3.sent;
              if (!res) {
                _context3.next = 9;
                break;
              }
              api.removeFromStore(this.tableName, this.id);
              return _context3.abrupt("return", res);
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function remove() {
        return _remove.apply(this, arguments);
      }
      return remove;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(record) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _superPropGet(Record, "init", this, 3)([record]);
            case 2:
              this.setModified(false);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function init(_x) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "clean",
    value: function clean(rec) {
      tools.clean(rec);
    }
  }, {
    key: "saveRecord",
    value: function () {
      var _saveRecord = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5() {
        var _this3 = this;
        var errors, rec, r, id, result;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.notifications.errors = [];
              this.notifications.warning = null;
              _context5.next = 4;
              return this.checkFields();
            case 4:
              errors = _context5.sent;
              if (!errors) {
                _context5.next = 9;
                break;
              }
              api.setProcessing(false);
              this.addError(errors.join('. '));
              return _context5.abrupt("return");
            case 9:
              this.initNotifications();
              rec = _.cloneDeep(this);
              this.clean(rec);
              r = tools.plainObject(rec);
              id = this.id ? this.id : 0;
              _context5.next = 16;
              return api.save("".concat(this.endpoint).concat(id), r, this.attachList, this.tableName, function (response) {
                _this3.addError(response.err, response.detail, response.field);
              });
            case 16:
              result = _context5.sent;
              if (!result) {
                _context5.next = 31;
                break;
              }
              if (result.filesError) {
                this.addError('Attachments errors', result.filesError.detail, result.filesError.field);
              }
              this._recordLoaded = false;
              this.attachList = [];
              _context5.next = 23;
              return this.init(result);
            case 23:
              _context5.next = 25;
              return this.getAttached();
            case 25:
              this.original_id = this.id;
              api.updateToStore(this.tableName, result);
              this.addNotification(tr("Record Saved"));
              if (result._warnings) {
                this.notifications.warning = result._warnings.join('; ');
              } else {
                this.notifications.warning = null;
              }
              this._recordLoaded = true;
              return _context5.abrupt("return", result);
            case 31:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function saveRecord() {
        return _saveRecord.apply(this, arguments);
      }
      return saveRecord;
    }()
  }, {
    key: "addNotification",
    value: function addNotification(msg) {
      var _this4 = this;
      this.notifications.message = msg;
      this.notifications.timer = 0;
      var k = 500;
      if (this.notifications.interval) {
        clearInterval(this.notifications.interval);
      }
      this.notifications.interval = setInterval(function () {
        _this4.notifications.timer += k;
        if (_this4.notifications.timer > 5000) {
          clearInterval(_this4.notifications.interval);
          _this4.notifications.message = null;
          _this4.notifications.timer = 0;
        }
      }, k);

      /*setTimeout(() => {
          this.notifications.message = null;
      }, 5000);*/
    }
  }, {
    key: "initNotifications",
    value: function initNotifications() {
      this.notifications = {
        errors: [],
        errorDetail: null,
        message: null,
        warning: null,
        interval: null,
        timer: 0
      };
    }
  }, {
    key: "addWarning",
    value: function addWarning(msg) {
      this.notifications.warning = msg;
    }
  }, {
    key: "addError",
    value: function addError(msg, detail, fieldName) {
      var e = msg;
      if (fieldName) {
        var label = this.getFieldLabel(fieldName);
        e = "".concat(tr(msg), " ").concat(tr(label));
      }
      if (this.notifications.errors.indexOf(e) == -1) {
        this.notifications.errors.push(e);
        if (detail) this.notifications.errorDetail = detail;
        this.notifications.message = null;
      }
    }
  }, {
    key: "titleName",
    get: function get() {
      if (this.setTitleName) return this.setTitleName(this);
      if (this.Name && this.id) return this.id + " - " + this.Name;
      if (this.Name) return this.Name;
      return '';
    }
  }, {
    key: "canDelete",
    get: function get() {
      if (!this.userCanDelete) return false;
      if (this.evalDelete) {
        return this.evalDelete(this);
      }
      return true;
    }
  }, {
    key: "canEdit",
    get: function get() {
      if (!this.userCanEdit) return false;
      if (this.evalEdit) {
        return this.evalEdit(this);
      }
      return true;
    }
  }, {
    key: "attachPending",
    get: function get() {
      return this.attachList;
    }
  }, {
    key: "getAttached",
    value: function () {
      var _getAttached = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6() {
        var res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!(this && this.id)) {
                _context6.next = 8;
                break;
              }
              this.processingAttach = true;
              _context6.next = 4;
              return api.get('/api/get_attach_list/' + this.tableName + '/' + this.id);
            case 4:
              res = _context6.sent;
              if (res) {
                this.attached = res;
                this.processingAttach = false;
              }
              _context6.next = 9;
              break;
            case 8:
              this.attached = [];
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getAttached() {
        return _getAttached.apply(this, arguments);
      }
      return getAttached;
    }()
  }], [{
    key: "clone",
    value: function () {
      var _clone = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7(_ref3) {
        var fields, record, parent, r;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              fields = _ref3.fields, record = _ref3.record, parent = _ref3.parent;
              _context7.next = 3;
              return _superPropGet(Record, "clone", this, 2)([{
                fields: fields,
                record: record,
                parent: parent
              }]);
            case 3:
              r = _context7.sent;
              r.endpoint = record.endpoint;
              r.tableName = record.tableName;
              r._modified = true;
              r._new = true;
              return _context7.abrupt("return", r);
            case 9:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function clone(_x2) {
        return _clone.apply(this, arguments);
      }
      return clone;
    }()
  }, {
    key: "get",
    value: function () {
      var _get2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8(_ref4) {
        var id, tableName, options, endpoint, record, r;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              id = _ref4.id, tableName = _ref4.tableName, options = _ref4.options, endpoint = _ref4.endpoint;
              _context8.next = 3;
              return api.getObjectFromStore(tableName, id);
            case 3:
              record = _context8.sent;
              if (!record) {
                _context8.next = 13;
                break;
              }
              _context8.next = 7;
              return new this({
                tableName: tableName,
                options: options,
                endpoint: endpoint,
                record: record
              });
            case 7:
              r = _context8.sent;
              if (!r.id) {
                _context8.next = 12;
                break;
              }
              r._recordLoaded = true;
              _context8.next = 12;
              return r.getAttached();
            case 12:
              return _context8.abrupt("return", r);
            case 13:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function get(_x3) {
        return _get2.apply(this, arguments);
      }
      return get;
    }()
  }]);
}(_base_model_base_model__WEBPACK_IMPORTED_MODULE_4__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Record);

/***/ }),

/***/ 55541:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51941);







function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingTotal = /*#__PURE__*/function (_BookingBaseModel) {
  function BookingTotal(obj) {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingTotal);
    obj.fields = (this instanceof BookingTotal ? this.constructor : void 0).setFields(obj.record);
    return _callSuper(this, BookingTotal, [obj]);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingTotal, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingTotal, [{
    key: "bases",
    get: function get() {
      //return tools.getBases(_.cloneDeep(this));
      return ['ADT', 'CHD', 'TL'];
    }
  }, {
    key: "newBookingTotalPerson",
    value: function () {
      var _newBookingTotalPerson = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(pax, obj) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.fields.push({
                name: pax,
                editor: {},
                objectClass: 'servicepersonquote'
              });
              _context.next = 3;
              return this.newRow({
                rowClass: 'bookingtotalperson'
              }, obj, pax);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function newBookingTotalPerson(_x, _x2) {
        return _newBookingTotalPerson.apply(this, arguments);
      }
      return newBookingTotalPerson;
    }()
  }, {
    key: "booking",
    get: function get() {
      return this.$parent.$parent;
    }
  }, {
    key: "baseId",
    get: function get() {
      for (var baseId in this.$parent.bases) {
        var totalList = this.$parent[baseId];
        if (totalList._id == this._id) {
          return baseId;
        }
      }
    }
  }], [{
    key: "setFields",
    value: function setFields(record) {
      var fields = [];
      if (record) {
        for (var key in record) {
          if (['ADT', 'CHD', 'TL'].indexOf(key) == -1) continue;
          fields.push({
            name: key,
            editor: {},
            objectClass: 'bookingtotalperson'
          });
        }
        //fields.push({name: 'PaxRooms', editor: 'number', decimal: 0, label: 'Pax. Rooms'});
      }
      return fields;
    }
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingTotal);

/***/ }),

/***/ 55600:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

/** @typedef {import("ajv").Ajv} Ajv */

/** @typedef {import("ajv").ValidateFunction} ValidateFunction */

/** @typedef {import("../validate").SchemaUtilErrorObject} SchemaUtilErrorObject */

/**
 * @param {string} message
 * @param {object} schema
 * @param {string} data
 * @returns {SchemaUtilErrorObject}
 */
function errorMessage(message, schema, data) {
  return {
    // @ts-ignore
    // eslint-disable-next-line no-undefined
    dataPath: undefined,
    // @ts-ignore
    // eslint-disable-next-line no-undefined
    schemaPath: undefined,
    keyword: "absolutePath",
    params: {
      absolutePath: data
    },
    message,
    parentSchema: schema
  };
}
/**
 * @param {boolean} shouldBeAbsolute
 * @param {object} schema
 * @param {string} data
 * @returns {SchemaUtilErrorObject}
 */


function getErrorFor(shouldBeAbsolute, schema, data) {
  const message = shouldBeAbsolute ? `The provided value ${JSON.stringify(data)} is not an absolute path!` : `A relative path is expected. However, the provided value ${JSON.stringify(data)} is an absolute path!`;
  return errorMessage(message, schema, data);
}
/**
 *
 * @param {Ajv} ajv
 * @returns {Ajv}
 */


function addAbsolutePathKeyword(ajv) {
  ajv.addKeyword("absolutePath", {
    errors: true,
    type: "string",

    compile(schema, parentSchema) {
      /** @type {ValidateFunction} */
      const callback = data => {
        let passes = true;
        const isExclamationMarkPresent = data.includes("!");

        if (isExclamationMarkPresent) {
          callback.errors = [errorMessage(`The provided value ${JSON.stringify(data)} contains exclamation mark (!) which is not allowed because it's reserved for loader syntax.`, parentSchema, data)];
          passes = false;
        } // ?:[A-Za-z]:\\ - Windows absolute path
        // \\\\ - Windows network absolute path
        // \/ - Unix-like OS absolute path


        const isCorrectAbsolutePath = schema === /^(?:[A-Za-z]:(\\|\/)|\\\\|\/)/.test(data);

        if (!isCorrectAbsolutePath) {
          callback.errors = [getErrorFor(schema, parentSchema, data)];
          passes = false;
        }

        return passes;
      };

      callback.errors = [];
      return callback;
    }

  });
  return ajv;
}

var _default = addAbsolutePathKeyword;
exports["default"] = _default;

/***/ }),

/***/ 55715:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = __webpack_require__(62951);


/***/ }),

/***/ 55729:
/***/ ((module) => {

"use strict";


// we can't use path.win32.isAbsolute because it also matches paths starting with a forward slash
const matchNativeWin32Path = /^[A-Z]:[/\\]|^\\\\/i;

function urlToRequest(url, root) {
  // Do not rewrite an empty url
  if (url === '') {
    return '';
  }

  const moduleRequestRegex = /^[^?]*~/;
  let request;

  if (matchNativeWin32Path.test(url)) {
    // absolute windows path, keep it
    request = url;
  } else if (root !== undefined && root !== false && /^\//.test(url)) {
    // if root is set and the url is root-relative
    switch (typeof root) {
      // 1. root is a string: root is prefixed to the url
      case 'string':
        // special case: `~` roots convert to module request
        if (moduleRequestRegex.test(root)) {
          request = root.replace(/([^~/])$/, '$1/') + url.slice(1);
        } else {
          request = root + url;
        }
        break;
      // 2. root is `true`: absolute paths are allowed
      //    *nix only, windows-style absolute paths are always allowed as they doesn't start with a `/`
      case 'boolean':
        request = url;
        break;
      default:
        throw new Error(
          "Unexpected parameters to loader-utils 'urlToRequest': url = " +
            url +
            ', root = ' +
            root +
            '.'
        );
    }
  } else if (/^\.\.?\//.test(url)) {
    // A relative url stays
    request = url;
  } else {
    // every other url is threaded like a relative url
    request = './' + url;
  }

  // A `~` makes the url an module
  if (moduleRequestRegex.test(request)) {
    request = request.replace(moduleRequestRegex, '');
  }

  return request;
}

module.exports = urlToRequest;


/***/ }),

/***/ 55802:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort:
            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


/***/ }),

/***/ 56000:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays:
            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
                '_'
            ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


/***/ }),

/***/ 56004:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51941);








function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingTotalPerson = /*#__PURE__*/function (_BookingBaseModel) {
  function BookingTotalPerson() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingTotalPerson);
    return _callSuper(this, BookingTotalPerson, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingTotalPerson, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingTotalPerson, [{
    key: "setOverByPrice",
    value: function setOverByPrice() {
      this.$OverPrice.value = this.Price;
      if (this.booking.quoteService) {
        if (tools.isNull(this.Price)) {
          this.$OverPersonPrice.value = null;
        } else {
          var pType = this.paxType;
          var pax = this.booking.BaseQuotes[this.baseId][pType];
          this.$OverPersonPrice.value = this.Price / pax;
        }
      }
    }
  }, {
    key: "booking",
    get: function get() {
      return this.$parent.$parent.$parent;
    }
  }, {
    key: "setOverByPersonPrice",
    value: function setOverByPersonPrice() {
      var pType = this.paxType;
      var pax = this.booking.BaseQuotes[this.baseId][pType];
      if (tools.isNull(this.PersonPrice)) {
        this.$OverPrice.value = null;
        this.$OverPersonPrice.value = null;
      } else {
        this.$OverPrice.value = this.PersonPrice * pax;
        this.$OverPersonPrice.value = this.PersonPrice;
      }
    }
  }, {
    key: "setHotelCost",
    value: function () {
      var _setHotelCost = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var baseId, _iterator, _step, day, _iterator2, _step2, hotel, _iterator3, _step3, room;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              baseId = this.baseId;
              _iterator = _createForOfIteratorHelper(this.booking.BookingDays);
              _context.prev = 2;
              _iterator.s();
            case 4:
              if ((_step = _iterator.n()).done) {
                _context.next = 43;
                break;
              }
              day = _step.value;
              _iterator2 = _createForOfIteratorHelper(day.BookingDayHotels);
              _context.prev = 7;
              _iterator2.s();
            case 9:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 33;
                break;
              }
              hotel = _step2.value;
              _iterator3 = _createForOfIteratorHelper(hotel.BookingDayRooms);
              _context.prev = 12;
              _iterator3.s();
            case 14:
              if ((_step3 = _iterator3.n()).done) {
                _context.next = 23;
                break;
              }
              room = _step3.value;
              if (room.QuoteList) {
                _context.next = 18;
                break;
              }
              return _context.abrupt("continue", 21);
            case 18:
              if (room.QuoteList[baseId]) {
                _context.next = 20;
                break;
              }
              return _context.abrupt("continue", 21);
            case 20:
              room.QuoteList[this.baseId].setRoomCost();
            case 21:
              _context.next = 14;
              break;
            case 23:
              _context.next = 28;
              break;
            case 25:
              _context.prev = 25;
              _context.t0 = _context["catch"](12);
              _iterator3.e(_context.t0);
            case 28:
              _context.prev = 28;
              _iterator3.f();
              return _context.finish(28);
            case 31:
              _context.next = 9;
              break;
            case 33:
              _context.next = 38;
              break;
            case 35:
              _context.prev = 35;
              _context.t1 = _context["catch"](7);
              _iterator2.e(_context.t1);
            case 38:
              _context.prev = 38;
              _iterator2.f();
              return _context.finish(38);
            case 41:
              _context.next = 4;
              break;
            case 43:
              _context.next = 48;
              break;
            case 45:
              _context.prev = 45;
              _context.t2 = _context["catch"](2);
              _iterator.e(_context.t2);
            case 48:
              _context.prev = 48;
              _iterator.f();
              return _context.finish(48);
            case 51:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 45, 48, 51], [7, 35, 38, 41], [12, 25, 28, 31]]);
      }));
      function setHotelCost() {
        return _setHotelCost.apply(this, arguments);
      }
      return setHotelCost;
    }()
  }, {
    key: "setPaxVales",
    value: function () {
      var _setPaxVales = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.setHotelCost();
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function setPaxVales() {
        return _setPaxVales.apply(this, arguments);
      }
      return setPaxVales;
    }()
  }, {
    key: "afterEdit",
    value: function afterEdit() {
      return {
        Price: function () {
          var _Price = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(r) {
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return r.setOverByPrice();
                case 2:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }));
          function Price(_x) {
            return _Price.apply(this, arguments);
          }
          return Price;
        }(),
        PersonPrice: function () {
          var _PersonPrice = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(r) {
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return r.setOverByPersonPrice();
                case 2:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          }));
          function PersonPrice(_x2) {
            return _PersonPrice.apply(this, arguments);
          }
          return PersonPrice;
        }(),
        Pax: function () {
          var _Pax = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(r) {
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return r.setPaxVales();
                case 2:
                case "end":
                  return _context5.stop();
              }
            }, _callee5);
          }));
          function Pax(_x3) {
            return _Pax.apply(this, arguments);
          }
          return Pax;
        }()
      };
    }
  }, {
    key: "baseId",
    get: function get() {
      for (var baseId in this.$parent.$parent.bases) {
        var totalList = this.$parent.$parent[baseId];
        var _iterator4 = _createForOfIteratorHelper(totalList.bases),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var pType = _step4.value;
            var quote = totalList[pType];
            if (!quote) continue;
            if (quote._id == this._id) {
              return baseId;
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }
  }, {
    key: "paxType",
    get: function get() {
      for (var baseId in this.$parent.$parent.bases) {
        var totalList = this.$parent.$parent[baseId];
        var _iterator5 = _createForOfIteratorHelper(totalList.bases),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var pType = _step5.value;
            var quote = totalList[pType];
            if (!quote) continue;
            if (quote._id == this._id) {
              return pType;
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingTotalPerson, "moduleName", 'bookingtotalperson');
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingTotalPerson, "invalidated_cache", ['totals', 'totalsServices', 'totalsHotels', 'quoted', 'totalByPaxVariantId', 'baseTotalsHotels']);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingTotalPerson);

/***/ }),

/***/ 56057:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('[{"id":4,"alpha2":"af","alpha3":"afg","name":"Afghanistan"},{"id":710,"alpha2":"za","alpha3":"zaf","name":"Afrique du Sud"},{"id":248,"alpha2":"ax","alpha3":"ala","name":"Îles Åland"},{"id":8,"alpha2":"al","alpha3":"alb","name":"Albanie"},{"id":12,"alpha2":"dz","alpha3":"dza","name":"Algérie"},{"id":276,"alpha2":"de","alpha3":"deu","name":"Allemagne"},{"id":20,"alpha2":"ad","alpha3":"and","name":"Andorre"},{"id":24,"alpha2":"ao","alpha3":"ago","name":"Angola"},{"id":660,"alpha2":"ai","alpha3":"aia","name":"Anguilla"},{"id":10,"alpha2":"aq","alpha3":"ata","name":"Antarctique"},{"id":28,"alpha2":"ag","alpha3":"atg","name":"Antigua-et-Barbuda"},{"id":682,"alpha2":"sa","alpha3":"sau","name":"Arabie saoudite"},{"id":32,"alpha2":"ar","alpha3":"arg","name":"Argentine"},{"id":51,"alpha2":"am","alpha3":"arm","name":"Arménie"},{"id":533,"alpha2":"aw","alpha3":"abw","name":"Aruba"},{"id":36,"alpha2":"au","alpha3":"aus","name":"Australie"},{"id":40,"alpha2":"at","alpha3":"aut","name":"Autriche"},{"id":31,"alpha2":"az","alpha3":"aze","name":"Azerbaïdjan"},{"id":44,"alpha2":"bs","alpha3":"bhs","name":"Bahamas"},{"id":48,"alpha2":"bh","alpha3":"bhr","name":"Bahreïn"},{"id":50,"alpha2":"bd","alpha3":"bgd","name":"Bangladesh"},{"id":52,"alpha2":"bb","alpha3":"brb","name":"Barbade"},{"id":112,"alpha2":"by","alpha3":"blr","name":"Biélorussie"},{"id":56,"alpha2":"be","alpha3":"bel","name":"Belgique"},{"id":84,"alpha2":"bz","alpha3":"blz","name":"Belize"},{"id":204,"alpha2":"bj","alpha3":"ben","name":"Bénin"},{"id":60,"alpha2":"bm","alpha3":"bmu","name":"Bermudes"},{"id":64,"alpha2":"bt","alpha3":"btn","name":"Bhoutan"},{"id":68,"alpha2":"bo","alpha3":"bol","name":"Bolivie"},{"id":535,"alpha2":"bq","alpha3":"bes","name":"Pays-Bas caribéens"},{"id":70,"alpha2":"ba","alpha3":"bih","name":"Bosnie-Herzégovine"},{"id":72,"alpha2":"bw","alpha3":"bwa","name":"Botswana"},{"id":74,"alpha2":"bv","alpha3":"bvt","name":"Île Bouvet"},{"id":76,"alpha2":"br","alpha3":"bra","name":"Brésil"},{"id":96,"alpha2":"bn","alpha3":"brn","name":"Brunei"},{"id":100,"alpha2":"bg","alpha3":"bgr","name":"Bulgarie"},{"id":854,"alpha2":"bf","alpha3":"bfa","name":"Burkina Faso"},{"id":108,"alpha2":"bi","alpha3":"bdi","name":"Burundi"},{"id":136,"alpha2":"ky","alpha3":"cym","name":"Îles Caïmans"},{"id":116,"alpha2":"kh","alpha3":"khm","name":"Cambodge"},{"id":120,"alpha2":"cm","alpha3":"cmr","name":"Cameroun"},{"id":124,"alpha2":"ca","alpha3":"can","name":"Canada"},{"id":132,"alpha2":"cv","alpha3":"cpv","name":"Cap-Vert"},{"id":140,"alpha2":"cf","alpha3":"caf","name":"République centrafricaine"},{"id":152,"alpha2":"cl","alpha3":"chl","name":"Chili"},{"id":156,"alpha2":"cn","alpha3":"chn","name":"Chine"},{"id":162,"alpha2":"cx","alpha3":"cxr","name":"Île Christmas"},{"id":196,"alpha2":"cy","alpha3":"cyp","name":"Chypre"},{"id":166,"alpha2":"cc","alpha3":"cck","name":"Îles Cocos"},{"id":170,"alpha2":"co","alpha3":"col","name":"Colombie"},{"id":174,"alpha2":"km","alpha3":"com","name":"Comores"},{"id":178,"alpha2":"cg","alpha3":"cog","name":"République du Congo"},{"id":180,"alpha2":"cd","alpha3":"cod","name":"République démocratique du Congo"},{"id":184,"alpha2":"ck","alpha3":"cok","name":"Îles Cook"},{"id":410,"alpha2":"kr","alpha3":"kor","name":"Corée du Sud"},{"id":408,"alpha2":"kp","alpha3":"prk","name":"Corée du Nord"},{"id":188,"alpha2":"cr","alpha3":"cri","name":"Costa Rica"},{"id":384,"alpha2":"ci","alpha3":"civ","name":"Côte d\'Ivoire"},{"id":191,"alpha2":"hr","alpha3":"hrv","name":"Croatie"},{"id":192,"alpha2":"cu","alpha3":"cub","name":"Cuba"},{"id":531,"alpha2":"cw","alpha3":"cuw","name":"Curaçao"},{"id":208,"alpha2":"dk","alpha3":"dnk","name":"Danemark"},{"id":262,"alpha2":"dj","alpha3":"dji","name":"Djibouti"},{"id":214,"alpha2":"do","alpha3":"dom","name":"République dominicaine"},{"id":212,"alpha2":"dm","alpha3":"dma","name":"Dominique"},{"id":818,"alpha2":"eg","alpha3":"egy","name":"Égypte"},{"id":222,"alpha2":"sv","alpha3":"slv","name":"Salvador"},{"id":784,"alpha2":"ae","alpha3":"are","name":"Émirats arabes unis"},{"id":218,"alpha2":"ec","alpha3":"ecu","name":"Équateur"},{"id":232,"alpha2":"er","alpha3":"eri","name":"Érythrée"},{"id":724,"alpha2":"es","alpha3":"esp","name":"Espagne"},{"id":233,"alpha2":"ee","alpha3":"est","name":"Estonie"},{"id":840,"alpha2":"us","alpha3":"usa","name":"États-Unis"},{"id":231,"alpha2":"et","alpha3":"eth","name":"Éthiopie"},{"id":238,"alpha2":"fk","alpha3":"flk","name":"Malouines"},{"id":234,"alpha2":"fo","alpha3":"fro","name":"Îles Féroé"},{"id":242,"alpha2":"fj","alpha3":"fji","name":"Fidji"},{"id":246,"alpha2":"fi","alpha3":"fin","name":"Finlande"},{"id":250,"alpha2":"fr","alpha3":"fra","name":"France"},{"id":266,"alpha2":"ga","alpha3":"gab","name":"Gabon"},{"id":270,"alpha2":"gm","alpha3":"gmb","name":"Gambie"},{"id":268,"alpha2":"ge","alpha3":"geo","name":"Géorgie"},{"id":239,"alpha2":"gs","alpha3":"sgs","name":"Géorgie du Sud-et-les îles Sandwich du Sud"},{"id":288,"alpha2":"gh","alpha3":"gha","name":"Ghana"},{"id":292,"alpha2":"gi","alpha3":"gib","name":"Gibraltar"},{"id":300,"alpha2":"gr","alpha3":"grc","name":"Grèce"},{"id":308,"alpha2":"gd","alpha3":"grd","name":"Grenade"},{"id":304,"alpha2":"gl","alpha3":"grl","name":"Groenland"},{"id":312,"alpha2":"gp","alpha3":"glp","name":"Guadeloupe"},{"id":316,"alpha2":"gu","alpha3":"gum","name":"Guam"},{"id":320,"alpha2":"gt","alpha3":"gtm","name":"Guatemala"},{"id":831,"alpha2":"gg","alpha3":"ggy","name":"Guernesey"},{"id":324,"alpha2":"gn","alpha3":"gin","name":"Guinée"},{"id":624,"alpha2":"gw","alpha3":"gnb","name":"Guinée-Bissau"},{"id":226,"alpha2":"gq","alpha3":"gnq","name":"Guinée équatoriale"},{"id":328,"alpha2":"gy","alpha3":"guy","name":"Guyana"},{"id":254,"alpha2":"gf","alpha3":"guf","name":"Guyane"},{"id":332,"alpha2":"ht","alpha3":"hti","name":"Haïti"},{"id":334,"alpha2":"hm","alpha3":"hmd","name":"Îles Heard-et-MacDonald"},{"id":340,"alpha2":"hn","alpha3":"hnd","name":"Honduras"},{"id":344,"alpha2":"hk","alpha3":"hkg","name":"Hong Kong"},{"id":348,"alpha2":"hu","alpha3":"hun","name":"Hongrie"},{"id":833,"alpha2":"im","alpha3":"imn","name":"Île de Man"},{"id":581,"alpha2":"um","alpha3":"umi","name":"Îles mineures éloignées des États-Unis"},{"id":92,"alpha2":"vg","alpha3":"vgb","name":"Îles Vierges britanniques"},{"id":850,"alpha2":"vi","alpha3":"vir","name":"Îles Vierges des États-Unis"},{"id":356,"alpha2":"in","alpha3":"ind","name":"Inde"},{"id":360,"alpha2":"id","alpha3":"idn","name":"Indonésie"},{"id":364,"alpha2":"ir","alpha3":"irn","name":"Iran"},{"id":368,"alpha2":"iq","alpha3":"irq","name":"Irak"},{"id":372,"alpha2":"ie","alpha3":"irl","name":"Irlande"},{"id":352,"alpha2":"is","alpha3":"isl","name":"Islande"},{"id":376,"alpha2":"il","alpha3":"isr","name":"Israël"},{"id":380,"alpha2":"it","alpha3":"ita","name":"Italie"},{"id":388,"alpha2":"jm","alpha3":"jam","name":"Jamaïque"},{"id":392,"alpha2":"jp","alpha3":"jpn","name":"Japon"},{"id":832,"alpha2":"je","alpha3":"jey","name":"Jersey"},{"id":400,"alpha2":"jo","alpha3":"jor","name":"Jordanie"},{"id":398,"alpha2":"kz","alpha3":"kaz","name":"Kazakhstan"},{"id":404,"alpha2":"ke","alpha3":"ken","name":"Kenya"},{"id":417,"alpha2":"kg","alpha3":"kgz","name":"Kirghizistan"},{"id":296,"alpha2":"ki","alpha3":"kir","name":"Kiribati"},{"id":414,"alpha2":"kw","alpha3":"kwt","name":"Koweït"},{"id":418,"alpha2":"la","alpha3":"lao","name":"Laos"},{"id":426,"alpha2":"ls","alpha3":"lso","name":"Lesotho"},{"id":428,"alpha2":"lv","alpha3":"lva","name":"Lettonie"},{"id":422,"alpha2":"lb","alpha3":"lbn","name":"Liban"},{"id":430,"alpha2":"lr","alpha3":"lbr","name":"Liberia"},{"id":434,"alpha2":"ly","alpha3":"lby","name":"Libye"},{"id":438,"alpha2":"li","alpha3":"lie","name":"Liechtenstein"},{"id":440,"alpha2":"lt","alpha3":"ltu","name":"Lituanie"},{"id":442,"alpha2":"lu","alpha3":"lux","name":"Luxembourg"},{"id":446,"alpha2":"mo","alpha3":"mac","name":"Macao"},{"id":807,"alpha2":"mk","alpha3":"mkd","name":"Macédoine du Nord"},{"id":450,"alpha2":"mg","alpha3":"mdg","name":"Madagascar"},{"id":458,"alpha2":"my","alpha3":"mys","name":"Malaisie"},{"id":454,"alpha2":"mw","alpha3":"mwi","name":"Malawi"},{"id":462,"alpha2":"mv","alpha3":"mdv","name":"Maldives"},{"id":466,"alpha2":"ml","alpha3":"mli","name":"Mali"},{"id":470,"alpha2":"mt","alpha3":"mlt","name":"Malte"},{"id":580,"alpha2":"mp","alpha3":"mnp","name":"Îles Mariannes du Nord"},{"id":504,"alpha2":"ma","alpha3":"mar","name":"Maroc"},{"id":584,"alpha2":"mh","alpha3":"mhl","name":"Îles Marshall"},{"id":474,"alpha2":"mq","alpha3":"mtq","name":"Martinique"},{"id":480,"alpha2":"mu","alpha3":"mus","name":"Maurice"},{"id":478,"alpha2":"mr","alpha3":"mrt","name":"Mauritanie"},{"id":175,"alpha2":"yt","alpha3":"myt","name":"Mayotte"},{"id":484,"alpha2":"mx","alpha3":"mex","name":"Mexique"},{"id":583,"alpha2":"fm","alpha3":"fsm","name":"États fédérés de Micronésie"},{"id":498,"alpha2":"md","alpha3":"mda","name":"Moldavie"},{"id":492,"alpha2":"mc","alpha3":"mco","name":"Monaco"},{"id":496,"alpha2":"mn","alpha3":"mng","name":"Mongolie"},{"id":499,"alpha2":"me","alpha3":"mne","name":"Monténégro"},{"id":500,"alpha2":"ms","alpha3":"msr","name":"Montserrat"},{"id":508,"alpha2":"mz","alpha3":"moz","name":"Mozambique"},{"id":104,"alpha2":"mm","alpha3":"mmr","name":"Birmanie"},{"id":516,"alpha2":"na","alpha3":"nam","name":"Namibie"},{"id":520,"alpha2":"nr","alpha3":"nru","name":"Nauru"},{"id":524,"alpha2":"np","alpha3":"npl","name":"Népal"},{"id":558,"alpha2":"ni","alpha3":"nic","name":"Nicaragua"},{"id":562,"alpha2":"ne","alpha3":"ner","name":"Niger"},{"id":566,"alpha2":"ng","alpha3":"nga","name":"Nigeria"},{"id":570,"alpha2":"nu","alpha3":"niu","name":"Niue"},{"id":574,"alpha2":"nf","alpha3":"nfk","name":"Île Norfolk"},{"id":578,"alpha2":"no","alpha3":"nor","name":"Norvège"},{"id":540,"alpha2":"nc","alpha3":"ncl","name":"Nouvelle-Calédonie"},{"id":554,"alpha2":"nz","alpha3":"nzl","name":"Nouvelle-Zélande"},{"id":86,"alpha2":"io","alpha3":"iot","name":"Territoire britannique de l\'océan Indien"},{"id":512,"alpha2":"om","alpha3":"omn","name":"Oman"},{"id":800,"alpha2":"ug","alpha3":"uga","name":"Ouganda"},{"id":860,"alpha2":"uz","alpha3":"uzb","name":"Ouzbékistan"},{"id":586,"alpha2":"pk","alpha3":"pak","name":"Pakistan"},{"id":585,"alpha2":"pw","alpha3":"plw","name":"Palaos"},{"id":275,"alpha2":"ps","alpha3":"pse","name":"Palestine"},{"id":591,"alpha2":"pa","alpha3":"pan","name":"Panama"},{"id":598,"alpha2":"pg","alpha3":"png","name":"Papouasie-Nouvelle-Guinée"},{"id":600,"alpha2":"py","alpha3":"pry","name":"Paraguay"},{"id":528,"alpha2":"nl","alpha3":"nld","name":"Pays-Bas"},{"id":604,"alpha2":"pe","alpha3":"per","name":"Pérou"},{"id":608,"alpha2":"ph","alpha3":"phl","name":"Philippines"},{"id":612,"alpha2":"pn","alpha3":"pcn","name":"Îles Pitcairn"},{"id":616,"alpha2":"pl","alpha3":"pol","name":"Pologne"},{"id":258,"alpha2":"pf","alpha3":"pyf","name":"Polynésie française"},{"id":630,"alpha2":"pr","alpha3":"pri","name":"Porto Rico"},{"id":620,"alpha2":"pt","alpha3":"prt","name":"Portugal"},{"id":634,"alpha2":"qa","alpha3":"qat","name":"Qatar"},{"id":638,"alpha2":"re","alpha3":"reu","name":"La Réunion"},{"id":642,"alpha2":"ro","alpha3":"rou","name":"Roumanie"},{"id":826,"alpha2":"gb","alpha3":"gbr","name":"Royaume-Uni"},{"id":643,"alpha2":"ru","alpha3":"rus","name":"Russie"},{"id":646,"alpha2":"rw","alpha3":"rwa","name":"Rwanda"},{"id":732,"alpha2":"eh","alpha3":"esh","name":"République arabe sahraouie démocratique"},{"id":652,"alpha2":"bl","alpha3":"blm","name":"Saint-Barthélemy"},{"id":659,"alpha2":"kn","alpha3":"kna","name":"Saint-Christophe-et-Niévès"},{"id":674,"alpha2":"sm","alpha3":"smr","name":"Saint-Marin"},{"id":663,"alpha2":"mf","alpha3":"maf","name":"Saint-Martin"},{"id":534,"alpha2":"sx","alpha3":"sxm","name":"Saint-Martin"},{"id":666,"alpha2":"pm","alpha3":"spm","name":"Saint-Pierre-et-Miquelon"},{"id":336,"alpha2":"va","alpha3":"vat","name":"Saint-Siège (État de la Cité du Vatican)"},{"id":670,"alpha2":"vc","alpha3":"vct","name":"Saint-Vincent-et-les-Grenadines"},{"id":654,"alpha2":"sh","alpha3":"shn","name":"Sainte-Hélène, Ascension et Tristan da Cunha"},{"id":662,"alpha2":"lc","alpha3":"lca","name":"Sainte-Lucie"},{"id":90,"alpha2":"sb","alpha3":"slb","name":"Îles Salomon"},{"id":882,"alpha2":"ws","alpha3":"wsm","name":"Samoa"},{"id":16,"alpha2":"as","alpha3":"asm","name":"Samoa américaines"},{"id":678,"alpha2":"st","alpha3":"stp","name":"Sao Tomé-et-Principe"},{"id":686,"alpha2":"sn","alpha3":"sen","name":"Sénégal"},{"id":688,"alpha2":"rs","alpha3":"srb","name":"Serbie"},{"id":690,"alpha2":"sc","alpha3":"syc","name":"Seychelles"},{"id":694,"alpha2":"sl","alpha3":"sle","name":"Sierra Leone"},{"id":702,"alpha2":"sg","alpha3":"sgp","name":"Singapour"},{"id":703,"alpha2":"sk","alpha3":"svk","name":"Slovaquie"},{"id":705,"alpha2":"si","alpha3":"svn","name":"Slovénie"},{"id":706,"alpha2":"so","alpha3":"som","name":"Somalie"},{"id":729,"alpha2":"sd","alpha3":"sdn","name":"Soudan"},{"id":728,"alpha2":"ss","alpha3":"ssd","name":"Soudan du Sud"},{"id":144,"alpha2":"lk","alpha3":"lka","name":"Sri Lanka"},{"id":752,"alpha2":"se","alpha3":"swe","name":"Suède"},{"id":756,"alpha2":"ch","alpha3":"che","name":"Suisse"},{"id":740,"alpha2":"sr","alpha3":"sur","name":"Suriname"},{"id":744,"alpha2":"sj","alpha3":"sjm","name":"Svalbard et ile Jan Mayen"},{"id":748,"alpha2":"sz","alpha3":"swz","name":"Eswatini"},{"id":760,"alpha2":"sy","alpha3":"syr","name":"Syrie"},{"id":762,"alpha2":"tj","alpha3":"tjk","name":"Tadjikistan"},{"id":158,"alpha2":"tw","alpha3":"twn","name":"Taïwan / (République de Chine (Taïwan))"},{"id":834,"alpha2":"tz","alpha3":"tza","name":"Tanzanie"},{"id":148,"alpha2":"td","alpha3":"tcd","name":"Tchad"},{"id":203,"alpha2":"cz","alpha3":"cze","name":"Tchéquie"},{"id":260,"alpha2":"tf","alpha3":"atf","name":"Terres australes et antarctiques françaises"},{"id":764,"alpha2":"th","alpha3":"tha","name":"Thaïlande"},{"id":626,"alpha2":"tl","alpha3":"tls","name":"Timor oriental"},{"id":768,"alpha2":"tg","alpha3":"tgo","name":"Togo"},{"id":772,"alpha2":"tk","alpha3":"tkl","name":"Tokelau"},{"id":776,"alpha2":"to","alpha3":"ton","name":"Tonga"},{"id":780,"alpha2":"tt","alpha3":"tto","name":"Trinité-et-Tobago"},{"id":788,"alpha2":"tn","alpha3":"tun","name":"Tunisie"},{"id":795,"alpha2":"tm","alpha3":"tkm","name":"Turkménistan"},{"id":796,"alpha2":"tc","alpha3":"tca","name":"Îles Turques-et-Caïques"},{"id":792,"alpha2":"tr","alpha3":"tur","name":"Turquie"},{"id":798,"alpha2":"tv","alpha3":"tuv","name":"Tuvalu"},{"id":804,"alpha2":"ua","alpha3":"ukr","name":"Ukraine"},{"id":858,"alpha2":"uy","alpha3":"ury","name":"Uruguay"},{"id":548,"alpha2":"vu","alpha3":"vut","name":"Vanuatu"},{"id":862,"alpha2":"ve","alpha3":"ven","name":"Venezuela"},{"id":704,"alpha2":"vn","alpha3":"vnm","name":"Viêt Nam"},{"id":876,"alpha2":"wf","alpha3":"wlf","name":"Wallis-et-Futuna"},{"id":887,"alpha2":"ye","alpha3":"yem","name":"Yémen"},{"id":894,"alpha2":"zm","alpha3":"zmb","name":"Zambie"},{"id":716,"alpha2":"zw","alpha3":"zwe","name":"Zimbabwe"}]');

/***/ }),

/***/ 56112:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);




function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

pdfMake.vfs = pdfFonts.pdfMake.vfs;
var PDF = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function PDF(r) {
    _classCallCheck(this, PDF);
    this.record = r;
  }
  return _createClass(PDF, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var docDefinition;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getBase64Image(this.record.Image.id, this.record.Image.url, null, 0.5);
            case 2:
              _context.t0 = _context.sent;
              _context.t1 = [0, 0, 0, 5];
              _context.t2 = {
                image: _context.t0,
                width: 515,
                margin: _context.t1
              };
              _context.t3 = {
                layout: 'noBorders',
                // optional
                table: {
                  widths: ['35%', '15%', '15%', '35%'],
                  body: [[{
                    text: tr('PROPOSE OF TRAVEL FOR') + ':',
                    style: 'header1'
                  }, {
                    text: tr('DURATION') + ':',
                    style: 'header1'
                  }, {
                    text: tr('TRIP MODE' + ':'),
                    style: 'header1'
                  }, {
                    text: tr('DIFFICULTY') + ':',
                    style: 'header1'
                  }], [{
                    text: this.record.PaxName,
                    style: 'header2'
                  }, {
                    text: this.record.BookingDays.length + ' ' + tr('Days'),
                    style: 'header2'
                  }, {
                    text: tr(this.record.TripMode.Name),
                    style: 'header2'
                  }, {
                    text: tr(this.record.Difficulty),
                    style: 'header2'
                  }]]
                }
              };
              _context.t4 = ['3%', '94%', '3%'];
              _context.t5 = {};
              _context.t6 = ['100%'];
              _context.next = 11;
              return this.getBase64Image(this.record.User.Image.id, this.record.User.Image.url, {
                width: 10,
                color: '#ffffff'
              });
            case 11:
              _context.t7 = _context.sent;
              _context.t8 = [0, 5, 0, 0];
              _context.t9 = {
                image: _context.t7,
                width: 80,
                alignment: 'center',
                margin: _context.t8
              };
              _context.t10 = [_context.t9];
              _context.t11 = [{
                text: this.record.User.FirstName + ' ' + this.record.User.LastName,
                style: 'userProfile'
              }];
              _context.t12 = [{
                text: 'Travel Advisor',
                style: 'userProfile'
              }];
              _context.t13 = [{
                text: this.record.User.Email,
                style: 'userProfile'
              }];
              _context.t14 = [{
                text: this.record.User.Phone,
                style: 'userProfile'
              }];
              _context.t15 = [_context.t10, _context.t11, _context.t12, _context.t13, _context.t14];
              _context.t16 = {
                widths: _context.t6,
                body: _context.t15
              };
              _context.t17 = {
                alignment: 'center',
                layout: 'noBorders',
                fillColor: '#224061',
                table: _context.t16
              };
              _context.t18 = {};
              _context.t19 = [_context.t5, _context.t17, _context.t18];
              _context.t20 = [{}, {
                text: this.getUserProfile,
                italics: true,
                fontSize: 8,
                alignment: 'justify'
              }, {}];
              _context.t21 = [_context.t19, _context.t20];
              _context.t22 = {
                widths: _context.t4,
                body: _context.t21
              };
              _context.t23 = {
                layout: 'noBorders',
                fillColor: '#F1F1F2',
                table: _context.t22
              };
              _context.t24 = {
                width: '33%',
                stack: this.getStacks([{
                  text: this.record.Title,
                  style: 'bookingTitle',
                  margin: [0, 0, 0, 3]
                }, {
                  text: this.record.Summary,
                  style: 'bookingSummary',
                  html: true
                }])
              };
              _context.t25 = [_context.t23, _context.t24];
              _context.t26 = [0, 5, 0, 5];
              _context.t27 = {
                columns: _context.t25,
                margin: _context.t26,
                columnGap: 10
              };
              _context.t28 = ['100%'];
              _context.next = 35;
              return this.getDaysObjects();
            case 35:
              _context.t29 = _context.sent;
              _context.t30 = {
                widths: _context.t28,
                body: _context.t29
              };
              _context.t31 = {
                layout: 'noBorders',
                table: _context.t30
              };
              _context.t32 = [_context.t2, _context.t3, _context.t27, _context.t31];
              _context.t33 = function pageBreakBefore(currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
                if (currentNode.id == 'day0') return true;
                return currentNode.headlineLevel === 1 && followingNodesOnPage.length === 0;
              };
              _context.t34 = {
                header1: {
                  color: '#ffffff',
                  background: '#224061',
                  fontSize: 8,
                  bold: false,
                  alignment: 'center',
                  fillColor: '#224061',
                  margin: [10, 5, 10, 0]
                },
                header2: {
                  color: '#ffffff',
                  background: '#224061',
                  fontSize: 8,
                  bold: true,
                  alignment: 'center',
                  fillColor: '#224061',
                  margin: [10, 0, 10, 5]
                },
                bookingTitle: {
                  color: '#224061',
                  fontSize: 12,
                  bold: true,
                  italics: true,
                  alignment: 'left'
                },
                bookingSummary: {
                  color: '#224061',
                  lineHeight: 1.2,
                  fontSize: 10,
                  bold: false,
                  italics: true,
                  alignment: 'justify'
                },
                serviceText: {
                  color: '#224061',
                  lineHeight: 1.2,
                  fontSize: 8,
                  alignment: 'justify'
                },
                userProfile: {
                  alignment: 'center',
                  lineHeight: 1.2,
                  bold: true,
                  fontSize: 7,
                  color: '#ffffff',
                  margin: [2, 0, 2, 0]
                }
              };
              docDefinition = {
                content: _context.t32,
                pageBreakBefore: _context.t33,
                styles: _context.t34
              };
              //console.log(docDefinition)
              pdfMake.createPdf(docDefinition).open();
              this.$emit('update:processingPDF', false);
              clearInterval(this.intervalPDF);
            case 45:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function create() {
        return _create.apply(this, arguments);
      }
      return create;
    }()
  }, {
    key: "replaceTagP",
    value: function replaceTagP(t) {
      var start = t.indexOf('<p ');
      var end = t.indexOf('>', start);
      var tag = t.substring(start, end + 1);
      return t.replace(tag, '');
    }
  }, {
    key: "getStacks",
    value: function getStacks(objects) {
      var res = [];
      var _iterator = _createForOfIteratorHelper(objects),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var o = _step.value;
          if (!o.html) {
            res.push(o);
          } else {
            if (!o.text) continue;
            var texts = o.text.replace(/&nbsp;/g, '').replace(/<p>/g, '').replace(/<ul>/g, '').replace(/<\/ul>/g, '').replace(/(\r\n|\n|\r)/g, '<br>').replace(/<li><br><\/li>/g, '').replace(/<br><\/li>/g, '').replace(/<\/p>/g, '<br>').split('<br>');
            var nextTag = void 0;
            var _iterator3 = _createForOfIteratorHelper(texts),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var _t = _step3.value;
                this.processingText = _t;
                if (nextTag) {
                  _t = '<' + nextTag + '>' + _t;
                }
                var lastTag = this.getLastTag(_t);
                if (lastTag) {
                  _t += '</' + lastTag + '>';
                  nextTag = lastTag;
                } else {
                  nextTag;
                }
                var _r = {
                  style: o.style
                };
                _r.text = this.getStyleText(_t);
                res.push(_r);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var r = [];
      for (var _i = 0, _res = res; _i < _res.length; _i++) {
        var p = _res[_i];
        var bullets = false;
        var _iterator2 = _createForOfIteratorHelper(p.text),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var t = _step2.value;
            if (t.bullet) {
              bullets = true;
              r.push({
                style: p.style,
                bullet: {
                  level: 0
                },
                text: [t]
              });
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        if (!bullets) {
          r.push(p);
        }
      }
      //console.log(r)
      return r;
    }
  }, {
    key: "getStyleText",
    value: function getStyleText(t) {
      var res = t;
      if (res.indexOf('<p ') > -1) {
        res = this.replaceTagP(res);
      }
      res = res.replace(/&amp;/g, '&');
      var styles = [];
      var style = this.processTag(res);
      while (style && style.text) {
        if (style.style) {
          styles.push(style.style);
        }
        style = this.processTag(style.text);
      }
      if (style && style.style) {
        styles.push(style.style);
      }
      return styles;
    }
  }, {
    key: "processTag",
    value: function processTag(t) {
      var nextTag = this.getTag(t);
      if (nextTag) {
        if (nextTag.start > 0) {
          var style = {};
          style.text = t.substring(0, nextTag.start);
          return {
            style: style,
            text: t.substring(nextTag.start, t.length)
          };
        } else {
          var text = t.substring(nextTag.start, nextTag.closeTag);
          return {
            style: this.getTagStyle(text),
            text: t.substring(nextTag.closeTag, t.length)
          };
        }
      } else {
        var _style = {};
        _style.text = t.substring(0, t.length);
        return {
          style: _style,
          text: null
        };
      }
    }
  }, {
    key: "getTagStyle",
    value: function getTagStyle(text, object) {
      var t = text;
      var res = {};
      if (object) res = object;
      if (t.indexOf('style') > -1 || t.indexOf('class=') > -1) {
        if (t.indexOf('color: rgb') > -1) {
          var colors = t.substring(t.indexOf('rgb(') + 4, t.indexOf(')', t.indexOf('rgb(')));
          var c = colors.split(',');
          var color = this.fullColorHex(parseInt(c[0]), parseInt(c[1]), parseInt(c[2]));
          res.color = '#' + color;
        }
        //let tag = t.substring(t.indexOf('<')+1, t.indexOf(' ', t.indexOf('<')));
        var tag = this.getTagName(t, t.indexOf('<'), t.length - 1);
        if (t.indexOf('ql-align-justify') > -1) res.justify = true;
        if (tag == 'strong') res.bold = true;
        if (tag == 'em') res.italics = true;
        if (tag == 'li') res.bullet = true;
        if (tag == 'u') res.decoration = 'underline';
        var tagEnd = t.indexOf('>', t.indexOf('<') + 1);
        var completeTag = t.substring(t.indexOf('<'), tagEnd + 1);
        t = t.replace(completeTag, "").replace("</" + tag + ">", "");
      }
      if (t.indexOf("<strong>") > -1) {
        t = t.replace("<strong>", "").replace("</strong>", "");
        res.bold = true;
      }
      if (t.indexOf("<em>") > -1) {
        t = t.replace("<em>", "").replace("</em>", "");
        res.italics = true;
      }
      if (t.indexOf("<u>") > -1) {
        t = t.replace("<u>", "").replace("</u>", "");
        res.decoration = 'underline';
      }
      if (t.indexOf("<ul>") > -1) {
        t = t.replace("<ul>", "").replace("</ul>", "");
      }
      if (t.indexOf("<li>") > -1) {
        t = t.replace("<li>", "").replace("</li>", "");
        res.bullet = true;
      }
      var containsTags = t.indexOf('<') > -1 && t.indexOf('</') > -1;
      if (containsTags) {
        res = this.getTagStyle(t, res);
        return res;
      } else {
        res.text = t;
        return res;
      }
    }
  }, {
    key: "getTag",
    value: function getTag(t) {
      var tagStart = t.indexOf("<");
      var tagEnd = -1;
      if (tagStart > -1) {
        tagEnd = t.indexOf(">", tagStart);
      }
      if (tagStart > -1 && tagEnd > -1) {
        var tag = this.getTagName(t, tagStart, tagEnd);
        //let tag = t.substring(tagStart+1, tagEnd);
        var closeTag = t.indexOf("</" + tag + ">", tagEnd);
        //console.log(t, tag, closeTag);
        return {
          tag: t.substring(tagStart + 1, tagEnd),
          start: tagStart,
          end: tagEnd,
          closeTag: closeTag + tag.length + 3
        };
      }
    }
  }, {
    key: "getLastTag",
    value: function getLastTag(t) {
      var tagStart = t.lastIndexOf("<");
      if (t[tagStart + 1] == '/') return;
      var tagEnd = -1;
      if (tagStart > -1) {
        tagEnd = t.indexOf(">", tagStart);
      }
      if (tagStart > -1 && tagEnd > -1) {
        var tag = this.getTagName(t, tagStart, tagEnd);
        var closeTag = t.indexOf("</" + tag + ">", tagEnd);
        if (closeTag == -1) {
          return tag;
        }
      }
    }
  }, {
    key: "getTagName",
    value: function getTagName(text, start, end) {
      var t = text.substring(start, end + 1);
      var tagEnd1 = t.indexOf(" ");
      var tagEnd2 = t.indexOf(">");
      var lTags = [];
      if (tagEnd1 > -1) lTags.push(tagEnd1);
      if (tagEnd2 > -1) lTags.push(tagEnd2);
      var tagEnd = Math.min.apply(Math, lTags);
      return t.substring(t.indexOf('<') + 1, tagEnd);
    }
  }, {
    key: "rgbToHex",
    value: function rgbToHex(rgb) {
      var hex = Number(rgb).toString(16);
      if (hex.length < 2) {
        hex = "0" + hex;
      }
      return hex;
    }
  }, {
    key: "fullColorHex",
    value: function fullColorHex(r, g, b) {
      var red = this.rgbToHex(r);
      var green = this.rgbToHex(g);
      var blue = this.rgbToHex(b);
      return red + green + blue;
    }
  }, {
    key: "getDaysObjects",
    value: function () {
      var _getDaysObjects = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res, i, day;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              res = [];
              _context2.t0 = _regeneratorRuntime.keys(this.getSortedDays);
            case 2:
              if ((_context2.t1 = _context2.t0()).done) {
                _context2.next = 13;
                break;
              }
              i = _context2.t1.value;
              day = this.getSortedDays[i];
              _context2.t2 = res;
              _context2.next = 8;
              return this.dayPrintObject(day, i);
            case 8:
              _context2.t3 = _context2.sent;
              _context2.t4 = [_context2.t3];
              _context2.t2.push.call(_context2.t2, _context2.t4);
              _context2.next = 2;
              break;
            case 13:
              return _context2.abrupt("return", res);
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getDaysObjects() {
        return _getDaysObjects.apply(this, arguments);
      }
      return getDaysObjects;
    }()
  }, {
    key: "dayPrintObject",
    value: function () {
      var _dayPrintObject = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(day, dayNr) {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = _defineProperty;
              _context3.t1 = _defineProperty({
                id: 'day' + day.DayNr,
                layout: 'noBorders'
              }, "layout", {
                hLineWidth: function hLineWidth(i, node) {
                  return 1;
                },
                vLineWidth: function vLineWidth(i, node) {
                  return 0.5;
                },
                hLineColor: function hLineColor(i, node) {
                  return 'black';
                },
                vLineColor: function vLineColor(i, node) {
                  return '#224061';
                }
              });
              _context3.t2 = ['10%', '50%', '40%'];
              _context3.t3 = [{
                border: [false, false, true, false],
                fillColor: '#F1F1F2',
                stack: [{
                  text: tr('Day'),
                  alignment: 'center',
                  color: '#224061',
                  fontSize: 10
                }, {
                  text: this.getDatesText(day),
                  alignment: 'center',
                  bold: true,
                  color: '#224061',
                  fontSize: 10
                }]
              }, {
                border: [false, false, false, false],
                fillColor: '#F1F1F2',
                margin: [10, 0, 0, 0],
                stack: [{
                  text: this.getCitiesNames(day),
                  alignment: 'left',
                  color: '#224061',
                  bold: true,
                  fontSize: 10
                }, {
                  text: day.Title,
                  alignment: 'left',
                  color: '#224061',
                  fontSize: 10
                }]
              }, {
                border: [false, false, false, false],
                fillColor: '#F1F1F2',
                text: ''
              }];
              _context3.t4 = {
                border: [false, false, true, false],
                margin: [0, 5, 0, 0],
                fillColor: '#FFFFFF',
                text: ''
              };
              _context3.t5 = {
                border: [false, false, false, false],
                margin: [10, 5, 0, 0],
                fillColor: '#FFFFFF',
                stack: this.getServiceObjects(day)
              };
              _context3.t6 = [false, false, false, false];
              _context3.next = 9;
              return this.getBase64Image(day.Image.id, day.Image.url, null, 0.5);
            case 9:
              _context3.t7 = _context3.sent;
              _context3.t8 = [0, 5, 0, 0];
              _context3.t9 = {
                border: _context3.t6,
                image: _context3.t7,
                width: 180,
                alignment: 'center',
                margin: _context3.t8,
                fillColor: '#FFFFFF'
              };
              _context3.t10 = [_context3.t4, _context3.t5, _context3.t9];
              _context3.t11 = [_context3.t3, _context3.t10];
              _context3.t12 = {
                widths: _context3.t2,
                body: _context3.t11
              };
              res = (0, _context3.t0)(_context3.t1, "table", _context3.t12);
              return _context3.abrupt("return", res);
            case 17:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function dayPrintObject(_x, _x2) {
        return _dayPrintObject.apply(this, arguments);
      }
      return dayPrintObject;
    }()
  }, {
    key: "setSelectedHotel",
    value: function setSelectedHotel(dayNr, i) {
      this.hotelSelected[dayNr] = i;
      this.hotelSelected = Object.assign({}, this.hotelSelected);
    }
  }, {
    key: "getServiceObjects",
    value: function getServiceObjects(day) {
      var stacks = [];
      this.processingDayNr = day.DayNr + 1;
      var _iterator4 = _createForOfIteratorHelper(day.BookingDayServices),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var s = _step4.value;
          stacks.push({
            text: s.Description,
            html: true,
            style: 'serviceText'
          });
          if (!this.typeOfServices[day.DayNr] && s.Service.ServiceType && s.Description && s.Description.length > 0) {
            var text = 'Type of service' + ': ' + s.Service.ServiceType.Name;
            //console.log(33, text);
            stacks.push({
              text: text,
              html: true,
              italics: true,
              bold: true,
              style: 'serviceText'
            });
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      var res = this.getStacks(stacks);
      return res;
    }
  }, {
    key: "getHotelObjects",
    value: function getHotelObjects(hotelDescription) {
      var stacks = [];
      stacks.push({
        text: hotelDescription,
        html: true,
        style: 'serviceText'
      });
      var res = this.getStacks(stacks);
      return res;
    }
  }]);
}()));

/***/ }),

/***/ 56117:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8818);









function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var HotelView = /*#__PURE__*/function (_View) {
  function HotelView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, HotelView);
    return _callSuper(this, HotelView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(HotelView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(HotelView, null, [{
    key: "options",
    value: function options() {
      return {
        fieldsOrder: ['Name', 'RoomCategories', 'HotelRoomTypes', 'RoomPrograms', 'HotelDescriptions', 'HotelPhotos'],
        fieldsAbmList: ['Name', 'Type', 'CityId', 'SupplierId', 'HotelCategoryId', 'Address', 'Phone', 'Email'],
        fieldsDataReplace: {
          SupplierId: {
            name: 'SupplierId',
            relation: 'supplier',
            optionLabels: 'Name',
            editor: 'vue-select',
            label: 'Supplier',
            filters: function filters(r) {
              return r.SupplierType == 'HOTEL' || r.SupplierType == 'MIXED' || r.SupplierType == 'ALL';
            },
            requiredCallback: function requiredCallback(r) {
              return !r.CreateSupplier;
            }
          },
          Comment: {
            name: 'Comment',
            label: 'Notes',
            editor: 'tab',
            hideFromList: true,
            icon: 'comment-dots',
            fields: [{
              name: 'Comment',
              hideFromList: true,
              editor: 'text-area',
              columns: 12,
              rows: 10
            }]
          },
          Commision: {
            name: 'Commision',
            label: '% Commission',
            editor: 'number',
            hideFromList: true,
            readonlyIf: function readonlyIf(record) {
              return !record.CommisionPrice;
            }
          },
          RoomCategories: {
            name: 'RoomCategories',
            editor: [],
            label: 'Categories',
            fieldName: 'RoomCategories',
            icon: 'bed',
            closeRow: true,
            filterRow: function filterRow(row) {
              return !row.Program;
            },
            rowFields: [{
              name: 'Program',
              hidden: true,
              defValue: false
            }, {
              name: 'ServiceId',
              hidden: true
            }, {
              name: 'AddingMode',
              hidden: true
            }, {
              name: 'ServiceDaysQty',
              hidden: true
            }, {
              name: 'Name',
              label: 'Category',
              columns: 2,
              required: true
            }, {
              name: 'Comment',
              label: 'Comment',
              columns: 4
            }, {
              name: 'NoBreakfast',
              label: 'No Breakfast',
              editor: 'checkbox',
              hideIf: function hideIf(row, parent) {
                return !(parent && parent.MealsByCategory);
              },
              checkHead: true
            }, {
              name: 'BoxLunch',
              label: 'Box Lunch',
              editor: 'checkbox',
              hideIf: function hideIf(row, parent) {
                return !(parent && parent.MealsByCategory);
              },
              checkHead: true
            }, {
              name: 'Dinner',
              label: 'Dinner',
              editor: 'checkbox',
              hideIf: function hideIf(row, parent) {
                return !(parent && parent.MealsByCategory);
              },
              checkHead: true
            }, {
              name: 'Lunch',
              label: 'Lunch',
              editor: 'checkbox',
              hideIf: function hideIf(row, parent) {
                return !(parent && parent.MealsByCategory);
              },
              checkHead: true
            }, {
              name: 'Snack',
              label: 'Snack',
              editor: 'checkbox',
              hideIf: function hideIf(row, parent) {
                return !(parent && parent.MealsByCategory);
              },
              checkHead: true
            }, {
              name: 'Closed',
              hidden: true
            }],
            hideFromList: true
          },
          HotelRoomTypes: {
            name: 'HotelRoomTypes',
            editor: [],
            label: 'Types',
            icon: 'bed',
            rowFields: [{
              name: 'RoomTypeId',
              label: 'Type',
              optionLabels: 'Name',
              relation: 'roomtype',
              columns: 2,
              editor: 'select',
              required: true
            }, {
              name: 'Comment',
              label: 'Comment',
              columns: 2
            }]
          },
          HotelPhotos: (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)((0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)((0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)((0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)({
            name: 'HotelPhotos',
            editor: [],
            component: 'record-image-rows',
            label: 'Images',
            hideFromList: true
          }, "editor", 'component'), "columns", 3), "icon", 'image'), "rowFields", [(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)({
            name: 'ImageId',
            setRelationTo: 'Image',
            relation: 'image'
          }, "setRelationTo", 'Image')]),
          HotelDescriptions: {
            name: 'HotelDescriptions',
            editor: 'component',
            hideFromList: true,
            component: 'languages-comp',
            icon: 'font',
            textStyle: true,
            label: 'Descriptions',
            rowFields: [{
              name: 'LanguageId',
              relation: 'language',
              optionLabels: 'Name',
              editor: 'select',
              setRelationTo: 'Language'
            }, {
              name: 'Description'
            }]
          }
        },
        extraFields: [{
          name: 'HotelCost',
          editor: 'component',
          component: 'hotel-cost-list',
          label: 'Rooms',
          icon: 'dollar-sign',
          showIf: function showIf(record) {
            var _iterator = _createForOfIteratorHelper(record.RoomCategories),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var row = _step.value;
                if (!row.id) return false;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            var _iterator2 = _createForOfIteratorHelper(record.HotelRoomTypes),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _row = _step2.value;
                if (!_row.id) return false;
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
            return record.id;
          }
        }, {
          name: 'AttachTab',
          editor: 'tab',
          label: 'Attachments',
          hideFromList: true,
          icon: 'paperclip',
          fields: [{
            name: 'Attach',
            label: 'Attachments',
            editor: 'attach',
            columns: 12
          }],
          showIf: function showIf(record) {
            return record.id;
          }
        }, {
          name: "SupplierServiceList",
          editor: "component",
          label: "Services",
          icon: 'hiking',
          component: 'supplier-service-list',
          hideCondition: function hideCondition(r) {
            if (!r.Supplier) return true;
            if (r.Supplier.SupplierType != 'MIXED' && r.Supplier.SupplierType != 'ALL') return true;
          }
        }, {
          name: 'ServiceCost',
          editor: 'component',
          component: 'supplier-service-cost-list',
          label: 'Services',
          icon: 'dollar-sign',
          hideCondition: function hideCondition(r) {
            if (!r.Supplier) return true;
            if (r.Supplier.SupplierType != 'MIXED' && r.Supplier.SupplierType != 'ALL') return true;
          }
        }],
        serverSide: true,
        beforeSave: function beforeSave(self) {
          self.periodError = null;
          self.setHotelCostToRecord();
          var res = travelTools.checkOverlap(self.periods);
          if (res) {
            self.periodError = res.overlap;
            self.addError(res.msj);
            return true;
          }
        },
        title: 'Hotels',
        canAdd: true,
        canCopy: true,
        tableOrderBy: (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)({
          ascending: true,
          column: null
        }, "column", 'Name')
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res, taxNumber, supId, roomTypes, remove, _iterator3, _step3, r;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(HotelView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              res = _context.sent;
              taxNumber = _.find(res.fields, function (r) {
                return r.name == 'TaxNumber';
              });
              if (taxNumber) taxNumber.requiredCallback = function (r) {
                return r.CreateSupplier;
              };
              supId = _.findIndex(res.fields, function (r) {
                return r.name == 'SupplierId';
              });
              res.fields.splice(supId + 1, 0, {
                name: 'CreateSupplier',
                label: 'Create Supplier',
                editor: 'checkbox',
                hideFromList: true,
                readonlyIf: function readonlyIf(record) {
                  return !!record.SupplierId;
                }
              });
              roomTypes = _.findIndex(res.fields, function (r) {
                return r.name == 'HotelRoomTypes';
              });
              res.fields.splice(roomTypes + 1, 0, {
                name: 'RoomPrograms',
                editor: [],
                label: 'Programs',
                fieldName: 'RoomCategories',
                icon: 'bed',
                closeRow: true,
                filterRow: function filterRow(row) {
                  return row.Program;
                },
                rowFields: [{
                  name: 'Program',
                  hidden: true,
                  defValue: true
                }, {
                  name: 'Name',
                  label: 'Type',
                  columns: 2,
                  required: true
                }, {
                  name: 'Comment',
                  label: 'Comment',
                  columns: 4
                }, {
                  name: 'ServiceId',
                  label: 'Service',
                  relation: 'service',
                  optionLabels: 'Name',
                  editor: 'vue-select',
                  hideIf: function hideIf(row, parent) {
                    return !(parent !== null && parent !== void 0 && parent.ProgramAddServices);
                  },
                  checkHead: true
                }, {
                  name: 'AddingMode',
                  label: 'Adding Mode',
                  editor: 'select',
                  options: [{
                    value: 'FIRST_DAY',
                    label: 'First Day'
                  }, {
                    value: 'EVERY_DAY',
                    label: 'Every Day'
                  }, {
                    value: 'SET_DAYS_QTY',
                    label: 'Days Quantity'
                  }],
                  hideIf: function hideIf(row, parent) {
                    return !(parent !== null && parent !== void 0 && parent.ProgramAddServices);
                  },
                  checkHead: true
                }, {
                  name: 'ServiceDaysQty',
                  label: 'Service Days Qty',
                  editor: 'number',
                  hideIf: function hideIf(row, parent) {
                    return !(row.AddingMode == 'SET_DAYS_QTY' && parent !== null && parent !== void 0 && parent.ProgramAddServices);
                  },
                  checkHead: true
                }, {
                  name: 'Closed',
                  hidden: true
                }]
              });
              remove = ['UnitCostBy', 'PeriodCostBy', 'ProgramUnitCostBy', 'ProgramPeriodCostBy'];
              _iterator3 = _createForOfIteratorHelper(res.fields);
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  r = _step3.value;
                  if (remove.indexOf(r.name) > -1) {
                    r.showIf = function (record) {
                      return api.currentUser.UserName == 'admin';
                    };
                  }
                  ;
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              return _context.abrupt("return", res);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_4__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(HotelView, "table", 'hotel');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HotelView);

/***/ }),

/***/ 56168:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var Buffer = (__webpack_require__(92861).Buffer);
var Transform = (__webpack_require__(88310).Transform);
var StringDecoder = (__webpack_require__(83141)/* .StringDecoder */ .I);
var inherits = __webpack_require__(56698);

function CipherBase(hashMode) {
	Transform.call(this);
	this.hashMode = typeof hashMode === 'string';
	if (this.hashMode) {
		this[hashMode] = this._finalOrDigest;
	} else {
		this['final'] = this._finalOrDigest;
	}
	if (this._final) {
		this.__final = this._final;
		this._final = null;
	}
	this._decoder = null;
	this._encoding = null;
}
inherits(CipherBase, Transform);

var useUint8Array = typeof Uint8Array !== 'undefined';
var useArrayBuffer = typeof ArrayBuffer !== 'undefined'
	&& typeof Uint8Array !== 'undefined'
	&& ArrayBuffer.isView
	&& (Buffer.prototype instanceof Uint8Array || Buffer.TYPED_ARRAY_SUPPORT);

function toBuffer(data, encoding) {
	/*
	 * No need to do anything for exact instance
	 * This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
	 */
	if (data instanceof Buffer) {
		return data;
	}

	// Convert strings to Buffer
	if (typeof data === 'string') {
		return Buffer.from(data, encoding);
	}

	/*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */
	if (useArrayBuffer && ArrayBuffer.isView(data)) {
		// Bug in Node.js <6.3.1, which treats this as out-of-bounds
		if (data.byteLength === 0) {
			return Buffer.alloc(0);
		}

		var res = Buffer.from(data.buffer, data.byteOffset, data.byteLength);
		/*
		 * Recheck result size, as offset/length doesn't work on Node.js <5.10
		 * We just go to Uint8Array case if this fails
		 */
		if (res.byteLength === data.byteLength) {
			return res;
		}
	}

	/*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */
	if (useUint8Array && data instanceof Uint8Array) {
		return Buffer.from(data);
	}

	/*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */
	if (
		Buffer.isBuffer(data)
			&& data.constructor
			&& typeof data.constructor.isBuffer === 'function'
			&& data.constructor.isBuffer(data)
	) {
		return Buffer.from(data);
	}

	throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
	var bufferData = toBuffer(data, inputEnc); // asserts correct input type
	var outData = this._update(bufferData);
	if (this.hashMode) {
		return this;
	}

	if (outputEnc) {
		outData = this._toString(outData, outputEnc);
	}

	return outData;
};

CipherBase.prototype.setAutoPadding = function () {};
CipherBase.prototype.getAuthTag = function () {
	throw new Error('trying to get auth tag in unsupported state');
};

CipherBase.prototype.setAuthTag = function () {
	throw new Error('trying to set auth tag in unsupported state');
};

CipherBase.prototype.setAAD = function () {
	throw new Error('trying to set aad in unsupported state');
};

CipherBase.prototype._transform = function (data, _, next) {
	var err;
	try {
		if (this.hashMode) {
			this._update(data);
		} else {
			this.push(this._update(data));
		}
	} catch (e) {
		err = e;
	} finally {
		next(err);
	}
};
CipherBase.prototype._flush = function (done) {
	var err;
	try {
		this.push(this.__final());
	} catch (e) {
		err = e;
	}

	done(err);
};
CipherBase.prototype._finalOrDigest = function (outputEnc) {
	var outData = this.__final() || Buffer.alloc(0);
	if (outputEnc) {
		outData = this._toString(outData, outputEnc, true);
	}
	return outData;
};

CipherBase.prototype._toString = function (value, enc, fin) {
	if (!this._decoder) {
		this._decoder = new StringDecoder(enc);
		this._encoding = enc;
	}

	if (this._encoding !== enc) {
		throw new Error('can’t switch encodings');
	}

	var out = this._decoder.write(value);
	if (fin) {
		out += this._decoder.end();
	}

	return out;
};

module.exports = CipherBase;


/***/ }),

/***/ 56195:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),

/***/ 56456:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8818);









function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var HotelCostView = /*#__PURE__*/function (_View) {
  function HotelCostView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, HotelCostView);
    return _callSuper(this, HotelCostView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(HotelCostView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(HotelCostView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(HotelCostView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_4__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(HotelCostView, "table", 'hotelcost');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HotelCostView);

/***/ }),

/***/ 56464:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = {
            standalone:
                'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
                    '_'
                ),
            format: 'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
                '_'
            ),
            isFormat: /DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/,
        },
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex =
            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex:
            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex:
            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


/***/ }),

/***/ 56575:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


/***/ }),

/***/ 56698:
/***/ ((module) => {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ 56853:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8818);





function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var HotelQuoteListView = /*#__PURE__*/function (_View) {
  function HotelQuoteListView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, HotelQuoteListView);
    return _callSuper(this, HotelQuoteListView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(HotelQuoteListView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(HotelQuoteListView, null, [{
    key: "getTableOptions",
    value: function getTableOptions() {
      return {
        fields: []
      };
    }
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_2__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HotelQuoteListView);

/***/ }),

/***/ 56990:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64467);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8818);






function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var IncludesView = /*#__PURE__*/function (_View) {
  function IncludesView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, IncludesView);
    return _callSuper(this, IncludesView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(IncludesView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(IncludesView, null, [{
    key: "getTableOptions",
    value: function getTableOptions() {
      return {
        fieldsAbmList: ['LanguageId'],
        fields: [{
          name: 'LanguageId',
          relation: 'language',
          optionLabels: 'Name',
          editor: 'select',
          label: 'Language',
          required: true,
          columns: 12
        }, {
          name: 'Includes',
          label: 'Includes',
          editor: 'text-area-style',
          columns: 6
        }, {
          name: 'NotIncludes',
          label: 'Not Includes',
          editor: 'text-area-style',
          columns: 6
        }, {
          name: 'Notes',
          label: 'Notes',
          editor: 'text-area-style',
          columns: 12
        }],
        canAdd: true,
        title: 'Travel Conditions',
        tableName: 'settings',
        apiEndpoint: '/api/includes/'
      };
    }
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(IncludesView, "table", 'setting');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (IncludesView);

/***/ }),

/***/ 57447:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var BN = __webpack_require__(28490);
var HmacDRBG = __webpack_require__(32723);
var utils = __webpack_require__(47011);
var curves = __webpack_require__(60480);
var rand = __webpack_require__(15037);
var assert = utils.assert;

var KeyPair = __webpack_require__(61200);
var Signature = __webpack_require__(28545);

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(Object.prototype.hasOwnProperty.call(curves, options),
      'Unknown curve ' + options);

    options = curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray(),
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  for (;;) {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  }
};

EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
  var byteLength;
  if (BN.isBN(msg) || typeof msg === 'number') {
    msg = new BN(msg, 16);
    byteLength = msg.byteLength();
  } else if (typeof msg === 'object') {
    // BN assumes an array-like input and asserts length
    byteLength = msg.length;
    msg = new BN(msg, 16);
  } else {
    // BN converts the value to string
    var str = msg.toString();
    // HEX encoding
    byteLength = (str.length + 1) >>> 1;
    msg = new BN(str, 16);
  }
  // Allow overriding
  if (typeof bitLength !== 'number') {
    bitLength = byteLength * 8;
  }
  var delta = bitLength - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  if (typeof msg !== 'string' && typeof msg !== 'number' && !BN.isBN(msg)) {
    assert(typeof msg === 'object' && msg && typeof msg.length === 'number',
      'Expected message to be an array-like, a hex string, or a BN instance');
    assert((msg.length >>> 0) === msg.length); // non-negative 32-bit integer
    for (var i = 0; i < msg.length; i++) assert((msg[i] & 255) === msg[i]);
  }

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(msg, false, options.msgBitLength);

  // Would fail further checks, but let's make the error message clear
  assert(!msg.isNeg(), 'Can not sign a negative message');

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Recheck nonce to be bijective to msg
  assert((new BN(nonce)).eq(msg), 'Can not sign message');

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; ; iter++) {
    var k = options.k ?
      options.k(iter) :
      new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc, options) {
  if (!options)
    options = {};

  msg = this._truncateToN(msg, false, options.msgBitLength);
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);
  var p;

  if (!this.curve._maxwellTrick) {
    p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};


/***/ }),

/***/ 57609:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


/***/ }),

/***/ 57766:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(67426);
var common = __webpack_require__(66166);
var assert = __webpack_require__(43349);

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),

/***/ 57777:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


/***/ }),

/***/ 57859:
/***/ (() => {

window.modelTables.googledrivefile = true;

/***/ }),

/***/ 57975:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(65606);
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



function assertPath(path) {
  if (typeof path !== 'string') {
    throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
  }
}

// Resolves . and .. elements in a path with directory names
function normalizeStringPosix(path, allowAboveRoot) {
  var res = '';
  var lastSegmentLength = 0;
  var lastSlash = -1;
  var dots = 0;
  var code;
  for (var i = 0; i <= path.length; ++i) {
    if (i < path.length)
      code = path.charCodeAt(i);
    else if (code === 47 /*/*/)
      break;
    else
      code = 47 /*/*/;
    if (code === 47 /*/*/) {
      if (lastSlash === i - 1 || dots === 1) {
        // NOOP
      } else if (lastSlash !== i - 1 && dots === 2) {
        if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/ || res.charCodeAt(res.length - 2) !== 46 /*.*/) {
          if (res.length > 2) {
            var lastSlashIndex = res.lastIndexOf('/');
            if (lastSlashIndex !== res.length - 1) {
              if (lastSlashIndex === -1) {
                res = '';
                lastSegmentLength = 0;
              } else {
                res = res.slice(0, lastSlashIndex);
                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
              }
              lastSlash = i;
              dots = 0;
              continue;
            }
          } else if (res.length === 2 || res.length === 1) {
            res = '';
            lastSegmentLength = 0;
            lastSlash = i;
            dots = 0;
            continue;
          }
        }
        if (allowAboveRoot) {
          if (res.length > 0)
            res += '/..';
          else
            res = '..';
          lastSegmentLength = 2;
        }
      } else {
        if (res.length > 0)
          res += '/' + path.slice(lastSlash + 1, i);
        else
          res = path.slice(lastSlash + 1, i);
        lastSegmentLength = i - lastSlash - 1;
      }
      lastSlash = i;
      dots = 0;
    } else if (code === 46 /*.*/ && dots !== -1) {
      ++dots;
    } else {
      dots = -1;
    }
  }
  return res;
}

function _format(sep, pathObject) {
  var dir = pathObject.dir || pathObject.root;
  var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
  if (!dir) {
    return base;
  }
  if (dir === pathObject.root) {
    return dir + base;
  }
  return dir + sep + base;
}

var posix = {
  // path.resolve([from ...], to)
  resolve: function resolve() {
    var resolvedPath = '';
    var resolvedAbsolute = false;
    var cwd;

    for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
      var path;
      if (i >= 0)
        path = arguments[i];
      else {
        if (cwd === undefined)
          cwd = process.cwd();
        path = cwd;
      }

      assertPath(path);

      // Skip empty entries
      if (path.length === 0) {
        continue;
      }

      resolvedPath = path + '/' + resolvedPath;
      resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/;
    }

    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)

    // Normalize the path
    resolvedPath = normalizeStringPosix(resolvedPath, !resolvedAbsolute);

    if (resolvedAbsolute) {
      if (resolvedPath.length > 0)
        return '/' + resolvedPath;
      else
        return '/';
    } else if (resolvedPath.length > 0) {
      return resolvedPath;
    } else {
      return '.';
    }
  },

  normalize: function normalize(path) {
    assertPath(path);

    if (path.length === 0) return '.';

    var isAbsolute = path.charCodeAt(0) === 47 /*/*/;
    var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/;

    // Normalize the path
    path = normalizeStringPosix(path, !isAbsolute);

    if (path.length === 0 && !isAbsolute) path = '.';
    if (path.length > 0 && trailingSeparator) path += '/';

    if (isAbsolute) return '/' + path;
    return path;
  },

  isAbsolute: function isAbsolute(path) {
    assertPath(path);
    return path.length > 0 && path.charCodeAt(0) === 47 /*/*/;
  },

  join: function join() {
    if (arguments.length === 0)
      return '.';
    var joined;
    for (var i = 0; i < arguments.length; ++i) {
      var arg = arguments[i];
      assertPath(arg);
      if (arg.length > 0) {
        if (joined === undefined)
          joined = arg;
        else
          joined += '/' + arg;
      }
    }
    if (joined === undefined)
      return '.';
    return posix.normalize(joined);
  },

  relative: function relative(from, to) {
    assertPath(from);
    assertPath(to);

    if (from === to) return '';

    from = posix.resolve(from);
    to = posix.resolve(to);

    if (from === to) return '';

    // Trim any leading backslashes
    var fromStart = 1;
    for (; fromStart < from.length; ++fromStart) {
      if (from.charCodeAt(fromStart) !== 47 /*/*/)
        break;
    }
    var fromEnd = from.length;
    var fromLen = fromEnd - fromStart;

    // Trim any leading backslashes
    var toStart = 1;
    for (; toStart < to.length; ++toStart) {
      if (to.charCodeAt(toStart) !== 47 /*/*/)
        break;
    }
    var toEnd = to.length;
    var toLen = toEnd - toStart;

    // Compare paths to find the longest common path from root
    var length = fromLen < toLen ? fromLen : toLen;
    var lastCommonSep = -1;
    var i = 0;
    for (; i <= length; ++i) {
      if (i === length) {
        if (toLen > length) {
          if (to.charCodeAt(toStart + i) === 47 /*/*/) {
            // We get here if `from` is the exact base path for `to`.
            // For example: from='/foo/bar'; to='/foo/bar/baz'
            return to.slice(toStart + i + 1);
          } else if (i === 0) {
            // We get here if `from` is the root
            // For example: from='/'; to='/foo'
            return to.slice(toStart + i);
          }
        } else if (fromLen > length) {
          if (from.charCodeAt(fromStart + i) === 47 /*/*/) {
            // We get here if `to` is the exact base path for `from`.
            // For example: from='/foo/bar/baz'; to='/foo/bar'
            lastCommonSep = i;
          } else if (i === 0) {
            // We get here if `to` is the root.
            // For example: from='/foo'; to='/'
            lastCommonSep = 0;
          }
        }
        break;
      }
      var fromCode = from.charCodeAt(fromStart + i);
      var toCode = to.charCodeAt(toStart + i);
      if (fromCode !== toCode)
        break;
      else if (fromCode === 47 /*/*/)
        lastCommonSep = i;
    }

    var out = '';
    // Generate the relative path based on the path difference between `to`
    // and `from`
    for (i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i) {
      if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/) {
        if (out.length === 0)
          out += '..';
        else
          out += '/..';
      }
    }

    // Lastly, append the rest of the destination (`to`) path that comes after
    // the common path parts
    if (out.length > 0)
      return out + to.slice(toStart + lastCommonSep);
    else {
      toStart += lastCommonSep;
      if (to.charCodeAt(toStart) === 47 /*/*/)
        ++toStart;
      return to.slice(toStart);
    }
  },

  _makeLong: function _makeLong(path) {
    return path;
  },

  dirname: function dirname(path) {
    assertPath(path);
    if (path.length === 0) return '.';
    var code = path.charCodeAt(0);
    var hasRoot = code === 47 /*/*/;
    var end = -1;
    var matchedSlash = true;
    for (var i = path.length - 1; i >= 1; --i) {
      code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          if (!matchedSlash) {
            end = i;
            break;
          }
        } else {
        // We saw the first non-path separator
        matchedSlash = false;
      }
    }

    if (end === -1) return hasRoot ? '/' : '.';
    if (hasRoot && end === 1) return '//';
    return path.slice(0, end);
  },

  basename: function basename(path, ext) {
    if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
    assertPath(path);

    var start = 0;
    var end = -1;
    var matchedSlash = true;
    var i;

    if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
      if (ext.length === path.length && ext === path) return '';
      var extIdx = ext.length - 1;
      var firstNonSlashEnd = -1;
      for (i = path.length - 1; i >= 0; --i) {
        var code = path.charCodeAt(i);
        if (code === 47 /*/*/) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            if (!matchedSlash) {
              start = i + 1;
              break;
            }
          } else {
          if (firstNonSlashEnd === -1) {
            // We saw the first non-path separator, remember this index in case
            // we need it if the extension ends up not matching
            matchedSlash = false;
            firstNonSlashEnd = i + 1;
          }
          if (extIdx >= 0) {
            // Try to match the explicit extension
            if (code === ext.charCodeAt(extIdx)) {
              if (--extIdx === -1) {
                // We matched the extension, so mark this as the end of our path
                // component
                end = i;
              }
            } else {
              // Extension does not match, so our result is the entire path
              // component
              extIdx = -1;
              end = firstNonSlashEnd;
            }
          }
        }
      }

      if (start === end) end = firstNonSlashEnd;else if (end === -1) end = path.length;
      return path.slice(start, end);
    } else {
      for (i = path.length - 1; i >= 0; --i) {
        if (path.charCodeAt(i) === 47 /*/*/) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            if (!matchedSlash) {
              start = i + 1;
              break;
            }
          } else if (end === -1) {
          // We saw the first non-path separator, mark this as the end of our
          // path component
          matchedSlash = false;
          end = i + 1;
        }
      }

      if (end === -1) return '';
      return path.slice(start, end);
    }
  },

  extname: function extname(path) {
    assertPath(path);
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    var matchedSlash = true;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find
    var preDotState = 0;
    for (var i = path.length - 1; i >= 0; --i) {
      var code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          // If we reached a path separator that was not part of a set of path
          // separators at the end of the string, stop now
          if (!matchedSlash) {
            startPart = i + 1;
            break;
          }
          continue;
        }
      if (end === -1) {
        // We saw the first non-path separator, mark this as the end of our
        // extension
        matchedSlash = false;
        end = i + 1;
      }
      if (code === 46 /*.*/) {
          // If this is our first dot, mark it as the start of our extension
          if (startDot === -1)
            startDot = i;
          else if (preDotState !== 1)
            preDotState = 1;
      } else if (startDot !== -1) {
        // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension
        preDotState = -1;
      }
    }

    if (startDot === -1 || end === -1 ||
        // We saw a non-dot character immediately before the dot
        preDotState === 0 ||
        // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      return '';
    }
    return path.slice(startDot, end);
  },

  format: function format(pathObject) {
    if (pathObject === null || typeof pathObject !== 'object') {
      throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
    }
    return _format('/', pathObject);
  },

  parse: function parse(path) {
    assertPath(path);

    var ret = { root: '', dir: '', base: '', ext: '', name: '' };
    if (path.length === 0) return ret;
    var code = path.charCodeAt(0);
    var isAbsolute = code === 47 /*/*/;
    var start;
    if (isAbsolute) {
      ret.root = '/';
      start = 1;
    } else {
      start = 0;
    }
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    var matchedSlash = true;
    var i = path.length - 1;

    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find
    var preDotState = 0;

    // Get non-dir info
    for (; i >= start; --i) {
      code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          // If we reached a path separator that was not part of a set of path
          // separators at the end of the string, stop now
          if (!matchedSlash) {
            startPart = i + 1;
            break;
          }
          continue;
        }
      if (end === -1) {
        // We saw the first non-path separator, mark this as the end of our
        // extension
        matchedSlash = false;
        end = i + 1;
      }
      if (code === 46 /*.*/) {
          // If this is our first dot, mark it as the start of our extension
          if (startDot === -1) startDot = i;else if (preDotState !== 1) preDotState = 1;
        } else if (startDot !== -1) {
        // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension
        preDotState = -1;
      }
    }

    if (startDot === -1 || end === -1 ||
    // We saw a non-dot character immediately before the dot
    preDotState === 0 ||
    // The (right-most) trimmed path component is exactly '..'
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      if (end !== -1) {
        if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);else ret.base = ret.name = path.slice(startPart, end);
      }
    } else {
      if (startPart === 0 && isAbsolute) {
        ret.name = path.slice(1, startDot);
        ret.base = path.slice(1, end);
      } else {
        ret.name = path.slice(startPart, startDot);
        ret.base = path.slice(startPart, end);
      }
      ret.ext = path.slice(startDot, end);
    }

    if (startPart > 0) ret.dir = path.slice(0, startPart - 1);else if (isAbsolute) ret.dir = '/';

    return ret;
  },

  sep: '/',
  delimiter: ':',
  win32: null,
  posix: null
};

posix.posix = posix;

module.exports = posix;


/***/ }),

/***/ 58076:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                  ? wordKey[1]
                  : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


/***/ }),

/***/ 58316:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8818);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingDayHotelView = /*#__PURE__*/function (_View) {
  function BookingDayHotelView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingDayHotelView);
    return _callSuper(this, BookingDayHotelView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingDayHotelView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingDayHotelView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", {
                fields: [{
                  name: 'Checkin'
                }, {
                  name: 'Checkout'
                }, {
                  name: 'Days',
                  defValue: 1
                }, {
                  name: 'CityId',
                  relation: 'city',
                  optionLabels: 'Name',
                  editor: 'vue-select',
                  label: 'City',
                  setRelationTo: 'City'
                }, {
                  name: 'BookingDayRooms',
                  editor: [],
                  rowClass: 'bookingdayroom'
                }, {
                  name: 'forceCapacityGetter',
                  defValue: false
                }]
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingDayHotelView, "table", 'bookingdayhotel');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingDayHotelView);

/***/ }),

/***/ 58382:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64467);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51941);






function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingDayServiceCar = /*#__PURE__*/function (_BookingBaseModel) {
  function BookingDayServiceCar() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, BookingDayServiceCar);
    return _callSuper(this, BookingDayServiceCar, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(BookingDayServiceCar, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingDayServiceCar, [{
    key: "dropOffDate",
    get: function get() {
      if (tools.isNull(this.Days)) return '';
      return moment(this.$parent.ServiceDate).add(this.Days - 1, 'days').format('YYYY-MM-DD');
    }
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingDayServiceCar, "moduleName", 'bookingdayservicecar');
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingDayServiceCar, "invalidated_cache", _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_2__["default"].invalidated_cache_services);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingDayServiceCar);

/***/ }),

/***/ 58676:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


/***/ }),

/***/ 58713:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64467);
/* harmony import */ var _base_model_record__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55539);






function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingForm = /*#__PURE__*/function (_Record) {
  function BookingForm() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, BookingForm);
    return _callSuper(this, BookingForm, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(BookingForm, _Record);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingForm, [{
    key: "titleName",
    get: function get() {
      return this.PaxName;
    }
  }], [{
    key: "roomTypesBookingForm",
    value: function roomTypesBookingForm() {
      return [{
        value: null,
        label: ' --- '
      }, {
        value: 'SGL',
        label: 'SGL',
        component: 'sgl-bed',
        componentPath: 'components/svg',
        componentName: 'SglBed'
      }, {
        value: 'TWIN',
        label: 'TWIN',
        component: 'twin-bed',
        componentPath: 'components/svg',
        componentName: 'TwinBed'
      }, {
        value: 'MAT',
        label: 'MAT',
        component: 'mat-bed',
        componentPath: 'components/svg',
        componentName: 'MatBed'
      }, {
        value: 'TPL',
        label: 'TPL',
        component: 'tpl-bed',
        componentPath: 'components/svg',
        componentName: 'TplBed'
      }];
    }
  }]);
}(_base_model_record__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingForm, "moduleName", 'bookingform');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingForm);

/***/ }),

/***/ 58903:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var inherits = __webpack_require__(56698);
var Buffer = (__webpack_require__(48287).Buffer);

var DERDecoder = __webpack_require__(62010);

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};


/***/ }),

/***/ 59083:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;
var _require$codes = (__webpack_require__(12463)/* .codes */ .F),
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
  ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = __webpack_require__(88101);
__webpack_require__(56698)(Transform, Duplex);
function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;
  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }
  ts.writechunk = null;
  ts.writecb = null;
  if (data != null)
    // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}
function prefinish() {
  var _this = this;
  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}
Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;
  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};
Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};
function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null)
    // single equals check for both `null` and `undefined`
    stream.push(data);

  // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}

/***/ }),

/***/ 59527:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tk;

})));


/***/ }),

/***/ 60294:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8818);









function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var SupplierCreditView = /*#__PURE__*/function (_View) {
  function SupplierCreditView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, SupplierCreditView);
    return _callSuper(this, SupplierCreditView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(SupplierCreditView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(SupplierCreditView, null, [{
    key: "options",
    value: function options() {
      return {
        serverSide: true,
        canAdd: true,
        fields: [{
          name: 'id',
          readonly: true,
          columns: 2,
          headerField: true,
          label: 'Number'
        }, {
          name: 'BookingId',
          readonly: true,
          columns: 2,
          headerField: true,
          label: 'File'
        }, {
          name: 'SupplierId',
          relation: 'supplier',
          optionLabels: 'Name',
          columns: 6,
          setRelationTo: 'Supplier',
          label: 'Supplier',
          headerField: true,
          editor: 'vue-select',
          required: true
        }, {
          name: 'TransDate',
          label: 'Date',
          required: true,
          editor: 'date',
          headerField: true,
          columns: 2,
          dateFormat: "DD/MM/YYYY"
        }, {
          name: 'DueDate',
          label: 'Due Date',
          editor: 'date',
          headerField: true,
          columns: 2,
          dateFormat: "DD/MM/YYYY"
        }, {
          name: 'Amount',
          label: 'Amount',
          headerField: true,
          editor: 'number',
          columns: 2,
          decimal: 2,
          required: true,
          currency: 'Currency'
        }, {
          name: 'CurrencyId',
          relation: 'currency',
          optionLabels: 'id',
          required: true,
          setRelationTo: 'Currency',
          editor: 'select',
          label: 'Currency',
          columns: 2,
          headerField: true
        }, {
          name: 'Comment',
          label: 'Notes',
          columns: 8,
          headerField: true
        }, {
          name: 'FromCurrencyId',
          relation: 'currency',
          optionLabels: 'id',
          editor: 'select',
          label: 'From',
          columns: 2,
          required: true,
          hideFromList: true
        }, {
          name: 'ToCurrencyId',
          relation: 'currency',
          optionLabels: 'id',
          editor: 'select',
          label: 'To',
          columns: 2,
          required: true,
          hideFromList: true
        }, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)((0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)((0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)({
          name: 'CurrencyRate',
          editor: 'number',
          columns: 2,
          decimal: 2,
          label: 'Curremcy Rate'
        }, "columns", 2), "required", true), "hideFromList", true), {
          name: 'BookingPayments',
          editor: [],
          label: 'Uses',
          readonly: true,
          rowFields: [{
            name: 'id',
            label: 'Payment Id',
            columns: 3,
            readonly: true,
            editor: 'number'
          }, {
            name: 'BookingId',
            label: 'File Number',
            columns: 3,
            readonly: true,
            editor: 'number'
          }, {
            name: 'PaymentAmount',
            label: 'Amount',
            columns: 3,
            readonly: true,
            editor: 'number',
            currency: 'Currency'
          }, {
            name: 'CurrencyId',
            label: 'Currency',
            columns: 3,
            readonly: true
          }]
        }]
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(SupplierCreditView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              res = _context.sent;
              return _context.abrupt("return", res);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_4__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(SupplierCreditView, "table", 'suppliercredit');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SupplierCreditView);

/***/ }),

/***/ 60392:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8818);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var CurrencyView = /*#__PURE__*/function (_View) {
  function CurrencyView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, CurrencyView);
    return _callSuper(this, CurrencyView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(CurrencyView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(CurrencyView, null, [{
    key: "options",
    value: function options() {
      return {
        fieldsOrder: ['id', 'Name', 'CurrencyConvertId', 'Operation', 'Symbol'],
        fieldsDataReplace: {
          CurrencyConvertId: {
            name: 'CurrencyConvertId',
            relation: 'currency',
            optionLabels: 'id',
            editor: 'select',
            setRelationTo: 'CurrencyConvert'
          }
        },
        canAdd: true
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(CurrencyView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_4__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CurrencyView);

/***/ }),

/***/ 60480:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var curves = exports;

var hash = __webpack_require__(77952);
var curve = __webpack_require__(894);
var utils = __webpack_require__(47011);

var assert = utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new curve.edwards(options);
  else
    this.curve = new curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve,
      });
      return curve;
    },
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811',
  ],
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34',
  ],
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5',
  ],
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f',
  ],
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650',
  ],
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9',
  ],
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658',
  ],
});

var pre;
try {
  pre = __webpack_require__(74011);
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3',
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15',
    },
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre,
  ],
});


/***/ }),

/***/ 60708:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


/***/ }),

/***/ 61158:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = (__webpack_require__(64688).Buffer);
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);


/***/ }),

/***/ 61163:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('[{"id":4,"alpha2":"af","alpha3":"afg","name":"Afghanistan"},{"id":248,"alpha2":"ax","alpha3":"ala","name":"Åland"},{"id":8,"alpha2":"al","alpha3":"alb","name":"Albanië"},{"id":12,"alpha2":"dz","alpha3":"dza","name":"Algerije"},{"id":850,"alpha2":"vi","alpha3":"vir","name":"Amerikaanse Maagdeneilanden"},{"id":16,"alpha2":"as","alpha3":"asm","name":"Amerikaans-Samoa"},{"id":20,"alpha2":"ad","alpha3":"and","name":"Andorra"},{"id":24,"alpha2":"ao","alpha3":"ago","name":"Angola"},{"id":660,"alpha2":"ai","alpha3":"aia","name":"Anguilla"},{"id":10,"alpha2":"aq","alpha3":"ata","name":"Antarctica"},{"id":28,"alpha2":"ag","alpha3":"atg","name":"Antigua en Barbuda"},{"id":32,"alpha2":"ar","alpha3":"arg","name":"Argentinië"},{"id":51,"alpha2":"am","alpha3":"arm","name":"Armenië"},{"id":533,"alpha2":"aw","alpha3":"abw","name":"Aruba"},{"id":36,"alpha2":"au","alpha3":"aus","name":"Australië"},{"id":31,"alpha2":"az","alpha3":"aze","name":"Azerbeidzjan"},{"id":44,"alpha2":"bs","alpha3":"bhs","name":"Bahama\'s"},{"id":48,"alpha2":"bh","alpha3":"bhr","name":"Bahrein"},{"id":50,"alpha2":"bd","alpha3":"bgd","name":"Bangladesh"},{"id":52,"alpha2":"bb","alpha3":"brb","name":"Barbados"},{"id":56,"alpha2":"be","alpha3":"bel","name":"België"},{"id":84,"alpha2":"bz","alpha3":"blz","name":"Belize"},{"id":204,"alpha2":"bj","alpha3":"ben","name":"Benin"},{"id":60,"alpha2":"bm","alpha3":"bmu","name":"Bermuda"},{"id":64,"alpha2":"bt","alpha3":"btn","name":"Bhutan"},{"id":68,"alpha2":"bo","alpha3":"bol","name":"Bolivia"},{"id":70,"alpha2":"ba","alpha3":"bih","name":"Bosnië en Herzegovina"},{"id":72,"alpha2":"bw","alpha3":"bwa","name":"Botswana"},{"id":74,"alpha2":"bv","alpha3":"bvt","name":"Bouvet"},{"id":76,"alpha2":"br","alpha3":"bra","name":"Brazilië"},{"id":92,"alpha2":"vg","alpha3":"vgb","name":"Britse Maagdeneilanden"},{"id":86,"alpha2":"io","alpha3":"iot","name":"Brits Indische Oceaanterritorium"},{"id":96,"alpha2":"bn","alpha3":"brn","name":"Brunei"},{"id":100,"alpha2":"bg","alpha3":"bgr","name":"Bulgarije"},{"id":854,"alpha2":"bf","alpha3":"bfa","name":"Burkina Faso"},{"id":108,"alpha2":"bi","alpha3":"bdi","name":"Burundi"},{"id":116,"alpha2":"kh","alpha3":"khm","name":"Cambodja"},{"id":124,"alpha2":"ca","alpha3":"can","name":"Canada"},{"id":535,"alpha2":"bq","alpha3":"bes","name":"Caribisch Nederland"},{"id":140,"alpha2":"cf","alpha3":"caf","name":"Centraal-Afrikaanse Republiek"},{"id":152,"alpha2":"cl","alpha3":"chl","name":"Chili"},{"id":156,"alpha2":"cn","alpha3":"chn","name":"China"},{"id":162,"alpha2":"cx","alpha3":"cxr","name":"Christmaseiland"},{"id":166,"alpha2":"cc","alpha3":"cck","name":"Cocoseilanden"},{"id":170,"alpha2":"co","alpha3":"col","name":"Colombia"},{"id":174,"alpha2":"km","alpha3":"com","name":"Comoren"},{"id":178,"alpha2":"cg","alpha3":"cog","name":"Congo-Brazzaville"},{"id":180,"alpha2":"cd","alpha3":"cod","name":"Congo-Kinshasa"},{"id":184,"alpha2":"ck","alpha3":"cok","name":"Cookeilanden"},{"id":188,"alpha2":"cr","alpha3":"cri","name":"Costa Rica"},{"id":192,"alpha2":"cu","alpha3":"cub","name":"Cuba"},{"id":531,"alpha2":"cw","alpha3":"cuw","name":"Curaçao"},{"id":196,"alpha2":"cy","alpha3":"cyp","name":"Cyprus"},{"id":208,"alpha2":"dk","alpha3":"dnk","name":"Denemarken"},{"id":262,"alpha2":"dj","alpha3":"dji","name":"Djibouti"},{"id":212,"alpha2":"dm","alpha3":"dma","name":"Dominica"},{"id":214,"alpha2":"do","alpha3":"dom","name":"Dominicaanse Republiek"},{"id":276,"alpha2":"de","alpha3":"deu","name":"Duitsland"},{"id":218,"alpha2":"ec","alpha3":"ecu","name":"Ecuador"},{"id":818,"alpha2":"eg","alpha3":"egy","name":"Egypte"},{"id":222,"alpha2":"sv","alpha3":"slv","name":"El Salvador"},{"id":226,"alpha2":"gq","alpha3":"gnq","name":"Equatoriaal-Guinea"},{"id":232,"alpha2":"er","alpha3":"eri","name":"Eritrea"},{"id":233,"alpha2":"ee","alpha3":"est","name":"Estland"},{"id":231,"alpha2":"et","alpha3":"eth","name":"Ethiopië"},{"id":234,"alpha2":"fo","alpha3":"fro","name":"Faeröer"},{"id":238,"alpha2":"fk","alpha3":"flk","name":"Falklandeilanden"},{"id":242,"alpha2":"fj","alpha3":"fji","name":"Fiji"},{"id":608,"alpha2":"ph","alpha3":"phl","name":"Filipijnen"},{"id":246,"alpha2":"fi","alpha3":"fin","name":"Finland"},{"id":250,"alpha2":"fr","alpha3":"fra","name":"Frankrijk"},{"id":260,"alpha2":"tf","alpha3":"atf","name":"Franse Zuidelijke Gebieden"},{"id":254,"alpha2":"gf","alpha3":"guf","name":"Frans-Guyana"},{"id":258,"alpha2":"pf","alpha3":"pyf","name":"Frans-Polynesië"},{"id":266,"alpha2":"ga","alpha3":"gab","name":"Gabon"},{"id":270,"alpha2":"gm","alpha3":"gmb","name":"Gambia"},{"id":268,"alpha2":"ge","alpha3":"geo","name":"Georgië"},{"id":288,"alpha2":"gh","alpha3":"gha","name":"Ghana"},{"id":292,"alpha2":"gi","alpha3":"gib","name":"Gibraltar"},{"id":308,"alpha2":"gd","alpha3":"grd","name":"Grenada"},{"id":300,"alpha2":"gr","alpha3":"grc","name":"Griekenland"},{"id":304,"alpha2":"gl","alpha3":"grl","name":"Groenland"},{"id":312,"alpha2":"gp","alpha3":"glp","name":"Guadeloupe"},{"id":316,"alpha2":"gu","alpha3":"gum","name":"Guam"},{"id":320,"alpha2":"gt","alpha3":"gtm","name":"Guatemala"},{"id":831,"alpha2":"gg","alpha3":"ggy","name":"Guernsey"},{"id":324,"alpha2":"gn","alpha3":"gin","name":"Guinee"},{"id":624,"alpha2":"gw","alpha3":"gnb","name":"Guinee-Bissau"},{"id":328,"alpha2":"gy","alpha3":"guy","name":"Guyana"},{"id":332,"alpha2":"ht","alpha3":"hti","name":"Haïti"},{"id":334,"alpha2":"hm","alpha3":"hmd","name":"Heard en McDonaldeilanden"},{"id":340,"alpha2":"hn","alpha3":"hnd","name":"Honduras"},{"id":348,"alpha2":"hu","alpha3":"hun","name":"Hongarije"},{"id":344,"alpha2":"hk","alpha3":"hkg","name":"Hongkong"},{"id":372,"alpha2":"ie","alpha3":"irl","name":"Ierland"},{"id":352,"alpha2":"is","alpha3":"isl","name":"IJsland"},{"id":356,"alpha2":"in","alpha3":"ind","name":"India"},{"id":360,"alpha2":"id","alpha3":"idn","name":"Indonesië"},{"id":368,"alpha2":"iq","alpha3":"irq","name":"Irak"},{"id":364,"alpha2":"ir","alpha3":"irn","name":"Iran"},{"id":376,"alpha2":"il","alpha3":"isr","name":"Israël"},{"id":380,"alpha2":"it","alpha3":"ita","name":"Italië"},{"id":384,"alpha2":"ci","alpha3":"civ","name":"Ivoorkust"},{"id":388,"alpha2":"jm","alpha3":"jam","name":"Jamaica"},{"id":392,"alpha2":"jp","alpha3":"jpn","name":"Japan"},{"id":887,"alpha2":"ye","alpha3":"yem","name":"Jemen"},{"id":832,"alpha2":"je","alpha3":"jey","name":"Jersey"},{"id":400,"alpha2":"jo","alpha3":"jor","name":"Jordanië"},{"id":136,"alpha2":"ky","alpha3":"cym","name":"Kaaimaneilanden"},{"id":132,"alpha2":"cv","alpha3":"cpv","name":"Kaapverdië"},{"id":120,"alpha2":"cm","alpha3":"cmr","name":"Kameroen"},{"id":398,"alpha2":"kz","alpha3":"kaz","name":"Kazachstan"},{"id":404,"alpha2":"ke","alpha3":"ken","name":"Kenia"},{"id":417,"alpha2":"kg","alpha3":"kgz","name":"Kirgizië"},{"id":296,"alpha2":"ki","alpha3":"kir","name":"Kiribati"},{"id":581,"alpha2":"um","alpha3":"umi","name":"Kleine afgelegen eilanden van de Verenigde Staten"},{"id":414,"alpha2":"kw","alpha3":"kwt","name":"Koeweit"},{"id":191,"alpha2":"hr","alpha3":"hrv","name":"Kroatië"},{"id":418,"alpha2":"la","alpha3":"lao","name":"Laos"},{"id":426,"alpha2":"ls","alpha3":"lso","name":"Lesotho"},{"id":428,"alpha2":"lv","alpha3":"lva","name":"Letland"},{"id":422,"alpha2":"lb","alpha3":"lbn","name":"Libanon"},{"id":430,"alpha2":"lr","alpha3":"lbr","name":"Liberia"},{"id":434,"alpha2":"ly","alpha3":"lby","name":"Libië"},{"id":438,"alpha2":"li","alpha3":"lie","name":"Liechtenstein"},{"id":440,"alpha2":"lt","alpha3":"ltu","name":"Litouwen"},{"id":442,"alpha2":"lu","alpha3":"lux","name":"Luxemburg"},{"id":446,"alpha2":"mo","alpha3":"mac","name":"Macau"},{"id":450,"alpha2":"mg","alpha3":"mdg","name":"Madagaskar"},{"id":454,"alpha2":"mw","alpha3":"mwi","name":"Malawi"},{"id":462,"alpha2":"mv","alpha3":"mdv","name":"Malediven"},{"id":458,"alpha2":"my","alpha3":"mys","name":"Maleisië"},{"id":466,"alpha2":"ml","alpha3":"mli","name":"Mali"},{"id":470,"alpha2":"mt","alpha3":"mlt","name":"Malta"},{"id":833,"alpha2":"im","alpha3":"imn","name":"Man"},{"id":504,"alpha2":"ma","alpha3":"mar","name":"Marokko"},{"id":584,"alpha2":"mh","alpha3":"mhl","name":"Marshalleilanden"},{"id":474,"alpha2":"mq","alpha3":"mtq","name":"Martinique"},{"id":478,"alpha2":"mr","alpha3":"mrt","name":"Mauritanië"},{"id":480,"alpha2":"mu","alpha3":"mus","name":"Mauritius"},{"id":175,"alpha2":"yt","alpha3":"myt","name":"Mayotte"},{"id":484,"alpha2":"mx","alpha3":"mex","name":"Mexico"},{"id":583,"alpha2":"fm","alpha3":"fsm","name":"Micronesië"},{"id":498,"alpha2":"md","alpha3":"mda","name":"Moldavië"},{"id":492,"alpha2":"mc","alpha3":"mco","name":"Monaco"},{"id":496,"alpha2":"mn","alpha3":"mng","name":"Mongolië"},{"id":499,"alpha2":"me","alpha3":"mne","name":"Montenegro"},{"id":500,"alpha2":"ms","alpha3":"msr","name":"Montserrat"},{"id":508,"alpha2":"mz","alpha3":"moz","name":"Mozambique"},{"id":104,"alpha2":"mm","alpha3":"mmr","name":"Myanmar"},{"id":516,"alpha2":"na","alpha3":"nam","name":"Namibië"},{"id":520,"alpha2":"nr","alpha3":"nru","name":"Nauru"},{"id":528,"alpha2":"nl","alpha3":"nld","name":"Nederland"},{"id":524,"alpha2":"np","alpha3":"npl","name":"Nepal"},{"id":558,"alpha2":"ni","alpha3":"nic","name":"Nicaragua"},{"id":540,"alpha2":"nc","alpha3":"ncl","name":"Nieuw-Caledonië"},{"id":554,"alpha2":"nz","alpha3":"nzl","name":"Nieuw-Zeeland"},{"id":562,"alpha2":"ne","alpha3":"ner","name":"Niger"},{"id":566,"alpha2":"ng","alpha3":"nga","name":"Nigeria"},{"id":570,"alpha2":"nu","alpha3":"niu","name":"Niue"},{"id":580,"alpha2":"mp","alpha3":"mnp","name":"Noordelijke Marianen"},{"id":408,"alpha2":"kp","alpha3":"prk","name":"Noord-Korea"},{"id":807,"alpha2":"mk","alpha3":"mkd","name":"Noord-Macedonië"},{"id":578,"alpha2":"no","alpha3":"nor","name":"Noorwegen"},{"id":574,"alpha2":"nf","alpha3":"nfk","name":"Norfolk"},{"id":800,"alpha2":"ug","alpha3":"uga","name":"Oeganda"},{"id":804,"alpha2":"ua","alpha3":"ukr","name":"Oekraïne"},{"id":860,"alpha2":"uz","alpha3":"uzb","name":"Oezbekistan"},{"id":512,"alpha2":"om","alpha3":"omn","name":"Oman"},{"id":40,"alpha2":"at","alpha3":"aut","name":"Oostenrijk"},{"id":626,"alpha2":"tl","alpha3":"tls","name":"Oost-Timor"},{"id":586,"alpha2":"pk","alpha3":"pak","name":"Pakistan"},{"id":585,"alpha2":"pw","alpha3":"plw","name":"Palau"},{"id":275,"alpha2":"ps","alpha3":"pse","name":"Palestina"},{"id":591,"alpha2":"pa","alpha3":"pan","name":"Panama"},{"id":598,"alpha2":"pg","alpha3":"png","name":"Papoea-Nieuw-Guinea"},{"id":600,"alpha2":"py","alpha3":"pry","name":"Paraguay"},{"id":604,"alpha2":"pe","alpha3":"per","name":"Peru"},{"id":612,"alpha2":"pn","alpha3":"pcn","name":"Pitcairneilanden"},{"id":616,"alpha2":"pl","alpha3":"pol","name":"Polen"},{"id":620,"alpha2":"pt","alpha3":"prt","name":"Portugal"},{"id":630,"alpha2":"pr","alpha3":"pri","name":"Puerto Rico"},{"id":634,"alpha2":"qa","alpha3":"qat","name":"Qatar"},{"id":638,"alpha2":"re","alpha3":"reu","name":"Réunion"},{"id":642,"alpha2":"ro","alpha3":"rou","name":"Roemenië"},{"id":643,"alpha2":"ru","alpha3":"rus","name":"Rusland"},{"id":646,"alpha2":"rw","alpha3":"rwa","name":"Rwanda"},{"id":652,"alpha2":"bl","alpha3":"blm","name":"Saint-Barthélemy"},{"id":659,"alpha2":"kn","alpha3":"kna","name":"Saint Kitts en Nevis"},{"id":662,"alpha2":"lc","alpha3":"lca","name":"Saint Lucia"},{"id":666,"alpha2":"pm","alpha3":"spm","name":"Saint-Pierre en Miquelon"},{"id":670,"alpha2":"vc","alpha3":"vct","name":"Saint Vincent en de Grenadines"},{"id":90,"alpha2":"sb","alpha3":"slb","name":"Salomonseilanden"},{"id":882,"alpha2":"ws","alpha3":"wsm","name":"Samoa"},{"id":674,"alpha2":"sm","alpha3":"smr","name":"San Marino"},{"id":682,"alpha2":"sa","alpha3":"sau","name":"Saoedi-Arabië"},{"id":678,"alpha2":"st","alpha3":"stp","name":"Sao Tomé en Principe"},{"id":686,"alpha2":"sn","alpha3":"sen","name":"Senegal"},{"id":688,"alpha2":"rs","alpha3":"srb","name":"Servië"},{"id":690,"alpha2":"sc","alpha3":"syc","name":"Seychellen"},{"id":694,"alpha2":"sl","alpha3":"sle","name":"Sierra Leone"},{"id":702,"alpha2":"sg","alpha3":"sgp","name":"Singapore"},{"id":654,"alpha2":"sh","alpha3":"shn","name":"Sint-Helena, Ascension en Tristan da Cunha"},{"id":663,"alpha2":"mf","alpha3":"maf","name":"Saint-Martin"},{"id":534,"alpha2":"sx","alpha3":"sxm","name":"Sint Maarten"},{"id":705,"alpha2":"si","alpha3":"svn","name":"Slovenië"},{"id":703,"alpha2":"sk","alpha3":"svk","name":"Slowakije"},{"id":729,"alpha2":"sd","alpha3":"sdn","name":"Soedan"},{"id":706,"alpha2":"so","alpha3":"som","name":"Somalië"},{"id":724,"alpha2":"es","alpha3":"esp","name":"Spanje"},{"id":744,"alpha2":"sj","alpha3":"sjm","name":"Spitsbergen en Jan Mayen"},{"id":144,"alpha2":"lk","alpha3":"lka","name":"Sri Lanka"},{"id":740,"alpha2":"sr","alpha3":"sur","name":"Suriname"},{"id":748,"alpha2":"sz","alpha3":"swz","name":"Swaziland"},{"id":760,"alpha2":"sy","alpha3":"syr","name":"Syrië"},{"id":762,"alpha2":"tj","alpha3":"tjk","name":"Tadzjikistan"},{"id":158,"alpha2":"tw","alpha3":"twn","name":"Taiwan"},{"id":834,"alpha2":"tz","alpha3":"tza","name":"Tanzania"},{"id":764,"alpha2":"th","alpha3":"tha","name":"Thailand"},{"id":768,"alpha2":"tg","alpha3":"tgo","name":"Togo"},{"id":772,"alpha2":"tk","alpha3":"tkl","name":"Tokelau"},{"id":776,"alpha2":"to","alpha3":"ton","name":"Tonga"},{"id":780,"alpha2":"tt","alpha3":"tto","name":"Trinidad en Tobago"},{"id":148,"alpha2":"td","alpha3":"tcd","name":"Tsjaad"},{"id":203,"alpha2":"cz","alpha3":"cze","name":"Tsjechië"},{"id":788,"alpha2":"tn","alpha3":"tun","name":"Tunesië"},{"id":792,"alpha2":"tr","alpha3":"tur","name":"Turkije"},{"id":795,"alpha2":"tm","alpha3":"tkm","name":"Turkmenistan"},{"id":796,"alpha2":"tc","alpha3":"tca","name":"Turks- en Caicoseilanden"},{"id":798,"alpha2":"tv","alpha3":"tuv","name":"Tuvalu"},{"id":858,"alpha2":"uy","alpha3":"ury","name":"Uruguay"},{"id":548,"alpha2":"vu","alpha3":"vut","name":"Vanuatu"},{"id":336,"alpha2":"va","alpha3":"vat","name":"Vaticaanstad"},{"id":862,"alpha2":"ve","alpha3":"ven","name":"Venezuela"},{"id":784,"alpha2":"ae","alpha3":"are","name":"Verenigde Arabische Emiraten"},{"id":840,"alpha2":"us","alpha3":"usa","name":"Verenigde Staten"},{"id":826,"alpha2":"gb","alpha3":"gbr","name":"Verenigd Koninkrijk"},{"id":704,"alpha2":"vn","alpha3":"vnm","name":"Vietnam"},{"id":876,"alpha2":"wf","alpha3":"wlf","name":"Wallis en Futuna"},{"id":732,"alpha2":"eh","alpha3":"esh","name":"Westelijke Sahara/SADR"},{"id":112,"alpha2":"by","alpha3":"blr","name":"Wit-Rusland"},{"id":894,"alpha2":"zm","alpha3":"zmb","name":"Zambia"},{"id":716,"alpha2":"zw","alpha3":"zwe","name":"Zimbabwe"},{"id":710,"alpha2":"za","alpha3":"zaf","name":"Zuid-Afrika"},{"id":239,"alpha2":"gs","alpha3":"sgs","name":"Zuid-Georgia en de Zuidelijke Sandwicheilanden"},{"id":410,"alpha2":"kr","alpha3":"kor","name":"Zuid-Korea"},{"id":728,"alpha2":"ss","alpha3":"ssd","name":"Zuid-Soedan"},{"id":752,"alpha2":"se","alpha3":"swe","name":"Zweden"},{"id":756,"alpha2":"ch","alpha3":"che","name":"Zwitserland"}]');

/***/ }),

/***/ 61200:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var BN = __webpack_require__(28490);
var utils = __webpack_require__(47011);
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc,
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc,
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  if(!pub.validate()) {
    assert(pub.validate(), 'public point not validated');
  }
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature, options) {
  return this.ec.verify(msg, signature, this, undefined, options);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


/***/ }),

/***/ 61206:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const MAX_SHORT_STRING = (__webpack_require__(91092).MAX_SHORT_STRING);

class BatchedHash {
  constructor(hash) {
    this.string = undefined;
    this.encoding = undefined;
    this.hash = hash;
  }

  /**
   * Update hash {@link https://nodejs.org/api/crypto.html#crypto_hash_update_data_inputencoding}
   * @param {string|Buffer} data data
   * @param {string=} inputEncoding data encoding
   * @returns {this} updated hash
   */
  update(data, inputEncoding) {
    if (this.string !== undefined) {
      if (
        typeof data === 'string' &&
        inputEncoding === this.encoding &&
        this.string.length + data.length < MAX_SHORT_STRING
      ) {
        this.string += data;

        return this;
      }

      this.hash.update(this.string, this.encoding);
      this.string = undefined;
    }

    if (typeof data === 'string') {
      if (
        data.length < MAX_SHORT_STRING &&
        // base64 encoding is not valid since it may contain padding chars
        (!inputEncoding || !inputEncoding.startsWith('ba'))
      ) {
        this.string = data;
        this.encoding = inputEncoding;
      } else {
        this.hash.update(data, inputEncoding);
      }
    } else {
      this.hash.update(data);
    }

    return this;
  }

  /**
   * Calculates the digest {@link https://nodejs.org/api/crypto.html#crypto_hash_digest_encoding}
   * @param {string=} encoding encoding of the return value
   * @returns {string|Buffer} digest
   */
  digest(encoding) {
    if (this.string !== undefined) {
      this.hash.update(this.string, this.encoding);
    }

    return this.hash.digest(encoding);
  }
}

module.exports = BatchedHash;


/***/ }),

/***/ 61290:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


/***/ }),

/***/ 61324:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__(48287)["Buffer"];
var elliptic = __webpack_require__(86729)
var BN = __webpack_require__(92801)

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}


/***/ }),

/***/ 61509:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


/***/ }),

/***/ 61649:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var View = api.importMixinModule('booking', 'views', 'custom');
var CustomBookingView = /*#__PURE__*/function (_View) {
  function CustomBookingView() {
    _classCallCheck(this, CustomBookingView);
    return _callSuper(this, CustomBookingView, arguments);
  }
  _inherits(CustomBookingView, _View);
  return _createClass(CustomBookingView, null, [{
    key: "showOnlyStatus",
    value: function showOnlyStatus(paxlead) {
      if (paxlead.LeadStatus && paxlead.LeadStatus.StatusType == 'INIT') return true;
      return false;
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var options,
          isTemplate,
          isOper,
          res,
          quoteBy,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              isTemplate = options.isTemplate, isOper = options.isOper;
              _context.next = 4;
              return _superPropGet(CustomBookingView, "getTableOptions", this, 2)([{
                isTemplate: isTemplate,
                isOper: isOper
              }]);
            case 4:
              res = _context.sent;
              res.fields.push({
                name: "AgencyCommission"
              });
              res.fields.push({
                name: "PaxTax"
              });
              res.fields.push({
                name: "SplitHotels",
                label: 'Separar Hoteles de Breakdown'
              });
              res.fields.push({
                name: "DisableTerms",
                label: 'Disable Terms & Conditions'
              });
              res.fields.push({
                name: "ShowAgencyCommission",
                label: 'Show Agency Commission'
              });
              res.fields.push({
                name: "ShowInvoiceAgencyCommission",
                label: 'Show Agency Commission in Invoice'
              });
              res.fields.push(_defineProperty({
                name: "EventFairId",
                label: 'Event/Fair',
                relation: 'eventfair',
                setRelationTo: 'EventFair',
                editor: 'vue-select',
                optionLabels: 'Name'
              }, "label", 'Feria/Evento'));
              quoteBy = res.fields.find(function (r) {
                return r.name == 'QuoteBy';
              });
              if (quoteBy) {
                quoteBy.options = [{
                  value: 'PERSON',
                  label: 'Person'
                }, {
                  value: 'SERVICE',
                  label: 'Services'
                }];
              }
              return _context.abrupt("return", res);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(View);
_defineProperty(CustomBookingView, "onlyByService", true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomBookingView);

/***/ }),

/***/ 61776:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SupplierMixinView = api.importMixinModule('supplierservice', 'views', 'contacts');
var SupplierServiceView = /*#__PURE__*/function (_SupplierMixinView) {
  function SupplierServiceView() {
    _classCallCheck(this, SupplierServiceView);
    return _callSuper(this, SupplierServiceView, arguments);
  }
  _inherits(SupplierServiceView, _SupplierMixinView);
  return _createClass(SupplierServiceView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(SupplierServiceView, "getTableOptions", this, 2)([]);
            case 2:
              res = _context.sent;
              res.extraFields.push({
                name: "SupplierContactList",
                editor: "component",
                hideFromList: true,
                label: "Contacts",
                icon: 'user',
                component: 'supplier-contact-list',
                componentName: 'supplier-contact-list',
                componentPath: 'components'
              });
              return _context.abrupt("return", res);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(SupplierMixinView);
_defineProperty(SupplierServiceView, "table", 'supplier');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SupplierServiceView);

//window.SupplierView = SupplierView

/***/ }),

/***/ 61777:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_record__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55539);








function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var Mail = /*#__PURE__*/function (_Record) {
  function Mail() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, Mail);
    return _callSuper(this, Mail, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(Mail, _Record);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(Mail, [{
    key: "saveMailAndSend",
    value: function () {
      var _saveMailAndSend = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(callback) {
        var res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.sendMail(this.id, callback);
            case 2:
              res = _context.sent;
              if (!res) {
                _context.next = 7;
                break;
              }
              _context.next = 6;
              return this.init(res);
            case 6:
              this.addNotification('Message sent');
            case 7:
              if (callback) callback(null, {
                update: true
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function saveMailAndSend(_x) {
        return _saveMailAndSend.apply(this, arguments);
      }
      return saveMailAndSend;
    }()
  }, {
    key: "sendMail",
    value: function () {
      var _sendMail = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(mailId, callback) {
        var data;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              data = new FormData();
              data.append('mailId', mailId);
              _context2.next = 4;
              return api.post('/api/mail/send_mail', data, {}, callback);
            case 4:
              return _context2.abrupt("return", _context2.sent);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function sendMail(_x2, _x3) {
        return _sendMail.apply(this, arguments);
      }
      return sendMail;
    }()
  }, {
    key: "titleName",
    get: function get() {
      if (this.id) return "Mail ".concat(this.id);
      return 'Mail';
    }
  }, {
    key: "getAttached",
    value: function () {
      var _getAttached = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3() {
        var _iterator, _step, row;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _superPropGet(Mail, "getAttached", this, 3)([]);
            case 2:
              if (this && this.id) {
                _iterator = _createForOfIteratorHelper(this.MailAttachments);
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    row = _step.value;
                    this.attached.push({
                      url: row.URL,
                      key: row.Key,
                      name: row.Name ? row.Name : row.Key
                    });
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getAttached() {
        return _getAttached.apply(this, arguments);
      }
      return getAttached;
    }()
  }, {
    key: "attachPending",
    get: function get() {
      var res = _superPropGet(Mail, "attachPending", this, 1);
      var _iterator2 = _createForOfIteratorHelper(this.MailAttachments),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var row = _step2.value;
          if (!row.id) {
            res.push({
              name: row.Name
            });
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return res;
    }
  }]);
}(_base_model_record__WEBPACK_IMPORTED_MODULE_4__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(Mail, "moduleName", 'mail');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Mail);

/***/ }),

/***/ 62010:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var inherits = __webpack_require__(56698);

var asn1 = __webpack_require__(87568);
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
                                                    options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}


/***/ }),

/***/ 62730:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('[{"id":4,"alpha2":"af","alpha3":"afg","name":"Afghanistan"},{"id":248,"alpha2":"ax","alpha3":"ala","name":"Åland Islands"},{"id":8,"alpha2":"al","alpha3":"alb","name":"Albania"},{"id":12,"alpha2":"dz","alpha3":"dza","name":"Algeria"},{"id":16,"alpha2":"as","alpha3":"asm","name":"American Samoa"},{"id":20,"alpha2":"ad","alpha3":"and","name":"Andorra"},{"id":24,"alpha2":"ao","alpha3":"ago","name":"Angola"},{"id":660,"alpha2":"ai","alpha3":"aia","name":"Anguilla"},{"id":10,"alpha2":"aq","alpha3":"ata","name":"Antarctica"},{"id":28,"alpha2":"ag","alpha3":"atg","name":"Antigua and Barbuda"},{"id":32,"alpha2":"ar","alpha3":"arg","name":"Argentina"},{"id":51,"alpha2":"am","alpha3":"arm","name":"Armenia"},{"id":533,"alpha2":"aw","alpha3":"abw","name":"Aruba"},{"id":36,"alpha2":"au","alpha3":"aus","name":"Australia"},{"id":40,"alpha2":"at","alpha3":"aut","name":"Austria"},{"id":31,"alpha2":"az","alpha3":"aze","name":"Azerbaijan"},{"id":44,"alpha2":"bs","alpha3":"bhs","name":"Bahamas"},{"id":48,"alpha2":"bh","alpha3":"bhr","name":"Bahrain"},{"id":50,"alpha2":"bd","alpha3":"bgd","name":"Bangladesh"},{"id":52,"alpha2":"bb","alpha3":"brb","name":"Barbados"},{"id":112,"alpha2":"by","alpha3":"blr","name":"Belarus"},{"id":56,"alpha2":"be","alpha3":"bel","name":"Belgium"},{"id":84,"alpha2":"bz","alpha3":"blz","name":"Belize"},{"id":204,"alpha2":"bj","alpha3":"ben","name":"Benin"},{"id":60,"alpha2":"bm","alpha3":"bmu","name":"Bermuda"},{"id":64,"alpha2":"bt","alpha3":"btn","name":"Bhutan"},{"id":68,"alpha2":"bo","alpha3":"bol","name":"Bolivia"},{"id":535,"alpha2":"bq","alpha3":"bes","name":"Bonaire, Sint Eustatius and Saba"},{"id":70,"alpha2":"ba","alpha3":"bih","name":"Bosnia and Herzegovina"},{"id":72,"alpha2":"bw","alpha3":"bwa","name":"Botswana"},{"id":74,"alpha2":"bv","alpha3":"bvt","name":"Bouvet Island"},{"id":76,"alpha2":"br","alpha3":"bra","name":"Brazil"},{"id":86,"alpha2":"io","alpha3":"iot","name":"British Indian Ocean Territory"},{"id":96,"alpha2":"bn","alpha3":"brn","name":"Brunei Darussalam"},{"id":100,"alpha2":"bg","alpha3":"bgr","name":"Bulgaria"},{"id":854,"alpha2":"bf","alpha3":"bfa","name":"Burkina Faso"},{"id":108,"alpha2":"bi","alpha3":"bdi","name":"Burundi"},{"id":132,"alpha2":"cv","alpha3":"cpv","name":"Cabo Verde"},{"id":116,"alpha2":"kh","alpha3":"khm","name":"Cambodia"},{"id":120,"alpha2":"cm","alpha3":"cmr","name":"Cameroon"},{"id":124,"alpha2":"ca","alpha3":"can","name":"Canada"},{"id":136,"alpha2":"ky","alpha3":"cym","name":"Cayman Islands"},{"id":140,"alpha2":"cf","alpha3":"caf","name":"Central African Republic"},{"id":148,"alpha2":"td","alpha3":"tcd","name":"Chad"},{"id":152,"alpha2":"cl","alpha3":"chl","name":"Chile"},{"id":156,"alpha2":"cn","alpha3":"chn","name":"China"},{"id":162,"alpha2":"cx","alpha3":"cxr","name":"Christmas Island"},{"id":166,"alpha2":"cc","alpha3":"cck","name":"Cocos Islands"},{"id":170,"alpha2":"co","alpha3":"col","name":"Colombia"},{"id":174,"alpha2":"km","alpha3":"com","name":"Comoros"},{"id":178,"alpha2":"cg","alpha3":"cog","name":"Congo"},{"id":180,"alpha2":"cd","alpha3":"cod","name":"Democratic Republic of the Congo"},{"id":184,"alpha2":"ck","alpha3":"cok","name":"Cook Islands"},{"id":188,"alpha2":"cr","alpha3":"cri","name":"Costa Rica"},{"id":384,"alpha2":"ci","alpha3":"civ","name":"Côte d\'Ivoire"},{"id":191,"alpha2":"hr","alpha3":"hrv","name":"Croatia"},{"id":192,"alpha2":"cu","alpha3":"cub","name":"Cuba"},{"id":531,"alpha2":"cw","alpha3":"cuw","name":"Curaçao"},{"id":196,"alpha2":"cy","alpha3":"cyp","name":"Cyprus"},{"id":203,"alpha2":"cz","alpha3":"cze","name":"Czechia"},{"id":208,"alpha2":"dk","alpha3":"dnk","name":"Denmark"},{"id":262,"alpha2":"dj","alpha3":"dji","name":"Djibouti"},{"id":212,"alpha2":"dm","alpha3":"dma","name":"Dominica"},{"id":214,"alpha2":"do","alpha3":"dom","name":"Dominican Republic"},{"id":218,"alpha2":"ec","alpha3":"ecu","name":"Ecuador"},{"id":818,"alpha2":"eg","alpha3":"egy","name":"Egypt"},{"id":222,"alpha2":"sv","alpha3":"slv","name":"El Salvador"},{"id":226,"alpha2":"gq","alpha3":"gnq","name":"Equatorial Guinea"},{"id":232,"alpha2":"er","alpha3":"eri","name":"Eritrea"},{"id":233,"alpha2":"ee","alpha3":"est","name":"Estonia"},{"id":748,"alpha2":"sz","alpha3":"swz","name":"Eswatini"},{"id":231,"alpha2":"et","alpha3":"eth","name":"Ethiopia"},{"id":238,"alpha2":"fk","alpha3":"flk","name":"Falkland Islands"},{"id":234,"alpha2":"fo","alpha3":"fro","name":"Faroe Islands"},{"id":242,"alpha2":"fj","alpha3":"fji","name":"Fiji"},{"id":246,"alpha2":"fi","alpha3":"fin","name":"Finland"},{"id":250,"alpha2":"fr","alpha3":"fra","name":"France"},{"id":254,"alpha2":"gf","alpha3":"guf","name":"French Guiana"},{"id":258,"alpha2":"pf","alpha3":"pyf","name":"French Polynesia"},{"id":260,"alpha2":"tf","alpha3":"atf","name":"French Southern Territories"},{"id":266,"alpha2":"ga","alpha3":"gab","name":"Gabon"},{"id":270,"alpha2":"gm","alpha3":"gmb","name":"Gambia"},{"id":268,"alpha2":"ge","alpha3":"geo","name":"Georgia"},{"id":276,"alpha2":"de","alpha3":"deu","name":"Germany"},{"id":288,"alpha2":"gh","alpha3":"gha","name":"Ghana"},{"id":292,"alpha2":"gi","alpha3":"gib","name":"Gibraltar"},{"id":300,"alpha2":"gr","alpha3":"grc","name":"Greece"},{"id":304,"alpha2":"gl","alpha3":"grl","name":"Greenland"},{"id":308,"alpha2":"gd","alpha3":"grd","name":"Grenada"},{"id":312,"alpha2":"gp","alpha3":"glp","name":"Guadeloupe"},{"id":316,"alpha2":"gu","alpha3":"gum","name":"Guam"},{"id":320,"alpha2":"gt","alpha3":"gtm","name":"Guatemala"},{"id":831,"alpha2":"gg","alpha3":"ggy","name":"Guernsey"},{"id":324,"alpha2":"gn","alpha3":"gin","name":"Guinea"},{"id":624,"alpha2":"gw","alpha3":"gnb","name":"Guinea-Bissau"},{"id":328,"alpha2":"gy","alpha3":"guy","name":"Guyana"},{"id":332,"alpha2":"ht","alpha3":"hti","name":"Haiti"},{"id":334,"alpha2":"hm","alpha3":"hmd","name":"Heard Island and McDonald Islands"},{"id":336,"alpha2":"va","alpha3":"vat","name":"Holy See"},{"id":340,"alpha2":"hn","alpha3":"hnd","name":"Honduras"},{"id":344,"alpha2":"hk","alpha3":"hkg","name":"Hong Kong"},{"id":348,"alpha2":"hu","alpha3":"hun","name":"Hungary"},{"id":352,"alpha2":"is","alpha3":"isl","name":"Iceland"},{"id":356,"alpha2":"in","alpha3":"ind","name":"India"},{"id":360,"alpha2":"id","alpha3":"idn","name":"Indonesia"},{"id":364,"alpha2":"ir","alpha3":"irn","name":"Iran"},{"id":368,"alpha2":"iq","alpha3":"irq","name":"Iraq"},{"id":372,"alpha2":"ie","alpha3":"irl","name":"Ireland"},{"id":833,"alpha2":"im","alpha3":"imn","name":"Isle of Man"},{"id":376,"alpha2":"il","alpha3":"isr","name":"Israel"},{"id":380,"alpha2":"it","alpha3":"ita","name":"Italy"},{"id":388,"alpha2":"jm","alpha3":"jam","name":"Jamaica"},{"id":392,"alpha2":"jp","alpha3":"jpn","name":"Japan"},{"id":832,"alpha2":"je","alpha3":"jey","name":"Jersey"},{"id":400,"alpha2":"jo","alpha3":"jor","name":"Jordan"},{"id":398,"alpha2":"kz","alpha3":"kaz","name":"Kazakhstan"},{"id":404,"alpha2":"ke","alpha3":"ken","name":"Kenya"},{"id":296,"alpha2":"ki","alpha3":"kir","name":"Kiribati"},{"id":408,"alpha2":"kp","alpha3":"prk","name":"Korea Democratic People\'s Republic of Korea"},{"id":410,"alpha2":"kr","alpha3":"kor","name":"Korea"},{"id":414,"alpha2":"kw","alpha3":"kwt","name":"Kuwait"},{"id":417,"alpha2":"kg","alpha3":"kgz","name":"Kyrgyzstan"},{"id":418,"alpha2":"la","alpha3":"lao","name":"Lao People\'s Democratic Republic"},{"id":428,"alpha2":"lv","alpha3":"lva","name":"Latvia"},{"id":422,"alpha2":"lb","alpha3":"lbn","name":"Lebanon"},{"id":426,"alpha2":"ls","alpha3":"lso","name":"Lesotho"},{"id":430,"alpha2":"lr","alpha3":"lbr","name":"Liberia"},{"id":434,"alpha2":"ly","alpha3":"lby","name":"Libya"},{"id":438,"alpha2":"li","alpha3":"lie","name":"Liechtenstein"},{"id":440,"alpha2":"lt","alpha3":"ltu","name":"Lithuania"},{"id":442,"alpha2":"lu","alpha3":"lux","name":"Luxembourg"},{"id":446,"alpha2":"mo","alpha3":"mac","name":"Macao"},{"id":450,"alpha2":"mg","alpha3":"mdg","name":"Madagascar"},{"id":454,"alpha2":"mw","alpha3":"mwi","name":"Malawi"},{"id":458,"alpha2":"my","alpha3":"mys","name":"Malaysia"},{"id":462,"alpha2":"mv","alpha3":"mdv","name":"Maldives"},{"id":466,"alpha2":"ml","alpha3":"mli","name":"Mali"},{"id":470,"alpha2":"mt","alpha3":"mlt","name":"Malta"},{"id":584,"alpha2":"mh","alpha3":"mhl","name":"Marshall Islands"},{"id":474,"alpha2":"mq","alpha3":"mtq","name":"Martinique"},{"id":478,"alpha2":"mr","alpha3":"mrt","name":"Mauritania"},{"id":480,"alpha2":"mu","alpha3":"mus","name":"Mauritius"},{"id":175,"alpha2":"yt","alpha3":"myt","name":"Mayotte"},{"id":484,"alpha2":"mx","alpha3":"mex","name":"Mexico"},{"id":583,"alpha2":"fm","alpha3":"fsm","name":"Micronesia"},{"id":498,"alpha2":"md","alpha3":"mda","name":"Moldova"},{"id":492,"alpha2":"mc","alpha3":"mco","name":"Monaco"},{"id":496,"alpha2":"mn","alpha3":"mng","name":"Mongolia"},{"id":499,"alpha2":"me","alpha3":"mne","name":"Montenegro"},{"id":500,"alpha2":"ms","alpha3":"msr","name":"Montserrat"},{"id":504,"alpha2":"ma","alpha3":"mar","name":"Morocco"},{"id":508,"alpha2":"mz","alpha3":"moz","name":"Mozambique"},{"id":104,"alpha2":"mm","alpha3":"mmr","name":"Myanmar"},{"id":516,"alpha2":"na","alpha3":"nam","name":"Namibia"},{"id":520,"alpha2":"nr","alpha3":"nru","name":"Nauru"},{"id":524,"alpha2":"np","alpha3":"npl","name":"Nepal"},{"id":528,"alpha2":"nl","alpha3":"nld","name":"Netherlands"},{"id":540,"alpha2":"nc","alpha3":"ncl","name":"New Caledonia"},{"id":554,"alpha2":"nz","alpha3":"nzl","name":"New Zealand"},{"id":558,"alpha2":"ni","alpha3":"nic","name":"Nicaragua"},{"id":562,"alpha2":"ne","alpha3":"ner","name":"Niger"},{"id":566,"alpha2":"ng","alpha3":"nga","name":"Nigeria"},{"id":570,"alpha2":"nu","alpha3":"niu","name":"Niue"},{"id":574,"alpha2":"nf","alpha3":"nfk","name":"Norfolk Island"},{"id":807,"alpha2":"mk","alpha3":"mkd","name":"North Macedonia"},{"id":580,"alpha2":"mp","alpha3":"mnp","name":"Northern Mariana Islands"},{"id":578,"alpha2":"no","alpha3":"nor","name":"Norway"},{"id":512,"alpha2":"om","alpha3":"omn","name":"Oman"},{"id":586,"alpha2":"pk","alpha3":"pak","name":"Pakistan"},{"id":585,"alpha2":"pw","alpha3":"plw","name":"Palau"},{"id":275,"alpha2":"ps","alpha3":"pse","name":"Palestine, State of"},{"id":591,"alpha2":"pa","alpha3":"pan","name":"Panama"},{"id":598,"alpha2":"pg","alpha3":"png","name":"Papua New Guinea"},{"id":600,"alpha2":"py","alpha3":"pry","name":"Paraguay"},{"id":604,"alpha2":"pe","alpha3":"per","name":"Peru"},{"id":608,"alpha2":"ph","alpha3":"phl","name":"Philippines"},{"id":612,"alpha2":"pn","alpha3":"pcn","name":"Pitcairn"},{"id":616,"alpha2":"pl","alpha3":"pol","name":"Poland"},{"id":620,"alpha2":"pt","alpha3":"prt","name":"Portugal"},{"id":630,"alpha2":"pr","alpha3":"pri","name":"Puerto Rico"},{"id":634,"alpha2":"qa","alpha3":"qat","name":"Qatar"},{"id":638,"alpha2":"re","alpha3":"reu","name":"Réunion"},{"id":642,"alpha2":"ro","alpha3":"rou","name":"Romania"},{"id":643,"alpha2":"ru","alpha3":"rus","name":"Russian Federation"},{"id":646,"alpha2":"rw","alpha3":"rwa","name":"Rwanda"},{"id":652,"alpha2":"bl","alpha3":"blm","name":"Saint Barthélemy"},{"id":654,"alpha2":"sh","alpha3":"shn","name":"Saint Helena, Ascension and Tristan da Cunha"},{"id":659,"alpha2":"kn","alpha3":"kna","name":"Saint Kitts and Nevis"},{"id":662,"alpha2":"lc","alpha3":"lca","name":"Saint Lucia"},{"id":663,"alpha2":"mf","alpha3":"maf","name":"Saint Martin (French part)"},{"id":666,"alpha2":"pm","alpha3":"spm","name":"Saint Pierre and Miquelon"},{"id":670,"alpha2":"vc","alpha3":"vct","name":"Saint Vincent and the Grenadines"},{"id":882,"alpha2":"ws","alpha3":"wsm","name":"Samoa"},{"id":674,"alpha2":"sm","alpha3":"smr","name":"San Marino"},{"id":678,"alpha2":"st","alpha3":"stp","name":"Sao Tome and Principe"},{"id":682,"alpha2":"sa","alpha3":"sau","name":"Saudi Arabia"},{"id":686,"alpha2":"sn","alpha3":"sen","name":"Senegal"},{"id":688,"alpha2":"rs","alpha3":"srb","name":"Serbia"},{"id":690,"alpha2":"sc","alpha3":"syc","name":"Seychelles"},{"id":694,"alpha2":"sl","alpha3":"sle","name":"Sierra Leone"},{"id":702,"alpha2":"sg","alpha3":"sgp","name":"Singapore"},{"id":534,"alpha2":"sx","alpha3":"sxm","name":"Sint Maarten (Dutch part)"},{"id":703,"alpha2":"sk","alpha3":"svk","name":"Slovakia"},{"id":705,"alpha2":"si","alpha3":"svn","name":"Slovenia"},{"id":90,"alpha2":"sb","alpha3":"slb","name":"Solomon Islands"},{"id":706,"alpha2":"so","alpha3":"som","name":"Somalia"},{"id":710,"alpha2":"za","alpha3":"zaf","name":"South Africa"},{"id":239,"alpha2":"gs","alpha3":"sgs","name":"South Georgia and the South Sandwich Islands"},{"id":728,"alpha2":"ss","alpha3":"ssd","name":"South Sudan"},{"id":724,"alpha2":"es","alpha3":"esp","name":"Spain"},{"id":144,"alpha2":"lk","alpha3":"lka","name":"Sri Lanka"},{"id":729,"alpha2":"sd","alpha3":"sdn","name":"Sudan"},{"id":740,"alpha2":"sr","alpha3":"sur","name":"Suriname"},{"id":744,"alpha2":"sj","alpha3":"sjm","name":"Svalbard and Jan Mayen"},{"id":752,"alpha2":"se","alpha3":"swe","name":"Sweden"},{"id":756,"alpha2":"ch","alpha3":"che","name":"Switzerland"},{"id":760,"alpha2":"sy","alpha3":"syr","name":"Syrian Arab Republic"},{"id":158,"alpha2":"tw","alpha3":"twn","name":"Taiwan, Province of China"},{"id":762,"alpha2":"tj","alpha3":"tjk","name":"Tajikistan"},{"id":834,"alpha2":"tz","alpha3":"tza","name":"Tanzania, United Republic of"},{"id":764,"alpha2":"th","alpha3":"tha","name":"Thailand"},{"id":626,"alpha2":"tl","alpha3":"tls","name":"Timor-Leste"},{"id":768,"alpha2":"tg","alpha3":"tgo","name":"Togo"},{"id":772,"alpha2":"tk","alpha3":"tkl","name":"Tokelau"},{"id":776,"alpha2":"to","alpha3":"ton","name":"Tonga"},{"id":780,"alpha2":"tt","alpha3":"tto","name":"Trinidad and Tobago"},{"id":788,"alpha2":"tn","alpha3":"tun","name":"Tunisia"},{"id":792,"alpha2":"tr","alpha3":"tur","name":"Turkey"},{"id":795,"alpha2":"tm","alpha3":"tkm","name":"Turkmenistan"},{"id":796,"alpha2":"tc","alpha3":"tca","name":"Turks and Caicos Islands"},{"id":798,"alpha2":"tv","alpha3":"tuv","name":"Tuvalu"},{"id":800,"alpha2":"ug","alpha3":"uga","name":"Uganda"},{"id":804,"alpha2":"ua","alpha3":"ukr","name":"Ukraine"},{"id":784,"alpha2":"ae","alpha3":"are","name":"United Arab Emirates"},{"id":826,"alpha2":"gb","alpha3":"gbr","name":"United Kingdom of Great Britain and Northern Ireland"},{"id":840,"alpha2":"us","alpha3":"usa","name":"United States of America"},{"id":581,"alpha2":"um","alpha3":"umi","name":"United States Minor Outlying Islands"},{"id":858,"alpha2":"uy","alpha3":"ury","name":"Uruguay"},{"id":860,"alpha2":"uz","alpha3":"uzb","name":"Uzbekistan"},{"id":548,"alpha2":"vu","alpha3":"vut","name":"Vanuatu"},{"id":862,"alpha2":"ve","alpha3":"ven","name":"Venezuela (Bolivarian Republic of)"},{"id":704,"alpha2":"vn","alpha3":"vnm","name":"Viet Nam"},{"id":92,"alpha2":"vg","alpha3":"vgb","name":"Virgin Islands (British)"},{"id":850,"alpha2":"vi","alpha3":"vir","name":"Virgin Islands (U.S.)"},{"id":876,"alpha2":"wf","alpha3":"wlf","name":"Wallis and Futuna"},{"id":732,"alpha2":"eh","alpha3":"esh","name":"Western Sahara"},{"id":887,"alpha2":"ye","alpha3":"yem","name":"Yemen"},{"id":894,"alpha2":"zm","alpha3":"zmb","name":"Zambia"},{"id":716,"alpha2":"zw","alpha3":"zwe","name":"Zimbabwe"}]');

/***/ }),

/***/ 62802:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__(27816)
exports.sha1 = __webpack_require__(63737)
exports.sha224 = __webpack_require__(26710)
exports.sha256 = __webpack_require__(24107)
exports.sha384 = __webpack_require__(32827)
exports.sha512 = __webpack_require__(82890)


/***/ }),

/***/ 62948:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64467);
/* harmony import */ var _base_model_base_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42675);






function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingOptionalServices = /*#__PURE__*/function (_BaseModel) {
  function BookingOptionalServices() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, BookingOptionalServices);
    return _callSuper(this, BookingOptionalServices, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(BookingOptionalServices, _BaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingOptionalServices);
}(_base_model_base_model__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingOptionalServices, "moduleName", 'bookingoptionalservice');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingOptionalServices);

/***/ }),

/***/ 62951:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

/***/ }),

/***/ 63053:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var xor = __webpack_require__(30295)
var Buffer = (__webpack_require__(92861).Buffer)
var incr32 = __webpack_require__(45122)

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),

/***/ 63164:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),

/***/ 63175:
/***/ ((module) => {

"use strict";


var KNOWN_TYPES = ['undefined', 'string', 'number', 'object', 'function', 'boolean', 'symbol'];

module.exports = function defFunc(ajv) {
  defFunc.definition = {
    inline: function (it, keyword, schema) {
      var data = 'data' + (it.dataLevel || '');
      if (typeof schema == 'string') return 'typeof ' + data + ' == "' + schema + '"';
      schema = 'validate.schema' + it.schemaPath + '.' + keyword;
      return schema + '.indexOf(typeof ' + data + ') >= 0';
    },
    metaSchema: {
      anyOf: [
        {
          type: 'string',
          enum: KNOWN_TYPES
        },
        {
          type: 'array',
          items: {
            type: 'string',
            enum: KNOWN_TYPES
          }
        }
      ]
    }
  };

  ajv.addKeyword('typeof', defFunc.definition);
  return ajv;
};


/***/ }),

/***/ 63600:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(74610);

/*<replacement>*/
var util = Object.create(__webpack_require__(15622));
util.inherits = __webpack_require__(56698);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ 63683:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"additionalProperties":true,"properties":{"name":{"description":"The filename template for the target file(s) (https://github.com/webpack-contrib/file-loader#name).","anyOf":[{"type":"string"},{"instanceof":"Function"}]},"outputPath":{"description":"A filesystem path where the target file(s) will be placed (https://github.com/webpack-contrib/file-loader#outputpath).","anyOf":[{"type":"string"},{"instanceof":"Function"}]},"publicPath":{"description":"A custom public path for the target file(s) (https://github.com/webpack-contrib/file-loader#publicpath).","anyOf":[{"type":"string"},{"instanceof":"Function"}]},"postTransformPublicPath":{"description":"A custom transformation function for post-processing the publicPath (https://github.com/webpack-contrib/file-loader#posttransformpublicpath).","instanceof":"Function"},"context":{"description":"A custom file context (https://github.com/webpack-contrib/file-loader#context).","type":"string"},"emitFile":{"description":"Enables/Disables emit files (https://github.com/webpack-contrib/file-loader#emitfile).","type":"boolean"},"regExp":{"description":"A Regular Expression to one or many parts of the target file path. The capture groups can be reused in the name property using [N] placeholder (https://github.com/webpack-contrib/file-loader#regexp).","anyOf":[{"type":"string"},{"instanceof":"RegExp"}]},"esModule":{"description":"By default, file-loader generates JS modules that use the ES modules syntax.","type":"boolean"}},"type":"object"}');

/***/ }),

/***/ 63737:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__(56698)
var Hash = __webpack_require__(90392)
var Buffer = (__webpack_require__(92861).Buffer)

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),

/***/ 63779:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 63966:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('[{"id":4,"alpha2":"af","alpha3":"afg","name":"Afghanistan"},{"id":818,"alpha2":"eg","alpha3":"egy","name":"Ägypten"},{"id":248,"alpha2":"ax","alpha3":"ala","name":"Åland"},{"id":8,"alpha2":"al","alpha3":"alb","name":"Albanien"},{"id":12,"alpha2":"dz","alpha3":"dza","name":"Algerien"},{"id":16,"alpha2":"as","alpha3":"asm","name":"Amerikanisch-Samoa"},{"id":850,"alpha2":"vi","alpha3":"vir","name":"Amerikanische Jungferninseln"},{"id":20,"alpha2":"ad","alpha3":"and","name":"Andorra"},{"id":24,"alpha2":"ao","alpha3":"ago","name":"Angola"},{"id":660,"alpha2":"ai","alpha3":"aia","name":"Anguilla"},{"id":10,"alpha2":"aq","alpha3":"ata","name":"Antarktis (Sonderstatus durch Antarktisvertrag)"},{"id":28,"alpha2":"ag","alpha3":"atg","name":"Antigua und Barbuda"},{"id":226,"alpha2":"gq","alpha3":"gnq","name":"Äquatorialguinea"},{"id":32,"alpha2":"ar","alpha3":"arg","name":"Argentinien"},{"id":51,"alpha2":"am","alpha3":"arm","name":"Armenien"},{"id":533,"alpha2":"aw","alpha3":"abw","name":"Aruba"},{"id":31,"alpha2":"az","alpha3":"aze","name":"Aserbaidschan"},{"id":231,"alpha2":"et","alpha3":"eth","name":"Äthiopien"},{"id":36,"alpha2":"au","alpha3":"aus","name":"Australien"},{"id":44,"alpha2":"bs","alpha3":"bhs","name":"Bahamas"},{"id":48,"alpha2":"bh","alpha3":"bhr","name":"Bahrain"},{"id":50,"alpha2":"bd","alpha3":"bgd","name":"Bangladesch"},{"id":52,"alpha2":"bb","alpha3":"brb","name":"Barbados"},{"id":112,"alpha2":"by","alpha3":"blr","name":"Belarus"},{"id":56,"alpha2":"be","alpha3":"bel","name":"Belgien"},{"id":84,"alpha2":"bz","alpha3":"blz","name":"Belize"},{"id":204,"alpha2":"bj","alpha3":"ben","name":"Benin"},{"id":60,"alpha2":"bm","alpha3":"bmu","name":"Bermuda"},{"id":64,"alpha2":"bt","alpha3":"btn","name":"Bhutan"},{"id":68,"alpha2":"bo","alpha3":"bol","name":"Bolivien"},{"id":535,"alpha2":"bq","alpha3":"bes","name":"Bonaire, Saba, Sint Eustatius"},{"id":70,"alpha2":"ba","alpha3":"bih","name":"Bosnien und Herzegowina"},{"id":72,"alpha2":"bw","alpha3":"bwa","name":"Botswana"},{"id":74,"alpha2":"bv","alpha3":"bvt","name":"Bouvetinsel"},{"id":76,"alpha2":"br","alpha3":"bra","name":"Brasilien"},{"id":92,"alpha2":"vg","alpha3":"vgb","name":"Britische Jungferninseln"},{"id":86,"alpha2":"io","alpha3":"iot","name":"Britisches Territorium im Indischen Ozean"},{"id":96,"alpha2":"bn","alpha3":"brn","name":"Brunei"},{"id":100,"alpha2":"bg","alpha3":"bgr","name":"Bulgarien"},{"id":854,"alpha2":"bf","alpha3":"bfa","name":"Burkina Faso"},{"id":108,"alpha2":"bi","alpha3":"bdi","name":"Burundi"},{"id":152,"alpha2":"cl","alpha3":"chl","name":"Chile"},{"id":156,"alpha2":"cn","alpha3":"chn","name":"Volksrepublik China"},{"id":184,"alpha2":"ck","alpha3":"cok","name":"Cookinseln"},{"id":188,"alpha2":"cr","alpha3":"cri","name":"Costa Rica"},{"id":531,"alpha2":"cw","alpha3":"cuw","name":"Curaçao"},{"id":208,"alpha2":"dk","alpha3":"dnk","name":"Dänemark"},{"id":276,"alpha2":"de","alpha3":"deu","name":"Deutschland"},{"id":212,"alpha2":"dm","alpha3":"dma","name":"Dominica"},{"id":214,"alpha2":"do","alpha3":"dom","name":"Dominikanische Republik"},{"id":262,"alpha2":"dj","alpha3":"dji","name":"Dschibuti"},{"id":218,"alpha2":"ec","alpha3":"ecu","name":"Ecuador"},{"id":384,"alpha2":"ci","alpha3":"civ","name":"Elfenbeinküste"},{"id":222,"alpha2":"sv","alpha3":"slv","name":"El Salvador"},{"id":232,"alpha2":"er","alpha3":"eri","name":"Eritrea"},{"id":233,"alpha2":"ee","alpha3":"est","name":"Estland"},{"id":748,"alpha2":"sz","alpha3":"swz","name":"Eswatini"},{"id":238,"alpha2":"fk","alpha3":"flk","name":"Falklandinseln"},{"id":234,"alpha2":"fo","alpha3":"fro","name":"Färöer"},{"id":242,"alpha2":"fj","alpha3":"fji","name":"Fidschi"},{"id":246,"alpha2":"fi","alpha3":"fin","name":"Finnland"},{"id":250,"alpha2":"fr","alpha3":"fra","name":"Frankreich"},{"id":254,"alpha2":"gf","alpha3":"guf","name":"Französisch-Guayana"},{"id":258,"alpha2":"pf","alpha3":"pyf","name":"Französisch-Polynesien"},{"id":260,"alpha2":"tf","alpha3":"atf","name":"Französische Süd- und Antarktisgebiete"},{"id":266,"alpha2":"ga","alpha3":"gab","name":"Gabun"},{"id":270,"alpha2":"gm","alpha3":"gmb","name":"Gambia"},{"id":268,"alpha2":"ge","alpha3":"geo","name":"Georgien"},{"id":288,"alpha2":"gh","alpha3":"gha","name":"Ghana"},{"id":292,"alpha2":"gi","alpha3":"gib","name":"Gibraltar"},{"id":308,"alpha2":"gd","alpha3":"grd","name":"Grenada"},{"id":300,"alpha2":"gr","alpha3":"grc","name":"Griechenland"},{"id":304,"alpha2":"gl","alpha3":"grl","name":"Grönland"},{"id":312,"alpha2":"gp","alpha3":"glp","name":"Guadeloupe"},{"id":316,"alpha2":"gu","alpha3":"gum","name":"Guam"},{"id":320,"alpha2":"gt","alpha3":"gtm","name":"Guatemala"},{"id":831,"alpha2":"gg","alpha3":"ggy","name":"Guernsey (Kanalinsel)"},{"id":324,"alpha2":"gn","alpha3":"gin","name":"Guinea"},{"id":624,"alpha2":"gw","alpha3":"gnb","name":"Guinea-Bissau"},{"id":328,"alpha2":"gy","alpha3":"guy","name":"Guyana"},{"id":332,"alpha2":"ht","alpha3":"hti","name":"Haiti"},{"id":334,"alpha2":"hm","alpha3":"hmd","name":"Heard und McDonaldinseln"},{"id":340,"alpha2":"hn","alpha3":"hnd","name":"Honduras"},{"id":344,"alpha2":"hk","alpha3":"hkg","name":"Hongkong"},{"id":356,"alpha2":"in","alpha3":"ind","name":"Indien"},{"id":360,"alpha2":"id","alpha3":"idn","name":"Indonesien"},{"id":833,"alpha2":"im","alpha3":"imn","name":"Insel Man"},{"id":368,"alpha2":"iq","alpha3":"irq","name":"Irak"},{"id":364,"alpha2":"ir","alpha3":"irn","name":"Iran"},{"id":372,"alpha2":"ie","alpha3":"irl","name":"Irland"},{"id":352,"alpha2":"is","alpha3":"isl","name":"Island"},{"id":376,"alpha2":"il","alpha3":"isr","name":"Israel"},{"id":380,"alpha2":"it","alpha3":"ita","name":"Italien"},{"id":388,"alpha2":"jm","alpha3":"jam","name":"Jamaika"},{"id":392,"alpha2":"jp","alpha3":"jpn","name":"Japan"},{"id":887,"alpha2":"ye","alpha3":"yem","name":"Jemen"},{"id":832,"alpha2":"je","alpha3":"jey","name":"Jersey (Kanalinsel)"},{"id":400,"alpha2":"jo","alpha3":"jor","name":"Jordanien"},{"id":136,"alpha2":"ky","alpha3":"cym","name":"Kaimaninseln"},{"id":116,"alpha2":"kh","alpha3":"khm","name":"Kambodscha"},{"id":120,"alpha2":"cm","alpha3":"cmr","name":"Kamerun"},{"id":124,"alpha2":"ca","alpha3":"can","name":"Kanada"},{"id":132,"alpha2":"cv","alpha3":"cpv","name":"Kap Verde"},{"id":398,"alpha2":"kz","alpha3":"kaz","name":"Kasachstan"},{"id":634,"alpha2":"qa","alpha3":"qat","name":"Katar"},{"id":404,"alpha2":"ke","alpha3":"ken","name":"Kenia"},{"id":417,"alpha2":"kg","alpha3":"kgz","name":"Kirgisistan"},{"id":296,"alpha2":"ki","alpha3":"kir","name":"Kiribati"},{"id":166,"alpha2":"cc","alpha3":"cck","name":"Kokosinseln"},{"id":170,"alpha2":"co","alpha3":"col","name":"Kolumbien"},{"id":174,"alpha2":"km","alpha3":"com","name":"Komoren"},{"id":180,"alpha2":"cd","alpha3":"cod","name":"Kongo, Demokratische Republik"},{"id":178,"alpha2":"cg","alpha3":"cog","name":"Kongo, Republik"},{"id":408,"alpha2":"kp","alpha3":"prk","name":"Korea, Nord (Nordkorea)"},{"id":410,"alpha2":"kr","alpha3":"kor","name":"Korea, Süd (Südkorea)"},{"id":191,"alpha2":"hr","alpha3":"hrv","name":"Kroatien"},{"id":192,"alpha2":"cu","alpha3":"cub","name":"Kuba"},{"id":414,"alpha2":"kw","alpha3":"kwt","name":"Kuwait"},{"id":418,"alpha2":"la","alpha3":"lao","name":"Laos"},{"id":426,"alpha2":"ls","alpha3":"lso","name":"Lesotho"},{"id":428,"alpha2":"lv","alpha3":"lva","name":"Lettland"},{"id":422,"alpha2":"lb","alpha3":"lbn","name":"Libanon"},{"id":430,"alpha2":"lr","alpha3":"lbr","name":"Liberia"},{"id":434,"alpha2":"ly","alpha3":"lby","name":"Libyen"},{"id":438,"alpha2":"li","alpha3":"lie","name":"Liechtenstein"},{"id":440,"alpha2":"lt","alpha3":"ltu","name":"Litauen"},{"id":442,"alpha2":"lu","alpha3":"lux","name":"Luxemburg"},{"id":446,"alpha2":"mo","alpha3":"mac","name":"Macau"},{"id":450,"alpha2":"mg","alpha3":"mdg","name":"Madagaskar"},{"id":454,"alpha2":"mw","alpha3":"mwi","name":"Malawi"},{"id":458,"alpha2":"my","alpha3":"mys","name":"Malaysia"},{"id":462,"alpha2":"mv","alpha3":"mdv","name":"Malediven"},{"id":466,"alpha2":"ml","alpha3":"mli","name":"Mali"},{"id":470,"alpha2":"mt","alpha3":"mlt","name":"Malta"},{"id":504,"alpha2":"ma","alpha3":"mar","name":"Marokko"},{"id":584,"alpha2":"mh","alpha3":"mhl","name":"Marshallinseln"},{"id":474,"alpha2":"mq","alpha3":"mtq","name":"Martinique"},{"id":478,"alpha2":"mr","alpha3":"mrt","name":"Mauretanien"},{"id":480,"alpha2":"mu","alpha3":"mus","name":"Mauritius"},{"id":175,"alpha2":"yt","alpha3":"myt","name":"Mayotte"},{"id":484,"alpha2":"mx","alpha3":"mex","name":"Mexiko"},{"id":583,"alpha2":"fm","alpha3":"fsm","name":"Mikronesien"},{"id":498,"alpha2":"md","alpha3":"mda","name":"Moldau"},{"id":492,"alpha2":"mc","alpha3":"mco","name":"Monaco"},{"id":496,"alpha2":"mn","alpha3":"mng","name":"Mongolei"},{"id":499,"alpha2":"me","alpha3":"mne","name":"Montenegro"},{"id":500,"alpha2":"ms","alpha3":"msr","name":"Montserrat"},{"id":508,"alpha2":"mz","alpha3":"moz","name":"Mosambik"},{"id":104,"alpha2":"mm","alpha3":"mmr","name":"Myanmar"},{"id":516,"alpha2":"na","alpha3":"nam","name":"Namibia"},{"id":520,"alpha2":"nr","alpha3":"nru","name":"Nauru"},{"id":524,"alpha2":"np","alpha3":"npl","name":"Nepal"},{"id":540,"alpha2":"nc","alpha3":"ncl","name":"Neukaledonien"},{"id":554,"alpha2":"nz","alpha3":"nzl","name":"Neuseeland"},{"id":558,"alpha2":"ni","alpha3":"nic","name":"Nicaragua"},{"id":528,"alpha2":"nl","alpha3":"nld","name":"Niederlande"},{"id":562,"alpha2":"ne","alpha3":"ner","name":"Niger"},{"id":566,"alpha2":"ng","alpha3":"nga","name":"Nigeria"},{"id":570,"alpha2":"nu","alpha3":"niu","name":"Niue"},{"id":580,"alpha2":"mp","alpha3":"mnp","name":"Nördliche Marianen"},{"id":807,"alpha2":"mk","alpha3":"mkd","name":"Nordmazedonien"},{"id":574,"alpha2":"nf","alpha3":"nfk","name":"Norfolkinsel"},{"id":578,"alpha2":"no","alpha3":"nor","name":"Norwegen"},{"id":512,"alpha2":"om","alpha3":"omn","name":"Oman"},{"id":40,"alpha2":"at","alpha3":"aut","name":"Österreich"},{"id":626,"alpha2":"tl","alpha3":"tls","name":"Osttimor"},{"id":586,"alpha2":"pk","alpha3":"pak","name":"Pakistan"},{"id":275,"alpha2":"ps","alpha3":"pse","name":"Palästina"},{"id":585,"alpha2":"pw","alpha3":"plw","name":"Palau"},{"id":591,"alpha2":"pa","alpha3":"pan","name":"Panama"},{"id":598,"alpha2":"pg","alpha3":"png","name":"Papua-Neuguinea"},{"id":600,"alpha2":"py","alpha3":"pry","name":"Paraguay"},{"id":604,"alpha2":"pe","alpha3":"per","name":"Peru"},{"id":608,"alpha2":"ph","alpha3":"phl","name":"Philippinen"},{"id":612,"alpha2":"pn","alpha3":"pcn","name":"Pitcairninseln"},{"id":616,"alpha2":"pl","alpha3":"pol","name":"Polen"},{"id":620,"alpha2":"pt","alpha3":"prt","name":"Portugal"},{"id":630,"alpha2":"pr","alpha3":"pri","name":"Puerto Rico"},{"id":638,"alpha2":"re","alpha3":"reu","name":"Réunion"},{"id":646,"alpha2":"rw","alpha3":"rwa","name":"Ruanda"},{"id":642,"alpha2":"ro","alpha3":"rou","name":"Rumänien"},{"id":643,"alpha2":"ru","alpha3":"rus","name":"Russland"},{"id":90,"alpha2":"sb","alpha3":"slb","name":"Salomonen"},{"id":652,"alpha2":"bl","alpha3":"blm","name":"Saint-Barthélemy"},{"id":663,"alpha2":"mf","alpha3":"maf","name":"Saint-Martin (französischer Teil)"},{"id":894,"alpha2":"zm","alpha3":"zmb","name":"Sambia"},{"id":882,"alpha2":"ws","alpha3":"wsm","name":"Samoa"},{"id":674,"alpha2":"sm","alpha3":"smr","name":"San Marino"},{"id":678,"alpha2":"st","alpha3":"stp","name":"São Tomé und Príncipe"},{"id":682,"alpha2":"sa","alpha3":"sau","name":"Saudi-Arabien"},{"id":752,"alpha2":"se","alpha3":"swe","name":"Schweden"},{"id":756,"alpha2":"ch","alpha3":"che","name":"Schweiz"},{"id":686,"alpha2":"sn","alpha3":"sen","name":"Senegal"},{"id":688,"alpha2":"rs","alpha3":"srb","name":"Serbien"},{"id":690,"alpha2":"sc","alpha3":"syc","name":"Seychellen"},{"id":694,"alpha2":"sl","alpha3":"sle","name":"Sierra Leone"},{"id":716,"alpha2":"zw","alpha3":"zwe","name":"Simbabwe"},{"id":702,"alpha2":"sg","alpha3":"sgp","name":"Singapur"},{"id":534,"alpha2":"sx","alpha3":"sxm","name":"Sint Maarten"},{"id":703,"alpha2":"sk","alpha3":"svk","name":"Slowakei"},{"id":705,"alpha2":"si","alpha3":"svn","name":"Slowenien"},{"id":706,"alpha2":"so","alpha3":"som","name":"Somalia"},{"id":724,"alpha2":"es","alpha3":"esp","name":"Spanien"},{"id":144,"alpha2":"lk","alpha3":"lka","name":"Sri Lanka"},{"id":654,"alpha2":"sh","alpha3":"shn","name":"St. Helena, Ascension und Tristan da Cunha"},{"id":659,"alpha2":"kn","alpha3":"kna","name":"St. Kitts und Nevis"},{"id":662,"alpha2":"lc","alpha3":"lca","name":"St. Lucia"},{"id":666,"alpha2":"pm","alpha3":"spm","name":"Saint-Pierre und Miquelon"},{"id":670,"alpha2":"vc","alpha3":"vct","name":"St. Vincent und die Grenadinen"},{"id":710,"alpha2":"za","alpha3":"zaf","name":"Südafrika"},{"id":729,"alpha2":"sd","alpha3":"sdn","name":"Sudan"},{"id":239,"alpha2":"gs","alpha3":"sgs","name":"Südgeorgien und die Südlichen Sandwichinseln"},{"id":728,"alpha2":"ss","alpha3":"ssd","name":"Südsudan"},{"id":740,"alpha2":"sr","alpha3":"sur","name":"Suriname"},{"id":744,"alpha2":"sj","alpha3":"sjm","name":"Spitzbergen und Jan Mayen"},{"id":760,"alpha2":"sy","alpha3":"syr","name":"Syrien"},{"id":762,"alpha2":"tj","alpha3":"tjk","name":"Tadschikistan"},{"id":158,"alpha2":"tw","alpha3":"twn","name":"Republik China"},{"id":834,"alpha2":"tz","alpha3":"tza","name":"Tansania"},{"id":764,"alpha2":"th","alpha3":"tha","name":"Thailand"},{"id":768,"alpha2":"tg","alpha3":"tgo","name":"Togo"},{"id":772,"alpha2":"tk","alpha3":"tkl","name":"Tokelau"},{"id":776,"alpha2":"to","alpha3":"ton","name":"Tonga"},{"id":780,"alpha2":"tt","alpha3":"tto","name":"Trinidad und Tobago"},{"id":148,"alpha2":"td","alpha3":"tcd","name":"Tschad"},{"id":203,"alpha2":"cz","alpha3":"cze","name":"Tschechien"},{"id":788,"alpha2":"tn","alpha3":"tun","name":"Tunesien"},{"id":792,"alpha2":"tr","alpha3":"tur","name":"Türkei"},{"id":795,"alpha2":"tm","alpha3":"tkm","name":"Turkmenistan"},{"id":796,"alpha2":"tc","alpha3":"tca","name":"Turks- und Caicosinseln"},{"id":798,"alpha2":"tv","alpha3":"tuv","name":"Tuvalu"},{"id":800,"alpha2":"ug","alpha3":"uga","name":"Uganda"},{"id":804,"alpha2":"ua","alpha3":"ukr","name":"Ukraine"},{"id":348,"alpha2":"hu","alpha3":"hun","name":"Ungarn"},{"id":581,"alpha2":"um","alpha3":"umi","name":"United States Minor Outlying Islands"},{"id":858,"alpha2":"uy","alpha3":"ury","name":"Uruguay"},{"id":860,"alpha2":"uz","alpha3":"uzb","name":"Usbekistan"},{"id":548,"alpha2":"vu","alpha3":"vut","name":"Vanuatu"},{"id":336,"alpha2":"va","alpha3":"vat","name":"Vatikanstadt"},{"id":862,"alpha2":"ve","alpha3":"ven","name":"Venezuela"},{"id":784,"alpha2":"ae","alpha3":"are","name":"Vereinigte Arabische Emirate"},{"id":840,"alpha2":"us","alpha3":"usa","name":"Vereinigte Staaten"},{"id":826,"alpha2":"gb","alpha3":"gbr","name":"Vereinigtes Königreich"},{"id":704,"alpha2":"vn","alpha3":"vnm","name":"Vietnam"},{"id":876,"alpha2":"wf","alpha3":"wlf","name":"Wallis und Futuna"},{"id":162,"alpha2":"cx","alpha3":"cxr","name":"Weihnachtsinsel"},{"id":732,"alpha2":"eh","alpha3":"esh","name":"Westsahara"},{"id":140,"alpha2":"cf","alpha3":"caf","name":"Zentralafrikanische Republik"},{"id":196,"alpha2":"cy","alpha3":"cyp","name":"Zypern"}]');

/***/ }),

/***/ 64000:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45458);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);










function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
var View = api.importMixinModule('supplier', 'views');
var SupplierServiceView = /*#__PURE__*/function (_View) {
  function SupplierServiceView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, SupplierServiceView);
    return _callSuper(this, SupplierServiceView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(SupplierServiceView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(SupplierServiceView, null, [{
    key: "options",
    value: function options() {
      var res = _superPropGet(SupplierServiceView, "options", this, 2)([]);
      res.apiEndpoint = '/api/supplier/';
      res.tableName = 'supplier';
      var extraFields = [];
      if (res.extraFields) extraFields = res.extraFields;
      res.extraFields = [].concat((0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(res.extraFields), (0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(this.extraFields));
      return res;
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(SupplierServiceView, "getTableOptions", this, 2)([]);
            case 2:
              res = _context.sent;
              res.serverSide = false;
              res.dataFilter = function (r) {
                return r.SupplierType != "HOTEL";
              };
              //res.fieldsAbmList = ['Name', 'Email', 'Phone', 'Address', 'SupplierClassId'];
              res.title = "Service Suppliers";
              //res.fieldsOrder = ['Name', 'Email', 'Phone', 'Address', 'CompanyName', 'SupplierType'];
              res.fieldsDataReplace.PaymentTypeId = {
                name: "PaymentTypeId",
                relation: "paymenttype",
                optionLabels: "Name",
                editor: "select",
                label: "Payment Type",
                hideFromList: true,
                filters: function filters(row) {
                  if (row.Payments == true) return true;
                }
              };
              res.beforeSave = function (self) {
                self.periodError = null;
                var res = travelTools.checkOverlap(self.periods, 'ServiceId');
                if (res) {
                  self.periodError = res.overlap;
                  self.addError(res.msj);
                  return true;
                }
              };
              //let res = await super.getTableOptions(options);
              return _context.abrupt("return", res);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(View);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(SupplierServiceView, "table", 'supplier');
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(SupplierServiceView, "extraFields", [{
  name: 'ServiceCategories',
  editor: [],
  label: 'Categories',
  closeRow: true,
  icon: 'list',
  rowFields: [{
    name: 'Name',
    label: 'Name'
  }, {
    name: 'Closed',
    hidden: true
  }],
  disabledTab: function disabledTab(record) {
    if (!record.id) return true;
  }
}, {
  name: "SupplierServiceList",
  editor: 'component',
  label: "Services",
  component: 'supplier-service-list',
  icon: 'hiking'
}, {
  name: 'ServiceCost',
  editor: 'component',
  component: 'supplier-service-cost-list',
  label: 'Fares',
  icon: 'dollar-sign'
}]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SupplierServiceView);

/***/ }),

/***/ 64051:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort:
            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
                '_'
            ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


/***/ }),

/***/ 64196:
/***/ ((module) => {

var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

module.exports = function (iterations, keylen) {
  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}


/***/ }),

/***/ 64226:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays:
            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
                '_'
            ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


/***/ }),

/***/ 64367:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};


/***/ }),

/***/ 64467:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ _defineProperty)
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20816);

function _defineProperty(e, r, t) {
  return (r = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),

/***/ 64551:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var resolve = __webpack_require__(91030);

module.exports = {
  Validation: errorSubclass(ValidationError),
  MissingRef: errorSubclass(MissingRefError)
};


function ValidationError(errors) {
  this.message = 'validation failed';
  this.errors = errors;
  this.ajv = this.validation = true;
}


MissingRefError.message = function (baseId, ref) {
  return 'can\'t resolve reference ' + ref + ' from id ' + baseId;
};


function MissingRefError(baseId, ref, message) {
  this.message = message || MissingRefError.message(baseId, ref);
  this.missingRef = resolve.url(baseId, ref);
  this.missingSchema = resolve.normalizeId(resolve.fullPath(this.missingRef));
}


function errorSubclass(Subclass) {
  Subclass.prototype = Object.create(Error.prototype);
  Subclass.prototype.constructor = Subclass;
  return Subclass;
}


/***/ }),

/***/ 64589:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');

/***/ }),

/***/ 64634:
/***/ ((module) => {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ 64688:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 65028:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"Dietary":"Dieta","Medication":"Farmaco","Days":"Giorni","Day":"Giorno","Accommodation":"Pernottamento","Accommodation Options":"Opzioni di Pernottamento","Option":"Opzione","Price":"Prezzo","Price per Person":"Prezzo per persona","Total Trip Price":"Prezzo Totale del viaggio","Room":"Camera","Rooms":"Camere","Prices include":"I prezzi includono","Prices DON\'T include":"I prezzi non includono","Internal operational flights":"Operativo voli interni","International flights":"Voli internazionali","Night":"Notte","Nights":"Notti","based on":"In base a","Meals Included":"Pasti inclusi","Breakfast":"Colazione","Lunch":"Pranzo","Local Operator":"Operatore Locale","Dinner":"Cena","Snack":"Snack","Box Lunch":"Pranzo al sacco","PREPAID TRAVEL VOUCHER":"VOUCHER DI VIAGGIO PREPAGATO","TO":"PER","SERVICES INCLUDED":"SERVIZI INCLUSI","CLIENT":"PASSEGGERO","N° OF ADULTS":"Nº DI ADULTI","N° OF CHILDREN":"N° DI MINORI","DATE":"DATA","DATE IN":"DATA IN","DATE OUT":"DATA OUT","_SIGNATURE":"AGENTE RESPONSABILE","_Word":"Word","COMMENTS":"OSSERVAZIONI","PROPOSE OF TRAVEL FOR":"PROPOSTA DI VIAGGIO PER","TRAVEL FOR":"VIAGGIO PER","DURATION":"DURATA","TRIP MODE":"TIPO DI VIAGGIO","ITINERARY":"ITINERARIO","Itinerary":"ITINERARIO","DIFFICULTY":"DIFFICOLTÀ","EASY":"FACILE","MODERATE":"MODERATO","HARD":"DIFFICILE","BOOK WITH CONFIDENCE":"PRENOTA CON FIDUCIA","TERMS AND CONDITIONS":"TERMINI E CONDIZIONI","NIGHTS ACCOMMODATION IN":"NOTTI DI ALLOGGIO IN","NO DOCUMENTS ATTACHED":"NESSUN DOCUMENTO ALLEGATO","HOW TO BOOK":"COME PRENOTARE","ROOM":"STANZA","ADT":"Adulto","CHD":"Minore","DBL":"Doppia","SGL":"Singola","TPL":"Tripla","CPL":"Quadruple","DBL Room":"Camera Doppia","SGL Room":"Camera Singola","TPL Room":"Camera Tripla","CPL Room":"Camera Quadruple","CAMA EXTRA":"Letto Extra","CAMA EXTRA Room":"Letto Extra","DBL TWIN":"Doppia letti separati","DBL MAT":"Doppia matrimoniale","Optional Services":"Servizi opzionali","Booked by yourself":"Alloggio per conto proprio","Expand All":"Ingrandire Tutto","Hide Hotel Text":"Nascondi il testo dell\'hotel","Show Hotel Text":"Mostra il testo dell\'hotel","Print":"Stampare","Collapse":"Ridurre Tutto","Passengers":"Passeggeri","Services":"Servizi","Service":"Servizo","End of our services":"Fine dei nostri servizi","Privado":"Privato","Regular":"Regolare","Semi Privado":"Semi Privato","Semi-Privado":"Semi-Privato","Included":"Incluso","Not Included":"Non incluso","Useful Information":"Informazioni utili","Our representatives in":"I nostri rappresentanti a","Accommodation during your trip":"Pernottamento durante il viaggio","Terms & Conditions":"Termini e condizioni","Terms and Conditions":"Termini e condizioni","Emergency contacts":"Contatti di emergenza","Booking Information Form":"Formulario di prenotazione","Who booked your trip?":"Chi ha prenotato il tuo viaggio?","Reservation under which name":"Prenotazione a nome di","Country":"Paese","Address":"Indirizzo","Phone Number":"Numero di telefono","Mobile Phone Number":"Numero di cellulare","VIAGGIATORI":"","First Name":"Nome","Second Name":"Secondo nome","Surname":"Cognome","Date of Birth":"Data di nascita","Valid Passport Number":"Numero di passaporto valido","Country of Origin of Passport":"Paese d’origine del passaporto","Room Type?":"Tipo di stanza?","_Allergies":"Allergie? Se sì, quali?","Taking medication? If so, what?":"Prendi medicinali? Se sì, quali?","Dietary Restrictions (Celiac, Vegan, Diabetic. etc)":"Restrizioni alimentari (celiachia, veganismo, diabete, ecc.)","Add Passport":"Aggiungere Passaporto","Add Ticket":"Aggiungere Ticket","More Passengers":"Altri viaggiatori","Cancel_":"Cancellare","INTERNATIONAL FLIGHTS":"VOLI INTERNAZIONALI","ENTRY FLIGHT":"VOLO DI ANDATA","DEPARTURE FLIGHT":"VOLO DI RITORNO","DOMESTIC FLIGHTS (COMPLETE ONLY IF YOU HAVE ALREADY PURCHASED INTERNAL FLIGHTS)":"VOLI NAZIONALI (DA COMPLETARE SOLO SE LI HAI COMPRATI PER CONTO TUO)","More Flights":"+ Voli","I accept":"Accetto","I accept the":"Accetto i","terms and conditions":"termini e condizioni","Send":"Invio","SIGN UP FOR OUR NEWSLETTER":"ABBONATI ALLA NOSTRA NEWSLETTER","RESERVE WITH CONFIDENCE":"PRENOTA CON FIDUCIA","CONTACT US":"CONTATTACI","Date and time of flight":"Data e ora della partenza","Airline and flight number":"Linea aerea e numero di volo","Departure city":"Città di partenza","Arrival city":"Destinazione","Optional Experiences":"ATTIVITÀ OPZIONALI","Argentina Suggested Restaurants":"Argentina - Ristoranti Suggeriti","Chile Suggested Restaurants":"Chile - Ristoranti Suggeriti","Flights Tickets":"VOLI","Flights":"VOLI","Final Confirmation":"CONFERMA FINALE","Pre - final Confirmation":"PRE - FINALE","Documentation for your trip":"DOCUMENTI PER IL VIAGGIO","DOCUMENTS ALREADY SENT":"DOCUMENTI GIÀ INVIATI","Warm regards":"Saluti","Languages":"Lingue","Type of service":"Tipo di servizio","Honeymoon":"Viaggio di nozze","Internal Flights":"Voli interni","International Flights":"Voli internazaionali","Record saved":"Informazioni effettuata","Observations":"Osservazioni","FIELDS_ERRORS":"Uno o più campi contiene un errore. Per favore controllare e riprovare.","PARK ENTRANCES NOT INCLUDED":"Ingresso al parco non incluso","National Park Entrances Included":"Ingresso al parco incluso","TO_":"a","_TO":"al","From":"Da","_From":"Dal","January":"Gennaio","February":"Febbraio","March":"Marzo","April":"Aprile","May":"Maggio","June":"Giugno","July":"Luglio","August":"Agosto","September":"Settembre","October":"Ottobre","November":" Novembre","December":"Dicembre","PARK ENTRANCES INCLUDED":"Ingressi inclusi","Passenger Mobile Number":"Numero di cellulare del passeggero","PASSENGERS":"PASSEGGERI","View like":"Per vedere come","Full Trip":"Viaggio Completo","Other Documents":"Altri Documenti","Others":"Altri","Simplified view":"Vista semplificata","Full view":"Vista completa","Passport Expiration Date":"Data di Scadenza del Passaporto","See More":"Vedi altro","See Less":"Vedi di meno","Private":"Privato","Operations":"Operazioni","Attachments sent":"Allegati inviati","the general terms and conditions of sale":"le condizioni generali di vendita","Travel Details":"Dettagli di viaggio","Accepted on":"Accettato il","Confirm":"Conferma","the itinerary":"il itinerario","the privacy policy":"l\'informativa sulla privacy","Reservation made":"Prenotazione effettuata","Maximum allowed file size":"Dimensione archivio massima consentita","Max. allowed size":"Dimensione massima","Sending attachments":"Invio di allegati","_contact_person":"Persona da avvisare in caso di necessità durante il viaggio","Contact Relation":"Relazione di contatto","Name and Surname":"Nome e cognome","Insurance Company":"Azenda di assistenza","Insurance Type":"Tipo di assistenza","Member Number":"Numero di socio","Name":"Nome","Phone":"Telefono","Home":"Inizio","Click here":"Fai click qui","Any ideas or suggestions about this app?":"Qualche idea o suggerimento riguardo questa app?","Comments or suggestions about this app?":"Commenti o suggerimenti riguardo questa app?","Help us to improve":"Aiutaci a migliorare","Loading, wait please":"Caricando, attendere prego","What can we do better?":"In cosa possiamo migliorare?","Emergency Contacts":"Contatti d\'emergenza","New Trip":"Nuovo viaggio","About":"Su di noi","Monday":"Lunedi","Friday":"Venerdi","Fields required":"Campi obbligatori","YES":"SÌ","_entrance_includes":"Ingresso al parco incluso","travel contract":"contratto di viaggio","Optional Service":"Servizio opzionale","Discount per person":"Sconto per persona","Discounted price":"Prezzo scontato","There are emojis or special characters that you must remove before saving your data":"Ci sono emoji o caratteri speciali che devi rimuovere prima di salvare i tuoi dati","Not Refundable Services":"Servizi non rimborsabili","NOT_AVAILABLE_DATE":"La data di inizio è inferiore alla data attuale","City of Residence":"Città di residenza","Quotation method not permitted":"Metodo di quotazione non consentito","Show Multi Quote By":"Mostra Multi Quotazione Per","Quantity / Pax Quantity":"Quantità / Quantità di Pax","Base / Rooms":"Base / Camere","Markup":"Margine di Guadagno","Cost Per Person":"Costo per Persona","Add Required Items":"Aggiungi Elementi Richiesti","Currency is required in service cost":"La valuta è richiesta nel costo del servizio"}');

/***/ }),

/***/ 65034:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(65606);


var _Object$setPrototypeO;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var finished = __webpack_require__(14257);
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}
function readAndResolve(iter) {
  var resolve = iter[kLastResolve];
  if (resolve !== null) {
    var data = iter[kStream].read();
    // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'
    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}
function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }
      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },
  next: function next() {
    var _this = this;
    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];
    if (error !== null) {
      return Promise.reject(error);
    }
    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }
    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    }

    // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time
    var lastPromise = this[kLastPromise];
    var promise;
    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();
      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }
      promise = new Promise(this[kHandlePromise]);
    }
    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;
  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }
      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;
  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();
      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject];
      // reject if we are waiting for data in the Promise
      // returned by next() and store the error
      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }
      iterator[kError] = err;
      return;
    }
    var resolve = iterator[kLastResolve];
    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }
    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};
module.exports = createReadableStreamAsyncIterator;

/***/ }),

/***/ 65243:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ 65279:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var assert = __webpack_require__(43349);
var inherits = __webpack_require__(56698);

var Cipher = __webpack_require__(82808);
var DES = __webpack_require__(82211);

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),

/***/ 65543:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),

/***/ 65556:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8818);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BaseQuoteView = /*#__PURE__*/function (_View) {
  function BaseQuoteView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BaseQuoteView);
    return _callSuper(this, BaseQuoteView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BaseQuoteView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BaseQuoteView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", {
                fields: [{
                  name: 'TourLeader',
                  defValue: false
                }, {
                  name: 'SingleSupplement',
                  defValue: false
                }]
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BaseQuoteView, "table", 'basequote');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BaseQuoteView);

/***/ }),

/***/ 65606:
/***/ ((module) => {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 65730:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64467);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8818);






function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingOptionalService = /*#__PURE__*/function (_View) {
  function BookingOptionalService() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, BookingOptionalService);
    return _callSuper(this, BookingOptionalService, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(BookingOptionalService, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingOptionalService);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingOptionalService, "table", 'bookingoptionalservice');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingOptionalService);

/***/ }),

/***/ 66011:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var Buffer = (__webpack_require__(48287).Buffer)
var inherits = __webpack_require__(56698)
var HashBase = __webpack_require__(4729)

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),

/***/ 66089:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 66166:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(67426);
var assert = __webpack_require__(43349);

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),

/***/ 66225:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(67426);
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;


/***/ }),

/***/ 66432:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8818);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }

var LeadStatusView = /*#__PURE__*/function (_View) {
  function LeadStatusView() {
    _classCallCheck(this, LeadStatusView);
    return _callSuper(this, LeadStatusView, arguments);
  }
  _inherits(LeadStatusView, _View);
  return _createClass(LeadStatusView, null, [{
    key: "options",
    value: function options() {
      return {
        canAdd: true,
        fieldsDataReplace: {
          Color: {
            name: 'Color',
            editor: 'color',
            abmSlot: 'color'
          }
        }
        //fieldsAbmList: ['Name', 'Color'],
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(LeadStatusView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_0__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LeadStatusView);

/***/ }),

/***/ 66473:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = (__webpack_require__(66089).Buffer);
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);


/***/ }),

/***/ 66506:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_model_record__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55539);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var PurchaseInvoice = /*#__PURE__*/function (_Record) {
  function PurchaseInvoice() {
    _classCallCheck(this, PurchaseInvoice);
    return _callSuper(this, PurchaseInvoice, arguments);
  }
  _inherits(PurchaseInvoice, _Record);
  return _createClass(PurchaseInvoice, [{
    key: "canDelete",
    get: function get() {
      var userCanDelete = tools.canAccess(api.currentUser, 'api', 'DELETE', '/purchaseinvoice', false);
      if (!userCanDelete) return false;
      return true;
    }
  }]);
}(_base_model_record__WEBPACK_IMPORTED_MODULE_0__["default"]);
_defineProperty(PurchaseInvoice, "table", 'purchaseinvoice');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PurchaseInvoice);

/***/ }),

/***/ 66584:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),

/***/ 66644:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var ERR_INVALID_OPT_VALUE = (__webpack_require__(12463)/* .codes */ .F).ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }
    return Math.floor(hwm);
  }

  // Default value
  return state.objectMode ? 16 : 16 * 1024;
}
module.exports = {
  getHighWaterMark: getHighWaterMark
};

/***/ }),

/***/ 66797:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64467);
/* harmony import */ var _base_model_record__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55539);






function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var User = /*#__PURE__*/function (_Record) {
  function User() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, User);
    return _callSuper(this, User, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(User, _Record);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(User);
}(_base_model_record__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(User, "moduleName", 'user');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (User);

/***/ }),

/***/ 67332:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var BN = __webpack_require__(39404);
var randomBytes = __webpack_require__(53209);
var Buffer = (__webpack_require__(92861).Buffer);

function getr(priv) {
	var len = priv.modulus.byteLength();
	var r;
	do {
		r = new BN(randomBytes(len));
	} while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
	return r;
}

function blind(priv) {
	var r = getr(priv);
	var blinder = r.toRed(BN.mont(priv.modulus)).redPow(new BN(priv.publicExponent)).fromRed();
	return { blinder: blinder, unblinder: r.invm(priv.modulus) };
}

function crt(msg, priv) {
	var blinds = blind(priv);
	var len = priv.modulus.byteLength();
	var blinded = new BN(msg).mul(blinds.blinder).umod(priv.modulus);
	var c1 = blinded.toRed(BN.mont(priv.prime1));
	var c2 = blinded.toRed(BN.mont(priv.prime2));
	var qinv = priv.coefficient;
	var p = priv.prime1;
	var q = priv.prime2;
	var m1 = c1.redPow(priv.exponent1).fromRed();
	var m2 = c2.redPow(priv.exponent2).fromRed();
	var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
	return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike(Buffer, 'be', len);
}
crt.getr = getr;

module.exports = crt;


/***/ }),

/***/ 67426:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var assert = __webpack_require__(43349);
var inherits = __webpack_require__(56698);

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;


/***/ }),

/***/ 67526:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 67537:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('[{"id":4,"alpha2":"af","alpha3":"afg","name":"Afganistán"},{"id":248,"alpha2":"ax","alpha3":"ala","name":"Åland"},{"id":8,"alpha2":"al","alpha3":"alb","name":"Albania"},{"id":276,"alpha2":"de","alpha3":"deu","name":"Alemania"},{"id":20,"alpha2":"ad","alpha3":"and","name":"Andorra"},{"id":24,"alpha2":"ao","alpha3":"ago","name":"Angola"},{"id":660,"alpha2":"ai","alpha3":"aia","name":"Anguila"},{"id":10,"alpha2":"aq","alpha3":"ata","name":"Antártida"},{"id":28,"alpha2":"ag","alpha3":"atg","name":"Antigua y Barbuda"},{"id":682,"alpha2":"sa","alpha3":"sau","name":"Arabia Saudita"},{"id":12,"alpha2":"dz","alpha3":"dza","name":"Argelia"},{"id":32,"alpha2":"ar","alpha3":"arg","name":"Argentina"},{"id":51,"alpha2":"am","alpha3":"arm","name":"Armenia"},{"id":533,"alpha2":"aw","alpha3":"abw","name":"Aruba"},{"id":36,"alpha2":"au","alpha3":"aus","name":"Australia"},{"id":40,"alpha2":"at","alpha3":"aut","name":"Austria"},{"id":31,"alpha2":"az","alpha3":"aze","name":"Azerbaiyán"},{"id":44,"alpha2":"bs","alpha3":"bhs","name":"Bahamas"},{"id":50,"alpha2":"bd","alpha3":"bgd","name":"Bangladés"},{"id":52,"alpha2":"bb","alpha3":"brb","name":"Barbados"},{"id":48,"alpha2":"bh","alpha3":"bhr","name":"Baréin"},{"id":56,"alpha2":"be","alpha3":"bel","name":"Bélgica"},{"id":84,"alpha2":"bz","alpha3":"blz","name":"Belice"},{"id":204,"alpha2":"bj","alpha3":"ben","name":"Benín"},{"id":60,"alpha2":"bm","alpha3":"bmu","name":"Bermudas"},{"id":112,"alpha2":"by","alpha3":"blr","name":"Bielorrusia"},{"id":68,"alpha2":"bo","alpha3":"bol","name":"Bolivia"},{"id":535,"alpha2":"bq","alpha3":"bes","name":"Bonaire, San Eustaquio y Saba"},{"id":70,"alpha2":"ba","alpha3":"bih","name":"Bosnia y Herzegovina"},{"id":72,"alpha2":"bw","alpha3":"bwa","name":"Botsuana"},{"id":76,"alpha2":"br","alpha3":"bra","name":"Brasil"},{"id":96,"alpha2":"bn","alpha3":"brn","name":"Brunéi"},{"id":100,"alpha2":"bg","alpha3":"bgr","name":"Bulgaria"},{"id":854,"alpha2":"bf","alpha3":"bfa","name":"Burkina Faso"},{"id":108,"alpha2":"bi","alpha3":"bdi","name":"Burundi"},{"id":64,"alpha2":"bt","alpha3":"btn","name":"Bután"},{"id":132,"alpha2":"cv","alpha3":"cpv","name":"Cabo Verde"},{"id":116,"alpha2":"kh","alpha3":"khm","name":"Camboya"},{"id":120,"alpha2":"cm","alpha3":"cmr","name":"Camerún"},{"id":124,"alpha2":"ca","alpha3":"can","name":"Canadá"},{"id":634,"alpha2":"qa","alpha3":"qat","name":"Catar"},{"id":148,"alpha2":"td","alpha3":"tcd","name":"Chad"},{"id":152,"alpha2":"cl","alpha3":"chl","name":"Chile"},{"id":156,"alpha2":"cn","alpha3":"chn","name":"China"},{"id":196,"alpha2":"cy","alpha3":"cyp","name":"Chipre"},{"id":170,"alpha2":"co","alpha3":"col","name":"Colombia"},{"id":174,"alpha2":"km","alpha3":"com","name":"Comoras"},{"id":408,"alpha2":"kp","alpha3":"prk","name":"Corea del Norte"},{"id":410,"alpha2":"kr","alpha3":"kor","name":"Corea del Sur"},{"id":384,"alpha2":"ci","alpha3":"civ","name":"Costa de Marfil"},{"id":188,"alpha2":"cr","alpha3":"cri","name":"Costa Rica"},{"id":191,"alpha2":"hr","alpha3":"hrv","name":"Croacia"},{"id":192,"alpha2":"cu","alpha3":"cub","name":"Cuba"},{"id":531,"alpha2":"cw","alpha3":"cuw","name":"Curazao"},{"id":208,"alpha2":"dk","alpha3":"dnk","name":"Dinamarca"},{"id":212,"alpha2":"dm","alpha3":"dma","name":"Dominica"},{"id":218,"alpha2":"ec","alpha3":"ecu","name":"Ecuador"},{"id":818,"alpha2":"eg","alpha3":"egy","name":"Egipto"},{"id":222,"alpha2":"sv","alpha3":"slv","name":"El Salvador"},{"id":784,"alpha2":"ae","alpha3":"are","name":"Emiratos Árabes Unidos"},{"id":232,"alpha2":"er","alpha3":"eri","name":"Eritrea"},{"id":703,"alpha2":"sk","alpha3":"svk","name":"Eslovaquia"},{"id":705,"alpha2":"si","alpha3":"svn","name":"Eslovenia"},{"id":724,"alpha2":"es","alpha3":"esp","name":"España"},{"id":840,"alpha2":"us","alpha3":"usa","name":"Estados Unidos"},{"id":233,"alpha2":"ee","alpha3":"est","name":"Estonia"},{"id":231,"alpha2":"et","alpha3":"eth","name":"Etiopía"},{"id":608,"alpha2":"ph","alpha3":"phl","name":"Filipinas"},{"id":246,"alpha2":"fi","alpha3":"fin","name":"Finlandia"},{"id":242,"alpha2":"fj","alpha3":"fji","name":"Fiyi"},{"id":250,"alpha2":"fr","alpha3":"fra","name":"Francia"},{"id":266,"alpha2":"ga","alpha3":"gab","name":"Gabón"},{"id":270,"alpha2":"gm","alpha3":"gmb","name":"Gambia"},{"id":268,"alpha2":"ge","alpha3":"geo","name":"Georgia"},{"id":288,"alpha2":"gh","alpha3":"gha","name":"Ghana"},{"id":292,"alpha2":"gi","alpha3":"gib","name":"Gibraltar"},{"id":308,"alpha2":"gd","alpha3":"grd","name":"Granada"},{"id":300,"alpha2":"gr","alpha3":"grc","name":"Grecia"},{"id":304,"alpha2":"gl","alpha3":"grl","name":"Groenlandia"},{"id":312,"alpha2":"gp","alpha3":"glp","name":"Guadalupe"},{"id":316,"alpha2":"gu","alpha3":"gum","name":"Guam"},{"id":320,"alpha2":"gt","alpha3":"gtm","name":"Guatemala"},{"id":254,"alpha2":"gf","alpha3":"guf","name":"Guayana Francesa"},{"id":831,"alpha2":"gg","alpha3":"ggy","name":"Guernsey"},{"id":324,"alpha2":"gn","alpha3":"gin","name":"Guinea"},{"id":624,"alpha2":"gw","alpha3":"gnb","name":"Guinea-Bisáu"},{"id":226,"alpha2":"gq","alpha3":"gnq","name":"Guinea Ecuatorial"},{"id":328,"alpha2":"gy","alpha3":"guy","name":"Guyana"},{"id":332,"alpha2":"ht","alpha3":"hti","name":"Haití"},{"id":340,"alpha2":"hn","alpha3":"hnd","name":"Honduras"},{"id":344,"alpha2":"hk","alpha3":"hkg","name":"Hong Kong"},{"id":348,"alpha2":"hu","alpha3":"hun","name":"Hungría"},{"id":356,"alpha2":"in","alpha3":"ind","name":"India"},{"id":360,"alpha2":"id","alpha3":"idn","name":"Indonesia"},{"id":368,"alpha2":"iq","alpha3":"irq","name":"Irak"},{"id":364,"alpha2":"ir","alpha3":"irn","name":"Irán"},{"id":372,"alpha2":"ie","alpha3":"irl","name":"Irlanda"},{"id":74,"alpha2":"bv","alpha3":"bvt","name":"Isla Bouvet"},{"id":833,"alpha2":"im","alpha3":"imn","name":"Isla de Man"},{"id":162,"alpha2":"cx","alpha3":"cxr","name":"Isla de Navidad"},{"id":352,"alpha2":"is","alpha3":"isl","name":"Islandia"},{"id":136,"alpha2":"ky","alpha3":"cym","name":"Islas Caimán"},{"id":166,"alpha2":"cc","alpha3":"cck","name":"Islas Cocos"},{"id":184,"alpha2":"ck","alpha3":"cok","name":"Islas Cook"},{"id":234,"alpha2":"fo","alpha3":"fro","name":"Islas Feroe"},{"id":239,"alpha2":"gs","alpha3":"sgs","name":"Islas Georgias del Sur y Sandwich del Sur"},{"id":334,"alpha2":"hm","alpha3":"hmd","name":"Islas Heard y McDonald"},{"id":238,"alpha2":"fk","alpha3":"flk","name":"Islas Malvinas"},{"id":580,"alpha2":"mp","alpha3":"mnp","name":"Islas Marianas del Norte"},{"id":584,"alpha2":"mh","alpha3":"mhl","name":"Islas Marshall"},{"id":612,"alpha2":"pn","alpha3":"pcn","name":"Islas Pitcairn"},{"id":90,"alpha2":"sb","alpha3":"slb","name":"Islas Salomón"},{"id":796,"alpha2":"tc","alpha3":"tca","name":"Islas Turcas y Caicos"},{"id":581,"alpha2":"um","alpha3":"umi","name":"Islas Ultramarinas Menores de los Estados Unidos"},{"id":92,"alpha2":"vg","alpha3":"vgb","name":"Islas Vírgenes Británicas"},{"id":850,"alpha2":"vi","alpha3":"vir","name":"Islas Vírgenes de los Estados Unidos"},{"id":376,"alpha2":"il","alpha3":"isr","name":"Israel"},{"id":380,"alpha2":"it","alpha3":"ita","name":"Italia"},{"id":388,"alpha2":"jm","alpha3":"jam","name":"Jamaica"},{"id":392,"alpha2":"jp","alpha3":"jpn","name":"Japón"},{"id":832,"alpha2":"je","alpha3":"jey","name":"Jersey"},{"id":400,"alpha2":"jo","alpha3":"jor","name":"Jordania"},{"id":398,"alpha2":"kz","alpha3":"kaz","name":"Kazajistán"},{"id":404,"alpha2":"ke","alpha3":"ken","name":"Kenia"},{"id":417,"alpha2":"kg","alpha3":"kgz","name":"Kirguistán"},{"id":296,"alpha2":"ki","alpha3":"kir","name":"Kiribati"},{"id":414,"alpha2":"kw","alpha3":"kwt","name":"Kuwait"},{"id":418,"alpha2":"la","alpha3":"lao","name":"Laos"},{"id":426,"alpha2":"ls","alpha3":"lso","name":"Lesoto"},{"id":428,"alpha2":"lv","alpha3":"lva","name":"Letonia"},{"id":422,"alpha2":"lb","alpha3":"lbn","name":"Líbano"},{"id":430,"alpha2":"lr","alpha3":"lbr","name":"Liberia"},{"id":434,"alpha2":"ly","alpha3":"lby","name":"Libia"},{"id":438,"alpha2":"li","alpha3":"lie","name":"Liechtenstein"},{"id":440,"alpha2":"lt","alpha3":"ltu","name":"Lituania"},{"id":442,"alpha2":"lu","alpha3":"lux","name":"Luxemburgo"},{"id":446,"alpha2":"mo","alpha3":"mac","name":"Macao"},{"id":807,"alpha2":"mk","alpha3":"mkd","name":"Macedonia del Norte"},{"id":450,"alpha2":"mg","alpha3":"mdg","name":"Madagascar"},{"id":458,"alpha2":"my","alpha3":"mys","name":"Malasia"},{"id":454,"alpha2":"mw","alpha3":"mwi","name":"Malaui"},{"id":462,"alpha2":"mv","alpha3":"mdv","name":"Maldivas"},{"id":466,"alpha2":"ml","alpha3":"mli","name":"Malí"},{"id":470,"alpha2":"mt","alpha3":"mlt","name":"Malta"},{"id":504,"alpha2":"ma","alpha3":"mar","name":"Marruecos"},{"id":474,"alpha2":"mq","alpha3":"mtq","name":"Martinica"},{"id":480,"alpha2":"mu","alpha3":"mus","name":"Mauricio"},{"id":478,"alpha2":"mr","alpha3":"mrt","name":"Mauritania"},{"id":175,"alpha2":"yt","alpha3":"myt","name":"Mayotte"},{"id":484,"alpha2":"mx","alpha3":"mex","name":"México"},{"id":583,"alpha2":"fm","alpha3":"fsm","name":"Micronesia"},{"id":498,"alpha2":"md","alpha3":"mda","name":"Moldavia"},{"id":492,"alpha2":"mc","alpha3":"mco","name":"Mónaco"},{"id":496,"alpha2":"mn","alpha3":"mng","name":"Mongolia"},{"id":499,"alpha2":"me","alpha3":"mne","name":"Montenegro"},{"id":500,"alpha2":"ms","alpha3":"msr","name":"Montserrat"},{"id":508,"alpha2":"mz","alpha3":"moz","name":"Mozambique"},{"id":104,"alpha2":"mm","alpha3":"mmr","name":"Birmania"},{"id":516,"alpha2":"na","alpha3":"nam","name":"Namibia"},{"id":520,"alpha2":"nr","alpha3":"nru","name":"Nauru"},{"id":524,"alpha2":"np","alpha3":"npl","name":"Nepal"},{"id":558,"alpha2":"ni","alpha3":"nic","name":"Nicaragua"},{"id":562,"alpha2":"ne","alpha3":"ner","name":"Níger"},{"id":566,"alpha2":"ng","alpha3":"nga","name":"Nigeria"},{"id":570,"alpha2":"nu","alpha3":"niu","name":"Niue"},{"id":574,"alpha2":"nf","alpha3":"nfk","name":"Isla Norfolk"},{"id":578,"alpha2":"no","alpha3":"nor","name":"Noruega"},{"id":540,"alpha2":"nc","alpha3":"ncl","name":"Nueva Caledonia"},{"id":554,"alpha2":"nz","alpha3":"nzl","name":"Nueva Zelanda"},{"id":512,"alpha2":"om","alpha3":"omn","name":"Omán"},{"id":528,"alpha2":"nl","alpha3":"nld","name":"Países Bajos"},{"id":586,"alpha2":"pk","alpha3":"pak","name":"Pakistán"},{"id":585,"alpha2":"pw","alpha3":"plw","name":"Palaos"},{"id":275,"alpha2":"ps","alpha3":"pse","name":"Palestina"},{"id":591,"alpha2":"pa","alpha3":"pan","name":"Panamá"},{"id":598,"alpha2":"pg","alpha3":"png","name":"Papúa Nueva Guinea"},{"id":600,"alpha2":"py","alpha3":"pry","name":"Paraguay"},{"id":604,"alpha2":"pe","alpha3":"per","name":"Perú"},{"id":258,"alpha2":"pf","alpha3":"pyf","name":"Polinesia Francesa"},{"id":616,"alpha2":"pl","alpha3":"pol","name":"Polonia"},{"id":620,"alpha2":"pt","alpha3":"prt","name":"Portugal"},{"id":630,"alpha2":"pr","alpha3":"pri","name":"Puerto Rico"},{"id":826,"alpha2":"gb","alpha3":"gbr","name":"Reino Unido"},{"id":732,"alpha2":"eh","alpha3":"esh","name":"República Árabe Saharaui Democrática"},{"id":140,"alpha2":"cf","alpha3":"caf","name":"República Centroafricana"},{"id":203,"alpha2":"cz","alpha3":"cze","name":"República Checa"},{"id":178,"alpha2":"cg","alpha3":"cog","name":"República del Congo"},{"id":180,"alpha2":"cd","alpha3":"cod","name":"República Democrática del Congo"},{"id":214,"alpha2":"do","alpha3":"dom","name":"República Dominicana"},{"id":638,"alpha2":"re","alpha3":"reu","name":"Reunión"},{"id":646,"alpha2":"rw","alpha3":"rwa","name":"Ruanda"},{"id":642,"alpha2":"ro","alpha3":"rou","name":"Rumania"},{"id":643,"alpha2":"ru","alpha3":"rus","name":"Rusia"},{"id":882,"alpha2":"ws","alpha3":"wsm","name":"Samoa"},{"id":16,"alpha2":"as","alpha3":"asm","name":"Samoa Americana"},{"id":652,"alpha2":"bl","alpha3":"blm","name":"San Bartolomé"},{"id":659,"alpha2":"kn","alpha3":"kna","name":"San Cristóbal y Nieves"},{"id":674,"alpha2":"sm","alpha3":"smr","name":"San Marino"},{"id":663,"alpha2":"mf","alpha3":"maf","name":"San Martín"},{"id":666,"alpha2":"pm","alpha3":"spm","name":"San Pedro y Miquelón"},{"id":670,"alpha2":"vc","alpha3":"vct","name":"San Vicente y las Granadinas"},{"id":654,"alpha2":"sh","alpha3":"shn","name":"Santa Elena, Ascensión y Tristán de Acuña"},{"id":662,"alpha2":"lc","alpha3":"lca","name":"Santa Lucía"},{"id":678,"alpha2":"st","alpha3":"stp","name":"Santo Tomé y Príncipe"},{"id":686,"alpha2":"sn","alpha3":"sen","name":"Senegal"},{"id":688,"alpha2":"rs","alpha3":"srb","name":"Serbia"},{"id":690,"alpha2":"sc","alpha3":"syc","name":"Seychelles"},{"id":694,"alpha2":"sl","alpha3":"sle","name":"Sierra Leona"},{"id":702,"alpha2":"sg","alpha3":"sgp","name":"Singapur"},{"id":534,"alpha2":"sx","alpha3":"sxm","name":"San Martín"},{"id":760,"alpha2":"sy","alpha3":"syr","name":"Siria"},{"id":706,"alpha2":"so","alpha3":"som","name":"Somalia"},{"id":144,"alpha2":"lk","alpha3":"lka","name":"Sri Lanka"},{"id":748,"alpha2":"sz","alpha3":"swz","name":"Suazilandia"},{"id":710,"alpha2":"za","alpha3":"zaf","name":"Sudáfrica"},{"id":729,"alpha2":"sd","alpha3":"sdn","name":"Sudán"},{"id":728,"alpha2":"ss","alpha3":"ssd","name":"Sudán del Sur"},{"id":752,"alpha2":"se","alpha3":"swe","name":"Suecia"},{"id":756,"alpha2":"ch","alpha3":"che","name":"Suiza"},{"id":740,"alpha2":"sr","alpha3":"sur","name":"Surinam"},{"id":744,"alpha2":"sj","alpha3":"sjm","name":"Svalbard y Jan Mayen"},{"id":764,"alpha2":"th","alpha3":"tha","name":"Tailandia"},{"id":158,"alpha2":"tw","alpha3":"twn","name":"Taiwán (República de China)"},{"id":834,"alpha2":"tz","alpha3":"tza","name":"Tanzania"},{"id":762,"alpha2":"tj","alpha3":"tjk","name":"Tayikistán"},{"id":86,"alpha2":"io","alpha3":"iot","name":"Territorio Británico del Océano Índico"},{"id":260,"alpha2":"tf","alpha3":"atf","name":"Tierras Australes y Antárticas Francesas"},{"id":626,"alpha2":"tl","alpha3":"tls","name":"Timor Oriental"},{"id":768,"alpha2":"tg","alpha3":"tgo","name":"Togo"},{"id":772,"alpha2":"tk","alpha3":"tkl","name":"Tokelau"},{"id":776,"alpha2":"to","alpha3":"ton","name":"Tonga"},{"id":780,"alpha2":"tt","alpha3":"tto","name":"Trinidad y Tobago"},{"id":788,"alpha2":"tn","alpha3":"tun","name":"Túnez"},{"id":795,"alpha2":"tm","alpha3":"tkm","name":"Turkmenistán"},{"id":792,"alpha2":"tr","alpha3":"tur","name":"Turquía"},{"id":798,"alpha2":"tv","alpha3":"tuv","name":"Tuvalu"},{"id":804,"alpha2":"ua","alpha3":"ukr","name":"Ucrania"},{"id":800,"alpha2":"ug","alpha3":"uga","name":"Uganda"},{"id":858,"alpha2":"uy","alpha3":"ury","name":"Uruguay"},{"id":860,"alpha2":"uz","alpha3":"uzb","name":"Uzbekistán"},{"id":548,"alpha2":"vu","alpha3":"vut","name":"Vanuatu"},{"id":336,"alpha2":"va","alpha3":"vat","name":"Vaticano, Ciudad del"},{"id":862,"alpha2":"ve","alpha3":"ven","name":"Venezuela"},{"id":704,"alpha2":"vn","alpha3":"vnm","name":"Vietnam"},{"id":876,"alpha2":"wf","alpha3":"wlf","name":"Wallis y Futuna"},{"id":887,"alpha2":"ye","alpha3":"yem","name":"Yemen"},{"id":262,"alpha2":"dj","alpha3":"dji","name":"Yibuti"},{"id":894,"alpha2":"zm","alpha3":"zmb","name":"Zambia"},{"id":716,"alpha2":"zw","alpha3":"zwe","name":"Zimbabue"}]');

/***/ }),

/***/ 67883:
/***/ ((module) => {

"use strict";


module.exports = {
  //NODE_ENV: "production",
  SERVER_ENDPOINT: "https://api-nubbo.designer-trips.com",
  EXTRAS: ["admin", "contacts", "accounting", "crm", "arg", "vamoos", "ai", "custom"],
  FRONT_URL: "https://app.designer-trips.com",
  API_GOOGLE_MAP: "AIzaSyAqSLEPJ7HAQYPi07V0XSJ1rS1fKYNkRLs",
  API_GOOGLE_MAP_ID: "a2c421d48f6df0c3efb962b6",
  APP_NAME: "Designer Trips",
  MAP_ICON: "logo.png",
  DOMAINS: ["localhost", "app.designer-trips.com"],
  COST_CONTROL: false,
  LANG_CODE: "es",
  DEF_EXCHANGE: true,
  SERVER_SIDE: {
    'hotel': true,
    'supplier': true,
    'hotelcost': true
  }
};

/***/ }),

/***/ 68078:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Buffer = (__webpack_require__(92861).Buffer)
var MD5 = __webpack_require__(88276)

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey


/***/ }),

/***/ 68152:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8818);







function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var serviceOptions = {
  fields: [{
    name: 'Name',
    label: 'Name',
    required: true,
    columns: 8
  }, {
    name: 'SupplierId',
    relation: 'supplier',
    optionLabels: 'Name',
    setRelationTo: 'Supplier',
    editor: 'vue-select',
    label: 'Supplier',
    required: true,
    filters: function filters(r) {
      return r.SupplierType != 'HOTEL';
    }
  }, {
    name: 'ServiceTypeId',
    relation: 'servicetype',
    optionLabels: 'Name',
    editor: 'select',
    required: true,
    label: 'Service Type'
  }, {
    name: 'ServiceClassId',
    relation: 'serviceclass',
    optionLabels: 'Name',
    editor: 'select',
    label: 'Classification',
    required: true
  }, {
    name: 'CityId',
    relation: 'city',
    optionLabels: 'Name',
    editor: 'vue-select',
    label: 'City',
    addBlank: true
  }, {
    name: 'CurrencyId',
    relation: 'currency',
    optionLabels: 'id',
    editor: 'select',
    label: 'Currency',
    hideFromList: true
  }, {
    name: 'WebSite',
    label: 'Web Site',
    hideFromList: true
  }, {
    name: "CostBy",
    label: "Cost Per",
    required: true,
    editor: "select",
    addBlank: true,
    options: [{
      value: 'BASE_PERSON',
      label: 'Per Person variable'
    }, {
      value: 'PERSON',
      label: 'Per Person, fixed'
    }, {
      value: 'SERVICE',
      label: 'Per Service, fixed'
    }, {
      value: 'BASE_SERVICE',
      label: 'Per Service variable'
    }]
  }, {
    name: 'PaxMinQty',
    hideFromList: true,
    label: 'Minimum Pax'
  }, {
    name: 'Duration',
    hideFromList: true
  }, {
    name: 'Trekking',
    hideFromList: true
  }, {
    name: 'Navigation',
    hideFromList: true
  }, {
    name: 'ScheduleType',
    editor: 'select',
    options: [{
      value: 'DAY',
      label: 'Half Day'
    }, {
      value: 'NIGHT',
      label: 'Night'
    }, {
      value: 'FULL_DAY',
      label: 'Full Day'
    }],
    label: 'Schedule'
  }, {
    name: 'RequiredServiceId',
    relation: 'service',
    optionLabels: 'Name',
    addBlank: true,
    label: 'Required Service',
    hideFromList: true,
    editor: 'vue-select'
  }, {
    name: 'CommisionPrice',
    label: 'Commission Price',
    editor: 'checkbox',
    hideFromList: true,
    columns: 1
  }, {
    name: 'Commision',
    label: 'Commission',
    editor: 'number',
    hideFromList: true,
    readonlyIf: function readonlyIf(r) {
      return !r.CommisionPrice;
    }
  }, {
    name: 'ImageId',
    hidden: true,
    setRelationTo: 'Image',
    relation: 'image'
  }, {
    name: 'Breakfast',
    hideFromList: true,
    editor: 'checkbox',
    label: 'Breakfast'
  }, {
    name: 'Dinner',
    hideFromList: true,
    editor: 'checkbox',
    label: 'Dinner'
  }, {
    name: 'Lunch',
    hideFromList: true,
    editor: 'checkbox',
    label: 'Lunch'
  }, {
    name: 'Snack',
    hideFromList: true,
    editor: 'checkbox',
    label: 'Snack'
  }, {
    name: 'BoxLunch',
    hideFromList: true,
    editor: 'checkbox',
    label: 'Box Lunch'
  }, {
    name: 'VoucherDisabled',
    hideFromList: true,
    editor: 'checkbox',
    label: 'Voucher Disabled'
  }, {
    name: 'TemplateOnly',
    hideFromList: true,
    editor: 'checkbox',
    label: 'Template Only'
  }, {
    name: 'EntranceIncluded',
    hideFromList: true,
    editor: 'checkbox',
    label: 'Entrance Included'
  }, {
    name: 'ByWeekDay',
    editor: 'component',
    component: 'record-week-days',
    label: 'Week Days'
  }, {
    name: 'WeekDays',
    editor: {},
    fields: [{
      name: '0'
    }, {
      name: '1'
    }, {
      name: '2'
    }, {
      name: '3'
    }, {
      name: '4'
    }, {
      name: '5'
    }, {
      name: '6'
    }]
  }, {
    name: 'Optional',
    hideFromList: true,
    editor: 'checkbox',
    label: 'Optional Service'
  }, {
    name: 'NotDescription',
    hideFromList: true,
    editor: 'checkbox',
    label: 'Without Description'
  }, {
    name: 'NotPrice',
    hideFromList: true,
    editor: 'checkbox',
    label: 'Without Price'
  }, {
    name: 'CarRental',
    hideFromList: true,
    editor: 'checkbox',
    label: 'Car Rental'
  }, {
    name: 'PricePerDay',
    hideFromList: true,
    editor: 'checkbox',
    label: 'Price Per Day',
    hideIf: function hideIf(r) {
      return !r.CarRental;
    }
  }, {
    name: 'Closed',
    hideFromList: true,
    editor: 'checkbox',
    label: 'Archive',
    footerRow: true
  }, {
    name: 'ServiceDescriptions',
    editor: 'component',
    hideFromList: true,
    component: 'languages-comp',
    title: true,
    textStyle: true,
    label: 'Descriptions',
    rowFields: [{
      name: 'LanguageId',
      relation: 'language',
      optionLabels: 'Name',
      editor: 'select',
      setRelationTo: 'Language'
    }, {
      name: 'Title',
      label: 'Title'
    }, {
      name: 'Description'
    }, {
      name: 'PickupInfo',
      label: 'Pickup Info',
      setEnd: true
    }, {
      name: 'OfferedLanguage',
      editor: 'checkbox',
      label: 'Service Offered Language'
    }]
  }, {
    name: 'tab1',
    label: 'Notes',
    editor: 'tab',
    hideFromList: true,
    fields: [{
      name: 'Comment',
      hideFromList: true,
      editor: 'text-area',
      columns: 12,
      rows: 10
    }]
  }, {
    name: 'ServiceCategories',
    editor: [],
    label: 'Categories',
    closeRow: true,
    rowFields: [{
      name: 'Name',
      label: 'Name',
      required: true
    }, {
      name: 'Closed',
      hidden: true
    }],
    disabledTab: function disabledTab(record) {
      if (!record.id) return true;
    }
  }, {
    name: 'ServicePhotos',
    component: 'record-image-rows',
    label: 'Images',
    editor: 'component',
    mainImage: 'Image',
    mainImageId: 'ImageId',
    rowFields: [{
      name: 'ImageId',
      setRelationTo: 'Image',
      relation: 'image'
    }]
  }, {
    name: 'RequiredServices',
    label: 'Required Services',
    editor: [],
    rowFields: [{
      name: 'RequiredServiceId',
      columns: 12,
      label: 'Servicio',
      relation: 'service',
      optionLabels: function optionLabels(row) {
        if (!row) return '';
        if (!api.tables.supplier) return row.Name;
        var supplier = api.tables.supplier.find(function (r) {
          return r.id === row.SupplierId;
        });
        if (!supplier) return row.Name;
        return supplier.Name + ' - ' + row.Name;
      },
      editor: 'vue-select',
      setRelationTo: 'RequiredService'
    }]
  }],
  title: 'Services',
  canAdd: true,
  canCopy: true
};

var ServiceView = /*#__PURE__*/function (_View) {
  function ServiceView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, ServiceView);
    return _callSuper(this, ServiceView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(ServiceView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(ServiceView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", serviceOptions);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_3__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ServiceView);

/***/ }),

/***/ 68674:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("{\"Agency\":{},\"AgencyId\":null,\"BaseQuotes\":{\"0\":{\"ADT\":4,\"CHD\":0}},\"BookingCommissions\":[],\"BookingDays\":[{\"BookingDayHotels\":[{\"BookingDayId\":8220,\"BookingDayRooms\":[{\"BookingDayHotelId\":2527,\"Category\":{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Junior Room con Balcon\",\"Program\":null,\"id\":106,\"syncVersion\":1},\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"CurrencyId\":\"USD\",\"Hotel\":{\"Address\":\"Gurruchaga 2121 (C1425FEE)  Palermo, Buenos Aires, Argentina\",\"Checkin\":null,\"Checkout\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"Closed\":false,\"Comment\":\"30 de diciembre 2019 al 04 de enero 2020 *estadia minima 3 noches*\",\"Commision\":null,\"CommisionPrice\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Email\":\"reservations@owngrand.com\",\"HotelCategory\":{},\"HotelCategoryId\":null,\"HotelDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>El Own Grand Palermo Soho es un hotel boutique elegante situado en Palermo, un barrio de moda, y ofrece habitaciones de estilo moderno y sofisticado con conexión WiFi gratuita. El establecimiento tiene una piscina en la azotea con vistas a la ciudad, bañera de hidromasaje, sauna e instalaciones de fitness. El establecimiento cuenta con un restaurante exclusivo y un bar. El hotel queda a 600 metros de la plaza Serrano, a 600 metros de la plaza Italia y a 1,3 km del hipódromo. El aeroparque Jorge Newbery está a 3 km.</p>\",\"HotelId\":27,\"LanguageId\":1,\"ModifiedUTC\":\"2019-08-23T14:06:54\",\"ModifiedUserId\":1,\"id\":76,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Located in the trendy Palermo neighborhood, Own Grand Palermo Soho is a stylish boutique hotel offering rooms with a modern and sophisticated décor and free WiFi access. The property has a rooftop pool with city views, a hot tub, a sauna and fitness facilities.</p><p>The hotel is 601 m from Plaza Serrano Square, 601 m from Plaza Italia Square and 0.8 mi from Hippodrome. Aeroparque Jorge Newbery Airport is 1.9 mi away.</p>\",\"HotelId\":27,\"LanguageId\":2,\"ModifiedUTC\":\"2019-08-23T14:06:54\",\"ModifiedUserId\":1,\"id\":77,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Il Grand Palermo Soho è un elegante hotel boutique situato a Palermo, un quartiere alla moda, e offre camere moderne e sofisticate con connessione Wi-Fi gratuita. La struttura vanta una piscina panoramica con vista sulla città, una vasca idromassaggio, una sauna e strutture per il fitness. L'hotel si trova a 600 metri da Plaza Serrano, a 600 metri da Plaza Italia e a 1,3 km dall'Ippodromo. Aeroparque Jorge Newbery si trova a 3 km di distanza.</p><p><br></p>\",\"HotelId\":27,\"LanguageId\":3,\"ModifiedUTC\":\"2019-08-23T14:06:54\",\"ModifiedUserId\":1,\"id\":78,\"syncVersion\":1}],\"HotelPhotos\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":27,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Own Palermo Soho\",\"id\":264,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/BUE/HOTELES/OWN%20PALERMO/undefinedOwnhotel.jpg\"},\"ImageId\":264,\"ImageURL\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":72,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":27,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Own Palermo Soho\",\"id\":265,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/BUE/HOTELES/OWN%20PALERMO/undefinedownhotel1.jpg\"},\"ImageId\":265,\"ImageURL\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":73,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":27,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Own Palermo Soho\",\"id\":266,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/BUE/HOTELES/OWN%20PALERMO/undefinedownhotel2.jpg\"},\"ImageId\":266,\"ImageURL\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":74,\"syncVersion\":1}],\"HotelRoomTypes\":[{\"Comment\":null,\"CreatedUTC\":\"2019-10-23T19:32:53\",\"CreatedUserId\":1,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"SGL\",\"Pax\":1,\"id\":1,\"syncVersion\":1},\"RoomTypeId\":1,\"id\":62,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2019-10-23T19:32:53\",\"CreatedUserId\":1,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"DBL\",\"Pax\":2,\"id\":2,\"syncVersion\":1},\"RoomTypeId\":2,\"id\":63,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2019-10-23T19:32:53\",\"CreatedUserId\":1,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":true,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"CAMA EXTRA\",\"Pax\":1,\"id\":5,\"syncVersion\":3},\"RoomTypeId\":5,\"id\":64,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2019-10-25T12:54:13\",\"CreatedUserId\":1,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"TPL\",\"Pax\":3,\"id\":3,\"syncVersion\":1},\"RoomTypeId\":3,\"id\":719,\"syncVersion\":1}],\"HotelTaxCodes\":[],\"ModifiedUTC\":\"2020-02-11T18:16:49\",\"ModifiedUserId\":8,\"Name\":\"Own Grand Palermo Soho\",\"Nights\":null,\"PeriodCostBy\":null,\"Phone\":\"+54 11 4831 0800\",\"ProgramPeriodCostBy\":null,\"ProgramUnitCostBy\":null,\"RoomCategories\":[{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Junior Room\",\"Program\":null,\"id\":105,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Junior Room con Balcon\",\"Program\":null,\"id\":106,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Deluxe Suite\",\"Program\":null,\"id\":107,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Deluxe Suite con Balcon\",\"Program\":null,\"id\":108,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Deluxe one Bedroom Suite con B\",\"Program\":null,\"id\":109,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Master Suite con Balcon\",\"Program\":null,\"id\":110,\"syncVersion\":1}],\"RoomCostBy\":\"ROOM_TYPE_CATEGORY\",\"Supplier\":{\"Address\":\"Gurruchaga 2121 (C1425FEE)  Palermo, Buenos Aires, Argentina\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"HOTEL GURRUCHAGA S.A.\",\"CreatedUTC\":\"2019-08-21T20:13:20\",\"CreatedUserId\":1,\"CurrencyId\":null,\"Email\":\"reservations@owngrand.com\",\"ModifiedUTC\":\"2020-04-24T03:07:34\",\"ModifiedUserId\":37,\"Name\":\"Own Grand Palermo Soho\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"-\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"HOTEL\",\"TaxBasePercent\":null,\"TaxCode\":{},\"TaxCodeId\":null,\"TaxExempt\":null,\"TaxNumber\":\"30-71436078-3\",\"id\":80,\"syncVersion\":3},\"SupplierId\":80,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:33\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:04\",\"ModifiedUserId\":27,\"Name\":\"TUR IVA\",\"Value\":0,\"id\":5,\"syncVersion\":3},\"TaxCodeId\":5,\"Type\":\"NORMAL\",\"UnitCostBy\":null,\"WebSite\":null,\"id\":27,\"syncVersion\":13},\"HotelCategory\":{},\"HotelCategoryId\":null,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Quote\":null,\"QuoteList\":{\"0\":{\"Cost\":130,\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":\"95\",\"Price\":182,\"PriceModified\":null,\"RoomCost\":130,\"SourceCost\":95,\"SourceCurrencyId\":\"USD\"}},\"ReservationNumber\":null,\"Room\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"DBL\",\"Pax\":2,\"id\":2,\"syncVersion\":1},\"RoomCategory\":106,\"RoomTypeId\":2,\"Rooms\":1,\"Status\":\"PENDING\",\"Supplier\":{},\"SupplierId\":null,\"id\":2804,\"syncVersion\":1}],\"Checkin\":\"2020-02-03\",\"Checkout\":\"2020-02-03\",\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"Days\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":2527,\"syncVersion\":1}],\"BookingDayServices\":[{\"BookingDayId\":8220,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"CreatedUTC\":\"2020-01-09T19:16:33\",\"CreatedUserId\":10,\"Description\":\"<p>Upon arrival into Buenos Aires International airport a private transfer will be waiting for you to take you to your hotel.\\n</p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":0,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":\"30.00\",\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":null,\"Price\":42,\"SourceCost\":\"30.00\",\"SourceCurrencyId\":\"USD\"}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"Closed\":false,\"Comment\":\"- Los translados desde el aeropuerto incluyen 1hs de espera \\n- Los peajes, estacionamientos y gastos maleteros no están incluidos \\nTarifas peaje y Estacionamiento actualizado Diciembre 2019\\nAEP: Auto 70 - Van 130\\nEZE: Auto 270 - Van 430\\nCNX: Auto 340 - Van 560\\nTigre: Auto 200 - Van 370\\nEstacionamiento EZE: Auto 100 - Van 115\\nEstacionamiento AEP: Auto 95 - Van 120  \\n- Tarifas especiales para las fiestas, 50% más. Aplica desde el 24-Dic y 31-Dic a las 16hs, y todo el 25-Dic y 01-\\nEnero. Sujeto a disponibilidad.\\n- Los precios son para servicios con y sin guía. Punto de encuentro: hotel céntrico.\",\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"USD\",\"ModifiedUTC\":\"2020-03-28T20:30:21\",\"ModifiedUserId\":1,\"Name\":\"Peso Argentino\",\"Operation\":\"DIVIDE\",\"id\":\"ARS\",\"syncVersion\":2},\"CurrencyId\":\"ARS\",\"Dinner\":null,\"Duration\":null,\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Buenos Aire City tour\",\"id\":286,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/BUE/SERVICIOS/BA.jpg\"},\"ImageId\":286,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":null,\"ModifiedUTC\":\"2019-07-25T13:22:50\",\"ModifiedUserId\":1,\"Name\":\"Transfer EZE - Palermo\",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[{\"Closed\":false,\"CreatedUTC\":\"2019-07-30T18:31:48\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-08-05T13:25:31\",\"ModifiedUserId\":1,\"Name\":\"Auto\",\"ParentId\":36,\"ParentType\":\"SERVICE\",\"id\":251,\"syncVersion\":3},{\"Closed\":false,\"CreatedUTC\":\"2019-07-30T18:31:48\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-08-05T13:25:31\",\"ModifiedUserId\":1,\"Name\":\"Van\",\"ParentId\":36,\"ParentType\":\"SERVICE\",\"id\":252,\"syncVersion\":3}],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Al llegar al aeropuerto internacional, serás trasladado al barrio de Palermo.\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-07-25T13:22:50\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":36,\"Title\":\"\",\"id\":102,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Upon arrival to the international airport, you will be transferred to the neighborhood of Palermo.\\n\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-07-25T13:22:50\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":36,\"Title\":\"\",\"id\":103,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>All'arrivo all'aeroporto internazionale, sarete trasferiti nel quartiere di Palermo. \\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-07-25T13:22:50\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":36,\"Title\":\"\",\"id\":104,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"BASE\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-10-31T13:33:58\",\"ModifiedUserId\":1,\"Name\":\"Privado\",\"PaxMin\":null,\"id\":2,\"syncVersion\":5},\"ServiceTypeId\":2,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Uspallata 781, B1638BXA Vicente López, Buenos Aires\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"SUTRANSFER S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"reservas@sutransfer.com.ar\",\"ModifiedUTC\":\"2020-06-17T13:14:40\",\"ModifiedUserId\":20,\"Name\":\"Sutransfer\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 4837-0544\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"32\":[243,244],\"33\":[245,246],\"34\":[247,248],\"35\":[249,250],\"36\":[251,252],\"37\":[253,254],\"38\":[255,256],\"39\":[257,258],\"40\":[265,266],\"41\":[267,268],\"42\":[null],\"456\":[259,260],\"457\":[263,264],\"1042\":[301,302],\"1103\":[303,304],\"1104\":[305,306],\"1105\":[307,308],\"1106\":[309,310],\"1107\":[311,312]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:11\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:18\",\"ModifiedUserId\":27,\"Name\":\"NO GRAVADO\",\"Value\":0,\"id\":4,\"syncVersion\":2},\"TaxCodeId\":4,\"TaxExempt\":null,\"TaxNumber\":\"30-71197322-9\",\"id\":10,\"syncVersion\":32},\"SupplierId\":10,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":36,\"syncVersion\":10},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-03\",\"ServiceId\":36,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Uspallata 781, B1638BXA Vicente López, Buenos Aires\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"SUTRANSFER S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"reservas@sutransfer.com.ar\",\"ModifiedUTC\":\"2020-06-17T13:14:40\",\"ModifiedUserId\":20,\"Name\":\"Sutransfer\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 4837-0544\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"32\":[243,244],\"33\":[245,246],\"34\":[247,248],\"35\":[249,250],\"36\":[251,252],\"37\":[253,254],\"38\":[255,256],\"39\":[257,258],\"40\":[265,266],\"41\":[267,268],\"42\":[null],\"456\":[259,260],\"457\":[263,264],\"1042\":[301,302],\"1103\":[303,304],\"1104\":[305,306],\"1105\":[307,308],\"1106\":[309,310],\"1107\":[311,312]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:11\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:18\",\"ModifiedUserId\":27,\"Name\":\"NO GRAVADO\",\"Value\":0,\"id\":4,\"syncVersion\":2},\"TaxCodeId\":4,\"TaxExempt\":null,\"TaxNumber\":\"30-71197322-9\",\"id\":10,\"syncVersion\":32},\"SupplierId\":10,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":14967,\"syncVersion\":1},{\"BookingDayId\":8220,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"CreatedUTC\":\"2020-01-09T19:16:33\",\"CreatedUserId\":10,\"Description\":\"<p>During this tour, you can visit the most beautiful, historical and important places of the city. The best thing about this is that you choose which one. Plus, you get the chance to do it at your own pace. Discover the history of “Plaza de Mayo” the site of the most important historical events in the country since its foundation. Once you leave May Square along May Avenue you can enjoy a coffee at the historical “Café Tortoni”. If you like, take a short trip on the first ever subway line of South America.\\nWonder in awe at the oldest residential neighborhood in Buenos Aires: San Telmo. Walk along its cobble-stoned streets and discover its antiques shops and picturesque buildings. Live and feel the original Tango in the neighborhood of La Boca: walk along “Caminito Street” and enjoy the dancers and souvenir shops. See the mythical Boca Juniors soccer stadium. If you wish, we can take you to the Pasión Boquense Museum and take a look around. On the next stop you can contemplate the modernization of the city while passing along Madero Port and its exclusive docks . Passing through Retiro you will come to one of the most aristocratic areas of the city, Recoleta. Once you get there ,there ́s a lot to discover, but the most important is the Recoleta Cemetery, where the remains of Eva Peron \\\"Evita\\\", rest.  You can also visit Palermo and it ́s most exclusive residential area before finally returning to your hotel. If you wish to add other places to your tour or choose some of</p><p>these, don’t hesitate to contact us.\\n</p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":1,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":\"40.00\",\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":null,\"Price\":56,\"SourceCost\":\"40.00\",\"SourceCurrencyId\":\"USD\"}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"USD\",\"ModifiedUTC\":\"2020-03-28T20:30:21\",\"ModifiedUserId\":1,\"Name\":\"Peso Argentino\",\"Operation\":\"DIVIDE\",\"id\":\"ARS\",\"syncVersion\":2},\"CurrencyId\":\"ARS\",\"Dinner\":null,\"Duration\":\"4\",\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Buenos Aire City tour\",\"id\":286,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/BUE/SERVICIOS/BA.jpg\"},\"ImageId\":286,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":null,\"ModifiedUTC\":\"2019-07-26T12:34:21\",\"ModifiedUserId\":1,\"Name\":\"City Tour 4 hs\",\"Navigation\":null,\"NotDescription\":null,\"Optional\":true,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[{\"Closed\":false,\"CreatedUTC\":\"2019-08-05T13:15:44\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-10-30T17:34:41\",\"ModifiedUserId\":1,\"Name\":\"Auto\",\"ParentId\":40,\"ParentType\":\"SERVICE\",\"id\":265,\"syncVersion\":2},{\"Closed\":false,\"CreatedUTC\":\"2019-08-05T13:15:44\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-10-30T17:34:41\",\"ModifiedUserId\":1,\"Name\":\"Van\",\"ParentId\":40,\"ParentType\":\"SERVICE\",\"id\":266,\"syncVersion\":2}],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p> Durante este recorrido, puede visitar los lugares más bellos, históricos e importantes de la ciudad. Lo mejor de esto es que usted elige cuál. Descubra la historia de “la plaza de Mayo” es el sitio de los eventos históricos más importantes del país desde su fundación. Una vez que salga de “la plaza de mayo”por la avenida de Mayo puede disfrutar de un café en el histórico \\\"Café Tortoni\\\". Si lo desea, haga un viaje corto por primera línea de metro en Sudamérica.\\nMaravíllese en el barrio residencial más antiguo de Buenos Aires: San Telmo.\\nCamine por sus calles empedradas y descubra sus antigüedades y sus pintorescas tiendas y edificios. Viva y sienta el Tango original en el barrio de La Boca: camine a lo largo de la \\\"Calle Caminito\\\" y disfrute de las bailarinas y tiendas de suvenires. Ver el mítico estadio de fútbol del Boca Junior. Si lo desea podemos llevarlo al Museo Pasión Boquense para que eche un vistazo alrededor. En la siguiente parada podrá contemplar la modernización de la ciudad mientras viaja a lo largo de Puerto Madero y sus muelles exclusivos.\\nPasando por Retiro llegará a una de las zonas más aristocráticas de la ciudad, Recoleta. Estando ahí hay mucho por descubrir, lo más importante de este lugar es el Cementerio de Recoleta donde descansan los restos de Eva Perón, \\\"Evita”. Antes de regresar al hotel también puede visitar Palermo, la zona residencial más exclusiva.\\nSi desea agregar otros lugares a su tour o elegir algunos de estos, no dude en contactarnos.\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-07-26T12:34:21\",\"ModifiedUserId\":1,\"OfferedLanguage\":true,\"Optional\":null,\"ServiceId\":40,\"Title\":\"City Tour\",\"id\":114,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>During this tour, you can visit the most beautiful, historical and important places of the city. The best thing about this is that you choose which one. Plus, you get the chance to do it at your own pace. Discover the history of “Plaza de Mayo” the site of the most important historical events in the country since its foundation. Once you leave May Square along May Avenue you can enjoy a coffee at the historical “Café Tortoni”. If you like, take a short trip on the first ever subway line of South America.\\nWonder in awe at the oldest residential neighborhood in Buenos Aires: San Telmo. Walk along its cobble-stoned streets and discover its antiques shops and picturesque buildings. Live and feel the original Tango in the neighborhood of La Boca: walk along “Caminito Street” and enjoy the dancers and souvenir shops. See the mythical Boca Juniors soccer stadium. If you wish, we can take you to the Pasión Boquense Museum and take a look around. On the next stop you can contemplate the modernization of the city while passing along Madero Port and its exclusive docks . Passing through Retiro you will come to one of the most aristocratic areas of the city, Recoleta. Once you get there ,there ́s a lot to discover, but the most important is the Recoleta Cemetery, where the remains of Eva Peron \\\"Evita\\\", rest.  You can also visit Palermo and it ́s most exclusive residential area before finally returning to your hotel. If you wish to add other places to your tour or choose some of</p><p>these, don’t hesitate to contact us.\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-07-26T12:34:21\",\"ModifiedUserId\":1,\"OfferedLanguage\":true,\"Optional\":null,\"ServiceId\":40,\"Title\":\"City Tour \",\"id\":115,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Durante questo tour, puoi visitare i luoghi più belli, storici e importanti della città. La cosa migliore è che tu scegli quale. Scopri la storia di “Plaza de Mayo”, il sito degli eventi storici più importanti del paese sin dalla sua fondazione. Una volta che lasci “Plaza de Mayo” in Avenida de Mayo, puoi degustare un caffè nello storico “Cafe Tortoni”. Se lo desideri, fai un breve viaggio sulla prima linea della metropolitana del Sud America. Lasciati stupire dal più antico quartiere residenziale di Buenos Aires: San Telmo. Passeggia per le sue strade acciottolate e scopri le sue antichità e i suoi pittoreschi negozi ed edifici. Vivi e senti il Tango originale nel quartiere di La Boca: cammina lungo la “Calle Caminito” e goditi i ballerini e i negozi di souvenir. Visita il mitico stadio di calcio di Boca Junior. Se lo desideri, possiamo portarti al Museo Pasión Boquense. Nella  fermata successiva potrai contemplare la modernizzazione della città passando lungo Puerto Madero e le sue banchine esclusive. Attraversando Retiro raggiungerai una delle zone più aristocratiche della città: Recoleta. C’è molto da scoprire, ma la cosa più importante di questo posto è il cimitero di Recoleta, dove riposano i resti di Eva Peron, “Evita”. Prima di tornare in hotel, puoi anche visitare Palermo, la zona residenziale più esclusiva. Se desideri aggiungere altri luoghi al tuo tuor o sceglierne alcuni, non esitare a contattarci.\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-07-26T12:34:21\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":40,\"Title\":\"City Tour\",\"id\":116,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"BASE\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-10-31T13:33:58\",\"ModifiedUserId\":1,\"Name\":\"Privado\",\"PaxMin\":null,\"id\":2,\"syncVersion\":5},\"ServiceTypeId\":2,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Uspallata 781, B1638BXA Vicente López, Buenos Aires\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"SUTRANSFER S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"reservas@sutransfer.com.ar\",\"ModifiedUTC\":\"2020-06-17T13:14:40\",\"ModifiedUserId\":20,\"Name\":\"Sutransfer\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 4837-0544\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"32\":[243,244],\"33\":[245,246],\"34\":[247,248],\"35\":[249,250],\"36\":[251,252],\"37\":[253,254],\"38\":[255,256],\"39\":[257,258],\"40\":[265,266],\"41\":[267,268],\"42\":[null],\"456\":[259,260],\"457\":[263,264],\"1042\":[301,302],\"1103\":[303,304],\"1104\":[305,306],\"1105\":[307,308],\"1106\":[309,310],\"1107\":[311,312]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:11\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:18\",\"ModifiedUserId\":27,\"Name\":\"NO GRAVADO\",\"Value\":0,\"id\":4,\"syncVersion\":2},\"TaxCodeId\":4,\"TaxExempt\":null,\"TaxNumber\":\"30-71197322-9\",\"id\":10,\"syncVersion\":32},\"SupplierId\":10,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":40,\"syncVersion\":13},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-03\",\"ServiceId\":40,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Uspallata 781, B1638BXA Vicente López, Buenos Aires\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"SUTRANSFER S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"reservas@sutransfer.com.ar\",\"ModifiedUTC\":\"2020-06-17T13:14:40\",\"ModifiedUserId\":20,\"Name\":\"Sutransfer\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 4837-0544\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"32\":[243,244],\"33\":[245,246],\"34\":[247,248],\"35\":[249,250],\"36\":[251,252],\"37\":[253,254],\"38\":[255,256],\"39\":[257,258],\"40\":[265,266],\"41\":[267,268],\"42\":[null],\"456\":[259,260],\"457\":[263,264],\"1042\":[301,302],\"1103\":[303,304],\"1104\":[305,306],\"1105\":[307,308],\"1106\":[309,310],\"1107\":[311,312]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:11\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:18\",\"ModifiedUserId\":27,\"Name\":\"NO GRAVADO\",\"Value\":0,\"id\":4,\"syncVersion\":2},\"TaxCodeId\":4,\"TaxExempt\":null,\"TaxNumber\":\"30-71197322-9\",\"id\":10,\"syncVersion\":32},\"SupplierId\":10,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":14968,\"syncVersion\":1},{\"BookingDayId\":8220,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"CreatedUTC\":\"2021-06-01T15:50:17\",\"CreatedUserId\":1,\"Description\":\"\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":2,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":\"40.00\",\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":null,\"Price\":56,\"SourceCost\":\"40.00\",\"SourceCurrencyId\":\"USD\"}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"USD\",\"ModifiedUTC\":\"2020-03-28T20:30:21\",\"ModifiedUserId\":1,\"Name\":\"Peso Argentino\",\"Operation\":\"DIVIDE\",\"id\":\"ARS\",\"syncVersion\":2},\"CurrencyId\":\"ARS\",\"Dinner\":null,\"Duration\":\"4 hs \",\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Buenos Aire City tour\",\"id\":286,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/BUE/SERVICIOS/BA.jpg\"},\"ImageId\":286,\"ImageURL\":null,\"Languages\":\"\",\"Lunch\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"City Tour - 4hs \",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":436,\"Title\":\"\",\"id\":1302,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":436,\"Title\":\"\",\"id\":1303,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":436,\"Title\":\"\",\"id\":1304,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"BASE\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-10-31T13:33:58\",\"ModifiedUserId\":1,\"Name\":\"Privado\",\"PaxMin\":null,\"id\":2,\"syncVersion\":5},\"ServiceTypeId\":2,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Thames 1872 Oficina ``i``. Palermo. Buenos Aires, Ciudad Autónoma de Buenos Aires\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"info@argentinaonthego.com\",\"ModifiedUTC\":\"2020-03-13T16:28:08\",\"ModifiedUserId\":8,\"Name\":\"Guías Buenos Aires \",\"PaymentConditionId\":null,\"PaymentTypeId\":null,\"Phone\":\"+54 115-368-5833\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"429\":[null],\"430\":[null],\"431\":[null],\"432\":[null],\"433\":[null],\"434\":[null],\"435\":[null],\"436\":[null],\"437\":[null],\"438\":[null],\"439\":[null],\"440\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:11\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:18\",\"ModifiedUserId\":27,\"Name\":\"NO GRAVADO\",\"Value\":0,\"id\":4,\"syncVersion\":2},\"TaxCodeId\":4,\"TaxExempt\":null,\"TaxNumber\":null,\"id\":54,\"syncVersion\":6},\"SupplierId\":54,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":436,\"syncVersion\":1},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-03\",\"ServiceId\":436,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Thames 1872 Oficina ``i``. Palermo. Buenos Aires, Ciudad Autónoma de Buenos Aires\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"info@argentinaonthego.com\",\"ModifiedUTC\":\"2020-03-13T16:28:08\",\"ModifiedUserId\":8,\"Name\":\"Guías Buenos Aires \",\"PaymentConditionId\":null,\"PaymentTypeId\":null,\"Phone\":\"+54 115-368-5833\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"429\":[null],\"430\":[null],\"431\":[null],\"432\":[null],\"433\":[null],\"434\":[null],\"435\":[null],\"436\":[null],\"437\":[null],\"438\":[null],\"439\":[null],\"440\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:11\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:18\",\"ModifiedUserId\":27,\"Name\":\"NO GRAVADO\",\"Value\":0,\"id\":4,\"syncVersion\":2},\"TaxCodeId\":4,\"TaxExempt\":null,\"TaxNumber\":null,\"id\":54,\"syncVersion\":6},\"SupplierId\":54,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":58013,\"syncVersion\":1}],\"BookingId\":679,\"BoxLunch\":null,\"Breakfast\":false,\"City\":{},\"CityId\":null,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"DayNr\":0,\"Description\":null,\"Dinner\":null,\"EntranceIncluded\":null,\"GroupDayTo\":null,\"GroupDays\":null,\"HotelId\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Buenos Aire City tour\",\"id\":286,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/BUE/SERVICIOS/BA.jpg\"},\"ImageId\":286,\"ImageURL\":null,\"Lunch\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"PaxHotel\":false,\"QuoteDate\":null,\"ShowOptionals\":null,\"Snack\":null,\"SortNr\":null,\"Title\":\"City Tour \",\"TransDate\":\"2020-02-03\",\"id\":8220,\"syncVersion\":1},{\"BookingDayHotels\":[],\"BookingDayServices\":[{\"BookingDayId\":8221,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"CreatedUTC\":\"2020-01-09T19:16:33\",\"CreatedUserId\":10,\"Description\":\"<p>Private tour. You will enjoy Tigre Delta, discover northern areas and the channels of the Delta. </p><p>Tigre is a privileged place to visit and enjoy nature, sports, sun, fun, flavors, with the particularity of being minutes from the city of Buenos Aires, which makes the contrast between vertigo and the climate of a tourist city.</p><p><br></p><ul><li><strong>Paseo Victorica:</strong> The attraction of this picturesque waterfront is the gastronomic variety close to the attraction of the river, the promenade of the museums and the access of most rowing clubs.</li><li><strong>The Puerto de Frutos</strong> is a classic craft and decoration walk that includes traditional wicker modeled objects and modern articles with the latest trends in art and author design.</li><li><strong>Boulevard Saenz Peña: </strong>A new walk renewed by artists, photographers, antique fairs, musicians and itinerant collector positions that bring their unparalleled treasures to share with their visitors.</li></ul><p><br></p><p>Enjoy a Navigation on a Traditional Public Cruise called Lancha Colectiva and lunch at a local restaurant.</p><p><br></p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":0,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":\"80.00\",\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":null,\"Price\":112,\"SourceCost\":\"80.00\",\"SourceCurrencyId\":\"USD\"}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"USD\",\"ModifiedUTC\":\"2020-03-28T20:30:21\",\"ModifiedUserId\":1,\"Name\":\"Peso Argentino\",\"Operation\":\"DIVIDE\",\"id\":\"ARS\",\"syncVersion\":2},\"CurrencyId\":\"ARS\",\"Dinner\":null,\"Duration\":\"7\",\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":302,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/BUE/SERVICIOS/Transturis/tigre-museo-arte.jpg\"},\"ImageId\":302,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":null,\"ModifiedUTC\":\"2019-10-30T17:35:09\",\"ModifiedUserId\":1,\"Name\":\"Tigre dia completo\",\"Navigation\":null,\"NotDescription\":null,\"Optional\":true,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":42,\"Title\":\"Tigre dia completo\",\"id\":120,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":42,\"Title\":\"Tigre Full Day\",\"id\":121,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":42,\"Title\":\"Tigre intera giornata \",\"id\":122,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"BASE\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-10-31T13:33:58\",\"ModifiedUserId\":1,\"Name\":\"Privado\",\"PaxMin\":null,\"id\":2,\"syncVersion\":5},\"ServiceTypeId\":2,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Uspallata 781, B1638BXA Vicente López, Buenos Aires\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"SUTRANSFER S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"reservas@sutransfer.com.ar\",\"ModifiedUTC\":\"2020-06-17T13:14:40\",\"ModifiedUserId\":20,\"Name\":\"Sutransfer\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 4837-0544\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"32\":[243,244],\"33\":[245,246],\"34\":[247,248],\"35\":[249,250],\"36\":[251,252],\"37\":[253,254],\"38\":[255,256],\"39\":[257,258],\"40\":[265,266],\"41\":[267,268],\"42\":[null],\"456\":[259,260],\"457\":[263,264],\"1042\":[301,302],\"1103\":[303,304],\"1104\":[305,306],\"1105\":[307,308],\"1106\":[309,310],\"1107\":[311,312]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:11\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:18\",\"ModifiedUserId\":27,\"Name\":\"NO GRAVADO\",\"Value\":0,\"id\":4,\"syncVersion\":2},\"TaxCodeId\":4,\"TaxExempt\":null,\"TaxNumber\":\"30-71197322-9\",\"id\":10,\"syncVersion\":32},\"SupplierId\":10,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":42,\"syncVersion\":4},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-04\",\"ServiceId\":42,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Uspallata 781, B1638BXA Vicente López, Buenos Aires\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"SUTRANSFER S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"reservas@sutransfer.com.ar\",\"ModifiedUTC\":\"2020-06-17T13:14:40\",\"ModifiedUserId\":20,\"Name\":\"Sutransfer\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 4837-0544\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"32\":[243,244],\"33\":[245,246],\"34\":[247,248],\"35\":[249,250],\"36\":[251,252],\"37\":[253,254],\"38\":[255,256],\"39\":[257,258],\"40\":[265,266],\"41\":[267,268],\"42\":[null],\"456\":[259,260],\"457\":[263,264],\"1042\":[301,302],\"1103\":[303,304],\"1104\":[305,306],\"1105\":[307,308],\"1106\":[309,310],\"1107\":[311,312]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:11\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:18\",\"ModifiedUserId\":27,\"Name\":\"NO GRAVADO\",\"Value\":0,\"id\":4,\"syncVersion\":2},\"TaxCodeId\":4,\"TaxExempt\":null,\"TaxNumber\":\"30-71197322-9\",\"id\":10,\"syncVersion\":32},\"SupplierId\":10,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":14970,\"syncVersion\":1},{\"BookingDayId\":8221,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"CreatedUTC\":\"2020-01-09T19:16:33\",\"CreatedUserId\":10,\"Description\":\"\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":1,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":\"50.00\",\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":null,\"Price\":70,\"SourceCost\":\"50.00\",\"SourceCurrencyId\":\"USD\"}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":\"PERSON\",\"CreatedUTC\":\"2019-10-17T20:38:59\",\"CreatedUserId\":1,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"USD\",\"ModifiedUTC\":\"2020-03-28T20:30:21\",\"ModifiedUserId\":1,\"Name\":\"Peso Argentino\",\"Operation\":\"DIVIDE\",\"id\":\"ARS\",\"syncVersion\":2},\"CurrencyId\":\"ARS\",\"Dinner\":null,\"Duration\":\"6,5 hs \",\"EntranceIncluded\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Languages\":\"\",\"Lunch\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Tigre y Delta FD \",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":\"2019-10-17T20:38:59\",\"CreatedUserId\":1,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":713,\"Title\":\"\",\"id\":2133,\"syncVersion\":1},{\"CreatedUTC\":\"2019-10-17T20:38:59\",\"CreatedUserId\":1,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":713,\"Title\":\"\",\"id\":2134,\"syncVersion\":1},{\"CreatedUTC\":\"2019-10-17T20:38:59\",\"CreatedUserId\":1,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":713,\"Title\":\"\",\"id\":2135,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"PERSON\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Regular\",\"PaxMin\":null,\"id\":1,\"syncVersion\":4},\"ServiceTypeId\":1,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Thames 1872, CABA \",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"TELIAS LAURA VERONICA\",\"CreatedUTC\":\"2019-10-16T22:05:04\",\"CreatedUserId\":1,\"CurrencyId\":null,\"Email\":\"laurateliasguia@gmail.com \",\"ModifiedUTC\":\"2020-04-27T18:42:07\",\"ModifiedUserId\":37,\"Name\":\"Guia Laura Telias \",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 911 60334429\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"709\":[null],\"710\":[null],\"711\":[null],\"712\":[null],\"713\":[null],\"714\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:11\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:18\",\"ModifiedUserId\":27,\"Name\":\"NO GRAVADO\",\"Value\":0,\"id\":4,\"syncVersion\":2},\"TaxCodeId\":4,\"TaxExempt\":null,\"TaxNumber\":\"27-32342440-9\",\"id\":288,\"syncVersion\":9},\"SupplierId\":288,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":713,\"syncVersion\":1},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-04\",\"ServiceId\":713,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Thames 1872, CABA \",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"TELIAS LAURA VERONICA\",\"CreatedUTC\":\"2019-10-16T22:05:04\",\"CreatedUserId\":1,\"CurrencyId\":null,\"Email\":\"laurateliasguia@gmail.com \",\"ModifiedUTC\":\"2020-04-27T18:42:07\",\"ModifiedUserId\":37,\"Name\":\"Guia Laura Telias \",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 911 60334429\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"709\":[null],\"710\":[null],\"711\":[null],\"712\":[null],\"713\":[null],\"714\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:11\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:18\",\"ModifiedUserId\":27,\"Name\":\"NO GRAVADO\",\"Value\":0,\"id\":4,\"syncVersion\":2},\"TaxCodeId\":4,\"TaxExempt\":null,\"TaxNumber\":\"27-32342440-9\",\"id\":288,\"syncVersion\":9},\"SupplierId\":288,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":14971,\"syncVersion\":1}],\"BookingId\":679,\"BoxLunch\":null,\"Breakfast\":true,\"City\":{},\"CityId\":null,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"DayNr\":1,\"Description\":null,\"Dinner\":null,\"EntranceIncluded\":null,\"GroupDayTo\":null,\"GroupDays\":null,\"HotelId\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-07T12:01:48\",\"CreatedUserId\":10,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Tigre 2\",\"id\":300,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/BUE/SERVICIOS/Tigre%201.jpg\"},\"ImageId\":300,\"ImageURL\":null,\"Lunch\":true,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"PaxHotel\":null,\"QuoteDate\":null,\"ShowOptionals\":null,\"Snack\":null,\"SortNr\":null,\"Title\":\"Tigre Full Day\",\"TransDate\":\"2020-02-04\",\"id\":8221,\"syncVersion\":1},{\"BookingDayHotels\":[{\"BookingDayId\":8222,\"BookingDayRooms\":[{\"BookingDayHotelId\":2528,\"Category\":{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":100,\"ModifiedUTC\":\"2019-12-12T18:54:28\",\"ModifiedUserId\":8,\"Name\":\"Superior\",\"Program\":null,\"id\":391,\"syncVersion\":1},\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"CurrencyId\":\"USD\",\"Hotel\":{\"Address\":\"Lionel Terray 212 | El Chaltén\",\"Checkin\":null,\"Checkout\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":79,\"syncVersion\":1},{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":80,\"syncVersion\":1},{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":81,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-48.08,\"Longitude\":-72.15,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:03:05\",\"ModifiedUserId\":27,\"Name\":\"El Chalten\",\"id\":13,\"syncVersion\":5},\"CityId\":13,\"Closed\":false,\"Comment\":\"Política de menores\\n- Hasta 2 años: sin cargo\\n- De 3 a 12 años cumplidos: abonan el 70% de la tarifa\\n- Mayores de 12: abonan el total de la tarifa\",\"Commision\":20,\"CommisionPrice\":true,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Email\":\"info@hosteriaelpuma.com.ar\",\"HotelCategory\":{},\"HotelCategoryId\":null,\"HotelDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>La Hosteria El Puma se encuentra al lado de las rutas de senderismo de El Chaltén y a poca distancia a pie de la carretera principal y el centro de la localidad. Ofrece conexión W-Fi gratuita y el desayuno. Un amplio parque ofrece un espacio único de relax y mantiene a la hostería lejos del murmullo turístico de la calle principal, la cual se encuentra ubicada a tan sólo una cuadra de distancia. El aeropuerto internacional de El Calafate está a 220 km.</p>\",\"HotelId\":100,\"LanguageId\":1,\"ModifiedUTC\":\"2019-08-23T14:06:54\",\"ModifiedUserId\":1,\"id\":295,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Located next to El Chalten’s trekking circuits and walking distance from the main road and the city centre, Hosteria El Puma offers free Wi-Fi and breakfast. A large park offers a unique space for relaxation and keeps the inn away from the tourist murmur of the main street, which located just one block away. El Calafate  Airport is 220 km away.</p>\",\"HotelId\":100,\"LanguageId\":2,\"ModifiedUTC\":\"2019-08-23T14:06:54\",\"ModifiedUserId\":1,\"id\":296,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>L'Hosteria El Puma si trova accanto ai sentieri escursionistici di El Chaltén, a pochi passi dalla strada principale e dal centro della città. Offre la connessione Wi-Fi gratuita e la prima colazione. Un grande parco offre uno spazio unico di relax e mantiene la locanda lontana dal mormorio turistico della strada principale, che si trova a solo un isolato di distanza. L'aeroporto internazionale El Calafate si trova a 220 km di distanza.</p>\",\"HotelId\":100,\"LanguageId\":3,\"ModifiedUTC\":\"2019-08-23T14:06:54\",\"ModifiedUserId\":1,\"id\":297,\"syncVersion\":1}],\"HotelPhotos\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":100,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":487,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Chalten/Hoteles/El%20Puma/109541078.jpg\"},\"ImageId\":487,\"ImageURL\":null,\"ModifiedUTC\":\"2019-12-12T18:54:28\",\"ModifiedUserId\":8,\"id\":286,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":100,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":489,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Chalten/Hoteles/El%20Puma/31233090.jpg\"},\"ImageId\":489,\"ImageURL\":null,\"ModifiedUTC\":\"2019-12-12T18:54:28\",\"ModifiedUserId\":8,\"id\":287,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":100,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":488,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Chalten/Hoteles/El%20Puma/193004407.jpg\"},\"ImageId\":488,\"ImageURL\":null,\"ModifiedUTC\":\"2019-12-12T18:54:28\",\"ModifiedUserId\":8,\"id\":288,\"syncVersion\":1}],\"HotelRoomTypes\":[{\"Comment\":null,\"CreatedUTC\":\"2019-10-23T19:32:55\",\"CreatedUserId\":1,\"HotelId\":100,\"ModifiedUTC\":\"2019-12-12T18:54:28\",\"ModifiedUserId\":8,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"SGL\",\"Pax\":1,\"id\":1,\"syncVersion\":1},\"RoomTypeId\":1,\"id\":283,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2019-10-23T19:32:55\",\"CreatedUserId\":1,\"HotelId\":100,\"ModifiedUTC\":\"2019-12-12T18:54:28\",\"ModifiedUserId\":8,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"DBL\",\"Pax\":2,\"id\":2,\"syncVersion\":1},\"RoomTypeId\":2,\"id\":284,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2019-10-23T19:32:55\",\"CreatedUserId\":1,\"HotelId\":100,\"ModifiedUTC\":\"2019-12-12T18:54:28\",\"ModifiedUserId\":8,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"TPL\",\"Pax\":3,\"id\":3,\"syncVersion\":1},\"RoomTypeId\":3,\"id\":285,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2019-12-12T18:54:28\",\"CreatedUserId\":8,\"HotelId\":100,\"ModifiedUTC\":\"2019-12-12T19:00:57\",\"ModifiedUserId\":8,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":true,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"CAMA EXTRA\",\"Pax\":1,\"id\":5,\"syncVersion\":3},\"RoomTypeId\":5,\"id\":930,\"syncVersion\":1}],\"HotelTaxCodes\":[],\"ModifiedUTC\":\"2021-02-15T13:33:43\",\"ModifiedUserId\":20,\"Name\":\"El Puma Lodge\",\"Nights\":null,\"PeriodCostBy\":null,\"Phone\":\"+54 02962 493095 \",\"ProgramPeriodCostBy\":null,\"ProgramUnitCostBy\":null,\"RoomCategories\":[{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":100,\"ModifiedUTC\":\"2019-12-12T18:54:28\",\"ModifiedUserId\":8,\"Name\":\"Standard\",\"Program\":null,\"id\":390,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":100,\"ModifiedUTC\":\"2019-12-12T18:54:28\",\"ModifiedUserId\":8,\"Name\":\"Superior\",\"Program\":null,\"id\":391,\"syncVersion\":1}],\"RoomCostBy\":\"ROOM_TYPE_CATEGORY\",\"Supplier\":{\"Address\":\"Lionel Terray 212 | El Chaltén\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"HOSTERIA EL PUMA SOCIEDAD DE RESPONSABILIDAD LIMITADA\",\"CreatedUTC\":\"2019-08-21T20:13:20\",\"CreatedUserId\":1,\"CurrencyId\":null,\"Email\":\"info@hosteriaelpuma.com.ar\",\"ModifiedUTC\":\"2020-04-27T16:09:44\",\"ModifiedUserId\":37,\"Name\":\"El Puma Lodge\",\"PaymentConditionId\":null,\"PaymentTypeId\":null,\"Phone\":\"0\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"HOTEL\",\"TaxBasePercent\":null,\"TaxCode\":{},\"TaxCodeId\":null,\"TaxExempt\":null,\"TaxNumber\":\"33-70745814-9\",\"id\":150,\"syncVersion\":2},\"SupplierId\":150,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:33\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:04\",\"ModifiedUserId\":27,\"Name\":\"TUR IVA\",\"Value\":0,\"id\":5,\"syncVersion\":3},\"TaxCodeId\":5,\"Type\":\"NORMAL\",\"UnitCostBy\":null,\"WebSite\":null,\"id\":100,\"syncVersion\":14},\"HotelCategory\":{},\"HotelCategoryId\":null,\"HotelId\":100,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Quote\":null,\"QuoteList\":{\"0\":{\"Cost\":240,\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":\"176\",\"Price\":336,\"PriceModified\":null,\"RoomCost\":160,\"SourceCost\":211.20000000000002,\"SourceCurrencyId\":\"USD\"}},\"ReservationNumber\":null,\"Room\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"DBL\",\"Pax\":2,\"id\":2,\"syncVersion\":1},\"RoomCategory\":391,\"RoomTypeId\":2,\"Rooms\":1,\"Status\":\"PENDING\",\"Supplier\":{},\"SupplierId\":null,\"id\":2805,\"syncVersion\":1}],\"Checkin\":\"2020-02-05\",\"Checkout\":\"2020-02-05\",\"City\":{\"CityDescriptions\":[{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":79,\"syncVersion\":1},{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":80,\"syncVersion\":1},{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":81,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-48.08,\"Longitude\":-72.15,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:03:05\",\"ModifiedUserId\":27,\"Name\":\"El Chalten\",\"id\":13,\"syncVersion\":5},\"CityId\":13,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"Days\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":2528,\"syncVersion\":1}],\"BookingDayServices\":[{\"BookingDayId\":8222,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"CreatedUTC\":\"2020-01-09T19:23:29\",\"CreatedUserId\":10,\"Description\":\"<p>At the designated time you will have a private transfer to Buenos Aires Domestic airport for your flight to El Calafate.\\n</p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":0,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":\"15.00\",\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":null,\"Price\":21,\"SourceCost\":\"15.00\",\"SourceCurrencyId\":\"USD\"}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"Closed\":false,\"Comment\":\"- Los translados desde el aeropuerto incluyen 1hs de espera \\n- Los peajes, estacionamientos y gastos maleteros no están incluidos \\nTarifas peaje y Estacionamiento actualizado Diciembre 2019\\nAEP: Auto 70 - Van 130\\nEZE: Auto 270 - Van 430\\nCNX: Auto 340 - Van 560\\nTigre: Auto 200 - Van 370\\nEstacionamiento EZE: Auto 100 - Van 115\\nEstacionamiento AEP: Auto 95 - Van 120  \\n- Tarifas especiales para las fiestas, 50% más. Aplica desde el 24-Dic y 31-Dic a las 16hs, y todo el 25-Dic y 01-\\nEnero. Sujeto a disponibilidad.\\n- Los precios son para servicios con y sin guía. Punto de encuentro: hotel céntrico.\",\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"USD\",\"ModifiedUTC\":\"2020-03-28T20:30:21\",\"ModifiedUserId\":1,\"Name\":\"Peso Argentino\",\"Operation\":\"DIVIDE\",\"id\":\"ARS\",\"syncVersion\":2},\"CurrencyId\":\"ARS\",\"Dinner\":null,\"Duration\":null,\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Buenos Aire City tour\",\"id\":286,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/BUE/SERVICIOS/BA.jpg\"},\"ImageId\":286,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":null,\"ModifiedUTC\":\"2019-07-25T13:20:52\",\"ModifiedUserId\":1,\"Name\":\"Transfer AEP - HTL\",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[{\"Closed\":false,\"CreatedUTC\":\"2019-07-30T18:30:59\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-08-05T13:25:10\",\"ModifiedUserId\":1,\"Name\":\"Auto\",\"ParentId\":34,\"ParentType\":\"SERVICE\",\"id\":247,\"syncVersion\":3},{\"Closed\":false,\"CreatedUTC\":\"2019-07-30T18:30:59\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-08-05T13:25:10\",\"ModifiedUserId\":1,\"Name\":\"Van\",\"ParentId\":34,\"ParentType\":\"SERVICE\",\"id\":248,\"syncVersion\":3}],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Al llegar al aeropuerto, serás trasladado al hotel. \\n\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-07-25T13:20:52\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":34,\"Title\":\"\",\"id\":96,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Upon arrival to the airport, you will be transferred to your hotel.  \\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-07-25T13:20:52\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":34,\"Title\":\"\",\"id\":97,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>All'arrivo in aeroporto, sarai trasferito all'hotel. \\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-07-25T13:20:52\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":34,\"Title\":\"\",\"id\":98,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"BASE\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-10-31T13:33:58\",\"ModifiedUserId\":1,\"Name\":\"Privado\",\"PaxMin\":null,\"id\":2,\"syncVersion\":5},\"ServiceTypeId\":2,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Uspallata 781, B1638BXA Vicente López, Buenos Aires\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"SUTRANSFER S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"reservas@sutransfer.com.ar\",\"ModifiedUTC\":\"2020-06-17T13:14:40\",\"ModifiedUserId\":20,\"Name\":\"Sutransfer\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 4837-0544\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"32\":[243,244],\"33\":[245,246],\"34\":[247,248],\"35\":[249,250],\"36\":[251,252],\"37\":[253,254],\"38\":[255,256],\"39\":[257,258],\"40\":[265,266],\"41\":[267,268],\"42\":[null],\"456\":[259,260],\"457\":[263,264],\"1042\":[301,302],\"1103\":[303,304],\"1104\":[305,306],\"1105\":[307,308],\"1106\":[309,310],\"1107\":[311,312]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:11\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:18\",\"ModifiedUserId\":27,\"Name\":\"NO GRAVADO\",\"Value\":0,\"id\":4,\"syncVersion\":2},\"TaxCodeId\":4,\"TaxExempt\":null,\"TaxNumber\":\"30-71197322-9\",\"id\":10,\"syncVersion\":32},\"SupplierId\":10,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":34,\"syncVersion\":9},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-05\",\"ServiceId\":34,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Uspallata 781, B1638BXA Vicente López, Buenos Aires\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"SUTRANSFER S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"reservas@sutransfer.com.ar\",\"ModifiedUTC\":\"2020-06-17T13:14:40\",\"ModifiedUserId\":20,\"Name\":\"Sutransfer\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 4837-0544\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"32\":[243,244],\"33\":[245,246],\"34\":[247,248],\"35\":[249,250],\"36\":[251,252],\"37\":[253,254],\"38\":[255,256],\"39\":[257,258],\"40\":[265,266],\"41\":[267,268],\"42\":[null],\"456\":[259,260],\"457\":[263,264],\"1042\":[301,302],\"1103\":[303,304],\"1104\":[305,306],\"1105\":[307,308],\"1106\":[309,310],\"1107\":[311,312]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:11\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:18\",\"ModifiedUserId\":27,\"Name\":\"NO GRAVADO\",\"Value\":0,\"id\":4,\"syncVersion\":2},\"TaxCodeId\":4,\"TaxExempt\":null,\"TaxNumber\":\"30-71197322-9\",\"id\":10,\"syncVersion\":32},\"SupplierId\":10,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":14972,\"syncVersion\":1},{\"BookingDayId\":8222,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":55,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":56,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":57,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-50.2,\"Longitude\":-72.16,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:03\",\"ModifiedUserId\":27,\"Name\":\"El Calafate\",\"id\":5,\"syncVersion\":5},\"CityId\":5,\"CreatedUTC\":\"2020-01-09T19:23:29\",\"CreatedUserId\":10,\"Description\":\"<p>Directly from the airport you will have a private transfer to your hotel in El Chalten</p><p>&nbsp;</p><p>Upon arrival in El Chalten, stop by the ranger's office to collect information about the various walks and hikes available in the area.&nbsp;</p><p>&nbsp;</p><p>There are a number of short day hikes that can be done; get a different perspective on the town from the Los Condores and Las Aguilas viewpoints (40 mins), or check out the Chorillo del Salto waterfall (2 hrs). </p><p>Spend the night at the hotel or discover the town, known for its laid-back atmosphere, for yourself. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":1,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":\"130.00\",\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":null,\"Price\":182,\"SourceCost\":\"130.00\",\"SourceCurrencyId\":\"USD\"}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":55,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":56,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":57,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-50.2,\"Longitude\":-72.16,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:03\",\"ModifiedUserId\":27,\"Name\":\"El Calafate\",\"id\":5,\"syncVersion\":5},\"CityId\":5,\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":null,\"Duration\":null,\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":415,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Calafate/Servicios/rompimiento-glaciar-perito-moreno-1-HD-Clarin.jpg\"},\"ImageId\":415,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":null,\"ModifiedUTC\":\"2019-07-25T17:26:40\",\"ModifiedUserId\":1,\"Name\":\"Transfer Calafate - Chalten sin guía \",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>A la hora apropiada, serás trasladado de El Calafate al Chalten. </p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-07-25T17:26:40\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":298,\"Title\":\"\",\"id\":888,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>At appropriate time, you will be transferred from El Calafate to Chalten.</p>\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-07-25T17:26:40\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":298,\"Title\":\"\",\"id\":889,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>All'orario stabilito, sarai trasferito da El Calafate al Chalten.</p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-07-25T17:26:40\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":298,\"Title\":\"\",\"id\":890,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"BASE\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-10-31T13:33:58\",\"ModifiedUserId\":1,\"Name\":\"Privado\",\"PaxMin\":null,\"id\":2,\"syncVersion\":5},\"ServiceTypeId\":2,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Calle 381 436, Z9405 El Calafate, Santa Cruz\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"FERNANDEZ VIVIANA INES\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\" goosheaikeoper@gmail.com\",\"ModifiedUTC\":\"2020-07-14T14:42:26\",\"ModifiedUserId\":30,\"Name\":\"Gooshe Aike\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+5492966613164\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"283\":[null],\"284\":[null],\"285\":[null],\"286\":[null],\"287\":[null],\"288\":[null],\"289\":[null],\"290\":[null],\"291\":[null],\"292\":[null],\"293\":[null],\"294\":[null],\"295\":[null],\"296\":[null],\"297\":[null],\"298\":[null],\"299\":[null],\"300\":[null],\"301\":[null],\"302\":[null],\"579\":[null],\"580\":[null],\"1132\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:21\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:42\",\"ModifiedUserId\":27,\"Name\":\"10.5%\",\"Value\":10.5,\"id\":1,\"syncVersion\":2},\"TaxCodeId\":1,\"TaxExempt\":null,\"TaxNumber\":\"27-17487198-7\",\"id\":37,\"syncVersion\":37},\"SupplierId\":37,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":298,\"syncVersion\":7},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-05\",\"ServiceId\":298,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Calle 381 436, Z9405 El Calafate, Santa Cruz\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"FERNANDEZ VIVIANA INES\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\" goosheaikeoper@gmail.com\",\"ModifiedUTC\":\"2020-07-14T14:42:26\",\"ModifiedUserId\":30,\"Name\":\"Gooshe Aike\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+5492966613164\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"283\":[null],\"284\":[null],\"285\":[null],\"286\":[null],\"287\":[null],\"288\":[null],\"289\":[null],\"290\":[null],\"291\":[null],\"292\":[null],\"293\":[null],\"294\":[null],\"295\":[null],\"296\":[null],\"297\":[null],\"298\":[null],\"299\":[null],\"300\":[null],\"301\":[null],\"302\":[null],\"579\":[null],\"580\":[null],\"1132\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:21\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:42\",\"ModifiedUserId\":27,\"Name\":\"10.5%\",\"Value\":10.5,\"id\":1,\"syncVersion\":2},\"TaxCodeId\":1,\"TaxExempt\":null,\"TaxNumber\":\"27-17487198-7\",\"id\":37,\"syncVersion\":37},\"SupplierId\":37,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":14973,\"syncVersion\":1}],\"BookingId\":679,\"BoxLunch\":null,\"Breakfast\":true,\"City\":{},\"CityId\":null,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"DayNr\":2,\"Description\":null,\"Dinner\":null,\"EntranceIncluded\":null,\"GroupDayTo\":null,\"GroupDays\":null,\"HotelId\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-09T19:20:47\",\"CreatedUserId\":10,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Chalten Entrada\",\"id\":462,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Chalten/Fotos%20varias%20%26%20Treks/argentina.jpg\"},\"ImageId\":462,\"ImageURL\":null,\"Lunch\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"PaxHotel\":false,\"QuoteDate\":null,\"ShowOptionals\":null,\"Snack\":null,\"SortNr\":null,\"Title\":\"test12\",\"TransDate\":\"2020-02-05\",\"id\":8222,\"syncVersion\":1},{\"BookingDayHotels\":[],\"BookingDayServices\":[{\"BookingDayId\":8223,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":79,\"syncVersion\":1},{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":80,\"syncVersion\":1},{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":81,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-48.08,\"Longitude\":-72.15,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:03:05\",\"ModifiedUserId\":27,\"Name\":\"El Chalten\",\"id\":13,\"syncVersion\":5},\"CityId\":13,\"CreatedUTC\":\"2020-01-09T19:27:52\",\"CreatedUserId\":10,\"Description\":\"<p>The only hike that does not go into a valley, but rises above them. It is one of the most impressive panoramic views of the entire area of ​​El Chaltén.</p><p>&nbsp;</p><p>The trail begins at the Ceferino Fonzo Visitor Center National Park, where a small gate indicates two paths: to the left, the path to Los Cóndores and Las Águilas lookouts, and to the right towards Pliegue Tumbado and Laguna Toro / Paso del Viento</p><p>This trail maintains an ascending slope of approximately 1100 meters in total, until reaching the viewpoint located at about 1500 meters above sea level. Due to its high height, the absence of trees and total exposure to the wind, you should go prepared with windbreaker jacket and shelter since a small snowfall is not uncommon even in the middle of summer.</p><p>&nbsp;</p><p>After an hour of starting the road, the trail crosses a plain called Pampa De las Carretas, from where you can appreciate the impressive Huemul hill, to the south the Viedma lake and to the Northwest the whole imposing of the Andes unfolds where they stand out Cerro Torre and Cerro Chaltén.</p><p><br></p><p>The trail then enters a beautiful forest until reaching an altitude of approximately 1000 meters above sea level, where the landscape changes abruptly: the trees give rise to bushes and scrubby vegetation, and among the many stones that occur Around the road it is possible to find remains of marine fossils 100 million years old.</p><p>&nbsp;</p><p>The last part of the road is blurred but it is still marked with yellow rods until it reaches the top of the Pliegue Tumbado -which can be snowed and in this case it is not recommended to walk- with an extraordinary panoramic view.</p><p>&nbsp;</p><p><em>Note: Although access to this viewpoint is possible in the range of dates mentioned, it will always depend on the accumulation of snow on the trail, especially on the final route. We recommend always check the condition of the trails in the Visitor Center of Los Glaciares National Park located just before entering the tourist village.</em></p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":0,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":\"0.00\",\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":null,\"Price\":0,\"SourceCost\":\"0.00\",\"SourceCurrencyId\":\"USD\"}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":79,\"syncVersion\":1},{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":80,\"syncVersion\":1},{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":81,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-48.08,\"Longitude\":-72.15,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:03:05\",\"ModifiedUserId\":27,\"Name\":\"El Chalten\",\"id\":13,\"syncVersion\":5},\"CityId\":13,\"Closed\":false,\"Comment\":\"Nota: Although access to this viewpoint is possible in the range of dates mentioned, it will always depend on the accumulation of snow on the trail, especially on the final route. We recommend always check the condition of the trails in the Visitor Center of Los Glaciares National Park located just before entering the tourist village.\",\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":\"PERSON\",\"CreatedUTC\":\"2019-11-06T22:05:09\",\"CreatedUserId\":1,\"Currency\":{},\"CurrencyId\":null,\"Dinner\":null,\"Duration\":null,\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-06T22:05:05\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-11-06T22:05:05\",\"ModifiedUserId\":1,\"Name\":null,\"id\":466,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Chalten/Fotos%20varias%20%26%20Treks/IMG_0903-1024x574.jpg\"},\"ImageId\":466,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Pliegue Tumbado \",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":\"2019-11-06T22:05:09\",\"CreatedUserId\":1,\"Description\":\"<p><br></p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"OfferedLanguage\":null,\"Optional\":null,\"ServiceId\":794,\"Title\":\"\",\"id\":2376,\"syncVersion\":1},{\"CreatedUTC\":\"2019-11-06T22:05:09\",\"CreatedUserId\":1,\"Description\":\"The trail begins at the Ceferino Fonzo Visitor Center National Park, where a small gate indicates two paths: to the left, the path to Los Cóndores and Las Águilas lookouts, and to the right towards Pliegue Tumbado and Laguna Toro / Paso del Viento This trail maintains an ascending slope of approximately 1100 meters in total, until reaching the viewpoint located at about 1500 meters above sea level. Due to its high height, the absence of trees and total exposure to the wind, you should go prepared with windbreaker jacket and shelter since a small snowfall is not uncommon even in the middle of summer. After an hour of starting the road, the trail crosses a plain called Pampa De las Carretas, from where you can appreciate the impressive Huemul hill, to the south the Viedma lake and to the Northwest the whole imposing of the Andes unfolds where they stand out Cerro Torre and Cerro Chaltén. The trail then enters a beautiful forest until reaching an altitude of approximately 1000 meters above sea level, where the landscape changes abruptly: the trees give rise to bushes and scrubby vegetation, and among the many stones that occur Around the road it is possible to find remains of marine fossils 100 million years old. The last part of the road is blurred but it is still marked with yellow rods until it reaches the top of the Pliegue Tumbado -which can be snowed and in this case it is not recommended to walk- with an extraordinary panoramic view.\\n\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"OfferedLanguage\":null,\"Optional\":null,\"ServiceId\":794,\"Title\":\"Pliegue Tumbado \",\"id\":2377,\"syncVersion\":1},{\"CreatedUTC\":\"2019-11-06T22:05:09\",\"CreatedUserId\":1,\"Description\":\"<p><br></p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"OfferedLanguage\":null,\"Optional\":null,\"ServiceId\":794,\"Title\":\"\",\"id\":2378,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"PERSON\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Regular\",\"PaxMin\":null,\"id\":1,\"syncVersion\":4},\"ServiceTypeId\":1,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"-\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":null,\"CreatedUTC\":\"2019-11-06T21:50:35\",\"CreatedUserId\":1,\"CurrencyId\":null,\"Email\":\"-\",\"ModifiedUTC\":\"2019-11-06T22:08:43\",\"ModifiedUserId\":1,\"Name\":\"Treks en Chalten\",\"PaymentConditionId\":null,\"PaymentTypeId\":null,\"Phone\":\"-\",\"PrivateCostBy\":\"NONE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{},\"TaxCodeId\":null,\"TaxExempt\":null,\"TaxNumber\":null,\"id\":316,\"syncVersion\":2},\"SupplierId\":316,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":794,\"syncVersion\":1},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-06\",\"ServiceId\":794,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"-\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":null,\"CreatedUTC\":\"2019-11-06T21:50:35\",\"CreatedUserId\":1,\"CurrencyId\":null,\"Email\":\"-\",\"ModifiedUTC\":\"2019-11-06T22:08:43\",\"ModifiedUserId\":1,\"Name\":\"Treks en Chalten\",\"PaymentConditionId\":null,\"PaymentTypeId\":null,\"Phone\":\"-\",\"PrivateCostBy\":\"NONE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{},\"TaxCodeId\":null,\"TaxExempt\":null,\"TaxNumber\":null,\"id\":316,\"syncVersion\":2},\"SupplierId\":316,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":14975,\"syncVersion\":1}],\"BookingId\":679,\"BoxLunch\":null,\"Breakfast\":true,\"City\":{},\"CityId\":null,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"DayNr\":3,\"Description\":null,\"Dinner\":null,\"EntranceIncluded\":null,\"GroupDayTo\":null,\"GroupDays\":null,\"HotelId\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-06T22:05:05\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-11-06T22:05:05\",\"ModifiedUserId\":1,\"Name\":null,\"id\":466,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Chalten/Fotos%20varias%20%26%20Treks/IMG_0903-1024x574.jpg\"},\"ImageId\":466,\"ImageURL\":null,\"Lunch\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"PaxHotel\":null,\"QuoteDate\":null,\"ShowOptionals\":null,\"Snack\":null,\"SortNr\":null,\"Title\":\"Pliegue Tumbado \",\"TransDate\":\"2020-02-06\",\"id\":8223,\"syncVersion\":1},{\"BookingDayHotels\":[],\"BookingDayServices\":[{\"BookingDayId\":8224,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":79,\"syncVersion\":1},{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":80,\"syncVersion\":1},{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":81,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-48.08,\"Longitude\":-72.15,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:03:05\",\"ModifiedUserId\":27,\"Name\":\"El Chalten\",\"id\":13,\"syncVersion\":5},\"CityId\":13,\"CreatedUTC\":\"2020-01-09T19:27:52\",\"CreatedUserId\":10,\"Description\":\"<p><em><span class=\\\"ql-cursor\\\">﻿</span></em>The most sought after trek with the most spectacular views of El Chalten (the Fitz Roy massif). This natural viewpoint is the closest site to the imposing walls of El Chalten (the Fitz Roy massif) and its peripheral granitic needles and without a doubt the most famous of all the walks.</p><p><br></p><ul><li>Jurisdiction: Los Glaciares National Park.</li><li>Duration: 5 hours (one way).</li><li>Difficulty: medium.</li><li>Slope: 700 meters from El Chaltén.</li><li>Accessible: normally from October to May.</li></ul><p>&nbsp;</p><p>The head of the trail begins at the end of Avenida San Martín, where the urban ejido of El Chaltén ends. There it is possible to park vehicles in an area designated for that purpose.</p><p>During the first hour of hiking, the slope is somewhat steep, until entering the valley of the Del Salto stream towards El Chalten (the Fitz Roy massif). The ñires begin to be more and more numerous around the footpath and approximately an hour and a half of the journey you get to a well-signposted natural rocky viewpoint, with a sign that allows you to interpret the mountainous and glacier landscape that is presented in front of the traveler. The path continues always up the Del Salto stream to the drainage area of ​​the Madre y Hija lagoons.</p><p>About 4 hours after leaving from El Chaltén, you will arrive first at Poincenot Base Camp (one of the busiest National Park camping sites) and after crossing the Blanco River, to the Río Blanco base camp (only for climbers). From here the path continues with a steep slope of approximately 400 meters of height to the Tres lagoon, which will require more than an hour of effort.</p><p><br></p><p>The road ends at the ancient moraine ridge (huge arc-shaped formation that currently contains the lagoon, formed by the action of the advance and subsequent glacial retreat), with an extraordinary view of the lagoon and glacier of the Three.</p><p>&nbsp;</p><p>This is the closest view of the granitic wall of El Chalten (the Fitz Roy massif)and its peripheral needles. Going down the moraine, you can continue along a path that goes around the lagoon to its mouth, and at the end of the trail you can see the desolate Sucia lagoon and its hanging glaciers.</p><p>&nbsp;</p><p><em>Note: Although access to this viewpoint is possible in the range of dates mentioned, it will always depend on the accumulation of snow on the trail, especially on the final route. We recommend always check the condition of the trails in the Visitor Center of Los Glaciares National Park located just before entering the tourist village.</em></p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":0,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":\"0.00\",\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":null,\"Price\":0,\"SourceCost\":\"0.00\",\"SourceCurrencyId\":\"USD\"}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":79,\"syncVersion\":1},{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":80,\"syncVersion\":1},{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":81,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-48.08,\"Longitude\":-72.15,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:03:05\",\"ModifiedUserId\":27,\"Name\":\"El Chalten\",\"id\":13,\"syncVersion\":5},\"CityId\":13,\"Closed\":false,\"Comment\":\"normally from October to May.\\nNote: Although access to this viewpoint is possible in the range of dates mentioned, it will always depend on the accumulation of snow on the trail, especially on the final route. We recommend always check the condition of the trails in the Visitor Center of Los Glaciares National Park located just before entering the tourist village.\",\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":\"PERSON\",\"CreatedUTC\":\"2019-11-06T21:54:16\",\"CreatedUserId\":1,\"Currency\":{},\"CurrencyId\":null,\"Dinner\":null,\"Duration\":\"5hs \",\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-06T21:57:03\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-11-06T21:57:04\",\"ModifiedUserId\":1,\"Name\":null,\"id\":467,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Chalten/Fotos%20varias%20%26%20Treks/laguna-de-los-tres-1.jpg\"},\"ImageId\":467,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":null,\"ModifiedUTC\":\"2019-11-06T21:57:08\",\"ModifiedUserId\":1,\"Name\":\"Trek to Laguna de los Tres \",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":\"2019-11-06T21:54:16\",\"CreatedUserId\":1,\"Description\":\"<p><br></p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-11-06T21:57:08\",\"ModifiedUserId\":1,\"OfferedLanguage\":null,\"Optional\":null,\"ServiceId\":793,\"Title\":\"\",\"id\":2373,\"syncVersion\":1},{\"CreatedUTC\":\"2019-11-06T21:54:16\",\"CreatedUserId\":1,\"Description\":\"<p>The head of the trail begins at the end of Avenida San Martín, where the urban ejido of El Chaltén ends. There it is possible to park vehicles in an area designated for that purpose. During the first hour of hiking, the slope is somewhat steep, until entering the valley of the Del Salto stream towards El Chalten (the Fitz Roy massif). The ñires begin to be more and more numerous around the footpath and approximately an hour and a half of the journey you get to a well-signposted natural rocky viewpoint, with a sign that allows you to interpret the mountainous and glacier landscape that is presented in front of the traveler. The path continues always up the Del Salto stream to the drainage area of ​​the Madre y Hija lagoons. About 4 hours after leaving from El Chaltén, you will arrive first at Poincenot Base Camp (one of the busiest National Park camping sites) and after crossing the Blanco River, to the Río Blanco base camp (only for climbers). From here the path continues with a steep slope of approximately 400 meters of height to the Tres lagoon, which will require more than an hour of effort. The road ends at the ancient moraine ridge (huge arc-shaped formation that currently contains the lagoon, formed by the action of the advance and subsequent glacial retreat), with an extraordinary view of the lagoon and glacier of the Three. This is the closest view of the granitic wall of El Chalten (the Fitz Roy massif)and its peripheral needles. Going down the moraine, you can continue along a path that goes around the lagoon to its mouth, and at the end of the trail you can see the desolate Sucia lagoon and its hanging glaciers.</p>\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-11-06T21:57:08\",\"ModifiedUserId\":1,\"OfferedLanguage\":null,\"Optional\":null,\"ServiceId\":793,\"Title\":\"Laguna De Los Tres \",\"id\":2374,\"syncVersion\":1},{\"CreatedUTC\":\"2019-11-06T21:54:16\",\"CreatedUserId\":1,\"Description\":\"<p><br></p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-11-06T21:57:08\",\"ModifiedUserId\":1,\"OfferedLanguage\":null,\"Optional\":null,\"ServiceId\":793,\"Title\":\"\",\"id\":2375,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"PERSON\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Regular\",\"PaxMin\":null,\"id\":1,\"syncVersion\":4},\"ServiceTypeId\":1,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"-\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":null,\"CreatedUTC\":\"2019-11-06T21:50:35\",\"CreatedUserId\":1,\"CurrencyId\":null,\"Email\":\"-\",\"ModifiedUTC\":\"2019-11-06T22:08:43\",\"ModifiedUserId\":1,\"Name\":\"Treks en Chalten\",\"PaymentConditionId\":null,\"PaymentTypeId\":null,\"Phone\":\"-\",\"PrivateCostBy\":\"NONE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{},\"TaxCodeId\":null,\"TaxExempt\":null,\"TaxNumber\":null,\"id\":316,\"syncVersion\":2},\"SupplierId\":316,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":793,\"syncVersion\":4},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-07\",\"ServiceId\":793,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"-\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":null,\"CreatedUTC\":\"2019-11-06T21:50:35\",\"CreatedUserId\":1,\"CurrencyId\":null,\"Email\":\"-\",\"ModifiedUTC\":\"2019-11-06T22:08:43\",\"ModifiedUserId\":1,\"Name\":\"Treks en Chalten\",\"PaymentConditionId\":null,\"PaymentTypeId\":null,\"Phone\":\"-\",\"PrivateCostBy\":\"NONE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{},\"TaxCodeId\":null,\"TaxExempt\":null,\"TaxNumber\":null,\"id\":316,\"syncVersion\":2},\"SupplierId\":316,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":14976,\"syncVersion\":1}],\"BookingId\":679,\"BoxLunch\":null,\"Breakfast\":true,\"City\":{},\"CityId\":null,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"DayNr\":4,\"Description\":null,\"Dinner\":null,\"EntranceIncluded\":null,\"GroupDayTo\":null,\"GroupDays\":null,\"HotelId\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-06T21:57:03\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-11-06T21:57:04\",\"ModifiedUserId\":1,\"Name\":null,\"id\":467,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Chalten/Fotos%20varias%20%26%20Treks/laguna-de-los-tres-1.jpg\"},\"ImageId\":467,\"ImageURL\":null,\"Lunch\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"PaxHotel\":null,\"QuoteDate\":null,\"ShowOptionals\":null,\"Snack\":null,\"SortNr\":null,\"Title\":\"Laguna De Los Tres \",\"TransDate\":\"2020-02-07\",\"id\":8224,\"syncVersion\":1},{\"BookingDayHotels\":[{\"BookingDayId\":8225,\"BookingDayRooms\":[{\"BookingDayHotelId\":2529,\"Category\":{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":111,\"ModifiedUTC\":\"2019-10-16T15:30:50\",\"ModifiedUserId\":1,\"Name\":\"Superior\",\"Program\":null,\"id\":426,\"syncVersion\":1},\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"CurrencyId\":\"ARS\",\"Hotel\":{\"Address\":\"Valentín Feilberg 51, El Calafate, Santa Cruz\",\"Checkin\":null,\"Checkout\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":55,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":56,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":57,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-50.2,\"Longitude\":-72.16,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:03\",\"ModifiedUserId\":27,\"Name\":\"El Calafate\",\"id\":5,\"syncVersion\":5},\"CityId\":5,\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"USD\",\"ModifiedUTC\":\"2020-03-28T20:30:21\",\"ModifiedUserId\":1,\"Name\":\"Peso Argentino\",\"Operation\":\"DIVIDE\",\"id\":\"ARS\",\"syncVersion\":2},\"CurrencyId\":\"ARS\",\"Email\":\"reservashotelelcalafate@aca.org.ar\",\"HotelCategory\":{},\"HotelCategoryId\":null,\"HotelDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>El elegante Hotel ACA El Calafate está ubicado en un edificio histórico de piedra de El Calafate y ofrece WiFi gratuita, desayuno buffet y un bar. El hotel se encuentra a solo 50 metros de la zona comercial. El aeropuerto internacional Comandante Armando Tola se halla a 21 km. El parque nacional de Los Glaciares se sitúa a 80 km.</p>\",\"HotelId\":111,\"LanguageId\":1,\"ModifiedUTC\":\"2019-08-23T14:06:54\",\"ModifiedUserId\":1,\"id\":328,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Housed inside a historic stone building in El Calafate, the stylish Hotel ACA El Calafate features free Wi-Fi, buffet breakfast services and an on site bar. It sits only 50 m from the commercial area. Comandante Armando Tola International Airport is 21 km from the property. Los Glaciares National Park lies 80 km away.</p>\",\"HotelId\":111,\"LanguageId\":2,\"ModifiedUTC\":\"2019-08-23T14:06:54\",\"ModifiedUserId\":1,\"id\":329,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>L'elegante Hotel ACA El Calafate occupa uno storico edificio in pietra a El Calafate e offre la connessione Wi-Fi gratuita, la colazione a buffet e un bar. L'hotel si trova a soli 50 metri dalla zona commerciale. L'aeroporto internazionale Comandante Armando Tola dista 21 km. Il Parco Nazionale Los Glaciares dista 80 km.</p>\",\"HotelId\":111,\"LanguageId\":3,\"ModifiedUTC\":\"2019-08-23T14:06:54\",\"ModifiedUserId\":1,\"id\":330,\"syncVersion\":1}],\"HotelPhotos\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":111,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":315,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Calafate/Hoteles/Aca%20Hotel/21097730.jpg\"},\"ImageId\":315,\"ImageURL\":null,\"ModifiedUTC\":\"2019-10-16T15:30:50\",\"ModifiedUserId\":1,\"id\":319,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":111,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":314,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Calafate/Hoteles/Aca%20Hotel/21096765.jpg\"},\"ImageId\":314,\"ImageURL\":null,\"ModifiedUTC\":\"2019-10-16T15:30:50\",\"ModifiedUserId\":1,\"id\":320,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":111,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":316,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Calafate/Hoteles/Aca%20Hotel/21097870.jpg\"},\"ImageId\":316,\"ImageURL\":null,\"ModifiedUTC\":\"2019-10-16T15:30:50\",\"ModifiedUserId\":1,\"id\":321,\"syncVersion\":1}],\"HotelRoomTypes\":[{\"Comment\":null,\"CreatedUTC\":\"2019-10-23T19:32:55\",\"CreatedUserId\":1,\"HotelId\":111,\"ModifiedUTC\":\"2019-11-05T20:45:05\",\"ModifiedUserId\":1,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"SGL\",\"Pax\":1,\"id\":1,\"syncVersion\":1},\"RoomTypeId\":1,\"id\":317,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2019-10-23T19:32:55\",\"CreatedUserId\":1,\"HotelId\":111,\"ModifiedUTC\":\"2019-11-05T20:45:05\",\"ModifiedUserId\":1,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"DBL\",\"Pax\":2,\"id\":2,\"syncVersion\":1},\"RoomTypeId\":2,\"id\":318,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2019-10-23T19:32:55\",\"CreatedUserId\":1,\"HotelId\":111,\"ModifiedUTC\":\"2019-11-05T20:45:05\",\"ModifiedUserId\":1,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"TPL\",\"Pax\":3,\"id\":3,\"syncVersion\":1},\"RoomTypeId\":3,\"id\":319,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2019-10-23T19:32:55\",\"CreatedUserId\":1,\"HotelId\":111,\"ModifiedUTC\":\"2019-11-05T20:45:05\",\"ModifiedUserId\":1,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"CPL\",\"Pax\":4,\"id\":6,\"syncVersion\":1},\"RoomTypeId\":6,\"id\":320,\"syncVersion\":1}],\"HotelTaxCodes\":[],\"ModifiedUTC\":\"2020-12-10T14:34:19\",\"ModifiedUserId\":30,\"Name\":\"Aca Hotel\",\"Nights\":null,\"PeriodCostBy\":null,\"Phone\":\"+54 2902 49-1004 / 491027\",\"ProgramPeriodCostBy\":null,\"ProgramUnitCostBy\":null,\"RoomCategories\":[{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":111,\"ModifiedUTC\":\"2019-10-16T15:30:50\",\"ModifiedUserId\":1,\"Name\":\"Standard\",\"Program\":null,\"id\":425,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":111,\"ModifiedUTC\":\"2019-10-16T15:30:50\",\"ModifiedUserId\":1,\"Name\":\"Superior\",\"Program\":null,\"id\":426,\"syncVersion\":1},{\"Closed\":true,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":111,\"ModifiedUTC\":\"2019-10-16T15:30:50\",\"ModifiedUserId\":1,\"Name\":\"Standard\",\"Program\":null,\"id\":427,\"syncVersion\":1},{\"Closed\":true,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":111,\"ModifiedUTC\":\"2019-10-16T15:30:50\",\"ModifiedUserId\":1,\"Name\":\"Standard\",\"Program\":null,\"id\":428,\"syncVersion\":1}],\"RoomCostBy\":\"ROOM_TYPE_CATEGORY\",\"Supplier\":{\"Address\":\"Valentín Feilberg 51, El Calafate, Santa Cruz\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"AUTOMOVIL CLUB ARGENTINO\",\"CreatedUTC\":\"2019-08-21T20:13:20\",\"CreatedUserId\":1,\"CurrencyId\":null,\"Email\":\"reservashotelelcalafate@aca.org.ar\",\"ModifiedUTC\":\"2020-04-27T16:17:35\",\"ModifiedUserId\":37,\"Name\":\"Aca Hotel\",\"PaymentConditionId\":null,\"PaymentTypeId\":null,\"Phone\":\"0\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"HOTEL\",\"TaxBasePercent\":null,\"TaxCode\":{},\"TaxCodeId\":null,\"TaxExempt\":null,\"TaxNumber\":\"30-50014329-7\",\"id\":161,\"syncVersion\":2},\"SupplierId\":161,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:33\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:04\",\"ModifiedUserId\":27,\"Name\":\"TUR IVA\",\"Value\":0,\"id\":5,\"syncVersion\":3},\"TaxCodeId\":5,\"Type\":\"NORMAL\",\"UnitCostBy\":null,\"WebSite\":null,\"id\":111,\"syncVersion\":12},\"HotelCategory\":{},\"HotelCategoryId\":null,\"HotelId\":111,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Quote\":null,\"QuoteList\":{\"0\":{\"Cost\":110,\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":null,\"Price\":154,\"PriceModified\":null,\"RoomCost\":110,\"SourceCost\":null,\"SourceCurrencyId\":\"USD\"}},\"ReservationNumber\":null,\"Room\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"DBL\",\"Pax\":2,\"id\":2,\"syncVersion\":1},\"RoomCategory\":426,\"RoomTypeId\":2,\"Rooms\":1,\"Status\":\"PENDING\",\"Supplier\":{},\"SupplierId\":null,\"id\":2806,\"syncVersion\":1}],\"Checkin\":\"2020-02-08\",\"Checkout\":\"2020-02-08\",\"City\":{\"CityDescriptions\":[{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":55,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":56,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":57,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-50.2,\"Longitude\":-72.16,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:03\",\"ModifiedUserId\":27,\"Name\":\"El Calafate\",\"id\":5,\"syncVersion\":5},\"CityId\":5,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"Days\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":2529,\"syncVersion\":1}],\"BookingDayServices\":[{\"BookingDayId\":8225,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":79,\"syncVersion\":1},{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":80,\"syncVersion\":1},{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":81,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-48.08,\"Longitude\":-72.15,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:03:05\",\"ModifiedUserId\":27,\"Name\":\"El Chalten\",\"id\":13,\"syncVersion\":5},\"CityId\":13,\"CreatedUTC\":\"2020-01-09T19:31:02\",\"CreatedUserId\":10,\"Description\":\"<p>If you still have some energy left and you want to do another self-guided trek. Depart early morning for one of the classic walks of El Chaltén that will lead you to the Adela cordon and the incredible Cerro Torre. The DeAgostini base camp is located there. Just approaching the viewpoint, two hours from El Chaltén, allows the traveler to witness one of the most capricious mountain landscapes in the world, and one of the mythical mountains of Patagonia: Cerro Torre.</p><p>&nbsp;</p><ul><li>Jurisdiction: Los Glaciares National Park.</li><li>Duration: 4 hours (one way).</li><li>Approximate total time: 9 hours (round trip).</li><li>Difficulty: moderate.</li><li>Slope: 200 meters from El Chaltén.</li><li>Accessible: normally from October to May.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</li></ul><p>&nbsp;</p><p>From El Chaltén there are two path heads that go to the Torre lagoon; both trails are unified 5 minutes from its start. The road enters the valley of the Fitz Roy River and continues up the course of this river to its source. Only 15 minutes from the beginning of the hike, there is access to a first viewpoint located in a gorge of the Fitz Roy River, which offers a panoramic view of the Solo hills, Adela cordon, Torre hill and Mount Fitz Roy. On the other side of the river is the Margarita waterfall. Halfway down the path you will reach a natural viewpoint with an incomparable panoramic view of the Adela cord and the Torre hill and the granite needles that accompany it. The road finally crosses the DeAgostini base camp where it is possible to spend the night, and 15 minutes later it ends at the Torre lagoon. This lagoon tends to group numerous icebergs on its shore that break off from the front of the Grande glacier.</p><p>&nbsp;</p><p><em>Note: Although access to this viewpoint is possible in the range of dates mentioned, it will always depend on the accumulation of snow on the trail, especially on the final route. We recommend always check the condition of the trails in the Visitor Center of Los Glaciares National Park located just before entering the tourist village.</em></p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":0,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":\"0.00\",\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":null,\"Price\":0,\"SourceCost\":\"0.00\",\"SourceCurrencyId\":\"USD\"}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":79,\"syncVersion\":1},{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":80,\"syncVersion\":1},{\"CityId\":13,\"CreatedUTC\":\"2020-10-09T12:03:00\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":81,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-48.08,\"Longitude\":-72.15,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:03:05\",\"ModifiedUserId\":27,\"Name\":\"El Chalten\",\"id\":13,\"syncVersion\":5},\"CityId\":13,\"Closed\":false,\"Comment\":\"Nota: Although access to this viewpoint is possible in the range of dates mentioned, it will always depend on the accumulation of snow on the trail, especially on the final route. We recommend always check the condition of the trails in the Visitor Center of Los Glaciares National Park located just before entering the tourist village.\",\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":\"PERSON\",\"CreatedUTC\":\"2019-11-06T22:08:41\",\"CreatedUserId\":1,\"Currency\":{},\"CurrencyId\":null,\"Dinner\":null,\"Duration\":\"4 hs (one \",\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-06T12:58:17\",\"CreatedUserId\":10,\"ModifiedUTC\":\"2019-11-06T12:58:18\",\"ModifiedUserId\":10,\"Name\":\"Cerro Torre\",\"id\":464,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Chalten/Fotos%20varias%20%26%20Treks/Cerro_Torre_%28east_face%29_and_Laguna_Torre.JPG\"},\"ImageId\":464,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Trek Cerro Torre \",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":\"2019-11-06T22:08:41\",\"CreatedUserId\":1,\"Description\":\"<p><br></p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"OfferedLanguage\":null,\"Optional\":null,\"ServiceId\":795,\"Title\":\"\",\"id\":2379,\"syncVersion\":1},{\"CreatedUTC\":\"2019-11-06T22:08:41\",\"CreatedUserId\":1,\"Description\":\"From El Chaltén there are two path heads that go to the Torre lagoon; both trails are unified 5 minutes from its start. The road enters the valley of the Fitz Roy River and continues up the course of this river to its source. Only 15 minutes from the beginning of the hike, there is access to a first viewpoint located in a gorge of the Fitz Roy River, which offers a panoramic view of the Solo hills, Adela cordon, Torre hill and Mount Fitz Roy. On the other side of the river is the Margarita waterfall. Halfway down the path you will reach a natural viewpoint with an incomparable panoramic view of the Adela cord and the Torre hill and the granite needles that accompany it. The road finally crosses the DeAgostini base camp where it is possible to spend the night, and 15 minutes later it ends at the Torre lagoon. This lagoon tends to group numerous icebergs on its shore that break off from the front of the Grande glacier.\\n\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"OfferedLanguage\":null,\"Optional\":null,\"ServiceId\":795,\"Title\":\"Cerro Torre \",\"id\":2380,\"syncVersion\":1},{\"CreatedUTC\":\"2019-11-06T22:08:41\",\"CreatedUserId\":1,\"Description\":\"<p><br></p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"OfferedLanguage\":null,\"Optional\":null,\"ServiceId\":795,\"Title\":\"\",\"id\":2381,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"PERSON\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Regular\",\"PaxMin\":null,\"id\":1,\"syncVersion\":4},\"ServiceTypeId\":1,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"-\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":null,\"CreatedUTC\":\"2019-11-06T21:50:35\",\"CreatedUserId\":1,\"CurrencyId\":null,\"Email\":\"-\",\"ModifiedUTC\":\"2019-11-06T22:08:43\",\"ModifiedUserId\":1,\"Name\":\"Treks en Chalten\",\"PaymentConditionId\":null,\"PaymentTypeId\":null,\"Phone\":\"-\",\"PrivateCostBy\":\"NONE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{},\"TaxCodeId\":null,\"TaxExempt\":null,\"TaxNumber\":null,\"id\":316,\"syncVersion\":2},\"SupplierId\":316,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":795,\"syncVersion\":1},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-08\",\"ServiceId\":795,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"-\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":null,\"CreatedUTC\":\"2019-11-06T21:50:35\",\"CreatedUserId\":1,\"CurrencyId\":null,\"Email\":\"-\",\"ModifiedUTC\":\"2019-11-06T22:08:43\",\"ModifiedUserId\":1,\"Name\":\"Treks en Chalten\",\"PaymentConditionId\":null,\"PaymentTypeId\":null,\"Phone\":\"-\",\"PrivateCostBy\":\"NONE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{},\"TaxCodeId\":null,\"TaxExempt\":null,\"TaxNumber\":null,\"id\":316,\"syncVersion\":2},\"SupplierId\":316,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":14977,\"syncVersion\":1},{\"BookingDayId\":8225,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":55,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":56,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":57,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-50.2,\"Longitude\":-72.16,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:03\",\"ModifiedUserId\":27,\"Name\":\"El Calafate\",\"id\":5,\"syncVersion\":5},\"CityId\":5,\"CreatedUTC\":\"2020-01-09T19:31:02\",\"CreatedUserId\":10,\"Description\":\"<p><span style=\\\"font-size: 14px; color: rgb(119, 119, 119);\\\">At the designated time in the afternoon you will have a private transfer to your hotel in El Calafate.</span></p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":1,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":\"130.00\",\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":null,\"Price\":182,\"SourceCost\":\"130.00\",\"SourceCurrencyId\":\"USD\"}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":55,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":56,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":57,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-50.2,\"Longitude\":-72.16,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:03\",\"ModifiedUserId\":27,\"Name\":\"El Calafate\",\"id\":5,\"syncVersion\":5},\"CityId\":5,\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":null,\"CreatedUTC\":\"2019-09-17T18:01:18\",\"CreatedUserId\":1,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":null,\"Duration\":null,\"EntranceIncluded\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":null,\"ModifiedUTC\":\"2019-09-17T18:01:38\",\"ModifiedUserId\":1,\"Name\":\"Transfer Chalten - El Calafate sin guía \",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":\"2019-09-17T18:01:18\",\"CreatedUserId\":1,\"Description\":\"<p><span style=\\\"font-size: 14px; color: rgb(119, 119, 119);\\\">A la hora apropiada, serás trasladado a El Calafate. </span></p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-09-17T18:01:38\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":580,\"Title\":\"\",\"id\":1734,\"syncVersion\":1},{\"CreatedUTC\":\"2019-09-17T18:01:18\",\"CreatedUserId\":1,\"Description\":\"<p><span style=\\\"font-size: 14px; color: rgb(119, 119, 119);\\\">At the appropriate time, you will be transferred to El Calafate. </span></p>\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-09-17T18:01:38\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":580,\"Title\":\"\",\"id\":1735,\"syncVersion\":1},{\"CreatedUTC\":\"2019-09-17T18:01:18\",\"CreatedUserId\":1,\"Description\":\"<p><span style=\\\"font-size: 14px; color: rgb(119, 119, 119);\\\">All'orario stabilito, sarai trasferito a El Calafate. </span></p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-09-17T18:01:38\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":580,\"Title\":\"\",\"id\":1736,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"BASE\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-10-31T13:33:58\",\"ModifiedUserId\":1,\"Name\":\"Privado\",\"PaxMin\":null,\"id\":2,\"syncVersion\":5},\"ServiceTypeId\":2,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Calle 381 436, Z9405 El Calafate, Santa Cruz\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"FERNANDEZ VIVIANA INES\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\" goosheaikeoper@gmail.com\",\"ModifiedUTC\":\"2020-07-14T14:42:26\",\"ModifiedUserId\":30,\"Name\":\"Gooshe Aike\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+5492966613164\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"283\":[null],\"284\":[null],\"285\":[null],\"286\":[null],\"287\":[null],\"288\":[null],\"289\":[null],\"290\":[null],\"291\":[null],\"292\":[null],\"293\":[null],\"294\":[null],\"295\":[null],\"296\":[null],\"297\":[null],\"298\":[null],\"299\":[null],\"300\":[null],\"301\":[null],\"302\":[null],\"579\":[null],\"580\":[null],\"1132\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:21\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:42\",\"ModifiedUserId\":27,\"Name\":\"10.5%\",\"Value\":10.5,\"id\":1,\"syncVersion\":2},\"TaxCodeId\":1,\"TaxExempt\":null,\"TaxNumber\":\"27-17487198-7\",\"id\":37,\"syncVersion\":37},\"SupplierId\":37,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":580,\"syncVersion\":2},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-08\",\"ServiceId\":580,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Calle 381 436, Z9405 El Calafate, Santa Cruz\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"FERNANDEZ VIVIANA INES\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\" goosheaikeoper@gmail.com\",\"ModifiedUTC\":\"2020-07-14T14:42:26\",\"ModifiedUserId\":30,\"Name\":\"Gooshe Aike\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+5492966613164\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"283\":[null],\"284\":[null],\"285\":[null],\"286\":[null],\"287\":[null],\"288\":[null],\"289\":[null],\"290\":[null],\"291\":[null],\"292\":[null],\"293\":[null],\"294\":[null],\"295\":[null],\"296\":[null],\"297\":[null],\"298\":[null],\"299\":[null],\"300\":[null],\"301\":[null],\"302\":[null],\"579\":[null],\"580\":[null],\"1132\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:21\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:42\",\"ModifiedUserId\":27,\"Name\":\"10.5%\",\"Value\":10.5,\"id\":1,\"syncVersion\":2},\"TaxCodeId\":1,\"TaxExempt\":null,\"TaxNumber\":\"27-17487198-7\",\"id\":37,\"syncVersion\":37},\"SupplierId\":37,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":14978,\"syncVersion\":1}],\"BookingId\":679,\"BoxLunch\":null,\"Breakfast\":true,\"City\":{},\"CityId\":null,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"DayNr\":5,\"Description\":null,\"Dinner\":null,\"EntranceIncluded\":null,\"GroupDayTo\":null,\"GroupDays\":null,\"HotelId\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-12-17T12:10:44\",\"CreatedUserId\":10,\"ModifiedUTC\":\"2019-12-17T12:10:45\",\"ModifiedUserId\":10,\"Name\":\"Torre\",\"id\":463,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Chalten/Fotos%20varias%20%26%20Treks/cerro-torre-wallpapers-27808-3017954.jpg\"},\"ImageId\":463,\"ImageURL\":null,\"Lunch\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"PaxHotel\":false,\"QuoteDate\":null,\"ShowOptionals\":null,\"Snack\":null,\"SortNr\":null,\"Title\":\"Cerro Torre \",\"TransDate\":\"2020-02-08\",\"id\":8225,\"syncVersion\":1},{\"BookingDayHotels\":[],\"BookingDayServices\":[{\"BookingDayId\":8226,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":55,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":56,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":57,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-50.2,\"Longitude\":-72.16,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:03\",\"ModifiedUserId\":27,\"Name\":\"El Calafate\",\"id\":5,\"syncVersion\":5},\"CityId\":5,\"CreatedUTC\":\"2020-01-09T19:49:33\",\"CreatedUserId\":10,\"Description\":\"<p>After breakfast, you will be picked up from your hotel for your transfer to \\\"Los Glaciares National Park\\\". Upon arrival at&nbsp;\\\"Bajo de las Sombras\\\" pier, you embark on a 20-minute sailing trip across the Rico Arm, enjoying breathtaking views of the glacier's front walls and Icebergs Channel. You disembark on the opposite shore, where specialized mountain guides welcome you and lead you to a small shelter. After a short briefing, groups of 10 follow their guides along the lake's shore towards the edge of the glacier. Once on the ice the guides give each participant a pair of crampons and explain how to use them.&nbsp;The two hours circuit that follows introduces you to the fascinating landscape of the glaciers: streams, small lagoons, gullies, crevasses and plenty of ice formations in the most incredible blue colors. The flora, fauna and general geograhpy of the region will be explained to you and also the particular phenomenon that happens in the Perito Moreno Glacier that eventually produces its rupture. After the walk, a stroll through the forest brings you back to the shelter where you will embark back and spend some time on the catwalks. In the afternoon, return to the hotel.</p><p><br></p><p><strong><em>Age limit, up to 65 years old.</em></strong></p><p>\\n\\n</p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":0,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":\"230.00\",\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":null,\"Price\":322,\"SourceCost\":\"230.00\",\"SourceCurrencyId\":\"USD\"}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":55,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":56,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":57,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-50.2,\"Longitude\":-72.16,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:03\",\"ModifiedUserId\":27,\"Name\":\"El Calafate\",\"id\":5,\"syncVersion\":5},\"CityId\":5,\"Closed\":false,\"Comment\":\"Minimo dos paxs (svs adic. Guia pasarela USD 120)\",\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":\"PERSON\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":null,\"Duration\":null,\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":404,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Calafate/Servicios/3.png\"},\"ImageId\":404,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":null,\"ModifiedUTC\":\"2019-08-20T19:09:21\",\"ModifiedUserId\":1,\"Name\":\"Minitrekking traslado privado\",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Después del desayuno, será recogido de su hotel para su traslado al \\\"Parque Nacional Los Glaciares\\\". A su llegada al muelle \\\"Bajo de las Sombras\\\", se embarca en un viaje en velero de 20 minutos a través del Brazo Rico, disfrutando de impresionantes vistas de las paredes frontales del glaciar y el Canal Icebergs. Desembarcas en la orilla opuesta, donde guías de montaña especializados te dan la bienvenida y te llevan a un pequeño refugio. Después de una breve sesión informativa, grupos de 10 personas siguen a sus guías a lo largo de la orilla del lago hacia el borde del glaciar. Una vez en el hielo, los guías le dan a cada participante un par de grampones y explican cómo usarlos. El circuito de dos horas que sigue te presenta el fascinante paisaje de los glaciares: arroyos, pequeñas lagunas, barrancos, grietas y muchas formaciones de hielo en los colores azules más increíbles. Le explicaremos la flora, la fauna y la geografía general de la región y también el fenómeno particular que ocurre en el glaciar Perito Moreno que eventualmente produce su ruptura. Después de la caminata, un paseo por el bosque lo lleva de regreso al refugio donde se embarcará y pasará un tiempo en las pasarelas. Por la tarde, regreso al hotel.\\n\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":289,\"Title\":\"Minitrekking\",\"id\":861,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>After breakfast, you will be picked up from your hotel for your transfer to \\\"Los Glaciares National Park\\\". Upon arrival at&nbsp;\\\"Bajo de las Sombras\\\" pier, you embark on a 20-minute sailing trip across the Rico Arm, enjoying breathtaking views of the glacier's front walls and Icebergs Channel. You disembark on the opposite shore, where specialized mountain guides welcome you and lead you to a small shelter. After a short briefing, groups of 10 follow their guides along the lake's shore towards the edge of the glacier. Once on the ice the guides give each participant a pair of crampons and explain how to use them.&nbsp;The two hours circuit that follows introduces you to the fascinating landscape of the glaciers: streams, small lagoons, gullies, crevasses and plenty of ice formations in the most incredible blue colors. The flora, fauna and general geograhpy of the region will be explained to you and also the particular phenomenon that happens in the Perito Moreno Glacier that eventually produces its rupture. After the walk, a stroll through the forest brings you back to the shelter where you will embark back and spend some time on the catwalks. In the afternoon, return to the hotel.\\n\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":289,\"Title\":\"Minitrekking\",\"id\":862,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Dopo la colazione, verrai prelevato dal tuo hotel per il tuo trasferimento al \\\"Parco Nazionale Los Glaciares\\\". All'arrivo al molo \\\"Bajo de las Sombras\\\", ti imbarchi in un giro in barca a vela di 20 minuti attraverso il Rich Arm, godendo di una vista mozzafiato sulle pareti anteriori del ghiacciaio e sul Canale di Iceberg. Sbarchi sulla sponda opposta, dove guide alpine specializzate ti accolgono e ti portano in un piccolo rifugio. Dopo un breve briefing, gruppi di 10 persone seguono le loro guide lungo la riva del lago verso il bordo del ghiacciaio. Una volta sul ghiaccio, le guide danno a ciascun partecipante un paio di ramponi e spiegano come usarli. Il circuito di due ore che segue ti presenta l'affascinante paesaggio dei ghiacciai: ruscelli, piccole lagune, burroni, crepe e molte formazioni di ghiaccio nei più incredibili colori blu. Spiegheremo la flora, la fauna e la geografia generale della regione e anche il particolare fenomeno che si verifica nel ghiacciaio Perito Moreno che alla fine provoca la sua rottura. Dopo la passeggiata, una passeggiata attraverso la foresta ti riporta al rifugio dove ti imbarcherai e passerai un po 'di tempo sulle passerelle. Nel pomeriggio, rientro in hotel.\\n\\n\\n\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":289,\"Title\":\"Minitrekking\",\"id\":863,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"PERSON\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Regular\",\"PaxMin\":null,\"id\":1,\"syncVersion\":4},\"ServiceTypeId\":1,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Calle 381 436, Z9405 El Calafate, Santa Cruz\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"FERNANDEZ VIVIANA INES\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\" goosheaikeoper@gmail.com\",\"ModifiedUTC\":\"2020-07-14T14:42:26\",\"ModifiedUserId\":30,\"Name\":\"Gooshe Aike\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+5492966613164\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"283\":[null],\"284\":[null],\"285\":[null],\"286\":[null],\"287\":[null],\"288\":[null],\"289\":[null],\"290\":[null],\"291\":[null],\"292\":[null],\"293\":[null],\"294\":[null],\"295\":[null],\"296\":[null],\"297\":[null],\"298\":[null],\"299\":[null],\"300\":[null],\"301\":[null],\"302\":[null],\"579\":[null],\"580\":[null],\"1132\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:21\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:42\",\"ModifiedUserId\":27,\"Name\":\"10.5%\",\"Value\":10.5,\"id\":1,\"syncVersion\":2},\"TaxCodeId\":1,\"TaxExempt\":null,\"TaxNumber\":\"27-17487198-7\",\"id\":37,\"syncVersion\":37},\"SupplierId\":37,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":289,\"syncVersion\":9},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-09\",\"ServiceId\":289,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Calle 381 436, Z9405 El Calafate, Santa Cruz\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"FERNANDEZ VIVIANA INES\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\" goosheaikeoper@gmail.com\",\"ModifiedUTC\":\"2020-07-14T14:42:26\",\"ModifiedUserId\":30,\"Name\":\"Gooshe Aike\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+5492966613164\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"283\":[null],\"284\":[null],\"285\":[null],\"286\":[null],\"287\":[null],\"288\":[null],\"289\":[null],\"290\":[null],\"291\":[null],\"292\":[null],\"293\":[null],\"294\":[null],\"295\":[null],\"296\":[null],\"297\":[null],\"298\":[null],\"299\":[null],\"300\":[null],\"301\":[null],\"302\":[null],\"579\":[null],\"580\":[null],\"1132\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:21\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:42\",\"ModifiedUserId\":27,\"Name\":\"10.5%\",\"Value\":10.5,\"id\":1,\"syncVersion\":2},\"TaxCodeId\":1,\"TaxExempt\":null,\"TaxNumber\":\"27-17487198-7\",\"id\":37,\"syncVersion\":37},\"SupplierId\":37,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":15018,\"syncVersion\":1},{\"BookingDayId\":8226,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":55,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":56,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":57,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-50.2,\"Longitude\":-72.16,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:03\",\"ModifiedUserId\":27,\"Name\":\"El Calafate\",\"id\":5,\"syncVersion\":5},\"CityId\":5,\"CreatedUTC\":\"2020-01-09T19:49:33\",\"CreatedUserId\":10,\"Description\":\"\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":1,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":null,\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":null,\"OriginCost\":null,\"Price\":null,\"PriceModified\":null,\"SourceCost\":null,\"SourceCurrencyId\":null}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":55,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":56,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":57,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-50.2,\"Longitude\":-72.16,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:03\",\"ModifiedUserId\":27,\"Name\":\"El Calafate\",\"id\":5,\"syncVersion\":5},\"CityId\":5,\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":\"PERSON\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":null,\"Duration\":null,\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":415,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Calafate/Servicios/rompimiento-glaciar-perito-moreno-1-HD-Clarin.jpg\"},\"ImageId\":415,\"ImageURL\":null,\"Languages\":\"\",\"Lunch\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Entrada Parque de Los Glaciares \",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":300,\"Title\":\"\",\"id\":894,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":300,\"Title\":\"\",\"id\":895,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":300,\"Title\":\"\",\"id\":896,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"PERSON\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Regular\",\"PaxMin\":null,\"id\":1,\"syncVersion\":4},\"ServiceTypeId\":1,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Calle 381 436, Z9405 El Calafate, Santa Cruz\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"FERNANDEZ VIVIANA INES\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\" goosheaikeoper@gmail.com\",\"ModifiedUTC\":\"2020-07-14T14:42:26\",\"ModifiedUserId\":30,\"Name\":\"Gooshe Aike\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+5492966613164\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"283\":[null],\"284\":[null],\"285\":[null],\"286\":[null],\"287\":[null],\"288\":[null],\"289\":[null],\"290\":[null],\"291\":[null],\"292\":[null],\"293\":[null],\"294\":[null],\"295\":[null],\"296\":[null],\"297\":[null],\"298\":[null],\"299\":[null],\"300\":[null],\"301\":[null],\"302\":[null],\"579\":[null],\"580\":[null],\"1132\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:21\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:42\",\"ModifiedUserId\":27,\"Name\":\"10.5%\",\"Value\":10.5,\"id\":1,\"syncVersion\":2},\"TaxCodeId\":1,\"TaxExempt\":null,\"TaxNumber\":\"27-17487198-7\",\"id\":37,\"syncVersion\":37},\"SupplierId\":37,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":300,\"syncVersion\":4},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-09\",\"ServiceId\":300,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Calle 381 436, Z9405 El Calafate, Santa Cruz\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"FERNANDEZ VIVIANA INES\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\" goosheaikeoper@gmail.com\",\"ModifiedUTC\":\"2020-07-14T14:42:26\",\"ModifiedUserId\":30,\"Name\":\"Gooshe Aike\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+5492966613164\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"283\":[null],\"284\":[null],\"285\":[null],\"286\":[null],\"287\":[null],\"288\":[null],\"289\":[null],\"290\":[null],\"291\":[null],\"292\":[null],\"293\":[null],\"294\":[null],\"295\":[null],\"296\":[null],\"297\":[null],\"298\":[null],\"299\":[null],\"300\":[null],\"301\":[null],\"302\":[null],\"579\":[null],\"580\":[null],\"1132\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:21\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:42\",\"ModifiedUserId\":27,\"Name\":\"10.5%\",\"Value\":10.5,\"id\":1,\"syncVersion\":2},\"TaxCodeId\":1,\"TaxExempt\":null,\"TaxNumber\":\"27-17487198-7\",\"id\":37,\"syncVersion\":37},\"SupplierId\":37,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":15019,\"syncVersion\":1}],\"BookingId\":679,\"BoxLunch\":null,\"Breakfast\":true,\"City\":{},\"CityId\":null,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"DayNr\":6,\"Description\":null,\"Dinner\":null,\"EntranceIncluded\":true,\"GroupDayTo\":null,\"GroupDays\":null,\"HotelId\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":404,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Calafate/Servicios/3.png\"},\"ImageId\":404,\"ImageURL\":null,\"Lunch\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"PaxHotel\":null,\"QuoteDate\":null,\"ShowOptionals\":null,\"Snack\":null,\"SortNr\":null,\"Title\":\"Minitrekking\",\"TransDate\":\"2020-02-09\",\"id\":8226,\"syncVersion\":1},{\"BookingDayHotels\":[{\"BookingDayId\":8227,\"BookingDayRooms\":[{\"BookingDayHotelId\":11466,\"Category\":{},\"CreatedUTC\":\"2021-06-02T10:10:32\",\"CreatedUserId\":1,\"CurrencyId\":\"USD\",\"Hotel\":{\"Address\":\"Gdor. Paz 868, V9410BAR Ushuaia, Tierra del Fuego\",\"Checkin\":null,\"Checkout\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":58,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":59,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":60,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"uh\",\"CreatedUTC\":\"2020-10-06T18:18:47\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2020-10-09T13:17:53\",\"ModifiedUserId\":27,\"Name\":\"Tierra del Fuego\",\"id\":4,\"syncVersion\":2},\"CountryId\":4,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-54.48,\"Longitude\":-68.18,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:10\",\"ModifiedUserId\":27,\"Name\":\"Ushuaia\",\"id\":6,\"syncVersion\":4},\"CityId\":6,\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Email\":\"reservas@altoandinohotel.com\",\"HotelCategory\":{},\"HotelCategoryId\":null,\"HotelDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Exclusivashabitaciones &amp; departamentospara disfrutar en la ciudad más austral del mundo y sus increíbles paisajes.Nuestra ubicación es excepcional en el corazón turístico de la ciudad de Ushuaia, a metros de la avenida principal San Martin, con vistas al Canal Beagle y a la imponente Cordillera de los Andes.\\n</p>\",\"HotelId\":132,\"LanguageId\":1,\"ModifiedUTC\":\"2019-08-23T14:06:54\",\"ModifiedUserId\":1,\"id\":391,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>In the southernmost city of the world, Alto Andino invites you to enjoy unique sensations in its warmly appointed rooms and apartments, overlooking the awesome Patagonian landscapes. Just a few minutes away, you will find the most extraordinary places, where the imposing peaks of the Andes Mountain Range and the open waters of the Beagle Channel meet.\\n</p>\",\"HotelId\":132,\"LanguageId\":2,\"ModifiedUTC\":\"2019-08-23T14:06:54\",\"ModifiedUserId\":1,\"id\":392,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Camere e appartamenti esclusivi per godere nella città più meridionale del mondo e dei suoi incredibili paesaggi. La nostra posizione è eccezionale nel cuore turistico della città di Ushuaia, a pochi metri dal viale principale di San Martin, con vista sul Canale di Beagle e sull'imponente catena montuosa delle Ande.</p>\",\"HotelId\":132,\"LanguageId\":3,\"ModifiedUTC\":\"2019-08-23T14:06:54\",\"ModifiedUserId\":1,\"id\":393,\"syncVersion\":1}],\"HotelPhotos\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":132,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":1281,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Ushuaia/Hoteles/Alto%20Andino/170479437.jpg\"},\"ImageId\":1281,\"ImageURL\":null,\"ModifiedUTC\":\"2019-11-07T21:07:00\",\"ModifiedUserId\":1,\"id\":379,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":132,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":1280,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Ushuaia/Hoteles/Alto%20Andino/170474960.jpg\"},\"ImageId\":1280,\"ImageURL\":null,\"ModifiedUTC\":\"2019-11-07T21:07:00\",\"ModifiedUserId\":1,\"id\":380,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":132,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":1279,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Ushuaia/Hoteles/Alto%20Andino/170065638.jpg\"},\"ImageId\":1279,\"ImageURL\":null,\"ModifiedUTC\":\"2019-11-07T21:07:00\",\"ModifiedUserId\":1,\"id\":381,\"syncVersion\":1}],\"HotelRoomTypes\":[{\"Comment\":null,\"CreatedUTC\":\"2019-10-23T19:32:55\",\"CreatedUserId\":1,\"HotelId\":132,\"ModifiedUTC\":\"2019-11-07T21:07:00\",\"ModifiedUserId\":1,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"SGL\",\"Pax\":1,\"id\":1,\"syncVersion\":1},\"RoomTypeId\":1,\"id\":384,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2019-10-23T19:32:55\",\"CreatedUserId\":1,\"HotelId\":132,\"ModifiedUTC\":\"2019-11-07T21:07:00\",\"ModifiedUserId\":1,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"DBL\",\"Pax\":2,\"id\":2,\"syncVersion\":1},\"RoomTypeId\":2,\"id\":385,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2019-10-23T19:32:55\",\"CreatedUserId\":1,\"HotelId\":132,\"ModifiedUTC\":\"2019-11-07T21:07:00\",\"ModifiedUserId\":1,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"TPL\",\"Pax\":3,\"id\":3,\"syncVersion\":1},\"RoomTypeId\":3,\"id\":386,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2019-10-23T19:32:55\",\"CreatedUserId\":1,\"HotelId\":132,\"ModifiedUTC\":\"2019-11-07T21:07:00\",\"ModifiedUserId\":1,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"CPL\",\"Pax\":4,\"id\":6,\"syncVersion\":1},\"RoomTypeId\":6,\"id\":387,\"syncVersion\":1}],\"HotelTaxCodes\":[],\"ModifiedUTC\":\"2021-03-03T14:07:03\",\"ModifiedUserId\":20,\"Name\":\"Hotel Alto Andino\",\"Nights\":null,\"PeriodCostBy\":null,\"Phone\":\"02901 43-0920\",\"ProgramPeriodCostBy\":null,\"ProgramUnitCostBy\":null,\"RoomCategories\":[{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":132,\"ModifiedUTC\":\"2019-11-07T21:07:00\",\"ModifiedUserId\":1,\"Name\":\"Standard\",\"Program\":null,\"id\":511,\"syncVersion\":1},{\"Closed\":true,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":132,\"ModifiedUTC\":\"2019-11-07T21:07:00\",\"ModifiedUserId\":1,\"Name\":\"tandard\",\"Program\":null,\"id\":512,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":132,\"ModifiedUTC\":\"2019-11-07T21:07:00\",\"ModifiedUserId\":1,\"Name\":\"Apart \",\"Program\":null,\"id\":513,\"syncVersion\":1},{\"Closed\":true,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":132,\"ModifiedUTC\":\"2019-11-07T21:07:00\",\"ModifiedUserId\":1,\"Name\":\"Apart\",\"Program\":null,\"id\":514,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":132,\"ModifiedUTC\":\"2019-11-07T21:07:00\",\"ModifiedUserId\":1,\"Name\":\"Vista Bahía\",\"Program\":null,\"id\":515,\"syncVersion\":1},{\"Closed\":true,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":132,\"ModifiedUTC\":\"2019-11-07T21:07:00\",\"ModifiedUserId\":1,\"Name\":\"Standard\",\"Program\":null,\"id\":516,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":132,\"ModifiedUTC\":\"2019-11-07T21:07:00\",\"ModifiedUserId\":1,\"Name\":\"Master Suite\",\"Program\":null,\"id\":517,\"syncVersion\":1}],\"RoomCostBy\":\"ROOM_TYPE_CATEGORY\",\"Supplier\":{\"Address\":\"Gdor. Paz 868, V9410BAR Ushuaia, Tierra del Fuego\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"PROYECTOS HOTELEROS S.R.L.\",\"CreatedUTC\":\"2019-08-21T20:13:20\",\"CreatedUserId\":1,\"CurrencyId\":null,\"Email\":\"reservas@altoandinohotel.com\",\"ModifiedUTC\":\"2020-04-27T16:47:22\",\"ModifiedUserId\":37,\"Name\":\"Hotel Alto Andino\",\"PaymentConditionId\":null,\"PaymentTypeId\":null,\"Phone\":\".\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"HOTEL\",\"TaxBasePercent\":null,\"TaxCode\":{},\"TaxCodeId\":null,\"TaxExempt\":null,\"TaxNumber\":\"30-70913848-7\",\"id\":182,\"syncVersion\":2},\"SupplierId\":182,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:11\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:18\",\"ModifiedUserId\":27,\"Name\":\"NO GRAVADO\",\"Value\":0,\"id\":4,\"syncVersion\":2},\"TaxCodeId\":4,\"Type\":\"NORMAL\",\"UnitCostBy\":null,\"WebSite\":null,\"id\":132,\"syncVersion\":18},\"HotelCategory\":{},\"HotelCategoryId\":null,\"HotelId\":132,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Quote\":null,\"QuoteList\":{\"id\":null},\"ReservationNumber\":null,\"Room\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"DBL\",\"Pax\":2,\"id\":2,\"syncVersion\":1},\"RoomCategory\":null,\"RoomTypeId\":2,\"Rooms\":1,\"Status\":\"PENDING\",\"Supplier\":{},\"SupplierId\":null,\"id\":15030,\"syncVersion\":1}],\"Checkin\":\"2020-02-13\",\"Checkout\":\"2020-02-13\",\"City\":{\"CityDescriptions\":[{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":58,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":59,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":60,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"uh\",\"CreatedUTC\":\"2020-10-06T18:18:47\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2020-10-09T13:17:53\",\"ModifiedUserId\":27,\"Name\":\"Tierra del Fuego\",\"id\":4,\"syncVersion\":2},\"CountryId\":4,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-54.48,\"Longitude\":-68.18,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:10\",\"ModifiedUserId\":27,\"Name\":\"Ushuaia\",\"id\":6,\"syncVersion\":4},\"CityId\":6,\"CreatedUTC\":\"2021-06-02T10:10:32\",\"CreatedUserId\":1,\"Days\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":11466,\"syncVersion\":1}],\"BookingDayServices\":[{\"BookingDayId\":8227,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":55,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":56,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":57,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-50.2,\"Longitude\":-72.16,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:03\",\"ModifiedUserId\":27,\"Name\":\"El Calafate\",\"id\":5,\"syncVersion\":5},\"CityId\":5,\"CreatedUTC\":\"2020-01-09T19:49:33\",\"CreatedUserId\":10,\"Description\":\"<p>At the designated time you will have a private transfer to El Calafate airport for your flight to Ushuaia.</p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":0,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":\"30.00\",\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":null,\"Price\":42,\"SourceCost\":\"30.00\",\"SourceCurrencyId\":\"USD\"}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":55,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":56,\"syncVersion\":1},{\"CityId\":5,\"CreatedUTC\":\"2020-10-09T12:02:03\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":57,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-50.2,\"Longitude\":-72.16,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:03\",\"ModifiedUserId\":27,\"Name\":\"El Calafate\",\"id\":5,\"syncVersion\":5},\"CityId\":5,\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":null,\"Duration\":null,\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":415,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Calafate/Servicios/rompimiento-glaciar-perito-moreno-1-HD-Clarin.jpg\"},\"ImageId\":415,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":null,\"ModifiedUTC\":\"2019-09-13T17:47:45\",\"ModifiedUserId\":1,\"Name\":\"Transfer Out - sin guia\",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"A la hora apropiada, serás trasladado al aeropuerto para tomar tu vuelo.\\n\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":296,\"Title\":\"\",\"id\":882,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"At the appropriate time, you will be transferred to the airport to take your flight. \\n\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":296,\"Title\":\"\",\"id\":883,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"All'orario stabilito, sarai trasferito all'aeroporto  per prendere il volo.     \\n\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":296,\"Title\":\"\",\"id\":884,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"BASE\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-10-31T13:33:58\",\"ModifiedUserId\":1,\"Name\":\"Privado\",\"PaxMin\":null,\"id\":2,\"syncVersion\":5},\"ServiceTypeId\":2,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Calle 381 436, Z9405 El Calafate, Santa Cruz\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"FERNANDEZ VIVIANA INES\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\" goosheaikeoper@gmail.com\",\"ModifiedUTC\":\"2020-07-14T14:42:26\",\"ModifiedUserId\":30,\"Name\":\"Gooshe Aike\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+5492966613164\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"283\":[null],\"284\":[null],\"285\":[null],\"286\":[null],\"287\":[null],\"288\":[null],\"289\":[null],\"290\":[null],\"291\":[null],\"292\":[null],\"293\":[null],\"294\":[null],\"295\":[null],\"296\":[null],\"297\":[null],\"298\":[null],\"299\":[null],\"300\":[null],\"301\":[null],\"302\":[null],\"579\":[null],\"580\":[null],\"1132\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:21\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:42\",\"ModifiedUserId\":27,\"Name\":\"10.5%\",\"Value\":10.5,\"id\":1,\"syncVersion\":2},\"TaxCodeId\":1,\"TaxExempt\":null,\"TaxNumber\":\"27-17487198-7\",\"id\":37,\"syncVersion\":37},\"SupplierId\":37,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":296,\"syncVersion\":3},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-10\",\"ServiceId\":296,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Calle 381 436, Z9405 El Calafate, Santa Cruz\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"FERNANDEZ VIVIANA INES\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\" goosheaikeoper@gmail.com\",\"ModifiedUTC\":\"2020-07-14T14:42:26\",\"ModifiedUserId\":30,\"Name\":\"Gooshe Aike\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+5492966613164\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"283\":[null],\"284\":[null],\"285\":[null],\"286\":[null],\"287\":[null],\"288\":[null],\"289\":[null],\"290\":[null],\"291\":[null],\"292\":[null],\"293\":[null],\"294\":[null],\"295\":[null],\"296\":[null],\"297\":[null],\"298\":[null],\"299\":[null],\"300\":[null],\"301\":[null],\"302\":[null],\"579\":[null],\"580\":[null],\"1132\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:21\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:42\",\"ModifiedUserId\":27,\"Name\":\"10.5%\",\"Value\":10.5,\"id\":1,\"syncVersion\":2},\"TaxCodeId\":1,\"TaxExempt\":null,\"TaxNumber\":\"27-17487198-7\",\"id\":37,\"syncVersion\":37},\"SupplierId\":37,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":15020,\"syncVersion\":1},{\"BookingDayId\":8227,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":58,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":59,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":60,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"uh\",\"CreatedUTC\":\"2020-10-06T18:18:47\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2020-10-09T13:17:53\",\"ModifiedUserId\":27,\"Name\":\"Tierra del Fuego\",\"id\":4,\"syncVersion\":2},\"CountryId\":4,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-54.48,\"Longitude\":-68.18,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:10\",\"ModifiedUserId\":27,\"Name\":\"Ushuaia\",\"id\":6,\"syncVersion\":4},\"CityId\":6,\"CreatedUTC\":\"2021-06-02T10:10:32\",\"CreatedUserId\":1,\"Description\":\"<p>Upon arrival to the international airport, you will be transferred to your selected Hotel.</p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":1,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"id\":null},\"id\":null},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":58,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":59,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":60,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"uh\",\"CreatedUTC\":\"2020-10-06T18:18:47\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2020-10-09T13:17:53\",\"ModifiedUserId\":27,\"Name\":\"Tierra del Fuego\",\"id\":4,\"syncVersion\":2},\"CountryId\":4,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-54.48,\"Longitude\":-68.18,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:10\",\"ModifiedUserId\":27,\"Name\":\"Ushuaia\",\"id\":6,\"syncVersion\":4},\"CityId\":6,\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":null,\"Duration\":null,\"EntranceIncluded\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":null,\"ModifiedUTC\":\"2019-07-25T17:56:50\",\"ModifiedUserId\":1,\"Name\":\"IN o OUT con guía PVT Apt – Htl o viceversa\",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Al llegar al aeropuerto internacional, serás trasladado al Hotel seleccionado.</p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-07-25T17:56:50\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":384,\"Title\":\"\",\"id\":1146,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Upon arrival to the international airport, you will be transferred to your selected Hotel.</p>\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-07-25T17:56:50\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":384,\"Title\":\"\",\"id\":1147,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>All'arrivo all'aeroporto internazionale, sarai trasferito all'Hotel selezionato. </p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-07-25T17:56:50\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":384,\"Title\":\"\",\"id\":1148,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"BASE\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-10-31T13:33:58\",\"ModifiedUserId\":1,\"Name\":\"Privado\",\"PaxMin\":null,\"id\":2,\"syncVersion\":5},\"ServiceTypeId\":2,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Roca 136 – Ushuaia – Tierra del Fuego\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"CANAL FUN & NATURE S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"mail@canalfun.com\",\"ModifiedUTC\":\"2021-03-02T13:24:39\",\"ModifiedUserId\":20,\"Name\":\"Canal \",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"02901 431591\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"365\":[null],\"366\":[null],\"367\":[null],\"368\":[null],\"369\":[null],\"370\":[null],\"371\":[null],\"372\":[null],\"373\":[null],\"374\":[null],\"375\":[null],\"376\":[null],\"377\":[null],\"378\":[null],\"379\":[null],\"380\":[null],\"381\":[null],\"382\":[null],\"383\":[null],\"384\":[null],\"385\":[null],\"386\":[null],\"387\":[null],\"388\":[null],\"389\":[null],\"577\":[null],\"578\":[null],\"798\":[null],\"869\":[null],\"899\":[null],\"900\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:45\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:24\",\"ModifiedUserId\":27,\"Name\":\"EXENTO\",\"Value\":0,\"id\":3,\"syncVersion\":2},\"TaxCodeId\":3,\"TaxExempt\":true,\"TaxNumber\":\"30-67580660-4\",\"id\":44,\"syncVersion\":30},\"SupplierId\":44,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":384,\"syncVersion\":2},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-10\",\"ServiceId\":384,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Roca 136 – Ushuaia – Tierra del Fuego\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"CANAL FUN & NATURE S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"mail@canalfun.com\",\"ModifiedUTC\":\"2021-03-02T13:24:39\",\"ModifiedUserId\":20,\"Name\":\"Canal \",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"02901 431591\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"365\":[null],\"366\":[null],\"367\":[null],\"368\":[null],\"369\":[null],\"370\":[null],\"371\":[null],\"372\":[null],\"373\":[null],\"374\":[null],\"375\":[null],\"376\":[null],\"377\":[null],\"378\":[null],\"379\":[null],\"380\":[null],\"381\":[null],\"382\":[null],\"383\":[null],\"384\":[null],\"385\":[null],\"386\":[null],\"387\":[null],\"388\":[null],\"389\":[null],\"577\":[null],\"578\":[null],\"798\":[null],\"869\":[null],\"899\":[null],\"900\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:45\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:24\",\"ModifiedUserId\":27,\"Name\":\"EXENTO\",\"Value\":0,\"id\":3,\"syncVersion\":2},\"TaxCodeId\":3,\"TaxExempt\":true,\"TaxNumber\":\"30-67580660-4\",\"id\":44,\"syncVersion\":30},\"SupplierId\":44,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":58053,\"syncVersion\":1}],\"BookingId\":679,\"BoxLunch\":null,\"Breakfast\":true,\"City\":{},\"CityId\":null,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"DayNr\":7,\"Description\":null,\"Dinner\":null,\"EntranceIncluded\":null,\"GroupDayTo\":null,\"GroupDays\":null,\"HotelId\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-09-17T20:10:25\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-09-17T20:10:25\",\"ModifiedUserId\":1,\"Name\":null,\"id\":68,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Bariloche/Fotos%20Sistema/Bariloche%20Sist%20Ok%20%284%29.jpg\"},\"ImageId\":68,\"ImageURL\":null,\"Lunch\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"PaxHotel\":false,\"QuoteDate\":null,\"ShowOptionals\":null,\"Snack\":null,\"SortNr\":null,\"Title\":null,\"TransDate\":\"2020-02-10\",\"id\":8227,\"syncVersion\":1},{\"BookingDayHotels\":[],\"BookingDayServices\":[{\"BookingDayId\":8228,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":58,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":59,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":60,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"uh\",\"CreatedUTC\":\"2020-10-06T18:18:47\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2020-10-09T13:17:53\",\"ModifiedUserId\":27,\"Name\":\"Tierra del Fuego\",\"id\":4,\"syncVersion\":2},\"CountryId\":4,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-54.48,\"Longitude\":-68.18,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:10\",\"ModifiedUserId\":27,\"Name\":\"Ushuaia\",\"id\":6,\"syncVersion\":4},\"CityId\":6,\"CreatedUTC\":\"2021-06-02T10:10:32\",\"CreatedUserId\":1,\"Description\":\"<p>Regular tour, maximum group size 20 people.</p><p>After covering the 10 km from Ushuaia to Tierra del Fuego National Park, this tour visits its most relevant attractions. On foot, and in contact with Nature, along the undulating 8-km-long Coastal Path, this medium-difficulty hike should not pose a big challenge to those passengers used to exercise, and with the appropriate attire.</p><p>Those who prefer a less demanding activity may choose to walk along a few shorter, and softer trails (please request the “Soft Trekk” option in advance).</p><p>Near to the border of Lapataia River, lunch will be served with a great panoramic view from inside a heated dome-tent, to avoid wind or rain.</p><p>Afterwards, all participants will be equipped with rubber boots, coverpants and lifejackets: the excursion will continue from Lake Acigami aboard inflatable canoes (duckies) for about an hour through the fresh water of the Lapataia and Ovando rivers until reaching the sea in Lapataia Bay. This canoe activity ends near the point where Route 3 (also called Pan-American Highway) meet its southern end.</p><p><br></p><ul><li>Meals: Potato omelette, mediterranean pasta salad, salad of lentils, cornmeal pie. Wok stir-fried chicken and vegetables. Mineral water, soft drinks and Patagonian red wine (Malbec)</li><li>Attractive: Ensenada Bay (also known as Ensenada Zaratiegui), Beagle Canal, Lapataia Bay,</li><li>Acigami lake (formerly known as Roca lake), Ovando and Lapataia rivers.</li><li>Included: transportation, Spanish/English guides, lunch and drinks. Canoeing equipment: rubber boots, life jacket and over-pants.</li></ul><p><br></p><p><strong>Itinerary:</strong></p><p>08:00/8:30 Pick up from the hotels</p><p>09:00 Arrival to the National Park</p><p>09:30 Trekking along the Coastal path -3 hours-</p><p>12:30 Arrival to Lapataia River and lunch.</p><p>13:45 Paddling technique briefing and canoe prompting</p><p>15:15 Lapataia Bay.</p><p>15:45 Return to Ushuaia.</p><p>16:30 Arrival to Ushuaia.</p><p><br></p><p>Activities details:</p><ul><li>Hiking level: medium. 3:00 - 3:30 hs</li><li>Cumulative elevation gain: 170 mts. / 560 ft.</li><li>Altitude gain: 70 mts. / 230 ft.</li><li>Distance covered: 7 km. / 4,4 miles</li></ul><p><br></p><p><strong>Optional:</strong> “Soft Trekk”: the long hike can be replaced with some short easy paths. Ask availability in advance.</p><p><strong>Canoeing:</strong> low difficulty. If the passenger does not want to take part in the activity, the option is to go reach Lapataia Bay by bus.</p><p>Basic, recommended attire: trekking boots, waterproof jacket, warm clothing, an extra pair of socks.</p><p><br></p><p><em>**All descriptions and itineraries are for illustration purposes: the timing of the activities, and their order may vary, and this applies also to the attractions, as the actual development of the tour depends on the guide’s decisions based on the group’s specific conformation and the evaluation of the conditions for the tour.</em></p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":0,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"id\":null},\"id\":null},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":true,\"City\":{\"CityDescriptions\":[{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":58,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":59,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":60,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"uh\",\"CreatedUTC\":\"2020-10-06T18:18:47\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2020-10-09T13:17:53\",\"ModifiedUserId\":27,\"Name\":\"Tierra del Fuego\",\"id\":4,\"syncVersion\":2},\"CountryId\":4,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-54.48,\"Longitude\":-68.18,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:10\",\"ModifiedUserId\":27,\"Name\":\"Ushuaia\",\"id\":6,\"syncVersion\":4},\"CityId\":6,\"Closed\":false,\"Comment\":\"Edad minima 5 años\\nMeals: Potato omelette, mediterranean pasta salad, salad of lentils, cornmeal pie. Wok stir-fried chicken and vegetables. Mineral water, soft drinks and Patagonian red wine (Malbec) \\nIncluded: transportation, Spanish/English guides, lunch and drinks. Canoeing equipment: rubber boots, life jacket and over-pants.\\nOptional: “Soft Trekk”: the long hike can be replaced with some short easy paths. Ask availability in advance.\\nCanoeing: low difficulty. If the passenger does not want to take part in the activity, the option is to go reach Lapataia Bay by bus.\\n\",\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":\"PERSON\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":null,\"Duration\":\"FD\",\"EntranceIncluded\":true,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-09-11T17:54:15\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-09-11T17:54:15\",\"ModifiedUserId\":1,\"Name\":null,\"id\":1262,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Ushuaia/Canal%20Fun%20/CANAL_PARQUE_PANOREMADA1.jpg\"},\"ImageId\":1262,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":true,\"ModifiedUTC\":\"2020-07-24T13:23:37\",\"ModifiedUserId\":20,\"Name\":\"Parque Nacional Trekking & Canoas\",\"Navigation\":null,\"NotDescription\":null,\"Optional\":true,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>En bus se cubren los 10 Km que separan los hoteles de Ushuaia de la Senda Costera, dentro del Parque Nacional Tierra del Fuego. Se conocen los atractivos más relevantes del lugar a pie, en contacto con la naturaleza. El recorrido se considera de dificultad media. Los pasajeros que prefieran hacer caminatas de menor dificultad, pueden optar por recorrer varios senderos de menor duración (solicitar esta opción con anticipación). La caminata es amena, una invitación a conocer en detalle este paraíso recuperado, donde las montañas se pueden alcanzar desde cerca del mar, y el agua dulce de ríos y lagos convive con la costa marina. Almuerzo en carpas cerca del Lago Acigami (llamado durante un tiempo Lago Roca). La excursión continúa desde el Lago Acigami a bordo de canoas inflables (tipo duckie) flotando durante aproximadamente una hora por el agua dulce de los ríos Lapataia y Ovando hasta llegar al mar en Bahía Lapataia, casi como los Yámana hicieron durante siglos. La flotada termina en Bahía Lapataia, cerca del punto donde se anuncia el final de la ruta 3. Desde allí, se regresa al hotel en bus.\\nIncluye: pick up, almuerzo\\nDuraciòn: 8 horas\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-08-15T19:22:27\",\"ModifiedUserId\":1,\"OfferedLanguage\":true,\"Optional\":null,\"ServiceId\":369,\"Title\":\"Parque Trekking & Canoas \",\"id\":1101,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"After covering the 10 km from Ushuaia to Tierra del Fuego National Park, this tour visits its most relevant attractions. On foot, and in contact with Nature, along the undulating 8-km-long Coastal Path, this medium-difficulty hike should not pose a big challenge to those passengers used to exercise, and with the appropriate attire. Those who prefer a less demanding activity may choose to walk along a few shorter, and softer trails (please request the “Soft Trekk” option in advance). Near to the border of Lapataia River, lunch will be served with a great panoramic view from inside a heated dome-tent, to avoid wind or rain. Afterwards, all participants will be equipped with rubber boots, coverpants and lifejackets: the excursion will continue from Lake Acigami aboard inflatable canoes (duckies) for about an hour through the freshwater of the Lapataia and Ovando rivers until reaching the sea in Lapataia Bay. This canoe activity ends near the point where Route 3 (also called Pan-American Highway) meet its southern end. \\n\\n\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-08-15T19:22:27\",\"ModifiedUserId\":1,\"OfferedLanguage\":true,\"Optional\":null,\"ServiceId\":369,\"Title\":\"Park Trekking & Canoeing\",\"id\":1102,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Si percorrono 10 km in bus dall’hotel di Ushuaua alla Senda Costera, dentro il parco nazionale Tierra del Fuego. Si conoscono i posti piu attrattivi della zona a piedi, a contatto con la natura. Il percorso si considera di difficoltà media, i passeggeri che preferiscono camminate di minor difficoltà possono percorrere sentieri più brevi (chiedere questa opzione con anticipo). La camminata è piacevole, un’invito a conoscere questo paradiso recuperato dove le montagne&nbsp;sono raggiungibili dal mare e l’acqua dolce di laghi e fiumi convivono con la costa marina. Pranzo in tende vicino al lago Acigami (chiamato anche Lago Roca). L’escursione continua dal lago Acigami a bordo di canoe (tipo duckie) navigando per circa un’ora sul fiume Lapataia e Ovando fino ad arrivare alla baia Lapataia, come facevano i Yàmana durante secoli.&nbsp;Il viaggio termina nella baia Lapataia vicino al punto finale della Ruta 3. Ritorno in hotel in autobus. \\nInclude: pick up, almuerzo\\nDurata: 8 ore\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-08-15T19:22:27\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":369,\"Title\":\"Parco Trekking & Canoa\",\"id\":1103,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"PERSON\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Regular\",\"PaxMin\":null,\"id\":1,\"syncVersion\":4},\"ServiceTypeId\":1,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Roca 136 – Ushuaia – Tierra del Fuego\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"CANAL FUN & NATURE S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"mail@canalfun.com\",\"ModifiedUTC\":\"2021-03-02T13:24:39\",\"ModifiedUserId\":20,\"Name\":\"Canal \",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"02901 431591\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"365\":[null],\"366\":[null],\"367\":[null],\"368\":[null],\"369\":[null],\"370\":[null],\"371\":[null],\"372\":[null],\"373\":[null],\"374\":[null],\"375\":[null],\"376\":[null],\"377\":[null],\"378\":[null],\"379\":[null],\"380\":[null],\"381\":[null],\"382\":[null],\"383\":[null],\"384\":[null],\"385\":[null],\"386\":[null],\"387\":[null],\"388\":[null],\"389\":[null],\"577\":[null],\"578\":[null],\"798\":[null],\"869\":[null],\"899\":[null],\"900\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:45\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:24\",\"ModifiedUserId\":27,\"Name\":\"EXENTO\",\"Value\":0,\"id\":3,\"syncVersion\":2},\"TaxCodeId\":3,\"TaxExempt\":true,\"TaxNumber\":\"30-67580660-4\",\"id\":44,\"syncVersion\":30},\"SupplierId\":44,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{\"0\":true,\"1\":true,\"2\":true,\"3\":true,\"4\":true,\"5\":false,\"6\":true},\"id\":369,\"syncVersion\":16},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-11\",\"ServiceId\":369,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Roca 136 – Ushuaia – Tierra del Fuego\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"CANAL FUN & NATURE S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"mail@canalfun.com\",\"ModifiedUTC\":\"2021-03-02T13:24:39\",\"ModifiedUserId\":20,\"Name\":\"Canal \",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"02901 431591\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"365\":[null],\"366\":[null],\"367\":[null],\"368\":[null],\"369\":[null],\"370\":[null],\"371\":[null],\"372\":[null],\"373\":[null],\"374\":[null],\"375\":[null],\"376\":[null],\"377\":[null],\"378\":[null],\"379\":[null],\"380\":[null],\"381\":[null],\"382\":[null],\"383\":[null],\"384\":[null],\"385\":[null],\"386\":[null],\"387\":[null],\"388\":[null],\"389\":[null],\"577\":[null],\"578\":[null],\"798\":[null],\"869\":[null],\"899\":[null],\"900\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:45\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:24\",\"ModifiedUserId\":27,\"Name\":\"EXENTO\",\"Value\":0,\"id\":3,\"syncVersion\":2},\"TaxCodeId\":3,\"TaxExempt\":true,\"TaxNumber\":\"30-67580660-4\",\"id\":44,\"syncVersion\":30},\"SupplierId\":44,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":58054,\"syncVersion\":1},{\"BookingDayId\":8228,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":58,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":59,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":60,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"uh\",\"CreatedUTC\":\"2020-10-06T18:18:47\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2020-10-09T13:17:53\",\"ModifiedUserId\":27,\"Name\":\"Tierra del Fuego\",\"id\":4,\"syncVersion\":2},\"CountryId\":4,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-54.48,\"Longitude\":-68.18,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:10\",\"ModifiedUserId\":27,\"Name\":\"Ushuaia\",\"id\":6,\"syncVersion\":4},\"CityId\":6,\"CreatedUTC\":\"2021-06-02T10:10:32\",\"CreatedUserId\":1,\"Description\":\"\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":1,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"id\":null},\"id\":null},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":58,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":59,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":60,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"uh\",\"CreatedUTC\":\"2020-10-06T18:18:47\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2020-10-09T13:17:53\",\"ModifiedUserId\":27,\"Name\":\"Tierra del Fuego\",\"id\":4,\"syncVersion\":2},\"CountryId\":4,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-54.48,\"Longitude\":-68.18,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:10\",\"ModifiedUserId\":27,\"Name\":\"Ushuaia\",\"id\":6,\"syncVersion\":4},\"CityId\":6,\"Closed\":false,\"Comment\":\"Tarifas estimadas a confirmar por el Parque Nacional y la Estancia Harberton respectivamente.\",\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":\"PERSON\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":null,\"Duration\":null,\"EntranceIncluded\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Languages\":\"\",\"Lunch\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Entrada Parque Nacional (solo mayores de 12 años) \",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":372,\"Title\":\"\",\"id\":1110,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":372,\"Title\":\"\",\"id\":1111,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":372,\"Title\":\"\",\"id\":1112,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"PERSON\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Regular\",\"PaxMin\":null,\"id\":1,\"syncVersion\":4},\"ServiceTypeId\":1,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Roca 136 – Ushuaia – Tierra del Fuego\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"CANAL FUN & NATURE S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"mail@canalfun.com\",\"ModifiedUTC\":\"2021-03-02T13:24:39\",\"ModifiedUserId\":20,\"Name\":\"Canal \",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"02901 431591\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"365\":[null],\"366\":[null],\"367\":[null],\"368\":[null],\"369\":[null],\"370\":[null],\"371\":[null],\"372\":[null],\"373\":[null],\"374\":[null],\"375\":[null],\"376\":[null],\"377\":[null],\"378\":[null],\"379\":[null],\"380\":[null],\"381\":[null],\"382\":[null],\"383\":[null],\"384\":[null],\"385\":[null],\"386\":[null],\"387\":[null],\"388\":[null],\"389\":[null],\"577\":[null],\"578\":[null],\"798\":[null],\"869\":[null],\"899\":[null],\"900\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:45\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:24\",\"ModifiedUserId\":27,\"Name\":\"EXENTO\",\"Value\":0,\"id\":3,\"syncVersion\":2},\"TaxCodeId\":3,\"TaxExempt\":true,\"TaxNumber\":\"30-67580660-4\",\"id\":44,\"syncVersion\":30},\"SupplierId\":44,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":372,\"syncVersion\":1},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-11\",\"ServiceId\":372,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Roca 136 – Ushuaia – Tierra del Fuego\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"CANAL FUN & NATURE S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"mail@canalfun.com\",\"ModifiedUTC\":\"2021-03-02T13:24:39\",\"ModifiedUserId\":20,\"Name\":\"Canal \",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"02901 431591\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"365\":[null],\"366\":[null],\"367\":[null],\"368\":[null],\"369\":[null],\"370\":[null],\"371\":[null],\"372\":[null],\"373\":[null],\"374\":[null],\"375\":[null],\"376\":[null],\"377\":[null],\"378\":[null],\"379\":[null],\"380\":[null],\"381\":[null],\"382\":[null],\"383\":[null],\"384\":[null],\"385\":[null],\"386\":[null],\"387\":[null],\"388\":[null],\"389\":[null],\"577\":[null],\"578\":[null],\"798\":[null],\"869\":[null],\"899\":[null],\"900\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:45\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:24\",\"ModifiedUserId\":27,\"Name\":\"EXENTO\",\"Value\":0,\"id\":3,\"syncVersion\":2},\"TaxCodeId\":3,\"TaxExempt\":true,\"TaxNumber\":\"30-67580660-4\",\"id\":44,\"syncVersion\":30},\"SupplierId\":44,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":58055,\"syncVersion\":1}],\"BookingId\":679,\"BoxLunch\":null,\"Breakfast\":true,\"City\":{},\"CityId\":null,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"DayNr\":8,\"Description\":null,\"Dinner\":null,\"EntranceIncluded\":true,\"GroupDayTo\":null,\"GroupDays\":null,\"HotelId\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-12-17T12:31:31\",\"CreatedUserId\":10,\"ModifiedUTC\":\"2019-12-17T12:31:32\",\"ModifiedUserId\":10,\"Name\":\"parque y canoas\",\"id\":1259,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Ushuaia/Canal%20Fun%20/CANAL%252FPARQUE%252FREMADA10.JPG\"},\"ImageId\":1259,\"ImageURL\":null,\"Lunch\":true,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"PaxHotel\":null,\"QuoteDate\":null,\"ShowOptionals\":null,\"Snack\":false,\"SortNr\":null,\"Title\":\"Park Trekking & Canoeing\",\"TransDate\":\"2020-02-11\",\"id\":8228,\"syncVersion\":1},{\"BookingDayHotels\":[],\"BookingDayServices\":[{\"BookingDayId\":8229,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":58,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":59,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":60,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"uh\",\"CreatedUTC\":\"2020-10-06T18:18:47\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2020-10-09T13:17:53\",\"ModifiedUserId\":27,\"Name\":\"Tierra del Fuego\",\"id\":4,\"syncVersion\":2},\"CountryId\":4,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-54.48,\"Longitude\":-68.18,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:10\",\"ModifiedUserId\":27,\"Name\":\"Ushuaia\",\"id\":6,\"syncVersion\":4},\"CityId\":6,\"CreatedUTC\":\"2021-06-02T10:10:32\",\"CreatedUserId\":1,\"Description\":\"<p>Regular tour. Maximum group size 20 people.</p><p>This program is a beautiful journey into the almost uninhabited, peaceful location of the first \\\"estancia\\\" in Tierra del Fuego: Harberton Ranch. This full-day, active tour takes passengers for a ride, to navigate, to walk and to make discoveries in one of the roughest and most beautiful places in the Beagle Channel.</p><p><br></p><p>From the hotel, we leave Ushuaia Eastbound along National Route No. 3 and Route \\\"J\\\". Once at Harberton Ranch we propose to visit the Marine Mammal Museum, and the surroundings of one of the first white men settlements in Tierra del Fuego.</p><p>On board a motorboat we will leave towards Martillo Island. From the boat, we'll have the chance to see penguins in their breeding lair. Navigation on the motorboat continues up to the main attraction of the day: the enormous Gable Island, where lunch with a good Patagonian wine, soft drink and mineral water await.</p><p>After coffee, go for a hike to know more of this gorgeous island, crossing over beaver damms and through the forest to reach the Beagle Channel shore. From there take the boat to reach Puerto Harberton, and to hop on the bus to Ushuaia.</p><p><br></p><ul><li>Meals: Snacks, fish en papillote with corn pie, dessert. Drinks included: Patagonian red wine, soft-drinks, bottled water.</li><li>Attractive: Road J, Lashifashaj River, Flag Trees, Estancia Harberton, Martillo Island penguin rookery, Gable Island.</li><li>Included: transportation, Spanish/English guides, lunch and drinks.</li><li>Not included: hike among the penguins at Martillo Island (ask optional for private groups).</li></ul><p><br></p><p><strong>Itinerary:</strong></p><p>08:00 to 08:30 Pick up from the hotel.</p><p>10:30 Arrival to Harberton Ranch. Walk around main house and Museum.</p><p>12:30 Navigation bound towards the penguin rookery at Martillo Island and Gable Island.</p><p>12:50 Penguin watching</p><p>13:10 Departure towards Gable Island</p><p>13:30 Arrival and disembark on Gable Island.</p><p>13:45 Lunch</p><p>15:00 Hike around the Island.</p><p>17:00 Sailing back to Harberton Ranch on a motor boat and ride back to Ushuaia.</p><p>18:30 Arrival to Ushuaia.</p><p><br></p><p><strong>Activities details:</strong></p><ul><li>Hiking level: medium. 2:30 hs.</li><li>Cumulative elevation gain: 90 mts/295 ft.</li><li>Altitude gain: 50 mts. / 165 ft.</li><li>Distance covered: 2,5 km. / 1,5 miles</li></ul><p><br></p><p><em>**All descriptions and itineraries are for illustration purposes: the timing of the activities, and their order may vary, and this applies also to the attractions, as the actual development of the tour depends on the guide’s decisions based on the group’s specific conformation and the evaluation of the conditions for the tour.</em></p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":0,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"id\":null},\"id\":null},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":true,\"City\":{\"CityDescriptions\":[{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":58,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":59,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":60,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"uh\",\"CreatedUTC\":\"2020-10-06T18:18:47\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2020-10-09T13:17:53\",\"ModifiedUserId\":27,\"Name\":\"Tierra del Fuego\",\"id\":4,\"syncVersion\":2},\"CountryId\":4,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-54.48,\"Longitude\":-68.18,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:10\",\"ModifiedUserId\":27,\"Name\":\"Ushuaia\",\"id\":6,\"syncVersion\":4},\"CityId\":6,\"Closed\":false,\"Comment\":\"Edad minima 4 años\\n*Las excursiones que incluyen actividades en la Isla Gable deben venderse adicionando el ticket de ingreso a Harberton. Las excursiones a Gable no pueden ser reservadas\\nFECHAS QUE NO OPERAN 24, 25, 31 DIC NI EL 01 DE ENERO\\ncuando el pasajero tiene vuelo OUT ese mismo día. El fee del Parque Nacional se puede incluir en la reserva o abonarlo el pasajero el día de la excursión.\\nMeals: Snacks, fish en papillote with corn pie, dessert. Drinks included: Patagonian red wine, soft-drinks, bottled water.\\nIncluded: transportation, Spanish/English guides, lunch and drinks.\",\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":\"PERSON\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":null,\"Duration\":\"FD\",\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-09-11T18:32:30\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-09-11T18:32:30\",\"ModifiedUserId\":1,\"Name\":null,\"id\":1258,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Ushuaia/Canal%20Fun%20/6%20isla%20martillo.JPG\"},\"ImageId\":1258,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":true,\"ModifiedUTC\":\"2020-01-10T13:46:10\",\"ModifiedUserId\":8,\"Name\":\"Isla Gable & Pingüinera con Harberton PROMO\",\"Navigation\":null,\"NotDescription\":null,\"Optional\":true,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Salida desde el hotel de Ushuaia hacia el este por la Ruta Nacional Nº3. Llegada a la Estancia Harberton para visitar el Museo de Mamíferos Marinos Acatushún y los alrededores de uno de los primeros asentamientos europeos en Tierra del Fuego. Una vez termine la visita se toma un bote a motor en dirección a la Isla Martillo. Desde la embarcación se pueden avistar pingüinos en su sitio de cría. La navegación en el bote a motor continúa luego hasta la atracción principal del día: la enorme Isla Gable. Almuerzo. Se recorre la isla. En el camino se pueden mirar restos dejados atrás por la civilización Yámana y por los primeros colonos, en un paisaje infinito y primordial, mágico y extremo. El camino sigue a través de diques de castores, por el bosque y a lo largo de la costa marina se llega a la playa.&nbsp;Regreso en bote &nbsp;a Puerto Harberton para tomar el bus hacia el hotel en Ushuaia. \\nDuración: 9/10 horas \\nIncluye: Pick up, almuerzo, guía español/inglés&nbsp;\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":true,\"Optional\":null,\"ServiceId\":371,\"Title\":\"Isla Gable & Pingüinera\",\"id\":1107,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"This program is a beautiful journey into the almost uninhabited, peaceful location of the first \\\"estancia\\\" in Tierra del Fuego: Harberton Ranch. This full-day, active tour takes passengers for a ride, to navigate, to walk and to make discoveries in one of the roughest and most beautiful places in the Beagle Channel. From the hotel, we leave Ushuaia Eastbound along National Route No. 3 and Route \\\"J\\\". Once at Harberton Ranch we propose to visit the Marine Mammal Museum, and the surroundings of one of the first white men settlements in Tierra del Fuego. On board of a motorboat we will leave towards Martillo Island. From the boat, we'll have the chance to see penguins in their breeding lair. Navigation on the motorboat continues up to the main attraction of the day: the enormous Gable Island, where lunch with a good Patagonian wine, soft drink and mineral water await. After coffee, go for a hike to know more of this gorgeous island, crossing over beaver damms and through the forest to reach the Beagle Channel shore. From there take the boat to reach Puerto Harberton, and to hop on the bus to Ushuaia. \\n\\n\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":true,\"Optional\":null,\"ServiceId\":371,\"Title\":\"Gable Island & Penguin Colony \",\"id\":1108,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Si parte dall’hotel di Ushuaia in direzione est percorrendo la Ruta 3. Si arriva alla Estancia Haberton dove si visita il Museo dei Mammiferi Marini Acatushún e i dintorni di uno dei primi insediamenti europei nella Tierra del Fuego. Terminata la visita, a bordo di una barca a motore si arriva a la Isla Martillo. Durante il tragitto si possono avvistare gruppi di pinguini con i loro piccoli. Si prosegue verso l’attrazione principale della giornata: l’enorme Isla Gable. Pranzo. Si percorre l’isola. Nel cammino si possono vedere i resti lasciati dall’antica civilizzazione Yámana e dai primi coloni europei , in un paesaggio primordiale, magico ed estremo. Passando per le dighe dei castori e attraversando il bosco si raggiunge la spiaggia. Da qui ci si imbarca di nuovo verso Puerto Harberton per prendere il bus di ritorno all’hotel. \\nDurata: 9/10 ore\\nInclude: Pick up, pranzo, guida inglese/spagnolo&nbsp;\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":371,\"Title\":\"Isla Gable & Pingüinera \",\"id\":1109,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"PERSON\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Regular\",\"PaxMin\":null,\"id\":1,\"syncVersion\":4},\"ServiceTypeId\":1,\"ShowServiceType\":null,\"Snack\":false,\"Supplier\":{\"Address\":\"Roca 136 – Ushuaia – Tierra del Fuego\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"CANAL FUN & NATURE S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"mail@canalfun.com\",\"ModifiedUTC\":\"2021-03-02T13:24:39\",\"ModifiedUserId\":20,\"Name\":\"Canal \",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"02901 431591\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"365\":[null],\"366\":[null],\"367\":[null],\"368\":[null],\"369\":[null],\"370\":[null],\"371\":[null],\"372\":[null],\"373\":[null],\"374\":[null],\"375\":[null],\"376\":[null],\"377\":[null],\"378\":[null],\"379\":[null],\"380\":[null],\"381\":[null],\"382\":[null],\"383\":[null],\"384\":[null],\"385\":[null],\"386\":[null],\"387\":[null],\"388\":[null],\"389\":[null],\"577\":[null],\"578\":[null],\"798\":[null],\"869\":[null],\"899\":[null],\"900\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:45\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:24\",\"ModifiedUserId\":27,\"Name\":\"EXENTO\",\"Value\":0,\"id\":3,\"syncVersion\":2},\"TaxCodeId\":3,\"TaxExempt\":true,\"TaxNumber\":\"30-67580660-4\",\"id\":44,\"syncVersion\":30},\"SupplierId\":44,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{\"0\":true,\"1\":false,\"2\":true,\"3\":false,\"4\":true,\"5\":true,\"6\":false},\"id\":371,\"syncVersion\":8},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-12\",\"ServiceId\":371,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Roca 136 – Ushuaia – Tierra del Fuego\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"CANAL FUN & NATURE S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"mail@canalfun.com\",\"ModifiedUTC\":\"2021-03-02T13:24:39\",\"ModifiedUserId\":20,\"Name\":\"Canal \",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"02901 431591\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"365\":[null],\"366\":[null],\"367\":[null],\"368\":[null],\"369\":[null],\"370\":[null],\"371\":[null],\"372\":[null],\"373\":[null],\"374\":[null],\"375\":[null],\"376\":[null],\"377\":[null],\"378\":[null],\"379\":[null],\"380\":[null],\"381\":[null],\"382\":[null],\"383\":[null],\"384\":[null],\"385\":[null],\"386\":[null],\"387\":[null],\"388\":[null],\"389\":[null],\"577\":[null],\"578\":[null],\"798\":[null],\"869\":[null],\"899\":[null],\"900\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:45\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:24\",\"ModifiedUserId\":27,\"Name\":\"EXENTO\",\"Value\":0,\"id\":3,\"syncVersion\":2},\"TaxCodeId\":3,\"TaxExempt\":true,\"TaxNumber\":\"30-67580660-4\",\"id\":44,\"syncVersion\":30},\"SupplierId\":44,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":58056,\"syncVersion\":1},{\"BookingDayId\":8229,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":58,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":59,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":60,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"uh\",\"CreatedUTC\":\"2020-10-06T18:18:47\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2020-10-09T13:17:53\",\"ModifiedUserId\":27,\"Name\":\"Tierra del Fuego\",\"id\":4,\"syncVersion\":2},\"CountryId\":4,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-54.48,\"Longitude\":-68.18,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:10\",\"ModifiedUserId\":27,\"Name\":\"Ushuaia\",\"id\":6,\"syncVersion\":4},\"CityId\":6,\"CreatedUTC\":\"2021-06-02T10:10:32\",\"CreatedUserId\":1,\"Description\":\"\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":1,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"id\":null},\"id\":null},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":58,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":59,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":60,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"uh\",\"CreatedUTC\":\"2020-10-06T18:18:47\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2020-10-09T13:17:53\",\"ModifiedUserId\":27,\"Name\":\"Tierra del Fuego\",\"id\":4,\"syncVersion\":2},\"CountryId\":4,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-54.48,\"Longitude\":-68.18,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:10\",\"ModifiedUserId\":27,\"Name\":\"Ushuaia\",\"id\":6,\"syncVersion\":4},\"CityId\":6,\"Closed\":false,\"Comment\":\"Tarifas estimadas a confirmar por el Parque Nacional y la Estancia Harberton respectivamente.\",\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":\"PERSON\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":null,\"Duration\":null,\"EntranceIncluded\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Languages\":\"\",\"Lunch\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Entrada Estancia Harberton (solo mayores de 10 años)\",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":373,\"Title\":\"\",\"id\":1113,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":373,\"Title\":\"\",\"id\":1114,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":373,\"Title\":\"\",\"id\":1115,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"PERSON\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Regular\",\"PaxMin\":null,\"id\":1,\"syncVersion\":4},\"ServiceTypeId\":1,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Roca 136 – Ushuaia – Tierra del Fuego\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"CANAL FUN & NATURE S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"mail@canalfun.com\",\"ModifiedUTC\":\"2021-03-02T13:24:39\",\"ModifiedUserId\":20,\"Name\":\"Canal \",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"02901 431591\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"365\":[null],\"366\":[null],\"367\":[null],\"368\":[null],\"369\":[null],\"370\":[null],\"371\":[null],\"372\":[null],\"373\":[null],\"374\":[null],\"375\":[null],\"376\":[null],\"377\":[null],\"378\":[null],\"379\":[null],\"380\":[null],\"381\":[null],\"382\":[null],\"383\":[null],\"384\":[null],\"385\":[null],\"386\":[null],\"387\":[null],\"388\":[null],\"389\":[null],\"577\":[null],\"578\":[null],\"798\":[null],\"869\":[null],\"899\":[null],\"900\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:45\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:24\",\"ModifiedUserId\":27,\"Name\":\"EXENTO\",\"Value\":0,\"id\":3,\"syncVersion\":2},\"TaxCodeId\":3,\"TaxExempt\":true,\"TaxNumber\":\"30-67580660-4\",\"id\":44,\"syncVersion\":30},\"SupplierId\":44,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":373,\"syncVersion\":1},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-12\",\"ServiceId\":373,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Roca 136 – Ushuaia – Tierra del Fuego\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"CANAL FUN & NATURE S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"mail@canalfun.com\",\"ModifiedUTC\":\"2021-03-02T13:24:39\",\"ModifiedUserId\":20,\"Name\":\"Canal \",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"02901 431591\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"365\":[null],\"366\":[null],\"367\":[null],\"368\":[null],\"369\":[null],\"370\":[null],\"371\":[null],\"372\":[null],\"373\":[null],\"374\":[null],\"375\":[null],\"376\":[null],\"377\":[null],\"378\":[null],\"379\":[null],\"380\":[null],\"381\":[null],\"382\":[null],\"383\":[null],\"384\":[null],\"385\":[null],\"386\":[null],\"387\":[null],\"388\":[null],\"389\":[null],\"577\":[null],\"578\":[null],\"798\":[null],\"869\":[null],\"899\":[null],\"900\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:45\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:24\",\"ModifiedUserId\":27,\"Name\":\"EXENTO\",\"Value\":0,\"id\":3,\"syncVersion\":2},\"TaxCodeId\":3,\"TaxExempt\":true,\"TaxNumber\":\"30-67580660-4\",\"id\":44,\"syncVersion\":30},\"SupplierId\":44,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":58057,\"syncVersion\":1}],\"BookingId\":679,\"BoxLunch\":null,\"Breakfast\":true,\"City\":{},\"CityId\":null,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"DayNr\":9,\"Description\":null,\"Dinner\":null,\"EntranceIncluded\":null,\"GroupDayTo\":null,\"GroupDays\":null,\"HotelId\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-12-17T12:35:34\",\"CreatedUserId\":10,\"ModifiedUTC\":\"2019-12-17T12:35:34\",\"ModifiedUserId\":10,\"Name\":\"pinguinera\",\"id\":1271,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Ushuaia/Canal%20Fun%20/pinguinera.jpg\"},\"ImageId\":1271,\"ImageURL\":null,\"Lunch\":true,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"PaxHotel\":null,\"QuoteDate\":null,\"ShowOptionals\":null,\"Snack\":null,\"SortNr\":null,\"Title\":\"Gable Island & Penguin Colony \",\"TransDate\":\"2020-02-12\",\"id\":8229,\"syncVersion\":1},{\"BookingDayHotels\":[],\"BookingDayServices\":[{\"BookingDayId\":8230,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":58,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":59,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":60,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"uh\",\"CreatedUTC\":\"2020-10-06T18:18:47\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2020-10-09T13:17:53\",\"ModifiedUserId\":27,\"Name\":\"Tierra del Fuego\",\"id\":4,\"syncVersion\":2},\"CountryId\":4,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-54.48,\"Longitude\":-68.18,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:10\",\"ModifiedUserId\":27,\"Name\":\"Ushuaia\",\"id\":6,\"syncVersion\":4},\"CityId\":6,\"CreatedUTC\":\"2021-06-02T10:10:32\",\"CreatedUserId\":1,\"Description\":\"<p>Regular tour. Maximum group size 8 people. </p><p>Adventure, emotion and the best sights of one of the most beautiful places in Tierra del Fuego awaits North of Ushuaia. The Great 4x4 Adventure is the best way to know Fagnano Lake, the fifth in size in Argentina, while travelling challenging off road circuits with specially designed vehicles prepared to overcome almost any obstacle which might crop up while exploring alluring forests and the coast of the lake.</p><p>Leaving Ushuaia and heading towards the Garibaldi Pass across the Andes, enjoy a great lookout of the Escondido Lake, a small marvel hidden at the end of a valley. Here starts a tour running old unused roads, passing by Fagnano and Escondido Lakes. On board powerful 4x4 vehicles, the guides drive the passengers to discover the forest by impossible mud roads, roads that become paths ending at the Lake coast.</p><p>The landscape opens during the longest and more intense 4x4 tour in Tierra del Fuego. The skills of both vehicles and drivers can overcome all types of difficulties to get to an exclusive refuge in the centre of a natural environment, far away from the noise of modern life. Once in the forest close to Fagnano Lake there are free time to walk and explore while the guide prepares a typical Argentine barbecue, to be enjoyed with a Malbec wine from Patagonia to be shared with the group in a relaxed environment.</p><p><br></p><ul><li>Meals: Aperitif: marinades, cheese, olives. Choripan (grilled Argentine sausage sandwich), Argentine prime beef steaks &amp; salad. Homemade brownies. Drinks Included: Red Wine, soft-drinks, bottled water.</li><li>Attractive: Andes Range, lakes Escondido and Fagnano, Tierra Mayor Valley</li><li>Included: transportation, Spanish or English guide, lunch and drinks.</li><li>Vehicle: Agrale Marrua: 7 passengers + 1 guide/driver / Land Rover Defender: 6 passengers + 1 guide/driver.</li></ul><p><br></p><p><strong>Itinerary:</strong></p><p>8:30/9:00 Pick-Up from the hotel.</p><p>10:30 Garibaldi Pass across the Andes.</p><p>11:00 Escondido Lake.</p><p>11:30 Off-Roading</p><p>12:30 Snack</p><p>13:00 More Off-Roading.</p><p>14:00 Fagnano Lake. Arrival to the refuge. Lunch.</p><p>16:00 Return to Ushuaia.</p><p>18:00 Arrival.</p><p><br></p><p><strong>Activities details:</strong></p><ul><li>Hiking Optional: easy. 15 minutes.</li><li>Distance covered: 700 meters.</li></ul><p><br></p><p>Basic, recommended attire: trekking boots, waterproof jacket, warm clothing.</p><p><br></p><p><em>**All descriptions and itineraries are for illustration purposes: the timing of the activities, and their order may vary, and this applies also to the attractions, as the actual development of the tour depends on the guide’s decisions based on the group’s specific conformation and the evaluation of the conditions for the tour.</em></p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":0,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"id\":null},\"id\":null},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":58,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":59,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":60,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"uh\",\"CreatedUTC\":\"2020-10-06T18:18:47\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2020-10-09T13:17:53\",\"ModifiedUserId\":27,\"Name\":\"Tierra del Fuego\",\"id\":4,\"syncVersion\":2},\"CountryId\":4,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-54.48,\"Longitude\":-68.18,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:10\",\"ModifiedUserId\":27,\"Name\":\"Ushuaia\",\"id\":6,\"syncVersion\":4},\"CityId\":6,\"Closed\":false,\"Comment\":\"- Comida: Picada de escabeches, aceitunas y quesos. Choripan, bifes de chorizo con ensaladas. Brownies caseros. Bebidas incluidas: agua mineral, gaseosa, vino tinto Malbec Patagónico.\\n- Meals: Aperitif: marinades, cheese, olives. Choripan (grilled Argentine sausage sandwich), Argentine prime beef steaks & salad. Homemade brownies. Drinks Included: Red Wine, soft-drinks, bottled water.\",\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":\"PERSON\",\"CreatedUTC\":\"2019-12-17T13:50:05\",\"CreatedUserId\":8,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":null,\"Duration\":\"FD\",\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-12-17T12:43:58\",\"CreatedUserId\":10,\"ModifiedUTC\":\"2019-12-17T12:43:59\",\"ModifiedUserId\":10,\"Name\":\"Great Adventure 4 x 4 (1)\",\"id\":1264,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Ushuaia/Canal%20Fun%20/great%20adventure%204%20x%204%202%20.jpg\"},\"ImageId\":1264,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":true,\"ModifiedUTC\":\"2020-01-10T13:58:18\",\"ModifiedUserId\":8,\"Name\":\"Gran Aventura 4x4 \",\"Navigation\":null,\"NotDescription\":null,\"Optional\":true,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":\"2019-12-17T13:50:05\",\"CreatedUserId\":8,\"Description\":\"<p>Salida desde Ushuaia hacia el paso cordillerano Garibaldi, desde donde se avistará el Lago Escondido, una pequeña maravilla oculta en el fondo de un valle. Desde ahí comienza un recorrido por antiguos caminos en desuso, pasando por el Lago Escondido y llegando al Lago Fagnano. A bordo de vehículos 4x4 el conductor, experto en técnicas de manejo por terrenos desafiantes, lo llevará a descubrir el bosque por caminos imposibles de barro; caminos que se transforman en huella y huellas que terminan en la costa del lago. El paisaje se va abriendo a medida que se avanza durante las casi dos horas del más intenso y extenso 4x4 de Tierra del Fuego. Llegarás a un refugio exclusivo ubicado en medio de un ambiente natural, lejos de los ruidos de la vida moderna. En el bosque cercano a la costa del Fagnano se cuenta con tiempo libre para caminar y explorar mientras el guía prepara un típico asado argentino, acompañado de un malbec patagónico que se comparte en un ambiente relajado.\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-12-17T15:01:54\",\"ModifiedUserId\":8,\"OfferedLanguage\":true,\"Optional\":null,\"ServiceId\":899,\"Title\":\"Gran Aventura 4x4\",\"id\":2691,\"syncVersion\":1},{\"CreatedUTC\":\"2019-12-17T13:50:05\",\"CreatedUserId\":8,\"Description\":\"<p>Adventure, emotion and the best sights of one of the most beautiful places in Tierra del Fuego awaits North of Ushuaia. The Great 4x4 Adventure is the best way to know Fagnano Lake, the fifth in size in Argentina, while travelling challenging off road circuits with specially designed vehicles prepared to overcome almost any obstacle which might crop up while exploring alluring forests and the coast of the lake. Leaving Ushuaia and heading towards the Garibaldi Pass across the Andes, enjoy a great lookout of the Escondido Lake, a small marvel hidden at the end of a valley. Here starts a tour running old unused roads, passing by Fagnano and Escondido Lakes. On board powerful 4x4 vehicles, the guides drive the passengers to discover the forest by impossible mud roads, roads that become paths ending at the Lake coast. The landscape opens during the longest and more intense 4x4 tour in Tierra del Fuego. The skills of both vehicles and drivers can overcome all types of difficulties to get to an exclusive refuge in the centre of a natural environment, far away from the noise of modern life. Once in the forest close to Fagnano Lake there are free time to walk and explore while the guide prepares a typical Argentine barbecue, to be enjoyed with a Malbec wine from Patagonia to be shared with the group in a relaxed environment.\\n\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-12-17T15:01:54\",\"ModifiedUserId\":8,\"OfferedLanguage\":true,\"Optional\":null,\"ServiceId\":899,\"Title\":\"Great 4x4 Adventure\",\"id\":2692,\"syncVersion\":1},{\"CreatedUTC\":\"2019-12-17T13:50:05\",\"CreatedUserId\":8,\"Description\":\"<p>La Grande Avventura 4x4 è il modo migliore per conoscere il Lago di Fagnano, il quinto in Argentina, viaggiando su impegnativi circuiti fuoristrada con veicoli appositamente progettati pronti a superare quasi tutti gli ostacoli che potrebbero sorgere esplorando foreste e la costa del lago. Lasciando Ushuaia e dirigendoci verso il Passo Garibaldi attraverso le Ande, si avrà una splendida vista sul Lago Escondido, una piccola meraviglia nascosta alla fine di una valle. Qui inizia un tour che percorre vecchie strade inutilizzate, passando per i laghi di Fagnano e Escondido. A bordo di veicoli 4x4, le guide guidano i passeggeri alla scoperta della foresta attraverso impossibili strade di fango, strade che diventano percorsi che finiscono sulla costa del lago. Si arriverà a un rifugio al centro di un ambiente naturale, lontano dai rumori della vita moderna. Una volta arrivati nella foresta vicino al Lago di Fagnano ci sarà tempo libero per passeggiare ed esplorare mentre la guida prepara un tipico barbecue argentino, da gustare con un vino Malbec della Patagonia da condividere con il gruppo in un ambiente rilassato.\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-12-17T15:01:54\",\"ModifiedUserId\":8,\"OfferedLanguage\":null,\"Optional\":null,\"ServiceId\":899,\"Title\":\"Grande Avventura 4x4  \",\"id\":2693,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"PERSON\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Regular\",\"PaxMin\":null,\"id\":1,\"syncVersion\":4},\"ServiceTypeId\":1,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Roca 136 – Ushuaia – Tierra del Fuego\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"CANAL FUN & NATURE S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"mail@canalfun.com\",\"ModifiedUTC\":\"2021-03-02T13:24:39\",\"ModifiedUserId\":20,\"Name\":\"Canal \",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"02901 431591\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"365\":[null],\"366\":[null],\"367\":[null],\"368\":[null],\"369\":[null],\"370\":[null],\"371\":[null],\"372\":[null],\"373\":[null],\"374\":[null],\"375\":[null],\"376\":[null],\"377\":[null],\"378\":[null],\"379\":[null],\"380\":[null],\"381\":[null],\"382\":[null],\"383\":[null],\"384\":[null],\"385\":[null],\"386\":[null],\"387\":[null],\"388\":[null],\"389\":[null],\"577\":[null],\"578\":[null],\"798\":[null],\"869\":[null],\"899\":[null],\"900\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:45\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:24\",\"ModifiedUserId\":27,\"Name\":\"EXENTO\",\"Value\":0,\"id\":3,\"syncVersion\":2},\"TaxCodeId\":3,\"TaxExempt\":true,\"TaxNumber\":\"30-67580660-4\",\"id\":44,\"syncVersion\":30},\"SupplierId\":44,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":899,\"syncVersion\":4},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-13\",\"ServiceId\":899,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Roca 136 – Ushuaia – Tierra del Fuego\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"CANAL FUN & NATURE S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"mail@canalfun.com\",\"ModifiedUTC\":\"2021-03-02T13:24:39\",\"ModifiedUserId\":20,\"Name\":\"Canal \",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"02901 431591\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"365\":[null],\"366\":[null],\"367\":[null],\"368\":[null],\"369\":[null],\"370\":[null],\"371\":[null],\"372\":[null],\"373\":[null],\"374\":[null],\"375\":[null],\"376\":[null],\"377\":[null],\"378\":[null],\"379\":[null],\"380\":[null],\"381\":[null],\"382\":[null],\"383\":[null],\"384\":[null],\"385\":[null],\"386\":[null],\"387\":[null],\"388\":[null],\"389\":[null],\"577\":[null],\"578\":[null],\"798\":[null],\"869\":[null],\"899\":[null],\"900\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:45\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:24\",\"ModifiedUserId\":27,\"Name\":\"EXENTO\",\"Value\":0,\"id\":3,\"syncVersion\":2},\"TaxCodeId\":3,\"TaxExempt\":true,\"TaxNumber\":\"30-67580660-4\",\"id\":44,\"syncVersion\":30},\"SupplierId\":44,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":58058,\"syncVersion\":1}],\"BookingId\":679,\"BoxLunch\":null,\"Breakfast\":true,\"City\":{},\"CityId\":null,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"DayNr\":10,\"Description\":null,\"Dinner\":null,\"EntranceIncluded\":null,\"GroupDayTo\":null,\"GroupDays\":null,\"HotelId\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-12-17T12:43:58\",\"CreatedUserId\":10,\"ModifiedUTC\":\"2019-12-17T12:43:59\",\"ModifiedUserId\":10,\"Name\":\"Great Adventure 4 x 4 (1)\",\"id\":1264,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Ushuaia/Canal%20Fun%20/great%20adventure%204%20x%204%202%20.jpg\"},\"ImageId\":1264,\"ImageURL\":null,\"Lunch\":true,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"PaxHotel\":null,\"QuoteDate\":null,\"ShowOptionals\":null,\"Snack\":null,\"SortNr\":null,\"Title\":\"Great 4x4 Adventure\",\"TransDate\":\"2020-02-13\",\"id\":8230,\"syncVersion\":1},{\"BookingDayHotels\":[{\"BookingDayId\":8231,\"BookingDayRooms\":[{\"BookingDayHotelId\":11467,\"Category\":{},\"CreatedUTC\":\"2021-06-02T10:10:32\",\"CreatedUserId\":1,\"CurrencyId\":null,\"Hotel\":{\"Address\":\"Juan Manuel de Rosas 625, San Carlos de Bariloche, Río Negro\",\"Checkin\":null,\"Checkout\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":49,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":50,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":51,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-41.15,\"Longitude\":-71.3,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:01:47\",\"ModifiedUserId\":27,\"Name\":\"Bariloche\",\"id\":3,\"syncVersion\":3},\"CityId\":3,\"Closed\":false,\"Comment\":\"Incluyen: copa de Bienvenida, desayuno Buffet Americano, acceso a Kénos Spa (piscina\\nclimatizada, utilización del sauna seco y húmedo, duchas escocesas e hidromasaje),\\nestacionamiento e internet wifi.\\nMenores: Los menores de 2 años se alojarán sin cargo en habitación con cuna. De 3 años abonan\\nalojamiento como un adulto.\\n*Las Cenas de Nochebuena (USD 75)  y Año Nuevo (USD 99)  son por persona. Menores de 12 años 50% y menores de\\n3 años sin cargo.\",\"Commision\":null,\"CommisionPrice\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Email\":\"reservas@hotelinacayal.com.ar\",\"HotelCategory\":{},\"HotelCategoryId\":null,\"HotelDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>A la orilla del Lago Nahuel Huapi, este sofisticado hotel dentro del Parque Nacional Nahuel Huapi se encuentra a 9 minutos a pie de las exposiciones de historia local del Museo de laPatagonia.</p><p>Las habitaciones refinadas disponen de pantalla plana, Wi-Fi y minibar. Muchas de ellas tienen vistas al lago; las suites y las habitaciones de categoría superior también incluyen bañera de hidromasaje y algunas cuentan con balcón. Servicio de habitaciones disponible.</p>\",\"HotelId\":75,\"LanguageId\":1,\"ModifiedUTC\":\"2019-08-23T14:06:54\",\"ModifiedUserId\":1,\"id\":220,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>This sophisticated hotel is located within the Nahuel Huapi National Park, just on the shores of Lake. It´s 9 minutes walking to the Museum of Patagonia. The refined rooms have flat screen, Wi-Fi and minibar. Many of them have view to the lake; Suites and upgraded rooms also include a spa bath and some have a balcony. Room service available.</p>\",\"HotelId\":75,\"LanguageId\":2,\"ModifiedUTC\":\"2019-08-23T14:06:54\",\"ModifiedUserId\":1,\"id\":221,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Sulle rive del Lago Nahuel Huapi, questo hotel sofisticato all'interno del Parco Nazionale Nahuel Huapi dista 9 minuti a piedi dalle mostre di storia locale del Museo della Patagonia.</p><p>Le raffinate camere sono dotate di schermo piatto, Wi-Fi e minibar. Molti di loro hanno una vista sul lago; Le suite e le camere di categoria superiore includono anche una vasca idromassaggio e alcune vantano un balcone. Servizio in camera disponibile.</p>\",\"HotelId\":75,\"LanguageId\":3,\"ModifiedUTC\":\"2019-08-23T14:06:54\",\"ModifiedUserId\":1,\"id\":222,\"syncVersion\":1}],\"HotelPhotos\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":75,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":77,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Bariloche/Hoteles/Cacique%20Inacayal/40402787.jpg\"},\"ImageId\":77,\"ImageURL\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":211,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":75,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":78,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Bariloche/Hoteles/Cacique%20Inacayal/48115121.jpg\"},\"ImageId\":78,\"ImageURL\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":212,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":75,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":79,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Bariloche/Hoteles/Cacique%20Inacayal/48115146.jpg\"},\"ImageId\":79,\"ImageURL\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":213,\"syncVersion\":1}],\"HotelRoomTypes\":[{\"Comment\":null,\"CreatedUTC\":\"2019-10-23T19:32:54\",\"CreatedUserId\":1,\"HotelId\":75,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"SGL\",\"Pax\":1,\"id\":1,\"syncVersion\":1},\"RoomTypeId\":1,\"id\":196,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2019-10-23T19:32:54\",\"CreatedUserId\":1,\"HotelId\":75,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"DBL\",\"Pax\":2,\"id\":2,\"syncVersion\":1},\"RoomTypeId\":2,\"id\":197,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2019-10-23T19:32:54\",\"CreatedUserId\":1,\"HotelId\":75,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":true,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"CAMA EXTRA\",\"Pax\":1,\"id\":5,\"syncVersion\":3},\"RoomTypeId\":5,\"id\":198,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2019-10-25T12:54:14\",\"CreatedUserId\":1,\"HotelId\":75,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"TPL\",\"Pax\":3,\"id\":3,\"syncVersion\":1},\"RoomTypeId\":3,\"id\":744,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2020-01-21T19:21:09\",\"CreatedUserId\":8,\"HotelId\":75,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"CPL\",\"Pax\":4,\"id\":6,\"syncVersion\":1},\"RoomTypeId\":6,\"id\":1122,\"syncVersion\":1}],\"HotelTaxCodes\":[],\"ModifiedUTC\":\"2021-02-19T15:09:20\",\"ModifiedUserId\":20,\"Name\":\"Cacique Inacayal Lake & Spa Hotel\",\"Nights\":null,\"PeriodCostBy\":null,\"Phone\":\"0294 443-3888\",\"ProgramPeriodCostBy\":null,\"ProgramUnitCostBy\":null,\"RoomCategories\":[{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":75,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Economy\",\"Program\":null,\"id\":293,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":75,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Standard\",\"Program\":null,\"id\":294,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":75,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Superior\",\"Program\":null,\"id\":295,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":75,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Superior Corner\",\"Program\":null,\"id\":296,\"syncVersion\":1},{\"Closed\":true,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":75,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Standard\",\"Program\":null,\"id\":297,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":75,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Grand Confort\",\"Program\":null,\"id\":298,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":75,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Junior Suite\",\"Program\":null,\"id\":299,\"syncVersion\":1}],\"RoomCostBy\":\"ROOM_TYPE_CATEGORY\",\"Supplier\":{\"Address\":\"Juan Manuel de Rosas 625, San Carlos de Bariloche, Río Negro\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"CASTION S.A.\",\"CreatedUTC\":\"2019-08-21T20:13:20\",\"CreatedUserId\":1,\"CurrencyId\":null,\"Email\":\"reservas@hotelinacayal.com.ar\",\"ModifiedUTC\":\"2020-04-27T15:28:25\",\"ModifiedUserId\":37,\"Name\":\"Cacique Inacayal Lake & Spa Hotel\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"0294 443-3888\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"HOTEL\",\"TaxBasePercent\":99,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:33\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:04\",\"ModifiedUserId\":27,\"Name\":\"TUR IVA\",\"Value\":0,\"id\":5,\"syncVersion\":3},\"TaxCodeId\":5,\"TaxExempt\":null,\"TaxNumber\":\"30-65937352-8\",\"id\":125,\"syncVersion\":3},\"SupplierId\":125,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:33\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:04\",\"ModifiedUserId\":27,\"Name\":\"TUR IVA\",\"Value\":0,\"id\":5,\"syncVersion\":3},\"TaxCodeId\":5,\"Type\":\"NORMAL\",\"UnitCostBy\":null,\"WebSite\":null,\"id\":75,\"syncVersion\":17},\"HotelCategory\":{},\"HotelCategoryId\":null,\"HotelId\":75,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Quote\":null,\"QuoteList\":{\"id\":null},\"ReservationNumber\":null,\"Room\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"DBL\",\"Pax\":2,\"id\":2,\"syncVersion\":1},\"RoomCategory\":null,\"RoomTypeId\":2,\"Rooms\":1,\"Status\":\"PENDING\",\"Supplier\":{},\"SupplierId\":null,\"id\":15031,\"syncVersion\":1}],\"Checkin\":\"2020-02-10\",\"Checkout\":\"2020-02-10\",\"City\":{\"CityDescriptions\":[{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":49,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":50,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":51,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-41.15,\"Longitude\":-71.3,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:01:47\",\"ModifiedUserId\":27,\"Name\":\"Bariloche\",\"id\":3,\"syncVersion\":3},\"CityId\":3,\"CreatedUTC\":\"2021-06-02T10:10:32\",\"CreatedUserId\":1,\"Days\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":11467,\"syncVersion\":1}],\"BookingDayServices\":[{\"BookingDayId\":8231,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":58,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":59,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":60,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"uh\",\"CreatedUTC\":\"2020-10-06T18:18:47\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2020-10-09T13:17:53\",\"ModifiedUserId\":27,\"Name\":\"Tierra del Fuego\",\"id\":4,\"syncVersion\":2},\"CountryId\":4,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-54.48,\"Longitude\":-68.18,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:10\",\"ModifiedUserId\":27,\"Name\":\"Ushuaia\",\"id\":6,\"syncVersion\":4},\"CityId\":6,\"CreatedUTC\":\"2021-06-02T10:10:32\",\"CreatedUserId\":1,\"Description\":\"<p>Upon arrival to the international airport, you will be transferred to your selected Hotel.</p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":0,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"id\":null},\"id\":null},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":58,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":59,\"syncVersion\":1},{\"CityId\":6,\"CreatedUTC\":\"2020-10-09T12:02:10\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":60,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"uh\",\"CreatedUTC\":\"2020-10-06T18:18:47\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2020-10-09T13:17:53\",\"ModifiedUserId\":27,\"Name\":\"Tierra del Fuego\",\"id\":4,\"syncVersion\":2},\"CountryId\":4,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-54.48,\"Longitude\":-68.18,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:10\",\"ModifiedUserId\":27,\"Name\":\"Ushuaia\",\"id\":6,\"syncVersion\":4},\"CityId\":6,\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":null,\"Duration\":null,\"EntranceIncluded\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":null,\"ModifiedUTC\":\"2019-07-25T17:56:50\",\"ModifiedUserId\":1,\"Name\":\"IN o OUT con guía PVT Apt – Htl o viceversa\",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Al llegar al aeropuerto internacional, serás trasladado al Hotel seleccionado.</p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-07-25T17:56:50\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":384,\"Title\":\"\",\"id\":1146,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Upon arrival to the international airport, you will be transferred to your selected Hotel.</p>\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-07-25T17:56:50\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":384,\"Title\":\"\",\"id\":1147,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>All'arrivo all'aeroporto internazionale, sarai trasferito all'Hotel selezionato. </p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-07-25T17:56:50\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":384,\"Title\":\"\",\"id\":1148,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"BASE\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-10-31T13:33:58\",\"ModifiedUserId\":1,\"Name\":\"Privado\",\"PaxMin\":null,\"id\":2,\"syncVersion\":5},\"ServiceTypeId\":2,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Roca 136 – Ushuaia – Tierra del Fuego\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"CANAL FUN & NATURE S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"mail@canalfun.com\",\"ModifiedUTC\":\"2021-03-02T13:24:39\",\"ModifiedUserId\":20,\"Name\":\"Canal \",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"02901 431591\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"365\":[null],\"366\":[null],\"367\":[null],\"368\":[null],\"369\":[null],\"370\":[null],\"371\":[null],\"372\":[null],\"373\":[null],\"374\":[null],\"375\":[null],\"376\":[null],\"377\":[null],\"378\":[null],\"379\":[null],\"380\":[null],\"381\":[null],\"382\":[null],\"383\":[null],\"384\":[null],\"385\":[null],\"386\":[null],\"387\":[null],\"388\":[null],\"389\":[null],\"577\":[null],\"578\":[null],\"798\":[null],\"869\":[null],\"899\":[null],\"900\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:45\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:24\",\"ModifiedUserId\":27,\"Name\":\"EXENTO\",\"Value\":0,\"id\":3,\"syncVersion\":2},\"TaxCodeId\":3,\"TaxExempt\":true,\"TaxNumber\":\"30-67580660-4\",\"id\":44,\"syncVersion\":30},\"SupplierId\":44,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":384,\"syncVersion\":2},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-14\",\"ServiceId\":384,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Roca 136 – Ushuaia – Tierra del Fuego\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"CANAL FUN & NATURE S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"mail@canalfun.com\",\"ModifiedUTC\":\"2021-03-02T13:24:39\",\"ModifiedUserId\":20,\"Name\":\"Canal \",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"02901 431591\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"365\":[null],\"366\":[null],\"367\":[null],\"368\":[null],\"369\":[null],\"370\":[null],\"371\":[null],\"372\":[null],\"373\":[null],\"374\":[null],\"375\":[null],\"376\":[null],\"377\":[null],\"378\":[null],\"379\":[null],\"380\":[null],\"381\":[null],\"382\":[null],\"383\":[null],\"384\":[null],\"385\":[null],\"386\":[null],\"387\":[null],\"388\":[null],\"389\":[null],\"577\":[null],\"578\":[null],\"798\":[null],\"869\":[null],\"899\":[null],\"900\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:45\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:24\",\"ModifiedUserId\":27,\"Name\":\"EXENTO\",\"Value\":0,\"id\":3,\"syncVersion\":2},\"TaxCodeId\":3,\"TaxExempt\":true,\"TaxNumber\":\"30-67580660-4\",\"id\":44,\"syncVersion\":30},\"SupplierId\":44,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":58059,\"syncVersion\":1},{\"BookingDayId\":8231,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":49,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":50,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":51,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-41.15,\"Longitude\":-71.3,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:01:47\",\"ModifiedUserId\":27,\"Name\":\"Bariloche\",\"id\":3,\"syncVersion\":3},\"CityId\":3,\"CreatedUTC\":\"2021-06-02T10:10:32\",\"CreatedUserId\":1,\"Description\":\"<p>Welcome to the Lake District!</p><p>Upon arrival in Bariloche a private transfer will be waiting for you to take you to your hotel.</p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":1,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"id\":null},\"id\":null},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":49,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":50,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":51,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-41.15,\"Longitude\":-71.3,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:01:47\",\"ModifiedUserId\":27,\"Name\":\"Bariloche\",\"id\":3,\"syncVersion\":3},\"CityId\":3,\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":null,\"Duration\":null,\"EntranceIncluded\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":null,\"ModifiedUTC\":\"2020-01-09T20:31:55\",\"ModifiedUserId\":8,\"Name\":\"Transfer Hotel desde km3 a km12 - APT (SIN GUIA)\",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>A la hora apropiada, serás trasladado al aeropuerto internacional, para tomar tu vuelo.&nbsp;\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-07-25T15:11:49\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":235,\"Title\":\"\",\"id\":699,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>At appropriate time, you will be transferred to the international airport, to take your flight.&nbsp;\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-07-25T15:11:49\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":235,\"Title\":\"\",\"id\":700,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>All'orario stabilito, sarai trasferito all'aeroporto internazionale per prendere il volo.</p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-07-25T15:11:49\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":235,\"Title\":\"\",\"id\":701,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"BASE\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-10-31T13:33:58\",\"ModifiedUserId\":1,\"Name\":\"Privado\",\"PaxMin\":null,\"id\":2,\"syncVersion\":5},\"ServiceTypeId\":2,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Elflein 89 of. 6, Bariloche, Río Negro, Argentina.\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"A REMARLA SRL\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"operaciones@kawenadventure.com\",\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Kawen\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"0054 - 294 - 15 4578084\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Camioneta\",\"ParentId\":33,\"ParentType\":\"SUPPLIER\",\"id\":90,\"syncVersion\":38},{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Auto\",\"ParentId\":33,\"ParentType\":\"SUPPLIER\",\"id\":91,\"syncVersion\":38}],\"ServiceCategoriesByService\":{\"228\":[null],\"229\":[null],\"230\":[null],\"231\":[null],\"232\":[90,91],\"233\":[90,91],\"234\":[90,91],\"235\":[90,91],\"236\":[90,91],\"237\":[90,91],\"238\":[90,91],\"239\":[90,91],\"240\":[null],\"241\":[90,91],\"242\":[90,91],\"243\":[90,91],\"244\":[90,91],\"245\":[90,91],\"246\":[90,91],\"247\":[90,91],\"248\":[90,91],\"772\":[null],\"936\":[null],\"965\":[null],\"966\":[null],\"1193\":[null],\"1196\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:21\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:42\",\"ModifiedUserId\":27,\"Name\":\"10.5%\",\"Value\":10.5,\"id\":1,\"syncVersion\":2},\"TaxCodeId\":1,\"TaxExempt\":null,\"TaxNumber\":\"30-71532406-3\",\"id\":33,\"syncVersion\":42},\"SupplierId\":33,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":235,\"syncVersion\":6},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-14\",\"ServiceId\":235,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Elflein 89 of. 6, Bariloche, Río Negro, Argentina.\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"A REMARLA SRL\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"operaciones@kawenadventure.com\",\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Kawen\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"0054 - 294 - 15 4578084\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Camioneta\",\"ParentId\":33,\"ParentType\":\"SUPPLIER\",\"id\":90,\"syncVersion\":38},{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Auto\",\"ParentId\":33,\"ParentType\":\"SUPPLIER\",\"id\":91,\"syncVersion\":38}],\"ServiceCategoriesByService\":{\"228\":[null],\"229\":[null],\"230\":[null],\"231\":[null],\"232\":[90,91],\"233\":[90,91],\"234\":[90,91],\"235\":[90,91],\"236\":[90,91],\"237\":[90,91],\"238\":[90,91],\"239\":[90,91],\"240\":[null],\"241\":[90,91],\"242\":[90,91],\"243\":[90,91],\"244\":[90,91],\"245\":[90,91],\"246\":[90,91],\"247\":[90,91],\"248\":[90,91],\"772\":[null],\"936\":[null],\"965\":[null],\"966\":[null],\"1193\":[null],\"1196\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:21\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:42\",\"ModifiedUserId\":27,\"Name\":\"10.5%\",\"Value\":10.5,\"id\":1,\"syncVersion\":2},\"TaxCodeId\":1,\"TaxExempt\":null,\"TaxNumber\":\"30-71532406-3\",\"id\":33,\"syncVersion\":42},\"SupplierId\":33,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":58060,\"syncVersion\":1}],\"BookingId\":679,\"BoxLunch\":null,\"Breakfast\":true,\"City\":{},\"CityId\":null,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"DayNr\":11,\"Description\":null,\"Dinner\":null,\"EntranceIncluded\":false,\"GroupDayTo\":null,\"GroupDays\":null,\"HotelId\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-09-17T20:10:25\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-09-17T20:10:25\",\"ModifiedUserId\":1,\"Name\":null,\"id\":68,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Bariloche/Fotos%20Sistema/Bariloche%20Sist%20Ok%20%284%29.jpg\"},\"ImageId\":68,\"ImageURL\":null,\"Lunch\":false,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"PaxHotel\":false,\"QuoteDate\":null,\"ShowOptionals\":null,\"Snack\":null,\"SortNr\":null,\"Title\":\"Park Trekking & Canoeing\",\"TransDate\":\"2020-02-14\",\"id\":8231,\"syncVersion\":1},{\"BookingDayHotels\":[],\"BookingDayServices\":[{\"BookingDayId\":8233,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":49,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":50,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":51,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-41.15,\"Longitude\":-71.3,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:01:47\",\"ModifiedUserId\":27,\"Name\":\"Bariloche\",\"id\":3,\"syncVersion\":3},\"CityId\":3,\"CreatedUTC\":\"2021-06-02T10:10:32\",\"CreatedUserId\":1,\"Description\":\"<p>This nautical activity allows you to enjoy an unforgettable experience from the conjunction of air, water and land, in a private sailing boat in which the captain transmits the magic of this adventure to the participants.</p><p>Transfers are included.</p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":0,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"id\":null},\"id\":null},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":49,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":50,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":51,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-41.15,\"Longitude\":-71.3,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:01:47\",\"ModifiedUserId\":27,\"Name\":\"Bariloche\",\"id\":3,\"syncVersion\":3},\"CityId\":3,\"Closed\":false,\"Comment\":\"- Incluido: TRASLADOS GUIA, Snack y bebidas.\",\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":null,\"CreatedUTC\":\"2020-01-07T14:51:24\",\"CreatedUserId\":8,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":null,\"Duration\":\"3-4 hs \",\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-07T15:06:12\",\"CreatedUserId\":8,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":125,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Bariloche/Servicios/Kawen/navegacion-vela-nahuel-huapi-4.jpg\"},\"ImageId\":125,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":null,\"ModifiedUTC\":\"2020-01-07T15:06:15\",\"ModifiedUserId\":8,\"Name\":\"Navegación en velero - Lago Nahuel Huapi \",\"Navigation\":null,\"NotDescription\":null,\"Optional\":true,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":\"2020-01-07T14:51:24\",\"CreatedUserId\":8,\"Description\":\"<p>Esta actividad náutica te permite disfrutar de una experiencia inolvidable desde la conjunción de aire, agua y tierra, en un velero privado en el que el capitán transmite la magia de esta aventura a los participantes.\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"OfferedLanguage\":true,\"Optional\":null,\"ServiceId\":965,\"Title\":\"Navegación en velero - Lago Nahuel Huapi\",\"id\":2889,\"syncVersion\":1},{\"CreatedUTC\":\"2020-01-07T14:51:24\",\"CreatedUserId\":8,\"Description\":\"<p>This nautical activity allows you to enjoy an unforgettable experience from the conjunction of air, water and land, in a private sailing boat in which the captain transmits the magic of this adventure to the participants.\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"OfferedLanguage\":true,\"Optional\":null,\"ServiceId\":965,\"Title\":\"Sailing trip in Nahuel Huapi Lake \",\"id\":2890,\"syncVersion\":1},{\"CreatedUTC\":\"2020-01-07T14:51:24\",\"CreatedUserId\":8,\"Description\":\"<p><br></p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"OfferedLanguage\":null,\"Optional\":null,\"ServiceId\":965,\"Title\":\"\",\"id\":2891,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"BASE\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-10-31T13:33:58\",\"ModifiedUserId\":1,\"Name\":\"Privado\",\"PaxMin\":null,\"id\":2,\"syncVersion\":5},\"ServiceTypeId\":2,\"ShowServiceType\":null,\"Snack\":true,\"Supplier\":{\"Address\":\"Elflein 89 of. 6, Bariloche, Río Negro, Argentina.\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"A REMARLA SRL\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"operaciones@kawenadventure.com\",\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Kawen\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"0054 - 294 - 15 4578084\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Camioneta\",\"ParentId\":33,\"ParentType\":\"SUPPLIER\",\"id\":90,\"syncVersion\":38},{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Auto\",\"ParentId\":33,\"ParentType\":\"SUPPLIER\",\"id\":91,\"syncVersion\":38}],\"ServiceCategoriesByService\":{\"228\":[null],\"229\":[null],\"230\":[null],\"231\":[null],\"232\":[90,91],\"233\":[90,91],\"234\":[90,91],\"235\":[90,91],\"236\":[90,91],\"237\":[90,91],\"238\":[90,91],\"239\":[90,91],\"240\":[null],\"241\":[90,91],\"242\":[90,91],\"243\":[90,91],\"244\":[90,91],\"245\":[90,91],\"246\":[90,91],\"247\":[90,91],\"248\":[90,91],\"772\":[null],\"936\":[null],\"965\":[null],\"966\":[null],\"1193\":[null],\"1196\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:21\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:42\",\"ModifiedUserId\":27,\"Name\":\"10.5%\",\"Value\":10.5,\"id\":1,\"syncVersion\":2},\"TaxCodeId\":1,\"TaxExempt\":null,\"TaxNumber\":\"30-71532406-3\",\"id\":33,\"syncVersion\":42},\"SupplierId\":33,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":965,\"syncVersion\":3},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-15\",\"ServiceId\":965,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Elflein 89 of. 6, Bariloche, Río Negro, Argentina.\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"A REMARLA SRL\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"operaciones@kawenadventure.com\",\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Kawen\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"0054 - 294 - 15 4578084\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Camioneta\",\"ParentId\":33,\"ParentType\":\"SUPPLIER\",\"id\":90,\"syncVersion\":38},{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Auto\",\"ParentId\":33,\"ParentType\":\"SUPPLIER\",\"id\":91,\"syncVersion\":38}],\"ServiceCategoriesByService\":{\"228\":[null],\"229\":[null],\"230\":[null],\"231\":[null],\"232\":[90,91],\"233\":[90,91],\"234\":[90,91],\"235\":[90,91],\"236\":[90,91],\"237\":[90,91],\"238\":[90,91],\"239\":[90,91],\"240\":[null],\"241\":[90,91],\"242\":[90,91],\"243\":[90,91],\"244\":[90,91],\"245\":[90,91],\"246\":[90,91],\"247\":[90,91],\"248\":[90,91],\"772\":[null],\"936\":[null],\"965\":[null],\"966\":[null],\"1193\":[null],\"1196\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:21\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:42\",\"ModifiedUserId\":27,\"Name\":\"10.5%\",\"Value\":10.5,\"id\":1,\"syncVersion\":2},\"TaxCodeId\":1,\"TaxExempt\":null,\"TaxNumber\":\"30-71532406-3\",\"id\":33,\"syncVersion\":42},\"SupplierId\":33,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":58061,\"syncVersion\":1}],\"BookingId\":679,\"BoxLunch\":null,\"Breakfast\":true,\"City\":{},\"CityId\":null,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"DayNr\":12,\"Description\":null,\"Dinner\":null,\"EntranceIncluded\":null,\"GroupDayTo\":null,\"GroupDays\":null,\"HotelId\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-07T15:06:12\",\"CreatedUserId\":8,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":125,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Bariloche/Servicios/Kawen/navegacion-vela-nahuel-huapi-4.jpg\"},\"ImageId\":125,\"ImageURL\":null,\"Lunch\":false,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"PaxHotel\":false,\"QuoteDate\":null,\"ShowOptionals\":null,\"Snack\":true,\"SortNr\":null,\"Title\":\"Sailing trip in Nahuel Huapi Lake \",\"TransDate\":\"2020-02-15\",\"id\":8233,\"syncVersion\":1},{\"BookingDayHotels\":[],\"BookingDayServices\":[{\"BookingDayId\":8232,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":49,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":50,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":51,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-41.15,\"Longitude\":-71.3,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:01:47\",\"ModifiedUserId\":27,\"Name\":\"Bariloche\",\"id\":3,\"syncVersion\":3},\"CityId\":3,\"CreatedUTC\":\"2021-06-02T10:10:32\",\"CreatedUserId\":1,\"Description\":\"<p>An active way to get to know the most classic circuit of San Carlos de Bariloche, joined by a guide explaining the story of this city. Going across the most important viewpoints of the area like Campanario Hill and Llao-Llao Peninsula there are also amazing views of Lakes Moreno and Nahuel Huapi and the mountains Capilla and Lopez.\\nBy the end of this day the cooking class takes place at Gilbert ́s Brewery and beer tasting as well. Finally there is a typical argentinian dinner to enjoy: fernet, empanada, main course, dessert.\\n</p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":0,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"id\":null},\"id\":null},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":49,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":50,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":51,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-41.15,\"Longitude\":-71.3,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:01:47\",\"ModifiedUserId\":27,\"Name\":\"Bariloche\",\"id\":3,\"syncVersion\":3},\"CityId\":3,\"Closed\":false,\"Comment\":\"Almuerzo. Charla y degustacion en Fabrica de Cerveza. Bebidas incluidas.\\nOpcional a la excurcion: se puede incluir una clase de yoga en un entorno natural, realizar el almuerzo \\\"puertas afuera\\\" (Almuerzo Campestre) o sorpresa musical.\\n# Incluyen en los traslados y excursiones el servicio de guía, un profesional con dominio del idioma español, inglés o portugués. Los servicios en italiano, alemán, ruso o francés tienen el mismo precio pero están sujetos a disponibilidad de guías en esos idiomas. En todos los casos se debe especificar al momento de realizar la reserva el idioma necesario para el servicio.\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t\",\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":null,\"Duration\":\"5-6 horas\",\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-01T19:06:01\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-11-01T19:06:02\",\"ModifiedUserId\":1,\"Name\":null,\"id\":121,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Bariloche/Servicios/Kawen/DSC_0026.jpg\"},\"ImageId\":121,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":true,\"ModifiedUTC\":\"2020-03-11T13:22:34\",\"ModifiedUserId\":8,\"Name\":\"Historia y Naturaleza\",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p><span style=\\\"color: rgb(31, 78, 121);\\\">Un recorrido dinámico por el circuito más clásico de San Carlos de Bariloche, acompañado por un guía. Se visitan los puntos panorámicos más famosos de la zona como el Cerro Campanario (subida en aerosilla) y el Hotel Llao-Llao desde el cual se aprecian increíbles vistas de los lagos Moreno y Nahuel Huapi y de los Cerros López y Capilla. Luego se realiza una caminata de interpretación natural por el increíble bosque nativo del Parque Municipal Llao-Llao. Para el final del dìa, se visita una Fábrica de Cerveza Artesanal donde se realiza una degustación de cerveza.</span></p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":true,\"Optional\":null,\"ServiceId\":228,\"Title\":\"Historia y Naturaleza \",\"id\":678,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"An active way to get to know the most classic circuit of San Carlos de Bariloche, joined by a guide explaining the story of this city. Going across the most important viewpoints of the area like Campanario Hill and Llao-Llao Peninsula there are also amazing views of Lakes Moreno and Nahuel Huapi and the mountains Capilla and Lopez.\\nThen, you will do a nature oriented walk through the impressive native forest in the Llao-llao Nature Park to finish with an interesting visit at a local microbrewery where you ́ll have lunch with beer tasting.\\n\\n\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":true,\"Optional\":null,\"ServiceId\":228,\"Title\":\"History & Nature \",\"id\":679,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Un tour dinamico del circuito più classico di San Carlos de Bariloche, accompagnato da una guida. È possibile visitare i punti panoramici più famosi della zona come il Cerro Campanario (salita in seggiovia) e l'Hotel Llao-Llao da cui si possono vedere incredibili panorami dei laghi Moreno e Nahuel Huapi e le colline di López e Capilla. Successivamente si farà una passeggiata di interpretazione della natura nell'incredibile foresta nativa del Parco Municipale Llao-Llao. Alla fine della giornata, si visiterà una fabbrica di birra artigianale dove farà una degustazione di birra.\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-08-20T16:08:25\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":228,\"Title\":\"Storia e Natura \",\"id\":680,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"BASE\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-10-31T13:33:58\",\"ModifiedUserId\":1,\"Name\":\"Privado\",\"PaxMin\":null,\"id\":2,\"syncVersion\":5},\"ServiceTypeId\":2,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Elflein 89 of. 6, Bariloche, Río Negro, Argentina.\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"A REMARLA SRL\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"operaciones@kawenadventure.com\",\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Kawen\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"0054 - 294 - 15 4578084\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Camioneta\",\"ParentId\":33,\"ParentType\":\"SUPPLIER\",\"id\":90,\"syncVersion\":38},{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Auto\",\"ParentId\":33,\"ParentType\":\"SUPPLIER\",\"id\":91,\"syncVersion\":38}],\"ServiceCategoriesByService\":{\"228\":[null],\"229\":[null],\"230\":[null],\"231\":[null],\"232\":[90,91],\"233\":[90,91],\"234\":[90,91],\"235\":[90,91],\"236\":[90,91],\"237\":[90,91],\"238\":[90,91],\"239\":[90,91],\"240\":[null],\"241\":[90,91],\"242\":[90,91],\"243\":[90,91],\"244\":[90,91],\"245\":[90,91],\"246\":[90,91],\"247\":[90,91],\"248\":[90,91],\"772\":[null],\"936\":[null],\"965\":[null],\"966\":[null],\"1193\":[null],\"1196\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:21\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:42\",\"ModifiedUserId\":27,\"Name\":\"10.5%\",\"Value\":10.5,\"id\":1,\"syncVersion\":2},\"TaxCodeId\":1,\"TaxExempt\":null,\"TaxNumber\":\"30-71532406-3\",\"id\":33,\"syncVersion\":42},\"SupplierId\":33,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":228,\"syncVersion\":9},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-16\",\"ServiceId\":228,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Elflein 89 of. 6, Bariloche, Río Negro, Argentina.\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"A REMARLA SRL\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"operaciones@kawenadventure.com\",\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Kawen\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"0054 - 294 - 15 4578084\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Camioneta\",\"ParentId\":33,\"ParentType\":\"SUPPLIER\",\"id\":90,\"syncVersion\":38},{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Auto\",\"ParentId\":33,\"ParentType\":\"SUPPLIER\",\"id\":91,\"syncVersion\":38}],\"ServiceCategoriesByService\":{\"228\":[null],\"229\":[null],\"230\":[null],\"231\":[null],\"232\":[90,91],\"233\":[90,91],\"234\":[90,91],\"235\":[90,91],\"236\":[90,91],\"237\":[90,91],\"238\":[90,91],\"239\":[90,91],\"240\":[null],\"241\":[90,91],\"242\":[90,91],\"243\":[90,91],\"244\":[90,91],\"245\":[90,91],\"246\":[90,91],\"247\":[90,91],\"248\":[90,91],\"772\":[null],\"936\":[null],\"965\":[null],\"966\":[null],\"1193\":[null],\"1196\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:21\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:42\",\"ModifiedUserId\":27,\"Name\":\"10.5%\",\"Value\":10.5,\"id\":1,\"syncVersion\":2},\"TaxCodeId\":1,\"TaxExempt\":null,\"TaxNumber\":\"30-71532406-3\",\"id\":33,\"syncVersion\":42},\"SupplierId\":33,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":58062,\"syncVersion\":1},{\"BookingDayId\":8232,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":49,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":50,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":51,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-41.15,\"Longitude\":-71.3,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:01:47\",\"ModifiedUserId\":27,\"Name\":\"Bariloche\",\"id\":3,\"syncVersion\":3},\"CityId\":3,\"CreatedUTC\":\"2021-06-02T10:10:32\",\"CreatedUserId\":1,\"Description\":null,\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Entrada Parque Nacional Nahuel Huapi\",\"OrderNr\":1,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Cost\":null,\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":null,\"OriginCost\":null,\"Price\":null,\"PriceModified\":null,\"SourceCost\":null,\"SourceCurrencyId\":null,\"_cache\":{},\"_computedGetters\":{},\"_id\":\"c084bd80-c38a-11eb-9381-e5bccee460c4\",\"_loaded\":true,\"fieldOptions\":{},\"fields\":[{\"name\":\"Base\"},{\"name\":\"Cost\"},{\"defValue\":true,\"name\":\"Include\"},{\"name\":\"Markup\"},{\"name\":\"OriginCost\"},{\"name\":\"Price\"},{\"name\":\"SourceCost\"},{\"name\":\"SourceCurrencyId\"},{\"defValue\":false,\"name\":\"Modified\"},{\"defValue\":false,\"name\":\"MarkupModified\"}],\"invalid\":{},\"tableSpec\":null},\"_cache\":{},\"_computedGetters\":{},\"_id\":\"c0838500-c38a-11eb-9381-e5bccee460c4\",\"_loaded\":true,\"fieldOptions\":{},\"fields\":[],\"invalid\":{},\"tableSpec\":null},\"id\":null},\"id\":null},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-16\",\"ServiceId\":null,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Elflein 89 of. 6, Bariloche, Río Negro, Argentina.\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"A REMARLA SRL\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"operaciones@kawenadventure.com\",\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Kawen\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"0054 - 294 - 15 4578084\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Camioneta\",\"ParentId\":33,\"ParentType\":\"SUPPLIER\",\"id\":90,\"syncVersion\":38},{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Auto\",\"ParentId\":33,\"ParentType\":\"SUPPLIER\",\"id\":91,\"syncVersion\":38}],\"ServiceCategoriesByService\":{\"228\":[null],\"229\":[null],\"230\":[null],\"231\":[null],\"232\":[90,91],\"233\":[90,91],\"234\":[90,91],\"235\":[90,91],\"236\":[90,91],\"237\":[90,91],\"238\":[90,91],\"239\":[90,91],\"240\":[null],\"241\":[90,91],\"242\":[90,91],\"243\":[90,91],\"244\":[90,91],\"245\":[90,91],\"246\":[90,91],\"247\":[90,91],\"248\":[90,91],\"772\":[null],\"936\":[null],\"965\":[null],\"966\":[null],\"1193\":[null],\"1196\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:21\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:42\",\"ModifiedUserId\":27,\"Name\":\"10.5%\",\"Value\":10.5,\"id\":1,\"syncVersion\":2},\"TaxCodeId\":1,\"TaxExempt\":null,\"TaxNumber\":\"30-71532406-3\",\"id\":33,\"syncVersion\":42},\"SupplierId\":33,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":58063,\"syncVersion\":1}],\"BookingId\":679,\"BoxLunch\":null,\"Breakfast\":true,\"City\":{},\"CityId\":null,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"DayNr\":13,\"Description\":null,\"Dinner\":null,\"EntranceIncluded\":true,\"GroupDayTo\":null,\"GroupDays\":null,\"HotelId\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-12-27T13:54:43\",\"CreatedUserId\":10,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Historia & Naturaleza 1\",\"id\":122,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Bariloche/Servicios/Kawen/Historia%20%26%20Naturaleza%201.jpg\"},\"ImageId\":122,\"ImageURL\":null,\"Lunch\":true,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"PaxHotel\":null,\"QuoteDate\":null,\"ShowOptionals\":null,\"Snack\":null,\"SortNr\":null,\"Title\":\"History & Nature \",\"TransDate\":\"2020-02-16\",\"id\":8232,\"syncVersion\":1},{\"BookingDayHotels\":[{\"BookingDayId\":8234,\"BookingDayRooms\":[{\"BookingDayHotelId\":2532,\"Category\":{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":\"2019-11-14T17:26:27\",\"CreatedUserId\":31,\"HotelId\":257,\"ModifiedUTC\":\"2019-11-14T17:35:49\",\"ModifiedUserId\":31,\"Name\":\"SUITE 2 PAX\",\"Program\":null,\"id\":990,\"syncVersion\":1},\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"CurrencyId\":\"USD\",\"Hotel\":{\"Address\":\"Medrano 2272, Chacras de Coria, Mendoza, Argentina\",\"Checkin\":null,\"Checkout\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":64,\"syncVersion\":1},{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":65,\"syncVersion\":1},{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":66,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-32.9,\"Longitude\":-68.85,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:23\",\"ModifiedUserId\":27,\"Name\":\"Mendoza\",\"id\":8,\"syncVersion\":3},\"CityId\":8,\"Closed\":false,\"Comment\":null,\"Commision\":15,\"CommisionPrice\":true,\"CreatedUTC\":\"2019-11-14T16:06:11\",\"CreatedUserId\":31,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Email\":\"info@casaglebinias.com\",\"HotelCategory\":{},\"HotelCategoryId\":null,\"HotelDescriptions\":[{\"CreatedUTC\":\"2019-11-14T16:06:11\",\"CreatedUserId\":31,\"Description\":\"<p>Acogedor hotel atendido por sus dueños, al pie de los Andes, en uno de los Caminos del Vino y próximo a importantes centros culturales, comerciales, gastronómicos y deportivos. Su estilo campestre y obras de arte originales, se integran con la colorida vegetación de un extenso parque, creando un clima confortable, intimista y elegante. Para garantizar la privacidad, tanto la casa principal que incluye los espacios comunes, como las cuatro unidades de alojamientos conformadas por 2 casitas y 5 suites, son independientes. Desde la recepción se aprecia el cálido salón de estar, extendido hacia la cocina abierta y la amplia galería vidriada donde se sirven comidas y bebidas. Esta, a su vez, se proyecta sobre el parque y la piscina con el fondo de la cordillera.La cava subterránea, conectada a esta galería, contiene una selección de vinos locales, que incluye nuestras propias etiquetas.\\n\\n</p>\",\"HotelId\":257,\"LanguageId\":1,\"ModifiedUTC\":\"2019-11-14T17:20:12\",\"ModifiedUserId\":31,\"id\":766,\"syncVersion\":1},{\"CreatedUTC\":\"2019-11-14T16:06:11\",\"CreatedUserId\":31,\"Description\":\"<p>Cozy hotel attended by its owners, at the foot of the Andes, in one of the Wine Roads and close to important cultural, commercial, gastronomic and sports centers. Its country style and original works of art are integrated with the colorful vegetation of an extensive park, creating a comfortable, intimate and elegant climate. To guarantee privacy, both the main house that includes the common spaces, and the four accommodation units consisting of 2 casitas and 5 suites, are independent. From the reception you can see the warm living room, extended to the open kitchen and the large glass gallery where food and drinks are served. This, in turn, is projected on the park and the pool with the bottom of the mountain range.The underground cellar, connected to this gallery, contains a selection of local wines, which includes our own labels.\\n</p>\",\"HotelId\":257,\"LanguageId\":2,\"ModifiedUTC\":\"2019-11-14T17:20:12\",\"ModifiedUserId\":31,\"id\":767,\"syncVersion\":1},{\"CreatedUTC\":\"2019-11-14T16:06:11\",\"CreatedUserId\":31,\"Description\":\"<p>Accogliente hotel frequentato dai proprietari, ai piedi delle Ande, in una delle strade del vino e vicino a importanti centri culturali, commerciali, gastronomici e sportivi. Il suo stile country e le sue opere d'arte originali si integrano con la colorata vegetazione di un vasto parco, creando un clima confortevole, intimo ed elegante. Per garantire la privacy, sia la casa principale che comprende gli spazi comuni, sia le quattro unità abitative composte da 2 casitas e 5 suite, sono indipendenti. Dalla reception è possibile vedere il caldo soggiorno, esteso alla cucina aperta e alla grande galleria di vetro dove vengono serviti cibi e bevande. Questo, a sua volta, è proiettato sul parco e sulla piscina con il fondo della catena montuosa. La cantina sotterranea, collegata a questa galleria, contiene una selezione di vini locali, che include le nostre etichette.\\n</p>\",\"HotelId\":257,\"LanguageId\":3,\"ModifiedUTC\":\"2019-11-14T17:20:12\",\"ModifiedUserId\":31,\"id\":768,\"syncVersion\":1}],\"HotelPhotos\":[{\"CreatedUTC\":\"2019-11-14T17:35:49\",\"CreatedUserId\":31,\"HotelId\":257,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-14T17:33:52\",\"CreatedUserId\":31,\"ModifiedUTC\":\"2019-11-14T17:33:53\",\"ModifiedUserId\":31,\"Name\":null,\"id\":790,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Mendoza/Hoteles/CASA%20GLEBINAS/GLEBINAS%202.jpg\"},\"ImageId\":790,\"ImageURL\":null,\"ModifiedUTC\":\"2019-11-14T17:40:04\",\"ModifiedUserId\":31,\"id\":752,\"syncVersion\":1},{\"CreatedUTC\":\"2019-11-14T17:35:49\",\"CreatedUserId\":31,\"HotelId\":257,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-14T17:34:35\",\"CreatedUserId\":31,\"ModifiedUTC\":\"2019-11-14T17:34:36\",\"ModifiedUserId\":31,\"Name\":null,\"id\":789,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Mendoza/Hoteles/CASA%20GLEBINAS/GLEBINAS%201.jpg\"},\"ImageId\":789,\"ImageURL\":null,\"ModifiedUTC\":\"2019-11-14T17:40:04\",\"ModifiedUserId\":31,\"id\":753,\"syncVersion\":1},{\"CreatedUTC\":\"2019-11-14T17:35:49\",\"CreatedUserId\":31,\"HotelId\":257,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-14T17:35:06\",\"CreatedUserId\":31,\"ModifiedUTC\":\"2019-11-14T17:35:07\",\"ModifiedUserId\":31,\"Name\":null,\"id\":791,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Mendoza/Hoteles/CASA%20GLEBINAS/GLEBINAS%203.jpg\"},\"ImageId\":791,\"ImageURL\":null,\"ModifiedUTC\":\"2019-11-14T17:40:04\",\"ModifiedUserId\":31,\"id\":754,\"syncVersion\":1},{\"CreatedUTC\":\"2019-11-14T17:35:49\",\"CreatedUserId\":31,\"HotelId\":257,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-14T17:35:45\",\"CreatedUserId\":31,\"ModifiedUTC\":\"2019-11-14T17:35:45\",\"ModifiedUserId\":31,\"Name\":null,\"id\":792,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Mendoza/Hoteles/CASA%20GLEBINAS/GLEBINAS%204.jpg\"},\"ImageId\":792,\"ImageURL\":null,\"ModifiedUTC\":\"2019-11-14T17:40:04\",\"ModifiedUserId\":31,\"id\":755,\"syncVersion\":1}],\"HotelRoomTypes\":[{\"Comment\":null,\"CreatedUTC\":\"2019-11-14T17:35:49\",\"CreatedUserId\":31,\"HotelId\":257,\"ModifiedUTC\":\"2019-11-14T17:40:04\",\"ModifiedUserId\":31,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"DBL\",\"Pax\":2,\"id\":2,\"syncVersion\":1},\"RoomTypeId\":2,\"id\":854,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2019-11-14T17:35:49\",\"CreatedUserId\":31,\"HotelId\":257,\"ModifiedUTC\":\"2019-11-14T17:40:04\",\"ModifiedUserId\":31,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"TPL\",\"Pax\":3,\"id\":3,\"syncVersion\":1},\"RoomTypeId\":3,\"id\":855,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2019-11-14T17:35:49\",\"CreatedUserId\":31,\"HotelId\":257,\"ModifiedUTC\":\"2019-11-14T17:40:04\",\"ModifiedUserId\":31,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"CPL\",\"Pax\":4,\"id\":6,\"syncVersion\":1},\"RoomTypeId\":6,\"id\":856,\"syncVersion\":1}],\"HotelTaxCodes\":[],\"ModifiedUTC\":\"2020-07-06T14:33:23\",\"ModifiedUserId\":20,\"Name\":\"Casa Glebinias Hotel Jardin\",\"Nights\":null,\"PeriodCostBy\":null,\"Phone\":\"+54  0261 496 2116 \",\"ProgramPeriodCostBy\":null,\"ProgramUnitCostBy\":null,\"RoomCategories\":[{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":\"2019-11-14T17:26:27\",\"CreatedUserId\":31,\"HotelId\":257,\"ModifiedUTC\":\"2019-11-14T17:35:49\",\"ModifiedUserId\":31,\"Name\":\"SUITE 2 PAX\",\"Program\":null,\"id\":990,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":\"2019-11-14T17:26:27\",\"CreatedUserId\":31,\"HotelId\":257,\"ModifiedUTC\":\"2019-11-14T17:35:49\",\"ModifiedUserId\":31,\"Name\":\"SUITE 3 PAX\",\"Program\":null,\"id\":991,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":\"2019-11-14T17:26:27\",\"CreatedUserId\":31,\"HotelId\":257,\"ModifiedUTC\":\"2019-11-14T17:35:49\",\"ModifiedUserId\":31,\"Name\":\"CASITA DOS DORMITORIOS 2 PAX \",\"Program\":null,\"id\":992,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":\"2019-11-14T17:26:27\",\"CreatedUserId\":31,\"HotelId\":257,\"ModifiedUTC\":\"2019-11-14T17:35:49\",\"ModifiedUserId\":31,\"Name\":\"CASITA DOS DOMITORIOS 3 PAX \",\"Program\":null,\"id\":993,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":\"2019-11-14T17:26:27\",\"CreatedUserId\":31,\"HotelId\":257,\"ModifiedUTC\":\"2019-11-14T17:35:49\",\"ModifiedUserId\":31,\"Name\":\"CASITA DOS DORMITORIOS 4 PAX\",\"Program\":null,\"id\":994,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":\"2019-11-14T17:26:27\",\"CreatedUserId\":31,\"HotelId\":257,\"ModifiedUTC\":\"2019-11-14T17:35:49\",\"ModifiedUserId\":31,\"Name\":\"CASITA DOS DORMITORIOS 5 PAX \",\"Program\":null,\"id\":995,\"syncVersion\":1}],\"RoomCostBy\":\"ROOM_TYPE_CATEGORY\",\"Supplier\":{\"Address\":\"Medrano 2272, Chacras de Coria, Mendoza, Argentina\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"ARISTARAIN ALBERTO JOSE\",\"CreatedUTC\":\"2019-11-14T17:48:32\",\"CreatedUserId\":31,\"CurrencyId\":null,\"Email\":\"info@casaglebinias.com\",\"ModifiedUTC\":\"2020-04-27T18:48:02\",\"ModifiedUserId\":37,\"Name\":\"Casa Glebinias Hotel Jardin\",\"PaymentConditionId\":null,\"PaymentTypeId\":null,\"Phone\":\".\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"HOTEL\",\"TaxBasePercent\":null,\"TaxCode\":{},\"TaxCodeId\":null,\"TaxExempt\":null,\"TaxNumber\":\"20-04400600-7\",\"id\":339,\"syncVersion\":2},\"SupplierId\":339,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:33\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:04\",\"ModifiedUserId\":27,\"Name\":\"TUR IVA\",\"Value\":0,\"id\":5,\"syncVersion\":3},\"TaxCodeId\":5,\"Type\":\"NORMAL\",\"UnitCostBy\":null,\"WebSite\":null,\"id\":257,\"syncVersion\":11},\"HotelCategory\":{},\"HotelCategoryId\":null,\"HotelId\":257,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Quote\":null,\"QuoteList\":{\"0\":{\"Cost\":null,\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":null,\"OriginCost\":null,\"Price\":399,\"PriceModified\":null,\"SourceCost\":null,\"SourceCurrencyId\":null}},\"ReservationNumber\":null,\"Room\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"DBL\",\"Pax\":2,\"id\":2,\"syncVersion\":1},\"RoomCategory\":990,\"RoomTypeId\":2,\"Rooms\":1,\"Status\":\"PENDING\",\"Supplier\":{},\"SupplierId\":null,\"id\":2809,\"syncVersion\":1}],\"Checkin\":\"2020-02-17\",\"Checkout\":\"2020-02-17\",\"City\":{\"CityDescriptions\":[{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":64,\"syncVersion\":1},{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":65,\"syncVersion\":1},{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":66,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-32.9,\"Longitude\":-68.85,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:23\",\"ModifiedUserId\":27,\"Name\":\"Mendoza\",\"id\":8,\"syncVersion\":3},\"CityId\":8,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"Days\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":2532,\"syncVersion\":1}],\"BookingDayServices\":[{\"BookingDayId\":8234,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":49,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":50,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":51,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-41.15,\"Longitude\":-71.3,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:01:47\",\"ModifiedUserId\":27,\"Name\":\"Bariloche\",\"id\":3,\"syncVersion\":3},\"CityId\":3,\"CreatedUTC\":\"2021-06-02T10:10:32\",\"CreatedUserId\":1,\"Description\":\"<p>At the designated time you will have a private transfer to Bariloche airport for your flight to Mendoza.\\n</p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":0,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"id\":null},\"id\":null},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":49,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":50,\"syncVersion\":1},{\"CityId\":3,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":51,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-41.15,\"Longitude\":-71.3,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:01:47\",\"ModifiedUserId\":27,\"Name\":\"Bariloche\",\"id\":3,\"syncVersion\":3},\"CityId\":3,\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":null,\"Duration\":null,\"EntranceIncluded\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":null,\"ModifiedUTC\":\"2020-01-09T20:31:55\",\"ModifiedUserId\":8,\"Name\":\"Transfer Hotel desde km3 a km12 - APT (SIN GUIA)\",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>A la hora apropiada, serás trasladado al aeropuerto internacional, para tomar tu vuelo.&nbsp;\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-07-25T15:11:49\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":235,\"Title\":\"\",\"id\":699,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>At appropriate time, you will be transferred to the international airport, to take your flight.&nbsp;\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-07-25T15:11:49\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":235,\"Title\":\"\",\"id\":700,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>All'orario stabilito, sarai trasferito all'aeroporto internazionale per prendere il volo.</p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-07-25T15:11:49\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":235,\"Title\":\"\",\"id\":701,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"BASE\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-10-31T13:33:58\",\"ModifiedUserId\":1,\"Name\":\"Privado\",\"PaxMin\":null,\"id\":2,\"syncVersion\":5},\"ServiceTypeId\":2,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Elflein 89 of. 6, Bariloche, Río Negro, Argentina.\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"A REMARLA SRL\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"operaciones@kawenadventure.com\",\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Kawen\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"0054 - 294 - 15 4578084\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Camioneta\",\"ParentId\":33,\"ParentType\":\"SUPPLIER\",\"id\":90,\"syncVersion\":38},{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Auto\",\"ParentId\":33,\"ParentType\":\"SUPPLIER\",\"id\":91,\"syncVersion\":38}],\"ServiceCategoriesByService\":{\"228\":[null],\"229\":[null],\"230\":[null],\"231\":[null],\"232\":[90,91],\"233\":[90,91],\"234\":[90,91],\"235\":[90,91],\"236\":[90,91],\"237\":[90,91],\"238\":[90,91],\"239\":[90,91],\"240\":[null],\"241\":[90,91],\"242\":[90,91],\"243\":[90,91],\"244\":[90,91],\"245\":[90,91],\"246\":[90,91],\"247\":[90,91],\"248\":[90,91],\"772\":[null],\"936\":[null],\"965\":[null],\"966\":[null],\"1193\":[null],\"1196\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:21\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:42\",\"ModifiedUserId\":27,\"Name\":\"10.5%\",\"Value\":10.5,\"id\":1,\"syncVersion\":2},\"TaxCodeId\":1,\"TaxExempt\":null,\"TaxNumber\":\"30-71532406-3\",\"id\":33,\"syncVersion\":42},\"SupplierId\":33,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":235,\"syncVersion\":6},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-17\",\"ServiceId\":235,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Elflein 89 of. 6, Bariloche, Río Negro, Argentina.\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"A REMARLA SRL\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"operaciones@kawenadventure.com\",\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Kawen\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"0054 - 294 - 15 4578084\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Camioneta\",\"ParentId\":33,\"ParentType\":\"SUPPLIER\",\"id\":90,\"syncVersion\":38},{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2020-05-13T14:23:42\",\"ModifiedUserId\":30,\"Name\":\"Auto\",\"ParentId\":33,\"ParentType\":\"SUPPLIER\",\"id\":91,\"syncVersion\":38}],\"ServiceCategoriesByService\":{\"228\":[null],\"229\":[null],\"230\":[null],\"231\":[null],\"232\":[90,91],\"233\":[90,91],\"234\":[90,91],\"235\":[90,91],\"236\":[90,91],\"237\":[90,91],\"238\":[90,91],\"239\":[90,91],\"240\":[null],\"241\":[90,91],\"242\":[90,91],\"243\":[90,91],\"244\":[90,91],\"245\":[90,91],\"246\":[90,91],\"247\":[90,91],\"248\":[90,91],\"772\":[null],\"936\":[null],\"965\":[null],\"966\":[null],\"1193\":[null],\"1196\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:21\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:42\",\"ModifiedUserId\":27,\"Name\":\"10.5%\",\"Value\":10.5,\"id\":1,\"syncVersion\":2},\"TaxCodeId\":1,\"TaxExempt\":null,\"TaxNumber\":\"30-71532406-3\",\"id\":33,\"syncVersion\":42},\"SupplierId\":33,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":58064,\"syncVersion\":1},{\"BookingDayId\":8234,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":64,\"syncVersion\":1},{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":65,\"syncVersion\":1},{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":66,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-32.9,\"Longitude\":-68.85,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:23\",\"ModifiedUserId\":27,\"Name\":\"Mendoza\",\"id\":8,\"syncVersion\":3},\"CityId\":8,\"CreatedUTC\":\"2020-01-09T20:15:23\",\"CreatedUserId\":10,\"Description\":\"<p>Upon arrival in Mendoza, a private transfer will be waiting fro you to take you to your hotel.</p><p>Chacras de Coria, like the rest of this region, concentrates a singular number of wineries open to tourism and an important number of museums and historical sites. In recent years a gastronomic pole of great concurrence and variety has been developed.\\n</p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":1,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":\"20.00\",\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":null,\"Price\":28,\"SourceCost\":\"20.00\",\"SourceCurrencyId\":\"USD\"}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":64,\"syncVersion\":1},{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":65,\"syncVersion\":1},{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":66,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-32.9,\"Longitude\":-68.85,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:23\",\"ModifiedUserId\":27,\"Name\":\"Mendoza\",\"id\":8,\"syncVersion\":3},\"CityId\":8,\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":null,\"Duration\":null,\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":840,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Mendoza/Servicios/Sak/IMG_2312.jpg\"},\"ImageId\":840,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":null,\"ModifiedUTC\":\"2019-07-25T15:02:37\",\"ModifiedUserId\":1,\"Name\":\"Transfer Aeropuerto - Chacras de Coria (Ej: Posada Finca Adalgisa)\",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"Al llegar al aeropuerto internacional, serás trasladado al Hotel seleccionado. \\n\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-07-25T15:02:37\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":201,\"Title\":\"\",\"id\":597,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"Upon arrival to the international airport, you will be transferred to your select Hotel. \\n\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-07-25T15:02:37\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":201,\"Title\":\"\",\"id\":598,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>All'arrivo all'aeroporto internazionale, sarai trasferito all'Hotel selezionato.</p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-07-25T15:02:37\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":201,\"Title\":\"\",\"id\":599,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"BASE\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-10-31T13:33:58\",\"ModifiedUserId\":1,\"Name\":\"Privado\",\"PaxMin\":null,\"id\":2,\"syncVersion\":5},\"ServiceTypeId\":2,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Chile 776 - piso 1 - of 8 - Mendoza, 5500, Argentina\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"SAK WINE & WINE TRAVEL S.A.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"operaciones@sakwinetravel.com\",\"ModifiedUTC\":\"2021-01-14T15:22:04\",\"ModifiedUserId\":20,\"Name\":\"Sak\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 261 4201191\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"178\":[null],\"179\":[null],\"180\":[null],\"181\":[null],\"182\":[null],\"183\":[null],\"184\":[null],\"185\":[null],\"186\":[null],\"187\":[null],\"188\":[null],\"189\":[null],\"190\":[null],\"191\":[null],\"192\":[null],\"193\":[null],\"194\":[null],\"195\":[null],\"196\":[null],\"197\":[null],\"198\":[null],\"199\":[null],\"200\":[null],\"201\":[null],\"202\":[null],\"203\":[null],\"204\":[null],\"205\":[null],\"206\":[null],\"207\":[null],\"208\":[null],\"209\":[null],\"210\":[null],\"211\":[null],\"212\":[null],\"796\":[null],\"959\":[null],\"960\":[null],\"1069\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:34\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:31\",\"ModifiedUserId\":27,\"Name\":\"21%\",\"Value\":21,\"id\":2,\"syncVersion\":2},\"TaxCodeId\":2,\"TaxExempt\":null,\"TaxNumber\":\"30-71472450-5\",\"id\":31,\"syncVersion\":29},\"SupplierId\":31,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":201,\"syncVersion\":5},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-17\",\"ServiceId\":201,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Chile 776 - piso 1 - of 8 - Mendoza, 5500, Argentina\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"SAK WINE & WINE TRAVEL S.A.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"operaciones@sakwinetravel.com\",\"ModifiedUTC\":\"2021-01-14T15:22:04\",\"ModifiedUserId\":20,\"Name\":\"Sak\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 261 4201191\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"178\":[null],\"179\":[null],\"180\":[null],\"181\":[null],\"182\":[null],\"183\":[null],\"184\":[null],\"185\":[null],\"186\":[null],\"187\":[null],\"188\":[null],\"189\":[null],\"190\":[null],\"191\":[null],\"192\":[null],\"193\":[null],\"194\":[null],\"195\":[null],\"196\":[null],\"197\":[null],\"198\":[null],\"199\":[null],\"200\":[null],\"201\":[null],\"202\":[null],\"203\":[null],\"204\":[null],\"205\":[null],\"206\":[null],\"207\":[null],\"208\":[null],\"209\":[null],\"210\":[null],\"211\":[null],\"212\":[null],\"796\":[null],\"959\":[null],\"960\":[null],\"1069\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:34\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:31\",\"ModifiedUserId\":27,\"Name\":\"21%\",\"Value\":21,\"id\":2,\"syncVersion\":2},\"TaxCodeId\":2,\"TaxExempt\":null,\"TaxNumber\":\"30-71472450-5\",\"id\":31,\"syncVersion\":29},\"SupplierId\":31,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":15064,\"syncVersion\":1}],\"BookingId\":679,\"BoxLunch\":null,\"Breakfast\":true,\"City\":{},\"CityId\":null,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"DayNr\":14,\"Description\":null,\"Dinner\":null,\"EntranceIncluded\":null,\"GroupDayTo\":null,\"GroupDays\":null,\"HotelId\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":840,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Mendoza/Servicios/Sak/IMG_2312.jpg\"},\"ImageId\":840,\"ImageURL\":null,\"Lunch\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"PaxHotel\":false,\"QuoteDate\":null,\"ShowOptionals\":null,\"Snack\":null,\"SortNr\":null,\"Title\":null,\"TransDate\":\"2020-02-17\",\"id\":8234,\"syncVersion\":1},{\"BookingDayHotels\":[],\"BookingDayServices\":[{\"BookingDayId\":8235,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":64,\"syncVersion\":1},{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":65,\"syncVersion\":1},{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":66,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-32.9,\"Longitude\":-68.85,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:23\",\"ModifiedUserId\":27,\"Name\":\"Mendoza\",\"id\":8,\"syncVersion\":3},\"CityId\":8,\"CreatedUTC\":\"2020-01-09T20:15:23\",\"CreatedUserId\":10,\"Description\":\"<p>At the appropriate time you will be picked up from your hotel (private service) and driven to the vineyards area, the region of Luján de Cuyo or Maipu, which is well-known as the cradle of Malbec with its centuries-old vineyards at the base of the imposing Andes Mountains. In the course of 6 hours you will visit two Exclusive wineries accompanied by a specialized guide.\\nThe proposed wineries change according to the season, as not all wineries are open to the public all year around. \\nClose to lunch-time we will stop at one of the best restaurants in one of the chosen wineries, with an excellent menu that includes four courses, perfectly combining excellent food and extraordinary wines with the scenic view of the Andes Mountains\\n</p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":0,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":null,\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":null,\"OriginCost\":null,\"Price\":null,\"PriceModified\":null,\"SourceCost\":null,\"SourceCurrencyId\":null}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":64,\"syncVersion\":1},{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":65,\"syncVersion\":1},{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":66,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-32.9,\"Longitude\":-68.85,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:23\",\"ModifiedUserId\":27,\"Name\":\"Mendoza\",\"id\":8,\"syncVersion\":3},\"CityId\":8,\"Closed\":false,\"Comment\":\"Guia Bilingue\\nAlmuerzo Gourme 4/5 pasos\\nSeguro de accidentes\",\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":null,\"CreatedUTC\":\"2019-11-07T18:08:46\",\"CreatedUserId\":31,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":null,\"Duration\":\"7 HS\",\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":833,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Mendoza/Servicios/Sak/9%20DSC_1205.jpg\"},\"ImageId\":833,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":true,\"ModifiedUTC\":\"2019-11-07T18:11:11\",\"ModifiedUserId\":31,\"Name\":\"Visita a 2 BODEGAS c/almuerzo - Lujan de Cuyo o Maipu (PREMIUM)\",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":\"2019-11-07T18:08:46\",\"CreatedUserId\":31,\"Description\":\"<p>Lo&nbsp;pasaran a buscar por el hote y lo llevarán a la zona de viñedos, la región de Luján de Cuyo o Maipú, que es conocida como la cuna del Malbec con sus viñedos centenarios en el base de la imponente Cordillera de los Andes. En el transcurso de 6 horas visitará dos bodegas exclusivas acompañadas de un guía especializado.\\nLas bodegas propuestas cambian según la temporada, ya que no todas las bodegas están abiertas al público durante todo el año.\\nCerca de la hora del almuerzo, nos detendremos en uno de los mejores restaurantes de una de las bodegas elegidas, con un excelente menú que incluye cuatro platos, combinando perfectamente una excelente comida y vinos extraordinarios con la vista panorámica de la Cordillera de los Andes.\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-11-07T18:11:11\",\"ModifiedUserId\":31,\"OfferedLanguage\":true,\"Optional\":null,\"ServiceId\":796,\"Title\":\"Bodegas exclusivas con degustacion premium\",\"id\":2382,\"syncVersion\":1},{\"CreatedUTC\":\"2019-11-07T18:08:46\",\"CreatedUserId\":31,\"Description\":\"<p>At the appropriate time you will be picked up from your hotel (private service) and driven to the vineyards area, the region of Luján de Cuyo or Maipu, which is well-known as the cradle of Malbec with its centuries-old vineyards at the base of the imposing Andes Mountains. In the course of 6 hours you will visit two Exclusive wineries accompanied by a specialized guide.\\nThe proposed wineries change according to the season, as not all wineries are open to the public all year around. \\nClose to lunch-time we will stop at one of the best restaurants in one of the chosen wineries, with an excellent menu that includes four courses, perfectly combining excellent food and extraordinary wines with the scenic view of the Andes Mountains\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-11-07T18:11:11\",\"ModifiedUserId\":31,\"OfferedLanguage\":true,\"Optional\":null,\"ServiceId\":796,\"Title\":\"Exclusive wineries with premium taste \",\"id\":2383,\"syncVersion\":1},{\"CreatedUTC\":\"2019-11-07T18:08:46\",\"CreatedUserId\":31,\"Description\":\"<p><br></p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-11-07T18:11:11\",\"ModifiedUserId\":31,\"OfferedLanguage\":null,\"Optional\":null,\"ServiceId\":796,\"Title\":\"\",\"id\":2384,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"BASE\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-10-31T13:33:58\",\"ModifiedUserId\":1,\"Name\":\"Privado\",\"PaxMin\":null,\"id\":2,\"syncVersion\":5},\"ServiceTypeId\":2,\"ShowServiceType\":null,\"Snack\":true,\"Supplier\":{\"Address\":\"Chile 776 - piso 1 - of 8 - Mendoza, 5500, Argentina\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"SAK WINE & WINE TRAVEL S.A.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"operaciones@sakwinetravel.com\",\"ModifiedUTC\":\"2021-01-14T15:22:04\",\"ModifiedUserId\":20,\"Name\":\"Sak\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 261 4201191\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"178\":[null],\"179\":[null],\"180\":[null],\"181\":[null],\"182\":[null],\"183\":[null],\"184\":[null],\"185\":[null],\"186\":[null],\"187\":[null],\"188\":[null],\"189\":[null],\"190\":[null],\"191\":[null],\"192\":[null],\"193\":[null],\"194\":[null],\"195\":[null],\"196\":[null],\"197\":[null],\"198\":[null],\"199\":[null],\"200\":[null],\"201\":[null],\"202\":[null],\"203\":[null],\"204\":[null],\"205\":[null],\"206\":[null],\"207\":[null],\"208\":[null],\"209\":[null],\"210\":[null],\"211\":[null],\"212\":[null],\"796\":[null],\"959\":[null],\"960\":[null],\"1069\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:34\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:31\",\"ModifiedUserId\":27,\"Name\":\"21%\",\"Value\":21,\"id\":2,\"syncVersion\":2},\"TaxCodeId\":2,\"TaxExempt\":null,\"TaxNumber\":\"30-71472450-5\",\"id\":31,\"syncVersion\":29},\"SupplierId\":31,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":796,\"syncVersion\":3},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-18\",\"ServiceId\":796,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Chile 776 - piso 1 - of 8 - Mendoza, 5500, Argentina\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"SAK WINE & WINE TRAVEL S.A.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"operaciones@sakwinetravel.com\",\"ModifiedUTC\":\"2021-01-14T15:22:04\",\"ModifiedUserId\":20,\"Name\":\"Sak\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 261 4201191\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"178\":[null],\"179\":[null],\"180\":[null],\"181\":[null],\"182\":[null],\"183\":[null],\"184\":[null],\"185\":[null],\"186\":[null],\"187\":[null],\"188\":[null],\"189\":[null],\"190\":[null],\"191\":[null],\"192\":[null],\"193\":[null],\"194\":[null],\"195\":[null],\"196\":[null],\"197\":[null],\"198\":[null],\"199\":[null],\"200\":[null],\"201\":[null],\"202\":[null],\"203\":[null],\"204\":[null],\"205\":[null],\"206\":[null],\"207\":[null],\"208\":[null],\"209\":[null],\"210\":[null],\"211\":[null],\"212\":[null],\"796\":[null],\"959\":[null],\"960\":[null],\"1069\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:34\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:31\",\"ModifiedUserId\":27,\"Name\":\"21%\",\"Value\":21,\"id\":2,\"syncVersion\":2},\"TaxCodeId\":2,\"TaxExempt\":null,\"TaxNumber\":\"30-71472450-5\",\"id\":31,\"syncVersion\":29},\"SupplierId\":31,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":15065,\"syncVersion\":1}],\"BookingId\":679,\"BoxLunch\":null,\"Breakfast\":true,\"City\":{},\"CityId\":null,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"DayNr\":15,\"Description\":null,\"Dinner\":null,\"EntranceIncluded\":null,\"GroupDayTo\":null,\"GroupDays\":null,\"HotelId\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-07T12:12:12\",\"CreatedUserId\":10,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"2 Bodegas\",\"id\":831,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Mendoza/Servicios/Sak/2%20bodegas%20SAK.jpg\"},\"ImageId\":831,\"ImageURL\":null,\"Lunch\":true,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"PaxHotel\":null,\"QuoteDate\":null,\"ShowOptionals\":null,\"Snack\":true,\"SortNr\":null,\"Title\":\"Exclusive wineries with premium taste \",\"TransDate\":\"2020-02-18\",\"id\":8235,\"syncVersion\":1},{\"BookingDayHotels\":[],\"BookingDayServices\":[{\"BookingDayId\":8236,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":64,\"syncVersion\":1},{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":65,\"syncVersion\":1},{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":66,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-32.9,\"Longitude\":-68.85,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:23\",\"ModifiedUserId\":27,\"Name\":\"Mendoza\",\"id\":8,\"syncVersion\":3},\"CityId\":8,\"CreatedUTC\":\"2020-01-09T20:17:11\",\"CreatedUserId\":10,\"Description\":\"You will be picked up by you hotel.  In this opportunity you will enjoy a culinary experience at one of the best known wineries of the region. Guided by a knowledgeable chef, you will learn different gastronomic techniques used in our province as well as local ingredients. Wine pairing with different varietals is a must of this tour. By the end of the class you’ll enjoy lunch and visit the winery. End of the service and back to your lodging.  \\n\\nDuration: 8 hrs\\nIncludes: private service, car, bilingual chef, cooking elements, raw material, drinks, lunch and visit.\\n\\n\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":0,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":\"107.00\",\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":null,\"Price\":149.79999999999998,\"SourceCost\":\"107.00\",\"SourceCurrencyId\":\"USD\"}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":64,\"syncVersion\":1},{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":65,\"syncVersion\":1},{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":66,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-32.9,\"Longitude\":-68.85,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:23\",\"ModifiedUserId\":27,\"Name\":\"Mendoza\",\"id\":8,\"syncVersion\":3},\"CityId\":8,\"Closed\":false,\"Comment\":\"Incluye: PVD Servicio privado/grupales, Vehiculo privado, Cheff bilingüe, Snack, Almuerzo/Cena. Duracion 8hs.\\nImportante: Para los servicios en Posada Finca Adalgisa, consultar disponibilidad! !!!!\\nSalidas: PVD: Todos los dias\",\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":null,\"Duration\":\"8 horas\",\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":833,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Mendoza/Servicios/Sak/9%20DSC_1205.jpg\"},\"ImageId\":833,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":true,\"ModifiedUTC\":\"2019-07-25T19:36:24\",\"ModifiedUserId\":1,\"Name\":\"Clase de cocina en Bodega Zuccardi - Casa del Visitante - Maipu\",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"Pasarán a buscarte por el hotel.  En esta oportunidad podrán disfrutar de una experiencia culinaria en una de las bodegas más reconocidas de la región. Guiados por un chef experimentado, aprenderán diversas técnicas gastronómicas utilizando ingredientes y técnicas autóctonas de nuestra provincia. El vino siempre estará presente ya que podrán degustar diferentes variedades de cepas durante el servicio. Finalizada la clase de cocina, podrán disfrutar del almuerzo y visita por la bodega.  Fin de los servicios, regreso al alojamiento seleccionado. \\n \\nDuración: 8 horas\\nIncluye: servicio privado, vehículo, chef bilingüe, elementos de cocina, materia prima, bebida, visita, almuerzo. \\n\\n\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-07-25T19:36:24\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":189,\"Title\":\"Clase de Cocina y Almuerzo en Bodega\",\"id\":561,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"You will be picked up by you hotel.  In this opportunity you will enjoy a culinary experience at one of the best known wineries of the region. Guided by a knowledgeable chef, you will learn different gastronomic techniques used in our province as well as local ingredients. Wine pairing with different varietals is a must of this tour. By the end of the class you’ll enjoy lunch and visit the winery. End of the service and back to your lodging.  \\n\\nDuration: 8 hrs\\nIncludes: private service, car, bilingual chef, cooking elements, raw material, drinks, lunch and visit.\\n\\n\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-07-25T19:36:24\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":189,\"Title\":\"Cooking Class & Lunch at a Winery\",\"id\":562,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>In questa occasione puoi goderti un'esperienza culinaria in una delle cantine più rinomate della regione. Guidati da uno chef esperto, imparerai diverse tecniche gastronomiche usando ingredienti e tecniche native della nostra provincia. Il vino sarà sempre presente in quanto è possibile degustare diverse varietà durante il servizio. Dopo la lezione di cucina, puoi pranzare e visitare la cantina.</p><p>Fine dei servizi, ritorno alla sistemazione selezionata.</p><p></p><p>Durata: 8 ore</p><p>Include: servizio privato, veicolo, cuoco bilingue, strumenti da cucina, ingredienti, bevande, visita, pranzo.</p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-07-25T19:36:24\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":189,\"Title\":\"Corso di Cucina e Pranzo in Cantina\",\"id\":563,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"BASE\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-10-31T13:33:58\",\"ModifiedUserId\":1,\"Name\":\"Privado\",\"PaxMin\":null,\"id\":2,\"syncVersion\":5},\"ServiceTypeId\":2,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Chile 776 - piso 1 - of 8 - Mendoza, 5500, Argentina\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"SAK WINE & WINE TRAVEL S.A.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"operaciones@sakwinetravel.com\",\"ModifiedUTC\":\"2021-01-14T15:22:04\",\"ModifiedUserId\":20,\"Name\":\"Sak\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 261 4201191\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"178\":[null],\"179\":[null],\"180\":[null],\"181\":[null],\"182\":[null],\"183\":[null],\"184\":[null],\"185\":[null],\"186\":[null],\"187\":[null],\"188\":[null],\"189\":[null],\"190\":[null],\"191\":[null],\"192\":[null],\"193\":[null],\"194\":[null],\"195\":[null],\"196\":[null],\"197\":[null],\"198\":[null],\"199\":[null],\"200\":[null],\"201\":[null],\"202\":[null],\"203\":[null],\"204\":[null],\"205\":[null],\"206\":[null],\"207\":[null],\"208\":[null],\"209\":[null],\"210\":[null],\"211\":[null],\"212\":[null],\"796\":[null],\"959\":[null],\"960\":[null],\"1069\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:34\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:31\",\"ModifiedUserId\":27,\"Name\":\"21%\",\"Value\":21,\"id\":2,\"syncVersion\":2},\"TaxCodeId\":2,\"TaxExempt\":null,\"TaxNumber\":\"30-71472450-5\",\"id\":31,\"syncVersion\":29},\"SupplierId\":31,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":189,\"syncVersion\":7},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-19\",\"ServiceId\":189,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Chile 776 - piso 1 - of 8 - Mendoza, 5500, Argentina\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"SAK WINE & WINE TRAVEL S.A.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"operaciones@sakwinetravel.com\",\"ModifiedUTC\":\"2021-01-14T15:22:04\",\"ModifiedUserId\":20,\"Name\":\"Sak\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 261 4201191\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"178\":[null],\"179\":[null],\"180\":[null],\"181\":[null],\"182\":[null],\"183\":[null],\"184\":[null],\"185\":[null],\"186\":[null],\"187\":[null],\"188\":[null],\"189\":[null],\"190\":[null],\"191\":[null],\"192\":[null],\"193\":[null],\"194\":[null],\"195\":[null],\"196\":[null],\"197\":[null],\"198\":[null],\"199\":[null],\"200\":[null],\"201\":[null],\"202\":[null],\"203\":[null],\"204\":[null],\"205\":[null],\"206\":[null],\"207\":[null],\"208\":[null],\"209\":[null],\"210\":[null],\"211\":[null],\"212\":[null],\"796\":[null],\"959\":[null],\"960\":[null],\"1069\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:34\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:31\",\"ModifiedUserId\":27,\"Name\":\"21%\",\"Value\":21,\"id\":2,\"syncVersion\":2},\"TaxCodeId\":2,\"TaxExempt\":null,\"TaxNumber\":\"30-71472450-5\",\"id\":31,\"syncVersion\":29},\"SupplierId\":31,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":15066,\"syncVersion\":1}],\"BookingId\":679,\"BoxLunch\":null,\"Breakfast\":true,\"City\":{},\"CityId\":null,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"DayNr\":16,\"Description\":null,\"Dinner\":null,\"EntranceIncluded\":null,\"GroupDayTo\":null,\"GroupDays\":null,\"HotelId\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":833,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Mendoza/Servicios/Sak/9%20DSC_1205.jpg\"},\"ImageId\":833,\"ImageURL\":null,\"Lunch\":true,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"PaxHotel\":null,\"QuoteDate\":null,\"ShowOptionals\":null,\"Snack\":null,\"SortNr\":null,\"Title\":\"Cooking Class & Lunch at a Winery\",\"TransDate\":\"2020-02-19\",\"id\":8236,\"syncVersion\":1},{\"BookingDayHotels\":[{\"BookingDayId\":8237,\"BookingDayRooms\":[{\"BookingDayHotelId\":2533,\"Category\":{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Junior Room con Balcon\",\"Program\":null,\"id\":106,\"syncVersion\":1},\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"CurrencyId\":\"USD\",\"Hotel\":{\"Address\":\"Gurruchaga 2121 (C1425FEE)  Palermo, Buenos Aires, Argentina\",\"Checkin\":null,\"Checkout\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"Closed\":false,\"Comment\":\"30 de diciembre 2019 al 04 de enero 2020 *estadia minima 3 noches*\",\"Commision\":null,\"CommisionPrice\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Email\":\"reservations@owngrand.com\",\"HotelCategory\":{},\"HotelCategoryId\":null,\"HotelDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>El Own Grand Palermo Soho es un hotel boutique elegante situado en Palermo, un barrio de moda, y ofrece habitaciones de estilo moderno y sofisticado con conexión WiFi gratuita. El establecimiento tiene una piscina en la azotea con vistas a la ciudad, bañera de hidromasaje, sauna e instalaciones de fitness. El establecimiento cuenta con un restaurante exclusivo y un bar. El hotel queda a 600 metros de la plaza Serrano, a 600 metros de la plaza Italia y a 1,3 km del hipódromo. El aeroparque Jorge Newbery está a 3 km.</p>\",\"HotelId\":27,\"LanguageId\":1,\"ModifiedUTC\":\"2019-08-23T14:06:54\",\"ModifiedUserId\":1,\"id\":76,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Located in the trendy Palermo neighborhood, Own Grand Palermo Soho is a stylish boutique hotel offering rooms with a modern and sophisticated décor and free WiFi access. The property has a rooftop pool with city views, a hot tub, a sauna and fitness facilities.</p><p>The hotel is 601 m from Plaza Serrano Square, 601 m from Plaza Italia Square and 0.8 mi from Hippodrome. Aeroparque Jorge Newbery Airport is 1.9 mi away.</p>\",\"HotelId\":27,\"LanguageId\":2,\"ModifiedUTC\":\"2019-08-23T14:06:54\",\"ModifiedUserId\":1,\"id\":77,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Il Grand Palermo Soho è un elegante hotel boutique situato a Palermo, un quartiere alla moda, e offre camere moderne e sofisticate con connessione Wi-Fi gratuita. La struttura vanta una piscina panoramica con vista sulla città, una vasca idromassaggio, una sauna e strutture per il fitness. L'hotel si trova a 600 metri da Plaza Serrano, a 600 metri da Plaza Italia e a 1,3 km dall'Ippodromo. Aeroparque Jorge Newbery si trova a 3 km di distanza.</p><p><br></p>\",\"HotelId\":27,\"LanguageId\":3,\"ModifiedUTC\":\"2019-08-23T14:06:54\",\"ModifiedUserId\":1,\"id\":78,\"syncVersion\":1}],\"HotelPhotos\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":27,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Own Palermo Soho\",\"id\":264,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/BUE/HOTELES/OWN%20PALERMO/undefinedOwnhotel.jpg\"},\"ImageId\":264,\"ImageURL\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":72,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":27,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Own Palermo Soho\",\"id\":265,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/BUE/HOTELES/OWN%20PALERMO/undefinedownhotel1.jpg\"},\"ImageId\":265,\"ImageURL\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":73,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":27,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Own Palermo Soho\",\"id\":266,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/BUE/HOTELES/OWN%20PALERMO/undefinedownhotel2.jpg\"},\"ImageId\":266,\"ImageURL\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":74,\"syncVersion\":1}],\"HotelRoomTypes\":[{\"Comment\":null,\"CreatedUTC\":\"2019-10-23T19:32:53\",\"CreatedUserId\":1,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"SGL\",\"Pax\":1,\"id\":1,\"syncVersion\":1},\"RoomTypeId\":1,\"id\":62,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2019-10-23T19:32:53\",\"CreatedUserId\":1,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"DBL\",\"Pax\":2,\"id\":2,\"syncVersion\":1},\"RoomTypeId\":2,\"id\":63,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2019-10-23T19:32:53\",\"CreatedUserId\":1,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":true,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"CAMA EXTRA\",\"Pax\":1,\"id\":5,\"syncVersion\":3},\"RoomTypeId\":5,\"id\":64,\"syncVersion\":1},{\"Comment\":null,\"CreatedUTC\":\"2019-10-25T12:54:13\",\"CreatedUserId\":1,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"RoomType\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"TPL\",\"Pax\":3,\"id\":3,\"syncVersion\":1},\"RoomTypeId\":3,\"id\":719,\"syncVersion\":1}],\"HotelTaxCodes\":[],\"ModifiedUTC\":\"2020-02-11T18:16:49\",\"ModifiedUserId\":8,\"Name\":\"Own Grand Palermo Soho\",\"Nights\":null,\"PeriodCostBy\":null,\"Phone\":\"+54 11 4831 0800\",\"ProgramPeriodCostBy\":null,\"ProgramUnitCostBy\":null,\"RoomCategories\":[{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Junior Room\",\"Program\":null,\"id\":105,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Junior Room con Balcon\",\"Program\":null,\"id\":106,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Deluxe Suite\",\"Program\":null,\"id\":107,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Deluxe Suite con Balcon\",\"Program\":null,\"id\":108,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Deluxe one Bedroom Suite con B\",\"Program\":null,\"id\":109,\"syncVersion\":1},{\"Closed\":false,\"Comment\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Master Suite con Balcon\",\"Program\":null,\"id\":110,\"syncVersion\":1}],\"RoomCostBy\":\"ROOM_TYPE_CATEGORY\",\"Supplier\":{\"Address\":\"Gurruchaga 2121 (C1425FEE)  Palermo, Buenos Aires, Argentina\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"HOTEL GURRUCHAGA S.A.\",\"CreatedUTC\":\"2019-08-21T20:13:20\",\"CreatedUserId\":1,\"CurrencyId\":null,\"Email\":\"reservations@owngrand.com\",\"ModifiedUTC\":\"2020-04-24T03:07:34\",\"ModifiedUserId\":37,\"Name\":\"Own Grand Palermo Soho\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"-\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"HOTEL\",\"TaxBasePercent\":null,\"TaxCode\":{},\"TaxCodeId\":null,\"TaxExempt\":null,\"TaxNumber\":\"30-71436078-3\",\"id\":80,\"syncVersion\":3},\"SupplierId\":80,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:33\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:04\",\"ModifiedUserId\":27,\"Name\":\"TUR IVA\",\"Value\":0,\"id\":5,\"syncVersion\":3},\"TaxCodeId\":5,\"Type\":\"NORMAL\",\"UnitCostBy\":null,\"WebSite\":null,\"id\":27,\"syncVersion\":13},\"HotelCategory\":{},\"HotelCategoryId\":null,\"HotelId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Quote\":null,\"QuoteList\":{\"0\":{\"Cost\":130,\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":\"95\",\"Price\":182,\"PriceModified\":null,\"RoomCost\":130,\"SourceCost\":95,\"SourceCurrencyId\":\"USD\"}},\"ReservationNumber\":null,\"Room\":{\"Checkin\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"DBL\",\"Pax\":2,\"id\":2,\"syncVersion\":1},\"RoomCategory\":106,\"RoomTypeId\":2,\"Rooms\":1,\"Status\":\"PENDING\",\"Supplier\":{},\"SupplierId\":null,\"id\":2810,\"syncVersion\":1}],\"Checkin\":\"2020-02-20\",\"Checkout\":\"2020-02-20\",\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"Days\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":2533,\"syncVersion\":1}],\"BookingDayServices\":[{\"BookingDayId\":8237,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":64,\"syncVersion\":1},{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":65,\"syncVersion\":1},{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":66,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-32.9,\"Longitude\":-68.85,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:23\",\"ModifiedUserId\":27,\"Name\":\"Mendoza\",\"id\":8,\"syncVersion\":3},\"CityId\":8,\"CreatedUTC\":\"2020-01-09T20:19:09\",\"CreatedUserId\":10,\"Description\":\"<p>At the designated time you will have a private transfer to Mendoza airport for your flight back to Buenos Aires.\\n</p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":0,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":\"20.00\",\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":null,\"Price\":28,\"SourceCost\":\"20.00\",\"SourceCurrencyId\":\"USD\"}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":64,\"syncVersion\":1},{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":65,\"syncVersion\":1},{\"CityId\":8,\"CreatedUTC\":\"2020-10-09T12:02:23\",\"CreatedUserId\":27,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":66,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-32.9,\"Longitude\":-68.85,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-09T12:02:23\",\"ModifiedUserId\":27,\"Name\":\"Mendoza\",\"id\":8,\"syncVersion\":3},\"CityId\":8,\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":null,\"Duration\":null,\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"id\":840,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Mendoza/Servicios/Sak/IMG_2312.jpg\"},\"ImageId\":840,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":null,\"ModifiedUTC\":\"2020-01-31T14:54:33\",\"ModifiedUserId\":8,\"Name\":\"Transfer Chacras de Coria (Ej: Posada Finca Adalgisa) - Aeropuerto\",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"A la hora apropiada, serás trasladado al aeropuerto internacional, para tomar tu vuelo.\\n\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-07-25T15:03:20\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":208,\"Title\":\"\",\"id\":618,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"At appropriate time, you will be transferred to the international airport, to take your flight.\\n\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-07-25T15:03:20\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":208,\"Title\":\"\",\"id\":619,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>All'orario stabilito, sarai trasferito all'aeroporto internazionale per prendere il volo.</p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-07-25T15:03:20\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":208,\"Title\":\"\",\"id\":620,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"BASE\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-10-31T13:33:58\",\"ModifiedUserId\":1,\"Name\":\"Privado\",\"PaxMin\":null,\"id\":2,\"syncVersion\":5},\"ServiceTypeId\":2,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Chile 776 - piso 1 - of 8 - Mendoza, 5500, Argentina\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"SAK WINE & WINE TRAVEL S.A.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"operaciones@sakwinetravel.com\",\"ModifiedUTC\":\"2021-01-14T15:22:04\",\"ModifiedUserId\":20,\"Name\":\"Sak\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 261 4201191\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"178\":[null],\"179\":[null],\"180\":[null],\"181\":[null],\"182\":[null],\"183\":[null],\"184\":[null],\"185\":[null],\"186\":[null],\"187\":[null],\"188\":[null],\"189\":[null],\"190\":[null],\"191\":[null],\"192\":[null],\"193\":[null],\"194\":[null],\"195\":[null],\"196\":[null],\"197\":[null],\"198\":[null],\"199\":[null],\"200\":[null],\"201\":[null],\"202\":[null],\"203\":[null],\"204\":[null],\"205\":[null],\"206\":[null],\"207\":[null],\"208\":[null],\"209\":[null],\"210\":[null],\"211\":[null],\"212\":[null],\"796\":[null],\"959\":[null],\"960\":[null],\"1069\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:34\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:31\",\"ModifiedUserId\":27,\"Name\":\"21%\",\"Value\":21,\"id\":2,\"syncVersion\":2},\"TaxCodeId\":2,\"TaxExempt\":null,\"TaxNumber\":\"30-71472450-5\",\"id\":31,\"syncVersion\":29},\"SupplierId\":31,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":208,\"syncVersion\":4},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-20\",\"ServiceId\":208,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Chile 776 - piso 1 - of 8 - Mendoza, 5500, Argentina\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"SAK WINE & WINE TRAVEL S.A.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"operaciones@sakwinetravel.com\",\"ModifiedUTC\":\"2021-01-14T15:22:04\",\"ModifiedUserId\":20,\"Name\":\"Sak\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 261 4201191\",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"178\":[null],\"179\":[null],\"180\":[null],\"181\":[null],\"182\":[null],\"183\":[null],\"184\":[null],\"185\":[null],\"186\":[null],\"187\":[null],\"188\":[null],\"189\":[null],\"190\":[null],\"191\":[null],\"192\":[null],\"193\":[null],\"194\":[null],\"195\":[null],\"196\":[null],\"197\":[null],\"198\":[null],\"199\":[null],\"200\":[null],\"201\":[null],\"202\":[null],\"203\":[null],\"204\":[null],\"205\":[null],\"206\":[null],\"207\":[null],\"208\":[null],\"209\":[null],\"210\":[null],\"211\":[null],\"212\":[null],\"796\":[null],\"959\":[null],\"960\":[null],\"1069\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:34\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:31\",\"ModifiedUserId\":27,\"Name\":\"21%\",\"Value\":21,\"id\":2,\"syncVersion\":2},\"TaxCodeId\":2,\"TaxExempt\":null,\"TaxNumber\":\"30-71472450-5\",\"id\":31,\"syncVersion\":29},\"SupplierId\":31,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":15067,\"syncVersion\":1},{\"BookingDayId\":8237,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"CreatedUTC\":\"2020-01-09T20:19:09\",\"CreatedUserId\":10,\"Description\":\"<p>Upon arrival to the airport, you will be transferred to your hotel.  \\n</p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":1,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":\"12.00\",\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":null,\"Price\":16.799999999999997,\"SourceCost\":\"12.00\",\"SourceCurrencyId\":\"USD\"}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"Closed\":false,\"Comment\":\"- Los translados desde el aeropuerto incluyen 1hs de espera \\n- Los peajes, estacionamientos y gastos maleteros no están incluidos \\nTarifas peaje y Estacionamiento actualizado Diciembre 2019\\nAEP: Auto 70 - Van 130\\nEZE: Auto 270 - Van 430\\nCNX: Auto 340 - Van 560\\nTigre: Auto 200 - Van 370\\nEstacionamiento EZE: Auto 100 - Van 115\\nEstacionamiento AEP: Auto 95 - Van 120  \\n- Tarifas especiales para las fiestas, 50% más. Aplica desde el 24-Dic y 31-Dic a las 16hs, y todo el 25-Dic y 01-\\nEnero. Sujeto a disponibilidad.\\n- Los precios son para servicios con y sin guía. Punto de encuentro: hotel céntrico.\",\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"USD\",\"ModifiedUTC\":\"2020-03-28T20:30:21\",\"ModifiedUserId\":1,\"Name\":\"Peso Argentino\",\"Operation\":\"DIVIDE\",\"id\":\"ARS\",\"syncVersion\":2},\"CurrencyId\":\"ARS\",\"Dinner\":null,\"Duration\":null,\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Buenos Aire City tour\",\"id\":286,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/BUE/SERVICIOS/BA.jpg\"},\"ImageId\":286,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":null,\"ModifiedUTC\":\"2019-07-25T13:20:52\",\"ModifiedUserId\":1,\"Name\":\"Transfer AEP - HTL\",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[{\"Closed\":false,\"CreatedUTC\":\"2019-07-30T18:30:59\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-08-05T13:25:10\",\"ModifiedUserId\":1,\"Name\":\"Auto\",\"ParentId\":34,\"ParentType\":\"SERVICE\",\"id\":247,\"syncVersion\":3},{\"Closed\":false,\"CreatedUTC\":\"2019-07-30T18:30:59\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-08-05T13:25:10\",\"ModifiedUserId\":1,\"Name\":\"Van\",\"ParentId\":34,\"ParentType\":\"SERVICE\",\"id\":248,\"syncVersion\":3}],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Al llegar al aeropuerto, serás trasladado al hotel. \\n\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-07-25T13:20:52\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":34,\"Title\":\"\",\"id\":96,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>Upon arrival to the airport, you will be transferred to your hotel.  \\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-07-25T13:20:52\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":34,\"Title\":\"\",\"id\":97,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>All'arrivo in aeroporto, sarai trasferito all'hotel. \\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-07-25T13:20:52\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":34,\"Title\":\"\",\"id\":98,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"BASE\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-10-31T13:33:58\",\"ModifiedUserId\":1,\"Name\":\"Privado\",\"PaxMin\":null,\"id\":2,\"syncVersion\":5},\"ServiceTypeId\":2,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Uspallata 781, B1638BXA Vicente López, Buenos Aires\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"SUTRANSFER S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"reservas@sutransfer.com.ar\",\"ModifiedUTC\":\"2020-06-17T13:14:40\",\"ModifiedUserId\":20,\"Name\":\"Sutransfer\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 4837-0544\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"32\":[243,244],\"33\":[245,246],\"34\":[247,248],\"35\":[249,250],\"36\":[251,252],\"37\":[253,254],\"38\":[255,256],\"39\":[257,258],\"40\":[265,266],\"41\":[267,268],\"42\":[null],\"456\":[259,260],\"457\":[263,264],\"1042\":[301,302],\"1103\":[303,304],\"1104\":[305,306],\"1105\":[307,308],\"1106\":[309,310],\"1107\":[311,312]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:11\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:18\",\"ModifiedUserId\":27,\"Name\":\"NO GRAVADO\",\"Value\":0,\"id\":4,\"syncVersion\":2},\"TaxCodeId\":4,\"TaxExempt\":null,\"TaxNumber\":\"30-71197322-9\",\"id\":10,\"syncVersion\":32},\"SupplierId\":10,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":34,\"syncVersion\":9},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-20\",\"ServiceId\":34,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Uspallata 781, B1638BXA Vicente López, Buenos Aires\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"SUTRANSFER S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"reservas@sutransfer.com.ar\",\"ModifiedUTC\":\"2020-06-17T13:14:40\",\"ModifiedUserId\":20,\"Name\":\"Sutransfer\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 4837-0544\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"32\":[243,244],\"33\":[245,246],\"34\":[247,248],\"35\":[249,250],\"36\":[251,252],\"37\":[253,254],\"38\":[255,256],\"39\":[257,258],\"40\":[265,266],\"41\":[267,268],\"42\":[null],\"456\":[259,260],\"457\":[263,264],\"1042\":[301,302],\"1103\":[303,304],\"1104\":[305,306],\"1105\":[307,308],\"1106\":[309,310],\"1107\":[311,312]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:11\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:18\",\"ModifiedUserId\":27,\"Name\":\"NO GRAVADO\",\"Value\":0,\"id\":4,\"syncVersion\":2},\"TaxCodeId\":4,\"TaxExempt\":null,\"TaxNumber\":\"30-71197322-9\",\"id\":10,\"syncVersion\":32},\"SupplierId\":10,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":15068,\"syncVersion\":1}],\"BookingId\":679,\"BoxLunch\":null,\"Breakfast\":true,\"City\":{},\"CityId\":null,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"DayNr\":17,\"Description\":null,\"Dinner\":null,\"EntranceIncluded\":null,\"GroupDayTo\":null,\"GroupDays\":null,\"HotelId\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Buenos Aire City tour\",\"id\":286,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/BUE/SERVICIOS/BA.jpg\"},\"ImageId\":286,\"ImageURL\":null,\"Lunch\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"PaxHotel\":false,\"QuoteDate\":null,\"ShowOptionals\":null,\"Snack\":null,\"SortNr\":null,\"Title\":null,\"TransDate\":\"2020-02-20\",\"id\":8237,\"syncVersion\":1},{\"BookingDayHotels\":[],\"BookingDayServices\":[{\"BookingDayId\":8238,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"CreatedUTC\":\"2020-01-09T20:20:16\",\"CreatedUserId\":10,\"Description\":\"<p>Day at your own leisure.</p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Day at leisure\",\"OrderNr\":0,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":\"0.00\",\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":null,\"Price\":0,\"SourceCost\":\"0.00\",\"SourceCurrencyId\":\"USD\"}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-21\",\"ServiceId\":null,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{},\"SupplierId\":null,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":15097,\"syncVersion\":1},{\"BookingDayId\":8238,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"CreatedUTC\":\"2020-01-09T20:20:16\",\"CreatedUserId\":10,\"Description\":\"<p>Argentina is famous for the meet and the ritual of making “asado”. Steaks by Luis offers to live an experience: to share a typical Argentinean barbecue. Luis joins the guests during the whole dinner, talking about this ritual making you feel like you are at Luis' home.He also invites you to move around the restaurant, meet your neighbors, join alongside the grill or just sit back, relax and enjoy the event. </p><p><br></p><p>The five courses dinner:</p><ul><li>1st course: Great welcome Picada (cheese, salami, toast, dips, olives and empanadas) accompanied by a Brut Sparkling Wine.</li><li>2nd course: Mixed vegetable salad with confit tomatoes, apples and a home-made honey mustard vinaigrette, accompanied by a young Torrontes Wine.</li><li>3rd course: Achuras, different cuts of grilled beef and pork, pork sausage, pork blood sausage, grilling sausage and grilled provolone cheese; served with typical Argentine sauces, accompanied by a young Red Wine.</li><li>4th course: New York Strip Steak with mashed vegetables and rustic potatoes, accompanied by a full body Red Wine.</li><li>5th course: Caramel cheesecake, accompanied by a Late Harvest Wine.</li></ul>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":1,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":null,\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":null,\"OriginCost\":null,\"Price\":null,\"PriceModified\":null,\"SourceCost\":null,\"SourceCurrencyId\":null}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":true,\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"Closed\":false,\"Comment\":\"Children: entre 6 y 12 años \",\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":\"PERSON\",\"CreatedUTC\":\"2019-07-29T13:34:19\",\"CreatedUserId\":1,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"Dinner\":true,\"Duration\":\"2,5 hs\",\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-07-29T12:55:56\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-07-29T12:55:57\",\"ModifiedUserId\":1,\"Name\":null,\"id\":298,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/BUE/SERVICIOS/Steaks%20by%20Luis/closed-door-restaurant-in-buenos-aires-dining-experience-at-steaks-by-in-buenos-aires-152782.jpg\"},\"ImageId\":298,\"ImageURL\":null,\"Languages\":\"Español English\",\"Lunch\":null,\"ModifiedUTC\":\"2019-07-29T13:41:54\",\"ModifiedUserId\":1,\"Name\":\"Steaks by Luis (Full menu)\",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":\"2019-07-29T13:34:19\",\"CreatedUserId\":1,\"Description\":\"<p>Argentina es famosa por sus carnes, por el ritual del asado. Steaks by Luis ofrece vivir una experiencia para compartir un típico asado argentino en la casa de Luis. Luis acompaña durante toda la noche, enseña el lugar y la famosa parrilla. Sentado alrededor de una gran mesa familiar conoce a tus vecinos y hace nuevas amistades.A lo largo de la noche disfruta de gran comida, vinos de gran calidad.</p><p>La cena cuenta con cinco pasos:</p><p>1er paso: Picada de bienvenida (salame, quesos, aceitunas, empandas) acompañada con vino espumante. </p><p>2do paso: Mix de vegetales con tomates confitados, manzanas, vinagreta agridulce casera acompañados con vino Torrontés.</p><p>3er paso: Achuras, cortes variados de res y cerdo a la parrilla, salchicha de cerdo, morcilla de cerdo, salchichas y queso provoleta a la parrilla; servido con salsas típicas argentinas acompañado con vino tinto. </p><p>4to paso: Ojo de bife con vegetales y papas rusticas acompañado con vino tinto.</p><p>5to paso: Cheese cake de dulce de leche acompañado con vino mistela. </p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-07-29T13:41:54\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":447,\"Title\":\"\",\"id\":1335,\"syncVersion\":1},{\"CreatedUTC\":\"2019-07-29T13:34:19\",\"CreatedUserId\":1,\"Description\":\"<p>Argentina is famous for the meet and the ritual of making “asado”. Steaks by Luis offers to live an experience: to share a typical Argentinean barbecue. Luis joins the guests during the whole dinner, talking about this ritual making you feel like you are at Luis' home.He also invites you to move around the restaurant, meet your neighbors, join alongside the grill or just sit back, relax and enjoy the event. </p><p>The five courses dinner:</p><p>1st course: Great welcome Picada (cheese, salami, toast, dips, olives and empanadas)</p><p>accompanied by a Brut Sparkling Wine.</p><p>2nd course: Mixed vegetable salad with confit tomatoes, apples and a home-made honey</p><p>mustard vinaigrette, accompanied by a young Torrontes Wine.</p><p>3rd course: Achuras, different cuts of grilled beef and pork, pork sausage, pork blood sausage,</p><p>grilling sausage and grilled provolone cheese; served with typical Argentine sauces,</p><p>accompanied by a young Red Wine.</p><p>4th course: New York Strip Steak with mashed vegetables and rustic potatoes, accompanied by</p><p>a full body Red Wine.</p><p>5th course: Caramel cheesecake, accompanied by a Late Harvest Wine.</p>\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-07-29T13:41:54\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":447,\"Title\":\"\",\"id\":1336,\"syncVersion\":1},{\"CreatedUTC\":\"2019-07-29T13:34:19\",\"CreatedUserId\":1,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-07-29T13:41:54\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":447,\"Title\":\"\",\"id\":1337,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"PERSON\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Regular\",\"PaxMin\":null,\"id\":1,\"syncVersion\":4},\"ServiceTypeId\":1,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Jerónimo Salguero 1410, 1177 CABA\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"FABRINI LUIS MARIA\",\"CreatedUTC\":\"2019-07-26T21:01:14\",\"CreatedUserId\":1,\"CurrencyId\":null,\"Email\":\"info@steaksbyluis.com\",\"ModifiedUTC\":\"2020-04-24T02:37:49\",\"ModifiedUserId\":37,\"Name\":\"Steaks by Luis \",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 11 4824-4232 \",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"447\":[null],\"448\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:34\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:31\",\"ModifiedUserId\":27,\"Name\":\"21%\",\"Value\":21,\"id\":2,\"syncVersion\":2},\"TaxCodeId\":2,\"TaxExempt\":null,\"TaxNumber\":\"20-27087953-6\",\"id\":55,\"syncVersion\":8},\"SupplierId\":55,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{\"0\":true,\"1\":true,\"2\":false,\"3\":true,\"4\":true,\"5\":true,\"6\":false},\"id\":447,\"syncVersion\":4},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-21\",\"ServiceId\":447,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Jerónimo Salguero 1410, 1177 CABA\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"FABRINI LUIS MARIA\",\"CreatedUTC\":\"2019-07-26T21:01:14\",\"CreatedUserId\":1,\"CurrencyId\":null,\"Email\":\"info@steaksbyluis.com\",\"ModifiedUTC\":\"2020-04-24T02:37:49\",\"ModifiedUserId\":37,\"Name\":\"Steaks by Luis \",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 11 4824-4232 \",\"PrivateCostBy\":\"BASE_PERSON\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"447\":[null],\"448\":[null]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:20:34\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:31\",\"ModifiedUserId\":27,\"Name\":\"21%\",\"Value\":21,\"id\":2,\"syncVersion\":2},\"TaxCodeId\":2,\"TaxExempt\":null,\"TaxNumber\":\"20-27087953-6\",\"id\":55,\"syncVersion\":8},\"SupplierId\":55,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":15096,\"syncVersion\":1}],\"BookingId\":679,\"BoxLunch\":null,\"Breakfast\":true,\"City\":{},\"CityId\":null,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"DayNr\":18,\"Description\":null,\"Dinner\":true,\"EntranceIncluded\":null,\"GroupDayTo\":null,\"GroupDays\":null,\"HotelId\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-07-29T12:55:56\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-07-29T12:55:57\",\"ModifiedUserId\":1,\"Name\":null,\"id\":298,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/BUE/SERVICIOS/Steaks%20by%20Luis/closed-door-restaurant-in-buenos-aires-dining-experience-at-steaks-by-in-buenos-aires-152782.jpg\"},\"ImageId\":298,\"ImageURL\":null,\"Lunch\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"PaxHotel\":null,\"QuoteDate\":null,\"ShowOptionals\":null,\"Snack\":null,\"SortNr\":null,\"Title\":null,\"TransDate\":\"2020-02-21\",\"id\":8238,\"syncVersion\":1},{\"BookingDayHotels\":[],\"BookingDayServices\":[{\"BookingDayId\":8239,\"BookingDayServiceImages\":[],\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"Description\":\"<p>At the designated time you will have a private transfer to Buenos Aires International airport for your flight back home.\\n</p>\",\"Language\":{},\"LanguageId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":null,\"OrderNr\":0,\"PaymentDate\":null,\"PickupInfo\":null,\"Quote\":{\"CurrencyId\":\"USD\",\"Include\":true,\"QuoteList\":{\"0\":{\"ADT\":{\"Base\":null,\"Cost\":\"30.00\",\"Include\":true,\"Markup\":null,\"MarkupModified\":null,\"Modified\":true,\"OriginCost\":null,\"Price\":42,\"SourceCost\":\"30.00\",\"SourceCurrencyId\":\"USD\"}}}},\"QuoteDate\":null,\"ReservationNumber\":null,\"Service\":{\"BoxLunch\":null,\"Breakfast\":null,\"ByWeekDay\":null,\"City\":{\"CityDescriptions\":[{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":13,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":14,\"syncVersion\":1},{\"CityId\":1,\"CreatedUTC\":\"2020-07-23T14:47:23\",\"CreatedUserId\":1,\"Description\":null,\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":15,\"syncVersion\":1}],\"Closed\":false,\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"Latitude\":-35.36,\"Longitude\":-58.22,\"MapHidden\":null,\"ModifiedUTC\":\"2020-10-07T15:16:13\",\"ModifiedUserId\":24,\"Name\":\"Buenos Aires\",\"id\":1,\"syncVersion\":4},\"CityId\":1,\"Closed\":false,\"Comment\":\"- Los translados desde el aeropuerto incluyen 1hs de espera \\n- Los peajes, estacionamientos y gastos maleteros no están incluidos \\nTarifas peaje y Estacionamiento actualizado Diciembre 2019\\nAEP: Auto 70 - Van 130\\nEZE: Auto 270 - Van 430\\nCNX: Auto 340 - Van 560\\nTigre: Auto 200 - Van 370\\nEstacionamiento EZE: Auto 100 - Van 115\\nEstacionamiento AEP: Auto 95 - Van 120  \\n- Tarifas especiales para las fiestas, 50% más. Aplica desde el 24-Dic y 31-Dic a las 16hs, y todo el 25-Dic y 01-\\nEnero. Sujeto a disponibilidad.\\n- Los precios son para servicios con y sin guía. Punto de encuentro: hotel céntrico.\",\"Commision\":null,\"CommisionPrice\":null,\"CostBy\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"USD\",\"ModifiedUTC\":\"2020-03-28T20:30:21\",\"ModifiedUserId\":1,\"Name\":\"Peso Argentino\",\"Operation\":\"DIVIDE\",\"id\":\"ARS\",\"syncVersion\":2},\"CurrencyId\":\"ARS\",\"Dinner\":null,\"Duration\":null,\"EntranceIncluded\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Buenos Aire City tour\",\"id\":286,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/BUE/SERVICIOS/BA.jpg\"},\"ImageId\":286,\"ImageURL\":null,\"Languages\":\"Español English Italiano\",\"Lunch\":null,\"ModifiedUTC\":\"2019-07-25T13:23:37\",\"ModifiedUserId\":1,\"Name\":\"Transfer Palermo - EZE \",\"Navigation\":null,\"NotDescription\":null,\"Optional\":null,\"PaxMinQty\":null,\"PrivateCostBy\":null,\"RequiredServiceId\":null,\"ServiceCategories\":[{\"Closed\":false,\"CreatedUTC\":\"2019-07-30T18:32:02\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-08-05T13:25:39\",\"ModifiedUserId\":1,\"Name\":\"Auto\",\"ParentId\":37,\"ParentType\":\"SERVICE\",\"id\":253,\"syncVersion\":3},{\"Closed\":false,\"CreatedUTC\":\"2019-07-30T18:32:02\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2019-08-05T13:25:39\",\"ModifiedUserId\":1,\"Name\":\"Van\",\"ParentId\":37,\"ParentType\":\"SERVICE\",\"id\":254,\"syncVersion\":3}],\"ServiceClass\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Normal\",\"TaxCode\":{},\"TaxCodeId\":null,\"id\":1,\"syncVersion\":1},\"ServiceClassId\":1,\"ServiceDescriptions\":[{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>A la hora apropiada, serás trasladado al aeropuerto internacional para tomar el vuelo de regreso. \\n\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":\"2019-07-25T13:23:37\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":37,\"Title\":\"\",\"id\":105,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>At appropriate time, you will be transferred to the international airport to take your flight home.\\n\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":\"2019-07-25T13:23:37\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":37,\"Title\":\"\",\"id\":106,\"syncVersion\":1},{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"<p>All'orario stabilito, sarai trasferito all'aeroporto internazionale per prendere  il volo di ritorno.\\n</p>\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":\"2019-07-25T13:23:37\",\"ModifiedUserId\":1,\"OfferedLanguage\":false,\"Optional\":null,\"ServiceId\":37,\"Title\":\"\",\"id\":107,\"syncVersion\":1}],\"ServicePhotos\":[],\"ServiceTaxCodes\":[],\"ServiceType\":{\"Closed\":false,\"CostBy\":\"BASE\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-10-31T13:33:58\",\"ModifiedUserId\":1,\"Name\":\"Privado\",\"PaxMin\":null,\"id\":2,\"syncVersion\":5},\"ServiceTypeId\":2,\"ShowServiceType\":null,\"Snack\":null,\"Supplier\":{\"Address\":\"Uspallata 781, B1638BXA Vicente López, Buenos Aires\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"SUTRANSFER S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"reservas@sutransfer.com.ar\",\"ModifiedUTC\":\"2020-06-17T13:14:40\",\"ModifiedUserId\":20,\"Name\":\"Sutransfer\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 4837-0544\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"32\":[243,244],\"33\":[245,246],\"34\":[247,248],\"35\":[249,250],\"36\":[251,252],\"37\":[253,254],\"38\":[255,256],\"39\":[257,258],\"40\":[265,266],\"41\":[267,268],\"42\":[null],\"456\":[259,260],\"457\":[263,264],\"1042\":[301,302],\"1103\":[303,304],\"1104\":[305,306],\"1105\":[307,308],\"1106\":[309,310],\"1107\":[311,312]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:11\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:18\",\"ModifiedUserId\":27,\"Name\":\"NO GRAVADO\",\"Value\":0,\"id\":4,\"syncVersion\":2},\"TaxCodeId\":4,\"TaxExempt\":null,\"TaxNumber\":\"30-71197322-9\",\"id\":10,\"syncVersion\":32},\"SupplierId\":10,\"TaxCode\":{},\"TaxCodeId\":null,\"TemplateOnly\":null,\"Trekking\":null,\"WebSite\":null,\"WeekDays\":{},\"id\":37,\"syncVersion\":9},\"ServiceCategory\":{},\"ServiceCategoryId\":null,\"ServiceCommentDeleted\":null,\"ServiceCommentReaded\":null,\"ServiceDate\":\"2020-02-22\",\"ServiceId\":37,\"SortNr\":null,\"Status\":\"PENDING\",\"Supplier\":{\"Address\":\"Uspallata 781, B1638BXA Vicente López, Buenos Aires\",\"Closed\":false,\"Comment\":null,\"Commision\":null,\"CommisionPrice\":null,\"CompanyName\":\"SUTRANSFER S.R.L.\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyId\":null,\"Email\":\"reservas@sutransfer.com.ar\",\"ModifiedUTC\":\"2020-06-17T13:14:40\",\"ModifiedUserId\":20,\"Name\":\"Sutransfer\",\"PaymentConditionId\":null,\"PaymentTypeId\":3,\"Phone\":\"+54 4837-0544\",\"PrivateCostBy\":\"BASE_SERVICE\",\"ServiceCategories\":[],\"ServiceCategoriesByService\":{\"32\":[243,244],\"33\":[245,246],\"34\":[247,248],\"35\":[249,250],\"36\":[251,252],\"37\":[253,254],\"38\":[255,256],\"39\":[257,258],\"40\":[265,266],\"41\":[267,268],\"42\":[null],\"456\":[259,260],\"457\":[263,264],\"1042\":[301,302],\"1103\":[303,304],\"1104\":[305,306],\"1105\":[307,308],\"1106\":[309,310],\"1107\":[311,312]},\"SupplierClassId\":null,\"SupplierDescriptions\":[],\"SupplierType\":\"SERVICE\",\"TaxBasePercent\":null,\"TaxCode\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-27T17:21:11\",\"CreatedUserId\":27,\"ModifiedUTC\":\"2020-01-30T15:13:18\",\"ModifiedUserId\":27,\"Name\":\"NO GRAVADO\",\"Value\":0,\"id\":4,\"syncVersion\":2},\"TaxCodeId\":4,\"TaxExempt\":null,\"TaxNumber\":\"30-71197322-9\",\"id\":10,\"syncVersion\":32},\"SupplierId\":10,\"VoucherDisabled\":null,\"VoucherText\":null,\"id\":14966,\"syncVersion\":1}],\"BookingId\":679,\"BoxLunch\":null,\"Breakfast\":true,\"City\":{},\"CityId\":null,\"CreatedUTC\":\"2020-01-09T19:09:06\",\"CreatedUserId\":10,\"DayNr\":19,\"Description\":null,\"Dinner\":null,\"EntranceIncluded\":null,\"GroupDayTo\":null,\"GroupDays\":null,\"HotelId\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-19T21:22:24\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Buenos Aire City tour\",\"id\":286,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/BUE/SERVICIOS/BA.jpg\"},\"ImageId\":286,\"ImageURL\":null,\"Lunch\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"PaxHotel\":null,\"QuoteDate\":null,\"ShowOptionals\":null,\"Snack\":null,\"SortNr\":null,\"Title\":null,\"TransDate\":\"2020-02-22\",\"id\":8239,\"syncVersion\":1}],\"BookingExpenses\":[],\"BookingFlights\":[],\"BookingFormId\":null,\"BookingOptionalServices\":[],\"BookingUserShares\":[],\"Child\":null,\"Closed\":false,\"Comment\":\"<p><br></p>\",\"ConfirmedDate\":null,\"Contact\":{},\"ContactId\":null,\"CreatedUTC\":\"2020-01-09T18:50:07\",\"CreatedUserId\":10,\"Currency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"CurrencyId\":\"USD\",\"CurrencyRate\":null,\"CurrencyRates\":{\"1\":{\"FromCurrencyId\":\"EUR\",\"Rate\":1.09,\"ToCurrencyId\":\"USD\"},\"2\":{\"FromCurrencyId\":\"USD\",\"Rate\":63,\"ToCurrencyId\":\"ARS\"},\"3\":{\"FromCurrencyId\":\"USD\",\"Rate\":795,\"ToCurrencyId\":\"CLP\"}},\"CustomerType\":{\"Agency\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Markup\":30,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Consumidor Final\",\"id\":1,\"syncVersion\":1},\"CustomerTypeId\":1,\"DestinationHostUser\":{},\"DestinationHostUserId\":null,\"Difficulty\":\"MODERATE\",\"Documentation\":{},\"EmergencyContacts\":null,\"EndDate\":\"2020-02-22\",\"FinalTotalWithFlights\":18687.2,\"FixedPrices\":null,\"FlightsURL\":null,\"Hash\":\"3e11ab46-ee94-4d6f-bc1b-0e80d24ff8ce\",\"HotelStatus\":null,\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2020-01-09T19:19:40\",\"CreatedUserId\":10,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Chalten Portada\",\"id\":468,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Chalten/Fotos%20varias%20%26%20Treks/Travesia-El-Chalten-in-Patagonia.jpg\"},\"ImageId\":468,\"ImageURL\":null,\"Include\":\"<ul><li>Transfers from – to the airport</li><li>4 nights accommodation in Buenos Aires, 3 in El Chalten, 2 in El Calafate, 4 in Ushuaia, 3 in Bariloche &amp; 3 in Mendoza.</li><li>Tours described in the itinerary.</li><li>Bilingual guides (Spanish – English)</li><li>Internal Flights (Please note that this is the cheapest rate and could change in the moment you confirm the trip)</li><li>National Park Entrance Fees (Los Glaciares, Tierra del Fuego, Harberton Ranch, Nahuel Huapi)</li></ul>\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"Markup\":40,\"ModifiedUTC\":\"2021-06-02T10:10:32\",\"ModifiedUserId\":1,\"NotInclude\":\"<ul><li>International Flights</li><li>City Tax (Bariloche - AR$ 150 per person per night)</li><li>Tarvel Insurance</li><li>Personal expenses</li></ul>\",\"OperUser\":{\"AccessGroupId\":7,\"AgencyId\":null,\"ChangePassword\":null,\"Closed\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"DecimalSeparator\":null,\"Department\":{\"Closed\":false,\"CreatedUTC\":\"2019-08-07T19:19:12\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2020-03-23T13:43:01\",\"ModifiedUserId\":1,\"Name\":\"Operaciones\",\"Oper\":true,\"Sales\":null,\"id\":1,\"syncVersion\":2},\"DepartmentId\":1,\"Email\":\"operaciones@argentinaonthego.com\",\"EmailIntro\":\"<p>Buenos dias</p><p>Les paso una reserva</p>\",\"FirstName\":\"Agustin\",\"Image\":{},\"ImageId\":null,\"ImageURL\":null,\"LastName\":\"Boubee\",\"ModifiedUTC\":\"2021-04-30T17:29:01\",\"ModifiedUserId\":1,\"Name\":\"agustin\",\"Phone\":\"+54 11 5368-5833\",\"Profile\":null,\"Signature\":\"<p>Aguardo confirmacion y liquidacion</p><p>Muchas graci</p><p><span style=\\\"color: rgb(34, 34, 34);\\\">--&nbsp;</span></p><p><strong style=\\\"color: rgb(7, 55, 99);\\\">Agustin Boubee</strong></p><p><em>Operaciones</em></p><p><br></p><p><a href=\\\"https://goo.gl/maps/vhpvPAgWB5D2\\\" target=\\\"_blank\\\" style=\\\"color: rgb(17, 85, 204);\\\">Thames 1872</a>&nbsp;Office&nbsp;<a href=\\\"https://www.youtube.com/watch?v=wK5fB07Nj_A\\\" target=\\\"_blank\\\" style=\\\"color: rgb(17, 85, 204);\\\">I</a>. Palermo. Buenos Aires</p><p>Tel ARG +54 11 5368-5833</p><p><strong>Celular de emergencia</strong>&nbsp;+54 9 11 5909-8984</p><p>Skype: agustinargentinaonthego</p><p><a href=\\\"http://www.argentinaonthego.com/\\\" target=\\\"_blank\\\" style=\\\"color: rgb(17, 85, 204);\\\">www.argentinaonthego.com</a></p>\",\"Skype\":null,\"UserName\":\"agustin\",\"UserProfiles\":[{\"CreatedUTC\":\"2020-03-30T13:58:10\",\"CreatedUserId\":20,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"es\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Español\",\"id\":1,\"syncVersion\":2},\"LanguageId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"UserId\":20,\"id\":10,\"syncVersion\":1},{\"CreatedUTC\":\"2020-03-30T13:58:10\",\"CreatedUserId\":20,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"en\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":\"2019-09-25T16:54:45\",\"ModifiedUserId\":1,\"Name\":\"English\",\"id\":2,\"syncVersion\":3},\"LanguageId\":2,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"UserId\":20,\"id\":11,\"syncVersion\":1},{\"CreatedUTC\":\"2020-03-30T13:58:10\",\"CreatedUserId\":20,\"Description\":\"\",\"Language\":{\"Closed\":false,\"Code\":\"it\",\"CreatedUTC\":null,\"CreatedUserId\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Italiano\",\"id\":3,\"syncVersion\":2},\"LanguageId\":3,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"UserId\":20,\"id\":12,\"syncVersion\":1}],\"id\":20,\"syncVersion\":10},\"OperUserId\":20,\"PaxCountryType\":\"NOT_RESIDENT\",\"PaxEmail\":null,\"PaxFeedback\":null,\"PaxFrom\":null,\"PaxName\":\"Barclay Janet\",\"PaxPhone\":null,\"PaxQuantity\":null,\"PaxTo\":null,\"PriceBreakdown\":null,\"PriceCurrency\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"CurrencyConvertId\":\"ARS\",\"ModifiedUTC\":\"2020-03-28T20:31:10\",\"ModifiedUserId\":1,\"Name\":\"US Dolar\",\"Operation\":\"MULTIPLY\",\"id\":\"USD\",\"syncVersion\":2},\"PriceCurrencyId\":\"USD\",\"ProfitSummary\":{},\"QuoteBy\":null,\"QuoteDate\":null,\"RoomConfiguration\":[{\"QuoteList\":{},\"Room\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"DBL\",\"Pax\":2,\"id\":2,\"syncVersion\":1},\"RoomTypeId\":2,\"Rooms\":1,\"Status\":\"PENDING\"}],\"SalesOrigin\":{\"Closed\":false,\"CreatedUTC\":\"2019-07-25T13:11:33\",\"CreatedUserId\":3,\"CustomerType\":{\"Agency\":null,\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Markup\":30,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Consumidor Final\",\"id\":1,\"syncVersion\":1},\"CustomerTypeId\":1,\"ImageName\":\"tm.png\",\"Markup\":null,\"ModifiedUTC\":\"2020-01-17T15:02:34\",\"ModifiedUserId\":1,\"Name\":\"Trip Me\",\"id\":7,\"syncVersion\":3},\"SalesOriginId\":7,\"SalesUser\":{\"AccessGroup\":{\"CreatedUTC\":null,\"CreatedUserId\":null,\"Description\":\"Ventas\",\"ModifiedUTC\":\"2020-11-30T14:02:39\",\"ModifiedUserId\":1,\"Name\":\"Ventas\",\"Permissions\":\"{\\\"access_group\\\":[\\\"1\\\"],\\\"api\\\":{\\\"sales_actions\\\":{\\\"methods\\\":{\\\"DELETE\\\":false,\\\"GET\\\":true,\\\"POST\\\":true}},\\\"split_quote_dates\\\":{\\\"methods\\\":{\\\"DELETE\\\":false,\\\"GET\\\":true,\\\"POST\\\":false}}},\\\"view\\\":{\\\"/bookingform\\\":{\\\"methods\\\":{\\\"DELETE\\\":false,\\\"GET\\\":true,\\\"POST\\\":false}},\\\"/bookings\\\":{\\\"methods\\\":{\\\"DELETE\\\":false,\\\"GET\\\":false,\\\"POST\\\":false}},\\\"/oper_menu/\\\":{\\\"methods\\\":{\\\"DELETE\\\":false,\\\"GET\\\":false,\\\"POST\\\":false}},\\\"/packages\\\":{\\\"methods\\\":{\\\"DELETE\\\":false,\\\"GET\\\":false,\\\"POST\\\":false}},\\\"/reports/bookingsbysalesuser\\\":{\\\"methods\\\":{\\\"DELETE\\\":false,\\\"GET\\\":true,\\\"POST\\\":false}},\\\"/reports/operpayments\\\":{\\\"methods\\\":{\\\"DELETE\\\":false,\\\"GET\\\":false,\\\"POST\\\":false}},\\\"/reports/payments\\\":{\\\"methods\\\":{\\\"DELETE\\\":false,\\\"GET\\\":false,\\\"POST\\\":false}},\\\"/reports/salesbudget\\\":{\\\"methods\\\":{\\\"DELETE\\\":false,\\\"GET\\\":true,\\\"POST\\\":false}},\\\"/reports/salesbyuser\\\":{\\\"methods\\\":{\\\"DELETE\\\":false,\\\"GET\\\":true,\\\"POST\\\":false}},\\\"/sales_menu/\\\":{\\\"methods\\\":{\\\"DELETE\\\":false,\\\"GET\\\":true,\\\"POST\\\":false}},\\\"/template\\\":{\\\"methods\\\":{\\\"DELETE\\\":false,\\\"GET\\\":true,\\\"POST\\\":false}},\\\"/admin_menu/\\\":{\\\"methods\\\":{\\\"DELETE\\\":false,\\\"GET\\\":false,\\\"POST\\\":false}}}}\",\"id\":6,\"permissions\":{\"access_group\":[\"1\"],\"api\":{\"sales_actions\":{\"methods\":{\"DELETE\":false,\"GET\":true,\"POST\":true}},\"split_quote_dates\":{\"methods\":{\"DELETE\":false,\"GET\":true,\"POST\":false}}},\"view\":{\"/admin_menu/\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/bookingform\":{\"methods\":{\"DELETE\":false,\"GET\":true,\"POST\":false}},\"/bookings\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/oper_menu/\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/packages\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/reports/bookingsbysalesuser\":{\"methods\":{\"DELETE\":false,\"GET\":true,\"POST\":false}},\"/reports/operpayments\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/reports/payments\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/reports/salesbudget\":{\"methods\":{\"DELETE\":false,\"GET\":true,\"POST\":false}},\"/reports/salesbyuser\":{\"methods\":{\"DELETE\":false,\"GET\":true,\"POST\":false}},\"/sales_menu/\":{\"methods\":{\"DELETE\":false,\"GET\":true,\"POST\":false}},\"/template\":{\"methods\":{\"DELETE\":false,\"GET\":true,\"POST\":false}}}},\"permissionsMerge\":{\"api\":{\"sales_actions\":{\"methods\":{\"DELETE\":false,\"GET\":true,\"POST\":true}},\"split_quote_dates\":{\"methods\":{\"DELETE\":false,\"GET\":true,\"POST\":false}}},\"view\":{\"/admin_menu/\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/bookingform\":{\"methods\":{\"DELETE\":false,\"GET\":true,\"POST\":false}},\"/bookings\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/city\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/currencyrate\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/finaltextmail\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/hotelcategory\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/images\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/includes\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/oper_menu/\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/packages\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/period\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/reports/bookingsbysalesuser\":{\"methods\":{\"DELETE\":false,\"GET\":true,\"POST\":false}},\"/reports/operpayments\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/reports/payments\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/reports/salesbudget\":{\"methods\":{\"DELETE\":false,\"GET\":true,\"POST\":false}},\"/reports/salesbyuser\":{\"methods\":{\"DELETE\":false,\"GET\":true,\"POST\":false}},\"/roomtype\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/sales_menu/\":{\"methods\":{\"DELETE\":false,\"GET\":true,\"POST\":false}},\"/salesorigin\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/salestarget\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/service\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/servicecategory\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/serviceclass\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/services_menu/\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/servicetype\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/settings_menu/\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/station\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/supplierall\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/system_menu/\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/template\":{\"methods\":{\"DELETE\":false,\"GET\":true,\"POST\":false}},\"/termsandconditions\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/textsummary\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"/tripmode\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}},\"finance_menu\":{\"methods\":{\"DELETE\":false,\"GET\":false,\"POST\":false}}}},\"syncVersion\":18},\"AccessGroupId\":6,\"AgencyId\":null,\"ChangePassword\":false,\"Closed\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"DecimalSeparator\":null,\"Department\":{\"Closed\":false,\"CreatedUTC\":\"2019-08-07T19:19:18\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2020-03-23T13:43:07\",\"ModifiedUserId\":1,\"Name\":\"Ventas\",\"Oper\":null,\"Sales\":true,\"id\":2,\"syncVersion\":2},\"DepartmentId\":2,\"Email\":\"ezequiel@argentinaonthego.com\",\"EmailIntro\":null,\"FirstName\":\"Ezequiel\",\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-05T13:35:01\",\"CreatedUserId\":10,\"ModifiedUTC\":\"2019-11-05T13:35:01\",\"ModifiedUserId\":10,\"Name\":\"Eze\",\"id\":577,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Fotos%20de%20Perfil/Ezeq%20Perfil.jpg\"},\"ImageId\":577,\"ImageURL\":null,\"LastName\":\"Fernandez Estelrich\",\"ModifiedUTC\":\"2019-08-07T19:20:05\",\"ModifiedUserId\":1,\"Name\":\"ezequiel\",\"Phone\":\"+1 305 424 1302\",\"Profile\":\"Born and raised in Buenos Aires City. I grew up neutering Buenos Aires streets, enjoying the beautiful melancholy of Tango music. Learning about life, but always knowing there was more for me out there.\\nI began my studies at Buenos Aires University (UBA) to be a Social Communicator. After a few years on the career and many journeys around Argentina & South America, I decided to make a turn in my life. I studied tourism and have been helping others sharing my knowledge and my passion for the last 8 years. \\nThis amazing job gave me the opportunity to get in touch with people all around the globe and share with them the excitement fo planing such adventure around Argentina & South America. \\nI organize trips all across Argentina, also Chile, Bolivia, Peru, Brasil & Uruguay. Luxury, classic, adventure, all custom-made trips, depending on your desire. \\nI look forward to being part of your next great adventure in Argentina & South America!\",\"Signature\":null,\"Skype\":\"ezequiel@argentinaonthego\",\"UserName\":\"ezequiel\",\"UserProfiles\":[],\"id\":10,\"syncVersion\":4},\"SalesUserId\":10,\"ServiceStatus\":null,\"ShowDates\":true,\"ShowPriceBy\":\"PERSON\",\"ShowServiceLanguage\":null,\"SplitQuoteDate\":null,\"StartDate\":\"2020-02-03\",\"Status\":\"QUOTE\",\"SubTitle\":null,\"SumByType\":\"ONE_TOTAL\",\"Summary\":\"<p>Argentina boasts a diverse natural richness. From inhospitable Patagonia to the colored mountains of Salta and Jujuy, this country will surprise you with its diversity and contrasts. Every corner offers a unique, and in most cases, unknown landscape.\\nThe richness of its culture and the warmth of its people turns Argentina into the perfect destination. The culinary offering must not be forgotten; anyone who visits here will be able to revel in the famous local delicacies, all of which are a product of the fusion of indigenous and European recipes. Meats, empanadas, humitas, casseroles, pasta and pizzas are just some of the culinary delights that will always be accompanied by a good Malbec.\\n</p>\",\"TemplateType\":\"NONE\",\"Title\":\"Majestic Argentina Adventure trip\",\"Totals\":{\"0\":{\"ADT\":{\"Cost\":3337,\"Pax\":\"4\",\"Price\":4671.8,\"Rooms\":{\"2\":{\"Closed\":false,\"CreatedUTC\":null,\"CreatedUserId\":null,\"ExtraBed\":null,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"DBL\",\"Pax\":2,\"id\":2,\"syncVersion\":1}},\"Selected\":true}}},\"TotalsByHotel\":null,\"TotalsBySupplier\":null,\"TripMode\":{\"Closed\":false,\"CreatedUTC\":\"2019-07-25T13:11:47\",\"CreatedUserId\":3,\"ModifiedUTC\":\"2019-10-23T15:39:30\",\"ModifiedUserId\":1,\"Name\":\"Adventure\",\"id\":1,\"syncVersion\":2},\"TripModeId\":1,\"User\":{\"AccessGroupId\":6,\"AgencyId\":null,\"ChangePassword\":false,\"Closed\":null,\"CreatedUTC\":null,\"CreatedUserId\":null,\"DecimalSeparator\":null,\"Department\":{\"Closed\":false,\"CreatedUTC\":\"2019-08-07T19:19:18\",\"CreatedUserId\":1,\"ModifiedUTC\":\"2020-03-23T13:43:07\",\"ModifiedUserId\":1,\"Name\":\"Ventas\",\"Oper\":null,\"Sales\":true,\"id\":2,\"syncVersion\":2},\"DepartmentId\":2,\"Email\":\"ezequiel@argentinaonthego.com\",\"EmailIntro\":null,\"FirstName\":\"Ezequiel\",\"Image\":{\"Closed\":false,\"CreatedUTC\":\"2019-11-05T13:35:01\",\"CreatedUserId\":10,\"ModifiedUTC\":\"2019-11-05T13:35:01\",\"ModifiedUserId\":10,\"Name\":\"Eze\",\"id\":577,\"syncVersion\":1,\"url\":\"https://storage.googleapis.com/onthego-app/prod/images/Fotos%20de%20Perfil/Ezeq%20Perfil.jpg\"},\"ImageId\":577,\"ImageURL\":null,\"LastName\":\"Fernandez Estelrich\",\"ModifiedUTC\":\"2019-08-07T19:20:05\",\"ModifiedUserId\":1,\"Name\":\"ezequiel\",\"Phone\":\"+1 305 424 1302\",\"Profile\":\"Born and raised in Buenos Aires City. I grew up neutering Buenos Aires streets, enjoying the beautiful melancholy of Tango music. Learning about life, but always knowing there was more for me out there.\\nI began my studies at Buenos Aires University (UBA) to be a Social Communicator. After a few years on the career and many journeys around Argentina & South America, I decided to make a turn in my life. I studied tourism and have been helping others sharing my knowledge and my passion for the last 8 years. \\nThis amazing job gave me the opportunity to get in touch with people all around the globe and share with them the excitement fo planing such adventure around Argentina & South America. \\nI organize trips all across Argentina, also Chile, Bolivia, Peru, Brasil & Uruguay. Luxury, classic, adventure, all custom-made trips, depending on your desire. \\nI look forward to being part of your next great adventure in Argentina & South America!\",\"Signature\":null,\"Skype\":\"ezequiel@argentinaonthego\",\"UserName\":\"ezequiel\",\"UserProfiles\":[],\"id\":10,\"syncVersion\":4},\"UserId\":10,\"VoucherComments\":{},\"id\":679,\"syncVersion\":31}");

/***/ }),

/***/ 68813:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8818);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var GoogleDriveFile = /*#__PURE__*/function (_View) {
  function GoogleDriveFile() {
    _classCallCheck(this, GoogleDriveFile);
    return _callSuper(this, GoogleDriveFile, arguments);
  }
  _inherits(GoogleDriveFile, _View);
  return _createClass(GoogleDriveFile, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(GoogleDriveFile, "getTableOptions", this, 2)([this.options()]);
            case 2:
              res = _context.sent;
              res.actions = [{
                label: 'Reprocesar',
                method: 'reprocess',
                id: 'reprocess',
                disabledIf: function disabledIf(record) {
                  if (record.Status !== 'PENDING' && record.Status !== 'FAILED') return true;
                }
              }];
              return _context.abrupt("return", res);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_0__["default"]);
_defineProperty(GoogleDriveFile, "table", 'googledrivefile');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (GoogleDriveFile);

/***/ }),

/***/ 68961:
/***/ ((__unused_webpack_module, exports) => {

var indexOf = function (xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for (var i = 0; i < xs.length; i++) {
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    if (context) {
        forEach(Object_keys(ctx), function (key) {
            context[key] = ctx[key];
        });
    }

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.isContext = function (context) {
    return context instanceof Context;
};

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};


/***/ }),

/***/ 69042:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_model_record__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55539);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var PaxLead = /*#__PURE__*/function (_Record) {
  function PaxLead() {
    _classCallCheck(this, PaxLead);
    return _callSuper(this, PaxLead, arguments);
  }
  _inherits(PaxLead, _Record);
  return _createClass(PaxLead, [{
    key: "titleName",
    get: function get() {
      if (this.PaxName && this.id) return this.id + " - " + this.PaxName;
      if (this.PaxName) return this.PaxName;
      if (this.id) return this.id;
      return '';
    }
  }, {
    key: "createQuote",
    value: function () {
      var _createQuote = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(callback) {
        var model, booking, r, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.BookingId) {
                _context.next = 3;
                break;
              }
              callback({
                err: 'Cotización ya creada'
              }, null);
              return _context.abrupt("return");
            case 3:
              _context.next = 5;
              return api.importMixinModule('booking', 'model');
            case 5:
              model = _context.sent;
              _context.next = 8;
              return new model({
                isTemplate: false
              });
            case 8:
              booking = _context.sent;
              r = tools.plainObject(booking);
              this.clean(r);
              _context.next = 13;
              return api.post('/api/paxlead/create_booking/' + this.id, JSON.stringify(r), null, callback);
            case 13:
              res = _context.sent;
              //let res = await api.post('/api/paxlead/create_booking/' + this.id, {}, {}, callback);
              if (res) {
                api.updateToStore('paxlead', res);
              }
              if (res && callback) {
                callback(null, {
                  record: res,
                  route: {
                    table: 'booking',
                    id: res.BookingId,
                    'name': 'booking'
                  }
                });
              }
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createQuote(_x) {
        return _createQuote.apply(this, arguments);
      }
      return createQuote;
    }()
  }, {
    key: "afterEdit",
    value: function afterEdit() {
      return {
        CustomerTypeId: function () {
          var _CustomerTypeId = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(r) {
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  if (r.CustomerType && !r.CustomerType.Agency) {
                    r.AgencyId = null;
                  }
                case 1:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          function CustomerTypeId(_x2) {
            return _CustomerTypeId.apply(this, arguments);
          }
          return CustomerTypeId;
        }()
      };
    }
  }]);
}(_base_model_record__WEBPACK_IMPORTED_MODULE_0__["default"]);
_defineProperty(PaxLead, "moduleName", 'paxlead');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PaxLead);

/***/ }),

/***/ 69203:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64467);
/* harmony import */ var _base_model_record__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55539);






function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var Service = /*#__PURE__*/function (_Record) {
  function Service() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, Service);
    return _callSuper(this, Service, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(Service, _Record);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(Service, [{
    key: "languageOffered",
    get: function get() {
      if (!this.ServiceDescriptions) return;
      var res = [];
      var _iterator = _createForOfIteratorHelper(this.ServiceDescriptions),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var d = _step.value;
          if (d.OfferedLanguage) {
            res.push(d.Language.Name);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return res.join(', ');
    }
  }]);
}(_base_model_record__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(Service, "moduleName", 'service');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Service);

/***/ }),

/***/ 69330:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone:
                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                    '_'
                ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                      ? 'n'
                      : number === 3
                        ? 'r'
                        : number === 4
                          ? 't'
                          : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


/***/ }),

/***/ 69532:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays:
            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
                '_'
            ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


/***/ }),

/***/ 69900:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 *  big.js v5.2.2
 *  A small, fast, easy-to-use library for arbitrary-precision decimal arithmetic.
 *  Copyright (c) 2018 Michael Mclaughlin <M8ch88l@gmail.com>
 *  https://github.com/MikeMcl/big.js/LICENCE
 */
;(function (GLOBAL) {
  'use strict';
  var Big,


/************************************** EDITABLE DEFAULTS *****************************************/


    // The default values below must be integers within the stated ranges.

    /*
     * The maximum number of decimal places (DP) of the results of operations involving division:
     * div and sqrt, and pow with negative exponents.
     */
    DP = 20,          // 0 to MAX_DP

    /*
     * The rounding mode (RM) used when rounding to the above decimal places.
     *
     *  0  Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)
     *  1  To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)
     *  2  To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)
     *  3  Away from zero.                                  (ROUND_UP)
     */
    RM = 1,             // 0, 1, 2 or 3

    // The maximum value of DP and Big.DP.
    MAX_DP = 1E6,       // 0 to 1000000

    // The maximum magnitude of the exponent argument to the pow method.
    MAX_POWER = 1E6,    // 1 to 1000000

    /*
     * The negative exponent (NE) at and beneath which toString returns exponential notation.
     * (JavaScript numbers: -7)
     * -1000000 is the minimum recommended exponent value of a Big.
     */
    NE = -7,            // 0 to -1000000

    /*
     * The positive exponent (PE) at and above which toString returns exponential notation.
     * (JavaScript numbers: 21)
     * 1000000 is the maximum recommended exponent value of a Big.
     * (This limit is not enforced or checked.)
     */
    PE = 21,            // 0 to 1000000


/**************************************************************************************************/


    // Error messages.
    NAME = '[big.js] ',
    INVALID = NAME + 'Invalid ',
    INVALID_DP = INVALID + 'decimal places',
    INVALID_RM = INVALID + 'rounding mode',
    DIV_BY_ZERO = NAME + 'Division by zero',

    // The shared prototype object.
    P = {},
    UNDEFINED = void 0,
    NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;


  /*
   * Create and return a Big constructor.
   *
   */
  function _Big_() {

    /*
     * The Big constructor and exported function.
     * Create and return a new instance of a Big number object.
     *
     * n {number|string|Big} A numeric value.
     */
    function Big(n) {
      var x = this;

      // Enable constructor usage without new.
      if (!(x instanceof Big)) return n === UNDEFINED ? _Big_() : new Big(n);

      // Duplicate.
      if (n instanceof Big) {
        x.s = n.s;
        x.e = n.e;
        x.c = n.c.slice();
      } else {
        parse(x, n);
      }

      /*
       * Retain a reference to this Big constructor, and shadow Big.prototype.constructor which
       * points to Object.
       */
      x.constructor = Big;
    }

    Big.prototype = P;
    Big.DP = DP;
    Big.RM = RM;
    Big.NE = NE;
    Big.PE = PE;
    Big.version = '5.2.2';

    return Big;
  }


  /*
   * Parse the number or string value passed to a Big constructor.
   *
   * x {Big} A Big number instance.
   * n {number|string} A numeric value.
   */
  function parse(x, n) {
    var e, i, nl;

    // Minus zero?
    if (n === 0 && 1 / n < 0) n = '-0';
    else if (!NUMERIC.test(n += '')) throw Error(INVALID + 'number');

    // Determine sign.
    x.s = n.charAt(0) == '-' ? (n = n.slice(1), -1) : 1;

    // Decimal point?
    if ((e = n.indexOf('.')) > -1) n = n.replace('.', '');

    // Exponential form?
    if ((i = n.search(/e/i)) > 0) {

      // Determine exponent.
      if (e < 0) e = i;
      e += +n.slice(i + 1);
      n = n.substring(0, i);
    } else if (e < 0) {

      // Integer.
      e = n.length;
    }

    nl = n.length;

    // Determine leading zeros.
    for (i = 0; i < nl && n.charAt(i) == '0';) ++i;

    if (i == nl) {

      // Zero.
      x.c = [x.e = 0];
    } else {

      // Determine trailing zeros.
      for (; nl > 0 && n.charAt(--nl) == '0';);
      x.e = e - i - 1;
      x.c = [];

      // Convert string to array of digits without leading/trailing zeros.
      for (e = 0; i <= nl;) x.c[e++] = +n.charAt(i++);
    }

    return x;
  }


  /*
   * Round Big x to a maximum of dp decimal places using rounding mode rm.
   * Called by stringify, P.div, P.round and P.sqrt.
   *
   * x {Big} The Big to round.
   * dp {number} Integer, 0 to MAX_DP inclusive.
   * rm {number} 0, 1, 2 or 3 (DOWN, HALF_UP, HALF_EVEN, UP)
   * [more] {boolean} Whether the result of division was truncated.
   */
  function round(x, dp, rm, more) {
    var xc = x.c,
      i = x.e + dp + 1;

    if (i < xc.length) {
      if (rm === 1) {

        // xc[i] is the digit after the digit that may be rounded up.
        more = xc[i] >= 5;
      } else if (rm === 2) {
        more = xc[i] > 5 || xc[i] == 5 &&
          (more || i < 0 || xc[i + 1] !== UNDEFINED || xc[i - 1] & 1);
      } else if (rm === 3) {
        more = more || !!xc[0];
      } else {
        more = false;
        if (rm !== 0) throw Error(INVALID_RM);
      }

      if (i < 1) {
        xc.length = 1;

        if (more) {

          // 1, 0.1, 0.01, 0.001, 0.0001 etc.
          x.e = -dp;
          xc[0] = 1;
        } else {

          // Zero.
          xc[0] = x.e = 0;
        }
      } else {

        // Remove any digits after the required decimal places.
        xc.length = i--;

        // Round up?
        if (more) {

          // Rounding up may mean the previous digit has to be rounded up.
          for (; ++xc[i] > 9;) {
            xc[i] = 0;
            if (!i--) {
              ++x.e;
              xc.unshift(1);
            }
          }
        }

        // Remove trailing zeros.
        for (i = xc.length; !xc[--i];) xc.pop();
      }
    } else if (rm < 0 || rm > 3 || rm !== ~~rm) {
      throw Error(INVALID_RM);
    }

    return x;
  }


  /*
   * Return a string representing the value of Big x in normal or exponential notation.
   * Handles P.toExponential, P.toFixed, P.toJSON, P.toPrecision, P.toString and P.valueOf.
   *
   * x {Big}
   * id? {number} Caller id.
   *         1 toExponential
   *         2 toFixed
   *         3 toPrecision
   *         4 valueOf
   * n? {number|undefined} Caller's argument.
   * k? {number|undefined}
   */
  function stringify(x, id, n, k) {
    var e, s,
      Big = x.constructor,
      z = !x.c[0];

    if (n !== UNDEFINED) {
      if (n !== ~~n || n < (id == 3) || n > MAX_DP) {
        throw Error(id == 3 ? INVALID + 'precision' : INVALID_DP);
      }

      x = new Big(x);

      // The index of the digit that may be rounded up.
      n = k - x.e;

      // Round?
      if (x.c.length > ++k) round(x, n, Big.RM);

      // toFixed: recalculate k as x.e may have changed if value rounded up.
      if (id == 2) k = x.e + n + 1;

      // Append zeros?
      for (; x.c.length < k;) x.c.push(0);
    }

    e = x.e;
    s = x.c.join('');
    n = s.length;

    // Exponential notation?
    if (id != 2 && (id == 1 || id == 3 && k <= e || e <= Big.NE || e >= Big.PE)) {
      s = s.charAt(0) + (n > 1 ? '.' + s.slice(1) : '') + (e < 0 ? 'e' : 'e+') + e;

    // Normal notation.
    } else if (e < 0) {
      for (; ++e;) s = '0' + s;
      s = '0.' + s;
    } else if (e > 0) {
      if (++e > n) for (e -= n; e--;) s += '0';
      else if (e < n) s = s.slice(0, e) + '.' + s.slice(e);
    } else if (n > 1) {
      s = s.charAt(0) + '.' + s.slice(1);
    }

    return x.s < 0 && (!z || id == 4) ? '-' + s : s;
  }


  // Prototype/instance methods


  /*
   * Return a new Big whose value is the absolute value of this Big.
   */
  P.abs = function () {
    var x = new this.constructor(this);
    x.s = 1;
    return x;
  };


  /*
   * Return 1 if the value of this Big is greater than the value of Big y,
   *       -1 if the value of this Big is less than the value of Big y, or
   *        0 if they have the same value.
  */
  P.cmp = function (y) {
    var isneg,
      x = this,
      xc = x.c,
      yc = (y = new x.constructor(y)).c,
      i = x.s,
      j = y.s,
      k = x.e,
      l = y.e;

    // Either zero?
    if (!xc[0] || !yc[0]) return !xc[0] ? !yc[0] ? 0 : -j : i;

    // Signs differ?
    if (i != j) return i;

    isneg = i < 0;

    // Compare exponents.
    if (k != l) return k > l ^ isneg ? 1 : -1;

    j = (k = xc.length) < (l = yc.length) ? k : l;

    // Compare digit by digit.
    for (i = -1; ++i < j;) {
      if (xc[i] != yc[i]) return xc[i] > yc[i] ^ isneg ? 1 : -1;
    }

    // Compare lengths.
    return k == l ? 0 : k > l ^ isneg ? 1 : -1;
  };


  /*
   * Return a new Big whose value is the value of this Big divided by the value of Big y, rounded,
   * if necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
   */
  P.div = function (y) {
    var x = this,
      Big = x.constructor,
      a = x.c,                  // dividend
      b = (y = new Big(y)).c,   // divisor
      k = x.s == y.s ? 1 : -1,
      dp = Big.DP;

    if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);

    // Divisor is zero?
    if (!b[0]) throw Error(DIV_BY_ZERO);

    // Dividend is 0? Return +-0.
    if (!a[0]) return new Big(k * 0);

    var bl, bt, n, cmp, ri,
      bz = b.slice(),
      ai = bl = b.length,
      al = a.length,
      r = a.slice(0, bl),   // remainder
      rl = r.length,
      q = y,                // quotient
      qc = q.c = [],
      qi = 0,
      d = dp + (q.e = x.e - y.e) + 1;    // number of digits of the result

    q.s = k;
    k = d < 0 ? 0 : d;

    // Create version of divisor with leading zero.
    bz.unshift(0);

    // Add zeros to make remainder as long as divisor.
    for (; rl++ < bl;) r.push(0);

    do {

      // n is how many times the divisor goes into current remainder.
      for (n = 0; n < 10; n++) {

        // Compare divisor and remainder.
        if (bl != (rl = r.length)) {
          cmp = bl > rl ? 1 : -1;
        } else {
          for (ri = -1, cmp = 0; ++ri < bl;) {
            if (b[ri] != r[ri]) {
              cmp = b[ri] > r[ri] ? 1 : -1;
              break;
            }
          }
        }

        // If divisor < remainder, subtract divisor from remainder.
        if (cmp < 0) {

          // Remainder can't be more than 1 digit longer than divisor.
          // Equalise lengths using divisor with extra leading zero?
          for (bt = rl == bl ? b : bz; rl;) {
            if (r[--rl] < bt[rl]) {
              ri = rl;
              for (; ri && !r[--ri];) r[ri] = 9;
              --r[ri];
              r[rl] += 10;
            }
            r[rl] -= bt[rl];
          }

          for (; !r[0];) r.shift();
        } else {
          break;
        }
      }

      // Add the digit n to the result array.
      qc[qi++] = cmp ? n : ++n;

      // Update the remainder.
      if (r[0] && cmp) r[rl] = a[ai] || 0;
      else r = [a[ai]];

    } while ((ai++ < al || r[0] !== UNDEFINED) && k--);

    // Leading zero? Do not remove if result is simply zero (qi == 1).
    if (!qc[0] && qi != 1) {

      // There can't be more than one zero.
      qc.shift();
      q.e--;
    }

    // Round?
    if (qi > d) round(q, dp, Big.RM, r[0] !== UNDEFINED);

    return q;
  };


  /*
   * Return true if the value of this Big is equal to the value of Big y, otherwise return false.
   */
  P.eq = function (y) {
    return !this.cmp(y);
  };


  /*
   * Return true if the value of this Big is greater than the value of Big y, otherwise return
   * false.
   */
  P.gt = function (y) {
    return this.cmp(y) > 0;
  };


  /*
   * Return true if the value of this Big is greater than or equal to the value of Big y, otherwise
   * return false.
   */
  P.gte = function (y) {
    return this.cmp(y) > -1;
  };


  /*
   * Return true if the value of this Big is less than the value of Big y, otherwise return false.
   */
  P.lt = function (y) {
    return this.cmp(y) < 0;
  };


  /*
   * Return true if the value of this Big is less than or equal to the value of Big y, otherwise
   * return false.
   */
  P.lte = function (y) {
    return this.cmp(y) < 1;
  };


  /*
   * Return a new Big whose value is the value of this Big minus the value of Big y.
   */
  P.minus = P.sub = function (y) {
    var i, j, t, xlty,
      x = this,
      Big = x.constructor,
      a = x.s,
      b = (y = new Big(y)).s;

    // Signs differ?
    if (a != b) {
      y.s = -b;
      return x.plus(y);
    }

    var xc = x.c.slice(),
      xe = x.e,
      yc = y.c,
      ye = y.e;

    // Either zero?
    if (!xc[0] || !yc[0]) {

      // y is non-zero? x is non-zero? Or both are zero.
      return yc[0] ? (y.s = -b, y) : new Big(xc[0] ? x : 0);
    }

    // Determine which is the bigger number. Prepend zeros to equalise exponents.
    if (a = xe - ye) {

      if (xlty = a < 0) {
        a = -a;
        t = xc;
      } else {
        ye = xe;
        t = yc;
      }

      t.reverse();
      for (b = a; b--;) t.push(0);
      t.reverse();
    } else {

      // Exponents equal. Check digit by digit.
      j = ((xlty = xc.length < yc.length) ? xc : yc).length;

      for (a = b = 0; b < j; b++) {
        if (xc[b] != yc[b]) {
          xlty = xc[b] < yc[b];
          break;
        }
      }
    }

    // x < y? Point xc to the array of the bigger number.
    if (xlty) {
      t = xc;
      xc = yc;
      yc = t;
      y.s = -y.s;
    }

    /*
     * Append zeros to xc if shorter. No need to add zeros to yc if shorter as subtraction only
     * needs to start at yc.length.
     */
    if ((b = (j = yc.length) - (i = xc.length)) > 0) for (; b--;) xc[i++] = 0;

    // Subtract yc from xc.
    for (b = i; j > a;) {
      if (xc[--j] < yc[j]) {
        for (i = j; i && !xc[--i];) xc[i] = 9;
        --xc[i];
        xc[j] += 10;
      }

      xc[j] -= yc[j];
    }

    // Remove trailing zeros.
    for (; xc[--b] === 0;) xc.pop();

    // Remove leading zeros and adjust exponent accordingly.
    for (; xc[0] === 0;) {
      xc.shift();
      --ye;
    }

    if (!xc[0]) {

      // n - n = +0
      y.s = 1;

      // Result must be zero.
      xc = [ye = 0];
    }

    y.c = xc;
    y.e = ye;

    return y;
  };


  /*
   * Return a new Big whose value is the value of this Big modulo the value of Big y.
   */
  P.mod = function (y) {
    var ygtx,
      x = this,
      Big = x.constructor,
      a = x.s,
      b = (y = new Big(y)).s;

    if (!y.c[0]) throw Error(DIV_BY_ZERO);

    x.s = y.s = 1;
    ygtx = y.cmp(x) == 1;
    x.s = a;
    y.s = b;

    if (ygtx) return new Big(x);

    a = Big.DP;
    b = Big.RM;
    Big.DP = Big.RM = 0;
    x = x.div(y);
    Big.DP = a;
    Big.RM = b;

    return this.minus(x.times(y));
  };


  /*
   * Return a new Big whose value is the value of this Big plus the value of Big y.
   */
  P.plus = P.add = function (y) {
    var t,
      x = this,
      Big = x.constructor,
      a = x.s,
      b = (y = new Big(y)).s;

    // Signs differ?
    if (a != b) {
      y.s = -b;
      return x.minus(y);
    }

    var xe = x.e,
      xc = x.c,
      ye = y.e,
      yc = y.c;

    // Either zero? y is non-zero? x is non-zero? Or both are zero.
    if (!xc[0] || !yc[0]) return yc[0] ? y : new Big(xc[0] ? x : a * 0);

    xc = xc.slice();

    // Prepend zeros to equalise exponents.
    // Note: reverse faster than unshifts.
    if (a = xe - ye) {
      if (a > 0) {
        ye = xe;
        t = yc;
      } else {
        a = -a;
        t = xc;
      }

      t.reverse();
      for (; a--;) t.push(0);
      t.reverse();
    }

    // Point xc to the longer array.
    if (xc.length - yc.length < 0) {
      t = yc;
      yc = xc;
      xc = t;
    }

    a = yc.length;

    // Only start adding at yc.length - 1 as the further digits of xc can be left as they are.
    for (b = 0; a; xc[a] %= 10) b = (xc[--a] = xc[a] + yc[a] + b) / 10 | 0;

    // No need to check for zero, as +x + +y != 0 && -x + -y != 0

    if (b) {
      xc.unshift(b);
      ++ye;
    }

    // Remove trailing zeros.
    for (a = xc.length; xc[--a] === 0;) xc.pop();

    y.c = xc;
    y.e = ye;

    return y;
  };


  /*
   * Return a Big whose value is the value of this Big raised to the power n.
   * If n is negative, round to a maximum of Big.DP decimal places using rounding
   * mode Big.RM.
   *
   * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.
   */
  P.pow = function (n) {
    var x = this,
      one = new x.constructor(1),
      y = one,
      isneg = n < 0;

    if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) throw Error(INVALID + 'exponent');
    if (isneg) n = -n;

    for (;;) {
      if (n & 1) y = y.times(x);
      n >>= 1;
      if (!n) break;
      x = x.times(x);
    }

    return isneg ? one.div(y) : y;
  };


  /*
   * Return a new Big whose value is the value of this Big rounded using rounding mode rm
   * to a maximum of dp decimal places, or, if dp is negative, to an integer which is a
   * multiple of 10**-dp.
   * If dp is not specified, round to 0 decimal places.
   * If rm is not specified, use Big.RM.
   *
   * dp? {number} Integer, -MAX_DP to MAX_DP inclusive.
   * rm? 0, 1, 2 or 3 (ROUND_DOWN, ROUND_HALF_UP, ROUND_HALF_EVEN, ROUND_UP)
   */
  P.round = function (dp, rm) {
    var Big = this.constructor;
    if (dp === UNDEFINED) dp = 0;
    else if (dp !== ~~dp || dp < -MAX_DP || dp > MAX_DP) throw Error(INVALID_DP);
    return round(new Big(this), dp, rm === UNDEFINED ? Big.RM : rm);
  };


  /*
   * Return a new Big whose value is the square root of the value of this Big, rounded, if
   * necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
   */
  P.sqrt = function () {
    var r, c, t,
      x = this,
      Big = x.constructor,
      s = x.s,
      e = x.e,
      half = new Big(0.5);

    // Zero?
    if (!x.c[0]) return new Big(x);

    // Negative?
    if (s < 0) throw Error(NAME + 'No square root');

    // Estimate.
    s = Math.sqrt(x + '');

    // Math.sqrt underflow/overflow?
    // Re-estimate: pass x coefficient to Math.sqrt as integer, then adjust the result exponent.
    if (s === 0 || s === 1 / 0) {
      c = x.c.join('');
      if (!(c.length + e & 1)) c += '0';
      s = Math.sqrt(c);
      e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
      r = new Big((s == 1 / 0 ? '1e' : (s = s.toExponential()).slice(0, s.indexOf('e') + 1)) + e);
    } else {
      r = new Big(s);
    }

    e = r.e + (Big.DP += 4);

    // Newton-Raphson iteration.
    do {
      t = r;
      r = half.times(t.plus(x.div(t)));
    } while (t.c.slice(0, e).join('') !== r.c.slice(0, e).join(''));

    return round(r, Big.DP -= 4, Big.RM);
  };


  /*
   * Return a new Big whose value is the value of this Big times the value of Big y.
   */
  P.times = P.mul = function (y) {
    var c,
      x = this,
      Big = x.constructor,
      xc = x.c,
      yc = (y = new Big(y)).c,
      a = xc.length,
      b = yc.length,
      i = x.e,
      j = y.e;

    // Determine sign of result.
    y.s = x.s == y.s ? 1 : -1;

    // Return signed 0 if either 0.
    if (!xc[0] || !yc[0]) return new Big(y.s * 0);

    // Initialise exponent of result as x.e + y.e.
    y.e = i + j;

    // If array xc has fewer digits than yc, swap xc and yc, and lengths.
    if (a < b) {
      c = xc;
      xc = yc;
      yc = c;
      j = a;
      a = b;
      b = j;
    }

    // Initialise coefficient array of result with zeros.
    for (c = new Array(j = a + b); j--;) c[j] = 0;

    // Multiply.

    // i is initially xc.length.
    for (i = b; i--;) {
      b = 0;

      // a is yc.length.
      for (j = a + i; j > i;) {

        // Current sum of products at this digit position, plus carry.
        b = c[j] + yc[i] * xc[j - i - 1] + b;
        c[j--] = b % 10;

        // carry
        b = b / 10 | 0;
      }

      c[j] = (c[j] + b) % 10;
    }

    // Increment result exponent if there is a final carry, otherwise remove leading zero.
    if (b) ++y.e;
    else c.shift();

    // Remove trailing zeros.
    for (i = c.length; !c[--i];) c.pop();
    y.c = c;

    return y;
  };


  /*
   * Return a string representing the value of this Big in exponential notation to dp fixed decimal
   * places and rounded using Big.RM.
   *
   * dp? {number} Integer, 0 to MAX_DP inclusive.
   */
  P.toExponential = function (dp) {
    return stringify(this, 1, dp, dp);
  };


  /*
   * Return a string representing the value of this Big in normal notation to dp fixed decimal
   * places and rounded using Big.RM.
   *
   * dp? {number} Integer, 0 to MAX_DP inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   */
  P.toFixed = function (dp) {
    return stringify(this, 2, dp, this.e + dp);
  };


  /*
   * Return a string representing the value of this Big rounded to sd significant digits using
   * Big.RM. Use exponential notation if sd is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * sd {number} Integer, 1 to MAX_DP inclusive.
   */
  P.toPrecision = function (sd) {
    return stringify(this, 3, sd, sd - 1);
  };


  /*
   * Return a string representing the value of this Big.
   * Return exponential notation if this Big has a positive exponent equal to or greater than
   * Big.PE, or a negative exponent equal to or less than Big.NE.
   * Omit the sign for negative zero.
   */
  P.toString = function () {
    return stringify(this);
  };


  /*
   * Return a string representing the value of this Big.
   * Return exponential notation if this Big has a positive exponent equal to or greater than
   * Big.PE, or a negative exponent equal to or less than Big.NE.
   * Include the sign for negative zero.
   */
  P.valueOf = P.toJSON = function () {
    return stringify(this, 4);
  };


  // Export


  Big = _Big_();

  Big['default'] = Big.Big = Big;

  //AMD.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () { return Big; }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  // Node and other CommonJS-like environments that support module.exports.
  } else {}
})(this);


/***/ }),

/***/ 70082:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var inherits = __webpack_require__(56698);
var Buffer = (__webpack_require__(48287).Buffer);

var asn1 = __webpack_require__(87568);
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}


/***/ }),

/***/ 70114:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_model_record__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55539);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }

var GoogleDriveFile = /*#__PURE__*/function (_Record) {
  function GoogleDriveFile() {
    _classCallCheck(this, GoogleDriveFile);
    return _callSuper(this, GoogleDriveFile, arguments);
  }
  _inherits(GoogleDriveFile, _Record);
  return _createClass(GoogleDriveFile, [{
    key: "reprocess",
    value: function () {
      var _reprocess = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(callback) {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return api.get("/api/google_drive_reader/process_file/".concat(this.id));
            case 2:
              res = _context.sent;
              if (!res) {
                _context.next = 6;
                break;
              }
              _context.next = 6;
              return this.init(res);
            case 6:
              this._recordLoaded = true;
              if (callback) callback(null, {
                update: true
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function reprocess(_x) {
        return _reprocess.apply(this, arguments);
      }
      return reprocess;
    }()
  }]);
}(_base_model_record__WEBPACK_IMPORTED_MODULE_0__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (GoogleDriveFile);

/***/ }),

/***/ 70217:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


/***/ }),

/***/ 70786:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"From_1":"From","_From":"From","TO_":"to","_TO":"to","To_1":"To","_Add":"Add","_Due":"Valid","Cancel_":"Cancel","ROOM_NO_HOTEL":"There is no hotel on a room on night","NO_HOTEL":"There is no hotel on night","QUOTED_NOT_AMOUNT_RECEIVED":"Amount to receive is not equal to amount quoted","OVERWRITE_PRICE":"Final Price Overwrite","UNLINKED_SERVICE_PAYMENT":"has payments without linked services","NOT_ROOM_ASSIGNED":"has no room type assigned","NOT_ROOM_CAT_ASSIGNED":"has no room category assigned","HOTEL_GROSS":"Price of room in Hotel","LOWER_THAN_NET":"is lower than cost on day","NOT_COST_ON_DATE":"has no cost on date","ON_ROOM":"on room","MIN_REQUIRED":"require a minimum of","NOT_AVAILABLE_ON_DATE":"is not available on date","NOT_AVAILABLE_ON_DAYS":"is not available on days","ROOM_PAX_QUANTITY":"Quantity of pax greater than rooms capacity","SupplierDescriptions":"Descriptions","_Close":"Summary","_TOTAL":"TOTAL","_Word":"Word","FIELDS_ERRORS":"One or more fields have errors. Please review and try again","GROSS_SERVICE":"The price of service","Failed to fetch":"Internet connection error","Privado":"Private","ADT":"Adult","CHD":"Child","TL":"Tour Leader","DBL":"Double","SGL":"Single","TPL":"Triple","CPL":"Quadruple","QDPL":"Quadruple","QTPL":"Quintuple","DBL Room":"Double Room","SGL Room":"Single Room","TPL Room":"Triple Room","CPL Room":"Quadruple Room","Archiveds":"Archived","Access Group":"Users Permission","Access Groups":"Users Permissions","_May":"May","Sales Origin":"Sales Channel","Private Cost By":"Private Cost Per","Cost By":"Cost Per","USED":"CREDIT USED","_DOCS":"Documentation","_contact_person":"Person to notify in case of necessity during your trip","ON_ACCOUNT":"Credit","On Account":"Credit","Semi Privado":"Semi Private","Semi-Privado":"Semi-Private","_entrance_includes":"Entrances Included","Date Inn":"Travel Date","Date Inn From":"Travel Date From","Date Inn To":"Travel Date To","_SIGNATURE":"TRAVEL AGENT","_Allergies":"Allergies? If so, what?","NIGHT_ROOM_CATEGORY":"Program - Night and Room Category","NIGHT_ROOM_TYPE":"Program - Night and Room Type","ROOM_TYPE_CATEGORY":"Category and Room Type","ROOM_TYPE_CATEGORY_NIGHT":"Program - Night, Category and Room Type","NOT_AVAILABLE_DATE":"The start date is less than the current date","faresreportheadermessage":"Fares Report Header Message"}');

/***/ }),

/***/ 70916:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64467);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8818);






function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var MailView = /*#__PURE__*/function (_View) {
  function MailView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, MailView);
    return _callSuper(this, MailView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(MailView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(MailView, null, [{
    key: "getTableOptions",
    value: function getTableOptions() {
      return {
        fields: [{
          name: 'MailFrom',
          label: 'From_1'
        }, {
          name: 'MailTo',
          label: 'To_1'
        }, {
          name: 'MailCc',
          label: 'CC',
          hideFromList: true
        }, {
          name: 'MailBcc',
          label: 'BCC',
          hideFromList: true
        }, {
          name: 'id',
          readonly: true
        }, {
          name: 'BookingId',
          label: 'File Nr',
          readonly: true
        }, {
          name: 'CreatedUTC',
          readonly: true,
          label: 'Date'
        }, {
          name: 'UserId',
          label: 'User',
          editor: 'select',
          optionLabels: 'UserName',
          relation: 'user',
          disabled: true
        }, {
          name: 'Status',
          label: 'Status',
          editor: 'select',
          optionLabels: 'UserName',
          columns: 3,
          disabled: true,
          options: [{
            value: 'CREATED',
            label: 'Created',
            tr: true
          }, {
            value: 'PENDING',
            label: 'Pending',
            tr: true
          }, {
            value: 'SENT',
            label: 'Sent',
            tr: true
          }],
          defValue: 'PENDING'
        }, {
          name: 'Template',
          readonly: true,
          label: 'Template',
          editor: 'checkbox',
          columns: 3,
          hideFromList: true,
          bodyRow: true
        }, {
          name: 'ScheduleDelivery',
          label: 'Schedule Delivery',
          editor: 'checkbox',
          columns: 3,
          hideFromList: true,
          bodyRow: true,
          disabledIf: function disabledIf(r) {
            return r.Status == 'SENT';
          }
        }, {
          name: 'ScheduleDeliveryDate',
          label: 'Date',
          editor: 'datetime',
          columns: 3,
          hideFromList: true
        }, {
          name: 'Attach',
          label: 'Attachments',
          editor: 'attach',
          columns: 12,
          hideFromList: true
        }, {
          name: 'Subject',
          label: 'Subject',
          columns: 12
        }, {
          name: 'tab1',
          label: 'Plain Text',
          editor: 'tab',
          hideFromList: true,
          fields: [{
            name: 'MessageBody',
            editor: 'text-area',
            columns: 12,
            hideFromList: true,
            rows: 20,
            defValue: ''
          }]
        }, {
          name: 'tab2',
          label: 'Preview',
          editor: 'tab',
          hideFromList: true,
          fields: [{
            name: 'MessageBody',
            editor: 'html',
            columns: 12
          }]
        }, {
          name: 'tab3',
          label: 'Styles',
          editor: 'tab',
          hideFromList: true,
          fields: [{
            name: 'Styles',
            editor: 'text-area',
            columns: 12,
            hideFromList: true,
            rows: 20
          }]
        }, {
          name: 'tab4',
          editor: 'component',
          component: 'MailActivity',
          label: 'Activity',
          componentName: 'MailActivity',
          componentPath: 'components/tools',
          inline: true
        }, {
          name: 'MessageBody',
          label: 'Message',
          editor: 'text-area-style',
          columns: 12,
          hideFromList: true,
          hideCondition: function hideCondition(r) {
            if (r.Template) return true;
          }
        }, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)((0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)({
          name: 'MailAttachments',
          editor: [],
          label: 'MailAttachments'
        }, "label", 'Link a Adjuntos'), "rowFields", [{
          name: 'Name',
          label: 'Name',
          columns: 3
        }, {
          name: 'Key',
          label: 'Key',
          columns: 4
        }, {
          name: 'URL',
          label: 'URL',
          columns: 4
        }])],
        serverSide: true,
        canCopy: true,
        title: 'Mails',
        actions: [{
          label: 'Send',
          method: 'saveMailAndSend',
          id: 'sendMail'
        }],
        beforeSave: function beforeSave(self) {
          if (!self.MailFrom) {
            self.addError('Falta configurar casill de correo');
            return true;
          }
        }
      };
    }
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(MailView, "table", 'mail');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MailView);

/***/ }),

/***/ 70984:
/***/ ((module) => {

"use strict";


module.exports = {
  //NODE_ENV: "testing",
  SERVER_ENDPOINT: "https://api-test.nubbo.io",
  EXTRAS: ["admin", "contacts", "accounting", "crm", "arg", "vamoos", "custom"],
  FRONT_URL: "https://dev-test.nubbo.io",
  API_GOOGLE_MAP: "AIzaSyAqSLEPJ7HAQYPi07V0XSJ1rS1fKYNkRLs",
  API_GOOGLE_MAP_ID: "a2c421d48f6df0c3efb962b6",
  APP_NAME: "Designer Trips",
  MAP_ICON: "logo.png",
  DOMAINS: ["localhost", "dev-test.nubbo.io"],
  DEV_TEST: true,
  COST_CONTROL: false,
  LANG_CODE: "es",
  DEF_EXCHANGE: true,
  SERVER_SIDE: {
    'hotel': true,
    'supplier': true,
    'hotelcost': true
  }
};

/***/ }),

/***/ 71040:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"en":{"accessgroup":"Access Group","account":"Account","agency":"Agency","contact":"Contact","contacts":"Contacts","booking":"Booking","bookingadjustment":"Adjustment","bookingcommission":"Commission","bookingcatalogue":"Catalogue","bookingday":"","bookingdayhotel":"","bookingdayroom":"","bookingdayservice":"","bookingdayserviceimage":"","bookingexpense":"Expense","bookingflight":"Flight","bookingform":"Reservation Form","bookingformflight":"","bookingformpax":"","bookingnote":"Notes","bookingoptionalservice":"","bookingpayment":"Payment","bookingreceipt":"Receipt","bookingusershare":"","bookingversion":"Version","cashout":"Cash Out","city":"City","citydescription":"","country":"Country","currency":"Currency","currencyconversion":"Currency Conversion","currencyrate":"Currency Rate","customertype":"Customer Type","department":"Department","expensetype":"Expense Type","hotel":"Hotel","hotelcategory":"Hotel Category","hotelcost":"Hotel Rates","hoteldescription":"","hotelmarginrow":"","hotelphoto":"","hotelroomtype":"","image":"Image","invoice":"Invoice","invoicedetail":"","language":"Language","mail":"Mail","mailinglist":"Mailing List","mailbookinghotel":"","mailbookingservice":"","margin":"Margin","paymentcondition":"Payment Condition","paymentpurchaseinvoice":"","paymenttype":"Payment Type","period":"Period","purchaseinvoice":"Purchase Invoice","purchaseinvoicedetail":"","purchaseinvoicetax":"","region":"Region","roomcategory":"Room Category","roomtype":"Room Type","salesorigin":"Sales Channel","service":"Service","servicecategory":"Service Category","serviceclass":"Service Class","servicecost":"Service Rates","servicedescription":"","servicemarginrow":"","servicephoto":"","servicetaxcode":"","servicetype":"Service Type","settings":"Settings","state":"State","station":"Station","storepassport":"Passaport","supplier":"Supplier","supplierclass":"Supplier Class","Supplierclass":"Supplier Class","supplierservice":"Service Suppliers","supplierdescription":"","taxcode":"Tax","textsummary":"Text Summary","tripmode":"Trip Mode","user":"User","userprofile":"Profile","includes":"Travel Conditions","termsandconditions":"Terms and Conditions","report":"Report","bookingbysalesman":"Sales Quotations","sales":"Sales","mybooking":"My Bookings","mybookings":"My Bookings","mysales":"My Sales","mysale":"My Sales","salesbyuser":"Sales by User","bookingbysalesorigin":"Bookings By Sales Origin","dhschedule":"DH Schedule","salessummary":"Sales Summary","QUOTE":"Quote","CLOSED":"Closed","QUOTE_LOST":"Lost","RE_PROGRAM":"Re-Program","FINAL":"Final","payment":"Payment","packages":"Supplier Packages","bookingview":"Booking Views","Base_person":"Per Person variable","Base_service":"Per Service variable","template":"Template","crontask":"Cron Process","suppliercredit":"Credit","credit":"Credit","accountmovement":"Account Movement","notificationcode":"Notification","reportfilter":"Report Filters","estimatedcost":"Estimated Cost"},"es":{"accessgroup":"Grupo de Acceso","account":"Cuentas","agency":"Agencia","contact":"Contacto","contacts":"Contactos","booking":"Cotización","bookingadjustment":"Ajuste","bookingcommission":"Comisión","bookingcatalogue":"Catalogo","bookingday":"","bookingdayhotel":"","bookingdayroom":"","bookingdayservice":"","bookingdayserviceimage":"","bookingexpense":"Gastos de Cotización","bookingflight":"Vuelos","bookingform":"Formulario de Reservas","bookingformflight":"","bookingformpax":"","bookingnote":"Notas","bookingoptionalservice":"","bookingpayment":"Pagos","bookingreceipt":"Recibo/Cobros","bookingusershare":"","bookingversion":"Versión","cashout":"Salida de Fondos","city":"Destino","citydescription":"","country":"País","currency":"Moneda","currencyconversion":"Conversión de Monedas","currencyrate":"Cotización de Monedas","customertype":"Tipo de Cliente","department":"Área","expensetype":"Tipo de Gasto","hotel":"Hotel","hotelcategory":"Categoría de Hotel","hotelcost":"Tarifario de Hotel","hoteldescription":"","hotelmarginrow":"","hotelphoto":"","hotelroomtype":"","image":"Imagen","invoice":"Factura","invoicedetail":"","language":"Idioma","mail":"Correo","mailinglist":"Listas de Correo","mailbookinghotel":"","mailbookingservice":"","margin":"Margen","paymentcondition":"Condicion de Pago","paymentpurchaseinvoice":"","paymenttype":"Forma de Pago","period":"Temporada","purchaseinvoice":"Factura de Compra","purchaseinvoicedetail":"","purchaseinvoicetax":"","roomcategory":"Categoría de Habitación","roomtype":"Tipo de Habitación","salesorigin":"Origen de Venta","Salesorigin":"Origen de Venta","service":"Servicio","servicecategory":"Categoría de Servicio","serviceclass":"Clase de Servicio","servicecost":"Tarifario de Servicio","servicedescription":"","servicemarginrow":"","servicephoto":"","servicetaxcode":"","servicetype":"Tipo de Servicio","settings":"Opciones","state":"Provincia","station":"Aeropuerto","storepassport":"Pasaporte","supplier":"Proveedor","supplierclass":"Clase de Proveedor","supplierservice":"Operadores de Servicio","supplierdescription":"","taxcode":"Impuesto","textsummary":"Texto Intro","tripmode":"Tipo de Viaje","user":"Usuario","userprofile":"Perfil","includes":"Condiciones de Viaje","termsandconditions":"Términos y Condiciones","report":"Reporte","bookingbysalesman":"Cotizaciones por Vendedor","sales":"Ventas","mybooking":"Mis Cotizaciones","mybookings":"Mis Cotizaciones","mysales":"Mis Ventas","salesbyuser":"Ventas por Vendedor","bookingbysalesorigin":"Cotizaciones Por Canal  de Venta","dhschedule":"Agenda DH","salessummary":"Resumen de Ventas","QUOTE":"Cotización","CLOSED":"Cerrado","QUOTE_LOST":"Perdida","BLOCKED":"Bloqueo","RE_PROGRAM":"Re-Programado","FINAL":"Final","bookingview":"Visualizaciones","packages":"Paquetes Proveedores","template":"Template","crontask":"Procesos","suppliercredit":"Saldos","accountmovement":"Account Movement","notificationcode":"Notificaciones","reportfilter":"Filtros Reportes","estimatedcost":"Costos Estimados"},"it":{},"fr":{},"de":{},"nl":{},"pt":{}}');

/***/ }),

/***/ 71059:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("{\"Name\":\"Bariloche\",\"Latitude\":-41.15,\"Longitude\":-71.3,\"ImageId\":null,\"MapHidden\":null,\"Closed\":false,\"CityDescriptions\":[{\"LanguageId\":1,\"Language\":{},\"CityId\":3,\"Description\":null,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":49,\"syncVersion\":1},{\"LanguageId\":2,\"Language\":{},\"CityId\":3,\"Description\":null,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":50,\"syncVersion\":1},{\"LanguageId\":3,\"Language\":{},\"CityId\":3,\"Description\":null,\"CreatedUTC\":\"2020-10-09T12:01:47\",\"CreatedUserId\":27,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"id\":51,\"syncVersion\":1}],\"Country\":{\"Code\":\"ar\",\"CreatedUTC\":\"2020-10-06T18:18:04\",\"CreatedUserId\":1,\"ModifiedUTC\":null,\"ModifiedUserId\":null,\"Name\":\"Argentina\",\"id\":1,\"syncVersion\":1},\"CountryId\":1,\"CreatedUTC\":null,\"CreatedUserId\":null,\"Image\":{},\"ImageURL\":null,\"ModifiedUTC\":\"2020-10-09T12:01:47\",\"ModifiedUserId\":27,\"id\":3,\"syncVersion\":3}");

/***/ }),

/***/ 71096:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8818);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var CurrencyConversionView = /*#__PURE__*/function (_View) {
  function CurrencyConversionView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, CurrencyConversionView);
    return _callSuper(this, CurrencyConversionView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(CurrencyConversionView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(CurrencyConversionView, null, [{
    key: "options",
    value:
    // static table = 'currencyconversion';

    function options() {
      return {
        fieldsDataReplace: {
          URL: {
            name: 'URL',
            label: 'URL',
            hideIf: function hideIf(row) {
              return row.ConversionType != 'API';
            },
            hideFromList: true
          },
          JSONFields: {
            name: 'JSONFields',
            label: 'Codificación',
            hideIf: function hideIf(row) {
              return row.ConversionType != 'API';
            },
            hideFromList: true
          },
          FromCurrencyId: {
            name: 'FromCurrencyId',
            relation: 'currency',
            optionLabels: 'id',
            editor: 'select',
            label: 'From_1'
          },
          ToCurrencyId: {
            name: 'ToCurrencyId',
            relation: 'currency',
            optionLabels: 'id',
            editor: 'select',
            label: 'To_1'
          },
          ConversionType: {
            name: 'ConversionType',
            label: 'Conversion Type',
            editor: 'select',
            options: [{
              value: 'TABLE',
              label: 'Table',
              tr: true
            }, {
              value: 'API',
              label: 'API'
            }]
          }
        },
        canAdd: true
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(CurrencyConversionView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_4__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CurrencyConversionView);

/***/ }),

/***/ 71368:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64467);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8818);






function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var UserView = /*#__PURE__*/function (_View) {
  function UserView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, UserView);
    return _callSuper(this, UserView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(UserView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(UserView, null, [{
    key: "getTableOptions",
    value: function getTableOptions() {
      return {
        fields: [{
          name: 'UserName',
          label: 'User Name',
          required: true
        }, {
          name: 'AccessGroupId',
          relation: 'accessgroup',
          optionLabels: 'Description',
          editor: 'select',
          label: 'Access Group',
          required: true
        }, {
          name: 'FirstName',
          label: 'Name'
        }, {
          name: 'LastName',
          label: 'Last Name'
        }, {
          name: 'Email',
          label: 'Email'
        }, {
          name: 'Phone',
          label: 'Phone'
        }, {
          name: 'DepartmentId',
          relation: 'department',
          optionLabels: 'Name',
          editor: 'select',
          label: 'Department',
          addBlank: true
        }, {
          name: 'AgencyId',
          relation: 'agency',
          optionLabels: 'Name',
          addBlank: true,
          editor: 'vue-select',
          label: 'Agency'
        }, {
          name: 'DecimalSeparator',
          label: 'Decimal Separator'
        }, {
          name: 'Password',
          type: 'password'
        }, {
          name: 'ChangePassword',
          editor: 'checkbox',
          label: 'Must change password',
          bodyRow: true
        }, {
          name: 'Status',
          editor: 'select',
          label: 'Status',
          options: [{
            label: 'Active',
            value: 'ACTIVE'
          }, {
            label: 'Inactive',
            value: 'INACTIVE'
          }]
        }, {
          name: "ImageId",
          editor: "photo-div",
          hideFromList: true,
          label: 'Profile Picture',
          setRelationTo: 'Image'
        }, {
          name: 'Closed',
          editor: 'checkbox',
          label: 'Archive',
          hideFromList: true,
          footerRow: true
        }, {
          name: 'UserProfiles',
          editor: 'component',
          component: 'languages-comp',
          title: false,
          label: 'Descriptions',
          hideFromList: true,
          textStyle: true,
          rowFields: [{
            name: 'LanguageId',
            relation: 'language',
            optionLabels: 'Name',
            editor: 'select',
            setRelationTo: 'Language'
          }, {
            name: 'Description'
          }]
        }, {
          name: 'tab1',
          label: 'Emails',
          editor: 'tab',
          hideFromList: true,
          fields: [{
            name: 'EmailIntro',
            editor: 'text-area-style',
            columns: 6,
            label: 'Intro'
          }, {
            name: 'Signature',
            editor: 'text-area-style',
            columns: 6,
            label: 'Signature'
          }]
        }, {
          name: 'CreatedDate',
          label: 'Created Date',
          editor: 'date',
          computed: function computed(record) {
            return record.CreatedUTC;
          }
        }],
        title: 'User',
        canAdd: true,
        fieldsAbmList: ['UserName', 'AccessGroupId', 'FirstName', 'LastName', 'Email', 'DepartmentId', 'AgencyId', 'ChangePassword', 'Status', 'CreatedDate']
      };
    }
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(UserView, "table", 'user');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (UserView);

/***/ }),

/***/ 71788:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Invoice = api.importMixinModule('invoice', 'model', 'argafip');
var ArgAfipInvoice = /*#__PURE__*/function (_Invoice) {
  function ArgAfipInvoice() {
    _classCallCheck(this, ArgAfipInvoice);
    return _callSuper(this, ArgAfipInvoice, arguments);
  }
  _inherits(ArgAfipInvoice, _Invoice);
  return _createClass(ArgAfipInvoice, [{
    key: "sendAFIP",
    value: function () {
      var _sendAFIP = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(callback) {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this._modified) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              if (this.id) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              if (!this.CAE) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              _context.next = 8;
              return api.post('/arg/api/inv_afip/' + this.id, null, null, function (response) {
                //this.addError(response.detail);
                if (callback) callback(response, null);
              });
            case 8:
              result = _context.sent;
              if (!result) {
                _context.next = 21;
                break;
              }
              this._recordLoaded = false;
              _context.next = 13;
              return this.init(result);
            case 13:
              _context.next = 15;
              return this.getAttached();
            case 15:
              this.original_id = this.id;
              api.updateToStore(this.tableName, result);
              this.addNotification("Facturación Exitosa");
              if (result._warnings) {
                this.notifications.warning = result._warnings.join('; ');
              } else {
                this.notifications.warning = null;
              }
              this._recordLoaded = true;
              if (callback) callback(null, {
                update: true
              });
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function sendAFIP(_x) {
        return _sendAFIP.apply(this, arguments);
      }
      return sendAFIP;
    }()
  }, {
    key: "canEdit",
    get: function get() {
      if (this.CAE) return false;
      if (this.InvoiceNumber) return false;
      if (this.AfipData) return false;
      return _superPropGet(ArgAfipInvoice, "canEdit", this, 1);
    }
  }, {
    key: "canDelete",
    get: function get() {
      if (this.CAE) return false;
      if (this.InvoiceNumber) return false;
      if (this.AfipData) return false;
      return _superPropGet(ArgAfipInvoice, "canDelete", this, 1);
    }
  }]);
}(Invoice);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ArgAfipInvoice);

/***/ }),

/***/ 71799:
/***/ (() => {

window.modelTables.supplier = true;
window.modelTables.paxlead = true;
window.modelTables.surveypax = true;
window.modelTables.survey = true;

/***/ }),

/***/ 72264:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


/***/ }),

/***/ 72312:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = {
  'instanceof': __webpack_require__(98208),
  range: __webpack_require__(7197),
  regexp: __webpack_require__(35031),
  'typeof': __webpack_require__(63175),
  dynamicDefaults: __webpack_require__(99047),
  allRequired: __webpack_require__(9774),
  anyRequired: __webpack_require__(48479),
  oneRequired: __webpack_require__(99749),
  prohibited: __webpack_require__(79100),
  uniqueItemProperties: __webpack_require__(35699),
  deepProperties: __webpack_require__(12913),
  deepRequired: __webpack_require__(72397),
  formatMinimum: __webpack_require__(18377),
  formatMaximum: __webpack_require__(33963),
  patternRequired: __webpack_require__(47419),
  'switch': __webpack_require__(95314),
  select: __webpack_require__(87718),
  transform: __webpack_require__(87560)
};


/***/ }),

/***/ 72344:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = (__webpack_require__(78982).Buffer);
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);


/***/ }),

/***/ 72397:
/***/ ((module) => {

"use strict";


module.exports = function defFunc(ajv) {
  defFunc.definition = {
    type: 'object',
    inline: function (it, keyword, schema) {
      var expr = '';
      for (var i=0; i<schema.length; i++) {
        if (i) expr += ' && ';
        expr += '(' + getData(schema[i], it.dataLevel) + ' !== undefined)';
      }
      return expr;
    },
    metaSchema: {
      type: 'array',
      items: {
        type: 'string',
        format: 'json-pointer'
      }
    }
  };

  ajv.addKeyword('deepRequired', defFunc.definition);
  return ajv;
};


function getData(jsonPointer, lvl) {
  var data = 'data' + (lvl || '');
  if (!jsonPointer) return data;

  var expr = data;
  var segments = jsonPointer.split('/');
  for (var i=1; i<segments.length; i++) {
    var segment = segments[i];
    data += getProperty(unescapeJsonPointer(segment));
    expr += ' && ' + data;
  }
  return expr;
}


var IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
var INTEGER = /^[0-9]+$/;
var SINGLE_QUOTE = /'|\\/g;
function getProperty(key) {
  return INTEGER.test(key)
          ? '[' + key + ']'
          : IDENTIFIER.test(key)
            ? '.' + key
            : "['" + key.replace(SINGLE_QUOTE, '\\$&') + "']";
}


function unescapeJsonPointer(str) {
  return str.replace(/~1/g, '/').replace(/~0/g, '~');
}


/***/ }),

/***/ 72475:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays:
            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
                '_'
            ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


/***/ }),

/***/ 72492:
/***/ ((module) => {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),

/***/ 72812:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var PurchaseInvoiceMixinView = api.importMixinModule('purchaseinvoice', 'views', 'ai');
var CustomPurchaseInvoiceView = /*#__PURE__*/function (_PurchaseInvoiceMixin) {
  function CustomPurchaseInvoiceView() {
    _classCallCheck(this, CustomPurchaseInvoiceView);
    return _callSuper(this, CustomPurchaseInvoiceView, arguments);
  }
  _inherits(CustomPurchaseInvoiceView, _PurchaseInvoiceMixin);
  return _createClass(CustomPurchaseInvoiceView, null, [{
    key: "options",
    value: function options() {
      var res = _superPropGet(CustomPurchaseInvoiceView, "options", this, 2)([]);
      /*res.fields.push({
          name: 'AI_Process',
          label: 'Process with AI',
          editor: 'component',
          component: 'upload-invoice-modal',
          componentName: 'UploadInvoiceModal',
          componentPath: 'components/invoice',
          columns: 12,
      })*/
      return res;
    }
  }]);
}(PurchaseInvoiceMixinView);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomPurchaseInvoiceView);

/***/ }),

/***/ 72842:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"Accommodation":"Unterkunft","Star":"Sterne","Booked by yourself":"Booked by yourself","Type of service":"Art der Dienstleistung","Private":"Privat","Description":"Beschreibung","Price per Person":"Preis pro Person","Prices include":"Die Preise beinhalten","Prices do NOT include":"Die Preise beinhalten NICHT","ADT":"Erw","based on":"basierend auf ","pax":"Personen","International flights":"Internationaler Flug","Note":"Anmerkung","For the general conditions of":"Für die allgemeinen Bedingungen der","please click":"Sie bitte","here":"hier","Optionals":"Wahlmöglichkeiten","Total Costs Land Arrangement":"Gesamtkosten im Land-Arrangement","NTS/DAYS":"Nächte/Tage","QTY":"QTY","Date":"Datum","Location":"Sandort","DESCRIPTION":"Beschreibung","TOTAL PRICES":"Gesamtpreise","Itinerary description":"Beschreibung der Reiseroute","Confirmation":"Confirmation","Names":"Namen","Flight Schedule":"Flugplan","Itinerary":"Reiseroute","Days":"Tage","Day":"Tag","Nights":"Nächte","Head Office":"Argentinisches Büro","Invoice number":"Rechnungsnummer","Travel date":"Reisedatum","Your reference":"Ihre Referenz","Qty":"Anzahl","unit price":"Preis","total":"Gesamtbetrag","Subtotal":"Zwischensumme","Tax":"MwSt","Total in":"Gesamtbetrag","Land package as confirmed by ":"Landpaket wie bestätigt von","Land package as confirmed by Patagonien Reiseprofis travel":"Landpaket wie von Patagonien Reiseprofis bestätigt","Invoice":"Rechnung","Payments":"Zahlungen","Payable 7 days before departure":"Zahlbar 7 Tage vor der Abreise","Free cancellation until one week of departure":"Kostenlose Stornierung bis eine Woche vor Abreise","100% cancellation fee apply 7 days before departure":"100% Stornogebühren werden 7 Tage vor Abreise fällig","Please transfer the money on our Bank of Montreal account":"Bitte überweisen Sie das Geld auf unser Bank of Montreal Konto","Name of our bank account":"Name unseres Bankkontos","Our account number":"Unsere Kontonummer","BMO’s beneficiary bank information in the format":"Die begünstigte Bankverbindung von BMO im Format","Our address":"Unsere Adresse","Destination bank":"Zielbank","Customer number":"Kundennummer","Book Now":"Jetzt Reservieren","Meals Included":"Mahlzeiten inklusive","_Word":"Word","_entrance_includes":"Der eintritt beinhaltet","Travel Details":"Reisedetails","Price":"Preis","Print":"Drucken","PLEASE, CONTACT US":"Bitte kontaktieren Sie uns","Unit price":"Einheitspreis","Total":"Gesamt","Confirmed Program":"Bestätigtes Programm","Program":"Programm","Included":"Die Preise beinhalten","Excluded":"Die Preise beinhalten NICHT","Prices DON\'T include":"Die Preise beinhalten NICHT","For any additional questions, please contact your travel expert.":"Bei weiteren Fragen wenden Sie sich bitte an Ihren Reiseexperten."}');

/***/ }),

/***/ 73386:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


/***/ }),

/***/ 73635:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays:
            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
                '_'
            ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                      ? 'тан'
                      : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


/***/ }),

/***/ 73738:
/***/ ((module) => {

function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 73739:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort:
            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
                '_'
            ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


/***/ }),

/***/ 73776:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 73845:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var ruleModules = __webpack_require__(27403)
  , toHash = (__webpack_require__(96740).toHash);

module.exports = function rules() {
  var RULES = [
    { type: 'number',
      rules: [ { 'maximum': ['exclusiveMaximum'] },
               { 'minimum': ['exclusiveMinimum'] }, 'multipleOf', 'format'] },
    { type: 'string',
      rules: [ 'maxLength', 'minLength', 'pattern', 'format' ] },
    { type: 'array',
      rules: [ 'maxItems', 'minItems', 'items', 'contains', 'uniqueItems' ] },
    { type: 'object',
      rules: [ 'maxProperties', 'minProperties', 'required', 'dependencies', 'propertyNames',
               { 'properties': ['additionalProperties', 'patternProperties'] } ] },
    { rules: [ '$ref', 'const', 'enum', 'not', 'anyOf', 'oneOf', 'allOf', 'if' ] }
  ];

  var ALL = [ 'type', '$comment' ];
  var KEYWORDS = [
    '$schema', '$id', 'id', '$data', '$async', 'title',
    'description', 'default', 'definitions',
    'examples', 'readOnly', 'writeOnly',
    'contentMediaType', 'contentEncoding',
    'additionalItems', 'then', 'else'
  ];
  var TYPES = [ 'number', 'integer', 'string', 'array', 'object', 'boolean', 'null' ];
  RULES.all = toHash(ALL);
  RULES.types = toHash(TYPES);

  RULES.forEach(function (group) {
    group.rules = group.rules.map(function (keyword) {
      var implKeywords;
      if (typeof keyword == 'object') {
        var key = Object.keys(keyword)[0];
        implKeywords = keyword[key];
        keyword = key;
        implKeywords.forEach(function (k) {
          ALL.push(k);
          RULES.all[k] = true;
        });
      }
      ALL.push(keyword);
      var rule = RULES.all[keyword] = {
        keyword: keyword,
        code: ruleModules[keyword],
        implements: implKeywords
      };
      return rule;
    });

    RULES.all.$comment = {
      keyword: '$comment',
      code: ruleModules.$comment
    };

    if (group.type) RULES.types[group.type] = group;
  });

  RULES.keywords = toHash(ALL.concat(KEYWORDS));
  RULES.custom = {};

  return RULES;
};


/***/ }),

/***/ 73892:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8818);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingDayServiceImageView = /*#__PURE__*/function (_View) {
  function BookingDayServiceImageView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingDayServiceImageView);
    return _callSuper(this, BookingDayServiceImageView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingDayServiceImageView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingDayServiceImageView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", {
                fields: [{
                  name: 'ImageId',
                  relation: 'image',
                  optionLabels: 'Name',
                  editor: 'select',
                  label: 'Image',
                  setRelationTo: 'Image'
                }]
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingDayServiceImageView, "table", 'bookingflightquote');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingDayServiceImageView);

/***/ }),

/***/ 73987:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51941);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingExpense = /*#__PURE__*/function (_BookingBaseModel) {
  function BookingExpense() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingExpense);
    return _callSuper(this, BookingExpense, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingExpense, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingExpense, [{
    key: "booking",
    get: function get() {
      return this.$parent;
    }
  }, {
    key: "afterEdit",
    value: function afterEdit() {
      var _this = this;
      return {
        Amount: function () {
          var _Amount = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(r) {
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _this.setAmount(r);
                case 1:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function Amount(_x) {
            return _Amount.apply(this, arguments);
          }
          return Amount;
        }()
      };
    }
  }, {
    key: "setAmount",
    value: function () {
      var _setAmount = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(r) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function setAmount(_x2) {
        return _setAmount.apply(this, arguments);
      }
      return setAmount;
    }()
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingExpense, "moduleName", 'bookingexpense');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingExpense);

/***/ }),

/***/ 74011:
/***/ ((module) => {

module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821',
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf',
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695',
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9',
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36',
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f',
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999',
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09',
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d',
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088',
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d',
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8',
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a',
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453',
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160',
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0',
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6',
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589',
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17',
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda',
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd',
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2',
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6',
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f',
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01',
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3',
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f',
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7',
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78',
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1',
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150',
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82',
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc',
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b',
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51',
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45',
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120',
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84',
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d',
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d',
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8',
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8',
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac',
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f',
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962',
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907',
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec',
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d',
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414',
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd',
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0',
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811',
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1',
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c',
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73',
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd',
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405',
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589',
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e',
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27',
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1',
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482',
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945',
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573',
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82',
      ],
    ],
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672',
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6',
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da',
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37',
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b',
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81',
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58',
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77',
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a',
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c',
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67',
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402',
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55',
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482',
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82',
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396',
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49',
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf',
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a',
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7',
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933',
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a',
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6',
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37',
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e',
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6',
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476',
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40',
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61',
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683',
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5',
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b',
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417',
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868',
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a',
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6',
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996',
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e',
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d',
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2',
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e',
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437',
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311',
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4',
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575',
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d',
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d',
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629',
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06',
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374',
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee',
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1',
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b',
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661',
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6',
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e',
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d',
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc',
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4',
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c',
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b',
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913',
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154',
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865',
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc',
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224',
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e',
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6',
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511',
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b',
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2',
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c',
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3',
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d',
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700',
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4',
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196',
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4',
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257',
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13',
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096',
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38',
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f',
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448',
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a',
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4',
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437',
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7',
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d',
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a',
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54',
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77',
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517',
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10',
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125',
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e',
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1',
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2',
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423',
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8',
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758',
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375',
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d',
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec',
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0',
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c',
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4',
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f',
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649',
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826',
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5',
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87',
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b',
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc',
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c',
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f',
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a',
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46',
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f',
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03',
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08',
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8',
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373',
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3',
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8',
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1',
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9',
      ],
    ],
  },
};


/***/ }),

/***/ 74021:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8818);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var BookingSettingView = /*#__PURE__*/function (_View) {
  function BookingSettingView() {
    _classCallCheck(this, BookingSettingView);
    return _callSuper(this, BookingSettingView, arguments);
  }
  _inherits(BookingSettingView, _View);
  return _createClass(BookingSettingView, null, [{
    key: "getTableOptions",
    value: function getTableOptions() {
      return {
        canAdd: true,
        fields: [{
          name: 'Name',
          required: true
        }, {
          name: 'DefaultServices',
          editor: [],
          label: 'Default Services',
          rowFields: [{
            name: 'ServiceId',
            relation: 'service',
            optionLabels: 'Name',
            editor: 'vue-select',
            setRelationTo: 'Service'
          }]
        }, {
          name: 'DefaultExpenses',
          editor: [],
          label: 'Default Expenses',
          rowFields: [{
            name: 'ExpenseTypeId',
            relation: 'expensetype',
            optionLabels: 'Name',
            editor: 'vue-select',
            setRelationTo: 'ExpenseType'
          }]
        }],
        title: 'Booking Default'
      };
    }
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_0__["default"]);
_defineProperty(BookingSettingView, "table", 'bookingsetting');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingSettingView);

/***/ }),

/***/ 74063:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


/***/ }),

/***/ 74598:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var constants = __webpack_require__(22153);

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);


/***/ }),

/***/ 74610:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(25382);

/*<replacement>*/
var util = Object.create(__webpack_require__(15622));
util.inherits = __webpack_require__(56698);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),

/***/ 74667:
/***/ ((module) => {

"use strict";

module.exports = function generate__limit(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $isMax = $keyword == 'maximum',
    $exclusiveKeyword = $isMax ? 'exclusiveMaximum' : 'exclusiveMinimum',
    $schemaExcl = it.schema[$exclusiveKeyword],
    $isDataExcl = it.opts.$data && $schemaExcl && $schemaExcl.$data,
    $op = $isMax ? '<' : '>',
    $notOp = $isMax ? '>' : '<',
    $errorKeyword = undefined;
  if (!($isData || typeof $schema == 'number' || $schema === undefined)) {
    throw new Error($keyword + ' must be number');
  }
  if (!($isDataExcl || $schemaExcl === undefined || typeof $schemaExcl == 'number' || typeof $schemaExcl == 'boolean')) {
    throw new Error($exclusiveKeyword + ' must be number or boolean');
  }
  if ($isDataExcl) {
    var $schemaValueExcl = it.util.getData($schemaExcl.$data, $dataLvl, it.dataPathArr),
      $exclusive = 'exclusive' + $lvl,
      $exclType = 'exclType' + $lvl,
      $exclIsNumber = 'exclIsNumber' + $lvl,
      $opExpr = 'op' + $lvl,
      $opStr = '\' + ' + $opExpr + ' + \'';
    out += ' var schemaExcl' + ($lvl) + ' = ' + ($schemaValueExcl) + '; ';
    $schemaValueExcl = 'schemaExcl' + $lvl;
    out += ' var ' + ($exclusive) + '; var ' + ($exclType) + ' = typeof ' + ($schemaValueExcl) + '; if (' + ($exclType) + ' != \'boolean\' && ' + ($exclType) + ' != \'undefined\' && ' + ($exclType) + ' != \'number\') { ';
    var $errorKeyword = $exclusiveKeyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ($errorKeyword || '_exclusiveLimit') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
      if (it.opts.messages !== false) {
        out += ' , message: \'' + ($exclusiveKeyword) + ' should be boolean\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError([' + (__err) + ']); ';
      } else {
        out += ' validate.errors = [' + (__err) + ']; return false; ';
      }
    } else {
      out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    }
    out += ' } else if ( ';
    if ($isData) {
      out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
    }
    out += ' ' + ($exclType) + ' == \'number\' ? ( (' + ($exclusive) + ' = ' + ($schemaValue) + ' === undefined || ' + ($schemaValueExcl) + ' ' + ($op) + '= ' + ($schemaValue) + ') ? ' + ($data) + ' ' + ($notOp) + '= ' + ($schemaValueExcl) + ' : ' + ($data) + ' ' + ($notOp) + ' ' + ($schemaValue) + ' ) : ( (' + ($exclusive) + ' = ' + ($schemaValueExcl) + ' === true) ? ' + ($data) + ' ' + ($notOp) + '= ' + ($schemaValue) + ' : ' + ($data) + ' ' + ($notOp) + ' ' + ($schemaValue) + ' ) || ' + ($data) + ' !== ' + ($data) + ') { var op' + ($lvl) + ' = ' + ($exclusive) + ' ? \'' + ($op) + '\' : \'' + ($op) + '=\'; ';
    if ($schema === undefined) {
      $errorKeyword = $exclusiveKeyword;
      $errSchemaPath = it.errSchemaPath + '/' + $exclusiveKeyword;
      $schemaValue = $schemaValueExcl;
      $isData = $isDataExcl;
    }
  } else {
    var $exclIsNumber = typeof $schemaExcl == 'number',
      $opStr = $op;
    if ($exclIsNumber && $isData) {
      var $opExpr = '\'' + $opStr + '\'';
      out += ' if ( ';
      if ($isData) {
        out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
      }
      out += ' ( ' + ($schemaValue) + ' === undefined || ' + ($schemaExcl) + ' ' + ($op) + '= ' + ($schemaValue) + ' ? ' + ($data) + ' ' + ($notOp) + '= ' + ($schemaExcl) + ' : ' + ($data) + ' ' + ($notOp) + ' ' + ($schemaValue) + ' ) || ' + ($data) + ' !== ' + ($data) + ') { ';
    } else {
      if ($exclIsNumber && $schema === undefined) {
        $exclusive = true;
        $errorKeyword = $exclusiveKeyword;
        $errSchemaPath = it.errSchemaPath + '/' + $exclusiveKeyword;
        $schemaValue = $schemaExcl;
        $notOp += '=';
      } else {
        if ($exclIsNumber) $schemaValue = Math[$isMax ? 'min' : 'max']($schemaExcl, $schema);
        if ($schemaExcl === ($exclIsNumber ? $schemaValue : true)) {
          $exclusive = true;
          $errorKeyword = $exclusiveKeyword;
          $errSchemaPath = it.errSchemaPath + '/' + $exclusiveKeyword;
          $notOp += '=';
        } else {
          $exclusive = false;
          $opStr += '=';
        }
      }
      var $opExpr = '\'' + $opStr + '\'';
      out += ' if ( ';
      if ($isData) {
        out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
      }
      out += ' ' + ($data) + ' ' + ($notOp) + ' ' + ($schemaValue) + ' || ' + ($data) + ' !== ' + ($data) + ') { ';
    }
  }
  $errorKeyword = $errorKeyword || $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ($errorKeyword || '_limit') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { comparison: ' + ($opExpr) + ', limit: ' + ($schemaValue) + ', exclusive: ' + ($exclusive) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should be ' + ($opStr) + ' ';
      if ($isData) {
        out += '\' + ' + ($schemaValue);
      } else {
        out += '' + ($schemaValue) + '\'';
      }
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + ($schema);
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += ' } ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),

/***/ 74692:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
( function( global, factory ) {

	"use strict";

	if (  true && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var version = "3.7.1",

	rhtmlSuffix = /HTML$/i,

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},


	// Retrieve the text value of an array of DOM nodes
	text: function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {

				// Do not traverse comment nodes
				ret += jQuery.text( node );
			}
		}
		if ( nodeType === 1 || nodeType === 11 ) {
			return elem.textContent;
		}
		if ( nodeType === 9 ) {
			return elem.documentElement.textContent;
		}
		if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}

		// Do not include comment or processing instruction nodes

		return ret;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	isXMLDoc: function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;

		// Assume HTML when documentElement doesn't yet exist, such as inside
		// document fragments.
		return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}


function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var pop = arr.pop;


var sort = arr.sort;


var splice = arr.splice;


var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




// Note: an element does not contain itself
jQuery.contains = function( a, b ) {
	var bup = b && b.parentNode;

	return a === bup || !!( bup && bup.nodeType === 1 && (

		// Support: IE 9 - 11+
		// IE doesn't have `contains` on SVG.
		a.contains ?
			a.contains( bup ) :
			a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
	) );
};




// CSS string/identifier serialization
// https://drafts.csswg.org/cssom/#common-serializing-idioms
var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

function fcssescape( ch, asCodePoint ) {
	if ( asCodePoint ) {

		// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
		if ( ch === "\0" ) {
			return "\uFFFD";
		}

		// Control characters and (dependent upon position) numbers get escaped as code points
		return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
	}

	// Other potentially-special ASCII characters get backslash-escaped
	return "\\" + ch;
}

jQuery.escapeSelector = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};




var preferredDoc = document,
	pushNative = push;

( function() {

var i,
	Expr,
	outermostContext,
	sortInput,
	hasDuplicate,
	push = pushNative,

	// Local document vars
	document,
	documentElement,
	documentIsHTML,
	rbuggyQSA,
	matches,

	// Instance-specific data
	expando = jQuery.expando,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
		"loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
		whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		ID: new RegExp( "^#(" + identifier + ")" ),
		CLASS: new RegExp( "^\\.(" + identifier + ")" ),
		TAG: new RegExp( "^(" + identifier + "|[*])" ),
		ATTR: new RegExp( "^" + attributes ),
		PSEUDO: new RegExp( "^" + pseudos ),
		CHILD: new RegExp(
			"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		bool: new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		needsContext: new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		if ( nonHex ) {

			// Strip the backslash prefix from a non-hex escape sequence
			return nonHex;
		}

		// Replace a hexadecimal escape sequence with the encoded Unicode code point
		// Support: IE <=11+
		// For values outside the Basic Multilingual Plane (BMP), manually construct a
		// surrogate pair
		return high < 0 ?
			String.fromCharCode( high + 0x10000 ) :
			String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes; see `setDocument`.
	// Support: IE 9 - 11+, Edge 12 - 18+
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE/Edge.
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && nodeName( elem, "fieldset" );
		},
		{ dir: "parentNode", next: "legend" }
	);

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android <=4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = {
		apply: function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		},
		call: function( target ) {
			pushNative.apply( target, slice.call( arguments, 1 ) );
		}
	};
}

function find( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								push.call( results, elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE 9 only
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							find.contains( context, elem ) &&
							elem.id === m ) {

							push.call( results, elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( !nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when
					// strict-comparing two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( newContext != context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = jQuery.escapeSelector( nid );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties
		// (see https://github.com/jquery/sizzle/issues/157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		return nodeName( elem, "input" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
			elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11+
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
function setDocument( node ) {
	var subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	documentElement = document.documentElement;
	documentIsHTML = !jQuery.isXMLDoc( document );

	// Support: iOS 7 only, IE 9 - 11+
	// Older browsers didn't support unprefixed `matches`.
	matches = documentElement.matches ||
		documentElement.webkitMatchesSelector ||
		documentElement.msMatchesSelector;

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors
	// (see trac-13936).
	// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
	// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
	if ( documentElement.msMatchesSelector &&

		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 9 - 11+, Edge 12 - 18+
		subWindow.addEventListener( "unload", unloadHandler );
	}

	// Support: IE <10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		documentElement.appendChild( el ).id = jQuery.expando;
		return !document.getElementsByName ||
			!document.getElementsByName( jQuery.expando ).length;
	} );

	// Support: IE 9 only
	// Check to see if it's possible to do matchesSelector
	// on a disconnected node.
	support.disconnectedMatch = assert( function( el ) {
		return matches.call( el, "*" );
	} );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// IE/Edge don't support the :scope pseudo-class.
	support.scope = assert( function() {
		return document.querySelectorAll( ":scope" );
	} );

	// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
	// Make sure the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter.ID = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter.ID =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find.TAG = function( tag, context ) {
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			return context.getElementsByTagName( tag );

		// DocumentFragment nodes don't have gEBTN
		} else {
			return context.querySelectorAll( tag );
		}
	};

	// Class
	Expr.find.CLASS = function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	rbuggyQSA = [];

	// Build QSA regex
	// Regex strategy adopted from Diego Perini
	assert( function( el ) {

		var input;

		documentElement.appendChild( el ).innerHTML =
			"<a id='" + expando + "' href='' disabled='disabled'></a>" +
			"<select id='" + expando + "-\r\\' disabled='disabled'>" +
			"<option selected=''></option></select>";

		// Support: iOS <=7 - 8 only
		// Boolean attributes and "value" are not treated correctly in some XML documents
		if ( !el.querySelectorAll( "[selected]" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
		}

		// Support: iOS <=7 - 8 only
		if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
			rbuggyQSA.push( "~=" );
		}

		// Support: iOS 8 only
		// https://bugs.webkit.org/show_bug.cgi?id=136851
		// In-page `selector#id sibling-combinator selector` fails
		if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
			rbuggyQSA.push( ".#.+[+~]" );
		}

		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		if ( !el.querySelectorAll( ":checked" ).length ) {
			rbuggyQSA.push( ":checked" );
		}

		// Support: Windows 8 Native Apps
		// The type and name attributes are restricted during .innerHTML assignment
		input = document.createElement( "input" );
		input.setAttribute( "type", "hidden" );
		el.appendChild( input ).setAttribute( "name", "D" );

		// Support: IE 9 - 11+
		// IE's :disabled selector does not pick up the children of disabled fieldsets
		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		documentElement.appendChild( el ).disabled = true;
		if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
			rbuggyQSA.push( ":enabled", ":disabled" );
		}

		// Support: IE 11+, Edge 15 - 18+
		// IE 11/Edge don't find elements on a `[name='']` query in some cases.
		// Adding a temporary attribute to the document before the selection works
		// around the issue.
		// Interestingly, IE 10 & older don't seem to have the issue.
		input = document.createElement( "input" );
		input.setAttribute( "name", "" );
		el.appendChild( input );
		if ( !el.querySelectorAll( "[name='']" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
				whitespace + "*(?:''|\"\")" );
		}
	} );

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a === document || a.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b === document || b.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	};

	return document;
}

find.matches = function( expr, elements ) {
	return find( expr, null, null, elements );
};

find.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return find( expr, document, null, [ elem ] ).length > 0;
};

find.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return jQuery.contains( context, elem );
};


find.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (see trac-13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	if ( val !== undefined ) {
		return val;
	}

	return elem.getAttribute( name );
};

find.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
jQuery.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	//
	// Support: Android <=4.0+
	// Testing for detecting duplicates is unpredictable so instead assume we can't
	// depend on duplicate detection in all browsers without a stable sort.
	hasDuplicate = !support.sortStable;
	sortInput = !support.sortStable && slice.call( results, 0 );
	sort.call( results, sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			splice.call( results, duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

jQuery.fn.uniqueSort = function() {
	return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
};

Expr = jQuery.expr = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		ATTR: function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
				.replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		CHILD: function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					find.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
				);
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

			// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				find.error( match[ 0 ] );
			}

			return match;
		},

		PSEUDO: function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		TAG: function( nodeNameSelector ) {
			var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return nodeName( elem, expectedNodeName );
				};
		},

		CLASS: function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace + ")" + className +
					"(" + whitespace + "|$)" ) ) &&
				classCache( className, function( elem ) {
					return pattern.test(
						typeof elem.className === "string" && elem.className ||
							typeof elem.getAttribute !== "undefined" &&
								elem.getAttribute( "class" ) ||
							""
					);
				} );
		},

		ATTR: function( name, operator, check ) {
			return function( elem ) {
				var result = find.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				if ( operator === "=" ) {
					return result === check;
				}
				if ( operator === "!=" ) {
					return result !== check;
				}
				if ( operator === "^=" ) {
					return check && result.indexOf( check ) === 0;
				}
				if ( operator === "*=" ) {
					return check && result.indexOf( check ) > -1;
				}
				if ( operator === "$=" ) {
					return check && result.slice( -check.length ) === check;
				}
				if ( operator === "~=" ) {
					return ( " " + result.replace( rwhitespace, " " ) + " " )
						.indexOf( check ) > -1;
				}
				if ( operator === "|=" ) {
					return result === check || result.slice( 0, check.length + 1 ) === check + "-";
				}

				return false;
			};
		},

		CHILD: function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || ( parent[ expando ] = {} );
							cache = outerCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {
								outerCache = elem[ expando ] || ( elem[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );
											outerCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		PSEUDO: function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// https://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					find.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as jQuery does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf.call( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		not: markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrimCSS, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element
					// (see https://github.com/jquery/sizzle/issues/299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		has: markFunction( function( selector ) {
			return function( elem ) {
				return find( selector, elem ).length > 0;
			};
		} ),

		contains: markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// https://www.w3.org/TR/selectors/#lang-pseudo
		lang: markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				find.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		target: function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		root: function( elem ) {
			return elem === documentElement;
		},

		focus: function( elem ) {
			return elem === safeActiveElement() &&
				document.hasFocus() &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		enabled: createDisabledPseudo( false ),
		disabled: createDisabledPseudo( true ),

		checked: function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			return ( nodeName( elem, "input" ) && !!elem.checked ) ||
				( nodeName( elem, "option" ) && !!elem.selected );
		},

		selected: function( elem ) {

			// Support: IE <=11+
			// Accessing the selectedIndex property
			// forces the browser to treat the default option as
			// selected when in an optgroup.
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		empty: function( elem ) {

			// https://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		parent: function( elem ) {
			return !Expr.pseudos.empty( elem );
		},

		// Element/input types
		header: function( elem ) {
			return rheader.test( elem.nodeName );
		},

		input: function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		button: function( elem ) {
			return nodeName( elem, "input" ) && elem.type === "button" ||
				nodeName( elem, "button" );
		},

		text: function( elem ) {
			var attr;
			return nodeName( elem, "input" ) && elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear
				// with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		first: createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		last: createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		even: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		odd: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i;

			if ( argument < 0 ) {
				i = argument + length;
			} else if ( argument > length ) {
				i = length;
			} else {
				i = argument;
			}

			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos.nth = Expr.pseudos.eq;

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrimCSS, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	if ( parseOnly ) {
		return soFar.length;
	}

	return soFar ?
		find.error( selector ) :

		// Cache the tokens
		tokenCache( selector, groups ).slice( 0 );
}

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						if ( skip && nodeName( elem, skip ) ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = outerCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							outerCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		find( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem, matcherOut,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed ||
				multipleContexts( selector || "*",
					context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems;

		if ( matcher ) {

			// If we have a postFinder, or filtered seed, or non-seed postFilter
			// or preexisting results,
			matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

				// ...intermediate processing is necessary
				[] :

				// ...otherwise use results directly
				results;

			// Find primary matches
			matcher( matcherIn, matcherOut, context, xml );
		} else {
			matcherOut = matcherIn;
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element
			// (see https://github.com/jquery/sizzle/issues/299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrimCSS, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find.TAG( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: iOS <=7 - 9 only
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
			// elements by id. (see trac-14142)
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							push.call( results, elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					jQuery.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

function compile( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
}

/**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
function select( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find.ID(
				token.matches[ 0 ].replace( runescape, funescape ),
				context
			) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) &&
						testContext( context.parentNode ) || context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
}

// One-time assignments

// Support: Android <=4.0 - 4.1+
// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Initialize against the default document
setDocument();

// Support: Android <=4.0 - 4.1+
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

jQuery.find = find;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.unique = jQuery.uniqueSort;

// These have always been private, but they used to be documented as part of
// Sizzle so let's maintain them for now for backwards compatibility purposes.
find.compile = compile;
find.select = select;
find.setDocument = setDocument;
find.tokenize = tokenize;

find.escape = jQuery.escapeSelector;
find.getText = jQuery.text;
find.isXML = jQuery.isXMLDoc;
find.selectors = jQuery.expr;
find.support = jQuery.support;
find.uniqueSort = jQuery.uniqueSort;

	/* eslint-enable */

} )();


var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to jQuery#find
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.error );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the error, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getErrorHook ) {
									process.error = jQuery.Deferred.getErrorHook();

								// The deprecated alias of the above. While the name suggests
								// returning the stack, not an error instance, jQuery just passes
								// it directly to `console.warn` so both will work; an instance
								// just better cooperates with source maps.
								} else if ( jQuery.Deferred.getStackHook ) {
									process.error = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
// captured before the async barrier to get the original error cause
// which may otherwise be hidden.
jQuery.Deferred.exceptionHook = function( error, asyncError ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message,
			error.stack, asyncError );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", true );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, isSetup ) {

	// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
	if ( !isSetup ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				if ( !saved ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					this[ type ]();
					result = dataPriv.get( this, type );
					dataPriv.set( this, type, false );

					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						return result;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering
				// the native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved ) {

				// ...and capture the result
				dataPriv.set( this, type, jQuery.event.trigger(
					saved[ 0 ],
					saved.slice( 1 ),
					this
				) );

				// Abort handling of the native event by all jQuery handlers while allowing
				// native handlers on the same element to run. On target, this is achieved
				// by stopping immediate propagation just on the jQuery event. However,
				// the native event is re-wrapped by a jQuery one on each level of the
				// propagation so the only way to stop it for jQuery is to stop it for
				// everyone via native `stopPropagation()`. This is not a problem for
				// focus/blur which don't bubble, but it does also stop click on checkboxes
				// and radios. We accept this limitation.
				event.stopPropagation();
				event.isImmediatePropagationStopped = returnTrue;
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {

	function focusMappedHandler( nativeEvent ) {
		if ( document.documentMode ) {

			// Support: IE 11+
			// Attach a single focusin/focusout handler on the document while someone wants
			// focus/blur. This is because the former are synchronous in IE while the latter
			// are async. In other browsers, all those handlers are invoked synchronously.

			// `handle` from private data would already wrap the event, but we need
			// to change the `type` here.
			var handle = dataPriv.get( this, "handle" ),
				event = jQuery.event.fix( nativeEvent );
			event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
			event.isSimulated = true;

			// First, handle focusin/focusout
			handle( nativeEvent );

			// ...then, handle focus/blur
			//
			// focus/blur don't bubble while focusin/focusout do; simulate the former by only
			// invoking the handler at the lower level.
			if ( event.target === event.currentTarget ) {

				// The setup part calls `leverageNative`, which, in turn, calls
				// `jQuery.event.add`, so event handle will already have been set
				// by this point.
				handle( event );
			}
		} else {

			// For non-IE browsers, attach a single capturing handler on the document
			// while someone wants focusin/focusout.
			jQuery.event.simulate( delegateType, nativeEvent.target,
				jQuery.event.fix( nativeEvent ) );
		}
	}

	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			var attaches;

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, true );

			if ( document.documentMode ) {

				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				attaches = dataPriv.get( this, delegateType );
				if ( !attaches ) {
					this.addEventListener( delegateType, focusMappedHandler );
				}
				dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
			} else {

				// Return false to allow normal processing in the caller
				return false;
			}
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		teardown: function() {
			var attaches;

			if ( document.documentMode ) {
				attaches = dataPriv.get( this, delegateType ) - 1;
				if ( !attaches ) {
					this.removeEventListener( delegateType, focusMappedHandler );
					dataPriv.remove( this, delegateType );
				} else {
					dataPriv.set( this, delegateType, attaches );
				}
			} else {

				// Return false to indicate standard teardown should be applied
				return false;
			}
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};

	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	//
	// Support: IE 9 - 11+
	// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
	// attach a single handler for both events in IE.
	jQuery.event.special[ delegateType ] = {
		setup: function() {

			// Handle: regular nodes (via `this.ownerDocument`), window
			// (via `this.document`) & document (via `this`).
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType );

			// Support: IE 9 - 11+
			// We use the same native handler for focusin & focus (and focusout & blur)
			// so we need to coordinate setup & teardown parts between those events.
			// Use `delegateType` as the key as `type` is already used by `leverageNative`.
			if ( !attaches ) {
				if ( document.documentMode ) {
					this.addEventListener( delegateType, focusMappedHandler );
				} else {
					doc.addEventListener( type, focusMappedHandler, true );
				}
			}
			dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
		},
		teardown: function() {
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType ) - 1;

			if ( !attaches ) {
				if ( document.documentMode ) {
					this.removeEventListener( delegateType, focusMappedHandler );
				} else {
					doc.removeEventListener( type, focusMappedHandler, true );
				}
				dataPriv.remove( dataHolder, delegateType );
			} else {
				dataPriv.set( dataHolder, delegateType, attaches );
			}
		}
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Re-enable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew jQuery#find here for performance reasons:
			// https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "box-sizing:content-box;border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is `display: block`
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0,
		marginDelta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		// Count margin delta separately to only add it after scroll gutter adjustment.
		// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
		if ( box === "margin" ) {
			marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta + marginDelta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		animationIterationCount: true,
		aspectRatio: true,
		borderImageSlice: true,
		columnCount: true,
		flexGrow: true,
		flexShrink: true,
		fontWeight: true,
		gridArea: true,
		gridColumn: true,
		gridColumnEnd: true,
		gridColumnStart: true,
		gridRow: true,
		gridRowEnd: true,
		gridRowStart: true,
		lineHeight: true,
		opacity: true,
		order: true,
		orphans: true,
		scale: true,
		widows: true,
		zIndex: true,
		zoom: true,

		// SVG-related
		fillOpacity: true,
		floodOpacity: true,
		stopOpacity: true,
		strokeMiterlimit: true,
		strokeOpacity: true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this
			.on( "mouseenter", fnOver )
			.on( "mouseleave", fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),

/***/ 74847:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = (__webpack_require__(92861).Buffer);
var BN = __webpack_require__(39404);
var EC = (__webpack_require__(86729).ec);
var parseKeys = __webpack_require__(78170);
var curves = __webpack_require__(64589);

function verify(sig, hash, key, signType, tag) {
  var pub = parseKeys(key);
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') { throw new Error('wrong public key type'); }
    return ecVerify(sig, hash, pub);
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') { throw new Error('wrong public key type'); }
    return dsaVerify(sig, hash, pub);
  }
  if (signType !== 'rsa' && signType !== 'ecdsa/rsa') { throw new Error('wrong public key type'); }

  hash = Buffer.concat([tag, hash]);
  var len = pub.modulus.byteLength();
  var pad = [1];
  var padNum = 0;
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff);
    padNum += 1;
  }
  pad.push(0x00);
  var i = -1;
  while (++i < hash.length) {
    pad.push(hash[i]);
  }
  pad = Buffer.from(pad);
  var red = BN.mont(pub.modulus);
  sig = new BN(sig).toRed(red);

  sig = sig.redPow(new BN(pub.publicExponent));
  sig = Buffer.from(sig.fromRed().toArray());
  var out = padNum < 8 ? 1 : 0;
  len = Math.min(sig.length, pad.length);
  if (sig.length !== pad.length) { out = 1; }

  i = -1;
  while (++i < len) { out |= sig[i] ^ pad[i]; }
  return out === 0;
}

function ecVerify(sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')];
  if (!curveId) { throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.')); }

  var curve = new EC(curveId);
  var pubkey = pub.data.subjectPrivateKey.data;

  return curve.verify(hash, sig, pubkey);
}

function dsaVerify(sig, hash, pub) {
  var p = pub.data.p;
  var q = pub.data.q;
  var g = pub.data.g;
  var y = pub.data.pub_key;
  var unpacked = parseKeys.signature.decode(sig, 'der');
  var s = unpacked.s;
  var r = unpacked.r;
  checkValue(s, q);
  checkValue(r, q);
  var montp = BN.mont(p);
  var w = s.invm(q);
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q);
  return v.cmp(r) === 0;
}

function checkValue(b, q) {
  if (b.cmpn(0) <= 0) { throw new Error('invalid sig'); }
  if (b.cmp(q) >= 0) { throw new Error('invalid sig'); }
}

module.exports = verify;


/***/ }),

/***/ 75301:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var View = api.importMixinModule('hotel', 'views', 'contacts');
var HotelView = /*#__PURE__*/function (_View) {
  function HotelView() {
    _classCallCheck(this, HotelView);
    return _callSuper(this, HotelView, arguments);
  }
  _inherits(HotelView, _View);
  return _createClass(HotelView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var options, field;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(HotelView, "getTableOptions", this, 2)([]);
            case 2:
              options = _context.sent;
              field = {
                name: "HotelContactList",
                editor: "component",
                hideFromList: true,
                label: "Contacts",
                icon: 'user',
                component: 'supplier-contact-list',
                componentName: 'supplier-contact-list',
                componentPath: 'components'
              };
              options.fields.push(field);
              return _context.abrupt("return", options);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(View);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HotelView);

/***/ }),

/***/ 75896:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(33225);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        pna.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        pna.nextTick(emitErrorNT, this, err);
      }
    }

    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        pna.nextTick(emitErrorNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        pna.nextTick(emitErrorNT, _this, err);
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),

/***/ 76619:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64467);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8818);






function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var UserProfileView = /*#__PURE__*/function (_View) {
  function UserProfileView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, UserProfileView);
    return _callSuper(this, UserProfileView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(UserProfileView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(UserProfileView, null, [{
    key: "getTableOptions",
    value: function getTableOptions() {
      return {
        fields: [{
          name: 'FirstName',
          label: 'Name'
        }, {
          name: 'LastName',
          label: 'Last Name'
        }, {
          name: 'Email',
          label: 'Email'
        }, {
          name: 'Phone',
          label: 'Phone'
        }, {
          name: 'DecimalSeparator',
          label: 'Decimal Separator'
        }, {
          name: "ImageId",
          editor: "photo-div",
          hideFromList: true,
          label: 'Profile Picture',
          setRelationTo: 'Image'
        }, {
          name: 'UserProfiles',
          editor: 'component',
          component: 'languages-comp',
          title: false,
          label: 'Descriptions',
          hideFromList: true,
          textStyle: true,
          rowFields: [{
            name: 'LanguageId',
            relation: 'language',
            optionLabels: 'Name',
            editor: 'select',
            setRelationTo: 'Language'
          }, {
            name: 'JobTitle',
            label: 'Job Title'
          }, {
            name: 'Description'
          }]
        }, {
          name: 'tab1',
          label: 'Emails',
          editor: 'tab',
          hideFromList: true,
          fields: [{
            name: 'EmailIntro',
            editor: 'text-area-style',
            columns: 6,
            label: 'Intro'
          }, {
            name: 'Signature',
            editor: 'text-area-style',
            columns: 6,
            label: 'Signature'
          }]
        }],
        title: 'User',
        afterSave: function afterSave(record, self) {
          api.updateUser(record);
        }
      };
    }
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(UserProfileView, "table", 'user');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (UserProfileView);

/***/ }),

/***/ 76983:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(65606);


function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = __webpack_require__(92861)
var randombytes = __webpack_require__(53209)
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = __webpack_require__.g.crypto || __webpack_require__.g.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof __webpack_require__.g.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof __webpack_require__.g.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}


/***/ }),

/***/ 77075:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays:
            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
                '_'
            ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


/***/ }),

/***/ 77199:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 77329:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort:
            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


/***/ }),

/***/ 77362:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var parseKeys = __webpack_require__(78170)
var mgf = __webpack_require__(48206)
var xor = __webpack_require__(52061)
var BN = __webpack_require__(82509)
var crt = __webpack_require__(67332)
var createHash = __webpack_require__(47108)
var withPublic = __webpack_require__(99247)
var Buffer = (__webpack_require__(92861).Buffer)

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}


/***/ }),

/***/ 77853:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),

/***/ 77880:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64467);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8818);






function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var bookingOptions = function bookingOptions(self, isTemplate, isOper) {
  return {
    fields: [{
      name: 'id',
      label: 'File Nr'
    }, {
      name: 'PaxName',
      label: 'Pax Name',
      requiredCallback: function requiredCallback(r) {
        return r.notTemplate;
      },
      length: 50
    }, {
      name: 'Title',
      label: 'Trip Title',
      required: true
    }, {
      name: 'SubTitle',
      label: 'Sub Title'
    }, {
      name: 'Closed'
    }, {
      name: 'PaxEmail',
      label: 'Email'
    }, {
      name: 'PaxPhone',
      label: 'Phone'
    }, {
      name: 'QuoteBy',
      label: 'Quote per',
      editor: 'select',
      readonly: true,
      options: [{
        value: 'SERVICE',
        label: 'Services'
      }]
    }, {
      name: 'QuoteViewType',
      label: 'Quote by',
      editor: 'select',
      defValue: 'PERSON',
      options: [{
        value: 'PERSON',
        label: 'Person'
      }, {
        value: 'SERVICE',
        label: 'Service'
      }, {
        value: 'ALL',
        label: 'All'
      }, {
        value: 'CUSTOM',
        label: 'Custom'
      }, {
        value: 'MULTI_QUOTE',
        label: 'Multi Quote'
      }
      //{value: 'QUANTITY', label: 'Services'}
      ]
    }, {
      name: 'ShowPriceBy'
    }, {
      name: 'HideTotalPrice',
      editor: 'checkbox'
    }, {
      name: 'SingleSupplement',
      editor: 'checkbox'
    }, {
      name: 'Summary'
    }, {
      name: 'Include'
    }, {
      name: 'SummaryCurrencyId',
      relation: 'currency',
      optionLabels: 'id',
      setRelationTo: 'SummaryCurrency',
      editor: 'select',
      label: 'Currency'
    }, {
      name: 'Markup'
      //afterEdit: (record) => {record.setMarkupToServices()}
    }, {
      name: 'SplitQuoteDate'
      //afterEdit: async function (record) {await record.setSplitQuoteDate()}
    }, {
      name: 'CreatedUserId',
      label: 'Created by',
      editor: 'select',
      optionLabels: 'UserName',
      relation: 'user'
    }, {
      name: 'UserId',
      label: 'User',
      editor: 'select',
      filters: function filters(row) {
        if (!row.Closed) return true;
      },
      optionLabels: 'UserName',
      relation: 'user'
    }, {
      name: 'Status',
      label: 'Status',
      editor: 'select',
      notSort: true,
      requiredCallback: function requiredCallback(r) {
        return r.isBooking;
      },
      addBlank: isTemplate,
      options: self.bookingStatusOptions,
      hidden: isTemplate
    }, {
      name: 'SalesOriginId',
      label: 'Origin',
      editor: 'select',
      hidden: isTemplate,
      requiredCallback: function requiredCallback(r) {
        return r.notTemplate;
      },
      optionLabels: 'Name',
      relation: 'salesorigin',
      setRelationTo: 'SalesOrigin'
      //afterEdit: async function (record) {await record.setSalesOrigin()}
    }, {
      name: 'OperUserId',
      label: 'Operation User',
      editor: 'select',
      requiredCallback: function requiredCallback(r) {
        return r.isBooking;
      },
      optionLabels: 'UserName',
      relation: 'user',
      filters: function filters(row) {
        if (row.Department && row.Department.Oper && !row.Closed) return true;
      }
    }, {
      name: 'SalesUserId',
      label: 'Seller',
      editor: 'select',
      requiredCallback: function requiredCallback(r) {
        return r.notTemplate;
      },
      optionLabels: 'UserName',
      relation: 'user',
      setRelationTo: 'SalesUser',
      filters: function filters(row) {
        if (row.Department && row.Department.Sales && !row.Closed) return true;
      }
    }, {
      name: 'TripModeId',
      label: 'Trip Type',
      editor: 'select',
      requiredCallback: function requiredCallback(r) {
        return r.notTemplate;
      },
      optionLabels: 'Name',
      relation: 'tripmode',
      setRelationTo: 'TripMode'
    }, {
      name: 'TemplateType',
      label: 'Template',
      editor: 'select',
      hidden: true,
      defValue: 'NONE',
      options: [{
        value: 'PUBLIC',
        label: 'Public',
        tr: true
      }, {
        value: 'PRIVATE',
        label: 'Private',
        tr: true
      }, {
        value: 'PACKAGE',
        label: 'Supplier Package',
        tr: true
      }]
    }, {
      name: 'TemplateKeepText'
    }, {
      name: 'Difficulty',
      label: 'Difficulty',
      editor: 'select',
      requiredCallback: function requiredCallback(r) {
        return r.notTemplate;
      },
      options: [{
        value: 'EASY',
        label: 'Easy',
        tr: true
      }, {
        value: 'MODERATE',
        label: 'Moderate',
        tr: true
      }, {
        value: 'HARD',
        label: 'Hard',
        tr: true
      }]
    }, {
      name: 'ShowPriceBy',
      label: 'Price By',
      editor: 'select',
      options: [{
        value: 'PERSON',
        label: 'Person',
        tr: true
      }, {
        value: 'TOTAL_TRIP',
        label: 'Trip',
        tr: true
      }]
    }, {
      name: 'NotInclude'
    }, {
      name: 'Comment'
    }, {
      name: 'EmergencyContacts'
    }, {
      name: 'ImageId',
      setRelationTo: 'Image',
      relation: 'image'
    }, {
      name: 'LanguageId',
      relation: 'language',
      optionLabels: 'Name',
      editor: 'select',
      label: 'Language',
      required: true,
      setRelationTo: 'Language'
    }, {
      name: 'CustomerTypeId',
      relation: 'customertype',
      optionLabels: 'Name',
      requiredCallback: function requiredCallback(r) {
        return r.notTemplate;
      },
      editor: 'select',
      label: 'Customer Type',
      setRelationTo: 'CustomerType'
      //afterEdit: (record) => {record.setMarkup()}
    }, {
      name: 'CurrencyId',
      relation: 'currency',
      optionLabels: 'id',
      setRelationTo: 'Currency',
      editor: 'select',
      label: 'Currency'
    }, {
      name: 'PriceCurrencyId',
      relation: 'currency',
      optionLabels: 'id',
      editor: 'select',
      label: 'Sales Currency',
      setRelationTo: 'PriceCurrency'
    }, {
      name: 'PaxQuantity',
      label: 'Passengers'
    }, {
      name: 'Child',
      label: 'Children'
    }, {
      name: 'StartDate',
      label: 'Start Date',
      editor: 'date',
      dateFormat: "DD/MM/YYYY",
      requiredCallback: function requiredCallback(r) {
        return r.notTemplate;
      }
    }, {
      name: 'ConfirmedDate',
      label: 'Sales Date',
      editor: 'date',
      dateFormat: "DD/MM/YYYY"
    }, {
      name: 'CreatedUTC',
      label: 'Quote Date',
      editor: 'date',
      dateFormat: "DD/MM/YYYY"
    }, {
      name: 'ModifiedUTC',
      label: 'Modified',
      editor: 'date',
      dateFormat: "DD/MM/YYYY"
    }, {
      name: 'QuoteDate',
      label: 'Quote Date',
      editor: 'date',
      dateFormat: "DD/MM/YYYY"
    }, {
      name: 'EndDate',
      label: 'End Date' || 0,
      dateFormat: "DD/MM/YYYY",
      editor: 'date'
    }, {
      name: 'Days',
      label: 'Days'
    }, {
      name: 'AgencyId',
      label: 'Agency',
      editor: 'vue-select',
      setRelationTo: 'Agency',
      optionLabels: 'Name',
      relation: 'agency',
      addBlank: true
    }, {
      name: 'PaxCountryType',
      label: 'Tipo de Pasajero',
      editor: 'select',
      options: [{
        value: 'RESIDENT',
        label: 'Resident'
      }, {
        value: 'NOT_RESIDENT',
        label: 'No Resident'
      }],
      afterEdit: function afterEdit(record) {
        record.setPaxCountryType();
      }
    }, {
      name: 'SumByType',
      label: 'Sum By',
      editor: 'select',
      options: [{
        value: 'ONE_TOTAL',
        label: 'One Total'
      }, {
        value: 'HOTEL_CATEGORY',
        label: 'Hotel Category'
      }, {
        value: 'QUOTE',
        label: 'Quotation'
      }]
    }, {
      name: 'ShowMQBy',
      label: 'Show Multi Quote By',
      editor: 'select',
      defValue: 'Cost',
      options: [{
        value: 'Price',
        label: 'Price'
      }, {
        value: 'Cost',
        label: 'Cost'
      }, {
        value: 'Markup',
        label: 'Markup'
      }, {
        value: 'Quantity',
        label: "Quantity / Pax Quantity"
      }, {
        value: 'Base',
        label: "Base / Rooms"
      }, {
        value: 'costPer',
        label: 'Cost Per'
      }, {
        value: 'PersonCost',
        label: 'Cost Per Person'
      }, {
        value: 'PersonPrice',
        label: 'Price Per Person'
      }, {
        value: 'TotalCost',
        label: 'Total Cost'
      }, {
        value: 'TotalPrice',
        label: 'Total Price'
      }]
    }, {
      name: 'FlightsBy',
      label: 'Flights by',
      editor: 'select',
      hideFromList: true,
      options: [{
        value: 'TOTAL',
        label: 'Total'
      }, {
        value: 'PERSON',
        label: 'Person'
      }]
    }, {
      name: 'PriceBreakdown'
    }, {
      name: 'HidePriceBreakdown'
    }, {
      name: 'SplitTourLeaderQuote'
    }, {
      name: 'BookingFormId'
    }, {
      name: 'PaxFrom'
    }, {
      name: 'PaxTo'
    }, {
      name: 'ShowDates',
      hidden: true
    }, {
      name: 'VoucherComments'
    }, {
      name: 'BookingDays',
      editor: [],
      rowClass: 'bookingday'
    }, {
      name: 'payments',
      editor: []
    }, {
      name: 'BookingUserShares',
      editor: [],
      rowClass: 'bookingusershare'
    }, {
      name: 'BookingOptionalServices',
      editor: [],
      rowClass: 'bookingoptionalservice'
    }, {
      name: 'RoomConfiguration',
      editor: [],
      rowClass: 'roomconfiguration'
    }, {
      name: 'CurrencyRates',
      editor: {},
      objectClass: 'bookingcurrencyrates'
    }, {
      name: 'BookingExpenses',
      editor: [],
      rowClass: 'bookingexpense'
    }, {
      name: 'BaseQuotes',
      editor: {},
      objectClass: 'basequotes',
      fields: []
    }, {
      name: 'Totals',
      editor: {},
      objectClass: 'bookingtotallist',
      fields: []
    },
    //{ name: 'QuoteGroups', editor: {}, objectClass: 'quotegroups', fields: []},
    {
      name: 'QuoteGroups'
    }, {
      name: 'BookingFlights',
      editor: [],
      rowClass: 'bookingflight'
    }, {
      name: 'ViewMode',
      defValue: -1,
      editor: 'select'
    }, {
      name: 'QuoteVariants'
    }, {
      name: 'forceHotelGetters',
      defValue: false
    }, {
      name: 'forceVariantGetters',
      defValue: false
    }, {
      name: 'SkipDays',
      editor: 'checkbox'
    }
    //{ name: 'BrowserTabId', editor: 'text', hideFromList: true },
    ],
    title: 'Quotations',
    serverSide: false
  };
};

var BookingView = /*#__PURE__*/function (_View) {
  function BookingView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, BookingView);
    return _callSuper(this, BookingView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(BookingView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingView, null, [{
    key: "getTableOptions",
    value: function getTableOptions(_ref) {
      var isTemplate = _ref.isTemplate,
        isOper = _ref.isOper;
      var res = bookingOptions(this, isTemplate, isOper);
      res.canAdd = true;
      if (!isTemplate) {
        res.fieldsAbmList = ['id', 'PaxName', 'Title', 'SalesUserId', 'SalesOriginId', 'Status', 'LanguageId', 'StartDate', 'Days', 'AgencyId'];
        res.fieldsOrder = ['id', 'PaxName', 'Title', 'SalesUserId', 'SalesOriginId', 'Status', 'LanguageId', 'StartDate', 'Days', 'AgencyId'];
      } else {
        res.fieldsAbmList = ['id', 'Title', 'UserId', 'LanguageId'];
        res.fieldsOrder = ['id', 'Title', 'UserId', 'LanguageId'];
      }
      return res;
    }
  }, {
    key: "bookingStatus",
    get: function get() {
      return {
        QUOTE: 'Quote',
        CONFIRMED: 'Confirmed',
        ENDED: 'Archived',
        CLOSED: 'Closed',
        CANCELED: 'Canceled',
        QUOTE_LOST: 'Lost',
        TRAVELED: 'Traveled'
      };
    }
  }, {
    key: "bookingStatusOptions",
    get: function get() {
      var dStatus = this.disabledStatus();
      var res = [];
      var status = this.bookingStatus;
      for (var s in status) {
        res.push({
          value: s,
          label: status[s],
          tr: true,
          disabled: dStatus[s]
        });
      }
      return res;
    }
  }, {
    key: "disabledStatus",
    value: function disabledStatus() {
      return {};
    }
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingView, "table", 'booking');
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingView, "onlyByService", false);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingView);

/***/ }),

/***/ 77941:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var View = api.importMixinModule('currency', 'views', 'argafip');
var ArgAfipCurrencyView = /*#__PURE__*/function (_View) {
  function ArgAfipCurrencyView() {
    _classCallCheck(this, ArgAfipCurrencyView);
    return _callSuper(this, ArgAfipCurrencyView, arguments);
  }
  _inherits(ArgAfipCurrencyView, _View);
  return _createClass(ArgAfipCurrencyView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(ArgAfipCurrencyView, "getTableOptions", this, 2)([]);
            case 2:
              res = _context.sent;
              res.fields.push({
                name: 'AfipCode'
              });
              return _context.abrupt("return", res);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(View);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ArgAfipCurrencyView);

/***/ }),

/***/ 77952:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var hash = exports;

hash.utils = __webpack_require__(67426);
hash.common = __webpack_require__(66166);
hash.sha = __webpack_require__(46229);
hash.ripemd = __webpack_require__(46784);
hash.hmac = __webpack_require__(28948);

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),

/***/ 77965:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 78170:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var asn1 = __webpack_require__(21137);
var aesid = __webpack_require__(15579);
var fixProc = __webpack_require__(24101);
var ciphers = __webpack_require__(1241);
var compat = __webpack_require__(78396);
var Buffer = (__webpack_require__(92861).Buffer);

function decrypt(data, password) {
	var salt = data.algorithm.decrypt.kde.kdeparams.salt;
	var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
	var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')];
	var iv = data.algorithm.decrypt.cipher.iv;
	var cipherText = data.subjectPrivateKey;
	var keylen = parseInt(algo.split('-')[1], 10) / 8;
	var key = compat.pbkdf2Sync(password, salt, iters, keylen, 'sha1');
	var cipher = ciphers.createDecipheriv(algo, key, iv);
	var out = [];
	out.push(cipher.update(cipherText));
	out.push(cipher['final']());
	return Buffer.concat(out);
}

function parseKeys(buffer) {
	var password;
	if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
		password = buffer.passphrase;
		buffer = buffer.key;
	}
	if (typeof buffer === 'string') {
		buffer = Buffer.from(buffer);
	}

	var stripped = fixProc(buffer, password);

	var type = stripped.tag;
	var data = stripped.data;
	var subtype, ndata;
	switch (type) {
		case 'CERTIFICATE':
			ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
			// falls through
		case 'PUBLIC KEY':
			if (!ndata) {
				ndata = asn1.PublicKey.decode(data, 'der');
			}
			subtype = ndata.algorithm.algorithm.join('.');
			switch (subtype) {
				case '1.2.840.113549.1.1.1':
					return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
				case '1.2.840.10045.2.1':
					ndata.subjectPrivateKey = ndata.subjectPublicKey;
					return {
						type: 'ec',
						data: ndata
					};
				case '1.2.840.10040.4.1':
					ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
					return {
						type: 'dsa',
						data: ndata.algorithm.params
					};
				default: throw new Error('unknown key id ' + subtype);
			}
			// throw new Error('unknown key type ' + type)
		case 'ENCRYPTED PRIVATE KEY':
			data = asn1.EncryptedPrivateKey.decode(data, 'der');
			data = decrypt(data, password);
			// falls through
		case 'PRIVATE KEY':
			ndata = asn1.PrivateKey.decode(data, 'der');
			subtype = ndata.algorithm.algorithm.join('.');
			switch (subtype) {
				case '1.2.840.113549.1.1.1':
					return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
				case '1.2.840.10045.2.1':
					return {
						curve: ndata.algorithm.curve,
						privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
					};
				case '1.2.840.10040.4.1':
					ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der');
					return {
						type: 'dsa',
						params: ndata.algorithm.params
					};
				default: throw new Error('unknown key id ' + subtype);
			}
			// throw new Error('unknown key type ' + type)
		case 'RSA PUBLIC KEY':
			return asn1.RSAPublicKey.decode(data, 'der');
		case 'RSA PRIVATE KEY':
			return asn1.RSAPrivateKey.decode(data, 'der');
		case 'DSA PRIVATE KEY':
			return {
				type: 'dsa',
				params: asn1.DSAPrivateKey.decode(data, 'der')
			};
		case 'EC PRIVATE KEY':
			data = asn1.ECPrivateKey.decode(data, 'der');
			return {
				curve: data.parameters.value,
				privateKey: data.privateKey
			};
		default: throw new Error('unknown key type ' + type);
	}
}
parseKeys.signature = asn1.signature;

module.exports = parseKeys;


/***/ }),

/***/ 78396:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

exports.pbkdf2 = __webpack_require__(43832)
exports.pbkdf2Sync = __webpack_require__(21352)


/***/ }),

/***/ 78473:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8818);





function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingTotalPersonView = /*#__PURE__*/function (_View) {
  function BookingTotalPersonView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, BookingTotalPersonView);
    return _callSuper(this, BookingTotalPersonView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(BookingTotalPersonView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingTotalPersonView, null, [{
    key: "getTableOptions",
    value: function getTableOptions() {
      return {
        fields: [{
          name: 'Price'
        }, {
          name: 'PersonPrice'
        }, {
          name: 'Cost'
        }, {
          name: 'PersonCost'
        }, {
          name: 'SumPersonPrice'
        }, {
          name: 'SumPersonCost'
        },
        //{ name: 'TotalPersonCost' },
        //{ name: 'TotalPersonPrice' },
        {
          name: 'Pax'
        }, {
          name: 'OverPrice'
        }, {
          name: 'OverPersonPrice'
        }, {
          name: 'Selected',
          defValue: true
        }]
      };
    }
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_2__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingTotalPersonView);

/***/ }),

/***/ 78474:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


/***/ }),

/***/ 78982:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 79100:
/***/ ((module) => {

"use strict";


module.exports = function defFunc(ajv) {
  defFunc.definition = {
    type: 'object',
    macro: function (schema) {
      if (schema.length == 0) return true;
      if (schema.length == 1) return {not: {required: schema}};
      var schemas = schema.map(function (prop) {
        return {required: [prop]};
      });
      return {not: {anyOf: schemas}};
    },
    metaSchema: {
      type: 'array',
      items: {
        type: 'string'
      }
    }
  };

  ajv.addKeyword('prohibited', defFunc.definition);
  return ajv;
};


/***/ }),

/***/ 79368:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 79402:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),

/***/ 79680:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
                '_'
            ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


/***/ }),

/***/ 79692:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8818);









function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var BookingDayView = /*#__PURE__*/function (_View) {
  function BookingDayView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, BookingDayView);
    return _callSuper(this, BookingDayView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingDayView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(BookingDayView, null, [{
    key: "options",
    value: function options() {
      return {
        fieldsDataReplace: {
          BookingDayServices: {
            name: 'BookingDayServices',
            editor: [],
            rowClass: 'bookingdayservice'
          },
          BookingDayHotels: {
            name: 'BookingDayHotels',
            editor: [],
            rowClass: 'bookingdayhotel'
          }
        }
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var r;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(BookingDayView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              r = _context.sent;
              r.fields.push({
                name: '_DayNr'
              });
              return _context.abrupt("return", r);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_4__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(BookingDayView, "table", 'bookingday');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingDayView);

/***/ }),

/***/ 79834:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
                '_'
            ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),

/***/ 79838:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 79846:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
              ? format[key][0]
              : format[key][1];
    }

    return tzl;

})));


/***/ }),

/***/ 80353:
/***/ ((module) => {

"use strict";

module.exports = function generate_allOf(it, $keyword, $ruleType) {
  var out = ' ';
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $currentBaseId = $it.baseId,
    $allSchemasEmpty = true;
  var arr1 = $schema;
  if (arr1) {
    var $sch, $i = -1,
      l1 = arr1.length - 1;
    while ($i < l1) {
      $sch = arr1[$i += 1];
      if ((it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all))) {
        $allSchemasEmpty = false;
        $it.schema = $sch;
        $it.schemaPath = $schemaPath + '[' + $i + ']';
        $it.errSchemaPath = $errSchemaPath + '/' + $i;
        out += '  ' + (it.validate($it)) + ' ';
        $it.baseId = $currentBaseId;
        if ($breakOnError) {
          out += ' if (' + ($nextValid) + ') { ';
          $closingBraces += '}';
        }
      }
    }
  }
  if ($breakOnError) {
    if ($allSchemasEmpty) {
      out += ' if (true) { ';
    } else {
      out += ' ' + ($closingBraces.slice(0, -1)) + ' ';
    }
  }
  return out;
}


/***/ }),

/***/ 80386:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51941);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingCurrencyRate = /*#__PURE__*/function (_BookingBaseModel) {
  function BookingCurrencyRate() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingCurrencyRate);
    return _callSuper(this, BookingCurrencyRate, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingCurrencyRate, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingCurrencyRate, [{
    key: "afterEdit",
    value: function afterEdit() {
      return {
        Rate: function () {
          var _Rate = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(r, value) {
            var res;
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return r.$parent.$parent.setCurrencyRateToServices({
                    rate: r
                  });
                case 2:
                  res = _context.sent;
                  return _context.abrupt("return", res);
                case 4:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function Rate(_x, _x2) {
            return _Rate.apply(this, arguments);
          }
          return Rate;
        }()
      };
    }
  }, {
    key: "booking",
    get: function get() {
      return this.$parent.$parent;
    }
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingCurrencyRate, "moduleName", 'bookingcurrencyrate');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingCurrencyRate);

/***/ }),

/***/ 80400:
/***/ ((module) => {

"use strict";

module.exports = function generate_format(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  if (it.opts.format === false) {
    if ($breakOnError) {
      out += ' if (true) { ';
    }
    return out;
  }
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $unknownFormats = it.opts.unknownFormats,
    $allowUnknown = Array.isArray($unknownFormats);
  if ($isData) {
    var $format = 'format' + $lvl,
      $isObject = 'isObject' + $lvl,
      $formatType = 'formatType' + $lvl;
    out += ' var ' + ($format) + ' = formats[' + ($schemaValue) + ']; var ' + ($isObject) + ' = typeof ' + ($format) + ' == \'object\' && !(' + ($format) + ' instanceof RegExp) && ' + ($format) + '.validate; var ' + ($formatType) + ' = ' + ($isObject) + ' && ' + ($format) + '.type || \'string\'; if (' + ($isObject) + ') { ';
    if (it.async) {
      out += ' var async' + ($lvl) + ' = ' + ($format) + '.async; ';
    }
    out += ' ' + ($format) + ' = ' + ($format) + '.validate; } if (  ';
    if ($isData) {
      out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'string\') || ';
    }
    out += ' (';
    if ($unknownFormats != 'ignore') {
      out += ' (' + ($schemaValue) + ' && !' + ($format) + ' ';
      if ($allowUnknown) {
        out += ' && self._opts.unknownFormats.indexOf(' + ($schemaValue) + ') == -1 ';
      }
      out += ') || ';
    }
    out += ' (' + ($format) + ' && ' + ($formatType) + ' == \'' + ($ruleType) + '\' && !(typeof ' + ($format) + ' == \'function\' ? ';
    if (it.async) {
      out += ' (async' + ($lvl) + ' ? await ' + ($format) + '(' + ($data) + ') : ' + ($format) + '(' + ($data) + ')) ';
    } else {
      out += ' ' + ($format) + '(' + ($data) + ') ';
    }
    out += ' : ' + ($format) + '.test(' + ($data) + '))))) {';
  } else {
    var $format = it.formats[$schema];
    if (!$format) {
      if ($unknownFormats == 'ignore') {
        it.logger.warn('unknown format "' + $schema + '" ignored in schema at path "' + it.errSchemaPath + '"');
        if ($breakOnError) {
          out += ' if (true) { ';
        }
        return out;
      } else if ($allowUnknown && $unknownFormats.indexOf($schema) >= 0) {
        if ($breakOnError) {
          out += ' if (true) { ';
        }
        return out;
      } else {
        throw new Error('unknown format "' + $schema + '" is used in schema at path "' + it.errSchemaPath + '"');
      }
    }
    var $isObject = typeof $format == 'object' && !($format instanceof RegExp) && $format.validate;
    var $formatType = $isObject && $format.type || 'string';
    if ($isObject) {
      var $async = $format.async === true;
      $format = $format.validate;
    }
    if ($formatType != $ruleType) {
      if ($breakOnError) {
        out += ' if (true) { ';
      }
      return out;
    }
    if ($async) {
      if (!it.async) throw new Error('async format in sync schema');
      var $formatRef = 'formats' + it.util.getProperty($schema) + '.validate';
      out += ' if (!(await ' + ($formatRef) + '(' + ($data) + '))) { ';
    } else {
      out += ' if (! ';
      var $formatRef = 'formats' + it.util.getProperty($schema);
      if ($isObject) $formatRef += '.validate';
      if (typeof $format == 'function') {
        out += ' ' + ($formatRef) + '(' + ($data) + ') ';
      } else {
        out += ' ' + ($formatRef) + '.test(' + ($data) + ') ';
      }
      out += ') { ';
    }
  }
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('format') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { format:  ';
    if ($isData) {
      out += '' + ($schemaValue);
    } else {
      out += '' + (it.util.toQuotedString($schema));
    }
    out += '  } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should match format "';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + (it.util.escapeQuotes($schema));
      }
      out += '"\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + (it.util.toQuotedString($schema));
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += ' } ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),

/***/ 80405:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82284);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);





function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var Tools = /*#__PURE__*/function () {
  function Tools() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(this, Tools);
  }
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(Tools, [{
    key: "canAccess",
    value: function canAccess(user, type, method, endpoint) {
      var defValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var force = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      if (!user || !user.AccessGroup) return true;
      var p = user.AccessGroup.permissionsMerge || {};
      if (typeof p[type] === 'boolean') return p[type];
      if (defValue) {
        var def = (((p[type] || {}).defaults || {}).methods || {})[method];
        if (def === false && force) def = true;
        if (def === undefined) def = true;
      } else {
        var def = false;
      }
      if (!endpoint) return def;
      endpoint = endpoint.replace(/(<[^:]+)?:[^>/]+>?/g, ':p');
      var perm = ((p[type] || {})[endpoint] || {}).methods;
      if ((0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(perm) === 'object') {
        return typeof perm === 'undefined' ? def : perm[method];
      }
      if (typeof perm === 'boolean') {
        return perm;
      }
      if (!perm) {
        return def;
      }
      return typeof perm[method] === 'undefined' ? def : perm[method];
    }
  }, {
    key: "canAccessModules",
    value: function canAccessModules(user, modules) {
      var _iterator = _createForOfIteratorHelper(modules),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var module = _step.value;
          var v = this.canAccessModule(user, module);
          if (v) return true;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return false;
    }
  }, {
    key: "canAccessModule",
    value: function canAccessModule(user, module) {
      return tools.canAccess(user, "view", "GET", module.user_access, module.def);
    }
  }, {
    key: "mergeDateAndTime",
    value: function mergeDateAndTime(d, t) {
      var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'utc';
      if (!d) return '';
      if (z == 'local') return moment.utc(d + ' ' + t, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM-DDTHH:mm:ss');
      return moment(d + ' ' + t, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DDTHH:mm:ss');
    }
  }, {
    key: "getDate",
    value: function getDate(d) {
      if (!d) return '';
      return moment(d).format("DD/MM/YYYY");
    }
  }, {
    key: "getTime",
    value: function getTime() {
      if (!this.t) {
        this.t = new Date().getTime();
        return 0;
      }
      this.oldT = this.t;
      this.t = new Date().getTime();
      return this.t - this.oldT;
    }
  }, {
    key: "getHourMinute",
    value: function getHourMinute(t) {
      if (!t) return '';
      return moment(t).format("HH:mm");
    }
  }, {
    key: "getDateTime",
    value: function getDateTime(d) {
      if (!d) return '';
      return moment(d).format("DD/MM/YYYY HH:mm");
    }
  }, {
    key: "getLocalDate",
    value: function getLocalDate(d, format) {
      if (!d) return '';
      if (format) return moment(d).local().locale(api.language).format(format);
      return moment(d).local().locale(api.language).format('DD MMM YYYY');
    }
  }, {
    key: "getLocalTime",
    value: function getLocalTime(d) {
      if (!d) return '';
      return moment(d).local().locale(api.language).format('HH:mm');
    }
  }, {
    key: "getLocalDateTime",
    value: function getLocalDateTime(d) {
      if (!d) return '';
      return moment.utc(d).local().locale(api.language).format('DD MMM YYYY HH:mm');
    }
  }, {
    key: "dateIsAfter",
    value: function dateIsAfter(date1, date2) {
      if (moment(date1).isAfter(date2)) return true;
      return false;
    }
  }, {
    key: "formatNumber",
    value: function formatNumber(value, _ref) {
      var c = _ref.c,
        s = _ref.s,
        d = _ref.d;
      var currency = c;
      var showCurrency = s;
      var decimals = 0;
      if (currency && currency.Decimals) decimals = currency.Decimals;
      if (d != null && d != undefined) decimals = d;
      var res = value;
      if (!currency) currency = {};
      if (typeof value === 'string') res = parseFloat(value).toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (typeof value === 'number') res = value.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (showCurrency == 1 && currency.id) {
        res = "".concat(res, " ").concat(currency.id);
      }
      ;
      if (showCurrency == 2 && currency.id) res = "".concat(currency.id, " ").concat(res);
      if (showCurrency == 3 && !currency.Symbol) {
        res = "".concat(res, " ").concat(currency.id);
      }
      ;
      if (showCurrency == 4 && !currency.Symbol) res = "".concat(currency.id, " ").concat(res);
      if (showCurrency == 4 && currency.Symbol) res = "".concat(currency.Symbol, " ").concat(res);
      if (showCurrency == 3 && currency.Symbol) res = "".concat(res, " ").concat(currency.Symbol);
      return res;
    }
  }, {
    key: "diffHours",
    value: function diffHours(date1, date2) {
      return moment(date1).diff(moment(date2)) / 3600000;
    }
  }, {
    key: "downloadRecord",
    value: function () {
      var _downloadRecord = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(table, id) {
        var record, text, fileName;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return api.getObjectFromStore(table, id);
            case 2:
              record = _context.sent;
              text = JSON.stringify(record);
              fileName = "".concat(table, "-").concat(id, ".txt");
              tools.download2(text, fileName, 'text/plain');
              return _context.abrupt("return", record);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function downloadRecord(_x, _x2) {
        return _downloadRecord.apply(this, arguments);
      }
      return downloadRecord;
    }()
  }, {
    key: "download2",
    value: function download2(content, fileName, contentType) {
      var a = document.createElement("a");
      var file = new Blob([content], {
        type: contentType
      });
      a.href = URL.createObjectURL(file);
      a.download = fileName;
      a.click();
    }
  }, {
    key: "getValue",
    value: function getValue(v) {
      if (v && v.value != undefined && v.value != null) {
        return v.value;
      }
      return v;
    }
  }, {
    key: "getBGColor",
    value: function getBGColor(v) {
      if (v && v.bgColor) return v.bgColor;
      return null;
    }
  }, {
    key: "getAlign",
    value: function getAlign(v) {
      if (v && v.align) return v.align;
      return 'left';
    }
  }, {
    key: "setAutoSizeTextArea",
    value: function setAutoSizeTextArea(t) {
      t.addEventListener('keyup', function () {
        tools.autoSizeTextArea(this);
      }, false);
    }
  }, {
    key: "autoSizeTextArea",
    value: function autoSizeTextArea(self) {
      self.style.overflow = 'hidden';
      self.style.height = 0;
      self.style.height = self.scrollHeight + 'px';
      if (parseInt(self.style.height) < 40) self.style.height = '40px';
    }
  }, {
    key: "normalize",
    value: function normalize(s, specials) {
      if (!s) return s;
      if (s.normalize != undefined) {
        s = s.normalize("NFKD");
      }
      s = s.toString().replace(/æ/g, "ae");
      s = s.replace(/[\'`´]/g, "");
      if (specials) {
        s = s.replace(/['`´.*+?^&${}()|[\]\\]/g, '');
      } else {
        s = s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); //all chars literal
      }
      return s.replace(/[\u0300-\u036F]/g, "");
    }
  }, {
    key: "normalizeText",
    value: function normalizeText(s) {
      if (!s) return s;
      if (s.normalize != undefined) {
        s = s.normalize("NFKD");
      }
      s = s.toString().replace(/æ/g, "ae");
      s = s.replace(/[\'`´]/g, "");
      //s = s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') //all chars literal
      return s.replace(/[\u0300-\u036F]/g, "");
    }
  }, {
    key: "joinText",
    value: function joinText(list, joiner, lastJoiner) {
      if (list.length == 1) return list[0];
      if (list.length == 2) {
        return list.join(lastJoiner);
      }
      if (list.length > 2) {
        var res = '';
        for (var i in list) {
          res += list[i];
          if (i < list.length - 2) {
            res += joiner;
          } else if (i == list.length - 2) {
            res += lastJoiner;
          }
        }
        return res;
      }
    }
  }, {
    key: "objectsDiff",
    value: function objectsDiff(a, b) {
      var s1 = JSON.stringify(a);
      var s2 = JSON.stringify(b);
      return s1 === s2;
    }
  }, {
    key: "toNumber",
    value: function toNumber(value, decimals, currency) {
      if (this.isNull(value)) return '';
      if (this._toExcel) {
        if (!api.currentUser.DecimalSeparator) return value;
        return value.toString().replace('.', api.currentUser.DecimalSeparator);
      }
      var c = currency;
      if (currency && typeof currency === 'string') {
        c = _.find(api.tables.currency, function (r) {
          return r.id == currency;
        });
      }
      if (!value) return value;
      if (c) return tools.formatNumber(value, {
        c: c
      });
      return parseFloat(value).toLocaleString('en', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      });
    }
  }, {
    key: "toTitleCase",
    value: function toTitleCase(str) {
      if (!str) return;
      if (typeof str != 'string') return str;
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    }
  }, {
    key: "getAbmFields",
    value: function getAbmFields(fields, listWindow) {
      var res = [];
      var _iterator2 = _createForOfIteratorHelper(fields),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var f = _step2.value;
          if (f.hideFromList && listWindow) continue;
          if (f.hidden) continue;
          if ((0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(f.editor) === 'object') continue;
          if (f.name) {
            var ff = _.cloneDeep(f);
            ff.label = f.label ? f.label : f.name;
            ff.sortOrder = 1;
            ff.editor = f.editor ? f.editor : 'text';
            ff.type = f.type ? f.type : 'text';
            if (f.classes) ff.classes ? f.classes : '';
            res.push(ff);
          } else {
            res.push({
              name: f,
              label: f,
              editor: 'text',
              sortOrder: 1
            });
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return res;
    }
  }, {
    key: "fetchTable",
    value: function () {
      var _fetchTable = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(tableName, endpoint, filters, refresh, record, showClosed, hideActive) {
        var f, _res, e, res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              f = filters;
              if (typeof f === 'function' && record) {
                f = f(record);
              } else if (typeof f === 'function' && !record) {
                f = null;
              }
              if (!(!refresh && !f && !endpoint)) {
                _context2.next = 9;
                break;
              }
              _res = api.getFromStore(tableName);
              if (!_res) {
                _context2.next = 8;
                break;
              }
              if (!showClosed) {
                _res = _.filter(_res, function (r) {
                  if (r.Closed) return false;
                  return true;
                });
              }
              if (hideActive) {
                _res = _.filter(_res, function (r) {
                  if (!r.Closed) return false;
                  return true;
                });
              }
              return _context2.abrupt("return", _res);
            case 8:
              ;
            case 9:
              if (!showClosed) {
                showClosed = false;
              }
              if (!hideActive) {
                hideActive = false;
              }
              e = endpoint ? endpoint : '/api/' + tableName + '/?IncludeClosed=' + showClosed + '&hideActive=' + hideActive;
              if (this.hasClosed && f) {
                f['IncludeClosed'] = showClosed;
              }
              if (f) {
                f = {
                  filters: JSON.stringify(f)
                };
              }
              _context2.next = 16;
              return api.get(e, f);
            case 16:
              res = _context2.sent;
              if (!res) {
                _context2.next = 20;
                break;
              }
              if (!f && !endpoint) {
                api.setTableToStore(tableName, res);
              }
              return _context2.abrupt("return", res);
            case 20:
              return _context2.abrupt("return", []);
            case 21:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchTable(_x3, _x4, _x5, _x6, _x7, _x8, _x9) {
        return _fetchTable.apply(this, arguments);
      }
      return fetchTable;
    }()
  }, {
    key: "calculateFieldOptionsByField",
    value: function () {
      var _calculateFieldOptionsByField = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(field, fo, serverSide, record, showClosed, currentValue) {
        var options, _refresh, rows, opts, found, _iterator3, _step3, row, skip, f, disabled, _label, label;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(Array.isArray(field.options) || typeof field.options === 'function')) {
                _context3.next = 6;
                break;
              }
              options = field.options;
              if (typeof field.options === 'function') {
                options = field.options();
              }
              fo[field.name] = _.map(_.filter(options, function (r) {
                return !r.skip;
              }), function (o) {
                var value = o;
                var label = o;
                var bgColor = null;
                var color = '#000000';
                var disabled = null;
                var icon;
                if (o.value != null && o.value != undefined) value = o.value;
                if (o.label) label = o.label;
                if (o.bgColor) bgColor = o.bgColor;
                if (o.color) color = o.color;
                if (o.icon) icon = o.icon;
                if (o.disabled) disabled = o.disabled;
                return {
                  label: label,
                  value: value,
                  bgColor: bgColor,
                  color: color,
                  disabled: disabled,
                  sortBy: o.sortBy,
                  icon: o.icon
                };
              });
              _context3.next = 17;
              break;
            case 6:
              if (!(field.relation && !serverSide)) {
                _context3.next = 17;
                break;
              }
              _refresh = false;
              if (field.refresh) _refresh = field.refresh;
              _context3.next = 11;
              return this.fetchTable(field.relation, field.endpoint, field.endpointFilters, _refresh, record, showClosed);
            case 11:
              rows = _context3.sent;
              opts = [];
              _iterator3 = _createForOfIteratorHelper(rows);
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  row = _step3.value;
                  skip = false;
                  if (field.filters) {
                    if ((0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(field.filters) === 'object') {
                      for (f in field.filters) {
                        if (row[f] != field.filters[f]) {
                          skip = true;
                        }
                      }
                    } else if (typeof field.filters === 'function') {
                      if (!field.filters(row, record)) {
                        skip = true;
                      }
                    }
                  }
                  //console.log(field.name, currentValue, row.id)
                  if (currentValue && currentValue == row.id) {
                    skip = false;
                    found = true;
                  }
                  if (!skip) {
                    disabled = void 0;
                    if (field.disabledIf) {
                      disabled = field.disabledIf(row, record, currentValue);
                    }
                    if (typeof field.optionLabels === 'function') {
                      _label = field.optionLabels(row);
                      opts.push({
                        label: _label,
                        value: row.id,
                        disabled: disabled
                      });
                    } else {
                      opts.push({
                        label: row[field.optionLabels],
                        value: row.id,
                        disabled: disabled
                      });
                    }
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              if (!found && currentValue && field.setRelationTo) {
                if (record && record[field.setRelationTo]) {
                  if (typeof field.optionLabels === 'function') {
                    label = field.optionLabels(record[field.setRelationTo]);
                    opts.push({
                      label: label,
                      value: currentValue
                    });
                  } else {
                    opts.push({
                      label: record[field.setRelationTo][field.optionLabels],
                      value: currentValue
                    });
                  }
                }
              }
              fo[field.name] = opts;
            case 17:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function calculateFieldOptionsByField(_x10, _x11, _x12, _x13, _x14, _x15) {
        return _calculateFieldOptionsByField.apply(this, arguments);
      }
      return calculateFieldOptionsByField;
    }()
  }, {
    key: "calculateFieldOptions",
    value: function () {
      var _calculateFieldOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(abmFields, serverSide, record, showClosed, onlyHeaders, fieldName, currentValue) {
        var fo, _iterator4, _step4, field, _showClosed, _iterator5, _step5, row, _iterator6, _step6, rowField, _iterator7, _step7, _rowField;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              fo = {};
              _iterator4 = _createForOfIteratorHelper(abmFields);
              _context4.prev = 2;
              _iterator4.s();
            case 4:
              if ((_step4 = _iterator4.n()).done) {
                _context4.next = 66;
                break;
              }
              field = _step4.value;
              if (!(fieldName && field.name != fieldName)) {
                _context4.next = 8;
                break;
              }
              return _context4.abrupt("continue", 64);
            case 8:
              _showClosed = showClosed;
              if (field.showClosed) _showClosed = field.showClosed;
              _context4.next = 12;
              return this.calculateFieldOptionsByField(field, fo, serverSide, record, _showClosed, currentValue);
            case 12:
              if (onlyHeaders) {
                _context4.next = 64;
                break;
              }
              if (!(field.rowFields && Array.isArray(field.editor) && Array.isArray(field.rowFields))) {
                _context4.next = 46;
                break;
              }
              _iterator5 = _createForOfIteratorHelper(record[field.name]);
              _context4.prev = 15;
              _iterator5.s();
            case 17:
              if ((_step5 = _iterator5.n()).done) {
                _context4.next = 38;
                break;
              }
              row = _step5.value;
              _iterator6 = _createForOfIteratorHelper(field.rowFields);
              _context4.prev = 20;
              _iterator6.s();
            case 22:
              if ((_step6 = _iterator6.n()).done) {
                _context4.next = 28;
                break;
              }
              rowField = _step6.value;
              _context4.next = 26;
              return this.calculateFieldOptionsByField(rowField, fo, serverSide, row, _showClosed, currentValue);
            case 26:
              _context4.next = 22;
              break;
            case 28:
              _context4.next = 33;
              break;
            case 30:
              _context4.prev = 30;
              _context4.t0 = _context4["catch"](20);
              _iterator6.e(_context4.t0);
            case 33:
              _context4.prev = 33;
              _iterator6.f();
              return _context4.finish(33);
            case 36:
              _context4.next = 17;
              break;
            case 38:
              _context4.next = 43;
              break;
            case 40:
              _context4.prev = 40;
              _context4.t1 = _context4["catch"](15);
              _iterator5.e(_context4.t1);
            case 43:
              _context4.prev = 43;
              _iterator5.f();
              return _context4.finish(43);
            case 46:
              if (!(field.editor == 'tab')) {
                _context4.next = 64;
                break;
              }
              _iterator7 = _createForOfIteratorHelper(field.fields);
              _context4.prev = 48;
              _iterator7.s();
            case 50:
              if ((_step7 = _iterator7.n()).done) {
                _context4.next = 56;
                break;
              }
              _rowField = _step7.value;
              _context4.next = 54;
              return this.calculateFieldOptionsByField(_rowField, fo, serverSide, record, _showClosed, currentValue);
            case 54:
              _context4.next = 50;
              break;
            case 56:
              _context4.next = 61;
              break;
            case 58:
              _context4.prev = 58;
              _context4.t2 = _context4["catch"](48);
              _iterator7.e(_context4.t2);
            case 61:
              _context4.prev = 61;
              _iterator7.f();
              return _context4.finish(61);
            case 64:
              _context4.next = 4;
              break;
            case 66:
              _context4.next = 71;
              break;
            case 68:
              _context4.prev = 68;
              _context4.t3 = _context4["catch"](2);
              _iterator4.e(_context4.t3);
            case 71:
              _context4.prev = 71;
              _iterator4.f();
              return _context4.finish(71);
            case 74:
              return _context4.abrupt("return", fo);
            case 75:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[2, 68, 71, 74], [15, 40, 43, 46], [20, 30, 33, 36], [48, 58, 61, 64]]);
      }));
      function calculateFieldOptions(_x16, _x17, _x18, _x19, _x20, _x21, _x22) {
        return _calculateFieldOptions.apply(this, arguments);
      }
      return calculateFieldOptions;
    }()
  }, {
    key: "getDisplayValue",
    value: function getDisplayValue(record, field, serverSide, fieldOptions, cutName) {
      if (field.computed) {
        return field.computed(record);
      }
      if (record[field.name] === null || record[field.name] === undefined) return '';
      if (record[field.name] === true) return tr('YES');
      if (record[field.name] === false) return tr('NO');
      if (field.dateFormat && record[field.name]) {
        if (field.locale) {
          return moment(record[field.name]).local().locale(api.language).format(field.dateFormat);
        }
        return moment(record[field.name]).format(field.dateFormat);
      } else if (field.editor == 'datetime' && record[field.name]) {
        return this.getLocalDateTime(record[field.name]);
      }
      if (field.relation || field.options) {
        if (serverSide) {
          if (typeof field.optionLabels === 'function') {
            return field.optionLabels(record.Booking);
          } else {
            var key = field.name + '_' + field.optionLabels;
            if (record[key]) return record[key];
          }
        }
        if (fieldOptions) {
          if (!fieldOptions[field.name]) return null;
          if (field.list) {
            var names = [];
            var _iterator8 = _createForOfIteratorHelper(record[field.name].split(',')),
              _step8;
            try {
              var _loop = function _loop() {
                var id = _step8.value;
                var opt = _.find(fieldOptions[field.name], function (opt) {
                  return opt.value == id;
                });
                if (opt) {
                  names.push(opt.label);
                }
              };
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                _loop();
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
            return names.join(',');
          }
          var opt = _.find(fieldOptions[field.name], function (opt) {
            return opt.value == record[field.name];
          });
          if (opt) {
            if (field.tr || field.options) return tr(opt.label);
            return opt.label;
          } else {
            if (field.relation && record[field.name]) {
              var e = "/api/".concat(field.relation, "/").concat(record[field.name]);
              if (!api.closedRequest[e]) {
                api.closedRequest[e] = true;
                api.get(e, null, null, /*#__PURE__*/function () {
                  var _ref2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(promise) {
                    var r, label;
                    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
                      while (1) switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return promise;
                        case 2:
                          r = _context5.sent;
                          if (!r) {
                            _context5.next = 10;
                            break;
                          }
                          api.closedRequest[e] = r;
                          label = r[field.optionLabels];
                          fieldOptions[field.name].push({
                            value: record[field.name],
                            label: label
                          });
                          if (!(field.tr || field.options)) {
                            _context5.next = 9;
                            break;
                          }
                          return _context5.abrupt("return", tr(label));
                        case 9:
                          return _context5.abrupt("return", label);
                        case 10:
                        case "end":
                          return _context5.stop();
                      }
                    }, _callee5);
                  }));
                  return function (_x23) {
                    return _ref2.apply(this, arguments);
                  };
                }());
              }
            }
          }
        }
        if (field.setRelationTo && record[field.setRelationTo] && record[field.setRelationTo][field.optionLabels]) {
          return record[field.setRelationTo][field.optionLabels];
        }
        if (field.setRelationTo && record[field.setRelationTo] && record[field.setRelationTo].Name) {
          return record[field.setRelationTo].Name;
        }
        return record[field.name];
      }
      if (cutName) {
        var maxLength = 50;
        if (field.maxLength) maxLength = field.maxLength;
        if (record[field.name] && typeof record[field.name] === 'string') {
          if (record[field.name].length > maxLength) {
            return record[field.name].substring(0, maxLength) + '...';
          }
        }
      }
      if (field && field.editor && field.currency && record[field.currency]) {
        return tools.toNumber(record[field.name], null, record[field.currency]);
      }
      return "" + record[field.name];
    }
  }, {
    key: "getMaxLength",
    value: function getMaxLength(tableSpec, fieldName, rowFieldName) {
      if (!tableSpec) return;
      if (rowFieldName) {
        if (tableSpec[fieldName] && tableSpec[fieldName][rowFieldName]) {
          return tableSpec[fieldName][rowFieldName];
        }
      } else {
        if (tableSpec[fieldName]) {
          return tableSpec[fieldName];
        }
      }
    }
  }, {
    key: "addNotification",
    value: function addNotification(_ref3, insert) {
      var msg = _ref3.msg,
        comment = _ref3.comment,
        action = _ref3.action,
        key = _ref3.key,
        id = _ref3.id,
        status = _ref3.status,
        html = _ref3.html;
      var notifications = localStorage.getItem('notifications');
      notifications = JSON.parse(notifications);
      if (notifications) {
        //let f = _.find(notifications, (r) => r.comment == comment);
        //if (f) return;
        if (id) {
          var f = _.find(notifications, function (r) {
            return r.id == id;
          });
          if (f) return;
        }
        if (key) {
          var _f = _.find(notifications, function (r) {
            return r.key == key;
          });
          if (_f) return;
        }
      }
      if (!notifications) notifications = [];
      if (insert) {
        notifications.splice(0, 0, {
          msg: msg,
          comment: comment,
          action: action,
          key: key,
          id: id,
          status: status,
          html: html
        });
      } else {
        notifications.push({
          msg: msg,
          comment: comment,
          action: action,
          key: key,
          id: id,
          status: status,
          html: html
        });
      }
      localStorage.setItem('notifications', JSON.stringify(notifications));
    }
  }, {
    key: "responseHelper",
    value: function responseHelper(status, response) {
      if (status == 401) {
        if (window.location.hash == '#/login') {
          return {
            err: 'Incorrect User or Password',
            detail: response
          };
        } else {
          api.currentUser = null;
          window.location.replace(window.location.origin + '/#/login');
        }
      } else if (status == 400) {
        if ((0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(response) === 'object') {
          if (response.codes && response.params) {
            var m = [];
            var i = 0;
            var _iterator9 = _createForOfIteratorHelper(response.codes),
              _step9;
            try {
              for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                var p = _step9.value;
                if (p == '%s') {
                  m.push(response.params[i]);
                  i += 1;
                } else {
                  m.push(tr(p));
                }
              }
            } catch (err) {
              _iterator9.e(err);
            } finally {
              _iterator9.f();
            }
            return {
              err: m.join(' '),
              detail: response,
              field: response.field
            };
          }
          return {
            err: response.code,
            detail: response,
            field: response.field
          };
        } else {
          return {
            err: response
          };
        }
      } else if (status == 433) {
        if (api.currentUser) {
          alert(tr('Session closed. User logged into another device'));
        }
        api.currentUser = null;
        window.location.replace(window.location.origin + '/#/logout');
      } else if (status == 420) {
        return {
          err: 'Integrity Error',
          detail: response
        };
      } else if (status == 403) {
        return {
          err: 'Action not allowed',
          detail: response
        };
      } else if (status == 410) {
        return {
          err: 'Session closed. User logged in in another device',
          detail: response
        };
      } else if (status == 500) {
        return {
          err: 'Server Error',
          detail: "Server Error: ".concat(response)
        };
      } else {
        return status;
        //reject(error);
      }
    }
  }, {
    key: "getWeekDayName",
    value: function getWeekDayName(w) {
      return {
        0: 'Monday',
        1: 'Tuesday',
        2: 'Wednesday',
        3: 'Thursday',
        4: 'Friday',
        5: 'Saturday',
        6: 'Sunday'
      }[w];
    }
  }, {
    key: "getClass",
    value: function getClass(tabId, field, currentTab, invalid) {
      var res = '';
      if (currentTab == tabId) res += 'active ';
      if (field && invalid[field]) res += ' tab-alert';
      return res;
    }
  }, {
    key: "abmList",
    value: function abmList(self) {
      if (self.search) {
        var abmFields = self.abmFields;
        if (self.fieldsAbmList) {
          abmFields = _.filter(abmFields, function (r) {
            return self.fieldsAbmList.indexOf(r.name) > -1;
          });
        }
        ;
        /*if (self.columnsNames) {
            abmFields = self.columnsNames;
        }
        if (self.fieldsAbmList) {
            abmFields = _.filter(self.abmFields, (r) => {
                return self.fieldsAbmList.indexOf(r.name) > 1;
            });
        }*/
        //let t1 = moment(new Date()).valueOf();
        var values = self.search.split(' ');
        var res = _.filter(self.dataList, function (r) {
          var _iterator10 = _createForOfIteratorHelper(values),
            _step10;
          try {
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              var value = _step10.value;
              var found = false;
              var re = new RegExp(tools.normalize(value, true), 'i');
              var _iterator11 = _createForOfIteratorHelper(abmFields),
                _step11;
              try {
                for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                  var f = _step11.value;
                  var displayValue = void 0;
                  if (self.listValues) {
                    //displayValue = self.listValues[[f.name, r[f.name]]]
                  } else {
                    displayValue = tools.getDisplayValue(r, f, self.serverSide, self.fieldOptions, false);
                  }
                  displayValue = tools.getDisplayValue(r, f, self.serverSide, self.fieldOptions, false);
                  if (!displayValue) displayValue = r[f];
                  if (displayValue) {
                    var m = tools.normalize(displayValue, true).match(re);
                    if (m) found = true;
                  }
                }
              } catch (err) {
                _iterator11.e(err);
              } finally {
                _iterator11.f();
              }
              if (!found) return false;
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }
          return true;
        });
        //let t2 = moment(new Date()).valueOf();
        //console.log('search', t2 - t1)
        return res;
      }
      return self.dataList;
    }
  }, {
    key: "printLog",
    value: function printLog(obj) {
      return;
      var t = this.getTime();
      console.log('ZZZ', t, this.t, this.oldT, obj, this.obj);
      this.obj = obj;
    }
  }, {
    key: "isNormalInteger",
    value: function isNormalInteger(str) {
      var n = Math.floor(Number(str));
      return n !== Infinity && String(n) === str && n >= 0;
    }
  }, {
    key: "getBases",
    value: function getBases(self) {
      var res = {};
      for (var id in self) {
        if (tools.isNormalInteger(id)) {
          res[id] = self[id];
        }
      }
      return res;
    }
  }, {
    key: "ifText",
    value: function ifText(s) {
      if (!s) return false;
      var t = s.replace(/ |<p>|<\/p>|<br>|\n/g, '');
      if (!t) return false;
      if (t.length > 0) return true;
    }
  }, {
    key: "serverTypes",
    value: function serverTypes(fields, options) {
      var res = [];
      var types = {
        'Text': 'text-area',
        'String': 'text',
        'Float': 'number',
        'Integer': 'number',
        'DateTime': 'datetime',
        'Time': 'time',
        'Date': 'date',
        'Boolean': 'checkbox',
        'Collection': '[]',
        'attach': 'attach',
        'LONGBLOB': 'text-area',
        'ListValues': 'select',
        'DOUBLE': 'number',
        'link': 'link'
      };
      var closed = false;
      for (var fieldName in fields) {
        var field = fields[fieldName];
        var editor = field.type;
        if (types[editor]) editor = types[editor];
        if (field.type == 'Text' && field.style) editor = 'text-area-style';
        var label = fieldName;
        if (fieldName.match(/[A-Z][a-z]+|[0-9]+/g)) {
          label = fieldName.replace(/([a-z])([A-Z])/g, '$1 $2');
        }
        if (field.label) label = field.label;
        if (fieldName == 'Closed') {
          closed = {
            name: fieldName,
            editor: editor,
            label: label,
            hideFromList: true,
            footerRow: true
          };
        } else {
          var f = {
            name: fieldName,
            editor: editor,
            label: label
          };
          if (editor == 'date') {
            f.dateFormat = 'DD/MM/YYYY';
          }
          if (editor == 'datetime') {
            f.dateFormat = 'DD/MM/YYYY HH:mm';
          }
          if (editor == 'number') {
            f.decimal = 2;
          }
          if (editor == 'number' && field.type == 'Integer') {
            f.decimal = 0;
          }
          if (editor == 'text-area') {
            f.columns = 12;
          }
          if (editor == 'text-area-style') {
            f.columns = 12;
          }
          if (field.relation) {
            f.editor = 'vue-select';
            f.relation = field.relation;
            f.setRelationTo = field.relation_to;
            f.optionLabels = 'Name';
            if (field.relation == 'user') f.optionLabels = 'UserName';
            if (field.options_labels) f.optionLabels = field.options_labels;
            f.label = tools.toTitleCase(field.relation);
            if (field.relation_to) {
              f.label = field.relation_to;
              if (field.relation_to.match(/[A-Z][a-z]+|[0-9]+/g)) {
                f.label = field.relation_to.match(/[A-Z][a-z]+|[0-9]+/g).join(" ");
              }
            }
            if (field.list) {
              f.list = true;
            }
          }
          if (field.options) {
            f.editor = 'select';
            f.options = _.map(field.options, function (r) {
              return {
                value: r,
                label: tools.toTitleCase(r)
              };
            });
          }
          if (field.type == 'Collection') {
            f.editor = [];
            f.rowFields = tools.serverTypes(field.row_fields);
          }
          if (field.hide) f.hideFromList = true;
          if (field.hide_list) f.hideFromList = true;
          if (field.add_blank) f.addBlank = true;
          if (field.header_field) f.headerField = true;
          if (field.columns) f.columns = field.columns;
          if (field.length) f.length = field.length;
          if (field.footer_row) f.footerRow = true;
          if (field.hide) f.hidden = true;
          if (field.order) f.order = field.order;
          if (field.label) f.label = field.label;
          if (field.read_only) f.readonly = true;
          if (field.max_length) f.maxLength = field.max_length;
          if (field.required) f.required = true;
          if (field.decimal) f.decimal = field.decimal;
          if (field.def_value) f.defValue = field.def_value;
          if (field.rows) f.rows = field.rows;
          if (field.linkTo) f.linkTo = field.linkTo;
          if (field.list) f.list = true;
          res.push(f);
        }
      }
      res.sort(function (a, b) {
        if (!a.order) return 1;
        if (!b.order) return -1;
        if (a.order > b.order) return 1;
        if (a.order < b.order) return -1;
        return 0;
      });
      if (options && options.fieldsOrder) {
        res.sort(function (a, b) {
          var sa = options.fieldsOrder.indexOf(a.name);
          var sb = options.fieldsOrder.indexOf(b.name);
          if (sa == -1) sa = 100;
          if (sb == -1) sb = 100;
          return sa - sb;
        });
      }
      if (options && options.extraFields) {
        var _iterator12 = _createForOfIteratorHelper(options.extraFields),
          _step12;
        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var _field = _step12.value;
            res.push(_field);
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
      }
      if (closed) {
        res.push(closed);
      }
      if (options && options.fieldsDataReplace) {
        var _loop2 = function _loop2(_fieldName) {
          var fieldIndex = _.findIndex(res, function (f) {
            return f.name == _fieldName;
          });
          if (fieldIndex > -1) {
            for (var data in options.fieldsDataReplace[_fieldName]) {
              res[fieldIndex][data] = options.fieldsDataReplace[_fieldName][data];
            }
          }
        };
        for (var _fieldName in options.fieldsDataReplace) {
          _loop2(_fieldName);
        }
      }
      return res;
    }
  }, {
    key: "plainObject",
    value: function plainObject(record, onlyHeaders) {
      var r = Object.assign({}, record);
      var toDelete = [];
      for (var fieldName in record) {
        if (!onlyHeaders && fieldName[0] != '$') {
          if (Array.isArray(record[fieldName])) {
            r[fieldName] = [];
            var _iterator13 = _createForOfIteratorHelper(record[fieldName]),
              _step13;
            try {
              for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                var row = _step13.value;
                var newRow = row;
                if ((0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(newRow) === 'object') {
                  newRow = this.plainObject(row);
                }
                r[fieldName].push(newRow);
              }
            } catch (err) {
              _iterator13.e(err);
            } finally {
              _iterator13.f();
            }
          } else if ((0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(record[fieldName]) === 'object') {
            if (record[fieldName]) {
              r[fieldName] = this.plainObject(record[fieldName]);
            }
          }
        }
        if (fieldName[0] == '$') {
          toDelete.push(fieldName);
        }
      }
      //if (toDelete.length>0) console.log(toDelete)
      for (var _i = 0, _toDelete = toDelete; _i < _toDelete.length; _i++) {
        var _fieldName2 = _toDelete[_i];
        delete r[_fieldName2];
      }
      //console.log(r)
      return r;
    }
  }, {
    key: "plainArray",
    value: function plainArray(rows) {
      var r = [];
      var _iterator14 = _createForOfIteratorHelper(rows),
        _step14;
      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var row = _step14.value;
          var newRow = this.plainObject(row);
          r.push(newRow);
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
      return r;
    }
  }, {
    key: "clean",
    value: function clean(record) {
      if (!record) return;
      if (record.fields) {
        var _iterator15 = _createForOfIteratorHelper(record.fields),
          _step15;
        try {
          for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
            var field = _step15.value;
            if (field && (Array.isArray(field.editor) || field.rowFields)) {
              var _iterator16 = _createForOfIteratorHelper(record[field.name]),
                _step16;
              try {
                for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                  var row = _step16.value;
                  if (row) {
                    this.clean(row);
                  }
                }
              } catch (err) {
                _iterator16.e(err);
              } finally {
                _iterator16.f();
              }
            } else if (field && (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(field.editor) == 'object') {
              if (record[field.name]) {
                this.clean(record[field.name]);
              }
            }
          }
        } catch (err) {
          _iterator15.e(err);
        } finally {
          _iterator15.f();
        }
      }
      delete record['fields'];
      delete record['fieldsObject'];
      delete record['abmFields'];
      delete record['arrayFields'];
      delete record['fieldOptions'];
      delete record['tabList'];
      delete record['tableSpec'];
      delete record['invalid'];
      delete record['_loaded'];
      delete record['_id'];
      delete record['_computedGetters'];
      delete record['_cache'];
      delete record['_isClone'];
      delete record['$parent'];
      delete record['me'];
      delete record['_new'];
      delete record['_modified'];
      delete record['serverSide'];
      delete record['search'];
      delete record['beforeSave'];
      delete record['canAdd'];
      delete record['userCanEdit'];
      delete record['userCanDelete'];
      delete record['evalDelete'];
      delete record['setTitleName'];
      delete record['evalEdit'];
      delete record['afterEdit'];
      delete record['showClosed'];
      delete record['attachList'];
      delete record['attached'];
      delete record['endpoint'];
      delete record['notifications'];
      delete record['processingAttach'];
      delete record['tableName'];
      delete record['getters'];
      delete record['_recordLoaded'];
      delete record['dependencies'];
      delete record['_requestCount'];
      delete record['_changeNr'];
      delete record['roomTypes'];
      if (!record.id) delete record['id'];
    }
  }, {
    key: "cleanRelations",
    value: function cleanRelations(record) {
      if (!record) return;
      if (record.fields) {
        var _iterator17 = _createForOfIteratorHelper(record.fields),
          _step17;
        try {
          for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
            var field = _step17.value;
            if (field && (Array.isArray(field.editor) || field.rowFields)) {
              var _iterator18 = _createForOfIteratorHelper(record[field.name]),
                _step18;
              try {
                for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                  var row = _step18.value;
                  if (row) {
                    this.cleanRelations(row);
                  }
                }
              } catch (err) {
                _iterator18.e(err);
              } finally {
                _iterator18.f();
              }
            } else if (field && (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(field.editor) == 'object') {
              if (record[field.name]) {
                this.cleanRelations(record[field.name]);
              }
            }
            if (field.setRelationTo && record[field.setRelationTo]) {
              delete record[field.setRelationTo];
            }
          }
        } catch (err) {
          _iterator17.e(err);
        } finally {
          _iterator17.f();
        }
      }
    }
  }, {
    key: "setRelations",
    value: function () {
      var _setRelations = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(record) {
        var _iterator19, _step19, field, _iterator20, _step20, row;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (record) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              if (!record.fields) {
                _context6.next = 22;
                break;
              }
              _iterator19 = _createForOfIteratorHelper(record.fields);
              _context6.prev = 4;
              _iterator19.s();
            case 6:
              if ((_step19 = _iterator19.n()).done) {
                _context6.next = 14;
                break;
              }
              field = _step19.value;
              if (field && (Array.isArray(field.editor) || field.rowFields)) {
                _iterator20 = _createForOfIteratorHelper(record[field.name]);
                try {
                  for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
                    row = _step20.value;
                    if (row) {
                      this.setRelations(row);
                    }
                  }
                } catch (err) {
                  _iterator20.e(err);
                } finally {
                  _iterator20.f();
                }
              } else if (field && (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(field.editor) == 'object') {
                if (record[field.name]) {
                  this.setRelations(record[field.name]);
                }
              }
              if (!(field.setRelationTo && record[field.setRelationTo])) {
                _context6.next = 12;
                break;
              }
              _context6.next = 12;
              return record.setRelationTo(field);
            case 12:
              _context6.next = 6;
              break;
            case 14:
              _context6.next = 19;
              break;
            case 16:
              _context6.prev = 16;
              _context6.t0 = _context6["catch"](4);
              _iterator19.e(_context6.t0);
            case 19:
              _context6.prev = 19;
              _iterator19.f();
              return _context6.finish(19);
            case 22:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[4, 16, 19, 22]]);
      }));
      function setRelations(_x24) {
        return _setRelations.apply(this, arguments);
      }
      return setRelations;
    }()
  }, {
    key: "removeGetters",
    value: function removeGetters(recordClass, record) {
      var proto = Object.getPrototypeOf(recordClass);
      var names = Object.getOwnPropertyNames(proto);
      var getters = names.filter(function (name) {
        return name.substring(0, 3) == '$$_';
      });
      var _iterator21 = _createForOfIteratorHelper(getters),
        _step21;
      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var getterName = _step21.value;
          delete record[getterName.replace('$$_', '')];
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
    }
  }, {
    key: "checkFields",
    value: function checkFields(self, record) {
      var required = false;
      self.invalid = {};
      self.invalid._tabData = false;
      var fields = _.cloneDeep(self.fields);
      if (self.tabList) {
        var _iterator22 = _createForOfIteratorHelper(self.tabList),
          _step22;
        try {
          for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
            var tab = _step22.value;
            var _iterator23 = _createForOfIteratorHelper(tab.fields),
              _step23;
            try {
              for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
                var field = _step23.value;
                field.tabName = tab.name;
                fields.push(field);
              }
            } catch (err) {
              _iterator23.e(err);
            } finally {
              _iterator23.f();
            }
          }
        } catch (err) {
          _iterator22.e(err);
        } finally {
          _iterator22.f();
        }
      }
      for (var p in fields) {
        var needsRequired = fields[p].required;
        if (fields[p].requiredCallback) {
          needsRequired = fields[p].requiredCallback(self, record);
        }
        if (needsRequired) {
          var value = record[fields[p].name];
          if (value === null || value === undefined || value === '' || fields[p].editor == 'date' && value == 'Invalid date') {
            if (fields[p].tabName) {
              self.invalid[fields[p].tabName] = true;
            } else if (!fields[p].headerField) {
              self.invalid._tabData = true;
            }
            self.invalid[fields[p].name] = true;
            required = true;
          }
        }
        if (Array.isArray(fields[p].editor)) {
          var _iterator24 = _createForOfIteratorHelper(record[fields[p].name]),
            _step24;
          try {
            for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
              var row = _step24.value;
              if (row.Closed) continue;
              var _iterator25 = _createForOfIteratorHelper(row.fields),
                _step25;
              try {
                for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
                  var rowField = _step25.value;
                  var _needsRequired = rowField.required;
                  if (rowField.requiredCallback) {
                    _needsRequired = rowField.requiredCallback(row, record);
                  }
                  if (_needsRequired) {
                    var _value = row[rowField.name];
                    if (_value === null || _value === undefined || _value === '' || rowField.editor == 'date' && _value == 'Invalid date') {
                      self.invalid[fields[p].name] = {};
                      self.invalid[fields[p].name][rowField.name] = true;
                      row.invalid[rowField.name] = true;
                      required = true;
                    }
                  }
                }
              } catch (err) {
                _iterator25.e(err);
              } finally {
                _iterator25.f();
              }
            }
          } catch (err) {
            _iterator24.e(err);
          } finally {
            _iterator24.f();
          }
        }
      }
      self.invalid = Object.assign({}, self.invalid);
      if (required) return ['Fill required fields'];
    }
  }, {
    key: "compare",
    value: function compare(a, b, parent) {
      var res = {};
      for (var i in a) {
        if (i.substring(0, 1) == '_') continue;
        if (i == 'ModifiedUTC') continue;
        if (i == 'ModifiedUserId') continue;
        if (i == 'BookingDayId') continue;
        if (i == 'BookingDayHotelId') continue;
        if (i.substring(0, 1) == '$') continue;
        if (i.substring(0, 1) != i.substring(0, 1).toUpperCase()) continue;
        if (Array.isArray(a[i])) {
          if (!b) b = [];
          var c = this.compare(a[i], b[i], i);
          if (Object.keys(c).length > 0) {
            res[i] = c;
          }
        } else if ((0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(a[i]) === 'object') {
          if (!b) b = {};
          var _c = this.compare(a[i], b[i], i);
          if (Object.keys(_c).length > 0) {
            res[i] = _c;
          }
        } else {
          if (a && b && a[i] != b[i]) {
            res[i] = [a[i], b[i]];
          }
          if (a && !b) {
            res[i] = [a[i], b];
          }
        }
      }
      return res;
    }
  }, {
    key: "removeFieldByName",
    value: function removeFieldByName(array, name) {
      var index = _.findIndex(array, function (r) {
        return r && r.name == name;
      });
      if (index > -1) delete array.splice(index, 1);
    }
  }, {
    key: "getPrice",
    value: function getPrice(cost, markup) {
      return cost * (1 + markup / 100.0);
    }
  }, {
    key: "getCost",
    value: function getCost(price, markup) {
      return price / (markup / 100 + 1);
    }
  }, {
    key: "getMarkup",
    value: function getMarkup(price, cost) {
      return (price / cost - 1) * 100.0;
    }
  }, {
    key: "isNull",
    value: function isNull(v) {
      return v === null || v === undefined || v === '' || Number.isNaN(v);
    }
  }, {
    key: "round",
    value: function round(v, d) {
      var f = Math.pow(10, d);
      return Math.round(v * f) / f;
    }
  }, {
    key: "importJSON",
    value: function importJSON(name, path, module, dict) {
      var extras = Object.assign([], api.EXTRAS).reverse();
      var p = "@/".concat(path, "/").concat(name, ".json");
      var m;
      if (!module && extras.length > 0) {
        m = extras[0];
        p = "@/extra/".concat(m, "/").concat(path, "/").concat(name);
      } else if (extras.length > 0) {
        var i = extras.indexOf(module);
        m = extras[i + 1];
        if (m) p = "@/extra/".concat(m, "/").concat(path, "/").concat(name);
      }
      var res;
      try {
        if (m) {
          res = __webpack_require__(99837)("./".concat(m, "/").concat(path, "/").concat(name));
        } else {
          res = __webpack_require__(25538)("./".concat(path, "/").concat(name));
        }
      } catch (err) {
        if (m) res = this.importJSON(name, path, m);
      }
      if (res && dict) res = Object.assign(res, dict);
      if (m) res = this.importJSON(name, path, m, res);
      return res;
    }
  }, {
    key: "deepCloneWithParent",
    value: function deepCloneWithParent(obj) {
      var _Object$getOwnPropert;
      var clone = _.cloneDeep(obj);
      var parent = (_Object$getOwnPropert = Object.getOwnPropertyDescriptor(obj, '$parent')) === null || _Object$getOwnPropert === void 0 ? void 0 : _Object$getOwnPropert.value;
      if (parent !== undefined) {
        Object.defineProperty(clone, '$parent', {
          enumerable: false,
          value: parent,
          configurable: true
        });
      }
      return clone;
    }
  }]);
}();
window.tools = new Tools();

/***/ }),

/***/ 80598:
/***/ ((module) => {

"use strict";

module.exports = function generate_enum(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $i = 'i' + $lvl,
    $vSchema = 'schema' + $lvl;
  if (!$isData) {
    out += ' var ' + ($vSchema) + ' = validate.schema' + ($schemaPath) + ';';
  }
  out += 'var ' + ($valid) + ';';
  if ($isData) {
    out += ' if (schema' + ($lvl) + ' === undefined) ' + ($valid) + ' = true; else if (!Array.isArray(schema' + ($lvl) + ')) ' + ($valid) + ' = false; else {';
  }
  out += '' + ($valid) + ' = false;for (var ' + ($i) + '=0; ' + ($i) + '<' + ($vSchema) + '.length; ' + ($i) + '++) if (equal(' + ($data) + ', ' + ($vSchema) + '[' + ($i) + '])) { ' + ($valid) + ' = true; break; }';
  if ($isData) {
    out += '  }  ';
  }
  out += ' if (!' + ($valid) + ') {   ';
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('enum') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { allowedValues: schema' + ($lvl) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should be equal to one of the allowed values\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += ' }';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),

/***/ 80713:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8818);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }

var AccountMovementView = /*#__PURE__*/function (_View) {
  function AccountMovementView() {
    _classCallCheck(this, AccountMovementView);
    return _callSuper(this, AccountMovementView, arguments);
  }
  _inherits(AccountMovementView, _View);
  return _createClass(AccountMovementView, null, [{
    key: "options",
    value: function options() {
      return {
        fieldsOrder: ['TransDate', 'FromPaymentTypeId', 'FromCurrencyId', 'FromAmount', 'ToPaymentTypeId', 'ToCurrencyId', 'ToAmount'],
        canAdd: true
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(AccountMovementView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              res = _context.sent;
              return _context.abrupt("return", res);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_0__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AccountMovementView);

/***/ }),

/***/ 80825:
/***/ ((module) => {

module.exports = [
  "🀄️",
  "🃏",
  "🅰️",
  "🅱️",
  "🅾️",
  "🅿️",
  "🆎",
  "🆑",
  "🆒",
  "🆓",
  "🆔",
  "🆕",
  "🆖",
  "🆗",
  "🆘",
  "🆙",
  "🆚",
  "🇦🇨",
  "🇦🇩",
  "🇦🇪",
  "🇦🇫",
  "🇦🇬",
  "🇦🇮",
  "🇦🇱",
  "🇦🇲",
  "🇦🇴",
  "🇦🇶",
  "🇦🇷",
  "🇦🇸",
  "🇦🇹",
  "🇦🇺",
  "🇦🇼",
  "🇦🇽",
  "🇦🇿",
  "🇦",
  "🇧🇦",
  "🇧🇧",
  "🇧🇩",
  "🇧🇪",
  "🇧🇫",
  "🇧🇬",
  "🇧🇭",
  "🇧🇮",
  "🇧🇯",
  "🇧🇱",
  "🇧🇲",
  "🇧🇳",
  "🇧🇴",
  "🇧🇶",
  "🇧🇷",
  "🇧🇸",
  "🇧🇹",
  "🇧🇻",
  "🇧🇼",
  "🇧🇾",
  "🇧🇿",
  "🇧",
  "🇨🇦",
  "🇨🇨",
  "🇨🇩",
  "🇨🇫",
  "🇨🇬",
  "🇨🇭",
  "🇨🇮",
  "🇨🇰",
  "🇨🇱",
  "🇨🇲",
  "🇨🇳",
  "🇨🇴",
  "🇨🇵",
  "🇨🇷",
  "🇨🇺",
  "🇨🇻",
  "🇨🇼",
  "🇨🇽",
  "🇨🇾",
  "🇨🇿",
  "🇨",
  "🇩🇪",
  "🇩🇬",
  "🇩🇯",
  "🇩🇰",
  "🇩🇲",
  "🇩🇴",
  "🇩🇿",
  "🇩",
  "🇪🇦",
  "🇪🇨",
  "🇪🇪",
  "🇪🇬",
  "🇪🇭",
  "🇪🇷",
  "🇪🇸",
  "🇪🇹",
  "🇪🇺",
  "🇪",
  "🇫🇮",
  "🇫🇯",
  "🇫🇰",
  "🇫🇲",
  "🇫🇴",
  "🇫🇷",
  "🇫",
  "🇬🇦",
  "🇬🇧",
  "🇬🇩",
  "🇬🇪",
  "🇬🇫",
  "🇬🇬",
  "🇬🇭",
  "🇬🇮",
  "🇬🇱",
  "🇬🇲",
  "🇬🇳",
  "🇬🇵",
  "🇬🇶",
  "🇬🇷",
  "🇬🇸",
  "🇬🇹",
  "🇬🇺",
  "🇬🇼",
  "🇬🇾",
  "🇬",
  "🇭🇰",
  "🇭🇲",
  "🇭🇳",
  "🇭🇷",
  "🇭🇹",
  "🇭🇺",
  "🇭",
  "🇮🇨",
  "🇮🇩",
  "🇮🇪",
  "🇮🇱",
  "🇮🇲",
  "🇮🇳",
  "🇮🇴",
  "🇮🇶",
  "🇮🇷",
  "🇮🇸",
  "🇮🇹",
  "🇮",
  "🇯🇪",
  "🇯🇲",
  "🇯🇴",
  "🇯🇵",
  "🇯",
  "🇰🇪",
  "🇰🇬",
  "🇰🇭",
  "🇰🇮",
  "🇰🇲",
  "🇰🇳",
  "🇰🇵",
  "🇰🇷",
  "🇰🇼",
  "🇰🇾",
  "🇰🇿",
  "🇰",
  "🇱🇦",
  "🇱🇧",
  "🇱🇨",
  "🇱🇮",
  "🇱🇰",
  "🇱🇷",
  "🇱🇸",
  "🇱🇹",
  "🇱🇺",
  "🇱🇻",
  "🇱🇾",
  "🇱",
  "🇲🇦",
  "🇲🇨",
  "🇲🇩",
  "🇲🇪",
  "🇲🇫",
  "🇲🇬",
  "🇲🇭",
  "🇲🇰",
  "🇲🇱",
  "🇲🇲",
  "🇲🇳",
  "🇲🇴",
  "🇲🇵",
  "🇲🇶",
  "🇲🇷",
  "🇲🇸",
  "🇲🇹",
  "🇲🇺",
  "🇲🇻",
  "🇲🇼",
  "🇲🇽",
  "🇲🇾",
  "🇲🇿",
  "🇲",
  "🇳🇦",
  "🇳🇨",
  "🇳🇪",
  "🇳🇫",
  "🇳🇬",
  "🇳🇮",
  "🇳🇱",
  "🇳🇴",
  "🇳🇵",
  "🇳🇷",
  "🇳🇺",
  "🇳🇿",
  "🇳",
  "🇴🇲",
  "🇴",
  "🇵🇦",
  "🇵🇪",
  "🇵🇫",
  "🇵🇬",
  "🇵🇭",
  "🇵🇰",
  "🇵🇱",
  "🇵🇲",
  "🇵🇳",
  "🇵🇷",
  "🇵🇸",
  "🇵🇹",
  "🇵🇼",
  "🇵🇾",
  "🇵",
  "🇶🇦",
  "🇶",
  "🇷🇪",
  "🇷🇴",
  "🇷🇸",
  "🇷🇺",
  "🇷🇼",
  "🇷",
  "🇸🇦",
  "🇸🇧",
  "🇸🇨",
  "🇸🇩",
  "🇸🇪",
  "🇸🇬",
  "🇸🇭",
  "🇸🇮",
  "🇸🇯",
  "🇸🇰",
  "🇸🇱",
  "🇸🇲",
  "🇸🇳",
  "🇸🇴",
  "🇸🇷",
  "🇸🇸",
  "🇸🇹",
  "🇸🇻",
  "🇸🇽",
  "🇸🇾",
  "🇸🇿",
  "🇸",
  "🇹🇦",
  "🇹🇨",
  "🇹🇩",
  "🇹🇫",
  "🇹🇬",
  "🇹🇭",
  "🇹🇯",
  "🇹🇰",
  "🇹🇱",
  "🇹🇲",
  "🇹🇳",
  "🇹🇴",
  "🇹🇷",
  "🇹🇹",
  "🇹🇻",
  "🇹🇼",
  "🇹🇿",
  "🇹",
  "🇺🇦",
  "🇺🇬",
  "🇺🇲",
  "🇺🇳",
  "🇺🇸",
  "🇺🇾",
  "🇺🇿",
  "🇺",
  "🇻🇦",
  "🇻🇨",
  "🇻🇪",
  "🇻🇬",
  "🇻🇮",
  "🇻🇳",
  "🇻🇺",
  "🇻",
  "🇼🇫",
  "🇼🇸",
  "🇼",
  "🇽🇰",
  "🇽",
  "🇾🇪",
  "🇾🇹",
  "🇾",
  "🇿🇦",
  "🇿🇲",
  "🇿🇼",
  "🇿",
  "🈁",
  "🈂️",
  "🈚️",
  "🈯️",
  "🈲",
  "🈳",
  "🈴",
  "🈵",
  "🈶",
  "🈷️",
  "🈸",
  "🈹",
  "🈺",
  "🉐",
  "🉑",
  "🌀",
  "🌁",
  "🌂",
  "🌃",
  "🌄",
  "🌅",
  "🌆",
  "🌇",
  "🌈",
  "🌉",
  "🌊",
  "🌋",
  "🌌",
  "🌍",
  "🌎",
  "🌏",
  "🌐",
  "🌑",
  "🌒",
  "🌓",
  "🌔",
  "🌕",
  "🌖",
  "🌗",
  "🌘",
  "🌙",
  "🌚",
  "🌛",
  "🌜",
  "🌝",
  "🌞",
  "🌟",
  "🌠",
  "🌡️",
  "🌤️",
  "🌥️",
  "🌦️",
  "🌧️",
  "🌨️",
  "🌩️",
  "🌪️",
  "🌫️",
  "🌬️",
  "🌭",
  "🌮",
  "🌯",
  "🌰",
  "🌱",
  "🌲",
  "🌳",
  "🌴",
  "🌵",
  "🌶️",
  "🌷",
  "🌸",
  "🌹",
  "🌺",
  "🌻",
  "🌼",
  "🌽",
  "🌾",
  "🌿",
  "🍀",
  "🍁",
  "🍂",
  "🍃",
  "🍄",
  "🍅",
  "🍆",
  "🍇",
  "🍈",
  "🍉",
  "🍊",
  "🍋",
  "🍌",
  "🍍",
  "🍎",
  "🍏",
  "🍐",
  "🍑",
  "🍒",
  "🍓",
  "🍔",
  "🍕",
  "🍖",
  "🍗",
  "🍘",
  "🍙",
  "🍚",
  "🍛",
  "🍜",
  "🍝",
  "🍞",
  "🍟",
  "🍠",
  "🍡",
  "🍢",
  "🍣",
  "🍤",
  "🍥",
  "🍦",
  "🍧",
  "🍨",
  "🍩",
  "🍪",
  "🍫",
  "🍬",
  "🍭",
  "🍮",
  "🍯",
  "🍰",
  "🍱",
  "🍲",
  "🍳",
  "🍴",
  "🍵",
  "🍶",
  "🍷",
  "🍸",
  "🍹",
  "🍺",
  "🍻",
  "🍼",
  "🍽️",
  "🍾",
  "🍿",
  "🎀",
  "🎁",
  "🎂",
  "🎃",
  "🎄",
  "🎅🏻",
  "🎅🏼",
  "🎅🏽",
  "🎅🏾",
  "🎅🏿",
  "🎅",
  "🎆",
  "🎇",
  "🎈",
  "🎉",
  "🎊",
  "🎋",
  "🎌",
  "🎍",
  "🎎",
  "🎏",
  "🎐",
  "🎑",
  "🎒",
  "🎓",
  "🎖️",
  "🎗️",
  "🎙️",
  "🎚️",
  "🎛️",
  "🎞️",
  "🎟️",
  "🎠",
  "🎡",
  "🎢",
  "🎣",
  "🎤",
  "🎥",
  "🎦",
  "🎧",
  "🎨",
  "🎩",
  "🎪",
  "🎫",
  "🎬",
  "🎭",
  "🎮",
  "🎯",
  "🎰",
  "🎱",
  "🎲",
  "🎳",
  "🎴",
  "🎵",
  "🎶",
  "🎷",
  "🎸",
  "🎹",
  "🎺",
  "🎻",
  "🎼",
  "🎽",
  "🎾",
  "🎿",
  "🏀",
  "🏁",
  "🏂🏻",
  "🏂🏼",
  "🏂🏽",
  "🏂🏾",
  "🏂🏿",
  "🏂",
  "🏃🏻‍♀️",
  "🏃🏻‍♂️",
  "🏃🏻",
  "🏃🏼‍♀️",
  "🏃🏼‍♂️",
  "🏃🏼",
  "🏃🏽‍♀️",
  "🏃🏽‍♂️",
  "🏃🏽",
  "🏃🏾‍♀️",
  "🏃🏾‍♂️",
  "🏃🏾",
  "🏃🏿‍♀️",
  "🏃🏿‍♂️",
  "🏃🏿",
  "🏃‍♀️",
  "🏃‍♂️",
  "🏃",
  "🏄🏻‍♀️",
  "🏄🏻‍♂️",
  "🏄🏻",
  "🏄🏼‍♀️",
  "🏄🏼‍♂️",
  "🏄🏼",
  "🏄🏽‍♀️",
  "🏄🏽‍♂️",
  "🏄🏽",
  "🏄🏾‍♀️",
  "🏄🏾‍♂️",
  "🏄🏾",
  "🏄🏿‍♀️",
  "🏄🏿‍♂️",
  "🏄🏿",
  "🏄‍♀️",
  "🏄‍♂️",
  "🏄",
  "🏅",
  "🏆",
  "🏇🏻",
  "🏇🏼",
  "🏇🏽",
  "🏇🏾",
  "🏇🏿",
  "🏇",
  "🏈",
  "🏉",
  "🏊🏻‍♀️",
  "🏊🏻‍♂️",
  "🏊🏻",
  "🏊🏼‍♀️",
  "🏊🏼‍♂️",
  "🏊🏼",
  "🏊🏽‍♀️",
  "🏊🏽‍♂️",
  "🏊🏽",
  "🏊🏾‍♀️",
  "🏊🏾‍♂️",
  "🏊🏾",
  "🏊🏿‍♀️",
  "🏊🏿‍♂️",
  "🏊🏿",
  "🏊‍♀️",
  "🏊‍♂️",
  "🏊",
  "🏋🏻‍♀️",
  "🏋🏻‍♂️",
  "🏋🏻",
  "🏋🏼‍♀️",
  "🏋🏼‍♂️",
  "🏋🏼",
  "🏋🏽‍♀️",
  "🏋🏽‍♂️",
  "🏋🏽",
  "🏋🏾‍♀️",
  "🏋🏾‍♂️",
  "🏋🏾",
  "🏋🏿‍♀️",
  "🏋🏿‍♂️",
  "🏋🏿",
  "🏋️‍♀️",
  "🏋️‍♂️",
  "🏋️",
  "🏌🏻‍♀️",
  "🏌🏻‍♂️",
  "🏌🏻",
  "🏌🏼‍♀️",
  "🏌🏼‍♂️",
  "🏌🏼",
  "🏌🏽‍♀️",
  "🏌🏽‍♂️",
  "🏌🏽",
  "🏌🏾‍♀️",
  "🏌🏾‍♂️",
  "🏌🏾",
  "🏌🏿‍♀️",
  "🏌🏿‍♂️",
  "🏌🏿",
  "🏌️‍♀️",
  "🏌️‍♂️",
  "🏌️",
  "🏍️",
  "🏎️",
  "🏏",
  "🏐",
  "🏑",
  "🏒",
  "🏓",
  "🏔️",
  "🏕️",
  "🏖️",
  "🏗️",
  "🏘️",
  "🏙️",
  "🏚️",
  "🏛️",
  "🏜️",
  "🏝️",
  "🏞️",
  "🏟️",
  "🏠",
  "🏡",
  "🏢",
  "🏣",
  "🏤",
  "🏥",
  "🏦",
  "🏧",
  "🏨",
  "🏩",
  "🏪",
  "🏫",
  "🏬",
  "🏭",
  "🏮",
  "🏯",
  "🏰",
  "🏳️‍🌈",
  "🏳️",
  "🏴‍☠️",
  "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
  "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
  "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
  "🏴",
  "🏵️",
  "🏷️",
  "🏸",
  "🏹",
  "🏺",
  "🏻",
  "🏼",
  "🏽",
  "🏾",
  "🏿",
  "🐀",
  "🐁",
  "🐂",
  "🐃",
  "🐄",
  "🐅",
  "🐆",
  "🐇",
  "🐈",
  "🐉",
  "🐊",
  "🐋",
  "🐌",
  "🐍",
  "🐎",
  "🐏",
  "🐐",
  "🐑",
  "🐒",
  "🐓",
  "🐔",
  "🐕‍🦺",
  "🐕",
  "🐖",
  "🐗",
  "🐘",
  "🐙",
  "🐚",
  "🐛",
  "🐜",
  "🐝",
  "🐞",
  "🐟",
  "🐠",
  "🐡",
  "🐢",
  "🐣",
  "🐤",
  "🐥",
  "🐦",
  "🐧",
  "🐨",
  "🐩",
  "🐪",
  "🐫",
  "🐬",
  "🐭",
  "🐮",
  "🐯",
  "🐰",
  "🐱",
  "🐲",
  "🐳",
  "🐴",
  "🐵",
  "🐶",
  "🐷",
  "🐸",
  "🐹",
  "🐺",
  "🐻",
  "🐼",
  "🐽",
  "🐾",
  "🐿️",
  "👀",
  "👁‍🗨",
  "👁️",
  "👂🏻",
  "👂🏼",
  "👂🏽",
  "👂🏾",
  "👂🏿",
  "👂",
  "👃🏻",
  "👃🏼",
  "👃🏽",
  "👃🏾",
  "👃🏿",
  "👃",
  "👄",
  "👅",
  "👆🏻",
  "👆🏼",
  "👆🏽",
  "👆🏾",
  "👆🏿",
  "👆",
  "👇🏻",
  "👇🏼",
  "👇🏽",
  "👇🏾",
  "👇🏿",
  "👇",
  "👈🏻",
  "👈🏼",
  "👈🏽",
  "👈🏾",
  "👈🏿",
  "👈",
  "👉🏻",
  "👉🏼",
  "👉🏽",
  "👉🏾",
  "👉🏿",
  "👉",
  "👊🏻",
  "👊🏼",
  "👊🏽",
  "👊🏾",
  "👊🏿",
  "👊",
  "👋🏻",
  "👋🏼",
  "👋🏽",
  "👋🏾",
  "👋🏿",
  "👋",
  "👌🏻",
  "👌🏼",
  "👌🏽",
  "👌🏾",
  "👌🏿",
  "👌",
  "👍🏻",
  "👍🏼",
  "👍🏽",
  "👍🏾",
  "👍🏿",
  "👍",
  "👎🏻",
  "👎🏼",
  "👎🏽",
  "👎🏾",
  "👎🏿",
  "👎",
  "👏🏻",
  "👏🏼",
  "👏🏽",
  "👏🏾",
  "👏🏿",
  "👏",
  "👐🏻",
  "👐🏼",
  "👐🏽",
  "👐🏾",
  "👐🏿",
  "👐",
  "👑",
  "👒",
  "👓",
  "👔",
  "👕",
  "👖",
  "👗",
  "👘",
  "👙",
  "👚",
  "👛",
  "👜",
  "👝",
  "👞",
  "👟",
  "👠",
  "👡",
  "👢",
  "👣",
  "👤",
  "👥",
  "👦🏻",
  "👦🏼",
  "👦🏽",
  "👦🏾",
  "👦🏿",
  "👦",
  "👧🏻",
  "👧🏼",
  "👧🏽",
  "👧🏾",
  "👧🏿",
  "👧",
  "👨🏻‍🌾",
  "👨🏻‍🍳",
  "👨🏻‍🎓",
  "👨🏻‍🎤",
  "👨🏻‍🎨",
  "👨🏻‍🏫",
  "👨🏻‍🏭",
  "👨🏻‍💻",
  "👨🏻‍💼",
  "👨🏻‍🔧",
  "👨🏻‍🔬",
  "👨🏻‍🚀",
  "👨🏻‍🚒",
  "👨🏻‍🦯",
  "👨🏻‍🦰",
  "👨🏻‍🦱",
  "👨🏻‍🦲",
  "👨🏻‍🦳",
  "👨🏻‍🦼",
  "👨🏻‍🦽",
  "👨🏻‍⚕️",
  "👨🏻‍⚖️",
  "👨🏻‍✈️",
  "👨🏻",
  "👨🏼‍🌾",
  "👨🏼‍🍳",
  "👨🏼‍🎓",
  "👨🏼‍🎤",
  "👨🏼‍🎨",
  "👨🏼‍🏫",
  "👨🏼‍🏭",
  "👨🏼‍💻",
  "👨🏼‍💼",
  "👨🏼‍🔧",
  "👨🏼‍🔬",
  "👨🏼‍🚀",
  "👨🏼‍🚒",
  "👨🏼‍🤝‍👨🏻",
  "👨🏼‍🦯",
  "👨🏼‍🦰",
  "👨🏼‍🦱",
  "👨🏼‍🦲",
  "👨🏼‍🦳",
  "👨🏼‍🦼",
  "👨🏼‍🦽",
  "👨🏼‍⚕️",
  "👨🏼‍⚖️",
  "👨🏼‍✈️",
  "👨🏼",
  "👨🏽‍🌾",
  "👨🏽‍🍳",
  "👨🏽‍🎓",
  "👨🏽‍🎤",
  "👨🏽‍🎨",
  "👨🏽‍🏫",
  "👨🏽‍🏭",
  "👨🏽‍💻",
  "👨🏽‍💼",
  "👨🏽‍🔧",
  "👨🏽‍🔬",
  "👨🏽‍🚀",
  "👨🏽‍🚒",
  "👨🏽‍🤝‍👨🏻",
  "👨🏽‍🤝‍👨🏼",
  "👨🏽‍🦯",
  "👨🏽‍🦰",
  "👨🏽‍🦱",
  "👨🏽‍🦲",
  "👨🏽‍🦳",
  "👨🏽‍🦼",
  "👨🏽‍🦽",
  "👨🏽‍⚕️",
  "👨🏽‍⚖️",
  "👨🏽‍✈️",
  "👨🏽",
  "👨🏾‍🌾",
  "👨🏾‍🍳",
  "👨🏾‍🎓",
  "👨🏾‍🎤",
  "👨🏾‍🎨",
  "👨🏾‍🏫",
  "👨🏾‍🏭",
  "👨🏾‍💻",
  "👨🏾‍💼",
  "👨🏾‍🔧",
  "👨🏾‍🔬",
  "👨🏾‍🚀",
  "👨🏾‍🚒",
  "👨🏾‍🤝‍👨🏻",
  "👨🏾‍🤝‍👨🏼",
  "👨🏾‍🤝‍👨🏽",
  "👨🏾‍🦯",
  "👨🏾‍🦰",
  "👨🏾‍🦱",
  "👨🏾‍🦲",
  "👨🏾‍🦳",
  "👨🏾‍🦼",
  "👨🏾‍🦽",
  "👨🏾‍⚕️",
  "👨🏾‍⚖️",
  "👨🏾‍✈️",
  "👨🏾",
  "👨🏿‍🌾",
  "👨🏿‍🍳",
  "👨🏿‍🎓",
  "👨🏿‍🎤",
  "👨🏿‍🎨",
  "👨🏿‍🏫",
  "👨🏿‍🏭",
  "👨🏿‍💻",
  "👨🏿‍💼",
  "👨🏿‍🔧",
  "👨🏿‍🔬",
  "👨🏿‍🚀",
  "👨🏿‍🚒",
  "👨🏿‍🤝‍👨🏻",
  "👨🏿‍🤝‍👨🏼",
  "👨🏿‍🤝‍👨🏽",
  "👨🏿‍🤝‍👨🏾",
  "👨🏿‍🦯",
  "👨🏿‍🦰",
  "👨🏿‍🦱",
  "👨🏿‍🦲",
  "👨🏿‍🦳",
  "👨🏿‍🦼",
  "👨🏿‍🦽",
  "👨🏿‍⚕️",
  "👨🏿‍⚖️",
  "👨🏿‍✈️",
  "👨🏿",
  "👨‍🌾",
  "👨‍🍳",
  "👨‍🎓",
  "👨‍🎤",
  "👨‍🎨",
  "👨‍🏫",
  "👨‍🏭",
  "👨‍👦‍👦",
  "👨‍👦",
  "👨‍👧‍👦",
  "👨‍👧‍👧",
  "👨‍👧",
  "👨‍👨‍👦‍👦",
  "👨‍👨‍👦",
  "👨‍👨‍👧‍👦",
  "👨‍👨‍👧‍👧",
  "👨‍👨‍👧",
  "👨‍👩‍👦‍👦",
  "👨‍👩‍👦",
  "👨‍👩‍👧‍👦",
  "👨‍👩‍👧‍👧",
  "👨‍👩‍👧",
  "👨‍💻",
  "👨‍💼",
  "👨‍🔧",
  "👨‍🔬",
  "👨‍🚀",
  "👨‍🚒",
  "👨‍🦯",
  "👨‍🦰",
  "👨‍🦱",
  "👨‍🦲",
  "👨‍🦳",
  "👨‍🦼",
  "👨‍🦽",
  "👨‍⚕️",
  "👨‍⚖️",
  "👨‍✈️",
  "👨‍❤️‍👨",
  "👨‍❤️‍💋‍👨",
  "👨",
  "👩🏻‍🌾",
  "👩🏻‍🍳",
  "👩🏻‍🎓",
  "👩🏻‍🎤",
  "👩🏻‍🎨",
  "👩🏻‍🏫",
  "👩🏻‍🏭",
  "👩🏻‍💻",
  "👩🏻‍💼",
  "👩🏻‍🔧",
  "👩🏻‍🔬",
  "👩🏻‍🚀",
  "👩🏻‍🚒",
  "👩🏻‍🤝‍👨🏼",
  "👩🏻‍🤝‍👨🏽",
  "👩🏻‍🤝‍👨🏾",
  "👩🏻‍🤝‍👨🏿",
  "👩🏻‍🦯",
  "👩🏻‍🦰",
  "👩🏻‍🦱",
  "👩🏻‍🦲",
  "👩🏻‍🦳",
  "👩🏻‍🦼",
  "👩🏻‍🦽",
  "👩🏻‍⚕️",
  "👩🏻‍⚖️",
  "👩🏻‍✈️",
  "👩🏻",
  "👩🏼‍🌾",
  "👩🏼‍🍳",
  "👩🏼‍🎓",
  "👩🏼‍🎤",
  "👩🏼‍🎨",
  "👩🏼‍🏫",
  "👩🏼‍🏭",
  "👩🏼‍💻",
  "👩🏼‍💼",
  "👩🏼‍🔧",
  "👩🏼‍🔬",
  "👩🏼‍🚀",
  "👩🏼‍🚒",
  "👩🏼‍🤝‍👨🏻",
  "👩🏼‍🤝‍👨🏽",
  "👩🏼‍🤝‍👨🏾",
  "👩🏼‍🤝‍👨🏿",
  "👩🏼‍🤝‍👩🏻",
  "👩🏼‍🦯",
  "👩🏼‍🦰",
  "👩🏼‍🦱",
  "👩🏼‍🦲",
  "👩🏼‍🦳",
  "👩🏼‍🦼",
  "👩🏼‍🦽",
  "👩🏼‍⚕️",
  "👩🏼‍⚖️",
  "👩🏼‍✈️",
  "👩🏼",
  "👩🏽‍🌾",
  "👩🏽‍🍳",
  "👩🏽‍🎓",
  "👩🏽‍🎤",
  "👩🏽‍🎨",
  "👩🏽‍🏫",
  "👩🏽‍🏭",
  "👩🏽‍💻",
  "👩🏽‍💼",
  "👩🏽‍🔧",
  "👩🏽‍🔬",
  "👩🏽‍🚀",
  "👩🏽‍🚒",
  "👩🏽‍🤝‍👨🏻",
  "👩🏽‍🤝‍👨🏼",
  "👩🏽‍🤝‍👨🏾",
  "👩🏽‍🤝‍👨🏿",
  "👩🏽‍🤝‍👩🏻",
  "👩🏽‍🤝‍👩🏼",
  "👩🏽‍🦯",
  "👩🏽‍🦰",
  "👩🏽‍🦱",
  "👩🏽‍🦲",
  "👩🏽‍🦳",
  "👩🏽‍🦼",
  "👩🏽‍🦽",
  "👩🏽‍⚕️",
  "👩🏽‍⚖️",
  "👩🏽‍✈️",
  "👩🏽",
  "👩🏾‍🌾",
  "👩🏾‍🍳",
  "👩🏾‍🎓",
  "👩🏾‍🎤",
  "👩🏾‍🎨",
  "👩🏾‍🏫",
  "👩🏾‍🏭",
  "👩🏾‍💻",
  "👩🏾‍💼",
  "👩🏾‍🔧",
  "👩🏾‍🔬",
  "👩🏾‍🚀",
  "👩🏾‍🚒",
  "👩🏾‍🤝‍👨🏻",
  "👩🏾‍🤝‍👨🏼",
  "👩🏾‍🤝‍👨🏽",
  "👩🏾‍🤝‍👨🏿",
  "👩🏾‍🤝‍👩🏻",
  "👩🏾‍🤝‍👩🏼",
  "👩🏾‍🤝‍👩🏽",
  "👩🏾‍🦯",
  "👩🏾‍🦰",
  "👩🏾‍🦱",
  "👩🏾‍🦲",
  "👩🏾‍🦳",
  "👩🏾‍🦼",
  "👩🏾‍🦽",
  "👩🏾‍⚕️",
  "👩🏾‍⚖️",
  "👩🏾‍✈️",
  "👩🏾",
  "👩🏿‍🌾",
  "👩🏿‍🍳",
  "👩🏿‍🎓",
  "👩🏿‍🎤",
  "👩🏿‍🎨",
  "👩🏿‍🏫",
  "👩🏿‍🏭",
  "👩🏿‍💻",
  "👩🏿‍💼",
  "👩🏿‍🔧",
  "👩🏿‍🔬",
  "👩🏿‍🚀",
  "👩🏿‍🚒",
  "👩🏿‍🤝‍👨🏻",
  "👩🏿‍🤝‍👨🏼",
  "👩🏿‍🤝‍👨🏽",
  "👩🏿‍🤝‍👨🏾",
  "👩🏿‍🤝‍👩🏻",
  "👩🏿‍🤝‍👩🏼",
  "👩🏿‍🤝‍👩🏽",
  "👩🏿‍🤝‍👩🏾",
  "👩🏿‍🦯",
  "👩🏿‍🦰",
  "👩🏿‍🦱",
  "👩🏿‍🦲",
  "👩🏿‍🦳",
  "👩🏿‍🦼",
  "👩🏿‍🦽",
  "👩🏿‍⚕️",
  "👩🏿‍⚖️",
  "👩🏿‍✈️",
  "👩🏿",
  "👩‍🌾",
  "👩‍🍳",
  "👩‍🎓",
  "👩‍🎤",
  "👩‍🎨",
  "👩‍🏫",
  "👩‍🏭",
  "👩‍👦‍👦",
  "👩‍👦",
  "👩‍👧‍👦",
  "👩‍👧‍👧",
  "👩‍👧",
  "👩‍👩‍👦‍👦",
  "👩‍👩‍👦",
  "👩‍👩‍👧‍👦",
  "👩‍👩‍👧‍👧",
  "👩‍👩‍👧",
  "👩‍💻",
  "👩‍💼",
  "👩‍🔧",
  "👩‍🔬",
  "👩‍🚀",
  "👩‍🚒",
  "👩‍🦯",
  "👩‍🦰",
  "👩‍🦱",
  "👩‍🦲",
  "👩‍🦳",
  "👩‍🦼",
  "👩‍🦽",
  "👩‍⚕️",
  "👩‍⚖️",
  "👩‍✈️",
  "👩‍❤️‍👨",
  "👩‍❤️‍👩",
  "👩‍❤️‍💋‍👨",
  "👩‍❤️‍💋‍👩",
  "👩",
  "👪",
  "👫🏻",
  "👫🏼",
  "👫🏽",
  "👫🏾",
  "👫🏿",
  "👫",
  "👬🏻",
  "👬🏼",
  "👬🏽",
  "👬🏾",
  "👬🏿",
  "👬",
  "👭🏻",
  "👭🏼",
  "👭🏽",
  "👭🏾",
  "👭🏿",
  "👭",
  "👮🏻‍♀️",
  "👮🏻‍♂️",
  "👮🏻",
  "👮🏼‍♀️",
  "👮🏼‍♂️",
  "👮🏼",
  "👮🏽‍♀️",
  "👮🏽‍♂️",
  "👮🏽",
  "👮🏾‍♀️",
  "👮🏾‍♂️",
  "👮🏾",
  "👮🏿‍♀️",
  "👮🏿‍♂️",
  "👮🏿",
  "👮‍♀️",
  "👮‍♂️",
  "👮",
  "👯‍♀️",
  "👯‍♂️",
  "👯",
  "👰🏻",
  "👰🏼",
  "👰🏽",
  "👰🏾",
  "👰🏿",
  "👰",
  "👱🏻‍♀️",
  "👱🏻‍♂️",
  "👱🏻",
  "👱🏼‍♀️",
  "👱🏼‍♂️",
  "👱🏼",
  "👱🏽‍♀️",
  "👱🏽‍♂️",
  "👱🏽",
  "👱🏾‍♀️",
  "👱🏾‍♂️",
  "👱🏾",
  "👱🏿‍♀️",
  "👱🏿‍♂️",
  "👱🏿",
  "👱‍♀️",
  "👱‍♂️",
  "👱",
  "👲🏻",
  "👲🏼",
  "👲🏽",
  "👲🏾",
  "👲🏿",
  "👲",
  "👳🏻‍♀️",
  "👳🏻‍♂️",
  "👳🏻",
  "👳🏼‍♀️",
  "👳🏼‍♂️",
  "👳🏼",
  "👳🏽‍♀️",
  "👳🏽‍♂️",
  "👳🏽",
  "👳🏾‍♀️",
  "👳🏾‍♂️",
  "👳🏾",
  "👳🏿‍♀️",
  "👳🏿‍♂️",
  "👳🏿",
  "👳‍♀️",
  "👳‍♂️",
  "👳",
  "👴🏻",
  "👴🏼",
  "👴🏽",
  "👴🏾",
  "👴🏿",
  "👴",
  "👵🏻",
  "👵🏼",
  "👵🏽",
  "👵🏾",
  "👵🏿",
  "👵",
  "👶🏻",
  "👶🏼",
  "👶🏽",
  "👶🏾",
  "👶🏿",
  "👶",
  "👷🏻‍♀️",
  "👷🏻‍♂️",
  "👷🏻",
  "👷🏼‍♀️",
  "👷🏼‍♂️",
  "👷🏼",
  "👷🏽‍♀️",
  "👷🏽‍♂️",
  "👷🏽",
  "👷🏾‍♀️",
  "👷🏾‍♂️",
  "👷🏾",
  "👷🏿‍♀️",
  "👷🏿‍♂️",
  "👷🏿",
  "👷‍♀️",
  "👷‍♂️",
  "👷",
  "👸🏻",
  "👸🏼",
  "👸🏽",
  "👸🏾",
  "👸🏿",
  "👸",
  "👹",
  "👺",
  "👻",
  "👼🏻",
  "👼🏼",
  "👼🏽",
  "👼🏾",
  "👼🏿",
  "👼",
  "👽",
  "👾",
  "👿",
  "💀",
  "💁🏻‍♀️",
  "💁🏻‍♂️",
  "💁🏻",
  "💁🏼‍♀️",
  "💁🏼‍♂️",
  "💁🏼",
  "💁🏽‍♀️",
  "💁🏽‍♂️",
  "💁🏽",
  "💁🏾‍♀️",
  "💁🏾‍♂️",
  "💁🏾",
  "💁🏿‍♀️",
  "💁🏿‍♂️",
  "💁🏿",
  "💁‍♀️",
  "💁‍♂️",
  "💁",
  "💂🏻‍♀️",
  "💂🏻‍♂️",
  "💂🏻",
  "💂🏼‍♀️",
  "💂🏼‍♂️",
  "💂🏼",
  "💂🏽‍♀️",
  "💂🏽‍♂️",
  "💂🏽",
  "💂🏾‍♀️",
  "💂🏾‍♂️",
  "💂🏾",
  "💂🏿‍♀️",
  "💂🏿‍♂️",
  "💂🏿",
  "💂‍♀️",
  "💂‍♂️",
  "💂",
  "💃🏻",
  "💃🏼",
  "💃🏽",
  "💃🏾",
  "💃🏿",
  "💃",
  "💄",
  "💅🏻",
  "💅🏼",
  "💅🏽",
  "💅🏾",
  "💅🏿",
  "💅",
  "💆🏻‍♀️",
  "💆🏻‍♂️",
  "💆🏻",
  "💆🏼‍♀️",
  "💆🏼‍♂️",
  "💆🏼",
  "💆🏽‍♀️",
  "💆🏽‍♂️",
  "💆🏽",
  "💆🏾‍♀️",
  "💆🏾‍♂️",
  "💆🏾",
  "💆🏿‍♀️",
  "💆🏿‍♂️",
  "💆🏿",
  "💆‍♀️",
  "💆‍♂️",
  "💆",
  "💇🏻‍♀️",
  "💇🏻‍♂️",
  "💇🏻",
  "💇🏼‍♀️",
  "💇🏼‍♂️",
  "💇🏼",
  "💇🏽‍♀️",
  "💇🏽‍♂️",
  "💇🏽",
  "💇🏾‍♀️",
  "💇🏾‍♂️",
  "💇🏾",
  "💇🏿‍♀️",
  "💇🏿‍♂️",
  "💇🏿",
  "💇‍♀️",
  "💇‍♂️",
  "💇",
  "💈",
  "💉",
  "💊",
  "💋",
  "💌",
  "💍",
  "💎",
  "💏",
  "💐",
  "💑",
  "💒",
  "💓",
  "💔",
  "💕",
  "💖",
  "💗",
  "💘",
  "💙",
  "💚",
  "💛",
  "💜",
  "💝",
  "💞",
  "💟",
  "💠",
  "💡",
  "💢",
  "💣",
  "💤",
  "💥",
  "💦",
  "💧",
  "💨",
  "💩",
  "💪🏻",
  "💪🏼",
  "💪🏽",
  "💪🏾",
  "💪🏿",
  "💪",
  "💫",
  "💬",
  "💭",
  "💮",
  "💯",
  "💰",
  "💱",
  "💲",
  "💳",
  "💴",
  "💵",
  "💶",
  "💷",
  "💸",
  "💹",
  "💺",
  "💻",
  "💼",
  "💽",
  "💾",
  "💿",
  "📀",
  "📁",
  "📂",
  "📃",
  "📄",
  "📅",
  "📆",
  "📇",
  "📈",
  "📉",
  "📊",
  "📋",
  "📌",
  "📍",
  "📎",
  "📏",
  "📐",
  "📑",
  "📒",
  "📓",
  "📔",
  "📕",
  "📖",
  "📗",
  "📘",
  "📙",
  "📚",
  "📛",
  "📜",
  "📝",
  "📞",
  "📟",
  "📠",
  "📡",
  "📢",
  "📣",
  "📤",
  "📥",
  "📦",
  "📧",
  "📨",
  "📩",
  "📪",
  "📫",
  "📬",
  "📭",
  "📮",
  "📯",
  "📰",
  "📱",
  "📲",
  "📳",
  "📴",
  "📵",
  "📶",
  "📷",
  "📸",
  "📹",
  "📺",
  "📻",
  "📼",
  "📽️",
  "📿",
  "🔀",
  "🔁",
  "🔂",
  "🔃",
  "🔄",
  "🔅",
  "🔆",
  "🔇",
  "🔈",
  "🔉",
  "🔊",
  "🔋",
  "🔌",
  "🔍",
  "🔎",
  "🔏",
  "🔐",
  "🔑",
  "🔒",
  "🔓",
  "🔔",
  "🔕",
  "🔖",
  "🔗",
  "🔘",
  "🔙",
  "🔚",
  "🔛",
  "🔜",
  "🔝",
  "🔞",
  "🔟",
  "🔠",
  "🔡",
  "🔢",
  "🔣",
  "🔤",
  "🔥",
  "🔦",
  "🔧",
  "🔨",
  "🔩",
  "🔪",
  "🔫",
  "🔬",
  "🔭",
  "🔮",
  "🔯",
  "🔰",
  "🔱",
  "🔲",
  "🔳",
  "🔴",
  "🔵",
  "🔶",
  "🔷",
  "🔸",
  "🔹",
  "🔺",
  "🔻",
  "🔼",
  "🔽",
  "🕉️",
  "🕊️",
  "🕋",
  "🕌",
  "🕍",
  "🕎",
  "🕐",
  "🕑",
  "🕒",
  "🕓",
  "🕔",
  "🕕",
  "🕖",
  "🕗",
  "🕘",
  "🕙",
  "🕚",
  "🕛",
  "🕜",
  "🕝",
  "🕞",
  "🕟",
  "🕠",
  "🕡",
  "🕢",
  "🕣",
  "🕤",
  "🕥",
  "🕦",
  "🕧",
  "🕯️",
  "🕰️",
  "🕳️",
  "🕴🏻‍♀️",
  "🕴🏻‍♂️",
  "🕴🏻",
  "🕴🏼‍♀️",
  "🕴🏼‍♂️",
  "🕴🏼",
  "🕴🏽‍♀️",
  "🕴🏽‍♂️",
  "🕴🏽",
  "🕴🏾‍♀️",
  "🕴🏾‍♂️",
  "🕴🏾",
  "🕴🏿‍♀️",
  "🕴🏿‍♂️",
  "🕴🏿",
  "🕴️‍♀️",
  "🕴️‍♂️",
  "🕴️",
  "🕵🏻‍♀️",
  "🕵🏻‍♂️",
  "🕵🏻",
  "🕵🏼‍♀️",
  "🕵🏼‍♂️",
  "🕵🏼",
  "🕵🏽‍♀️",
  "🕵🏽‍♂️",
  "🕵🏽",
  "🕵🏾‍♀️",
  "🕵🏾‍♂️",
  "🕵🏾",
  "🕵🏿‍♀️",
  "🕵🏿‍♂️",
  "🕵🏿",
  "🕵️‍♀️",
  "🕵️‍♂️",
  "🕵️",
  "🕶️",
  "🕷️",
  "🕸️",
  "🕹️",
  "🕺🏻",
  "🕺🏼",
  "🕺🏽",
  "🕺🏾",
  "🕺🏿",
  "🕺",
  "🖇️",
  "🖊️",
  "🖋️",
  "🖌️",
  "🖍️",
  "🖐🏻",
  "🖐🏼",
  "🖐🏽",
  "🖐🏾",
  "🖐🏿",
  "🖐️",
  "🖕🏻",
  "🖕🏼",
  "🖕🏽",
  "🖕🏾",
  "🖕🏿",
  "🖕",
  "🖖🏻",
  "🖖🏼",
  "🖖🏽",
  "🖖🏾",
  "🖖🏿",
  "🖖",
  "🖤",
  "🖥️",
  "🖨️",
  "🖱️",
  "🖲️",
  "🖼️",
  "🗂️",
  "🗃️",
  "🗄️",
  "🗑️",
  "🗒️",
  "🗓️",
  "🗜️",
  "🗝️",
  "🗞️",
  "🗡️",
  "🗣️",
  "🗨️",
  "🗯️",
  "🗳️",
  "🗺️",
  "🗻",
  "🗼",
  "🗽",
  "🗾",
  "🗿",
  "😀",
  "😁",
  "😂",
  "😃",
  "😄",
  "😅",
  "😆",
  "😇",
  "😈",
  "😉",
  "😊",
  "😋",
  "😌",
  "😍",
  "😎",
  "😏",
  "😐",
  "😑",
  "😒",
  "😓",
  "😔",
  "😕",
  "😖",
  "😗",
  "😘",
  "😙",
  "😚",
  "😛",
  "😜",
  "😝",
  "😞",
  "😟",
  "😠",
  "😡",
  "😢",
  "😣",
  "😤",
  "😥",
  "😦",
  "😧",
  "😨",
  "😩",
  "😪",
  "😫",
  "😬",
  "😭",
  "😮",
  "😯",
  "😰",
  "😱",
  "😲",
  "😳",
  "😴",
  "😵",
  "😶",
  "😷",
  "😸",
  "😹",
  "😺",
  "😻",
  "😼",
  "😽",
  "😾",
  "😿",
  "🙀",
  "🙁",
  "🙂",
  "🙃",
  "🙄",
  "🙅🏻‍♀️",
  "🙅🏻‍♂️",
  "🙅🏻",
  "🙅🏼‍♀️",
  "🙅🏼‍♂️",
  "🙅🏼",
  "🙅🏽‍♀️",
  "🙅🏽‍♂️",
  "🙅🏽",
  "🙅🏾‍♀️",
  "🙅🏾‍♂️",
  "🙅🏾",
  "🙅🏿‍♀️",
  "🙅🏿‍♂️",
  "🙅🏿",
  "🙅‍♀️",
  "🙅‍♂️",
  "🙅",
  "🙆🏻‍♀️",
  "🙆🏻‍♂️",
  "🙆🏻",
  "🙆🏼‍♀️",
  "🙆🏼‍♂️",
  "🙆🏼",
  "🙆🏽‍♀️",
  "🙆🏽‍♂️",
  "🙆🏽",
  "🙆🏾‍♀️",
  "🙆🏾‍♂️",
  "🙆🏾",
  "🙆🏿‍♀️",
  "🙆🏿‍♂️",
  "🙆🏿",
  "🙆‍♀️",
  "🙆‍♂️",
  "🙆",
  "🙇🏻‍♀️",
  "🙇🏻‍♂️",
  "🙇🏻",
  "🙇🏼‍♀️",
  "🙇🏼‍♂️",
  "🙇🏼",
  "🙇🏽‍♀️",
  "🙇🏽‍♂️",
  "🙇🏽",
  "🙇🏾‍♀️",
  "🙇🏾‍♂️",
  "🙇🏾",
  "🙇🏿‍♀️",
  "🙇🏿‍♂️",
  "🙇🏿",
  "🙇‍♀️",
  "🙇‍♂️",
  "🙇",
  "🙈",
  "🙉",
  "🙊",
  "🙋🏻‍♀️",
  "🙋🏻‍♂️",
  "🙋🏻",
  "🙋🏼‍♀️",
  "🙋🏼‍♂️",
  "🙋🏼",
  "🙋🏽‍♀️",
  "🙋🏽‍♂️",
  "🙋🏽",
  "🙋🏾‍♀️",
  "🙋🏾‍♂️",
  "🙋🏾",
  "🙋🏿‍♀️",
  "🙋🏿‍♂️",
  "🙋🏿",
  "🙋‍♀️",
  "🙋‍♂️",
  "🙋",
  "🙌🏻",
  "🙌🏼",
  "🙌🏽",
  "🙌🏾",
  "🙌🏿",
  "🙌",
  "🙍🏻‍♀️",
  "🙍🏻‍♂️",
  "🙍🏻",
  "🙍🏼‍♀️",
  "🙍🏼‍♂️",
  "🙍🏼",
  "🙍🏽‍♀️",
  "🙍🏽‍♂️",
  "🙍🏽",
  "🙍🏾‍♀️",
  "🙍🏾‍♂️",
  "🙍🏾",
  "🙍🏿‍♀️",
  "🙍🏿‍♂️",
  "🙍🏿",
  "🙍‍♀️",
  "🙍‍♂️",
  "🙍",
  "🙎🏻‍♀️",
  "🙎🏻‍♂️",
  "🙎🏻",
  "🙎🏼‍♀️",
  "🙎🏼‍♂️",
  "🙎🏼",
  "🙎🏽‍♀️",
  "🙎🏽‍♂️",
  "🙎🏽",
  "🙎🏾‍♀️",
  "🙎🏾‍♂️",
  "🙎🏾",
  "🙎🏿‍♀️",
  "🙎🏿‍♂️",
  "🙎🏿",
  "🙎‍♀️",
  "🙎‍♂️",
  "🙎",
  "🙏🏻",
  "🙏🏼",
  "🙏🏽",
  "🙏🏾",
  "🙏🏿",
  "🙏",
  "🚀",
  "🚁",
  "🚂",
  "🚃",
  "🚄",
  "🚅",
  "🚆",
  "🚇",
  "🚈",
  "🚉",
  "🚊",
  "🚋",
  "🚌",
  "🚍",
  "🚎",
  "🚏",
  "🚐",
  "🚑",
  "🚒",
  "🚓",
  "🚔",
  "🚕",
  "🚖",
  "🚗",
  "🚘",
  "🚙",
  "🚚",
  "🚛",
  "🚜",
  "🚝",
  "🚞",
  "🚟",
  "🚠",
  "🚡",
  "🚢",
  "🚣🏻‍♀️",
  "🚣🏻‍♂️",
  "🚣🏻",
  "🚣🏼‍♀️",
  "🚣🏼‍♂️",
  "🚣🏼",
  "🚣🏽‍♀️",
  "🚣🏽‍♂️",
  "🚣🏽",
  "🚣🏾‍♀️",
  "🚣🏾‍♂️",
  "🚣🏾",
  "🚣🏿‍♀️",
  "🚣🏿‍♂️",
  "🚣🏿",
  "🚣‍♀️",
  "🚣‍♂️",
  "🚣",
  "🚤",
  "🚥",
  "🚦",
  "🚧",
  "🚨",
  "🚩",
  "🚪",
  "🚫",
  "🚬",
  "🚭",
  "🚮",
  "🚯",
  "🚰",
  "🚱",
  "🚲",
  "🚳",
  "🚴🏻‍♀️",
  "🚴🏻‍♂️",
  "🚴🏻",
  "🚴🏼‍♀️",
  "🚴🏼‍♂️",
  "🚴🏼",
  "🚴🏽‍♀️",
  "🚴🏽‍♂️",
  "🚴🏽",
  "🚴🏾‍♀️",
  "🚴🏾‍♂️",
  "🚴🏾",
  "🚴🏿‍♀️",
  "🚴🏿‍♂️",
  "🚴🏿",
  "🚴‍♀️",
  "🚴‍♂️",
  "🚴",
  "🚵🏻‍♀️",
  "🚵🏻‍♂️",
  "🚵🏻",
  "🚵🏼‍♀️",
  "🚵🏼‍♂️",
  "🚵🏼",
  "🚵🏽‍♀️",
  "🚵🏽‍♂️",
  "🚵🏽",
  "🚵🏾‍♀️",
  "🚵🏾‍♂️",
  "🚵🏾",
  "🚵🏿‍♀️",
  "🚵🏿‍♂️",
  "🚵🏿",
  "🚵‍♀️",
  "🚵‍♂️",
  "🚵",
  "🚶🏻‍♀️",
  "🚶🏻‍♂️",
  "🚶🏻",
  "🚶🏼‍♀️",
  "🚶🏼‍♂️",
  "🚶🏼",
  "🚶🏽‍♀️",
  "🚶🏽‍♂️",
  "🚶🏽",
  "🚶🏾‍♀️",
  "🚶🏾‍♂️",
  "🚶🏾",
  "🚶🏿‍♀️",
  "🚶🏿‍♂️",
  "🚶🏿",
  "🚶‍♀️",
  "🚶‍♂️",
  "🚶",
  "🚷",
  "🚸",
  "🚹",
  "🚺",
  "🚻",
  "🚼",
  "🚽",
  "🚾",
  "🚿",
  "🛀🏻",
  "🛀🏼",
  "🛀🏽",
  "🛀🏾",
  "🛀🏿",
  "🛀",
  "🛁",
  "🛂",
  "🛃",
  "🛄",
  "🛅",
  "🛋️",
  "🛌🏻",
  "🛌🏼",
  "🛌🏽",
  "🛌🏾",
  "🛌🏿",
  "🛌",
  "🛍️",
  "🛎️",
  "🛏️",
  "🛐",
  "🛑",
  "🛒",
  "🛕",
  "🛠️",
  "🛡️",
  "🛢️",
  "🛣️",
  "🛤️",
  "🛥️",
  "🛩️",
  "🛫",
  "🛬",
  "🛰️",
  "🛳️",
  "🛴",
  "🛵",
  "🛶",
  "🛷",
  "🛸",
  "🛹",
  "🛺",
  "🟠",
  "🟡",
  "🟢",
  "🟣",
  "🟤",
  "🟥",
  "🟦",
  "🟧",
  "🟨",
  "🟩",
  "🟪",
  "🟫",
  "🤍",
  "🤎",
  "🤏🏻",
  "🤏🏼",
  "🤏🏽",
  "🤏🏾",
  "🤏🏿",
  "🤏",
  "🤐",
  "🤑",
  "🤒",
  "🤓",
  "🤔",
  "🤕",
  "🤖",
  "🤗",
  "🤘🏻",
  "🤘🏼",
  "🤘🏽",
  "🤘🏾",
  "🤘🏿",
  "🤘",
  "🤙🏻",
  "🤙🏼",
  "🤙🏽",
  "🤙🏾",
  "🤙🏿",
  "🤙",
  "🤚🏻",
  "🤚🏼",
  "🤚🏽",
  "🤚🏾",
  "🤚🏿",
  "🤚",
  "🤛🏻",
  "🤛🏼",
  "🤛🏽",
  "🤛🏾",
  "🤛🏿",
  "🤛",
  "🤜🏻",
  "🤜🏼",
  "🤜🏽",
  "🤜🏾",
  "🤜🏿",
  "🤜",
  "🤝",
  "🤞🏻",
  "🤞🏼",
  "🤞🏽",
  "🤞🏾",
  "🤞🏿",
  "🤞",
  "🤟🏻",
  "🤟🏼",
  "🤟🏽",
  "🤟🏾",
  "🤟🏿",
  "🤟",
  "🤠",
  "🤡",
  "🤢",
  "🤣",
  "🤤",
  "🤥",
  "🤦🏻‍♀️",
  "🤦🏻‍♂️",
  "🤦🏻",
  "🤦🏼‍♀️",
  "🤦🏼‍♂️",
  "🤦🏼",
  "🤦🏽‍♀️",
  "🤦🏽‍♂️",
  "🤦🏽",
  "🤦🏾‍♀️",
  "🤦🏾‍♂️",
  "🤦🏾",
  "🤦🏿‍♀️",
  "🤦🏿‍♂️",
  "🤦🏿",
  "🤦‍♀️",
  "🤦‍♂️",
  "🤦",
  "🤧",
  "🤨",
  "🤩",
  "🤪",
  "🤫",
  "🤬",
  "🤭",
  "🤮",
  "🤯",
  "🤰🏻",
  "🤰🏼",
  "🤰🏽",
  "🤰🏾",
  "🤰🏿",
  "🤰",
  "🤱🏻",
  "🤱🏼",
  "🤱🏽",
  "🤱🏾",
  "🤱🏿",
  "🤱",
  "🤲🏻",
  "🤲🏼",
  "🤲🏽",
  "🤲🏾",
  "🤲🏿",
  "🤲",
  "🤳🏻",
  "🤳🏼",
  "🤳🏽",
  "🤳🏾",
  "🤳🏿",
  "🤳",
  "🤴🏻",
  "🤴🏼",
  "🤴🏽",
  "🤴🏾",
  "🤴🏿",
  "🤴",
  "🤵🏻‍♀️",
  "🤵🏻‍♂️",
  "🤵🏻",
  "🤵🏼‍♀️",
  "🤵🏼‍♂️",
  "🤵🏼",
  "🤵🏽‍♀️",
  "🤵🏽‍♂️",
  "🤵🏽",
  "🤵🏾‍♀️",
  "🤵🏾‍♂️",
  "🤵🏾",
  "🤵🏿‍♀️",
  "🤵🏿‍♂️",
  "🤵🏿",
  "🤵‍♀️",
  "🤵‍♂️",
  "🤵",
  "🤶🏻",
  "🤶🏼",
  "🤶🏽",
  "🤶🏾",
  "🤶🏿",
  "🤶",
  "🤷🏻‍♀️",
  "🤷🏻‍♂️",
  "🤷🏻",
  "🤷🏼‍♀️",
  "🤷🏼‍♂️",
  "🤷🏼",
  "🤷🏽‍♀️",
  "🤷🏽‍♂️",
  "🤷🏽",
  "🤷🏾‍♀️",
  "🤷🏾‍♂️",
  "🤷🏾",
  "🤷🏿‍♀️",
  "🤷🏿‍♂️",
  "🤷🏿",
  "🤷‍♀️",
  "🤷‍♂️",
  "🤷",
  "🤸🏻‍♀️",
  "🤸🏻‍♂️",
  "🤸🏻",
  "🤸🏼‍♀️",
  "🤸🏼‍♂️",
  "🤸🏼",
  "🤸🏽‍♀️",
  "🤸🏽‍♂️",
  "🤸🏽",
  "🤸🏾‍♀️",
  "🤸🏾‍♂️",
  "🤸🏾",
  "🤸🏿‍♀️",
  "🤸🏿‍♂️",
  "🤸🏿",
  "🤸‍♀️",
  "🤸‍♂️",
  "🤸",
  "🤹🏻‍♀️",
  "🤹🏻‍♂️",
  "🤹🏻",
  "🤹🏼‍♀️",
  "🤹🏼‍♂️",
  "🤹🏼",
  "🤹🏽‍♀️",
  "🤹🏽‍♂️",
  "🤹🏽",
  "🤹🏾‍♀️",
  "🤹🏾‍♂️",
  "🤹🏾",
  "🤹🏿‍♀️",
  "🤹🏿‍♂️",
  "🤹🏿",
  "🤹‍♀️",
  "🤹‍♂️",
  "🤹",
  "🤺",
  "🤼‍♀️",
  "🤼‍♂️",
  "🤼",
  "🤽🏻‍♀️",
  "🤽🏻‍♂️",
  "🤽🏻",
  "🤽🏼‍♀️",
  "🤽🏼‍♂️",
  "🤽🏼",
  "🤽🏽‍♀️",
  "🤽🏽‍♂️",
  "🤽🏽",
  "🤽🏾‍♀️",
  "🤽🏾‍♂️",
  "🤽🏾",
  "🤽🏿‍♀️",
  "🤽🏿‍♂️",
  "🤽🏿",
  "🤽‍♀️",
  "🤽‍♂️",
  "🤽",
  "🤾🏻‍♀️",
  "🤾🏻‍♂️",
  "🤾🏻",
  "🤾🏼‍♀️",
  "🤾🏼‍♂️",
  "🤾🏼",
  "🤾🏽‍♀️",
  "🤾🏽‍♂️",
  "🤾🏽",
  "🤾🏾‍♀️",
  "🤾🏾‍♂️",
  "🤾🏾",
  "🤾🏿‍♀️",
  "🤾🏿‍♂️",
  "🤾🏿",
  "🤾‍♀️",
  "🤾‍♂️",
  "🤾",
  "🤿",
  "🥀",
  "🥁",
  "🥂",
  "🥃",
  "🥄",
  "🥅",
  "🥇",
  "🥈",
  "🥉",
  "🥊",
  "🥋",
  "🥌",
  "🥍",
  "🥎",
  "🥏",
  "🥐",
  "🥑",
  "🥒",
  "🥓",
  "🥔",
  "🥕",
  "🥖",
  "🥗",
  "🥘",
  "🥙",
  "🥚",
  "🥛",
  "🥜",
  "🥝",
  "🥞",
  "🥟",
  "🥠",
  "🥡",
  "🥢",
  "🥣",
  "🥤",
  "🥥",
  "🥦",
  "🥧",
  "🥨",
  "🥩",
  "🥪",
  "🥫",
  "🥬",
  "🥭",
  "🥮",
  "🥯",
  "🥰",
  "🥱",
  "🥳",
  "🥴",
  "🥵",
  "🥶",
  "🥺",
  "🥻",
  "🥼",
  "🥽",
  "🥾",
  "🥿",
  "🦀",
  "🦁",
  "🦂",
  "🦃",
  "🦄",
  "🦅",
  "🦆",
  "🦇",
  "🦈",
  "🦉",
  "🦊",
  "🦋",
  "🦌",
  "🦍",
  "🦎",
  "🦏",
  "🦐",
  "🦑",
  "🦒",
  "🦓",
  "🦔",
  "🦕",
  "🦖",
  "🦗",
  "🦘",
  "🦙",
  "🦚",
  "🦛",
  "🦜",
  "🦝",
  "🦞",
  "🦟",
  "🦠",
  "🦡",
  "🦢",
  "🦥",
  "🦦",
  "🦧",
  "🦨",
  "🦩",
  "🦪",
  "🦮",
  "🦯",
  "🦰",
  "🦱",
  "🦲",
  "🦳",
  "🦴",
  "🦵🏻",
  "🦵🏼",
  "🦵🏽",
  "🦵🏾",
  "🦵🏿",
  "🦵",
  "🦶🏻",
  "🦶🏼",
  "🦶🏽",
  "🦶🏾",
  "🦶🏿",
  "🦶",
  "🦷",
  "🦸🏻‍♀️",
  "🦸🏻‍♂️",
  "🦸🏻",
  "🦸🏼‍♀️",
  "🦸🏼‍♂️",
  "🦸🏼",
  "🦸🏽‍♀️",
  "🦸🏽‍♂️",
  "🦸🏽",
  "🦸🏾‍♀️",
  "🦸🏾‍♂️",
  "🦸🏾",
  "🦸🏿‍♀️",
  "🦸🏿‍♂️",
  "🦸🏿",
  "🦸‍♀️",
  "🦸‍♂️",
  "🦸",
  "🦹🏻‍♀️",
  "🦹🏻‍♂️",
  "🦹🏻",
  "🦹🏼‍♀️",
  "🦹🏼‍♂️",
  "🦹🏼",
  "🦹🏽‍♀️",
  "🦹🏽‍♂️",
  "🦹🏽",
  "🦹🏾‍♀️",
  "🦹🏾‍♂️",
  "🦹🏾",
  "🦹🏿‍♀️",
  "🦹🏿‍♂️",
  "🦹🏿",
  "🦹‍♀️",
  "🦹‍♂️",
  "🦹",
  "🦺",
  "🦻🏻",
  "🦻🏼",
  "🦻🏽",
  "🦻🏾",
  "🦻🏿",
  "🦻",
  "🦼",
  "🦽",
  "🦾",
  "🦿",
  "🧀",
  "🧁",
  "🧂",
  "🧃",
  "🧄",
  "🧅",
  "🧆",
  "🧇",
  "🧈",
  "🧉",
  "🧊",
  "🧍🏻‍♀️",
  "🧍🏻‍♂️",
  "🧍🏻",
  "🧍🏼‍♀️",
  "🧍🏼‍♂️",
  "🧍🏼",
  "🧍🏽‍♀️",
  "🧍🏽‍♂️",
  "🧍🏽",
  "🧍🏾‍♀️",
  "🧍🏾‍♂️",
  "🧍🏾",
  "🧍🏿‍♀️",
  "🧍🏿‍♂️",
  "🧍🏿",
  "🧍‍♀️",
  "🧍‍♂️",
  "🧍",
  "🧎🏻‍♀️",
  "🧎🏻‍♂️",
  "🧎🏻",
  "🧎🏼‍♀️",
  "🧎🏼‍♂️",
  "🧎🏼",
  "🧎🏽‍♀️",
  "🧎🏽‍♂️",
  "🧎🏽",
  "🧎🏾‍♀️",
  "🧎🏾‍♂️",
  "🧎🏾",
  "🧎🏿‍♀️",
  "🧎🏿‍♂️",
  "🧎🏿",
  "🧎‍♀️",
  "🧎‍♂️",
  "🧎",
  "🧏🏻‍♀️",
  "🧏🏻‍♂️",
  "🧏🏻",
  "🧏🏼‍♀️",
  "🧏🏼‍♂️",
  "🧏🏼",
  "🧏🏽‍♀️",
  "🧏🏽‍♂️",
  "🧏🏽",
  "🧏🏾‍♀️",
  "🧏🏾‍♂️",
  "🧏🏾",
  "🧏🏿‍♀️",
  "🧏🏿‍♂️",
  "🧏🏿",
  "🧏‍♀️",
  "🧏‍♂️",
  "🧏",
  "🧐",
  "🧑🏻‍🤝‍🧑🏻",
  "🧑🏻",
  "🧑🏼‍🤝‍🧑🏻",
  "🧑🏼‍🤝‍🧑🏼",
  "🧑🏼",
  "🧑🏽‍🤝‍🧑🏻",
  "🧑🏽‍🤝‍🧑🏼",
  "🧑🏽‍🤝‍🧑🏽",
  "🧑🏽",
  "🧑🏾‍🤝‍🧑🏻",
  "🧑🏾‍🤝‍🧑🏼",
  "🧑🏾‍🤝‍🧑🏽",
  "🧑🏾‍🤝‍🧑🏾",
  "🧑🏾",
  "🧑🏿‍🤝‍🧑🏻",
  "🧑🏿‍🤝‍🧑🏼",
  "🧑🏿‍🤝‍🧑🏽",
  "🧑🏿‍🤝‍🧑🏾",
  "🧑🏿‍🤝‍🧑🏿",
  "🧑🏿",
  "🧑‍🤝‍🧑",
  "🧑",
  "🧒🏻",
  "🧒🏼",
  "🧒🏽",
  "🧒🏾",
  "🧒🏿",
  "🧒",
  "🧓🏻",
  "🧓🏼",
  "🧓🏽",
  "🧓🏾",
  "🧓🏿",
  "🧓",
  "🧔🏻",
  "🧔🏼",
  "🧔🏽",
  "🧔🏾",
  "🧔🏿",
  "🧔",
  "🧕🏻",
  "🧕🏼",
  "🧕🏽",
  "🧕🏾",
  "🧕🏿",
  "🧕",
  "🧖🏻‍♀️",
  "🧖🏻‍♂️",
  "🧖🏻",
  "🧖🏼‍♀️",
  "🧖🏼‍♂️",
  "🧖🏼",
  "🧖🏽‍♀️",
  "🧖🏽‍♂️",
  "🧖🏽",
  "🧖🏾‍♀️",
  "🧖🏾‍♂️",
  "🧖🏾",
  "🧖🏿‍♀️",
  "🧖🏿‍♂️",
  "🧖🏿",
  "🧖‍♀️",
  "🧖‍♂️",
  "🧖",
  "🧗🏻‍♀️",
  "🧗🏻‍♂️",
  "🧗🏻",
  "🧗🏼‍♀️",
  "🧗🏼‍♂️",
  "🧗🏼",
  "🧗🏽‍♀️",
  "🧗🏽‍♂️",
  "🧗🏽",
  "🧗🏾‍♀️",
  "🧗🏾‍♂️",
  "🧗🏾",
  "🧗🏿‍♀️",
  "🧗🏿‍♂️",
  "🧗🏿",
  "🧗‍♀️",
  "🧗‍♂️",
  "🧗",
  "🧘🏻‍♀️",
  "🧘🏻‍♂️",
  "🧘🏻",
  "🧘🏼‍♀️",
  "🧘🏼‍♂️",
  "🧘🏼",
  "🧘🏽‍♀️",
  "🧘🏽‍♂️",
  "🧘🏽",
  "🧘🏾‍♀️",
  "🧘🏾‍♂️",
  "🧘🏾",
  "🧘🏿‍♀️",
  "🧘🏿‍♂️",
  "🧘🏿",
  "🧘‍♀️",
  "🧘‍♂️",
  "🧘",
  "🧙🏻‍♀️",
  "🧙🏻‍♂️",
  "🧙🏻",
  "🧙🏼‍♀️",
  "🧙🏼‍♂️",
  "🧙🏼",
  "🧙🏽‍♀️",
  "🧙🏽‍♂️",
  "🧙🏽",
  "🧙🏾‍♀️",
  "🧙🏾‍♂️",
  "🧙🏾",
  "🧙🏿‍♀️",
  "🧙🏿‍♂️",
  "🧙🏿",
  "🧙‍♀️",
  "🧙‍♂️",
  "🧙",
  "🧚🏻‍♀️",
  "🧚🏻‍♂️",
  "🧚🏻",
  "🧚🏼‍♀️",
  "🧚🏼‍♂️",
  "🧚🏼",
  "🧚🏽‍♀️",
  "🧚🏽‍♂️",
  "🧚🏽",
  "🧚🏾‍♀️",
  "🧚🏾‍♂️",
  "🧚🏾",
  "🧚🏿‍♀️",
  "🧚🏿‍♂️",
  "🧚🏿",
  "🧚‍♀️",
  "🧚‍♂️",
  "🧚",
  "🧛🏻‍♀️",
  "🧛🏻‍♂️",
  "🧛🏻",
  "🧛🏼‍♀️",
  "🧛🏼‍♂️",
  "🧛🏼",
  "🧛🏽‍♀️",
  "🧛🏽‍♂️",
  "🧛🏽",
  "🧛🏾‍♀️",
  "🧛🏾‍♂️",
  "🧛🏾",
  "🧛🏿‍♀️",
  "🧛🏿‍♂️",
  "🧛🏿",
  "🧛‍♀️",
  "🧛‍♂️",
  "🧛",
  "🧜🏻‍♀️",
  "🧜🏻‍♂️",
  "🧜🏻",
  "🧜🏼‍♀️",
  "🧜🏼‍♂️",
  "🧜🏼",
  "🧜🏽‍♀️",
  "🧜🏽‍♂️",
  "🧜🏽",
  "🧜🏾‍♀️",
  "🧜🏾‍♂️",
  "🧜🏾",
  "🧜🏿‍♀️",
  "🧜🏿‍♂️",
  "🧜🏿",
  "🧜‍♀️",
  "🧜‍♂️",
  "🧜",
  "🧝🏻‍♀️",
  "🧝🏻‍♂️",
  "🧝🏻",
  "🧝🏼‍♀️",
  "🧝🏼‍♂️",
  "🧝🏼",
  "🧝🏽‍♀️",
  "🧝🏽‍♂️",
  "🧝🏽",
  "🧝🏾‍♀️",
  "🧝🏾‍♂️",
  "🧝🏾",
  "🧝🏿‍♀️",
  "🧝🏿‍♂️",
  "🧝🏿",
  "🧝‍♀️",
  "🧝‍♂️",
  "🧝",
  "🧞‍♀️",
  "🧞‍♂️",
  "🧞",
  "🧟‍♀️",
  "🧟‍♂️",
  "🧟",
  "🧠",
  "🧡",
  "🧢",
  "🧣",
  "🧤",
  "🧥",
  "🧦",
  "🧧",
  "🧨",
  "🧩",
  "🧪",
  "🧫",
  "🧬",
  "🧭",
  "🧮",
  "🧯",
  "🧰",
  "🧱",
  "🧲",
  "🧳",
  "🧴",
  "🧵",
  "🧶",
  "🧷",
  "🧸",
  "🧹",
  "🧺",
  "🧻",
  "🧼",
  "🧽",
  "🧾",
  "🧿",
  "🩰",
  "🩱",
  "🩲",
  "🩳",
  "🩸",
  "🩹",
  "🩺",
  "🪀",
  "🪁",
  "🪂",
  "🪐",
  "🪑",
  "🪒",
  "🪓",
  "🪔",
  "🪕",
  "‼️",
  "⁉️",
  "™️",
  "ℹ️",
  "↔️",
  "↕️",
  "↖️",
  "↗️",
  "↘️",
  "↙️",
  "↩️",
  "↪️",
  "#⃣",
  "⌚️",
  "⌛️",
  "⌨️",
  "⏏️",
  "⏩",
  "⏪",
  "⏫",
  "⏬",
  "⏭️",
  "⏮️",
  "⏯️",
  "⏰",
  "⏱️",
  "⏲️",
  "⏳",
  "⏸️",
  "⏹️",
  "⏺️",
  "Ⓜ️",
  "▪️",
  "▫️",
  "▶️",
  "◀️",
  "◻️",
  "◼️",
  "◽️",
  "◾️",
  "☀️",
  "☁️",
  "☂️",
  "☃️",
  "☄️",
  "☎️",
  "☑️",
  "☔️",
  "☕️",
  "☘️",
  "☝🏻",
  "☝🏼",
  "☝🏽",
  "☝🏾",
  "☝🏿",
  "☝️",
  "☠️",
  "☢️",
  "☣️",
  "☦️",
  "☪️",
  "☮️",
  "☯️",
  "☸️",
  "☹️",
  "☺️",
  "♀️",
  "♂️",
  "♈️",
  "♉️",
  "♊️",
  "♋️",
  "♌️",
  "♍️",
  "♎️",
  "♏️",
  "♐️",
  "♑️",
  "♒️",
  "♓️",
  "♟️",
  "♠️",
  "♣️",
  "♥️",
  "♦️",
  "♨️",
  "♻️",
  "♾",
  "♿️",
  "⚒️",
  "⚓️",
  "⚔️",
  "⚕️",
  "⚖️",
  "⚗️",
  "⚙️",
  "⚛️",
  "⚜️",
  "⚠️",
  "⚡️",
  "⚪️",
  "⚫️",
  "⚰️",
  "⚱️",
  "⚽️",
  "⚾️",
  "⛄️",
  "⛅️",
  "⛈️",
  "⛎",
  "⛏️",
  "⛑️",
  "⛓️",
  "⛔️",
  "⛩️",
  "⛪️",
  "⛰️",
  "⛱️",
  "⛲️",
  "⛳️",
  "⛴️",
  "⛵️",
  "⛷🏻",
  "⛷🏼",
  "⛷🏽",
  "⛷🏾",
  "⛷🏿",
  "⛷️",
  "⛸️",
  "⛹🏻‍♀️",
  "⛹🏻‍♂️",
  "⛹🏻",
  "⛹🏼‍♀️",
  "⛹🏼‍♂️",
  "⛹🏼",
  "⛹🏽‍♀️",
  "⛹🏽‍♂️",
  "⛹🏽",
  "⛹🏾‍♀️",
  "⛹🏾‍♂️",
  "⛹🏾",
  "⛹🏿‍♀️",
  "⛹🏿‍♂️",
  "⛹🏿",
  "⛹️‍♀️",
  "⛹️‍♂️",
  "⛹️",
  "⛺️",
  "⛽️",
  "✂️",
  "✅",
  "✈️",
  "✉️",
  "✊🏻",
  "✊🏼",
  "✊🏽",
  "✊🏾",
  "✊🏿",
  "✊",
  "✋🏻",
  "✋🏼",
  "✋🏽",
  "✋🏾",
  "✋🏿",
  "✋",
  "✌🏻",
  "✌🏼",
  "✌🏽",
  "✌🏾",
  "✌🏿",
  "✌️",
  "✍🏻",
  "✍🏼",
  "✍🏽",
  "✍🏾",
  "✍🏿",
  "✍️",
  "✏️",
  "✒️",
  "✔️",
  "✖️",
  "✝️",
  "✡️",
  "✨",
  "✳️",
  "✴️",
  "❄️",
  "❇️",
  "❌",
  "❎",
  "❓",
  "❔",
  "❕",
  "❗️",
  "❣️",
  "❤️",
  "➕",
  "➖",
  "➗",
  "➡️",
  "➰",
  "➿",
  "⤴️",
  "⤵️",
  "*⃣",
  "⬅️",
  "⬆️",
  "⬇️",
  "⬛️",
  "⬜️",
  "⭐️",
  "⭕️",
  "0⃣",
  "〰️",
  "〽️",
  "1⃣",
  "2⃣",
  "㊗️",
  "㊙️",
  "3⃣",
  "4⃣",
  "5⃣",
  "6⃣",
  "7⃣",
  "8⃣",
  "9⃣",
  "©️",
  "®️",
  ""
]

/***/ }),

/***/ 80924:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51941);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ServiceQuoteObject = /*#__PURE__*/function (_BookingBaseModel) {
  function ServiceQuoteObject() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, ServiceQuoteObject);
    return _callSuper(this, ServiceQuoteObject, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(ServiceQuoteObject, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(ServiceQuoteObject, [{
    key: "newServiceQuoteList",
    value: function () {
      var _newServiceQuoteList = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(obj) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.newObject({
                objectClass: 'servicequotelist'
              }, obj, 'QuoteList');
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function newServiceQuoteList(_x) {
        return _newServiceQuoteList.apply(this, arguments);
      }
      return newServiceQuoteList;
    }()
  }, {
    key: "booking",
    get: function get() {
      return this.$parent.$parent.$parent;
    }
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(ServiceQuoteObject, "moduleName", 'servicequoteobject');
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(ServiceQuoteObject, "invalidated_cache", _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__["default"].invalidated_cache_services);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ServiceQuoteObject);

/***/ }),

/***/ 81219:
/***/ (function(module) {

(function (global, factory) {
	 true ? module.exports = factory() :
	0;
}(this, (function () { 'use strict';

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var _global = createCommonjsModule(function (module) {
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') { __g = global; } // eslint-disable-line no-undef
	});

	var _core = createCommonjsModule(function (module) {
	var core = module.exports = { version: '2.6.5' };
	if (typeof __e == 'number') { __e = core; } // eslint-disable-line no-undef
	});
	var _core_1 = _core.version;

	var _isObject = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

	var _anObject = function (it) {
	  if (!_isObject(it)) { throw TypeError(it + ' is not an object!'); }
	  return it;
	};

	var _fails = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};

	// Thank's IE8 for his funny defineProperty
	var _descriptors = !_fails(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});

	var document = _global.document;
	// typeof document.createElement is 'object' in old IE
	var is = _isObject(document) && _isObject(document.createElement);
	var _domCreate = function (it) {
	  return is ? document.createElement(it) : {};
	};

	var _ie8DomDefine = !_descriptors && !_fails(function () {
	  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
	});

	// 7.1.1 ToPrimitive(input [, PreferredType])

	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	var _toPrimitive = function (it, S) {
	  if (!_isObject(it)) { return it; }
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) { return val; }
	  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) { return val; }
	  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) { return val; }
	  throw TypeError("Can't convert object to primitive value");
	};

	var dP = Object.defineProperty;

	var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  _anObject(O);
	  P = _toPrimitive(P, true);
	  _anObject(Attributes);
	  if (_ie8DomDefine) { try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ } }
	  if ('get' in Attributes || 'set' in Attributes) { throw TypeError('Accessors not supported!'); }
	  if ('value' in Attributes) { O[P] = Attributes.value; }
	  return O;
	};

	var _objectDp = {
		f: f
	};

	var _propertyDesc = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};

	var _hide = _descriptors ? function (object, key, value) {
	  return _objectDp.f(object, key, _propertyDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};

	var hasOwnProperty = {}.hasOwnProperty;
	var _has = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};

	var id = 0;
	var px = Math.random();
	var _uid = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

	var _library = false;

	var _shared = createCommonjsModule(function (module) {
	var SHARED = '__core-js_shared__';
	var store = _global[SHARED] || (_global[SHARED] = {});

	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: _core.version,
	  mode: _library ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});
	});

	var _functionToString = _shared('native-function-to-string', Function.toString);

	var _redefine = createCommonjsModule(function (module) {
	var SRC = _uid('src');

	var TO_STRING = 'toString';
	var TPL = ('' + _functionToString).split(TO_STRING);

	_core.inspectSource = function (it) {
	  return _functionToString.call(it);
	};

	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) { _has(val, 'name') || _hide(val, 'name', key); }
	  if (O[key] === val) { return; }
	  if (isFunction) { _has(val, SRC) || _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key))); }
	  if (O === _global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    _hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    _hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || _functionToString.call(this);
	});
	});

	var _aFunction = function (it) {
	  if (typeof it != 'function') { throw TypeError(it + ' is not a function!'); }
	  return it;
	};

	// optional / simple context binding

	var _ctx = function (fn, that, length) {
	  _aFunction(fn);
	  if (that === undefined) { return fn; }
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};

	var PROTOTYPE = 'prototype';

	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) { source = name; }
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
	    // extend global
	    if (target) { _redefine(target, key, out, type & $export.U); }
	    // export
	    if (exports[key] != out) { _hide(exports, key, exp); }
	    if (IS_PROTO && expProto[key] != out) { expProto[key] = out; }
	  }
	};
	_global.core = _core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	var _export = $export;

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	var _toInteger = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

	// 7.2.1 RequireObjectCoercible(argument)
	var _defined = function (it) {
	  if (it == undefined) { throw TypeError("Can't call method on  " + it); }
	  return it;
	};

	// true  -> String#at
	// false -> String#codePointAt
	var _stringAt = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(_defined(that));
	    var i = _toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) { return TO_STRING ? '' : undefined; }
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

	var $at = _stringAt(false);
	_export(_export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});

	var codePointAt = _core.String.codePointAt;

	var max = Math.max;
	var min = Math.min;
	var _toAbsoluteIndex = function (index, length) {
	  index = _toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;

	// length should be 1, old FF problem
	_export(_export.S + _export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) {
	    var arguments$1 = arguments;
	 // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments$1[i++];
	      if (_toAbsoluteIndex(code, 0x10ffff) !== code) { throw RangeError(code + ' is not a valid code point'); }
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

	var fromCodePoint = _core.String.fromCodePoint;

	// This is a generated file. Do not edit.
	var Space_Separator = /[\u1680\u2000-\u200A\u202F\u205F\u3000]/;
	var ID_Start = /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE83\uDE86-\uDE89\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]/;
	var ID_Continue = /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u09FC\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9-\u0AFF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D00-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF9\u1D00-\u1DF9\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDE00-\uDE3E\uDE47\uDE50-\uDE83\uDE86-\uDE99\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD50-\uDD59]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/;

	var unicode = {
		Space_Separator: Space_Separator,
		ID_Start: ID_Start,
		ID_Continue: ID_Continue
	};

	var util = {
	    isSpaceSeparator: function isSpaceSeparator (c) {
	        return typeof c === 'string' && unicode.Space_Separator.test(c)
	    },

	    isIdStartChar: function isIdStartChar (c) {
	        return typeof c === 'string' && (
	            (c >= 'a' && c <= 'z') ||
	        (c >= 'A' && c <= 'Z') ||
	        (c === '$') || (c === '_') ||
	        unicode.ID_Start.test(c)
	        )
	    },

	    isIdContinueChar: function isIdContinueChar (c) {
	        return typeof c === 'string' && (
	            (c >= 'a' && c <= 'z') ||
	        (c >= 'A' && c <= 'Z') ||
	        (c >= '0' && c <= '9') ||
	        (c === '$') || (c === '_') ||
	        (c === '\u200C') || (c === '\u200D') ||
	        unicode.ID_Continue.test(c)
	        )
	    },

	    isDigit: function isDigit (c) {
	        return typeof c === 'string' && /[0-9]/.test(c)
	    },

	    isHexDigit: function isHexDigit (c) {
	        return typeof c === 'string' && /[0-9A-Fa-f]/.test(c)
	    },
	};

	var source;
	var parseState;
	var stack;
	var pos;
	var line;
	var column;
	var token;
	var key;
	var root;

	var parse = function parse (text, reviver) {
	    source = String(text);
	    parseState = 'start';
	    stack = [];
	    pos = 0;
	    line = 1;
	    column = 0;
	    token = undefined;
	    key = undefined;
	    root = undefined;

	    do {
	        token = lex();

	        // This code is unreachable.
	        // if (!parseStates[parseState]) {
	        //     throw invalidParseState()
	        // }

	        parseStates[parseState]();
	    } while (token.type !== 'eof')

	    if (typeof reviver === 'function') {
	        return internalize({'': root}, '', reviver)
	    }

	    return root
	};

	function internalize (holder, name, reviver) {
	    var value = holder[name];
	    if (value != null && typeof value === 'object') {
	        if (Array.isArray(value)) {
	            for (var i = 0; i < value.length; i++) {
	                var key = String(i);
	                var replacement = internalize(value, key, reviver);
	                if (replacement === undefined) {
	                    delete value[key];
	                } else {
	                    Object.defineProperty(value, key, {
	                        value: replacement,
	                        writable: true,
	                        enumerable: true,
	                        configurable: true,
	                    });
	                }
	            }
	        } else {
	            for (var key$1 in value) {
	                var replacement$1 = internalize(value, key$1, reviver);
	                if (replacement$1 === undefined) {
	                    delete value[key$1];
	                } else {
	                    Object.defineProperty(value, key$1, {
	                        value: replacement$1,
	                        writable: true,
	                        enumerable: true,
	                        configurable: true,
	                    });
	                }
	            }
	        }
	    }

	    return reviver.call(holder, name, value)
	}

	var lexState;
	var buffer;
	var doubleQuote;
	var sign;
	var c;

	function lex () {
	    lexState = 'default';
	    buffer = '';
	    doubleQuote = false;
	    sign = 1;

	    for (;;) {
	        c = peek();

	        // This code is unreachable.
	        // if (!lexStates[lexState]) {
	        //     throw invalidLexState(lexState)
	        // }

	        var token = lexStates[lexState]();
	        if (token) {
	            return token
	        }
	    }
	}

	function peek () {
	    if (source[pos]) {
	        return String.fromCodePoint(source.codePointAt(pos))
	    }
	}

	function read () {
	    var c = peek();

	    if (c === '\n') {
	        line++;
	        column = 0;
	    } else if (c) {
	        column += c.length;
	    } else {
	        column++;
	    }

	    if (c) {
	        pos += c.length;
	    }

	    return c
	}

	var lexStates = {
	    default: function default$1 () {
	        switch (c) {
	        case '\t':
	        case '\v':
	        case '\f':
	        case ' ':
	        case '\u00A0':
	        case '\uFEFF':
	        case '\n':
	        case '\r':
	        case '\u2028':
	        case '\u2029':
	            read();
	            return

	        case '/':
	            read();
	            lexState = 'comment';
	            return

	        case undefined:
	            read();
	            return newToken('eof')
	        }

	        if (util.isSpaceSeparator(c)) {
	            read();
	            return
	        }

	        // This code is unreachable.
	        // if (!lexStates[parseState]) {
	        //     throw invalidLexState(parseState)
	        // }

	        return lexStates[parseState]()
	    },

	    comment: function comment () {
	        switch (c) {
	        case '*':
	            read();
	            lexState = 'multiLineComment';
	            return

	        case '/':
	            read();
	            lexState = 'singleLineComment';
	            return
	        }

	        throw invalidChar(read())
	    },

	    multiLineComment: function multiLineComment () {
	        switch (c) {
	        case '*':
	            read();
	            lexState = 'multiLineCommentAsterisk';
	            return

	        case undefined:
	            throw invalidChar(read())
	        }

	        read();
	    },

	    multiLineCommentAsterisk: function multiLineCommentAsterisk () {
	        switch (c) {
	        case '*':
	            read();
	            return

	        case '/':
	            read();
	            lexState = 'default';
	            return

	        case undefined:
	            throw invalidChar(read())
	        }

	        read();
	        lexState = 'multiLineComment';
	    },

	    singleLineComment: function singleLineComment () {
	        switch (c) {
	        case '\n':
	        case '\r':
	        case '\u2028':
	        case '\u2029':
	            read();
	            lexState = 'default';
	            return

	        case undefined:
	            read();
	            return newToken('eof')
	        }

	        read();
	    },

	    value: function value () {
	        switch (c) {
	        case '{':
	        case '[':
	            return newToken('punctuator', read())

	        case 'n':
	            read();
	            literal('ull');
	            return newToken('null', null)

	        case 't':
	            read();
	            literal('rue');
	            return newToken('boolean', true)

	        case 'f':
	            read();
	            literal('alse');
	            return newToken('boolean', false)

	        case '-':
	        case '+':
	            if (read() === '-') {
	                sign = -1;
	            }

	            lexState = 'sign';
	            return

	        case '.':
	            buffer = read();
	            lexState = 'decimalPointLeading';
	            return

	        case '0':
	            buffer = read();
	            lexState = 'zero';
	            return

	        case '1':
	        case '2':
	        case '3':
	        case '4':
	        case '5':
	        case '6':
	        case '7':
	        case '8':
	        case '9':
	            buffer = read();
	            lexState = 'decimalInteger';
	            return

	        case 'I':
	            read();
	            literal('nfinity');
	            return newToken('numeric', Infinity)

	        case 'N':
	            read();
	            literal('aN');
	            return newToken('numeric', NaN)

	        case '"':
	        case "'":
	            doubleQuote = (read() === '"');
	            buffer = '';
	            lexState = 'string';
	            return
	        }

	        throw invalidChar(read())
	    },

	    identifierNameStartEscape: function identifierNameStartEscape () {
	        if (c !== 'u') {
	            throw invalidChar(read())
	        }

	        read();
	        var u = unicodeEscape();
	        switch (u) {
	        case '$':
	        case '_':
	            break

	        default:
	            if (!util.isIdStartChar(u)) {
	                throw invalidIdentifier()
	            }

	            break
	        }

	        buffer += u;
	        lexState = 'identifierName';
	    },

	    identifierName: function identifierName () {
	        switch (c) {
	        case '$':
	        case '_':
	        case '\u200C':
	        case '\u200D':
	            buffer += read();
	            return

	        case '\\':
	            read();
	            lexState = 'identifierNameEscape';
	            return
	        }

	        if (util.isIdContinueChar(c)) {
	            buffer += read();
	            return
	        }

	        return newToken('identifier', buffer)
	    },

	    identifierNameEscape: function identifierNameEscape () {
	        if (c !== 'u') {
	            throw invalidChar(read())
	        }

	        read();
	        var u = unicodeEscape();
	        switch (u) {
	        case '$':
	        case '_':
	        case '\u200C':
	        case '\u200D':
	            break

	        default:
	            if (!util.isIdContinueChar(u)) {
	                throw invalidIdentifier()
	            }

	            break
	        }

	        buffer += u;
	        lexState = 'identifierName';
	    },

	    sign: function sign$1 () {
	        switch (c) {
	        case '.':
	            buffer = read();
	            lexState = 'decimalPointLeading';
	            return

	        case '0':
	            buffer = read();
	            lexState = 'zero';
	            return

	        case '1':
	        case '2':
	        case '3':
	        case '4':
	        case '5':
	        case '6':
	        case '7':
	        case '8':
	        case '9':
	            buffer = read();
	            lexState = 'decimalInteger';
	            return

	        case 'I':
	            read();
	            literal('nfinity');
	            return newToken('numeric', sign * Infinity)

	        case 'N':
	            read();
	            literal('aN');
	            return newToken('numeric', NaN)
	        }

	        throw invalidChar(read())
	    },

	    zero: function zero () {
	        switch (c) {
	        case '.':
	            buffer += read();
	            lexState = 'decimalPoint';
	            return

	        case 'e':
	        case 'E':
	            buffer += read();
	            lexState = 'decimalExponent';
	            return

	        case 'x':
	        case 'X':
	            buffer += read();
	            lexState = 'hexadecimal';
	            return
	        }

	        return newToken('numeric', sign * 0)
	    },

	    decimalInteger: function decimalInteger () {
	        switch (c) {
	        case '.':
	            buffer += read();
	            lexState = 'decimalPoint';
	            return

	        case 'e':
	        case 'E':
	            buffer += read();
	            lexState = 'decimalExponent';
	            return
	        }

	        if (util.isDigit(c)) {
	            buffer += read();
	            return
	        }

	        return newToken('numeric', sign * Number(buffer))
	    },

	    decimalPointLeading: function decimalPointLeading () {
	        if (util.isDigit(c)) {
	            buffer += read();
	            lexState = 'decimalFraction';
	            return
	        }

	        throw invalidChar(read())
	    },

	    decimalPoint: function decimalPoint () {
	        switch (c) {
	        case 'e':
	        case 'E':
	            buffer += read();
	            lexState = 'decimalExponent';
	            return
	        }

	        if (util.isDigit(c)) {
	            buffer += read();
	            lexState = 'decimalFraction';
	            return
	        }

	        return newToken('numeric', sign * Number(buffer))
	    },

	    decimalFraction: function decimalFraction () {
	        switch (c) {
	        case 'e':
	        case 'E':
	            buffer += read();
	            lexState = 'decimalExponent';
	            return
	        }

	        if (util.isDigit(c)) {
	            buffer += read();
	            return
	        }

	        return newToken('numeric', sign * Number(buffer))
	    },

	    decimalExponent: function decimalExponent () {
	        switch (c) {
	        case '+':
	        case '-':
	            buffer += read();
	            lexState = 'decimalExponentSign';
	            return
	        }

	        if (util.isDigit(c)) {
	            buffer += read();
	            lexState = 'decimalExponentInteger';
	            return
	        }

	        throw invalidChar(read())
	    },

	    decimalExponentSign: function decimalExponentSign () {
	        if (util.isDigit(c)) {
	            buffer += read();
	            lexState = 'decimalExponentInteger';
	            return
	        }

	        throw invalidChar(read())
	    },

	    decimalExponentInteger: function decimalExponentInteger () {
	        if (util.isDigit(c)) {
	            buffer += read();
	            return
	        }

	        return newToken('numeric', sign * Number(buffer))
	    },

	    hexadecimal: function hexadecimal () {
	        if (util.isHexDigit(c)) {
	            buffer += read();
	            lexState = 'hexadecimalInteger';
	            return
	        }

	        throw invalidChar(read())
	    },

	    hexadecimalInteger: function hexadecimalInteger () {
	        if (util.isHexDigit(c)) {
	            buffer += read();
	            return
	        }

	        return newToken('numeric', sign * Number(buffer))
	    },

	    string: function string () {
	        switch (c) {
	        case '\\':
	            read();
	            buffer += escape();
	            return

	        case '"':
	            if (doubleQuote) {
	                read();
	                return newToken('string', buffer)
	            }

	            buffer += read();
	            return

	        case "'":
	            if (!doubleQuote) {
	                read();
	                return newToken('string', buffer)
	            }

	            buffer += read();
	            return

	        case '\n':
	        case '\r':
	            throw invalidChar(read())

	        case '\u2028':
	        case '\u2029':
	            separatorChar(c);
	            break

	        case undefined:
	            throw invalidChar(read())
	        }

	        buffer += read();
	    },

	    start: function start () {
	        switch (c) {
	        case '{':
	        case '[':
	            return newToken('punctuator', read())

	        // This code is unreachable since the default lexState handles eof.
	        // case undefined:
	        //     return newToken('eof')
	        }

	        lexState = 'value';
	    },

	    beforePropertyName: function beforePropertyName () {
	        switch (c) {
	        case '$':
	        case '_':
	            buffer = read();
	            lexState = 'identifierName';
	            return

	        case '\\':
	            read();
	            lexState = 'identifierNameStartEscape';
	            return

	        case '}':
	            return newToken('punctuator', read())

	        case '"':
	        case "'":
	            doubleQuote = (read() === '"');
	            lexState = 'string';
	            return
	        }

	        if (util.isIdStartChar(c)) {
	            buffer += read();
	            lexState = 'identifierName';
	            return
	        }

	        throw invalidChar(read())
	    },

	    afterPropertyName: function afterPropertyName () {
	        if (c === ':') {
	            return newToken('punctuator', read())
	        }

	        throw invalidChar(read())
	    },

	    beforePropertyValue: function beforePropertyValue () {
	        lexState = 'value';
	    },

	    afterPropertyValue: function afterPropertyValue () {
	        switch (c) {
	        case ',':
	        case '}':
	            return newToken('punctuator', read())
	        }

	        throw invalidChar(read())
	    },

	    beforeArrayValue: function beforeArrayValue () {
	        if (c === ']') {
	            return newToken('punctuator', read())
	        }

	        lexState = 'value';
	    },

	    afterArrayValue: function afterArrayValue () {
	        switch (c) {
	        case ',':
	        case ']':
	            return newToken('punctuator', read())
	        }

	        throw invalidChar(read())
	    },

	    end: function end () {
	        // This code is unreachable since it's handled by the default lexState.
	        // if (c === undefined) {
	        //     read()
	        //     return newToken('eof')
	        // }

	        throw invalidChar(read())
	    },
	};

	function newToken (type, value) {
	    return {
	        type: type,
	        value: value,
	        line: line,
	        column: column,
	    }
	}

	function literal (s) {
	    for (var i = 0, list = s; i < list.length; i += 1) {
	        var c = list[i];

	        var p = peek();

	        if (p !== c) {
	            throw invalidChar(read())
	        }

	        read();
	    }
	}

	function escape () {
	    var c = peek();
	    switch (c) {
	    case 'b':
	        read();
	        return '\b'

	    case 'f':
	        read();
	        return '\f'

	    case 'n':
	        read();
	        return '\n'

	    case 'r':
	        read();
	        return '\r'

	    case 't':
	        read();
	        return '\t'

	    case 'v':
	        read();
	        return '\v'

	    case '0':
	        read();
	        if (util.isDigit(peek())) {
	            throw invalidChar(read())
	        }

	        return '\0'

	    case 'x':
	        read();
	        return hexEscape()

	    case 'u':
	        read();
	        return unicodeEscape()

	    case '\n':
	    case '\u2028':
	    case '\u2029':
	        read();
	        return ''

	    case '\r':
	        read();
	        if (peek() === '\n') {
	            read();
	        }

	        return ''

	    case '1':
	    case '2':
	    case '3':
	    case '4':
	    case '5':
	    case '6':
	    case '7':
	    case '8':
	    case '9':
	        throw invalidChar(read())

	    case undefined:
	        throw invalidChar(read())
	    }

	    return read()
	}

	function hexEscape () {
	    var buffer = '';
	    var c = peek();

	    if (!util.isHexDigit(c)) {
	        throw invalidChar(read())
	    }

	    buffer += read();

	    c = peek();
	    if (!util.isHexDigit(c)) {
	        throw invalidChar(read())
	    }

	    buffer += read();

	    return String.fromCodePoint(parseInt(buffer, 16))
	}

	function unicodeEscape () {
	    var buffer = '';
	    var count = 4;

	    while (count-- > 0) {
	        var c = peek();
	        if (!util.isHexDigit(c)) {
	            throw invalidChar(read())
	        }

	        buffer += read();
	    }

	    return String.fromCodePoint(parseInt(buffer, 16))
	}

	var parseStates = {
	    start: function start () {
	        if (token.type === 'eof') {
	            throw invalidEOF()
	        }

	        push();
	    },

	    beforePropertyName: function beforePropertyName () {
	        switch (token.type) {
	        case 'identifier':
	        case 'string':
	            key = token.value;
	            parseState = 'afterPropertyName';
	            return

	        case 'punctuator':
	            // This code is unreachable since it's handled by the lexState.
	            // if (token.value !== '}') {
	            //     throw invalidToken()
	            // }

	            pop();
	            return

	        case 'eof':
	            throw invalidEOF()
	        }

	        // This code is unreachable since it's handled by the lexState.
	        // throw invalidToken()
	    },

	    afterPropertyName: function afterPropertyName () {
	        // This code is unreachable since it's handled by the lexState.
	        // if (token.type !== 'punctuator' || token.value !== ':') {
	        //     throw invalidToken()
	        // }

	        if (token.type === 'eof') {
	            throw invalidEOF()
	        }

	        parseState = 'beforePropertyValue';
	    },

	    beforePropertyValue: function beforePropertyValue () {
	        if (token.type === 'eof') {
	            throw invalidEOF()
	        }

	        push();
	    },

	    beforeArrayValue: function beforeArrayValue () {
	        if (token.type === 'eof') {
	            throw invalidEOF()
	        }

	        if (token.type === 'punctuator' && token.value === ']') {
	            pop();
	            return
	        }

	        push();
	    },

	    afterPropertyValue: function afterPropertyValue () {
	        // This code is unreachable since it's handled by the lexState.
	        // if (token.type !== 'punctuator') {
	        //     throw invalidToken()
	        // }

	        if (token.type === 'eof') {
	            throw invalidEOF()
	        }

	        switch (token.value) {
	        case ',':
	            parseState = 'beforePropertyName';
	            return

	        case '}':
	            pop();
	        }

	        // This code is unreachable since it's handled by the lexState.
	        // throw invalidToken()
	    },

	    afterArrayValue: function afterArrayValue () {
	        // This code is unreachable since it's handled by the lexState.
	        // if (token.type !== 'punctuator') {
	        //     throw invalidToken()
	        // }

	        if (token.type === 'eof') {
	            throw invalidEOF()
	        }

	        switch (token.value) {
	        case ',':
	            parseState = 'beforeArrayValue';
	            return

	        case ']':
	            pop();
	        }

	        // This code is unreachable since it's handled by the lexState.
	        // throw invalidToken()
	    },

	    end: function end () {
	        // This code is unreachable since it's handled by the lexState.
	        // if (token.type !== 'eof') {
	        //     throw invalidToken()
	        // }
	    },
	};

	function push () {
	    var value;

	    switch (token.type) {
	    case 'punctuator':
	        switch (token.value) {
	        case '{':
	            value = {};
	            break

	        case '[':
	            value = [];
	            break
	        }

	        break

	    case 'null':
	    case 'boolean':
	    case 'numeric':
	    case 'string':
	        value = token.value;
	        break

	    // This code is unreachable.
	    // default:
	    //     throw invalidToken()
	    }

	    if (root === undefined) {
	        root = value;
	    } else {
	        var parent = stack[stack.length - 1];
	        if (Array.isArray(parent)) {
	            parent.push(value);
	        } else {
	            Object.defineProperty(parent, key, {
	                value: value,
	                writable: true,
	                enumerable: true,
	                configurable: true,
	            });
	        }
	    }

	    if (value !== null && typeof value === 'object') {
	        stack.push(value);

	        if (Array.isArray(value)) {
	            parseState = 'beforeArrayValue';
	        } else {
	            parseState = 'beforePropertyName';
	        }
	    } else {
	        var current = stack[stack.length - 1];
	        if (current == null) {
	            parseState = 'end';
	        } else if (Array.isArray(current)) {
	            parseState = 'afterArrayValue';
	        } else {
	            parseState = 'afterPropertyValue';
	        }
	    }
	}

	function pop () {
	    stack.pop();

	    var current = stack[stack.length - 1];
	    if (current == null) {
	        parseState = 'end';
	    } else if (Array.isArray(current)) {
	        parseState = 'afterArrayValue';
	    } else {
	        parseState = 'afterPropertyValue';
	    }
	}

	// This code is unreachable.
	// function invalidParseState () {
	//     return new Error(`JSON5: invalid parse state '${parseState}'`)
	// }

	// This code is unreachable.
	// function invalidLexState (state) {
	//     return new Error(`JSON5: invalid lex state '${state}'`)
	// }

	function invalidChar (c) {
	    if (c === undefined) {
	        return syntaxError(("JSON5: invalid end of input at " + line + ":" + column))
	    }

	    return syntaxError(("JSON5: invalid character '" + (formatChar(c)) + "' at " + line + ":" + column))
	}

	function invalidEOF () {
	    return syntaxError(("JSON5: invalid end of input at " + line + ":" + column))
	}

	// This code is unreachable.
	// function invalidToken () {
	//     if (token.type === 'eof') {
	//         return syntaxError(`JSON5: invalid end of input at ${line}:${column}`)
	//     }

	//     const c = String.fromCodePoint(token.value.codePointAt(0))
	//     return syntaxError(`JSON5: invalid character '${formatChar(c)}' at ${line}:${column}`)
	// }

	function invalidIdentifier () {
	    column -= 5;
	    return syntaxError(("JSON5: invalid identifier character at " + line + ":" + column))
	}

	function separatorChar (c) {
	    console.warn(("JSON5: '" + (formatChar(c)) + "' in strings is not valid ECMAScript; consider escaping"));
	}

	function formatChar (c) {
	    var replacements = {
	        "'": "\\'",
	        '"': '\\"',
	        '\\': '\\\\',
	        '\b': '\\b',
	        '\f': '\\f',
	        '\n': '\\n',
	        '\r': '\\r',
	        '\t': '\\t',
	        '\v': '\\v',
	        '\0': '\\0',
	        '\u2028': '\\u2028',
	        '\u2029': '\\u2029',
	    };

	    if (replacements[c]) {
	        return replacements[c]
	    }

	    if (c < ' ') {
	        var hexString = c.charCodeAt(0).toString(16);
	        return '\\x' + ('00' + hexString).substring(hexString.length)
	    }

	    return c
	}

	function syntaxError (message) {
	    var err = new SyntaxError(message);
	    err.lineNumber = line;
	    err.columnNumber = column;
	    return err
	}

	var stringify = function stringify (value, replacer, space) {
	    var stack = [];
	    var indent = '';
	    var propertyList;
	    var replacerFunc;
	    var gap = '';
	    var quote;

	    if (
	        replacer != null &&
	        typeof replacer === 'object' &&
	        !Array.isArray(replacer)
	    ) {
	        space = replacer.space;
	        quote = replacer.quote;
	        replacer = replacer.replacer;
	    }

	    if (typeof replacer === 'function') {
	        replacerFunc = replacer;
	    } else if (Array.isArray(replacer)) {
	        propertyList = [];
	        for (var i = 0, list = replacer; i < list.length; i += 1) {
	            var v = list[i];

	            var item = (void 0);

	            if (typeof v === 'string') {
	                item = v;
	            } else if (
	                typeof v === 'number' ||
	                v instanceof String ||
	                v instanceof Number
	            ) {
	                item = String(v);
	            }

	            if (item !== undefined && propertyList.indexOf(item) < 0) {
	                propertyList.push(item);
	            }
	        }
	    }

	    if (space instanceof Number) {
	        space = Number(space);
	    } else if (space instanceof String) {
	        space = String(space);
	    }

	    if (typeof space === 'number') {
	        if (space > 0) {
	            space = Math.min(10, Math.floor(space));
	            gap = '          '.substr(0, space);
	        }
	    } else if (typeof space === 'string') {
	        gap = space.substr(0, 10);
	    }

	    return serializeProperty('', {'': value})

	    function serializeProperty (key, holder) {
	        var value = holder[key];
	        if (value != null) {
	            if (typeof value.toJSON5 === 'function') {
	                value = value.toJSON5(key);
	            } else if (typeof value.toJSON === 'function') {
	                value = value.toJSON(key);
	            }
	        }

	        if (replacerFunc) {
	            value = replacerFunc.call(holder, key, value);
	        }

	        if (value instanceof Number) {
	            value = Number(value);
	        } else if (value instanceof String) {
	            value = String(value);
	        } else if (value instanceof Boolean) {
	            value = value.valueOf();
	        }

	        switch (value) {
	        case null: return 'null'
	        case true: return 'true'
	        case false: return 'false'
	        }

	        if (typeof value === 'string') {
	            return quoteString(value, false)
	        }

	        if (typeof value === 'number') {
	            return String(value)
	        }

	        if (typeof value === 'object') {
	            return Array.isArray(value) ? serializeArray(value) : serializeObject(value)
	        }

	        return undefined
	    }

	    function quoteString (value) {
	        var quotes = {
	            "'": 0.1,
	            '"': 0.2,
	        };

	        var replacements = {
	            "'": "\\'",
	            '"': '\\"',
	            '\\': '\\\\',
	            '\b': '\\b',
	            '\f': '\\f',
	            '\n': '\\n',
	            '\r': '\\r',
	            '\t': '\\t',
	            '\v': '\\v',
	            '\0': '\\0',
	            '\u2028': '\\u2028',
	            '\u2029': '\\u2029',
	        };

	        var product = '';

	        for (var i = 0; i < value.length; i++) {
	            var c = value[i];
	            switch (c) {
	            case "'":
	            case '"':
	                quotes[c]++;
	                product += c;
	                continue

	            case '\0':
	                if (util.isDigit(value[i + 1])) {
	                    product += '\\x00';
	                    continue
	                }
	            }

	            if (replacements[c]) {
	                product += replacements[c];
	                continue
	            }

	            if (c < ' ') {
	                var hexString = c.charCodeAt(0).toString(16);
	                product += '\\x' + ('00' + hexString).substring(hexString.length);
	                continue
	            }

	            product += c;
	        }

	        var quoteChar = quote || Object.keys(quotes).reduce(function (a, b) { return (quotes[a] < quotes[b]) ? a : b; });

	        product = product.replace(new RegExp(quoteChar, 'g'), replacements[quoteChar]);

	        return quoteChar + product + quoteChar
	    }

	    function serializeObject (value) {
	        if (stack.indexOf(value) >= 0) {
	            throw TypeError('Converting circular structure to JSON5')
	        }

	        stack.push(value);

	        var stepback = indent;
	        indent = indent + gap;

	        var keys = propertyList || Object.keys(value);
	        var partial = [];
	        for (var i = 0, list = keys; i < list.length; i += 1) {
	            var key = list[i];

	            var propertyString = serializeProperty(key, value);
	            if (propertyString !== undefined) {
	                var member = serializeKey(key) + ':';
	                if (gap !== '') {
	                    member += ' ';
	                }
	                member += propertyString;
	                partial.push(member);
	            }
	        }

	        var final;
	        if (partial.length === 0) {
	            final = '{}';
	        } else {
	            var properties;
	            if (gap === '') {
	                properties = partial.join(',');
	                final = '{' + properties + '}';
	            } else {
	                var separator = ',\n' + indent;
	                properties = partial.join(separator);
	                final = '{\n' + indent + properties + ',\n' + stepback + '}';
	            }
	        }

	        stack.pop();
	        indent = stepback;
	        return final
	    }

	    function serializeKey (key) {
	        if (key.length === 0) {
	            return quoteString(key, true)
	        }

	        var firstChar = String.fromCodePoint(key.codePointAt(0));
	        if (!util.isIdStartChar(firstChar)) {
	            return quoteString(key, true)
	        }

	        for (var i = firstChar.length; i < key.length; i++) {
	            if (!util.isIdContinueChar(String.fromCodePoint(key.codePointAt(i)))) {
	                return quoteString(key, true)
	            }
	        }

	        return key
	    }

	    function serializeArray (value) {
	        if (stack.indexOf(value) >= 0) {
	            throw TypeError('Converting circular structure to JSON5')
	        }

	        stack.push(value);

	        var stepback = indent;
	        indent = indent + gap;

	        var partial = [];
	        for (var i = 0; i < value.length; i++) {
	            var propertyString = serializeProperty(String(i), value);
	            partial.push((propertyString !== undefined) ? propertyString : 'null');
	        }

	        var final;
	        if (partial.length === 0) {
	            final = '[]';
	        } else {
	            if (gap === '') {
	                var properties = partial.join(',');
	                final = '[' + properties + ']';
	            } else {
	                var separator = ',\n' + indent;
	                var properties$1 = partial.join(separator);
	                final = '[\n' + indent + properties$1 + ',\n' + stepback + ']';
	            }
	        }

	        stack.pop();
	        indent = stepback;
	        return final
	    }
	};

	var JSON5 = {
	    parse: parse,
	    stringify: stringify,
	};

	var lib = JSON5;

	var es5 = lib;

	return es5;

})));


/***/ }),

/***/ 81765:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort:
            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
                '_'
            ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


/***/ }),

/***/ 81766:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = __webpack_require__(48287),
  Buffer = _require.Buffer;
var _require2 = __webpack_require__(63779),
  inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/function () {
  function BufferList() {
    _classCallCheck(this, BufferList);
    this.head = null;
    this.tail = null;
    this.length = 0;
  }
  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;
      while (p = p.next) ret += s + p.data;
      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;
      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }
      return ret;
    }

    // Consumes a specified amount of bytes or characters from the buffered data.
  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;
      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }
      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    }

    // Consumes a specified amount of characters from the buffered data.
  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;
      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Consumes a specified amount of bytes from the buffered data.
  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;
      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Make sure the linked list only shows the minimal necessary information.
  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);
  return BufferList;
}();

/***/ }),

/***/ 81999:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(65606);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;
  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(94643)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(41396);
/*</replacement>*/

var Buffer = (__webpack_require__(48287).Buffer);
var OurUint8Array = (typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = __webpack_require__(54347);
var _require = __webpack_require__(66644),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = (__webpack_require__(12463)/* .codes */ .F),
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
  ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
  ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
  ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
__webpack_require__(56698)(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__(88101);
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'finish' (and potentially 'end')
  this.autoDestroy = !!options.autoDestroy;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};
(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}
function Writable(options) {
  Duplex = Duplex || __webpack_require__(88101);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex);

  // legacy.
  this.writable = true;
  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }
  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END();
  // TODO: defer error events consistently everywhere, not just the cb
  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var er;
  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }
  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }
  return true;
}
Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);
  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }
  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};
Writable.prototype.cork = function () {
  this._writableState.corked++;
};
Writable.prototype.uncork = function () {
  var state = this._writableState;
  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;
  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }
  return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}
function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}
function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;
    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }
    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}
function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;
  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }
    if (entry === null) state.lastBufferedRequest = null;
  }
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}
Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;
  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
  return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});
function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      errorOrDestroy(stream, err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}
function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;
        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }
  return need;
}
function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  cb(err);
};

/***/ }),

/***/ 82211:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var assert = __webpack_require__(43349);
var inherits = __webpack_require__(56698);

var utils = __webpack_require__(87626);
var Cipher = __webpack_require__(82808);

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  if (this.padding === false) {
    return false;
  }

  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  if (this.padding === false) {
    return buffer;
  }

  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),

/***/ 82218:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


/***/ }),

/***/ 82271:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone:
                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                    '_'
                ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone:
                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                    '_'
                ),
        },
        weekdays: {
            standalone:
                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                    '_'
                ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex:
            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex:
            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),

/***/ 82284:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ _typeof)
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),

/***/ 82509:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = (__webpack_require__(51069).Buffer);
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);


/***/ }),

/***/ 82682:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


/***/ }),

/***/ 82808:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var assert = __webpack_require__(43349);

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
  this.padding = options.padding !== false
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),

/***/ 82890:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var inherits = __webpack_require__(56698)
var Hash = __webpack_require__(90392)
var Buffer = (__webpack_require__(92861).Buffer)

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),

/***/ 83141:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = (__webpack_require__(15003).Buffer);
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.I = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ 83211:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8818);









function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var BookingDayServiceCarView = /*#__PURE__*/function (_View) {
  function BookingDayServiceCarView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, BookingDayServiceCarView);
    return _callSuper(this, BookingDayServiceCarView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingDayServiceCarView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(BookingDayServiceCarView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res, dropOffAddressId, pickupAddressId;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(BookingDayServiceCarView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              res = _context.sent;
              dropOffAddressId = _.find(res.fields, function (r) {
                return r.name == 'DropOffAddressId';
              });
              if (dropOffAddressId) {
                dropOffAddressId.filters = function (row, record) {
                  var v = true;
                  if (record.Service && record.Service.SupplierId != row.SupplierId) v = false;
                  if (record.BookingDayServiceCar && record.BookingDayServiceCar.DropOffCityId && record.BookingDayServiceCar.DropOffCityId != row.CityId) v = false;
                  //if (record.CityId && record.CityId != row.CityId) v = false;
                  return v;
                };
              }
              pickupAddressId = _.find(res.fields, function (r) {
                return r.name == 'PickupAddressId';
              });
              if (pickupAddressId) {
                pickupAddressId.filters = function (row, record) {
                  var v = true;
                  if (record.Service && record.Service.SupplierId != row.SupplierId) v = false;
                  if (record.Service && record.Service.CityId && record.Service.CityId != row.CityId) v = false;
                  if (record.CityId && record.CityId != row.CityId) v = false;
                  return v;
                };
              }
              return _context.abrupt("return", res);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_4__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(BookingDayServiceCarView, "table", 'bookingdayservicecar');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingDayServiceCarView);

/***/ }),

/***/ 83222:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = (__webpack_require__(34106).Buffer);
var util = __webpack_require__(15340);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),

/***/ 83417:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8818);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var SurveyPaxView = /*#__PURE__*/function (_View) {
  function SurveyPaxView() {
    _classCallCheck(this, SurveyPaxView);
    return _callSuper(this, SurveyPaxView, arguments);
  }
  _inherits(SurveyPaxView, _View);
  return _createClass(SurveyPaxView, null, [{
    key: "getTableOptions",
    value: function getTableOptions() {
      return {
        canAdd: true,
        fields: [{
          name: 'SurveyId',
          relation: 'survey',
          optionLabels: 'Name',
          editor: 'select',
          label: 'Survey',
          setRelationTo: 'Survey'
        }, {
          name: 'BookingId'
        }, {
          name: 'SurveyPaxQuestions',
          editor: [],
          label: 'Questions',
          rowFields: [{
            name: 'SurveyQuestionId',
            relation: 'surveyquestion',
            optionLabels: 'Label',
            editor: 'select',
            setRelationTo: '',
            columns: 12,
            readonly: true
          }, {
            name: 'Response',
            columns: 10,
            editor: 'component',
            component: 'SurveyPaxQuestion',
            componentName: 'SurveyPaxQuestion',
            componentPath: 'components/tools',
            inline: true,
            hideIf: function hideIf(row) {
              return row.SurveyQuestion && row.SurveyQuestion.QuestionType == 'TABLE';
            }
          }, {
            name: 'TableId',
            columns: 10,
            editor: 'component',
            component: 'SurveyPaxQuestion',
            componentName: 'SurveyPaxQuestion',
            componentPath: 'components/tools',
            inline: true,
            hideIf: function hideIf(row) {
              return row.SurveyQuestion && row.SurveyQuestion.QuestionType != 'TABLE';
            },
            extras: function () {
              var _extras = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(row) {
                var r;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return api.get('/api/surveypax/' + row.SurveyPaxId);
                    case 2:
                      r = _context.sent;
                      if (!r) {
                        _context.next = 5;
                        break;
                      }
                      return _context.abrupt("return", {
                        BookingId: r.BookingId
                      });
                    case 5:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              function extras(_x) {
                return _extras.apply(this, arguments);
              }
              return extras;
            }()
          }]
        }],
        actions: [{
          label: 'Update Questions',
          method: 'updateQuestions',
          id: 'updateQuestions'
        }],
        title: 'Survey Pax'
      };
    }
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_0__["default"]);
_defineProperty(SurveyPaxView, "table", 'surveypax');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SurveyPaxView);

/***/ }),

/***/ 83507:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var inherits = __webpack_require__(56698)
var Legacy = __webpack_require__(41800)
var Base = __webpack_require__(56168)
var Buffer = (__webpack_require__(92861).Buffer)
var md5 = __webpack_require__(20320)
var RIPEMD160 = __webpack_require__(66011)

var sha = __webpack_require__(62802)

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}


/***/ }),

/***/ 83646:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8818);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var ImageView = /*#__PURE__*/function (_View) {
  function ImageView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, ImageView);
    return _callSuper(this, ImageView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(ImageView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(ImageView, null, [{
    key: "options",
    value: function options() {
      return {
        fieldsDataReplace: {
          url: {
            name: 'url',
            maxLength: 255
          }
        },
        canAdd: true
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(ImageView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_4__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ImageView);

/***/ }),

/***/ 84050:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var CipherBase = __webpack_require__(56168)
var des = __webpack_require__(29560)
var inherits = __webpack_require__(56698)
var Buffer = (__webpack_require__(92861).Buffer)

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}


/***/ }),

/***/ 84070:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8818);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingReceiptView = /*#__PURE__*/function (_View) {
  function BookingReceiptView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingReceiptView);
    return _callSuper(this, BookingReceiptView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingReceiptView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingReceiptView, null, [{
    key: "receiptStatusOptions",
    get: function get() {
      var res = [];
      for (var s in this.receiptStatus) {
        var v = {
          value: s,
          label: this.receiptStatus[s]
        };
        if (s == 'CONFIRMED') {
          v.disabled = !this.adminActions;
        }
        res.push(v);
      }
      return res;
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var adminActions;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              adminActions = this.adminActions;
              return _context.abrupt("return", {
                canAdd: true,
                canCopy: true,
                fields: [{
                  name: 'id',
                  readonly: true,
                  columns: 2,
                  headerField: true,
                  label: 'Number'
                }, {
                  name: 'BookingId',
                  readonly: true,
                  columns: 2,
                  headerField: true,
                  label: 'File Nr'
                }, {
                  name: 'Amount',
                  label: 'Amount',
                  headerField: true,
                  editor: 'number',
                  columns: 2,
                  decimal: 2,
                  currency: 'Currency'
                }, {
                  name: 'CurrencyId',
                  relation: 'currency',
                  optionLabels: 'id',
                  setRelationTo: 'Currency',
                  editor: 'select',
                  label: 'Currency',
                  columns: 2,
                  headerField: true,
                  required: true
                }, {
                  name: 'PaymentDate',
                  label: 'Payment Date',
                  editor: 'date',
                  headerField: true,
                  columns: 2,
                  required: true,
                  dateFormat: "DD/MM/YYYY"
                }, {
                  name: 'PaymentStatus',
                  label: 'Status',
                  editor: 'select',
                  notSort: true,
                  headerField: true,
                  columns: 2,
                  options: this.receiptStatusOptions,
                  required: true
                }, {
                  name: "PaymentTypeId",
                  relation: "paymenttype",
                  optionLabels: "Name",
                  editor: "select",
                  addBlank: true,
                  label: "Payment Type",
                  hideFromList: true,
                  columns: 2,
                  headerField: true,
                  setRelationTo: 'PaymentType',
                  requiredCallback: function requiredCallback(record) {
                    if (record.PaymentStatus && record.PaymentStatus != 'PENDING') return true;
                  },
                  filters: function filters(row) {
                    if (row.Receipts == true) return true;
                  }
                }, {
                  name: 'Comment',
                  columns: 12,
                  headerField: true,
                  label: 'Notes'
                }, {
                  name: 'ReceivedAmount',
                  label: 'Receipt Amount',
                  editor: 'number',
                  columns: 3,
                  readonly: !adminActions,
                  hidden: !adminActions,
                  decimal: 2,
                  currency: 'ReceivedCurrency',
                  requiredCallback: function requiredCallback(record) {
                    return record.PaymentStatus == 'CONFIRMED';
                  }
                }, {
                  name: 'ReceivedCurrencyId',
                  relation: 'currency',
                  optionLabels: 'id',
                  disabled: !adminActions,
                  editor: 'select',
                  label: 'Currency',
                  columns: 3,
                  hidden: !adminActions,
                  setRelationTo: 'ReceivedCurrency',
                  requiredCallback: function requiredCallback(record) {
                    if (record.ReceivedAmount) return true;
                    if (record.PaymentStatus && record.PaymentStatus == 'CONFIRMED') return true;
                  }
                }, {
                  name: 'ReceivedPaymentDate',
                  label: 'Received Date',
                  editor: 'date',
                  columns: 3,
                  dateFormat: "DD/MM/YYYY",
                  requiredCallback: function requiredCallback(record) {
                    return record.PaymentStatus == 'CONFIRMED';
                  }
                }, {
                  name: 'CurrencyRate',
                  label: 'Rate',
                  editor: 'number',
                  columns: 3,
                  decimal: 2,
                  readonly: !adminActions,
                  hidden: !adminActions
                }, {
                  name: 'Attach',
                  label: 'Attachments',
                  editor: 'attach',
                  columns: 12,
                  hideFromList: true
                }]
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingReceiptView, "table", 'bookingreceipt');
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingReceiptView, "adminActions", tools.canAccess(api.currentUser, 'api', 'GET', 'admin_actions', false));
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingReceiptView, "receiptStatus", {
  PENDING: 'Pending',
  PAID: 'Paid',
  CONFIRMED: 'Confirmed',
  CANCELED: 'Canceled'
  //ON_ACCOUNT: 'Credit',
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingReceiptView);

/***/ }),

/***/ 84451:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort:
            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


/***/ }),

/***/ 84735:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51941);








function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ServiceQuote = /*#__PURE__*/function (_BookingBaseModel) {
  function ServiceQuote(obj) {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, ServiceQuote);
    //console.log('ServiceQuote')
    var fieldsList = [];
    if (obj.record) {
      for (var key in obj.record) {
        if (['ADT', 'CHD', 'TL', 'Groups', 'Variants'].indexOf(key) == -1) continue;
        if (key == 'ADT' || key == 'CHD' || key == 'TL') {
          fieldsList.push({
            name: key,
            editor: {},
            objectClass: 'servicepersonquote'
          });
        } else {
          fieldsList.push({
            name: key,
            editor: 'checkbox'
          });
        }
      }
    }
    if (obj.fields) {
      var _iterator = _createForOfIteratorHelper(obj.fields),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var field = _step.value;
          if (['ADT', 'CHD', 'TL', 'Groups', 'Variants'].indexOf(field.name) == -1) continue;
          fieldsList.push(field);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    obj.fields = fieldsList;
    return _callSuper(this, ServiceQuote, [obj]);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(ServiceQuote, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(ServiceQuote, [{
    key: "paxTypes",
    get: function get() {
      //return tools.getBases(_.cloneDeep(this));
      return ['ADT', 'CHD', 'TL'];
    }
  }, {
    key: "getPaxDetails",
    get: function get() {
      var r = {};
      if (this.booking.QuoteBy == 'PERSON') {
        var _this$booking;
        if ((_this$booking = this.booking) !== null && _this$booking !== void 0 && (_this$booking = _this$booking.BaseQuotes) !== null && _this$booking !== void 0 && (_this$booking = _this$booking[this.baseId]) !== null && _this$booking !== void 0 && _this$booking[this.paxType]) {
          var pax = this.booking.BaseQuotes[this.baseId][this.paxType];
          if (this.booking.Totals[this.baseId][this.paxType].Pax) {
            pax = this.booking.Totals[this.baseId][this.paxType].Pax;
          }
          r[this.paxType] = pax;
        }
      } else {
        if (this.costPer == 'PERSON') {
          if (this.ADT) r.ADT = this.ADT.Base;
          if (this.CHD) r.CHD = this.CHD.Base;
          if (this.TL) r.TL = this.TL.Base;
        } else if (this.booking.isGroup(this.baseId)) {
          var groups = this.booking.QuoteGroups[this.baseId];
          if (groups) {
            for (var groupId in groups) {
              if (!this.Groups[groupId]) continue;
              var group = groups[groupId];
              if (group.ADT) {
                if (!r.ADT) r.ADT = 0;
                r.ADT += group.ADT;
              }
              ;
              if (group.CHD) {
                if (!r.CHD) r.CHD = 0;
                r.CHD += group.CHD;
              }
              ;
              if (group.TL) {
                if (!r.TL) r.TL = 0;
                r.TL += group.TL;
              }
              ;
            }
          }
        } else {
          if (this.ADT) r.ADT = this.ADT.Base;
        }
      }
      return r;
    }
  }, {
    key: "service",
    get: function get() {
      return this.$parent.$parent;
    }
  }, {
    key: "baseId",
    get: function get() {
      for (var id in this.$parent.bases) {
        if (!this.$parent[id]) continue;
        if (this.$parent[id]._id == this._id) {
          return id;
        }
      }
    }
  }, {
    key: "newServicePersonQuote",
    value: function () {
      var _newServicePersonQuote = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(pType, obj) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.fields.push({
                name: pType,
                editor: {},
                objectClass: 'servicepersonquote'
              });
              _context.next = 3;
              return this.newObject({
                objectClass: 'servicepersonquote'
              }, obj, pType);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function newServicePersonQuote(_x, _x2) {
        return _newServicePersonQuote.apply(this, arguments);
      }
      return newServicePersonQuote;
    }()
  }, {
    key: "costPer",
    get: function get() {
      var quoteADT = this.ADT;
      var costPer = quoteADT.costPer;
      if (!costPer) costPer = this.$parent.$parent.$parent.costPer;
      return costPer;
    }
  }, {
    key: "paxQuant",
    get: function get() {
      if (this.costPer == 'PERSON') {
        return (this.ADT ? this.ADT.Base : 0) + (this.CHD ? this.CHD.Base : 0) + (this.TL ? this.TL.Base : 0);
      } else {
        return this.ADT.Base;
      }
    }
  }, {
    key: "booking",
    get: function get() {
      return this.$parent.$parent.$parent.$parent.$parent;
    }
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(ServiceQuote, "moduleName", 'servicequote');
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(ServiceQuote, "invalidated_cache", _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__["default"].invalidated_cache_services);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ServiceQuote);

/***/ }),

/***/ 85096:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


/***/ }),

/***/ 85332:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var HotelMixinView = api.importMixinModule('hotel', 'views', 'custom');
var HotelView = /*#__PURE__*/function (_HotelMixinView) {
  function HotelView() {
    _classCallCheck(this, HotelView);
    return _callSuper(this, HotelView, arguments);
  }
  _inherits(HotelView, _HotelMixinView);
  return _createClass(HotelView, null, [{
    key: "options",
    value: function options() {
      var options = _superPropGet(HotelView, "options", this, 2)([]);
      options.fieldsDataReplace.Review = {
        name: 'Review',
        label: 'Reseñas',
        editor: 'tab',
        hideFromList: true,
        icon: 'comment-dots',
        fields: [{
          name: 'Review',
          hideFromList: true,
          editor: 'text-area',
          columns: 12,
          rows: 10
        }]
      };
      return options;
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(options) {
        var res, i;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(HotelView, "getTableOptions", this, 2)([options]);
            case 2:
              res = _context.sent;
              i = res.fields.findIndex(function (f) {
                return f.name === 'Snack';
              }); // res.fields.splice(i + 1, 0, { name: 'MealsByCategory', label: 'Meals By Category', editor: 'checkbox' });
              return _context.abrupt("return", res);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions(_x) {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(HotelMixinView);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HotelView);

/***/ }),

/***/ 85498:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex =
            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),

/***/ 85725:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8818);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var PurchaseInvoiceView = /*#__PURE__*/function (_View) {
  function PurchaseInvoiceView() {
    _classCallCheck(this, PurchaseInvoiceView);
    return _callSuper(this, PurchaseInvoiceView, arguments);
  }
  _inherits(PurchaseInvoiceView, _View);
  return _createClass(PurchaseInvoiceView, null, [{
    key: "currencyConvertTab",
    get: function get() {
      var adminActions = this.adminActions;
      return {
        name: 'currencyConvertTab',
        label: 'Currency Rate',
        editor: 'tab',
        hideFromList: true,
        hidden: !adminActions,
        fields: [{
          name: 'FromCurrencyId',
          relation: 'currency',
          optionLabels: 'id',
          editor: 'select',
          label: 'From',
          columns: 2,
          required: adminActions
        }, {
          name: 'ToCurrencyId',
          relation: 'currency',
          optionLabels: 'id',
          editor: 'select',
          label: 'To',
          columns: 2,
          required: adminActions
        }, {
          name: 'CurrencyRate',
          editor: 'number',
          columns: 2,
          decimal: 5,
          label: 'Rate',
          required: adminActions
        }]
      };
    }
  }, {
    key: "options",
    value: function options() {
      return {
        serverSide: true,
        canAdd: true,
        title: 'Purchase Invoice',
        setTitleName: function setTitleName(self) {
          var res = tr('Purchase Invoice');
          if (self.InvoiceNumber) res += ' ' + self.InvoiceNumber;
          return res;
        },
        fields: [{
          name: 'id',
          hidden: true
        }, {
          name: 'BookingId',
          label: 'File',
          headerField: true,
          editor: 'number'
        }, {
          name: 'SupplierId',
          relation: 'supplier',
          optionLabels: 'Name',
          setRelationTo: 'Supplier',
          label: 'Supplier',
          headerField: true,
          editor: 'vue-select'
        }, {
          name: 'Type',
          label: 'Type',
          editor: 'select',
          optionLabels: 'Name',
          defValue: 'INVOICE',
          headerField: true,
          options: [{
            value: 'INVOICE',
            label: 'Invoice'
          }, {
            value: 'CREDIT',
            label: 'Credit Note'
          }]
        }, {
          name: 'InvoiceNumber',
          label: 'Number',
          required: true,
          headerField: true
        }, {
          name: 'InvoiceDate',
          label: 'Date',
          required: true,
          editor: 'date',
          headerField: true,
          dateformat: "DD/MM/YYYY"
        }, {
          name: 'InvoiceTotal',
          label: 'Total',
          headerField: true,
          readonly: true,
          editor: 'number',
          hideFromList: true,
          decimal: 2,
          computed: function computed(record) {
            var res = 0;
            var _iterator = _createForOfIteratorHelper(record.PurchaseInvoiceDetails),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var row = _step.value;
                if (row.Amount) res += parseFloat(row.Amount);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            return res;
          }
        }, {
          name: 'CurrencyId',
          relation: 'currency',
          optionLabels: 'id',
          editor: 'select',
          label: 'Currency',
          headerField: true
        }, {
          name: 'CurrencyRate',
          label: 'Currency Rate',
          headerField: true,
          editor: 'number',
          hideFromList: true,
          decimal: 5,
          required: true
        },
        /*{name: 'SupplierTotal', label: 'Supplier Invoice', headerField: true,  editor: 'number', hideFromList: true,
            decimal: 2,
            afterEdit: (record) => {
                let res = [];
                let f = record.SupplierTotal / record.InvoiceTotal;
                for (let rowId in record.PurchaseInvoiceDetails) {
                    let row = record.PurchaseInvoiceDetails[rowId];
                    row.Amount = row.Amount * f;
                    res.push({
                        params: ['PurchaseInvoiceDetails', rowId, 'Amount'],
                        value: row.Amount,
                        action: 'set'
                    })
                }
                return res;
            }
        },*/
        {
          name: 'BaseTotal',
          label: 'Base Value',
          headerField: true,
          readonly: true,
          editor: 'number',
          hideFromList: true,
          decimal: 2,
          computed: function computed(record) {
            var res = 0;
            var _iterator2 = _createForOfIteratorHelper(record.PurchaseInvoiceTaxes),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var row = _step2.value;
                if (row.TaxBase) res += parseFloat(row.TaxBase);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
            return res;
          }
        }, {
          name: 'TaxTotal',
          label: 'Tax',
          headerField: true,
          readonly: true,
          editor: 'number',
          hideFromList: true,
          decimal: 2,
          computed: function computed(record) {
            var res = 0;
            var _iterator3 = _createForOfIteratorHelper(record.PurchaseInvoiceTaxes),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var row = _step3.value;
                if (!row.TaxCode) continue;
                if (row.Amount) res += parseFloat(row.Amount);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
            return res;
          }
        }, {
          name: 'PurchaseInvoiceDetails',
          editor: [],
          label: 'Detail',
          rowFields: [{
            name: 'id',
            hidden: true
          }, {
            name: 'Detail',
            label: 'Concept',
            columns: 4,
            hideIf: function hideIf(row) {
              if (!row.BookingId) return true;
            }
          }, {
            name: 'ExpenseTypeId',
            relation: 'expensetype',
            optionLabels: 'Name',
            editor: 'select',
            label: 'Concept',
            columns: 7,
            filters: function filters(row) {
              if (row.Invoice == true) return true;
            },
            hideIf: function hideIf(row) {
              if (row.BookingId) return true;
            }
          }, {
            name: 'BookingId',
            label: 'File',
            columns: 1,
            readonly: true,
            editor: 'number',
            decimal: 0,
            hideIf: function hideIf(row) {
              if (!row.BookingId) return true;
            }
          }, {
            name: 'PaxName',
            label: 'Passenger',
            columns: 2,
            readonly: true,
            hideIf: function hideIf(row) {
              if (!row.BookingId) return true;
            }
          }, {
            name: 'Amount',
            label: 'Amount',
            editor: 'number',
            columns: 2,
            required: true,
            decimal: 2
          }]
        }, {
          name: 'PurchaseInvoiceTaxes',
          editor: [],
          label: 'Taxes',
          rowFields: [
          //{name: 'id', hidden: true},
          {
            name: 'TaxCodeId',
            relation: 'taxcode',
            optionLabels: 'Name',
            setRelationTo: 'TaxCode',
            editor: 'select',
            label: 'Tax',
            required: true,
            columns: 2,
            afterEdit: function afterEdit(row) {
              if (row.TaxCode && row.TaxBase) {
                row.Amount = parseFloat(row.TaxBase) * parseFloat(row.TaxCode.Value) / 100.0;
              }
            }
          }, {
            name: 'TaxBase',
            label: 'Base Value',
            editor: 'number',
            columns: 2,
            required: true,
            decimal: 2,
            afterEdit: function afterEdit(row) {
              if (row.TaxCode && row.TaxBase) {
                row.Amount = parseFloat(row.TaxBase) * parseFloat(row.TaxCode.Value) / 100.0;
              }
            }
          }, {
            name: 'Amount',
            label: 'Tax Amount',
            editor: 'number',
            columns: 2,
            decimal: 2
            /*computed: function(row, record) {
                if (row.TaxCode) {
                    return parseFloat(row.TaxBase) * parseFloat(row.TaxCode.Value) / 100.0;
                }
                return row.Amount;
            }*/
          }],
          fields: []
        }, {
          name: 'AttachTab',
          editor: 'tab',
          label: 'Attachments',
          hideFromList: true,
          fields: [{
            name: 'Attach',
            label: 'Attachments',
            editor: 'attach',
            columns: 12
          }]
        }]
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(PurchaseInvoiceView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              res = _context.sent;
              return _context.abrupt("return", res);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_0__["default"]);
_defineProperty(PurchaseInvoiceView, "table", 'purchaseinvoice');
_defineProperty(PurchaseInvoiceView, "adminActions", tools.canAccess(api.currentUser, 'api', 'GET', 'admin_actions', false));
_defineProperty(PurchaseInvoiceView, "operActions", tools.canAccess(api.currentUser, 'api', 'GET', 'oper_actions', false));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PurchaseInvoiceView);

/***/ }),

/***/ 85898:
/***/ ((module) => {

"use strict";

module.exports = function generate_uniqueItems(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  if (($schema || $isData) && it.opts.uniqueItems !== false) {
    if ($isData) {
      out += ' var ' + ($valid) + '; if (' + ($schemaValue) + ' === false || ' + ($schemaValue) + ' === undefined) ' + ($valid) + ' = true; else if (typeof ' + ($schemaValue) + ' != \'boolean\') ' + ($valid) + ' = false; else { ';
    }
    out += ' var i = ' + ($data) + '.length , ' + ($valid) + ' = true , j; if (i > 1) { ';
    var $itemType = it.schema.items && it.schema.items.type,
      $typeIsArray = Array.isArray($itemType);
    if (!$itemType || $itemType == 'object' || $itemType == 'array' || ($typeIsArray && ($itemType.indexOf('object') >= 0 || $itemType.indexOf('array') >= 0))) {
      out += ' outer: for (;i--;) { for (j = i; j--;) { if (equal(' + ($data) + '[i], ' + ($data) + '[j])) { ' + ($valid) + ' = false; break outer; } } } ';
    } else {
      out += ' var itemIndices = {}, item; for (;i--;) { var item = ' + ($data) + '[i]; ';
      var $method = 'checkDataType' + ($typeIsArray ? 's' : '');
      out += ' if (' + (it.util[$method]($itemType, 'item', it.opts.strictNumbers, true)) + ') continue; ';
      if ($typeIsArray) {
        out += ' if (typeof item == \'string\') item = \'"\' + item; ';
      }
      out += ' if (typeof itemIndices[item] == \'number\') { ' + ($valid) + ' = false; j = itemIndices[item]; break; } itemIndices[item] = i; } ';
    }
    out += ' } ';
    if ($isData) {
      out += '  }  ';
    }
    out += ' if (!' + ($valid) + ') {   ';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('uniqueItems') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { i: i, j: j } ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should NOT have duplicate items (items ## \' + j + \' and \' + i + \' are identical)\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema:  ';
        if ($isData) {
          out += 'validate.schema' + ($schemaPath);
        } else {
          out += '' + ($schema);
        }
        out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError([' + (__err) + ']); ';
      } else {
        out += ' validate.errors = [' + (__err) + ']; return false; ';
      }
    } else {
      out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    }
    out += ' } ';
    if ($breakOnError) {
      out += ' else { ';
    }
  } else {
    if ($breakOnError) {
      out += ' if (true) { ';
    }
  }
  return out;
}


/***/ }),

/***/ 86078:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_model_record__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55539);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var SurveyPax = /*#__PURE__*/function (_Record) {
  function SurveyPax() {
    _classCallCheck(this, SurveyPax);
    return _callSuper(this, SurveyPax, arguments);
  }
  _inherits(SurveyPax, _Record);
  return _createClass(SurveyPax, [{
    key: "afterEdit",
    value: function afterEdit() {
      return {
        SurveyId: function () {
          var _SurveyId = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(r) {
            var _iterator, _step, q, values;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  r.SurveyPaxQuestions = [];
                  if (r.Survey) {
                    _context.next = 3;
                    break;
                  }
                  return _context.abrupt("return");
                case 3:
                  _iterator = _createForOfIteratorHelper(r.Survey.SurveyQuestions);
                  _context.prev = 4;
                  _iterator.s();
                case 6:
                  if ((_step = _iterator.n()).done) {
                    _context.next = 13;
                    break;
                  }
                  q = _step.value;
                  values = {
                    SurveyQuestionId: q.id
                  };
                  _context.next = 11;
                  return r.addRow({
                    fieldName: 'SurveyPaxQuestions',
                    values: values
                  });
                case 11:
                  _context.next = 6;
                  break;
                case 13:
                  _context.next = 18;
                  break;
                case 15:
                  _context.prev = 15;
                  _context.t0 = _context["catch"](4);
                  _iterator.e(_context.t0);
                case 18:
                  _context.prev = 18;
                  _iterator.f();
                  return _context.finish(18);
                case 21:
                case "end":
                  return _context.stop();
              }
            }, _callee, null, [[4, 15, 18, 21]]);
          }));
          function SurveyId(_x) {
            return _SurveyId.apply(this, arguments);
          }
          return SurveyId;
        }()
      };
    }
  }, {
    key: "updateQuestions",
    value: function () {
      var _updateQuestions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(callback) {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              api.setProcessing(true);
              _context2.next = 3;
              return api.post('/api/surveypax/update_questions/' + this.id, {}, {}, callback);
            case 3:
              res = _context2.sent;
              if (!res) {
                _context2.next = 19;
                break;
              }
              this._recordLoaded = false;
              this.attachList = [];
              _context2.next = 9;
              return this.init(res);
            case 9:
              _context2.next = 11;
              return this.getAttached();
            case 11:
              this.original_id = this.id;
              api.updateToStore('surveypax', res);
              this.addNotification(tr("Record Saved"));
              if (res._warnings) {
                this.notifications.warning = res._warnings.join('; ');
              }
              this._recordLoaded = true;
              _context2.next = 18;
              return this.init(res);
            case 18:
              api.setProcessing(false);
            case 19:
              if (res && callback) {
                callback(null, {
                  record: res,
                  update: true
                });
              }
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function updateQuestions(_x2) {
        return _updateQuestions.apply(this, arguments);
      }
      return updateQuestions;
    }()
  }]);
}(_base_model_record__WEBPACK_IMPORTED_MODULE_0__["default"]);
_defineProperty(SurveyPax, "moduleName", 'surveypax');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SurveyPax);

/***/ }),

/***/ 86169:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort:
            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


/***/ }),

/***/ 86559:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var map = {
	"./admin/index.js": 24802,
	"./ai/index.js": 57859,
	"./contacts/index.js": 1506,
	"./crm/index.js": 71799,
	"./custom/index.js": 7543
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86559;

/***/ }),

/***/ 86571:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone:
                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                    '_'
                ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


/***/ }),

/***/ 86729:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var elliptic = exports;

elliptic.version = (__webpack_require__(1636)/* .version */ .rE);
elliptic.utils = __webpack_require__(47011);
elliptic.rand = __webpack_require__(15037);
elliptic.curve = __webpack_require__(894);
elliptic.curves = __webpack_require__(60480);

// Protocols
elliptic.ec = __webpack_require__(57447);
elliptic.eddsa = __webpack_require__(8650);


/***/ }),

/***/ 86747:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const {
  validate,
  ValidationError,
  enableValidation,
  disableValidation,
  needValidate
} = __webpack_require__(13393);

module.exports = {
  validate,
  ValidationError,
  enableValidation,
  disableValidation,
  needValidate
};

/***/ }),

/***/ 86794:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


/***/ }),

/***/ 86813:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

/** @typedef {import("ajv").Ajv} Ajv */

/**
 *
 * @param {Ajv} ajv
 * @param {string} keyword
 * @param {any} definition
 */
function addKeyword(ajv, keyword, definition) {
  let customRuleCode;

  try {
    // @ts-ignore
    // eslint-disable-next-line global-require
    customRuleCode = __webpack_require__(7992); // @ts-ignore

    const {
      RULES
    } = ajv;
    let ruleGroup;

    for (let i = 0; i < RULES.length; i++) {
      const rg = RULES[i];

      if (typeof rg.type === "undefined") {
        ruleGroup = rg;
        break;
      }
    }

    const rule = {
      keyword,
      definition,
      custom: true,
      code: customRuleCode,
      implements: definition.implements
    };
    ruleGroup.rules.unshift(rule);
    RULES.custom[keyword] = rule;
    RULES.keywords[keyword] = true;
    RULES.all[keyword] = true;
  } catch (e) {// Nothing, fallback
  }
}
/**
 *
 * @param {Ajv} ajv
 * @returns {Ajv}
 */


function addUndefinedAsNullKeyword(ajv) {
  // There is workaround for old versions of ajv, where `before` is not implemented
  addKeyword(ajv, "undefinedAsNull", {
    modifying: true,

    /**
     * @param {boolean} kwVal
     * @param {unknown} data
     * @param {any} parentSchema
     * @param {string} dataPath
     * @param {unknown} parentData
     * @param {number | string} parentDataProperty
     * @return {boolean}
     */
    validate(kwVal, data, parentSchema, dataPath, parentData, parentDataProperty) {
      if (kwVal && parentSchema && typeof parentSchema.enum !== "undefined" && parentData && typeof parentDataProperty === "number") {
        const idx =
        /** @type {number} */
        parentDataProperty;
        const parentDataRef =
        /** @type {any[]} */
        parentData;

        if (typeof parentDataRef[idx] === "undefined") {
          parentDataRef[idx] = null;
        }
      }

      return true;
    }

  });
  return ajv;
}

var _default = addUndefinedAsNullKeyword;
exports["default"] = _default;

/***/ }),

/***/ 86824:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var View = api.importMixinModule('booking', 'views', 'contacts');
var ContactBookingView = /*#__PURE__*/function (_View) {
  function ContactBookingView() {
    _classCallCheck(this, ContactBookingView);
    return _callSuper(this, ContactBookingView, arguments);
  }
  _inherits(ContactBookingView, _View);
  return _createClass(ContactBookingView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(ContactBookingView, "getTableOptions", this, 2)([params]);
            case 2:
              res = _context.sent;
              res.fields.push({
                name: 'ContactId',
                label: 'Contact',
                editor: 'select',
                relation: 'contact',
                optionLabels: 'ContactName',
                setRelationTo: 'Contact',
                endpointFilters: function endpointFilters(record) {
                  if (record && record.AgencyId) {
                    var _res = {};
                    _res.AgencyId = record.AgencyId;
                    return _res;
                  }
                  return {};
                }
              });
              return _context.abrupt("return", res);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions(_x) {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(View);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ContactBookingView);

/***/ }),

/***/ 86975:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var Buffer = (__webpack_require__(92861).Buffer)

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),

/***/ 87214:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_record__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55539);









function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var Hotel = /*#__PURE__*/function (_Record) {
  function Hotel(obj) {
    var _this;
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(this, Hotel);
    _this = _callSuper(this, Hotel, [obj]);
    _this.HotelCost = [];
    _this.periods = [];
    _this.periodError = null;
    return _this;
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(Hotel, _Record);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(Hotel, [{
    key: "setPeriods",
    value: function setPeriods(periods) {
      this.periods = Object.assign([], periods);
    }
  }, {
    key: "setHotelCostToRecord",
    value: function setHotelCostToRecord() {
      if (!this.periods) return;
      this.HotelCost = [];
      var k = 0;
      var _iterator = _createForOfIteratorHelper(this.periods),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var period = _step.value;
          period.rowNr = k;
          if (period.isModified || period.remove) {
            this.HotelCost.push(period);
          }
          k++;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "save",
    value: function () {
      var _save = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var originalServiceCost, _iterator2, _step2, row, key, res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              originalServiceCost = null;
              if (this.ServiceCost) {
                originalServiceCost = this.ServiceCost;
                this.ServiceCost = this.ServiceCost.map(function (r) {
                  var mapped = _objectSpread({}, r);
                  if (r.Delete) mapped.Closed = true;
                  return mapped;
                });
              }
              if (!this.HotelCost) {
                _context.next = 21;
                break;
              }
              _iterator2 = _createForOfIteratorHelper(this.HotelCost);
              _context.prev = 4;
              _iterator2.s();
            case 6:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 13;
                break;
              }
              row = _step2.value;
              if (row.Data) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("continue", 11);
            case 10:
              for (key in row.Data) {
                if (row.Data[key].roomType) delete row.Data[key]['roomType'];
                if (row.Data[key].roomClass) delete row.Data[key]['roomClass'];
              }
            case 11:
              _context.next = 6;
              break;
            case 13:
              _context.next = 18;
              break;
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](4);
              _iterator2.e(_context.t0);
            case 18:
              _context.prev = 18;
              _iterator2.f();
              return _context.finish(18);
            case 21:
              _context.next = 23;
              return _superPropGet(Hotel, "save", this, 3)([]);
            case 23:
              res = _context.sent;
              if (originalServiceCost) this.ServiceCost = originalServiceCost;
              if (res && res.SupplierId && res.Supplier) {
                api.updateToStore('supplier', res.Supplier);
                api.addHotelsList();
              }
              return _context.abrupt("return", res);
            case 27:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 15, 18, 21]]);
      }));
      function save() {
        return _save.apply(this, arguments);
      }
      return save;
    }()
  }]);
}(_base_model_record__WEBPACK_IMPORTED_MODULE_5__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(Hotel, "moduleName", 'hotel');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Hotel);

/***/ }),

/***/ 87444:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);




function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var BookingTest = /*#__PURE__*/function () {
  function BookingTest(booking) {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(this, BookingTest);
    this.booking = booking;
  }
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(BookingTest, [{
    key: "testCopyAndSetValues",
    value: function () {
      var _testCopyAndSetValues = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(quoteBy) {
        var _this = this;
        var basesIds, baseId, model, b, quote, dayId, d, sId, s, rowQuote, modified, value, _value, _iterator, _step, hotel, roomId, room, _rowQuote;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              console.log('TEST start', this.booking.id, quoteBy);
              basesIds = Object.keys(this.booking.BaseQuotes.bases);
              baseId = basesIds[0];
              _context.next = 5;
              return this.booking.setValue({
                fieldName: 'PriceCurrencyId',
                value: this.booking.CurrencyId
              });
            case 5:
              _context.next = 7;
              return this.booking.setCostByDate({
                update: true,
                baseId: baseId,
                sync: true
              });
            case 7:
              window._booking1 = this.booking;
              _context.next = 10;
              return api.importMixinModule('booking', 'model');
            case 10:
              model = _context.sent;
              _context.next = 13;
              return model.cloneAll({
                record: this.booking
              });
            case 13:
              b = _context.sent;
              b.id = null;
              if (quoteBy == 'SERVICE') {
                if (this.booking.QuoteBy == 'PERSON') {
                  b.QuoteViewType = 'PERSON';
                } else {
                  b.QuoteViewType = 'SERVICE';
                }
              }
              b.Markup = this.booking.Markup;
              quote = this.booking.BaseQuotes[baseId];
              _context.next = 20;
              return b.removeBase(baseId);
            case 20:
              b.QuoteBy = quoteBy;
              _context.next = 23;
              return b.addBase({
                adt: quote.ADT,
                chd: quote.CHD,
                sync: true
              });
            case 23:
              _context.t0 = _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().keys(this.booking.BookingDays);
            case 24:
              if ((_context.t1 = _context.t0()).done) {
                _context.next = 136;
                break;
              }
              dayId = _context.t1.value;
              d = this.booking.BookingDays[dayId];
              _context.t2 = _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().keys(d.BookingDayServices);
            case 28:
              if ((_context.t3 = _context.t2()).done) {
                _context.next = 84;
                break;
              }
              sId = _context.t3.value;
              s = d.BookingDayServices[sId];
              if (s.Quote) {
                _context.next = 33;
                break;
              }
              return _context.abrupt("continue", 28);
            case 33:
              if (s.Quote.QuoteList) {
                _context.next = 35;
                break;
              }
              return _context.abrupt("continue", 28);
            case 35:
              if (s.Quote.QuoteList[baseId]) {
                _context.next = 37;
                break;
              }
              return _context.abrupt("continue", 28);
            case 37:
              if (s.Quote.QuoteList[baseId].ADT) {
                _context.next = 39;
                break;
              }
              return _context.abrupt("continue", 28);
            case 39:
              rowQuote = b.BookingDays[dayId].BookingDayServices[sId].Quote.QuoteList[baseId].ADT;
              if (s.Quote.QuoteList[baseId].ADT.Include) {
                _context.next = 43;
                break;
              }
              _context.next = 43;
              return rowQuote.setValue({
                fieldName: 'Include',
                value: false
              });
            case 43:
              if (!(s.Quote.QuoteList[baseId].ADT.Include && !rowQuote.Include)) {
                _context.next = 46;
                break;
              }
              _context.next = 46;
              return rowQuote.setValue({
                fieldName: 'Include',
                value: true
              });
            case 46:
              if (!(!s.costPer && s.Quote.QuoteList[baseId].ADT.Quantity == 1 && quoteBy != 'PERSON')) {
                _context.next = 49;
                break;
              }
              _context.next = 49;
              return b.BookingDays[dayId].BookingDayServices[sId].setValue({
                fieldName: 'CostPer',
                value: 'SERVICE'
              });
            case 49:
              if (!(!s.costPer && s.Quote.QuoteList[baseId].ADT.Quantity > 1 && quoteBy != 'PERSON')) {
                _context.next = 52;
                break;
              }
              _context.next = 52;
              return b.BookingDays[dayId].BookingDayServices[sId].setValue({
                fieldName: 'CostPer',
                value: 'PERSON'
              });
            case 52:
              modified = s.Quote.QuoteList[baseId].ADT.Modified || s.Quote.QuoteList[baseId].ADT.PersonCostModified;
              if (!modified) {
                _context.next = 62;
                break;
              }
              value = s.Quote.QuoteList[baseId].ADT.Cost;
              if (!(this.booking.QuoteBy == 'PERSON' && b.QuoteBy == 'SERVICE')) {
                _context.next = 60;
                break;
              }
              _context.next = 58;
              return rowQuote.setValue({
                fieldName: 'PersonCost',
                value: value
              });
            case 58:
              _context.next = 62;
              break;
            case 60:
              _context.next = 62;
              return rowQuote.setValue({
                fieldName: 'Cost',
                value: value
              });
            case 62:
              if (!(!s.Quote.QuoteList[baseId].ADT.Cost && s.Quote.QuoteList[baseId].ADT.Price)) {
                _context.next = 66;
                break;
              }
              _value = s.Quote.QuoteList[baseId].ADT.Price;
              _context.next = 66;
              return rowQuote.setValue({
                fieldName: 'Price',
                value: _value
              });
            case 66:
              if (!(!rowQuote.Quantity && s.Quote.QuoteList[baseId].ADT.Quantity)) {
                _context.next = 69;
                break;
              }
              _context.next = 69;
              return rowQuote.setValue({
                fieldName: 'Quantity',
                value: s.Quote.QuoteList[baseId].ADT.Quantity
              });
            case 69:
              if (!s.Quote.QuoteList[baseId].ADT.MarkupModified) {
                _context.next = 72;
                break;
              }
              _context.next = 72;
              return rowQuote.setValue({
                fieldName: 'Markup',
                value: s.Quote.QuoteList[baseId].ADT.Markup
              });
            case 72:
              if (!s.Quote.QuoteList[baseId].ADT.PriceModified) {
                _context.next = 75;
                break;
              }
              _context.next = 75;
              return rowQuote.setValue({
                fieldName: 'Price',
                value: s.Quote.QuoteList[baseId].ADT.Price
              });
            case 75:
              if (!(rowQuote.Markup != s.Quote.QuoteList[baseId].ADT.Markup)) {
                _context.next = 78;
                break;
              }
              _context.next = 78;
              return rowQuote.setValue({
                fieldName: 'Markup',
                value: s.Quote.QuoteList[baseId].ADT.Markup
              });
            case 78:
              if (rowQuote.Price != s.Quote.QuoteList[baseId].ADT.Price && this.booking.QuoteBy == 'QUANTITY') {
                //console.log(103, dayId, s.Name, rowQuote.Cost, rowQuote.Price, rowQuote.PersonPrice, rowQuote.Markup, s.Quote.QuoteList[baseId].ADT.Price)
              }
              if (rowQuote.PersonPrice != s.Quote.QuoteList[baseId].ADT.Price && this.booking.QuoteBy == 'PERSON' && quoteBy == 'SERVICE') {
                //console.log(dayId, sId, rowQuote.PersonPrice, s.Quote.QuoteList[baseId].ADT.Price, rowQuote.CostBy, rowQuote.costPer)
              }
              if (this.booking.QuoteBy == 'PERSON' && quoteBy == 'PERSON' && rowQuote.Price != s.Quote.QuoteList[baseId].ADT.Price) {
                //console.log(102, dayId, rowQuote.Price, s.Quote.QuoteList[baseId].ADT.Price)
              }
              if (this.booking.QuoteBy == 'PERSON' && quoteBy == 'PERSON') {
                //console.log(103, dayId, sId, rowQuote.Price, s.Quote.QuoteList[baseId].ADT.Price)
              }
              _context.next = 28;
              break;
            case 84:
              _iterator = _createForOfIteratorHelper(d.BookingDayHotels);
              _context.prev = 85;
              _iterator.s();
            case 87:
              if ((_step = _iterator.n()).done) {
                _context.next = 126;
                break;
              }
              hotel = _step.value;
              _context.t4 = _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().keys(hotel.BookingDayRooms);
            case 90:
              if ((_context.t5 = _context.t4()).done) {
                _context.next = 124;
                break;
              }
              roomId = _context.t5.value;
              room = hotel.BookingDayRooms[roomId];
              if (room.QuoteList) {
                _context.next = 95;
                break;
              }
              return _context.abrupt("continue", 90);
            case 95:
              if (room.QuoteList[baseId]) {
                _context.next = 97;
                break;
              }
              return _context.abrupt("continue", 90);
            case 97:
              _rowQuote = b.BookingDays[dayId].BookingDayHotels[baseId].BookingDayRooms[roomId].QuoteList[baseId];
              if (room.QuoteList[baseId].Include) {
                _context.next = 101;
                break;
              }
              _context.next = 101;
              return _rowQuote.setValue({
                fieldName: 'Include',
                value: false
              });
            case 101:
              if (!room.QuoteList[baseId].Modified) {
                _context.next = 109;
                break;
              }
              if (!(this.booking.QuoteBy == 'PERSON' && b.QuoteBy == 'SERVICE')) {
                _context.next = 107;
                break;
              }
              _context.next = 105;
              return _rowQuote.setValue({
                fieldName: 'Cost',
                value: room.QuoteList[baseId].RoomCost
              });
            case 105:
              _context.next = 109;
              break;
            case 107:
              _context.next = 109;
              return _rowQuote.setValue({
                fieldName: 'Cost',
                value: room.QuoteList[baseId].Cost
              });
            case 109:
              if (!room.QuoteList[baseId].MarkupModified) {
                _context.next = 112;
                break;
              }
              _context.next = 112;
              return _rowQuote.setValue({
                fieldName: 'Markup',
                value: room.QuoteList[baseId].Markup
              });
            case 112:
              if (!room.QuoteList[baseId].PriceModified) {
                _context.next = 115;
                break;
              }
              _context.next = 115;
              return _rowQuote.setValue({
                fieldName: 'Price',
                value: room.QuoteList[baseId].Price
              });
            case 115:
              if (!(room.QuoteList[baseId].UnitCostBy && _rowQuote.UnitCostBy != room.QuoteList[baseId].UnitCostBy)) {
                _context.next = 118;
                break;
              }
              _context.next = 118;
              return _rowQuote.setValue({
                fieldName: 'UnitCostBy',
                value: room.QuoteList[baseId].UnitCostBy
              });
            case 118:
              if (!(room.QuoteList[baseId].PeriodCostBy && _rowQuote.PeriodCostBy != room.QuoteList[baseId].PeriodCostBy)) {
                _context.next = 121;
                break;
              }
              _context.next = 121;
              return _rowQuote.setValue({
                fieldName: 'PeriodCostBy',
                value: room.QuoteList[baseId].PeriodCostBy
              });
            case 121:
              if (Math.round(_rowQuote.RoomPersonPrice, 2) != Math.round(room.QuoteList[baseId].Price, 2) && this.booking.QuoteBy == 'PERSON' && b.QuoteBy == 'SERVICE') {
                console.log(dayId, _rowQuote.Cost, _rowQuote.RoomPersonPrice, room.QuoteList[baseId].Price, _rowQuote.PeriodCostBy, _rowQuote.UnitCostBy);
              } else if (Math.round(_rowQuote.Price, 2) != Math.round(room.QuoteList[baseId].Price, 2)) {}
              _context.next = 90;
              break;
            case 124:
              _context.next = 87;
              break;
            case 126:
              _context.next = 131;
              break;
            case 128:
              _context.prev = 128;
              _context.t6 = _context["catch"](85);
              _iterator.e(_context.t6);
            case 131:
              _context.prev = 131;
              _iterator.f();
              return _context.finish(131);
            case 134:
              _context.next = 24;
              break;
            case 136:
              setTimeout(function () {
                if (_this.booking.finalTotalWithFlights == b.finalTotalWithFlights) {
                  console.log('TEST Price OK', _this.booking.id, quoteBy);
                } else {
                  console.log('finalTotalWithFlights', _this.booking.finalTotalWithFlights, b.finalTotalWithFlights);
                  if (_this.booking.QuoteBy == 'PERSON' && b.QuoteBy == 'SERVICE') {
                    //console.log('Total', this.booking.totals[baseId].ADT.Price, b.totals)
                    console.log('Hotel', _this.booking.totalsHotels[baseId].ADT.Price, b.totalsHotels[baseId].ADT.PersonPrice);
                    console.log('Servicios', _this.booking.totalsServices[baseId].ADT.Price, b.totalsServices[baseId].ADT.PersonPrice);
                  } else {
                    console.log('Total', _this.booking.totals[baseId].ADT.Price, b.totals);
                    console.log('Hotel', _this.booking.totalsHotels[baseId].ADT.Price, b.totalsHotels[baseId].ADT.Price);
                    console.log('Servicios', _this.booking.totalsServices[baseId].ADT.Price, b.totalsServices[baseId].ADT.Price);
                  }
                }
                window._booking = b;
                _this.running = false;
              }, 1000 * 3);

              //}, 1000 * 5)
            case 137:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[85, 128, 131, 134]]);
      }));
      function testCopyAndSetValues(_x) {
        return _testCopyAndSetValues.apply(this, arguments);
      }
      return testCopyAndSetValues;
    }()
  }]);
}();
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingTest);

/***/ }),

/***/ 87489:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var map = {
	"./booking-679.txt": 68674,
	"./city-3.txt": 71059
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87489;

/***/ }),

/***/ 87560:
/***/ ((module) => {

"use strict";


module.exports = function defFunc (ajv) {
  var transform = {
    trimLeft: function (value) {
      return value.replace(/^[\s]+/, '');
    },
    trimRight: function (value) {
      return value.replace(/[\s]+$/, '');
    },
    trim: function (value) {
      return value.trim();
    },
    toLowerCase: function (value) {
      return value.toLowerCase();
    },
    toUpperCase: function (value) {
      return value.toUpperCase();
    },
    toEnumCase: function (value, cfg) {
      return cfg.hash[makeHashTableKey(value)] || value;
    }
  };

  defFunc.definition = {
    type: 'string',
    errors: false,
    modifying: true,
    valid: true,
    compile: function (schema, parentSchema) {
      var cfg;

      if (schema.indexOf('toEnumCase') !== -1) {
        // build hash table to enum values
        cfg = {hash: {}};

        // requires `enum` in schema
        if (!parentSchema.enum)
          throw new Error('Missing enum. To use `transform:["toEnumCase"]`, `enum:[...]` is required.');
        for (var i = parentSchema.enum.length; i--; i) {
          var v = parentSchema.enum[i];
          if (typeof v !== 'string') continue;
          var k = makeHashTableKey(v);
          // requires all `enum` values have unique keys
          if (cfg.hash[k])
            throw new Error('Invalid enum uniqueness. To use `transform:["toEnumCase"]`, all values must be unique when case insensitive.');
          cfg.hash[k] = v;
        }
      }

      return function (data, dataPath, object, key) {
        // skip if value only
        if (!object) return;

        // apply transform in order provided
        for (var j = 0, l = schema.length; j < l; j++)
          data = transform[schema[j]](data, cfg);

        object[key] = data;
      };
    },
    metaSchema: {
      type: 'array',
      items: {
        type: 'string',
        enum: [
          'trimLeft', 'trimRight', 'trim',
          'toLowerCase', 'toUpperCase', 'toEnumCase'
        ]
      }
    }
  };

  ajv.addKeyword('transform', defFunc.definition);
  return ajv;

  function makeHashTableKey (value) {
    return value.toLowerCase();
  }
};


/***/ }),

/***/ 87568:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var asn1 = exports;

asn1.bignum = __webpack_require__(72344);

asn1.define = (__webpack_require__(47363).define);
asn1.base = __webpack_require__(9673);
asn1.constants = __webpack_require__(22153);
asn1.decoders = __webpack_require__(22853);
asn1.encoders = __webpack_require__(24669);


/***/ }),

/***/ 87581:
/***/ (() => {

//import '@/extra/custom/test/booking-test';

/***/ }),

/***/ 87626:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),

/***/ 87718:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var util = __webpack_require__(23949);

module.exports = function defFunc(ajv) {
  if (!ajv._opts.$data) {
    console.warn('keyword select requires $data option');
    return ajv;
  }
  var metaSchemaRef = util.metaSchemaRef(ajv);
  var compiledCaseSchemas = [];

  defFunc.definition = {
    validate: function v(schema, data, parentSchema) {
      if (parentSchema.selectCases === undefined)
        throw new Error('keyword "selectCases" is absent');
      var compiled = getCompiledSchemas(parentSchema, false);
      var validate = compiled.cases[schema];
      if (validate === undefined) validate = compiled.default;
      if (typeof validate == 'boolean') return validate;
      var valid = validate(data);
      if (!valid) v.errors = validate.errors;
      return valid;
    },
    $data: true,
    metaSchema: { type: ['string', 'number', 'boolean', 'null'] }
  };

  ajv.addKeyword('select', defFunc.definition);
  ajv.addKeyword('selectCases', {
    compile: function (schemas, parentSchema) {
      var compiled = getCompiledSchemas(parentSchema);
      for (var value in schemas)
        compiled.cases[value] = compileOrBoolean(schemas[value]);
      return function() { return true; };
    },
    valid: true,
    metaSchema: {
      type: 'object',
      additionalProperties: metaSchemaRef
    }
  });
  ajv.addKeyword('selectDefault', {
    compile: function (schema, parentSchema) {
      var compiled = getCompiledSchemas(parentSchema);
      compiled.default = compileOrBoolean(schema);
      return function() { return true; };
    },
    valid: true,
    metaSchema: metaSchemaRef
  });
  return ajv;


  function getCompiledSchemas(parentSchema, create) {
    var compiled;
    compiledCaseSchemas.some(function (c) {
      if (c.parentSchema === parentSchema) {
        compiled = c;
        return true;
      }
    });
    if (!compiled && create !== false) {
      compiled = {
        parentSchema: parentSchema,
        cases: {},
        default: true
      };
      compiledCaseSchemas.push(compiled);
    }
    return compiled;
  }

  function compileOrBoolean(schema) {
    return typeof schema == 'boolean'
            ? schema
            : ajv.compile(schema);
  }
};


/***/ }),

/***/ 87938:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64467);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8818);






function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var isTemplate = false;
var BookingFlightView = /*#__PURE__*/function (_View) {
  function BookingFlightView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, BookingFlightView);
    return _callSuper(this, BookingFlightView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(BookingFlightView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingFlightView, null, [{
    key: "flightStatusOptions",
    get: function get() {
      var res = [];
      for (var s in this.flightStatus) {
        res.push({
          value: s,
          label: this.flightStatus[s]
        });
      }
      return res;
    }
  }, {
    key: "getTableOptions",
    value: function getTableOptions() {
      return {
        fields: [{
          name: 'Input',
          label: 'Input',
          editor: 'text-area'
        }, {
          name: 'Output',
          label: 'Output',
          editor: 'text-area'
        }, {
          name: 'FlightType',
          label: 'Flight Type',
          editor: 'select',
          required: true,
          options: [{
            value: 'LOCAL',
            label: 'Domestic'
          }, {
            value: 'INTERNATIONAL',
            label: 'International'
          }]
        }, {
          name: 'PricePer',
          label: 'Price per',
          editor: 'select',
          options: [{
            value: 'PERSON',
            label: 'Person'
          }, {
            value: 'GROUP',
            label: 'Group'
          }]
        }, {
          name: 'QuoteType',
          label: 'Quote',
          editor: 'select',
          required: true,
          options: [{
            value: 'INCLUDED',
            label: 'Included'
          }, {
            value: 'NOT_INCLUDED',
            label: 'Not Included'
          }]
        }, {
          name: 'Status',
          editor: 'select',
          options: this.flightStatusOptions
        }, {
          name: 'CurrencyId',
          relation: 'currency',
          optionLabels: 'id',
          required: true,
          editor: 'select',
          label: 'Currency',
          hidden: true
        }, {
          name: 'SupplierId',
          relation: 'supplier',
          optionLabels: 'Name',
          setRelationTo: 'Supplier',
          filters: function filters(r) {
            return r.SupplierType == 'FLIGHTS' || r.SupplierType == 'ALL';
          },
          editor: 'select',
          label: 'Supplier',
          requiredCallback: function requiredCallback(record, row) {
            if (record.Status == 'CONFIRMED') return true;
          }
        }, {
          name: 'QuoteList',
          editor: {},
          objectClass: 'bookingflightquotelist'
        }, {
          name: 'FlightCost',
          label: 'Cost',
          editor: 'number',
          required: true
        }, {
          name: 'Markup',
          label: 'Markup',
          editor: 'number'
        }, {
          name: 'MarkupModified',
          defValue: false
        }, {
          name: 'FlightPrice',
          label: 'Price',
          editor: 'number',
          required: true
        }, {
          name: 'Comment',
          label: 'Comment'
        }, {
          name: 'ReservationNumber'
        }, {
          name: 'IssueDate',
          label: 'Issue Date',
          editor: 'date',
          requiredCallback: function requiredCallback(record, row) {
            if (record.Status == 'CONFIRMED') return true;
          }
        }, {
          name: 'PaxType',
          label: 'Pax Type',
          editor: 'select',
          notSort: true,
          required: true,
          options: [{
            value: 'ADT',
            label: 'ADT'
          }, {
            value: 'CHD',
            label: 'CHD'
          }]
        }]
      };
    }
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingFlightView, "flightStatus", {
  PENDING: 'Pending',
  REQUESTED: 'Requested',
  CONFIRMED: 'Confirmed',
  CANCELED: 'Canceled'
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingFlightView);

/***/ }),

/***/ 87942:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const path = __webpack_require__(57975);

const matchRelativePath = /^\.\.?[/\\]/;

function isAbsolutePath(str) {
  return path.posix.isAbsolute(str) || path.win32.isAbsolute(str);
}

function isRelativePath(str) {
  return matchRelativePath.test(str);
}

function stringifyRequest(loaderContext, request) {
  const splitted = request.split('!');
  const context =
    loaderContext.context ||
    (loaderContext.options && loaderContext.options.context);

  return JSON.stringify(
    splitted
      .map((part) => {
        // First, separate singlePath from query, because the query might contain paths again
        const splittedPart = part.match(/^(.*?)(\?.*)/);
        const query = splittedPart ? splittedPart[2] : '';
        let singlePath = splittedPart ? splittedPart[1] : part;

        if (isAbsolutePath(singlePath) && context) {
          singlePath = path.relative(context, singlePath);

          if (isAbsolutePath(singlePath)) {
            // If singlePath still matches an absolute path, singlePath was on a different drive than context.
            // In this case, we leave the path platform-specific without replacing any separators.
            // @see https://github.com/webpack/loader-utils/pull/14
            return singlePath + query;
          }

          if (isRelativePath(singlePath) === false) {
            // Ensure that the relative path starts at least with ./ otherwise it would be a request into the modules directory (like node_modules).
            singlePath = './' + singlePath;
          }
        }

        return singlePath.replace(/\\/g, '/') + query;
      })
      .join('!')
  );
}

module.exports = stringifyRequest;


/***/ }),

/***/ 88098:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_record__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55539);









function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var Supplier = /*#__PURE__*/function (_Record) {
  function Supplier() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, Supplier);
    return _callSuper(this, Supplier, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(Supplier, _Record);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(Supplier, [{
    key: "save",
    value: function () {
      var _save = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(Supplier, "save", this, 3)([]);
            case 2:
              res = _context.sent;
              if (res) {
                this.ServiceCost = null;
              }
              return _context.abrupt("return", res);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function save() {
        return _save.apply(this, arguments);
      }
      return save;
    }()
  }]);
}(_base_model_record__WEBPACK_IMPORTED_MODULE_4__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(Supplier, "moduleName", 'supplier');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Supplier);

/***/ }),

/***/ 88101:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(65606);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
};
/*</replacement>*/

module.exports = Duplex;
var Readable = __webpack_require__(46891);
var Writable = __webpack_require__(81999);
__webpack_require__(56698)(Duplex, Readable);
{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;
  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;
    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

// the no-half-open enforcer
function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(onEndNT, this);
}
function onEndNT(self) {
  self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

/***/ }),

/***/ 88276:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var inherits = __webpack_require__(56698)
var HashBase = __webpack_require__(4729)
var Buffer = (__webpack_require__(92861).Buffer)

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5


/***/ }),

/***/ 88310:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = (__webpack_require__(37007).EventEmitter);
var inherits = __webpack_require__(56698);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(46891);
Stream.Writable = __webpack_require__(81999);
Stream.Duplex = __webpack_require__(88101);
Stream.Transform = __webpack_require__(59083);
Stream.PassThrough = __webpack_require__(3681);
Stream.finished = __webpack_require__(14257)
Stream.pipeline = __webpack_require__(5267)

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),

/***/ 88383:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                  ? ' '
                                  : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                  ? ' '
                                  : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),

/***/ 88532:
/***/ ((module) => {

"use strict";

module.exports = function generate_if(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $thenSch = it.schema['then'],
    $elseSch = it.schema['else'],
    $thenPresent = $thenSch !== undefined && (it.opts.strictKeywords ? (typeof $thenSch == 'object' && Object.keys($thenSch).length > 0) || $thenSch === false : it.util.schemaHasRules($thenSch, it.RULES.all)),
    $elsePresent = $elseSch !== undefined && (it.opts.strictKeywords ? (typeof $elseSch == 'object' && Object.keys($elseSch).length > 0) || $elseSch === false : it.util.schemaHasRules($elseSch, it.RULES.all)),
    $currentBaseId = $it.baseId;
  if ($thenPresent || $elsePresent) {
    var $ifClause;
    $it.createErrors = false;
    $it.schema = $schema;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    out += ' var ' + ($errs) + ' = errors; var ' + ($valid) + ' = true;  ';
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    out += '  ' + (it.validate($it)) + ' ';
    $it.baseId = $currentBaseId;
    $it.createErrors = true;
    out += '  errors = ' + ($errs) + '; if (vErrors !== null) { if (' + ($errs) + ') vErrors.length = ' + ($errs) + '; else vErrors = null; }  ';
    it.compositeRule = $it.compositeRule = $wasComposite;
    if ($thenPresent) {
      out += ' if (' + ($nextValid) + ') {  ';
      $it.schema = it.schema['then'];
      $it.schemaPath = it.schemaPath + '.then';
      $it.errSchemaPath = it.errSchemaPath + '/then';
      out += '  ' + (it.validate($it)) + ' ';
      $it.baseId = $currentBaseId;
      out += ' ' + ($valid) + ' = ' + ($nextValid) + '; ';
      if ($thenPresent && $elsePresent) {
        $ifClause = 'ifClause' + $lvl;
        out += ' var ' + ($ifClause) + ' = \'then\'; ';
      } else {
        $ifClause = '\'then\'';
      }
      out += ' } ';
      if ($elsePresent) {
        out += ' else { ';
      }
    } else {
      out += ' if (!' + ($nextValid) + ') { ';
    }
    if ($elsePresent) {
      $it.schema = it.schema['else'];
      $it.schemaPath = it.schemaPath + '.else';
      $it.errSchemaPath = it.errSchemaPath + '/else';
      out += '  ' + (it.validate($it)) + ' ';
      $it.baseId = $currentBaseId;
      out += ' ' + ($valid) + ' = ' + ($nextValid) + '; ';
      if ($thenPresent && $elsePresent) {
        $ifClause = 'ifClause' + $lvl;
        out += ' var ' + ($ifClause) + ' = \'else\'; ';
      } else {
        $ifClause = '\'else\'';
      }
      out += ' } ';
    }
    out += ' if (!' + ($valid) + ') {   var err =   '; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('if') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { failingKeyword: ' + ($ifClause) + ' } ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should match "\' + ' + ($ifClause) + ' + \'" schema\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError(vErrors); ';
      } else {
        out += ' validate.errors = vErrors; return false; ';
      }
    }
    out += ' }   ';
    if ($breakOnError) {
      out += ' else { ';
    }
  } else {
    if ($breakOnError) {
      out += ' if (true) { ';
    }
  }
  return out;
}


/***/ }),

/***/ 88829:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51941);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26028);








function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

//const uuidv1 = require('uuid/v1');

//var assert = require('assert');
var BookingDay = /*#__PURE__*/function (_BookingBaseModel) {
  function BookingDay() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingDay);
    return _callSuper(this, BookingDay, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingDay, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingDay, [{
    key: "booking",
    get: function get() {
      return this.$parent;
    }
  }, {
    key: "updateHotel",
    value: function () {
      var _updateHotel = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var _iterator, _step, room, h, res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.BookingDayHotels[0]) {
                _context.next = 22;
                break;
              }
              _iterator = _createForOfIteratorHelper(this.BookingDayHotels[0].BookingDayRooms);
              _context.prev = 2;
              _iterator.s();
            case 4:
              if ((_step = _iterator.n()).done) {
                _context.next = 14;
                break;
              }
              room = _step.value;
              h = room.Hotel;
              if (!(h && h.id)) {
                _context.next = 12;
                break;
              }
              _context.next = 10;
              return api.get('/api/hotel/' + h.id);
            case 10:
              res = _context.sent;
              if (res) {
                room.Hotel = res;
              }
            case 12:
              _context.next = 4;
              break;
            case 14:
              _context.next = 19;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              _iterator.e(_context.t0);
            case 19:
              _context.prev = 19;
              _iterator.f();
              return _context.finish(19);
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 16, 19, 22]]);
      }));
      function updateHotel() {
        return _updateHotel.apply(this, arguments);
      }
      return updateHotel;
    }()
  }, {
    key: "getCitiesNames",
    value: function getCitiesNames(hotel) {
      var cities = this.getCities(hotel);
      var res = [];
      var _iterator2 = _createForOfIteratorHelper(cities),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var city = _step2.value;
          if (city.Name) {
            res.push(city.Name);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (res.length > 0) {
        return res.join(' - ');
      }
      if (this.CityId && this.City && this.City.Name) {
        return this.City.Name;
      }
      return "";
    }
  }, {
    key: "showByViewMode",
    value: function showByViewMode(viewMode) {
      if (viewMode == -1) return true;
      var found = false;
      if (!this.BookingDayHotels[0]) return;
      var _iterator3 = _createForOfIteratorHelper(this.BookingDayHotels[0].BookingDayRooms),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var room = _step3.value;
          if (room.QuoteList[viewMode] && room.QuoteList[viewMode].Include) {
            found = true;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return found;
    }
  }, {
    key: "getCities",
    value: function getCities(hotel) {
      var cities = [];
      var viewMode = this.$parent.ViewMode;
      var _iterator4 = _createForOfIteratorHelper(this.BookingDayServices),
        _step4;
      try {
        var _loop2 = function _loop2() {
            var service = _step4.value;
            if (!service) return 0; // continue
            if (service.serviceSelected && !service.serviceSelected(viewMode)) return 0; // continue
            if (!service.City || !service.City.id) return 0; // continue
            var found = _.find(cities, function (c) {
              return service.City && c.id == service.City.id;
            });
            if (!found && service.City) cities.push(service.City);
          },
          _ret;
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          _ret = _loop2();
          if (_ret === 0) continue;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      if (hotel) {
        var _iterator5 = _createForOfIteratorHelper(hotel.BookingDayRooms),
          _step5;
        try {
          var _loop = function _loop() {
            var room = _step5.value;
            var found = false;
            if (viewMode == -1) {
              found = true;
            } else {
              if (room.QuoteList[viewMode] && room.QuoteList[viewMode].Include) {
                found = true;
              }
            }
            if (!found) return 1; // continue
            if (room.Hotel && room.Hotel.City) {
              var _found = _.find(cities, function (c) {
                return c.id == room.Hotel.City.id;
              });
              if (!_found) cities.push(room.Hotel.City);
            }
          };
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            if (_loop()) continue;
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
      return cities;
    }
  }, {
    key: "sortServices",
    value: function sortServices() {
      this.BookingDayServices.sort(function (a, b) {
        return a.OrderNr - b.OrderNr;
      });
    }
  }, {
    key: "setTitle",
    value: function setTitle(setBlank, force, removed) {}
  }, {
    key: "removeRequiredServices",
    value: function removeRequiredServices(i, move) {
      var _this = this;
      if (!this.BookingDayServices[i]) return;
      var s = this.BookingDayServices[i].Service;
      var requiredsDayServices = [];
      if (s && s.RequiredServices) {
        var _iterator6 = _createForOfIteratorHelper(s.RequiredServices),
          _step6;
        try {
          var _loop3 = function _loop3() {
            var rs = _step6.value;
            var found = _.find(_this.BookingDayServices, function (r) {
              return r.ServiceId == rs.RequiredServiceId;
            });
            if (found) requiredsDayServices.push(found);
          };
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            _loop3();
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
      for (var j = requiredsDayServices.length - 1; j >= 0; j--) {
        var idx = this.BookingDayServices.indexOf(requiredsDayServices[j]);
        if (idx !== -1) {
          this.removeService(idx, move);
        }
      }
    }
  }, {
    key: "removeService",
    value: function removeService(i, move) {
      var _this2 = this;
      if (!this.BookingDayServices[i]) return;
      var s = this.BookingDayServices[i].Service;
      var title;
      if (s) {
        var d = _.find(s.ServiceDescriptions, function (r) {
          return r.LanguageId == _this2.$parent.LanguageId;
        });
        if (d && d.Title) title = d.Title;
        this.setBookingDayOptionsFalse(s);
      }
      this.removeRow({
        fieldName: 'BookingDayServices',
        rowNr: i
      });
      this.setServicesOrderNr();
      this.setTitle(false, false, title);
      this.$parent.setBookingTotals();
    }
  }, {
    key: "setServicesOrderNr",
    value: function setServicesOrderNr() {
      for (var i = 0; i < this.BookingDayServices.length; i++) {
        this.BookingDayServices[i].setOrderNr(i);
      }
    }
  }, {
    key: "newServiceRow",
    value: function () {
      var _newServiceRow = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
        var row;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.newRowByName('BookingDayServices');
            case 2:
              row = _context2.sent;
              if (row) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              row.ServiceDate = this.TransDate;
              if (this.$parent.SplitQuoteDate && this.$parent.QuoteDate) {
                row.QuoteDate = this.QuoteDate;
              }
              row.tempId = (0,uuid__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)();
              return _context2.abrupt("return", row);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function newServiceRow() {
        return _newServiceRow.apply(this, arguments);
      }
      return newServiceRow;
    }()
  }, {
    key: "lunch",
    get: function get() {
      var _iterator7 = _createForOfIteratorHelper(this.BookingDayServices),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var s = _step7.value;
          if (s.Optional) continue;
          if (s.Lunch) {
            return true;
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      var hotel = this.$parent.hotelsByDay[this.DayNr];
      if (hotel) {
        var _hotel$BookingDayRoom;
        if (hotel !== null && hotel !== void 0 && (_hotel$BookingDayRoom = hotel.BookingDayRooms[0]) !== null && _hotel$BookingDayRoom !== void 0 && (_hotel$BookingDayRoom = _hotel$BookingDayRoom.Hotel) !== null && _hotel$BookingDayRoom !== void 0 && _hotel$BookingDayRoom.MealsByCategory) {
          var _iterator8 = _createForOfIteratorHelper(hotel.BookingDayRooms),
            _step8;
          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var room = _step8.value;
              return room.Category.Lunch;
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
        } else {
          var _iterator9 = _createForOfIteratorHelper(hotel.BookingDayRooms),
            _step9;
          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var _room = _step9.value;
              if (_room.Hotel && _room.Hotel.Lunch) return true;
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }
        }
      }
    }
  }, {
    key: "_lunch",
    get: function get() {
      return this.lunch || this.Lunch;
    }
  }, {
    key: "boxLunch",
    get: function get() {
      var _iterator10 = _createForOfIteratorHelper(this.BookingDayServices),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var s = _step10.value;
          if (s.Optional) continue;
          if (s.BoxLunch) {
            return true;
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      var hotel = this.$parent.hotelsByDay[this.DayNr];
      if (hotel) {
        var _hotel$BookingDayRoom2;
        if (hotel !== null && hotel !== void 0 && (_hotel$BookingDayRoom2 = hotel.BookingDayRooms[0]) !== null && _hotel$BookingDayRoom2 !== void 0 && (_hotel$BookingDayRoom2 = _hotel$BookingDayRoom2.Hotel) !== null && _hotel$BookingDayRoom2 !== void 0 && _hotel$BookingDayRoom2.MealsByCategory) {
          var _iterator11 = _createForOfIteratorHelper(hotel.BookingDayRooms),
            _step11;
          try {
            for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
              var room = _step11.value;
              return room.Category.BoxLunch;
            }
          } catch (err) {
            _iterator11.e(err);
          } finally {
            _iterator11.f();
          }
        } else {
          var _iterator12 = _createForOfIteratorHelper(hotel.BookingDayRooms),
            _step12;
          try {
            for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
              var _room2 = _step12.value;
              if (_room2.Hotel && _room2.Hotel.BoxLunch) return true;
            }
          } catch (err) {
            _iterator12.e(err);
          } finally {
            _iterator12.f();
          }
        }
      }
    }
  }, {
    key: "_boxLunch",
    get: function get() {
      return this.boxLunch || this.BoxLunch;
    }
  }, {
    key: "dinner",
    get: function get() {
      var _iterator13 = _createForOfIteratorHelper(this.BookingDayServices),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var s = _step13.value;
          if (s.Optional) continue;
          if (s.Dinner) return true;
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
      var hotel = this.$parent.hotelsByDay[this.DayNr];
      if (hotel) {
        var _hotel$BookingDayRoom3;
        if (hotel !== null && hotel !== void 0 && (_hotel$BookingDayRoom3 = hotel.BookingDayRooms[0]) !== null && _hotel$BookingDayRoom3 !== void 0 && (_hotel$BookingDayRoom3 = _hotel$BookingDayRoom3.Hotel) !== null && _hotel$BookingDayRoom3 !== void 0 && _hotel$BookingDayRoom3.MealsByCategory) {
          var _iterator14 = _createForOfIteratorHelper(hotel.BookingDayRooms),
            _step14;
          try {
            for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
              var room = _step14.value;
              return room.Category.Dinner;
            }
          } catch (err) {
            _iterator14.e(err);
          } finally {
            _iterator14.f();
          }
        } else {
          var _iterator15 = _createForOfIteratorHelper(hotel.BookingDayRooms),
            _step15;
          try {
            for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
              var _room3 = _step15.value;
              if (_room3.Hotel && _room3.Hotel.Dinner) return true;
            }
          } catch (err) {
            _iterator15.e(err);
          } finally {
            _iterator15.f();
          }
        }
      }
    }
  }, {
    key: "_dinner",
    get: function get() {
      return this.dinner || this.Dinner;
    }
  }, {
    key: "snack",
    get: function get() {
      var _iterator16 = _createForOfIteratorHelper(this.BookingDayServices),
        _step16;
      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var s = _step16.value;
          if (s.Optional) continue;
          if (s.Snack) {
            return true;
          }
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }
      var hotel = this.$parent.hotelsByDay[this.DayNr];
      if (hotel) {
        var _hotel$BookingDayRoom4;
        if (hotel !== null && hotel !== void 0 && (_hotel$BookingDayRoom4 = hotel.BookingDayRooms[0]) !== null && _hotel$BookingDayRoom4 !== void 0 && (_hotel$BookingDayRoom4 = _hotel$BookingDayRoom4.Hotel) !== null && _hotel$BookingDayRoom4 !== void 0 && _hotel$BookingDayRoom4.MealsByCategory) {
          var _iterator17 = _createForOfIteratorHelper(hotel.BookingDayRooms),
            _step17;
          try {
            for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
              var room = _step17.value;
              return room.Category.Snack;
            }
          } catch (err) {
            _iterator17.e(err);
          } finally {
            _iterator17.f();
          }
        } else {
          var _iterator18 = _createForOfIteratorHelper(hotel.BookingDayRooms),
            _step18;
          try {
            for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
              var _room4 = _step18.value;
              if (_room4.Hotel && _room4.Hotel.Snack) return true;
            }
          } catch (err) {
            _iterator18.e(err);
          } finally {
            _iterator18.f();
          }
        }
      }
    }
  }, {
    key: "_snack",
    get: function get() {
      return this.snack || this.Snack;
    }
  }, {
    key: "breakfast",
    get: function get() {
      var _iterator19 = _createForOfIteratorHelper(this.BookingDayServices),
        _step19;
      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var s = _step19.value;
          if (s.Optional) continue;
          if (s.Breakfast) {
            return true;
          }
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
      if (this.prevDayHotel) return true;
      var hotel = this.$parent.hotelsByDay[this.DayNr];
      if (hotel) {
        var _hotel$BookingDayRoom5;
        if (hotel !== null && hotel !== void 0 && (_hotel$BookingDayRoom5 = hotel.BookingDayRooms[0]) !== null && _hotel$BookingDayRoom5 !== void 0 && (_hotel$BookingDayRoom5 = _hotel$BookingDayRoom5.Hotel) !== null && _hotel$BookingDayRoom5 !== void 0 && _hotel$BookingDayRoom5.MealsByCategory) {
          var _iterator20 = _createForOfIteratorHelper(hotel.BookingDayRooms),
            _step20;
          try {
            for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
              var room = _step20.value;
              return room.Category.Breakfast;
            }
          } catch (err) {
            _iterator20.e(err);
          } finally {
            _iterator20.f();
          }
        }
      }
    }
  }, {
    key: "_breakfast",
    get: function get() {
      return this.breakfast || this.Breakfast;
    }
  }, {
    key: "entranceIncluded",
    get: function get() {
      var _iterator21 = _createForOfIteratorHelper(this.BookingDayServices),
        _step21;
      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var s = _step21.value;
          if (s.Optional) continue;
          if (s.EntranceIncluded) return true;
          if (s.Service && s.Service.EntranceIncluded) return true;
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
    }
  }, {
    key: "_entranceIncluded",
    get: function get() {
      return this.entranceIncluded || this.EntranceIncluded;
    }
  }, {
    key: "setServiceToDay",
    value: function () {
      var _setServiceToDay = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(_ref) {
        var _this3 = this;
        var record, include, description, cityId, isTemplate, templateLanguageId, changeService, currentService, index, desc, d, row, qDate;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              record = _ref.record, include = _ref.include, description = _ref.description, cityId = _ref.cityId, isTemplate = _ref.isTemplate, templateLanguageId = _ref.templateLanguageId, changeService = _ref.changeService, currentService = _ref.currentService, index = _ref.index;
              if (description && isTemplate && templateLanguageId == this.$parent.LanguageId) {
                desc = description;
              } else if (record) {
                d = _.find(record.ServiceDescriptions, function (r) {
                  return r.LanguageId == _this3.$parent.LanguageId;
                });
                if (d) {
                  desc = d.Description;
                }
              }
              if (!desc && description) {
                desc = description;
              }
              if (changeService) {
                _context3.next = 10;
                break;
              }
              _context3.next = 6;
              return this.newServiceRow();
            case 6:
              row = _context3.sent;
              if (row) {
                if (record && record.SupplierId) row.Status = 'PENDING';
                row.Quote.Include = include;
                if (index == undefined) {
                  row.setOrderNr(this.BookingDayServices.length);
                  this.BookingDayServices.push(row);
                } else {
                  this.BookingDayServices.splice(index, 0, row);
                  this.setServicesOrderNr();
                  this.sortServices();
                }
              }
              _context3.next = 13;
              break;
            case 10:
              row = this.BookingDayServices[currentService];
              row.Status = this.constructor.exchangeStatus;
              row.Name = record.Name;
            case 13:
              if (row) row.Description = desc;
              //if (record.EntranceIncluded) row.EntranceIncluded = true;
              if (!(record && row)) {
                _context3.next = 37;
                break;
              }
              _context3.next = 17;
              return row.setValue({
                fieldName: 'ServiceId',
                value: record.id
              });
            case 17:
              _context3.next = 19;
              return row.setValue({
                fieldName: 'ServiceCategoryId',
                value: record.ServiceCategoryId
              });
            case 19:
              if (record.EntranceIncluded) this.EntranceIncluded = true;
              if (record.Breakfast) row.Breakfast = true;
              if (record.BoxLunch) row.BoxLunch = true;
              if (record.VoucherDisabled) row.VoucherDisabled = true;
              if (record.Lunch) row.Lunch = true;
              if (record.Dinner) row.Dinner = true;
              if (record.Snack) row.Snack = true;
              if (this.ImageId) {
                _context3.next = 29;
                break;
              }
              _context3.next = 29;
              return this.setDayImage(record);
            case 29:
              if (!(record.Supplier && record.Supplier.id)) {
                _context3.next = 32;
                break;
              }
              _context3.next = 32;
              return row.setValue({
                fieldName: 'SupplierId',
                value: record.Supplier.id
              });
            case 32:
              if (!(record.City && record.City.id)) {
                _context3.next = 35;
                break;
              }
              _context3.next = 35;
              return row.setValue({
                fieldName: 'CityId',
                value: record.City.id
              });
            case 35:
              _context3.next = 37;
              return row.setImagesToService();
            case 37:
              if (!cityId) {
                _context3.next = 40;
                break;
              }
              _context3.next = 40;
              return this.setValue({
                fieldName: 'CityId',
                value: cityId
              });
            case 40:
              qDate = this.TransDate;
              if (this.$parent.SplitQuoteDate && this.$parent.QuoteDate) {
                qDate = this.QuoteDate;
              }
              if (!row) {
                _context3.next = 47;
                break;
              }
              _context3.next = 45;
              return this.$parent.getServicePersonCostRow({
                service: row
              });
            case 45:
              _context3.next = 47;
              return this.$parent.getServiceCost({
                service: row,
                exchange: changeService,
                quoteDate: qDate
              });
            case 47:
              if (isTemplate) {
                _context3.next = 50;
                break;
              }
              _context3.next = 50;
              return this.setRequiredService({
                record: record,
                include: include,
                isTemplate: isTemplate,
                templateLanguageId: templateLanguageId
              });
            case 50:
              return _context3.abrupt("return", row);
            case 51:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function setServiceToDay(_x) {
        return _setServiceToDay.apply(this, arguments);
      }
      return setServiceToDay;
    }()
    /*async setRequiredService ({record, include, isTemplate, templateLanguageId}) {
        if (record && record.RequiredService) {
            await this.setServiceToDay({
                record: record.RequiredService,
                include: include,
                isTemplate: isTemplate,
                templateLanguageId: templateLanguageId,
            });
        }
    }*/
  }, {
    key: "setDayImage",
    value: (function () {
      var _setDayImage = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(value) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function setDayImage(_x2) {
        return _setDayImage.apply(this, arguments);
      }
      return setDayImage;
    }())
  }, {
    key: "editHotel",
    value: function () {
      var _editHotel = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5() {
        var defaultRoomConfig, roomId, room, length, r, baseId;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.PaxHotel = 0;
              if (this.BookingDayHotels[0]) {
                _context5.next = 32;
                break;
              }
              _context5.next = 4;
              return this.addRow({
                fieldName: 'BookingDayHotels'
              });
            case 4:
              defaultRoomConfig = _.cloneDeep(this.$parent.RoomConfiguration);
              defaultRoomConfig = tools.plainObject(defaultRoomConfig);
              tools.clean(defaultRoomConfig);
              _context5.t0 = _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().keys(defaultRoomConfig);
            case 8:
              if ((_context5.t1 = _context5.t0()).done) {
                _context5.next = 31;
                break;
              }
              roomId = _context5.t1.value;
              room = defaultRoomConfig[roomId];
              _context5.next = 13;
              return this.BookingDayHotels[0].addRow({
                fieldName: 'BookingDayRooms',
                values: room
              });
            case 13:
              length = this.BookingDayHotels[0].BookingDayRooms.length;
              r = this.BookingDayHotels[0].BookingDayRooms[length - 1];
              r.tempId = (0,uuid__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)();
              _context5.t2 = _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().keys(this.$parent.BaseQuotes.bases);
            case 17:
              if ((_context5.t3 = _context5.t2()).done) {
                _context5.next = 28;
                break;
              }
              baseId = _context5.t3.value;
              if (r.QuoteList[baseId]) {
                _context5.next = 26;
                break;
              }
              _context5.next = 22;
              return r.QuoteList.newHotelQuote();
            case 22:
              r.QuoteList[baseId] = _context5.sent;
              r.QuoteList.getFields();
              r.QuoteList.setGroups();
              r.QuoteList.setVariants();
            case 26:
              _context5.next = 17;
              break;
            case 28:
              if (!room.RoomCategory) room.RoomCategory = null;
              _context5.next = 8;
              break;
            case 31:
              this.BookingDayHotels[0].setHotelDates();
            case 32:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function editHotel() {
        return _editHotel.apply(this, arguments);
      }
      return editHotel;
    }()
  }, {
    key: "removeServicePrograms",
    value: function () {
      var _removeServicePrograms = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6() {
        var _iterator22, _step22, room;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (this.BookingDayHotels[0]) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              _iterator22 = _createForOfIteratorHelper(this.BookingDayHotels[0].BookingDayRooms);
              _context6.prev = 3;
              _iterator22.s();
            case 5:
              if ((_step22 = _iterator22.n()).done) {
                _context6.next = 11;
                break;
              }
              room = _step22.value;
              _context6.next = 9;
              return room.removeProgramServices(room.RoomCategory, room.HotelId);
            case 9:
              _context6.next = 5;
              break;
            case 11:
              _context6.next = 16;
              break;
            case 13:
              _context6.prev = 13;
              _context6.t0 = _context6["catch"](3);
              _iterator22.e(_context6.t0);
            case 16:
              _context6.prev = 16;
              _iterator22.f();
              return _context6.finish(16);
            case 19:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[3, 13, 16, 19]]);
      }));
      function removeServicePrograms() {
        return _removeServicePrograms.apply(this, arguments);
      }
      return removeServicePrograms;
    }()
  }, {
    key: "deleteHotel",
    value: function () {
      var _deleteHotel = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7() {
        var res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.removeServicePrograms();
            case 2:
              res = this.removeRow({
                fieldName: 'BookingDayHotels',
                rowNr: 0
              });
              if (res) {
                _context7.next = 5;
                break;
              }
              return _context7.abrupt("return", false);
            case 5:
              //this.BookingDayHotels = [];
              this.$parent.setDaysByHotel();
              this.$parent.setBookingTotals();
              return _context7.abrupt("return", true);
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function deleteHotel() {
        return _deleteHotel.apply(this, arguments);
      }
      return deleteHotel;
    }()
  }, {
    key: "nextDay",
    get: function get() {
      var _this4 = this;
      return _.find(this.$parent.BookingDays, function (r) {
        return parseInt(r.DayNr) == parseInt(_this4.DayNr + 1);
      });
    }
  }, {
    key: "prevDayHotel",
    get: function get() {
      var hotel = this.$parent.hotelsByDay[this.DayNr - 1];
      if (hotel) {
        var _iterator23 = _createForOfIteratorHelper(hotel.BookingDayRooms),
          _step23;
        try {
          for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
            var room = _step23.value;
            if (room.Hotel && !room.Hotel.NoBreakfast) return true;
          }
        } catch (err) {
          _iterator23.e(err);
        } finally {
          _iterator23.f();
        }
      }
      ;
    }
  }, {
    key: "setPaxHotel",
    value: function setPaxHotel(value) {
      this.PaxHotel = value;
      if (this.nextDay) {
        this.nextDay.Breakfast = false;
      }
      this.BookingDayHotels = [];
      this.$parent.setDaysByHotel();
    }
  }, {
    key: "setExchange",
    value: function setExchange(value) {
      if (!this.BookingDayHotels[0]) return;
      var _iterator24 = _createForOfIteratorHelper(this.BookingDayHotels[0].BookingDayRooms),
        _step24;
      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var room = _step24.value;
          room.exchange = value;
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
    }
  }, {
    key: "setHotel",
    value: function () {
      var _setHotel = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8(selected, exchange) {
        var _this5 = this;
        var oldHotelId, _iterator25, _step25, _loop4;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (this.BookingDayHotels[0]) {
                _context9.next = 2;
                break;
              }
              return _context9.abrupt("return");
            case 2:
              _iterator25 = _createForOfIteratorHelper(this.BookingDayHotels[0].BookingDayRooms);
              _context9.prev = 3;
              _loop4 = /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _loop4() {
                var room, baseId, roomType;
                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _loop4$(_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      room = _step25.value;
                      room.exchange = exchange;
                      if (room.QuoteList) {
                        for (baseId in _this5.$parent.bases) {
                          if (room.QuoteList[baseId]) {
                            room.QuoteList[baseId].Modified = false;
                            if (!exchange) room.QuoteList[baseId].PriceModified = false;
                          } else {
                            console.log('!room.QuoteList[baseId]', baseId, room.QuoteList);
                          }
                        }
                      }
                      if (room.HotelId) oldHotelId = room.HotelId;
                      _context8.next = 6;
                      return room.setValue({
                        fieldName: 'HotelId',
                        value: selected.id
                      });
                    case 6:
                      room.setHotel(oldHotelId);
                      roomType = _.find(room.Hotel.HotelRoomTypes, function (r) {
                        return r.RoomTypeId == room.RoomTypeId;
                      });
                      if (roomType) {
                        _context8.next = 11;
                        break;
                      }
                      _context8.next = 11;
                      return room.setValue({
                        fieldName: 'RoomTypeId',
                        value: null
                      });
                    case 11:
                      if (exchange) {
                        room.Status = _this5.constructor.exchangeStatus;
                      }
                    case 12:
                    case "end":
                      return _context8.stop();
                  }
                }, _loop4);
              });
              _iterator25.s();
            case 6:
              if ((_step25 = _iterator25.n()).done) {
                _context9.next = 10;
                break;
              }
              return _context9.delegateYield(_loop4(), "t0", 8);
            case 8:
              _context9.next = 6;
              break;
            case 10:
              _context9.next = 15;
              break;
            case 12:
              _context9.prev = 12;
              _context9.t1 = _context9["catch"](3);
              _iterator25.e(_context9.t1);
            case 15:
              _context9.prev = 15;
              _iterator25.f();
              return _context9.finish(15);
            case 18:
              _context9.next = 20;
              return this.BookingDayHotels[0].setValue({
                fieldName: 'CityId',
                value: selected.CityId
              });
            case 20:
              if (oldHotelId) {
                this.$parent.setHotelCostById({
                  hotelId: oldHotelId,
                  exchange: exchange,
                  skipCurrency: false,
                  daysChange: false,
                  sync: true
                });
              }
              if (this.selected) {
                this.$parent.setHotelCostById({
                  hotelId: selected.id,
                  exchange: exchange,
                  skipCurrency: false,
                  daysChange: false,
                  sync: true,
                  dayNr: this.DayNr
                });
              } else {}
            case 22:
            case "end":
              return _context9.stop();
          }
        }, _callee8, this, [[3, 12, 15, 18]]);
      }));
      function setHotel(_x3, _x4) {
        return _setHotel.apply(this, arguments);
      }
      return setHotel;
    }()
  }, {
    key: "setDayNr",
    value: function setDayNr(dayNr, breakfast) {
      this.DayNr = dayNr;
    }
  }, {
    key: "addBlankService",
    value: function () {
      var _addBlankService = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee9() {
        var orderNr, row, qDate;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee9$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              orderNr = this.BookingDayServices.length;
              _context10.next = 3;
              return this.newRowByName('BookingDayServices');
            case 3:
              row = _context10.sent;
              if (row) {
                _context10.next = 6;
                break;
              }
              return _context10.abrupt("return");
            case 6:
              row.setOrderNr(orderNr);
              this.BookingDayServices.push(row);
              qDate = this.TransDate;
              row.ServiceDate = this.TransDate;
              if (this.$parent.SplitQuoteDate && this.$parent.QuoteDate) {
                row.quoteDate = this.QuoteDate;
                qDate = this.QuoteDate;
              }
              row.tempId = (0,uuid__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)();
              row.Status = 'PENDING';
              if (this.$parent.QuoteBy == 'SERVICE') {
                row.$CostPer.value = 'SERVICE';
                if (this.$parent.QuoteViewType == 'PERSON') {
                  row.$CostPer.value = 'PERSON';
                }
              }
              _context10.next = 16;
              return this.$parent.getServicePersonCostRow({
                service: row
              });
            case 16:
              _context10.next = 18;
              return this.$parent.getServiceCost({
                service: row,
                quoteDate: this.QuoteDate
              });
            case 18:
              return _context10.abrupt("return", row);
            case 19:
            case "end":
              return _context10.stop();
          }
        }, _callee9, this);
      }));
      function addBlankService() {
        return _addBlankService.apply(this, arguments);
      }
      return addBlankService;
    }()
  }, {
    key: "setBookingDayOptions",
    value: function setBookingDayOptions(s) {
      if (s.Service.Breakfast && !s.Breakfast) this.Breakfast = true;
      if (s.Service.BoxLunch && !s.BoxLunch) this.BoxLunch = true;
      if (s.Service.EntranceIncluded) this.EntranceIncluded = true;
      if (s.Service.Lunch && !s.Lunch) this.Lunch = true;
      if (s.Service.Dinner && !s.Dinner) this.Dinner = true;
      if (s.Service.Snack && !s.Snack) this.Snack = true;
    }
  }, {
    key: "setBookingDayOptionsFalse",
    value: function setBookingDayOptionsFalse(s) {
      if (s.Breakfast) this.Breakfast = false;
      if (s.BoxLunch) this.BoxLunch = false;
      if (s.EntranceIncluded) this.EntranceIncluded = false;
      if (s.Lunch) this.Lunch = false;
      if (s.Dinner) this.Dinner = false;
      if (s.Snack) this.Snack = false;
    }
  }, {
    key: "moveHotelToDay",
    value: function () {
      var _moveHotelToDay = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee10(hotel) {
        var hotels, bookingDayHotels;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee10$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.newRowByName('BookingDayHotels');
            case 2:
              hotels = _context11.sent;
              _context11.next = 5;
              return hotels.constructor.clone({
                fields: hotels.fields,
                record: hotel,
                parent: hotel.$parent
              });
            case 5:
              bookingDayHotels = _context11.sent;
              this.BookingDayHotels = [];
              this.BookingDayHotels.push(bookingDayHotels);
              this.setPending();
            case 9:
            case "end":
              return _context11.stop();
          }
        }, _callee10, this);
      }));
      function moveHotelToDay(_x5) {
        return _moveHotelToDay.apply(this, arguments);
      }
      return moveHotelToDay;
    }()
  }, {
    key: "moveServiceToDay",
    value: function () {
      var _moveServiceToDay = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee11(s, moveBefore) {
        var service, index;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee11$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this.newRowByName('BookingDayServices');
            case 2:
              service = _context12.sent;
              _context12.next = 5;
              return service.constructor.clone({
                fields: service.fields,
                record: s,
                parent: s.$parent
              });
            case 5:
              service = _context12.sent;
              service.ServiceDate = this.TransDate;
              service.tempId = (0,uuid__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)();
              if (this.$parent.SplitQuoteDate && this.$parent.QuoteDate) {
                service.QuoteDate = this.QuoteDate;
              }
              if (moveBefore) {
                index = _.findIndex(this.BookingDayServices, function (r) {
                  if (r.id == moveBefore) return true;
                  if (r.tempId == moveBefore) return true;
                });
                this.BookingDayServices.splice(index, 0, service);
                this.setServicesOrderNr();
              } else {
                service.setOrderNr(this.BookingDayServices.length);
                this.BookingDayServices.push(service);
              }
              service._moved = true;
            case 11:
            case "end":
              return _context12.stop();
          }
        }, _callee11, this);
      }));
      function moveServiceToDay(_x6, _x7) {
        return _moveServiceToDay.apply(this, arguments);
      }
      return moveServiceToDay;
    }()
  }, {
    key: "setOrderNr",
    value: function setOrderNr(toAdd, fromNr) {
      var _iterator26 = _createForOfIteratorHelper(this.BookingDayServices),
        _step26;
      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var s = _step26.value;
          if (s.OrderNr >= fromNr) {
            s.OrderNr += toAdd;
          }
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
    }
  }, {
    key: "dayExtraImages",
    get: function get() {
      var res = [];
      var _iterator27 = _createForOfIteratorHelper(this.BookingDayServices),
        _step27;
      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var s = _step27.value;
          if (!s.BookingDayServiceImages) continue;
          var _iterator28 = _createForOfIteratorHelper(s.BookingDayServiceImages),
            _step28;
          try {
            for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
              var image = _step28.value;
              if (!image.Image) continue;
              res.push(image.Image);
            }
          } catch (err) {
            _iterator28.e(err);
          } finally {
            _iterator28.f();
          }
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }
      return res;
    }
  }, {
    key: "dayNumber",
    get: function get() {
      if (this.GroupDays && this.GroupDayTo) {
        var r = parseInt(this.DayNr) + 1;
        r += ' ' + 'TO' + ' ' + this.GroupDayTo;
        return r;
      }
      return (parseInt(this.DayNr) + 1).toString();
    }
  }, {
    key: "typeOfService",
    get: function get() {
      var res = [];
      var _iterator29 = _createForOfIteratorHelper(this.BookingDayServices),
        _step29;
      try {
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
          var s = _step29.value;
          if (s && s.Service && s.Service.ServiceType) {
            if (res.indexOf(s.Service.ServiceType.Name) == -1) {
              res.push(s.Service.ServiceType.Name);
            }
          }
        }
      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }
      if (res.length > 0) {
        return 'Type of service' + ': ' + res.join(', ');
      }
      return '';
    }
  }, {
    key: "hotelListByDay",
    get: function get() {
      var viewMode = this.$parent.ViewMode;
      var hotelList = [];
      var hotels = {};
      if (!this.BookingDayHotels[0]) return [];
      var _iterator30 = _createForOfIteratorHelper(this.BookingDayHotels[0].BookingDayRooms),
        _step30;
      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          var room = _step30.value;
          var found = false;
          if (viewMode == -1) {
            found = true;
          } else {
            if (room.QuoteList[viewMode] && room.QuoteList[viewMode].Include) {
              found = true;
            }
          }
          if (!found) continue;
          if (!room.Hotel) continue;
          if (!room.Hotel.id) continue;
          if (!room.Hotel.RoomCategories) continue;
          if (!room.roomQuoteSelected && this.$parent.anyQuoteSelected) continue;
          var key = room.Hotel.id;
          if (!hotels[key]) {
            hotelList.push(key);
            hotels[key] = {
              rooms: [],
              Hotel: room.Hotel,
              types: [],
              fullNames: []
            };
            if (room.HotelCategory && room.HotelCategory.Name) {
              hotels[key].HotelCategory = room.HotelCategory.Name;
            }
          }
          hotels[key].types.push(room.roomsQuantity + ' ' + room.Room.Name);
          hotels[key].fullNames.push(room.roomsQuantity + ' ' + room.Room.Name + ' ' + room.Category.Name);
          var _iterator31 = _createForOfIteratorHelper(room.Hotel.RoomCategories),
            _step31;
          try {
            for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
              var category = _step31.value;
              if (category.id == room.RoomCategory && hotels[key].rooms.indexOf(category.Name) == -1) {
                hotels[key].rooms.push(category.Name);
              }
            }
          } catch (err) {
            _iterator31.e(err);
          } finally {
            _iterator31.f();
          }
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }
      var res = [];
      for (var _i = 0, _hotelList = hotelList; _i < _hotelList.length; _i++) {
        var id = _hotelList[_i];
        var h = hotels[id];
        var r = {
          Hotel: h.Hotel,
          rooms: h.rooms.join(', '),
          HotelCategory: h.HotelCategory,
          types: h.types.join('/'),
          fullNames: h.fullNames.join(' / ')
        };
        res.push(r);
      }
      return res;
    }
  }, {
    key: "setPending",
    value: function setPending() {
      var _iterator32 = _createForOfIteratorHelper(this.BookingDayHotels),
        _step32;
      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var hotel = _step32.value;
          var _iterator33 = _createForOfIteratorHelper(hotel.BookingDayRooms),
            _step33;
          try {
            for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
              var room = _step33.value;
              room.setPending();
            }
          } catch (err) {
            _iterator33.e(err);
          } finally {
            _iterator33.f();
          }
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }
    }
  }, {
    key: "afterEdit",
    value: function afterEdit() {
      return {
        TransDate: function TransDate(r) {
          r.setPending();
        },
        _DayNr: function _DayNr(r) {
          r.set_DayNr();
        },
        DayNr: function DayNr(r) {
          r._DayNr = parseInt(r.DayNr) + 1;
        }
      };
    }
  }, {
    key: "set_DayNr",
    value: function set_DayNr() {
      if (tools.isNull(this._DayNr)) {
        this._DayNr = parseInt(this.DayNr) + 1;
      } else {
        this.$DayNr.value = parseInt(this._DayNr) - 1;
        if (this.StartDate) {
          this.TransDate = moment(this.$parent.StartDate, "YYYY-MM-DD").add(this.DayNr, 'days').format("YYYY-MM-DD");
        }
      }
    }
  }, {
    key: "images",
    get: function get() {
      var res = [];
      if (this.Image && this.Image.url) res.push(this.Image);
      var _iterator34 = _createForOfIteratorHelper(this.BookingDayServices),
        _step34;
      try {
        for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
          var s = _step34.value;
          if (s && s.BookingDayServiceImages) {
            if (s.Optional) continue;
            var _iterator36 = _createForOfIteratorHelper(s.BookingDayServiceImages),
              _step36;
            try {
              var _loop6 = function _loop6() {
                var image = _step36.value;
                if (!image.Image) return 1; // continue
                var found = _.find(res, function (r) {
                  return r.id == image.Image.id;
                });
                if (!found) res.push(image.Image);
              };
              for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
                if (_loop6()) continue;
              }
            } catch (err) {
              _iterator36.e(err);
            } finally {
              _iterator36.f();
            }
          }
        }
      } catch (err) {
        _iterator34.e(err);
      } finally {
        _iterator34.f();
      }
      if (this.hotelListByDay.length == 1) {
        if (this.hotelListByDay[0].Hotel) {
          var _iterator35 = _createForOfIteratorHelper(this.hotelListByDay[0].Hotel.HotelPhotos),
            _step35;
          try {
            var _loop5 = function _loop5() {
              var image = _step35.value;
              if (!image.Image) return 1; // continue
              var found = _.find(res, function (r) {
                return r.id == image.Image.id;
              });
              if (!found) res.push(image.Image);
            };
            for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
              if (_loop5()) continue;
            }
          } catch (err) {
            _iterator35.e(err);
          } finally {
            _iterator35.f();
          }
        }
      }
      return res;
    }
  }, {
    key: "imagesServices",
    get: function get() {
      var res = [];
      if (this.Image && this.Image.url) res.push(this.Image);
      var _iterator37 = _createForOfIteratorHelper(this.BookingDayServices),
        _step37;
      try {
        for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
          var s = _step37.value;
          if (s && s.BookingDayServiceImages) {
            var _iterator38 = _createForOfIteratorHelper(s.BookingDayServiceImages),
              _step38;
            try {
              var _loop7 = function _loop7() {
                var image = _step38.value;
                if (!image.Image) return 1; // continue
                var found = _.find(res, function (r) {
                  return r.id == image.Image.id;
                });
                if (!found) res.push(image.Image);
              };
              for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
                if (_loop7()) continue;
              }
            } catch (err) {
              _iterator38.e(err);
            } finally {
              _iterator38.f();
            }
          }
        }
      } catch (err) {
        _iterator37.e(err);
      } finally {
        _iterator37.f();
      }
      return res;
    }
  }, {
    key: "ifHotel",
    get: function get() {
      if (!this.BookingDayHotels[0]) return;
      var hotel = this.BookingDayHotels[0];
      if (hotel.BookingDayRooms && hotel.BookingDayRooms[0] && hotel.BookingDayRooms[0].Hotel && hotel.BookingDayRooms[0].Hotel.id) {
        return true;
      }
    }
  }, {
    key: "dayTitle",
    get: function get() {
      var res = [];
      var citiesNames = this.getCitiesNames(this.$parent.hotelsByDay[this.DayNr]);
      if (citiesNames) res.push(citiesNames);
      if (this.Title) res.push(this.Title);
      return res.join(' - ');
    }
  }, {
    key: "citiesNames",
    get: function get() {
      return this.getCitiesNames(this.$parent.hotelsByDay[this.DayNr]);
    }
  }, {
    key: "dayId",
    get: function get() {
      for (var i in this.$parent.BookingDays) {
        var day = this.$parent.BookingDays[i];
        if (day._id == this._id) {
          return i;
        }
      }
    }
  }, {
    key: "setRequiredService",
    value: function () {
      var _setRequiredService = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee12(_ref2) {
        var record, include, isTemplate, templateLanguageId, _iterator39, _step39, rs;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee12$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              record = _ref2.record, include = _ref2.include, isTemplate = _ref2.isTemplate, templateLanguageId = _ref2.templateLanguageId;
              if (!(record && record.RequiredServices)) {
                _context13.next = 19;
                break;
              }
              _iterator39 = _createForOfIteratorHelper(record.RequiredServices);
              _context13.prev = 3;
              _iterator39.s();
            case 5:
              if ((_step39 = _iterator39.n()).done) {
                _context13.next = 11;
                break;
              }
              rs = _step39.value;
              _context13.next = 9;
              return this.setServiceToDay({
                record: rs.RequiredService,
                include: include,
                isTemplate: isTemplate,
                templateLanguageId: templateLanguageId
              });
            case 9:
              _context13.next = 5;
              break;
            case 11:
              _context13.next = 16;
              break;
            case 13:
              _context13.prev = 13;
              _context13.t0 = _context13["catch"](3);
              _iterator39.e(_context13.t0);
            case 16:
              _context13.prev = 16;
              _iterator39.f();
              return _context13.finish(16);
            case 19:
            case "end":
              return _context13.stop();
          }
        }, _callee12, this, [[3, 13, 16, 19]]);
      }));
      function setRequiredService(_x8) {
        return _setRequiredService.apply(this, arguments);
      }
      return setRequiredService;
    }()
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(BookingDay, "moduleName", 'bookingday');
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(BookingDay, "exchangeStatus", 'PENDING');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingDay);

/***/ }),

/***/ 88974:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = loader;
exports.raw = void 0;

var _path = _interopRequireDefault(__webpack_require__(57975));

var _loaderUtils = __webpack_require__(46662);

var _schemaUtils = __webpack_require__(86747);

var _options = _interopRequireDefault(__webpack_require__(63683));

var _utils = __webpack_require__(44287);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loader(content) {
  const options = (0, _loaderUtils.getOptions)(this);
  (0, _schemaUtils.validate)(_options.default, options, {
    name: 'File Loader',
    baseDataPath: 'options'
  });
  const context = options.context || this.rootContext;
  const name = options.name || '[contenthash].[ext]';
  const url = (0, _loaderUtils.interpolateName)(this, name, {
    context,
    content,
    regExp: options.regExp
  });
  let outputPath = url;

  if (options.outputPath) {
    if (typeof options.outputPath === 'function') {
      outputPath = options.outputPath(url, this.resourcePath, context);
    } else {
      outputPath = _path.default.posix.join(options.outputPath, url);
    }
  }

  let publicPath = `__webpack_public_path__ + ${JSON.stringify(outputPath)}`;

  if (options.publicPath) {
    if (typeof options.publicPath === 'function') {
      publicPath = options.publicPath(url, this.resourcePath, context);
    } else {
      publicPath = `${options.publicPath.endsWith('/') ? options.publicPath : `${options.publicPath}/`}${url}`;
    }

    publicPath = JSON.stringify(publicPath);
  }

  if (options.postTransformPublicPath) {
    publicPath = options.postTransformPublicPath(publicPath);
  }

  if (typeof options.emitFile === 'undefined' || options.emitFile) {
    const assetInfo = {};

    if (typeof name === 'string') {
      let normalizedName = name;
      const idx = normalizedName.indexOf('?');

      if (idx >= 0) {
        normalizedName = normalizedName.substr(0, idx);
      }

      const isImmutable = /\[([^:\]]+:)?(hash|contenthash)(:[^\]]+)?]/gi.test(normalizedName);

      if (isImmutable === true) {
        assetInfo.immutable = true;
      }
    }

    assetInfo.sourceFilename = (0, _utils.normalizePath)(_path.default.relative(this.rootContext, this.resourcePath));
    this.emitFile(outputPath, content, null, assetInfo);
  }

  const esModule = typeof options.esModule !== 'undefined' ? options.esModule : true;
  return `${esModule ? 'export default' : 'module.exports ='} ${publicPath};`;
}

const raw = true;
exports.raw = raw;

/***/ }),

/***/ 89067:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64467);
/* harmony import */ var _base_model_record__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55539);






function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingReceipt = /*#__PURE__*/function (_Record) {
  function BookingReceipt() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, BookingReceipt);
    return _callSuper(this, BookingReceipt, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(BookingReceipt, _Record);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingReceipt, [{
    key: "titleName",
    get: function get() {
      if (this.id) return "".concat(tr('Receipt'), " ").concat(this.id);
      return tr('Receipt');
    }
  }]);
}(_base_model_record__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingReceipt, "moduleName", 'bookingreceipt');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingReceipt);

/***/ }),

/***/ 89220:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var inherits = __webpack_require__(56698);

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.a = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};


/***/ }),

/***/ 89374:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays:
            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


/***/ }),

/***/ 89431:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);



function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

var ImageApi = /*#__PURE__*/function () {
  function ImageApi() {
    var _this = this;
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(this, ImageApi);
    var self = this;
    return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.getImageList();
          case 2:
            self.files = _context.sent;
            self.path = '';
            return _context.abrupt("return", self);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(ImageApi, [{
    key: "getImageList",
    value: function () {
      var _getImageList = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return api.get('/api/image/get_image_list/');
            case 2:
              return _context2.abrupt("return", _context2.sent);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getImageList() {
        return _getImageList.apply(this, arguments);
      }
      return getImageList;
    }()
  }, {
    key: "uploadImage",
    value: function () {
      var _uploadImage = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(imageFile) {
        var files, res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              files = new FormData();
              files.append('file', imageFile);
              if (this.path) files.append('folder', this.path);
              _context3.next = 5;
              return api.post('/api/image/upload_image', files, {});
            case 5:
              res = _context3.sent;
              return _context3.abrupt("return", res);
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function uploadImage(_x) {
        return _uploadImage.apply(this, arguments);
      }
      return uploadImage;
    }()
  }, {
    key: "setImageName",
    value: function () {
      var _setImageName = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(file, value, set) {
        var id, res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.uploadImage(file);
            case 2:
              id = _context4.sent;
              if (!id) {
                _context4.next = 9;
                break;
              }
              _context4.next = 6;
              return api.post('/api/image/update_name/', JSON.stringify({
                id: id,
                Name: value
              }));
            case 6:
              res = _context4.sent;
              if (res && !set) {
                this.files[this.path].push({
                  url: res.url,
                  name: res.Name,
                  id: id
                });
                this.files = Object.assign({}, this.files);
              }
              return _context4.abrupt("return", res);
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function setImageName(_x2, _x3, _x4) {
        return _setImageName.apply(this, arguments);
      }
      return setImageName;
    }()
  }, {
    key: "addFolder",
    value: function () {
      var _addFolder = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(value) {
        var newFolder, res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (this.path) {
                newFolder = this.path + value + '/';
              } else {
                newFolder = value + '/';
              }
              _context5.next = 3;
              return api.post('/api/image/new_folder/', JSON.stringify({
                path: newFolder
              }));
            case 3:
              res = _context5.sent;
              if (res) {
                if (!this.files[res.path]) {
                  this.files[res.path] = [];
                  this.files = Object.assign({}, this.files);
                }
              }
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function addFolder(_x5) {
        return _addFolder.apply(this, arguments);
      }
      return addFolder;
    }()
  }, {
    key: "renameImage",
    value: function () {
      var _renameImage = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(id, value) {
        var res, key, el;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return api.post('/api/image/update_name/', JSON.stringify({
                id: id,
                Name: value
              }));
            case 2:
              res = _context6.sent;
              if (res) {
                if (this.path) {
                  key = this.path;
                } else {
                  key = '';
                }
                el = _.findIndex(this.files[key], function (c) {
                  return c.id == id;
                });
                if (el > -1) {
                  this.files[key][el].name = value;
                }
              }
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function renameImage(_x6, _x7) {
        return _renameImage.apply(this, arguments);
      }
      return renameImage;
    }()
  }, {
    key: "remove",
    value: function () {
      var _remove = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7(id) {
        var key, res, el;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (this.path) {
                key = this.path;
              } else {
                key = '';
              }
              _context7.next = 3;
              return api.post('/api/image/remove_url/', JSON.stringify({
                id: id
              }));
            case 3:
              res = _context7.sent;
              if (res) {
                el = _.findIndex(this.files[key], function (c) {
                  return c.id == id;
                });
                this.files[key].splice(el, 1);
              }
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function remove(_x8) {
        return _remove.apply(this, arguments);
      }
      return remove;
    }()
  }, {
    key: "imageList",
    value: function imageList(search) {
      var files = [];
      if (this.files) {
        if (this.path) {
          files = this.files[this.path];
        } else {
          files = this.files[''];
        }
      }
      if (search) {
        var values = search.split(' ');
        return _.filter(files, function (r) {
          var _iterator = _createForOfIteratorHelper(values),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var value = _step.value;
              var found = false;
              var re = new RegExp(tools.normalize(value), 'i');
              if (r.name) {
                var m = tools.normalize(r.name).match(re);
                if (m) found = true;
              }
              if (!found) return false;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return true;
        });
      }
      return files;
    }
  }, {
    key: "getFolders",
    value: function getFolders(search) {
      var res = [];
      var files = {};
      if (this.path) {
        for (var f in this.files) {
          if (f.startsWith(this.path)) {
            var key = f.replace(this.path, '');
            files[key] = this.files[f];
          }
        }
      } else {
        files = this.files;
      }
      for (var _f in files) {
        if (_f && _f.split('/').length > 1) {
          var folder = _f.split('/')[0];
          if (res.indexOf(folder) == -1) {
            res.push(_f.split('/')[0]);
          }
        }
      }
      if (search) {
        var values = search.split(' ');
        return _.filter(res, function (r) {
          var _iterator2 = _createForOfIteratorHelper(values),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var value = _step2.value;
              var found = false;
              var re = new RegExp(tools.normalize(value), 'i');
              var m = tools.normalize(r).match(re);
              if (m) found = true;
              if (!found) return false;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          return true;
        });
      }
      return res;
    }
  }, {
    key: "updateFolderPath",
    value: function () {
      var _updateFolderPath = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8() {
        var res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.getImageList();
            case 2:
              res = _context8.sent;
              if (res) {
                this.files = res;
              }
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function updateFolderPath() {
        return _updateFolderPath.apply(this, arguments);
      }
      return updateFolderPath;
    }()
  }, {
    key: "back",
    value: function back() {
      if (this.path.split('/').length == 2) {
        this.path = '';
      } else {
        var res;
        var path = this.path.split('/');
        var l = path.length;
        var toRemove = path[l - 2] + '/';
        this.path = this.path.replace(toRemove, '');
      }
    }
  }, {
    key: "setFolder",
    value: function setFolder(f) {
      if (this.path) {
        this.path = this.path + f + '/';
      } else {
        this.path = f + '/';
      }
    }
  }, {
    key: "removeImageFromList",
    value: function removeImageFromList(toMove) {
      for (var k in this.files) {
        for (var i in this.files[k]) {
          var p = this.files[k][i];
          if (p.id == toMove) {
            this.files[k].splice(i, 1);
            return true;
          }
        }
      }
    }
  }, {
    key: "updateFilePath",
    value: function updateFilePath(toMove, img) {
      var r = this.removeImageFromList(toMove);
      if (!this.files[img.path]) this.files[img.path] = [];
      this.files[img.path].push({
        "url": img.url,
        "name": img.name,
        "id": img.id
      });
      this.files = Object.assign({}, this.files);
      return r;
    }
  }, {
    key: "move",
    value: function () {
      var _move = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee9(text, folder, isFolder, toMove) {
        var newPath, url;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (this.path) {
                newPath = this.path + folder + '/';
              } else {
                newPath = folder + '/';
              }
              url = '/api/image/move_image/';
              if (isFolder) {
                url = '/api/image/move_folder/';
              }
              _context9.next = 5;
              return api.post(url, JSON.stringify({
                id: toMove,
                newPath: newPath
              }));
            case 5:
              return _context9.abrupt("return", _context9.sent);
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function move(_x9, _x10, _x11, _x12) {
        return _move.apply(this, arguments);
      }
      return move;
    }()
  }, {
    key: "removeFolder",
    value: function () {
      var _removeFolder = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee10(folder) {
        var url;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              url = '/api/image/remove_folder/';
              _context10.next = 3;
              return api.post(url, JSON.stringify({
                folder: folder
              }));
            case 3:
              return _context10.abrupt("return", _context10.sent);
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
      function removeFolder(_x13) {
        return _removeFolder.apply(this, arguments);
      }
      return removeFolder;
    }()
  }]);
}();
window.imageApi = ImageApi;

/***/ }),

/***/ 89722:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


/***/ }),

/***/ 89756:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


/***/ }),

/***/ 90028:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8818);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }

var AccountView = /*#__PURE__*/function (_View) {
  function AccountView() {
    _classCallCheck(this, AccountView);
    return _callSuper(this, AccountView, arguments);
  }
  _inherits(AccountView, _View);
  return _createClass(AccountView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, parentAccountId;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(AccountView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              res = _context.sent;
              parentAccountId = _.find(res.fields, function (r) {
                return r.name == 'ParentAccountId';
              });
              parentAccountId.optionLabels = function (row) {
                return "".concat(row.id, " - ").concat(row.Name);
              };
              return _context.abrupt("return", res);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_0__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AccountView);

/***/ }),

/***/ 90188:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8818);









function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var BookingPaymentView = /*#__PURE__*/function (_View) {
  function BookingPaymentView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, BookingPaymentView);
    return _callSuper(this, BookingPaymentView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingPaymentView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(BookingPaymentView, null, [{
    key: "currencyConvertTab",
    get: function get() {
      var adminActions = BookingPaymentView.adminActions || BookingPaymentView.paymentActions;
      return {
        name: 'currencyConvertTab',
        label: 'Currency Rate',
        editor: 'tab',
        hideFromList: true,
        hidden: !adminActions,
        fields: [{
          name: 'FromCurrencyId',
          relation: 'currency',
          optionLabels: 'id',
          editor: 'select',
          label: 'From',
          columns: 2,
          requiredCallback: function requiredCallback(r) {
            if (r.PaymentStatus == 'PAID') return true;
            if (r.PaymentCurrencyId && r.PaymentCurrencyId != api.baseCurrency.BookingCurrency) return true;
          }
        }, {
          name: 'ToCurrencyId',
          relation: 'currency',
          optionLabels: 'id',
          editor: 'select',
          label: 'To',
          columns: 2,
          requiredCallback: function requiredCallback(r) {
            if (r.PaymentStatus == 'PAID') return true;
            if (r.PaymentCurrencyId && r.PaymentCurrencyId != api.baseCurrency.BookingCurrency) return true;
          }
        }, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)((0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)({
          name: 'CurrencyRate',
          editor: 'number',
          columns: 2,
          decimal: 2,
          label: 'Rate'
        }, "columns", 2), "requiredCallback", function requiredCallback(r) {
          if (r.PaymentStatus == 'PAID') return true;
          if (r.PaymentCurrencyId && r.PaymentCurrencyId != api.baseCurrency.BookingCurrency) return true;
        })]
      };
    }
  }, {
    key: "paymentStatusOptions",
    value: function paymentStatusOptions() {
      var adminActions = BookingPaymentView.adminActions || BookingPaymentView.paymentActions;
      return [{
        value: 'CREATED',
        label: 'Initial'
      }, {
        value: 'PENDING',
        label: 'Pending'
      }, {
        value: 'PAID',
        label: 'Paid',
        disabled: !adminActions
      },
      //{value: 'ON_ACCOUNT', label: 'Credit', disabled: !adminActions},
      {
        value: 'USED',
        label: 'Credit Used',
        disabled: !adminActions
      }, {
        value: 'CANCELED',
        label: 'Canceled',
        disabled: !adminActions
      }];
    }
  }, {
    key: "options",
    value: function options() {
      var adminActions = BookingPaymentView.adminActions || BookingPaymentView.paymentActions;
      var operActions = BookingPaymentView.operActions;
      return {
        serverSide: true,
        canAdd: true,
        fields: [{
          name: 'id',
          readonly: true,
          columns: 2,
          headerField: true,
          label: 'Number',
          hidden: !adminActions
        }, {
          name: 'BookingId',
          readonly: true,
          columns: 2,
          headerField: true,
          label: 'File',
          hidden: !adminActions
        }, {
          name: 'SupplierId',
          relation: 'supplier',
          optionLabels: 'Name',
          columns: 8,
          setRelationTo: 'Supplier',
          label: 'Supplier',
          headerField: true,
          editor: 'vue-select'
        }, {
          name: 'PaymentStatus',
          label: 'Status',
          editor: 'select',
          notSort: true,
          headerField: true,
          columns: 4,
          options: this.paymentStatusOptions(),
          required: true
        }, {
          name: "PaymentTypeId",
          relation: "paymenttype",
          optionLabels: "Name",
          editor: "select",
          label: "Payment Mode",
          columns: 4,
          headerField: true,
          addBlank: true,
          filters: function filters(row) {
            if (row.Payments == true) return true;
          },
          setRelationTo: 'PaymentType',
          requiredCallback: function requiredCallback(r) {
            return r.PaymentStatus == 'ON_ACCOUNT' || r.PaymentStatus == 'USED';
          }
        }, {
          name: 'SupplierCreditId',
          relation: 'suppliercredit',
          optionLabels: function optionLabels(row) {
            if (row.PaxName && row.Balance) {
              var balance = row.Balance;
              var c = _.find(api.tables.currency, function (r) {
                return r.id == row.CurrencyId;
              });
              var value = tools.formatNumber(balance, {
                c: c,
                s: 1
              });
              if (c) return "".concat(row.PaxName, " ").concat(value);
              return "".concat(row.PaxName, " ").concat(value, " ").concat(row.CurrencyId);
            } else if (row.PaxName) {
              return "File: ".concat(row.BookingId, " ").concat(row.PaxName, ", ").concat(tr('Credit Number'), ": ").concat(row.id);
            } else {
              return " ".concat(tr('Credit Number'), " ").concat(row.id);
            }
          },
          editor: 'select',
          label: 'Credit',
          endpoint: '/api/supplier/get_credit/',
          endpointFilters: function endpointFilters(record) {
            if (record && record.SupplierId) {
              var res = {};
              res.SupplierId = record.SupplierId;
              return res;
            }
            return {};
          },
          setRelationTo: 'SupplierCredit',
          hideFromList: true,
          headerField: true,
          columns: 4,
          hideIf: function hideIf(row) {
            if (!row.PaymentType || !row.PaymentType.OnAccount || row.PaymentStatus != 'USED') return true;
          }
        }, {
          name: 'DueDate',
          label: 'Due Date',
          required: true,
          editor: 'date',
          headerField: true,
          columns: 2,
          dateFormat: "DD/MM/YYYY",
          disablePast: true
        }, {
          name: 'PaymentDate',
          label: 'Payment Date',
          editor: 'date',
          headerField: true,
          columns: 2,
          dateFormat: "DD/MM/YYYY",
          disabled: !adminActions,
          hidden: !adminActions,
          requiredCallback: function requiredCallback(record) {
            return record.PaymentStatus == 'PAID';
          }
        }, {
          name: 'Amount',
          label: 'To Pay',
          headerField: true,
          editor: 'number',
          columns: 2,
          decimal: 2,
          required: true,
          currency: 'Currency'
        }, {
          name: 'CurrencyId',
          relation: 'currency',
          optionLabels: 'id',
          required: true,
          setRelationTo: 'Currency',
          editor: 'select',
          label: 'Currency',
          columns: 2,
          headerField: true
        }, {
          name: 'PaymentAmount',
          label: 'Paid',
          headerField: true,
          editor: 'number',
          columns: 2,
          readonly: !adminActions,
          hidden: !adminActions,
          decimal: 2,
          requiredCallback: function requiredCallback(record) {
            if (record.PaymentStatus == 'PAID') return true;
            if (record.PaymentType.OnAccount) return true;
          },
          currency: 'PaymentCurrency'
        }, {
          name: 'PaymentCurrencyId',
          relation: 'currency',
          optionLabels: 'id',
          disabled: !adminActions,
          setRelationTo: 'PaymentCurrency',
          editor: 'select',
          label: 'Currency',
          columns: 2,
          addBlank: true,
          headerField: true,
          hidden: !adminActions,
          requiredCallback: function requiredCallback(record) {
            if (record.PaymentStatus == 'PAID') return true;
            if (record.PaymentType.OnAccount) return true;
          }
        }, {
          name: 'InvoiceStatus',
          editor: 'select',
          addBlank: true,
          columns: 2,
          headerField: true,
          hidden: !adminActions,
          label: 'Invoice',
          options: [{
            value: 'PENDING',
            label: 'Pending'
          }, {
            value: 'RECEIVED',
            label: 'Receipt'
          }, {
            value: 'CONFIRMED',
            label: 'Confirmed'
          }, {
            value: 'NOT_APPLY',
            label: 'Not Apply'
          }]
        }, {
          name: 'Comment',
          label: 'Notes',
          columns: 10,
          headerField: true,
          hideFromList: true
        }, BookingPaymentView.currencyConvertTab]
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(BookingPaymentView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              res = _context.sent;
              return _context.abrupt("return", res);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_4__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingPaymentView, "table", 'bookingpayment');
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingPaymentView, "adminActions", tools.canAccess(api.currentUser, 'api', 'GET', 'admin_actions', false));
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingPaymentView, "operActions", tools.canAccess(api.currentUser, 'api', 'GET', 'oper_actions', false));
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingPaymentView, "paymentActions", tools.canAccess(api.currentUser, 'api', 'GET', 'edit_payments', false));
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingPaymentView, "paymentStatus", {
  CREATED: 'Initial',
  PENDING: 'Pending',
  PAID: 'Paid',
  //ON_ACCOUNT: 'Credit',
  USED: 'Credit Used',
  CANCELED: 'Canceled'
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingPaymentView);

/***/ }),

/***/ 90220:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var BN = __webpack_require__(28490);
var utils = __webpack_require__(47011);
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength),
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;


/***/ }),

/***/ 90392:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Buffer = (__webpack_require__(92861).Buffer)

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),

/***/ 90497:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const JSON5 = __webpack_require__(81219);

const specialValues = {
  null: null,
  true: true,
  false: false,
};

function parseQuery(query) {
  if (query.substr(0, 1) !== '?') {
    throw new Error(
      "A valid query string passed to parseQuery should begin with '?'"
    );
  }

  query = query.substr(1);

  if (!query) {
    return {};
  }

  if (query.substr(0, 1) === '{' && query.substr(-1) === '}') {
    return JSON5.parse(query);
  }

  const queryArgs = query.split(/[,&]/g);
  const result = Object.create(null);

  queryArgs.forEach((arg) => {
    const idx = arg.indexOf('=');

    if (idx >= 0) {
      let name = arg.substr(0, idx);
      let value = decodeURIComponent(arg.substr(idx + 1));

      // eslint-disable-next-line no-prototype-builtins
      if (specialValues.hasOwnProperty(value)) {
        value = specialValues[value];
      }

      if (name.substr(-2) === '[]') {
        name = decodeURIComponent(name.substr(0, name.length - 2));

        if (!Array.isArray(result[name])) {
          result[name] = [];
        }

        result[name].push(value);
      } else {
        name = decodeURIComponent(name);
        result[name] = value;
      }
    } else {
      if (arg.substr(0, 1) === '-') {
        result[decodeURIComponent(arg.substr(1))] = false;
      } else if (arg.substr(0, 1) === '+') {
        result[decodeURIComponent(arg.substr(1))] = true;
      } else {
        result[decodeURIComponent(arg)] = true;
      }
    }
  });

  return result;
}

module.exports = parseQuery;


/***/ }),

/***/ 90514:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8818);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var CurrencyRateView = /*#__PURE__*/function (_View) {
  function CurrencyRateView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, CurrencyRateView);
    return _callSuper(this, CurrencyRateView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(CurrencyRateView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(CurrencyRateView, null, [{
    key: "options",
    value: function options() {
      return {
        fieldsOrder: ['FromCurrencyId', 'ToCurrencyId', 'ConversionRate', 'Date'],
        canAdd: true
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(CurrencyRateView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_4__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CurrencyRateView);

/***/ }),

/***/ 90527:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast =
            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
                ' '
            ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort:
            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
                '_'
            ),
        weekdays:
            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
                '_'
            ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),

/***/ 90609:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings =
        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


/***/ }),

/***/ 90735:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var inherits = __webpack_require__(56698);

var DEREncoder = __webpack_require__(70082);

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};


/***/ }),

/***/ 90968:
/***/ ((module) => {

module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};


/***/ }),

/***/ 90991:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ _get)
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(53954);
;// ./node_modules/@babel/runtime/helpers/esm/superPropBase.js

function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = (0,getPrototypeOf/* default */.A)(t)););
  return t;
}

;// ./node_modules/@babel/runtime/helpers/esm/get.js

function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}


/***/ }),

/***/ 90993:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Reporter = (__webpack_require__(9673).Reporter);
var EncoderBuffer = (__webpack_require__(9673).EncoderBuffer);
var DecoderBuffer = (__webpack_require__(9673).DecoderBuffer);
var assert = __webpack_require__(43349);

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input, options);
    else
      result = this._decodeChoice(input, options);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
          ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
        ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};


/***/ }),

/***/ 91030:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var URI = __webpack_require__(46579)
  , equal = __webpack_require__(32017)
  , util = __webpack_require__(96740)
  , SchemaObject = __webpack_require__(2585)
  , traverse = __webpack_require__(7106);

module.exports = resolve;

resolve.normalizeId = normalizeId;
resolve.fullPath = getFullPath;
resolve.url = resolveUrl;
resolve.ids = resolveIds;
resolve.inlineRef = inlineRef;
resolve.schema = resolveSchema;

/**
 * [resolve and compile the references ($ref)]
 * @this   Ajv
 * @param  {Function} compile reference to schema compilation funciton (localCompile)
 * @param  {Object} root object with information about the root schema for the current schema
 * @param  {String} ref reference to resolve
 * @return {Object|Function} schema object (if the schema can be inlined) or validation function
 */
function resolve(compile, root, ref) {
  /* jshint validthis: true */
  var refVal = this._refs[ref];
  if (typeof refVal == 'string') {
    if (this._refs[refVal]) refVal = this._refs[refVal];
    else return resolve.call(this, compile, root, refVal);
  }

  refVal = refVal || this._schemas[ref];
  if (refVal instanceof SchemaObject) {
    return inlineRef(refVal.schema, this._opts.inlineRefs)
            ? refVal.schema
            : refVal.validate || this._compile(refVal);
  }

  var res = resolveSchema.call(this, root, ref);
  var schema, v, baseId;
  if (res) {
    schema = res.schema;
    root = res.root;
    baseId = res.baseId;
  }

  if (schema instanceof SchemaObject) {
    v = schema.validate || compile.call(this, schema.schema, root, undefined, baseId);
  } else if (schema !== undefined) {
    v = inlineRef(schema, this._opts.inlineRefs)
        ? schema
        : compile.call(this, schema, root, undefined, baseId);
  }

  return v;
}


/**
 * Resolve schema, its root and baseId
 * @this Ajv
 * @param  {Object} root root object with properties schema, refVal, refs
 * @param  {String} ref  reference to resolve
 * @return {Object} object with properties schema, root, baseId
 */
function resolveSchema(root, ref) {
  /* jshint validthis: true */
  var p = URI.parse(ref)
    , refPath = _getFullPath(p)
    , baseId = getFullPath(this._getId(root.schema));
  if (Object.keys(root.schema).length === 0 || refPath !== baseId) {
    var id = normalizeId(refPath);
    var refVal = this._refs[id];
    if (typeof refVal == 'string') {
      return resolveRecursive.call(this, root, refVal, p);
    } else if (refVal instanceof SchemaObject) {
      if (!refVal.validate) this._compile(refVal);
      root = refVal;
    } else {
      refVal = this._schemas[id];
      if (refVal instanceof SchemaObject) {
        if (!refVal.validate) this._compile(refVal);
        if (id == normalizeId(ref))
          return { schema: refVal, root: root, baseId: baseId };
        root = refVal;
      } else {
        return;
      }
    }
    if (!root.schema) return;
    baseId = getFullPath(this._getId(root.schema));
  }
  return getJsonPointer.call(this, p, baseId, root.schema, root);
}


/* @this Ajv */
function resolveRecursive(root, ref, parsedRef) {
  /* jshint validthis: true */
  var res = resolveSchema.call(this, root, ref);
  if (res) {
    var schema = res.schema;
    var baseId = res.baseId;
    root = res.root;
    var id = this._getId(schema);
    if (id) baseId = resolveUrl(baseId, id);
    return getJsonPointer.call(this, parsedRef, baseId, schema, root);
  }
}


var PREVENT_SCOPE_CHANGE = util.toHash(['properties', 'patternProperties', 'enum', 'dependencies', 'definitions']);
/* @this Ajv */
function getJsonPointer(parsedRef, baseId, schema, root) {
  /* jshint validthis: true */
  parsedRef.fragment = parsedRef.fragment || '';
  if (parsedRef.fragment.slice(0,1) != '/') return;
  var parts = parsedRef.fragment.split('/');

  for (var i = 1; i < parts.length; i++) {
    var part = parts[i];
    if (part) {
      part = util.unescapeFragment(part);
      schema = schema[part];
      if (schema === undefined) break;
      var id;
      if (!PREVENT_SCOPE_CHANGE[part]) {
        id = this._getId(schema);
        if (id) baseId = resolveUrl(baseId, id);
        if (schema.$ref) {
          var $ref = resolveUrl(baseId, schema.$ref);
          var res = resolveSchema.call(this, root, $ref);
          if (res) {
            schema = res.schema;
            root = res.root;
            baseId = res.baseId;
          }
        }
      }
    }
  }
  if (schema !== undefined && schema !== root.schema)
    return { schema: schema, root: root, baseId: baseId };
}


var SIMPLE_INLINED = util.toHash([
  'type', 'format', 'pattern',
  'maxLength', 'minLength',
  'maxProperties', 'minProperties',
  'maxItems', 'minItems',
  'maximum', 'minimum',
  'uniqueItems', 'multipleOf',
  'required', 'enum'
]);
function inlineRef(schema, limit) {
  if (limit === false) return false;
  if (limit === undefined || limit === true) return checkNoRef(schema);
  else if (limit) return countKeys(schema) <= limit;
}


function checkNoRef(schema) {
  var item;
  if (Array.isArray(schema)) {
    for (var i=0; i<schema.length; i++) {
      item = schema[i];
      if (typeof item == 'object' && !checkNoRef(item)) return false;
    }
  } else {
    for (var key in schema) {
      if (key == '$ref') return false;
      item = schema[key];
      if (typeof item == 'object' && !checkNoRef(item)) return false;
    }
  }
  return true;
}


function countKeys(schema) {
  var count = 0, item;
  if (Array.isArray(schema)) {
    for (var i=0; i<schema.length; i++) {
      item = schema[i];
      if (typeof item == 'object') count += countKeys(item);
      if (count == Infinity) return Infinity;
    }
  } else {
    for (var key in schema) {
      if (key == '$ref') return Infinity;
      if (SIMPLE_INLINED[key]) {
        count++;
      } else {
        item = schema[key];
        if (typeof item == 'object') count += countKeys(item) + 1;
        if (count == Infinity) return Infinity;
      }
    }
  }
  return count;
}


function getFullPath(id, normalize) {
  if (normalize !== false) id = normalizeId(id);
  var p = URI.parse(id);
  return _getFullPath(p);
}


function _getFullPath(p) {
  return URI.serialize(p).split('#')[0] + '#';
}


var TRAILING_SLASH_HASH = /#\/?$/;
function normalizeId(id) {
  return id ? id.replace(TRAILING_SLASH_HASH, '') : '';
}


function resolveUrl(baseId, id) {
  id = normalizeId(id);
  return URI.resolve(baseId, id);
}


/* @this Ajv */
function resolveIds(schema) {
  var schemaId = normalizeId(this._getId(schema));
  var baseIds = {'': schemaId};
  var fullPaths = {'': getFullPath(schemaId, false)};
  var localRefs = {};
  var self = this;

  traverse(schema, {allKeys: true}, function(sch, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (jsonPtr === '') return;
    var id = self._getId(sch);
    var baseId = baseIds[parentJsonPtr];
    var fullPath = fullPaths[parentJsonPtr] + '/' + parentKeyword;
    if (keyIndex !== undefined)
      fullPath += '/' + (typeof keyIndex == 'number' ? keyIndex : util.escapeFragment(keyIndex));

    if (typeof id == 'string') {
      id = baseId = normalizeId(baseId ? URI.resolve(baseId, id) : id);

      var refVal = self._refs[id];
      if (typeof refVal == 'string') refVal = self._refs[refVal];
      if (refVal && refVal.schema) {
        if (!equal(sch, refVal.schema))
          throw new Error('id "' + id + '" resolves to more than one schema');
      } else if (id != normalizeId(fullPath)) {
        if (id[0] == '#') {
          if (localRefs[id] && !equal(sch, localRefs[id]))
            throw new Error('id "' + id + '" resolves to more than one schema');
          localRefs[id] = sch;
        } else {
          self._refs[id] = fullPath;
        }
      }
    }
    baseIds[jsonPtr] = baseId;
    fullPaths[jsonPtr] = fullPath;
  });

  return localRefs;
}


/***/ }),

/***/ 91092:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48287)["Buffer"];
/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/



// 65536 is the size of a wasm memory page
// 64 is the maximum chunk size for every possible wasm hash implementation
// 4 is the maximum number of bytes per char for string encoding (max is utf-8)
// ~3 makes sure that it's always a block of 4 chars, so avoid partially encoded bytes for base64
const MAX_SHORT_STRING = Math.floor((65536 - 64) / 4) & ~3;

class WasmHash {
  /**
   * @param {WebAssembly.Instance} instance wasm instance
   * @param {WebAssembly.Instance[]} instancesPool pool of instances
   * @param {number} chunkSize size of data chunks passed to wasm
   * @param {number} digestSize size of digest returned by wasm
   */
  constructor(instance, instancesPool, chunkSize, digestSize) {
    const exports = /** @type {any} */ (instance.exports);

    exports.init();

    this.exports = exports;
    this.mem = Buffer.from(exports.memory.buffer, 0, 65536);
    this.buffered = 0;
    this.instancesPool = instancesPool;
    this.chunkSize = chunkSize;
    this.digestSize = digestSize;
  }

  reset() {
    this.buffered = 0;
    this.exports.init();
  }

  /**
   * @param {Buffer | string} data data
   * @param {BufferEncoding=} encoding encoding
   * @returns {this} itself
   */
  update(data, encoding) {
    if (typeof data === 'string') {
      while (data.length > MAX_SHORT_STRING) {
        this._updateWithShortString(data.slice(0, MAX_SHORT_STRING), encoding);
        data = data.slice(MAX_SHORT_STRING);
      }

      this._updateWithShortString(data, encoding);

      return this;
    }

    this._updateWithBuffer(data);

    return this;
  }

  /**
   * @param {string} data data
   * @param {BufferEncoding=} encoding encoding
   * @returns {void}
   */
  _updateWithShortString(data, encoding) {
    const { exports, buffered, mem, chunkSize } = this;

    let endPos;

    if (data.length < 70) {
      if (!encoding || encoding === 'utf-8' || encoding === 'utf8') {
        endPos = buffered;
        for (let i = 0; i < data.length; i++) {
          const cc = data.charCodeAt(i);

          if (cc < 0x80) {
            mem[endPos++] = cc;
          } else if (cc < 0x800) {
            mem[endPos] = (cc >> 6) | 0xc0;
            mem[endPos + 1] = (cc & 0x3f) | 0x80;
            endPos += 2;
          } else {
            // bail-out for weird chars
            endPos += mem.write(data.slice(i), endPos, encoding);
            break;
          }
        }
      } else if (encoding === 'latin1') {
        endPos = buffered;

        for (let i = 0; i < data.length; i++) {
          const cc = data.charCodeAt(i);

          mem[endPos++] = cc;
        }
      } else {
        endPos = buffered + mem.write(data, buffered, encoding);
      }
    } else {
      endPos = buffered + mem.write(data, buffered, encoding);
    }

    if (endPos < chunkSize) {
      this.buffered = endPos;
    } else {
      const l = endPos & ~(this.chunkSize - 1);

      exports.update(l);

      const newBuffered = endPos - l;

      this.buffered = newBuffered;

      if (newBuffered > 0) {
        mem.copyWithin(0, l, endPos);
      }
    }
  }

  /**
   * @param {Buffer} data data
   * @returns {void}
   */
  _updateWithBuffer(data) {
    const { exports, buffered, mem } = this;
    const length = data.length;

    if (buffered + length < this.chunkSize) {
      data.copy(mem, buffered, 0, length);

      this.buffered += length;
    } else {
      const l = (buffered + length) & ~(this.chunkSize - 1);

      if (l > 65536) {
        let i = 65536 - buffered;

        data.copy(mem, buffered, 0, i);
        exports.update(65536);

        const stop = l - buffered - 65536;

        while (i < stop) {
          data.copy(mem, 0, i, i + 65536);
          exports.update(65536);
          i += 65536;
        }

        data.copy(mem, 0, i, l - buffered);

        exports.update(l - buffered - i);
      } else {
        data.copy(mem, buffered, 0, l - buffered);

        exports.update(l);
      }

      const newBuffered = length + buffered - l;

      this.buffered = newBuffered;

      if (newBuffered > 0) {
        data.copy(mem, 0, length - newBuffered, length);
      }
    }
  }

  digest(type) {
    const { exports, buffered, mem, digestSize } = this;

    exports.final(buffered);

    this.instancesPool.push(this);

    const hex = mem.toString('latin1', 0, digestSize);

    if (type === 'hex') {
      return hex;
    }

    if (type === 'binary' || !type) {
      return Buffer.from(hex, 'hex');
    }

    return Buffer.from(hex, 'hex').toString(type);
  }
}

const create = (wasmModule, instancesPool, chunkSize, digestSize) => {
  if (instancesPool.length > 0) {
    const old = instancesPool.pop();

    old.reset();

    return old;
  } else {
    return new WasmHash(
      new WebAssembly.Instance(wasmModule),
      instancesPool,
      chunkSize,
      digestSize
    );
  }
};

module.exports = create;
module.exports.MAX_SHORT_STRING = MAX_SHORT_STRING;


/***/ }),

/***/ 91256:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var PurchaseInvoiceMixinView = api.importMixinModule('purchaseinvoice', 'views', 'arg');
var CustomPurchaseInvoiceView = /*#__PURE__*/function (_PurchaseInvoiceMixin) {
  function CustomPurchaseInvoiceView() {
    _classCallCheck(this, CustomPurchaseInvoiceView);
    return _callSuper(this, CustomPurchaseInvoiceView, arguments);
  }
  _inherits(CustomPurchaseInvoiceView, _PurchaseInvoiceMixin);
  return _createClass(CustomPurchaseInvoiceView, null, [{
    key: "options",
    value: function options() {
      var res = _superPropGet(CustomPurchaseInvoiceView, "options", this, 2)([]);
      var i = _.findIndex(res.fields, function (r) {
        return r.name == 'Type';
      });
      var invType = {
        name: 'InvType',
        label: 'Doc.',
        editor: 'select',
        defValue: '0',
        headerField: true,
        options: [{
          value: 'A',
          label: 'A'
        }, {
          value: 'B',
          label: 'B'
        }, {
          value: 'C',
          label: 'C'
        }, {
          value: 'T',
          label: 'T'
        }]
      };
      res.fields.splice(i + 1, 0, invType);
      var tipoComprobante = {
        name: 'TipoComprobanteId',
        label: 'Tipo comprobante',
        relation: 'tipocomprobante',
        optionLabels: function optionLabels(row) {
          return row && row.Codigo ? "".concat(row.Codigo, " \u2014 ").concat(row.Descripcion || '') : '';
        },
        setRelationTo: 'TipoComprobante',
        editor: 'vue-select',
        headerField: true,
        addBlank: true
      };
      res.fields.splice(i + 2, 0, tipoComprobante);
      var i3 = _.findIndex(res.fields, function (r) {
        return r.name == 'InvoiceDate';
      });
      var fiscalDate = {
        name: 'FiscalDate',
        label: 'Fecha Fiscal',
        editor: 'date',
        headerField: true,
        dateformat: "DD/MM/YYYY"
      };
      res.fields.splice(i3 + 1, 0, fiscalDate);
      var invTotal = _.find(res.fields, function (r) {
        return r.name == 'InvoiceTotal';
      });
      if (invTotal) {
        invTotal.computed = function (record) {
          var v = 0;
          var _iterator = _createForOfIteratorHelper(record.PurchaseInvoiceDetails),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var row = _step.value;
              if (row.Amount) v += parseFloat(row.Amount);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return v;
        };
      }
      var taxTab = _.find(res.fields, function (r) {
        return r.name == 'PurchaseInvoiceTaxes';
      });
      if (taxTab) {}
      var baseTotal = _.find(res.fields, function (r) {
        return r.name == 'BaseTotal';
      });
      if (baseTotal) {
        baseTotal.computed = function (record) {
          var v = 0;
          var _iterator2 = _createForOfIteratorHelper(record.PurchaseInvoiceTaxes),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var row = _step2.value;
              if (row.TaxCode && row.TaxCode.PerIIBB) continue;
              if (row.TaxCode && row.TaxCode.PerIVA) continue;
              if (row.TaxBase) v += parseFloat(row.TaxBase);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          return v;
        };
      }
      var taxTotal = _.find(res.fields, function (r) {
        return r.name == 'TaxTotal';
      });
      if (taxTotal) {
        taxTotal.computed = function (record) {
          var v = 0;
          var _iterator3 = _createForOfIteratorHelper(record.PurchaseInvoiceTaxes),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var row = _step3.value;
              //if (row.TaxCode && row.TaxCode.PerIIBB) continue;
              //if (row.TaxCode && row.TaxCode.PerIVA) continue;
              if (!row.TaxCode) continue;
              if (row.Amount) v += parseFloat(row.Amount);
              if (row.RestAmount) v += parseFloat(row.RestAmount);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          return v;
        };
      }
      var purchaseInvoiceTaxes = _.find(res.fields, function (r) {
        return r.name == 'PurchaseInvoiceTaxes';
      });
      if (purchaseInvoiceTaxes) {
        taxTab.rowFields.push({
          name: 'RestAmount',
          editor: 'number',
          columns: 2,
          decimal: 2,
          label: '- Impuesto'
        });
        var taxField = _.find(purchaseInvoiceTaxes.rowFields, function (r) {
          return r.name == 'TaxCodeId';
        });
        if (taxField) {
          taxField.afterEdit = CustomPurchaseInvoiceView.setAmount;
        }
        var taxBase = _.find(purchaseInvoiceTaxes.rowFields, function (r) {
          return r.name == 'TaxBase';
        });
        if (taxBase) {
          taxBase.afterEdit = CustomPurchaseInvoiceView.setAmount;
          taxBase.requiredCallback = function (row) {
            if (row.TaxCode && row.TaxCode.PerIIBB) return false;
            if (row.TaxCode && row.TaxCode.PerIVA) return false;
            if (row.TaxCode && row.TaxCode.TurIVA) return false;
            return true;
          };
        }
      }
      return res;
    }
  }, {
    key: "setAmount",
    value: function setAmount(row) {
      if (row.TaxCode && row.TaxBase) {
        row.Amount = parseFloat(row.TaxBase) * parseFloat(row.TaxCode.Value) / 100.0;
        if (row.TaxCode && row.TaxCode.TurIVA) {
          row.RestAmount = -row.Amount;
        } else {
          row.RestAmount = null;
        }
      }
    }
  }]);
}(PurchaseInvoiceMixinView);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomPurchaseInvoiceView);

/***/ }),

/***/ 91565:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


// eslint-disable-next-line no-multi-assign
exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__(53209);

// eslint-disable-next-line no-multi-assign
exports.createHash = exports.Hash = __webpack_require__(47108);

// eslint-disable-next-line no-multi-assign
exports.createHmac = exports.Hmac = __webpack_require__(83507);

var algos = __webpack_require__(55715);
var algoKeys = Object.keys(algos);
var hashes = [
	'sha1',
	'sha224',
	'sha256',
	'sha384',
	'sha512',
	'md5',
	'rmd160'
].concat(algoKeys);

exports.getHashes = function () {
	return hashes;
};

var p = __webpack_require__(78396);
exports.pbkdf2 = p.pbkdf2;
exports.pbkdf2Sync = p.pbkdf2Sync;

var aes = __webpack_require__(30125);

exports.Cipher = aes.Cipher;
exports.createCipher = aes.createCipher;
exports.Cipheriv = aes.Cipheriv;
exports.createCipheriv = aes.createCipheriv;
exports.Decipher = aes.Decipher;
exports.createDecipher = aes.createDecipher;
exports.Decipheriv = aes.Decipheriv;
exports.createDecipheriv = aes.createDecipheriv;
exports.getCiphers = aes.getCiphers;
exports.listCiphers = aes.listCiphers;

var dh = __webpack_require__(15380);

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup;
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup;
exports.getDiffieHellman = dh.getDiffieHellman;
exports.createDiffieHellman = dh.createDiffieHellman;
exports.DiffieHellman = dh.DiffieHellman;

var sign = __webpack_require__(20);

exports.createSign = sign.createSign;
exports.Sign = sign.Sign;
exports.createVerify = sign.createVerify;
exports.Verify = sign.Verify;

exports.createECDH = __webpack_require__(61324);

var publicEncrypt = __webpack_require__(97168);

exports.publicEncrypt = publicEncrypt.publicEncrypt;
exports.privateEncrypt = publicEncrypt.privateEncrypt;
exports.publicDecrypt = publicEncrypt.publicDecrypt;
exports.privateDecrypt = publicEncrypt.privateDecrypt;

// the least I can do is make error messages for the rest of the node.js/crypto api.
// [
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error('sorry, ' + name + ' is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
//   };
// });

var rf = __webpack_require__(76983);

exports.randomFill = rf.randomFill;
exports.randomFillSync = rf.randomFillSync;

exports.createCredentials = function () {
	throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};

exports.constants = {
	DH_CHECK_P_NOT_SAFE_PRIME: 2,
	DH_CHECK_P_NOT_PRIME: 1,
	DH_UNABLE_TO_CHECK_GENERATOR: 4,
	DH_NOT_SUITABLE_GENERATOR: 8,
	NPN_ENABLED: 1,
	ALPN_ENABLED: 1,
	RSA_PKCS1_PADDING: 1,
	RSA_SSLV23_PADDING: 2,
	RSA_NO_PADDING: 3,
	RSA_PKCS1_OAEP_PADDING: 4,
	RSA_X931_PADDING: 5,
	RSA_PKCS1_PSS_PADDING: 6,
	POINT_CONVERSION_COMPRESSED: 2,
	POINT_CONVERSION_UNCOMPRESSED: 4,
	POINT_CONVERSION_HYBRID: 6
};


/***/ }),

/***/ 92297:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


/***/ }),

/***/ 92356:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aes = __webpack_require__(50462)
var Buffer = (__webpack_require__(92861).Buffer)
var Transform = __webpack_require__(56168)
var inherits = __webpack_require__(56698)
var GHASH = __webpack_require__(25892)
var xor = __webpack_require__(30295)
var incr32 = __webpack_require__(45122)

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher


/***/ }),

/***/ 92493:
/***/ ((module) => {

"use strict";


module.exports = {
  //NODE_ENV: "production",
  SERVER_ENDPOINT: "https://api-support.nubbo.io",
  EXTRAS: ["admin", "contacts", "taxes", "accounting", "crm", "arg", "vamoos", "ai", "custom"],
  FRONT_URL: "https://support.nubbo.io",
  API_GOOGLE_MAP: "AIzaSyAqSLEPJ7HAQYPi07V0XSJ1rS1fKYNkRLs",
  API_GOOGLE_MAP_ID: "a2c421d48f6df0c3efb962b6",
  APP_NAME: "Designer Trips",
  MAP_ICON: "logo.png",
  DOMAINS: ["localhost", "support.nubbo.io"],
  COST_CONTROL: false,
  LANG_CODE: "es",
  DEV_TEST: true,
  DEF_EXCHANGE: true,
  SERVER_SIDE: {
    'hotel': true,
    'supplier': true,
    'hotelcost': true
  }
};

/***/ }),

/***/ 92572:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^(maart|mrt\.?)$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),

/***/ 92702:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8818);









function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var CashOutView = /*#__PURE__*/function (_View) {
  function CashOutView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, CashOutView);
    return _callSuper(this, CashOutView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(CashOutView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(CashOutView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res, paymentTypeId;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(CashOutView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              res = _context.sent;
              paymentTypeId = res.fields.find(function (field) {
                return field.name == 'PaymentTypeId';
              });
              paymentTypeId.filters = function (row) {
                return row.CashOut;
              };
              res.fields.splice(res.fields.indexOf(res.fields.find(function (field) {
                return field.name == 'CurrencyRate';
              })), 1);
              res.fields.splice(res.fields.indexOf(res.fields.find(function (field) {
                return field.name == 'FromCurrencyId';
              })), 1);
              res.fields.splice(res.fields.indexOf(res.fields.find(function (field) {
                return field.name == 'ToCurrencyId';
              })), 1);
              res.canAdd = true;
              res.serverSide = true;
              res.fields.push({
                name: 'currencyConvertTab',
                label: 'Currency Rate',
                editor: 'tab',
                hideFromList: true,
                fields: [{
                  name: 'FromCurrencyId',
                  relation: 'currency',
                  optionLabels: 'id',
                  editor: 'select',
                  label: 'From',
                  required: true
                }, {
                  name: 'ToCurrencyId',
                  relation: 'currency',
                  optionLabels: 'id',
                  editor: 'select',
                  label: 'To',
                  required: true
                }, {
                  name: 'CurrencyRate',
                  editor: 'number',
                  columns: 2,
                  decimal: 2,
                  label: 'Rate',
                  required: true
                }]
              });
              return _context.abrupt("return", res);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_4__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(CashOutView, "table", 'cashout');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CashOutView);

/***/ }),

/***/ 92801:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = (__webpack_require__(77965).Buffer);
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);


/***/ }),

/***/ 92861:
/***/ ((module, exports, __webpack_require__) => {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(48287)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 92884:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var xor = __webpack_require__(30295)

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),

/***/ 92901:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ _createClass)
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20816);

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}


/***/ }),

/***/ 93382:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Buffer = (__webpack_require__(92861).Buffer)

module.exports = function (thing, encoding, name) {
  if (Buffer.isBuffer(thing)) {
    return thing
  } else if (typeof thing === 'string') {
    return Buffer.from(thing, encoding)
  } else if (ArrayBuffer.isView(thing)) {
    return Buffer.from(thing.buffer)
  } else {
    throw new TypeError(name + ' must be a string, a Buffer, a typed array or a DataView')
  }
}


/***/ }),

/***/ 93383:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone:
                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                    '_'
                ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


/***/ }),

/***/ 93601:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


/***/ }),

/***/ 93662:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const path = __webpack_require__(57975);

function isUrlRequest(url, root) {
  // An URL is not an request if

  // 1. It's an absolute url and it is not `windows` path like `C:\dir\file`
  if (/^[a-z][a-z0-9+.-]*:/i.test(url) && !path.win32.isAbsolute(url)) {
    return false;
  }

  // 2. It's a protocol-relative
  if (/^\/\//.test(url)) {
    return false;
  }

  // 3. It's some kind of url for a template
  if (/^[{}[\]#*;,'§$%&(=?`´^°<>]/.test(url)) {
    return false;
  }

  // 4. It's also not an request if root isn't set and it's a root-relative url
  if ((root === undefined || root === false) && /^\//.test(url)) {
    return false;
  }

  return true;
}

module.exports = isUrlRequest;


/***/ }),

/***/ 94006:
/***/ ((module) => {

"use strict";



var Cache = module.exports = function Cache() {
  this._cache = {};
};


Cache.prototype.put = function Cache_put(key, value) {
  this._cache[key] = value;
};


Cache.prototype.get = function Cache_get(key) {
  return this._cache[key];
};


Cache.prototype.del = function Cache_del(key) {
  delete this._cache[key];
};


Cache.prototype.clear = function Cache_clear() {
  this._cache = {};
};


/***/ }),

/***/ 94418:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative =
            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
                '_'
            ),
        monthsSubjective =
            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
                '_'
            ),
        monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays:
            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


/***/ }),

/***/ 94576:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8818);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var InvoiceView = /*#__PURE__*/function (_View) {
  function InvoiceView() {
    _classCallCheck(this, InvoiceView);
    return _callSuper(this, InvoiceView, arguments);
  }
  _inherits(InvoiceView, _View);
  return _createClass(InvoiceView, null, [{
    key: "options",
    value: function options() {
      return {
        canAdd: true,
        canEdit: true,
        canCopy: true,
        title: 'Invoice',
        setTitleName: function setTitleName(self) {
          var res = 'Invoice';
          if (self.InvoiceNumber) res += ' ' + self.InvoiceNumber;
          return res;
        },
        fieldsDataReplace: {
          InvoiceDetails: {
            name: 'InvoiceDetails',
            editor: [],
            label: 'Detail',
            rowFields: [{
              name: 'BookingDayServiceId',
              hidden: true
            }, {
              name: 'BookingRoomId',
              hidden: true
            }, {
              name: 'BookingFlightId',
              hidden: true
            }, {
              name: 'Detail',
              label: 'Concept',
              columns: 6
            }, {
              name: 'Amount',
              label: 'Amount',
              editor: 'number',
              columns: 2,
              decimal: 2
            }, {
              name: 'TaxCodeId',
              relation: 'taxcode',
              optionLabels: 'Name',
              setRelationTo: 'TaxCode',
              editor: 'select',
              label: 'Tax',
              required: true,
              columns: 2
            }]
          }
        }
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(InvoiceView, "getTableOptions", this, 2)([this.options()]);
            case 2:
              res = _context.sent;
              res.fields.push({
                name: 'InvoiceTotal',
                label: 'Total',
                headerField: true,
                readonly: true,
                editor: 'number',
                hideFromList: true,
                decimal: 2,
                columns: 2,
                computed: function computed(record) {
                  return record.totalAmount;
                }
              });
              return _context.abrupt("return", res);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_0__["default"]);
_defineProperty(InvoiceView, "table", 'invoice');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InvoiceView);

/***/ }),

/***/ 94643:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!__webpack_require__.g.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = __webpack_require__.g.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}


/***/ }),

/***/ 95050:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort:
            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


/***/ }),

/***/ 95093:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    0
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            "object" !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = undefined;
                __webpack_require__(35358)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));


/***/ }),

/***/ 95314:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var util = __webpack_require__(23949);

module.exports = function defFunc(ajv) {
  if (ajv.RULES.keywords.switch && ajv.RULES.keywords.if) return;

  var metaSchemaRef = util.metaSchemaRef(ajv);

  defFunc.definition = {
    inline: __webpack_require__(12995),
    statements: true,
    errors: 'full',
    metaSchema: {
      type: 'array',
      items: {
        required: [ 'then' ],
        properties: {
          'if': metaSchemaRef,
          'then': {
            anyOf: [
              { type: 'boolean' },
              metaSchemaRef
            ]
          },
          'continue': { type: 'boolean' }
        },
        additionalProperties: false,
        dependencies: {
          'continue': [ 'if' ]
        }
      }
    }
  };

  ajv.addKeyword('switch', defFunc.definition);
  return ajv;
};


/***/ }),

/***/ 95326:
/***/ ((module) => {

"use strict";

module.exports = function generate_oneOf(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $currentBaseId = $it.baseId,
    $prevValid = 'prevValid' + $lvl,
    $passingSchemas = 'passingSchemas' + $lvl;
  out += 'var ' + ($errs) + ' = errors , ' + ($prevValid) + ' = false , ' + ($valid) + ' = false , ' + ($passingSchemas) + ' = null; ';
  var $wasComposite = it.compositeRule;
  it.compositeRule = $it.compositeRule = true;
  var arr1 = $schema;
  if (arr1) {
    var $sch, $i = -1,
      l1 = arr1.length - 1;
    while ($i < l1) {
      $sch = arr1[$i += 1];
      if ((it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all))) {
        $it.schema = $sch;
        $it.schemaPath = $schemaPath + '[' + $i + ']';
        $it.errSchemaPath = $errSchemaPath + '/' + $i;
        out += '  ' + (it.validate($it)) + ' ';
        $it.baseId = $currentBaseId;
      } else {
        out += ' var ' + ($nextValid) + ' = true; ';
      }
      if ($i) {
        out += ' if (' + ($nextValid) + ' && ' + ($prevValid) + ') { ' + ($valid) + ' = false; ' + ($passingSchemas) + ' = [' + ($passingSchemas) + ', ' + ($i) + ']; } else { ';
        $closingBraces += '}';
      }
      out += ' if (' + ($nextValid) + ') { ' + ($valid) + ' = ' + ($prevValid) + ' = true; ' + ($passingSchemas) + ' = ' + ($i) + '; }';
    }
  }
  it.compositeRule = $it.compositeRule = $wasComposite;
  out += '' + ($closingBraces) + 'if (!' + ($valid) + ') {   var err =   '; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('oneOf') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { passingSchemas: ' + ($passingSchemas) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should match exactly one schema in oneOf\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError(vErrors); ';
    } else {
      out += ' validate.errors = vErrors; return false; ';
    }
  }
  out += '} else {  errors = ' + ($errs) + '; if (vErrors !== null) { if (' + ($errs) + ') vErrors.length = ' + ($errs) + '; else vErrors = null; }';
  if (it.opts.allErrors) {
    out += ' } ';
  }
  return out;
}


/***/ }),

/***/ 95533:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays:
            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
                '_'
            ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


/***/ }),

/***/ 95961:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8818);





function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var TermsAndConditionsView = /*#__PURE__*/function (_View) {
  function TermsAndConditionsView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, TermsAndConditionsView);
    return _callSuper(this, TermsAndConditionsView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(TermsAndConditionsView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(TermsAndConditionsView, null, [{
    key: "getTableOptions",
    value:
    //static table = 'setting';

    function getTableOptions() {
      return {
        fields: [{
          name: 'LanguageId',
          relation: 'language',
          optionLabels: 'Name',
          editor: 'select',
          label: 'Language',
          required: true
        }, {
          name: 'Terms',
          label: 'Text',
          editor: 'text-area-style',
          hideFromList: true,
          columns: 12
        }],
        canAdd: true,
        title: 'Terms and Conditions',
        tableName: 'settings',
        apiEndpoint: '/api/termsandconditions/'
      };
    }
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_2__["default"]);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TermsAndConditionsView);

/***/ }),

/***/ 95995:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


/***/ }),

/***/ 96016:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var IDENTIFIER = /^[a-z_$][a-z0-9_$-]*$/i;
var customRuleCode = __webpack_require__(7992);
var definitionSchema = __webpack_require__(22897);

module.exports = {
  add: addKeyword,
  get: getKeyword,
  remove: removeKeyword,
  validate: validateKeyword
};


/**
 * Define custom keyword
 * @this  Ajv
 * @param {String} keyword custom keyword, should be unique (including different from all standard, custom and macro keywords).
 * @param {Object} definition keyword definition object with properties `type` (type(s) which the keyword applies to), `validate` or `compile`.
 * @return {Ajv} this for method chaining
 */
function addKeyword(keyword, definition) {
  /* jshint validthis: true */
  /* eslint no-shadow: 0 */
  var RULES = this.RULES;
  if (RULES.keywords[keyword])
    throw new Error('Keyword ' + keyword + ' is already defined');

  if (!IDENTIFIER.test(keyword))
    throw new Error('Keyword ' + keyword + ' is not a valid identifier');

  if (definition) {
    this.validateKeyword(definition, true);

    var dataType = definition.type;
    if (Array.isArray(dataType)) {
      for (var i=0; i<dataType.length; i++)
        _addRule(keyword, dataType[i], definition);
    } else {
      _addRule(keyword, dataType, definition);
    }

    var metaSchema = definition.metaSchema;
    if (metaSchema) {
      if (definition.$data && this._opts.$data) {
        metaSchema = {
          anyOf: [
            metaSchema,
            { '$ref': 'https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#' }
          ]
        };
      }
      definition.validateSchema = this.compile(metaSchema, true);
    }
  }

  RULES.keywords[keyword] = RULES.all[keyword] = true;


  function _addRule(keyword, dataType, definition) {
    var ruleGroup;
    for (var i=0; i<RULES.length; i++) {
      var rg = RULES[i];
      if (rg.type == dataType) {
        ruleGroup = rg;
        break;
      }
    }

    if (!ruleGroup) {
      ruleGroup = { type: dataType, rules: [] };
      RULES.push(ruleGroup);
    }

    var rule = {
      keyword: keyword,
      definition: definition,
      custom: true,
      code: customRuleCode,
      implements: definition.implements
    };
    ruleGroup.rules.push(rule);
    RULES.custom[keyword] = rule;
  }

  return this;
}


/**
 * Get keyword
 * @this  Ajv
 * @param {String} keyword pre-defined or custom keyword.
 * @return {Object|Boolean} custom keyword definition, `true` if it is a predefined keyword, `false` otherwise.
 */
function getKeyword(keyword) {
  /* jshint validthis: true */
  var rule = this.RULES.custom[keyword];
  return rule ? rule.definition : this.RULES.keywords[keyword] || false;
}


/**
 * Remove keyword
 * @this  Ajv
 * @param {String} keyword pre-defined or custom keyword.
 * @return {Ajv} this for method chaining
 */
function removeKeyword(keyword) {
  /* jshint validthis: true */
  var RULES = this.RULES;
  delete RULES.keywords[keyword];
  delete RULES.all[keyword];
  delete RULES.custom[keyword];
  for (var i=0; i<RULES.length; i++) {
    var rules = RULES[i].rules;
    for (var j=0; j<rules.length; j++) {
      if (rules[j].keyword == keyword) {
        rules.splice(j, 1);
        break;
      }
    }
  }
  return this;
}


/**
 * Validate keyword definition
 * @this  Ajv
 * @param {Object} definition keyword definition object.
 * @param {Boolean} throwError true to throw exception if definition is invalid
 * @return {boolean} validation result
 */
function validateKeyword(definition, throwError) {
  validateKeyword.errors = null;
  var v = this._validateKeyword = this._validateKeyword
                                  || this.compile(definitionSchema, true);

  if (v(definition)) return true;
  validateKeyword.errors = v.errors;
  if (throwError)
    throw new Error('custom keyword definition is invalid: '  + this.errorsText(v.errors));
  else
    return false;
}


/***/ }),

/***/ 96496:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8818);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingFlightQuoteView = /*#__PURE__*/function (_View) {
  function BookingFlightQuoteView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingFlightQuoteView);
    return _callSuper(this, BookingFlightQuoteView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingFlightQuoteView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingFlightQuoteView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", {
                fields: [{
                  name: 'Include',
                  defValue: true
                }, {
                  name: 'Groups'
                }, {
                  name: 'Variants',
                  defValue: true
                }]
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingFlightQuoteView, "table", 'bookingflightquote');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingFlightQuoteView);

/***/ }),

/***/ 96740:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";



module.exports = {
  copy: copy,
  checkDataType: checkDataType,
  checkDataTypes: checkDataTypes,
  coerceToTypes: coerceToTypes,
  toHash: toHash,
  getProperty: getProperty,
  escapeQuotes: escapeQuotes,
  equal: __webpack_require__(32017),
  ucs2length: __webpack_require__(29853),
  varOccurences: varOccurences,
  varReplace: varReplace,
  schemaHasRules: schemaHasRules,
  schemaHasRulesExcept: schemaHasRulesExcept,
  schemaUnknownRules: schemaUnknownRules,
  toQuotedString: toQuotedString,
  getPathExpr: getPathExpr,
  getPath: getPath,
  getData: getData,
  unescapeFragment: unescapeFragment,
  unescapeJsonPointer: unescapeJsonPointer,
  escapeFragment: escapeFragment,
  escapeJsonPointer: escapeJsonPointer
};


function copy(o, to) {
  to = to || {};
  for (var key in o) to[key] = o[key];
  return to;
}


function checkDataType(dataType, data, strictNumbers, negate) {
  var EQUAL = negate ? ' !== ' : ' === '
    , AND = negate ? ' || ' : ' && '
    , OK = negate ? '!' : ''
    , NOT = negate ? '' : '!';
  switch (dataType) {
    case 'null': return data + EQUAL + 'null';
    case 'array': return OK + 'Array.isArray(' + data + ')';
    case 'object': return '(' + OK + data + AND +
                          'typeof ' + data + EQUAL + '"object"' + AND +
                          NOT + 'Array.isArray(' + data + '))';
    case 'integer': return '(typeof ' + data + EQUAL + '"number"' + AND +
                           NOT + '(' + data + ' % 1)' +
                           AND + data + EQUAL + data +
                           (strictNumbers ? (AND + OK + 'isFinite(' + data + ')') : '') + ')';
    case 'number': return '(typeof ' + data + EQUAL + '"' + dataType + '"' +
                          (strictNumbers ? (AND + OK + 'isFinite(' + data + ')') : '') + ')';
    default: return 'typeof ' + data + EQUAL + '"' + dataType + '"';
  }
}


function checkDataTypes(dataTypes, data, strictNumbers) {
  switch (dataTypes.length) {
    case 1: return checkDataType(dataTypes[0], data, strictNumbers, true);
    default:
      var code = '';
      var types = toHash(dataTypes);
      if (types.array && types.object) {
        code = types.null ? '(': '(!' + data + ' || ';
        code += 'typeof ' + data + ' !== "object")';
        delete types.null;
        delete types.array;
        delete types.object;
      }
      if (types.number) delete types.integer;
      for (var t in types)
        code += (code ? ' && ' : '' ) + checkDataType(t, data, strictNumbers, true);

      return code;
  }
}


var COERCE_TO_TYPES = toHash([ 'string', 'number', 'integer', 'boolean', 'null' ]);
function coerceToTypes(optionCoerceTypes, dataTypes) {
  if (Array.isArray(dataTypes)) {
    var types = [];
    for (var i=0; i<dataTypes.length; i++) {
      var t = dataTypes[i];
      if (COERCE_TO_TYPES[t]) types[types.length] = t;
      else if (optionCoerceTypes === 'array' && t === 'array') types[types.length] = t;
    }
    if (types.length) return types;
  } else if (COERCE_TO_TYPES[dataTypes]) {
    return [dataTypes];
  } else if (optionCoerceTypes === 'array' && dataTypes === 'array') {
    return ['array'];
  }
}


function toHash(arr) {
  var hash = {};
  for (var i=0; i<arr.length; i++) hash[arr[i]] = true;
  return hash;
}


var IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
var SINGLE_QUOTE = /'|\\/g;
function getProperty(key) {
  return typeof key == 'number'
          ? '[' + key + ']'
          : IDENTIFIER.test(key)
            ? '.' + key
            : "['" + escapeQuotes(key) + "']";
}


function escapeQuotes(str) {
  return str.replace(SINGLE_QUOTE, '\\$&')
            .replace(/\n/g, '\\n')
            .replace(/\r/g, '\\r')
            .replace(/\f/g, '\\f')
            .replace(/\t/g, '\\t');
}


function varOccurences(str, dataVar) {
  dataVar += '[^0-9]';
  var matches = str.match(new RegExp(dataVar, 'g'));
  return matches ? matches.length : 0;
}


function varReplace(str, dataVar, expr) {
  dataVar += '([^0-9])';
  expr = expr.replace(/\$/g, '$$$$');
  return str.replace(new RegExp(dataVar, 'g'), expr + '$1');
}


function schemaHasRules(schema, rules) {
  if (typeof schema == 'boolean') return !schema;
  for (var key in schema) if (rules[key]) return true;
}


function schemaHasRulesExcept(schema, rules, exceptKeyword) {
  if (typeof schema == 'boolean') return !schema && exceptKeyword != 'not';
  for (var key in schema) if (key != exceptKeyword && rules[key]) return true;
}


function schemaUnknownRules(schema, rules) {
  if (typeof schema == 'boolean') return;
  for (var key in schema) if (!rules[key]) return key;
}


function toQuotedString(str) {
  return '\'' + escapeQuotes(str) + '\'';
}


function getPathExpr(currentPath, expr, jsonPointers, isNumber) {
  var path = jsonPointers // false by default
              ? '\'/\' + ' + expr + (isNumber ? '' : '.replace(/~/g, \'~0\').replace(/\\//g, \'~1\')')
              : (isNumber ? '\'[\' + ' + expr + ' + \']\'' : '\'[\\\'\' + ' + expr + ' + \'\\\']\'');
  return joinPaths(currentPath, path);
}


function getPath(currentPath, prop, jsonPointers) {
  var path = jsonPointers // false by default
              ? toQuotedString('/' + escapeJsonPointer(prop))
              : toQuotedString(getProperty(prop));
  return joinPaths(currentPath, path);
}


var JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
var RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function getData($data, lvl, paths) {
  var up, jsonPointer, data, matches;
  if ($data === '') return 'rootData';
  if ($data[0] == '/') {
    if (!JSON_POINTER.test($data)) throw new Error('Invalid JSON-pointer: ' + $data);
    jsonPointer = $data;
    data = 'rootData';
  } else {
    matches = $data.match(RELATIVE_JSON_POINTER);
    if (!matches) throw new Error('Invalid JSON-pointer: ' + $data);
    up = +matches[1];
    jsonPointer = matches[2];
    if (jsonPointer == '#') {
      if (up >= lvl) throw new Error('Cannot access property/index ' + up + ' levels up, current level is ' + lvl);
      return paths[lvl - up];
    }

    if (up > lvl) throw new Error('Cannot access data ' + up + ' levels up, current level is ' + lvl);
    data = 'data' + ((lvl - up) || '');
    if (!jsonPointer) return data;
  }

  var expr = data;
  var segments = jsonPointer.split('/');
  for (var i=0; i<segments.length; i++) {
    var segment = segments[i];
    if (segment) {
      data += getProperty(unescapeJsonPointer(segment));
      expr += ' && ' + data;
    }
  }
  return expr;
}


function joinPaths (a, b) {
  if (a == '""') return b;
  return (a + ' + ' + b).replace(/([^\\])' \+ '/g, '$1');
}


function unescapeFragment(str) {
  return unescapeJsonPointer(decodeURIComponent(str));
}


function escapeFragment(str) {
  return encodeURIComponent(escapeJsonPointer(str));
}


function escapeJsonPointer(str) {
  return str.replace(/~/g, '~0').replace(/\//g, '~1');
}


function unescapeJsonPointer(str) {
  return str.replace(/~1/g, '/').replace(/~0/g, '~');
}


/***/ }),

/***/ 96870:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort:
            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
                '_'
            ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


/***/ }),

/***/ 97168:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

exports.publicEncrypt = __webpack_require__(28902)
exports.privateDecrypt = __webpack_require__(77362)

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}


/***/ }),

/***/ 97326:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64467);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8818);






function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var AccessGroupView = /*#__PURE__*/function (_View) {
  function AccessGroupView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(this, AccessGroupView);
    return _callSuper(this, AccessGroupView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(AccessGroupView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(AccessGroupView, null, [{
    key: "getTableOptions",
    value: function getTableOptions() {
      return {
        fields: [{
          name: 'id',
          label: 'id',
          columns: 3
        }, {
          name: 'Description',
          label: 'Description',
          columns: 3
        }, {
          name: 'Permissions',
          editor: 'text-area',
          columns: 12,
          rows: 20
        }, {
          name: 'Closed',
          label: 'Closed',
          editor: 'checkbox',
          footerRow: true
        }, {
          name: 'permissions',
          fieldName: 'Permissions',
          editor: 'component',
          component: 'json-editor',
          label: 'Permissions'
        }],
        title: 'Access Group',
        canAdd: true
      };
    }
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_2__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(AccessGroupView, "table", 'accessgroup');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AccessGroupView);

/***/ }),

/***/ 97341:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8818);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var PaxLeadView = /*#__PURE__*/function (_View) {
  function PaxLeadView() {
    _classCallCheck(this, PaxLeadView);
    return _callSuper(this, PaxLeadView, arguments);
  }
  _inherits(PaxLeadView, _View);
  return _createClass(PaxLeadView, null, [{
    key: "fieldsToBlock",
    get: function get() {
      return ['SalesOriginId', 'CustomerTypeId', 'PaxName', 'SalesUserId', 'AgencyId', 'Phone', 'TripDate', 'PaxEmail', 'Phone'];
    }
  }, {
    key: "options",
    value: function options() {
      return {
        canAdd: true,
        serverSide: true,
        sortDesc: true,
        sortColumn: 'TransDate',
        actions: [{
          label: 'Create Quote',
          method: 'createQuote',
          id: 'createQuote',
          disabledIf: function disabledIf(record) {
            if (record.BookingId) return true;
          }
        }],
        fieldsAbmList: ['TransDate', 'BookingId', 'PaxName', 'Phone', 'TripDate', 'SalesOriginId', 'MarketId', 'SalesUserId', 'LeadValueId', 'LeadStatusId', 'CustomerTypeId', 'AgencyId'],
        fieldsOrder: ['TransDate', 'BookingId', 'PaxName', 'Phone', 'TripDate', 'SalesOriginId', 'MarketId', 'SalesUserId', 'LeadValueId', 'LeadStatusId', 'StatusDate', 'TripModeId', 'LeadBudgetId', 'CountryId', 'CustomerTypeId', 'AgencyId', 'CampaignId', 'SubCampaignId', 'ReviewDate', 'PaxEmail', 'Comment', 'Note'],
        getEndpoint: '/api/paxlead/?SalesUserId=' + api.currentUser.id,
        fieldsDataReplace: {
          TransDate: {
            name: 'TransDate',
            label: 'Date',
            editor: 'date',
            defValue: function defValue() {
              return moment(new Date()).format('YYYY-MM-DD');
            }
          },
          SalesUserId: {
            name: 'SalesUserId',
            label: 'Seller',
            editor: 'select',
            optionLabels: 'UserName',
            relation: 'user',
            setRelationTo: 'SalesUser',
            filters: function filters(row) {
              if (row.Department && row.Department.Sales && !row.Closed) return true;
            }
          }
        }
      };
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var manager, crm, res, sellerField, campaign, subCampaign, agencyField;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              manager = tools.canAccess(api.currentUser, 'api', 'GET', 'manager_actions', false);
              crm = tools.canAccess(this.user, "view", "GET", 'crm', false);
              _context.next = 4;
              return _superPropGet(PaxLeadView, "getTableOptions", this, 2)([this.options()]);
            case 4:
              res = _context.sent;
              res.fields.splice(1, 0, {
                name: 'BookingId',
                readonly: true,
                label: 'Coti'
              });
              sellerField = _.find(res.fields, function (r) {
                return r.name == 'SalesUserId';
              });
              if (sellerField && !manager && !crm) {
                sellerField.disabled = true;
                sellerField.readonly = true;
                sellerField.defValue = function () {
                  return api.currentUser.id;
                };
              }
              res.fields.push({
                name: 'AttachTab',
                editor: 'tab',
                label: 'Attachments',
                hideFromList: true,
                icon: 'paperclip',
                fields: [{
                  name: 'Attach',
                  label: 'Attachments',
                  editor: 'attach',
                  columns: 12
                }],
                showIf: function showIf(record) {
                  return record.id;
                }
              });
              res.evalDelete = function (record) {
                if (!tools.canAccess(api.currentUser, 'api', 'GET', 'manager_actions', false) && !crm) return false;
                return true;
              };
              campaign = _.find(res.fields, function (r) {
                return r.name == 'CampaignId';
              });
              if (campaign) {
                campaign.hideIf = function (record) {
                  return !record.SalesOrigin || !record.SalesOrigin.MktCampaign;
                };
              }
              subCampaign = _.find(res.fields, function (r) {
                return r.name == 'SubCampaignId';
              });
              if (subCampaign) {
                subCampaign.hideIf = function (record) {
                  return !record.Campaign || !record.Campaign.WithSubCampaign;
                };
              }
              agencyField = _.find(res.fields, function (r) {
                return r.name == 'AgencyId';
              });
              if (agencyField) {
                agencyField.requiredCallback = function (r) {
                  if (r.CustomerType && r.CustomerType.Agency) return true;
                };
              }
              this.fieldsToBlock.forEach(function (fieldName) {
                var field = _.find(res.fields, function (r) {
                  return r.name == fieldName;
                });
                if (field) {
                  field.readonlyIf = function (row) {
                    if (row.BookingId) {
                      return true;
                    }
                    return false;
                  };
                  field.requiredCallback = function (row) {
                    if (row.BookingId) return false;
                    return field.required;
                  };
                  //field.required = false;
                }
              });
              return _context.abrupt("return", res);
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_0__["default"]);
_defineProperty(PaxLeadView, "table", 'paxlead');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PaxLeadView);

/***/ }),

/***/ 97439:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_views_view__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8818);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var BookingDayRoomView = /*#__PURE__*/function (_View) {
  function BookingDayRoomView() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, BookingDayRoomView);
    return _callSuper(this, BookingDayRoomView, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(BookingDayRoomView, _View);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingDayRoomView, null, [{
    key: "serviceStatusOptions",
    get: function get() {
      var res = [];
      for (var s in this.serviceStatus) {
        res.push({
          value: s,
          label: this.serviceStatus[s]
        });
      }
      return res;
    }
  }, {
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", {
                fields: [{
                  name: 'HotelId',
                  relation: 'hotel',
                  setRelationTo: 'Hotel',
                  optionLabels: 'Name'
                }, {
                  name: 'RoomTypeId',
                  relation: 'roomtype',
                  setRelationTo: 'Room',
                  optionLabels: 'Name'
                }, {
                  name: 'RoomCategory',
                  relation: 'roomcategory',
                  setRelationTo: 'Category',
                  optionLabels: 'Name'
                }, {
                  name: 'HotelCategoryId',
                  relation: 'hotelcategory',
                  setRelationTo: 'HotelCategory',
                  optionLabels: 'Name'
                }, {
                  name: 'CurrencyId'
                }, {
                  name: 'Rooms'
                }, {
                  name: 'TourLeader'
                }, {
                  name: 'SingleSupplement'
                }, {
                  name: 'Status',
                  editor: 'select',
                  options: this.serviceStatusOptions
                }, {
                  name: 'ReservationNumber'
                }, {
                  name: 'SupplierId',
                  relation: 'supplier',
                  optionLabels: 'Name',
                  setRelationTo: 'Supplier'
                }, {
                  name: 'QuoteList',
                  editor: {},
                  objectClass: 'hotelquotelist'
                }, {
                  name: 'ExcludeQuotation'
                }]
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(_base_views_view__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingDayRoomView, "table", 'bookingdayroom');
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(BookingDayRoomView, "serviceStatus", {
  PENDING: 'Pending',
  REQUESTED: 'Requested',
  CONFIRMED: 'Confirmed',
  CANCELED: 'Canceled'
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingDayRoomView);

/***/ }),

/***/ 97650:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),

/***/ 97711:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort:
            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
                '_'
            ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


/***/ }),

/***/ 98174:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays:
            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
                '_'
            ),
        weekdaysShort:
            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


/***/ }),

/***/ 98208:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48287)["Buffer"];


var CONSTRUCTORS = {
  Object: Object,
  Array: Array,
  Function: Function,
  Number: Number,
  String: String,
  Date: Date,
  RegExp: RegExp
};

module.exports = function defFunc(ajv) {
  /* istanbul ignore else */
  if (typeof Buffer != 'undefined')
    CONSTRUCTORS.Buffer = Buffer;

  /* istanbul ignore else */
  if (typeof Promise != 'undefined')
    CONSTRUCTORS.Promise = Promise;

  defFunc.definition = {
    compile: function (schema) {
      if (typeof schema == 'string') {
        var Constructor = getConstructor(schema);
        return function (data) {
          return data instanceof Constructor;
        };
      }

      var constructors = schema.map(getConstructor);
      return function (data) {
        for (var i=0; i<constructors.length; i++)
          if (data instanceof constructors[i]) return true;
        return false;
      };
    },
    CONSTRUCTORS: CONSTRUCTORS,
    metaSchema: {
      anyOf: [
        { type: 'string' },
        {
          type: 'array',
          items: { type: 'string' }
        }
      ]
    }
  };

  ajv.addKeyword('instanceof', defFunc.definition);
  return ajv;

  function getConstructor(c) {
    var Constructor = CONSTRUCTORS[c];
    if (Constructor) return Constructor;
    throw new Error('invalid "instanceof" keyword value ' + c);
  }
};


/***/ }),

/***/ 98658:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Record = api.importMixinModule('booking', 'model', 'crm');
var CrmBooking = /*#__PURE__*/function (_Record) {
  function CrmBooking() {
    _classCallCheck(this, CrmBooking);
    return _callSuper(this, CrmBooking, arguments);
  }
  _inherits(CrmBooking, _Record);
  return _createClass(CrmBooking, null, [{
    key: "get",
    value: function () {
      var _get2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
        var id, isTemplate, payments, receipts, r;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              id = _ref.id, isTemplate = _ref.isTemplate, payments = _ref.payments, receipts = _ref.receipts;
              _context.next = 3;
              return _superPropGet(CrmBooking, "get", this, 2)([{
                id: id,
                isTemplate: isTemplate,
                payments: true,
                receipts: true
              }]);
            case 3:
              r = _context.sent;
              if (!(r !== null && r !== void 0 && r.PaxLeadId && !r.Title)) {
                _context.next = 20;
                break;
              }
              if (!r.SalesUserId) {
                _context.next = 8;
                break;
              }
              _context.next = 8;
              return r.setSalesOrigin();
            case 8:
              if (!r.SalesOriginId) {
                _context.next = 11;
                break;
              }
              _context.next = 11;
              return r.setSalesOrigin();
            case 11:
              if (!r.CustomerTypeId) {
                _context.next = 14;
                break;
              }
              _context.next = 14;
              return r.setCustomerTypeId();
            case 14:
              if (!r.StartDate) {
                _context.next = 17;
                break;
              }
              _context.next = 17;
              return r.changeDate(null, true);
            case 17:
              if (!r.AgencyId) {
                _context.next = 20;
                break;
              }
              _context.next = 20;
              return r.setAgency();
            case 20:
              return _context.abrupt("return", r);
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function get(_x) {
        return _get2.apply(this, arguments);
      }
      return get;
    }()
  }]);
}(Record);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CrmBooking);

/***/ }),

/***/ 98881:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90991);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_record__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55539);









function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0,_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)((0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }

var BookingPayment = /*#__PURE__*/function (_Record) {
  function BookingPayment() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(this, BookingPayment);
    return _callSuper(this, BookingPayment, arguments);
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(BookingPayment, _Record);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(BookingPayment, [{
    key: "setCurrencyRate",
    value: function () {
      var _setCurrencyRate = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var _this = this;
        var currencyconversion, cc, rate, _cc;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.FromCurrencyId && this.ToCurrencyId && this.CurrencyRate)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return api.getTable('currencyconversion');
            case 4:
              currencyconversion = _context.sent;
              cc = _.find(currencyconversion, function (r) {
                if (r.FromCurrencyId == _this.FromCurrencyId && r.ToCurrencyId == _this.ToCurrencyId) return true;
                if (r.FromCurrencyId == _this.ToCurrencyId && r.ToCurrencyId == _this.FromCurrencyId) return true;
              });
              if (cc) {
                _context.next = 11;
                break;
              }
              cc = _.find(currencyconversion, function (r) {
                if (r.FromCurrencyId == _this.FromCurrencyId) return true;
              });
              if (cc) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return");
            case 10:
              this.$ToCurrencyId.value = cc.ToCurrencyId;
            case 11:
              if (cc) {
                _context.next = 13;
                break;
              }
              return _context.abrupt("return");
            case 13:
              _context.next = 15;
              return travelTools.getCurrencyRate(cc, 'purchase');
            case 15:
              rate = _context.sent;
              if (rate) {
                this.$FromCurrencyId.value = rate.FromCurrencyId;
                this.$ToCurrencyId.value = rate.ToCurrencyId;
                this.$CurrencyRate.value = rate.ConversionRate;
              }
              if (!this.CurrencyRate) {
                _cc = _.find(api.CurrencyRates, function (r) {
                  return r.FromCurrencyId == _this.FromCurrencyId && r.ToCurrencyId == _this.ToCurrencyId;
                });
                if (_cc) {
                  this.$CurrencyRate.value = _cc.Rate;
                }
              }
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function setCurrencyRate() {
        return _setCurrencyRate.apply(this, arguments);
      }
      return setCurrencyRate;
    }()
  }, {
    key: "afterEdit",
    value: function afterEdit() {
      return {
        CurrencyId: function () {
          var _CurrencyId = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(record) {
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(record.CurrencyId && record.Currency)) {
                    _context2.next = 5;
                    break;
                  }
                  if (record.Currency.Operation == 'DIVIDE') {
                    record.$ToCurrencyId.value = record.CurrencyId;
                    record.$FromCurrencyId.value = record.Currency.CurrencyConvertId;
                  }
                  if (record.Currency.Operation == 'MULTIPLY') {
                    record.$FromCurrencyId.value = record.CurrencyId;
                    record.$ToCurrencyId.value = record.Currency.CurrencyConvertId;
                  }
                  _context2.next = 5;
                  return record.setCurrencyRate();
                case 5:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          function CurrencyId(_x) {
            return _CurrencyId.apply(this, arguments);
          }
          return CurrencyId;
        }(),
        PaymentCurrencyId: function () {
          var _PaymentCurrencyId = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(record) {
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  if (!(record.PaymentCurrencyId && record.PaymentCurrency)) {
                    _context3.next = 5;
                    break;
                  }
                  if (record.PaymentCurrency.Operation == 'DIVIDE') {
                    record.$ToCurrencyId.value = record.PaymentCurrencyId;
                    record.$FromCurrencyId.value = record.PaymentCurrency.CurrencyConvertId;
                  }
                  if (record.PaymentCurrency.Operation == 'MULTIPLY') {
                    record.$FromCurrencyId.value = record.PaymentCurrencyId;
                    record.$ToCurrencyId.value = record.PaymentCurrency.CurrencyConvertId;
                  }
                  _context3.next = 5;
                  return record.setCurrencyRate();
                case 5:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }));
          function PaymentCurrencyId(_x2) {
            return _PaymentCurrencyId.apply(this, arguments);
          }
          return PaymentCurrencyId;
        }(),
        SupplierId: function () {
          var _SupplierId = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(record) {
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  record.SupplierCreditId = null;
                  //record.OnAccountPaymentId = null;
                  _context4.next = 3;
                  return record.setSupplierCreditOptions();
                case 3:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          }));
          function SupplierId(_x3) {
            return _SupplierId.apply(this, arguments);
          }
          return SupplierId;
        }(),
        PaymentTypeId: function () {
          var _PaymentTypeId = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(record) {
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return record.setSupplierCreditOptions();
                case 2:
                case "end":
                  return _context5.stop();
              }
            }, _callee5);
          }));
          function PaymentTypeId(_x4) {
            return _PaymentTypeId.apply(this, arguments);
          }
          return PaymentTypeId;
        }(),
        PaymentStatus: function () {
          var _PaymentStatus = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(record) {
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return record.setPaymentStatus();
                case 2:
                case "end":
                  return _context6.stop();
              }
            }, _callee6);
          }));
          function PaymentStatus(_x5) {
            return _PaymentStatus.apply(this, arguments);
          }
          return PaymentStatus;
        }(),
        DueDate: function DueDate(record) {
          var today = moment(new Date()).format('YYYY-MM-DD');
          if (record.DueDate < today) {
            record.DueDate = today;
          }
        }
      };
    }
  }, {
    key: "setPaymentStatus",
    value: function () {
      var _setPaymentStatus = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function setPaymentStatus() {
        return _setPaymentStatus.apply(this, arguments);
      }
      return setPaymentStatus;
    }()
  }, {
    key: "setSupplierCreditOptions",
    value: function () {
      var _setSupplierCreditOptions = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8() {
        var fo, field;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              fo = {};
              field = _.find(this.fields, function (r) {
                return r.name == 'SupplierCreditId';
              });
              if (field) {
                if (this.PaymentType && this.PaymentType.OnAccount && this.Supplier && this.PaymentStatus == 'USED') {} else {
                  this.SupplierCreditId = null;
                }
              }
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function setSupplierCreditOptions() {
        return _setSupplierCreditOptions.apply(this, arguments);
      }
      return setSupplierCreditOptions;
    }()
  }, {
    key: "titleName",
    get: function get() {
      if (this.id) return "".concat(tr('Payment'), " ").concat(this.id);
      return tr('Payment');
    }
  }, {
    key: "getAmount",
    get: function get() {
      return this.Amount;
    }
  }, {
    key: "getCurrencyRate",
    get: function get() {
      return this.CurrencyRate;
    }
  }, {
    key: "checkFields",
    value: function () {
      var _checkFields = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee9() {
        var res, errors;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _superPropGet(BookingPayment, "checkFields", this, 3)([]);
            case 2:
              res = _context9.sent;
              if (!res) {
                _context9.next = 5;
                break;
              }
              return _context9.abrupt("return", res);
            case 5:
              this.invalid = {};
              errors = [];
              if (this.PaymentStatus == 'ON_ACCOUNT' || this.PaymentStatus == 'USED') {
                if (this.PaymentType && !this.PaymentType.OnAccount) {
                  errors.push('Invalid Payment Type for Credit');
                  this.invalid.PaymentTypeId = true;
                }
              }
              if (!(errors.length > 0)) {
                _context9.next = 10;
                break;
              }
              return _context9.abrupt("return", errors);
            case 10:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function checkFields() {
        return _checkFields.apply(this, arguments);
      }
      return checkFields;
    }()
  }]);
}(_base_model_record__WEBPACK_IMPORTED_MODULE_4__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(BookingPayment, "moduleName", 'bookingpayment');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BookingPayment);

/***/ }),

/***/ 99047:
/***/ ((module) => {

"use strict";


var sequences = {};

var DEFAULTS = {
  timestamp: function() { return Date.now(); },
  datetime: function() { return (new Date).toISOString(); },
  date: function() { return (new Date).toISOString().slice(0, 10); },
  time: function() { return (new Date).toISOString().slice(11); },
  random: function() { return Math.random(); },
  randomint: function (args) {
    var limit = args && args.max || 2;
    return function() { return Math.floor(Math.random() * limit); };
  },
  seq: function (args) {
    var name = args && args.name || '';
    sequences[name] = sequences[name] || 0;
    return function() { return sequences[name]++; };
  }
};

module.exports = function defFunc(ajv) {
  defFunc.definition = {
    compile: function (schema, parentSchema, it) {
      var funcs = {};

      for (var key in schema) {
        var d = schema[key];
        var func = getDefault(typeof d == 'string' ? d : d.func);
        funcs[key] = func.length ? func(d.args) : func;
      }

      return it.opts.useDefaults && !it.compositeRule
              ? assignDefaults
              : noop;

      function assignDefaults(data) {
        for (var prop in schema){
          if (data[prop] === undefined
            || (it.opts.useDefaults == 'empty'
            && (data[prop] === null || data[prop] === '')))
            data[prop] = funcs[prop]();
        }
        return true;
      }

      function noop() { return true; }
    },
    DEFAULTS: DEFAULTS,
    metaSchema: {
      type: 'object',
      additionalProperties: {
        type: ['string', 'object'],
        additionalProperties: false,
        required: ['func', 'args'],
        properties: {
          func: { type: 'string' },
          args: { type: 'object' }
        }
      }
    }
  };

  ajv.addKeyword('dynamicDefaults', defFunc.definition);
  return ajv;

  function getDefault(d) {
    var def = DEFAULTS[d];
    if (def) return def;
    throw new Error('invalid "dynamicDefaults" keyword property value: ' + d);
  }
};


/***/ }),

/***/ 99053:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__(95093)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort:
            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


/***/ }),

/***/ 99091:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _base_model_record__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55539);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var Survey = /*#__PURE__*/function (_Record) {
  function Survey(obj) {
    var _this;
    _classCallCheck(this, Survey);
    _this = _callSuper(this, Survey, [obj]);
    var self = _this;
    return _possibleConstructorReturn(_this, _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var initPromise;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            initPromise = new Promise(function (resolve, reject) {
              resolve(self);
            });
            _context.next = 3;
            return initPromise;
          case 3:
            self = _context.sent;
            self.SurveyQuestions.sort(function (a, b) {
              return a.OrderNr - b.OrderNr;
            });
            return _context.abrupt("return", self);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))());
  }
  _inherits(Survey, _Record);
  return _createClass(Survey, [{
    key: "afterSave",
    value: function afterSave(record) {
      //this.SurveyQuestions.sort((a, b) => {return a.OrderNr - b.OrderNr});
    }
  }]);
}(_base_model_record__WEBPACK_IMPORTED_MODULE_0__["default"]);
_defineProperty(Survey, "moduleName", 'survey');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Survey);

/***/ }),

/***/ 99247:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var BN = __webpack_require__(82509)
var Buffer = (__webpack_require__(92861).Buffer)

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic


/***/ }),

/***/ 99249:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Record = api.importMixinModule('bookingpayment', 'model', 'admin');
var AdminBookingPayment = /*#__PURE__*/function (_Record) {
  function AdminBookingPayment() {
    _classCallCheck(this, AdminBookingPayment);
    return _callSuper(this, AdminBookingPayment, arguments);
  }
  _inherits(AdminBookingPayment, _Record);
  return _createClass(AdminBookingPayment, [{
    key: "addRow",
    value: function () {
      var _addRow = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
        var fieldName, values, row;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              fieldName = _ref.fieldName, values = _ref.values;
              _context.next = 3;
              return _superPropGet(AdminBookingPayment, "addRow", this, 3)([{
                fieldName: fieldName,
                values: values
              }]);
            case 3:
              row = _context.sent;
              row.SupplierId = this.SupplierId;
              return _context.abrupt("return", row);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function addRow(_x) {
        return _addRow.apply(this, arguments);
      }
      return addRow;
    }()
  }]);
}(Record);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AdminBookingPayment);

/***/ }),

/***/ 99294:
/***/ ((module) => {

"use strict";

module.exports = function generate_multipleOf(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  if (!($isData || typeof $schema == 'number')) {
    throw new Error($keyword + ' must be number');
  }
  out += 'var division' + ($lvl) + ';if (';
  if ($isData) {
    out += ' ' + ($schemaValue) + ' !== undefined && ( typeof ' + ($schemaValue) + ' != \'number\' || ';
  }
  out += ' (division' + ($lvl) + ' = ' + ($data) + ' / ' + ($schemaValue) + ', ';
  if (it.opts.multipleOfPrecision) {
    out += ' Math.abs(Math.round(division' + ($lvl) + ') - division' + ($lvl) + ') > 1e-' + (it.opts.multipleOfPrecision) + ' ';
  } else {
    out += ' division' + ($lvl) + ' !== parseInt(division' + ($lvl) + ') ';
  }
  out += ' ) ';
  if ($isData) {
    out += '  )  ';
  }
  out += ' ) {   ';
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('multipleOf') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { multipleOf: ' + ($schemaValue) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should be multiple of ';
      if ($isData) {
        out += '\' + ' + ($schemaValue);
      } else {
        out += '' + ($schemaValue) + '\'';
      }
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + ($schema);
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '} ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),

/***/ 99352:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10467);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23029);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92901);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50388);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53954);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15361);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64467);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54756);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51941);








function _callSuper(t, o, e) { return o = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(o), (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var ServicePersonQuote = /*#__PURE__*/function (_BookingBaseModel) {
  function ServicePersonQuote(obj) {
    var _this;
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(this, ServicePersonQuote);
    _this = _callSuper(this, ServicePersonQuote, [obj]);
    var self = _this;
    return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(_this, (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var quote;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return new Promise(function (resolve, reject) {
              resolve(self);
            });
          case 2:
            quote = _context.sent;
            if (tools.isNull(quote.Cost)) quote.invalid.Cost = true;
            if (tools.isNull(quote.PersonCost)) quote.invalid.PersonCost = true;
            return _context.abrupt("return", quote);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))());
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(ServicePersonQuote, _BookingBaseModel);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(ServicePersonQuote, [{
    key: "isErrorPrice",
    get:
    /*get paxType () {
        for (let pType of this.$parent.paxTypes) {
            let quote = this.$parent[pType];
            if (quote && quote._id == this._id) return pType;
        }
    }*/

    function get() {
      if (!this.Include) return false;
      var priceNull = this.Price === null || this.Price === undefined || this.Price === '';
      if (priceNull) return true;
      if (parseFloat(this.Price) < parseFloat(this.Cost)) {
        return true;
      }
    }
  }, {
    key: "service",
    get: function get() {
      if (!this.$parent) return;
      if (!this.$parent.$parent) return;
      if (!this.$parent.$parent.$parent) return;
      return this.$parent.$parent.$parent.$parent;
    }
  }, {
    key: "costPer",
    get: function get() {
      if (this.service.CostPerModified) return this.service.CostPer;
      if (this.CostBy) {
        if (this.CostBy == 'PERSON' || this.CostBy == 'BASE_PERSON') {
          return 'PERSON';
        }
        if (this.CostBy == 'SERVICE' || this.CostBy == 'BASE_SERVICE') {
          return 'SERVICE';
        }
      }
      ;
      return this.service.costPer;
    }
  }, {
    key: "booking",
    get: function get() {
      return this.$parent.$parent.$parent.$parent.$parent.$parent;
    }
  }, {
    key: "getPax",
    get: function get() {
      if (this.Base) return this.Base;
      var booking = this.booking;
      var r = 0;
      if (this.costPer == 'PERSON') {
        if (booking.BaseQuotes[this.baseId]) {
          if (booking.BaseQuotes[this.baseId] && booking.BaseQuotes[this.baseId][this.paxType]) {
            r += booking.BaseQuotes[this.baseId] && booking.BaseQuotes[this.baseId][this.paxType];
          }
        }
      } else {
        if (booking.BaseQuotes[this.baseId]) {
          if (booking.BaseQuotes[this.baseId].ADT) r += booking.BaseQuotes[this.baseId].ADT;
          if (booking.BaseQuotes[this.baseId].CHD) r += booking.BaseQuotes[this.baseId].CHD;
          if (booking.BaseQuotes[this.baseId].TL) r += booking.BaseQuotes[this.baseId].TL;
        }
      }
      return r;
    }
  }, {
    key: "baseId",
    get: function get() {
      var paxType = this.paxType;
      if (!paxType) return;
      for (var id in this.$parent.$parent.bases) {
        if (!this.$parent.$parent[id]) continue;
        if (!this.$parent.$parent[id][paxType]) continue;
        if (this.$parent.$parent[id][paxType]._id == this._id) {
          return id;
        }
      }
    }
  }, {
    key: "paxType",
    get: function get() {
      for (var _i = 0, _arr = ['ADT', 'CHD', 'TL']; _i < _arr.length; _i++) {
        var paxType = _arr[_i];
        if (this.$parent[paxType] && this.$parent[paxType]._id == this._id) {
          return paxType;
        }
      }
    }
  }, {
    key: "baseQuote",
    get: function get() {
      return this.booking.BaseQuotes[this.baseId];
    }
  }, {
    key: "afterEdit",
    value: function afterEdit() {
      return {
        Markup: function Markup(r) {
          r.setMarkup();
        },
        Cost: function Cost(r) {
          r.setPriceByCost(true, true);
        },
        Price: function Price(r) {
          r.setMarkupByPrice(true);
        },
        Quantity: function () {
          var _Quantity = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(r) {
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return r.setQuantity();
                case 2:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          function Quantity(_x) {
            return _Quantity.apply(this, arguments);
          }
          return Quantity;
        }(),
        Base: function () {
          var _Base = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(r) {
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return r.setBase();
                case 2:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }));
          function Base(_x2) {
            return _Base.apply(this, arguments);
          }
          return Base;
        }(),
        PersonCost: function PersonCost(r) {
          r.setPersonCost(true);
        },
        PersonPrice: function PersonPrice(r) {
          r.setPersonPrice(true);
        },
        Include: function Include(r) {
          r.setBookingTotals();
        },
        CostBy: function CostBy(r) {
          r.setCostBy();
        }
      };
    }
  }, {
    key: "setCostByModified",
    value: function () {
      var _setCostByModified = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(value) {
        var pType, pax, _pax;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.CostByModified = true;
              pType = this.paxType;
              if (!(value == 'SERVICE' && pType == 'ADT')) {
                _context4.next = 12;
                break;
              }
              pax = this.booking.BaseQuotes[this.baseId].ADT;
              if (this.booking.BaseQuotes[this.baseId].CHD) pax += this.booking.BaseQuotes[this.baseId].CHD;
              if (this.booking.BaseQuotes[this.baseId].TL) pax += this.booking.BaseQuotes[this.baseId].TL;
              _context4.next = 8;
              return this.setValue({
                fieldName: 'Base',
                value: pax
              });
            case 8:
              _context4.next = 10;
              return this.setValue({
                fieldName: 'Quantity',
                value: 1
              });
            case 10:
              _context4.next = 15;
              break;
            case 12:
              _pax = this.booking.BaseQuotes[this.baseId][pType];
              _context4.next = 15;
              return this.setValue({
                fieldName: 'Base',
                value: _pax
              });
            case 15:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function setCostByModified(_x3) {
        return _setCostByModified.apply(this, arguments);
      }
      return setCostByModified;
    }()
  }, {
    key: "setCostBy",
    value: function () {
      var _setCostBy = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.setTotals();
              this.calculatePersonCost();
              this.calculatePersonPrice();
              this.setBookingTotals();
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function setCostBy() {
        return _setCostBy.apply(this, arguments);
      }
      return setCostBy;
    }()
  }, {
    key: "setPriceByCost",
    value: function setPriceByCost(modified, calculatePersonCost) {
      //console.log('setPriceByCost', modified, calculatePersonCost);
      var markup = this.booking.Markup;
      var markupValue = this.$Markup.value;
      var markupNull = tools.isNull(markupValue);
      if (!markupNull) markup = markupValue;
      if (modified) this.EstimatedCost = null;
      if (!this.PriceModified) {
        this.setPrice(markup);
      } else {
        this.$Markup.value = tools.getMarkup(this.$Price.value, this.$Cost.value);
      }
      if (!this.SourceCost) this.$SourceCost.value = this.$Cost.value;
      this.$Modified.value = false;
      var costValue = this.$Cost.value;
      if (modified && !tools.isNull(costValue)) {
        this.$Modified.value = true;
        this.$PersonCostModified.value = false;
      }
      this.setTotals();
      if (calculatePersonCost) this.calculatePersonCost();
      this.calculatePersonPrice();
      if (!tools.isNull(this.Cost)) this.invalid.Cost = false;
      if (!tools.isNull(this.Price)) this.invalid.Price = false;
      this.setBookingTotals();
    }
  }, {
    key: "setMarkup",
    value: function setMarkup() {
      //console.log('setMarkup');
      this.$MarkupModified.value = false;
      var markupValue = this.$Markup.value;
      var markupNull = tools.isNull(markupValue);
      if (!markupNull) this.$MarkupModified.value = true;
      if (this.Modified && this.MarkupModified) this.PriceModified = false;
      this.setPriceByCost(false);
    }
  }, {
    key: "setMarkupByPrice",
    value: function setMarkupByPrice(calculatePersonPrice) {
      //console.log('setMarkupByPrice', calculatePersonPrice);
      this.$Markup.value = tools.getMarkup(this.$Price.value, this.$Cost.value);
      this.$PriceModified.value = false;
      if (this.Price) {
        this.$PriceModified.value = true;
        this.$MarkupModified.value = true;
      }
      this.setTotals();
      if (calculatePersonPrice) {
        this.calculatePersonPrice();
        this.$PersonPriceModified.value = false;
      }
      this.setBookingTotals();
    }
  }, {
    key: "calculatePersonCost",
    value: function calculatePersonCost() {
      //console.log('calculatePersonCost');
      var pax = this.getPax;
      if (tools.isNull(this.$Cost.value)) {
        this.$PersonCost.value = null;
      } else {
        if (this.costPer == 'PERSON') this.$PersonCost.value = this.$Cost.value;
        if (this.costPer == 'SERVICE') this.$PersonCost.value = this._TotalCost / pax;
      }
      if (this.PersonCost) this.invalid.PersonCost = false;
    }
  }, {
    key: "calculatePersonPrice",
    value: function calculatePersonPrice() {
      var pax = this.getPax;
      if (tools.isNull(this.Price)) {
        this.$PersonPrice.value = null;
      } else {
        if (this.costPer == 'PERSON') this.$PersonPrice.value = this.$Price.value;
        if (this.costPer == 'SERVICE') this.$PersonPrice.value = this._TotalPrice / pax;
      }
    }
  }, {
    key: "setTotals",
    value: function setTotals() {
      //console.log('setTotals');
      var booking = this.booking;
      if (booking.QuoteBy == 'QUANTITY') {
        this.TotalCost = this.Cost * this.Quantity;
        this.TotalPrice = this.Price * this.Quantity;
        var baseQuote = this.baseQuote;
        if (this.Quantity && baseQuote && baseQuote.TourLeader && (this.CostBy == 'PERSON' || this.CostBy == 'BASE_PERSON')) {
          this.TotalCost = this.Cost * (this.Quantity + 1);
          this.TotalPrice = this.Price * (this.Quantity + 1);
        }
        if (this.Quantity && baseQuote && baseQuote.TourLeader && !this.CostBy && this.Quantity != 1 && this.Quantity <= baseQuote.paxQuantity) {
          this.TotalCost = this.Cost * (this.Quantity + 1);
          this.TotalPrice = this.Price * (this.Quantity + 1);
        }
      }
      if (booking.QuoteBy == 'SERVICE') {
        if (this.costPer == 'PERSON') {
          if (!tools.isNull(this.$Cost.value)) this.TotalCost = this.$Cost.value * this.$Base.value;
          if (!tools.isNull(this.$Price.value)) this.TotalPrice = this.$Price.value * this.$Base.value;
        } else {
          if (!tools.isNull(this.$Cost.value)) this.TotalCost = this.$Cost.value * this.$Quantity.value * this.carDays;
          if (!tools.isNull(this.$Price.value)) this.TotalPrice = this.$Price.value * this.$Quantity.value * this.carDays;
        }
      }
    }
  }, {
    key: "_totalCost",
    get: function get() {
      var res = 0;
      var booking = this.booking;
      if (booking.QuoteBy == 'QUANTITY') {
        res = this.Cost * this.Quantity;
        var baseQuote = this.baseQuote;
        if (this.Quantity && baseQuote && baseQuote.TourLeader && (this.CostBy == 'PERSON' || this.CostBy == 'BASE_PERSON')) {
          return this.Cost * (this.Quantity + 1);
        }
        if (this.Quantity && baseQuote && baseQuote.TourLeader && !this.CostBy && this.Quantity != 1 && this.Quantity <= baseQuote.paxQuantity) {
          return this.Cost * (this.Quantity + 1);
        }
        return res;
      } else if (booking.QuoteBy == 'SERVICE') {
        if (this.costPer == 'PERSON') {
          if (!tools.isNull(this.$Cost.value)) return this.$Cost.value * this.$Base.value * this.carDays;
        } else {
          if (!tools.isNull(this.$Cost.value)) return this.$Cost.value * this.$Quantity.value * this.carDays;
        }
      }
      return res;
    }
  }, {
    key: "_TotalCost",
    get: function get() {
      return this._totalCost;
    }
  }, {
    key: "_TotalPrice",
    get: function get() {
      return this._totalPrice;
    }
  }, {
    key: "_totalPrice",
    get: function get() {
      var res = 0;
      var booking = this.booking;
      if (booking.QuoteBy == 'QUANTITY') {
        var _res = this.Price * this.Quantity;
        var baseQuote = this.baseQuote;
        if (this.Quantity && baseQuote && baseQuote.TourLeader && (this.CostBy == 'PERSON' || this.CostBy == 'BASE_PERSON')) {
          return this.Price * (this.Quantity + 1);
        }
        if (this.Quantity && baseQuote && baseQuote.TourLeader && !this.CostBy && this.Quantity != 1 && this.Quantity <= baseQuote.paxQuantity) {
          return this.Price * (this.Quantity + 1);
        }
        return _res;
      }
      if (booking.QuoteBy == 'SERVICE') {
        if (this.costPer == 'PERSON') {
          if (!tools.isNull(this.$Price.value)) return this.$Price.value * this.$Base.value * this.carDays;
        } else {
          if (!tools.isNull(this.$Price.value)) return this.$Price.value * this.$Quantity.value * this.carDays;
        }
      }
      return res;
    }
  }, {
    key: "setQuantity",
    value: function () {
      var _setQuantity = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6() {
        var quoteDate;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!this.booking.quoteService) {
                _context6.next = 7;
                break;
              }
              if (this.costPer == 'PERSON') {
                this.$Base.value = this.$Quantity.value;
              }
              if (!(this.costPer == 'SERVICE')) {
                _context6.next = 7;
                break;
              }
              quoteDate = this.day.TransDate;
              if (this.booking.SplitQuoteDate && this.booking.QuoteDate) {
                quoteDate = this.day.QuoteDate;
              }
              _context6.next = 7;
              return this.booking.getServiceCost({
                baseQuoteId: this.baseId,
                quoteDate: quoteDate,
                service: this.service,
                sync: true
              });
            case 7:
              this.setTotals();
              this.setBookingTotals();
              if (this.booking.QuoteBy == 'SERVICE') {
                this.calculatePersonCost();
                this.calculatePersonPrice();
              }
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function setQuantity() {
        return _setQuantity.apply(this, arguments);
      }
      return setQuantity;
    }()
  }, {
    key: "setPersonCost",
    value: function setPersonCost(setPrice) {
      if (this.booking.QuoteBy == 'SERVICE' && !this.costPer) {
        if (this.booking.QuoteViewType == 'PERSON') {
          this.service.CostPer = 'PERSON';
        } else if (this.booking.QuoteViewType == 'SERVICE') {
          this.service.CostPer = 'SERVICE';
        }
      }
      if (this.booking.QuoteBy == 'SERVICE' && !this.Quantity) {
        if (this.costPer == 'PERSON') {
          this.$Quantity.value = this.Base;
        } else if (this.costPer == 'SERVICE') {
          this.$Quantity.value = 1;
        }
      }
      this.$PersonCostModified.value = false;
      if (tools.isNull(this.$PersonCost.value)) {
        this.$Cost.value = null;
      } else {
        this.$PersonCostModified.value = true;
        if (this.costPer == 'PERSON') this.$Cost.value = this.$PersonCost.value;
        if (this.costPer == 'SERVICE') {
          var q = this.Quantity || 1;
          this.$Cost.value = this.$PersonCost.value * this.getPax / q / this.carDays;
        }
        ;
      }
      if (setPrice) this.setPriceByCost(false, false);
    }
  }, {
    key: "carDays",
    get: function get() {
      var _this$service, _this$service2;
      var carDays = 1;
      if ((_this$service = this.service) !== null && _this$service !== void 0 && (_this$service = _this$service.Service) !== null && _this$service !== void 0 && _this$service.CarRental && (_this$service2 = this.service) !== null && _this$service2 !== void 0 && (_this$service2 = _this$service2.Service) !== null && _this$service2 !== void 0 && _this$service2.PricePerDay) {
        var _this$service$Booking;
        carDays = ((_this$service$Booking = this.service.BookingDayServiceCar) === null || _this$service$Booking === void 0 ? void 0 : _this$service$Booking.Days) || 1;
      }
      return carDays;
    }
  }, {
    key: "setPersonPrice",
    value: function setPersonPrice(setModified) {
      //console.log('setPersonPrice', setModified);
      this.$PersonPriceModified.value = false;
      if (!tools.isNull(this.$PersonPrice.value) && setModified) {
        this.$PersonPriceModified.value = true;
      }
      if (this.costPer == 'PERSON') this.$Price.value = this.$PersonPrice.value;
      if (this.costPer == 'SERVICE') this.$Price.value = this.$PersonPrice.value * this.getPax / this.carDays;
      if (setModified) {
        this.setMarkupByPrice(false);
      } else {
        this.setTotals();
        this.setBookingTotals();
      }
    }
  }, {
    key: "setPrice",
    value: function setPrice(markup) {
      //console.log('setPrice', markup);
      this.$Price.value = tools.getPrice(this.$Cost.value, markup);
    }
  }, {
    key: "setBase",
    value: function () {
      var _setBase = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              //console.log('setBase');
              if (this.costPer == 'PERSON') {
                this.$Quantity.value = this.$Base.value;
              }
              _context7.next = 3;
              return this.setCost(true);
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function setBase() {
        return _setBase.apply(this, arguments);
      }
      return setBase;
    }()
  }, {
    key: "setCost",
    value: function () {
      var _setCost = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8(checkPersonModified) {
        var updateCost, quoteDate, service;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              //console.log('setCost');
              updateCost = false;
              if (!checkPersonModified) updateCost = true;
              if (!this.PersonCostModified) updateCost = true;
              if (!updateCost) {
                _context8.next = 11;
                break;
              }
              quoteDate = this.day.TransDate;
              if (this.booking.SplitQuoteDate && this.booking.QuoteDate) {
                quoteDate = this.day.QuoteDate;
              }
              service = this.service;
              _context8.next = 9;
              return this.booking.getServiceCost({
                service: service,
                quoteDate: quoteDate,
                baseQuoteId: this.baseId || this.baseQuoteId
              });
            case 9:
              _context8.next = 13;
              break;
            case 11:
              this.setPersonCost(false);
              this.setPersonPrice(false);
            case 13:
              this.setBookingTotals();
            case 14:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function setCost(_x4) {
        return _setCost.apply(this, arguments);
      }
      return setCost;
    }()
  }, {
    key: "day",
    get: function get() {
      return this.$parent.$parent.$parent.$parent.$parent;
    }
  }, {
    key: "setBookingTotals",
    value: function setBookingTotals() {
      //console.log('setBookingTotals');
      var baseId = this.baseId;
      this.clearBookingCache();
      this.booking.setBookingTotals(baseId);
    }
  }]);
}(_base_model_bookingbasemodel__WEBPACK_IMPORTED_MODULE_3__["default"]);
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(ServicePersonQuote, "moduleName", 'servicepersonquote');
(0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(ServicePersonQuote, "invalidated_cache", ['totals', 'totalsServices', 'quoted', 'totalByPaxVariantId', 'baseTotalsHotels', 'totalByPaxGroup']);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ServicePersonQuote);

/***/ }),

/***/ 99708:
/***/ ((module) => {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('[{"id":4,"alpha2":"af","alpha3":"afg","name":"Afghanistan"},{"id":8,"alpha2":"al","alpha3":"alb","name":"Albania"},{"id":12,"alpha2":"dz","alpha3":"dza","name":"Algeria"},{"id":20,"alpha2":"ad","alpha3":"and","name":"Andorra"},{"id":24,"alpha2":"ao","alpha3":"ago","name":"Angola"},{"id":660,"alpha2":"ai","alpha3":"aia","name":"Anguilla"},{"id":10,"alpha2":"aq","alpha3":"ata","name":"Antartide"},{"id":28,"alpha2":"ag","alpha3":"atg","name":"Antigua e Barbuda"},{"id":682,"alpha2":"sa","alpha3":"sau","name":"Arabia Saudita"},{"id":32,"alpha2":"ar","alpha3":"arg","name":"Argentina"},{"id":51,"alpha2":"am","alpha3":"arm","name":"Armenia"},{"id":533,"alpha2":"aw","alpha3":"abw","name":"Aruba"},{"id":36,"alpha2":"au","alpha3":"aus","name":"Australia"},{"id":40,"alpha2":"at","alpha3":"aut","name":"Austria"},{"id":31,"alpha2":"az","alpha3":"aze","name":"Azerbaigian"},{"id":44,"alpha2":"bs","alpha3":"bhs","name":"Bahamas"},{"id":48,"alpha2":"bh","alpha3":"bhr","name":"Bahrein"},{"id":50,"alpha2":"bd","alpha3":"bgd","name":"Bangladesh"},{"id":52,"alpha2":"bb","alpha3":"brb","name":"Barbados"},{"id":56,"alpha2":"be","alpha3":"bel","name":"Belgio"},{"id":84,"alpha2":"bz","alpha3":"blz","name":"Belize"},{"id":204,"alpha2":"bj","alpha3":"ben","name":"Benin"},{"id":60,"alpha2":"bm","alpha3":"bmu","name":"Bermuda"},{"id":64,"alpha2":"bt","alpha3":"btn","name":"Bhutan"},{"id":112,"alpha2":"by","alpha3":"blr","name":"Bielorussia"},{"id":104,"alpha2":"mm","alpha3":"mmr","name":"Birmania"},{"id":68,"alpha2":"bo","alpha3":"bol","name":"Bolivia"},{"id":70,"alpha2":"ba","alpha3":"bih","name":"Bosnia ed Erzegovina"},{"id":72,"alpha2":"bw","alpha3":"bwa","name":"Botswana"},{"id":76,"alpha2":"br","alpha3":"bra","name":"Brasile"},{"id":96,"alpha2":"bn","alpha3":"brn","name":"Brunei"},{"id":100,"alpha2":"bg","alpha3":"bgr","name":"Bulgaria"},{"id":854,"alpha2":"bf","alpha3":"bfa","name":"Burkina Faso"},{"id":108,"alpha2":"bi","alpha3":"bdi","name":"Burundi"},{"id":116,"alpha2":"kh","alpha3":"khm","name":"Cambogia"},{"id":120,"alpha2":"cm","alpha3":"cmr","name":"Camerun"},{"id":124,"alpha2":"ca","alpha3":"can","name":"Canada"},{"id":132,"alpha2":"cv","alpha3":"cpv","name":"Capo Verde"},{"id":148,"alpha2":"td","alpha3":"tcd","name":"Ciad"},{"id":152,"alpha2":"cl","alpha3":"chl","name":"Cile"},{"id":156,"alpha2":"cn","alpha3":"chn","name":"Cina"},{"id":196,"alpha2":"cy","alpha3":"cyp","name":"Cipro"},{"id":336,"alpha2":"va","alpha3":"vat","name":"Città del Vaticano"},{"id":170,"alpha2":"co","alpha3":"col","name":"Colombia"},{"id":174,"alpha2":"km","alpha3":"com","name":"Comore"},{"id":408,"alpha2":"kp","alpha3":"prk","name":"Corea del Nord"},{"id":410,"alpha2":"kr","alpha3":"kor","name":"Corea del Sud"},{"id":384,"alpha2":"ci","alpha3":"civ","name":"Costa d\'Avorio"},{"id":188,"alpha2":"cr","alpha3":"cri","name":"Costa Rica"},{"id":191,"alpha2":"hr","alpha3":"hrv","name":"Croazia"},{"id":192,"alpha2":"cu","alpha3":"cub","name":"Cuba"},{"id":531,"alpha2":"cw","alpha3":"cuw","name":"Curaçao"},{"id":208,"alpha2":"dk","alpha3":"dnk","name":"Danimarca"},{"id":212,"alpha2":"dm","alpha3":"dma","name":"Dominica"},{"id":218,"alpha2":"ec","alpha3":"ecu","name":"Ecuador"},{"id":818,"alpha2":"eg","alpha3":"egy","name":"Egitto"},{"id":222,"alpha2":"sv","alpha3":"slv","name":"El Salvador"},{"id":784,"alpha2":"ae","alpha3":"are","name":"Emirati Arabi Uniti"},{"id":232,"alpha2":"er","alpha3":"eri","name":"Eritrea"},{"id":233,"alpha2":"ee","alpha3":"est","name":"Estonia"},{"id":231,"alpha2":"et","alpha3":"eth","name":"Etiopia"},{"id":242,"alpha2":"fj","alpha3":"fji","name":"Figi"},{"id":608,"alpha2":"ph","alpha3":"phl","name":"Filippine"},{"id":246,"alpha2":"fi","alpha3":"fin","name":"Finlandia"},{"id":250,"alpha2":"fr","alpha3":"fra","name":"Francia"},{"id":266,"alpha2":"ga","alpha3":"gab","name":"Gabon"},{"id":270,"alpha2":"gm","alpha3":"gmb","name":"Gambia"},{"id":268,"alpha2":"ge","alpha3":"geo","name":"Georgia"},{"id":239,"alpha2":"gs","alpha3":"sgs","name":"Georgia del Sud e Isole Sandwich Australi"},{"id":276,"alpha2":"de","alpha3":"deu","name":"Germania"},{"id":288,"alpha2":"gh","alpha3":"gha","name":"Ghana"},{"id":388,"alpha2":"jm","alpha3":"jam","name":"Giamaica"},{"id":392,"alpha2":"jp","alpha3":"jpn","name":"Giappone"},{"id":292,"alpha2":"gi","alpha3":"gib","name":"Gibilterra"},{"id":262,"alpha2":"dj","alpha3":"dji","name":"Gibuti"},{"id":400,"alpha2":"jo","alpha3":"jor","name":"Giordania"},{"id":300,"alpha2":"gr","alpha3":"grc","name":"Grecia"},{"id":308,"alpha2":"gd","alpha3":"grd","name":"Grenada"},{"id":304,"alpha2":"gl","alpha3":"grl","name":"Groenlandia"},{"id":312,"alpha2":"gp","alpha3":"glp","name":"Guadalupa"},{"id":316,"alpha2":"gu","alpha3":"gum","name":"Guam"},{"id":320,"alpha2":"gt","alpha3":"gtm","name":"Guatemala"},{"id":831,"alpha2":"gg","alpha3":"ggy","name":"Guernsey"},{"id":324,"alpha2":"gn","alpha3":"gin","name":"Guinea"},{"id":624,"alpha2":"gw","alpha3":"gnb","name":"Guinea-Bissau"},{"id":226,"alpha2":"gq","alpha3":"gnq","name":"Guinea Equatoriale"},{"id":328,"alpha2":"gy","alpha3":"guy","name":"Guyana"},{"id":254,"alpha2":"gf","alpha3":"guf","name":"Guyana francese"},{"id":332,"alpha2":"ht","alpha3":"hti","name":"Haiti"},{"id":340,"alpha2":"hn","alpha3":"hnd","name":"Honduras"},{"id":344,"alpha2":"hk","alpha3":"hkg","name":"Hong Kong"},{"id":356,"alpha2":"in","alpha3":"ind","name":"India"},{"id":360,"alpha2":"id","alpha3":"idn","name":"Indonesia"},{"id":364,"alpha2":"ir","alpha3":"irn","name":"Iran"},{"id":368,"alpha2":"iq","alpha3":"irq","name":"Iraq"},{"id":372,"alpha2":"ie","alpha3":"irl","name":"Irlanda"},{"id":352,"alpha2":"is","alpha3":"isl","name":"Islanda"},{"id":74,"alpha2":"bv","alpha3":"bvt","name":"Isola Bouvet"},{"id":833,"alpha2":"im","alpha3":"imn","name":"Isola di Man"},{"id":162,"alpha2":"cx","alpha3":"cxr","name":"Isola di Natale"},{"id":574,"alpha2":"nf","alpha3":"nfk","name":"Isola Norfolk"},{"id":248,"alpha2":"ax","alpha3":"ala","name":"Isole Åland"},{"id":535,"alpha2":"bq","alpha3":"bes","name":"Isole BES"},{"id":136,"alpha2":"ky","alpha3":"cym","name":"Isole Cayman"},{"id":166,"alpha2":"cc","alpha3":"cck","name":"Isole Cocos (Keeling)"},{"id":184,"alpha2":"ck","alpha3":"cok","name":"Isole Cook"},{"id":234,"alpha2":"fo","alpha3":"fro","name":"Fær Øer"},{"id":238,"alpha2":"fk","alpha3":"flk","name":"Isole Falkland"},{"id":334,"alpha2":"hm","alpha3":"hmd","name":"Isole Heard e McDonald"},{"id":580,"alpha2":"mp","alpha3":"mnp","name":"Isole Marianne Settentrionali"},{"id":584,"alpha2":"mh","alpha3":"mhl","name":"Isole Marshall"},{"id":581,"alpha2":"um","alpha3":"umi","name":"Isole minori esterne degli Stati Uniti"},{"id":612,"alpha2":"pn","alpha3":"pcn","name":"Isole Pitcairn"},{"id":90,"alpha2":"sb","alpha3":"slb","name":"Isole Salomone"},{"id":92,"alpha2":"vg","alpha3":"vgb","name":"Isole Vergini britanniche"},{"id":850,"alpha2":"vi","alpha3":"vir","name":"Isole Vergini americane"},{"id":376,"alpha2":"il","alpha3":"isr","name":"Israele"},{"id":380,"alpha2":"it","alpha3":"ita","name":"Italia"},{"id":832,"alpha2":"je","alpha3":"jey","name":"Jersey"},{"id":398,"alpha2":"kz","alpha3":"kaz","name":"Kazakistan"},{"id":404,"alpha2":"ke","alpha3":"ken","name":"Kenya"},{"id":417,"alpha2":"kg","alpha3":"kgz","name":"Kirghizistan"},{"id":296,"alpha2":"ki","alpha3":"kir","name":"Kiribati"},{"id":414,"alpha2":"kw","alpha3":"kwt","name":"Kuwait"},{"id":418,"alpha2":"la","alpha3":"lao","name":"Laos"},{"id":426,"alpha2":"ls","alpha3":"lso","name":"Lesotho"},{"id":428,"alpha2":"lv","alpha3":"lva","name":"Lettonia"},{"id":422,"alpha2":"lb","alpha3":"lbn","name":"Libano"},{"id":430,"alpha2":"lr","alpha3":"lbr","name":"Liberia"},{"id":434,"alpha2":"ly","alpha3":"lby","name":"Libia"},{"id":438,"alpha2":"li","alpha3":"lie","name":"Liechtenstein"},{"id":440,"alpha2":"lt","alpha3":"ltu","name":"Lituania"},{"id":442,"alpha2":"lu","alpha3":"lux","name":"Lussemburgo"},{"id":446,"alpha2":"mo","alpha3":"mac","name":"Macao"},{"id":807,"alpha2":"mk","alpha3":"mkd","name":"Macedonia del Nord"},{"id":450,"alpha2":"mg","alpha3":"mdg","name":"Madagascar"},{"id":454,"alpha2":"mw","alpha3":"mwi","name":"Malawi"},{"id":458,"alpha2":"my","alpha3":"mys","name":"Malaysia"},{"id":462,"alpha2":"mv","alpha3":"mdv","name":"Maldive"},{"id":466,"alpha2":"ml","alpha3":"mli","name":"Mali"},{"id":470,"alpha2":"mt","alpha3":"mlt","name":"Malta"},{"id":504,"alpha2":"ma","alpha3":"mar","name":"Marocco"},{"id":474,"alpha2":"mq","alpha3":"mtq","name":"Martinica"},{"id":478,"alpha2":"mr","alpha3":"mrt","name":"Mauritania"},{"id":480,"alpha2":"mu","alpha3":"mus","name":"Mauritius"},{"id":175,"alpha2":"yt","alpha3":"myt","name":"Mayotte"},{"id":484,"alpha2":"mx","alpha3":"mex","name":"Messico"},{"id":583,"alpha2":"fm","alpha3":"fsm","name":"Micronesia"},{"id":498,"alpha2":"md","alpha3":"mda","name":"Moldavia"},{"id":496,"alpha2":"mn","alpha3":"mng","name":"Mongolia"},{"id":499,"alpha2":"me","alpha3":"mne","name":"Montenegro"},{"id":500,"alpha2":"ms","alpha3":"msr","name":"Montserrat"},{"id":508,"alpha2":"mz","alpha3":"moz","name":"Mozambico"},{"id":516,"alpha2":"na","alpha3":"nam","name":"Namibia"},{"id":520,"alpha2":"nr","alpha3":"nru","name":"Nauru"},{"id":524,"alpha2":"np","alpha3":"npl","name":"Nepal"},{"id":558,"alpha2":"ni","alpha3":"nic","name":"Nicaragua"},{"id":562,"alpha2":"ne","alpha3":"ner","name":"Niger"},{"id":566,"alpha2":"ng","alpha3":"nga","name":"Nigeria"},{"id":570,"alpha2":"nu","alpha3":"niu","name":"Niue"},{"id":578,"alpha2":"no","alpha3":"nor","name":"Norvegia"},{"id":540,"alpha2":"nc","alpha3":"ncl","name":"Nuova Caledonia"},{"id":554,"alpha2":"nz","alpha3":"nzl","name":"Nuova Zelanda"},{"id":512,"alpha2":"om","alpha3":"omn","name":"Oman"},{"id":528,"alpha2":"nl","alpha3":"nld","name":"Paesi Bassi"},{"id":586,"alpha2":"pk","alpha3":"pak","name":"Pakistan"},{"id":585,"alpha2":"pw","alpha3":"plw","name":"Palau"},{"id":275,"alpha2":"ps","alpha3":"pse","name":"Palestina"},{"id":591,"alpha2":"pa","alpha3":"pan","name":"Panama"},{"id":598,"alpha2":"pg","alpha3":"png","name":"Papua Nuova Guinea"},{"id":600,"alpha2":"py","alpha3":"pry","name":"Paraguay"},{"id":604,"alpha2":"pe","alpha3":"per","name":"Perù"},{"id":258,"alpha2":"pf","alpha3":"pyf","name":"Polinesia francese"},{"id":616,"alpha2":"pl","alpha3":"pol","name":"Polonia"},{"id":630,"alpha2":"pr","alpha3":"pri","name":"Porto Rico"},{"id":620,"alpha2":"pt","alpha3":"prt","name":"Portogallo"},{"id":492,"alpha2":"mc","alpha3":"mco","name":"Monaco"},{"id":634,"alpha2":"qa","alpha3":"qat","name":"Qatar"},{"id":826,"alpha2":"gb","alpha3":"gbr","name":"Regno Unito"},{"id":180,"alpha2":"cd","alpha3":"cod","name":"RD del Congo"},{"id":203,"alpha2":"cz","alpha3":"cze","name":"Rep. Ceca"},{"id":140,"alpha2":"cf","alpha3":"caf","name":"Rep. Centrafricana"},{"id":178,"alpha2":"cg","alpha3":"cog","name":"Rep. del Congo"},{"id":214,"alpha2":"do","alpha3":"dom","name":"Rep. Dominicana"},{"id":638,"alpha2":"re","alpha3":"reu","name":"Riunione"},{"id":642,"alpha2":"ro","alpha3":"rou","name":"Romania"},{"id":646,"alpha2":"rw","alpha3":"rwa","name":"Ruanda"},{"id":643,"alpha2":"ru","alpha3":"rus","name":"Russia"},{"id":732,"alpha2":"eh","alpha3":"esh","name":"Sahara Occidentale"},{"id":659,"alpha2":"kn","alpha3":"kna","name":"Saint Kitts e Nevis"},{"id":662,"alpha2":"lc","alpha3":"lca","name":"Saint Lucia"},{"id":654,"alpha2":"sh","alpha3":"shn","name":"Sant\'Elena, Ascensione e Tristan da Cunha"},{"id":670,"alpha2":"vc","alpha3":"vct","name":"Saint Vincent e Grenadine"},{"id":652,"alpha2":"bl","alpha3":"blm","name":"Saint-Barthélemy"},{"id":663,"alpha2":"mf","alpha3":"maf","name":"Saint-Martin"},{"id":666,"alpha2":"pm","alpha3":"spm","name":"Saint-Pierre e Miquelon"},{"id":882,"alpha2":"ws","alpha3":"wsm","name":"Samoa"},{"id":16,"alpha2":"as","alpha3":"asm","name":"Samoa Americane"},{"id":674,"alpha2":"sm","alpha3":"smr","name":"San Marino"},{"id":678,"alpha2":"st","alpha3":"stp","name":"São Tomé e Príncipe"},{"id":686,"alpha2":"sn","alpha3":"sen","name":"Senegal"},{"id":688,"alpha2":"rs","alpha3":"srb","name":"Serbia"},{"id":690,"alpha2":"sc","alpha3":"syc","name":"Seychelles"},{"id":694,"alpha2":"sl","alpha3":"sle","name":"Sierra Leone"},{"id":702,"alpha2":"sg","alpha3":"sgp","name":"Singapore"},{"id":534,"alpha2":"sx","alpha3":"sxm","name":"Sint Maarten"},{"id":760,"alpha2":"sy","alpha3":"syr","name":"Siria"},{"id":703,"alpha2":"sk","alpha3":"svk","name":"Slovacchia"},{"id":705,"alpha2":"si","alpha3":"svn","name":"Slovenia"},{"id":706,"alpha2":"so","alpha3":"som","name":"Somalia"},{"id":724,"alpha2":"es","alpha3":"esp","name":"Spagna"},{"id":144,"alpha2":"lk","alpha3":"lka","name":"Sri Lanka"},{"id":840,"alpha2":"us","alpha3":"usa","name":"Stati Uniti"},{"id":710,"alpha2":"za","alpha3":"zaf","name":"Sudafrica"},{"id":729,"alpha2":"sd","alpha3":"sdn","name":"Sudan"},{"id":728,"alpha2":"ss","alpha3":"ssd","name":"Sudan del Sud"},{"id":740,"alpha2":"sr","alpha3":"sur","name":"Suriname"},{"id":744,"alpha2":"sj","alpha3":"sjm","name":"Svalbard e Jan Mayen"},{"id":752,"alpha2":"se","alpha3":"swe","name":"Svezia"},{"id":756,"alpha2":"ch","alpha3":"che","name":"Svizzera"},{"id":748,"alpha2":"sz","alpha3":"swz","name":"eSwatini"},{"id":158,"alpha2":"tw","alpha3":"twn","name":"Taiwan"},{"id":762,"alpha2":"tj","alpha3":"tjk","name":"Tagikistan"},{"id":834,"alpha2":"tz","alpha3":"tza","name":"Tanzania"},{"id":260,"alpha2":"tf","alpha3":"atf","name":"Terre australi e antartiche francesi"},{"id":86,"alpha2":"io","alpha3":"iot","name":"Territorio britannico dell\'Oceano Indiano"},{"id":764,"alpha2":"th","alpha3":"tha","name":"Thailandia"},{"id":626,"alpha2":"tl","alpha3":"tls","name":"Timor Est"},{"id":768,"alpha2":"tg","alpha3":"tgo","name":"Togo"},{"id":772,"alpha2":"tk","alpha3":"tkl","name":"Tokelau"},{"id":776,"alpha2":"to","alpha3":"ton","name":"Tonga"},{"id":780,"alpha2":"tt","alpha3":"tto","name":"Trinidad e Tobago"},{"id":788,"alpha2":"tn","alpha3":"tun","name":"Tunisia"},{"id":792,"alpha2":"tr","alpha3":"tur","name":"Turchia"},{"id":795,"alpha2":"tm","alpha3":"tkm","name":"Turkmenistan"},{"id":796,"alpha2":"tc","alpha3":"tca","name":"Turks e Caicos"},{"id":798,"alpha2":"tv","alpha3":"tuv","name":"Tuvalu"},{"id":804,"alpha2":"ua","alpha3":"ukr","name":"Ucraina"},{"id":800,"alpha2":"ug","alpha3":"uga","name":"Uganda"},{"id":348,"alpha2":"hu","alpha3":"hun","name":"Ungheria"},{"id":858,"alpha2":"uy","alpha3":"ury","name":"Uruguay"},{"id":860,"alpha2":"uz","alpha3":"uzb","name":"Uzbekistan"},{"id":548,"alpha2":"vu","alpha3":"vut","name":"Vanuatu"},{"id":862,"alpha2":"ve","alpha3":"ven","name":"Venezuela"},{"id":704,"alpha2":"vn","alpha3":"vnm","name":"Vietnam"},{"id":876,"alpha2":"wf","alpha3":"wlf","name":"Wallis e Futuna"},{"id":887,"alpha2":"ye","alpha3":"yem","name":"Yemen"},{"id":894,"alpha2":"zm","alpha3":"zmb","name":"Zambia"},{"id":716,"alpha2":"zw","alpha3":"zwe","name":"Zimbabwe"}]');

/***/ }),

/***/ 99725:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var View = api.importMixinModule('service', 'views', 'custom');
var CustomServiceView = /*#__PURE__*/function (_View) {
  function CustomServiceView() {
    _classCallCheck(this, CustomServiceView);
    return _callSuper(this, CustomServiceView, arguments);
  }
  _inherits(CustomServiceView, _View);
  return _createClass(CustomServiceView, null, [{
    key: "getTableOptions",
    value: function () {
      var _getTableOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var options;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _superPropGet(CustomServiceView, "getTableOptions", this, 2)([]);
            case 2:
              options = _context.sent;
              options.fields.push({
                name: 'Guide',
                label: 'Guide',
                editor: 'checkbox'
              });
              options.fields.push({
                name: 'Transfer',
                label: 'Transfer',
                editor: 'checkbox'
              });
              options.fields.push({
                name: 'GroupByServiceId',
                label: 'Agrupar con',
                editor: 'vue-select',
                optionLabels: 'Name',
                relation: 'service',
                setRelationTo: 'GroupByService'
              });
              options.fields.splice(options.fields.findIndex(function (f) {
                return f.name === 'RequiredServiceId';
              }), 1);
              options.fields.push({
                name: 'Review',
                label: 'Reseñas',
                editor: 'tab',
                hideFromList: true,
                icon: 'comment-dots',
                fields: [{
                  name: 'Review',
                  hideFromList: true,
                  editor: 'text-area',
                  columns: 12,
                  rows: 10
                }]
              });
              return _context.abrupt("return", options);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableOptions() {
        return _getTableOptions.apply(this, arguments);
      }
      return getTableOptions;
    }()
  }]);
}(View);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomServiceView);

/***/ }),

/***/ 99749:
/***/ ((module) => {

"use strict";


module.exports = function defFunc(ajv) {
  defFunc.definition = {
    type: 'object',
    macro: function (schema) {
      if (schema.length == 0) return true;
      if (schema.length == 1) return {required: schema};
      var schemas = schema.map(function (prop) {
        return {required: [prop]};
      });
      return {oneOf: schemas};
    },
    metaSchema: {
      type: 'array',
      items: {
        type: 'string'
      }
    }
  };

  ajv.addKeyword('oneRequired', defFunc.definition);
  return ajv;
};


/***/ }),

/***/ 99837:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var map = {
	"./accounting/views/account": 90028,
	"./accounting/views/account.js": 90028,
	"./admin": 24802,
	"./admin/": 24802,
	"./admin/index": 24802,
	"./admin/index.js": 24802,
	"./admin/model/bookingpayment": 99249,
	"./admin/model/bookingpayment.js": 99249,
	"./admin/model/invoice": 25967,
	"./admin/model/invoice.js": 25967,
	"./admin/model/purchaseinvoice": 66506,
	"./admin/model/purchaseinvoice.js": 66506,
	"./admin/views/accountmovement": 80713,
	"./admin/views/accountmovement.js": 80713,
	"./admin/views/bookingpayment": 26780,
	"./admin/views/bookingpayment.js": 26780,
	"./admin/views/hotel": 35557,
	"./admin/views/hotel.js": 35557,
	"./admin/views/invoice": 94576,
	"./admin/views/invoice.js": 94576,
	"./admin/views/purchaseinvoice": 85725,
	"./admin/views/purchaseinvoice.js": 85725,
	"./ai": 57859,
	"./ai/": 57859,
	"./ai/index": 57859,
	"./ai/index.js": 57859,
	"./ai/model/googledrivefile": 70114,
	"./ai/model/googledrivefile.js": 70114,
	"./ai/model/purchaseinvoice": 48095,
	"./ai/model/purchaseinvoice.js": 48095,
	"./ai/views/aiprompt": 9080,
	"./ai/views/aiprompt.js": 9080,
	"./ai/views/airesponse": 5689,
	"./ai/views/airesponse.js": 5689,
	"./ai/views/aisettings": 55231,
	"./ai/views/aisettings.js": 55231,
	"./ai/views/googledrivefile": 68813,
	"./ai/views/googledrivefile.js": 68813,
	"./ai/views/purchaseinvoice": 72812,
	"./ai/views/purchaseinvoice.js": 72812,
	"./ai/views/service": 47289,
	"./ai/views/service.js": 47289,
	"./arg/views/purchaseinvoice": 91256,
	"./arg/views/purchaseinvoice.js": 91256,
	"./argafip/model/invoice": 71788,
	"./argafip/model/invoice.js": 71788,
	"./argafip/views/currency": 77941,
	"./argafip/views/currency.js": 77941,
	"./argafip/views/invoice": 49955,
	"./argafip/views/invoice.js": 49955,
	"./contacts": 1506,
	"./contacts/": 1506,
	"./contacts/index": 1506,
	"./contacts/index.js": 1506,
	"./contacts/model/contact": 43928,
	"./contacts/model/contact.js": 43928,
	"./contacts/views/agency": 47500,
	"./contacts/views/agency.js": 47500,
	"./contacts/views/booking": 86824,
	"./contacts/views/booking.js": 86824,
	"./contacts/views/contact": 22859,
	"./contacts/views/contact.js": 22859,
	"./contacts/views/hotel": 75301,
	"./contacts/views/hotel.js": 75301,
	"./contacts/views/supplier": 29895,
	"./contacts/views/supplier.js": 29895,
	"./contacts/views/supplierservice": 61776,
	"./contacts/views/supplierservice.js": 61776,
	"./crm": 71799,
	"./crm/": 71799,
	"./crm/index": 71799,
	"./crm/index.js": 71799,
	"./crm/model/booking": 98658,
	"./crm/model/booking.js": 98658,
	"./crm/model/paxlead": 69042,
	"./crm/model/paxlead.js": 69042,
	"./crm/model/survey": 99091,
	"./crm/model/survey.js": 99091,
	"./crm/model/surveypax": 86078,
	"./crm/model/surveypax.js": 86078,
	"./crm/model/surveyquestion": 20407,
	"./crm/model/surveyquestion.js": 20407,
	"./crm/views/booking": 53233,
	"./crm/views/booking.js": 53233,
	"./crm/views/leadstatus": 66432,
	"./crm/views/leadstatus.js": 66432,
	"./crm/views/paxlead": 97341,
	"./crm/views/paxlead.js": 97341,
	"./crm/views/survey": 19318,
	"./crm/views/survey.js": 19318,
	"./crm/views/surveypax": 83417,
	"./crm/views/surveypax.js": 83417,
	"./crm/views/surveyquestion": 36158,
	"./crm/views/surveyquestion.js": 36158,
	"./custom": 7543,
	"./custom/": 7543,
	"./custom/env/dev-test.env": 70984,
	"./custom/env/dev-test.env.js": 70984,
	"./custom/env/prod.env": 67883,
	"./custom/env/prod.env.js": 67883,
	"./custom/env/support.env": 92493,
	"./custom/env/support.env.js": 92493,
	"./custom/env/test.env": 926,
	"./custom/env/test.env.js": 926,
	"./custom/index": 7543,
	"./custom/index.js": 7543,
	"./custom/model/booking": 3298,
	"./custom/model/booking.js": 3298,
	"./custom/model/bookingday": 39258,
	"./custom/model/bookingday.js": 39258,
	"./custom/model/bookingdayservice": 45567,
	"./custom/model/bookingdayservice.js": 45567,
	"./custom/model/bookingpayment": 134,
	"./custom/model/bookingpayment.js": 134,
	"./custom/model/servicepersonquote": 39975,
	"./custom/model/servicepersonquote.js": 39975,
	"./custom/test/data/booking-679.txt": 68674,
	"./custom/test/data/city-3.txt": 71059,
	"./custom/test/tests": 87581,
	"./custom/test/tests.js": 87581,
	"./custom/views/aisettings": 30475,
	"./custom/views/aisettings.js": 30475,
	"./custom/views/booking": 61649,
	"./custom/views/booking.js": 61649,
	"./custom/views/bookingdayservice": 3044,
	"./custom/views/bookingdayservice.js": 3044,
	"./custom/views/bookingpayment": 4131,
	"./custom/views/bookingpayment.js": 4131,
	"./custom/views/bookingsetting": 74021,
	"./custom/views/bookingsetting.js": 74021,
	"./custom/views/claim": 39994,
	"./custom/views/claim.js": 39994,
	"./custom/views/hotel": 85332,
	"./custom/views/hotel.js": 85332,
	"./custom/views/paxlead": 39517,
	"./custom/views/paxlead.js": 39517,
	"./custom/views/purchaseinvoice": 22296,
	"./custom/views/purchaseinvoice.js": 22296,
	"./custom/views/service": 99725,
	"./custom/views/service.js": 99725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99837;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(8626);
/******/ 	
/******/ })()
;